_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[103,31,34,38,39,40,122],{

/***/ "+7q0":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("eN33"),
    defineProperty = __webpack_require__("Pz+s"),
    identity = __webpack_require__("zWgn");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "+82i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productPriceRemoteResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var productPriceRemoteResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_PRICE_REMOTE */ "mb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var resortId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "query {\n      bookingCriteria(resortId: \"".concat(resortId, "\") {\n        departureCities {\n          label: name\n          value\n        }\n        durations\n        initialDuration(resortId: \"").concat(resortId, "\")\n        initialTransport(resortId: \"").concat(resortId, "\")\n      }\n      config {\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* priceRemote */ "d"](), "\n      }\n      product: resort(").concat(productArgs, ") {\n        badgeIcon\n        category\n        color\n        comfort\n        comfortLabel\n        destination {\n          country\n        }\n        href\n        id\n        isExplicitEC\n        isJoyview\n        isSummer\n        isWinter\n        name\n        relatedDestinations\n        resortId\n        type\n        transportType\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_PRICE_REMOTE */ "nc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "+BJN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return props; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function props() {
  return {
    componentId: function componentId() {
      return "collapse-panel-".concat(Object(lodash__WEBPACK_IMPORTED_MODULE_0__["random"])(1000, 10000));
    },
    collapseLabel: function collapseLabel(_ref) {
      var collapseLabels = _ref.collapseLabels;
      return collapseLabels.collapse || '';
    },
    expandLabel: function expandLabel(_ref2) {
      var collapseLabels = _ref2.collapseLabels;
      return collapseLabels.expand || '';
    },
    displayed: function displayed() {
      return true;
    }
  };
}

/***/ }),

/***/ "+MSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productImageMapResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productImageMapResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_IMAGE_MAP */ "O"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var resortArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, location.urlParams);
    var query = "query {resort(".concat(resortArgs, ") {name mapUrl}}");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_IMAGE_MAP */ "fc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "+Rc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTrigger; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("XiOS");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("RPju");
/* harmony import */ var _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("YZTm");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/Mt0");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("m1JM");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("U6GL");
/* harmony import */ var _frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("W+NJ");
/* harmony import */ var _frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("U2fG");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;














var CriteriaTrigger = function CriteriaTrigger(props) {
  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_8__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_2__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_3__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0];

  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_2__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_4__[/* ReactPageContext */ "a"]);
  var rootRef = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])();
  var buttons = props.buttons.map(function (btnProps) {
    var children = btnProps.children,
        allOtherProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(btnProps, ["children"]);

    return __jsx("div", {
      key: Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_9__[/* generateUniqueId */ "b"])([btnProps.theme, btnProps.color, btnProps.colorBg, btnProps.colorBorder], 'criteria-btn-')
    }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_12__[/* Button */ "a"], allOtherProps, children));
  });
  var criteriaDropdownOrLayer = isDesktop ? __jsx("div", {
    className: "flex flex-2"
  }, __jsx(_frameworks_drop_down_DropDown__WEBPACK_IMPORTED_MODULE_13__[/* DropDown */ "a"], {
    className: "flex-1 mx-px10",
    contentStyle: {
      minWidth: props.dropDownMinWidth || 300
    },
    isExpanded: props.isOpen,
    onClose: props.onClose,
    rootRef: rootRef,
    theme: "hollow",
    unmountsOnClose: true
  }, function () {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2___default.a.Fragment, null, props.children, !!buttons.length && __jsx("div", {
      className: "bg-transparent border-t-1 flex items-center justify-between p-px10"
    }, buttons), props.reassurance.shouldDisplay && __jsx("div", {
      className: "pt-0 p-px10 text-gray-medium-dark rtl:text-left text-xs"
    }, props.reassurance.text));
  })) : __jsx(_frameworks_layer_Layer__WEBPACK_IMPORTED_MODULE_15__[/* Layer */ "b"], {
    ariaLabelledby: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "w"],
    buttonLeft: {
      iconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].LEFT_ARROW,
      label: Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('common.backNavigation'),
      onClick: props.onClose
    },
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_11__[/* t */ "h"])('common.close'),
    hasAnimateEnter: true,
    header: __jsx("div", {
      className: "font-normal text-center text-gray-darker text-xl",
      dangerouslySetInnerHTML: {
        __html: criteriaContext.layerHeader
      },
      id: _utils_identifiers_constants__WEBPACK_IMPORTED_MODULE_5__[/* ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER */ "w"]
    }),
    onClose: props.onClose
  }, __jsx("div", {
    className: "scroll-y",
    style: {
      height: "calc(100% - ".concat(buttons.length > 0 ? '70px' : '0px', ")")
    }
  }, props.children, props.reassurance.shouldDisplay && __jsx("div", {
    className: "sm:border-t-1 mt-px10 lg:mt-0 mx-px10 sm:pt-px10 text-gray-medium-dark rtl:text-left text-sm"
  }, props.reassurance.text)), buttons.length && __jsx("div", {
    className: "bg-white flex items-center justify-between mt-auto p-px10 lg:px-0 relative shadow w-full"
  }, buttons));
  var defaultTheme = isDesktop ? 'default' : 'remote';
  var theme = props.theme ? props.theme : defaultTheme;
  return __jsx("div", {
    "data-testid": props.dataTestId,
    ref: rootRef
  }, __jsx(_frameworks_form_inputs_input_button_InputButton__WEBPACK_IMPORTED_MODULE_14__[/* InputButton */ "a"], {
    className: "w-full",
    color: criteriaContext.isJoyview ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_7__[/* COLORS */ "a"].WATER_GREEN : _utils_color_colors__WEBPACK_IMPORTED_MODULE_7__[/* COLORS */ "a"].SUCCESS,
    dataTestId: "criteria-trigger-button",
    hasSwitch: props.hasSwitch,
    iconName: props.buttonIcon,
    isActive: props.isOpen,
    isFilled: props.buttonIsFilled,
    isLoading: isDesktop && props.isLoading,
    onClear: isDesktop ? function () {
      props.onClear && props.onClear();
    } : undefined,
    onClick: function onClick() {
      if (props.isOpen) {
        props.onClose && props.onClose();
      } else {
        props.onOpen && props.onOpen();

        if (props.trackingLabel && criteriaContext.trackingActionName) {
          track({
            actionGA: criteriaContext.trackingActionName,
            categoryGA: pageContext.pageId,
            labelGA: props.trackingLabel
          });
        }
      }
    },
    theme: theme
  }, props.buttonLabel), props.isOpen && criteriaDropdownOrLayer);
};
CriteriaTrigger.defaultProps = {
  buttons: [],
  reassurance: {
    shouldDisplay: false,
    text: ''
  }
};

/***/ }),

/***/ "+dj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMeetingRoomInfoResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productMeetingRoomInfoResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_MEETING_ROOM_INFO */ "kb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "{\n        productMeetingRooms(".concat(productArgs, ") {\n          availableMeetingRoomShapes\n          meetingRooms {\n            label\n            area {\n              value\n              unit\n            }\n            length {\n              value\n              unit\n            }\n            width {\n              value\n              unit\n            }\n            shapes {\n              type\n              maxCapacity\n            }\n          }\n        }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_MEETING_ROOM_INFO */ "kc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "+mhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureCity; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PFCZ");



function setDepartureCity(_ref) {
  var value = _ref.value;
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_CITY */ "b"], {
    value: value
  });
}



/***/ }),

/***/ "+pJz":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "/+ub":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var fails = __webpack_require__("fhLv");
var createElement = __webpack_require__("a4SZ");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "/0L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productServicesResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productServicesResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_SERVICES */ "S"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_1__[/* common */ "a"](), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_SERVICES */ "vc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "/ExG":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var store = __webpack_require__("l6h7");

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "/FsK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_AVAILABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_EXCLUSIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_NO_FLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_NO_DEPARTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_NOT_BOOKABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return API_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return API_SIBLING_SUMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return API_SIBLING_WINTER; });
var API_AVAILABLE = 'available';
var API_CLOSED = 'closed';
var API_EXCLUSIVITY = 'exclusivity';
var API_FULL = 'full';
var API_NO_FLIGHT = 'noFlight';
var API_NO_DEPARTURE = 'noDeparture';
var API_OPEN = 'open';
var API_SIBLING_SUMMER = 'siblingSummer';
var API_SIBLING_WINTER = 'siblingWinter';
var API_NOT_BOOKABLE = [API_CLOSED, API_EXCLUSIVITY, API_FULL, API_NO_DEPARTURE, API_SIBLING_SUMMER, API_SIBLING_WINTER];


/***/ }),

/***/ "/KRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productRecommendationsResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("KL6I");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");











var productRecommendationsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_4__[/* RESORT_RECOMMENDATIONS */ "ob"],
  resolve: function resolve(appContext, props, pageContext) {
    if (Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_9__[/* isSeller */ "g"])(appContext)) {
      return Promise.resolve();
    }

    var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["b2cPagesService"].isMicePage(pageContext.pageType);
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
    var resortId = props.resortId;
    var resortThumbnailQueryString = Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_8__[/* default */ "b"])({
      content: cmsContent,
      isMice: isMice,
      release: cmsRelease
    });
    var query = "query {\n      recommendations(productId: \"".concat(resortId, "\", limit: 3) {\n        products: resorts {\n          ").concat(resortThumbnailQueryString, "\n        }\n      },\n      config(").concat(cmsArgs, ") {\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n          thumbnailTourCTA\n          recommendedResorts\n        }\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* resort */ "e"](appContext), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* LINE_PRODUCT_RECOMMENDATIONS */ "rc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "/WwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useScriptLoader; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);




var cachedScripts = [];
function useScriptLoader(scriptUrl) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(cachedScripts.includes(scriptUrl)),
      scriptLoaded = _useState[0],
      setScriptLoaded = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_3__["useState"])(false),
      scriptLoadingFailed = _useState2[0],
      setScriptLoadingFailed = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_3__["useEffect"])(function () {
    if (scriptLoaded) {
      return;
    }

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    new Promise(function (resolve, reject) {
      script.addEventListener('load', function () {
        return resolve(scriptUrl);
      });
      script.addEventListener('error', function (e) {
        return reject(e);
      });
    }).then(function () {
      cachedScripts.push(scriptUrl);
      setScriptLoaded(true);
    })["catch"](function () {
      script.remove();
      setScriptLoadingFailed(true);
    }); // $FlowFixMe

    document.body.appendChild(script);
  }, [scriptUrl]);
  return {
    scriptLoaded: scriptLoaded,
    scriptLoadingFailed: scriptLoadingFailed
  };
}

/***/ }),

/***/ "/nu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureDate; });
/* unused harmony export hasPriceSuggestions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSuggestionsTrackingData; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UIAR");



var getDepartureDate = function getDepartureDate(_ref) {
  var date = _ref.date,
      duration = _ref.duration,
      format = _ref.format,
      unit = _ref.unit;
  return moment__WEBPACK_IMPORTED_MODULE_1___default()(date, format).add(duration, unit).format(format);
};
var hasPriceSuggestions = function hasPriceSuggestions(proposal, appContext) {
  return proposal && proposal.price && proposal.price.gap > 0 && (proposal.price.gap < _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */ "s"] || appContext.isSeller && proposal.price.gap >= _store_booking_proposals_constants__WEBPACK_IMPORTED_MODULE_2__[/* PRICE_COUNTER_PROPOSAL_THRESHOLD */ "t"]);
};
var getSuggestionsTrackingData = function getSuggestionsTrackingData(_ref2) {
  var proposal = _ref2.proposal,
      suggestions = _ref2.suggestions,
      appContext = _ref2.appContext,
      disableAlternativePrice = _ref2.disableAlternativePrice;
  var hasDateSuggestion = suggestions.dates.length > 0;
  var hasResortSuggestion = suggestions.resorts.length > 0;
  var hasDurationSuggestion = suggestions.durations.length > 0;
  var hasPriceSuggestion = !disableAlternativePrice && proposal && hasPriceSuggestions(proposal, appContext);
  var labelGA = "displayCounterProposals".concat(hasPriceSuggestion ? '_rate10' : '').concat(hasDateSuggestion ? '_date' : '').concat(hasResortSuggestion ? '_resort' : '').concat(hasDurationSuggestion ? '_duration' : '');
  return {
    labelGA: labelGA
  };
};

/***/ }),

/***/ "034l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("FXyv");
var toPrimitive = __webpack_require__("CD8Q");

module.exports = function (hint) {
  if (hint !== 'string' && hint !== 'number' && hint !== 'default') {
    throw TypeError('Incorrect hint');
  } return toPrimitive(anObject(this), hint !== 'number');
};


/***/ }),

/***/ "04nu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SELECTED_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADDITIONAL_TRANSPORTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEARCH_CRITERIA_TRANSPORTS; });
/* unused harmony export SET_FILTERED_ADDITIONAL_TRANSPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_FILTERED_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SORT_ADDITIONAL_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return clearAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSameJourney; });
/* unused harmony export isSameTransport */
/* unused harmony export disableAdditionalTransportFilters */
/* unused harmony export toggleAdditionalTransportFilter */
/* unused harmony export unselectAdditionalTransportsFilterCategory */
/* unused harmony export updateAdditionalTransportsSort */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setSearchCriteria; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nnRT");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("70jX");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("rJ95");
/* harmony import */ var _booking_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("uL19");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("NLwV");
/* harmony import */ var _transports_transports_reducer__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("Fk4B");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var CLEAR_ADDITIONAL_TRANSPORTS = 'CLEAR_ADDITIONAL_TRANSPORTS';
var FETCH_ADDITIONAL_TRANSPORTS = 'FETCH_ADDITIONAL_TRANSPORTS';
var SEARCH_CRITERIA_TRANSPORTS = 'SEARCH_CRITERIA_TRANSPORTS';
var CREATE_ADDITIONAL_TRANSPORTS_FILTERS = 'CREATE_ADDITIONAL_TRANSPORTS_FILTERS';
var SET_FILTERED_ADDITIONAL_TRANSPORTS = 'SET_FILTERED_ADDITIONAL_TRANSPORTS';
var TOGGLE_FILTER = 'TOGGLE_FILTER';
var DISABLE_FILTERS = 'DISABLE_FILTERS';
var UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY = 'UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY';
var UPDATE_FILTERED_RESULTS = 'UPDATE_FILTERED_RESULTS';
var SORT_ADDITIONAL_TRANSPORTS = 'SORT_ADDITIONAL_TRANSPORTS';
var UPDATE_SELECTED_TRANSPORT = 'UPDATE_SELECTED_TRANSPORT';

function setSearchCriteria(newSearchCriteria) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(SEARCH_CRITERIA_TRANSPORTS, newSearchCriteria);
}

function _toggleFilter(filter, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(TOGGLE_FILTER, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransports */ "f"])(getState()),
    filter: filter
  });
}

function _disableFilters(filters, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(DISABLE_FILTERS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransports */ "f"])(getState()),
    filters: filters
  });
}

function _unselectFiltersCategory(category, getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(UNSELECT_ADDITIONAL_TRANSPORTS_FILTER_CATEGORY, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransports */ "f"])(getState()),
    category: category
  });
}

function _updateFilteredTransports(getState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(UPDATE_FILTERED_RESULTS, {
    additionalTransports: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransports */ "f"])(getState()),
    filters: Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransportsFilters */ "h"])(getState())
  });
}

function _runAdditionalTransportsQuery(_ref) {
  var proposalId = _ref.proposalId,
      appContext = _ref.appContext,
      searchCriterias = _ref.searchCriterias;
  var query = "\n    {\n      additionalTransports(proposalId : \"".concat(proposalId, "\" ").concat(searchCriterias ? ", searchCriteria: ".concat(Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_18__[/* graphqlify */ "d"])(searchCriterias)) : '', ") {\n        inbound { \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n        outboundList {  \n          transportInfo {\n            id\n            isMultiTransport\n            price {\n              ...priceDetails\n            }\n            totalDifferentialPrice {\n              ...priceDetails\n            }\n            way\n          }\n          journey {\n            ...transportsDetails \n          }\n        }\n       \n      }\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_13__[/* transportDetailsFragment */ "q"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_13__[/* getPriceDetailFragment */ "h"])(appContext.locale), "\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* PROPOSAL_GET_ADDITIONAL_TRANSPORT */ "jd"]
  });
}

function updateAdditionalTransportsSort(sorter) {
  return function (dispatch, getState) {
    var additionalTransports = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransports */ "f"])(getState());
    var filters = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getAdditionalTransportsFilters */ "h"])(getState());
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(SORT_ADDITIONAL_TRANSPORTS, {
      additionalTransports: additionalTransports,
      filters: filters,
      sorter: sorter
    }));
  };
}

function clearAdditionalTransports() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(CLEAR_ADDITIONAL_TRANSPORTS);
}

var formatProposalLegacyTransportAsAlternative = function formatProposalLegacyTransportAsAlternative(_ref2) {
  var _proposal$price, _proposal$price$total, _proposal$price2, _proposal$price2$tota, _proposal$price3, _proposal$price3$tota, _proposal$price4, _proposal$price4$tota, _proposal$transports, _proposal$transports2;

  var proposal = _ref2.proposal,
      appContext = _ref2.appContext;

  if (!proposal) {
    return null;
  }

  var transportInfo = {
    id: proposal.id,
    // this id is added for unit testing - proposal id is not similar to AdditionalTransport id
    price: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_19__[/* getTotalDifferentialPrice */ "b"])((_proposal$price = proposal.price) === null || _proposal$price === void 0 ? void 0 : (_proposal$price$total = _proposal$price.total) === null || _proposal$price$total === void 0 ? void 0 : _proposal$price$total.value, (_proposal$price2 = proposal.price) === null || _proposal$price2 === void 0 ? void 0 : (_proposal$price2$tota = _proposal$price2.totalWithoutTransport) === null || _proposal$price2$tota === void 0 ? void 0 : _proposal$price2$tota.value, appContext.locale),
    totalDifferentialPrice: Object(_transports_transports_reducer__WEBPACK_IMPORTED_MODULE_19__[/* getTotalDifferentialPrice */ "b"])((_proposal$price3 = proposal.price) === null || _proposal$price3 === void 0 ? void 0 : (_proposal$price3$tota = _proposal$price3.totalWithoutTransport) === null || _proposal$price3$tota === void 0 ? void 0 : _proposal$price3$tota.value, (_proposal$price4 = proposal.price) === null || _proposal$price4 === void 0 ? void 0 : (_proposal$price4$tota = _proposal$price4.totalWithoutTransport) === null || _proposal$price4$tota === void 0 ? void 0 : _proposal$price4$tota.value, appContext.locale)
  };
  return {
    inbound: {
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'INBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : _proposal$transports.inbound
    },
    outboundList: [{
      transportInfo: _objectSpread(_objectSpread({}, transportInfo), {}, {
        way: 'OUTBOUND'
      }),
      journey: proposal === null || proposal === void 0 ? void 0 : (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : _proposal$transports2.outbound
    }]
  };
};

var isSameJourney = function isSameJourney(firstTransport, secondTransport) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (firstTransport && firstTransport.journey && secondTransport && secondTransport.journey) {
    var _firstTransport$journ, _secondTransport$jour, _firstTransport$journ2, _secondTransport$jour2;

    var firstTravelSections = (_firstTransport$journ = firstTransport.journey) === null || _firstTransport$journ === void 0 ? void 0 : _firstTransport$journ.travelSections;
    var secondTravelSections = (_secondTransport$jour = secondTransport.journey) === null || _secondTransport$jour === void 0 ? void 0 : _secondTransport$jour.travelSections;
    var haveSameTravelSections = (firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === (secondTravelSections === null || secondTravelSections === void 0 ? void 0 : secondTravelSections.length) && ((firstTravelSections === null || firstTravelSections === void 0 ? void 0 : firstTravelSections.length) === 0 || firstTravelSections.every(function (currentValue, index) {
      var selectedValue = secondTravelSections[index];
      return lodash_isEqual__WEBPACK_IMPORTED_MODULE_12___default()(currentValue, selectedValue);
    }));
    var haveSameDurationInMin = ((_firstTransport$journ2 = firstTransport.journey) === null || _firstTransport$journ2 === void 0 ? void 0 : _firstTransport$journ2.durationInMin) === ((_secondTransport$jour2 = secondTransport.journey) === null || _secondTransport$jour2 === void 0 ? void 0 : _secondTransport$jour2.durationInMin);
    return haveSameTravelSections && haveSameDurationInMin;
  }

  return defaultValue;
};

var isSameTransport = function isSameTransport(_ref3) {
  var transportId = _ref3.transportId,
      currentTransport = _ref3.currentTransport,
      selectedTransport = _ref3.selectedTransport,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? true : _ref3$defaultValue;

  if (currentTransport && selectedTransport) {
    var sameInbound = isSameJourney(currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.inbound, selectedTransport === null || selectedTransport === void 0 ? void 0 : selectedTransport.inbound, defaultValue);

    if (sameInbound && transportId) {
      var _selectedTransport$ou;

      var currentOutbound = currentTransport === null || currentTransport === void 0 ? void 0 : currentTransport.outboundList[0];
      var selectedOutbound = selectedTransport === null || selectedTransport === void 0 ? void 0 : (_selectedTransport$ou = selectedTransport.outboundList) === null || _selectedTransport$ou === void 0 ? void 0 : _selectedTransport$ou.find(function (transport) {
        return transport.transportInfo.id === transportId;
      });
      return currentOutbound && selectedOutbound ? isSameJourney(currentOutbound, selectedOutbound, false) : false;
    }

    return sameInbound;
  }

  return defaultValue;
};

function fetchAdditionalTransports(_ref4) {
  var proposal = _ref4.proposal,
      appContext = _ref4.appContext;
  return function (dispatch, getState) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(FETCH_ADDITIONAL_TRANSPORTS));
    var defaultTransport = formatProposalLegacyTransportAsAlternative({
      proposal: proposal,
      appContext: appContext
    });
    var searchCriterias = Object(_booking_selector__WEBPACK_IMPORTED_MODULE_17__[/* getSearchCriteriaTransports */ "y"])(getState());
    return _runAdditionalTransportsQuery({
      proposalId: proposal.id,
      appContext: appContext,
      searchCriterias: searchCriterias
    }).then(function (_ref5) {
      var additionalTransports = _ref5.additionalTransports;
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_11__["resolve"])(FETCH_ADDITIONAL_TRANSPORTS), {
        additionalTransports: additionalTransports,
        selectedTransport: defaultTransport
      }));
    }, function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_11__["reject"])(FETCH_ADDITIONAL_TRANSPORTS), error));
    });
  };
}

function toggleAdditionalTransportFilter(filter) {
  return function (dispatch, getState) {
    dispatch(_toggleFilter(filter, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function disableAdditionalTransportFilters(filters) {
  return function (dispatch, getState) {
    dispatch(_disableFilters(filters, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}

function unselectAdditionalTransportsFilterCategory(category) {
  return function (dispatch, getState) {
    dispatch(_unselectFiltersCategory(category, getState));
    dispatch(_updateFilteredTransports(getState));
  };
}



/***/ }),

/***/ "05PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getCalendar; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getSelectedMonth; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getCalendarLoading; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getDays; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ getPricesByDays; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getDepartureDateBookable; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getAvailableDurations; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getInitialDuration; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ getCalendarTripPrice; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getCalendarTripPriceLoading; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getBlockInputDepartureDate; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getCalendarDepartureCity; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getCalendarProductId; });

// UNUSED EXPORTS: getBasePrice

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/utils/api-availability/constants.js
var constants = __webpack_require__("/FsK");

// CONCATENATED MODULE: ./src/utils/api-availability/availabilityUtils.js




function isBookable(availability) {
  return !!availability && !constants["d" /* API_NOT_BOOKABLE */].includes(availability);
}


// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/store/calendar/calendar.selector.js















var INITIAL_LIST = [];
var INITIAL_CALENDAR = {};

function getMonthIndex() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var monthId = arguments.length > 1 ? arguments[1] : undefined;
  return months.findIndex(function (_ref) {
    var id = _ref.id;
    return id === monthId;
  });
}

function getMonthIndexFromDays() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dayId = arguments.length > 1 ? arguments[1] : undefined;
  /**
   * return if a day is elligible based on:
   * - dayContent.id equals dayId parameter
   * - dayContent.isCurrentMonth at true
   * @param  {Object} day  objet day from calendar.months[i]
   * @return {boolean}     this day is elligible
   */

  var matchBasedOnDay = function matchBasedOnDay(_ref2) {
    var dayContent = _ref2.dayContent;
    return dayContent.id === dayId && dayContent.isCurrentMonth;
  };

  return months.findIndex(function (_ref3) {
    var days = _ref3.days;
    return days.some(matchBasedOnDay);
  });
}

function getCurrentMonth() {
  var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedDay = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDayMonthIndex = arguments.length > 2 ? arguments[2] : undefined;
  var firstMonthIndex = arguments.length > 3 ? arguments[3] : undefined;
  return selectedDay && selectedDayMonthIndex > -1 ? months[selectedDayMonthIndex] : months[firstMonthIndex];
}

function getDaysFromMonths(calendar, monthId) {
  var months = calendar.months;
  var monthIndex = getMonthIndex(months, monthId);
  return Object(lodash["get"])(months, "".concat(monthIndex, ".days"));
}

function getDaysFromDays(calendar, dayId) {
  var months = calendar.months,
      firstAvailableMonthIndex = calendar.firstAvailableMonthIndex;
  var selectedDayMonthIndex = getMonthIndexFromDays(months, dayId);
  var month = getCurrentMonth(months, dayId, selectedDayMonthIndex, firstAvailableMonthIndex);
  return Object(lodash["get"])(month, 'days', INITIAL_LIST);
}

function getDaysSelector() {
  var calendar = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_CALENDAR;
  var selectedMonth = arguments.length > 1 ? arguments[1] : undefined;
  var selectedDay = arguments.length > 2 ? arguments[2] : undefined;

  if (Object(lodash["isEmpty"])(calendar)) {
    return INITIAL_LIST;
  }

  var daysFromMonths = getDaysFromMonths(calendar, selectedMonth);
  var daysFromDays = getDaysFromDays(calendar, selectedDay);
  return !daysFromMonths || daysFromMonths === daysFromDays ? daysFromDays : daysFromMonths;
}

var calendarSelector = function calendarSelector(_ref4) {
  var calendar = _ref4.calendar;
  return calendar;
};

var getCalendar = Object(lib["createSelector"])(calendarSelector, function (_ref5) {
  var calendar = _ref5.calendar;
  return calendar;
});
var getSelectedMonth = Object(lib["createSelector"])(calendarSelector, function (_ref6) {
  var selectedMonth = _ref6.selectedMonth;
  return selectedMonth;
});
var getCalendarLoading = Object(lib["createSelector"])(calendarSelector, function (_ref7) {
  var isLoading = _ref7.isLoading;
  return isLoading;
});
var getDays = Object(lib["createSelector"])(getCalendar, getSelectedMonth, tripCriteria_selector["b" /* getDepartureDate */], getDaysSelector);
var getPricesByDays = Object(lib["createSelector"])(calendarSelector, function (_ref8) {
  var byDays = _ref8.byDays;
  return byDays;
});
var getDepartureDateBookable = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getCalendarLoading, function (_ref9, departureDate, isLoading) {
  var _byDays$dayId;

  var byDays = _ref9.byDays;

  if (!departureDate || isLoading) {
    return false;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return byDays && byDays[dayId] && isBookable((_byDays$dayId = byDays[dayId]) === null || _byDays$dayId === void 0 ? void 0 : _byDays$dayId.availability);
});
var getBasePrice = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], getDepartureDateBookable, function (_ref10, departureDate, departureDateBoobable) {
  var basePrice = _ref10.basePrice,
      byDays = _ref10.byDays;

  if (!departureDate || !departureDateBoobable) {
    return basePrice;
  }

  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);

  if (!byDays || !byDays[dayId]) {
    return null;
  }

  var _byDays$dayId2 = byDays[dayId],
      oldPrice = _byDays$dayId2.oldPrice,
      price = _byDays$dayId2.price,
      unit = _byDays$dayId2.unit;
  return {
    bestPrice: price ? {
      formattedValue: price,
      value: price
    } : null,
    initialPrice: oldPrice ? {
      formattedValue: oldPrice,
      value: oldPrice
    } : null,
    unit: unit
  };
});
var getAvailableDurations = Object(lib["createSelector"])(calendarSelector, tripCriteria_selector["b" /* getDepartureDate */], function (_ref11, departureDate) {
  var _bookableDates$months, _bookableDates$months2, _bookableDates$months3;

  var bookableDates = _ref11.bookableDates,
      bookableDatesLoading = _ref11.bookableDatesLoading;

  if (bookableDatesLoading) {
    return [];
  }

  if (!departureDate || !bookableDates) {
    return null;
  }

  var monthId = moment_default()(departureDate).format(apiDate["b" /* API_MONTH_ID */]);
  var dayId = moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]);
  return Array.isArray(bookableDates === null || bookableDates === void 0 ? void 0 : bookableDates.months) ? (bookableDates === null || bookableDates === void 0 ? void 0 : (_bookableDates$months = bookableDates.months.find(function (m) {
    return m.id.toString() === monthId;
  })) === null || _bookableDates$months === void 0 ? void 0 : (_bookableDates$months2 = _bookableDates$months.days.find(function (d) {
    return d.id.toString() === dayId;
  })) === null || _bookableDates$months2 === void 0 ? void 0 : (_bookableDates$months3 = _bookableDates$months2.availabilities.filter(function (a) {
    return a.status === 'AVAILABLE' || a.status === 'UNKNOWN';
  })) === null || _bookableDates$months3 === void 0 ? void 0 : _bookableDates$months3.reduce(function (acc, a) {
    return [].concat(Object(toConsumableArray["a" /* default */])(acc), Object(toConsumableArray["a" /* default */])(a.durations));
  }, [])) || null : null;
});
var getInitialDuration = Object(lib["createSelector"])(calendarSelector, function (_ref12) {
  var initialDuration = _ref12.initialDuration;
  return initialDuration;
});
var getCalendarTripPrice = Object(lib["createSelector"])(calendarSelector, function (_ref13) {
  var tripPrice = _ref13.tripPrice;
  return tripPrice;
});
var getCalendarTripPriceLoading = Object(lib["createSelector"])(calendarSelector, function (_ref14) {
  var tripPriceIsLoading = _ref14.tripPriceIsLoading;
  return tripPriceIsLoading;
});
var getBlockInputDepartureDate = Object(lib["createSelector"])(calendarSelector, function (_ref15) {
  var blockInputDepartureDate = _ref15.blockInputDepartureDate;
  return blockInputDepartureDate;
});
var getCalendarDepartureCity = Object(lib["createSelector"])(calendarSelector, function (_ref16) {
  var departureCity = _ref16.departureCity;
  return departureCity;
});
var getCalendarProductId = Object(lib["createSelector"])(calendarSelector, function (_ref17) {
  var productId = _ref17.productId;
  return productId;
});

/***/ }),

/***/ "05v4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARROW_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HOME; });
// export const BACKSPACE = 8;
// export const SPACE = 32;
var ENTER = 13;
var ESCAPE = 27;
var ARROW_LEFT = 37;
var ARROW_UP = 38;
var ARROW_RIGHT = 39;
var ARROW_DOWN = 40;
var END = 35;
var HOME = 36;

/***/ }),

/***/ "0Jwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _toArray; });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("Umn3");
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5x5+");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HO86");
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kQdG");




function _toArray(arr) {
  return Object(_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(arr) || Object(_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(arr) || Object(_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(arr) || Object(_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])();
}

/***/ }),

/***/ "0OJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PRICE_TICKET_REQUEST = 'PRICET_TICKET_REQUEST';
/* harmony default export */ __webpack_exports__["a"] = (PRICE_TICKET_REQUEST);

/***/ }),

/***/ "0ibg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setKeywords; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");


function setKeywords(keywords) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SEARCH_SET_KEYWORDS */ "t"], {
    keywords: keywords
  });
}

/***/ }),

/***/ "1I7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productSEOTitleResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");













function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var getPriceRange = function getPriceRange(_ref) {
  var price = _ref.price,
      priceConditionLabel = _ref.priceConditionLabel;

  if (!price || !price.bestPrice && !price.initialPrice) {
    return null;
  }

  var _price$bestPrice = price.bestPrice;
  _price$bestPrice = _price$bestPrice === void 0 ? {} : _price$bestPrice;
  var bestPrice = _price$bestPrice.formattedValue,
      _price$initialPrice = price.initialPrice;
  _price$initialPrice = _price$initialPrice === void 0 ? {} : _price$initialPrice;
  var initialPrice = _price$initialPrice.formattedValue,
      _price$termsAndCondit = price.termsAndConditions,
      duration = _price$termsAndCondit.duration,
      numberOfAdults = _price$termsAndCondit.numberOfAdults,
      unit = price.unit;
  var priceToUse = bestPrice || initialPrice;
  return priceToUse ? Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["messageFormat"])(priceConditionLabel).format({
    bestPrice: priceToUse,
    duration: duration,
    numberOfAdults: numberOfAdults,
    priceUnit: unit.toLowerCase()
  }) : null;
};

var getStructuredData = function getStructuredData(props) {
  var origin = props.origin,
      _props$resort = props.resort,
      name = _props$resort.name,
      images = _props$resort.images,
      description = _props$resort.description,
      price = _props$resort.price,
      _props$resort$tripadv = _props$resort.tripadvisor,
      numReviews = _props$resort$tripadv.numReviews,
      rating = _props$resort$tripadv.rating,
      priceCondition = props.config.resort.seo.priceCondition;
  var priceRange = getPriceRange({
    price: price,
    priceConditionLabel: priceCondition
  });

  var structuredData = _objectSpread(_objectSpread({
    aggregateRating: {
      ratingValue: rating,
      reviewCount: numReviews,
      bestRating: '5',
      '@context': 'http://schema.org/',
      '@type': 'AggregateRating'
    },
    description: description,
    image: images,
    name: name
  }, priceRange ? {
    priceRange: priceRange
  } : null), {}, {
    url: origin,
    '@context': 'http://schema.org/',
    '@type': 'Hotel'
  });

  return {
    type: 'application/ld+json',
    innerHTML: JSON.stringify(structuredData)
  };
};

var getOpenGraphData = function getOpenGraphData(props) {
  var title = _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["resortAction"].generateResortTitle(props.title || '', props.resort.name);
  return [{
    property: 'og:site_name',
    content: 'Club Med'
  }, {
    property: 'og:locale',
    content: props.locale
  }, {
    property: 'og:title',
    content: title
  }, {
    property: 'twitter:title',
    content: title
  }];
};

var productSEOTitleResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_13__[/* RESORT_SEO */ "qb"],
  props: function props() {
    return {
      title: function title(props) {
        return _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["resortAction"].generateResortTitle(props.title || '', props.resort.name);
      },
      meta: function meta(props) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(props.resort.htmlHeader.meta), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(getOpenGraphData(props)));
      },
      script: function script(props) {
        return [getStructuredData(props)];
      }
    };
  },
  resolve: function resolve() {
    var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments.length > 1 ? arguments[1] : undefined;
    var query = "query {\n      resort(resortId: \"".concat(props.resortId, "\") {\n        name\n        htmlHeader { meta {name content} }\n        images\n        description\n        title\n        tripadvisor(resortId: \"").concat(props.resortId, "\") {\n          rating\n          numReviews\n        }\n        price(resortId: \"").concat(props.resortId, "\") {\n          bestPrice {\n            formattedValue\n          }\n          initialPrice {\n            formattedValue\n          }\n          termsAndConditions {\n            duration\n            numberOfAdults\n          }\n          unit\n        }\n      }\n      config {\n        resort {\n          seo {\n            priceCondition\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* LINE_PRODUCT_SEO_TITLE */ "uc"],
      strictErrors: false
    }).then(function (data) {
      return _objectSpread({
        origin: appContext.originalUrl,
        locale: appContext.locale
      }, data);
    });
  }
};

/***/ }),

/***/ "1P7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFormattedLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCursorClass; });
function getFormattedLabel() {
  var placeholder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!placeholder) return '';
  return isRequired ? "".concat(placeholder, "*") : placeholder;
}
function getCursorClass(_ref) {
  var hasPointer = _ref.hasPointer,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly;
  if (isDisabled) return 'cursor-not-allowed';
  if (isReadOnly) return 'cursor-default';
  if (isLoading) return 'cursor-wait';
  return hasPointer ? 'cursor-pointer' : '';
}

/***/ }),

/***/ "1Wgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndexes; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("pKEY");
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_lazyload__WEBPACK_IMPORTED_MODULE_16__);















function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var ActiveIndexes = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(ActiveIndexes, _Component);

  var _super = _createSuper(ActiveIndexes);

  function ActiveIndexes() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, ActiveIndexes);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "state", {
      activeIndexes: _this.props.activeIndexes || [],
      isPristine: true,
      lastIndex: 0
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "clear", function () {
      _this.setState(function (prevState) {
        if (prevState.activeIndexes.length) return {
          activeIndexes: []
        };
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(_this), "update", function (index) {
      var _this$props$onUpdate = _this.props.onUpdate,
          onUpdate = _this$props$onUpdate === void 0 ? lodash__WEBPACK_IMPORTED_MODULE_15__["noop"] : _this$props$onUpdate;
      var activeIndexes = _this.state.activeIndexes;
      var newActiveIndexes = activeIndexes.includes(index) ? _this.removeIndex(activeIndexes, index) : _this.addIndex(activeIndexes, index);

      _this.setState({
        activeIndexes: newActiveIndexes,
        isPristine: false,
        lastIndex: index
      }, function () {
        onUpdate(index);
        Object(react_lazyload__WEBPACK_IMPORTED_MODULE_16__["forceCheck"])();
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(ActiveIndexes, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props$activeInd = this.props.activeIndexes,
          activeIndexes = _this$props$activeInd === void 0 ? [] : _this$props$activeInd;

      if (!Object(lodash__WEBPACK_IMPORTED_MODULE_15__["isEqual"])(prevProps.activeIndexes, activeIndexes)) {
        var lastIndex = activeIndexes[activeIndexes.length - 1];
        this.setState({
          activeIndexes: activeIndexes,
          lastIndex: lastIndex >= 0 ? lastIndex : prevState.lastIndex
        });
      }
    }
  }, {
    key: "addIndex",
    value: function addIndex(activeIndexes, index) {
      var hasMultipleIndexEnabled = this.props.hasMultipleIndexEnabled;

      if (hasMultipleIndexEnabled) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(activeIndexes), [index]);
      }

      return [index];
    }
  }, {
    key: "removeIndex",
    value: function removeIndex(activeIndexes, index) {
      var hasNoIndexEnabled = this.props.hasNoIndexEnabled;

      if (hasNoIndexEnabled || activeIndexes.length > 1) {
        return Object(lodash__WEBPACK_IMPORTED_MODULE_15__["pull"])(activeIndexes, index);
      }

      return activeIndexes;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        activeIndexes: this.state.activeIndexes,
        clear: this.clear,
        isPristine: this.state.isPristine,
        lastIndex: this.state.lastIndex,
        update: this.update
      });
    }
  }]);

  return ActiveIndexes;
}(react__WEBPACK_IMPORTED_MODULE_14__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(ActiveIndexes, "defaultProps", {
  activeIndexes: [],
  hasMultipleIndexEnabled: false,
  hasNoIndexEnabled: false
});

/***/ }),

/***/ "1YFU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "1a7w":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("wEFx");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "1bWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setKids; });
/* unused harmony export updateKid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resetKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setKidsWithoutClearProposals; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("wQ38");
/* eslint-disable flowtype/no-weak-types */



function setKids(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS */ "c"], {
    kids: kids
  });
}

function setKidsWithoutClearProposals(kids) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS */ "d"], {
    kids: kids
  });
}

function resetKids() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_RESET_KIDS */ "b"]);
}

function updateKid(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_KID */ "e"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}



/***/ }),

/***/ "1m4l":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var anObject = __webpack_require__("ep/x");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "1qsz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWinterResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isWinterMountainResort; });
/* unused harmony export resortHasBeActivities */
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);





var WINTER_MOUNTAIN_RESORT = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].WINTER_MOUNTAIN_RESORT;
function isWinterResort(resort) {
  var seasons = Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(resort, 'seasons', []);
  return seasons.length === 1 && seasons.includes('WINTER') && Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(resort, 'type', '').toUpperCase() === 'VILLAGE';
}
function isWinterMountainResort(resort) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_3__["get"])(resort, 'category') === WINTER_MOUNTAIN_RESORT;
}
var resortHasBeActivities = function resortHasBeActivities(resort) {
  return resort.activityCategories.leisure.some(function (_ref) {
    var subCategories = _ref.subCategories;
    return subCategories.length !== 0;
  });
};

/***/ }),

/***/ "1tzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isChineseLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLocaleToDisplayDidomi; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qFX+");




var isChineseLocale = function isChineseLocale(locale) {
  return locale === _constants__WEBPACK_IMPORTED_MODULE_2__[/* LOCALES */ "a"].EN_CN || locale === _constants__WEBPACK_IMPORTED_MODULE_2__[/* LOCALES */ "a"].ZH_CN;
};

var isLocaleToDisplayDidomi = function isLocaleToDisplayDidomi(locale) {
  return _constants__WEBPACK_IMPORTED_MODULE_2__[/* LOCALES_TO_DISPLAY_DIDOMI */ "b"].includes(locale);
};



/***/ }),

/***/ "27iJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productChildcaresResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("H0gB");




var productChildcaresResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_CHILDCARES */ "L"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var query = Object(_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__[/* productChildcaresQuery */ "d"])(productId, {
      urlParams: urlParams
    });
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_CHILDCARE */ "ac"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hero; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("/Mt0");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("mmhe");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("3jv5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("qqKu");
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("NJJ8");
/* harmony import */ var _heroUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("5xkM");












var __jsx = react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */












var Hero = function Hero(_ref) {
  var _ref2;

  var alt = _ref.alt,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      isLegacyMode = _ref.isLegacyMode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      url = _ref.url;

  var _useResponsive = Object(_utils_responsive_responsiveContext__WEBPACK_IMPORTED_MODULE_16__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _generateBackgroundSt = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* generateBackgroundStylesAndClassName */ "d"])(url),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].BLUE : _theming$linkBackgrou;

  var _getHeroDimensions = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* getHeroDimensions */ "f"])(size, isDesktop),
      height = _getHeroDimensions.height,
      paddingBottom = _getHeroDimensions.paddingBottom,
      paddingTop = _getHeroDimensions.paddingTop;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? _heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* TITLE_POSITIONS */ "c"][contentPosition] : _heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* TITLE_POSITIONS */ "c"]['bottom-left'];
  var horizontalAlignment = contentPosition ? contentPosition.split('-')[1] : '';
  var linkSpacing = horizontalAlignment ? _heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* LINK_SPACINGS */ "b"][horizontalAlignment] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_22__[/* TrackClick */ "a"] : react__WEBPACK_IMPORTED_MODULE_12__["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    as: _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"],
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('inline-block reset-anchor hover:scale-105 transition-all', linkSpacing),
    trackingData: tracking,
    url: link.url
  } : {};
  var displayIcon = isDesktop ? icon === null || icon === void 0 ? void 0 : icon.displayDesktop : icon === null || icon === void 0 ? void 0 : icon.displayMobile;
  return __jsx("div", {
    "aria-label": alt,
    className: className,
    "data-size": size,
    id: id,
    role: "img",
    style: _objectSpread({
      height: height
    }, style)
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('relative', {
      'inset-border-after': isExclusiveCollection
    }),
    style: {
      height: height,
      paddingTop: paddingTop
    }
  }, __jsx("div", {
    className: "absolute bg-center bg-cover bg-no-repeat fadeIn h-full inset-x-0 top-0 w-full ".concat(imageClassName),
    style: {
      height: height
    }
  }), displayIcon && (icon === null || icon === void 0 ? void 0 : icon.link) && __jsx("div", {
    className: "absolute inset-0",
    style: {
      paddingTop: paddingTop,
      paddingBottom: hasOverlap ? '40px' : 0
    }
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('flex h-full m-auto max-w-site overflow-hidden p-px20 w-full', isTablet ? _heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* ICON_POSITIONS */ "a"][icon.positionDesktop] : _heroUtils__WEBPACK_IMPORTED_MODULE_23__[/* ICON_POSITIONS */ "a"][icon.positionMobile]),
    dir: "ltr"
  }, __jsx("img", {
    alt: icon.alt || '',
    className: "flex-none max-h-full",
    src: icon.link,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && __jsx("div", {
    className: "align-bottom flex flex-col h-full z-1 pt-px10 px-px20 relative",
    style: {
      paddingBottom: paddingBottom
    }
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()("flex flex-col max-w-site mx-auto w-full ".concat(textAlignment), {
      'h-full': isHighlight
    })
  }, __jsx(TitleAndSubtitleWrapperTag, titleAndSubtitleWrapperProps, __jsx(_frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_20__[/* Heading */ "a"], {
    className: !isLegacyMode && !isHighlight && size !== 'small' ? 'lg:text-7xl' : '',
    color: titleColor,
    hLevel: hLevel,
    theme: isLegacyMode ? 'heading-brand-2' : 'heading-brand-1'
  }, title), !!subtitle && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_21__[/* Text */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('mt-px5', {
      'font-serif': isExclusiveCollection
    }),
    color: subtitleColor,
    text: subtitle,
    theme: "text-sans-5"
  })), !Object(lodash__WEBPACK_IMPORTED_MODULE_13__["isEmpty"])(countdown) && __jsx(_frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_18__[/* Countdown */ "a"], {
    className: "pt-px10",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()({
      'mt-auto w-full': isHighlight
    })
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_17__[/* Button */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('mt-px15 md:mt-0', {
      'w-full': !isDesktop
    }),
    color: linkColor,
    colorBg: linkBackgroundColor,
    style: {
      maxWidth: isHighlight && !isDesktop ? 'none' : '17.5rem'
    },
    trackingData: tracking,
    url: link.url || '#hero-beacon'
  }, link.label)))), __jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && __jsx("div", {
    className: "absolute inset-0",
    style: (_ref2 = {
      /* eslint-disable no-dupe-keys */
      background: '-moz-linear-gradient(top, rgba(0,0,0,0) 0%, rgba(0,0,0,0.2) 100%)'
    }, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_ref2, "background", '-webkit-linear-gradient(top, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 100%)'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_ref2, "background", 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.2) 100%)'), _ref2)
  })), __jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "2CYk":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");

module.exports = function (argument) {
  if (typeof argument === 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "2N/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOKING_ENGINE_ENTRIES; });
/* unused harmony export BOOKING_TRACKING_UPSELL_REVENUE */
var BOOKING_ENGINE_ENTRIES = {
  PRICE_CALENDAR: 'PriceCalendar',
  PRICE_REMOTE: 'PriceRemote',
  QUICK_SEARCH: 'QuickSearch',
  CRUISE_BOOKING: 'CruiseBooking'
};
var BOOKING_TRACKING_UPSELL_REVENUE = 'BOOKING_TRACKING_UPSELL_REVENUE';

/***/ }),

/***/ "2Ufl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineTitle; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var LineTitle = function LineTitle(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className", "isExclusiveCollection"]);

  return __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mb-px20', className),
    theme: isExclusiveCollection ? 'title-serif-7' : 'title-brand-1'
  }));
};

/***/ }),

/***/ "2dUC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productTagsResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("QsI/");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jw1E");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("4VTZ");











var productTagsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_6__[/* PRODUCT_TAGS */ "X"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(appContext, props, pageContext) {
      var allProductIds, productIdsAsString, isMice, _appContext$cmsConten, cmsContent, _appContext$cmsReleas, cmsRelease, resortThumbnailQueryString, query;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allProductIds = props.tags.reduce(function (acc, tag) {
                return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(acc), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(tag.productIds));
              }, []);
              productIdsAsString = JSON.stringify(allProductIds);
              isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["b2cPagesService"].isMicePage(pageContext.pageType);
              _appContext$cmsConten = appContext.cmsContent, cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten, _appContext$cmsReleas = appContext.cmsRelease, cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
              resortThumbnailQueryString = Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_9__[/* default */ "b"])({
                content: cmsContent,
                release: cmsRelease,
                isMice: isMice
              });
              query = "query {\n      config {\n        common {\n          close\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_10__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_10__[/* resort */ "e"](appContext), "\n      }\n      products: resorts(resortIds: ").concat(productIdsAsString, ") {\n        ").concat(resortThumbnailQueryString, "\n      }\n    }");
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_8__[/* LINE_COMMON_PRODUCT_TAGS */ "Hb"]
              }));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2, _x3) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "34at":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return goToHash; });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1cDg");



/* eslint-env browser */

function goToHash(hash) {
  var scrollUnderNav = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'auto';
  /* In mobile context, navBar is on top of the content of the page so hash scroll goes under the nav */

  function scrollUnderNavBar() {
    var navBar = document.getElementsByClassName(_widgets_navigation_Navigation_constants__WEBPACK_IMPORTED_MODULE_2__[/* NAVIGATION_OFFSET_SELECTOR */ "b"])[0];

    if (navBar) {
      document.documentElement.scrollTop -= navBar.clientHeight;
    }
  }

  if (hash) {
    var hashName = hash.split('#')[1];
    setTimeout(function () {
      var element = document.getElementById(hashName);

      if (element) {
        element.scrollIntoView({
          behavior: behavior
        });
      }

      if (scrollUnderNav) {
        scrollUnderNavBar();
      }
    }, 100);
  }
}

/***/ }),

/***/ "393O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHEN_EVENT; });
var OPEN_CRITERIA_WHEN_EVENT = 'openCriteriaWhen';

/***/ }),

/***/ "3FxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productPriceTicketResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var productPriceTicketResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_PRICE_TICKET */ "nb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId,
        _props$durationPlaceh = props.durationPlaceholder,
        durationPlaceholder = _props$durationPlaceh === void 0 ? '' : _props$durationPlaceh,
        _props$fromToPlacehol = props.fromToPlaceholder,
        fromToPlaceholder = _props$fromToPlacehol === void 0 ? '' : _props$fromToPlacehol;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* buildProductArgs */ "c"])(productId, urlParams);
    var cruiseArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* buildCruiseArgs */ "b"])(urlParams);
    var query = "query {\n      config {\n        booking { form { withoutTransport } }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* price */ "c"](), "\n        common {\n          close\n          comparator {\n            backToSearch\n          }\n        }\n        resort {\n          ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* resortStartingPrice */ "f"](), "\n        }\n        travelAdvisor {\n          href\n          phoneNumber\n          text\n          type\n        }\n      }\n      cruise(").concat(cruiseArgs, ") {\n        fromToDestination(message: \"").concat(fromToPlaceholder, "\")\n      }\n      product: resort(").concat(productArgs, ") {\n        badgeIcon\n        color\n        comfortLabel\n        destination {\n          country\n        }\n        duration(message:\"").concat(durationPlaceholder, "\")\n        id\n        isExplicitEC\n        name\n        rangeId\n        transportType\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_PRICE_TICKET */ "oc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "3K/D":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var create = __webpack_require__("Znn2");
var definePropertyModule = __webpack_require__("87KK");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "3LIW":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var isCallable = __webpack_require__("ANQd");
var classofRaw = __webpack_require__("XywU");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "3OB6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return editorialFoldingBlockResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("XygZ");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("psNz");
/* harmony import */ var _collapsePanel_resolver__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+BJN");










function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var editorialFoldingBlockResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_10__[/* EDITORIAL_FOLDING_BLOCK */ "n"],
  props: function props() {
    return _objectSpread(_objectSpread({}, Object(lodash__WEBPACK_IMPORTED_MODULE_9__["omit"])(Object(_collapsePanel_resolver__WEBPACK_IMPORTED_MODULE_11__[/* props */ "a"])(), ['children'])), {}, {
      componentId: function componentId(_ref) {
        var anchor = _ref.anchor;
        return anchor;
      }
    });
  }
};

/***/ }),

/***/ "3dm5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var classof = __webpack_require__("3LIW");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js



var Heading_themes_themes = function themes(_ref) {
  var _classnames, _classnames2;

  var color = _ref.color;
  return {
    'heading-brand-1': {
      thRoot: classnames_default()('reset-heading font-brand leading-tight text-2xl lg:text-4xl', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "text-".concat(color), color), Object(defineProperty["a" /* default */])(_classnames, 'text-shadow-2', color === colors["a" /* COLORS */].WHITE), _classnames)),
      thSpan: 'mt-0 mb-px15'
    },
    'heading-brand-2': {
      thRoot: classnames_default()('reset-heading font-brand leading-tight text-4xl lg:text-7xl', (_classnames2 = {}, Object(defineProperty["a" /* default */])(_classnames2, "text-".concat(color), color), Object(defineProperty["a" /* default */])(_classnames2, 'text-shadow-2', color === colors["a" /* COLORS */].WHITE), _classnames2)),
      thSpan: 'mt-0 mb-px15'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx

var __jsx = react_default.a.createElement;






var MARKDOWN_TEXT = ['break', 'emphasis', 'paragraph', 'strong', 'text'];

var Heading_markdownRootRenderer = function markdownRootRenderer(hLevel) {
  return function (props) {
    var RootElementTag = "h".concat(hLevel);

    var children = props.children,
        node = props.node,
        otherProps = Object(objectWithoutProperties["a" /* default */])(props, ["children", "node"]);

    return __jsx(RootElementTag, otherProps, children);
  };
};

var Heading_markdownNeutralRenderer = function markdownNeutralRenderer(className) {
  return function (_ref) {
    var children = _ref.children;
    return __jsx("span", {
      className: classnames_default()('last-child-mb-0', className)
    }, children);
  };
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = Heading_themes_themes({
    color: color
  })[theme],
      thRoot = _themes$theme.thRoot,
      thSpan = _themes$theme.thSpan;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_TEXT,
    className: classnames_default()(className, thRoot),
    children: children,
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Heading_markdownRootRenderer(hLevel),
      paragraph: Heading_markdownNeutralRenderer(thSpan)
    }
  });
};

/***/ }),

/***/ "3zhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildProductsQuery */
/* unused harmony export buildOfferWithProductIdsQuery */
/* unused harmony export fetchProducts */
/* unused harmony export buildProductIdsQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productsGridResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("jw1E");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("4VTZ");


















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











function getThumbnailDatesArgs(props) {
  var today = moment__WEBPACK_IMPORTED_MODULE_17___default()();
  var start = moment__WEBPACK_IMPORTED_MODULE_17___default()(props.departureDateStart || null); // moment(undefined) === today, moment(null) === invalid date. Dat's why

  var end = moment__WEBPACK_IMPORTED_MODULE_17___default()(props.departureDateEnd || null);

  if (!start.isValid() || !end.isValid() || end.isSameOrBefore(today)) {
    return {};
  }

  return {
    duration: props.duration,
    departureCity: props.departureCity,
    dateStart: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_21__[/* momentToApiDate */ "j"])(start.isBefore(today) ? today : start),
    dateEnd: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_21__[/* momentToApiDate */ "j"])(end)
  };
} // Exported for test purpose only


function buildProductsQuery(_ref) {
  var appContext = _ref.appContext,
      isMice = _ref.isMice,
      productIds = _ref.productIds,
      offerId = _ref.offerId,
      props = _ref.props;
  var _appContext$cmsConten = appContext.cmsContent,
      content = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      release = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;

  var thumbnailArgs = _objectSpread({
    content: content,
    isMice: isMice,
    release: release,
    offerId: offerId,
    tourDurationPlaceholder: props.tourDurationPlaceholder,
    cruiseTimingPlaceholder: props.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: props.cruiseDurationPlaceholder,
    dateFormat: props.dateFormat
  }, getThumbnailDatesArgs(props));

  return "query {\n    products : resorts(resortIds : ".concat(JSON.stringify(productIds), ") {\n      ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_24__[/* default */ "b"])(thumbnailArgs), "\n    }\n    config(content : \"").concat(content, "\" release : \"").concat(release, "\") {\n      ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_25__[/* resort */ "e"](appContext), "\n      ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_25__[/* price */ "c"](), "\n      ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_25__[/* faceting */ "b"](), "\n      common {\n        backNavigation\n        close\n        closed\n        included\n        onDemand\n        openingSoon\n        next\n        previous\n        seeMore\n        scrollBackward\n        scrollForward\n        thumbnailCTA\n        thumbnailTourCTA\n      }\n      remote {\n        date\n        searchAction\n        noResult {\n          zeroResult\n          explanation\n        }\n      }\n    }\n  }");
}
function buildOfferWithProductIdsQuery(productIds, offerId) {
  return "query {\n    offer(offerId : \"".concat(offerId, "\") {\n      id\n      name\n      seoName\n      color\n      resortIds(resortIds: ").concat(JSON.stringify(productIds), ")\n      products {\n        id\n        price {\n          bestPrice {\n            value\n            formattedValue\n          }\n          initialPrice {\n            value\n            formattedValue\n          }\n          unit\n          currency\n          termsAndConditions {\n            departureDate\n            duration\n            durationFormatted\n            numberOfAdults\n            accommodationComfortLabel\n          }\n        }\n      }\n    }\n  }");
}
function fetchProducts(_ref2) {
  var appContext = _ref2.appContext,
      isMice = _ref2.isMice,
      productIds = _ref2.productIds,
      offerId = _ref2.offerId,
      props = _ref2.props;
  var query = buildProductsQuery({
    appContext: appContext,
    isMice: isMice,
    productIds: productIds,
    offerId: offerId,
    props: props
  });
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* LINE_COMMON_PRODUCT_GRID_PRODUCTS */ "Fb"],
    strictErrors: false
  }).then(function (data) {
    Object(_i18n__WEBPACK_IMPORTED_MODULE_20__[/* addTranslationKeys */ "a"])(data.config);
    return data;
  });
}
function buildProductIdsQuery(productIds) {
  return "query {\n    products : resorts(resortIds : ".concat(JSON.stringify(productIds), ") {\n      id\n    }\n  }");
}

function getThumbnailCMSTrads(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runQuery("query {\n      config {\n        thumbnails {\n          cruiseDurationPlaceholder\n          tourDurationPlaceholder\n          cruiseTimingPlaceholder\n        }\n      }\n    }", appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* LINE_COMMON_PRODUCT_GRID_THUMBNAIL_TRADS */ "Gb"]
  });
}

function fetchOfferWithProductIds(_x, _x2, _x3) {
  return _fetchOfferWithProductIds.apply(this, arguments);
}

function _fetchOfferWithProductIds() {
  _fetchOfferWithProductIds = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function _callee2(appContext, productIds, offerId) {
    var query, _yield$graphQLClient$, _yield$graphQLClient$2, resortIds, rest;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = buildOfferWithProductIdsQuery(productIds, offerId);
            _context2.next = 3;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* LINE_COMMON_PRODUCT_GRID_IDS_WITH_OFFER */ "Eb"],
              strictErrors: false
            });

          case 3:
            _yield$graphQLClient$ = _context2.sent;
            _yield$graphQLClient$2 = _yield$graphQLClient$.offer;
            resortIds = _yield$graphQLClient$2.resortIds;
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(_yield$graphQLClient$2, ["resortIds"]);
            return _context2.abrupt("return", {
              resortIds: resortIds,
              offer: rest
            });

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchOfferWithProductIds.apply(this, arguments);
}

function fetchProductIds(_x4, _x5) {
  return _fetchProductIds.apply(this, arguments);
}

function _fetchProductIds() {
  _fetchProductIds = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function _callee3(appContext, productIds) {
    var query, _yield$graphQLClient$3, products;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = buildProductIdsQuery(productIds);
            _context3.next = 3;
            return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* LINE_COMMON_PRODUCT_GRID_IDS */ "Db"],
              strictErrors: false
            });

          case 3:
            _yield$graphQLClient$3 = _context3.sent;
            products = _yield$graphQLClient$3.products;
            return _context3.abrupt("return", {
              resortIds: products.map(function (_ref4) {
                var id = _ref4.id;
                return id;
              })
            });

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchProductIds.apply(this, arguments);
}

var productsGridResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_19__[/* RESORT_GRID */ "ib"],
  resolve: function resolve(appContext, props, pageContext) {
    return Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.mark(function _callee() {
      var _props$displaySearch, displaySearch, _props$resortIds, productIds, offerId, isMice, fetchOfferAndProductIds, _fetchOfferAndProduct, offer, _fetchOfferAndProduct2, resortIds, sortedExistingProductIds, _yield$getThumbnailCM, thumbnailCMSTrads, _yield$fetchProducts, _yield$fetchProducts$, products, config;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_13___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props$displaySearch = props.displaySearch, displaySearch = _props$displaySearch === void 0 ? false : _props$displaySearch, _props$resortIds = props.resortIds, productIds = _props$resortIds === void 0 ? [] : _props$resortIds, offerId = props.offerId;
              isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_18__["b2cPagesService"].isMicePage(pageContext.pageType);
              _context.next = 4;
              return offerId ? fetchOfferWithProductIds(appContext, productIds, offerId)["catch"](function () {
                return fetchProductIds(appContext, productIds);
              }) : fetchProductIds(appContext, productIds);

            case 4:
              fetchOfferAndProductIds = _context.sent;
              _fetchOfferAndProduct = fetchOfferAndProductIds.offer, offer = _fetchOfferAndProduct === void 0 ? {} : _fetchOfferAndProduct, _fetchOfferAndProduct2 = fetchOfferAndProductIds.resortIds, resortIds = _fetchOfferAndProduct2 === void 0 ? [] : _fetchOfferAndProduct2;
              sortedExistingProductIds = productIds.filter(function (id) {
                return resortIds.indexOf(id) !== -1;
              });

              if (!(!sortedExistingProductIds || sortedExistingProductIds.length === 0)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", null);

            case 9:
              _context.next = 11;
              return getThumbnailCMSTrads(appContext);

            case 11:
              _yield$getThumbnailCM = _context.sent;
              thumbnailCMSTrads = _yield$getThumbnailCM.config;
              _context.next = 15;
              return fetchProducts({
                appContext: appContext,
                isMice: isMice,
                productIds: sortedExistingProductIds,
                offerId: offer.id,
                props: _objectSpread(_objectSpread({}, props), thumbnailCMSTrads.thumbnails)
              });

            case 15:
              _yield$fetchProducts = _context.sent;
              _yield$fetchProducts$ = _yield$fetchProducts.products;
              products = _yield$fetchProducts$ === void 0 ? [] : _yield$fetchProducts$;
              config = _yield$fetchProducts.config;
              return _context.abrupt("return", {
                config: config,
                displaySearch: displaySearch,
                offer: offer,
                productIds: sortedExistingProductIds,
                products: sortedExistingProductIds.reduce(function (acc, next) {
                  var product = products.find(function (_ref3) {
                    var id = _ref3.id;
                    return id === next;
                  });

                  if (product) {
                    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(acc), [product]);
                  }

                  return acc;
                }, [])
              });

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};

/***/ }),

/***/ "4+vj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPertimmDateFormat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPertimmDate; });
/* unused harmony export loadFacetingTopCountries */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOffsetSell; });
/* unused harmony export loadProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadProductsWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchWithFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadChildcareAvailabilities; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("y316");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("L73y");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("KL6I");

























function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_23__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var PERTIMM_ENGLISH_SPEAKING_LOCALE = 'en';
function getPertimmDateFormat(locale) {
  return (locale === null || locale === void 0 ? void 0 : locale.slice(0, 2)) === PERTIMM_ENGLISH_SPEAKING_LOCALE ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
}
function formatPertimmDate(departureDate, locale) {
  var format = getPertimmDateFormat(locale);
  return departureDate.isValid() ? departureDate.format(format) : '';
}

function getResortThumbnailArgsConfig(appContext) {
  var query = "query {\n    config {\n      thumbnails {\n        tourDurationPlaceholder\n        cruiseTimingPlaceholder\n        cruiseDurationPlaceholder\n        dateFormat\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCT_CONFIG */ "Fd"]
  });
}

function getAllProductsInfo(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      _ref$ids = _ref.ids,
      ids = _ref$ids === void 0 ? [] : _ref$ids;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var _options$offerId = options.offerId,
      offerId = _options$offerId === void 0 ? '' : _options$offerId,
      _options$offerName = options.offerName,
      offerName = _options$offerName === void 0 ? '' : _options$offerName,
      _options$productIds = options.productIds,
      productIds = _options$productIds === void 0 ? [] : _options$productIds;
  return getResortThumbnailArgsConfig(appContext).then(function (data) {
    var resortThumbnailQueryArgs = _objectSpread({
      content: cmsContent,
      release: cmsRelease,
      isMice: false,
      offerName: offerName,
      offerId: offerId
    }, data.config.thumbnails);

    var allProductsId = productIds.length ? ids.filter(function (id) {
      return productIds.includes(id);
    }) : ids;
    var query = "query {\n      resorts(resortIds : [\"".concat(allProductsId.join('","'), "\"]) {\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__[/* default */ "b"])(resortThumbnailQueryArgs, {
      withoutPrice: true
    }), "\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCTS */ "Dd"]
    });
  });
}

function loadFacetingTopCountries(_ref2) {
  var appContext = _ref2.appContext;
  var query = "query {\n    config {\n      faceting {\n        topCountries {\n          enabled\n           title\n           items {\n             id\n           }\n        }\n      }\n    }\n  }";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_FACETING_TOP_COUNTRIES */ "Bd"]
  });
}
function loadOffsetSell(_ref3) {
  var appContext = _ref3.appContext;
  var query = "\n    query {\n      locale {\n        joyviewOffsetSell\n        resortOffsetSell\n      }\n    }\n  ";
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_OFFSET_SELL */ "Cd"]
  });
}
function loadProducts(_ref4) {
  var appContext = _ref4.appContext,
      options = _ref4.options;
  return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_26__[/* getIdsFromProducts */ "a"])(appContext).then(function (ids) {
    return getAllProductsInfo({
      appContext: appContext,
      options: options,
      ids: ids
    });
  });
}
function loadProductsWithIds(_ref5) {
  var appContext = _ref5.appContext,
      productIds = _ref5.productIds;
  return getAllProductsInfo({
    appContext: appContext,
    options: {},
    ids: productIds
  });
}
function searchWithFacets(_ref6) {
  var criteria = _ref6.criteria,
      options = _ref6.options,
      appContext = _ref6.appContext;
  var facetingTopCountriesPromise = loadFacetingTopCountries({
    appContext: appContext
  });
  var productsPromise = loadProducts({
    appContext: appContext,
    options: options
  });
  var userIsSeller = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_33__[/* isSeller */ "g"])(appContext); // $FlowFixMe

  var searchPromise = Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_26__[/* searchWithFacets */ "c"])({
    criteria: _objectSpread(_objectSpread({}, criteria), {}, {
      tripDuration: userIsSeller ? null : criteria.tripDuration
    }),
    appContext: appContext
  });
  return Promise.all([facetingTopCountriesPromise, productsPromise, searchPromise]).then(function (_ref7) {
    var _ref8 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"])(_ref7, 3),
        facetingTopCountriesInfo = _ref8[0],
        productsInfo = _ref8[1],
        pertimmResults = _ref8[2];

    var facetingTopCountries = Object(lodash__WEBPACK_IMPORTED_MODULE_24__["get"])(facetingTopCountriesInfo, 'config.faceting.topCountries');
    var filteredProducts = Object(lodash__WEBPACK_IMPORTED_MODULE_24__["get"])(pertimmResults, 'answers', []).reduce(function (acc, result) {
      var resultProductId = Object(lodash__WEBPACK_IMPORTED_MODULE_24__["get"])(result, 'meta.product_id[0]');
      var resort = productsInfo.resorts.find(function (_ref9) {
        var id = _ref9.id;
        return id === resultProductId;
      });
      var isAllAttendeeAllowed = !!resort && (!criteria.kids || criteria.kids.every(function (_ref10) {
        var birthdate = _ref10.birthdate;
        return Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_30__[/* getKidAgeInMonths */ "h"])({
          birthdate: birthdate,
          departureDate: criteria.departureDate
        }) >= resort.minAuthorizedAge.value;
      }));
      return resort && isAllAttendeeAllowed ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_21__[/* default */ "a"])(acc), [resort]) : acc;
    }, []);
    var sortedFilteredProducts = criteria.productIds && criteria.productIds.length > 0 ? criteria.productIds.map(function (id) {
      return filteredProducts.find(function (product) {
        return product.id === id;
      });
    }) : filteredProducts;
    return _objectSpread(_objectSpread({
      facetingTopCountries: facetingTopCountries
    }, pertimmResults), {}, {
      query: criteria.query || '',
      search: {
        products: sortedFilteredProducts.filter(Boolean)
      }
    });
  });
}

function getTransportArgs(criteria) {
  var departureCityFilter = Object(lodash__WEBPACK_IMPORTED_MODULE_24__["get"])(criteria, 'filters', []).find(function (filter) {
    return filter.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  });
  var selectedDepartureCity = Object(lodash__WEBPACK_IMPORTED_MODULE_24__["get"])(departureCityFilter, 'name');

  switch (selectedDepartureCity) {
    case 'NO':
      return {
        forceWithoutTransport: true,
        departureCity: ''
      };

    case undefined:
      return {
        forceWithoutTransport: false,
        departureCity: criteria.defaultDepartureCity || ''
      };

    default:
      return {
        forceWithoutTransport: false,
        departureCity: selectedDepartureCity
      };
  }
}

function loadPrices(_ref11) {
  var appContext = _ref11.appContext,
      _ref11$criteria = _ref11.criteria,
      criteria = _ref11$criteria === void 0 ? {} : _ref11$criteria,
      withFlexibility = _ref11.withFlexibility;
  var _criteria$offerName = criteria.offerName,
      offerName = _criteria$offerName === void 0 ? '' : _criteria$offerName,
      _criteria$offerId = criteria.offerId,
      offerId = _criteria$offerId === void 0 ? '' : _criteria$offerId,
      _criteria$productIds = criteria.productIds,
      productIds = _criteria$productIds === void 0 ? [] : _criteria$productIds,
      duration = criteria.duration;

  var _getTransportArgs = getTransportArgs(criteria),
      departureCity = _getTransportArgs.departureCity,
      forceWithoutTransport = _getTransportArgs.forceWithoutTransport;

  var date = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* formatTimestampDate */ "b"])(criteria.departureDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DATE_FORMAT */ "f"]) || '';
  var dateStart = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* formatTimestampDate */ "b"])(criteria.minDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DATE_FORMAT */ "f"]) || '';
  var dateEnd = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* formatTimestampDate */ "b"])(criteria.maxDate, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_31__[/* DATE_FORMAT */ "f"]) || '';
  var hasDateRange = dateStart && dateEnd && (!date || withFlexibility);
  var query = "\n    query {\n      resorts(\n        optimizedPriceCalls: true,\n        ".concat(date ? "date: \"".concat(date, "\",") : '', "\n        ").concat(hasDateRange ? "dateStart: \"".concat(dateStart, "\",") : '', "\n        ").concat(hasDateRange ? "dateEnd: \"".concat(dateEnd, "\",") : '', "\n        resortIds: [\"").concat(productIds.join('","'), "\"],\n        departureCity: \"").concat(departureCity, "\",\n        duration: ").concat(String(duration || null), ",\n        offerName: \"").concat(offerName, "\",\n        offerId: \"").concat(offerId, "\",\n        forceWithoutTransport: ").concat(String(forceWithoutTransport), ",\n      ) {\n        id\n        ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_27__[/* cleanupArgs */ "a"])({
    isMice: false,
    optimizedPriceCalls: true,
    resortIds: productIds,
    departureCity: departureCity,
    duration: duration || undefined,
    // for flow: criteria duration can be null, but cleanupArgs doesn't accept null as parameter.
    offerName: offerName,
    offerId: offerId,
    forceWithoutTransport: forceWithoutTransport,
    content: appContext.cmsContent,
    release: appContext.cmsRelease,
    date: date,
    dateStart: dateStart,
    dateEnd: dateEnd
  })), "\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCT_PRICE */ "Gd"]
  });
}
function loadChildcareAvailabilities(_ref12) {
  var appContext = _ref12.appContext,
      _ref12$criteria = _ref12.criteria,
      criteria = _ref12$criteria === void 0 ? {} : _ref12$criteria;
  var _criteria$productIds2 = criteria.productIds,
      productIds = _criteria$productIds2 === void 0 ? [] : _criteria$productIds2,
      arrivalDate = criteria.departureDate,
      duration = criteria.duration,
      kids = criteria.kids;

  if (!kids || kids.length === 0) {
    return Promise.resolve();
  }

  var query = "\n    query {\n      childcareSearch(\n        arrival_date: \"".concat(Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* formatTimestampDate */ "b"])(arrivalDate, 'YYYYMMDD') || '', "\",\n        product_ids: [\"").concat(productIds.join('","'), "\"],\n        concerned_attendees_birthdates: [\"").concat(kids.map(function (_ref13) {
    var birthdate = _ref13.birthdate;
    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* formatTimestampDate */ "b"])(birthdate, 'YYYYMMDD');
  }).join('","'), "\"],\n        duration: ").concat(String(duration || null), ",\n      ) {\n        id\n        productId,\n        availability,\n        isIncluded,\n        ageMin,\n        ageMax\n        remainingStock\n      }\n    }\n  ");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_29__[/* STATE_SEARCH_PRODUCT_CHILDCARE */ "Ed"]
  });
}

/***/ }),

/***/ "4/4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.themes.js

var Tabs_themes_themes = function themes(_ref) {
  var isScrollable = _ref.isScrollable,
      isTablet = _ref.isTablet;
  return {
    "default": {
      thHeader: '',
      thList: 'pb-px10',
      thListItem: classnames_default()({
        'flex-grow': !isScrollable
      }),
      thSlot: 'pb-px10',
      thBody: '-mt-px10 pt-px20',
      thScrollableNavPosition: 'side'
    },
    clean: {
      thHeader: 'border-b-1 items-stretch',
      thList: 'whitespace-no-wrap',
      thListItem: 'decorator-separator-left',
      thSlot: 'flex items-center rtl:border-r-1',
      thBody: '-m-px py-px20',
      thScrollableNavPosition: 'side'
    },
    rounded: {
      thHeader: '',
      thScrollable: 'flex-1',
      thList: '',
      thListItem: 'flex-1',
      thSlot: '',
      thBody: 'bg-white border-1 border-t-0 rounded-tiny',
      thScrollableNavPosition: 'side'
    },
    simple: {
      thHeader: '',
      thList: 'pb-px10',
      thListItem: classnames_default()('mx-px5', {
        'flex-grow': !isScrollable
      }),
      thSlot: 'pb-px10',
      thBody: '',
      thScrollableNavPosition: 'side'
    },
    lite: {
      thHeader: 'mb-px20 justify-between items-end flex-wrap',
      thList: '-mx-px5 flex-grow',
      thListItem: classnames_default()('mx-px5', {
        'flex-none': isScrollable
      }),
      thSlot: '',
      thScrollableNavPosition: 'side'
    },
    flat: {
      thBody: 'bg-white border-1 border-gray-light p-px20 rounded-tiny relative -mt-px shadow-diffuse',
      thHeader: 'items-center',
      thList: '',
      thListItem: '',
      thSlot: 'flex-shrink-0',
      thScrollableNavPosition: 'side'
    },
    buttons: {
      thBody: 'border-t-1 border-gray-light pt-px60 relative',
      thHeader: 'items-center',
      thList: '-mb-px px-px',
      thListItem: '',
      thSlot: 'flex-shrink-0 rtl:ml-auto top-full mt-px10 absolute z-1 md:static md:mt-0 px-px20 md:px-0 inset-x-0',
      thScrollableNavPosition: isTablet ? 'side' : 'center'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx














var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var Tabs_Tabs = function _Tabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      bgColor = _ref.bgColor,
      className = _ref.className,
      collapseIconName = _ref.collapseIconName,
      containerSize = _ref.containerSize,
      expandIconName = _ref.expandIconName,
      hasControlsOnTouch = _ref.hasControlsOnTouch,
      hasBackground = _ref.hasBackground,
      isContainerWide = _ref.isContainerWide,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      initialSelectedItem = _ref$initialSelectedI === void 0 ? 0 : _ref$initialSelectedI,
      id = _ref.id,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      onSelect = _ref.onSelect,
      onTabClick = _ref.onTabClick,
      scrollForwardLabel = _ref.scrollForwardLabel,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      slotLeft = _ref.slotLeft,
      slotRight = _ref.slotRight,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL,
      isTablet = _useResponsive.isTablet;

  if (!items.length) {
    return null;
  }

  var refsArray = [];
  var _themes$theme = Tabs_themes_themes({
    isScrollable: isScrollable,
    isTablet: isTablet
  })[theme],
      thBody = _themes$theme.thBody,
      thHeader = _themes$theme.thHeader,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thScrollable = _themes$theme.thScrollable,
      thScrollableNavPosition = _themes$theme.thScrollableNavPosition,
      thSlot = _themes$theme.thSlot;

  var tabUpdate = function tabUpdate(idx, update) {
    update(idx);
    refsArray[idx] && refsArray[idx].focus();
  };

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index,
        update = _ref2.update;

    if (items.length > 1) {
      var lastItem = items.length - 1;

      switch (e.which) {
        case keyCodes["c" /* ARROW_RIGHT */]:
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          tabUpdate(index === lastItem ? 0 : index + 1, update);
          break;

        case keyCodes["b" /* ARROW_LEFT */]:
        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          tabUpdate(index === 0 ? lastItem : index - 1, update);
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          tabUpdate(0, update);
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          tabUpdate(lastItem, update);
          break;

        default:
      }
    }
  };

  var tabsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: [initialSelectedItem],
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        lastIndex = _ref3.lastIndex;
    var els = items.filter(Boolean).map(function (_ref4, index) {
      var customHeader = _ref4.customHeader,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var onClick = function onClick() {
        tabUpdate(index, update);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(headerId, index);
      };

      var isActive = activeIndexes.includes(index);

      var setRef = function setRef(ref) {
        refsArray[index] = ref;
      };

      var title = header.title,
          _header$headerClassNa = header.headerClassNames,
          headerClassNames = _header$headerClassNa === void 0 ? {} : _header$headerClassNa,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title", "headerClassNames"]);

      var headerProps = _objectSpread(_objectSpread({}, rest), {}, {
        className: thListItem,
        controlsId: panelId,
        modifierClassNames: headerClassNames,
        id: headerId,
        isActive: isActive,
        isDisabled: tabsCount <= 1,
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index,
            update: update
          });
        },
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        tabIndex: isActive || index === lastIndex ? 0 : -1
      });

      if (Object(lodash["isFunction"])(customHeader)) {
        return customHeader(headerProps, setRef);
      }

      return __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, headerProps, {
        collapseIconName: collapseIconName,
        expandIconName: expandIconName,
        key: headerId,
        ref: setRef,
        role: "tab",
        style: isRTL && isScrollable ? {
          direction: 'rtl'
        } : null,
        theme: theme
      }), title);
    });

    var tabsList = __jsx("div", {
      className: classnames_default()('reset-list flex w-full', thList),
      role: "tablist"
    }, els);

    return __jsx("section", {
      className: className,
      id: id,
      "data-cs-override-id": "Tabs" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
      ,
      "data-testid": "tabs"
    }, __jsx(SiteContainer["a" /* SiteContainer */], {
      isWide: isContainerWide,
      size: containerSize
    }, __jsx("div", {
      className: classnames_default()('flex', thHeader)
    }, slotLeft && __jsx("div", {
      className: thSlot
    }, slotLeft(activeIndexes)), isScrollable ? __jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      className: thScrollable,
      forwardLabel: scrollForwardLabel,
      hasShadow: true,
      hasControlsOnTouch: hasControlsOnTouch,
      navPosition: thScrollableNavPosition
    }, tabsList) : tabsList, slotRight && __jsx("div", {
      className: thSlot
    }, slotRight(activeIndexes)))), __jsx("div", {
      "data-testid": "tabs-items-container",
      className: classnames_default()(Object(defineProperty["a" /* default */])({}, Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground, bgColor), activeIndexes.length > 0 && !activeIndexes.includes(-1)), thBody)
    }, items.filter(Boolean).map(function (_ref5, index) {
      var content = _ref5.content,
          headerId = _ref5.headerId,
          panelId = _ref5.panelId;
      var isActive = activeIndexes.includes(index);
      return (!isContentUnmountedOnCollapse || isActive) && __jsx("div", {
        "aria-hidden": !isActive,
        "aria-labelledby": headerId,
        className: classnames_default()({
          'h-0 invisible overflow-hidden pointer-events-none': !isActive,
          fadeIn: isActive
        }),
        "data-cs-override-id": "Tabs-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        key: panelId,
        role: "tabpanel",
        "data-testid": "tabs-item-".concat(index, "-content")
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        isWide: isContainerWide,
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i)
        }) : null;
      })));
    })));
  });
};

var Tabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Tabs_Tabs);

/***/ }),

/***/ "45Yg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRIP_INFORMATION_SET_FLEXIBILITY; });
var TRIP_INFORMATION_SET_FLEXIBILITY = 'TRIP_INFORMATION_SET_FLEXIBILITY';

/***/ }),

/***/ "47Eh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shouldHideServicesPage */
/* unused harmony export shouldHideTransportPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStepIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilteredBreadcrumbPages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateInBookingEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllProposalsIdWithAlternative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackErrorOnAddService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttendeesList; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ee2X");
/* harmony import */ var core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_splice__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("SPKZ");
/* harmony import */ var _components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("z8xc");
/* harmony import */ var _components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("aWOT");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("oL6k");
/* harmony import */ var _utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("1qsz");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("nv//");




















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











var JOYVIEW_ROOM_ONLY = _clubmed_utils__WEBPACK_IMPORTED_MODULE_21__["constants"].PACKAGES.JOYVIEW_ROOM_ONLY;
var BASE_PATH = '/booking/';
var shouldHideServicesPage = function shouldHideServicesPage(selectedProposal, resort) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__[/* hasChildcare */ "q"])(selectedProposal) && !resort.isJoyview && selectedProposal.additionalServices.childcares.length === 0 || resort.isJoyview && !selectedProposal.alternativePackages && selectedProposal.packageId === JOYVIEW_ROOM_ONLY;
};
var shouldHideTransportPage = function shouldHideTransportPage(selectedProposal) {
  return !Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__[/* hasTransfer */ "t"])(selectedProposal) && !Object(lodash__WEBPACK_IMPORTED_MODULE_19__["get"])(selectedProposal, 'transports');
};
var getStepIndex = function getStepIndex(steps, bookingStep) {
  return steps.findIndex(function (step) {
    return step.name === bookingStep;
  });
}; // eslint-disable-next-line max-params

var getFilteredBreadcrumbPages = function getFilteredBreadcrumbPages(_ref) {
  var selectedProposal = _ref.selectedProposal,
      resort = _ref.resort,
      i18n = _ref.i18n,
      isActivitiesViewFeatureFlipped = _ref.isActivitiesViewFeatureFlipped,
      isOptionHoldOnlyFeatureFlipped = _ref.isOptionHoldOnlyFeatureFlipped,
      _ref$isSeller = _ref.isSeller,
      isSeller = _ref$isSeller === void 0 ? false : _ref$isSeller,
      _ref$isCmta = _ref.isCmta,
      isCmta = _ref$isCmta === void 0 ? false : _ref$isCmta,
      _ref$isDelCredere = _ref.isDelCredere,
      isDelCredere = _ref$isDelCredere === void 0 ? false : _ref$isDelCredere;
  var isRecommendedTransportSelected = selectedProposal.transports && Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_26__[/* isRecommendedTransport */ "A"])(selectedProposal.transports, selectedProposal.id);
  var activitiesView = isActivitiesViewFeatureFlipped && (selectedProposal.additionalServices.activities.some(function (activity) {
    var _activity$productInfo;

    return ((_activity$productInfo = activity.productInfo) === null || _activity$productInfo === void 0 ? void 0 : _activity$productInfo.isIncluded) === false;
  }) || selectedProposal.additionalServices.rentals.length > 0) ? {
    name: 'activities',
    path: "".concat(BASE_PATH, "activities"),
    actionGA: 'activities',
    labelGA: 'validateActivities',
    basePriceGALabel: 'basePriceActivities',
    icon: Object(_utils_resort_resortUtils__WEBPACK_IMPORTED_MODULE_27__[/* isWinterMountainResort */ "a"])(resort) ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SKI : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].GOLF,
    showIcon: true,
    title: i18n.booking.activities.pageTitle,
    seoTitle: i18n.booking.activities.seo.title,
    gridSize: 'large'
  } : null;
  var isJoyview = Object(lodash__WEBPACK_IMPORTED_MODULE_19__["get"])(resort, 'isJoyview');
  var breadcrumbPages = [{
    name: 'accommodation',
    path: "".concat(BASE_PATH, "accommodation"),
    eventPageName: 'accommodations',
    actionGA: 'accommodation',
    labelGA: 'validateAccommodation',
    basePriceGALabel: 'basePriceAccommodation',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].ACCOMODATIONS,
    showIcon: true,
    title: Object(_components_utils_booking_bookingUtils__WEBPACK_IMPORTED_MODULE_24__[/* tAlt */ "q"])({
      resortKeyPath: isSeller ? 'booking.partners.accommodation.pageTitle' : 'booking.accommodation.pageTitle',
      cruiseKeyPath: 'booking.accommodation.pageTitleCruise',
      resort: resort
    }),
    seoTitle: i18n.booking.accommodation.seo.title,
    gridSize: 'large'
  }, _objectSpread(_objectSpread({
    name: 'transport',
    path: "".concat(BASE_PATH, "transport"),
    actionGA: 'transport',
    labelGA: 'validateTransport'
  }, Object(lodash__WEBPACK_IMPORTED_MODULE_19__["get"])(selectedProposal, 'transports') ? {
    icon: Object(_components_widgets_transport_details_transportUtils__WEBPACK_IMPORTED_MODULE_23__[/* getTransportIcon */ "g"])(Object(lodash__WEBPACK_IMPORTED_MODULE_19__["get"])(selectedProposal, 'transports.inbound'), Object(lodash__WEBPACK_IMPORTED_MODULE_19__["get"])(selectedProposal, 'transports.outbound')),
    // eslint-disable-next-line no-nested-ternary
    title: isRecommendedTransportSelected ? isSeller ? i18n.booking.partners.transport.transportPageTitle : i18n.booking.transport.transportPageTitle : i18n.booking.transport.additionalTransports.transportSelection,
    seoTitle: i18n.booking.transport.seo.title,
    basePriceGALabel: 'basePriceTransport'
  } : {
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].TRANSFER,
    title: isSeller ? i18n.booking.partners.transport.transferPageTitle : i18n.booking.transport.transferPageTitle,
    seoTitle: i18n.booking.transport.transfer.seo.title,
    basePriceGALabel: 'basePriceTransfer'
  }), {}, {
    showIcon: true,
    isToBeHidden: shouldHideTransportPage(selectedProposal),
    gridSize: 'large'
  }), {
    name: 'services',
    path: "".concat(BASE_PATH, "services"),
    actionGA: isJoyview ? 'allInclusive' : 'service',
    labelGA: isJoyview ? 'validateAllInclusive' : 'validateServices',
    basePriceGALabel: 'basePriceServices',
    icon: isJoyview ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].DATE_PLUS : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CHILDREN,
    showIcon: true,
    title: isJoyview ? i18n.booking.services.pageTitleJoyview : i18n.booking.services.pageTitleChildcare,
    seoTitle: i18n.booking.services.seo.title,
    isToBeHidden: shouldHideServicesPage(selectedProposal, resort),
    gridSize: isJoyview ? 'small' : 'large'
  }, {
    name: 'participants',
    path: "".concat(BASE_PATH, "participants"),
    actionGA: 'participant',
    labelGA: 'validateParticipants',
    basePriceGALabel: 'basePricePaymentParticipants',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CONTACT,
    showIcon: true,
    title: i18n.booking.participants.pageTitle,
    seoTitle: i18n.booking.participants.seo.title,
    gridSize: 'large'
  }, {
    name: 'summary',
    path: "".concat(BASE_PATH, "summary"),
    actionGA: 'summary',
    labelGA: 'validateSummary',
    basePriceGALabel: 'basePriceSummary',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].SUMMARY,
    showIcon: true,
    title: isCmta ? Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.partners.summary.pageTitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_25__[/* t */ "h"])('booking.summary.pageTitle'),
    seoTitle: i18n.booking.summary.seo.title,
    gridSize: 'large'
  }];
  if (activitiesView) breadcrumbPages.splice(3, 0, activitiesView); // adds the banking step if the optionHoldOnly featureFlip is disabled

  if (!isOptionHoldOnlyFeatureFlipped) breadcrumbPages.push({
    name: 'banking',
    eventPageName: 'banking',
    path: "".concat(BASE_PATH, "banking"),
    actionGA: 'banking',
    agenceType: isSeller && isDelCredere ? 'Ducroire' : 'NonDucroire',
    labelGA: 'validateBanking',
    basePriceGALabel: 'basePricePaymentBanking',
    icon: _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_22__[/* ICONS */ "a"].CREDIT_CARD,
    showIcon: !isSeller || isCmta,
    title: i18n.booking.banking.pageTitle,
    seoTitle: i18n.booking.banking.seo.title
  }); // $FlowFixMe Absolutely no clue of why

  return Object(lodash__WEBPACK_IMPORTED_MODULE_19__["reject"])(breadcrumbPages, 'isToBeHidden');
};
var navigateInBookingEngine = function navigateInBookingEngine(_ref2) {
  var location = _ref2.location,
      history = _ref2.history,
      _ref2$replace = _ref2.replace,
      replace = _ref2$replace === void 0 ? false : _ref2$replace;
  var nextUri = location instanceof urijs__WEBPACK_IMPORTED_MODULE_20___default.a ? location : Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_28__[/* convertLocationToURI */ "c"])(location);
  var fileName = nextUri.filename();
  var shownUri = nextUri.clone();
  nextUri.pathname('/booking').setQuery('bookingStep', fileName);
  var nextUrl = nextUri.resource().toString();
  var shownUrl = shownUri.resource().toString();

  if (replace) {
    return history.replace(nextUrl, shownUrl);
  }

  return history.push(nextUrl, shownUrl);
};
var getAllProposalsIdWithAlternative = function getAllProposalsIdWithAlternative(proposal) {
  return [proposal.id].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(proposal.alternativePackages ? proposal.alternativePackages.map(function (alternativePackage) {
    return alternativePackage.proposalId;
  }) : []));
};
var trackErrorOnAddService = function trackErrorOnAddService(error, trackCallback, defaultValue) {
  if (error) {
    var _error$errors, _error$errors$, _error$errors$$respon, _error$errors$$respon2, _error$errors$$respon3;

    var errorCode = error === null || error === void 0 ? void 0 : (_error$errors = error.errors) === null || _error$errors === void 0 ? void 0 : (_error$errors$ = _error$errors[0]) === null || _error$errors$ === void 0 ? void 0 : (_error$errors$$respon = _error$errors$.responseBody) === null || _error$errors$$respon === void 0 ? void 0 : (_error$errors$$respon2 = _error$errors$$respon.errors) === null || _error$errors$$respon2 === void 0 ? void 0 : (_error$errors$$respon3 = _error$errors$$respon2[0]) === null || _error$errors$$respon3 === void 0 ? void 0 : _error$errors$$respon3.error_code;
    trackCallback({
      labelGA: "error_".concat(errorCode ? errorCode : defaultValue)
    });
  }
};
var getAttendeesList = function getAttendeesList(attendeesWithInfos) {
  var adults = attendeesWithInfos.adults,
      children = attendeesWithInfos.children;
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(adults), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(children.map(function (kid) {
    return _objectSpread(_objectSpread({}, kid), {}, {
      isChild: true
    });
  })));
};

/***/ }),

/***/ "47go":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function () {
    var STATE_OUTPUT       = 0,
        STATE_HTML         = 1,
        STATE_PRE_COMMENT  = 2,
        STATE_COMMENT      = 3,
        WHITESPACE         = /\s/,
        ALLOWED_TAGS_REGEX = /<(\w*)>/g;

    function striptags(html, allowableTags) {
        var html = html || '',
            state = STATE_OUTPUT,
            depth = 0,
            output = '',
            tagBuffer = '',
            inQuote = false,
            i, length, c;

        if (typeof allowableTags === 'string') {
            // Parse the string into an array of tags
            allowableTags = parseAllowableTags(allowableTags);
        } else if (!Array.isArray(allowableTags)) {
            // If it is not an array, explicitly set to null
            allowableTags = null;
        }

        for (i = 0, length = html.length; i < length; i++) {
            c = html[i];

            switch (c) {
                case '<': {
                    // ignore '<' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // '<' followed by a space is not a valid tag, continue
                    if (html[i + 1] == ' ') {
                        consumeCharacter(c);
                        break;
                    }

                    // change to STATE_HTML
                    if (state == STATE_OUTPUT) {
                        state = STATE_HTML;

                        consumeCharacter(c);
                        break;
                    }

                    // ignore additional '<' characters when inside a tag
                    if (state == STATE_HTML) {
                        depth++;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '>': {
                    // something like this is happening: '<<>>'
                    if (depth) {
                        depth--;
                        break;
                    }

                    // ignore '>' if inside a quote
                    if (inQuote) {
                        break;
                    }

                    // an HTML tag was closed
                    if (state == STATE_HTML) {
                        inQuote = state = 0;

                        if (allowableTags) {
                            tagBuffer += '>';
                            flushTagBuffer();
                        }

                        break;
                    }

                    // '<!' met its ending '>'
                    if (state == STATE_PRE_COMMENT) {
                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    // if last two characters were '--', then end comment
                    if (state == STATE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '-') {

                        inQuote = state = 0;
                        tagBuffer = '';
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                // catch both single and double quotes
                case '"':
                case '\'': {
                    if (state == STATE_HTML) {
                        if (inQuote == c) {
                            // end quote found
                            inQuote = false;
                        } else if (!inQuote) {
                            // start quote only if not already in one
                            inQuote = c;
                        }
                    }

                    consumeCharacter(c);
                    break;
                }

                case '!': {
                    if (state == STATE_HTML &&
                        html[i - 1] == '<') {

                        // looks like we might be starting a comment
                        state = STATE_PRE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case '-': {
                    // if the previous two characters were '!-', this is a comment
                    if (state == STATE_PRE_COMMENT &&
                        html[i - 1] == '-' &&
                        html[i - 2] == '!') {

                        state = STATE_COMMENT;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                case 'E':
                case 'e': {
                    // check for DOCTYPE, because it looks like a comment and isn't
                    if (state == STATE_PRE_COMMENT &&
                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {

                        state = STATE_HTML;
                        break;
                    }

                    consumeCharacter(c);
                    break;
                }

                default: {
                    consumeCharacter(c);
                }
            }
        }

        function consumeCharacter(c) {
            if (state == STATE_OUTPUT) {
                output += c;
            } else if (allowableTags && state == STATE_HTML) {
                tagBuffer += c;
            }
        }

        function flushTagBuffer() {
            var normalized = '',
                nonWhitespaceSeen = false,
                i, length, c;

            normalizeTagBuffer:
            for (i = 0, length = tagBuffer.length; i < length; i++) {
                c = tagBuffer[i].toLowerCase();

                switch (c) {
                    case '<': {
                        break;
                    }

                    case '>': {
                        break normalizeTagBuffer;
                    }

                    case '/': {
                        nonWhitespaceSeen = true;
                        break;
                    }

                    default: {
                        if (!c.match(WHITESPACE)) {
                            nonWhitespaceSeen = true;
                            normalized += c;
                        } else if (nonWhitespaceSeen) {
                            break normalizeTagBuffer;
                        }
                    }
                }
            }

            if (allowableTags.indexOf(normalized) !== -1) {
                output += tagBuffer;
            }

            tagBuffer = '';
        }

        return output;
    }

    /**
     * Return an array containing tags that are allowed to pass through the
     * algorithm.
     *
     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
     * @return array|null An array of allowed tags or null if none.
     */
    function parseAllowableTags(allowableTags) {
        var tagsArray = [],
            match;

        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
            tagsArray.push(match[1]);
        }

        return tagsArray.length !== 0 ? tagsArray : null;
    }

    return striptags;
}));


/***/ }),

/***/ "4A3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AsyncLoader_AsyncLoader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/label/SpinnerLabel.jsx
var SpinnerLabel = __webpack_require__("4SQ0");

// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center h-full items-center'
  },
  labeled: {
    thRoot: 'flex flex-col justify-center items-center my-0 mx-auto text-center',
    thRootStyle: {
      width: '20rem'
    },
    thLabel: 'inline'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx








var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var AsyncLoader_AsyncLoader = function AsyncLoader(_ref) {
  var className = _ref.className,
      label = _ref.label,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref$icon,
      iconSize = _ref.iconSize,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thRootStyle = _themes$theme.thRootStyle;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: _objectSpread(_objectSpread({}, thRootStyle), style)
  }, __jsx(Spinner["a" /* Spinner */], {
    iconName: icon,
    iconSize: iconSize
  }), __jsx(SpinnerLabel["a" /* SpinnerLabel */], {
    className: thLabel,
    label: label
  }));
};

/***/ }),

/***/ "4Bi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createReducer(initialState) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = action && action.type && handlers ? handlers[action.type] : undefined; // if no action was provided, return the actual state

    if (!handler) {
      return state;
    }

    state = handler(state, action);
    return state;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),

/***/ "4HxW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productRelatedProductsResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("CcNa");








var productRelatedProductsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* RELATED_PRODUCTS */ "ab"],
  resolve: function resolve(appContext, props, pageContext) {
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var _props$resortId = props.resortId,
        resortId = _props$resortId === void 0 ? '' : _props$resortId,
        tourDurationPlaceholder = props.tourDurationPlaceholder,
        cruiseTimingPlaceholder = props.cruiseTimingPlaceholder,
        cruiseDurationPlaceholder = props.cruiseDurationPlaceholder,
        dateFormat = props.dateFormat;
    var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].isMicePage(pageContext.pageType);
    var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
    var query = "query {\n      product: resort(productId: \"".concat(resortId, "\") {\n        relatedProducts {\n          id\n          ").concat(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])({
      content: cmsContent,
      release: cmsRelease,
      isMice: isMice,
      tourDurationPlaceholder: tourDurationPlaceholder,
      cruiseTimingPlaceholder: cruiseTimingPlaceholder,
      cruiseDurationPlaceholder: cruiseDurationPlaceholder,
      dateFormat: dateFormat
    }), "\n        }\n      }\n      config(").concat(cmsArgs, ") {\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_4__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_4__[/* price */ "c"](), "\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__[/* LINE_PRODUCT_RELATED_PRODUCTS */ "sc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "4I0e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "4NBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productBookingBEResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var productBookingBEResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* RESORT_BOOKING_BE */ "fb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var offerName = location.queryParams.offer ? _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["url"].decodePath(location.queryParams.offer) : '';
    var resortId = props.resortId;
    var resortArgs = "resortId: \"".concat(resortId, "\"");
    var offerArgs = "offerName: \"".concat(offerName, "\"");
    var cmsArgs = "content: \"".concat(appContext.cmsContent, "\" release: \"").concat(appContext.cmsRelease, "\"");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery('', appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_BOOKING */ "Yb"],
      queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_BOOKING */ "Yb"],
      prebuiltArgs: {
        resortArgs: resortArgs,
        resortId: resortId,
        cmsArgs: cmsArgs,
        offerArgs: offerArgs,
        minAgeInformation: props.minAgeInformation,
        minAgeErrorMessage: props.minAgeErrorMessage,
        resortStartingPrice: _views_configQueries__WEBPACK_IMPORTED_MODULE_4__[/* resortStartingPrice */ "f"]()
      }
    });
  }
};

/***/ }),

/***/ "4SQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerLabel; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var SpinnerLabel = function SpinnerLabel(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'text-center font-brand leading-normal max-w-4/5 sm:max-w-3/5 mt-px20 text-blue text-xl', {
      'sr-only': !label
    }),
    "aria-live": "polite"
  }, label ? label : 'Loading');
};

/***/ }),

/***/ "4VTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return searchRemote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resortStartingPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return price; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return faceting; });
/* unused harmony export birthdatePopin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return common; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return priceRemote; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);

function searchRemote() {
  return "\n    remote {\n      date\n      placeholder\n      searchAction\n      title\n    }\n  ";
}
function resortStartingPrice() {
  return "\n    startingPrice {\n      allInclusive\n      bookingButtonLabel\n      dateFormat\n      departureCityLabel\n      departureDateLabel\n      durationUnit\n      endDateLabel\n      longDateFormat\n      roomOnly\n      seeDetails\n      stayDeparture\n    }\n  ";
}
function resort(appContext) {
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var cmsArgs = "content : \"".concat(cmsContent, "\", release : \"").concat(cmsRelease, "\"");
  return "\n    resort {\n      season(".concat(cmsArgs, ") {\n        winter\n        summer\n        button\n      }\n      ").concat(resortStartingPrice(), "\n      pricePopin {\n        buttonLabel\n        buttonCruiseLabel\n        buttonTourLabel\n        priceIsLabel\n        roomAvailability\n        startingPriceDescriptionWithoutTransport\n        startingPriceDescriptionWithTransport\n        taxeAndFees\n      }\n      tripadvisor {\n        menubar {\n          reviews\n        }\n      }\n      moreResultsLabels {\n        label\n        buttonLabel\n      }\n    }\n  ");
}
function price() {
  return "\n    price {\n      format{\n        from\n        instead\n        flightIncluded\n        unitPerTrip\n        unitPerNight\n        viewRates\n      }\n    }\n  ";
}
function faceting() {
  return "\n    common {\n      dateFormatPlaceholder\n      loadLess\n      loadMore\n      selectedCriteriasLabel {\n        _1\n        n\n      }\n    }\n    booking {\n      form {\n        dateFormat\n        dayPlaceholder\n        monthPlaceholder\n        yearPlaceholder\n        departureDateTitle\n        selectAdultsLabels {\n          _1\n          n\n        }\n        selectChildrenLabels {\n          _1\n          n\n        }\n      }\n      editCriteria {\n        validateCriteria\n      }\n    }\n    faceting {\n      intro\n      facetClear\n      oneResortThatMatchYourCriteria\n      nbResortsThatMatchYourCriteria\n      viewResorts\n      searchTitle\n      searchLinkLabel\n      suggestedRequests {\n        title\n        items {\n          label\n          url\n        }\n      }\n      reset\n      validate\n      when {\n        title\n        subTitle\n        durations\n        duration\n        from\n        bestPrice\n        lastAvailability\n        notAvailable\n        departureDateTitle\n        arrivalDateTitle\n        durationSingular\n        durationPlural\n        reinsurance\n        pricesBasedOn\n      }\n      where {\n        title\n        destinationTitle\n        countriesTitle\n      }\n      who {\n        addChildcare\n        adults\n        ageComment\n        ageSectionChildcareSubtitle\n        ageSectionSubtitle\n        birthdatePlaceholder\n        kids\n        kidsAgeLimit\n        kidsBirthdate\n        subTitle\n        title\n        withKidsFacetLabel\n        withChildcareFacetLabel\n      }\n      activities {\n        title\n        sportTitle\n        relaxTitle\n        otherActivitiesTitle\n      }\n      compare {\n        selectResort\n        selected\n        dateAndTransportMandatory\n        unavailableThumbnail\n        warningMessage\n        title\n        buttonLabel\n        cancelLabel\n        collapseLabel\n        expandLabel\n        dropzoneLabel\n      }\n      topCountries {\n        enabled\n        title\n        items {\n          id\n        }\n      }\n      transport {\n        comment\n        defaultDepartureCityOnlyForDefaultTransportation\n        departingFrom\n        introduction\n        reassurance {\n          iconName\n          label\n        }\n        selectPlaceholder\n        subTitle\n        titleFrom\n      }\n      availabilities {\n        childcare\n        enterBirthdate\n        years\n        year\n        months\n        noChildcare\n        noChildcareFrom0\n        available\n        unavailable\n        unknown\n        urgentizationSingular\n        urgentizationPlural\n      }\n      showFilterCTA\n      hideFilterCTA\n      typesOfStay {\n        title\n        label_village\n        label_cruise\n        label_tour\n        label_villa\n      }\n      comfort {\n        title\n      }\n    }";
}
function birthdatePopin() {
  return "birthdatePopin {\n    title\n    subtitle\n    confirm\n    child\n    skip\n  }";
}
function common() {
  return "common {\n    close\n    continue\n    included\n    allInclusive\n  }";
}
function priceRemote() {
  return "".concat(faceting(), "\n  ").concat(common(), "\n  booking {\n    form {\n      selectAdultsLabels {\n        _1\n        n\n      }\n      selectChildrenLabels {\n        _1\n        n\n      }\n      selectDates\n      selectParticipants\n      selectTransports\n      proposalsLoaderLabel\n      errors {\n        birthdayFormat\n      }\n    }\n    priceCalendar {\n      offers {\n        bestPrice { label }\n        urgentisation { label rateToDisplay }\n      }\n    }\n  }\n  price {\n    format{\n      from\n      instead\n      viewRates\n      unitTotalPerTrip\n    }\n  }\n  priceRemote {\n    openAllInclusiveDetails\n    closeAllInclusiveDetails\n    notAvailable\n    notAvailableCTA\n    notAvailableCTATransportation\n    notAvailableTransportation\n    priceForAll\n    priceRemoteButton\n    linkToCalendar\n    errors {\n      birthdateError\n      noAvailabilities\n      notOnSale\n      technicalError\n      invalidCriteria\n      noTransport\n    }\n    rateCounterProposalLabel\n  }\n  resort {\n    startingPrice {\n      allInclusive\n    }\n  }\n  ");
}

/***/ }),

/***/ "4gXF":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "4jPf":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "4oK2":
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__("BRr/"),
    decode = __webpack_require__("oW49");

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ "5LiQ":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("dNjr");
var toLength = __webpack_require__("DOIJ");
var toAbsoluteIndex = __webpack_require__("Jm8J");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "5WP5":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("dnX/");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "5h8T":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var createPropertyDescriptor = __webpack_require__("OouP");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var has = __webpack_require__("DZWw");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "5iaM":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("oMzG");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "5q4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttendeesSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("WGoB");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;








var AttendeesSummary = function AttendeesSummary(_ref) {
  var adults = _ref.adults,
      _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      kids = _ref.kids;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "q"].ATTENDEES
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    hasRtl: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].USERS,
    width: "1.875rem"
  }), __jsx("span", null, __jsx("div", {
    className: "PackagePriceSummary-guestsItem",
    key: "adults"
  }, __jsx("span", {
    className: "PackagePriceSummary-guestsNumber"
  }, adults), " ".concat(Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__[/* pluralizeLabel */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.common.adult'), Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.common.adults'), adults))), kids > 0 ? __jsx("div", {
    className: "PackagePriceSummary-guestsItem",
    key: "children"
  }, __jsx("span", {
    className: "PackagePriceSummary-guestsNumber"
  }, kids), " ".concat(Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_5__[/* pluralizeLabel */ "d"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.common.child'), Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('booking.common.children'), kids))) : null));
};

/***/ }),

/***/ "5siB":
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {}

}());


/***/ }),

/***/ "60DJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("C8GU").charAt;
var toString = __webpack_require__("vnfA");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("ZiN6");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "6Azr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ formatLinesForLineComponent; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/client/cms/toolkit/tracking/pageTracking.resolver.js + 2 modules
var pageTracking_resolver = __webpack_require__("9wHB");

// EXTERNAL MODULE: ./src/client/cms/toolkit/destinations/destinations.resolver.js
var destinations_resolver = __webpack_require__("bEXL");

// EXTERNAL MODULE: ./src/client/cms/toolkit/editorial-folding-block/editorialFoldingBlock.resolver.js
var editorialFoldingBlock_resolver = __webpack_require__("3OB6");

// EXTERNAL MODULE: ./src/client/cms/toolkit/event-form/eventForm.resolver.js
var eventForm_resolver = __webpack_require__("yWy0");

// EXTERNAL MODULE: ./src/client/cms/toolkit/immersive/immersive.resolver.js
var immersive_resolver = __webpack_require__("pIL7");

// EXTERNAL MODULE: ./src/client/cms/toolkit/instagram/instagram.resolver.js
var instagram_resolver = __webpack_require__("vt7b");

// EXTERNAL MODULE: ./src/client/cms/toolkit/media-text-horizontal/mediaTextHorizontal.resolver.js
var mediaTextHorizontal_resolver = __webpack_require__("PT2a");

// EXTERNAL MODULE: ./src/client/cms/toolkit/navigation-tabs/navigationTabs.resolver.js
var navigationTabs_resolver = __webpack_require__("v78B");

// EXTERNAL MODULE: ./src/client/cms/toolkit/offers-grid/offersGrid.resolver.js
var offersGrid_resolver = __webpack_require__("xXeT");

// EXTERNAL MODULE: ./src/client/cms/toolkit/prebooking-form/prebookingForm.resolver.js
var prebookingForm_resolver = __webpack_require__("VqO2");

// EXTERNAL MODULE: ./src/client/cms/toolkit/products-filters/productsFilters.resolver.js
var productsFilters_resolver = __webpack_require__("YYl6");

// EXTERNAL MODULE: ./src/client/cms/toolkit/products-grid/productsGrid.resolver.js
var productsGrid_resolver = __webpack_require__("3zhs");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-tags/productTags.resolver.js
var productTags_resolver = __webpack_require__("2dUC");

// EXTERNAL MODULE: ./src/client/cms/toolkit/sections/sections.resolver.js
var sections_resolver = __webpack_require__("6TMq");

// EXTERNAL MODULE: ./src/client/cms/toolkit/tab/tab.resolver.js
var tab_resolver = __webpack_require__("yTc0");

// EXTERNAL MODULE: ./src/client/cms/toolkit/teaser-cards/teaserCards.resolver.js
var teaserCards_resolver = __webpack_require__("yLnO");

// EXTERNAL MODULE: ./src/client/cms/toolkit/title-and-text/titleAndText.resolver.js
var titleAndText_resolver = __webpack_require__("BXQg");

// EXTERNAL MODULE: ./src/client/cms/toolkit/travel-restrictions/travelRestrictions.resolver.js
var travelRestrictions_resolver = __webpack_require__("aBEZ");

// EXTERNAL MODULE: ./src/client/cms/toolkit/country-events/countryEvents.resolver.js
var countryEvents_resolver = __webpack_require__("fGxS");

// EXTERNAL MODULE: ./src/client/cms/toolkit/country-infos/countryInfos.resolver.js
var countryInfos_resolver = __webpack_require__("6X2a");

// EXTERNAL MODULE: ./src/client/cms/toolkit/country-introduction/countryIntroduction.resolver.js
var countryIntroduction_resolver = __webpack_require__("VGY0");

// EXTERNAL MODULE: ./src/client/cms/toolkit/country-poi/countryPoi.resolver.js
var countryPoi_resolver = __webpack_require__("A7XF");

// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-description/offerDescription.resolver.js
var offerDescription_resolver = __webpack_require__("ih3X");

// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-legal-information/offerLegalInformation.resolver.js
var offerLegalInformation_resolver = __webpack_require__("9Kh7");

// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-seo/offerSeo.resolver.js
var offerSeo_resolver = __webpack_require__("Wb8K");

// EXTERNAL MODULE: ./src/client/cms/toolkit/cruise-booking/cruiseBooking.resolver.js
var cruiseBooking_resolver = __webpack_require__("Qabk");

// EXTERNAL MODULE: ./src/client/cms/toolkit/cruise-program/cruiseProgram.resolver.js
var cruiseProgram_resolver = __webpack_require__("eVJY");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-access-and-map/productAccessAndMap.resolver.js
var productAccessAndMap_resolver = __webpack_require__("afpJ");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-accommodations/productAccommodations.resolver.js
var productAccommodations_resolver = __webpack_require__("JEY5");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-activities/productActivities.resolver.js
var productActivities_resolver = __webpack_require__("g3/4");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-bars/productBars.resolver.js
var productBars_resolver = __webpack_require__("9Ts2");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/productBookingBE.resolver.js
var productBookingBE_resolver = __webpack_require__("4NBB");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-breadcrumb/productBreadcrumb.resolver.js
var productBreadcrumb_resolver = __webpack_require__("9smd");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-childcares/productChildcares.resolver.js
var productChildcares_resolver = __webpack_require__("27iJ");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-community-questions/productCommunityQuestions.resolver.js
var productCommunityQuestions_resolver = __webpack_require__("bNYI");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-destination/productDestination.resolver.js
var productDestination_resolver = __webpack_require__("IpDy");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-flash-info/productFlashInfo.resolver.js
var productFlashInfo_resolver = __webpack_require__("YbGu");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-google-street-view/productGoogleStreetView.resolver.js
var productGoogleStreetView_resolver = __webpack_require__("muDs");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-image-map/productImageMap.resolver.js
var productImageMap_resolver = __webpack_require__("+MSq");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-immersive/productImmersive.resolver.js
var productImmersive_resolver = __webpack_require__("AaDX");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-information-summary/productInformationSummary.resolver.js
var productInformationSummary_resolver = __webpack_require__("C2l2");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-instagram/productInstagram.resolver.js
var productInstagram_resolver = __webpack_require__("eaHo");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-introduction/productIntroduction.resolver.js
var productIntroduction_resolver = __webpack_require__("g73z");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-meeting-room-info/productMeetingRoomInfo.resolver.js
var productMeetingRoomInfo_resolver = __webpack_require__("+dj+");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-multimedia/productMultimedia.resolver.js
var productMultimedia_resolver = __webpack_require__("VUEF");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-must-try-experiences/productMustTryExperiences.resolver.js
var productMustTryExperiences_resolver = __webpack_require__("BthO");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-remote/productPriceRemote.resolver.js
var productPriceRemote_resolver = __webpack_require__("+82i");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-ticket/productPriceTicket.resolver.js
var productPriceTicket_resolver = __webpack_require__("3FxL");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-ticket-custom/productPriceTicketCustom.resolver.js
var productPriceTicketCustom_resolver = __webpack_require__("m4Zw");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-quotation-form/productQuotationForm.resolver.js
var productQuotationForm_resolver = __webpack_require__("aFmo");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-recommendations/productRecommendations.resolver.js
var productRecommendations_resolver = __webpack_require__("/KRb");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-related-products/productRelatedProducts.resolver.js
var productRelatedProducts_resolver = __webpack_require__("4HxW");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-restaurants/productRestaurants.resolver.js
var productRestaurants_resolver = __webpack_require__("WUtx");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-seo-title/productSEOTitle.resolver.js
var productSEOTitle_resolver = __webpack_require__("1I7E");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-services/productServices.resolver.js
var productServices_resolver = __webpack_require__("/0L0");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-space-introduction/productSpaceIntroduction.resolver.js
var productSpaceIntroduction_resolver = __webpack_require__("bLh8");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-strengths/productStrengths.resolver.js
var productStrengths_resolver = __webpack_require__("jVcT");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-summary/productSummary.resolver.js
var productSummary_resolver = __webpack_require__("kawP");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-tripadvisor/productTripadvisor.resolver.js
var productTripadvisor_resolver = __webpack_require__("ODPy");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-wellness/productWellness.resolver.js
var productWellness_resolver = __webpack_require__("i0/9");

// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-introduction/tourIntroduction.resolver.js
var tourIntroduction_resolver = __webpack_require__("klIi");

// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-practical-information/tourPracticalInformation.resolver.js
var tourPracticalInformation_resolver = __webpack_require__("v7Z5");

// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-program/tourProgram.resolver.js
var tourProgram_resolver = __webpack_require__("pUua");

// CONCATENATED MODULE: ./src/client/cms/toolkit/resolvers.js



/* layout lines */

/* common lines */


















/* country lines : webedia countryId needed */





/* offer lines : offerId needed */




/* cruise lines : resortId/productId needed (only cruise ID) */


 // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */




























 // no ID but commonly on product page






/* tour lines : resortId/productId needed (only tour ID) */




var resolvers = [countryEvents_resolver["a" /* countryEventsResolver */], countryInfos_resolver["a" /* countryInfosResolver */], countryIntroduction_resolver["a" /* countryIntroductionResolver */], countryPoi_resolver["a" /* countryPoiResolver */], cruiseBooking_resolver["a" /* cruiseBookingResolver */], cruiseProgram_resolver["a" /* cruiseProgramResolver */], destinations_resolver["a" /* destinationsResolver */], editorialFoldingBlock_resolver["a" /* editorialFoldingBlockResolver */], eventForm_resolver["a" /* eventFormResolver */], immersive_resolver["a" /* immersiveResolver */], instagram_resolver["a" /* instagramResolver */], mediaTextHorizontal_resolver["a" /* mediaTextHorizontalResolver */], navigationTabs_resolver["a" /* navigationTabsResolver */], offerDescription_resolver["a" /* offerDescriptionResolver */], offersGrid_resolver["a" /* offersGridResolver */], offerLegalInformation_resolver["a" /* offerLegalInformationResolver */], offerSeo_resolver["a" /* offerSEOResolver */], pageTracking_resolver["b" /* pageTrackingResolver */], prebookingForm_resolver["a" /* prebookingFormResolver */], productAccessAndMap_resolver["a" /* productAccessAndMapResolver */], productAccommodations_resolver["a" /* productAccommodationsExclusiveCollectionResolver */], productAccommodations_resolver["b" /* productAccommodationsResolver */], productActivities_resolver["a" /* productActivitiesResolver */], productBars_resolver["a" /* productBarsResolver */], productBookingBE_resolver["a" /* productBookingBEResolver */], productBreadcrumb_resolver["a" /* productBreadcrumbResolver */], productChildcares_resolver["a" /* productChildcaresResolver */], productCommunityQuestions_resolver["a" /* productCommunityQuestionsResolver */], productDestination_resolver["a" /* productDestinationResolver */], productFlashInfo_resolver["a" /* productFlashInfoResolver */], productGoogleStreetView_resolver["a" /* productGoogleStreetViewResolver */], productImageMap_resolver["a" /* productImageMapResolver */], productImmersive_resolver["a" /* productImmersiveResolver */], productInformationSummary_resolver["a" /* productInformationSummaryResolver */], productInstagram_resolver["a" /* productInstagramResolver */], productIntroduction_resolver["a" /* productIntroductionResolver */], productMeetingRoomInfo_resolver["a" /* productMeetingRoomInfoResolver */], productMultimedia_resolver["a" /* productMultimediaResolver */], productMustTryExperiences_resolver["a" /* productMustTryExperiencesResolver */], productPriceRemote_resolver["a" /* productPriceRemoteResolver */], productPriceTicket_resolver["a" /* productPriceTicketResolver */], productPriceTicketCustom_resolver["a" /* productPriceTicketCustomResolver */], productQuotationForm_resolver["a" /* productQuotationFormResolver */], productRecommendations_resolver["a" /* productRecommendationsResolver */], productRelatedProducts_resolver["a" /* productRelatedProductsResolver */], productRestaurants_resolver["a" /* productRestaurantsResolver */], productSEOTitle_resolver["a" /* productSEOTitleResolver */], productServices_resolver["a" /* productServicesResolver */], productSpaceIntroduction_resolver["a" /* productSpaceIntroductionResolver */], productStrengths_resolver["a" /* productStrengthsResolver */], productSummary_resolver["a" /* productSummaryResolver */], productTags_resolver["a" /* productTagsResolver */], productTripadvisor_resolver["a" /* productTripadvisorResolver */], productWellness_resolver["a" /* productWellnessResolver */], productsFilters_resolver["a" /* productsFiltersResolver */], productsGrid_resolver["a" /* productsGridResolver */], sections_resolver["a" /* sectionsResolver */], tab_resolver["a" /* tabResolver */], teaserCards_resolver["a" /* teaserCardsResolver */], titleAndText_resolver["a" /* titleAndTextResolver */], tourIntroduction_resolver["a" /* tourIntroductionResolver */], tourPracticalInformation_resolver["a" /* tourPracticalInformationResolver */], tourProgram_resolver["a" /* tourProgramResolver */], travelRestrictions_resolver["a" /* travelRestrictionsResolver */]];
var resolvers_resolversLibrary = resolvers.reduce(function (acc, resolver) {
  if (acc[resolver.name]) {
    throw new Error("A resolver named ".concat(resolver.name, " is already set."));
  }

  acc[resolver.name] = resolver;
  return acc;
}, {});
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/invariant/invariant.js
var invariant = __webpack_require__("UQkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// CONCATENATED MODULE: ./src/utils/lines/lineUtils.js



var IMMERSIVE_COMPONENTS = [constants["r" /* IMMERSIVE */], constants["P" /* PRODUCT_IMMERSIVE */]];

function isImmersive(lineName) {
  return IMMERSIVE_COMPONENTS.includes(lineName);
}


// CONCATENATED MODULE: ./src/utils/lines/formatLinesForLineComponent.js




















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var formatLinesForLineComponent_pickResolvers = function pickResolvers(_ref) {
  var list = _ref.list,
      library = _ref.library;
  return list.map(function (name) {
    return library[name] ? Object(defineProperty["a" /* default */])({}, name, library[name]) : undefined;
  }).filter(Boolean);
};

function formatLinesForLineComponent(_x) {
  return _formatLinesForLineComponent.apply(this, arguments);
}

function _formatLinesForLineComponent() {
  _formatLinesForLineComponent = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref3) {
    var lines, appContext, pageContext, location, _ref3$linesToPrepend, linesToPrepend, _ref3$linesToAppend, linesToAppend, _ref3$resolversLibrar, resolversLibrary;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lines = _ref3.lines, appContext = _ref3.appContext, pageContext = _ref3.pageContext, location = _ref3.location, _ref3$linesToPrepend = _ref3.linesToPrepend, linesToPrepend = _ref3$linesToPrepend === void 0 ? [] : _ref3$linesToPrepend, _ref3$linesToAppend = _ref3.linesToAppend, linesToAppend = _ref3$linesToAppend === void 0 ? [] : _ref3$linesToAppend, _ref3$resolversLibrar = _ref3.resolversLibrary, resolversLibrary = _ref3$resolversLibrar === void 0 ? resolvers_resolversLibrary : _ref3$resolversLibrar;
            lines.unshift.apply(lines, Object(toConsumableArray["a" /* default */])(formatLinesForLineComponent_pickResolvers({
              list: linesToPrepend,
              library: resolversLibrary
            })));
            lines.push.apply(lines, Object(toConsumableArray["a" /* default */])(formatLinesForLineComponent_pickResolvers({
              list: linesToAppend,
              library: resolversLibrary
            })));
            /* eslint-disable no-use-before-define */

            return _context.abrupt("return", Promise.all(lines.map(function (line, index) {
              return mapLineProps({
                location: location,
                line: line,
                resolversLibrary: resolversLibrary,
                index: index,
                appContext: appContext,
                pageContext: pageContext
              });
            }).filter(Boolean) // filter Promises
            ).then(function (results) {
              return results.filter(Boolean);
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _formatLinesForLineComponent.apply(this, arguments);
}

function mapLineProps(_ref4) {
  var line = _ref4.line,
      resolversLibrary = _ref4.resolversLibrary,
      index = _ref4.index,
      _ref4$baseIndex = _ref4.baseIndex,
      baseIndex = _ref4$baseIndex === void 0 ? 0 : _ref4$baseIndex,
      appContext = _ref4.appContext,
      pageContext = _ref4.pageContext,
      location = _ref4.location;
  /**
   * NOTE: a line is a one-item object of shape { [name]: { name, resolve, props, etc. } }
   * For instance: { 'resort-grid': { name: 'resort-grid', resolve() {}, props(), ...etc } }
   * That's why we consider only the first object entry
   */

  var lineEntries = Object.entries(line);
  Object(invariant["a" /* invariant */])(lineEntries.length === 1, // This is the kind of things that can happen when due to some wrong CMS configuration, we get
  // the @metadata, which we don't want (but are needed for migrations for instance)
  // $FlowFixMe
  "A line should contain only one property. See ".concat(lineEntries)); // $FlowFixMe

  var _ref5 = lineEntries[0],
      _ref6 = Object(slicedToArray["a" /* default */])(_ref5, 2),
      lineName = _ref6[0],
      propsFromCms = _ref6[1];

  if (Object(sellerUtils["g" /* isSeller */])(appContext) && isImmersive(lineName)) return undefined;
  var id = index + baseIndex; // COMPUTE result.props

  var resolver = resolversLibrary[lineName] || {};
  var subLinesPromises = Object(lodash["isEmpty"])(propsFromCms.lines) ? undefined : propsFromCms.lines.map(function (subline, subindex) {
    return mapLineProps({
      location: location,
      line: subline,
      resolversLibrary: resolversLibrary,
      index: subindex,
      baseIndex: index * 10,
      // FIXME: random arbitrary value that I won't change because backward compatibility.
      appContext: appContext,
      pageContext: pageContext
    });
  }).filter(Boolean); // filter Promises

  return Promise.all([resolver.resolve && resolver.resolve(appContext, propsFromCms, pageContext, location)["catch"](function () {
    return false;
  }), subLinesPromises && Promise.all(subLinesPromises).then(function (results) {
    return results.filter(Boolean);
  }) // filter Promises results
  ["catch"](function () {
    return [];
  })]).then(function (_ref7) {
    var _ref8 = Object(slicedToArray["a" /* default */])(_ref7, 2),
        _ref8$ = _ref8[0],
        propsFromResolve = _ref8$ === void 0 ? {} : _ref8$,
        _ref8$2 = _ref8[1],
        lines = _ref8$2 === void 0 ? [] : _ref8$2;

    var resolverProps = resolver.props && resolver.props(appContext, pageContext, location);

    var baseProps = _objectSpread(_objectSpread(_objectSpread({}, propsFromResolve), propsFromCms), {}, {
      lines: lines
    });

    var propsFromResolver = Object(lodash["mapValues"])(resolverProps, function (prop) {
      return typeof prop === 'function' ? prop(baseProps) : prop;
    }); // END COMPUTE result.props

    return {
      id: id,
      props: _objectSpread(_objectSpread({}, baseProps), propsFromResolver),
      name: lineName
    };
  })["catch"](function () {
    return false;
  });
}

/***/ }),

/***/ "6TMq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sectionsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var sectionsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* SECTIONS */ "wb"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "d"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "6X2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryInfosResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PIvV");






var countryInfosResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* COUNTRY_INFOS */ "f"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      config {\n        common { close }\n      }\n      countryInfos(".concat(countryArgs, ") {\n        texts {\n          title\n          description\n          media {\n            mediaUrl\n            mediaAlt\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_COMMON_COUNTRY_INFOS */ "vb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "6XIJ":
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ "6wD6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateTripDateCriteria; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function updateTripDateCriteria(options) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* UPDATE_TRIP_DATE_CRITERIA */ "x"], options);
}



/***/ }),

/***/ "70jX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return childcaresQuery; });
/* unused harmony export transfersQuery */
/* unused harmony export servicesWithSchedulePricingInfoQuery */
/* unused harmony export additionalServicesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addAccommodationMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addServiceMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addTransportMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPaymentScheduleRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPriceDetailFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return proposalsQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return proposalFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return proposalPriceQuery; });
/* unused harmony export proposalTransfersQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return transportDetailsFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return paymentProvidersRequest; });
/* unused harmony export getKnownAttendeesInformation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return insurancesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return promoCodeProposalMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return putServicesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return switchProposalsOffers; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("MAH5");
/* harmony import */ var _client_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("GZ82");
/* harmony import */ var _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("BYx+");
/* harmony import */ var _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("SQLw");
/* harmony import */ var _feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("L7OA");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("PIvV");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("ldK3");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("NLwV");















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













var _constants$PACKAGES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_16__["constants"].PACKAGES,
    JOYVIEW_ROOM_ONLY = _constants$PACKAGES.JOYVIEW_ROOM_ONLY,
    JOYVIEW_ALL_INCLUSIVE = _constants$PACKAGES.JOYVIEW_ALL_INCLUSIVE,
    JOYVIEW_FOOD_AND_BEVERAGES = _constants$PACKAGES.JOYVIEW_FOOD_AND_BEVERAGES;

function getPriceDetailFragment(locale) {
  var precision = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default.a.getBookingPrecision(locale);
  return "\n    fragment priceDetails on PriceDetailType {\n      value\n      formattedValue(precision : ".concat(precision, ")\n    }\n  ");
}

var flightFragment = "{\n  id\n  cityId\n  label\n  airportLabel\n  terminalCode\n  date\n  time\n}";
var transportFragment = "{\n  type\n  class\n  travelNumber\n  baggage {\n    quantity\n    weight\n  }\n  companyOperator {\n    id\n    label\n    logo\n  }\n  companyExploiter {\n    id\n    label\n    logo\n  }\n}";
var transportDetailsFragment = "\n  fragment transportsDetails on TransportDetailType {\n    isClubmedTransport\n    durationInMin\n    travelSections {\n      connectionDurationInMin\n      isClubmedTransport\n      stopDurationInMin\n      technicalStops\n      departure {\n        ...".concat(flightFragment, "\n      }\n      arrival {\n        ...").concat(flightFragment, "\n      }\n      transport {\n        ...").concat(transportFragment, "\n      }\n    }\n    cancellationPolicyType\n    transferIncluded\n    stayId\n  }\n");
var childcaresQuery = "\nchildcares {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    isPartiallyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    label\n    images\n    description\n    durationDescription\n    isIncluded\n    ageInMonths {\n      min\n      max\n    }\n    closingWeekdays\n    openingHours {\n      start\n      end\n    }\n  }\n}";
var transfersQuery = "\ntransfers {\n  pricingInfo {\n    id\n    isIncluded\n    price: startingPricePerAdult {\n      ...priceDetails\n      formattedValueRounded : formattedValue(precision : 0)\n    }\n    totalPrice {\n      value\n      formattedValue\n      currency\n    }\n    isPartiallyRented\n    isFullyRented\n    type\n    rentedAmount {\n      value\n    }\n    schedules {\n      startDate\n      endDate\n      remainingStock\n      attendees {\n        id\n        isRented\n      }\n    }\n  }\n  productInfo {\n    id\n    description\n    durationInMinutes\n    vehicle {\n      id\n      label\n    }\n    label\n  }\n}\n";
var servicesWithSchedulePricingInfoQuery = "\n    pricingInfo {\n        id\n        type\n        currency\n        rentedAmount {...priceDetails, currency}\n        startingPricePerAdult {...priceDetails, currency}\n        isPartiallyRented\n        attendees {\n          id\n          rentedAmount {...priceDetails}\n          price {\n            value\n            formattedValue(precision:0)\n          }\n          schedules {\n            startDate\n            endDate\n            isPartiallyRented\n            isPartiallyPaid\n            isFullyRented\n            isFullyPaid\n            rentedAmount {...priceDetails}\n            timeSlots {\n              id\n              slotName\n              remainingStock\n              isRented\n              isPaid\n              price {...priceDetails}\n            }\n          }\n        }\n        schedules {\n          startDate\n          endDate\n          slots {\n            id\n            type\n            initialStock\n            remainingStock\n            attendees {\n              id\n              price {...priceDetails}\n            }\n          }\n        }\n      }";
var additionalServicesQuery = "\n  additionalServices(types: [EXCURSION, RENTAL, CHILDCARE, LAND_SPORT, WATER_SPORT, WINTER_SPORT, TRANSFER, WELLNESS]) {\n    activities {\n      ".concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        isIncluded\n        parentActivityCategoriesId\n      }\n    }\n    rentals {\n      ").concat(servicesWithSchedulePricingInfoQuery, "\n      productInfo {\n        id\n        label\n        ageInMonths {\n          min\n          max\n        }\n        useCase {\n          id\n          label\n        }\n        typeId: type\n        typeLabel\n        description: longDescription\n        sizes {\n          min\n          max\n          unit\n        }\n        practiceLevels {\n          id\n          label\n        }\n      }\n    }\n    ").concat(childcaresQuery, "\n    ").concat(transfersQuery, "\n  }\n");

function proposalPriceQuery() {
  return "\n    price {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      totalWithoutTransport {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      excursions {...priceDetails}\n      wellness {...priceDetails}\n      sports {...priceDetails}\n      currency\n      hasFlexRates\n      selectedRate\n      yieldPricingVariation\n      gap\n    }\n    alternativePrice {\n      total {...priceDetails}\n      totalWithoutDiscount {...priceDetails}\n      aggregateDiscount {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      aggregateDiscountPromoCode {\n        offerColor\n        offerName\n        amount {...priceDetails}\n      }\n      promoCode {\n        offerColor\n        offerName\n        amount {\n          value\n          formattedValue\n        }\n      }\n      totalWithoutChildcare {...priceDetails}\n      totalWithoutChildcareAndDiscount {...priceDetails}\n      initialPrice {...priceDetails}\n      discounts {\n        amount {...priceDetails}\n        offerId\n        offerName\n        offerColor\n      }\n      transfer {...priceDetails}\n      fees {\n        type\n        amount {...priceDetails}\n      }\n      childcare {...priceDetails}\n      rental {...priceDetails}\n      currency\n    }\n    attendeesPrice {\n      id\n      total {\n        ...priceDetails\n        currency\n      }\n      priceItems {\n        type\n        offerId\n        price {\n          ...priceDetails\n          currency\n        }\n      }\n    }\n    ";
}

function insurancesQuery() {
  return "\n    listInsurances {\n      id\n      label\n      subscribed\n      price {\n        ...priceDetails\n      }\n      insuranceDetails{\n        id\n        label\n        images\n        description\n        shortDescription\n        videos\n        attachedDocuments {\n          label\n          url\n        }\n        company {\n          label\n          logo\n        }\n        coverageDescriptions\n        subscriptionConditions {\n          age_min\n          ageMax\n          byAttendees\n        }\n      }\n    }";
}

function proposalTransfersQuery() {
  return "\n    availableTransfers {\n      ...transferDetails\n    }\n    selectedTransfers {\n      ...transferDetails\n    }\n  ";
}

function proposalFields(params) {
  return "\n    id\n    packageId\n    productId\n    originalLocale\n    ".concat(additionalServicesQuery, "\n    ").concat(params.isJoyView ? "\n    alternativePackages {\n      proposalId\n      packageId\n      upsellPrice\n    }\n    packages(packageIds : [\"".concat(JOYVIEW_ROOM_ONLY, "\", \"").concat(JOYVIEW_ALL_INCLUSIVE, "\", \"").concat(JOYVIEW_FOOD_AND_BEVERAGES, "\"]) {\n      id\n      image\n      additionalInfo\n      description\n      label\n      prices {\n        perAdultPerNight {\n          ...priceDetails\n          currency\n        }\n        perKidPerNight {\n          ...priceDetails\n          currency\n        }\n      }\n    }") : '', "\n    label\n    accommodationsCount\n    accommodations {\n      id\n      label\n      description\n      quantity\n      connectingRoom\n      familyRoom\n      surface\n      view {\n        id\n        label\n      }\n      strengths {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      services {\n        id\n        label\n      }\n      outsideFacilities {\n        id\n        label\n      }\n      bathroomEquipments {\n        id\n        label\n      }\n      equipments {\n        id\n        label\n      }\n      categories {\n        id\n      }\n      exclusiveCollection\n      category\n      categoryId\n      comfortType\n      comfortId\n      maxCapacity\n      media {\n        photos {\n          url\n        }\n      }\n      roomType\n      attendeesDistribution {\n        attendees {\n          id\n          type\n          birthdate,\n          customerId\n        }\n      }\n    }\n    duration\n    media {\n      photos {\n        url\n      }\n    }\n    ").concat(proposalPriceQuery(), "\n    arrivalDate\n    departureDate\n    adultsCount\n    childrenCount\n    attendees {\n      list {\n        id\n        birthdate\n        customerId\n        email\n        householdId\n        civility\n        firstName\n        lastName\n      }\n      adults {\n        id\n        customerId\n      }\n      children(birthdateSort: asc) {\n        id\n        birthdate\n        customerId\n      }\n    }\n    remainingStock\n    optionAvailable\n    isCounterProposal\n    transports {\n      inbound {\n        ...transportsDetails\n      }\n      outbound {\n        ...transportsDetails\n      }\n    }\n     ").concat(insurancesQuery(), "\n    allInclusiveServices {\n      icon\n      label\n      description\n    }\n    ").concat(params.withCommission ? "sellerCommission {\n            formattedValue(precision: 2)\n          }" : '', "\n     ");
}

var paymentScheduleRequest = "paymentSchedule {\n  total {...priceDetails}\n  depositAmount {...priceDetails}\n  repaymentSchedules{\n    amount {...priceDetails}\n    deadline\n  }\n}";

var paymentProvidersRequest = function paymentProvidersRequest() {
  return "paymentProviders {\n  description\n  id\n  selectorId\n  label\n  logo\n  paymentMethods {\n    category\n    id\n    image\n    label\n    timePaymentConditions {\n      chargePercentage\n      id\n      paymentCount\n    }\n  }\n  requiredDelayBeforeDeparture\n  token {\n    format\n    value\n  }\n}";
};

function getPaymentScheduleRequest(appContext) {
  return Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__[/* isFeatureFlipped */ "a"])(appContext)('booking.deposit') ? paymentScheduleRequest : '';
}

function fetchPayment(proposalId, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposal(id: \"".concat(proposalId, "\") {\n        ").concat(getPaymentScheduleRequest(appContext), "\n      }\n      ").concat(paymentProvidersRequest(), "\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(appContext, 'locale')), "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_GET_SCHEDULE_PAYMENT */ "ld"]
  });
}

function getKnownAttendeesInformation(attendees, neolaneId) {
  var attendeeInfo = attendees.map(function (attendee, index) {
    var _attendee$neolid = attendee.neolid,
        neolid = _attendee$neolid === void 0 ? '' : _attendee$neolid,
        birthdate = attendee.birthdate; // neolid : Send by CXO in query params
    // neolaneId : In appContext, identify user logged
    // When not seller, set first adult with neolaneId if user is authenticated

    return _objectSpread({
      customer_id: index === 0 && neolaneId ? neolaneId : neolid
    }, birthdate ? {
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_24__[/* timestampToApiDate */ "l"])(birthdate)
    } : null);
  });
  return Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(attendeeInfo);
}

function proposalsQuery(params, appContext) {
  var kids = params.kids,
      adults = params.adults;
  var attendees = adults && adults.length ? adults.concat(kids) : kids; // When quick logged neolaneId but should not call profile api
  // TODO: handle quicklogged status and not call profile API every fucking time because 401 is silent

  var neolaneId = appContext.isUserLogged ? appContext.neolaneId : null; // $FlowFixMe

  var knownAttendeesInformation = getKnownAttendeesInformation(attendees, neolaneId);
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  var proposalArgs = ["productId: \"".concat(params.productId, "\""), "arrivalDate: \"".concat(params.arrivalDate, "\""), "duration: ".concat(params.duration), "numberAttendees: ".concat(params.numberAttendees), "knownAttendeesInformation: ".concat(knownAttendeesInformation)].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.departureCity ? ["departureCity : \"".concat(params.departureCity, "\"")] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.isJoyView ? ['isJoyView: true'] : []), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(params.salesNetworkId ? ["salesNetworkId: \"".concat(params.salesNetworkId, "\"")] : []), ["displayCounterDurations: ".concat(Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayDurationsCounterProposals') ? 'true' : 'false')]);
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals(".concat(proposalArgs.join(', '), ") {\n        ... on ErrorsProposalType {\n          errors {\n            errorCode\n          }\n        }\n        ... on ProposalsType {\n          proposals {\n            ").concat(proposalFields(_objectSpread(_objectSpread({}, params), {}, {
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  })), "\n          }\n          dateSuggestion {\n            dateOffset\n            price {\n              total\n            }\n            resortArrivalDate\n            resortDepartureDate\n          }\n          priceCurrency\n          suggestions {\n            resort {\n              badgeIcon\n              color\n              comfort\n              comfortLabel\n              destination {\n                country\n              }\n              href\n              id\n              images\n              isExplicitEC\n              name\n              type\n            }\n            remainingStock\n            initialStock\n          }\n          durationSuggestions {\n            ids\n            data {\n              price {\n                total {\n                  formattedValue\n                }\n              }\n              duration\n              resortArrivalDate: arrivalDate\n              resortDepartureDate: departureDate\n            }\n          }\n          ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_17__[/* getResort */ "b"])(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(appContext.isUserLogged ? 'profile { ...BookingProfile }' : '', "\n      validationSchema(productId: \"").concat(params.productId, "\", resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n      ").concat(Object(_client_views_booking_BookingEngine_query__WEBPACK_IMPORTED_MODULE_17__[/* getCxoAttendeesData */ "a"])(params), "\n    }\n\n    ").concat(_client_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"], "\n    ").concat(appContext.isUserLogged ? _client_components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_19__[/* profileFragment */ "b"] : '', "\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(appContext, 'locale')), "\n    ").concat(params.adultsAttendeesIds && params.adultsAttendeesIds[0] || params.kidsAttendeesIds && params.kidsAttendeesIds[0] ? _client_components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"] : '', "\n  "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_GET_SEVERAL */ "md"]
  });
}

function addTransportMutation(transportId, proposalsId, isJoyView, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addTransport (proposalsId: [\"".concat(proposalsId.join('","'), "\"], transportId: \"").concat(transportId, "\") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_ADD_TRANSPORT */ "gd"]
  });
}

function addAccommodationMutation(arrangement, proposalsId, isJoyView, appContext) {
  var displayCommission = Object(_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_21__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addAccommodation (proposalsId: [\"".concat(proposalsId.join('","'), "\"], arrangement: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(arrangement), ") {\n        ").concat(proposalFields({
    isJoyView: isJoyView,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }), "\n      }\n    }\n    ").concat(transportDetailsFragment, "\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_ACCOMMODATION_ADD */ "cd"]
  });
}

var putServicesGraphQLQuery = function putServicesGraphQLQuery(proposalsId, services, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      putServices(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(proposalsId), ", attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(services), ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_ADDITIONAL_SERVICES_UPDATE */ "fd"]
  });
};
/**
 * We don't want to have this request in parallel, it's a put and it can be really long, so we create a queue to do
 * these requests synchronously
 */


var serviceRequestRunning = null;

var putServicesMutation = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(proposalIds, attendees, appContext) {
    var result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (serviceRequestRunning) {
              _context.next = 15;
              break;
            }

            serviceRequestRunning = putServicesGraphQLQuery(proposalIds, attendees, appContext);
            _context.prev = 2;
            _context.next = 5;
            return serviceRequestRunning;

          case 5:
            result = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            throw _context.t0;

          case 11:
            _context.prev = 11;
            serviceRequestRunning = null;
            return _context.finish(11);

          case 14:
            return _context.abrupt("return", result);

          case 15:
            _context.next = 17;
            return serviceRequestRunning;

          case 17:
            return _context.abrupt("return", putServicesMutation(proposalIds, attendees, appContext));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8, 11, 14]]);
  }));

  return function putServicesMutation(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var deleteServiceGraphQLQuery = function deleteServiceGraphQLQuery(_ref2) {
  var proposalIds = _ref2.proposalIds,
      serviceIds = _ref2.serviceIds,
      attendeeIds = _ref2.attendeeIds,
      overloadForSpecificProposalIds = _ref2.overloadForSpecificProposalIds,
      appContext = _ref2.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      deleteService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(proposalIds), " serviceIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(serviceIds), " attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(attendeeIds), " ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_ADDITIONAL_SERVICES_DELETE */ "ed"]
  });
};

var deleteServicesMutation = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2(_ref3) {
    var proposalIds, serviceIds, attendeeIds, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            proposalIds = _ref3.proposalIds, serviceIds = _ref3.serviceIds, attendeeIds = _ref3.attendeeIds, overloadForSpecificProposalIds = _ref3.overloadForSpecificProposalIds, appContext = _ref3.appContext;

            if (serviceRequestRunning) {
              _context2.next = 16;
              break;
            }

            serviceRequestRunning = deleteServiceGraphQLQuery({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            });
            _context2.prev = 3;
            _context2.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context2.sent;
            _context2.next = 12;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);
            throw _context2.t0;

          case 12:
            _context2.prev = 12;
            serviceRequestRunning = null;
            return _context2.finish(12);

          case 15:
            return _context2.abrupt("return", result);

          case 16:
            _context2.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context2.abrupt("return", deleteServicesMutation({
              proposalIds: proposalIds,
              serviceIds: serviceIds,
              attendeeIds: attendeeIds,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9, 12, 15]]);
  }));

  return function deleteServicesMutation(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

var addServiceGraphQLQuery = function addServiceGraphQLQuery(_ref5) {
  var proposalIds = _ref5.proposalIds,
      serviceId = _ref5.serviceId,
      attendeeIds = _ref5.attendeeIds,
      schedules = _ref5.schedules,
      overloadForSpecificProposalIds = _ref5.overloadForSpecificProposalIds,
      appContext = _ref5.appContext;
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      addService(proposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(proposalIds), ", serviceId: \"").concat(serviceId, "\", attendeeIds: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(attendeeIds), ", schedules: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(schedules), "  ").concat(overloadForSpecificProposalIds ? "overloadForSpecificProposalIds: ".concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_25__[/* graphqlify */ "d"])(overloadForSpecificProposalIds)) : '', ") {\n        id\n        ").concat(additionalServicesQuery, "\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(appContext.locale), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_ADDITIONAL_SERVICES_ADD */ "dd"]
  });
};

var addServiceMutation = /*#__PURE__*/function () {
  var _ref7 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee3(_ref6) {
    var proposalIds, serviceId, attendeeIds, schedules, overloadForSpecificProposalIds, appContext, result;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            proposalIds = _ref6.proposalIds, serviceId = _ref6.serviceId, attendeeIds = _ref6.attendeeIds, schedules = _ref6.schedules, overloadForSpecificProposalIds = _ref6.overloadForSpecificProposalIds, appContext = _ref6.appContext;

            if (serviceRequestRunning) {
              _context3.next = 16;
              break;
            }

            serviceRequestRunning = addServiceGraphQLQuery(_objectSpread(_objectSpread({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules
            }, overloadForSpecificProposalIds && {
              overloadForSpecificProposalIds: {
                proposalIds: overloadForSpecificProposalIds.proposalIds,
                serviceId: overloadForSpecificProposalIds.serviceIds[0]
              }
            }), {}, {
              appContext: appContext
            }));
            _context3.prev = 3;
            _context3.next = 6;
            return serviceRequestRunning;

          case 6:
            result = _context3.sent;
            _context3.next = 12;
            break;

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            throw _context3.t0;

          case 12:
            _context3.prev = 12;
            serviceRequestRunning = null;
            return _context3.finish(12);

          case 15:
            return _context3.abrupt("return", result);

          case 16:
            _context3.next = 18;
            return serviceRequestRunning;

          case 18:
            return _context3.abrupt("return", addServiceMutation({
              proposalIds: proposalIds,
              serviceId: serviceId,
              attendeeIds: attendeeIds,
              schedules: schedules,
              overloadForSpecificProposalIds: overloadForSpecificProposalIds,
              appContext: appContext
            }));

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 9, 12, 15]]);
  }));

  return function addServiceMutation(_x5) {
    return _ref7.apply(this, arguments);
  };
}();

function promoCodeProposalMutation(params, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      promoCodeProposal(id: \"".concat(params.proposalId, "\", promoCode: \"").concat(params.promoCode, "\" ").concat(params.partnerId && params.accessCode ? ", partnerId: \"".concat(params.partnerId, "\", accessCode: \"").concat(params.accessCode, "\"") : '', ", customerId: ").concat(params.customerId, ") {\n        id\n        price {\n          aggregateDiscount {\n            offerColor\n            offerName\n            amount {...priceDetails}\n          }\n          aggregateDiscountPromoCode {\n            offerColor\n            offerName\n            amount {...priceDetails}\n         }\n          promoCode {\n            offerColor\n            offerName\n            amount {\n              value\n              formattedValue\n            }\n          }\n          total {...priceDetails}\n          discounts {\n            amount {...priceDetails}\n            offerName\n            offerColor\n          }\n        }\n        paymentSchedule {\n          total {...priceDetails}\n          depositAmount {...priceDetails}\n          repaymentSchedules {\n            amount {...priceDetails}\n            deadline\n          }\n        }\n      }\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_USE_PROMO_CODE */ "ud"]
  });
}

function switchProposalsOffers(proposalIds, offerIds, appContext) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"].runNoCacheQuery("mutation {\n      proposals: switchProposalsOffers(proposalIds: [\"".concat(proposalIds.join('","'), "\"], offerIds: [\"").concat(offerIds.join('","'), "\"]) {\n        id\n        optionAvailable\n        ").concat(proposalPriceQuery(), "\n      }\n    }\n    ").concat(getPriceDetailFragment(Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_23__[/* PROPOSAL_SWITCH_OFFER */ "qd"]
  });
}



/***/ }),

/***/ "786X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Card_Card; });

// NAMESPACE OBJECT: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_namespaceObject = {};
__webpack_require__.r(Card_layouts_namespaceObject);
__webpack_require__.d(Card_layouts_namespaceObject, "Inline1", function() { return Card_layouts_Inline1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Inline2", function() { return Card_layouts_Inline2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column1", function() { return Card_layouts_Column1; });
__webpack_require__.d(Card_layouts_namespaceObject, "Column2", function() { return Column2; });
__webpack_require__.d(Card_layouts_namespaceObject, "Composite1", function() { return Card_layouts_Composite1; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.themes.js

var defaultTheme = {
  thCtaDefaultColor: colors["a" /* COLORS */].GRAY_DARKER
};
var cardBodyThemes = {
  "default": defaultTheme,
  thumbnail: defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-body/CardBody.jsx




var __jsx = react_default.a.createElement;






var CardBody_CardBody = function CardBody(_ref) {
  var color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isTablet = _ref.isTablet,
      layout = _ref.layout,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? {} : _ref$text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thCtaDefaultColor = cardBodyThemes[theme].thCtaDefaultColor;
  var isCollapsable = displayLoadMore && (!isTablet || [Card_constants["a" /* COLUMN_1 */], Card_constants["b" /* COLUMN_2 */]].includes(layout));
  return __jsx(react["Fragment"], null, __jsx(TextSeeMore["a" /* TextSeeMore */], Object(esm_extends["a" /* default */])({}, text, {
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: isCollapsable,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel
  })), __jsx(TextLink["a" /* TextLink */], Object(esm_extends["a" /* default */])({}, link, {
    className: classnames_default()({
      'mt-px20': text === null || text === void 0 ? void 0 : text.text
    }),
    color: color || thCtaDefaultColor,
    label: ctaLabel
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.themes.js
var cardHeadingThemes = {
  "default": {
    thTitleTheme: 'title-brand-11',
    thSmall: 'font-normal text-small ml-px5',
    thSubtitleTheme: 'title-sans-11'
  },
  thumbnail: {
    thTitleTheme: 'title-brand-7',
    thSmall: 'font-normal text-small ml-px5',
    thSubtitleTheme: 'title-sans-12'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/card-heading/CardHeading.jsx



var CardHeading_jsx = react_default.a.createElement;




var CardHeading_CardHeading = function CardHeading(_ref) {
  var className = _ref.className,
      color = _ref.color,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 2 : _ref$hLevel,
      iconName = _ref.iconName,
      link = _ref.link,
      small = _ref.small,
      subtitle = _ref.subtitle,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title) {
    return null;
  }

  var _cardHeadingThemes$th = cardHeadingThemes[theme],
      thSmall = _cardHeadingThemes$th.thSmall,
      thSubtitleTheme = _cardHeadingThemes$th.thSubtitleTheme,
      thTitleTheme = _cardHeadingThemes$th.thTitleTheme; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return (link === null || link === void 0 ? void 0 : link.url) ? CardHeading_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return withLink(CardHeading_jsx("div", {
    className: className
  }, CardHeading_jsx(Title["a" /* Title */], {
    color: color,
    hLevel: hLevel,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && CardHeading_jsx("small", {
    className: thSmall
  }, small)), !!subtitle && CardHeading_jsx(Title["a" /* Title */], {
    hLevel: hLevel < 6 ? hLevel + 1 : 6,
    color: color,
    theme: thSubtitleTheme
  }, subtitle)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.themes.js
var CardHeader_themes_defaultTheme = {
  thIntro: 'mt-px20'
};
var cardHeaderThemes = {
  "default": CardHeader_themes_defaultTheme,
  thumbnail: CardHeader_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-header/CardHeader.jsx


var CardHeader_jsx = react_default.a.createElement;




var CardHeader_CardHeader = function CardHeader(_ref) {
  var color = _ref.color,
      heading = _ref.heading,
      introduction = _ref.introduction,
      link = _ref.link,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var thIntro = cardHeaderThemes[theme].thIntro;
  return CardHeader_jsx("header", null, CardHeader_jsx(CardHeading_CardHeading, Object(esm_extends["a" /* default */])({}, heading, {
    color: color,
    link: link,
    theme: theme
  })), !!introduction && CardHeader_jsx(Text["a" /* Text */], Object(esm_extends["a" /* default */])({
    className: thIntro
  }, introduction)));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/is-image/index.js
var is_image = __webpack_require__("JFtY");
var is_image_default = /*#__PURE__*/__webpack_require__.n(is_image);

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.utils.js
var Video_utils = __webpack_require__("JhHq");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.themes.js
var themes = {
  "default": {
    thThumbnailButton: 'hover:opacity-75 relative reset-button transition-opacity w-full',
    thThumbnailButtonLabel: 'sr-only',
    thThumbnailIcon: 'absolute bg-overlay-black-60 leading-none m-px10 top-0 p-px10 right-0 text-white',
    thThumbnailIconSize: '1.5625rem',
    thVideo: 'w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/video-with-full-screen/VideoWithFullScreen.jsx
var VideoWithFullScreen_jsx = react_default.a.createElement;









function VideoWithFullScreen(props) {
  var buttonLabel = props.buttonLabel,
      className = props.className,
      closeLabel = props.closeLabel,
      ratioKey = props.ratioKey,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      thumbnail = props.thumbnail,
      title = props.title,
      url = props.url;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  if (!Object(Video_utils["b" /* isVideoUrl */])(url)) return null;
  if (!thumbnail) return VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: className,
    ratioKey: ratioKey,
    url: url
  });
  var _themes$theme = themes[theme],
      thIframe = _themes$theme.thIframe,
      thThumbnailButton = _themes$theme.thThumbnailButton,
      thThumbnailIcon = _themes$theme.thThumbnailIcon,
      thThumbnailIconSize = _themes$theme.thThumbnailIconSize,
      thThumbnailButtonLabel = _themes$theme.thThumbnailButtonLabel,
      thVideo = _themes$theme.thVideo;
  return VideoWithFullScreen_jsx(react["Fragment"], null, VideoWithFullScreen_jsx("button", {
    className: classnames_default()(className, thThumbnailButton),
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    type: "button"
  }, VideoWithFullScreen_jsx("span", {
    classnames: thThumbnailButtonLabel
  }, buttonLabel), VideoWithFullScreen_jsx(Image["b" /* default */], {
    imageUrl: thumbnail,
    ratioKey: ratioKey
  }), VideoWithFullScreen_jsx("div", {
    className: thThumbnailIcon
  }, VideoWithFullScreen_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].VIDEOS,
    width: thThumbnailIconSize
  }))), isExpanded && VideoWithFullScreen_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setExpanded(!isExpanded);
    }
  }, VideoWithFullScreen_jsx(Video["a" /* Video */], {
    className: thVideo,
    iFrameClassName: thIframe,
    ratioKey: ratioKey,
    url: url
  })));
}
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.themes.js

var CardMedia_themes_defaultTheme = {
  thImageRatio: ratios_utils["a" /* default */].M,
  thVideo: 'bg-black'
};
var cardMediaThemes = {
  "default": CardMedia_themes_defaultTheme,
  thumbnail: CardMedia_themes_defaultTheme
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/card-media/CardMedia.jsx


var CardMedia_jsx = react_default.a.createElement;






var CardMedia_CardMedia = function CardMedia(_ref) {
  var children = _ref.children,
      closeLabel = _ref.closeLabel,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _cardMediaThemes$them = cardMediaThemes[theme],
      thVideo = _cardMediaThemes$them.thVideo,
      thImageRatio = _cardMediaThemes$them.thImageRatio; // eslint-disable-next-line clubmed/no-fake-component

  var withLink = function withLink(node) {
    return node && link && link.url ? CardMedia_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({}, link, {
      className: "block"
    }), node) : node;
  };

  return CardMedia_jsx(react["Fragment"], null, is_image_default()(media.url || '') ? withLink(CardMedia_jsx("div", {
    className: "overflow-hidden rounded-tiny"
  }, CardMedia_jsx(Image["b" /* default */], {
    altMsg: media.alt,
    imageUrl: media.url,
    ratioKey: media.ratioKey || thImageRatio,
    ratioDisplay: 1 / 2
  }))) : CardMedia_jsx(VideoWithFullScreen, {
    buttonLabel: media.thumbnailLabel,
    className: thVideo,
    closeLabel: closeLabel,
    thumbnail: media.thumbnail || '',
    title: media.title,
    url: media.url
  }), withLink(children));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.layouts.jsx
var Card_layouts_jsx = react_default.a.createElement;


var Card_layouts_Inline1 = function Inline1(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "sm:flex sm:justify-between -mx-px10"
  }, media && Card_layouts_jsx("div", {
    className: "mb-px20 sm:mb-0 sm:w-1/2 px-px10"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: classnames_default()('px-px10', {
      'sm:w-1/2': media
    })
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-px20'
  }, body)));
};
var Card_layouts_Inline2 = function Inline2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "sm:flex sm:flex-row-reverse sm:justify-between -mx-px10"
  }, media && Card_layouts_jsx("div", {
    className: "mb-px20 sm:mb-0 sm:w-1/2 px-px10"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: classnames_default()('px-px10', {
      'sm:w-1/2': media
    })
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-px20'
  }, body)));
};
var Card_layouts_Column1 = function Column1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media, header && Card_layouts_jsx("div", {
    className: media && 'mt-px20'
  }, header), body && Card_layouts_jsx("div", {
    className: (media || header) && 'mt-px20'
  }, body));
};
var Column2 = function Column2(header, body, media) {
  return Card_layouts_jsx("div", {
    className: "border-1 border-gray-light h-full rounded-tiny shadow-diffuse"
  }, media && Card_layouts_jsx("div", {
    className: "-mx-px -mt-px"
  }, media), (header || body) && Card_layouts_jsx("div", {
    className: "p-px20"
  }, header, body && Card_layouts_jsx("div", {
    className: header && 'mt-px20'
  }, body)));
};
var Card_layouts_Composite1 = function Composite1(header, body, media) {
  return Card_layouts_jsx(react["Fragment"], null, media, (header || body) && Card_layouts_jsx("div", {
    className: classnames_default()('sm:flex sm:-mx-px10', {
      'mt-px20': media
    })
  }, header && Card_layouts_jsx("div", {
    className: "sm:flex-1 sm:px-px10"
  }, header), body && Card_layouts_jsx("div", {
    className: classnames_default()('sm:flex-1 sm:px-px10', {
      'mt-px20': header
    })
  }, body)));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/card/Card.jsx

var Card_jsx = react_default.a.createElement;







var Card_Card = function Card(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      color = _ref.color,
      ctaLabel = _ref.ctaLabel,
      customMedia = _ref.customMedia,
      displayLoadMore = _ref.displayLoadMore,
      heading = _ref.heading,
      id = _ref.id,
      introduction = _ref.introduction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? Card_constants["d" /* INLINE_1 */] : _ref$layout,
      link = _ref.link,
      media = _ref.media,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasTitle = Boolean(heading === null || heading === void 0 ? void 0 : heading.title);
  var hasCta = Boolean(ctaLabel);
  var header = !(introduction === null || introduction === void 0 ? void 0 : introduction.text) && !hasTitle ? null : Card_jsx(CardHeader_CardHeader, {
    color: color,
    heading: heading,
    introduction: introduction,
    link: hasCta ? null : link,
    theme: theme
  });
  var body = !(text === null || text === void 0 ? void 0 : text.text) && !hasCta ? null : Card_jsx(CardBody_CardBody, {
    ctaLabel: ctaLabel,
    color: color,
    displayLoadMore: displayLoadMore,
    isTablet: isTablet,
    layout: layout,
    link: link,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text,
    theme: theme
  });
  var picture = !(media === null || media === void 0 ? void 0 : media.url) && !customMedia ? null : Card_jsx(CardMedia_CardMedia, {
    closeLabel: closeLabel,
    link: hasCta || hasTitle ? null : link,
    media: media,
    theme: theme
  }, customMedia);
  return body || header || picture ? Card_jsx("article", {
    className: className,
    id: id
  }, Card_layouts_namespaceObject[layout](header, body, picture)) : null;
};

/***/ }),

/***/ "7CPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggler; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);












function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


var Toggler = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Toggler, _Component);

  var _super = _createSuper(Toggler);

  function Toggler() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, Toggler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_this), "state", {
      isActive: _this.props.isActive || false
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(_this), "toggle", function () {
      var onToggle = _this.props.onToggle;

      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      }, function () {
        if (onToggle) {
          onToggle(_this.state.isActive);
        }
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Toggler, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isActive = this.props.isActive;

      if (isActive !== prevProps.isActive) {
        this.setState({
          isActive: isActive
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var isActive = this.state.isActive;
      return children(this.toggle, isActive);
    }
  }]);

  return Toggler;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

/***/ }),

/***/ "7Pat":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("+7q0"),
    shortOut = __webpack_require__("kG2z");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "8+jV":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("SRps");
var store = __webpack_require__("l6h7");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "87KK":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var IE8_DOM_DEFINE = __webpack_require__("/+ub");
var anObject = __webpack_require__("ep/x");
var toPropertyKey = __webpack_require__("RWUY");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8D46":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "8PLQ":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Abreve\":\"Ă\",\"abreve\":\"ă\",\"ac\":\"∾\",\"acd\":\"∿\",\"acE\":\"∾̳\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"Acy\":\"А\",\"acy\":\"а\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"af\":\"⁡\",\"Afr\":\"𝔄\",\"afr\":\"𝔞\",\"Agrave\":\"À\",\"agrave\":\"à\",\"alefsym\":\"ℵ\",\"aleph\":\"ℵ\",\"Alpha\":\"Α\",\"alpha\":\"α\",\"Amacr\":\"Ā\",\"amacr\":\"ā\",\"amalg\":\"⨿\",\"amp\":\"&\",\"AMP\":\"&\",\"andand\":\"⩕\",\"And\":\"⩓\",\"and\":\"∧\",\"andd\":\"⩜\",\"andslope\":\"⩘\",\"andv\":\"⩚\",\"ang\":\"∠\",\"ange\":\"⦤\",\"angle\":\"∠\",\"angmsdaa\":\"⦨\",\"angmsdab\":\"⦩\",\"angmsdac\":\"⦪\",\"angmsdad\":\"⦫\",\"angmsdae\":\"⦬\",\"angmsdaf\":\"⦭\",\"angmsdag\":\"⦮\",\"angmsdah\":\"⦯\",\"angmsd\":\"∡\",\"angrt\":\"∟\",\"angrtvb\":\"⊾\",\"angrtvbd\":\"⦝\",\"angsph\":\"∢\",\"angst\":\"Å\",\"angzarr\":\"⍼\",\"Aogon\":\"Ą\",\"aogon\":\"ą\",\"Aopf\":\"𝔸\",\"aopf\":\"𝕒\",\"apacir\":\"⩯\",\"ap\":\"≈\",\"apE\":\"⩰\",\"ape\":\"≊\",\"apid\":\"≋\",\"apos\":\"'\",\"ApplyFunction\":\"⁡\",\"approx\":\"≈\",\"approxeq\":\"≊\",\"Aring\":\"Å\",\"aring\":\"å\",\"Ascr\":\"𝒜\",\"ascr\":\"𝒶\",\"Assign\":\"≔\",\"ast\":\"*\",\"asymp\":\"≈\",\"asympeq\":\"≍\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"awconint\":\"∳\",\"awint\":\"⨑\",\"backcong\":\"≌\",\"backepsilon\":\"϶\",\"backprime\":\"‵\",\"backsim\":\"∽\",\"backsimeq\":\"⋍\",\"Backslash\":\"∖\",\"Barv\":\"⫧\",\"barvee\":\"⊽\",\"barwed\":\"⌅\",\"Barwed\":\"⌆\",\"barwedge\":\"⌅\",\"bbrk\":\"⎵\",\"bbrktbrk\":\"⎶\",\"bcong\":\"≌\",\"Bcy\":\"Б\",\"bcy\":\"б\",\"bdquo\":\"„\",\"becaus\":\"∵\",\"because\":\"∵\",\"Because\":\"∵\",\"bemptyv\":\"⦰\",\"bepsi\":\"϶\",\"bernou\":\"ℬ\",\"Bernoullis\":\"ℬ\",\"Beta\":\"Β\",\"beta\":\"β\",\"beth\":\"ℶ\",\"between\":\"≬\",\"Bfr\":\"𝔅\",\"bfr\":\"𝔟\",\"bigcap\":\"⋂\",\"bigcirc\":\"◯\",\"bigcup\":\"⋃\",\"bigodot\":\"⨀\",\"bigoplus\":\"⨁\",\"bigotimes\":\"⨂\",\"bigsqcup\":\"⨆\",\"bigstar\":\"★\",\"bigtriangledown\":\"▽\",\"bigtriangleup\":\"△\",\"biguplus\":\"⨄\",\"bigvee\":\"⋁\",\"bigwedge\":\"⋀\",\"bkarow\":\"⤍\",\"blacklozenge\":\"⧫\",\"blacksquare\":\"▪\",\"blacktriangle\":\"▴\",\"blacktriangledown\":\"▾\",\"blacktriangleleft\":\"◂\",\"blacktriangleright\":\"▸\",\"blank\":\"␣\",\"blk12\":\"▒\",\"blk14\":\"░\",\"blk34\":\"▓\",\"block\":\"█\",\"bne\":\"=⃥\",\"bnequiv\":\"≡⃥\",\"bNot\":\"⫭\",\"bnot\":\"⌐\",\"Bopf\":\"𝔹\",\"bopf\":\"𝕓\",\"bot\":\"⊥\",\"bottom\":\"⊥\",\"bowtie\":\"⋈\",\"boxbox\":\"⧉\",\"boxdl\":\"┐\",\"boxdL\":\"╕\",\"boxDl\":\"╖\",\"boxDL\":\"╗\",\"boxdr\":\"┌\",\"boxdR\":\"╒\",\"boxDr\":\"╓\",\"boxDR\":\"╔\",\"boxh\":\"─\",\"boxH\":\"═\",\"boxhd\":\"┬\",\"boxHd\":\"╤\",\"boxhD\":\"╥\",\"boxHD\":\"╦\",\"boxhu\":\"┴\",\"boxHu\":\"╧\",\"boxhU\":\"╨\",\"boxHU\":\"╩\",\"boxminus\":\"⊟\",\"boxplus\":\"⊞\",\"boxtimes\":\"⊠\",\"boxul\":\"┘\",\"boxuL\":\"╛\",\"boxUl\":\"╜\",\"boxUL\":\"╝\",\"boxur\":\"└\",\"boxuR\":\"╘\",\"boxUr\":\"╙\",\"boxUR\":\"╚\",\"boxv\":\"│\",\"boxV\":\"║\",\"boxvh\":\"┼\",\"boxvH\":\"╪\",\"boxVh\":\"╫\",\"boxVH\":\"╬\",\"boxvl\":\"┤\",\"boxvL\":\"╡\",\"boxVl\":\"╢\",\"boxVL\":\"╣\",\"boxvr\":\"├\",\"boxvR\":\"╞\",\"boxVr\":\"╟\",\"boxVR\":\"╠\",\"bprime\":\"‵\",\"breve\":\"˘\",\"Breve\":\"˘\",\"brvbar\":\"¦\",\"bscr\":\"𝒷\",\"Bscr\":\"ℬ\",\"bsemi\":\"⁏\",\"bsim\":\"∽\",\"bsime\":\"⋍\",\"bsolb\":\"⧅\",\"bsol\":\"\\\\\",\"bsolhsub\":\"⟈\",\"bull\":\"•\",\"bullet\":\"•\",\"bump\":\"≎\",\"bumpE\":\"⪮\",\"bumpe\":\"≏\",\"Bumpeq\":\"≎\",\"bumpeq\":\"≏\",\"Cacute\":\"Ć\",\"cacute\":\"ć\",\"capand\":\"⩄\",\"capbrcup\":\"⩉\",\"capcap\":\"⩋\",\"cap\":\"∩\",\"Cap\":\"⋒\",\"capcup\":\"⩇\",\"capdot\":\"⩀\",\"CapitalDifferentialD\":\"ⅅ\",\"caps\":\"∩︀\",\"caret\":\"⁁\",\"caron\":\"ˇ\",\"Cayleys\":\"ℭ\",\"ccaps\":\"⩍\",\"Ccaron\":\"Č\",\"ccaron\":\"č\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"Ccirc\":\"Ĉ\",\"ccirc\":\"ĉ\",\"Cconint\":\"∰\",\"ccups\":\"⩌\",\"ccupssm\":\"⩐\",\"Cdot\":\"Ċ\",\"cdot\":\"ċ\",\"cedil\":\"¸\",\"Cedilla\":\"¸\",\"cemptyv\":\"⦲\",\"cent\":\"¢\",\"centerdot\":\"·\",\"CenterDot\":\"·\",\"cfr\":\"𝔠\",\"Cfr\":\"ℭ\",\"CHcy\":\"Ч\",\"chcy\":\"ч\",\"check\":\"✓\",\"checkmark\":\"✓\",\"Chi\":\"Χ\",\"chi\":\"χ\",\"circ\":\"ˆ\",\"circeq\":\"≗\",\"circlearrowleft\":\"↺\",\"circlearrowright\":\"↻\",\"circledast\":\"⊛\",\"circledcirc\":\"⊚\",\"circleddash\":\"⊝\",\"CircleDot\":\"⊙\",\"circledR\":\"®\",\"circledS\":\"Ⓢ\",\"CircleMinus\":\"⊖\",\"CirclePlus\":\"⊕\",\"CircleTimes\":\"⊗\",\"cir\":\"○\",\"cirE\":\"⧃\",\"cire\":\"≗\",\"cirfnint\":\"⨐\",\"cirmid\":\"⫯\",\"cirscir\":\"⧂\",\"ClockwiseContourIntegral\":\"∲\",\"CloseCurlyDoubleQuote\":\"”\",\"CloseCurlyQuote\":\"’\",\"clubs\":\"♣\",\"clubsuit\":\"♣\",\"colon\":\":\",\"Colon\":\"∷\",\"Colone\":\"⩴\",\"colone\":\"≔\",\"coloneq\":\"≔\",\"comma\":\",\",\"commat\":\"@\",\"comp\":\"∁\",\"compfn\":\"∘\",\"complement\":\"∁\",\"complexes\":\"ℂ\",\"cong\":\"≅\",\"congdot\":\"⩭\",\"Congruent\":\"≡\",\"conint\":\"∮\",\"Conint\":\"∯\",\"ContourIntegral\":\"∮\",\"copf\":\"𝕔\",\"Copf\":\"ℂ\",\"coprod\":\"∐\",\"Coproduct\":\"∐\",\"copy\":\"©\",\"COPY\":\"©\",\"copysr\":\"℗\",\"CounterClockwiseContourIntegral\":\"∳\",\"crarr\":\"↵\",\"cross\":\"✗\",\"Cross\":\"⨯\",\"Cscr\":\"𝒞\",\"cscr\":\"𝒸\",\"csub\":\"⫏\",\"csube\":\"⫑\",\"csup\":\"⫐\",\"csupe\":\"⫒\",\"ctdot\":\"⋯\",\"cudarrl\":\"⤸\",\"cudarrr\":\"⤵\",\"cuepr\":\"⋞\",\"cuesc\":\"⋟\",\"cularr\":\"↶\",\"cularrp\":\"⤽\",\"cupbrcap\":\"⩈\",\"cupcap\":\"⩆\",\"CupCap\":\"≍\",\"cup\":\"∪\",\"Cup\":\"⋓\",\"cupcup\":\"⩊\",\"cupdot\":\"⊍\",\"cupor\":\"⩅\",\"cups\":\"∪︀\",\"curarr\":\"↷\",\"curarrm\":\"⤼\",\"curlyeqprec\":\"⋞\",\"curlyeqsucc\":\"⋟\",\"curlyvee\":\"⋎\",\"curlywedge\":\"⋏\",\"curren\":\"¤\",\"curvearrowleft\":\"↶\",\"curvearrowright\":\"↷\",\"cuvee\":\"⋎\",\"cuwed\":\"⋏\",\"cwconint\":\"∲\",\"cwint\":\"∱\",\"cylcty\":\"⌭\",\"dagger\":\"†\",\"Dagger\":\"‡\",\"daleth\":\"ℸ\",\"darr\":\"↓\",\"Darr\":\"↡\",\"dArr\":\"⇓\",\"dash\":\"‐\",\"Dashv\":\"⫤\",\"dashv\":\"⊣\",\"dbkarow\":\"⤏\",\"dblac\":\"˝\",\"Dcaron\":\"Ď\",\"dcaron\":\"ď\",\"Dcy\":\"Д\",\"dcy\":\"д\",\"ddagger\":\"‡\",\"ddarr\":\"⇊\",\"DD\":\"ⅅ\",\"dd\":\"ⅆ\",\"DDotrahd\":\"⤑\",\"ddotseq\":\"⩷\",\"deg\":\"°\",\"Del\":\"∇\",\"Delta\":\"Δ\",\"delta\":\"δ\",\"demptyv\":\"⦱\",\"dfisht\":\"⥿\",\"Dfr\":\"𝔇\",\"dfr\":\"𝔡\",\"dHar\":\"⥥\",\"dharl\":\"⇃\",\"dharr\":\"⇂\",\"DiacriticalAcute\":\"´\",\"DiacriticalDot\":\"˙\",\"DiacriticalDoubleAcute\":\"˝\",\"DiacriticalGrave\":\"`\",\"DiacriticalTilde\":\"˜\",\"diam\":\"⋄\",\"diamond\":\"⋄\",\"Diamond\":\"⋄\",\"diamondsuit\":\"♦\",\"diams\":\"♦\",\"die\":\"¨\",\"DifferentialD\":\"ⅆ\",\"digamma\":\"ϝ\",\"disin\":\"⋲\",\"div\":\"÷\",\"divide\":\"÷\",\"divideontimes\":\"⋇\",\"divonx\":\"⋇\",\"DJcy\":\"Ђ\",\"djcy\":\"ђ\",\"dlcorn\":\"⌞\",\"dlcrop\":\"⌍\",\"dollar\":\"$\",\"Dopf\":\"𝔻\",\"dopf\":\"𝕕\",\"Dot\":\"¨\",\"dot\":\"˙\",\"DotDot\":\"⃜\",\"doteq\":\"≐\",\"doteqdot\":\"≑\",\"DotEqual\":\"≐\",\"dotminus\":\"∸\",\"dotplus\":\"∔\",\"dotsquare\":\"⊡\",\"doublebarwedge\":\"⌆\",\"DoubleContourIntegral\":\"∯\",\"DoubleDot\":\"¨\",\"DoubleDownArrow\":\"⇓\",\"DoubleLeftArrow\":\"⇐\",\"DoubleLeftRightArrow\":\"⇔\",\"DoubleLeftTee\":\"⫤\",\"DoubleLongLeftArrow\":\"⟸\",\"DoubleLongLeftRightArrow\":\"⟺\",\"DoubleLongRightArrow\":\"⟹\",\"DoubleRightArrow\":\"⇒\",\"DoubleRightTee\":\"⊨\",\"DoubleUpArrow\":\"⇑\",\"DoubleUpDownArrow\":\"⇕\",\"DoubleVerticalBar\":\"∥\",\"DownArrowBar\":\"⤓\",\"downarrow\":\"↓\",\"DownArrow\":\"↓\",\"Downarrow\":\"⇓\",\"DownArrowUpArrow\":\"⇵\",\"DownBreve\":\"̑\",\"downdownarrows\":\"⇊\",\"downharpoonleft\":\"⇃\",\"downharpoonright\":\"⇂\",\"DownLeftRightVector\":\"⥐\",\"DownLeftTeeVector\":\"⥞\",\"DownLeftVectorBar\":\"⥖\",\"DownLeftVector\":\"↽\",\"DownRightTeeVector\":\"⥟\",\"DownRightVectorBar\":\"⥗\",\"DownRightVector\":\"⇁\",\"DownTeeArrow\":\"↧\",\"DownTee\":\"⊤\",\"drbkarow\":\"⤐\",\"drcorn\":\"⌟\",\"drcrop\":\"⌌\",\"Dscr\":\"𝒟\",\"dscr\":\"𝒹\",\"DScy\":\"Ѕ\",\"dscy\":\"ѕ\",\"dsol\":\"⧶\",\"Dstrok\":\"Đ\",\"dstrok\":\"đ\",\"dtdot\":\"⋱\",\"dtri\":\"▿\",\"dtrif\":\"▾\",\"duarr\":\"⇵\",\"duhar\":\"⥯\",\"dwangle\":\"⦦\",\"DZcy\":\"Џ\",\"dzcy\":\"џ\",\"dzigrarr\":\"⟿\",\"Eacute\":\"É\",\"eacute\":\"é\",\"easter\":\"⩮\",\"Ecaron\":\"Ě\",\"ecaron\":\"ě\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"ecir\":\"≖\",\"ecolon\":\"≕\",\"Ecy\":\"Э\",\"ecy\":\"э\",\"eDDot\":\"⩷\",\"Edot\":\"Ė\",\"edot\":\"ė\",\"eDot\":\"≑\",\"ee\":\"ⅇ\",\"efDot\":\"≒\",\"Efr\":\"𝔈\",\"efr\":\"𝔢\",\"eg\":\"⪚\",\"Egrave\":\"È\",\"egrave\":\"è\",\"egs\":\"⪖\",\"egsdot\":\"⪘\",\"el\":\"⪙\",\"Element\":\"∈\",\"elinters\":\"⏧\",\"ell\":\"ℓ\",\"els\":\"⪕\",\"elsdot\":\"⪗\",\"Emacr\":\"Ē\",\"emacr\":\"ē\",\"empty\":\"∅\",\"emptyset\":\"∅\",\"EmptySmallSquare\":\"◻\",\"emptyv\":\"∅\",\"EmptyVerySmallSquare\":\"▫\",\"emsp13\":\" \",\"emsp14\":\" \",\"emsp\":\" \",\"ENG\":\"Ŋ\",\"eng\":\"ŋ\",\"ensp\":\" \",\"Eogon\":\"Ę\",\"eogon\":\"ę\",\"Eopf\":\"𝔼\",\"eopf\":\"𝕖\",\"epar\":\"⋕\",\"eparsl\":\"⧣\",\"eplus\":\"⩱\",\"epsi\":\"ε\",\"Epsilon\":\"Ε\",\"epsilon\":\"ε\",\"epsiv\":\"ϵ\",\"eqcirc\":\"≖\",\"eqcolon\":\"≕\",\"eqsim\":\"≂\",\"eqslantgtr\":\"⪖\",\"eqslantless\":\"⪕\",\"Equal\":\"⩵\",\"equals\":\"=\",\"EqualTilde\":\"≂\",\"equest\":\"≟\",\"Equilibrium\":\"⇌\",\"equiv\":\"≡\",\"equivDD\":\"⩸\",\"eqvparsl\":\"⧥\",\"erarr\":\"⥱\",\"erDot\":\"≓\",\"escr\":\"ℯ\",\"Escr\":\"ℰ\",\"esdot\":\"≐\",\"Esim\":\"⩳\",\"esim\":\"≂\",\"Eta\":\"Η\",\"eta\":\"η\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"euro\":\"€\",\"excl\":\"!\",\"exist\":\"∃\",\"Exists\":\"∃\",\"expectation\":\"ℰ\",\"exponentiale\":\"ⅇ\",\"ExponentialE\":\"ⅇ\",\"fallingdotseq\":\"≒\",\"Fcy\":\"Ф\",\"fcy\":\"ф\",\"female\":\"♀\",\"ffilig\":\"ﬃ\",\"fflig\":\"ﬀ\",\"ffllig\":\"ﬄ\",\"Ffr\":\"𝔉\",\"ffr\":\"𝔣\",\"filig\":\"ﬁ\",\"FilledSmallSquare\":\"◼\",\"FilledVerySmallSquare\":\"▪\",\"fjlig\":\"fj\",\"flat\":\"♭\",\"fllig\":\"ﬂ\",\"fltns\":\"▱\",\"fnof\":\"ƒ\",\"Fopf\":\"𝔽\",\"fopf\":\"𝕗\",\"forall\":\"∀\",\"ForAll\":\"∀\",\"fork\":\"⋔\",\"forkv\":\"⫙\",\"Fouriertrf\":\"ℱ\",\"fpartint\":\"⨍\",\"frac12\":\"½\",\"frac13\":\"⅓\",\"frac14\":\"¼\",\"frac15\":\"⅕\",\"frac16\":\"⅙\",\"frac18\":\"⅛\",\"frac23\":\"⅔\",\"frac25\":\"⅖\",\"frac34\":\"¾\",\"frac35\":\"⅗\",\"frac38\":\"⅜\",\"frac45\":\"⅘\",\"frac56\":\"⅚\",\"frac58\":\"⅝\",\"frac78\":\"⅞\",\"frasl\":\"⁄\",\"frown\":\"⌢\",\"fscr\":\"𝒻\",\"Fscr\":\"ℱ\",\"gacute\":\"ǵ\",\"Gamma\":\"Γ\",\"gamma\":\"γ\",\"Gammad\":\"Ϝ\",\"gammad\":\"ϝ\",\"gap\":\"⪆\",\"Gbreve\":\"Ğ\",\"gbreve\":\"ğ\",\"Gcedil\":\"Ģ\",\"Gcirc\":\"Ĝ\",\"gcirc\":\"ĝ\",\"Gcy\":\"Г\",\"gcy\":\"г\",\"Gdot\":\"Ġ\",\"gdot\":\"ġ\",\"ge\":\"≥\",\"gE\":\"≧\",\"gEl\":\"⪌\",\"gel\":\"⋛\",\"geq\":\"≥\",\"geqq\":\"≧\",\"geqslant\":\"⩾\",\"gescc\":\"⪩\",\"ges\":\"⩾\",\"gesdot\":\"⪀\",\"gesdoto\":\"⪂\",\"gesdotol\":\"⪄\",\"gesl\":\"⋛︀\",\"gesles\":\"⪔\",\"Gfr\":\"𝔊\",\"gfr\":\"𝔤\",\"gg\":\"≫\",\"Gg\":\"⋙\",\"ggg\":\"⋙\",\"gimel\":\"ℷ\",\"GJcy\":\"Ѓ\",\"gjcy\":\"ѓ\",\"gla\":\"⪥\",\"gl\":\"≷\",\"glE\":\"⪒\",\"glj\":\"⪤\",\"gnap\":\"⪊\",\"gnapprox\":\"⪊\",\"gne\":\"⪈\",\"gnE\":\"≩\",\"gneq\":\"⪈\",\"gneqq\":\"≩\",\"gnsim\":\"⋧\",\"Gopf\":\"𝔾\",\"gopf\":\"𝕘\",\"grave\":\"`\",\"GreaterEqual\":\"≥\",\"GreaterEqualLess\":\"⋛\",\"GreaterFullEqual\":\"≧\",\"GreaterGreater\":\"⪢\",\"GreaterLess\":\"≷\",\"GreaterSlantEqual\":\"⩾\",\"GreaterTilde\":\"≳\",\"Gscr\":\"𝒢\",\"gscr\":\"ℊ\",\"gsim\":\"≳\",\"gsime\":\"⪎\",\"gsiml\":\"⪐\",\"gtcc\":\"⪧\",\"gtcir\":\"⩺\",\"gt\":\">\",\"GT\":\">\",\"Gt\":\"≫\",\"gtdot\":\"⋗\",\"gtlPar\":\"⦕\",\"gtquest\":\"⩼\",\"gtrapprox\":\"⪆\",\"gtrarr\":\"⥸\",\"gtrdot\":\"⋗\",\"gtreqless\":\"⋛\",\"gtreqqless\":\"⪌\",\"gtrless\":\"≷\",\"gtrsim\":\"≳\",\"gvertneqq\":\"≩︀\",\"gvnE\":\"≩︀\",\"Hacek\":\"ˇ\",\"hairsp\":\" \",\"half\":\"½\",\"hamilt\":\"ℋ\",\"HARDcy\":\"Ъ\",\"hardcy\":\"ъ\",\"harrcir\":\"⥈\",\"harr\":\"↔\",\"hArr\":\"⇔\",\"harrw\":\"↭\",\"Hat\":\"^\",\"hbar\":\"ℏ\",\"Hcirc\":\"Ĥ\",\"hcirc\":\"ĥ\",\"hearts\":\"♥\",\"heartsuit\":\"♥\",\"hellip\":\"…\",\"hercon\":\"⊹\",\"hfr\":\"𝔥\",\"Hfr\":\"ℌ\",\"HilbertSpace\":\"ℋ\",\"hksearow\":\"⤥\",\"hkswarow\":\"⤦\",\"hoarr\":\"⇿\",\"homtht\":\"∻\",\"hookleftarrow\":\"↩\",\"hookrightarrow\":\"↪\",\"hopf\":\"𝕙\",\"Hopf\":\"ℍ\",\"horbar\":\"―\",\"HorizontalLine\":\"─\",\"hscr\":\"𝒽\",\"Hscr\":\"ℋ\",\"hslash\":\"ℏ\",\"Hstrok\":\"Ħ\",\"hstrok\":\"ħ\",\"HumpDownHump\":\"≎\",\"HumpEqual\":\"≏\",\"hybull\":\"⁃\",\"hyphen\":\"‐\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"ic\":\"⁣\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"Icy\":\"И\",\"icy\":\"и\",\"Idot\":\"İ\",\"IEcy\":\"Е\",\"iecy\":\"е\",\"iexcl\":\"¡\",\"iff\":\"⇔\",\"ifr\":\"𝔦\",\"Ifr\":\"ℑ\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"ii\":\"ⅈ\",\"iiiint\":\"⨌\",\"iiint\":\"∭\",\"iinfin\":\"⧜\",\"iiota\":\"℩\",\"IJlig\":\"Ĳ\",\"ijlig\":\"ĳ\",\"Imacr\":\"Ī\",\"imacr\":\"ī\",\"image\":\"ℑ\",\"ImaginaryI\":\"ⅈ\",\"imagline\":\"ℐ\",\"imagpart\":\"ℑ\",\"imath\":\"ı\",\"Im\":\"ℑ\",\"imof\":\"⊷\",\"imped\":\"Ƶ\",\"Implies\":\"⇒\",\"incare\":\"℅\",\"in\":\"∈\",\"infin\":\"∞\",\"infintie\":\"⧝\",\"inodot\":\"ı\",\"intcal\":\"⊺\",\"int\":\"∫\",\"Int\":\"∬\",\"integers\":\"ℤ\",\"Integral\":\"∫\",\"intercal\":\"⊺\",\"Intersection\":\"⋂\",\"intlarhk\":\"⨗\",\"intprod\":\"⨼\",\"InvisibleComma\":\"⁣\",\"InvisibleTimes\":\"⁢\",\"IOcy\":\"Ё\",\"iocy\":\"ё\",\"Iogon\":\"Į\",\"iogon\":\"į\",\"Iopf\":\"𝕀\",\"iopf\":\"𝕚\",\"Iota\":\"Ι\",\"iota\":\"ι\",\"iprod\":\"⨼\",\"iquest\":\"¿\",\"iscr\":\"𝒾\",\"Iscr\":\"ℐ\",\"isin\":\"∈\",\"isindot\":\"⋵\",\"isinE\":\"⋹\",\"isins\":\"⋴\",\"isinsv\":\"⋳\",\"isinv\":\"∈\",\"it\":\"⁢\",\"Itilde\":\"Ĩ\",\"itilde\":\"ĩ\",\"Iukcy\":\"І\",\"iukcy\":\"і\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"Jcirc\":\"Ĵ\",\"jcirc\":\"ĵ\",\"Jcy\":\"Й\",\"jcy\":\"й\",\"Jfr\":\"𝔍\",\"jfr\":\"𝔧\",\"jmath\":\"ȷ\",\"Jopf\":\"𝕁\",\"jopf\":\"𝕛\",\"Jscr\":\"𝒥\",\"jscr\":\"𝒿\",\"Jsercy\":\"Ј\",\"jsercy\":\"ј\",\"Jukcy\":\"Є\",\"jukcy\":\"є\",\"Kappa\":\"Κ\",\"kappa\":\"κ\",\"kappav\":\"ϰ\",\"Kcedil\":\"Ķ\",\"kcedil\":\"ķ\",\"Kcy\":\"К\",\"kcy\":\"к\",\"Kfr\":\"𝔎\",\"kfr\":\"𝔨\",\"kgreen\":\"ĸ\",\"KHcy\":\"Х\",\"khcy\":\"х\",\"KJcy\":\"Ќ\",\"kjcy\":\"ќ\",\"Kopf\":\"𝕂\",\"kopf\":\"𝕜\",\"Kscr\":\"𝒦\",\"kscr\":\"𝓀\",\"lAarr\":\"⇚\",\"Lacute\":\"Ĺ\",\"lacute\":\"ĺ\",\"laemptyv\":\"⦴\",\"lagran\":\"ℒ\",\"Lambda\":\"Λ\",\"lambda\":\"λ\",\"lang\":\"⟨\",\"Lang\":\"⟪\",\"langd\":\"⦑\",\"langle\":\"⟨\",\"lap\":\"⪅\",\"Laplacetrf\":\"ℒ\",\"laquo\":\"«\",\"larrb\":\"⇤\",\"larrbfs\":\"⤟\",\"larr\":\"←\",\"Larr\":\"↞\",\"lArr\":\"⇐\",\"larrfs\":\"⤝\",\"larrhk\":\"↩\",\"larrlp\":\"↫\",\"larrpl\":\"⤹\",\"larrsim\":\"⥳\",\"larrtl\":\"↢\",\"latail\":\"⤙\",\"lAtail\":\"⤛\",\"lat\":\"⪫\",\"late\":\"⪭\",\"lates\":\"⪭︀\",\"lbarr\":\"⤌\",\"lBarr\":\"⤎\",\"lbbrk\":\"❲\",\"lbrace\":\"{\",\"lbrack\":\"[\",\"lbrke\":\"⦋\",\"lbrksld\":\"⦏\",\"lbrkslu\":\"⦍\",\"Lcaron\":\"Ľ\",\"lcaron\":\"ľ\",\"Lcedil\":\"Ļ\",\"lcedil\":\"ļ\",\"lceil\":\"⌈\",\"lcub\":\"{\",\"Lcy\":\"Л\",\"lcy\":\"л\",\"ldca\":\"⤶\",\"ldquo\":\"“\",\"ldquor\":\"„\",\"ldrdhar\":\"⥧\",\"ldrushar\":\"⥋\",\"ldsh\":\"↲\",\"le\":\"≤\",\"lE\":\"≦\",\"LeftAngleBracket\":\"⟨\",\"LeftArrowBar\":\"⇤\",\"leftarrow\":\"←\",\"LeftArrow\":\"←\",\"Leftarrow\":\"⇐\",\"LeftArrowRightArrow\":\"⇆\",\"leftarrowtail\":\"↢\",\"LeftCeiling\":\"⌈\",\"LeftDoubleBracket\":\"⟦\",\"LeftDownTeeVector\":\"⥡\",\"LeftDownVectorBar\":\"⥙\",\"LeftDownVector\":\"⇃\",\"LeftFloor\":\"⌊\",\"leftharpoondown\":\"↽\",\"leftharpoonup\":\"↼\",\"leftleftarrows\":\"⇇\",\"leftrightarrow\":\"↔\",\"LeftRightArrow\":\"↔\",\"Leftrightarrow\":\"⇔\",\"leftrightarrows\":\"⇆\",\"leftrightharpoons\":\"⇋\",\"leftrightsquigarrow\":\"↭\",\"LeftRightVector\":\"⥎\",\"LeftTeeArrow\":\"↤\",\"LeftTee\":\"⊣\",\"LeftTeeVector\":\"⥚\",\"leftthreetimes\":\"⋋\",\"LeftTriangleBar\":\"⧏\",\"LeftTriangle\":\"⊲\",\"LeftTriangleEqual\":\"⊴\",\"LeftUpDownVector\":\"⥑\",\"LeftUpTeeVector\":\"⥠\",\"LeftUpVectorBar\":\"⥘\",\"LeftUpVector\":\"↿\",\"LeftVectorBar\":\"⥒\",\"LeftVector\":\"↼\",\"lEg\":\"⪋\",\"leg\":\"⋚\",\"leq\":\"≤\",\"leqq\":\"≦\",\"leqslant\":\"⩽\",\"lescc\":\"⪨\",\"les\":\"⩽\",\"lesdot\":\"⩿\",\"lesdoto\":\"⪁\",\"lesdotor\":\"⪃\",\"lesg\":\"⋚︀\",\"lesges\":\"⪓\",\"lessapprox\":\"⪅\",\"lessdot\":\"⋖\",\"lesseqgtr\":\"⋚\",\"lesseqqgtr\":\"⪋\",\"LessEqualGreater\":\"⋚\",\"LessFullEqual\":\"≦\",\"LessGreater\":\"≶\",\"lessgtr\":\"≶\",\"LessLess\":\"⪡\",\"lesssim\":\"≲\",\"LessSlantEqual\":\"⩽\",\"LessTilde\":\"≲\",\"lfisht\":\"⥼\",\"lfloor\":\"⌊\",\"Lfr\":\"𝔏\",\"lfr\":\"𝔩\",\"lg\":\"≶\",\"lgE\":\"⪑\",\"lHar\":\"⥢\",\"lhard\":\"↽\",\"lharu\":\"↼\",\"lharul\":\"⥪\",\"lhblk\":\"▄\",\"LJcy\":\"Љ\",\"ljcy\":\"љ\",\"llarr\":\"⇇\",\"ll\":\"≪\",\"Ll\":\"⋘\",\"llcorner\":\"⌞\",\"Lleftarrow\":\"⇚\",\"llhard\":\"⥫\",\"lltri\":\"◺\",\"Lmidot\":\"Ŀ\",\"lmidot\":\"ŀ\",\"lmoustache\":\"⎰\",\"lmoust\":\"⎰\",\"lnap\":\"⪉\",\"lnapprox\":\"⪉\",\"lne\":\"⪇\",\"lnE\":\"≨\",\"lneq\":\"⪇\",\"lneqq\":\"≨\",\"lnsim\":\"⋦\",\"loang\":\"⟬\",\"loarr\":\"⇽\",\"lobrk\":\"⟦\",\"longleftarrow\":\"⟵\",\"LongLeftArrow\":\"⟵\",\"Longleftarrow\":\"⟸\",\"longleftrightarrow\":\"⟷\",\"LongLeftRightArrow\":\"⟷\",\"Longleftrightarrow\":\"⟺\",\"longmapsto\":\"⟼\",\"longrightarrow\":\"⟶\",\"LongRightArrow\":\"⟶\",\"Longrightarrow\":\"⟹\",\"looparrowleft\":\"↫\",\"looparrowright\":\"↬\",\"lopar\":\"⦅\",\"Lopf\":\"𝕃\",\"lopf\":\"𝕝\",\"loplus\":\"⨭\",\"lotimes\":\"⨴\",\"lowast\":\"∗\",\"lowbar\":\"_\",\"LowerLeftArrow\":\"↙\",\"LowerRightArrow\":\"↘\",\"loz\":\"◊\",\"lozenge\":\"◊\",\"lozf\":\"⧫\",\"lpar\":\"(\",\"lparlt\":\"⦓\",\"lrarr\":\"⇆\",\"lrcorner\":\"⌟\",\"lrhar\":\"⇋\",\"lrhard\":\"⥭\",\"lrm\":\"‎\",\"lrtri\":\"⊿\",\"lsaquo\":\"‹\",\"lscr\":\"𝓁\",\"Lscr\":\"ℒ\",\"lsh\":\"↰\",\"Lsh\":\"↰\",\"lsim\":\"≲\",\"lsime\":\"⪍\",\"lsimg\":\"⪏\",\"lsqb\":\"[\",\"lsquo\":\"‘\",\"lsquor\":\"‚\",\"Lstrok\":\"Ł\",\"lstrok\":\"ł\",\"ltcc\":\"⪦\",\"ltcir\":\"⩹\",\"lt\":\"<\",\"LT\":\"<\",\"Lt\":\"≪\",\"ltdot\":\"⋖\",\"lthree\":\"⋋\",\"ltimes\":\"⋉\",\"ltlarr\":\"⥶\",\"ltquest\":\"⩻\",\"ltri\":\"◃\",\"ltrie\":\"⊴\",\"ltrif\":\"◂\",\"ltrPar\":\"⦖\",\"lurdshar\":\"⥊\",\"luruhar\":\"⥦\",\"lvertneqq\":\"≨︀\",\"lvnE\":\"≨︀\",\"macr\":\"¯\",\"male\":\"♂\",\"malt\":\"✠\",\"maltese\":\"✠\",\"Map\":\"⤅\",\"map\":\"↦\",\"mapsto\":\"↦\",\"mapstodown\":\"↧\",\"mapstoleft\":\"↤\",\"mapstoup\":\"↥\",\"marker\":\"▮\",\"mcomma\":\"⨩\",\"Mcy\":\"М\",\"mcy\":\"м\",\"mdash\":\"—\",\"mDDot\":\"∺\",\"measuredangle\":\"∡\",\"MediumSpace\":\" \",\"Mellintrf\":\"ℳ\",\"Mfr\":\"𝔐\",\"mfr\":\"𝔪\",\"mho\":\"℧\",\"micro\":\"µ\",\"midast\":\"*\",\"midcir\":\"⫰\",\"mid\":\"∣\",\"middot\":\"·\",\"minusb\":\"⊟\",\"minus\":\"−\",\"minusd\":\"∸\",\"minusdu\":\"⨪\",\"MinusPlus\":\"∓\",\"mlcp\":\"⫛\",\"mldr\":\"…\",\"mnplus\":\"∓\",\"models\":\"⊧\",\"Mopf\":\"𝕄\",\"mopf\":\"𝕞\",\"mp\":\"∓\",\"mscr\":\"𝓂\",\"Mscr\":\"ℳ\",\"mstpos\":\"∾\",\"Mu\":\"Μ\",\"mu\":\"μ\",\"multimap\":\"⊸\",\"mumap\":\"⊸\",\"nabla\":\"∇\",\"Nacute\":\"Ń\",\"nacute\":\"ń\",\"nang\":\"∠⃒\",\"nap\":\"≉\",\"napE\":\"⩰̸\",\"napid\":\"≋̸\",\"napos\":\"ŉ\",\"napprox\":\"≉\",\"natural\":\"♮\",\"naturals\":\"ℕ\",\"natur\":\"♮\",\"nbsp\":\" \",\"nbump\":\"≎̸\",\"nbumpe\":\"≏̸\",\"ncap\":\"⩃\",\"Ncaron\":\"Ň\",\"ncaron\":\"ň\",\"Ncedil\":\"Ņ\",\"ncedil\":\"ņ\",\"ncong\":\"≇\",\"ncongdot\":\"⩭̸\",\"ncup\":\"⩂\",\"Ncy\":\"Н\",\"ncy\":\"н\",\"ndash\":\"–\",\"nearhk\":\"⤤\",\"nearr\":\"↗\",\"neArr\":\"⇗\",\"nearrow\":\"↗\",\"ne\":\"≠\",\"nedot\":\"≐̸\",\"NegativeMediumSpace\":\"​\",\"NegativeThickSpace\":\"​\",\"NegativeThinSpace\":\"​\",\"NegativeVeryThinSpace\":\"​\",\"nequiv\":\"≢\",\"nesear\":\"⤨\",\"nesim\":\"≂̸\",\"NestedGreaterGreater\":\"≫\",\"NestedLessLess\":\"≪\",\"NewLine\":\"\\n\",\"nexist\":\"∄\",\"nexists\":\"∄\",\"Nfr\":\"𝔑\",\"nfr\":\"𝔫\",\"ngE\":\"≧̸\",\"nge\":\"≱\",\"ngeq\":\"≱\",\"ngeqq\":\"≧̸\",\"ngeqslant\":\"⩾̸\",\"nges\":\"⩾̸\",\"nGg\":\"⋙̸\",\"ngsim\":\"≵\",\"nGt\":\"≫⃒\",\"ngt\":\"≯\",\"ngtr\":\"≯\",\"nGtv\":\"≫̸\",\"nharr\":\"↮\",\"nhArr\":\"⇎\",\"nhpar\":\"⫲\",\"ni\":\"∋\",\"nis\":\"⋼\",\"nisd\":\"⋺\",\"niv\":\"∋\",\"NJcy\":\"Њ\",\"njcy\":\"њ\",\"nlarr\":\"↚\",\"nlArr\":\"⇍\",\"nldr\":\"‥\",\"nlE\":\"≦̸\",\"nle\":\"≰\",\"nleftarrow\":\"↚\",\"nLeftarrow\":\"⇍\",\"nleftrightarrow\":\"↮\",\"nLeftrightarrow\":\"⇎\",\"nleq\":\"≰\",\"nleqq\":\"≦̸\",\"nleqslant\":\"⩽̸\",\"nles\":\"⩽̸\",\"nless\":\"≮\",\"nLl\":\"⋘̸\",\"nlsim\":\"≴\",\"nLt\":\"≪⃒\",\"nlt\":\"≮\",\"nltri\":\"⋪\",\"nltrie\":\"⋬\",\"nLtv\":\"≪̸\",\"nmid\":\"∤\",\"NoBreak\":\"⁠\",\"NonBreakingSpace\":\" \",\"nopf\":\"𝕟\",\"Nopf\":\"ℕ\",\"Not\":\"⫬\",\"not\":\"¬\",\"NotCongruent\":\"≢\",\"NotCupCap\":\"≭\",\"NotDoubleVerticalBar\":\"∦\",\"NotElement\":\"∉\",\"NotEqual\":\"≠\",\"NotEqualTilde\":\"≂̸\",\"NotExists\":\"∄\",\"NotGreater\":\"≯\",\"NotGreaterEqual\":\"≱\",\"NotGreaterFullEqual\":\"≧̸\",\"NotGreaterGreater\":\"≫̸\",\"NotGreaterLess\":\"≹\",\"NotGreaterSlantEqual\":\"⩾̸\",\"NotGreaterTilde\":\"≵\",\"NotHumpDownHump\":\"≎̸\",\"NotHumpEqual\":\"≏̸\",\"notin\":\"∉\",\"notindot\":\"⋵̸\",\"notinE\":\"⋹̸\",\"notinva\":\"∉\",\"notinvb\":\"⋷\",\"notinvc\":\"⋶\",\"NotLeftTriangleBar\":\"⧏̸\",\"NotLeftTriangle\":\"⋪\",\"NotLeftTriangleEqual\":\"⋬\",\"NotLess\":\"≮\",\"NotLessEqual\":\"≰\",\"NotLessGreater\":\"≸\",\"NotLessLess\":\"≪̸\",\"NotLessSlantEqual\":\"⩽̸\",\"NotLessTilde\":\"≴\",\"NotNestedGreaterGreater\":\"⪢̸\",\"NotNestedLessLess\":\"⪡̸\",\"notni\":\"∌\",\"notniva\":\"∌\",\"notnivb\":\"⋾\",\"notnivc\":\"⋽\",\"NotPrecedes\":\"⊀\",\"NotPrecedesEqual\":\"⪯̸\",\"NotPrecedesSlantEqual\":\"⋠\",\"NotReverseElement\":\"∌\",\"NotRightTriangleBar\":\"⧐̸\",\"NotRightTriangle\":\"⋫\",\"NotRightTriangleEqual\":\"⋭\",\"NotSquareSubset\":\"⊏̸\",\"NotSquareSubsetEqual\":\"⋢\",\"NotSquareSuperset\":\"⊐̸\",\"NotSquareSupersetEqual\":\"⋣\",\"NotSubset\":\"⊂⃒\",\"NotSubsetEqual\":\"⊈\",\"NotSucceeds\":\"⊁\",\"NotSucceedsEqual\":\"⪰̸\",\"NotSucceedsSlantEqual\":\"⋡\",\"NotSucceedsTilde\":\"≿̸\",\"NotSuperset\":\"⊃⃒\",\"NotSupersetEqual\":\"⊉\",\"NotTilde\":\"≁\",\"NotTildeEqual\":\"≄\",\"NotTildeFullEqual\":\"≇\",\"NotTildeTilde\":\"≉\",\"NotVerticalBar\":\"∤\",\"nparallel\":\"∦\",\"npar\":\"∦\",\"nparsl\":\"⫽⃥\",\"npart\":\"∂̸\",\"npolint\":\"⨔\",\"npr\":\"⊀\",\"nprcue\":\"⋠\",\"nprec\":\"⊀\",\"npreceq\":\"⪯̸\",\"npre\":\"⪯̸\",\"nrarrc\":\"⤳̸\",\"nrarr\":\"↛\",\"nrArr\":\"⇏\",\"nrarrw\":\"↝̸\",\"nrightarrow\":\"↛\",\"nRightarrow\":\"⇏\",\"nrtri\":\"⋫\",\"nrtrie\":\"⋭\",\"nsc\":\"⊁\",\"nsccue\":\"⋡\",\"nsce\":\"⪰̸\",\"Nscr\":\"𝒩\",\"nscr\":\"𝓃\",\"nshortmid\":\"∤\",\"nshortparallel\":\"∦\",\"nsim\":\"≁\",\"nsime\":\"≄\",\"nsimeq\":\"≄\",\"nsmid\":\"∤\",\"nspar\":\"∦\",\"nsqsube\":\"⋢\",\"nsqsupe\":\"⋣\",\"nsub\":\"⊄\",\"nsubE\":\"⫅̸\",\"nsube\":\"⊈\",\"nsubset\":\"⊂⃒\",\"nsubseteq\":\"⊈\",\"nsubseteqq\":\"⫅̸\",\"nsucc\":\"⊁\",\"nsucceq\":\"⪰̸\",\"nsup\":\"⊅\",\"nsupE\":\"⫆̸\",\"nsupe\":\"⊉\",\"nsupset\":\"⊃⃒\",\"nsupseteq\":\"⊉\",\"nsupseteqq\":\"⫆̸\",\"ntgl\":\"≹\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"ntlg\":\"≸\",\"ntriangleleft\":\"⋪\",\"ntrianglelefteq\":\"⋬\",\"ntriangleright\":\"⋫\",\"ntrianglerighteq\":\"⋭\",\"Nu\":\"Ν\",\"nu\":\"ν\",\"num\":\"#\",\"numero\":\"№\",\"numsp\":\" \",\"nvap\":\"≍⃒\",\"nvdash\":\"⊬\",\"nvDash\":\"⊭\",\"nVdash\":\"⊮\",\"nVDash\":\"⊯\",\"nvge\":\"≥⃒\",\"nvgt\":\">⃒\",\"nvHarr\":\"⤄\",\"nvinfin\":\"⧞\",\"nvlArr\":\"⤂\",\"nvle\":\"≤⃒\",\"nvlt\":\"<⃒\",\"nvltrie\":\"⊴⃒\",\"nvrArr\":\"⤃\",\"nvrtrie\":\"⊵⃒\",\"nvsim\":\"∼⃒\",\"nwarhk\":\"⤣\",\"nwarr\":\"↖\",\"nwArr\":\"⇖\",\"nwarrow\":\"↖\",\"nwnear\":\"⤧\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"oast\":\"⊛\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"ocir\":\"⊚\",\"Ocy\":\"О\",\"ocy\":\"о\",\"odash\":\"⊝\",\"Odblac\":\"Ő\",\"odblac\":\"ő\",\"odiv\":\"⨸\",\"odot\":\"⊙\",\"odsold\":\"⦼\",\"OElig\":\"Œ\",\"oelig\":\"œ\",\"ofcir\":\"⦿\",\"Ofr\":\"𝔒\",\"ofr\":\"𝔬\",\"ogon\":\"˛\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ogt\":\"⧁\",\"ohbar\":\"⦵\",\"ohm\":\"Ω\",\"oint\":\"∮\",\"olarr\":\"↺\",\"olcir\":\"⦾\",\"olcross\":\"⦻\",\"oline\":\"‾\",\"olt\":\"⧀\",\"Omacr\":\"Ō\",\"omacr\":\"ō\",\"Omega\":\"Ω\",\"omega\":\"ω\",\"Omicron\":\"Ο\",\"omicron\":\"ο\",\"omid\":\"⦶\",\"ominus\":\"⊖\",\"Oopf\":\"𝕆\",\"oopf\":\"𝕠\",\"opar\":\"⦷\",\"OpenCurlyDoubleQuote\":\"“\",\"OpenCurlyQuote\":\"‘\",\"operp\":\"⦹\",\"oplus\":\"⊕\",\"orarr\":\"↻\",\"Or\":\"⩔\",\"or\":\"∨\",\"ord\":\"⩝\",\"order\":\"ℴ\",\"orderof\":\"ℴ\",\"ordf\":\"ª\",\"ordm\":\"º\",\"origof\":\"⊶\",\"oror\":\"⩖\",\"orslope\":\"⩗\",\"orv\":\"⩛\",\"oS\":\"Ⓢ\",\"Oscr\":\"𝒪\",\"oscr\":\"ℴ\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"osol\":\"⊘\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"otimesas\":\"⨶\",\"Otimes\":\"⨷\",\"otimes\":\"⊗\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"ovbar\":\"⌽\",\"OverBar\":\"‾\",\"OverBrace\":\"⏞\",\"OverBracket\":\"⎴\",\"OverParenthesis\":\"⏜\",\"para\":\"¶\",\"parallel\":\"∥\",\"par\":\"∥\",\"parsim\":\"⫳\",\"parsl\":\"⫽\",\"part\":\"∂\",\"PartialD\":\"∂\",\"Pcy\":\"П\",\"pcy\":\"п\",\"percnt\":\"%\",\"period\":\".\",\"permil\":\"‰\",\"perp\":\"⊥\",\"pertenk\":\"‱\",\"Pfr\":\"𝔓\",\"pfr\":\"𝔭\",\"Phi\":\"Φ\",\"phi\":\"φ\",\"phiv\":\"ϕ\",\"phmmat\":\"ℳ\",\"phone\":\"☎\",\"Pi\":\"Π\",\"pi\":\"π\",\"pitchfork\":\"⋔\",\"piv\":\"ϖ\",\"planck\":\"ℏ\",\"planckh\":\"ℎ\",\"plankv\":\"ℏ\",\"plusacir\":\"⨣\",\"plusb\":\"⊞\",\"pluscir\":\"⨢\",\"plus\":\"+\",\"plusdo\":\"∔\",\"plusdu\":\"⨥\",\"pluse\":\"⩲\",\"PlusMinus\":\"±\",\"plusmn\":\"±\",\"plussim\":\"⨦\",\"plustwo\":\"⨧\",\"pm\":\"±\",\"Poincareplane\":\"ℌ\",\"pointint\":\"⨕\",\"popf\":\"𝕡\",\"Popf\":\"ℙ\",\"pound\":\"£\",\"prap\":\"⪷\",\"Pr\":\"⪻\",\"pr\":\"≺\",\"prcue\":\"≼\",\"precapprox\":\"⪷\",\"prec\":\"≺\",\"preccurlyeq\":\"≼\",\"Precedes\":\"≺\",\"PrecedesEqual\":\"⪯\",\"PrecedesSlantEqual\":\"≼\",\"PrecedesTilde\":\"≾\",\"preceq\":\"⪯\",\"precnapprox\":\"⪹\",\"precneqq\":\"⪵\",\"precnsim\":\"⋨\",\"pre\":\"⪯\",\"prE\":\"⪳\",\"precsim\":\"≾\",\"prime\":\"′\",\"Prime\":\"″\",\"primes\":\"ℙ\",\"prnap\":\"⪹\",\"prnE\":\"⪵\",\"prnsim\":\"⋨\",\"prod\":\"∏\",\"Product\":\"∏\",\"profalar\":\"⌮\",\"profline\":\"⌒\",\"profsurf\":\"⌓\",\"prop\":\"∝\",\"Proportional\":\"∝\",\"Proportion\":\"∷\",\"propto\":\"∝\",\"prsim\":\"≾\",\"prurel\":\"⊰\",\"Pscr\":\"𝒫\",\"pscr\":\"𝓅\",\"Psi\":\"Ψ\",\"psi\":\"ψ\",\"puncsp\":\" \",\"Qfr\":\"𝔔\",\"qfr\":\"𝔮\",\"qint\":\"⨌\",\"qopf\":\"𝕢\",\"Qopf\":\"ℚ\",\"qprime\":\"⁗\",\"Qscr\":\"𝒬\",\"qscr\":\"𝓆\",\"quaternions\":\"ℍ\",\"quatint\":\"⨖\",\"quest\":\"?\",\"questeq\":\"≟\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"rAarr\":\"⇛\",\"race\":\"∽̱\",\"Racute\":\"Ŕ\",\"racute\":\"ŕ\",\"radic\":\"√\",\"raemptyv\":\"⦳\",\"rang\":\"⟩\",\"Rang\":\"⟫\",\"rangd\":\"⦒\",\"range\":\"⦥\",\"rangle\":\"⟩\",\"raquo\":\"»\",\"rarrap\":\"⥵\",\"rarrb\":\"⇥\",\"rarrbfs\":\"⤠\",\"rarrc\":\"⤳\",\"rarr\":\"→\",\"Rarr\":\"↠\",\"rArr\":\"⇒\",\"rarrfs\":\"⤞\",\"rarrhk\":\"↪\",\"rarrlp\":\"↬\",\"rarrpl\":\"⥅\",\"rarrsim\":\"⥴\",\"Rarrtl\":\"⤖\",\"rarrtl\":\"↣\",\"rarrw\":\"↝\",\"ratail\":\"⤚\",\"rAtail\":\"⤜\",\"ratio\":\"∶\",\"rationals\":\"ℚ\",\"rbarr\":\"⤍\",\"rBarr\":\"⤏\",\"RBarr\":\"⤐\",\"rbbrk\":\"❳\",\"rbrace\":\"}\",\"rbrack\":\"]\",\"rbrke\":\"⦌\",\"rbrksld\":\"⦎\",\"rbrkslu\":\"⦐\",\"Rcaron\":\"Ř\",\"rcaron\":\"ř\",\"Rcedil\":\"Ŗ\",\"rcedil\":\"ŗ\",\"rceil\":\"⌉\",\"rcub\":\"}\",\"Rcy\":\"Р\",\"rcy\":\"р\",\"rdca\":\"⤷\",\"rdldhar\":\"⥩\",\"rdquo\":\"”\",\"rdquor\":\"”\",\"rdsh\":\"↳\",\"real\":\"ℜ\",\"realine\":\"ℛ\",\"realpart\":\"ℜ\",\"reals\":\"ℝ\",\"Re\":\"ℜ\",\"rect\":\"▭\",\"reg\":\"®\",\"REG\":\"®\",\"ReverseElement\":\"∋\",\"ReverseEquilibrium\":\"⇋\",\"ReverseUpEquilibrium\":\"⥯\",\"rfisht\":\"⥽\",\"rfloor\":\"⌋\",\"rfr\":\"𝔯\",\"Rfr\":\"ℜ\",\"rHar\":\"⥤\",\"rhard\":\"⇁\",\"rharu\":\"⇀\",\"rharul\":\"⥬\",\"Rho\":\"Ρ\",\"rho\":\"ρ\",\"rhov\":\"ϱ\",\"RightAngleBracket\":\"⟩\",\"RightArrowBar\":\"⇥\",\"rightarrow\":\"→\",\"RightArrow\":\"→\",\"Rightarrow\":\"⇒\",\"RightArrowLeftArrow\":\"⇄\",\"rightarrowtail\":\"↣\",\"RightCeiling\":\"⌉\",\"RightDoubleBracket\":\"⟧\",\"RightDownTeeVector\":\"⥝\",\"RightDownVectorBar\":\"⥕\",\"RightDownVector\":\"⇂\",\"RightFloor\":\"⌋\",\"rightharpoondown\":\"⇁\",\"rightharpoonup\":\"⇀\",\"rightleftarrows\":\"⇄\",\"rightleftharpoons\":\"⇌\",\"rightrightarrows\":\"⇉\",\"rightsquigarrow\":\"↝\",\"RightTeeArrow\":\"↦\",\"RightTee\":\"⊢\",\"RightTeeVector\":\"⥛\",\"rightthreetimes\":\"⋌\",\"RightTriangleBar\":\"⧐\",\"RightTriangle\":\"⊳\",\"RightTriangleEqual\":\"⊵\",\"RightUpDownVector\":\"⥏\",\"RightUpTeeVector\":\"⥜\",\"RightUpVectorBar\":\"⥔\",\"RightUpVector\":\"↾\",\"RightVectorBar\":\"⥓\",\"RightVector\":\"⇀\",\"ring\":\"˚\",\"risingdotseq\":\"≓\",\"rlarr\":\"⇄\",\"rlhar\":\"⇌\",\"rlm\":\"‏\",\"rmoustache\":\"⎱\",\"rmoust\":\"⎱\",\"rnmid\":\"⫮\",\"roang\":\"⟭\",\"roarr\":\"⇾\",\"robrk\":\"⟧\",\"ropar\":\"⦆\",\"ropf\":\"𝕣\",\"Ropf\":\"ℝ\",\"roplus\":\"⨮\",\"rotimes\":\"⨵\",\"RoundImplies\":\"⥰\",\"rpar\":\")\",\"rpargt\":\"⦔\",\"rppolint\":\"⨒\",\"rrarr\":\"⇉\",\"Rrightarrow\":\"⇛\",\"rsaquo\":\"›\",\"rscr\":\"𝓇\",\"Rscr\":\"ℛ\",\"rsh\":\"↱\",\"Rsh\":\"↱\",\"rsqb\":\"]\",\"rsquo\":\"’\",\"rsquor\":\"’\",\"rthree\":\"⋌\",\"rtimes\":\"⋊\",\"rtri\":\"▹\",\"rtrie\":\"⊵\",\"rtrif\":\"▸\",\"rtriltri\":\"⧎\",\"RuleDelayed\":\"⧴\",\"ruluhar\":\"⥨\",\"rx\":\"℞\",\"Sacute\":\"Ś\",\"sacute\":\"ś\",\"sbquo\":\"‚\",\"scap\":\"⪸\",\"Scaron\":\"Š\",\"scaron\":\"š\",\"Sc\":\"⪼\",\"sc\":\"≻\",\"sccue\":\"≽\",\"sce\":\"⪰\",\"scE\":\"⪴\",\"Scedil\":\"Ş\",\"scedil\":\"ş\",\"Scirc\":\"Ŝ\",\"scirc\":\"ŝ\",\"scnap\":\"⪺\",\"scnE\":\"⪶\",\"scnsim\":\"⋩\",\"scpolint\":\"⨓\",\"scsim\":\"≿\",\"Scy\":\"С\",\"scy\":\"с\",\"sdotb\":\"⊡\",\"sdot\":\"⋅\",\"sdote\":\"⩦\",\"searhk\":\"⤥\",\"searr\":\"↘\",\"seArr\":\"⇘\",\"searrow\":\"↘\",\"sect\":\"§\",\"semi\":\";\",\"seswar\":\"⤩\",\"setminus\":\"∖\",\"setmn\":\"∖\",\"sext\":\"✶\",\"Sfr\":\"𝔖\",\"sfr\":\"𝔰\",\"sfrown\":\"⌢\",\"sharp\":\"♯\",\"SHCHcy\":\"Щ\",\"shchcy\":\"щ\",\"SHcy\":\"Ш\",\"shcy\":\"ш\",\"ShortDownArrow\":\"↓\",\"ShortLeftArrow\":\"←\",\"shortmid\":\"∣\",\"shortparallel\":\"∥\",\"ShortRightArrow\":\"→\",\"ShortUpArrow\":\"↑\",\"shy\":\"­\",\"Sigma\":\"Σ\",\"sigma\":\"σ\",\"sigmaf\":\"ς\",\"sigmav\":\"ς\",\"sim\":\"∼\",\"simdot\":\"⩪\",\"sime\":\"≃\",\"simeq\":\"≃\",\"simg\":\"⪞\",\"simgE\":\"⪠\",\"siml\":\"⪝\",\"simlE\":\"⪟\",\"simne\":\"≆\",\"simplus\":\"⨤\",\"simrarr\":\"⥲\",\"slarr\":\"←\",\"SmallCircle\":\"∘\",\"smallsetminus\":\"∖\",\"smashp\":\"⨳\",\"smeparsl\":\"⧤\",\"smid\":\"∣\",\"smile\":\"⌣\",\"smt\":\"⪪\",\"smte\":\"⪬\",\"smtes\":\"⪬︀\",\"SOFTcy\":\"Ь\",\"softcy\":\"ь\",\"solbar\":\"⌿\",\"solb\":\"⧄\",\"sol\":\"/\",\"Sopf\":\"𝕊\",\"sopf\":\"𝕤\",\"spades\":\"♠\",\"spadesuit\":\"♠\",\"spar\":\"∥\",\"sqcap\":\"⊓\",\"sqcaps\":\"⊓︀\",\"sqcup\":\"⊔\",\"sqcups\":\"⊔︀\",\"Sqrt\":\"√\",\"sqsub\":\"⊏\",\"sqsube\":\"⊑\",\"sqsubset\":\"⊏\",\"sqsubseteq\":\"⊑\",\"sqsup\":\"⊐\",\"sqsupe\":\"⊒\",\"sqsupset\":\"⊐\",\"sqsupseteq\":\"⊒\",\"square\":\"□\",\"Square\":\"□\",\"SquareIntersection\":\"⊓\",\"SquareSubset\":\"⊏\",\"SquareSubsetEqual\":\"⊑\",\"SquareSuperset\":\"⊐\",\"SquareSupersetEqual\":\"⊒\",\"SquareUnion\":\"⊔\",\"squarf\":\"▪\",\"squ\":\"□\",\"squf\":\"▪\",\"srarr\":\"→\",\"Sscr\":\"𝒮\",\"sscr\":\"𝓈\",\"ssetmn\":\"∖\",\"ssmile\":\"⌣\",\"sstarf\":\"⋆\",\"Star\":\"⋆\",\"star\":\"☆\",\"starf\":\"★\",\"straightepsilon\":\"ϵ\",\"straightphi\":\"ϕ\",\"strns\":\"¯\",\"sub\":\"⊂\",\"Sub\":\"⋐\",\"subdot\":\"⪽\",\"subE\":\"⫅\",\"sube\":\"⊆\",\"subedot\":\"⫃\",\"submult\":\"⫁\",\"subnE\":\"⫋\",\"subne\":\"⊊\",\"subplus\":\"⪿\",\"subrarr\":\"⥹\",\"subset\":\"⊂\",\"Subset\":\"⋐\",\"subseteq\":\"⊆\",\"subseteqq\":\"⫅\",\"SubsetEqual\":\"⊆\",\"subsetneq\":\"⊊\",\"subsetneqq\":\"⫋\",\"subsim\":\"⫇\",\"subsub\":\"⫕\",\"subsup\":\"⫓\",\"succapprox\":\"⪸\",\"succ\":\"≻\",\"succcurlyeq\":\"≽\",\"Succeeds\":\"≻\",\"SucceedsEqual\":\"⪰\",\"SucceedsSlantEqual\":\"≽\",\"SucceedsTilde\":\"≿\",\"succeq\":\"⪰\",\"succnapprox\":\"⪺\",\"succneqq\":\"⪶\",\"succnsim\":\"⋩\",\"succsim\":\"≿\",\"SuchThat\":\"∋\",\"sum\":\"∑\",\"Sum\":\"∑\",\"sung\":\"♪\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"sup\":\"⊃\",\"Sup\":\"⋑\",\"supdot\":\"⪾\",\"supdsub\":\"⫘\",\"supE\":\"⫆\",\"supe\":\"⊇\",\"supedot\":\"⫄\",\"Superset\":\"⊃\",\"SupersetEqual\":\"⊇\",\"suphsol\":\"⟉\",\"suphsub\":\"⫗\",\"suplarr\":\"⥻\",\"supmult\":\"⫂\",\"supnE\":\"⫌\",\"supne\":\"⊋\",\"supplus\":\"⫀\",\"supset\":\"⊃\",\"Supset\":\"⋑\",\"supseteq\":\"⊇\",\"supseteqq\":\"⫆\",\"supsetneq\":\"⊋\",\"supsetneqq\":\"⫌\",\"supsim\":\"⫈\",\"supsub\":\"⫔\",\"supsup\":\"⫖\",\"swarhk\":\"⤦\",\"swarr\":\"↙\",\"swArr\":\"⇙\",\"swarrow\":\"↙\",\"swnwar\":\"⤪\",\"szlig\":\"ß\",\"Tab\":\"\\t\",\"target\":\"⌖\",\"Tau\":\"Τ\",\"tau\":\"τ\",\"tbrk\":\"⎴\",\"Tcaron\":\"Ť\",\"tcaron\":\"ť\",\"Tcedil\":\"Ţ\",\"tcedil\":\"ţ\",\"Tcy\":\"Т\",\"tcy\":\"т\",\"tdot\":\"⃛\",\"telrec\":\"⌕\",\"Tfr\":\"𝔗\",\"tfr\":\"𝔱\",\"there4\":\"∴\",\"therefore\":\"∴\",\"Therefore\":\"∴\",\"Theta\":\"Θ\",\"theta\":\"θ\",\"thetasym\":\"ϑ\",\"thetav\":\"ϑ\",\"thickapprox\":\"≈\",\"thicksim\":\"∼\",\"ThickSpace\":\"  \",\"ThinSpace\":\" \",\"thinsp\":\" \",\"thkap\":\"≈\",\"thksim\":\"∼\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"tilde\":\"˜\",\"Tilde\":\"∼\",\"TildeEqual\":\"≃\",\"TildeFullEqual\":\"≅\",\"TildeTilde\":\"≈\",\"timesbar\":\"⨱\",\"timesb\":\"⊠\",\"times\":\"×\",\"timesd\":\"⨰\",\"tint\":\"∭\",\"toea\":\"⤨\",\"topbot\":\"⌶\",\"topcir\":\"⫱\",\"top\":\"⊤\",\"Topf\":\"𝕋\",\"topf\":\"𝕥\",\"topfork\":\"⫚\",\"tosa\":\"⤩\",\"tprime\":\"‴\",\"trade\":\"™\",\"TRADE\":\"™\",\"triangle\":\"▵\",\"triangledown\":\"▿\",\"triangleleft\":\"◃\",\"trianglelefteq\":\"⊴\",\"triangleq\":\"≜\",\"triangleright\":\"▹\",\"trianglerighteq\":\"⊵\",\"tridot\":\"◬\",\"trie\":\"≜\",\"triminus\":\"⨺\",\"TripleDot\":\"⃛\",\"triplus\":\"⨹\",\"trisb\":\"⧍\",\"tritime\":\"⨻\",\"trpezium\":\"⏢\",\"Tscr\":\"𝒯\",\"tscr\":\"𝓉\",\"TScy\":\"Ц\",\"tscy\":\"ц\",\"TSHcy\":\"Ћ\",\"tshcy\":\"ћ\",\"Tstrok\":\"Ŧ\",\"tstrok\":\"ŧ\",\"twixt\":\"≬\",\"twoheadleftarrow\":\"↞\",\"twoheadrightarrow\":\"↠\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"uarr\":\"↑\",\"Uarr\":\"↟\",\"uArr\":\"⇑\",\"Uarrocir\":\"⥉\",\"Ubrcy\":\"Ў\",\"ubrcy\":\"ў\",\"Ubreve\":\"Ŭ\",\"ubreve\":\"ŭ\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ucy\":\"У\",\"ucy\":\"у\",\"udarr\":\"⇅\",\"Udblac\":\"Ű\",\"udblac\":\"ű\",\"udhar\":\"⥮\",\"ufisht\":\"⥾\",\"Ufr\":\"𝔘\",\"ufr\":\"𝔲\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uHar\":\"⥣\",\"uharl\":\"↿\",\"uharr\":\"↾\",\"uhblk\":\"▀\",\"ulcorn\":\"⌜\",\"ulcorner\":\"⌜\",\"ulcrop\":\"⌏\",\"ultri\":\"◸\",\"Umacr\":\"Ū\",\"umacr\":\"ū\",\"uml\":\"¨\",\"UnderBar\":\"_\",\"UnderBrace\":\"⏟\",\"UnderBracket\":\"⎵\",\"UnderParenthesis\":\"⏝\",\"Union\":\"⋃\",\"UnionPlus\":\"⊎\",\"Uogon\":\"Ų\",\"uogon\":\"ų\",\"Uopf\":\"𝕌\",\"uopf\":\"𝕦\",\"UpArrowBar\":\"⤒\",\"uparrow\":\"↑\",\"UpArrow\":\"↑\",\"Uparrow\":\"⇑\",\"UpArrowDownArrow\":\"⇅\",\"updownarrow\":\"↕\",\"UpDownArrow\":\"↕\",\"Updownarrow\":\"⇕\",\"UpEquilibrium\":\"⥮\",\"upharpoonleft\":\"↿\",\"upharpoonright\":\"↾\",\"uplus\":\"⊎\",\"UpperLeftArrow\":\"↖\",\"UpperRightArrow\":\"↗\",\"upsi\":\"υ\",\"Upsi\":\"ϒ\",\"upsih\":\"ϒ\",\"Upsilon\":\"Υ\",\"upsilon\":\"υ\",\"UpTeeArrow\":\"↥\",\"UpTee\":\"⊥\",\"upuparrows\":\"⇈\",\"urcorn\":\"⌝\",\"urcorner\":\"⌝\",\"urcrop\":\"⌎\",\"Uring\":\"Ů\",\"uring\":\"ů\",\"urtri\":\"◹\",\"Uscr\":\"𝒰\",\"uscr\":\"𝓊\",\"utdot\":\"⋰\",\"Utilde\":\"Ũ\",\"utilde\":\"ũ\",\"utri\":\"▵\",\"utrif\":\"▴\",\"uuarr\":\"⇈\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"uwangle\":\"⦧\",\"vangrt\":\"⦜\",\"varepsilon\":\"ϵ\",\"varkappa\":\"ϰ\",\"varnothing\":\"∅\",\"varphi\":\"ϕ\",\"varpi\":\"ϖ\",\"varpropto\":\"∝\",\"varr\":\"↕\",\"vArr\":\"⇕\",\"varrho\":\"ϱ\",\"varsigma\":\"ς\",\"varsubsetneq\":\"⊊︀\",\"varsubsetneqq\":\"⫋︀\",\"varsupsetneq\":\"⊋︀\",\"varsupsetneqq\":\"⫌︀\",\"vartheta\":\"ϑ\",\"vartriangleleft\":\"⊲\",\"vartriangleright\":\"⊳\",\"vBar\":\"⫨\",\"Vbar\":\"⫫\",\"vBarv\":\"⫩\",\"Vcy\":\"В\",\"vcy\":\"в\",\"vdash\":\"⊢\",\"vDash\":\"⊨\",\"Vdash\":\"⊩\",\"VDash\":\"⊫\",\"Vdashl\":\"⫦\",\"veebar\":\"⊻\",\"vee\":\"∨\",\"Vee\":\"⋁\",\"veeeq\":\"≚\",\"vellip\":\"⋮\",\"verbar\":\"|\",\"Verbar\":\"‖\",\"vert\":\"|\",\"Vert\":\"‖\",\"VerticalBar\":\"∣\",\"VerticalLine\":\"|\",\"VerticalSeparator\":\"❘\",\"VerticalTilde\":\"≀\",\"VeryThinSpace\":\" \",\"Vfr\":\"𝔙\",\"vfr\":\"𝔳\",\"vltri\":\"⊲\",\"vnsub\":\"⊂⃒\",\"vnsup\":\"⊃⃒\",\"Vopf\":\"𝕍\",\"vopf\":\"𝕧\",\"vprop\":\"∝\",\"vrtri\":\"⊳\",\"Vscr\":\"𝒱\",\"vscr\":\"𝓋\",\"vsubnE\":\"⫋︀\",\"vsubne\":\"⊊︀\",\"vsupnE\":\"⫌︀\",\"vsupne\":\"⊋︀\",\"Vvdash\":\"⊪\",\"vzigzag\":\"⦚\",\"Wcirc\":\"Ŵ\",\"wcirc\":\"ŵ\",\"wedbar\":\"⩟\",\"wedge\":\"∧\",\"Wedge\":\"⋀\",\"wedgeq\":\"≙\",\"weierp\":\"℘\",\"Wfr\":\"𝔚\",\"wfr\":\"𝔴\",\"Wopf\":\"𝕎\",\"wopf\":\"𝕨\",\"wp\":\"℘\",\"wr\":\"≀\",\"wreath\":\"≀\",\"Wscr\":\"𝒲\",\"wscr\":\"𝓌\",\"xcap\":\"⋂\",\"xcirc\":\"◯\",\"xcup\":\"⋃\",\"xdtri\":\"▽\",\"Xfr\":\"𝔛\",\"xfr\":\"𝔵\",\"xharr\":\"⟷\",\"xhArr\":\"⟺\",\"Xi\":\"Ξ\",\"xi\":\"ξ\",\"xlarr\":\"⟵\",\"xlArr\":\"⟸\",\"xmap\":\"⟼\",\"xnis\":\"⋻\",\"xodot\":\"⨀\",\"Xopf\":\"𝕏\",\"xopf\":\"𝕩\",\"xoplus\":\"⨁\",\"xotime\":\"⨂\",\"xrarr\":\"⟶\",\"xrArr\":\"⟹\",\"Xscr\":\"𝒳\",\"xscr\":\"𝓍\",\"xsqcup\":\"⨆\",\"xuplus\":\"⨄\",\"xutri\":\"△\",\"xvee\":\"⋁\",\"xwedge\":\"⋀\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"YAcy\":\"Я\",\"yacy\":\"я\",\"Ycirc\":\"Ŷ\",\"ycirc\":\"ŷ\",\"Ycy\":\"Ы\",\"ycy\":\"ы\",\"yen\":\"¥\",\"Yfr\":\"𝔜\",\"yfr\":\"𝔶\",\"YIcy\":\"Ї\",\"yicy\":\"ї\",\"Yopf\":\"𝕐\",\"yopf\":\"𝕪\",\"Yscr\":\"𝒴\",\"yscr\":\"𝓎\",\"YUcy\":\"Ю\",\"yucy\":\"ю\",\"yuml\":\"ÿ\",\"Yuml\":\"Ÿ\",\"Zacute\":\"Ź\",\"zacute\":\"ź\",\"Zcaron\":\"Ž\",\"zcaron\":\"ž\",\"Zcy\":\"З\",\"zcy\":\"з\",\"Zdot\":\"Ż\",\"zdot\":\"ż\",\"zeetrf\":\"ℨ\",\"ZeroWidthSpace\":\"​\",\"Zeta\":\"Ζ\",\"zeta\":\"ζ\",\"zfr\":\"𝔷\",\"Zfr\":\"ℨ\",\"ZHcy\":\"Ж\",\"zhcy\":\"ж\",\"zigrarr\":\"⇝\",\"zopf\":\"𝕫\",\"Zopf\":\"ℤ\",\"Zscr\":\"𝒵\",\"zscr\":\"𝓏\",\"zwj\":\"‍\",\"zwnj\":\"‌\"}");

/***/ }),

/***/ "8WCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export catalogToState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return facetingReducer; });
/* unused harmony export filtersToActiveFacetsState */
/* unused harmony export filtersToState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTotalLabelsCount; });
/* unused harmony export initialState */
/* unused harmony export PERTIMM_DEPARTURE_MAX_DATE */
/* unused harmony export PERTIMM_DEPARTURE_MIN_DATE */
/* unused harmony export removeUnselectedFiltersFromActiveFacetsState */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_to_primitive__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("gqY9");
/* harmony import */ var core_js_modules_es_symbol_to_primitive__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_to_primitive__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_date_to_primitive__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("HUPx");
/* harmony import */ var core_js_modules_es_date_to_primitive__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_date_to_primitive__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("zjfJ");
/* harmony import */ var entities__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("4oK2");
/* harmony import */ var entities__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(entities__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("L73y");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("kNiU");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("cvSI");
/* harmony import */ var _utils_createReducer__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("4Bi9");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__("9QcM");






























var _createReducer;

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var IGNORED_FILTERS_IDS = [_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* PRODUCT_FACET_ID */ "B"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* LOCALE_FACET_ID */ "v"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* COUNTRIES_FACET_ID */ "e"]];

function catalogFacetItemToState(item) {
  return {
    label: item.i18n,
    value: item.filter,
    count: item.freq
  };
} // Pertimm will always send `interpretation_explanation.interpretations` dates
// in the format 'DD/MM/YYYY', for any locale


var PERTIMM_INTERPRETATION_DATE_FORMAT = 'DD/MM/YYYY';
var PERTIMM_DEPARTURE_MIN_DATE = 'departure_date_min';
var PERTIMM_DEPARTURE_MAX_DATE = 'departure_date_max';
/**
 * Takes the Pertimm catalog of facets and restructure it before storage in redux store.
 */

function catalogToState() {
  var catalogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacets = arguments.length > 1 ? arguments[1] : undefined;
  var completeCountriesFacetAsTree = arguments.length > 2 ? arguments[2] : undefined;
  var facetingTopCountries = arguments.length > 3 ? arguments[3] : undefined;
  var catalogIdsAsList = [_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* CHILDCARE_FACET_ID */ "d"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* COUNTRIES_FACET_ID */ "e"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* DEPARTURE_CITY_FACET_ID */ "i"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* DURATION_FACET */ "o"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* FACET_COMFORT_ID */ "p"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* TYPES_OF_STAY_FACET_ID */ "E"]];
  var catalogIdsAsTree = [_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* ACTIVITIES_FACET_ID */ "a"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* DESTINATIONS_FACET_ID */ "n"]];
  var facetsAsList = catalogs.filter(function (catalog) {
    return catalogIdsAsList.includes(catalog.id);
  }).map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        list = _ref.list;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: list.map(catalogFacetItemToState)
    };
  });
  var facetsAsTree = catalogs.filter(function (catalog) {
    return catalogIdsAsTree.includes(catalog.id);
  }).map(function (_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        tree = _ref2.tree;
    return {
      id: id,
      name: name,
      // $FlowFixMe
      list: tree.map(function (list) {
        return _objectSpread(_objectSpread({
          id: list.name
        }, catalogFacetItemToState(list)), {}, {
          list: list.tree.map(catalogFacetItemToState)
        });
      })
    };
  });

  var _facetsAsList$filter = facetsAsList.filter(function (_ref3) {
    var id = _ref3.id;
    return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* COUNTRIES_FACET_ID */ "e"];
  }),
      _facetsAsList$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsAsList$filter, 1),
      countriesFacetAsList = _facetsAsList$filter2[0];

  var _facetsAsTree$filter = facetsAsTree.filter(function (_ref4) {
    var id = _ref4.id;
    return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* DESTINATIONS_FACET_ID */ "n"];
  }),
      _facetsAsTree$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facetsAsTree$filter, 1),
      destinationsFacetAsTree = _facetsAsTree$filter2[0];

  var topCountriesFacetAsList = getTopCountriesFacetList(facetingTopCountries, countriesFacetAsList);
  var countriesFacetAsTree = countriesFacetAsList && destinationsFacetAsTree ? getCountriesFacetAsTree(activeFacets, completeCountriesFacetAsTree, countriesFacetAsList, destinationsFacetAsTree, topCountriesFacetAsList) : null;
  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(facetsAsList.map(function (facet) {
    return facet.id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* COUNTRIES_FACET_ID */ "e"] ? countriesFacetAsTree : facet;
  }).filter(Boolean)), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(facetsAsTree));
}

function filtersToActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return filters.reduce(function (acc, filter) {
    var categoryId = filter.id;

    if (_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* FILTERABLE_FACETS_IDS */ "q"].includes(categoryId)) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])({}, categoryId, _objectSpread(_objectSpread({}, acc[categoryId]), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])({}, filter.value, true))));
    }

    return acc;
  }, {});
}

function sanitizeFilters(filters) {
  return filters.filter(function (filter) {
    return !Object(lodash__WEBPACK_IMPORTED_MODULE_30__["includes"])(IGNORED_FILTERS_IDS, Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(filter, 'id'));
  });
}

function sanitizeLabel(label) {
  return label ? label.toLowerCase().replace(/\s+/g, '') : '';
}

function sanitizeValue(value) {
  return value ? value.toUpperCase().replace(/\s+/g, '') : '';
}

function removeDuplicateCountries(countryList) {
  var countryLabels = {};
  return countryList.reduce(function (result, country) {
    var label = sanitizeLabel(country.label);

    if (!countryLabels[label]) {
      countryLabels[label] = _objectSpread({}, country);
      result.push(countryLabels[label]);
    }

    return result;
  }, []);
}

function trimLabel(label) {
  return label ? label.trim() : '';
}

function filtersToState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return sanitizeFilters(filters).map(function (filter) {
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(filter, 'id'),
      name: Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(filter, 'value'),
      label: Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(filter, 'value_i18n'),
      selected: true
    };
  });
}

function getCountriesFacetAsTree(activeFacets, completeCountriesFacetAsTree, countriesFacetAsList, destinationsFacetAsTree, topCountriesFacetAsList) {
  var destinationsActiveFacets = activeFacets[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* DESTINATIONS_FACET_ID */ "n"]];
  var initialValueForCountriesFacetAsTree = completeCountriesFacetAsTree && completeCountriesFacetAsTree.list.length >= destinationsFacetAsTree.list.length ? completeCountriesFacetAsTree : _objectSpread(_objectSpread({}, destinationsFacetAsTree), {}, {
    id: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* COUNTRIES_FACET_ID */ "e"]
  });
  return _objectSpread(_objectSpread({}, initialValueForCountriesFacetAsTree), {}, {
    list: [topCountriesFacetAsList].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(initialValueForCountriesFacetAsTree.list.map(function (region) {
      var _destinationsFacetAsT, _completeCountriesFac;

      var regionLabel = region.label,
          value = region.value; // Retrieve updated data for the current region in destinationsFacetAsTree

      var destinationsFacetRegion = destinationsFacetAsTree === null || destinationsFacetAsTree === void 0 ? void 0 : (_destinationsFacetAsT = destinationsFacetAsTree.list) === null || _destinationsFacetAsT === void 0 ? void 0 : _destinationsFacetAsT.find(function (_ref5) {
        var regionLabelFromTree = _ref5.label;
        return sanitizeLabel(regionLabel) === sanitizeLabel(regionLabelFromTree);
      }); // Check if there are region filters selected, if there are but the current region is not in the active filters, remove it

      if (destinationsActiveFacets && !destinationsActiveFacets[value]) {
        return null;
      } // Retrieve stored data for the current region in completeCountriesFacetRegion


      var completeCountriesFacetRegion = completeCountriesFacetAsTree === null || completeCountriesFacetAsTree === void 0 ? void 0 : (_completeCountriesFac = completeCountriesFacetAsTree.list) === null || _completeCountriesFac === void 0 ? void 0 : _completeCountriesFac.find(function (_ref6) {
        var regionLabelFromTree = _ref6.label;
        return sanitizeLabel(regionLabel) === sanitizeLabel(regionLabelFromTree);
      });
      var completeCountriesFacetRegionList = (completeCountriesFacetRegion === null || completeCountriesFacetRegion === void 0 ? void 0 : completeCountriesFacetRegion.list) || [];
      var destinationsFacetRegionList = (destinationsFacetRegion === null || destinationsFacetRegion === void 0 ? void 0 : destinationsFacetRegion.list) || []; // Keep stored data if it's country list is bigger than the updated data

      var list = completeCountriesFacetRegionList.length > destinationsFacetRegionList.length ? completeCountriesFacetRegionList : destinationsFacetRegionList;
      return _objectSpread(_objectSpread({}, region), {}, {
        label: trimLabel(regionLabel),
        list: removeDuplicateCountries(list.map(function (country) {
          var countryLabel = country.label; // Retrieve updated data for the current country in countriesFacetAsList

          var countriesFacetCountry = countriesFacetAsList.list.find(function (_ref7) {
            var countryLabelFromList = _ref7.label;
            return sanitizeLabel(countryLabel) === sanitizeLabel(countryLabelFromList);
          }); // Update current country's data if it is in countriesFacetAsList, otherwise remove it

          return countriesFacetCountry ? _objectSpread(_objectSpread({}, country), {}, {
            count: countriesFacetCountry.count,
            label: trimLabel(countriesFacetCountry.label),
            value: countriesFacetCountry.value
          }) : null;
        }).filter(Boolean))
      });
    }).filter(Boolean).filter(function (_ref8) {
      var id = _ref8.id;
      return id !== _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* TOP_COUNTRIES_FACET_LIST_ID */ "D"];
    }))).filter(Boolean).filter(function (_ref9) {
      var list = _ref9.list;
      return list && list.length > 0;
    })
  });
}

function getTopCountriesFacetList(facetingTopCountries, countriesFacetAsList) {
  var topCountries = facetingTopCountries.enabled ? facetingTopCountries.items.map(function (_ref10) {
    var id = _ref10.id;
    return id;
  }) : [];
  var topCountriesList = countriesFacetAsList && countriesFacetAsList.list ? topCountries.map(function (countryCode) {
    return countriesFacetAsList.list.find(function (_ref11) {
      var value = _ref11.value;
      return sanitizeValue(value) === countryCode;
    });
  }).filter(Boolean) : [];
  return topCountriesList.length > 0 ? {
    count: topCountriesList.reduce(function (result, country) {
      return country && country.count ? result + parseInt(country.count, 10) : result;
    }, 0).toString(),
    id: _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* TOP_COUNTRIES_FACET_LIST_ID */ "D"],
    label: trimLabel(facetingTopCountries.title),
    list: removeDuplicateCountries(topCountriesList.map(function (country) {
      return _objectSpread(_objectSpread({}, country), {}, {
        label: trimLabel(country.label)
      });
    })),
    value: facetingTopCountries.title
  } : null;
}

function getTotalLabelsCount(facet) {
  return facet.list.reduce(function (result, facetList) {
    return facetList && facetList.list ? result + facetList.list.length : result;
  }, 0);
}

function parseBanners() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  try {
    return banners.map(function (banner) {
      return _objectSpread(_objectSpread({}, banner), {}, {
        content: JSON.parse(banner.content)
      });
    });
  } catch (e) {
    return [];
  }
}

function removeUnselectedFiltersFromActiveFacetsState() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activeFacetsState = arguments.length > 1 ? arguments[1] : undefined;

  var activeFacets = _objectSpread({}, activeFacetsState);

  var newActiveFacets = {};

  if (filters.length) {
    var _loop = function _loop(categoryId) {
      if (activeFacets.hasOwnProperty(categoryId)) {
        var categoryIdFilter = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(filters).filter(function (_ref12) {
          var id = _ref12.id;
          return id === categoryId;
        });

        if (categoryIdFilter.length) {
          newActiveFacets[categoryId] = {};

          var _loop2 = function _loop2(categoryName) {
            if (activeFacets[categoryId].hasOwnProperty(categoryName) && // $FlowFixMe
            categoryIdFilter.some(function (_ref13) {
              var name = _ref13.name,
                  id = _ref13.id;
              return name === categoryName && id === categoryId;
            })) {
              newActiveFacets[categoryId][categoryName] = activeFacets[categoryId][categoryName];
            }
          };

          for (var categoryName in activeFacets[categoryId]) {
            _loop2(categoryName);
          }
        }
      }
    };

    for (var categoryId in activeFacets) {
      _loop(categoryId);
    }
  }

  return newActiveFacets;
}

var initialState = {
  // Special pertimm marchandising rules with pre-parameterized criteria
  // such as `minDate` / `maxDate` for some user queries such as `noel`.
  pertimmInterpretations: {},
  products: [],
  recommandedProducts: [],
  facets: [],
  activeFacets: {},
  childcareAvailabilities: [],
  filters: [],
  completeCountriesFacetAsTree: null,
  query: {
    label: ''
  },
  redirection: null,
  scrollToResults: false,
  isLoading: true,
  isPriceLoading: true,
  isLoadingChildcareAvailabilities: false,
  isSearchEnabled: false,
  isSelectionModeEnabled: false,
  kidsValidationState: [],
  joyviewOffsetSell: -1,
  resortOffsetSell: -1,
  productsSelectedForComparison: [],
  prices: [],
  noResults: false,
  lastRequestId: -1,
  lastRecommandedRequestId: -1,
  isDateRequired: false
};
var facetingReducer = Object(_utils_createReducer__WEBPACK_IMPORTED_MODULE_36__[/* default */ "a"])(initialState, (_createReducer = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_RESET_REDIRECTION */ "g"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    redirection: null
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_RESET_SEARCH */ "h"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    products: [],
    prices: [],
    childcareAvailabilities: [],
    redirection: null,
    scrollToResults: false,
    isLoading: true,
    noResults: false,
    searchIsEnabled: false
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "c"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "c"]), function (state, action) {
  var locale = action.payload.locale;
  return _objectSpread(_objectSpread({}, state), {}, {
    joyviewOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.joyviewOffsetSell) || -1,
    resortOffsetSell: (locale === null || locale === void 0 ? void 0 : locale.resortOffsetSell) || -1
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_LOAD_OFFSET_SELL_REQUEST */ "c"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    joyviewOffsetSell: -1,
    resortOffsetSell: -1
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "d"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRecommandedRequestId: Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(action, 'optimist.id', -1),
    recommandedProducts: [],
    noResults: true,
    prices: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "d"]), function (state, action) {
  var _action$optimist, _action$payload; // If there is another request in progress


  if ((action === null || action === void 0 ? void 0 : (_action$optimist = action.optimist) === null || _action$optimist === void 0 ? void 0 : _action$optimist.id) !== state.lastRecommandedRequestId) {
    return state;
  }

  var _ref14 = (_action$payload = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload !== void 0 ? _action$payload : {},
      resorts = _ref14.resorts;

  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    recommandedProducts: resorts,
    noResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_LOAD_PRODUCTS_REQUEST */ "d"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SEARCH_REQUEST */ "i"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    childcareAvailabilities: [],
    isLoading: true,
    lastRequestId: Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(action, 'optimist.id', -1),
    noResults: false,
    prices: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SEARCH_REQUEST */ "i"]), function (state, action) {
  // If there is another request in progress
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(action, 'optimist.id') !== state.lastRequestId) {
    return state;
  }

  var products = action.payload.search.products;
  var productsSelectedForComparison = Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(state, 'productsSelectedForComparison', []).filter(function (selectedProductId) {
    return products.some(function (product) {
      return product.id === selectedProductId;
    });
  });
  var pertimmInterpretations = Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(action.payload, 'interpretation_explanation.interpretations', []).reduce(function (acc, interpretation) {
    if (interpretation.filter_name === PERTIMM_DEPARTURE_MIN_DATE) {
      acc.minDate = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* getTimestamp */ "d"])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    if (interpretation.filter_name === PERTIMM_DEPARTURE_MAX_DATE) {
      acc.maxDate = Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_32__[/* getTimestamp */ "d"])(interpretation.filter_value, PERTIMM_INTERPRETATION_DATE_FORMAT);
    }

    return acc;
  }, {});
  var activeFacets = filtersToActiveFacetsState(action.payload.filters);
  var facetingTopCountries = action.payload.facetingTopCountries;
  var facets = !Object(lodash__WEBPACK_IMPORTED_MODULE_30__["isEmpty"])(action.payload.catalogs) ? catalogToState(action.payload.catalogs, activeFacets, state.completeCountriesFacetAsTree, facetingTopCountries) : state.facets || [];

  var _facets$filter = facets.filter(function (catalog) {
    return _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* COUNTRIES_FACET_ID */ "e"] === catalog.id;
  }),
      _facets$filter2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_27__[/* default */ "a"])(_facets$filter, 1),
      countriesFacetAsTree = _facets$filter2[0];

  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: activeFacets,
    banners: parseBanners(action.payload.banners),
    // We need to store the complete country list because pertimm doesn't return all of them once a filter is selected
    completeCountriesFacetAsTree: !state.completeCountriesFacetAsTree || countriesFacetAsTree && getTotalLabelsCount(countriesFacetAsTree) > getTotalLabelsCount(state.completeCountriesFacetAsTree) ? countriesFacetAsTree : state.completeCountriesFacetAsTree,
    // If the catalog of facets is empty (e.g. "no results"), keep the previous state
    facets: facets,
    filters: filtersToState(action.payload.filters),
    isLoading: false,
    noResults: !action.payload.redirection && products.length === 0,
    pertimmInterpretations: pertimmInterpretations,
    products: products,
    productsSelectedForComparison: productsSelectedForComparison,
    query: _objectSpread(_objectSpread({}, state.query), {}, {
      label: Object(entities__WEBPACK_IMPORTED_MODULE_29__["decodeHTML"])(action.payload.query)
    }),
    redirection: action.payload.redirection
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SEARCH_REQUEST */ "i"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    noResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_PRICES_REQUEST */ "e"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isPriceLoading: true,
    prices: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_PRICES_REQUEST */ "e"]), function (state, action) {
  var _action$payload2;

  var _ref15 = (_action$payload2 = action === null || action === void 0 ? void 0 : action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : {},
      resorts = _ref15.resorts;

  return _objectSpread(_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: resorts,
    scrollToResults: false
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_PRICES_REQUEST */ "e"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isPriceLoading: false,
    prices: [],
    scrollToResults: true
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_CHILDCARE_REQUEST */ "a"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: true,
    childcareAvailabilities: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["resolve"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_CHILDCARE_REQUEST */ "a"]), function (state, action) {
  var childcareSearch = action.payload.childcareSearch;
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: childcareSearch
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_31__["reject"])(_constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_CHILDCARE_REQUEST */ "a"]), function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoadingChildcareAvailabilities: false,
    childcareAvailabilities: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_FILTERS */ "j"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filters: action.payload.filters
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_INITIAL_PRICES */ "k"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    prices: action.payload.initialProductPrices,
    isPriceLoading: false
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_IS_SEARCH_ENABLED */ "m"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSearchEnabled: action.payload.isSearchEnabled
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "n"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    kidsValidationState: action.payload.kidsValidationState
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */ "o"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSelectionModeEnabled: action.payload.enable,
    productsSelectedForComparison: []
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */ "s"], function (state, action) {
  var productsCurrentlySelected = Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(state, 'productsSelectedForComparison');
  var productToBeToggled = Object(lodash__WEBPACK_IMPORTED_MODULE_30__["get"])(action, 'payload.productId', null);

  if (!productToBeToggled) {
    return state;
  }

  if (Object(lodash__WEBPACK_IMPORTED_MODULE_30__["includes"])(productsCurrentlySelected, productToBeToggled)) {
    return _objectSpread(_objectSpread({}, state), {}, {
      productsSelectedForComparison: productsCurrentlySelected.filter(function (p) {
        return p !== productToBeToggled;
      })
    });
  }

  if (productsCurrentlySelected.length < _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* MAX_NUMBER_OF_SELECTED_PRODUCTS */ "w"]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      productsSelectedForComparison: [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_26__[/* default */ "a"])(productsCurrentlySelected), [productToBeToggled])
    });
  }

  return state;
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_35__[/* SYNC_WITH_LOCATION */ "u"], function (state, action) {
  var _action$payload3 = action.payload;
  _action$payload3 = _action$payload3 === void 0 ? {} : _action$payload3;
  var queryParams = _action$payload3.location.queryParams;

  if (!queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_QUERY_PARAM */ "C"]]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      activeFacets: _objectSpread(_objectSpread({}, state.activeFacets), Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_34__[/* getActiveFacetsFromQueryParams */ "d"])(queryParams))
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: _objectSpread(_objectSpread({}, state.activeFacets), Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_34__[/* getActiveFacetsFromQueryParams */ "d"])(queryParams)),
    query: _objectSpread(_objectSpread({}, state.query), {}, {
      label: queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_QUERY_PARAM */ "C"]]
    })
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_SEARCH_QUERY */ "p"], function (state, _ref16) {
  var value = _ref16.payload.value;

  if (Object(lodash__WEBPACK_IMPORTED_MODULE_30__["isUndefined"])(value)) {
    return state;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    query: _objectSpread(_objectSpread({}, value), {}, {
      label: Object(entities__WEBPACK_IMPORTED_MODULE_29__["decodeHTML"])(value.label)
    })
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_CLEAR_FACETS */ "b"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: _objectSpread(_objectSpread({}, state.activeFacets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])({}, action.payload.categoryId, {}))
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_TOGGLE_FACET_SELECTED */ "q"], function (state, action) {
  var facet = action.payload;
  var categoryActiveFacets = state.activeFacets[facet.categoryId];
  var newState;

  if (facet.isSelected) {
    // lodash/fp
    // return set(`activeFacets.${facet.category}.${facet.value}`, action.payload.isSelected, state);
    newState = _objectSpread(_objectSpread({}, categoryActiveFacets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])({}, facet.value, facet.isSelected));
  } else {
    var _facet$value = facet.value,
        _ = categoryActiveFacets[_facet$value],
        rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_25__[/* default */ "a"])(categoryActiveFacets, [_facet$value].map(_toPropertyKey)); // eslint-disable-line


    newState = rest;
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: _objectSpread(_objectSpread({}, state.activeFacets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])({}, facet.categoryId, _objectSpread({}, newState)))
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_SET_IS_DATE_REQUIRED */ "l"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isDateRequired: action.payload.isDateRequired
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_UPDATE_FILTERS */ "t"], function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filters: action.payload.filters,
    activeFacets: removeUnselectedFiltersFromActiveFacetsState( // $FlowFixMe
    action.payload.filters, state.activeFacets)
  });
}), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_28__[/* default */ "a"])(_createReducer, _constants__WEBPACK_IMPORTED_MODULE_37__[/* FACETING_RESET_FILTERS */ "f"], function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    activeFacets: {},
    filters: [],
    query: {
      label: ''
    }
  });
}), _createReducer));


/***/ }),

/***/ "8zGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flipper; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Flipper = function Flipper(_ref) {
  var description = _ref.description,
      value = _ref.value;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(value),
      oldValue = _useState[0],
      setOldValue = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(value),
      latestValue = _useState2[0],
      setLatestValue = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(''),
      transition = _useState3[0],
      setTransition = _useState3[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    setOldValue(latestValue);
    setLatestValue(value);

    if (value !== latestValue) {
      setTransition('flipperLeave');
    }
  }, [value]);
  return __jsx("span", {
    "data-testid": value,
    className: "relative"
  }, !!description && __jsx("span", {
    className: "sr-only",
    "data-testid": "srOnly"
  }, description), __jsx("span", {
    className: "text-center block ".concat(transition),
    "data-testid": "Flipper-value",
    key: transition,
    onAnimationEnd: function onAnimationEnd(event) {
      switch (event.animationName) {
        case 'flipperLeave':
          setTransition('flipperEnter');
          break;

        case 'flipperEnter':
          setTransition('flipperEnter');
          break;

        default:
          break;
      }
    }
  }, transition === 'flipperLeave' ? oldValue : latestValue));
};

/***/ }),

/***/ "9BC+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPhoneNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emailRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPhoneRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return salesmanIDRegex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return internationalPhoneRegex; });
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4__);




 // WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest) {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

var emailRegex = new RegExp(/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/);
var salesmanIDRegex = new RegExp(/(^\d{6,8}$|^$)/);

var getPhoneRegex = function getPhoneRegex(locale) {
  var _domainsService$getDo, _domainsService$getDo2;

  return new RegExp(((_domainsService$getDo = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_4___default.a.getDomain(locale)) === null || _domainsService$getDo === void 0 ? void 0 : (_domainsService$getDo2 = _domainsService$getDo.fields) === null || _domainsService$getDo2 === void 0 ? void 0 : _domainsService$getDo2.phoneNumber) || /^ *\+? *(?:[ \-()\.\/]*[0-9][ \-()\.\/]*){6,12}$/);
};

var internationalPhoneRegex = new RegExp(/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/);


/***/ }),

/***/ "9Kh7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerLegalInformationResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var offerLegalInformationResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* OFFER_LEGAL_INFORMATION */ "E"],
  resolve: function resolve(appContext, props) {
    var offerId = props.offerId;
    var query = "\n    {\n      offer(offerId: \"".concat(offerId, "\") {\n        legalInformation\n      },\n      config {\n        common {\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_OFFER_LEGAL_INFORMATION */ "Qb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "9LZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBookingEngineI18nQuery; });
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("CcNa");


function fetchBookingEngineI18nQuery(appContext) {
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].runQuery('', appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"],
    queryId: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_1__[/* BOOKING_GET_BOOKING_I18N */ "a"]
  });
}

/***/ }),

/***/ "9OZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("gA51");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;







var ProductService = function ProductService(_ref) {
  var className = _ref.className,
      service = _ref.service;
  var description = service.description,
      icon = service.icon,
      label = service.label;
  return description ? __jsx(_frameworks_collapse_panel_CollapsePanel__WEBPACK_IMPORTED_MODULE_7__[/* CollapsePanel */ "a"], {
    className: className,
    collapseIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].BOLDER_ARROW_FORTH_DOWN,
    collapseLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('common.included'),
    expandIconName: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].BOLDER_ARROW_FORTH_DOWN,
    expandLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('common.included'),
    hasEllipsis: false,
    hasKeepCollapsedContent: false,
    iconName: icon,
    id: icon,
    isExpanded: false,
    key: icon,
    theme: "remote",
    title: label
  }, __jsx("p", {
    className: "reset-paragraph mb-px20 text-base"
  }, description)) : __jsx("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'fadeIn border-b-1 flex items-center py-px20 text-base')
  }, __jsx("span", {
    className: "flex items-center flex-1 max-w-full overflow-hidden text-gray-darker"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    className: "rtl:mr-px20 flex-shrink-0",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE,
    name: icon,
    width: "1.375rem"
  }), label), __jsx("span", {
    className: "flex-shrink-0 font-bold rtl:ml-auto text-blue"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('common.included')));
};

/***/ }),

/***/ "9QcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACETING_CHILDCARE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FACETING_CLEAR_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FACETING_PRICES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FACETING_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FACETING_LOAD_PRODUCTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FACETING_LOAD_OFFSET_SELL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FACETING_SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FACETING_SET_INITIAL_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FACETING_SET_IS_DATE_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FACETING_SET_IS_SEARCH_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FACETING_SET_KIDS_VALIDATION_STATE; });
/* unused harmony export FACETING_SET_SCROLL_TO_RESULTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACETING_SET_SEARCH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FACETING_RESET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FACETING_RESET_REDIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FACETING_RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FACETING_TOGGLE_FACET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FACETING_UPDATE_FILTERS; });
var FACETING_CHILDCARE_REQUEST = 'FACETING_CHILDCARE_REQUEST';
var FACETING_CLEAR_FACETS = 'FACETING_CLEAR_FACETS';
var FACETING_PRICES_REQUEST = 'FACETING_PRICES_REQUEST';
var FACETING_SEARCH_REQUEST = 'FACETING_SEARCH_REQUEST';
var FACETING_LOAD_PRODUCTS_REQUEST = 'FACETING_LOAD_PRODUCTS_REQUEST';
var FACETING_LOAD_OFFSET_SELL_REQUEST = 'FACETING_LOAD_OFFSET_SELL_REQUEST';
var FACETING_SET_FILTERS = 'FACETING_SET_FILTERS';
var FACETING_SET_INITIAL_PRICES = 'FACETING_SET_INITIAL_PRICES';
var FACETING_SET_IS_DATE_REQUIRED = 'FACETING_SET_IS_DATE_REQUIRED';
var FACETING_SET_IS_SEARCH_ENABLED = 'FACETING_SET_IS_SEARCH_ENABLED';
var FACETING_SET_KIDS_VALIDATION_STATE = 'FACETING_SET_KIDS_VALIDATION_STATE';
var FACETING_SET_SCROLL_TO_RESULTS = 'FACETING_SCROLL_TO_RESULTS';
var FACETING_SET_SEARCH_QUERY = 'FACETING_SET_SEARCH_QUERY';
var FACETING_RESET_FILTERS = 'FACETING_RESET_FILTERS';
var FACETING_RESET_REDIRECTION = 'FACETING_RESET_REDIRECTION';
var FACETING_RESET_SEARCH = 'FACETING_RESET_SEARCH';
var FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_FACET_SELECTED = 'FACETING_TOGGLE_FACET_SELECTED';
var FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE = 'FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE';
var FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON = 'FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON';
var FACETING_UPDATE_FILTERS = 'FACETING_UPDATE_FILTERS';

/***/ }),

/***/ "9TP6":
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__("OBn4"),
    noop = __webpack_require__("nnm9"),
    setToArray = __webpack_require__("XlL0");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ "9Ts2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productBarsResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productBarsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_BARS */ "eb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      resort(".concat(productArgs, ") {\n        adultOnly\n      },\n      bars(").concat(productArgs, ") {\n        introduction { included withSupplement }\n        barsList { name images description }\n      }\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_BARS */ "Xb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "9YYj":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "9jKB":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("Uqkn");
var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");
var createNonEnumerableProperty = __webpack_require__("g51W");
var objectHas = __webpack_require__("DZWw");
var shared = __webpack_require__("l6h7");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "9smd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productBreadcrumbResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productBreadcrumbResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* PRODUCT_BREADCRUMB */ "K"],
  props: function props(appContext) {
    return {
      originalUrl: function originalUrl() {
        return appContext.originalUrl;
      }
    };
  },
  resolve: function resolve(appContext, cmsProps, pageContext) {
    var resortId = cmsProps.resortId;
    var productCountryPageUrl = pageContext.productCountryPageUrl,
        productRegionPageUrl = pageContext.productRegionPageUrl;
    var pageCountryQuery = productCountryPageUrl ? "\n      countryPage: pageByUrl(pageUrl: \"".concat(productCountryPageUrl, "\") {\n        pageCountry { breadcrumbLabel }\n        url\n      }") : '';
    var pageRegionQuery = productRegionPageUrl ? "\n      regionPage: pageByUrl(pageUrl: \"".concat(productRegionPageUrl, "\") {\n        pageRegion { breadcrumbLabel }\n        url\n      }") : '';
    var query = "query {\n      ".concat(resortId ? "resort(productId: \"".concat(resortId, "\") { name }") : '', "\n      ").concat(pageCountryQuery, "\n      ").concat(pageRegionQuery, "\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_BREADCRUMB */ "Zb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "9wHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CRUISE; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ pageTrackingResolver; });

// UNUSED EXPORTS: DESTINATION, DESTINATION_TOUR, DESTINATION_MICE, DESTINATION_TRAVEL, RESORT, TOUR, LANDING, LANDING_MICE, OFFER, PREBOOKING, RESORT_MICE, HOMEPAGE, HOME

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__("0Jwk");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// CONCATENATED MODULE: ./node_modules/path-to-regexp/dist.es2015/index.js
/**
 * Tokenize input string.
 */
function lexer(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({ type: "MODIFIER", index: i, value: str[i++] });
            continue;
        }
        if (char === "\\") {
            tokens.push({ type: "ESCAPED_CHAR", index: i++, value: str[i++] });
            continue;
        }
        if (char === "{") {
            tokens.push({ type: "OPEN", index: i, value: str[i++] });
            continue;
        }
        if (char === "}") {
            tokens.push({ type: "CLOSE", index: i, value: str[i++] });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while (j < str.length) {
                var code = str.charCodeAt(j);
                if (
                // `0-9`
                (code >= 48 && code <= 57) ||
                    // `A-Z`
                    (code >= 65 && code <= 90) ||
                    // `a-z`
                    (code >= 97 && code <= 122) ||
                    // `_`
                    code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name)
                throw new TypeError("Missing parameter name at " + i);
            tokens.push({ type: "NAME", index: i, value: name });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") {
                throw new TypeError("Pattern cannot start with \"?\" at " + j);
            }
            while (j < str.length) {
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                }
                else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") {
                        throw new TypeError("Capturing groups are not allowed at " + j);
                    }
                }
                pattern += str[j++];
            }
            if (count)
                throw new TypeError("Unbalanced pattern at " + i);
            if (!pattern)
                throw new TypeError("Missing pattern at " + i);
            tokens.push({ type: "PATTERN", index: i, value: pattern });
            i = j;
            continue;
        }
        tokens.push({ type: "CHAR", index: i, value: str[i++] });
    }
    tokens.push({ type: "END", index: i, value: "" });
    return tokens;
}
/**
 * Parse a string for the raw tokens.
 */
function parse(str, options) {
    if (options === void 0) { options = {}; }
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^" + escapeString(options.delimiter || "/#?") + "]+?";
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function (type) {
        if (i < tokens.length && tokens[i].type === type)
            return tokens[i++].value;
    };
    var mustConsume = function (type) {
        var value = tryConsume(type);
        if (value !== undefined)
            return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected " + nextType + " at " + index + ", expected " + type);
    };
    var consumeText = function () {
        var result = "";
        var value;
        // tslint:disable-next-line
        while ((value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))) {
            result += value;
        }
        return result;
    };
    while (i < tokens.length) {
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
/**
 * Compile a string to a template function for the path.
 */
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
    if (options === void 0) { options = {}; }
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function (x) { return x; } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function (token) {
        if (typeof token === "object") {
            return new RegExp("^(?:" + token.pattern + ")$", reFlags);
        }
    });
    return function (data) {
        var path = "";
        for (var i = 0; i < tokens.length; i++) {
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) {
                    throw new TypeError("Expected \"" + token.name + "\" to not repeat, but got an array");
                }
                if (value.length === 0) {
                    if (optional)
                        continue;
                    throw new TypeError("Expected \"" + token.name + "\" to not be empty");
                }
                for (var j = 0; j < value.length; j++) {
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) {
                        throw new TypeError("Expected all \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                    }
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) {
                    throw new TypeError("Expected \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                }
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional)
                continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"" + token.name + "\" to be " + typeOfMessage);
        }
        return path;
    };
}
/**
 * Create path match function from `path-to-regexp` spec.
 */
function dist_es2015_match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */
function regexpToFunction(re, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.decode, decode = _a === void 0 ? function (x) { return x; } : _a;
    return function (pathname) {
        var m = re.exec(pathname);
        if (!m)
            return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function (i) {
            // tslint:disable-next-line
            if (m[i] === undefined)
                return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") {
                params[key.name] = m[i].split(key.prefix + key.suffix).map(function (value) {
                    return decode(value, key);
                });
            }
            else {
                params[key.name] = decode(m[i], key);
            }
        };
        for (var i = 1; i < m.length; i++) {
            _loop_1(i);
        }
        return { path: path, index: index, params: params };
    };
}
/**
 * Escape a regular expression string.
 */
function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */
function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */
function regexpToRegexp(path, keys) {
    if (!keys)
        return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) {
        for (var i = 0; i < groups.length; i++) {
            keys.push({
                name: i,
                prefix: "",
                suffix: "",
                modifier: "",
                pattern: ""
            });
        }
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */
function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function (path) { return pathToRegexp(path, keys, options).source; });
    return new RegExp("(?:" + parts.join("|") + ")", flags(options));
}
/**
 * Create a path regexp from string input.
 */
function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 */
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) { options = {}; }
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function (x) { return x; } : _d;
    var endsWith = "[" + escapeString(options.endsWith || "") + "]|$";
    var delimiter = "[" + escapeString(options.delimiter || "/#?") + "]";
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        if (typeof token === "string") {
            route += escapeString(encode(token));
        }
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys)
                    keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
                    }
                    else {
                        route += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
                    }
                }
                else {
                    route += "(" + token.pattern + ")" + token.modifier;
                }
            }
            else {
                route += "(?:" + prefix + suffix + ")" + token.modifier;
            }
        }
    }
    if (end) {
        if (!strict)
            route += delimiter + "?";
        route += !options.endsWith ? "$" : "(?=" + endsWith + ")";
    }
    else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string"
            ? delimiter.indexOf(endToken[endToken.length - 1]) > -1
            : // tslint:disable-next-line
                endToken === undefined;
        if (!strict) {
            route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        }
        if (!isEndDelimited) {
            route += "(?=" + delimiter + "|" + endsWith + ")";
        }
    }
    return new RegExp(route, flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp)
        return regexpToRegexp(path, keys);
    if (Array.isArray(path))
        return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/utils/tracking/resort.js
var tracking_resort = __webpack_require__("zCbR");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/pageTracking.utils.js




















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;

function matchPath(path, pathSchema) {
  var keys = [];
  var regexp = pathToRegexp(pathSchema, keys);
  var match = regexp.exec(path);

  if (match) {
    var _match = Object(toArray["a" /* default */])(match),
        url = _match[0],
        paramValues = _match.slice(1);

    return {
      matched: true,
      url: url,
      params: keys.reduce(function (memo, key, index) {
        return _objectSpread(_objectSpread({}, memo), {}, Object(defineProperty["a" /* default */])({}, key.name, paramValues[index]));
      }, {})
    };
  }

  return {
    matched: false
  };
}

function getDefaultTrackingProps(_ref) {
  var pageId = _ref.pageId,
      pageType = _ref.pageType;
  var siteSection = Object(utils["e" /* getSiteSection */])({
    pageType: pageType
  });
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageId)
  };
}
function getDestinationTrackingProps(_ref2) {
  var pageType = _ref2.pageType,
      _ref2$pageRegion = _ref2.pageRegion;
  _ref2$pageRegion = _ref2$pageRegion === void 0 ? {
    name: null
  } : _ref2$pageRegion;
  var destinationRegion = _ref2$pageRegion.name,
      _ref2$pageCountry = _ref2.pageCountry;
  _ref2$pageCountry = _ref2$pageCountry === void 0 ? {
    name: null
  } : _ref2$pageCountry;
  var destinationCountry = _ref2$pageCountry.name;
  var siteSection = Object(utils["e" /* getSiteSection */])({
    pageType: pageType
  }); // The default productType for 'destination' && 'destination-mice' pages is 'resort',
  // Otherwise it is specified after the hyphen, e.g. 'destination-tour' or 'destination-cruise'.

  var productType = pageType === PAGE_TYPES.DESTINATION || pageType === PAGE_TYPES.DESTINATION_MICE ? PAGE_TYPES.RESORT : pageType.split('-')[1];
  var productTypes = Object.keys(PRODUCT_TYPES).map(lodash["toLower"]);
  var isIndexPage = !destinationRegion && !destinationCountry;
  var pageName = siteSection;

  if (!isIndexPage) {
    var pageIdentifier = [destinationRegion, destinationCountry].filter(function (item) {
      return !!item;
    }).join('_');
    pageName = "".concat(siteSection, "_").concat(pageIdentifier);
  }

  return _objectSpread({
    siteSection: siteSection,
    pageName: pageName,
    destinationRegion: destinationRegion,
    destinationCountry: destinationCountry
  }, productTypes.includes(productType) ? {
    productType: Object(lodash["toUpper"])(productType)
  } : null);
}
function getDestinationTravelTrackingProps(_ref3) {
  var pageId = _ref3.pageId,
      pageMeta = _ref3.pageMeta,
      _ref3$pageRegion = _ref3.pageRegion;
  _ref3$pageRegion = _ref3$pageRegion === void 0 ? {
    name: null
  } : _ref3$pageRegion;
  var destinationRegion = _ref3$pageRegion.name,
      _ref3$pageCountry = _ref3.pageCountry;
  _ref3$pageCountry = _ref3$pageCountry === void 0 ? {
    name: null
  } : _ref3$pageCountry;
  var destinationCountry = _ref3$pageCountry.name; // 'Travel' section != 'DestinationTravel' pageType to preserve historical tracking consistency

  var siteSection = 'Shopping_Travel';
  var _pageMeta$name = pageMeta.name,
      name = _pageMeta$name === void 0 ? null : _pageMeta$name;
  var pageIdentifier = name ? name : pageId;
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageIdentifier),
    destinationRegion: destinationRegion,
    destinationCountry: destinationCountry
  };
}
function getLandingTrackingProps(_ref4, resort) {
  var pageId = _ref4.pageId,
      pageType = _ref4.pageType,
      pageMeta = _ref4.pageMeta;
  var isSummerCamp = (resort === null || resort === void 0 ? void 0 : resort.type) === PRODUCT_TYPES.SUMMER_CAMP;
  var siteSection = Object(utils["e" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageMeta$name2 = pageMeta.name,
      name = _pageMeta$name2 === void 0 ? null : _pageMeta$name2;
  var pageIdentifier = name ? name : pageId;

  if (isSummerCamp && resort) {
    return {
      siteSection: siteSection,
      pageName: "".concat(siteSection, "_SummerCamp_").concat(resort.id),
      categoryGA: pageIdentifier
    };
  }

  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageIdentifier)
  };
}
function getOfferTrackingProps(_ref5) {
  var pagePath = _ref5.pagePath; // 'Offers' section != 'Offer' pageType to preserve historical tracking consistency

  var siteSection = 'Shopping_Offers';

  var _matchPath = matchPath(pagePath, '/o/:offerSlug?'),
      _matchPath$params = _matchPath.params;

  _matchPath$params = _matchPath$params === void 0 ? {} : _matchPath$params;
  var offerSlug = _matchPath$params.offerSlug;
  var pageName = offerSlug ? "".concat(siteSection, "_").concat(Object(utils["f" /* noCase */])(offerSlug)) : siteSection;
  return {
    siteSection: siteSection,
    pageName: pageName,
    channel: 'Offers'
  };
}
function getPrebookingTrackingProps(_ref6) {
  var pageId = _ref6.pageId,
      pageType = _ref6.pageType;
  var siteSection = Object(utils["e" /* getSiteSection */])({
    pageType: pageType
  });
  return {
    siteSection: siteSection,
    pageName: "".concat(siteSection, "_").concat(pageId)
  };
}
function getHomepageTrackingProps(_ref7) {
  var pageId = _ref7.pageId;
  var siteSection = 'Shopping_Home';
  var categoryGA = pageId.toLowerCase();
  return {
    categoryGA: categoryGA,
    siteSection: siteSection,
    pageName: "".concat(siteSection)
  };
}
function getResortTrackingProps(_ref8) {
  var pageType = _ref8.pageType,
      _ref8$pageData = _ref8.pageData,
      pageData = _ref8$pageData === void 0 ? {} : _ref8$pageData;
  var siteSection = Object(utils["e" /* getSiteSection */])({
    pageType: pageType
  });
  var _pageData$resort = pageData.resort,
      resort = _pageData$resort === void 0 ? {} : _pageData$resort,
      _pageData$price = pageData.price,
      price = _pageData$price === void 0 ? {} : _pageData$price,
      _pageData$bookingCrit = pageData.bookingCriteria,
      bookingCriteria = _pageData$bookingCrit === void 0 ? null : _pageData$bookingCrit;
  var resortId = Object(lodash["get"])(resort, 'id'); // '_Main' is appended to resort pageNames to preserve historical tracking consistency

  var pageName = Object(lodash["get"])(resort, 'type', '') === PRODUCT_TYPES.RESORT ? "".concat(siteSection, "_").concat(resortId, "_Main") : "".concat(siteSection, "_").concat(resortId);
  var departureCityCode = Object(lodash["get"])(price, 'termsAndConditions.departureCity.value');
  var departureCityName = Object(lodash["get"])(price, 'termsAndConditions.departureCity.name');
  return {
    isProductPage: true,
    categoryGA: "".concat(pageType, "-").concat(resortId),
    siteSection: siteSection,
    pageName: pageName,
    resortCode: Object(lodash["get"])(resort, 'id', null),
    resortCountry: Object(lodash["toUpper"])(Object(lodash["get"])(resort, 'destination.country', '')),
    resortDefaultPrice: Object(lodash["get"])(price, 'bestPrice.value', null),
    resortDepartureCityCode: Object(lodash["toUpper"])(Object(tracking_resort["b" /* getDepartureCityCode */])(departureCityCode)),
    resortDepartureCityName: Object(lodash["toUpper"])(Object(tracking_resort["c" /* getDepartureCityName */])(departureCityCode, departureCityName)),
    resortDepartureDate: Object(lodash["get"])(price, 'termsAndConditions.departureDate', null),
    resortName: Object(lodash["toUpper"])(Object(lodash["get"])(resort, 'name', '')),
    resortOldPrice: Object(lodash["get"])(price, 'initialPrice.value', null),
    resortRegion: Object(lodash["toUpper"])(Object(lodash["get"])(resort, 'destination.area', '')),
    resortSeasonType: Object(lodash["get"])(resort, 'seasonName', null),
    resortTransport: Object(lodash["toUpper"])(Object(tracking_resort["d" /* getTrackingTransport */])(departureCityCode)),
    resortTrident: Object(lodash["get"])(resort, 'comfort', null),
    resortUrlImage: Object(lodash["get"])(resort, 'image'),
    bookingCriteria: bookingCriteria
  };
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/pageTracking.resolver.js














function pageTracking_resolver_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pageTracking_resolver_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pageTracking_resolver_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pageTracking_resolver_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var pageTracking_resolver_PAGE_TYPES = dist["b2cPagesService"].PAGE_TYPES;
var DESTINATION = pageTracking_resolver_PAGE_TYPES.DESTINATION,
    DESTINATION_TOUR = pageTracking_resolver_PAGE_TYPES.DESTINATION_TOUR,
    DESTINATION_MICE = pageTracking_resolver_PAGE_TYPES.DESTINATION_MICE,
    DESTINATION_TRAVEL = pageTracking_resolver_PAGE_TYPES.DESTINATION_TRAVEL,
    RESORT = pageTracking_resolver_PAGE_TYPES.RESORT,
    TOUR = pageTracking_resolver_PAGE_TYPES.TOUR,
    CRUISE = pageTracking_resolver_PAGE_TYPES.CRUISE,
    LANDING = pageTracking_resolver_PAGE_TYPES.LANDING,
    LANDING_MICE = pageTracking_resolver_PAGE_TYPES.LANDING_MICE,
    OFFER = pageTracking_resolver_PAGE_TYPES.OFFER,
    PREBOOKING = pageTracking_resolver_PAGE_TYPES.PREBOOKING,
    RESORT_MICE = pageTracking_resolver_PAGE_TYPES.RESORT_MICE,
    HOMEPAGE = pageTracking_resolver_PAGE_TYPES.HOMEPAGE,
    HOME = pageTracking_resolver_PAGE_TYPES.HOME;

var pageTrackingResolver = {
  name: constants["G" /* PAGE_TRACKING */],
  props: function props(appContext, pageContext, location) {
    var pagePath = location.pathname;

    var pageProps = pageTracking_resolver_objectSpread(pageTracking_resolver_objectSpread({}, pageContext), {}, {
      pagePath: pagePath
    });

    return {
      trackingData: function trackingData(props) {
        var resort = props.resort,
            price = props.price,
            bookingCriteria = props.bookingCriteria;
        var pageData = {
          resort: resort,
          price: price,
          bookingCriteria: bookingCriteria
        };

        switch (pageContext.pageType) {
          case OFFER:
            return getOfferTrackingProps(pageProps);

          case DESTINATION:
          case DESTINATION_TOUR:
          case DESTINATION_MICE:
            return getDestinationTrackingProps(pageProps);

          case DESTINATION_TRAVEL:
            return getDestinationTravelTrackingProps(pageProps);

          case RESORT:
          case TOUR:
          case CRUISE:
          case RESORT_MICE:
            return getResortTrackingProps(pageTracking_resolver_objectSpread(pageTracking_resolver_objectSpread({}, pageProps), {}, {
              pageData: pageData
            }));

          case LANDING:
          case LANDING_MICE:
            return getLandingTrackingProps(pageProps, resort);

          case PREBOOKING:
            return getPrebookingTrackingProps(pageProps);

          case HOME:
          case HOMEPAGE:
            return getHomepageTrackingProps(pageProps);

          default:
            return getDefaultTrackingProps(pageProps);
        }
      }
    };
  },
  resolve: function resolve(appContext, props, pageContext, location) {
    var pageType = pageContext.pageType,
        _pageContext$pageMeta = pageContext.pageMeta;
    _pageContext$pageMeta = _pageContext$pageMeta === void 0 ? {} : _pageContext$pageMeta;
    var resortId = _pageContext$pageMeta.resortId;
    var urlParams = location.urlParams,
        queryParams = location.queryParams; // Fetch data for resort, resort_mice, tour and cruise pages only

    if (![RESORT, TOUR, CRUISE, RESORT_MICE, LANDING].includes(pageType) || !resortId) {
      return Promise.resolve({});
    }

    var productArgs = Object(graphql["c" /* buildProductArgs */])(resortId, urlParams);
    var query;

    if (pageType === LANDING) {
      query = "query {\n        resort(".concat(productArgs, ") {\n          id\n          type\n        }\n      }");
    } else {
      var offerName = queryParams.offer ? dist["url"].decodePath(queryParams.offer) : '';
      var departureCity = queryParams.departure_city || '';
      var productArgsWithOffer = Object(graphql["c" /* buildProductArgs */])(resortId, urlParams, {
        offerName: offerName,
        departureCity: departureCity
      });
      query = "query {\n        resort(".concat(productArgs, ") {\n          id type name comfort seasonName image destination {country area} adultOnly\n        }\n        price(").concat(productArgsWithOffer, ") {\n          termsAndConditions {\n            departureDate departureCity {value name}\n          }\n          bestPrice {value}\n          initialPrice {value}\n        }\n        bookingCriteria(").concat(productArgs, ") {\n          initialDuration(").concat(productArgsWithOffer, ")\n          initialNumberOfAdults(").concat(productArgsWithOffer, ")\n          initialNumberOfChildren\n        }\n      }");
    }

    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Kb" /* LINE_COMMON_TRACKING */],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "A+R+":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("4gXF");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "A/WM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var classNames = (function () {
		// don't inherit from Object so we can skip hasOwnProperty check later
		// http://stackoverflow.com/questions/15518328/creating-js-object-with-object-createnull#answer-21079232
		function StorageObject() {}
		StorageObject.prototype = Object.create(null);

		function _parseArray (resultSet, array) {
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				_parse(resultSet, array[i]);
			}
		}

		var hasOwn = {}.hasOwnProperty;

		function _parseNumber (resultSet, num) {
			resultSet[num] = true;
		}

		function _parseObject (resultSet, object) {
			for (var k in object) {
				if (hasOwn.call(object, k)) {
					// set value to false instead of deleting it to avoid changing object structure
					// https://www.smashingmagazine.com/2012/11/writing-fast-memory-efficient-javascript/#de-referencing-misconceptions
					resultSet[k] = !!object[k];
				}
			}
		}

		var SPACE = /\s+/;
		function _parseString (resultSet, str) {
			var array = str.split(SPACE);
			var length = array.length;

			for (var i = 0; i < length; ++i) {
				resultSet[array[i]] = true;
			}
		}

		function _parse (resultSet, arg) {
			if (!arg) return;
			var argType = typeof arg;

			// 'foo bar'
			if (argType === 'string') {
				_parseString(resultSet, arg);

			// ['foo', 'bar', ...]
			} else if (Array.isArray(arg)) {
				_parseArray(resultSet, arg);

			// { 'foo': true, ... }
			} else if (argType === 'object') {
				_parseObject(resultSet, arg);

			// '130'
			} else if (argType === 'number') {
				_parseNumber(resultSet, arg);
			}
		}

		function _classNames () {
			// don't leak arguments
			// https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
			var len = arguments.length;
			var args = Array(len);
			for (var i = 0; i < len; i++) {
				args[i] = arguments[i];
			}

			var classSet = new StorageObject();
			_parseArray(classSet, args);

			var list = [];

			for (var k in classSet) {
				if (classSet[k]) {
					list.push(k)
				}
			}

			return list.join(' ');
		}

		return _classNames;
	})();

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "A5Hi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SliderHandler_SliderHandler; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.helper.js
function getIndexInRange(index, max) {
  if (index < 0) {
    return 0;
  }

  return index < max ? index : max;
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandlerItems.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */


// $FlowFixMe
var SliderHandlerItems = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var center = props.center,
      children = props.children,
      className = props.className,
      currentIndex = props.currentIndex,
      fadeUnseenItems = props.fadeUnseenItems,
      hasControls = props.hasControls,
      isSwiping = props.isSwiping,
      itemPercentSize = props.itemPercentSize,
      onSwipeEnd = props.onSwipeEnd,
      onSwipeMove = props.onSwipeMove,
      onSwipeStart = props.onSwipeStart,
      position = props.position,
      _props$spacerWidth = props.spacerWidth,
      spacerWidth = _props$spacerWidth === void 0 ? 0 : _props$spacerWidth;
  return __jsx("div", {
    className: classnames_default()(className, 'overflow-hidden'),
    ref: ref,
    tabIndex: hasControls ? 0 : -1
  }, __jsx("div", {
    className: classnames_default()('flex h-full will-change-transform', {
      'transition-transform': !isSwiping
    }),
    style: _objectSpread({
      transform: "translate(".concat(position, "%, 0)"),
      WebkitTapHighlightColor: 'transparent'
    }, center ? {
      padding: '0 25%'
    } : {}),
    onTouchStart: onSwipeStart,
    onTouchMove: onSwipeMove,
    onTouchEnd: onSwipeEnd
  }, react["Children"].map(children, function (child, idx) {
    var isCurrentItem = currentIndex === idx;
    return __jsx("div", {
      "aria-hidden": child.props.ariaHidden,
      className: "max-w-full will-change-transform ".concat(isSwiping ? '' : 'transition-opacity', " px-px").concat(spacerWidth),
      key: idx,
      style: {
        minWidth: "".concat(itemPercentSize, "%"),
        maxWidth: "".concat(itemPercentSize, "%"),
        opacity: isCurrentItem || !fadeUnseenItems ? 1 : 0.3
      },
      tabIndex: child.props.tabIndex
    }, child);
  })));
});
// CONCATENATED MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx




















var SliderHandler_jsx = react_default.a.createElement;

function SliderHandler_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SliderHandler_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SliderHandler_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SliderHandler_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var SliderHandler_SliderHandler = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SliderHandler, _Component);

  var _super = _createSuper(SliderHandler);

  function SliderHandler(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SliderHandler);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "sliderRef", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "intervalId", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onNext", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state = _this.state,
          maxIndex = _this$state.maxIndex,
          index = _this$state.index;

      var i = index + _this.getStep();

      if (i > maxIndex) {
        i = _this.props.hasInfiniteScroll ? 0 : maxIndex;
      }

      _this.goToIndex(i, _this.props.onNext);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onIndex", function (event, index) {
      if (event) {
        event.preventDefault();
      }

      if (index === _this.state.index) {
        return;
      }

      var isNext = index > _this.state.index;
      var callback = isNext ? _this.props.onNext : _this.props.onPrevious;

      _this.goToIndex(index, callback);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onPrevious", function (event) {
      if (event) {
        event.preventDefault();
      }

      var _this$state2 = _this.state,
          maxIndex = _this$state2.maxIndex,
          index = _this$state2.index;
      var min = 0;

      var i = index - _this.getStep();

      if (i < min) {
        i = _this.props.hasInfiniteScroll ? maxIndex + i + 1 : min;
      }

      _this.goToIndex(i, _this.props.onPrevious);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyUp", function (event) {
      var isRTL = _this.state.isRTL;

      if (_this.props.hasKeyboardSupport) {
        switch (event.which) {
          case keyCodes["c" /* ARROW_RIGHT */]:
            event.stopPropagation();
            isRTL ? _this.onPrevious(event) : _this.onNext(event);
            break;

          case keyCodes["b" /* ARROW_LEFT */]:
            event.stopPropagation();
            isRTL ? _this.onNext(event) : _this.onPrevious(event);
            break;

          default:
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeStart", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var swipeStart = _this.getSwipeX(event);

        var slideWidth = _this.sliderRef.current ? _this.sliderRef.current.offsetWidth : 0;

        _this.setState(function (_ref) {
          var lastIndex = _ref.lastIndex;
          return {
            slideWidth: slideWidth,
            isSwiping: true,
            swipeStart: swipeStart,
            swipeX: lastIndex,
            swipeStartTime: new Date()
          };
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeMove", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        var x = _this.getSwipeX(event);

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStart = prevState.swipeStart,
              slideWidth = prevState.slideWidth,
              maxIndex = prevState.maxIndex,
              isRTL = prevState.isRTL;
          var offset = swipeStart - x;
          var percentageOffset = offset / slideWidth;
          var swipeX = isRTL ? lastIndex - percentageOffset : lastIndex + percentageOffset;
          var index = getIndexInRange(Math.round(swipeX), maxIndex);

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return SliderHandler_objectSpread({
            swipeX: getIndexInRange(swipeX, maxIndex)
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onSwipeEnd", function (event) {
      if (_this.props.hasSwipeSupport) {
        event.stopPropagation();

        _this.setState(function (prevState) {
          var prevItemsToRender = prevState.itemsToRender,
              lastIndex = prevState.lastIndex,
              swipeStartTime = prevState.swipeStartTime,
              swipeX = prevState.swipeX,
              maxIndex = prevState.maxIndex;

          var step = _this.getStep();

          var timeElapsed = new Date().getTime() - swipeStartTime.getTime();
          var offset = lastIndex - swipeX;
          var velocity = Math.round(offset / timeElapsed * 10000);
          var index = Math.round(swipeX);

          if (Math.abs(velocity) > 5) {
            index = velocity < 0 ? lastIndex + step : lastIndex - step;
          }

          var itemsToRender = _this.getItemsToRender(prevItemsToRender, index, _this.props.nbItemsToShow);

          return SliderHandler_objectSpread({
            index: getIndexInRange(index, maxIndex),
            isSwiping: false,
            swipeStart: 0,
            swipeX: 0
          }, itemsToRender && {
            itemsToRender: itemsToRender
          });
        }, function () {
          var _this$state3 = _this.state,
              index = _this$state3.index,
              lastIndex = _this$state3.lastIndex;
          var _this$props = _this.props,
              onPrevious = _this$props.onPrevious,
              onNext = _this$props.onNext;

          if (index < lastIndex && onPrevious) {
            onPrevious();
          } else if (index > lastIndex && onNext) {
            onNext();
          }

          _this.setState(function () {
            return {
              lastIndex: index
            };
          });
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "isItemVisible", function (itemIndex) {
      var index = _this.state.index;
      return itemIndex >= index && itemIndex < index + _this.props.nbItemsToShow;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldRenderItem", function (itemIndex) {
      return !_this.props.hasLazyload || _this.state.itemsToRender[itemIndex];
    });

    _this.sliderRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = _this.initState(props);
    return _this;
  }

  Object(createClass["a" /* default */])(SliderHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          hasAutoplay = _this$props2.hasAutoplay,
          hasKeyboardSupport = _this$props2.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.addEventListener('keyup', this.onKeyUp, false);
      }

      if (hasAutoplay) {
        this.intervalId = setInterval(function () {
          return _this2.onNext();
        }, 3000);
      }

      if (Object(lodash["get"])(document, 'documentElement.dir', 'ltr') === 'rtl') {
        this.setState({
          isRTL: true
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var hasKeyboardSupport = this.props.hasKeyboardSupport;

      if (hasKeyboardSupport && this.sliderRef.current) {
        this.sliderRef.current.removeEventListener('keyup', this.onKeyUp, false);
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  }, {
    key: "initState",
    value: function initState(props) {
      var hasLazyload = props.hasLazyload,
          initialIndex = props.initialIndex,
          items = props.items,
          nbItemsToShow = props.nbItemsToShow;
      var itemsCount = items.length;
      var maxIndex = itemsCount < nbItemsToShow ? 0 : Math.ceil(itemsCount - nbItemsToShow);
      var index = getIndexInRange(initialIndex, maxIndex);
      var initialItemsToRender = Array(itemsCount).fill(!hasLazyload, 0, itemsCount);
      var itemsToRender = this.getItemsToRender(initialItemsToRender, index, nbItemsToShow);
      return {
        index: index,
        isSwiping: false,
        isRTL: false,
        itemsCount: itemsCount,
        itemsToRender: itemsToRender,
        lastIndex: index,
        maxIndex: maxIndex,
        slideWidth: 0,
        swipeStart: 0,
        swipeStartTime: new Date(),
        swipeX: 0
      };
    }
  }, {
    key: "getItemsToRender",
    value: function getItemsToRender(itemsToRender, index, nbItemsToShow) {
      var hasLazyload = this.props.hasLazyload;
      var step = this.getStep();
      var minRange = index - step;
      var maxRange = index + nbItemsToShow + step;
      var newItemToRender = itemsToRender.map(function (isRendered, itemIndex) {
        return isRendered || Object(lodash["inRange"])(itemIndex, minRange, maxRange);
      });

      if (!hasLazyload || itemsToRender.every(function (isRendered) {
        return isRendered;
      }) || Object(lodash["isEqual"])(itemsToRender, newItemToRender)) {
        return itemsToRender;
      }

      return newItemToRender;
    }
  }, {
    key: "getStep",
    value: function getStep() {
      var _this$props$nbItemsTo = this.props.nbItemsToScroll,
          nbItemsToScroll = _this$props$nbItemsTo === void 0 ? 1 : _this$props$nbItemsTo;
      return nbItemsToScroll > 0 ? nbItemsToScroll : 1;
    } // Slide

  }, {
    key: "getItemPosition",
    value: function getItemPosition() {
      var _this$state4 = this.state,
          index = _this$state4.index,
          swipeX = _this$state4.swipeX,
          isSwiping = _this$state4.isSwiping,
          isRTL = _this$state4.isRTL;
      var center = this.props.center;
      var x = isSwiping ? swipeX : index;
      var reductionCoefficient = center ? 2 : 1;
      var increment = 100 / this.props.nbItemsToShow / reductionCoefficient;
      var posX = x * increment;
      return {
        position: isRTL ? posX : -posX,
        increment: increment
      };
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(index) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : lodash["noop"];

      if (this.props.onChangeIndex) {
        this.props.onChangeIndex(index);
      }

      this.setState(function (prevState) {
        var itemsToRender = _this3.getItemsToRender(prevState.itemsToRender, index, _this3.props.nbItemsToShow);

        return {
          index: index,
          itemsToRender: itemsToRender,
          lastIndex: index
        };
      }, callback);
    } // Events handlers

  }, {
    key: "getSwipeX",
    // Swipe
    value: function getSwipeX(event) {
      return event.touches[0].pageX;
    }
  }, {
    key: "isFirstItemVisible",
    value: function isFirstItemVisible() {
      return this.isItemVisible(0);
    }
  }, {
    key: "isLastItemVisible",
    value: function isLastItemVisible() {
      var itemsCount = this.state.itemsCount;
      return this.isItemVisible(itemsCount - 1);
    }
  }, {
    key: "hasControls",
    value: function hasControls() {
      return this.state.itemsCount > this.props.nbItemsToShow;
    }
  }, {
    key: "render",
    // render
    value: function render() {
      var _this4 = this;

      var _this$state5 = this.state,
          index = _this$state5.index,
          isSwiping = _this$state5.isSwiping,
          itemsCount = _this$state5.itemsCount;
      if (!itemsCount) return null;
      var _this$props3 = this.props,
          center = _this$props3.center,
          children = _this$props3.children,
          className = _this$props3.className,
          fadeUnseenItems = _this$props3.fadeUnseenItems,
          hasInfiniteScroll = _this$props3.hasInfiniteScroll,
          items = _this$props3.items,
          nbItemsToShow = _this$props3.nbItemsToShow,
          spacerWidth = _this$props3.spacerWidth;
      var hasControls = this.hasControls();

      var _this$getItemPosition = this.getItemPosition(),
          position = _this$getItemPosition.position,
          increment = _this$getItemPosition.increment;

      var itemsNode = SliderHandler_jsx(SliderHandlerItems, {
        center: center,
        className: className,
        currentIndex: index,
        fadeUnseenItems: fadeUnseenItems,
        hasControls: hasControls,
        isSwiping: isSwiping,
        itemPercentSize: 100 / nbItemsToShow,
        onSwipeEnd: this.onSwipeEnd,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        position: position,
        increment: increment,
        ref: this.sliderRef,
        spacerWidth: spacerWidth
      }, items.map(function (item, idx) {
        return _this4.shouldRenderItem(idx) ? /*#__PURE__*/Object(react["cloneElement"])(item, {
          'aria-hidden': !_this4.isItemVisible(idx),
          tabIndex: -1
        }) : null;
      }).filter(Boolean));

      var childrenProps = {
        hasControls: hasControls,
        index: index,
        isNextControlDisabled: !hasInfiniteScroll && this.isLastItemVisible(),
        isPreviousControlDisabled: !hasInfiniteScroll && this.isFirstItemVisible(),
        itemsNode: itemsNode,
        onNext: this.onNext,
        onPrevious: this.onPrevious,
        onIndex: this.onIndex
      };
      return children(childrenProps);
    }
  }]);

  return SliderHandler;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SliderHandler_SliderHandler, "defaultProps", {
  initialIndex: 0,
  nbItemsToScroll: 1,
  nbItemsToShow: 1,
  spacerWidth: 0
});

/***/ }),

/***/ "A7XF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryPoiResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var countryPoiResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* COUNTRY_POI */ "h"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      config {\n        common { close }\n      }\n      countryPoi(".concat(countryArgs, ") {\n        title\n        description\n        media {\n          mediaUrl\n          mediaAlt\n        }\n        associatedProducts {\n          name\n          href\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_COMMON_COUNTRY_POI */ "xb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "ANQd":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument === 'function';
};


/***/ }),

/***/ "AZSF":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "AaDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productImmersiveResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");






var productImmersiveResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* PRODUCT_IMMERSIVE */ "P"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId,
        _props$tourDurationPl = props.tourDurationPlaceholder,
        tourDurationPlaceholder = _props$tourDurationPl === void 0 ? '' : _props$tourDurationPl,
        _props$cruiseDatesPla = props.cruiseDatesPlaceholder,
        cruiseDatesPlaceholder = _props$cruiseDatesPla === void 0 ? '' : _props$cruiseDatesPla,
        _props$fromToPlacehol = props.fromToPlaceholder,
        fromToPlaceholder = _props$fromToPlacehol === void 0 ? '' : _props$fromToPlacehol,
        _props$dateFormat = props.dateFormat,
        dateFormat = _props$dateFormat === void 0 ? '' : _props$dateFormat;
    var urlParams = location.urlParams;
    var resortArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var cruiseArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildCruiseArgs */ "b"])(urlParams);
    var query = "query {\n      config {\n        common {\n          close\n          galleries {\n            gallery\n            openSlideShowGallery\n            productGallery\n            productPictureItem\n            productNextPicture\n            productPreviousPicture\n          }\n          next\n          photoTitle\n          previous\n          socialPicturesTitle\n          videoTitle\n          video360Title\n        }\n      }\n      cruise(".concat(cruiseArgs, ") {\n        fromToDestination(message: \"").concat(fromToPlaceholder, "\")\n      }\n      media(").concat(resortArgs, ") {\n        photos {url}\n        videos {url thumbnailUrl}\n        videos360 {url thumbnailUrl}\n      }\n      resort(").concat(resortArgs, ") {\n        badgeIcon\n        color\n        comfortLabel\n        dateRange(message: \"").concat(cruiseDatesPlaceholder, "\", dateFormat: \"").concat(dateFormat, "\")\n        destination {\n          country\n          area\n        }\n        duration(message: \"").concat(tourDurationPlaceholder, "\")\n        images\n        isExclusiveCollection\n        isExplicitEC\n        name\n        type\n      }\n      socialPictures(").concat(resortArgs, ") {\n        imageLarge\n        imageSmall\n        userName\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_IMMERSIVE */ "gc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "Akr5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useSyncDepartureCity; });
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("loSl");





var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["constants"].NO_TRANSPORT_VALUE;
function useSyncDepartureCity(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      initialTransport = _ref.initialTransport,
      onChange = _ref.onChange,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_2__[/* useDispatch */ "d"])();

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(initialTransport || NO_TRANSPORT_VALUE),
      inputDepartureCity = _useState[0],
      setInputDepartureCity = _useState[1]; // Store update effect


  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    var newDepartureCity = departureCity;
    var isDepartureCityAvailable = departureCitiesOptions === null || departureCitiesOptions === void 0 ? void 0 : departureCitiesOptions.some(function (_ref2) {
      var value = _ref2.value;
      return value === departureCity;
    });

    if (withValidDepartureCity && newDepartureCity && !isDepartureCityAvailable) {
      newDepartureCity = initialTransport || NO_TRANSPORT_VALUE;
      dispatch(Object(_client_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_4__[/* changeDepartureCity */ "a"])(newDepartureCity));
    } // 1. Sync local state with store updates


    if (inputDepartureCity !== newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    } // 2. Sync criteria validation with store updates


    if (onChange) {
      onChange(newDepartureCity);
    }
  }, [departureCity]);
  return {
    inputDepartureCity: inputDepartureCity,
    setInputDepartureCity: setInputDepartureCity
  };
}

/***/ }),

/***/ "AnR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ setPromoCode; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ addAccommodation; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ addTransport; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ proposals_action_addAdditionalService; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ proposals_action_deleteAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ updateAttendees; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ clearProposals; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ fetchProposalsAndRedirect; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ fetchProposalsById; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ proposals_action_fetchSelectedProposalPayment; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ proposals_action_saveCustomerProposalsHandler; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ updateInsurances; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ deleteInsurances; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ refuseInsuranceAction; });
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ proposals_action_prepareBe; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ displayToastOnContextShare; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ editCriteriaFetchProposals; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ simpleFetchProposals; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ proposals_action_saveDonationToProposals; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ proposals_action_addOrReplaceAdditionalServices; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ proposals_action_switchProposalsOffers; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getSearchCriteria; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/proposal/proposalQuery.js
var proposalQuery = __webpack_require__("70jX");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-query-helper/booking/attendees/attendeesQuery.js
var attendeesQuery = __webpack_require__("Bujb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/utils/graphql-query-helper/booking/insurances/insurancesQuery.js







function updateInsurancesMutation(proposalId, insuranceId, attendees, appContext) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      modifyInsurances (\n      proposalId: \"".concat(proposalId, "\",\n      insuranceId: \"").concat(insuranceId, "\",\n      attendees:   ").concat(Object(graphql["d" /* graphqlify */])(attendees), "\n     ) {\n        proposal {\n          id\n          ").concat(Object(proposalQuery["m" /* proposalPriceQuery */])(), "\n          ").concat(Object(proposalQuery["i" /* insurancesQuery */])(), "\n          ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(Object(lodash["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["td" /* PROPOSAL_UPDATE_INSURANCES */]
  });
}

function deleteInsurancesMutation(proposalId, insuranceId, appContext) {
  return graphqlClient["a" /* default */].runNoCacheQuery("\n    mutation {\n      deleteInsurances (\n      proposalId: \"".concat(proposalId, "\",\n      insuranceId: \"").concat(insuranceId, "\",\n     ) {\n        proposal {\n          id\n          ").concat(Object(proposalQuery["m" /* proposalPriceQuery */])(), "\n          ").concat(Object(proposalQuery["i" /* insurancesQuery */])(), "\n          ").concat(Object(proposalQuery["g" /* getPaymentScheduleRequest */])(appContext), "\n        }\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n      }\n    }\n    ").concat(Object(proposalQuery["h" /* getPriceDetailFragment */])(Object(lodash["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: requestDictionary["hd" /* PROPOSAL_DELETE_INSURANCES */]
  });
}


// EXTERNAL MODULE: ./src/client/store/booking/additional-transports/additionalTransports.action.js
var additionalTransports_action = __webpack_require__("04nu");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./logger/logger.js
var logger = __webpack_require__("zytj");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 1 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/store/booking/proposals/proposals.action.js






















var _BOOKING_ENGINE_ENTRY;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




























var BOOKING_ENGINE_ENTRY_TRACKING_LABELS = (_BOOKING_ENGINE_ENTRY = {}, Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR, 'calendarPrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE, 'remotePrice'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].QUICK_SEARCH, 'quickSearch'), Object(defineProperty["a" /* default */])(_BOOKING_ENGINE_ENTRY, booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING, 'cruiseBooking'), _BOOKING_ENGINE_ENTRY);

function setPromoCode(proposalId, params, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["x" /* SET_PROMO_CODE */], {}, {
    optimist: true,
    promise: Object(proposalQuery["k" /* promoCodeProposalMutation */])(_objectSpread({
      proposalId: proposalId
    }, params), appContext)
  });
}

function fetchProposalsById(_ref) {
  var proposalsId = _ref.proposalsId,
      appContext = _ref.appContext,
      shouldRequestPayment = _ref.shouldRequestPayment,
      adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["k" /* FETCH_PROPOSALS_BY_ID */], {}, {
      optimist: true,
      promise: Object(BookingEngine_query["c" /* proposalsByIdQuery */])({
        proposalsId: proposalsId,
        shouldRequestPayment: shouldRequestPayment,
        adultsAttendeesIds: adultsAttendeesIds,
        kidsAttendeesIds: kidsAttendeesIds,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
      }, appContext)
    }));
  };
}

function getNumberOfAttendees() {
  var nbAdults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var nbKids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var isSeller = arguments.length > 2 ? arguments[2] : undefined;
  var numberOfAttendees = nbAdults + nbKids;
  var maxPaxByUser = isSeller ? faceting_constants["y" /* MAX_PAX_SELLER */] : faceting_constants["x" /* MAX_PAX */];
  /** reset to default adults number if no adults or if the number exceeds the allowed sum (maxPaxByUser) */

  return numberOfAttendees === 0 || numberOfAttendees > maxPaxByUser ? adults_constants["a" /* DEFAULT_ADULTS_NB */] : numberOfAttendees;
}

function getSearchCriteria(_ref2) {
  var _proposal$transports, _proposal$transports2, _inboundTravelSection, _outboundTravelSectio, _inboundTravelSection2, _outboundTravelSectio2, _outboundTravelSectio3, _outboundTravelSectio4;

  var proposal = _ref2.proposal,
      searchedDepartureID = _ref2.searchedDepartureID,
      searchedDepartureDate = _ref2.searchedDepartureDate,
      _ref2$searchByAeropor = _ref2.searchByAeroport,
      searchByAeroport = _ref2$searchByAeropor === void 0 ? false : _ref2$searchByAeropor,
      flightClass = _ref2.flightClass,
      _ref2$directFlights = _ref2.directFlights,
      directFlights = _ref2$directFlights === void 0 ? false : _ref2$directFlights;
  var inboundTravelSection = (_proposal$transports = proposal.transports) === null || _proposal$transports === void 0 ? void 0 : _proposal$transports.inbound.travelSections[0];
  var outboundTravelSection = (_proposal$transports2 = proposal.transports) === null || _proposal$transports2 === void 0 ? void 0 : _proposal$transports2.outbound.travelSections[0];
  var departureSearchId = searchByAeroport ? 'id' : 'cityId';
  return [{
    departure: {
      locationId: searchedDepartureID || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : inboundTravelSection.departure[departureSearchId]),
      date: searchedDepartureDate || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : (_inboundTravelSection = inboundTravelSection.departure) === null || _inboundTravelSection === void 0 ? void 0 : _inboundTravelSection.date)
    },
    arrival: {
      locationId: outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio = outboundTravelSection.departure) === null || _outboundTravelSectio === void 0 ? void 0 : _outboundTravelSectio.cityId
    },
    flightClass: flightClass || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : (_inboundTravelSection2 = inboundTravelSection.transport) === null || _inboundTravelSection2 === void 0 ? void 0 : _inboundTravelSection2["class"]),
    maxConnections: directFlights ? 0 : undefined
  }, {
    departure: {
      locationId: outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio2 = outboundTravelSection.departure) === null || _outboundTravelSectio2 === void 0 ? void 0 : _outboundTravelSectio2.cityId,
      date: outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio3 = outboundTravelSection.departure) === null || _outboundTravelSectio3 === void 0 ? void 0 : _outboundTravelSectio3.date
    },
    arrival: {
      locationId: searchedDepartureID || (inboundTravelSection === null || inboundTravelSection === void 0 ? void 0 : inboundTravelSection.departure[departureSearchId])
    },
    flightClass: flightClass || (outboundTravelSection === null || outboundTravelSection === void 0 ? void 0 : (_outboundTravelSectio4 = outboundTravelSection.transport) === null || _outboundTravelSectio4 === void 0 ? void 0 : _outboundTravelSectio4["class"]),
    maxConnections: directFlights ? 0 : undefined
  }];
}
/*
  ATTENTION:
  Les valeurs par défaut de departureCity et duration sont mises dans le CMS,
  on ne peut donc pas récupérer les valeurs du store
 */


function fetchProposalsAndRedirect(params, appContext, _ref3) {
  var queryParams = _ref3.queryParams;
  return function (dispatch, getState) {
    var _queryParams$kids, _queryParams$kids$spl;

    var state = getState();
    var intArrivalDate = params.newArrivalDate || Object(storeHelper["a" /* getArrivalDate */])(state) || Object(apiDate["l" /* timestampToApiDate */])(state.tripCriteria.departureDate);

    if (!intArrivalDate) {
      // $FlowFixMe
      logger["default"].error('the arrivalDate is required in fetchProposalsAndRedirect action');
      return;
    }

    var adults = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
    var kids = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
    var nbKids = appContext.isSeller ? ((_queryParams$kids = queryParams.kids) === null || _queryParams$kids === void 0 ? void 0 : (_queryParams$kids$spl = _queryParams$kids.split('_')) === null || _queryParams$kids$spl === void 0 ? void 0 : _queryParams$kids$spl.length) || 0 : kids.length;
    var nbAdults = appContext.isSeller ? Number(queryParams.number_of_adults || adults.length) : adults.length;

    var proposalParams = _objectSpread(_objectSpread({
      arrivalDate: intArrivalDate.toString(),
      kids: kids,
      adults: adults,
      numberAttendees: getNumberOfAttendees(nbAdults, nbKids, appContext.isSeller),
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }, appContext.isSeller ? {
      salesNetworkId: queryParams.cxo_sales_network_id
    } : null), params);

    var redirectUri = Object(sellerUtils["e" /* getSigninURIWithRedirection */])({
      locale: appContext.locale,
      proposalId: null,
      step: null,
      isCmta: appContext.isCmta
    });
    /**  Method 5 steps
     * 1. fetch BE i18n config
     * 2. fetch proposal
     * 3. send tracking
     * 4. Set search criteria if transport for MoreTransports
     * 5. redirect to signin redirection URL
     */

    /* 1. fetch BE i18n config */

    dispatch(Object(cms_actions["c" /* getBookingEngineI18n */])(appContext));
    /* 2. fetch proposal */

    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* FETCH_PROPOSALS */], {
      globalLoaderLabel: params.globalLoaderLabel,
      bookingEngineEntry: params.bookingEngineEntry
    }, {
      optimist: true,
      promise: Object(proposalQuery["n" /* proposalsQuery */])(proposalParams, appContext).then(function (response) {
        var _proposals$errors, _proposals$errors$;

        var proposals = response.proposals;
        var isFetchProposalsFailed = Object(proposalUtils["s" /* hasFetchProposalsFailed */])(proposals);

        if (!isFetchProposalsFailed) {
          /* 4. Set search criteria if transport for MoreTransports */
          // this was added to save the selected departureCity which can either be the cityID or the aeroportID
          if (params.departureCity) {
            var _proposals$proposals = Object(slicedToArray["a" /* default */])(proposals.proposals, 1),
                firstProposal = _proposals$proposals[0];

            dispatch(Object(additionalTransports_action["n" /* setSearchCriteria */])(getSearchCriteria({
              proposal: firstProposal,
              searchedDepartureID: params.departureCity,
              searchedDepartureDate: params.newArrivalDate
            })));
          }

          var bookingUrl = Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals || [], proposals.resort, undefined, queryParams);
          /* 5. redirect to signin redirection URL */
          // $FlowFixMe

          redirectUtils["a" /* default */].redirectTo()(bookingUrl);
        }

        var errorCode = proposals === null || proposals === void 0 ? void 0 : (_proposals$errors = proposals.errors) === null || _proposals$errors === void 0 ? void 0 : (_proposals$errors$ = _proposals$errors[0]) === null || _proposals$errors$ === void 0 ? void 0 : _proposals$errors$.errorCode;
        tracking_api["b" /* setDataLayer */]({
          categoryGA: 'resort',
          actionGA: BOOKING_ENGINE_ENTRY_TRACKING_LABELS[params.bookingEngineEntry],
          labelGA: isFetchProposalsFailed ? "errorCheckPrices".concat(errorCode ? "_".concat(Object(lodash["snakeCase"])(errorCode).toUpperCase()) : '') : 'checkPrices'
        }, appContext);
        return response;
      }),
      redirect_uri: redirectUri
    }));
  };
}

function editCriteriaFetchProposals(criteria, proposalsLoderLabel, appContext, location) {
  return function (dispatch, getState) {
    var search = criteria.search,
        departure = criteria.departure,
        attendees = criteria.attendees,
        departureCity = criteria.departureCity;
    var payload = {
      globalLoaderLabel: proposalsLoderLabel
    };
    var state = getState();
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["l" /* FETCH_PROPOSALS_FROM_EDIT_CRITERIA */], payload, {
      optimist: true,
      promise: Object(proposalQuery["n" /* proposalsQuery */])(_objectSpread({
        productId: search.value,
        arrivalDate: moment_default()(departure.date).format('YYYYMMDD'),
        duration: departure.duration,
        departureCity: departureCity.value,
        numberAttendees: attendees.adults + attendees.kids.length,
        adults: new Array(attendees.adults).fill({}),
        // $FlowFixMe
        kids: attendees.kids,
        isJoyView: criteria.isJoyView,
        fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities'),
        adultsAttendeesIds: state.tripInformation.adults.map(function (_ref4) {
          var neolid = _ref4.neolid;
          return neolid;
        }).filter(Boolean),
        kidsAttendeesIds: state.tripInformation.kids.map(function (_ref5) {
          var neolid = _ref5.neolid;
          return neolid;
        }).filter(Boolean)
      }, appContext.isSeller ? {
        salesNetworkId: location.queryParams.cxo_sales_network_id
      } : null), appContext)
    }));
  };
}

function simpleFetchProposals(criterias, proposalsLoaderLabel, appContext, location) {
  var productId = criterias.productId,
      arrivalDate = criterias.arrivalDate,
      duration = criterias.duration,
      attendees = criterias.attendees,
      departureCity = criterias.departureCity,
      bookingEngineEntry = criterias.bookingEngineEntry;
  var payload = {
    globalLoaderLabel: proposalsLoaderLabel,
    bookingEngineEntry: bookingEngineEntry
  };

  var sellerParams = _objectSpread(_objectSpread({}, Object(ContactInfoUtils["e" /* getAllAttendeesIds */])({
    adults: attendees.adults,
    kids: attendees.kids
  })), {}, {
    salesNetworkId: location.queryParams.cxo_sales_network_id
  });

  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["j" /* FETCH_PROPOSALS */], payload, {
    optimist: true,
    promise: Object(proposalQuery["n" /* proposalsQuery */])(_objectSpread(_objectSpread({}, appContext.isSeller ? sellerParams : null), {}, {
      productId: productId,
      arrivalDate: arrivalDate,
      duration: duration,
      departureCity: departureCity,
      numberAttendees: attendees.adults.length + attendees.kids.length,
      // $FlowFixMe
      adults: attendees.adults,
      // $FlowFixMe
      kids: attendees.kids,
      fetchActivityCategories: Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.displayActivities')
    }), appContext)
  });
}

function addTransport(transportId, proposalsId, isJoyview, appContext, globalLoaderLabel, toastLabel) {
  return function (dispatch) {
    // TODO show a toast if error
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["e" /* ADD_TRANSPORT */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel,
      transportId: transportId
    }, {
      optimist: true,
      promise: Object(proposalQuery["c" /* addTransportMutation */])(transportId, proposalsId, isJoyview, appContext)
    }));
  };
}

function displayToastOnContextShare(toastLabel) {
  return {
    type: proposals_constants["i" /* DISPLAY_TOAST_ON_CONTEXT_SHARE */],
    payload: {
      toastLabel: toastLabel
    }
  };
}

function addAccommodation(_ref6) {
  var arrangement = _ref6.arrangement,
      proposalsId = _ref6.proposalsId,
      isJoyview = _ref6.isJoyview,
      appContext = _ref6.appContext,
      globalLoaderLabel = _ref6.globalLoaderLabel,
      toastLabel = _ref6.toastLabel;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["a" /* ADD_ACCOMMODATION */], {
      globalLoaderLabel: globalLoaderLabel,
      toastLabel: toastLabel
    }, {
      optimist: true,
      promise: Object(proposalQuery["a" /* addAccommodationMutation */])(arrangement, proposalsId, isJoyview, appContext)
    }));
  };
}

function updateAttendees(_ref7) {
  var proposalId = _ref7.proposalId,
      attendees = _ref7.attendees,
      appContext = _ref7.appContext;
  return function (dispatch) {
    return Object(attendeesQuery["b" /* updateAttendeesMutation */])({
      proposalId: proposalId,
      attendees: attendees,
      appContext: appContext
    }).then(function (data) {
      // $FlowFixMe it can be modifyAttendeesSellerMultipleFamilies or modifyAttendees
      var payload = Object.values(data)[0];
      var errors = payload.errors;

      if (errors) {
        // We don't do anything specific with the errors, but this will let us display per field errors
        logger["default"].error(errors[0]);
        var error = new Error('Unhandled field form error'); // $FlowFixMe we need the errorCode for tracking

        error.errors = errors;
        throw error;
      }

      var neolaneId = Object(lodash["get"])(payload, 'proposal.attendees.list[0].customerId');

      var cookieToSet = _objectSpread(_objectSpread({}, tracking_storage_api["a" /* get */](constants["d" /* BE_TRACKING */])), {}, {
        neolaneId: neolaneId,
        BE_customerStatus: payload.customerStatus
      });

      tracking_storage_api["b" /* set */](cookieToSet);
      dispatch(Object(createAction["b" /* default */])(proposals_constants["B" /* UPDATE_ATTENDEES */], payload));
    });
  };
}

function updateInsurances(proposalId, insuranceId, attendees, app) {
  return function (dispatch) {
    return updateInsurancesMutation(proposalId, insuranceId, attendees, app).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["C" /* UPDATE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["o" /* INSURANCE_ADDED */], insuranceId));
    });
  };
}

function deleteInsurances(proposalId, insuranceId, app) {
  return function (dispatch) {
    return deleteInsurancesMutation(proposalId, insuranceId, app).then(function (payload) {
      dispatch(Object(createAction["b" /* default */])(proposals_constants["g" /* DELETE_INSURANCES */], payload));
      dispatch(Object(createAction["b" /* default */])(proposals_constants["p" /* INSURANCE_DELETED */], insuranceId));
    });
  };
}

function refuseInsuranceAction(insuranceId) {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(proposals_constants["p" /* INSURANCE_DELETED */], insuranceId));
  };
}

function clearProposals() {
  return Object(createAction["b" /* default */])(proposals_constants["f" /* CLEAR_PROPOSALS */]);
}

var proposals_action_fetchSelectedProposalPayment = function fetchSelectedProposalPayment(selectedProposal, appContext) {
  return Object(createAction["a" /* createOptimisticAction */])(proposals_constants["m" /* FETCH_SELECTED_PROPOSAL_PAYMENT */], {
    selectedProposalId: selectedProposal.id
  }, {
    optimist: true,
    promise: Object(proposalQuery["f" /* fetchPayment */])(selectedProposal.id, appContext)
  });
};

var proposals_action_saveCustomerProposalsHandler = function saveCustomerProposalsHandler(proposalId, appContext, customerId) {
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["v" /* SAVE_CUSTOMER_PROPOSAL */], {}, {
      optimist: true,
      promise: Object(sellerUtils["j" /* saveCustomerProposal */])(proposalId, appContext, customerId)
    }));
  };
};

var proposals_action_addOrReplaceAdditionalServices = function addOrReplaceAdditionalServices(_ref8) {
  var proposalIds = _ref8.proposalIds,
      attendees = _ref8.attendees,
      _ref8$showNotificatio = _ref8.showNotification,
      showNotification = _ref8$showNotificatio === void 0 ? false : _ref8$showNotificatio,
      appContext = _ref8.appContext;
  return function (dispatch, getState) {
    var proposal = Object(booking_selector["l" /* getCurrentProposal */])(getState());
    var servicesIds = attendees.map(function (_ref9) {
      var productInfoId = _ref9.productInfoId;
      return productInfoId;
    });
    var additionalServicesValues = Object.values(proposal.additionalServices);
    var isUpdatingAlreadyReservedService = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref10) {
          var pricingInfo = _ref10.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.isPartiallyRented;
        })
      );
    });
    var newReservedServiceToastLabel = additionalServicesValues.some(function (oldServices) {
      return (// $FlowFixMe
        oldServices.some(function (_ref11) {
          var pricingInfo = _ref11.pricingInfo;
          return servicesIds.includes(pricingInfo.id) && pricingInfo.type === 'RENTAL';
        })
      );
    }) ? 'booking.activities.skiEquipment.newEquipmentSelection' : 'booking.activities.newActivitySelection';
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["D" /* UPDATE_SERVICES */], showNotification ? {
      toastLabel: isUpdatingAlreadyReservedService ? 'booking.activities.activityUpdate' : newReservedServiceToastLabel
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["o" /* putServicesMutation */])(proposalIds, attendees, appContext)
    }));
  };
};

var proposals_action_deleteAdditionalServices = function deleteAdditionalServices(_ref12) {
  var proposalIds = _ref12.proposalIds,
      serviceIds = _ref12.serviceIds,
      attendeeIds = _ref12.attendeeIds,
      _ref12$showNotificati = _ref12.showNotification,
      showNotification = _ref12$showNotificati === void 0 ? false : _ref12$showNotificati,
      overloadForSpecificProposalIds = _ref12.overloadForSpecificProposalIds,
      appContext = _ref12.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["h" /* DELETE_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["e" /* deleteServicesMutation */])({
        proposalIds: proposalIds,
        serviceIds: serviceIds,
        attendeeIds: attendeeIds,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_addAdditionalService = function addAdditionalService(_ref13) {
  var proposalIds = _ref13.proposalIds,
      serviceId = _ref13.serviceId,
      attendeeIds = _ref13.attendeeIds,
      schedules = _ref13.schedules,
      _ref13$showNotificati = _ref13.showNotification,
      showNotification = _ref13$showNotificati === void 0 ? false : _ref13$showNotificati,
      overloadForSpecificProposalIds = _ref13.overloadForSpecificProposalIds,
      appContext = _ref13.appContext;
  return function (dispatch) {
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["c" /* ADD_SERVICE */], showNotification ? {
      toastLabel: 'booking.activities.activityUpdate'
    } : {}, {
      optimist: true,
      promise: Object(proposalQuery["b" /* addServiceMutation */])({
        proposalIds: proposalIds,
        serviceId: serviceId,
        attendeeIds: attendeeIds,
        schedules: schedules,
        overloadForSpecificProposalIds: overloadForSpecificProposalIds,
        appContext: appContext
      })
    }));
  };
};

var proposals_action_prepareBe = function prepareBe(payload) {
  return Object(createAction["b" /* default */])(proposals_constants["q" /* PREPARE_BE */], payload);
};

var proposals_action_saveDonationToProposals = function saveDonationToProposals(donation) {
  return function (dispatch) {
    dispatch({
      type: proposals_constants["w" /* SAVE_DONATION_TO_PROPOSALS */],
      payload: donation
    });
  };
};

var proposals_action_switchProposalsOffers = function switchProposalsOffers(offers, appContext) {
  return function (dispatch, getState) {
    var state = getState();
    var proposals = Object(booking_selector["D" /* proposalsSelector */])(state); // TODO : remove filter when proposals array in store is fixed and does not include a random object

    var proposalsIds = proposals.map(function (_ref14) {
      var id = _ref14.id;
      return id;
    }).filter(function (id) {
      return !!id;
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(proposals_constants["z" /* SWITCH_PROPOSALS_OFFERS */], {}, {
      optimist: true,
      promise: Object(proposalQuery["p" /* switchProposalsOffers */])(proposalsIds, offers, appContext)
    }));
  };
};



/***/ }),

/***/ "B3yO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return keywordsSelector; });
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_2__);




var searchSelector = function searchSelector(_ref) {
  var search = _ref.search;
  return search || {};
};

var querySelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(searchSelector, function (_ref2) {
  var query = _ref2.query;
  return query || {};
});
var keywordsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_2__["createSelector"])(querySelector, function (_ref3) {
  var keywords = _ref3.keywords;
  return keywords;
});


/***/ }),

/***/ "BRr/":
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__("ZLJe")),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__("8PLQ")),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ "BU6i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return WECHAT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PAYMENT_METHOD_CREDIT_CARD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PAYMENT_METHOD_CARD_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ECYBERSOURCE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIPAY_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ESSPSCT_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ESSPSDD_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NODELCRERE_TRANSFER_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NODELCRERE_CHEQUE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HIPAY_CMTA_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EGLOBALCOLLECT_PSP_ID; });
/* unused harmony export OGONE_CMTA_PSP_ID */
/* unused harmony export OGONE_PSP_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PAYMENT_METHOD_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BANK_TRANSFER_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHEQUE_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREDIT_CARD_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return VOXPAY_PSP_ID_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return VOXPAY_PHONE_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return VOXPAY_PHONE_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return VOXPAY_EMAIL_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return VOXPAY_EMAIL_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return VOXPAY_SMS_PSP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return VOXPAY_SMS_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NAPAY_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PROVIDER_ID_EVOPAY_PREFIX; });
var WECHAT_PSP_ID = 'M99BILLW';
var PAYMENT_METHOD_CREDIT_CARD_CATEGORY = 'CreditCard';
var PAYMENT_METHOD_CARD_CATEGORY = 'card';
var CYBERSOURCE_PSP_ID = 'MCYBERSOURCE';
var ECYBERSOURCE_PSP_ID = 'ECYBERSOURCE';
var HIPAY_PSP_ID = 'MHIPAY';
var ESSPSCT_PSP_ID = 'ESSPSCT'; // TRANSFER

var ESSPSDD_PSP_ID = 'ESSPSDD'; // DEBIT

var NODELCRERE_TRANSFER_PSP_ID = 'NODELCRERE_TRANSFER'; // TRANSFER

var NODELCRERE_CHEQUE_PSP_ID = 'NODELCRERE_CHEQUE'; // DEBIT

var HIPAY_CMTA_PSP_ID = 'EHIPAYCMTA';
var EGLOBALCOLLECT_PSP_ID = 'EGLOBALCOLLECT'; // DEBIT

var OGONE_CMTA_PSP_ID = 'MOGONE';
var OGONE_PSP_ID = 'EOGONE';
var PAYMENT_METHOD_LABEL = 'paymentMethodLabel';
var BANK_TRANSFER_LABEL = 'Bank Transfer';
var CHEQUE_LABEL = 'Cheque';
var CREDIT_CARD_LABEL = 'Credit Card';
var VOXPAY_PSP_ID_PREFIX = 'EVOXPAY';
var VOXPAY_PHONE_PSP_ID = 'EVOXPAY_PHONE';
var VOXPAY_PHONE_LABEL = 'Phone';
var VOXPAY_EMAIL_PSP_ID = 'EVOXPAY_EMAIL';
var VOXPAY_EMAIL_LABEL = 'Email';
var VOXPAY_SMS_PSP_ID = 'EVOXPAY_SMS';
var VOXPAY_SMS_LABEL = 'Sms';
var NAPAY_LABEL = 'NAPAY';
var PROVIDER_ID_EVOPAY_PREFIX = 'EVOXPAY';

/***/ }),

/***/ "BXQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return titleAndTextResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var titleAndTextResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TITLE_AND_TEXT */ "Fb"],
  resolve: function resolve() {
    var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = "query {\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "d"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "BYx+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profileFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commonProfileFieldsFragment; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kH/m");


var documentFragment = "{ issuingDate\n  expirationDate\n  nationality\n  documentNumber\n  issuingCountry\n  birthCountry\n  type }";
var profileFragment = "\n  fragment BookingProfile on Profile {\n    optinEmail\n    optinSms\n    optinPhone\n    optinMail\n    optinClubmedPlus\n    address {\n      ...Address\n    }\n    document {\n      passport {\n        ...".concat(documentFragment, "\n      }\n      idcard{\n        ...").concat(documentFragment, "\n      }\n    }\n    passport {\n      issuingDate\n      expirationDate\n      nationality\n      documentNumber\n    }\n   dateOfBirth\n   civility\n   mobilePhoneNumber\n  }\n  ").concat(_utils_graphql_query_helper_address_addressQuery__WEBPACK_IMPORTED_MODULE_1__[/* addressFragment */ "a"], "\n");
/**
 * Common fields between adults and children
 * customerId is used as temp id, till being override by real proposal attendees id
 * see addSearchDataToAttendees
 *  */

var commonProfileFieldsFragment = "\n  fragment CommonProfileFields on Profile {\n    birthdate:dateOfBirth\n    civility\n    firstName\n    gmNumber\n    id:customerId \n    lastName\n    neolid:customerId\n    unicodeFirstName\n    unicodeLastName\n  }\n";


/***/ }),

/***/ "Bcqe":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("RNvQ"),
    isObject = __webpack_require__("tQYX");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "Bg8+":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("L1Xj");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "BhBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlternativeProposalsModal; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("sRdV");
/* harmony import */ var _alternative_proposals_AlternativeProposals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("YRNe");
/* harmony import */ var _frameworks_side_panel_SidePanel_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("p7XS");
/* harmony import */ var _alternative_proposals_AlternativeProposalsUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("/nu6");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ub5k");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;







function AlternativeProposalsModal(_ref) {
  var trackingDefaultPayload = _ref.trackingDefaultPayload,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, ["trackingDefaultPayload"]);

  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"]);
  var modal = Object(react__WEBPACK_IMPORTED_MODULE_1__["useRef"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_3__[/* useTracking */ "a"])(trackingDefaultPayload);
  var proposal = props.proposals[0];
  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    var trackingData = Object(_alternative_proposals_AlternativeProposalsUtils__WEBPACK_IMPORTED_MODULE_6__[/* getSuggestionsTrackingData */ "b"])({
      proposal: proposal,
      suggestions: props.suggestions,
      appContext: appContext,
      disableAlternativePrice: props.disableAlternativePrice
    });
    track(trackingData);
  }, [proposal]);
  return __jsx(_frameworks_side_panel_SidePanel_jsx__WEBPACK_IMPORTED_MODULE_5__[/* SidePanel */ "a"], {
    ariaLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('booking.counterProposalPopIn.rateCounterProposalTitle'),
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* t */ "h"])('common.close'),
    isExpanded: true,
    onClose: function onClose(event) {
      if (modal.current && !modal.current.contains(event.target)) {
        props.onClose();
        track({
          labelGA: 'exit'
        });
      }
    }
  }, __jsx("div", {
    ref: modal
  }, __jsx(_alternative_proposals_AlternativeProposals__WEBPACK_IMPORTED_MODULE_4__[/* AlternativeProposals */ "a"], props)));
}

/***/ }),

/***/ "BthO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMustTryExperiencesResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");







var productMustTryExperiencesResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* MUST_TRY_EXPERIENCES */ "y"],
  props: function props(appContext) {
    return {
      isFrench: appContext.locale.startsWith('fr')
    };
  },
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_3__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n      mustTryExperiences(".concat(productArgs, ") {\n        description\n        id\n        image\n        title\n      }\n      resort(resortId: \"").concat(productId, "\") {\n        color\n        icon\n        name\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_MUST_TRY_EXPERIENCES */ "mc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {
      return {
        mustTryExperiences: []
      };
    });
  }
};

/***/ }),

/***/ "Bujb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateAttendeesMutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queryBookingAttendees; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("PIvV");
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("NLwV");
/* harmony import */ var _proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("70jX");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");
/* harmony import */ var _date_apiDate__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("ldK3");
/* harmony import */ var _seller_sellerUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("KL6I");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var ATTENDEE_SCHEMA_PROPERTIES = ['id', 'gmNumber', 'lastName', 'firstName', 'unicodeLastName', 'unicodeFirstName', 'birthdate', 'email', 'mobile', 'optinSms', 'optinMail', 'optinFosun', 'optinEmail', 'optinPhone', 'optinClubmedPlus', 'civility', 'identityNumber', 'healthPassId', 'travelDocuments', 'customerId', 'address', 'mainContactId', 'isChild'];
/**
 * Remove all properties that don't match GQL Schema Otherwise the mutation fails
 */

var removeUselessProperties = function removeUselessProperties(attendee) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_11__["pick"])(attendee, ATTENDEE_SCHEMA_PROPERTIES);
};
/**
 * Connected customer experience : Put attendees
 */


function updateAttendeesMutation(_ref) {
  var proposalId = _ref.proposalId,
      attendees = _ref.attendees,
      appContext = _ref.appContext;
  var formatedAttendees = attendees.map(function (attendee) {
    return removeUselessProperties(_objectSpread(_objectSpread({}, attendee), {}, {
      customerId: attendee.neolid,
      birthdate: Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_16__[/* timestampToApiDate */ "l"])(attendee.birthdate),
      travelDocuments: attendee.document ? Object.keys(attendee.document).reduce(function (fullDocuments, type) {
        var document = attendee.document[type] || {}; // all fields starting with document require document_id

        if (!Object(lodash__WEBPACK_IMPORTED_MODULE_11__["isEmpty"])(document)) {
          var newDocument = {};

          if (document.nationality) {
            newDocument.nationality = document.nationality || undefined;
          }

          if (document.documentNumber) {
            newDocument.document_number = document.documentNumber || undefined;
            newDocument.issuing_country = (document === null || document === void 0 ? void 0 : document.issuingCountry) || undefined;
            newDocument.birth_country = (document === null || document === void 0 ? void 0 : document.birthCountry) || undefined;
            newDocument.expiration_date = Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_16__[/* timestampToApiDate */ "l"])(document === null || document === void 0 ? void 0 : document.expirationDate) || undefined;
            newDocument.issuing_date = Object(_date_apiDate__WEBPACK_IMPORTED_MODULE_16__[/* timestampToApiDate */ "l"])(document === null || document === void 0 ? void 0 : document.issuingDate) || undefined;
          }

          if (document.nationality || document.documentNumber) {
            newDocument.type = (document === null || document === void 0 ? void 0 : document.type) || undefined;
          }

          if (!Object(lodash__WEBPACK_IMPORTED_MODULE_11__["isEmpty"])(newDocument)) {
            fullDocuments.push(newDocument);
          }
        }

        return fullDocuments;
      }, []) : []
    }));
  });
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runNoCacheQuery("\n    mutation {\n      ".concat(Object(_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_17__[/* isSellerAndInMultiplesFamiliesContext */ "h"])(appContext, attendees) ? 'modifyAttendeesSellerMultipleFamilies' : 'modifyAttendees', " (\n      proposalId: \"").concat(proposalId, "\",\n      attendees: ").concat(Object(_graphql__WEBPACK_IMPORTED_MODULE_13__[/* graphqlify */ "d"])(formatedAttendees), "\n     ) {\n        proposal {\n          id\n          attendees {\n            list {\n              id\n              customerId\n              householdId\n              civility\n              firstName\n              lastName\n              email\n            }\n          }\n          ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_14__[/* proposalPriceQuery */ "m"])(), "\n          ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_14__[/* getPaymentScheduleRequest */ "g"])(appContext), "\n        }\n        ").concat(appContext.isDirectCxo || appContext.isIndirectCxo ? '' : 'customerStatus', "\n        errors {\n          errorKey\n          errorValue\n          errorCode\n        }\n        ").concat(appContext.isDirectCxo || appContext.isIndirectCxo ? "attendees {\n                id\n                gmNumber\n                customerId\n              }" : '', "\n      }\n    }\n    ").concat(Object(_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_14__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_11__["get"])(appContext, 'locale')), "\n    "), appContext, {
    requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* PROPOSAL_UPDATE_ATTENDEES */ "sd"]
  });
}

var queryBookingAttendees = function queryBookingAttendees(bookingId) {
  return _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"].runQuery("query {\n    bookingAttendees(bookingId: ".concat(bookingId, ") {\n      civility\n      gmNumber\n      customerId\n      identityNumber\n      healthPassId\n      mainContact\n      lastName\n      unicodeLastName\n      firstName\n      unicodeFirstName\n      email\n      birthdate\n    }\n  }"));
};



/***/ }),

/***/ "C2l2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productInformationSummaryResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productInformationSummaryResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_INFORMATION_SUMMARY */ "Q"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {resort(".concat(productArgs, ") {factSheetUrl}}");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_INFORMATION_SUMMARY */ "hc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "C56r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("eGzU");
var isObject = __webpack_require__("1YFU");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aCallable(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "C5R2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDuration; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _duration_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("RBvG");


function setDuration(value) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_duration_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DURATION */ "c"], {
    value: value
  });
}

/***/ }),

/***/ "C8GU":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");
var toString = __webpack_require__("vnfA");
var requireObjectCoercible = __webpack_require__("4gXF");

// `String.prototype.codePointAt` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "C9cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IS_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IS_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IS_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProductBadgeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRentalAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getServiceAgesLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getServiceAgesLabelTranslateOptions; });
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("UCZK");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");


var IS_DISABLED = 'isDisabled';
var IS_ENABLED = 'isEnabled';
var IS_SELECTED = 'isSelected';

var getProductBadgeIcon = function getProductBadgeIcon(_ref) {
  var badgeIcon = _ref.badgeIcon,
      color = _ref.color,
      comfortLabel = _ref.comfortLabel;
  return {
    alt: comfortLabel || '',
    color: _color_colors__WEBPACK_IMPORTED_MODULE_0__[/* COLORS */ "a"].WHITE,
    colorBg: color,
    colorBorder: color,
    iconName: badgeIcon
  };
};

var getServiceAgesLabel = function getServiceAgesLabel(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    });
  }

  if (min < 23 && max && max > 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  });
};

function getServiceAgesLabelTranslateOptions(ageInMonths) {
  var min = ageInMonths.min,
      max = ageInMonths.max;

  if (min > 23) {
    return ['booking.services.childcare.kidsAgeInYears', {
      min: Math.floor(min / 12),
      max: max ? Math.floor(max / 12) : ''
    }];
  }

  if (min < 23 && max && max > 23) {
    return ['booking.services.childcare.kidsAgeInMonthsAndYears', {
      min: min,
      max: Math.floor(max / 12)
    }];
  }

  return ['booking.services.childcare.kidsAgeInMonths', {
    min: min,
    // $FlowFixMe 🤬
    max: max
  }];
}

var getRentalAgesLabel = function getRentalAgesLabel(ageInMonths) {
  if (!ageInMonths || !ageInMonths.min) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.activities.forAllAges');
  }

  if (ageInMonths.max) {
    return getServiceAgesLabel(ageInMonths);
  }

  if (ageInMonths.min < 23) {
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.activities.ageFromMonths', {
      amount: ageInMonths.min
    });
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('booking.activities.ageFrom', {
    age: Math.floor(ageInMonths.min / 12)
  });
};



/***/ }),

/***/ "CGO5":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("87KK").f;
var has = __webpack_require__("DZWw");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "DOIJ":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "DQFb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageSlideShow; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("u/u4");
/* harmony import */ var _arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Gy6l");
/* harmony import */ var _backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("NZxu");
/* harmony import */ var _image_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("0IQ5");
/* harmony import */ var _slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("A5Hi");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;







var ImageSlideShow = function ImageSlideShow(_ref) {
  var center = _ref.center,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      fadeUnseenItems = _ref.fadeUnseenItems,
      galleryLabel = _ref.galleryLabel,
      _ref$groupKey = _ref.groupKey,
      groupKey = _ref$groupKey === void 0 ? 'thumbnails' : _ref$groupKey,
      hasControlsOnHover = _ref.hasControlsOnHover,
      hasFullScreenMode = _ref.hasFullScreenMode,
      hasOverlappingControls = _ref.hasOverlappingControls,
      hasInfiniteScroll = _ref.hasInfiniteScroll,
      hasInsetBorder = _ref.hasInsetBorder,
      hasLazyLoading = _ref.hasLazyLoading,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      _ref$nbItemsToShow = _ref.nbItemsToShow,
      nbItemsToShow = _ref$nbItemsToShow === void 0 ? 1 : _ref$nbItemsToShow,
      nextLabel = _ref.nextLabel,
      onChangeIndex = _ref.onChangeIndex,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].XL : _ref$ratio,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 1 : _ref$ratioDisplay,
      _ref$spacerWidth = _ref.spacerWidth,
      spacerWidth = _ref$spacerWidth === void 0 ? 0 : _ref$spacerWidth;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(false),
      isFullScreen = _useState[0],
      setIsFullScreen = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_2__["useState"])(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  if (!media.length) {
    return null;
  }

  var updateActiveIndex = function updateActiveIndex(index) {
    setActiveIndex(index);
  };

  var gk = hasFullScreenMode ? null : groupKey;
  var items = media.filter(function (_ref2) {
    var src = _ref2.src;
    return Boolean(src);
  }).map(function (_ref3) {
    var _ref3$alt = _ref3.alt,
        alt = _ref3$alt === void 0 ? '' : _ref3$alt,
        _onClick = _ref3.onClick,
        src = _ref3.src;

    var children = __jsx(_image_Image__WEBPACK_IMPORTED_MODULE_7__[/* default */ "b"], {
      altMsg: alt,
      groupKey: gk,
      hasInsetBorder: hasInsetBorder,
      hasLazyLoading: hasLazyLoading,
      imageUrl: src,
      key: src,
      ratioKey: ratio,
      ratioDisplay: ratioDisplay,
      spacerWidth: ratioDisplay
    });

    var isButton = hasFullScreenMode || _onClick;
    return __jsx(react__WEBPACK_IMPORTED_MODULE_2__["Fragment"], {
      key: "Image-".concat(src)
    }, isButton ? __jsx("button", {
      className: "block h-full reset-button w-full",
      onClick: function onClick() {
        _onClick && _onClick();

        if (hasFullScreenMode) {
          setIsFullScreen(true);
        }
      },
      type: "button"
    }, children) : __jsx("div", {
      className: "h-full"
    }, children));
  });
  return __jsx(_slider_handler_SliderHandler__WEBPACK_IMPORTED_MODULE_8__[/* SliderHandler */ "a"], {
    center: center,
    fadeUnseenItems: fadeUnseenItems,
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items,
    nbItemsToShow: nbItemsToShow,
    onChangeIndex: updateActiveIndex,
    spacerWidth: spacerWidth
  }, function (_ref4) {
    var hasControls = _ref4.hasControls,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        itemsNode = _ref4.itemsNode,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'group relative')
    }, itemsNode, hasControls && __jsx("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('transition-opacity will-change-transform absolute flex items-center justify-between m-auto inset-0 pointer-events-none w-full z-2', {
        'px-px10 sm:px-px20': !hasOverlappingControls
      }, {
        'group-hover:opacity-100 opacity-0': hasControlsOnHover
      }),
      "data-testid": "ImageSlideShow-controls-parent"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_5__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('rtl:mr-auto pointer-events-auto shadow-sm z-2', {
        '-translate-x-50': hasOverlappingControls
      }),
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_5__[/* ArrowButton */ "a"], {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('rtl:ml-auto pointer-events-auto shadow-sm z-2', {
        'translate-x-50': hasOverlappingControls
      }),
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasFullScreenMode && isFullScreen && __jsx(_backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_6__[/* Backdrop */ "a"], {
      ariaLabel: galleryLabel,
      closeLabel: closeLabel,
      hasCloseButton: true,
      onClose: function onClose() {
        return setIsFullScreen(false);
      }
    }, __jsx("div", {
      className: "relative w-full"
    }, itemsNode, hasControls && __jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-px10 sm:px-px20 w-full"
    }, !isPreviousControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_5__[/* ArrowButton */ "a"], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-2",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && __jsx(_arrow_button_ArrowButton__WEBPACK_IMPORTED_MODULE_5__[/* ArrowButton */ "a"], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-2",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })))));
  });
};

/***/ }),

/***/ "DSo7":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "DVx9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-string-prototype-matchall -- safe */
var $ = __webpack_require__("ax0f");
var createIteratorConstructor = __webpack_require__("Lj86");
var requireObjectCoercible = __webpack_require__("cww3");
var toLength = __webpack_require__("tJVe");
var aFunction = __webpack_require__("hpdy");
var anObject = __webpack_require__("FXyv");
var classof = __webpack_require__("amH4");
var isRegExp = __webpack_require__("jl0/");
var getRegExpFlags = __webpack_require__("q/0V");
var createNonEnumerableProperty = __webpack_require__("WxKw");
var fails = __webpack_require__("ct80");
var wellKnownSymbol = __webpack_require__("fVMg");
var speciesConstructor = __webpack_require__("Qzre");
var advanceStringIndex = __webpack_require__("4/YM");
var InternalStateModule = __webpack_require__("zc29");
var IS_PURE = __webpack_require__("DpO5");

var MATCH_ALL = wellKnownSymbol('matchAll');
var REGEXP_STRING = 'RegExp String';
var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
var RegExpPrototype = RegExp.prototype;
var regExpBuiltinExec = RegExpPrototype.exec;
var nativeMatchAll = ''.matchAll;

var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
  'a'.matchAll(/./);
});

var regExpExec = function (R, S) {
  var exec = R.exec;
  var result;
  if (typeof exec == 'function') {
    result = exec.call(R, S);
    if (typeof result != 'object') throw TypeError('Incorrect exec result');
    return result;
  } return regExpBuiltinExec.call(R, S);
};

// eslint-disable-next-line max-len -- ignore
var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, global, fullUnicode) {
  setInternalState(this, {
    type: REGEXP_STRING_ITERATOR,
    regexp: regexp,
    string: string,
    global: global,
    unicode: fullUnicode,
    done: false
  });
}, REGEXP_STRING, function next() {
  var state = getInternalState(this);
  if (state.done) return { value: undefined, done: true };
  var R = state.regexp;
  var S = state.string;
  var match = regExpExec(R, S);
  if (match === null) return { value: undefined, done: state.done = true };
  if (state.global) {
    if (String(match[0]) == '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
    return { value: match, done: false };
  }
  state.done = true;
  return { value: match, done: false };
});

var $matchAll = function (string) {
  var R = anObject(this);
  var S = String(string);
  var C, flagsValue, flags, matcher, global, fullUnicode;
  C = speciesConstructor(R, RegExp);
  flagsValue = R.flags;
  if (flagsValue === undefined && R instanceof RegExp && !('flags' in RegExpPrototype)) {
    flagsValue = getRegExpFlags.call(R);
  }
  flags = flagsValue === undefined ? '' : String(flagsValue);
  matcher = new C(C === RegExp ? R.source : R, flags);
  global = !!~flags.indexOf('g');
  fullUnicode = !!~flags.indexOf('u');
  matcher.lastIndex = toLength(R.lastIndex);
  return new $RegExpStringIterator(matcher, S, global, fullUnicode);
};

// `String.prototype.matchAll` method
// https://tc39.es/ecma262/#sec-string.prototype.matchall
$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
  matchAll: function matchAll(regexp) {
    var O = requireObjectCoercible(this);
    var flags, S, matcher, rx;
    if (regexp != null) {
      if (isRegExp(regexp)) {
        flags = String(requireObjectCoercible('flags' in RegExpPrototype
          ? regexp.flags
          : getRegExpFlags.call(regexp)
        ));
        if (!~flags.indexOf('g')) throw TypeError('`.matchAll` does not allow non-global regexes');
      }
      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll.apply(O, arguments);
      matcher = regexp[MATCH_ALL];
      if (matcher === undefined && IS_PURE && classof(regexp) == 'RegExp') matcher = $matchAll;
      if (matcher != null) return aFunction(matcher).call(regexp, O);
    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll.apply(O, arguments);
    S = String(O);
    rx = new RegExp(regexp, 'g');
    return IS_PURE ? $matchAll.call(rx, S) : rx[MATCH_ALL](S);
  }
});

IS_PURE || MATCH_ALL in RegExpPrototype || createNonEnumerableProperty(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ }),

/***/ "DZWw":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("A+R+");

var hasOwnProperty = {}.hasOwnProperty;

module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};


/***/ }),

/***/ "DuXo":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "DwNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormFeedback; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("RUiN");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var BEACON_SELECTOR = 'FormFeedbackBeacon';
var FormFeedback = function FormFeedback(_ref) {
  var className = _ref.className,
      hasAutoScroll = _ref.hasAutoScroll,
      isError = _ref.isError,
      message = _ref.message;
  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (hasAutoScroll) {
      Object(_utils_scroll_scrollToElement__WEBPACK_IMPORTED_MODULE_3__[/* scrollToElement */ "a"])("[data-testid=\"".concat(BEACON_SELECTOR, "\"]"));
    }
  }, []);
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'flex font-bold items-center leading-one my-px10 text-base', "".concat(isError ? 'text-danger' : 'text-success')),
    "data-testid": BEACON_SELECTOR
  }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('flex-shrink-0 rtl:mr-px10', {
      'pt-px5 px-px5': !isError
    }),
    name: isError ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].WARNING : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_2__[/* ICONS */ "a"].STRAIGHT_CHECK,
    width: "1.25rem"
  }), __jsx("span", {
    "data-testid": "FormFeedback-message"
  }, message));
};

/***/ }),

/***/ "E8Xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return capitalizeFromUppercase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return capitalize; });
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);



function capitalize(string) {
  if (!string) {
    return '';
  }

  return string[0].toUpperCase() + string.slice(1);
}

var capitalizeFromUppercase = function capitalizeFromUppercase(str) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["upperFirst"])(str.toLowerCase());
};


/***/ }),

/***/ "ELg1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductFlag_ProductFlag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.themes.js
var themes = {
  thumbnail: {
    thPriceFrom: 'font-sans text-sm sm:text-base text-gray-darker px-px5',
    thPriceTheme: 'thumbnail'
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx

var __jsx = react_default.a.createElement;






var ProductFlag_ProductFlag = function ProductFlag(_ref) {
  var _ref$isLinkDisabled = _ref.isLinkDisabled,
      isLinkDisabled = _ref$isLinkDisabled === void 0 ? false : _ref$isLinkDisabled,
      _ref$isPriceLoading = _ref.isPriceLoading,
      isPriceLoading = _ref$isPriceLoading === void 0 ? false : _ref$isPriceLoading,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      _ref$onCtaClick = _ref.onCtaClick,
      onCtaClick = _ref$onCtaClick === void 0 ? lodash["noop"] : _ref$onCtaClick,
      _ref$onEmptyPriceClic = _ref.onEmptyPriceClick,
      onEmptyPriceClick = _ref$onEmptyPriceClic === void 0 ? lodash["noop"] : _ref$onEmptyPriceClic,
      _ref$onPriceClick = _ref.onPriceClick,
      onPriceClick = _ref$onPriceClick === void 0 ? lodash["noop"] : _ref$onPriceClick,
      _ref$price = _ref.price,
      price = _ref$price === void 0 ? {} : _ref$price,
      _ref$priceInfo = _ref.priceInfo,
      priceInfo = _ref$priceInfo === void 0 ? {} : _ref$priceInfo,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'thumbnail' : _ref$theme;

  if (Object(lodash["isEmpty"])(price)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thPriceFrom = _themes$theme.thPriceFrom,
      thPriceTheme = _themes$theme.thPriceTheme;
  var hasPrice = !isPriceLoading && (!!price.initialPrice || !!price.bestPrice);

  var handleEmptyPriceClick = function handleEmptyPriceClick() {
    onEmptyPriceClick && onEmptyPriceClick();

    if (!isLinkDisabled) {
      onClick && onClick();
    }
  };

  var handlePriceClick = function handlePriceClick() {
    onPriceClick && onPriceClick();
  };

  var handleProductPriceModalOnClickButton = function handleProductPriceModalOnClickButton() {
    onCtaClick && onCtaClick();
    onClick && onClick();
  };

  var priceNode = __jsx("span", {
    className: "flex items-center justify-end w-full"
  }, Object(price_util["d" /* hasAtLeastOnePrice */])(price) && __jsx("span", {
    className: thPriceFrom
  }, price.from), __jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "flex items-center h-full rounded-tiny",
    "data-testid": "ProductFlag-price",
    from: null,
    isLoading: isPriceLoading,
    onClick: hasPrice ? handlePriceClick : handleEmptyPriceClick,
    theme: thPriceTheme
  })));

  return hasPrice ? __jsx(ProductPriceModal["a" /* ProductPriceModal */], Object(esm_extends["a" /* default */])({
    className: "m-px5 z-2"
  }, priceInfo, {
    onClickButton: handleProductPriceModalOnClickButton
  }), priceNode) : __jsx("div", {
    className: "m-px5"
  }, priceNode);
};

/***/ }),

/***/ "ENE1":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("IBsm");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "EWLr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickOutside; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ClickOutside = function ClickOutside(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$shard = _ref.shard,
      shard = _ref$shard === void 0 ? {} : _ref$shard,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children", "className", "onClick", "shard"]);

  var ref = Object(react__WEBPACK_IMPORTED_MODULE_2__["useRef"])(null);
  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    var onClickOutside = function onClickOutside(e) {
      var current = ref.current;
      var shardElement = shard.current;
      var clickedElement = e.target;

      if (current && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return function () {
      document.removeEventListener('click', onClickOutside);
    };
  }, [children]);
  return __jsx("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: className,
    ref: ref
  }), children);
};

/***/ }),

/***/ "Ed3r":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__("dNjr");
var $getOwnPropertyNames = __webpack_require__("8D46").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "EvYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Modal_Modal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.themes.js
var MAX_HEIGHT = '70vh';
var sizes = {
  auto: 'auto',
  small: '23.75rem',
  medium: '40rem',
  large: '50rem'
};
var themes = function themes(_ref) {
  var size = _ref.size;
  return {
    "default": {
      thRoot: 'fadeIn flex relative scaleIn',
      thRootStyles: {
        width: sizes[size],
        maxWidth: '100%',
        maxHeight: MAX_HEIGHT,
        minHeight: 100
      },
      thCloseButton: 'absolute bg-white border-1 cursor-pointer leading-none top-0 mb-px10 rtl:right-0 p-px5 reset-button rounded-full z-1',
      thCloseButtonLabel: 'sr-only',
      thCloseButtonStyles: {
        top: 'auto',
        bottom: '100%',
        width: 40,
        height: 40
      },
      thBody: 'bg-white max-h-full relative z-1 overflow-hidden rounded-small md:rounded-tiny shadow w-full',
      thBodyStyles: {
        maxHeight: MAX_HEIGHT
      },
      // ⚠️ relative is only needed to prevent a weird bug of reflow on chrome
      thContent: 'max-h-full overflow-auto relative w-full',
      thAddendum: 'max-h-full fixed bottom-0 inset-x-0 overflow-hidden rounded-small md:rounded-tiny shadow w-full',
      thAddendumStyles: {
        maxHeight: MAX_HEIGHT
      },
      thAddendumContent: 'max-h-full overflow-auto relative w-full'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/modal/Modal.jsx

var __jsx = react_default.a.createElement;






var Modal_Modal = function Modal(_ref) {
  var addendum = _ref.addendum,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      id = _ref.id,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$withCloseButton = _ref.withCloseButton,
      withCloseButton = _ref$withCloseButton === void 0 ? true : _ref$withCloseButton;
  var modalButtonRef = Object(react["useRef"])();
  var closeBtnModal = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  Object(react["useEffect"])(function () {
    modalButtonRef.current && modalButtonRef.current.focus();
  }, []);
  var _themes$theme = themes({
    size: size
  })[theme],
      thAddendum = _themes$theme.thAddendum,
      thAddendumStyles = _themes$theme.thAddendumStyles,
      thAddendumContent = _themes$theme.thAddendumContent,
      thBody = _themes$theme.thBody,
      thBodyStyles = _themes$theme.thBodyStyles,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyles = _themes$theme.thCloseButtonStyles,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thContent = _themes$theme.thContent,
      thRoot = _themes$theme.thRoot,
      thRootStyles = _themes$theme.thRootStyles;
  return __jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    bgColor: backdropColor,
    onClose: onClose,
    opacity: backdropOpacity,
    portalName: portalName
  }, __jsx("aside", {
    className: thRoot,
    id: id,
    style: thRootStyles
  }, withCloseButton && __jsx("button", {
    className: thCloseButton,
    "data-testid": "Modal-close",
    onClick: onClose,
    ref: modalButtonRef,
    style: thCloseButtonStyles,
    type: "button"
  }, closeBtnModal && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnModal), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), __jsx("div", {
    className: thBody,
    style: thBodyStyles
  }, __jsx("div", {
    className: classnames_default()(className, thContent)
  }, children)), addendum && __jsx("div", {
    className: thAddendum,
    style: thAddendumStyles
  }, __jsx("div", {
    className: classnames_default()(className, thAddendumContent)
  }, addendum))));
};

/***/ }),

/***/ "F9U4":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var classof = __webpack_require__("XywU");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "Fe0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export grid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateProductLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateLinkProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return localeHasCmtaLinks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateCmtaLinkProp; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("igjW");





var grid = {
  mobile: 1,
  phablet: 2,
  tablet: 3,
  desktop: 3
};
var generateProductLink = function generateProductLink(url, offer) {
  var newLink = offer && offer.seoName ? new urijs__WEBPACK_IMPORTED_MODULE_2___default.a(url).addSearch(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["appQueryParameters"].shopping.offer, _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeSlug(offer.seoName)).toString() : url;
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["url"].normalizeUrl(newLink);
};
var generateLinkProp = function generateLinkProp(url, offer) {
  return url ? {
    url: generateProductLink(url, offer),
    queryParamsToIgnore: offer ? [] : ['offer']
  } : undefined;
};
var localeHasCmtaLinks = function localeHasCmtaLinks(cmtaLinks) {
  return cmtaLinks && cmtaLinks.cmtaIntegLink && cmtaLinks.cmtaStagingLink && cmtaLinks.cmtaProdLink;
};
var generateCmtaLinkProp = function generateCmtaLinkProp(resortId, cmtaLinks) {
  var cmtaIntegLink = cmtaLinks.cmtaIntegLink,
      cmtaStagingLink = cmtaLinks.cmtaStagingLink,
      cmtaProdLink = cmtaLinks.cmtaProdLink;
  var cmtaUrl = cmtaProdLink;

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyIntegrationEnv */ "e"])()) {
    cmtaUrl = cmtaIntegLink;
  }

  if (Object(_utils_context_contextUtils__WEBPACK_IMPORTED_MODULE_4__[/* isStrictlyStagingEnv */ "g"])()) {
    cmtaUrl = cmtaStagingLink;
  }

  return {
    url: cmtaUrl + resortId,
    isExternalLink: true
  };
};

/***/ }),

/***/ "Fk4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTotalDifferentialPrice; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("2srY");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("u6DZ");
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("fO+d");
/* harmony import */ var lodash_unionWith__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_unionWith__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _additionalTransports_action__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("04nu");
/* harmony import */ var _cities_cities_action__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("bDrE");
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("wz9x");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var getTotalDifferentialPrice = function getTotalDifferentialPrice() {
  var price1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var price2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var locale = arguments.length > 2 ? arguments[2] : undefined;
  var diff = price1 - price2;
  return {
    value: diff,
    formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_18__[/* formatAmountForLocale */ "b"])(diff, locale)
  };
};
var sortPath = 'inbound.transportInfo.price.value';

var updateAlternativeTransports = function updateAlternativeTransports(_ref) {
  var selectedTransportId = _ref.selectedTransportId,
      state = _ref.state; // we do not change this value to keep track of the proposal's selected transport

  var proposalTransport = _objectSpread({}, state.proposalTransport); // fetched Alternative transports from api


  var previousAlternativeTransports = Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(state.alternativeTransports); // current selected which also is the first recommended


  var currentSelectedTransport = _objectSpread({}, state.selectedTransport); // searching by id


  var selectedInboundInAlternative = previousAlternativeTransports.find(function (_ref2) {
    var inbound = _ref2.inbound;
    return inbound.transportInfo.id === selectedTransportId;
  }); // if it's not an alternative then we have selected the current selected (in the right)

  var newSelectedTransport = selectedInboundInAlternative || currentSelectedTransport;
  var proposalInAlternative = false;
  var currenAlternativeTransports = previousAlternativeTransports.map(function (_ref3) {
    var inbound = _ref3.inbound,
        outboundList = _ref3.outboundList,
        transportNumber = _ref3.transportNumber;

    if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_16__[/* isSameJourney */ "m"])(inbound, proposalTransport.inbound)) {
      proposalInAlternative = true; // the same selected recommended and alternative should have the same outboundlist

      var sameOutboundList = lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default()(lodash_unionWith__WEBPACK_IMPORTED_MODULE_14___default()(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(proposalTransport.outboundList), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(outboundList), _additionalTransports_action__WEBPACK_IMPORTED_MODULE_16__[/* isSameJourney */ "m"]), sortPath); // if the proposal's transport was selected && there's a similar inbound in alternative transports

      if (Object(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_16__[/* isSameJourney */ "m"])(proposalTransport.inbound, newSelectedTransport.inbound)) {
        newSelectedTransport.outboundList = sameOutboundList;
      }

      return {
        inbound: inbound,
        outboundList: sameOutboundList,
        transportNumber: transportNumber
      };
    }

    return {
      inbound: inbound,
      outboundList: outboundList,
      transportNumber: transportNumber
    };
  });

  if (!proposalInAlternative && proposalTransport.inbound.transportInfo.id !== newSelectedTransport.inbound.transportInfo.id) {
    // after selecting an inbound, if the proposal's transport is not in the list we should add it to be able to find it afterwards
    currenAlternativeTransports.push(proposalTransport);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    // keep selectedTransportId in redux store
    selectedTransportId: selectedTransportId,
    selectedTransport: newSelectedTransport,
    alternativeTransports: Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default()(currenAlternativeTransports, sortPath))
  });
};

var initialState = {
  alternativeTransports: [],
  selectedTransport: {},
  selectedTransportId: null,
  cityTransports: {
    loading: false,
    cityId: null,
    data: {
      airports: [],
      trainStations: [],
      ports: []
    }
  }
};

var hasAvailabilityCheckedWithAmadeus = function hasAvailabilityCheckedWithAmadeus(transport) {
  return (// the flight class should always be present, even for clubmed charter for which we have almost no data
    !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(transport, 'inbound.journey.travelSections.0.transport.class'))
  );
};

function transportsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (lodash_get__WEBPACK_IMPORTED_MODULE_12___default()(action, 'type')) {
    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_15__["resolve"])(_additionalTransports_action__WEBPACK_IMPORTED_MODULE_16__[/* FETCH_ADDITIONAL_TRANSPORTS */ "d"]):
      var _action$payload = action.payload,
          additionalTransports = _action$payload.additionalTransports,
          selectedTransport = _action$payload.selectedTransport;
      var alternativeTransports = lodash_sortBy__WEBPACK_IMPORTED_MODULE_13___default()(additionalTransports.filter(hasAvailabilityCheckedWithAmadeus), sortPath).map(function (transport, index) {
        return _objectSpread(_objectSpread({}, transport), {}, {
          transportNumber: index + 1
        });
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedTransport: selectedTransport,
        proposalTransport: selectedTransport,
        alternativeTransports: alternativeTransports,
        selectedTransportId: null
      });

    case _additionalTransports_action__WEBPACK_IMPORTED_MODULE_16__[/* UPDATE_SELECTED_TRANSPORT */ "j"]:
      var selectedTransportId = action.payload.selectedTransportId;
      return updateAlternativeTransports({
        selectedTransportId: selectedTransportId,
        state: state
      });

    case _cities_cities_action__WEBPACK_IMPORTED_MODULE_17__[/* FETCH_CITY_TRANSPORTS */ "a"]:
      return _objectSpread(_objectSpread({}, state), {}, {
        cityTransports: _objectSpread(_objectSpread({}, state.cityTransports), {}, {
          loading: true,
          cityId: action.payload
        })
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_15__["resolve"])(_cities_cities_action__WEBPACK_IMPORTED_MODULE_17__[/* FETCH_CITY_TRANSPORTS */ "a"]):
      return _objectSpread(_objectSpread({}, state), {}, {
        cityTransports: _objectSpread(_objectSpread({}, state.cityTransports), {}, {
          data: action.payload
        })
      });

    case Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_15__["reject"])(_cities_cities_action__WEBPACK_IMPORTED_MODULE_17__[/* FETCH_CITY_TRANSPORTS */ "a"]):
      return _objectSpread(_objectSpread({}, state), {}, {
        cityTransports: _objectSpread({}, state.cityTransports)
      });

    default:
      return state;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (transportsReducer);

/***/ }),

/***/ "Fmrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirmation; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("jD8k");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;









var getDefaultIcon = function getDefaultIcon(status) {
  return status === 'success' ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CONFIRMATION : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].WARNING;
};

var Confirmation = function Confirmation(_ref) {
  var _ref$button = _ref.button,
      button = _ref$button === void 0 ? {} : _ref$button,
      className = _ref.className,
      icon = _ref.icon,
      link = _ref.link,
      status = _ref.status,
      text = _ref.text,
      title = _ref.title;

  if (!status || !title) {
    return null;
  }

  var colors = {
    error: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].RED,
    neutral: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE,
    success: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].EMERALD
  };
  var iconName = icon ? icon : getDefaultIcon(status);
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'flex items-start sm:items-center sm:px-px20 py-px20')
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('leading-none rtl:mr-px20 text-sm sm:text-xl', "text-".concat(colors[status]))
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    name: iconName,
    width: "4em"
  })), __jsx("div", {
    className: "flex-auto"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('font-bold text-md sm:text-xl', "text-".concat(colors[status]))
  }, title), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    text: text
  }), __jsx("div", {
    className: "flex flex-col-reverse\tsm:flex-row sm:items-start"
  }, __jsx(_frameworks_text_link_TextLink__WEBPACK_IMPORTED_MODULE_9__[/* TextLink */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, link, {
    className: "mt-px10 sm:rtl:mr-auto"
  })), button && button.children && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, button, {
    className: "my-px10"
  }), button.children))));
};

/***/ }),

/***/ "GJxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "listen", function() { return /* binding */ index_es_listen; });
__webpack_require__.d(__webpack_exports__, "subscribe", function() { return /* binding */ index_es_subscribe; });
__webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return /* binding */ index_es_unsubscribe; });

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/assign.js
var lodash_assign = __webpack_require__("whR3");
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: /opt/webapp/node_modules/eventemitter3/index.js
var eventemitter3 = __webpack_require__("Gpi5");
var eventemitter3_default = /*#__PURE__*/__webpack_require__.n(eventemitter3);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/supportPassiveEvent.js
/* global window */

var passiveSupported = false; // eslint-disable-line import/no-mutable-exports

if (typeof window !== 'undefined') {
  try {
    var supportPassiveEvent_options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passiveSupported = true;
      }
    });

    window.addEventListener('test', null, supportPassiveEvent_options);
    window.removeEventListener('test', null, supportPassiveEvent_options);
  } catch (err) {} // eslint-disable-line no-empty
}

/* harmony default export */ var supportPassiveEvent = (passiveSupported);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/globalVars.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




/* harmony default export */ var globalVars = ({
  connections: {},
  EE: new eventemitter3_default.a(),
  enableResizeInfo: false,
  enableScrollInfo: false,
  listeners: {},
  removers: [],
  supportPassiveEvent: supportPassiveEvent
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/listen.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */




var listen_supportPassiveEvent = globalVars.supportPassiveEvent;


var defaultEventOption = {
  capture: false,
  passive: false
};

/**
 * Cross-browser addEventListener.
 * @method listen
 * @param {Object} target - The target to add event listener.
 * @param {String} eventType - The event type.
 * @param {Function} handler - The event handler.
 * @param {Object} handler - The options object that specifies
 * characteristics about the event listener.
 * @return {Object} The object to be able to remove the handler.
 */
function listen(target, eventType, handler, options) {
  var add = 'addEventListener';
  var _remove = 'removeEventListener';
  var type = eventType;

  var eventOptions = listen_supportPassiveEvent ? assign_default()({}, defaultEventOption, options) : false;

  if (!target.addEventListener && target.attachEvent) {
    add = 'attachEvent';
    _remove = 'detachEvent';
    type = 'on' + eventType;
  }
  target[add](type, handler, eventOptions);

  return {
    remove: function remove() {
      target[_remove](eventType, handler);
    }
  };
}

/* harmony default export */ var lib_listen = (listen);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/leIE8.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global navigator, parseFloat */

// less then or equal to IE8
var leIE8 = false; // eslint-disable-line import/no-mutable-exports

if (typeof navigator !== 'undefined') {
  var matches = navigator.userAgent.match(/MSIE (\d+\.\d+)/);
  if (matches) {
    leIE8 = parseFloat(matches[1], 10) < 9;
  }
}

/* harmony default export */ var lib_leIE8 = (leIE8);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/clone.js
var clone = __webpack_require__("zr3P");
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("Bcqe");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/noop.js
var noop = __webpack_require__("nnm9");
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/AugmentedEvent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document */



var resize = { // eslint-disable-line prefer-const
  width: 0,
  height: 0
};
var AugmentedEvent_scroll = { // eslint-disable-line prefer-const
  delta: 0,
  top: 0
};
var touch = { // eslint-disable-line prefer-const
  axisIntention: '',
  startX: 0,
  startY: 0,
  deltaX: 0,
  deltaY: 0
};

var INTENTION_THRESHOLD = 5;

var getXY = function getXY(pos) {
  var t = { x: 0, y: 0 }; // eslint-disable-line prefer-const
  var docBody = document.body;
  var docEl = document.documentElement;

  if (pos.pageX || pos.pageY) {
    t.x = pos.pageX;
    t.y = pos.pageY;
  } else {
    t.x = pos.clientX + docBody.scrollLeft + docEl.scrollLeft;
    t.y = pos.clientY + docBody.scrollTop + docEl.scrollTop;
  }

  return t;
};

/**
 * ArgmentedEvent will hold some global information, such like window scroll postion,
 * so that those information is only calculated once.
 * @param {Object} option - The option for SyntheticEvent
 */

var AugmentedEvent_AugmentedEvent = function () {
  function AugmentedEvent() {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AugmentedEvent);

    var mainType = (option.mainType || '').toLowerCase();
    var subType = (option.subType || '').toLowerCase();

    this.mainType = mainType;
    this.subType = subType;
    this.type = mainType + subType.charAt(0).toUpperCase() + subType.slice(1) || '';
    this.scroll = AugmentedEvent_scroll;
    this.resize = resize;
    this.touch = touch;
  }

  _createClass(AugmentedEvent, [{
    key: 'update',
    value: function update(e) {
      var mainType = this.mainType,
          subType = this.subType;

      var docEl = document.documentElement;

      if (globalVars.enableScrollInfo && (mainType === 'scroll' || mainType === 'touchmove')) {
        var top = docEl.scrollTop + document.body.scrollTop;
        // Prevent delta from being 0
        if (top !== this.scroll.top) {
          this.scroll.delta = top - this.scroll.top;
          this.scroll.top = top;
        }
      }
      if (globalVars.enableResizeInfo && mainType === 'resize') {
        this.resize.width = window.innerWidth || docEl.clientWidth;
        this.resize.height = window.innerHeight || docEl.clientHeight;
      }
      if (globalVars.enableTouchInfo && e.touches && (mainType === 'touchstart' || mainType === 'touchmove' || mainType === 'touchend')) {
        var pos = void 0;
        var absX = void 0;
        var absY = void 0;
        if (mainType === 'touchstart' || subType === 'start') {
          pos = getXY(e.touches[0]);
          this.touch.axisIntention = '';
          this.touch.startX = pos.x;
          this.touch.startY = pos.y;
          this.touch.deltaX = 0;
          this.touch.deltaY = 0;
        } else if (mainType === 'touchmove') {
          pos = getXY(e.touches[0]);
          this.touch.deltaX = pos.x - this.touch.startX;
          this.touch.deltaY = pos.y - this.touch.startY;
          if (this.touch.axisIntention === '') {
            absX = Math.abs(this.touch.deltaX);
            absY = Math.abs(this.touch.deltaY);
            if (absX > INTENTION_THRESHOLD && absX >= absY) {
              this.touch.axisIntention = 'x';
            } else if (absY > INTENTION_THRESHOLD && absY > absX) {
              this.touch.axisIntention = 'y';
            }
          }
        }
      }
    }
  }]);

  return AugmentedEvent;
}();

/* harmony default export */ var dist_es_AugmentedEvent = (AugmentedEvent_AugmentedEvent);

// EXTERNAL MODULE: /opt/webapp/node_modules/raf/index.js
var raf = __webpack_require__("0xii");
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/lib/rAFThrottle.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var getTime = Date.now ||
/* istanbul ignore next */function () {
  return new Date().getTime();
};

function rAFThrottle(func) {
  var throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;

  var context = void 0;
  var args = void 0;
  var last = 0;
  var requestId = 0;

  var later = function later() {
    var now = getTime();
    var remaining = throttle - (now - last);

    if (remaining <= 0) {
      last = now;
      requestId = 0;
      func.apply(context, args);
    } else {
      requestId = raf_default()(later);
    }
  };

  return function throttledFunc() {
    context = this;
    args = arguments; // eslint-disable-line prefer-rest-params

    if (!requestId) {
      requestId = raf_default()(later);
    }
  };
}

/* harmony default export */ var lib_rAFThrottle = (rAFThrottle);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/constants.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var EVENT_END_DELAY = 100;
var DEFAULT_THROTTLE_RATE = 50;

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/mainEventConnectors.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global window, document, setTimeout */











// constants


var connections = globalVars.connections,
    EE = globalVars.EE,
    listeners = globalVars.listeners,
    removers = globalVars.removers;

// global variables

var doc = void 0;
var win = void 0;
var body = void 0;
var hashId = 0;

if (typeof window !== 'undefined') {
  win = window;
  doc = win.document || document;
  body = doc.body;
}

function getHash(domNode) {
  return domNode.id || 'target-id-' + hashId++; // eslint-disable-line
}

/**
 * Connect a throttled event to a throttled main event, and return an event remover.
 * The number of connections to a throttled main event will be kept. If all throttled events
 * are removed, then remove throttled main event.
 * @method connectThrottle
 * @param {String} throttledEvent - A throttled event
 * @param {Function} cb - Callback function
 * @param {Object} ctx - The "this"
 * @param {String} throttledMainEvent - A throttled main event
 * @return {Object} An event remover
 */
function connectThrottle(throttledEvent, cb, ctx, throttledMainEvent) {
  EE.on(throttledEvent, cb || noop_default.a, ctx);
  throttledMainEvent = throttledMainEvent || throttledEvent;
  connections[throttledMainEvent] = (connections[throttledMainEvent] || 0) + 1;
  return {
    _type: throttledEvent,
    _cb: cb,
    _ctx: ctx,
    unsubscribe: function unsubscribe() {
      if (!this._type) {
        return;
      }

      EE.removeListener(throttledEvent, cb, ctx);
      connections[throttledMainEvent]--;
      if (connections[throttledMainEvent] === 0) {
        listeners[throttledMainEvent].remove();
        listeners[throttledMainEvent] = undefined;
      }

      this._type = undefined;
      this._cb = undefined;
      this._ctx = undefined;

      // remove the remover from removers array
      for (var i = removers.length - 1; i >= 0; i--) {
        var remover = removers[i];
        if (remover === this) {
          removers.splice(i, 1);
          break;
        }
      }
    }
  };
}

/**
 * Connect to event, event start and event end.
 * @method connectContinuousEvent
 * @param {Object} target - The target of a main event, window or document.
 * @param {String} mainEvent - A browser event, like scroll or resize.
 * @param {String} event - A subscribe event.
 * @param {Object} eventOptions - An options pass to event listener
 */
function connectContinuousEvent(target, mainEvent, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);
    var targetPart = domId ? ':' + domId : '';

    var throttledStartEvent = mainEvent + 'Start:' + throttleRate + targetPart;
    var throttledEndEvent = mainEvent + 'End:' + throttleRate + targetPart;
    var throttledMainEvent = mainEvent + ':' + throttleRate + targetPart;
    var throttledEvent = event + ':' + throttleRate + targetPart;

    var remover = connectThrottle(throttledEvent, cb, context, throttledMainEvent);
    removers.push(remover);

    if (listeners[throttledMainEvent]) {
      return remover;
    }

    var ae = {
      start: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'start' }), // start
      main: new dist_es_AugmentedEvent({ mainType: mainEvent }), // main
      end: new dist_es_AugmentedEvent({ mainType: mainEvent, subType: 'end' })
    };

    // No throttle for throttleRate = 0
    // end
    if (throttleRate === 'raf') {
      throttleRate = 16; // Set as a number for setTimeout later.
      handler = lib_rAFThrottle(handler);
    } else if (throttleRate > 0) {
      handler = throttle_default()(handler, throttleRate);
    }

    var timer = void 0;
    function endCallback(e) {
      ae.end.update(e);
      EE.emit(throttledEndEvent, e, ae.end);
      timer = null;
    }
    function handler(e) {
      if (!timer) {
        ae.start.update(e);
        EE.emit(throttledStartEvent, e, ae.start);
      }
      clearTimeout(timer);

      ae.main.update(e);
      EE.emit(throttledMainEvent, e, ae.main);
      if (!lib_leIE8) {
        timer = setTimeout(endCallback.bind(null, e), throttleRate + EVENT_END_DELAY);
      } else {
        // For browser less then and equal to IE8, event object need to be cloned for setTimeout.
        timer = setTimeout(function () {
          endCallback(clone_default()(e));
        }, throttleRate + EVENT_END_DELAY);
      }
    }

    listeners[throttledMainEvent] = lib_listen(domTarget || target, mainEvent, handler, eventOptions);
    return remover;
  };
}

function connectDiscreteEvent(target, event) {
  return function throttleEvent(throttleRate, cb, options, eventOptions) {
    var context = options.context;
    var domTarget = options.target;
    var domId = domTarget && getHash(domTarget);

    // no throttling for discrete event
    var throttledEvent = event + ':0' + (domId ? ':' + domId : '');

    var remover = connectThrottle(throttledEvent, cb, context);
    removers.push(remover);

    if (listeners[throttledEvent]) {
      return remover;
    }

    var ae = new dist_es_AugmentedEvent({ mainType: event });

    function handler(e) {
      ae.update(e);
      EE.emit(throttledEvent, e, ae);
    }

    listeners[throttledEvent] = lib_listen(domTarget || target, event, handler, eventOptions);
    return remover;
  };
}

/* harmony default export */ var mainEventConnectors = ({
  scrollStart: connectContinuousEvent(win, 'scroll', 'scrollStart'),
  scrollEnd: connectContinuousEvent(win, 'scroll', 'scrollEnd'),
  scroll: connectContinuousEvent(win, 'scroll', 'scroll'),
  resizeStart: connectContinuousEvent(win, 'resize', 'resizeStart'),
  resizeEnd: connectContinuousEvent(win, 'resize', 'resizeEnd'),
  resize: connectContinuousEvent(win, 'resize', 'resize'),
  visibilitychange: connectDiscreteEvent(doc, 'visibilitychange'),
  touchmoveStart: connectContinuousEvent(body, 'touchmove', 'touchmoveStart'),
  touchmoveEnd: connectContinuousEvent(body, 'touchmove', 'touchmoveEnd'),
  touchmove: connectContinuousEvent(body, 'touchmove', 'touchmove'),
  touchstart: connectDiscreteEvent(body, 'touchstart'),
  touchend: connectDiscreteEvent(body, 'touchend')
});

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/subscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


 // less then or equal to IE8


// constants


/**
 * Subscribe to UI events.
 * @method subscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 * @param {Object} options.context - The caller.
 * @param {Number} options.throttleRate - The amount of time for throttling.
 * @param {Boolean} options.useRAF - Use rAF for throttling if true.
 * @param {Object} options.eventOptions - Option to pass to event listener
 * @return {Object} The object with unsubscribe function.
 */
function subscribe(type, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var useRAF = options.useRAF || false;
  var throttleRate = parseInt(options.throttleRate, 10);
  var eventOptions = options.eventOptions;

  if (isNaN(throttleRate)) {
    throttleRate = DEFAULT_THROTTLE_RATE;
  }

  if (useRAF) {
    throttleRate = 'raf';
  }

  // turn off throttle if the browser is IE8 or less, because window.event will be reset
  // when using any delayed function, i.g., setTimeout, or rAF.
  if (lib_leIE8) {
    throttleRate = 0;
  }

  // once those variables enabled, then never disabled.
  globalVars.enableScrollInfo = globalVars.enableScrollInfo || options.enableScrollInfo || false;
  globalVars.enableResizeInfo = globalVars.enableResizeInfo || options.enableResizeInfo || false;
  globalVars.enableTouchInfo = globalVars.enableTouchInfo || options.enableTouchInfo || false;

  return mainEventConnectors[type](throttleRate, cb, options, eventOptions);
}

/* harmony default export */ var dist_es_subscribe = (subscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/dist-es/unsubscribe.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */



var unsubscribe_removers = globalVars.removers;

/**
 * Unsubscribe to UI events.
 * @method unsubscribe
 * @param {String} type - The type of event.
 * @param {Function} cb - The callback function.
 */

function unsubscribe(type, cb) {
  var remover = void 0;
  for (var i = unsubscribe_removers.length - 1; i >= 0; i -= 1) {
    remover = unsubscribe_removers[i];
    if (remover._cb === cb && remover._type.indexOf(type) >= 0) {
      remover.unsubscribe();
      unsubscribe_removers.splice(i, 1);
    }
  }
}

/* harmony default export */ var dist_es_unsubscribe = (unsubscribe);

// CONCATENATED MODULE: /opt/webapp/node_modules/subscribe-ui-event/index.es.js
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */





var IS_CLIENT = typeof window !== 'undefined';

function warn() {
  if (false) {}
}

var index_es_listen = IS_CLIENT ? lib_listen : warn;
var index_es_subscribe = IS_CLIENT ? dist_es_subscribe : warn;
var index_es_unsubscribe = IS_CLIENT ? dist_es_unsubscribe : warn;


/***/ }),

/***/ "GZ82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Technically, this is not related to the address, since it can work with any type of validationSchema
// but other form of schemas, might not be object. So here we went for the simplest case, the one we
// use, i.e. address
var validationSchemaAddressFragment = "\n fragment ValidationSchemaAddress on SchemaValidationFieldInterface {\n  name\n  ...on ValidationSchemaObjectField {\n    fields {\n      display\n      name\n      required\n      validators {\n        name\n        value\n      }\n    }\n  }\n }\n";
/* harmony default export */ __webpack_exports__["a"] = (validationSchemaAddressFragment);

/***/ }),

/***/ "GZgf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRICE_OF_STAY_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_PRICE_OF_STAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_SERVICES_REQUEST; });
var PRICE_OF_STAY_REQUEST = 'PRICE_OF_STAY_REQUEST';
var RESET_PRICE_OF_STAY = 'RESET_PRICE_OF_STAY';
var ALL_INCLUSIVE_SERVICES_REQUEST = 'ALL_INCLUSIVE_SERVICES_REQUEST';

/***/ }),

/***/ "Go22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaWhen; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("zygG");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("uDfI");
/* harmony import */ var _frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("EvYw");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("SPKZ");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("393O");
/* harmony import */ var _filter_when_FilterWhen__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("qLhN");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("+Rc+");
/* harmony import */ var _trip_date_picker_day_with_price_DayPriceDoubleSeasonPopin__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("uMuQ");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("Ub5k");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kiXb");
/* harmony import */ var _store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("05PS");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("loSl");
/* harmony import */ var _hooks_use_block_input_departure_date_useBlockInputDepartureDate__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("VQ9C");
/* harmony import */ var _store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("fflk");
/* harmony import */ var _store_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("RBvG");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("RBO1");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_date_apiDate_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("KL6I");




var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

























var selector = function selector(state) {
  return {
    departureDate: state.tripCriteria.departureDate,
    duration: state.tripCriteria.duration
  };
};

var CriteriaWhen = function CriteriaWhen(props) {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_6__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_17__[/* default */ "b"]);

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_6__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_13__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_14__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* useSelector */ "e"])(selector),
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration;

  var intialDuration = Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* useSelector */ "e"])(_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_19__[/* getInitialDuration */ "k"]);
  var checkIfDepartureDateIsBookable = props.checkIfDepartureDateIsBookable,
      prices = props.prices,
      product = props.product,
      withFlexibility = props.withFlexibility;

  var _useBlockInputDepartu = Object(_hooks_use_block_input_departure_date_useBlockInputDepartureDate__WEBPACK_IMPORTED_MODULE_21__[/* useBlockInputDepartureDate */ "a"])(checkIfDepartureDateIsBookable),
      blockInputDepartureDate = _useBlockInputDepartu.blockInputDepartureDate,
      setBlockInputDepartureDate = _useBlockInputDepartu.setBlockInputDepartureDate;

  var seasonLabel = (product === null || product === void 0 ? void 0 : product.isSummer) || (product === null || product === void 0 ? void 0 : product.isWinter) ? "booking.priceCalendar.priceStatus.".concat((product === null || product === void 0 ? void 0 : product.isWinter) ? 'siblingSummer' : 'siblingWinter') : '';

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(!blockInputDepartureDate ? departureDate : null),
      inputDepartureDate = _useState[0],
      setInputDepartureDate = _useState[1];

  var flexibility = Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_24__[/* getTripFlexibility */ "d"]);

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(duration),
      inputDuration = _useState2[0],
      setInputDuration = _useState2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* useDispatch */ "d"])();
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_25__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  });

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_6__["useState"])(false),
      isDoubleSeasonPopinVisible = _useState3[0],
      setIsDoubleSeasonPopinVisible = _useState3[1];

  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    var formattedDepartureDate = departureDate ? moment__WEBPACK_IMPORTED_MODULE_5___default()(departureDate).format('DDMM') : departureDate;
    var formattedInputDepartureDate = inputDepartureDate ? moment__WEBPACK_IMPORTED_MODULE_5___default()(inputDepartureDate).format('DDMM') : inputDepartureDate;

    if (formattedDepartureDate !== formattedInputDepartureDate && !blockInputDepartureDate) {
      setInputDepartureDate(departureDate);
    }
  }, [departureDate]);
  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    if (duration !== inputDuration) {
      setInputDuration(duration);
    }
  }, [duration]);
  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    setCriteriaContext({
      criteriaWhenIsSet: Boolean(departureDate && duration && !blockInputDepartureDate)
    });
  }, [departureDate, duration, blockInputDepartureDate]);
  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    setInputDepartureDate(blockInputDepartureDate ? null : departureDate);
  }, [blockInputDepartureDate]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_14__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaWhen'
    });
  };

  Object(react__WEBPACK_IMPORTED_MODULE_6__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__[/* OPEN_CRITERIA_WHEN_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_11__[/* OPEN_CRITERIA_WHEN_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);
  var hasPrices = !Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isEmpty"])(prices);
  var apiDate = Object(_utils_date_apiDate_js__WEBPACK_IMPORTED_MODULE_26__[/* timestampToApiDate */ "l"])(departureDate); // $FlowFixMe

  var price = hasPrices && !!apiDate ? prices[apiDate] : undefined;
  var priceAvailability = price ? price === null || price === void 0 ? void 0 : price.availability : '';

  var saveDateAndDuration = function saveDateAndDuration() {
    if (inputDepartureDate !== departureDate) {
      criteriaContext.setFacetHasSeeMore(false);
    }

    if (!inputDepartureDate) {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__[/* clearDepartureDate */ "e"])());
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__[/* clearTripDuration */ "g"])());
    } else if (departureDate) {
      if (hasPrices) {
        setIsDoubleSeasonPopinVisible(price === null || price === void 0 ? void 0 : price.siblingOpen);
      }

      var currentDuration = inputDuration || props.defaultDuration || _store_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_23__[/* DEFAULT_TRIP_DURATION */ "b"];

      if (currentDuration !== duration) {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__[/* changeTripDuration */ "d"])(currentDuration));
      }
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_14__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaWhen'
    });
  };

  var labelPartsMobile = [];

  if (departureDate && duration && !blockInputDepartureDate) {
    labelPartsMobile.push(moment__WEBPACK_IMPORTED_MODULE_5___default()(departureDate).format('DD/MM'));
    var arrival = moment__WEBPACK_IMPORTED_MODULE_5___default()(departureDate).add({
      days: duration
    });
    labelPartsMobile.push(arrival.format('DD/MM'));
  }

  var labelParts = [Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('faceting.when.arrivalDateTitle'), Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('faceting.when.departureDateTitle')];

  if (departureDate && (!duration || !blockInputDepartureDate)) {
    labelParts[0] = moment__WEBPACK_IMPORTED_MODULE_5___default()(departureDate).format('DD MMM');
  }

  if (departureDate && duration && !blockInputDepartureDate) {
    labelParts[1] = moment__WEBPACK_IMPORTED_MODULE_5___default()(departureDate).add({
      days: duration
    }).format('DD MMM');

    if (flexibility && withFlexibility) {
      labelParts[1] = "".concat(labelParts[1], " (").concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])("faceting.flexibility.duration_".concat(flexibility, "short")), ")");
    }
  }

  var durationOptions = Object(_utils_seller_sellerUtils__WEBPACK_IMPORTED_MODULE_27__[/* isSeller */ "g"])(appContext) ? Object(lodash__WEBPACK_IMPORTED_MODULE_4__["range"])(1, 31) : props.durationOptions;
  var showDuration = !!inputDepartureDate && !!duration && !withFlexibility;

  var buttonLabel = __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("span", {
    className: "flex-1 hidden lg:inline truncate"
  }, labelParts.join(' - '), ' ', showDuration && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, "(".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.form.selectDuration', {
    duration: duration
  }), ")"))), labelPartsMobile.length > 1 && __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("div", {
    className: "flex flex-col h-full lg:hidden justify-center leading-tight rtl:ml-px5 py-px5"
  }, labelPartsMobile.map(function (labelSplited, key) {
    return __jsx("span", {
      key: "".concat(labelSplited, "_").concat(key)
    }, labelSplited);
  }), showDuration && __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.form.selectDuration', {
    duration: duration
  }))), !!flexibility && withFlexibility && __jsx("span", {
    className: "lg:hidden rtl:ml-px5"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])("faceting.flexibility.duration_".concat(flexibility, "short")))));

  var trackDepartureDateChange = function trackDepartureDateChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: "when_".concat(value.format('DD/MM/YYYY'))
      });
    }
  };

  var trackDurationChange = function trackDurationChange(value) {
    if (criteriaContext.trackingActionName) {
      var labelGA = "duration_".concat(value);
      track({
        labelGA: labelGA
      });
    }
  };

  var closeModal = function closeModal() {
    setIsDoubleSeasonPopinVisible(false);
  };

  return __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx(_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_15__[/* CriteriaTrigger */ "a"], {
    buttonLabel: buttonLabel,
    buttonIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_10__[/* ICONS */ "a"].DATE,
    buttonIsFilled: criteriaContext.criteriaWhenIsSet,
    isOpen: criteriaDisplayContext.criteriaWhenIsOpen,
    isJoyview: props.isJoyview,
    trackingLabel: "when",
    onOpen: function onOpen() {
      dispatchCriteriaDisplayContext({
        type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_14__[/* ACTIONS */ "a"].OPEN_CRITERIA,
        payload: 'criteriaWhen'
      });
    },
    onClose: saveDateAndDuration,
    onClear: function onClear() {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__[/* clearTripDuration */ "g"])());
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__[/* clearDepartureDate */ "e"])());
    },
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputDuration();
        setInputDepartureDate();
      },
      className: 'text-base cursor-pointer rtl:pl-0 underline text-gray-darker',
      dataTestId: 'criteria-when-reset'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('faceting.validate'),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_9__[/* COLORS */ "a"].WHITE,
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_9__[/* COLORS */ "a"].BLUE,
      dataTestId: 'criteria-when-validate',
      onClick: function onClick() {
        saveDateAndDuration();
        dispatchCriteriaDisplayContext({
          type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_14__[/* ACTIONS */ "a"].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaWhen',
            criteriaContext: criteriaContext
          }
        });
      }
    }],
    reassurance: {
      text: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('faceting.when.reinsurance'),
      shouldDisplay: hasPrices
    }
  }, __jsx(_filter_when_FilterWhen__WEBPACK_IMPORTED_MODULE_12__[/* FilterWhen */ "a"], {
    defaultDuration: intialDuration || props.defaultDuration,
    optionsDuration: durationOptions,
    prices: prices,
    changeTripDuration: function changeTripDuration(time) {
      if (time) {
        setInputDuration(time);
        trackDurationChange(time);
      }
    },
    changeDepartureDate: function changeDepartureDate(value) {
      if (!value) {
        setInputDepartureDate();
        setInputDuration();
        return;
      }

      var newDepartureDate = moment__WEBPACK_IMPORTED_MODULE_5___default()(value);
      var timestamp = newDepartureDate.valueOf();

      if (inputDepartureDate !== timestamp) {
        if (blockInputDepartureDate) {
          setBlockInputDepartureDate(false);
        }

        dispatch(Object(_store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureDate */ "a"])(timestamp));
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_20__[/* clearTripDuration */ "g"])());
        setInputDepartureDate(timestamp);
        setInputDuration();
        setCriteriaContext({
          defaultValueForCalendar: newDepartureDate
        });
        trackDepartureDateChange(newDepartureDate);
      }
    },
    duration: inputDuration,
    departureDate: inputDepartureDate,
    openCalendarToDate: criteriaContext.defaultValueForCalendar,
    offsetCalendar: props.offsetSell,
    dateFormat: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('booking.form.dateFormat'),
    seasonLabel: seasonLabel,
    withFlexibility: withFlexibility
  })), isDoubleSeasonPopinVisible && !!product && __jsx(_frameworks_modal_Modal__WEBPACK_IMPORTED_MODULE_8__[/* Modal */ "a"], {
    closeLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_18__[/* t */ "h"])('common.close'),
    onClose: closeModal,
    size: "small"
  }, __jsx(_trip_date_picker_day_with_price_DayPriceDoubleSeasonPopin__WEBPACK_IMPORTED_MODULE_16__[/* DayPriceDoubleSeasonPopin */ "a"], {
    availability: priceAvailability,
    product: product,
    statusMessageKey: "booking.priceCalendar.priceStatus.".concat(priceAvailability),
    trackingData: {
      actionGA: 'priceBar'
    }
  })));
};

/***/ }),

/***/ "Gpi5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "Gqxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("HbGN");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _responsiveContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("/Mt0");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10__["createElement"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




function Responsiveness(WrappedComponent) {
  var Responsive = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Responsive, _React$Component);

    var _super = _createSuper(Responsive);

    function Responsive() {
      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, Responsive);

      return _super.apply(this, arguments);
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Responsive, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this$props, ["forwardRef"]);

        return __jsx(_responsiveContext__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"].Consumer, null, function (responsive) {
          return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({
            ref: forwardRef
          }, rest, {
            responsive: responsive
          }));
        });
      }
    }]);

    return Responsive;
  }(react__WEBPACK_IMPORTED_MODULE_10__["Component"]); // $FlowFixMe


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_10__["forwardRef"](function (props, ref) {
    return __jsx(Responsive, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])({}, props, {
      forwardRef: ref
    }));
  });
}

/* harmony default export */ __webpack_exports__["a"] = (Responsiveness);

/***/ }),

/***/ "GzVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTabsBackgroundClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTabsMainId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTabsItemIds; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("m1JM");
/* harmony import */ var _color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");




var getTabsBackgroundClasses = function getTabsBackgroundClasses() {
  var hasBackground = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_LIGHTER;
  return hasBackground ? "bg-".concat(color, " border-b-1 border-t-1 border-gray-light") : '';
};
var getTabsMainId = function getTabsMainId() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = items.filter(Boolean).map(function (_ref) {
    var header = _ref.header,
        title = _ref.title;
    return header && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(header.title) || title && Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title);
  }).filter(Boolean);
  return Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])(list, 'tabs-');
};
var getTabsItemIds = function getTabsItemIds(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      index = _ref2.index,
      mainId = _ref2.mainId;
  var headerId = id || Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), "".concat(index)], 'tabs-header-');
  var panelId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* generateUniqueId */ "b"])([mainId, Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_2__[/* cleanupId */ "a"])(title), id && "".concat(id), "".concat(index)], 'tabs-panel-');
  return [headerId, panelId];
};

/***/ }),

/***/ "H0gB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return productWellnessDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productActivityDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productChildcareDetailQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActivitiesQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productChildcaresQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return productWellnessQuery; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");



function productFeatureServiceQuery(lineProps) {
  var ageInformation = lineProps.ageInformation,
      groupMin = lineProps.groupMin,
      groupMax = lineProps.groupMax,
      groupRange = lineProps.groupRange;
  return "\n    hasBookingOnline\n    hasBookingOnsite\n    id\n    isIdealForFamily\n    label\n    description\n    detailedDescription\n    durationDescription\n    ageRestriction(message: \"".concat(ageInformation, "\")\n    level\n    note\n    group(min: \"").concat(groupMin, "\" max: \"").concat(groupMax, "\" range: \"").concat(groupRange, "\")\n    specificConditions\n    equipments {\n      label\n      included\n    }\n    utilities {\n      label\n      included\n    }\n    targetPrice {\n      price\n      currency\n    }\n  ");
}

var productFeatureFacilityQuery = "\n    id\n    description\n    distance\n    label\n    nightLighting\n    onSite\n    openingHours {\n      opening\n      closing\n    }\n    outdoor\n    quantity\n    specificInformation {\n      type\n      value\n    }\n    technicalSpecificities {\n      typeDescription\n      length\n      width\n      minDepth\n      maxDepth\n      unit\n    }\n    localisation\n  ";
function productWellnessDetailQuery(productId, activityId, _ref) {
  var lineProps = _ref.lineProps,
      urlParams = _ref.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  return "query {\n      config {\n        common { \n          previous\n          next\n          scrollBackward\n          scrollForward\n        }\n      }\n      includedServices: activities(".concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n        ").concat(productFeatureServiceQuery(lineProps), "\n      }\n      onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n        ").concat(productFeatureServiceQuery(lineProps), "\n      }\n      productActivities(").concat(productArgs, ") {\n        facilities(activityId : \"").concat(activityId, "\") {\n          ").concat(productFeatureFacilityQuery, "\n        }\n      }\n    }");
}
var productActivityExcursionQuery = "\n    seasonality\n    transportation\n    whatToBring\n  ";
function productActivityDetailQuery(_ref2, _ref3) {
  var productId = _ref2.productId,
      activityId = _ref2.activityId,
      rentalEquipmentsUsecasesId = _ref2.rentalEquipmentsUsecasesId;
  var lineProps = _ref3.lineProps,
      urlParams = _ref3.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  var rentalEquipmentsUsecasesIdArg = "rentalEquipmentsUsecasesId: \"".concat(rentalEquipmentsUsecasesId, "\"");
  return "query {\n    config {\n      common { previous next }\n    }\n    includedServices: activities(".concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true, withoutRental: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true, withoutRental: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n      ").concat(productActivityExcursionQuery, "\n    }\n    productActivities(").concat(productArgs, ") {\n      facilities(activityId : \"").concat(activityId, "\") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n    ").concat(rentalEquipmentsUsecasesId ? "\n    rentalEquipments(".concat(productArgs, ", ").concat(rentalEquipmentsUsecasesIdArg, ") {\n      ageInMonths {\n        max\n        min\n      }\n      id\n      label\n      longDescription\n      practiceLevels {\n        label\n      }\n      sizes {\n        max\n        min\n        unit\n      }\n    }\n    ") : '', "\n  }");
}
function productChildcareDetailQuery(productId, activityId, _ref4) {
  var lineProps = _ref4.lineProps,
      urlParams = _ref4.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  var productActivitiesArgs = "activityId : \"".concat(activityId, "\"");
  var activityArgs = "categoryId: \"".concat(activityId, "\"");
  var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
  return "query {\n    config {\n      common { previous next }\n    }\n    resort(".concat(productArgs, ") {\n      facilities(types: [\"CHILDREN\"], withEquipments: true) {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n      productActivities(idFilter: \"").concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        subtitle\n        label\n        equipments {\n          id\n          label\n        }\n      }\n    }\n    productActivities(").concat(productArgs, ") {\n      childcare(").concat(productActivitiesArgs, ") {\n        closingWeekdays\n        description\n        duration\n        furtherInformation\n        id\n        label\n        openingDates {\n          opening\n          closing\n        }\n        openingHours {\n          start\n          end\n        }\n        philosophy\n        targetPrice {\n          currency\n          price\n        }\n      }\n      facilities(").concat(productActivitiesArgs, ") {\n        ").concat(productFeatureFacilityQuery, "\n      }\n    }\n    includedServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n    onDemandServices: activities(").concat(productArgs, ", ").concat(activityArgs, ", onlyNotIncluded: true) {\n      ").concat(productFeatureServiceQuery(lineProps), "\n    }\n  }");
}
/* lists of features */

var productFeaturesConfigQuery = "\n    config {\n      common {\n        allInclusive\n        backNavigation\n        bookOnlineOnly\n        bookOnlineOrOnsite\n        bookOnsiteOnly    \n        childcarealacarte\n        downloadLeafletLabel\n        extraCost\n        howToBookLabel\n        idealForFamilyLabel\n        included\n        loadLess\n        onDemandService\n        philosophyLabel\n        price {\n          priceFrom\n        }\n        scrollBackward\n        scrollForward\n        treatmentsLabel\n        viewMore\n      }\n    }\n  ";

function productFeaturesCategoriesFields(defaultLabel) {
  var activityLabel = defaultLabel ? "label(defaultLabel: \"".concat(defaultLabel, "\")") : 'label';
  return "\n    activities: subCategories {\n      bookingDescription\n      bookletUrl\n      brandLogoUrl\n      description\n      equipmentRentalDescription\n      id\n      image: imageUrl\n      isChildrenClub\n      isIncluded\n      keywords\n      ".concat(activityLabel, "\n      name\n      numberOfIncludedActivities\n      numberOfOnDemandActivities\n      philosophy\n      ranking\n      rentalEquipmentsUsecasesId\n      supervisionDescription\n      termsAndConditionsDescription\n    }\n    id\n    label\n    ranking\n  ");
}

function productActivitiesQuery(_ref5) {
  var productId = _ref5.productId,
      defaultLabel = _ref5.defaultLabel,
      urlParams = _ref5.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      categories: activityCategories {\n        leisure {\n          ").concat(productFeaturesCategoriesFields(defaultLabel), "\n        }\n      }\n    }\n  }");
}
function productChildcaresQuery(productId, _ref6) {
  var urlParams = _ref6.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      kidsActivitiesIntroduction {\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        children {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}
function productWellnessQuery(productId, _ref7) {
  var urlParams = _ref7.urlParams;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams);
  return "query {\n    ".concat(productFeaturesConfigQuery, "\n    resort(").concat(productArgs, ") {\n      wellnessActivitiesIntroduction {\n        bookletUrl\n        description\n        shortDescription\n      }\n      categories: activityCategories {\n        wellness {\n          ").concat(productFeaturesCategoriesFields(), "\n        }\n      }\n    }\n  }");
}

/***/ }),

/***/ "HKmi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StreetView; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hNT8");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UlIv");



var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;




var GoogleMapReact = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(41), __webpack_require__.e(122)]).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var addStreetView = function addStreetView(_ref) {
  var hideFloorControls = _ref.hideFloorControls,
      map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      pov = _ref.pov,
      ref = _ref.ref;
  var panorama = new maps.StreetViewPanorama(ref, {
    addressControl: true,
    disableDefaultUI: hideFloorControls,
    fullscreenControl: false,
    position: position,
    pov: pov,
    linksControl: true,
    panControl: true,
    zoomControl: true
  });
  map.setStreetView(panorama);
};

function StreetView(props) {
  var _props$fov = props.fov,
      fov = _props$fov === void 0 ? 2 : _props$fov,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 2 : _props$heading,
      _props$hideFloorContr = props.hideFloorControls,
      hideFloorControls = _props$hideFloorContr === void 0 ? false : _props$hideFloorContr,
      latitude = props.latitude,
      longitude = props.longitude;

  var _map = Object(react__WEBPACK_IMPORTED_MODULE_4__["useRef"])();

  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  return __jsx("div", {
    className: "h-full",
    "data-testid": "StreetViewComponent",
    ref: _map
  }, __jsx(GoogleMapReact, {
    bootstrapURLKeys: {
      key: _config__WEBPACK_IMPORTED_MODULE_5___default.a.get(_utils_google_google_constants__WEBPACK_IMPORTED_MODULE_6__[/* GOOGLE_API_KEY */ "c"])
    },
    defaultCenter: coordinates,
    defaultZoom: fov,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addStreetView({
        hideFloorControls: hideFloorControls,
        map: map,
        maps: maps,
        position: coordinates,
        pov: {
          heading: heading,
          pitch: 0
        },
        // same here, for now
        ref: _map.current
      });
    },
    yesIWantToUseGoogleMapApiInternals: true
  }));
}

/***/ }),

/***/ "HKx7":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var anObject = __webpack_require__("ep/x");
var objectKeys = __webpack_require__("X95k");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "HUPx":
/***/ (function(module, exports, __webpack_require__) {

var createNonEnumerableProperty = __webpack_require__("WxKw");
var dateToPrimitive = __webpack_require__("034l");
var wellKnownSymbol = __webpack_require__("fVMg");

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!(TO_PRIMITIVE in DatePrototype)) {
  createNonEnumerableProperty(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ "HnW7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("lpmq")))

/***/ }),

/***/ "I/kN":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("w7mb");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "I1fX":
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__("6XIJ");

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ "I2c1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("dNjr");
var addToUnscopables = __webpack_require__("3K/D");
var Iterators = __webpack_require__("oa0l");
var InternalStateModule = __webpack_require__("9jKB");
var defineIterator = __webpack_require__("ZiN6");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "IYAN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var isForced = __webpack_require__("wxLG");
var redefine = __webpack_require__("L1Xj");
var InternalMetadataModule = __webpack_require__("wKkN");
var iterate = __webpack_require__("ZuH9");
var anInstance = __webpack_require__("V/va");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var fails = __webpack_require__("fhLv");
var checkCorrectnessOfIteration = __webpack_require__("AZSF");
var setToStringTag = __webpack_require__("CGO5");
var inheritIfRequired = __webpack_require__("XmKO");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "IpDy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productDestinationResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productDestinationResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_DESTINATION */ "gb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var productId = props.resortId;
    var urlParams = location.urlParams,
        queryParams = location.queryParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      resort(".concat(productArgs, ") {\n        title\n        name\n        description\n        productVideo\n        destination { country image description }\n        practicalInformation { healthFormalities passportAndVisas }\n        comfort\n        href(offerName : \"").concat(queryParams.offer || '', "\")\n        strengths\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_DESTINATIONS */ "cc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "Itgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ECBadge; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var ECBadge = function ECBadge(_ref) {
  var className = _ref.className,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 50 : _ref$height,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '90%' : _ref$iconWidth;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, 'bg-deepBlue px-px5 flex items-center inset-border-after--small justify-center'),
    style: {
      height: height,
      width: height * 2
    }
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_4__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].WHITE,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_3__[/* ICONS */ "a"].EXCLUSIVE_COLLECTION,
    width: iconWidth
  }));
};

/***/ }),

/***/ "IuYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Price_Price; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/currency-config-for-locale/currencyConfigForLocale.js
var currencyConfigForLocale = __webpack_require__("wz9x");

// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.themes.js

var PriceItem_themes_themes = function themes(_ref) {
  var hasAction = _ref.hasAction;
  return {
    best: {
      "package": {
        thRoot: 'font-bold leading-one text-center',
        thLabel: 'block font-sans text-gray-darker text-base uppercase',
        thValue: 'block text-turquoise text-5xl',
        thLongValue: 'block text-turquoise text-3xl'
      },
      thumbnail: {
        thRoot: 'flex items-center text-base',
        thLabel: 'font-sans text-gray-darker',
        thValue: 'leading-tight px-px5 text-2xl underline',
        thLongValue: 'leading-tight px-px5 text-xl underline',
        thLongValueLimit: 10
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'leading-tight text-md underline font-bold',
        thLongValue: 'leading-tight text-2xl underline'
      },
      remote: {
        thRoot: 'leading-one font-bold px-px5 flex items-center',
        thLabel: 'align-top font-sans inline-block text-sm pr-px5 rtl:pr-px5',
        thValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        }),
        thLongValue: classnames_default()('font-sans inline-block text-3xl', {
          underline: hasAction
        })
      }
    },
    initial: {
      "package": {
        thRoot: 'block font-bold leading-tight text-center',
        thLabel: 'inline-block font-sans text-gray-darker text-base',
        thValue: 'inline-block line-through text-gray-darker text-base',
        thLongValue: 'block line-through text-gray-darker text-base'
      },
      thumbnail: {
        thRoot: 'inline-block lowercase text-md',
        thLabel: 'hidden',
        thValue: 'line-through uppercase',
        thLongValue: 'line-through text-base uppercase',
        thLongValueLimit: 10
      },
      instagram: {
        thRoot: 'text-sm sm:text-base',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      },
      remote: {
        thRoot: 'font-bold text-md text-grenadine',
        thLabel: 'font-sans',
        thValue: 'font-sans line-through',
        thLongValue: 'font-sans line-through'
      }
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price-item/PriceItem.jsx
var __jsx = react_default.a.createElement;




var PriceItem_PriceItem = function PriceItem(_ref) {
  var className = _ref.className,
      formattedValue = _ref.formattedValue,
      hasAction = _ref.hasAction,
      label = _ref.label,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'best' : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value;

  if (!value || !formattedValue) {
    return null;
  }

  var _themes$type$theme = PriceItem_themes_themes({
    hasAction: hasAction
  })[type][theme],
      thLabel = _themes$type$theme.thLabel,
      thLongValue = _themes$type$theme.thLongValue,
      thLongValueLimit = _themes$type$theme.thLongValueLimit,
      thRoot = _themes$type$theme.thRoot,
      thValue = _themes$type$theme.thValue;
  var valueClasses = Object(price_util["g" /* isLongFormat */])(formattedValue, thLongValueLimit) ? thLongValue : thValue;
  return __jsx("span", {
    className: classnames_default()(className, thRoot)
  }, !!label && __jsx("span", {
    className: thLabel,
    "data-testid": "PriceItem-label"
  }, label), !!label && !!formattedValue && __jsx("span", null, " "), __jsx("span", {
    className: valueClasses,
    "data-testid": "PriceItem-value"
  }, formattedValue));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.themes.js
var PriceUnit_themes_themes = {
  "package": {
    thRoot: 'block font-sans font-bold text-center text-sm uppercase'
  },
  thumbnail: {
    thRoot: 'inline-block font-sans text-sm md:text-base text-gray-darker'
  },
  instagram: {
    thRoot: 'inline-block font-sans text-sm sm:text-base'
  },
  remote: {
    thRoot: 'font-bold font-sans inline-block text-sm'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/unit/PriceUnit.jsx
var PriceUnit_jsx = react_default.a.createElement;


var PriceUnit_PriceUnit = function PriceUnit(_ref) {
  var hasAsterisk = _ref.hasAsterisk,
      theme = _ref.theme,
      unit = _ref.unit;
  return unit ? PriceUnit_jsx("span", {
    className: PriceUnit_themes_themes[theme].thRoot,
    "data-testid": "Price-unit"
  }, unit, hasAsterisk && PriceUnit_jsx("sup", null, "*")) : null;
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.themes.js
var PriceDiscount_themes_themes = {
  "package": {},
  thumbnail: {
    thInitialPrice: 'flex-shrink-0 -mb-px5 -order-1 text-grenadine',
    thBestPrice: 'flex-shrink-0'
  },
  instagram: {
    thInitialPrice: 'text-grenadine'
  },
  remote: {
    thInitialPrice: '-order-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/discount/PriceDiscount.jsx



var PriceDiscount_jsx = react_default.a.createElement;








var PriceDiscount_PriceDiscount = function PriceDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAction = _ref.hasAction,
      hasAsterisk = _ref.hasAsterisk,
      hasInitialPrice = _ref.hasInitialPrice,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? [] : _ref$instalmentLocale,
      instead = _ref.instead,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var _themes$theme = PriceDiscount_themes_themes[theme],
      thBestPrice = _themes$theme.thBestPrice,
      thInitialPrice = _themes$theme.thInitialPrice;
  var displayInstalment = hasInstalment && Object(i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice');
  var locale = context.locale;
  return PriceDiscount_jsx(react["Fragment"], null, PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: from,
    theme: theme,
    type: "best"
  }, bestPrice, {
    className: thBestPrice,
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(bestPrice, locale) : bestPrice && bestPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), hasInitialPrice && PriceDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    hasAction: hasAction,
    label: instead,
    theme: theme,
    type: "initial"
  }, initialPrice, {
    className: thInitialPrice,
    formattedValue: displayInstalment && initialPrice && instalmentLocales.includes(locale) ? Object(currencyConfigForLocale["b" /* formatAmountForLocale */])(Math.floor(initialPrice.value), locale, initialPrice.currency, {
      precision: 0
    }) : initialPrice && initialPrice.formattedValue
  })), PriceDiscount_jsx("span", null, " "), PriceDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/no-discount/PriceNoDiscount.jsx

var PriceNoDiscount_jsx = react_default.a.createElement;





var PriceNoDiscount_PriceNoDiscount = function PriceNoDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      from = _ref.from,
      hasAsterisk = _ref.hasAsterisk,
      hasInstalment = _ref.hasInstalment,
      initialPrice = _ref.initialPrice,
      theme = _ref.theme,
      unit = _ref.unit;
  var context = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var price;

  if (Object(price_util["f" /* hasPrice */])(initialPrice)) {
    price = initialPrice;
  } else if (Object(price_util["f" /* hasPrice */])(bestPrice)) {
    price = bestPrice;
  }

  return PriceNoDiscount_jsx(react["Fragment"], null, PriceNoDiscount_jsx(PriceItem_PriceItem, Object(esm_extends["a" /* default */])({
    label: from,
    theme: theme,
    type: "best"
  }, price, {
    formattedValue: hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])(price, context.locale) : price && price.formattedValue
  })), PriceNoDiscount_jsx("span", null, " "), PriceNoDiscount_jsx(PriceUnit_PriceUnit, {
    hasAsterisk: hasAsterisk,
    theme: theme,
    unit: unit
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.themes.js
var PriceViewRate_themes_themes = {
  "package": {
    thRoot: 'flex font-bold font-sans justify-center leading-tight text-center text-md',
    thLabel: 'rtl:ml-px10'
  },
  thumbnail: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm md:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-px5'
  },
  instagram: {
    thRoot: 'flex items-center underline font-sans leading-one text-sm sm:text-base',
    thIcon: 'hidden',
    thLabel: 'rtl:ml-px5'
  },
  remote: {
    thRoot: 'flex items-center font-bold font-sans leading-one text-xl',
    thLabel: 'rtl:ml-px10'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/view-rate/PriceViewRate.jsx
var PriceViewRate_jsx = react_default.a.createElement;




var PriceViewRate_PriceViewRate = function PriceViewRate(_ref) {
  var label = _ref.label,
      theme = _ref.theme;
  var _themes$theme = PriceViewRate_themes_themes[theme],
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  if (!label) {
    return null;
  }

  return PriceViewRate_jsx("div", {
    className: thRoot
  }, PriceViewRate_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].DATE,
    width: "1em"
  }), PriceViewRate_jsx("span", {
    className: thLabel,
    "data-testid": "Price-viewRate"
  }, label));
};
// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.themes.js

var Price_themes_themes = function themes(_ref) {
  var color = _ref.color;
  return {
    "package": {
      thRoot: 'overflow-hidden'
    },
    thumbnail: {
      thRoot: 'flex items-center overflow-hidden pt-px5 pb-px10 text-gray-darker',
      thPriceRoot: 'font-brand flex items-center'
    },
    instagram: {
      thRoot: 'w-full flex items-center truncate text-white',
      thPriceRoot: 'font-brand text-inherit'
    },
    remote: {
      thRoot: "inline-flex overflow-hidden text-".concat(color || colors["a" /* COLORS */].BLUE),
      thPriceRoot: 'flex items-center'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/price/Price.jsx
var Price_jsx = react_default.a.createElement;







var HEIGHT = '2.5rem';
var Price_Price = function Price(_ref) {
  var bestPrice = _ref.bestPrice,
      className = _ref.className,
      color = _ref.color,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {
    minHeight: HEIGHT
  } : _ref$containerStyle,
      from = _ref.from,
      _ref$hasAsterisk = _ref.hasAsterisk,
      hasAsterisk = _ref$hasAsterisk === void 0 ? true : _ref$hasAsterisk,
      _ref$hasInitialPrice = _ref.hasInitialPrice,
      hasInitialPrice = _ref$hasInitialPrice === void 0 ? true : _ref$hasInitialPrice,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? true : _ref$hasInstalment,
      initialPrice = _ref.initialPrice,
      _ref$instalmentLocale = _ref.instalmentLocales,
      instalmentLocales = _ref$instalmentLocale === void 0 ? ['pt-BR', 'es-AR'] : _ref$instalmentLocale,
      instead = _ref.instead,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      onClick = _ref.onClick,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'package' : _ref$theme,
      unit = _ref.unit,
      viewRates = _ref.viewRates;
  var displayPrice = Object(price_util["d" /* hasAtLeastOnePrice */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  });

  if (!displayPrice && !viewRates) {
    return null;
  }

  var _themes$theme = Price_themes_themes({
    color: color
  })[theme],
      thPriceRoot = _themes$theme.thPriceRoot,
      thRoot = _themes$theme.thRoot;
  var hasAction = !!onClick;
  var TagName = hasAction ? 'button' : 'div';
  return Price_jsx(TagName, {
    "data-testid": "Price-wrapper",
    className: classnames_default()(className, thRoot, {
      'reset-button': hasAction
    }),
    onClick: onClick,
    style: containerStyle
  }, Price_jsx("span", {
    className: thPriceRoot,
    style: style
  }, isLoading ? Price_jsx("span", {
    className: "loadingDots",
    "data-testid": "Price-loader"
  }) : Price_jsx(react["Fragment"], null, displayPrice ? Price_jsx(react["Fragment"], null, Object(price_util["e" /* hasDiscount */])({
    initialPrice: initialPrice,
    bestPrice: bestPrice
  }) ? Price_jsx(PriceDiscount_PriceDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAction: hasAction,
    hasAsterisk: hasAsterisk,
    hasInitialPrice: hasInitialPrice,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    instalmentLocales: instalmentLocales,
    instead: instead,
    theme: theme,
    unit: unit
  }) : Price_jsx(PriceNoDiscount_PriceNoDiscount, {
    bestPrice: bestPrice,
    from: from,
    hasAsterisk: hasAsterisk,
    hasInstalment: hasInstalment,
    initialPrice: initialPrice,
    theme: theme,
    unit: unit
  })) : Price_jsx(PriceViewRate_PriceViewRate, {
    label: viewRates,
    theme: theme
  }))));
};

/***/ }),

/***/ "J9Yr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("7x/C");

__webpack_require__("OZaJ");

__webpack_require__("DZ+c");

var _toConsumableArray = __webpack_require__("iN+R");

var _classCallCheck = __webpack_require__("zQIG");

var _createClass = __webpack_require__("8mBC");

var _assertThisInitialized = __webpack_require__("N7I1");

var _inherits = __webpack_require__("I/kN");

var _possibleConstructorReturn = __webpack_require__("cMav");

var _getPrototypeOf = __webpack_require__("pSQP");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports.default = void 0;

var _react = __webpack_require__("ERkP");

var isServer = false;

var _default = /*#__PURE__*/function (_react$Component) {
  _inherits(_default, _react$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._hasHeadManager = void 0;

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.delete(this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _default;
}(_react.Component);

exports.default = _default;

/***/ }),

/***/ "JEY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productAccommodationsResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productAccommodationsExclusiveCollectionResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("CcNa");
















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







var getQuery = function getQuery(productArgs) {
  return "query {\n    config {\n      common {\n        backNavigation\n        exclusiveCollectionLabel\n        viewMore\n        loadLess\n        next\n        previous\n        scrollBackward\n        scrollForward\n        roomPlan {\n          title\n          disclaimer\n          swipeInstruction\n        }\n      }\n      accommodations {\n        surfaceLabel\n      }\n    }\n    accommodationCategory(".concat(productArgs, ") {\n      rankedCategories: accommodations {\n        id\n        ranking\n      }\n    }\n    resort(").concat(productArgs, ") {\n      accommodationsIntroduction {\n        description\n        shortDescription\n      }\n      accommodations {\n        area {\n          max\n          min\n          unit\n        }\n        bathroomEquipments {\n          id\n          label\n        }\n        category\n        categoryId\n        comfortId\n        comfortType\n        description\n        equipments {\n          id\n          label\n          ranking\n        }\n        exclusiveCollection\n        floorPlan\n        id\n        label\n        maxCapacity\n        minCapacity\n        media {\n          photos {\n            url\n          }\n        }\n        ranking\n        roomType\n        services {\n          id\n          label\n          ranking\n        }\n        outsideFacilities {\n          id\n          label\n        }\n        strengths {\n          id\n          label\n        }\n        surface\n        view {\n          id\n          label\n        }\n      }\n      comfort\n      isExclusiveCollection\n      type\n    }\n  }");
};

var getStreetViewsQuery = function getStreetViewsQuery(productArgs, accommodationCategory) {
  var accommodationCategoryIds = (accommodationCategory === null || accommodationCategory === void 0 ? void 0 : accommodationCategory.rankedCategories) && (accommodationCategory === null || accommodationCategory === void 0 ? void 0 : accommodationCategory.rankedCategories.length) > 0 ? accommodationCategory === null || accommodationCategory === void 0 ? void 0 : accommodationCategory.rankedCategories.map(function (_ref) {
    var id = _ref.id;
    return id ? "\"".concat(id, "\"") : '';
  }) : [];
  return "query {\n      streetViews(".concat(productArgs, ", accommodationCategoryIds:[").concat(accommodationCategoryIds === null || accommodationCategoryIds === void 0 ? void 0 : accommodationCategoryIds.join(','), "]) {\n      accommodationCategoryId\n      streetView {\n        latitude\n        longitude\n        heading\n        pitch\n        fov\n      }\n    }\n  }");
};

var CRUISE_RESORT_ID = 'CM2C';

var commonAccommodationsResolver = function commonAccommodationsResolver(_ref2) {
  var isLineExclusiveCollection = _ref2.isLineExclusiveCollection;
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.mark(function _callee(appContext, props, pageContext, location) {
      var urlParams, productId, productArgs, query, mainData, streetViewsQuery;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_12___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              urlParams = location.urlParams;
              productId = props.resortId;
              productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_17__[/* buildProductArgs */ "c"])(productId, urlParams);
              query = getQuery(productArgs);
              _context.next = 6;
              return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_19__[/* LINE_PRODUCT_ACCOMMODATIONS */ "Ub"],
                strictErrors: false
              }).then(function (data) {
                return _objectSpread(_objectSpread({}, data), {}, {
                  isLineExclusiveCollection: isLineExclusiveCollection
                });
              });

            case 6:
              mainData = _context.sent;

              if (!(productId !== CRUISE_RESORT_ID)) {
                _context.next = 10;
                break;
              }

              streetViewsQuery = getStreetViewsQuery(productArgs, mainData.accommodationCategory);
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_18__[/* default */ "a"].runQuery(streetViewsQuery, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_19__[/* LINE_PRODUCT_ACCOMMODATIONS_STREETVIEWS */ "Vb"],
                strictErrors: false
              }).then(function (data) {
                Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* addTranslationKeys */ "a"])(mainData.config);
                return _objectSpread(_objectSpread(_objectSpread({}, mainData), data), {}, {
                  isLineExclusiveCollection: isLineExclusiveCollection
                });
              }));

            case 10:
              Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* addTranslationKeys */ "a"])(mainData.config);
              return _context.abrupt("return", Promise.resolve(_objectSpread(_objectSpread({}, mainData), {}, {
                isLineExclusiveCollection: isLineExclusiveCollection
              })));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var productAccommodationsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_15__[/* RESORT_ACCOMMODATION_TYPES */ "db"],
  resolve: commonAccommodationsResolver({
    isLineExclusiveCollection: false
  })
};
var productAccommodationsExclusiveCollectionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_15__[/* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */ "cb"],
  resolve: commonAccommodationsResolver({
    isLineExclusiveCollection: true
  })
};

/***/ }),

/***/ "JFtY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__("oNVP");
var imageExtensions = __webpack_require__("y147");
var exts = Object.create(null);

imageExtensions.forEach(function (el) {
	exts[el] = true;
});

module.exports = function (filepath) {
	return path.extname(filepath).slice(1).toLowerCase() in exts;
};


/***/ }),

/***/ "JHNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SocialPicture_SocialPicture; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/social-picture/SocialPicture.themes.js

var themes = {
  "default": {
    thRoot: 'relative',
    thIconContainer: 'absolute bottom-0 flex gradient-linear-transparent-black-80 items-center p-px10 text-white w-full',
    thText: 'truncate rtl:ml-px5',
    thIcon: 'flex-shrink-0',
    thIconWidth: 'calc(20rem / 16)',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thImageLazyloading: false,
    thImageSize: {
      w: 1000,
      h: 'auto'
    }
  },
  cards: {
    thRoot: 'relative rounded-tiny overflow-hidden',
    thIconContainer: 'absolute flex items-center justify-end p-px10 sm:p-px20 top-0 text-white w-full',
    thText: 'truncate rtl:ml-px5 text-sm font-bold',
    thIcon: 'flex-shrink-0',
    thIconWidth: '1rem',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thImageLazyloading: true,
    thImageSize: {
      w: 500,
      h: 500
    }
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/social-picture/SocialPicture.jsx
var __jsx = react_default.a.createElement;






var SocialPicture_SocialPicture = function SocialPicture(_ref) {
  var className = _ref.className,
      src = _ref.src,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      userName = _ref.userName;

  if (!src) {
    return null;
  }

  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconColor = _themes$theme.thIconColor,
      thIconContainer = _themes$theme.thIconContainer,
      thIconWidth = _themes$theme.thIconWidth,
      thImageLazyloading = _themes$theme.thImageLazyloading,
      thImageSize = _themes$theme.thImageSize,
      thRoot = _themes$theme.thRoot,
      thText = _themes$theme.thText;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    "data-testid": "social-picture"
  }, __jsx(Image["a" /* Image */], {
    className: "align-bottom w-full",
    dimensions: thImageSize,
    hasLazyLoading: thImageLazyloading,
    imageUrl: src,
    transformation: "crop"
  }), userName && __jsx("div", {
    className: thIconContainer
  }, __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: thIconColor,
    name: icons["a" /* ICONS */].INSTAGRAM,
    width: thIconWidth
  }), __jsx("span", {
    className: thText
  }, userName)));
};

/***/ }),

/***/ "JPie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");






var AutoFocusInside = function AutoFocusInside(_ref) {
  var disabled = _ref.disabled,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !disabled), {
    className: className
  }), children);
};

AutoFocusInside.propTypes =  false ? undefined : {};
AutoFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (AutoFocusInside);

/***/ }),

/***/ "JYr1":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("dSaG");

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "Jcrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FormControl_FormControl; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./node_modules/classnames/dedupe.js
var dedupe = __webpack_require__("A/WM");
var dedupe_default = /*#__PURE__*/__webpack_require__.n(dedupe);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.themes.js



var DEFAULT_SIZES = {
  small: 32,
  medium: 42,
  large: 52
};
var themes = {
  "default": function _default(props) {
    var bgTransparent = props.bgTransparent,
        hasValidationIcon = props.hasValidationIcon,
        isActive = props.isActive,
        isDisabled = props.isDisabled,
        isFilled = props.isFilled,
        isReadOnly = props.isReadOnly,
        _props$size = props.size,
        size = _props$size === void 0 ? 'medium' : _props$size,
        _props$validationStat = props.validationState,
        validationState = _props$validationStat === void 0 ? 'NOT_VALIDATED' : _props$validationStat;
    var hasDefaultStyle = validationState === 'NOT_VALIDATED' && !isActive && !isFilled && !isDisabled;
    var hasActiveStyle = validationState === 'NOT_VALIDATED' && isActive && !isDisabled && !isFilled;
    var hasValidStyle = validationState === 'IS_VALID' && !isFilled && !isDisabled;
    var hasInvalidStyle = validationState === 'IS_INVALID' && !isFilled && !isDisabled;
    var hasFilledStyle = isFilled && !isDisabled;
    var iconTheme = dedupe_default()('flex items-center justify-center', {
      'text-current': !hasFilledStyle,
      'text-gray-medium': isDisabled
    });
    var validationIconName = null;

    if (hasValidationIcon && (hasValidStyle || hasInvalidStyle)) {
      validationIconName = hasValidStyle ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].CROSS;
    }

    return {
      thLabel: 'block font-bold pb-px5 text-gray-darker text-sm transition-color',
      thField: dedupe_default()('border-1 flex outline-custom px-px10 relative rounded-tiny transition-colors', Object(form_util["a" /* getCursorClass */])(props), {
        'button-medium': size === 'medium',
        'button-default': size === 'large',
        'bg-gray-lighter border-gray-lighter': isDisabled,
        'bg-white border-gray-medium': hasDefaultStyle && !bgTransparent,
        'bg-transparent border-gray-medium': hasDefaultStyle && !!bgTransparent,
        'focus-within:border-blue text-gray-darker focus-within:text-blue': hasDefaultStyle && !isReadOnly,
        'bg-white border-blue text-blue': hasActiveStyle,
        'bg-white border-success': hasValidStyle,
        'bg-white border-danger': hasInvalidStyle,
        'bg-blue border-blue text-white': hasFilledStyle
      }),
      thFieldStyle: {
        height: DEFAULT_SIZES[size]
      },
      thIconLeft: dedupe_default()(iconTheme, 'rtl:pr-px10'),
      thIconRight: dedupe_default()(iconTheme, 'rtl:pl-px10'),
      thInput: 'flex flex-1 relative',
      thLoader: 'flex items-center justify-center leading-none rtl:pl-px10',
      thSpinnerColor: hasFilledStyle ? 'current' : 'blue',
      thClearButton: dedupe_default()('reset-button leading-none rtl:pl-px10 transition-color', {
        'text-gray-medium': !hasFilledStyle,
        'text-current': hasFilledStyle
      }),
      thClearIconSize: '0.625rem',
      thValidationIcon: dedupe_default()('flex items-center justify-center pl-px10 text-xs transition-all', {
        'text-success': hasValidStyle,
        'text-danger': hasInvalidStyle
      }),
      thValidationIconSize: '1em',
      thValidationIconName: validationIconName,
      thNotes: 'mt-px pt-px text-sm text-gray-medium'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx
var __jsx = react_default.a.createElement;







var FormControl_FormControl = function FormControl(_ref) {
  var bgTransparent = _ref.bgTransparent,
      children = _ref.children,
      className = _ref.className,
      dir = _ref.dir,
      hasClear = _ref.hasClear,
      _ref$hasValidationIco = _ref.hasValidationIcon,
      hasValidationIcon = _ref$hasValidationIco === void 0 ? true : _ref$hasValidationIco,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      id = _ref.id,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      isReadOnly = _ref.isReadOnly,
      isRequired = _ref.isRequired,
      label = _ref.label,
      notes = _ref.notes,
      onClear = _ref.onClear,
      size = _ref.size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      validationState = _ref.validationState;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme]({
    bgTransparent: bgTransparent,
    hasValidationIcon: hasValidationIcon,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isReadOnly: isReadOnly,
    size: size,
    validationState: validationState
  }),
      thClearButton = _themes$theme.thClearButton,
      thClearIconSize = _themes$theme.thClearIconSize,
      thField = _themes$theme.thField,
      thFieldStyle = _themes$theme.thFieldStyle,
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thInput = _themes$theme.thInput,
      thLabel = _themes$theme.thLabel,
      thLoader = _themes$theme.thLoader,
      thNotes = _themes$theme.thNotes,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thValidationIcon = _themes$theme.thValidationIcon,
      thValidationIconName = _themes$theme.thValidationIconName,
      thValidationIconSize = _themes$theme.thValidationIconSize;

  return __jsx("div", {
    className: className,
    dir: dir
  }, !!label && __jsx("label", {
    className: thLabel,
    htmlFor: id
  }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label), __jsx("div", {
    className: thField,
    style: thFieldStyle
  }, !!iconLeft && __jsx("div", {
    className: thIconLeft
  }, __jsx(Icon["a" /* Icon */], {
    name: iconLeft,
    width: "0.875rem"
  })), __jsx("div", {
    className: thInput
  }, children, isLoading && !isDisabled && !isReadOnly && __jsx("div", {
    className: thLoader
  }, __jsx(Spinner["a" /* Spinner */], {
    color: thSpinnerColor,
    size: "small"
  })), hasClear && !isDisabled && !isLoading && !isReadOnly && __jsx("button", {
    className: thClearButton,
    "data-testid": "FormControlClear",
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearIconSize
  }))), !!iconRight && __jsx("div", {
    className: thIconRight
  }, __jsx(Icon["a" /* Icon */], {
    name: iconRight
  })), thValidationIconName && __jsx("span", {
    className: thValidationIcon
  }, __jsx(Icon["a" /* Icon */], {
    name: thValidationIconName,
    width: thValidationIconSize
  }))), !!notes && __jsx("div", {
    className: thNotes,
    "data-testid": "FormControlNotes"
  }, notes));
};

/***/ }),

/***/ "JhHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoUrl; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_4__);





var youtubeRegEx = new RegExp('https://(?:youtu.be/|www.youtube.com/(?:watch\\?v=|embed/))([a-zA-Z0-9_-]+)');
var youkuRegEx = new RegExp('https?://(?:player.youku.com/embed/|player.youku.com/player.php/sid/)([a-zA-Z0-9]+)');

function getYoutubeVideoUrl(url) {
  var urlId = youtubeRegEx.exec(url);
  return urlId ? "https://www.youtube.com/embed/".concat(urlId[1]) : null;
}

function getYoukuVideoUrl(url) {
  var urlId = youkuRegEx.exec(url);
  var clientId = _config__WEBPACK_IMPORTED_MODULE_4___default.a.get('youku.clientId');
  return urlId ? "https://player.youku.com/embed/".concat(urlId[1], "?client_id=").concat(clientId) : null;
}

function getVideoUrl(url) {
  return getYoutubeVideoUrl(url) || getYoukuVideoUrl(url);
}

function isVideoUrl(url) {
  return youtubeRegEx.test(url) || youkuRegEx.test(url);
}



/***/ }),

/***/ "Jm8J":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("j2ob");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "JpEK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var create = __webpack_require__("Znn2");
var getPrototypeOf = __webpack_require__("yvHl");
var redefine = __webpack_require__("L1Xj");
var wellKnownSymbol = __webpack_require__("nJrx");
var IS_PURE = __webpack_require__("SRps");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "Jsmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tripInformationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAdultsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getKids; });
/* unused harmony export getMainContactOptins */
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);

var tripInformationSelector = function tripInformationSelector(_ref) {
  var tripInformation = _ref.tripInformation;
  return tripInformation || {};
};

var tripCriteriaSelector = function tripCriteriaSelector(_ref2) {
  var tripCriteria = _ref2.tripCriteria;
  return tripCriteria || {};
};

var getAdults = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref3) {
  var adults = _ref3.adults;
  return adults || [];
});
var getAdultsNumber = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref4) {
  var adults = _ref4.adults;
  return (adults || []).length;
});
var getKids = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripInformationSelector, function (_ref5) {
  var kids = _ref5.kids;
  return kids || [];
});
var getMainContactOptins = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref6) {
  var mainContact = _ref6.mainContact;
  return mainContact;
});


/***/ }),

/***/ "L1Xj":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");
var has = __webpack_require__("DZWw");
var createNonEnumerableProperty = __webpack_require__("g51W");
var setGlobal = __webpack_require__("edYw");
var inspectSource = __webpack_require__("/ExG");
var InternalStateModule = __webpack_require__("9jKB");
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("mu8A").CONFIGURABLE;

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!has(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
      createNonEnumerableProperty(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "LFxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("Bg8+");
var getWeakData = __webpack_require__("wKkN").getWeakData;
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var anInstance = __webpack_require__("V/va");
var iterate = __webpack_require__("ZuH9");
var ArrayIterationModule = __webpack_require__("VrMI");
var $has = __webpack_require__("DZWw");
var InternalStateModule = __webpack_require__("9jKB");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};


/***/ }),

/***/ "LNcM":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function(window, document) {
'use strict';


// Exits early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }
  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}(window, document));


/***/ }),

/***/ "LR4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LabeledIconsList_LabeledIconsList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.themes.js
var themes = {
  "default": {
    thRoot: 'flex justify-center',
    thListRoot: 'reset-list flex flex-row flex-wrap justify-between w-full',
    thListWidth: 'w-1/2',
    thItem: 'leading-normal text-center text-current text-md flex items-center my-px20',
    thItemWidth: 'calc(280rem / 16)',
    thIcon: 'flex items-center justify-center leading-none',
    thIconWidth: '2.5rem',
    thLabels: 'rtl:ml-px30 rtl:mr-px10 text-gray-darker'
  },
  list: {
    thRoot: 'flex flex-wrap',
    thListRoot: 'reset-list flex flex-col flex-wrap -mx-px10',
    thListWidth: 'md:w-1/2',
    thItem: 'flex items-start p-px10',
    thItemWidth: 'calc(280rem / 16)',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'leading-normal px-px10 text-base text-gray-darker'
  },
  listCondensed: {
    thRoot: 'flex',
    thListRoot: 'reset-list flex flex-col flex-wrap -mx-px10',
    thListWidth: 'md:w-1/2',
    thItem: 'flex items-start p-px10',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'leading-normal px-px10 text-base text-gray-darker'
  },
  comparator: {
    thRoot: 'h-full',
    thListRoot: 'reset-list flex font-bold h-1/2',
    thListFirst: 'py-px15 border-gray-dark',
    thListSubsequent: 'border-t-1 py-px15 border-gray-dark -mt-px',
    thItem: 'flex flex-1 px-px20 flex-col items-center text-center',
    thItemNth: 'rtl:border-l-1 border-gray-dark',
    thIconWidth: 'calc(40rem / 16)',
    thLabels: 'text-sm'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx





var __jsx = react_default.a.createElement;







var LabeledIconsList_LabeledIconsListItems = function LabeledIconsListItems(_ref) {
  var _classnames;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      isMoreThanOneList = _ref.isMoreThanOneList,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$listIndex = _ref.listIndex,
      listIndex = _ref$listIndex === void 0 ? 0 : _ref$listIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thItem = _themes$theme.thItem,
      thItemWidth = _themes$theme.thItemWidth,
      thItemNth = _themes$theme.thItemNth,
      thLabels = _themes$theme.thLabels,
      thListRoot = _themes$theme.thListRoot,
      thListWidth = _themes$theme.thListWidth,
      thListFirst = _themes$theme.thListFirst,
      thListSubsequent = _themes$theme.thListSubsequent;
  return __jsx("ul", {
    className: classnames_default()("text-".concat(color), thListRoot, (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, thListWidth, isMoreThanOneList), Object(defineProperty["a" /* default */])(_classnames, thListFirst, listIndex === 0), Object(defineProperty["a" /* default */])(_classnames, thListSubsequent, listIndex !== 0), _classnames))
  }, items.map(function (_ref2, idx) {
    var icon = _ref2.icon,
        labels = _ref2.labels;
    return __jsx("li", {
      className: classnames_default()(thItem, Object(defineProperty["a" /* default */])({}, thItemNth, idx > 0)),
      "data-testid": "LabeledIconsList-item",
      key: idx,
      style: {
        width: thItemWidth
      }
    }, __jsx("div", {
      className: thIcon
    }, __jsx(Icon["a" /* Icon */], {
      name: icon,
      width: thIconWidth,
      alt: (labels || []).join('/')
    })), !!labels.length && __jsx("div", {
      className: thLabels
    }, labels.map(function (label) {
      return __jsx("div", {
        "data-testid": "LabeledIconsList-label",
        key: label
      }, label);
    })));
  }));
};

var LabeledIconsList_LabeledIconsList = function LabeledIconsList(props) {
  var _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;

  if (!items.length) {
    return null;
  }

  var shouldSplitItems = theme !== 'default' && items.length > 2;
  var thRoot = themes[theme].thRoot;
  var splitItems = Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(items), Math.ceil(items.length / 2));
  var isMoreThanOneList = splitItems.length > 1;
  return __jsx("div", {
    className: thRoot
  }, shouldSplitItems ? splitItems.map(function (splitItem, idx) {
    return __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
      key: idx,
      listIndex: idx,
      isMoreThanOneList: isMoreThanOneList,
      items: splitItem
    }));
  }) : __jsx(LabeledIconsList_LabeledIconsListItems, Object(esm_extends["a" /* default */])({}, props, {
    listIndex: 0,
    items: items
  })));
};

/***/ }),

/***/ "LTtw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var getOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var setGlobal = __webpack_require__("edYw");
var copyConstructorProperties = __webpack_require__("sfoL");
var isForced = __webpack_require__("wxLG");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "LaX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookAndTwitterSeoHeaderMeta; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fGyu");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("vpUC");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FLQK");
/* harmony import */ var _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("psNz");








var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;





var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["b2cPagesService"].PAGE_TYPES;
var FacebookAndTwitterSeoHeaderMeta = function FacebookAndTwitterSeoHeaderMeta(_ref) {
  var description = _ref.description,
      _ref$immersiveUrl = _ref.immersiveUrl,
      immersiveUrl = _ref$immersiveUrl === void 0 ? '' : _ref$immersiveUrl,
      lines = _ref.lines,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === void 0 ? '' : _ref$pageType,
      title = _ref.title,
      url = _ref.url;

  /**
   * Format immersive url for SEO
   * @param {string} urlImmersive The url to format
   * @returns The url formatted
   */
  var getImmersiveUrl = function getImmersiveUrl(urlImmersive) {
    return _utils_media_server__WEBPACK_IMPORTED_MODULE_11__[/* getUrl */ "a"]({
      url: urlImmersive,
      width: 1200,
      height: 'auto',
      format: '_AUTOFORMAT_',
      quality: 70,
      transform: 'resize'
    });
  };

  var getFirstImmersiveUrl = function getFirstImmersiveUrl(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media, _line$props$media2;

      immersives = line.name === _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_12__[/* IMMERSIVE */ "r"] ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(immersives), [getImmersiveUrl(line.props.backgroundURL)]) : immersives;
      immersives = line.name === _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_12__[/* PRODUCT_IMMERSIVE */ "P"] && !!((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos) ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(immersives), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])((_line$props$media2 = line.props.media) === null || _line$props$media2 === void 0 ? void 0 : _line$props$media2.photos.map(function (p) {
        return getImmersiveUrl(p.url);
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives && immersives.length > 0 ? immersives[0] : '';
  };

  var immersiveUrlFromLines = lines && lines.length > 0 ? getFirstImmersiveUrl(lines) : '';
  return __jsx(next_head__WEBPACK_IMPORTED_MODULE_8___default.a, null, __jsx("meta", {
    property: "og:type",
    content: "website"
  }), pageType !== PAGE_TYPES.CRUISE && pageType !== PAGE_TYPES.RESORT && pageType !== PAGE_TYPES.RESORT_MICE && __jsx("meta", {
    property: "og:title",
    content: title
  }), pageType !== PAGE_TYPES.CRUISE && __jsx("meta", {
    property: "og:description",
    content: description
  }), __jsx("meta", {
    property: "og:image",
    content: immersiveUrl || immersiveUrlFromLines
  }), __jsx("meta", {
    property: "og:url",
    content: url
  }), __jsx("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), pageType !== PAGE_TYPES.CRUISE && pageType !== PAGE_TYPES.RESORT && pageType !== PAGE_TYPES.RESORT_MICE && __jsx("meta", {
    name: "twitter:title",
    content: title
  }), pageType !== PAGE_TYPES.CRUISE && __jsx("meta", {
    name: "twitter:description",
    content: description
  }), __jsx("meta", {
    name: "twitter:image",
    content: immersiveUrl || immersiveUrlFromLines
  }), __jsx("meta", {
    name: "twitter:url",
    content: url
  }));
};

/***/ }),

/***/ "M3jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterTransport; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7amT");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;







var FilterTransport = function FilterTransport(_ref) {
  var changeDepartureCity = _ref.changeDepartureCity,
      className = _ref.className,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'FilterTransport' : _ref$dataTestId,
      departureCity = _ref.departureCity,
      isDisabled = _ref.isDisabled,
      isLoading = _ref.isLoading,
      optionsDepartureCities = _ref.optionsDepartureCities,
      _ref$reassurance = _ref.reassurance,
      reassurance = _ref$reassurance === void 0 ? [] : _ref$reassurance,
      _ref$withIntroduction = _ref.withIntroduction,
      withIntroduction = _ref$withIntroduction === void 0 ? true : _ref$withIntroduction;
  var value = departureCity ? departureCity : '';
  var loading = isLoading || optionsDepartureCities.length === 0;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'flex flex-col'),
    "data-testid": "FilterTransport"
  }, __jsx("div", {
    className: "border-b-1 p-px20 pb-px10"
  }, withIntroduction && __jsx("p", {
    className: "font-brand mb-px10 reset-paragraph text-base text-blue text-center"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('faceting.transport.introduction')), !!reassurance && !!reassurance.length && __jsx("ul", {
    className: "mb-px20 reset-list"
  }, reassurance.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return __jsx("li", {
      className: "flex items-center py-px5 text-sm",
      key: label
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
      className: "flex-shrink-0 rtl:mr-px10",
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE,
      name: iconName,
      width: "1.25rem"
    }), label);
  })), __jsx("p", {
    className: "font-bold reset-paragraph text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_6__[/* t */ "h"])('faceting.when.from'))), loading ? __jsx("div", {
    className: "flex-1 flex items-center justify-center leading-none p-px20"
  }, __jsx(_frameworks_spinner_Spinner__WEBPACK_IMPORTED_MODULE_8__[/* Spinner */ "a"], {
    size: "small"
  })) : __jsx("ul", {
    className: "flex-1 lg:flex-none px-px20 py-px10 max-h-none lg:max-h-50vh overflow-y-auto reset-list text-base"
  }, optionsDepartureCities.map(function (o) {
    return __jsx("li", {
      className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
        'font-bold text-success': o.value === value
      }),
      key: o.value
    }, __jsx("label", {
      className: "cursor-pointer flex items-baseline justify-between py-px5",
      htmlFor: o.value
    }, __jsx("input", {
      checked: o.value === value,
      className: "hidden",
      "data-testid": "".concat(dataTestId, "-").concat(o.value),
      disabled: o.isDisabled || isDisabled,
      id: o.value,
      name: "TransportSelectFilter",
      onChange: function onChange(e) {
        return changeDepartureCity(e.target.value);
      },
      type: "radio",
      value: o.value
    }), o.label, o.value === value && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_5__[/* ICONS */ "a"].CHECK,
      width: "0.625rem"
    })));
  })));
};

/***/ }),

/***/ "M4Qz":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var toIndexedObject = __webpack_require__("dNjr");
var indexOf = __webpack_require__("5LiQ").indexOf;
var hiddenKeys = __webpack_require__("qXr/");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "MAH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCxoAttendeesData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return proposalsByIdQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return streetViewsByAccommodationCategoryId; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Cm4o");
/* harmony import */ var core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SQLw");
/* harmony import */ var _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("BYx+");
/* harmony import */ var _store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("GZ82");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("70jX");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("L7OA");















var CHILDREN_ACTIVITY_IDENTIFIER = '_CHILD_';
function getResort() {
  var fetchActivityCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return "\n    resort {\n      accommodations {\n        category\n        categoryId\n        comfortId\n        comfortType\n        connectingRoom\n        id\n        roomType\n      }\n      adultOnly\n      associatedResort{\n        id\n        name\n      }\n      badgeIcon\n      category\n      childcareDetails {\n        isIncluded\n      }\n      childrenActivities: productActivities(idFilter: \"".concat(CHILDREN_ACTIVITY_IDENTIFIER, "\") {\n        ageInMonths {\n          max\n          min\n        }\n        description\n        equipments {\n          id\n          label\n        }\n        id\n        isIncluded\n        label\n        subtitle\n      }\n      color\n      comfort\n      comfortLabel\n      destination {\n        area\n        country\n      }\n      facilities(types: [\"CHILDREN\",\"PARKING\"], withEquipments: true) {\n        equipments {\n          id\n          label\n        }\n        label\n        subtitle\n        type\n      }\n      href\n      id\n      image\n      images\n      isCruise\n      isExclusiveCollection\n      isExplicitEC\n      isJoyview\n      name\n      offsetSell\n      openingDates {\n        opening\n        closing\n      }\n      seasonName\n      seasons\n      title\n      transportType\n      type\n      ").concat(fetchActivityCategories ? "activityCategories {\n        leisure {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            startDate\n            endDate\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n        wellness {\n          id\n          label\n          subCategories {\n            id\n            label\n            imageUrl\n            keywords\n            activities {\n              id\n              label\n              description\n              isIncluded\n              durationDescription\n              practiceLevelDescription\n              activityTags{\n                id\n                label\n              }\n              ageInMonths {\n                min\n                max\n              }\n            }\n          }\n        }\n      }" : '', "\n    }");
}

function getValidationSchema() {
  var productId = new URL(window.location.href).searchParams.get('coderesort');

  if (productId) {
    return "\n      validationSchema(productId: \"".concat(productId, "\", resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n    ");
  }

  return "\n      validationSchema(resource : \"profile\", fields: [\"address\"]) {\n        ...ValidationSchemaAddress\n      }\n    ";
}

var getCxoAttendeesData = function getCxoAttendeesData(_ref) {
  var adultsAttendeesIds = _ref.adultsAttendeesIds,
      kidsAttendeesIds = _ref.kidsAttendeesIds;
  return "".concat(adultsAttendeesIds && adultsAttendeesIds[0] ? "adultsAttendees: attendees(attendeesIds: [\"".concat(adultsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n          birthdate: dateOfBirth\n          email\n          mobile: mobilePhoneNumber\n          optinEmail\n          optinSms\n          optinPhone\n          optinMail\n          optinClubmedPlus\n          address {\n            streetNumber\n            streetName\n            additionalInformation1\n            additionalInformation2\n            addOn\n            zipCode\n            city\n            town\n            stateOrDistrict\n            countryCode\n            country\n          }\n        }") : '', "\n  ").concat( // no need of birthday, we already have it
  kidsAttendeesIds && kidsAttendeesIds[0] ? "kidsAttendees: attendees(attendeesIds: [\"".concat(kidsAttendeesIds.join('","'), "\"]) {\n          ...BookingAttendeesProfile\n        }") : '', "\n");
};
/*
 * * Used in fetchProposalsById to get transports list and node for <TransportsSection/>
 * * Uses  API route /v1/proposals/{proposal_id}
 */


function proposalsByIdQuery(params, appContext) {
  var proposalsArgs = Array.isArray(params.proposalsId) ? ["ids: [\"".concat(params.proposalsId.join('","'), "\"]")] : ["ids: [\"".concat(params.proposalsId, "\"]")];
  var displayCommission = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_14__[/* isFeatureFlipped */ "a"])(appContext)('booking.displayCommission');
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"].runNoCacheQuery("\n    {\n      proposals: proposalsById(".concat(proposalsArgs.join(', '), ") {\n        ... on ProposalsType {\n          proposals {\n            ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_12__[/* getPaymentScheduleRequest */ "g"])(appContext) : '', "\n            ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_12__[/* proposalFields */ "l"])({
    isJoyView: true,
    withCommission: (appContext.isCmta || appContext.isIndirectCxo) && displayCommission
  }), "\n          }\n          ").concat(getResort(params.fetchActivityCategories), "\n        }\n      }\n      ").concat(getValidationSchema(), "\n      ").concat(appContext.isUserLogged ? 'profile {...BookingProfile}' : '', "\n      ").concat( // When it is an attendee identified on the Cxo side we already know the customerIds
  // via the cxo_traveler query param
  getCxoAttendeesData(params), "\n      ").concat(params.shouldRequestPayment ? Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_12__[/* paymentProvidersRequest */ "j"])() : '', "\n    }\n    ").concat(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_12__[/* transportDetailsFragment */ "q"], "\n    ").concat(_store_validation_schema_validationSchema_address_fragment__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"], "\n    ").concat(Object(_utils_graphql_query_helper_booking_proposal_proposalQuery__WEBPACK_IMPORTED_MODULE_12__[/* getPriceDetailFragment */ "h"])(Object(lodash__WEBPACK_IMPORTED_MODULE_7__["get"])(appContext, 'locale')), "\n    ").concat(appContext.isUserLogged ? _components_widgets_contact_info_ContactInfo_fragment__WEBPACK_IMPORTED_MODULE_9__[/* profileFragment */ "b"] : '', "\n    ").concat(params.adultsAttendeesIds && params.adultsAttendeesIds[0] || params.kidsAttendeesIds && params.kidsAttendeesIds[0] ? _components_widgets_contact_info_BookingAttendeesProfile_fragment__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"] : '', "\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* PROPOSAL_GET_BY_ID */ "kd"]
  });
}
/*
 * * Used in fetchStreetViewsByAccommodationCategoryId to get street views list for <AccommodationRoomSlideshow/>
 * * Uses  API route GET /v0/products/{product_id}/accommodation_categories/{accommodation_category_id}/virtual_visits
 */


function streetViewsByAccommodationCategoryId(params, appContext) {
  var streetViewsArgs = ["productId: \"".concat(params.productId, "\"")];
  streetViewsArgs.push(Array.isArray(params.accommodationCategoryIds) ? "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds.join('","'), "\"]") : "accommodationCategoryIds: [\"".concat(params.accommodationCategoryIds, "\"]"));
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"].runNoCacheQuery("\n    {\n      streetViews(".concat(streetViewsArgs.join(', '), ") {\n        accommodationCategoryId\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n        }\n      }\n    }\n  "), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_13__[/* STREET_VIEW_GET_SEVERAL */ "Hd"]
  });
}



/***/ }),

/***/ "MRpX":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var setPrototypeOf = __webpack_require__("iBXc");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "MU85":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");
var getMethod = __webpack_require__("Uey1");
var Iterators = __webpack_require__("oa0l");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "MX/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_TRANSPORT_EVENT; });
var OPEN_CRITERIA_TRANSPORT_EVENT = 'openCriteriaTransport';

/***/ }),

/***/ "MaE1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = global;


/***/ }),

/***/ "Mn1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrivalDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripDateCriteriaSelector = function tripDateCriteriaSelector(_ref) {
  var tripDateCriteria = _ref.tripDateCriteria;
  return tripDateCriteria || {};
};

var getArrivalDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref2) {
  var arrivalDate = _ref2.arrivalDate;
  return arrivalDate;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripDateCriteriaSelector, function (_ref3) {
  var departureDate = _ref3.departureDate;
  return departureDate;
});


/***/ }),

/***/ "MwrP":
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__("4uJK"),
    getTag = __webpack_require__("kkM+"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD"),
    isArrayLike = __webpack_require__("9y2L"),
    isBuffer = __webpack_require__("3ajY"),
    isPrototype = __webpack_require__("CbIe"),
    isTypedArray = __webpack_require__("Qd2C");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ "N5WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Tag; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.themes.js

var themes = {
  "default": function _default(_ref) {
    var onClick = _ref.onClick;
    return {
      thRoot: 'bg-current inline-flex items-stretch rounded-tiny text-base',
      thBody: classnames_default()('flex items-center font-bold leading-one m-px5 text-current', {
        'reset-button': onClick
      }),
      thBadgeStyle: {
        width: '1.5em',
        height: '1.5em'
      },
      thBadge: 'bg-white flex items-center justify-center leading-one m-px5 overflow-hidden rounded-full text-center',
      thBadgeLabel: 'text-sm',
      thIconSize: '1em',
      thIconLeft: 'm-px5 text-white',
      thIconRight: 'm-px5 text-white',
      thLabel: 'inline-flex m-px5 text-white',
      thClose: 'p-px10 reset-button text-white',
      thCloseSize: '0.625em'
    };
  },
  outlined: function outlined(_ref2) {
    var onClick = _ref2.onClick;
    return {
      thRoot: 'border-2 border-current inline-flex items-stretch text-sm',
      thBody: classnames_default()('flex items-center font-bold leading-one px-px10 py-px5 text-current uppercase', {
        'reset-button': onClick
      }),
      thBadgeStyle: {
        width: '2em',
        height: '2em'
      },
      thBadge: 'bg-white border-1 border-current flex items-center justify-center leading-one m-px5 overflow-hidden rounded-full text-center',
      thBadgeLabel: '',
      thIconSize: '1em',
      thIconLeft: 'm-px5',
      thIconRight: 'm-px5',
      thLabel: 'inline-flex m-px5',
      thClose: 'm-px10 reset-button text-current',
      thCloseSize: '0.625em'
    };
  },
  outlinedThin: function outlinedThin(_ref3) {
    var onClick = _ref3.onClick,
        active = _ref3.active;
    return {
      thRoot: classnames_default()('border border-current items-stretch rounded-tiny text-sm', {
        'bg-current': active,
        'bg-white': !active
      }),
      thBody: classnames_default()('flex items-center leading-one px-px10 py-px5 text-base text-current', {
        'reset-button': onClick
      }),
      thBadgeStyle: {
        width: '2em',
        height: '2em'
      },
      thBadge: 'bg-white border-1 border-current flex items-center justify-center leading-one m-px5 overflow-hidden rounded-full text-center',
      thBadgeLabel: '',
      thIconSize: '1em',
      thIconLeft: classnames_default()('m-px5', {
        'text-white': active
      }),
      thIconRight: classnames_default()('m-px5', {
        'text-white': active
      }),
      thLabel: classnames_default()('inline-flex m-px5 whitespace-no-wrap', {
        'text-white': active
      }),
      thClose: classnames_default()('m-px10 reset-button text-current', {
        'text-white': active
      }),
      thCloseSize: '0.625em'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tag/Tag.jsx



var __jsx = react_default.a.createElement;








var Tag = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var active = props.active,
      badge = props.badge,
      borderColor = props.borderColor,
      className = props.className,
      closeLabel = props.closeLabel,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].BLUE : _props$color,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'Tag' : _props$dataTestId,
      href = props.href,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      label = props.label,
      _onClick = props.onClick,
      onClose = props.onClose,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      _props$trackingData = props.trackingData,
      trackingData = _props$trackingData === void 0 ? {} : _props$trackingData,
      rest = Object(objectWithoutProperties["a" /* default */])(props, ["active", "badge", "borderColor", "className", "closeLabel", "color", "dataTestId", "href", "iconLeft", "iconRight", "label", "onClick", "onClose", "tabIndex", "theme", "trackingData"]);

  var track = !Object(lodash["isEmpty"])(trackingData) && _onClick ? Object(useTracking["a" /* useTracking */])(trackingData) : lodash["noop"];

  if (!label) {
    return null;
  }

  var TagName = 'div';

  if (href) {
    TagName = 'a';
  } else if (_onClick) {
    TagName = 'button';
  }

  var _themes$theme = themes[theme](props),
      thRoot = _themes$theme.thRoot,
      thBody = _themes$theme.thBody,
      thBadge = _themes$theme.thBadge,
      thBadgeStyle = _themes$theme.thBadgeStyle,
      thBadgeLabel = _themes$theme.thBadgeLabel,
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconSize = _themes$theme.thIconSize,
      thLabel = _themes$theme.thLabel,
      thClose = _themes$theme.thClose,
      thCloseSize = _themes$theme.thCloseSize;

  return __jsx("div", {
    className: classnames_default()(className, "text-".concat(color, " border-").concat(borderColor || color), thRoot)
  }, __jsx(TagName, Object(esm_extends["a" /* default */])({}, rest, {
    className: thBody,
    "data-testid": dataTestId,
    onClick: function onClick(e) {
      _onClick && _onClick(e);
      track({});
    },
    ref: ref,
    title: label,
    href: href
  }, _onClick ? {
    tabIndex: tabIndex,
    type: href ? 'link' : 'button'
  } : null), !!badge && __jsx("span", {
    key: "badge",
    className: thBadge,
    style: thBadgeStyle,
    "data-testid": "Tag-badge"
  }, typeof badge === 'string' ? __jsx("span", {
    className: thBadgeLabel
  }, badge) : badge), !!iconLeft && __jsx(Icon["a" /* Icon */], {
    key: "icon-left",
    className: thIconLeft,
    name: iconLeft,
    width: thIconSize
  }), __jsx("span", {
    key: "label",
    className: thLabel
  }, label), !!iconRight && __jsx(Icon["a" /* Icon */], {
    key: "icon-right",
    className: thIconRight,
    name: iconRight,
    width: thIconSize
  })), !!onClose && __jsx("button", {
    className: thClose,
    onClick: onClose,
    tabIndex: tabIndex,
    type: "button",
    "data-testid": "Tag-Close"
  }, !!closeLabel && __jsx("span", {
    className: "sr-only"
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseSize
  })));
});

/***/ }),

/***/ "N7I1":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "NLwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return graphqlify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return graphqlifyString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildProductArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildCruiseArgs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildArgs; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_12__);













function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var EMPTY_STRING = '""';

function graphqlify(jsonObject) {
  if (jsonObject) {
    return JSON.stringify(jsonObject).replace(/\"([^(\")"]+)\":/g, '$1:').replace(/(null)/g, EMPTY_STRING);
  }

  return '';
}

function graphqlifyString(str) {
  if (Object(lodash__WEBPACK_IMPORTED_MODULE_12__["isString"])(str)) {
    return JSON.stringify(str);
  }

  return EMPTY_STRING;
}

function buildArgs() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var initialArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object.keys(args).reduce(function (acc, key) {
    var value = args[key];

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_12__["isNull"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_12__["isUndefined"])(value)) {
      return acc;
    }

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_12__["isNumber"])(value) || Object(lodash__WEBPACK_IMPORTED_MODULE_12__["isBoolean"])(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(value);
    }

    if (Object(lodash__WEBPACK_IMPORTED_MODULE_12__["isArray"])(value)) {
      return "".concat(acc, " ").concat(key, ": ").concat(graphqlify(value));
    }

    return "".concat(acc, " ").concat(key, ": \"").concat(value, "\"");
  }, initialArgs);
}

function getCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$arrivalDate = params.arrivalDate,
      arrivalDate = _params$arrivalDate === void 0 ? '' : _params$arrivalDate;
  return {
    cruiseDepartureDate: departureDate,
    cruiseArrivalDate: arrivalDate
  };
}

function buildCruiseArgs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var optionalArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var args = _objectSpread(_objectSpread({}, optionalArguments), getCruiseArgs(params));

  return buildArgs(args);
}

var CRUISE_RESORT_ID = 'CM2C';

function buildProductArgs(productId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var optionalArguments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!productId) {
    throw new Error('You must provide a productId');
  }

  var productArg;

  if (productId !== CRUISE_RESORT_ID) {
    productArg = "productId: \"".concat(productId, "\"");
  } else {
    var _getCruiseArgs = getCruiseArgs(params),
        cruiseDepartureDate = _getCruiseArgs.cruiseDepartureDate,
        cruiseArrivalDate = _getCruiseArgs.cruiseArrivalDate;

    productArg = "productId: \"".concat(productId, "_").concat(cruiseDepartureDate, "_").concat(cruiseArrivalDate, "\"");
  }

  return buildArgs(optionalArguments, productArg);
}



/***/ }),

/***/ "NPTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SeeMore_SeeMore; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMore.themes.js
var COLLAPSED_OVERLAY_HEIGHT = 50;
var themes = {
  "default": {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 100%)'
    },
    thButton: 'reset-button mt-px10 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline'
  },
  gray: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #f7f7f7 100%)'
    },
    thButton: 'reset-button mt-px10 text-base text-gray-darker focus:text-blue hover:text-blue transition-color underline'
  },
  deepBlue: {
    thBlurStyle: {
      height: COLLAPSED_OVERLAY_HEIGHT,
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, hsla(216, 100%, 18%, 1) 100%)'
    },
    thButton: 'reset-button mt-px10 text-base text-white transition-color underline'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMoreEngine.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var SeeMoreEngine_SeeMoreEngine = function SeeMoreEngine(_ref) {
  var children = _ref.children,
      className = _ref.className,
      classNameButton = _ref.classNameButton,
      _ref$hasDynamicHeight = _ref.hasDynamicHeight,
      hasDynamicHeight = _ref$hasDynamicHeight === void 0 ? false : _ref$hasDynamicHeight,
      _ref$hasNoScrollOnCol = _ref.hasNoScrollOnCollapse,
      hasNoScrollOnCollapse = _ref$hasNoScrollOnCol === void 0 ? false : _ref$hasNoScrollOnCol,
      _ref$isCollapseEnable = _ref.isCollapseEnabled,
      isCollapseEnabled = _ref$isCollapseEnable === void 0 ? true : _ref$isCollapseEnable,
      _ref$offsetScrollSele = _ref.offsetScrollSelector,
      offsetScrollSelector = _ref$offsetScrollSele === void 0 ? Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */] : _ref$offsetScrollSele,
      _onClick = _ref.onClick,
      _ref$seeLessLabel = _ref.seeLessLabel,
      seeLessLabel = _ref$seeLessLabel === void 0 ? Object(i18n["h" /* t */])('common.loadLess') : _ref$seeLessLabel,
      _ref$seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLabel = _ref$seeMoreLabel === void 0 ? Object(i18n["h" /* t */])('common.loadMore') : _ref$seeMoreLabel,
      _ref$seeMoreSize = _ref.seeMoreSize,
      seeMoreSize = _ref$seeMoreSize === void 0 ? 120 : _ref$seeMoreSize,
      _ref$seeMoreSizeToler = _ref.seeMoreSizeTolerance,
      seeMoreSizeTolerance = _ref$seeMoreSizeToler === void 0 ? 30 : _ref$seeMoreSizeToler,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useState = Object(react["useState"])(0),
      height = _useState[0],
      setHeight = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isCollapsable = _useState2[0],
      setIsCollapsable = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isExpanded = _useState3[0],
      setIsExpanded = _useState3[1];

  var ref = Object(react["useRef"])(null);
  var seeMoreSizeTolerated = seeMoreSize + seeMoreSizeTolerance;
  Object(react["useEffect"])(function () {
    var _ref$current;

    if (children && (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientHeight) && ref.current.clientHeight > seeMoreSizeTolerated) {
      setHeight(ref.current.clientHeight);
    }
  }, [children, ref]);
  Object(react["useEffect"])(function () {
    if (height > seeMoreSizeTolerated) {
      setIsCollapsable(true);
    }
  }, [height]);

  if (!react["Children"].count(children)) {
    return null;
  }

  if (!isCollapseEnabled) {
    return children;
  }

  var _themes$theme = themes[theme],
      thBlurStyle = _themes$theme.thBlurStyle,
      thButton = _themes$theme.thButton;
  return __jsx("div", {
    className: className
  }, __jsx("div", Object(esm_extends["a" /* default */])({
    className: "overflow-hidden relative transition-heights",
    ref: ref
  }, hasDynamicHeight && isCollapsable && !isExpanded && {
    style: {
      height: seeMoreSize
    }
  }, !hasDynamicHeight && isCollapsable && {
    style: {
      height: isExpanded ? height : seeMoreSize
    }
  }), children, isCollapsable && __jsx("div", {
    className: classnames_default()('absolute bottom-0 w-full', {
      'opacity-0': isExpanded,
      'opacity-100': !isExpanded
    }),
    style: _objectSpread(_objectSpread({}, thBlurStyle), {}, {
      height: isExpanded ? 0 : thBlurStyle.height
    })
  })), isCollapsable && __jsx("div", {
    className: classNameButton
  }, __jsx("button", {
    className: thButton,
    onClick: function onClick(e) {
      setIsExpanded(!isExpanded);
      _onClick && _onClick(e, isExpanded);

      if (isExpanded && !hasNoScrollOnCollapse) {
        Object(scrollToElement["a" /* scrollToElement */])(ref.current, 300, ".".concat(offsetScrollSelector));
      }
    },
    type: "button"
  }, isExpanded ? seeLessLabel : seeMoreLabel, __jsx(Icon["a" /* Icon */], {
    className: "mx-px5",
    name: isExpanded ? icons["a" /* ICONS */].MINUS : icons["a" /* ICONS */].PLUS,
    width: "0.7em"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx
var SeeMore_jsx = react_default.a.createElement;





var SeeMore_SeeMore = function SeeMore(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var unfoldMobileContent = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('unfoldMobileContent');

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return !isDesktop && unfoldMobileContent ? props.children : SeeMore_jsx(SeeMoreEngine_SeeMoreEngine, props);
};

/***/ }),

/***/ "NWzG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaTransport; });
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("uDfI");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("SPKZ");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+Rc+");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("MX/n");
/* harmony import */ var _filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("M3jp");
/* harmony import */ var _hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Akr5");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("loSl");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("vIa8");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("RBO1");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("sW3P");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

















var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["constants"].NO_TRANSPORT_VALUE;
var CriteriaTransport = function CriteriaTransport(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      initialTransport = _ref.initialTransport,
      reassurance = _ref.reassurance,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].TRANSPORT : _ref$transportIcon,
      withValidDepartureCity = _ref.withValidDepartureCity;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_2__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_7__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_8__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_3__[/* useDispatch */ "d"])();
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_3__[/* useSelector */ "e"])(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_16__[/* getDepartureCity */ "a"]);
  var facetingFilters = Object(react_redux__WEBPACK_IMPORTED_MODULE_3__[/* useSelector */ "e"])(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* filtersSelector */ "h"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  }); // Store update effect

  var _useSyncDepartureCity = Object(_hooks_use_sync_departure_city_useSyncDepartureCity__WEBPACK_IMPORTED_MODULE_12__[/* useSyncDepartureCity */ "a"])({
    departureCitiesOptions: departureCitiesOptions,
    departureCity: departureCity,
    initialTransport: initialTransport,
    onChange: function onChange(newDepartureCity) {
      setCriteriaContext({
        criteriaTransportIsSet: Boolean(newDepartureCity)
      });
    },
    withValidDepartureCity: withValidDepartureCity
  }),
      inputDepartureCity = _useSyncDepartureCity.inputDepartureCity,
      setInputDepartureCity = _useSyncDepartureCity.setInputDepartureCity;

  var noDepartureCitiesOptions = [{
    isDisabled: true,
    isSelected: true,
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_8__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaTransport'
    });
  }; // Open/Close effect


  Object(react__WEBPACK_IMPORTED_MODULE_2__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_10__[/* OPEN_CRITERIA_TRANSPORT_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_10__[/* OPEN_CRITERIA_TRANSPORT_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var saveTransport = function saveTransport() {
    if (inputDepartureCity !== departureCity) {
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_14__[/* changeDepartureCity */ "a"])(inputDepartureCity));
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_8__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaTransport'
    });
  };

  var getIcon = function getIcon() {
    if (departureCity === NO_TRANSPORT_VALUE) {
      return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_6__[/* ICONS */ "a"].NO_TRANSPORT;
    }

    return transportIcon;
  };

  var getLabel = function getLabel() {
    if (!criteriaContext.criteriaTransportIsSet) {
      return Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('faceting.transport.departingFrom');
    }

    var selectedOption = departureCitiesOptions.find(function (item) {
      return item.value === departureCity;
    });

    if (!selectedOption) {
      var departureCityFilter = facetingFilters.find(function (_ref2) {
        var id = _ref2.id;
        return id === _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_18__[/* DEPARTURE_CITY_FACET_ID */ "i"];
      });
      return departureCityFilter ? departureCityFilter.label : '';
    }

    return selectedOption.label;
  };

  var buttonIsLoading = !departureCitiesOptions.length && isLoading && criteriaContext.criteriaTransportIsSet;

  var buttonLabel = __jsx("span", {
    className: "flex-1 hidden lg:block truncate"
  }, getLabel());

  var trackDepartureCityChange = function trackDepartureCityChange(newDepartureCity) {
    if (newDepartureCity) {
      var labelGA = "departureCity_".concat(newDepartureCity);

      if (criteriaContext.trackingActionName) {
        track({
          labelGA: labelGA
        });
      }
    }
  };

  return __jsx(_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_9__[/* CriteriaTrigger */ "a"], {
    dataTestId: "CriteriaTransport-trigger",
    buttonLabel: buttonLabel,
    buttonIcon: getIcon(),
    buttonIsFilled: criteriaContext.criteriaTransportIsSet && departureCity !== NO_TRANSPORT_VALUE,
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputDepartureCity('');
      },
      className: 'cursor-pointer text-sm'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('faceting.validate'),
      color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].WHITE,
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].TURQUOISE,
      onClick: saveTransport
    }],
    hasSwitch: true,
    isJoyview: isJoyview,
    isLoading: buttonIsLoading,
    isOpen: criteriaDisplayContext.criteriaTransportIsOpen,
    onClear: function onClear() {
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_14__[/* changeDepartureCity */ "a"])(''));
    },
    onClose: saveTransport,
    onOpen: function onOpen() {
      dispatchCriteriaDisplayContext({
        type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_8__[/* ACTIONS */ "a"].OPEN_CRITERIA,
        payload: 'criteriaTransport'
      });
    },
    trackingLabel: "departureCity"
  }, __jsx(_filter_transport_FilterTransport__WEBPACK_IMPORTED_MODULE_11__[/* FilterTransport */ "a"], {
    dataTestId: "CriteriaTransport-input",
    className: "h-full",
    optionsDepartureCities: !isLoading && !departureCitiesOptions.length ? noDepartureCitiesOptions : departureCitiesOptions,
    isDisabled: !isLoading && !departureCitiesOptions.length,
    isLoading: isLoading,
    reassurance: reassurance,
    changeDepartureCity: function changeDepartureCity(newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
      trackDepartureCityChange(newDepartureCity);
    },
    departureCity: !departureCitiesOptions.length ? '' : inputDepartureCity,
    labelDepartingFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('faceting.transport.departingFrom'),
    selectPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('faceting.transport.selectPlaceholder'),
    placeholderFrom: Object(_i18n__WEBPACK_IMPORTED_MODULE_13__[/* t */ "h"])('faceting.transport.titleFrom')
  }));
};

/***/ }),

/***/ "NXDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getInstallmentPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTotalPriceWithDonation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasAtLeastOnePrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isLongFormat; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("wz9x");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");














function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var MAX_LENGTH = 10;

function getCurrencySymbol(locale, currency) {
  return 0 .toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim();
}

function hasPrice(price) {
  return !!(price === null || price === void 0 ? void 0 : price.value);
}

var hasDiscount = function hasDiscount(_ref) {
  var bestPrice = _ref.bestPrice,
      initialPrice = _ref.initialPrice;
  return hasPrice(initialPrice) && hasPrice(bestPrice) && (initialPrice === null || initialPrice === void 0 ? void 0 : initialPrice.value) !== (bestPrice === null || bestPrice === void 0 ? void 0 : bestPrice.value);
};

function hasAtLeastOnePrice() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref2 = props || {},
      initialPrice = _ref2.initialPrice,
      bestPrice = _ref2.bestPrice;

  return hasPrice(initialPrice) || hasPrice(bestPrice);
}

var isLongFormat = function isLongFormat(amount) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_LENGTH;
  return amount ? amount.toString().length > limit : false;
};

var getTotalPriceWithDonation = function getTotalPriceWithDonation(price, locale) {
  var donation = price.donation,
      total = price.total,
      totalWithoutDiscount = price.totalWithoutDiscount;
  var totalWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_13__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_13__["get"])(total, 'value', 0);
  var totalWithoutDiscountWithDonation = Object(lodash__WEBPACK_IMPORTED_MODULE_13__["get"])(donation, 'value', 0) + Object(lodash__WEBPACK_IMPORTED_MODULE_13__["get"])(totalWithoutDiscount, 'value', 0);
  var currencyOptions = {
    precision: Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_15__["getBookingPrecision"])(locale)
  };
  return _objectSpread(_objectSpread({}, price), {}, {
    withDonation: {
      total: {
        value: totalWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithDonation, locale, price.currency, currencyOptions)
      },
      totalWithoutDiscount: {
        value: totalWithoutDiscountWithDonation,
        formattedValue: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(totalWithoutDiscountWithDonation, locale, price.currency, currencyOptions)
      },
      hasFlexRates: price.hasFlexRates,
      selectedRate: price.selectedRate
    }
  });
};

var getInstallmentPrice = function getInstallmentPrice(price, locale) {
  if (!price || !price.value) return '';

  if (Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.displayInstalmentsPrice')) {
    var instalmentValue = Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* getKeyValue */ "d"])('common.price.instalmentValue');
    return Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('common.price.instalmentPrice', {
      instalmentValue: instalmentValue,
      dividedPrice: Object(_utils_currency_config_for_locale_currencyConfigForLocale__WEBPACK_IMPORTED_MODULE_14__[/* formatAmountForLocale */ "b"])(Math.ceil(price.value / instalmentValue), locale, price.currency, {
        precision: 0
      })
    });
  }

  return price.formattedValue;
};


/***/ }),

/***/ "NZxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Backdrop_Backdrop; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 10 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-lock/dist/es2015/MoveFocusInside.js
var MoveFocusInside = __webpack_require__("oweP");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/backdrop/Backdrop.themes.js
var themes = {
  "default": {
    thCloseButton: 'reset-button bg-white flex items-center justify-center leading-none m-px20 rtl:right-0 rtl:slideInRight rounded-tiny shadow text-gray-darker text-sm transition-colors',
    thCloseButtonStyle: {
      width: 28,
      height: 28
    },
    thCloseButtonLabel: 'sr-only'
  },
  lite: {
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none mt-px20 mx-px20 md:mx-px50 p-px15 rtl:right-0 rounded-full text-gray-darker text-md rtl:slideInRight',
    thCloseButtonLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx

var __jsx = react_default.a.createElement;









var Backdrop_Backdrop = function Backdrop(_ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? '#000' : _ref$bgColor,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      externalFocusTrapRefs = _ref.externalFocusTrapRefs,
      hasCloseButton = _ref.hasCloseButton,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      onClose = _ref.onClose,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? 0.8 : _ref$opacity,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["b" /* AFTER_APP */] : _ref$portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thCloseButtonStyle = _themes$theme.thCloseButtonStyle;
  var closeBtnLabel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: true
  }, __jsx("div", {
    className: classnames_default()(className, 'fadeIn fixed inset-0 escape-responsive-helper z-3')
  }, __jsx("div", {
    className: "fixed h-screen inset-0 z-1",
    "data-testid": "Backdrop-overlay",
    style: {
      backgroundColor: bgColor,
      opacity: opacity
    }
  }), __jsx("div", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, hasCloseButton ? __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: externalFocusTrapRefs
  }, __jsx(MoveFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('absolute top-0 z-3', thCloseButton),
    "data-testid": "Backdrop-close",
    onClick: onClose,
    title: closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : null,
    type: "button",
    style: thCloseButtonStyle
  }, closeBtnLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("div", {
    className: "absolute flex items-center justify-center inset-0 z-2"
  }, children)) : __jsx("div", {
    className: "absolute flex items-center justify-center inset-0 p-px20 z-2"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    className: "max-w-full",
    enabled: !hasNoFocusTrap,
    onClickOutside: onClose,
    onEscapeKey: onClose,
    shards: externalFocusTrapRefs
  }, children)))))));
};

/***/ }),

/***/ "Ndl3":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L"),
    isObjectLike = __webpack_require__("tLQN");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "NrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackSearchResults; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _FacetSearch_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("hPQF");
/* harmony import */ var _global_search_GlobalSearchSuggestionsList__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("RWDY");
/* harmony import */ var _store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("vIa8");
/* harmony import */ var _store_search_search_selector__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("B3yO");
/* harmony import */ var _store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("RBO1");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("Jsmy");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("sRdV");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_tracking_resort__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("zCbR");
/* harmony import */ var _store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("apzf");











function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}















var useTrackSearchResults = function useTrackSearchResults() {
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_20__[/* useTracking */ "a"])();
  var adults = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_18__[/* getAdults */ "a"])(state) || [];
  });
  var departureCity = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__[/* getDepartureCity */ "a"])(state);
  });
  var departureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__[/* getDepartureDate */ "b"])(state);
  });
  var duration = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_criteria_tripCriteria_selector__WEBPACK_IMPORTED_MODULE_17__[/* getTripDuration */ "c"])(state);
  });

  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* facetingCriteriaSelector */ "c"])(state);
  }),
      _useSelector$filters = _useSelector.filters,
      filters = _useSelector$filters === void 0 ? [] : _useSelector$filters;

  var keywords = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_search_search_selector__WEBPACK_IMPORTED_MODULE_16__[/* keywordsSelector */ "a"])(state);
  });
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_18__[/* getKids */ "c"])(state) || [];
  });
  var products = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* filteredProductsSelector */ "g"])(state) || [];
  });
  var productsCount = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (state) {
    return Object(_store_faceting_faceting_selector__WEBPACK_IMPORTED_MODULE_15__[/* filteredProductsCountSelector */ "e"])(state) || 0;
  });
  var facetingQuery = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.query || {};
  });
  var redirection = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.redirection;
  });
  var profile = Object(react_redux__WEBPACK_IMPORTED_MODULE_11__[/* useSelector */ "e"])(_store_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_23__[/* userInfoSelector */ "a"]);
  var isFromAutoComplete = Boolean(facetingQuery.type);
  var nbAdults = adults.length;
  var nbKids = kids.length;
  var nbParticipants = nbAdults + nbKids;
  var searchTerms = isFromAutoComplete || facetingQuery.label ? facetingQuery.label : keywords;
  var withFilter = Boolean(nbKids > 0 || duration || departureDate || departureCity || filters.length > 0);

  var executeTracking = function executeTracking(payload, query) {
    var trackingData = {};

    if (!query || query.type !== _global_search_GlobalSearchSuggestionsList__WEBPACK_IMPORTED_MODULE_14__[/* SUGGESTION_TYPES */ "b"].EDITO) {
      var _profile$loyaltyProgr;

      trackingData.fidelityStatus = (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || '';
      trackingData.resortAdult = nbAdults;
      trackingData.resortChildren = nbKids;
      trackingData.resortDepartureCityCode = departureCity;
      trackingData.resortNightNumber = duration;
      trackingData.resortTotalParticipant = nbParticipants;
      trackingData.resortTransport = departureCity ? 'with Transport' : null;
      trackingData.searchDepartureDate = departureDate ? moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_21__[/* DATE_FORMAT */ "f"]) : null;
      trackingData.searchDestinationArea = Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_13__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_21__[/* DESTINATIONS_FACET_ID */ "n"]);
      trackingData.searchDestinationCountry = Object(_FacetSearch_utils__WEBPACK_IMPORTED_MODULE_13__[/* getFacetsAsString */ "d"])(filters, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_21__[/* COUNTRIES_FACET_ID */ "e"]);
      trackingData.searchFilter = withFilter ? 'withFilter' : 'withoutFilter';
      trackingData.searchResorts = products.map(function (product) {
        return {
          resortCode: product.id,
          resortName: product.name,
          resortTrident: product.comfort,
          resortCountry: product.destination ? product.destination.country : null,
          resortRegion: product.destination ? product.destination.area : null,
          resortAdult: nbAdults,
          resortChildren: nbKids,
          resortDepartureCityCode: departureCity,
          resortSeasonType: product.seasonName || 'Summer',
          resortUrlImage: product.image,
          versionBooking: 'responsive',
          resortSeason: departureDate && Object(_utils_tracking_resort__WEBPACK_IMPORTED_MODULE_22__[/* isSummer */ "e"])(new Date(departureDate)) ? 'Summer' : 'Winter',
          resortYearSeason: moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).format('YYYY')
        };
      });
    } // $FlowFixMe


    track(_objectSpread(_objectSpread({
      event: _tracking_constants__WEBPACK_IMPORTED_MODULE_19__[/* VIRTUAL_PAGE_LOAD */ "y"],
      internalSearchEngineNbResults: redirection ? 'redirection' : productsCount,
      pageName: 'shopping_home_search',
      searchDate: moment__WEBPACK_IMPORTED_MODULE_12___default()().format(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_21__[/* DATE_FORMAT */ "f"]),
      searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
      searchTerms: searchTerms || ''
    }, trackingData), payload)); // Reset searchReferrer after each pageView is sent.
    // If searchReferrer === "null", GTM will set it to "search"

    track({
      event: 'PUSH',
      searchReferrer: 'null'
    });
  };

  return executeTracking;
};

/***/ }),

/***/ "O94r":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ "ODPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productTripadvisorResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("kiXb");





var productTripadvisorResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_TRIPADVISOR */ "ub"],
  resolve: function resolve() {
    var appContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments.length > 1 ? arguments[1] : undefined;
    var cmsContent = appContext.cmsContent,
        cmsRelease = appContext.cmsRelease;
    var cmsArgs = "content: \"".concat(cmsContent, "\", release:\"").concat(cmsRelease, "\"");
    var query = "query {\n      config {\n        common { next previous }\n      }\n      tripadvisor(resortId:\"".concat(props.resortId, "\") {\n        awards {\n          displayName\n          images {\n            large\n          }\n        }\n        numReviews\n        rating\n        ratingImageUrl\n        reviews {\n          title\n          text\n          url\n          rating\n          ratingImageUrl\n          reviewAuthor(").concat(cmsArgs, ")\n          publishedDate\n          reviewDate(").concat(cmsArgs, ")\n        }\n        subratings {\n          localizedName\n          ratingImageUrl\n          value\n        }\n        tripAdvisorUrl\n      },\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_TRIPADVISOR */ "Ac"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_4__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {
      return {};
    });
  }
};

/***/ }),

/***/ "ORYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_SET_ADULTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIP_INFORMATION_UPDATE_ADULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ADULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ADULTS_NB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ADULT_VALUE; });
var TRIP_INFORMATION_SET_ADULTS_NUMBER = 'TRIP_INFORMATION_SET_ADULTS_NUMBER';
var TRIP_INFORMATION_UPDATE_ADULT = 'TRIP_INFORMATION_UPDATE_ADULT';
var SET_ATTENDEES = 'SET_ATTENDEES';
var SET_ADULTS = 'SET_ADULTS';
var DEFAULT_ADULTS_NB = 2;
var DEFAULT_ADULT_VALUE = {
  birthdate: undefined,
  civility: undefined,
  firstName: undefined,
  lastName: undefined,
  unicodeFirstName: undefined,
  unicodeLastName: undefined,
  neolid: undefined
};

/***/ }),

/***/ "OfKG":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("c7Qd");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "Ohju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TemplateString; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("WNMA");
/* harmony import */ var core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

var TEMPLATE_REGEXP = /{\w+}/g;

function escapeCurlyBrackets(string) {
  return (string.match(/\w+/) || [''])[0];
}

function generateTemplateNodes(_ref) {
  var staticClassName = _ref.staticClassName,
      _ref$template = _ref.template,
      template = _ref$template === void 0 ? '' : _ref$template,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$valuesClassName = _ref.valuesClassName,
      valuesClassName = _ref$valuesClassName === void 0 ? {} : _ref$valuesClassName;
  var templateWithoutVariables = template.split(TEMPLATE_REGEXP) || [];
  var templateVariables = template.match(TEMPLATE_REGEXP) || [];
  return templateWithoutVariables.reduce(function (templateNodes, staticValue, index, array) {
    if (index === array.length - 1) {
      return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
        className: staticClassName,
        key: staticValue
      }, staticValue) : staticValue]);
    }

    var variableName = escapeCurlyBrackets(templateVariables[index]);
    return templateNodes.concat([staticClassName && staticValue ? __jsx("span", {
      className: staticClassName,
      key: staticValue
    }, staticValue) : staticValue, encapsulateWithClassName(values[variableName], variableName, valuesClassName[variableName])]);
  }, []);
}

function encapsulateWithClassName() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  var className = arguments.length > 2 ? arguments[2] : undefined;
  var v = value ? value.toString() : '';
  return className && v ? __jsx("span", {
    key: keyName,
    className: className
  }, v) : v;
}

var TemplateString = function TemplateString(_ref2) {
  var className = _ref2.className,
      dataTestId = _ref2.dataTestId,
      staticClassName = _ref2.staticClassName,
      _ref2$template = _ref2.template,
      template = _ref2$template === void 0 ? '' : _ref2$template,
      _ref2$values = _ref2.values,
      values = _ref2$values === void 0 ? {} : _ref2$values,
      valuesClassName = _ref2.valuesClassName;
  return template ? __jsx("span", {
    "data-testid": dataTestId,
    className: className
  }, generateTemplateNodes({
    staticClassName: staticClassName,
    template: template,
    values: values,
    valuesClassName: valuesClassName
  })) : null;
};

/***/ }),

/***/ "Onl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BlockLink; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("3voH");
/* harmony import */ var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("NJJ8");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("qBqs");
/* harmony import */ var _BlockLink_themes__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("uRnh");












var __jsx = react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var BlockLink = /*#__PURE__*/function (_PureComponent) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(BlockLink, _PureComponent);

  var _super = _createSuper(BlockLink);

  function BlockLink() {
    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, BlockLink);

    return _super.apply(this, arguments);
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(BlockLink, [{
    key: "renderTexts",
    value: function renderTexts() {
      var texts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _this$props$theme = this.props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme;
      return texts.filter(function (text) {
        return !Object(lodash__WEBPACK_IMPORTED_MODULE_13__["isEmpty"])(text);
      }).map(function (text, idx) {
        return __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_14___default()(classes, 'block', _BlockLink_themes__WEBPACK_IMPORTED_MODULE_17__[/* themes */ "a"][theme]["thCustomText".concat(idx)]),
          "data-testid": "BlockLink-text",
          key: idx
        }, text);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          icon = _this$props.icon,
          _this$props$onClick = _this$props.onClick,
          onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
          _this$props$secondary = _this$props.secondaryTexts,
          secondaryTexts = _this$props$secondary === void 0 ? [] : _this$props$secondary,
          _this$props$target = _this$props.target,
          target = _this$props$target === void 0 ? '_blank' : _this$props$target,
          _this$props$texts = _this$props.texts,
          texts = _this$props$texts === void 0 ? [] : _this$props$texts,
          _this$props$theme2 = _this$props.theme,
          theme = _this$props$theme2 === void 0 ? 'default' : _this$props$theme2,
          trackingData = _this$props.trackingData,
          _this$props$url = _this$props.url,
          url = _this$props$url === void 0 ? '' : _this$props$url;
      var title = (texts || []).filter(function (t) {
        return typeof t === 'string';
      }).join(' ');
      var linkTarget = url.startsWith('tel:') ? '' : target;
      var _themes$theme = _BlockLink_themes__WEBPACK_IMPORTED_MODULE_17__[/* themes */ "a"][theme],
          thIcon = _themes$theme.thIcon,
          thIconWidth = _themes$theme.thIconWidth,
          thRoot = _themes$theme.thRoot,
          thTexts = _themes$theme.thTexts,
          thSText = _themes$theme.thSText;
      return !!texts.length || icon ? __jsx(_tracking_track_click_TrackClick__WEBPACK_IMPORTED_MODULE_15__[/* TrackClick */ "a"], {
        as: "a",
        className: classnames__WEBPACK_IMPORTED_MODULE_14___default()(className, thRoot),
        href: url,
        onClick: onClick,
        rel: "noopener noreferrer",
        target: linkTarget,
        title: title,
        trackingData: trackingData
      }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
        className: classnames__WEBPACK_IMPORTED_MODULE_14___default()('flex-shrink-0', thIcon),
        name: icon,
        width: thIconWidth
      }), !!texts.length && __jsx("span", {
        className: thTexts
      }, this.renderTexts(texts), this.renderTexts(secondaryTexts, thSText))) : null;
    }
  }]);

  return BlockLink;
}(react__WEBPACK_IMPORTED_MODULE_12__["PureComponent"]);

/***/ }),

/***/ "OouP":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "PFCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPARTURE_CITY; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cvSI");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _constants__WEBPACK_IMPORTED_MODULE_0__["v"]; });


var DEFAULT_DEPARTURE_CITY = 'NO';

/***/ }),

/***/ "PFSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_CRITERIA_WHO_EVENT; });
var OPEN_CRITERIA_WHO_EVENT = 'openCriteriaWho';

/***/ }),

/***/ "PT2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mediaTextHorizontalResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var mediaTextHorizontalResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* MEDIA_TEXT_HORIZONTAL */ "v"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          close\n          seeMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "d"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "PZXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ WebCallbackTrigger; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.themes.js
var BlockLink_themes = __webpack_require__("uRnh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackFields.jsx



var __jsx = react_default.a.createElement;





function GroupedSelect(_ref) {
  var fieldName = _ref.fieldName,
      position = _ref.position,
      width = _ref.width,
      options = _ref.options,
      onChange = _ref.onChange;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref2) {
    var field = _ref2.field,
        errors = _ref2.form.errors;
    return __jsx("div", {
      className: classnames_default()("relative inline-block w-".concat(width, " border-1 overflow-hidden"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-success': !errors[field.name],
        'border-danger': errors[field.name]
      })
    }, __jsx("select", Object(esm_extends["a" /* default */])({
      autoComplete: "off",
      className: "reset-input reset-select relative text-current w-full bg-white p-px10"
    }, field, onChange ? {
      onChange: onChange
    } : null), options.map(function (_ref3) {
      var value = _ref3.value,
          name = _ref3.name;
      return __jsx("option", {
        key: name,
        value: value
      }, name);
    })), __jsx("div", {
      className: "absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none px-px10 text-current"
    }, __jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].SELECT,
      width: "0.75rem"
    })));
  });
}
function GroupedInput(_ref4) {
  var fieldName = _ref4.fieldName,
      position = _ref4.position,
      width = _ref4.width,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? 'text' : _ref4$type,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required;
  return __jsx(formik_esm["b" /* Field */], {
    name: fieldName
  }, function (_ref5) {
    var field = _ref5.field,
        _ref5$form = _ref5.form,
        touched = _ref5$form.touched,
        errors = _ref5$form.errors;
    return __jsx("input", Object(esm_extends["a" /* default */])({
      type: type,
      required: required
    }, field, {
      className: classnames_default()("outline-none shadows-none inline-block w-".concat(width, " p-px10 align-top text-current bg-white border-1"), {
        'border-r-0': position === 'left',
        'rounded-l-small': position === 'left',
        'rounded-r-small': position === 'right',
        'border-gray-medium': !touched[field.name],
        'border-success': touched[field.name] && !errors[field.name],
        'border-danger': touched[field.name] && errors[field.name]
      })
    }));
  });
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.utils.js




















/* eslint-disable space-before-function-paren */






var ACCOUNT_ID = config_default.a.get('freespee.accountId');
var AGENT_NUMBER = config_default.a.get('freespee.agentNumber');
var AGENT_NUMBER_ID = config_default.a.get('freespee.agentNumberId');
var CALLER_ID = config_default.a.get('freespee.callerId') || '';
var CUSTOMER_ID = config_default.a.get('freespee.customerId');
var FREESPEE_DATE_FORMAT = 'YYYY-MM-DD';
var FREESPEE_TIME_FORMAT = 'HH:mm:ss';
var FREESPEE_DATETIME_FORMAT = "".concat(FREESPEE_DATE_FORMAT, " ").concat(FREESPEE_TIME_FORMAT);
var DISPLAY_TIME_FORMAT = 'HH:mm';
var RETRIES = '2';
var RETRY_INTERVAL = '120';
var ASAP_TIME = 'ASAP';
var CALLBACK_STATUS = {
  UNSCHEDULED: 'unscheduled',
  SCHEDULED: 'scheduled',
  ERROR: 'error'
};
var PHONE_PREFIXES = [{
  countryCode: 'AL',
  value: 355,
  name: '+355 (AL)'
}, {
  countryCode: 'AR',
  value: 54,
  name: '+54 (AR)'
}, {
  countryCode: 'AT',
  value: 43,
  name: '+43 (AT)'
}, {
  countryCode: 'AU',
  value: 61,
  name: '+61 (AU)'
}, {
  countryCode: 'BA',
  value: 387,
  name: '+387 (BA)'
}, {
  countryCode: 'BE',
  value: 32,
  name: '+32 (BE)'
}, {
  countryCode: 'BG',
  value: 359,
  name: '+359 (BG)'
}, {
  countryCode: 'BR',
  value: 55,
  name: '+55 (BR)'
}, {
  countryCode: 'CA',
  value: 1,
  name: '+1 (CA)'
}, {
  countryCode: 'CH',
  value: 41,
  name: '+41 (CH)'
}, {
  countryCode: 'CL',
  value: 56,
  name: '+56 (CL)'
}, {
  countryCode: 'CN',
  value: 86,
  name: '+86 (CN)'
}, {
  countryCode: 'CY',
  value: 357,
  name: '+357 (CY)'
}, {
  countryCode: 'CZ',
  value: 420,
  name: '+420 (CZ)'
}, {
  countryCode: 'DE',
  value: 49,
  name: '+49 (DE)'
}, {
  countryCode: 'DK',
  value: 45,
  name: '+45 (DK)'
}, {
  countryCode: 'EE',
  value: 372,
  name: '+372 (EE)'
}, {
  countryCode: 'EG',
  value: 20,
  name: '+20 (EG)'
}, {
  countryCode: 'ES',
  value: 34,
  name: '+34 (ES)'
}, {
  countryCode: 'FI',
  value: 358,
  name: '+358 (FI)'
}, {
  countryCode: 'FR',
  value: 33,
  name: '+33 (FR)'
}, {
  countryCode: 'GB',
  value: 44,
  name: '+44 (GB)'
}, {
  countryCode: 'GI',
  value: 350,
  name: '+350 (GI)'
}, {
  countryCode: 'GR',
  value: 30,
  name: '+30 (GR)'
}, {
  countryCode: 'HK',
  value: 852,
  name: '+852 (HK)'
}, {
  countryCode: 'HR',
  value: 385,
  name: '+385 (HR)'
}, {
  countryCode: 'HU',
  value: 36,
  name: '+36 (HU)'
}, {
  countryCode: 'IE',
  value: 353,
  name: '+353 (IE)'
}, {
  countryCode: 'IL',
  value: 972,
  name: '+972 (IL)'
}, {
  countryCode: 'IN',
  value: 91,
  name: '+91 (IN)'
}, {
  countryCode: 'IR',
  value: 98,
  name: '+98 (IR)'
}, {
  countryCode: 'IS',
  value: 354,
  name: '+354 (IS)'
}, {
  countryCode: 'IT',
  value: 39,
  name: '+39 (IT)'
}, {
  countryCode: 'JP',
  value: 81,
  name: '+81 (JP)'
}, {
  countryCode: 'LB',
  value: 961,
  name: '+961 (LB)'
}, {
  countryCode: 'LT',
  value: 370,
  name: '+370 (LT)'
}, {
  countryCode: 'LU',
  value: 352,
  name: '+352 (LU)'
}, {
  countryCode: 'LV',
  value: 371,
  name: '+371 (LV)'
}, {
  countryCode: 'MC',
  value: 377,
  name: '+377 (MC)'
}, {
  countryCode: 'MD',
  value: 373,
  name: '+373 (MD)'
}, {
  countryCode: 'MT',
  value: 356,
  name: '+356 (MT)'
}, {
  countryCode: 'MX',
  value: 52,
  name: '+52 (MX)'
}, {
  countryCode: 'NL',
  value: 31,
  name: '+31 (NL)'
}, {
  countryCode: 'NO',
  value: 47,
  name: '+47 (NO)'
}, {
  countryCode: 'NZ',
  value: 64,
  name: '+64 (NZ)'
}, {
  countryCode: 'PA',
  value: 507,
  name: '+507 (PA)'
}, {
  countryCode: 'PE',
  value: 51,
  name: '+51 (PE)'
}, {
  countryCode: 'PK',
  value: 92,
  name: '+92 (PK)'
}, {
  countryCode: 'PL',
  value: 48,
  name: '+48 (PL)'
}, {
  countryCode: 'PT',
  value: 351,
  name: '+351 (PT)'
}, {
  countryCode: 'RO',
  value: 40,
  name: '+40 (RO)'
}, {
  countryCode: 'RS',
  value: 381,
  name: '+381 (RS)'
}, {
  countryCode: 'RU',
  value: 7,
  name: '+7 (RU)'
}, {
  countryCode: 'SE',
  value: 46,
  name: '+46 (SE)'
}, {
  countryCode: 'SG',
  value: 65,
  name: '+65 (SG)'
}, {
  countryCode: 'SI',
  value: 386,
  name: '+386 (SI)'
}, {
  countryCode: 'SK',
  value: 421,
  name: '+421 (SK)'
}, {
  countryCode: 'TH',
  value: 66,
  name: '+66 (TH)'
}, {
  countryCode: 'TR',
  value: 90,
  name: '+90 (TR)'
}, {
  countryCode: 'US',
  value: 1,
  name: '+1 (US)'
}, {
  countryCode: 'ZA',
  value: 27,
  name: '+27 (ZA)'
}];

function hasNameInSlots(slots, name) {
  return slots.some(function (slot) {
    return slot.name === name;
  });
}

var WebCallbackForm_utils_getTimeSlots = function getTimeSlots(_ref) {
  var openingTimesPerDay = _ref.openingTimesPerDay,
      i18n = _ref.i18n;
  if (!openingTimesPerDay) return [];
  var openDays = Object.keys(openingTimesPerDay);
  var asap = i18n.asap,
      today = i18n.today,
      tomorrow = i18n.tomorrow;
  var maxDaysInTheFuture = 7;

  var daysOfWeek = Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).map(function (day) {
    return moment_default()().utc().add(day, 'd').locale('en').format('ddd').toLowerCase();
  });

  return Object(toConsumableArray["a" /* default */])(Array(maxDaysInTheFuture).keys()).filter(function (day) {
    var dayOfWeek = moment_default()().utc().add(day, 'd').locale('en').format('ddd');
    return openDays.includes(dayOfWeek.toLowerCase());
  }).map(function (day, idx) {
    var slots = [];
    var dayLabel = daysOfWeek[day];
    var openingTimes = openingTimesPerDay[dayLabel];
    var now = moment_default.a.utc().add(day, 'd');
    var dayOfWeek = now.calendar(null, {
      sameDay: "[".concat(Object(lodash["upperFirst"])(today), "]"),
      nextDay: "[".concat(Object(lodash["upperFirst"])(tomorrow), "]"),
      nextWeek: 'dddd',
      sameElse: 'dddd'
    });
    openingTimes === null || openingTimes === void 0 ? void 0 : openingTimes.forEach(function (openingTime) {
      var _openingTime$from$spl = openingTime.from.split(':'),
          _openingTime$from$spl2 = Object(slicedToArray["a" /* default */])(_openingTime$from$spl, 2),
          beginHour = _openingTime$from$spl2[0],
          beginMinute = _openingTime$from$spl2[1];

      var begin = moment_default.a.utc().startOf('day').hour(parseInt(beginHour, 10)).minute(parseInt(beginMinute, 10));

      var _openingTime$to$split = openingTime.to.split(':'),
          _openingTime$to$split2 = Object(slicedToArray["a" /* default */])(_openingTime$to$split, 2),
          endHour = _openingTime$to$split2[0],
          endMinute = _openingTime$to$split2[1];

      var end = moment_default.a.utc().startOf('day').hour(parseInt(endHour, 10)).minute(parseInt(endMinute, 10));
      var current = begin;

      if (idx === 0) {
        current = moment_default.a.max(now, begin).add(1, 'h').startOf('h');

        if (!hasNameInSlots(slots, Object(lodash["upperFirst"])(asap))) {
          slots.push({
            value: ASAP_TIME,
            name: Object(lodash["upperFirst"])(asap)
          });
        }
      }

      while (current.isBefore(end)) {
        var value = current.format(FREESPEE_DATETIME_FORMAT);
        var slotStart = current.format(DISPLAY_TIME_FORMAT);
        current.add(30, 'm');
        var slotEnd = current.format(DISPLAY_TIME_FORMAT);
        var name = "".concat(slotStart, " - ").concat(slotEnd);

        if (!hasNameInSlots(slots, name)) {
          slots.push({
            value: value,
            name: name
          });
        }
      }
    });
    return {
      value: now.format(FREESPEE_DATE_FORMAT),
      name: Object(lodash["upperFirst"])(dayOfWeek),
      slots: slots
    };
  });
};

function concatIntervalsPerDay(openingTimesPerDay, weekday) {
  var _weekday$intervals;

  if (!(weekday === null || weekday === void 0 ? void 0 : weekday.intervals)) return openingTimesPerDay;
  var openingTimeInterval = weekday === null || weekday === void 0 ? void 0 : (_weekday$intervals = weekday.intervals) === null || _weekday$intervals === void 0 ? void 0 : _weekday$intervals.map(function (interval) {
    return {
      from: interval === null || interval === void 0 ? void 0 : interval.openingTime,
      to: interval === null || interval === void 0 ? void 0 : interval.closingTime
    };
  });

  if (openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day]) {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day].concat(openingTimeInterval);
  } else {
    openingTimesPerDay[weekday === null || weekday === void 0 ? void 0 : weekday.day] = openingTimeInterval;
  }

  return openingTimesPerDay;
}

var fetchOpeningHours = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2, appContext) {
    var setOpeningTimesPerDay, query, data, _openingTimesPerDay;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setOpeningTimesPerDay = _ref2.setOpeningTimesPerDay;
            query = "query {\n    webCallbackHours(customerId: \"".concat(CUSTOMER_ID, "\") {\n      weekdays {\n        day\n        intervals {\n          openingTime\n          closingTime\n        }\n      }\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: requestDictionary["Nd" /* WIDGET_WEBCALLBACK_OPENING_HOURS */]
            });

          case 5:
            data = _context.sent;
            _openingTimesPerDay = data.webCallbackHours.weekdays.reduce(concatIntervalsPerDay, {});
            if (_openingTimesPerDay && !Object(lodash["isEmpty"])(_openingTimesPerDay)) setOpeningTimesPerDay(_openingTimesPerDay);
            _context.next = 12;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));

  return function fetchOpeningHours(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
var submitCallback = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref4, appContext) {
    var scheduled, requesterNumber, setCallbackStatus, setSubmitting, schedule, query, _yield$graphQLClient$, webCallback;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            scheduled = _ref4.scheduled, requesterNumber = _ref4.requesterNumber, setCallbackStatus = _ref4.setCallbackStatus, setSubmitting = _ref4.setSubmitting;
            schedule = scheduled ? "\"".concat(scheduled, "\"") : 'null';
            query = "mutation {\n    webCallback(\n      agentNumber: \"".concat(AGENT_NUMBER, "\",\n      callerId: \"").concat(CALLER_ID, "\",\n      customerId: \"").concat(CUSTOMER_ID, "\",\n      webCallbackInput: {\n        requesterNumber: \"").concat(requesterNumber, "\",\n        scheduled: ").concat(schedule, ",\n        retries: ").concat(RETRIES, ",\n        retryInterval: ").concat(RETRY_INTERVAL, "\n      }) {\n      ... on WebCallback {\n        id\n        type\n        agentNumber\n        callerId\n        requesterNumber\n        retries\n        retryInterval\n      }\n      ... on WebCallbackError {\n        errorCode\n        errorDescription\n        errorKey\n        errorValue        \n      }\n    }\n  }");
            _context2.prev = 3;
            _context2.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
              requestName: requestDictionary["Od" /* WIDGET_WEBCALLBACK_SCHEDULE_CALL */]
            });

          case 6:
            _yield$graphQLClient$ = _context2.sent;
            webCallback = _yield$graphQLClient$.webCallback;

            if (webCallback.errorCode) {
              setCallbackStatus(CALLBACK_STATUS.ERROR);
            } else {
              setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
            }

            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            setCallbackStatus(CALLBACK_STATUS.ERROR);

          case 14:
            _context2.prev = 14;
            setSubmitting(false);
            return _context2.finish(14);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11, 14, 17]]);
  }));

  return function submitCallback(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();
var requestCallback = function requestCallback(_ref6) {
  var scheduled = _ref6.scheduled,
      requesterNumber = _ref6.requesterNumber,
      requesterNumberPrefix = _ref6.requesterNumberPrefix,
      setCallbackStatus = _ref6.setCallbackStatus,
      setSubmitting = _ref6.setSubmitting;

  try {
    window.__fs_dncs_instance.requestCallback(ACCOUNT_ID, // AVD_ID
    AGENT_NUMBER_ID, // Answering_number_id
    requesterNumberPrefix, // Country_code
    requesterNumber, // customer_phonenr
    CALLER_ID, // caller_id
    {}, // custom_*
    scheduled ? scheduled : null, // call_time,
    function (ref, data) {
      var status = data.status,
          callId = data.call_uuid;

      if (status === 'ok' && callId) {
        setCallbackStatus(CALLBACK_STATUS.SCHEDULED);
      } else {
        setCallbackStatus(CALLBACK_STATUS.ERROR);
      }

      setSubmitting(false);
    }, null, RETRIES // retries
    );
  } catch (error) {
    setCallbackStatus(CALLBACK_STATUS.ERROR);
    setSubmitting(false);
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackForm.jsx













var WebCallbackForm_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var DEFAULT_OPENING_TIME = '10:00:00';
var DEFAULT_CLOSING_TIME = '18:00:00';
var DEFAULT_OPENING_TIMES_PER_DAY = {
  mon: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  tue: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  wed: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  thu: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  fri: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sat: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }],
  sun: [{
    from: DEFAULT_OPENING_TIME,
    to: DEFAULT_CLOSING_TIME
  }]
};
function WebCallbackForm(_ref) {
  var _currentDay$slots, _currentDay$slots$;

  var callbackStatus = _ref.callbackStatus,
      setCallbackStatus = _ref.setCallbackStatus,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])(); // These are UTC times, like what Freespee returns in from_time, to_time.

  var _useState = Object(react["useState"])(DEFAULT_OPENING_TIMES_PER_DAY),
      openingTimesPerDay = _useState[0],
      setOpeningTimesPerDay = _useState[1];

  var timeSlots = Object(react["useMemo"])(function () {
    return WebCallbackForm_utils_getTimeSlots({
      openingTimesPerDay: openingTimesPerDay,
      i18n: {
        asap: Object(src_i18n["h" /* t */])('common.dateTime.asap'),
        today: Object(src_i18n["h" /* t */])('common.dateTime.today'),
        tomorrow: Object(src_i18n["h" /* t */])('common.dateTime.tomorrow')
      }
    });
  }, [openingTimesPerDay]);

  var _timeSlots = Object(slicedToArray["a" /* default */])(timeSlots, 1),
      initialDay = _timeSlots[0];

  var _useState2 = Object(react["useState"])(initialDay),
      currentDay = _useState2[0],
      setCurrentDay = _useState2[1];

  Object(react["useEffect"])(function () {
    fetchOpeningHours({
      setOpeningTimesPerDay: setOpeningTimesPerDay
    }, appContext);
  }, []);
  Object(react["useEffect"])(function () {
    var _timeSlots2 = Object(slicedToArray["a" /* default */])(timeSlots, 1),
        newDay = _timeSlots2[0];

    setCurrentDay(newDay);
  }, [timeSlots]);
  if (!currentDay) return null;
  var localPhonePrefix = PHONE_PREFIXES.find(function (prefix) {
    var country = appContext.locale.split('-')[1];
    return country === prefix.countryCode;
  });
  var initialPhonePrefix = localPhonePrefix || PHONE_PREFIXES.find(function (prefix) {
    return prefix.countryCode === 'FR';
  }) || {};

  var changeDay = function changeDay(event, setFieldValue) {
    var dayValue = event.target.value;
    var newDay = timeSlots.find(function (slot) {
      return slot.value === dayValue;
    });

    if (newDay) {
      setCurrentDay(newDay);
      setFieldValue('slotDay', newDay.value, false);
    }
  };

  return WebCallbackForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: {
      slotDay: currentDay.value,
      slotTime: currentDay === null || currentDay === void 0 ? void 0 : (_currentDay$slots = currentDay.slots) === null || _currentDay$slots === void 0 ? void 0 : (_currentDay$slots$ = _currentDay$slots[0]) === null || _currentDay$slots$ === void 0 ? void 0 : _currentDay$slots$.value,
      phonePrefix: initialPhonePrefix.value,
      phoneNumber: ''
    },
    validate: function validate(_ref2) {
      var phoneNumber = _ref2.phoneNumber;
      var errors = {};

      if (!phoneNumber) {
        errors.phoneNumber = 'Phone number is required';
      } // https://www.twilio.com/docs/glossary/what-e164


      if (!/^[1-9]\d{1,14}$/.test(phoneNumber)) {
        errors.phoneNumber = 'Phone number is not valid';
      }

      return errors;
    },
    onSubmit: function onSubmit(formValues, _ref3) {
      var setSubmitting = _ref3.setSubmitting;
      var slotTime = formValues.slotTime,
          phonePrefix = formValues.phonePrefix,
          phoneNumber = formValues.phoneNumber;
      requestCallback({
        scheduled: slotTime === ASAP_TIME ? null : slotTime,
        requesterNumber: "+".concat(phonePrefix).concat(phoneNumber),
        requesterNumberPrefix: phonePrefix,
        setCallbackStatus: setCallbackStatus,
        setSubmitting: setSubmitting
      });
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        labelGA: tracking_constants["A" /* WEB_CALLBACK_SUBMIT */]
      }, trackingData));
    }
  }, function (_ref4) {
    var isValid = _ref4.isValid,
        isSubmitting = _ref4.isSubmitting,
        setFieldValue = _ref4.setFieldValue;
    var isDisabled = callbackStatus !== CALLBACK_STATUS.UNSCHEDULED || !isValid;
    return WebCallbackForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "web-callback-form",
      className: "h-full"
    }, WebCallbackForm_jsx("div", {
      className: "flex flex-col justify-between h-full w-full bg-gray-200"
    }, WebCallbackForm_jsx("div", {
      className: "w-full bg-ardoise",
      style: {
        backgroundImage: "url(\"".concat(Object(src_i18n["h" /* t */])('webCallback.picture'), "\")"),
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '150px'
      }
    }), WebCallbackForm_jsx("div", {
      className: "flex-auto px-px25 py-px20"
    }, WebCallbackForm_jsx("h3", {
      className: "my-0",
      id: constants["I" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */]
    }, Object(src_i18n["h" /* t */])('webCallback.title')), WebCallbackForm_jsx("p", null, Object(src_i18n["h" /* t */])('webCallback.subtitle')), callbackStatus !== CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Notification["a" /* Notification */], {
      color: callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING,
      hasBorder: true,
      icon: callbackStatus === CALLBACK_STATUS.SCHEDULED ? icons["a" /* ICONS */].SMALL_CIRCLE_CHECK : icons["a" /* ICONS */].CIRCLED_CROSS,
      iconWidth: "1rem"
    }, WebCallbackForm_jsx("p", {
      className: "m-0 text-base text-".concat(callbackStatus === CALLBACK_STATUS.SCHEDULED ? colors["a" /* COLORS */].SUCCESS : colors["a" /* COLORS */].WARNING)
    }, callbackStatus === CALLBACK_STATUS.SCHEDULED ? Object(src_i18n["h" /* t */])('webCallback.successMessage') : Object(src_i18n["h" /* t */])('webCallback.errorMessage'))) : WebCallbackForm_jsx(react["Fragment"], null, WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-3/5 mb-px10 md:pr-px10"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-px5 text-sm"
    }, Object(src_i18n["h" /* t */])('webCallback.timeLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotDay",
      position: "left",
      width: "2/5" // $FlowFixMe
      ,
      options: timeSlots,
      onChange: function onChange(e) {
        return changeDay(e, setFieldValue);
      }
    }), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "slotTime",
      position: "right",
      width: "3/5" // $FlowFixMe
      ,
      options: currentDay.slots
    })), WebCallbackForm_jsx("div", {
      className: "inline-block w-full md:w-2/5 mb-px10"
    }, WebCallbackForm_jsx("label", {
      className: "block w-full p-px5 text-sm"
    }, Object(src_i18n["h" /* t */])('webCallback.phoneLabel')), WebCallbackForm_jsx(GroupedSelect, {
      fieldName: "phonePrefix",
      position: "left",
      width: "1/2",
      options: PHONE_PREFIXES
    }), WebCallbackForm_jsx(GroupedInput, {
      fieldName: "phoneNumber",
      position: "right",
      width: "1/2",
      type: "tel",
      required: true
    })))), WebCallbackForm_jsx("div", {
      className: "flex justify-end px-px25 w-full",
      style: {
        minHeight: '3.75rem'
      }
    }, callbackStatus === CALLBACK_STATUS.UNSCHEDULED ? WebCallbackForm_jsx(Button["a" /* Button */], {
      className: "self-center w-full md:w-1/2 text-center",
      type: "submit",
      isLoading: isSubmitting,
      isDisabled: isDisabled
    }, Object(src_i18n["h" /* t */])('webCallback.callToAction')) : null)));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx








var WebCallbackTrigger_jsx = react_default.a.createElement;

function WebCallbackTrigger_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function WebCallbackTrigger_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WebCallbackTrigger_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WebCallbackTrigger_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function WebCallbackTrigger(_ref) {
  var trackingData = _ref.trackingData,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isAppMounted = _useContext.isAppMounted;

  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var track = Object(useTracking["a" /* useTracking */])();

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(CALLBACK_STATUS.UNSCHEDULED),
      callbackStatus = _useState2[0],
      setCallbackStatus = _useState2[1];

  var webCallbackModal = isOpen ? WebCallbackTrigger_jsx(Modal["a" /* Modal */], {
    ariaLabel: Object(src_i18n["h" /* t */])('webCallback.title'),
    ariaLabelledby: constants["I" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })) : null;

  var webCallbackDrawer = WebCallbackTrigger_jsx(SidePanel["a" /* SidePanel */], {
    ariaLabel: Object(src_i18n["h" /* t */])('webCallback.title'),
    ariaLabelledby: constants["I" /* ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER */],
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    isExpanded: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    }
  }, WebCallbackTrigger_jsx("div", {
    className: "h-full w-full fadeIn"
  }, WebCallbackTrigger_jsx(WebCallbackForm, {
    callbackStatus: callbackStatus,
    setCallbackStatus: setCallbackStatus,
    trackingData: trackingData
  })));

  var webCallbackPopin = isTablet ? webCallbackModal : webCallbackDrawer;
  return WebCallbackTrigger_jsx(react["Fragment"], null, isAppMounted ? webCallbackPopin : null, WebCallbackTrigger_jsx("button", {
    type: "button",
    className: classnames_default()(BlockLink_themes["a" /* themes */][theme].thRoot, 'bg-transparent'),
    onClick: function onClick() {
      setCallbackStatus(CALLBACK_STATUS.UNSCHEDULED);
      setIsOpen(true);

      if (isOpen === false && trackingData) {
        track(WebCallbackTrigger_objectSpread({
          categoryGA: pageContext.pageId,
          labelGA: tracking_constants["z" /* WEB_CALLBACK_OPEN */]
        }, trackingData));
      }
    }
  }, children));
}

/***/ }),

/***/ "Phb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

/* global window, document */


__webpack_require__("ZVqJ");

__webpack_require__("vuE1");

__webpack_require__("qs2G");

__webpack_require__("i2OK");

__webpack_require__("5iaM");

__webpack_require__("I2c1");

__webpack_require__("60DJ");

__webpack_require__("QRET");

__webpack_require__("bMl7");

__webpack_require__("zSnQ");

__webpack_require__("MRpX");

__webpack_require__("ieZH");

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _propTypes = _interopRequireDefault(__webpack_require__("aWzz"));

var _subscribeUiEvent = __webpack_require__("GJxp");

var _classnames = _interopRequireDefault(__webpack_require__("O94r"));

var _shallowequal = _interopRequireDefault(__webpack_require__("Pu0A"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// constants
var STATUS_ORIGINAL = 0; // The default status, locating at the original position.

var STATUS_RELEASED = 1; // The released status, locating at somewhere on document but not default one.

var STATUS_FIXED = 2; // The sticky status, locating fixed to the top or the bottom of screen.

var TRANSFORM_PROP = 'transform'; // global variable for all instances

var doc;
var docBody;
var docEl;
var canEnableTransforms = true; // Use transform by default, so no Sticky on lower-end browser when no Modernizr

var M;
var scrollDelta = 0;
var win;
var winHeight = -1;

var Sticky = /*#__PURE__*/function (_Component) {
  _inherits(Sticky, _Component);

  var _super = _createSuper(Sticky);

  function Sticky(props, context) {
    var _this;

    _classCallCheck(this, Sticky);

    _this = _super.call(this, props, context);
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleScrollStart = _this.handleScrollStart.bind(_assertThisInitialized(_this));
    _this.delta = 0;
    _this.stickyTop = 0;
    _this.stickyBottom = 0;
    _this.frozen = false;
    _this.skipNextScrollEvent = false;
    _this.scrollTop = -1;
    _this.bottomBoundaryTarget;
    _this.topTarget;
    _this.subscribers;
    _this.state = {
      top: 0,
      // A top offset from viewport top where Sticky sticks to when scrolling up
      bottom: 0,
      // A bottom offset from viewport top where Sticky sticks to when scrolling down
      width: 0,
      // Sticky width
      height: 0,
      // Sticky height
      x: 0,
      // The original x of Sticky
      y: 0,
      // The original y of Sticky
      topBoundary: 0,
      // The top boundary on document
      bottomBoundary: Infinity,
      // The bottom boundary on document
      status: STATUS_ORIGINAL,
      // The Sticky status
      pos: 0,
      // Real y-axis offset for rendering position-fixed and position-relative
      activated: false // once browser info is available after mounted, it becomes true to avoid checksum error

    };
    return _this;
  }

  _createClass(Sticky, [{
    key: "getTargetHeight",
    value: function getTargetHeight(target) {
      return target && target.offsetHeight || 0;
    }
  }, {
    key: "getTopPosition",
    value: function getTopPosition(top) {
      // a top argument can be provided to override reading from the props
      top = top || this.props.top || 0;

      if (typeof top === 'string') {
        if (!this.topTarget) {
          this.topTarget = doc.querySelector(top);
        }

        top = this.getTargetHeight(this.topTarget);
      }

      return top;
    }
  }, {
    key: "getTargetBottom",
    value: function getTargetBottom(target) {
      if (!target) {
        return -1;
      }

      var rect = target.getBoundingClientRect();
      return this.scrollTop + rect.bottom;
    }
  }, {
    key: "getBottomBoundary",
    value: function getBottomBoundary(bottomBoundary) {
      // a bottomBoundary can be provided to avoid reading from the props
      var boundary = bottomBoundary || this.props.bottomBoundary; // TODO, bottomBoundary was an object, depricate it later.

      if (_typeof(boundary) === 'object') {
        boundary = boundary.value || boundary.target || 0;
      }

      if (typeof boundary === 'string') {
        if (!this.bottomBoundaryTarget) {
          this.bottomBoundaryTarget = doc.querySelector(boundary);
        }

        boundary = this.getTargetBottom(this.bottomBoundaryTarget);
      }

      return boundary && boundary > 0 ? boundary : Infinity;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        status: STATUS_ORIGINAL,
        pos: 0
      });
    }
  }, {
    key: "release",
    value: function release(pos) {
      this.setState({
        status: STATUS_RELEASED,
        pos: pos - this.state.y
      });
    }
  }, {
    key: "fix",
    value: function fix(pos) {
      this.setState({
        status: STATUS_FIXED,
        pos: pos
      });
    }
    /**
     * Update the initial position, width, and height. It should update whenever children change.
     * @param {Object} options optional top and bottomBoundary new values
     */

  }, {
    key: "updateInitialDimension",
    value: function updateInitialDimension(options) {
      options = options || {};

      if (!this.outerElement || !this.innerElement) {
        return;
      }

      var outerRect = this.outerElement.getBoundingClientRect();
      var innerRect = this.innerElement.getBoundingClientRect();
      var width = outerRect.width || outerRect.right - outerRect.left;
      var height = innerRect.height || innerRect.bottom - innerRect.top;
      ;
      var outerY = outerRect.top + this.scrollTop;
      this.setState({
        top: this.getTopPosition(options.top),
        bottom: Math.min(this.state.top + height, winHeight),
        width: width,
        height: height,
        x: outerRect.left,
        y: outerY,
        bottomBoundary: this.getBottomBoundary(options.bottomBoundary),
        topBoundary: outerY
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(e, ae) {
      if (this.props.shouldFreeze()) {
        return;
      }

      winHeight = ae.resize.height;
      this.updateInitialDimension();
      this.update();
    }
  }, {
    key: "handleScrollStart",
    value: function handleScrollStart(e, ae) {
      this.frozen = this.props.shouldFreeze();

      if (this.frozen) {
        return;
      }

      if (this.scrollTop === ae.scroll.top) {
        // Scroll position hasn't changed,
        // do nothing
        this.skipNextScrollEvent = true;
      } else {
        this.scrollTop = ae.scroll.top;
        this.updateInitialDimension();
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e, ae) {
      // Scroll doesn't need to be handled
      if (this.skipNextScrollEvent) {
        this.skipNextScrollEvent = false;
        return;
      }

      scrollDelta = ae.scroll.delta;
      this.scrollTop = ae.scroll.top;
      this.update();
    }
    /**
     * Update Sticky position.
     */

  }, {
    key: "update",
    value: function update() {
      var disabled = !this.props.enabled || this.state.bottomBoundary - this.state.topBoundary <= this.state.height || this.state.width === 0 && this.state.height === 0;

      if (disabled) {
        if (this.state.status !== STATUS_ORIGINAL) {
          this.reset();
        }

        return;
      }

      var delta = scrollDelta; // "top" and "bottom" are the positions that this.state.top and this.state.bottom project
      // on document from viewport.

      var top = this.scrollTop + this.state.top;
      var bottom = this.scrollTop + this.state.bottom; // There are 2 principles to make sure Sticky won't get wrong so much:
      // 1. Reset Sticky to the original postion when "top" <= topBoundary
      // 2. Release Sticky to the bottom boundary when "bottom" >= bottomBoundary

      if (top <= this.state.topBoundary) {
        // #1
        this.reset();
      } else if (bottom >= this.state.bottomBoundary) {
        // #2
        this.stickyBottom = this.state.bottomBoundary;
        this.stickyTop = this.stickyBottom - this.state.height;
        this.release(this.stickyTop);
      } else {
        if (this.state.height > winHeight - this.state.top) {
          // In this case, Sticky is higher then viewport minus top offset
          switch (this.state.status) {
            case STATUS_ORIGINAL:
              this.release(this.state.y);
              this.stickyTop = this.state.y;
              this.stickyBottom = this.stickyTop + this.state.height;
            // Commentting out "break" is on purpose, because there is a chance to transit to FIXED
            // from ORIGINAL when calling window.scrollTo().
            // break;

            case STATUS_RELEASED:
              // If "top" and "bottom" are inbetween stickyTop and stickyBottom, then Sticky is in
              // RELEASE status. Otherwise, it changes to FIXED status, and its bottom sticks to
              // viewport bottom when scrolling down, or its top sticks to viewport top when scrolling up.
              this.stickyBottom = this.stickyTop + this.state.height;

              if (delta > 0 && bottom > this.stickyBottom) {
                this.fix(this.state.bottom - this.state.height);
              } else if (delta < 0 && top < this.stickyTop) {
                this.fix(this.state.top);
              }

              break;

            case STATUS_FIXED:
              var toRelease = true;
              var pos = this.state.pos;
              var height = this.state.height; // In regular cases, when Sticky is in FIXED status,
              // 1. it's top will stick to the screen top,
              // 2. it's bottom will stick to the screen bottom,
              // 3. if not the cases above, then it's height gets changed

              if (delta > 0 && pos === this.state.top) {
                // case 1, and scrolling down
                this.stickyTop = top - delta;
                this.stickyBottom = this.stickyTop + height;
              } else if (delta < 0 && pos === this.state.bottom - height) {
                // case 2, and scrolling up
                this.stickyBottom = bottom - delta;
                this.stickyTop = this.stickyBottom - height;
              } else if (pos !== this.state.bottom - height && pos !== this.state.top) {
                // case 3
                // This case only happens when Sticky's bottom sticks to the screen bottom and
                // its height gets changed. Sticky should be in RELEASE status and update its
                // sticky bottom by calculating how much height it changed.
                var deltaHeight = pos + height - this.state.bottom;
                this.stickyBottom = bottom - delta + deltaHeight;
                this.stickyTop = this.stickyBottom - height;
              } else {
                toRelease = false;
              }

              if (toRelease) {
                this.release(this.stickyTop);
              }

              break;
          }
        } else {
          // In this case, Sticky is shorter then viewport minus top offset
          // and will always fix to the top offset of viewport
          this.fix(this.state.top);
        }
      }

      this.delta = delta;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.status !== this.state.status && this.props.onStateChange) {
        this.props.onStateChange({
          status: this.state.status
        });
      }

      var arePropsChanged = !(0, _shallowequal.default)(this.props, prevProps);

      if (arePropsChanged) {
        // if the props for enabling are toggled, then trigger the update or reset depending on the current props
        if (prevProps.enabled !== this.props.enabled) {
          if (this.props.enabled) {
            this.setState({
              activated: true
            }, function () {
              _this2.updateInitialDimension();

              _this2.update();
            });
          } else {
            this.setState({
              activated: false
            }, function () {
              _this2.reset();
            });
          }
        } // if the top or bottomBoundary props were changed, then trigger the update
        else if (prevProps.top !== this.props.top || prevProps.bottomBoundary !== this.props.bottomBoundary) {
            this.updateInitialDimension();
            this.update();
          }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var subscribers = this.subscribers || [];

      for (var i = subscribers.length - 1; i >= 0; i--) {
        this.subscribers[i].unsubscribe();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Only initialize the globals if this is the first
      // time this component type has been mounted
      if (!win) {
        win = window;
        doc = document;
        docEl = doc.documentElement;
        docBody = doc.body;
        winHeight = win.innerHeight || docEl.clientHeight;
        M = window.Modernizr; // No Sticky on lower-end browser when no Modernizr

        if (M && M.prefixed) {
          canEnableTransforms = M.csstransforms3d;
          TRANSFORM_PROP = M.prefixed('transform');
        }
      } // when mount, the scrollTop is not necessary on the top


      this.scrollTop = docBody.scrollTop + docEl.scrollTop;

      if (this.props.enabled) {
        this.setState({
          activated: true
        });
        this.updateInitialDimension();
        this.update();
      } // bind the listeners regardless if initially enabled - allows the component to toggle sticky functionality


      this.subscribers = [(0, _subscribeUiEvent.subscribe)('scrollStart', this.handleScrollStart.bind(this), {
        useRAF: true
      }), (0, _subscribeUiEvent.subscribe)('scroll', this.handleScroll.bind(this), {
        useRAF: true,
        enableScrollInfo: true
      }), (0, _subscribeUiEvent.subscribe)('resize', this.handleResize.bind(this), {
        enableResizeInfo: true
      })];
    }
  }, {
    key: "translate",
    value: function translate(style, pos) {
      var enableTransforms = canEnableTransforms && this.props.enableTransforms;

      if (enableTransforms && this.state.activated) {
        style[TRANSFORM_PROP] = 'translate3d(0,' + Math.round(pos) + 'px,0)';
      } else {
        style.top = pos + 'px';
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !this.props.shouldFreeze() && !((0, _shallowequal.default)(this.props, nextProps) && (0, _shallowequal.default)(this.state, nextState));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      // TODO, "overflow: auto" prevents collapse, need a good way to get children height
      var innerStyle = {
        position: this.state.status === STATUS_FIXED ? 'fixed' : 'relative',
        top: this.state.status === STATUS_FIXED ? '0px' : '',
        zIndex: this.props.innerZ
      };
      var outerStyle = {}; // always use translate3d to enhance the performance

      this.translate(innerStyle, this.state.pos);

      if (this.state.status !== STATUS_ORIGINAL) {
        innerStyle.width = this.state.width + 'px';
        outerStyle.height = this.state.height + 'px';
      }

      var outerClasses = (0, _classnames.default)('sticky-outer-wrapper', this.props.className, (_classNames = {}, _defineProperty(_classNames, this.props.activeClass, this.state.status === STATUS_FIXED), _defineProperty(_classNames, this.props.releasedClass, this.state.status === STATUS_RELEASED), _classNames));
      var innerClasses = (0, _classnames.default)('sticky-inner-wrapper', this.props.innerClass, _defineProperty({}, this.props.innerActiveClass, this.state.status === STATUS_FIXED));
      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(outer) {
          _this3.outerElement = outer;
        },
        className: outerClasses,
        style: outerStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(inner) {
          _this3.innerElement = inner;
        },
        className: innerClasses,
        style: innerStyle
      }, typeof children === 'function' ? children({
        status: this.state.status
      }) : children));
    }
  }]);

  return Sticky;
}(_react.Component);

Sticky.displayName = 'Sticky';
Sticky.defaultProps = {
  shouldFreeze: function shouldFreeze() {
    return false;
  },
  enabled: true,
  top: 0,
  bottomBoundary: 0,
  enableTransforms: true,
  activeClass: 'active',
  releasedClass: 'released',
  onStateChange: null,
  innerClass: '',
  innerActiveClass: ''
};
/**
 * @param {Bool} enabled A switch to enable or disable Sticky.
 * @param {String/Number} top A top offset px for Sticky. Could be a selector representing a node
 *        whose height should serve as the top offset.
 * @param {String/Number} bottomBoundary A bottom boundary px on document where Sticky will stop.
 *        Could be a selector representing a node whose bottom should serve as the bottom boudary.
 */

Sticky.propTypes = {
  enabled: _propTypes.default.bool,
  top: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  bottomBoundary: _propTypes.default.oneOfType([_propTypes.default.object, // TODO, may remove
  _propTypes.default.string, _propTypes.default.number]),
  enableTransforms: _propTypes.default.bool,
  activeClass: _propTypes.default.string,
  releasedClass: _propTypes.default.string,
  innerClass: _propTypes.default.string,
  innerActiveClass: _propTypes.default.string,
  className: _propTypes.default.string,
  onStateChange: _propTypes.default.func,
  shouldFreeze: _propTypes.default.func,
  innerZ: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Sticky.STATUS_ORIGINAL = STATUS_ORIGINAL;
Sticky.STATUS_RELEASED = STATUS_RELEASED;
Sticky.STATUS_FIXED = STATUS_FIXED;
module.exports = Sticky;

/***/ }),

/***/ "Pu0A":
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ "Q4oW":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("zKkv"),
    createBaseEach = __webpack_require__("bz5b");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "Q8Qh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = {
  "default": {
    thBody: 'arrow-up arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-light-gray mt-px15 p-px10 shadow-lg'
  },
  hollow: {
    thBody: 'arrow-up arrow-white arrow-bg arrow-bg-gray-light bg-white border-1 border-gray-light -mt-px10 rounded-small shadow-lg'
  },
  solid: {
    thBody: 'bg-white'
  }
};

/***/ }),

/***/ "QPCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ResponsiveTabs_ResponsiveTabs; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.util.js
var tabs_util = __webpack_require__("GzVq");

// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx + 1 modules
var TabHeader = __webpack_require__("ZKlR");

// CONCATENATED MODULE: ./src/client/components/frameworks/accordion/Accordion.jsx







var __jsx = react_default.a.createElement;













var Accordion_scrollToId = function scrollToId(id, offsetSelector) {
  return Object(scrollToElement["a" /* scrollToElement */])("#".concat(id), 100, ".".concat(offsetSelector));
};

var Accordion_Accordion = function _Accordion(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      areMultiExpandable = _ref.areMultiExpandable,
      className = _ref.className,
      collapseIconName = _ref.collapseIconName,
      containerSize = _ref.containerSize,
      expandIconName = _ref.expandIconName,
      hasBackground = _ref.hasBackground,
      hasNoAutoScroll = _ref.hasNoAutoScroll,
      _ref$headerLevel = _ref.headerLevel,
      headerLevel = _ref$headerLevel === void 0 ? 3 : _ref$headerLevel,
      _ref$initialSelectedI = _ref.initialSelectedItems,
      initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
      id = _ref.id,
      isContentUnmountedOnCollapse = _ref.isContentUnmountedOnCollapse,
      items = _ref.items,
      onSelect = _ref.onSelect,
      _ref$scrollOffsetSele = _ref.scrollOffsetSelector,
      scrollOffsetSelector = _ref$scrollOffsetSele === void 0 ? Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */] : _ref$scrollOffsetSele,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!items.length) {
    return null;
  }

  var refsArray = [];

  var _onKeyDown = function onKeyDown(_ref2) {
    var e = _ref2.e,
        index = _ref2.index;

    if (items.length > 1) {
      var lastItem = items.length - 1;
      var idx = -1;

      switch (e.which) {
        case keyCodes["a" /* ARROW_DOWN */]:
          e.preventDefault();
          idx = index === lastItem ? 0 : index + 1;
          break;

        case keyCodes["d" /* ARROW_UP */]:
          e.preventDefault();
          idx = index === 0 ? lastItem : index - 1;
          break;

        case keyCodes["h" /* HOME */]:
          e.preventDefault();
          idx = 0;
          break;

        case keyCodes["e" /* END */]:
          e.preventDefault();
          idx = lastItem;
          break;

        default:
      }

      refsArray[idx] && refsArray[idx].focus();
    }
  };

  var CollapsedTag = isContentUnmountedOnCollapse ? lib["UnmountClosed"] : lib["Collapse"];
  var accordionsCount = items.filter(Boolean).length;
  return __jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    activeIndexes: initialSelectedItems,
    hasMultipleIndexEnabled: areMultiExpandable,
    hasNoIndexEnabled: areAllCollapsable,
    onUpdate: onSelect
  }, function (_ref3) {
    var update = _ref3.update,
        activeIndexes = _ref3.activeIndexes,
        isPristine = _ref3.isPristine;
    return __jsx("section", {
      className: className,
      id: id,
      "data-cs-override-id": "Accordion" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id

    }, items.filter(Boolean).map(function (_ref4, index) {
      var content = _ref4.content,
          _ref4$header = _ref4.header,
          header = _ref4$header === void 0 ? {} : _ref4$header,
          headerId = _ref4.headerId,
          panelId = _ref4.panelId;

      var title = header.title,
          rest = Object(objectWithoutProperties["a" /* default */])(header, ["title"]);

      var isExpanded = activeIndexes.includes(index);

      var onRest = function onRest() {
        if (!hasNoAutoScroll && isExpanded && !isPristine) Accordion_scrollToId(headerId, scrollOffsetSelector);
      };

      var Heading = "h".concat(headerLevel);
      return __jsx("article", {
        key: headerId
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        size: containerSize
      }, __jsx(Heading, {
        className: "reset-heading"
      }, __jsx(TabHeader["a" /* TabHeader */], Object(esm_extends["a" /* default */])({}, rest, {
        collapseIconName: collapseIconName,
        controlsId: panelId,
        expandIconName: expandIconName,
        id: headerId,
        isAccordion: true,
        isActive: isExpanded,
        isDisabled: accordionsCount <= 1 && isTablet,
        onClick: function onClick() {
          update(index);
          refsArray[index] && refsArray[index].focus();
        },
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown({
            e: e,
            index: index
          });
        },
        ref: function ref(_ref5) {
          refsArray[index] = _ref5;
        },
        theme: theme
      }), title))), __jsx(CollapsedTag, {
        isOpened: isExpanded,
        onRest: onRest
      }, __jsx("div", {
        "aria-hidden": !isExpanded,
        "aria-labelledby": headerId,
        className: classnames_default()(Object(tabs_util["a" /* getTabsBackgroundClasses */])(hasBackground), 'pt-px20 sm:pt-px40', {
          'invisible pointer-events-none': !isExpanded
        }),
        "data-cs-override-id": "Accordion-panel" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
        ,
        id: panelId,
        role: "region"
      }, __jsx(SiteContainer["a" /* SiteContainer */], {
        size: containerSize
      }, react["Children"].map(content, function (el, i) {
        return el ? /*#__PURE__*/Object(react["cloneElement"])(el, {
          key: "".concat(panelId, "-").concat(i)
        }) : null;
      })))));
    }));
  });
};

var Accordion = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(Accordion_Accordion);
// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// CONCATENATED MODULE: ./src/client/components/frameworks/responsive-tabs/ResponsiveTabs.jsx


var ResponsiveTabs_jsx = react_default.a.createElement;




var ResponsiveTabs_ResponsiveTabs = function ResponsiveTabs(_ref) {
  var areAllCollapsable = _ref.areAllCollapsable,
      areMultiExpandable = _ref.areMultiExpandable,
      _ref$initialSelectedI = _ref.initialSelectedItems,
      initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["areAllCollapsable", "areMultiExpandable", "initialSelectedItems"]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return isTablet ? ResponsiveTabs_jsx(Tabs["a" /* Tabs */], Object(esm_extends["a" /* default */])({}, rest, {
    initialSelectedItem: initialSelectedItems[0]
  })) : ResponsiveTabs_jsx(Accordion, Object(esm_extends["a" /* default */])({}, rest, {
    areAllCollapsable: areAllCollapsable,
    areMultiExpandable: areMultiExpandable,
    initialSelectedItems: initialSelectedItems
  }));
};

/***/ }),

/***/ "QPdA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("m1JM");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("SPKZ");
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("qBqs");
/* harmony import */ var _spinner_Spinner__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("7amT");












var __jsx = react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable clubmed/no-fake-component */






var defaultProps = {
  isActive: false,
  isLoading: false,
  isReadOnly: false,
  isRequired: false,
  validationState: 'NOT_VALIDATED',
  generateUniqueId: true,
  scrollSelector: ''
};
/* DEPRECATED : DO NOT USE ANYMORE */

function formField(Component) {
  var FormField = /*#__PURE__*/function (_React$Component) {
    Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(FormField, _React$Component);

    var _super = _createSuper(FormField);

    function FormField() {
      var _this;

      Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this, FormField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_this), "state", {
        isActive: false,
        hasValue: !!(_this.props.defaultValue || _this.props.value)
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_this), "setActive", function () {
        _this.setState({
          isActive: true
        });
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_this), "unsetActive", function () {
        _this.setState({
          isActive: false
        });
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_this), "onClear", function () {
        _this.unsetActive();

        if (_this.props.onClear) {
          _this.props.onClear();
        }
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_this), "onChange", function (value) {
        _this.setState({
          hasValue: value !== ''
        });

        if (_this.props.onChange) {
          _this.props.onChange(value);
        }
      });

      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(_this), "getValidationState", function () {
        var validationState = _this.props.validationState;
        var hasValue = _this.state.hasValue;
        return validationState === 'IS_VALID' && !hasValue ? 'NOT_VALIDATED' : validationState;
      });

      return _this;
    }

    Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(FormField, [{
      key: "renderInput",
      value: function renderInput(id) {
        var _this$props = this.props,
            icon = _this$props.icon,
            isDisabled = _this$props.isDisabled,
            isLoading = _this$props.isLoading,
            isReadOnly = _this$props.isReadOnly;
        var isActive = this.state.isActive;
        var validationState = this.getValidationState();
        var active = isActive || this.props.isActive;
        var isValid = validationState === 'IS_VALID' && !isDisabled;
        var isInvalid = validationState === 'IS_INVALID' && !isDisabled;
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('flex overflow-hidden outline-custom rounded-tiny transition-all', {
            'border-1': !isReadOnly,
            'bg-white': !isReadOnly && !isDisabled,
            'bg-gray-light': isDisabled && !isReadOnly,
            'border-blue': isActive && !isDisabled && validationState === 'NOT_VALIDATED',
            'border-success': isValid,
            'border-danger': isInvalid
          }),
          onBlur: this.unsetActive,
          onFocus: this.setActive
        }, __jsx(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])({}, this.props, id ? {
          id: id
        } : null, {
          onClear: this.onClear,
          onChange: this.onChange,
          height: "2.6875rem"
        })), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
          className: "flex items-center justify-center leading-none rtl:pr-px10"
        }, __jsx(_spinner_Spinner__WEBPACK_IMPORTED_MODULE_17__[/* Spinner */ "a"], {
          size: "small"
        })), !!icon && __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('flex items-center justify-center -order-1 px-px5 transition-all', {
            'bg-gray-light text-gray-dark': !active,
            'bg-blue text-white': active,
            'bg-success text-white': isValid,
            'bg-danger text-white': isInvalid
          }),
          style: {
            width: '2.6875rem',
            minWidth: '2.6875rem',
            height: '2.6875rem'
          }
        }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
          name: icon,
          width: "1em"
        })), (isValid || isInvalid) && __jsx("span", {
          className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('flex items-center justify-center px-px10 text-xs transition-all', {
            'text-success': isValid,
            'text-danger': isInvalid
          })
        }, __jsx(_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
          name: isValid ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].CHECK : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_15__[/* ICONS */ "a"].CROSS,
          width: "1em"
        })));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            className = _this$props2.className,
            isRequired = _this$props2.isRequired,
            label = _this$props2.label,
            notes = _this$props2.notes,
            scrollSelector = _this$props2.scrollSelector;
        var id = this.props.generateUniqueId ? Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_14__[/* generateUniqueId */ "b"])([this.props.id, this.props.dataSelector]) : this.props.id;
        return __jsx("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_13___default()(className, scrollSelector, 'flex flex-col')
        }, !!label && __jsx("label", {
          className: classnames__WEBPACK_IMPORTED_MODULE_13___default()('flex font-bold items-center mb-px5 text-sm text-gray-darker transition-all'),
          htmlFor: id
        }, "".concat(label).concat(isRequired ? '*' : '')), this.renderInput(id), !!notes && __jsx("span", {
          className: "mt-px10 text-gray-darker text-sm"
        }, notes));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props) {
        return {
          hasValue: !!(props.defaultValue || props.value)
        };
      }
    }]);

    return FormField;
  }(react__WEBPACK_IMPORTED_MODULE_12___default.a.Component);

  Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(FormField, "displayName", 'FormField');

  Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(FormField, "defaultProps", defaultProps);

  return FormField;
}

/* harmony default export */ __webpack_exports__["a"] = (formField);

/***/ }),

/***/ "QRET":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var DOMIterables = __webpack_require__("YQkA");
var DOMTokenListPrototype = __webpack_require__("k4ez");
var ArrayIteratorMethods = __webpack_require__("I2c1");
var createNonEnumerableProperty = __webpack_require__("g51W");
var wellKnownSymbol = __webpack_require__("nJrx");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "Qabk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cruiseBookingResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fGyu");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("CcNa");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var generateCruiseTitle = function generateCruiseTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!title) {
    return '';
  }

  var cruiseTitle = name ? "".concat(title, " ").concat(name) : title;
  return "".concat(cruiseTitle, " | Club Med");
};

var getOpenGraphData = function getOpenGraphData(props) {
  var _props$product, _props$product2;

  var title = generateCruiseTitle((props === null || props === void 0 ? void 0 : (_props$product = props.product) === null || _props$product === void 0 ? void 0 : _props$product.title) || '', (props === null || props === void 0 ? void 0 : (_props$product2 = props.product) === null || _props$product2 === void 0 ? void 0 : _props$product2.name) || '') || props.title;
  return [{
    property: 'og:site_name',
    content: 'Club Med'
  }, {
    property: 'og:locale',
    content: props.locale
  }, {
    property: 'og:title',
    content: title
  }, {
    property: 'og:description',
    content: props.title
  }, {
    property: 'twitter:title',
    content: title
  }, {
    property: 'twitter:description',
    content: props.title
  }];
};

var cruiseBookingResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_11__[/* CRUISE_BOOKING */ "j"],
  props: function props() {
    return {
      title: function title(props) {
        var _props$product3, _props$product4;

        return generateCruiseTitle((props === null || props === void 0 ? void 0 : (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : _props$product3.title) || '', (props === null || props === void 0 ? void 0 : (_props$product4 = props.product) === null || _props$product4 === void 0 ? void 0 : _props$product4.name) || '') || props.title;
      },
      description: function description(props) {
        return props.title;
      },
      meta: function meta(props) {
        return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(props.product.htmlHeader.meta), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(getOpenGraphData(props)));
      }
    };
  },
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId,
        _props$criteria = props.criteria,
        criteria = _props$criteria === void 0 ? {} : _props$criteria,
        _props$dateFormat = props.dateFormat,
        dateFormat = _props$dateFormat === void 0 ? '' : _props$dateFormat,
        _props$pax = props.pax,
        pax = _props$pax === void 0 ? {
      minAgeErrorMessage: '',
      minAgeInformation: ''
    } : _props$pax;
    var minAgeErrorMessage = pax.minAgeErrorMessage,
        minAgeInformation = pax.minAgeInformation;
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var urlParams = location.urlParams;
    var durationValuePlaceholder = criteria.durationValuePlaceholder,
        dateValuePlaceholder = criteria.dateValuePlaceholder,
        fromToValuePlaceholder = criteria.fromToValuePlaceholder;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_12__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var cruiseArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_12__[/* buildCruiseArgs */ "b"])(urlParams);
    var cmsArgs = "content : \"".concat(cmsContent, "\" release : \"").concat(cmsRelease, "\"");
    var query = "{\n      product: resort(".concat(productArgs, ") {\n        adultOnly\n        description\n        duration(message : \"").concat(durationValuePlaceholder, "\")\n        dateRange(message : \"").concat(dateValuePlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")\n        htmlHeader { meta {name content} }\n        id\n        image\n        isJoyview\n        minAuthorizedAge {\n          formattedValue (message : \"").concat(minAgeInformation, "\" ").concat(cmsArgs, ")\n          value\n        }\n        minAgeErrorMessage : minAuthorizedAge {\n          formattedValue(message : \"").concat(minAgeErrorMessage, "\" ").concat(cmsArgs, ")\n        }\n        name\n        title\n        transportType\n      }\n      cruise(").concat(cruiseArgs, ") {\n        fromToDestination(message : \"").concat(fromToValuePlaceholder, "\")\n        departureDate\n      }\n      bookingCriteria(").concat(productArgs, ") {\n        departureCities {\n          value\n          label : name\n        },\n        initialNumberOfAdults(").concat(productArgs, ")\n        initialNumberOfChildren\n        initialTransport(").concat(productArgs, ")\n      }\n      config {\n        common {\n          participants {\n            kidsLabel\n            adultsLabel\n            kidsAgeLimit\n          }\n        }\n        booking {\n          accommodation {\n            errorMessages {\n              noProposalAvailable\n              noTransport\n            }\n          }\n          form {\n            dayPlaceholder\n            monthPlaceholder\n            yearPlaceholder\n            childrenBirthdayDateFormatPlaceholder\n            errorMaxGuestsLabel\n            departureDateErrorMessage\n            adultAge\n            proposalsLoaderLabel\n            errors {\n              adultChild\n              birthdayFormat\n            }\n          }\n        }\n        faceting {\n          reset\n          transport {\n            comment\n            defaultDepartureCityOnlyForDefaultTransportation\n            departingFrom\n            introduction\n            reassurance {\n              iconName\n              label\n            }\n            selectPlaceholder\n            subTitle\n            titleFrom\n          }\n          validate\n          when {\n            from\n          }\n        }\n        price {\n          format {\n            from\n            instead\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_14__[/* LINE_CRUISE_BOOKING */ "Mb"],
      strictErrors: false
    }).then(function (data) {
      return _objectSpread({
        origin: appContext.originalUrl,
        locale: appContext.locale
      }, data);
    });
  }
};

/***/ }),

/***/ "QknU":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "Qmkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESORT_PRODUCT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getResultItem; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aLgo");
/* harmony import */ var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("hCOa");
/* harmony import */ var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("LqLs");
/* harmony import */ var core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_set__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("87if");
/* harmony import */ var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var core_js_modules_es_string_match_all__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("DVx9");
/* harmony import */ var core_js_modules_es_string_match_all__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_match_all__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("fGyu");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("UCZK");
/* harmony import */ var _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("SPKZ");



























function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}






var COMFORT_EXCLUSIVE = 5;
var REGEXP_DYNAMIC_CRUISE = /^CM2C_\d{8}_\d{8}$/;
var REGEXP_SPAN_MATCH = /<span class="match">([^<]*)<\/span>/g;
var RESORT_PRODUCT_TYPE = 'resort';

function getType(item) {
  return item.product_id ? RESORT_PRODUCT_TYPE : item.type || item.section || '';
}

function isItemResort(item) {
  return getType(item) === RESORT_PRODUCT_TYPE;
}

function getLabel(item) {
  var label = striptags__WEBPACK_IMPORTED_MODULE_26___default()(item.value || '', '<span>');
  return isItemResort(item) && item.sibling_id ? "".concat(label, " - ").concat(item.season || '') : label;
}

function isCruise(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.CRUISE;
}

function isDynamicCruise(item) {
  return isCruise(item) && REGEXP_DYNAMIC_CRUISE.test(item.product_id || '');
}

function isJoyview(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.JOYVIEW;
}

function isTour(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.TOUR;
}

function isVilla(item) {
  return item.type === _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.VILLA;
}

function isExclusiveComfort(item) {
  return Number(item.comfort_level) >= COMFORT_EXCLUSIVE;
}

function isExclusiveCollection(item) {
  return isVilla(item) || isCruise(item) || isExclusiveComfort(item);
}

function getDescription(item) {
  return striptags__WEBPACK_IMPORTED_MODULE_26___default()(item.description || '', '<span>');
}

function getQueryMatches(item) {
  var queryMatches = [];
  var valueMatches = item.value ? item.value.matchAll(REGEXP_SPAN_MATCH) : [];

  var _iterator = _createForOfIteratorHelper(valueMatches),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var valueMatch = _step.value;
      queryMatches.push(valueMatch[1].toLowerCase());
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var descriptionMatches = item.description ? item.description.matchAll(REGEXP_SPAN_MATCH) : [];

  var _iterator2 = _createForOfIteratorHelper(descriptionMatches),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var descriptionMatch = _step2.value;
      queryMatches.push(descriptionMatch[1].toLowerCase());
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_25__[/* default */ "a"])(new Set(queryMatches));
}

function getProductId(item) {
  return isItemResort(item) ? item.product_id : null;
}

function getProductSeason(item) {
  return _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["resortAction"].getSeasonInfos(item.sibling_id ? item.season_id : _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].ALL_YEAR);
}

function getProductUrl(item) {
  var productUrl = new urijs__WEBPACK_IMPORTED_MODULE_27___default.a('/');

  if (isDynamicCruise(item)) {
    productUrl.segment('c').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["url"].normalizePath((item.product_id || '').split('_').join('/')));
  } else if (isTour(item)) {
    productUrl.segment('i').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  } else {
    productUrl.segment('r').segment(_clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["url"].normalizeSlug(item.title)).segment(getProductSeason(item));
  }

  return productUrl.toString();
}

function getLink(item) {
  return isItemResort(item) ? getProductUrl(item) : item.url;
}

function getHeadlines(item) {
  return isItemResort(item) ? {
    subLabel1: Array.isArray(item.destination_country) ? item.destination_country.join(', ') : item.destination_country,
    subLabel2: item.destination_area,
    productId: item.product_id,
    productType: item.type,
    comfortLevel: item.comfort_level,
    season: Array.isArray(item.season) ? '' : item.season
  } : {};
}

function getIcon(item) {
  var comfortLevel = item.comfort_level || 1;

  switch (item.type) {
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.CRUISE:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"].CRUISE;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.JOYVIEW:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"].TRIDENT_JOYVIEW;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.TOUR:
      return _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"].TOUR;

    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.RESORT:
    case _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].PRODUCT_TYPES.VILLA:
      return comfortLevel === String(COMFORT_EXCLUSIVE) ? null : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"]["TRIDENT".concat(comfortLevel)];

    default:
      return item.type === 'activity' ? _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"].ACTIVITIES : _components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_30__[/* ICONS */ "a"].ADDRESS;
  }
}

function getImage(item) {
  return isItemResort(item) ? item.immersive_image : item.backgroundurl || '';
}

function getColor(item) {
  if (isExclusiveCollection(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_29__[/* COLORS */ "a"].DEEP_BLUE;
  }

  if (isJoyview(item)) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_29__[/* COLORS */ "a"].WATER_GREEN;
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_29__[/* COLORS */ "a"].BLUE;
}

var getTagsColor = function getTagsColor(item) {
  var seasonName = Array.isArray(item.seasons_id) ? '' : item.seasons_id;

  if (seasonName === _clubmed_utils__WEBPACK_IMPORTED_MODULE_28__["constants"].SEASONS.SUMMER) {
    return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_29__[/* COLORS */ "a"].ORANGE;
  }

  if (isTour(item) || isCruise(item)) {
    return getColor(item);
  }

  return _components_utils_color_colors__WEBPACK_IMPORTED_MODULE_29__[/* COLORS */ "a"].BLUE;
};

function getResultItem(item) {
  return _objectSpread({
    description: getDescription(item),
    icon: getIcon(item),
    id: getProductId(item) || getLabel(item),
    image: getImage(item),
    isExclusiveCollection: isExclusiveCollection(item),
    label: getLabel(item),
    link: getLink(item),
    productColor: getColor(item),
    product_id: getProductId(item),
    queryMatches: getQueryMatches(item),
    tagsColor: getTagsColor(item),
    type: getType(item)
  }, getHeadlines(item));
}

/***/ }),

/***/ "R2jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return START_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endLoading; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");

var START_LOADING = 'START_LOADING';
var END_LOADING = 'END_LOADING';

function endLoading() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(END_LOADING, {});
}

function startLoading(globalLoaderLabel, isNavigation) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(START_LOADING, {
    globalLoaderLabel: globalLoaderLabel,
    isNavigation: isNavigation
  });
}



/***/ }),

/***/ "R3TX":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("zWgn"),
    overRest = __webpack_require__("UAs9"),
    setToString = __webpack_require__("7Pat");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "R5u7":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("pPzx"),
    isArrayLike = __webpack_require__("9y2L"),
    isIndex = __webpack_require__("pnw1"),
    isObject = __webpack_require__("tQYX");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "RBO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDepartureCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureDate; });
/* unused harmony export getMainContactOptinEmail */
/* unused harmony export getMainContactOptinSms */
/* unused harmony export getMainContactOptinFosun */
/* unused harmony export getMainContactOptinMail */
/* unused harmony export getMainContactOptinPhone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTripFlexibility; });
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_0__);


var tripCriteriaSelector = function tripCriteriaSelector(_ref) {
  var tripCriteria = _ref.tripCriteria;
  return tripCriteria || {};
};

var mainContactSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref2) {
  var mainContact = _ref2.mainContact;
  return mainContact || {};
});
var getDepartureCity = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref3) {
  var departureCity = _ref3.departureCity;
  return departureCity;
});
var getDepartureDate = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref4) {
  var departureDate = _ref4.departureDate;
  return departureDate;
});
var getMainContactOptinEmail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref5) {
  var optinEmail = _ref5.optinEmail;
  return optinEmail;
});
var getMainContactOptinSms = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref6) {
  var optinSms = _ref6.optinSms;
  return optinSms;
});
var getMainContactOptinMail = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref7) {
  var optinMail = _ref7.optinMail;
  return optinMail;
});
var getMainContactOptinPhone = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref8) {
  var optinPhone = _ref8.optinPhone;
  return optinPhone;
});
var getMainContactOptinFosun = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(mainContactSelector, function (_ref9) {
  var optinFosun = _ref9.optinFosun;
  return optinFosun;
});
var getTripDuration = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref10) {
  var duration = _ref10.duration;
  return duration;
});
var getTripFlexibility = Object(reselect__WEBPACK_IMPORTED_MODULE_0__["createSelector"])(tripCriteriaSelector, function (_ref11) {
  var flexibility = _ref11.flexibility;
  return flexibility;
});


/***/ }),

/***/ "RBvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRIP_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_NO_DURATION; });
var TRIP_INFORMATION_SET_DURATION = 'TRIP_INFORMATION_SET_DURATION';
var DEFAULT_TRIP_DURATION = 7;
var DEFAULT_NO_DURATION = null;

/***/ }),

/***/ "RNiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/line/Line.jsx + 358 modules
var Line = __webpack_require__("ybtA");

// EXTERNAL MODULE: ./src/client/components/seo/FacebookAndTwitterSeoHeaderMeta.jsx
var FacebookAndTwitterSeoHeaderMeta = __webpack_require__("LaX8");

// EXTERNAL MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx + 2 modules
var BaiduSeoScript = __webpack_require__("XL2j");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// CONCATENATED MODULE: ./src/client/views/home/HomeView.helper.js












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var HomeView_helper_formatContacts = function formatContacts(contacts, locale) {
  return contacts.map(function (contact) {
    var contactOption = [];

    if (contact.hearingImpairedSupported) {
      contactOption.push('HearingImpairedSupported');
    }

    if (contact.tollFree) {
      contactOption.push('TollFree');
    }

    return _objectSpread({
      '@type': 'ContactPoint',
      telephone: contact.phoneNumber,
      contactType: dist["constants"].CONTACT_TYPES[contact.type],
      areaServed: locale.split('-')[1]
    }, contactOption.length === 0 ? null : {
      contactOption: contactOption
    });
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var toolkit_constants = __webpack_require__("psNz");

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// EXTERNAL MODULE: ./src/utils/lines/formatLinesForLineComponent.js + 2 modules
var formatLinesForLineComponent = __webpack_require__("6Azr");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// CONCATENATED MODULE: ./src/server/dynamicPageService.js















function dynamicPageService_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function dynamicPageService_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      dynamicPageService_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      dynamicPageService_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}















var dynamicPageService_return404StatusCode = function return404StatusCode(location) {
  logger_default.a.error(new errors["e" /* PageNotFound */]({
    location: location
  }));
  return {
    statusCode: statusCode_constants["d" /* STATUS_CODE_404 */]
  };
};

/* harmony default export */ var dynamicPageService = (/*#__PURE__*/(function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var appContext, location, requestedPath, requestedPathHasCapitalLetters, pageQuery;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref.appContext, location = _ref.location;
            _context.prev = 1; // this try / catch is needed because the CMS pageByUrl request is not case-sensitive

            requestedPath = new URI_default.a(location.pathname || '').path(true);
            requestedPathHasCapitalLetters = requestedPath !== Object(lodash["toLower"])(requestedPath);

            if (!requestedPathHasCapitalLetters) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", dynamicPageService_return404StatusCode(location));

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", dynamicPageService_return404StatusCode(location));

          case 11:
            pageQuery = "\n  query {\n    page: pageByUrl(pageUrl: \"".concat(location.pathname, "\") {\n      breadcrumb {\n        label\n        url\n      }\n      pageId\n      pageType\n      pageRegion { name breadcrumbLabel }\n      pageCountry { name breadcrumbLabel }\n      url\n      title\n      description\n      lines\n      meta { key value }\n      hrefLang { url locale }\n      productRegionPageUrl\n      productCountryPageUrl\n    }\n  }");
            return _context.abrupt("return", graphqlClient["a" /* default */].runQuery(pageQuery, appContext, {
              requestName: requestDictionary["Lc" /* PAGE_DYNAMIC */]
            }).then(function (response) {
              var page = response.page;

              if (!page) {
                return dynamicPageService_return404StatusCode(location);
              }

              var pageType = page.pageType || page.pageId || 'none';

              var pageContext = dynamicPageService_objectSpread(dynamicPageService_objectSpread(dynamicPageService_objectSpread(dynamicPageService_objectSpread(dynamicPageService_objectSpread({
                breadcrumb: page.breadcrumb,
                pageId: page.pageId,
                pageTitle: page.title || dist["constants"].WEBSITE_NAME
              }, page.pageRegion ? {
                pageRegion: page.pageRegion
              } : null), page.pageCountry ? {
                pageCountry: page.pageCountry
              } : null), page.productRegionPageUrl ? {
                productRegionPageUrl: page.productRegionPageUrl
              } : null), page.productCountryPageUrl ? {
                productCountryPageUrl: page.productCountryPageUrl
              } : null), {}, {
                canonicalUrl: Object(uriUtils["h" /* getPageCanonicalUrl */])(appContext.originalUrl, page.url),
                hrefLang: page.hrefLang,
                pageDescription: page.description,
                pageMeta: Object(lodash["fromPairs"])(Object(lodash["castArray"])(page.meta).map(function (meta) {
                  return meta && [meta.key, meta.value];
                }).filter(Boolean)),
                pageType: pageType,
                // default status
                statusCode: statusCode_constants["a" /* STATUS_CODE_200 */],
                siteSection: Object(utils["e" /* getSiteSection */])({
                  pageType: pageType
                })
              });

              var pageLines = page.lines || []; // Filter non-form lines out of CxO prebookingform pages (form, error, success)
              // Filter non-form lines out of CxO prebookingform pages (form, error, success)

              var isPrebookingformPage = pageContext.pageType === dist["b2cPagesService"].PAGE_TYPES.PREBOOKING;

              if (isPrebookingformPage && Object(sellerUtils["g" /* isSeller */])(appContext) && pageLines) {
                pageLines = pageLines.filter(function (line) {
                  var lineName = Object.keys(line)[0];
                  return [toolkit_constants["H" /* PREBOOKING_FORM */], toolkit_constants["yb" /* SUBMISSION_STATUS */]].includes(lineName);
                });
              }

              return pageLines ? Object(formatLinesForLineComponent["a" /* formatLinesForLineComponent */])({
                lines: pageLines,
                appContext: appContext,
                pageContext: pageContext,
                // $FlowFixMe
                location: location,
                linesToAppend: [toolkit_constants["G" /* PAGE_TRACKING */]]
              }).then(function (lines) {
                return {
                  pageContext: pageContext,
                  page: dynamicPageService_objectSpread(dynamicPageService_objectSpread({}, page), {}, {
                    lines: lines
                  })
                };
              }) : {
                pageContext: pageContext,
                page: page
              };
            })["catch"](function () {
              return dynamicPageService_return404StatusCode(location);
            }));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})());
// CONCATENATED MODULE: ./src/client/views/home/HomeView.query.js















function HomeView_query_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function HomeView_query_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      HomeView_query_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      HomeView_query_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var HomeView_query_fetchHomeSeo = function fetchHomeSeo(_ref) {
  var appContext = _ref.appContext;
  var seoQuery = "query {\n    config {\n      footer { seo { description } }\n      seo {\n        contacts {\n          type\n          phoneNumber\n          hearingImpairedSupported\n          tollFree\n        }\n      }\n    }\n  }";
  return graphqlClient["a" /* default */].runQuery(seoQuery, appContext, {
    requestName: requestDictionary["Mc" /* PAGE_HOME */]
  });
};

var HomeView_query_fetchHomeConfig = function fetchHomeConfig(appContext, location) {
  return Promise.all([HomeView_query_fetchHomeSeo({
    appContext: appContext
  }), dynamicPageService({
    appContext: appContext,
    location: location
  })]).then(function (_ref2) {
    var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 2),
        config = _ref3[0],
        page = _ref3[1];

    return HomeView_query_objectSpread(HomeView_query_objectSpread({}, config), page);
  });
};
// CONCATENATED MODULE: ./src/client/views/home/HomeView.jsx














var __jsx = react_default.a.createElement;

function HomeView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function HomeView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HomeView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HomeView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var HomeView_Home = function Home(_ref) {
  var config = _ref.config,
      page = _ref.page;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      locale = _useContext.locale,
      origin = _useContext.originalUrl,
      userAgent = _useContext.userAgent;

  var _React$useContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]),
      pageTitle = _React$useContext.pageTitle,
      pageType = _React$useContext.pageType,
      pageDescription = _React$useContext.pageDescription;

  var currentUri = Object(uriUtils["c" /* convertLocationToURI */])(location);
  var seo = config.seo,
      description = config.footer.seo.description;
  var contactPoints = seo ? HomeView_helper_formatContacts(seo.contacts, locale) : [];

  var seoScript = __jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(HomeView_objectSpread({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: origin,
        name: dist["constants"].WEBSITE_NAME,
        description: description
      }, contactPoints.length === 0 ? null : {
        contactPoint: contactPoints
      }))
    }
  });

  return page ? __jsx(react["Fragment"], null, __jsx(head_default.a, null, seoScript, __jsx(BaiduSeoScript["a" /* BaiduSeoScript */], {
    lines: page.lines,
    locale: locale,
    userAgent: userAgent,
    originalUrl: origin,
    pageTitle: pageTitle,
    pageType: pageType,
    pageDescription: pageDescription
  })), __jsx(FacebookAndTwitterSeoHeaderMeta["a" /* FacebookAndTwitterSeoHeaderMeta */], {
    description: pageDescription,
    lines: page.lines,
    title: pageTitle,
    url: currentUri.toString()
  }), __jsx(Line["a" /* Line */], {
    props: {
      lines: page.lines
    }
  })) : null;
};

HomeView_Home.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
    var appContext, location, homeConfig;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref2.appContext, location = _ref2.location;
            _context.next = 3;
            return HomeView_query_fetchHomeConfig(appContext, location);

          case 3:
            homeConfig = _context.sent;
            return _context.abrupt("return", homeConfig);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

HomeView_Home.pageId = constants["h" /* HOME */];
HomeView_Home.pageType = tracking_constants["v" /* STATIC_PAGE_TYPES */].SHOPPING_HOME;
/* harmony default export */ var HomeView = (HomeView_Home);
// CONCATENATED MODULE: ./pages/index.js

/* harmony default export */ var pages = __webpack_exports__["default"] = (HomeView);

/***/ }),

/***/ "RNvQ":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("tQYX"),
    now = __webpack_require__("ENE1"),
    toNumber = __webpack_require__("nvU9");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "RWDY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUGGESTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalSearchSuggestionsList; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("iKE+");
/* harmony import */ var core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("47go");
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _frameworks_image_Image__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("0IQ5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("u/u4");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("MWZw");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("kiXb");











var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;









var SUGGESTION_TYPES = {
  ACTIVITY: 'activity',
  AREA: 'area',
  COUNTRY: 'country',
  EDITO: 'edito',
  RESORT: 'resort'
};
var GlobalSearchSuggestionsList = function GlobalSearchSuggestionsList(_ref) {
  var blockSuggestions = _ref.blockSuggestions,
      blockType = _ref.blockType,
      isDesktop = _ref.isDesktop,
      onClick = _ref.onClick;
  var maxNumberOfSuggestions = !isDesktop || blockType === SUGGESTION_TYPES.EDITO ? 3 : 5;

  var onPress = function onPress(suggestion) {
    onClick(suggestion);
  };

  return __jsx("ul", {
    className: "reset-list"
  }, blockSuggestions.slice(0, maxNumberOfSuggestions).map(function (suggestion) {
    var description = suggestion.description,
        image = suggestion.image,
        label = suggestion.label,
        link = suggestion.link,
        queryMatches = suggestion.queryMatches,
        type = suggestion.type;
    return {
      description: description,
      image: image,
      label: striptags__WEBPACK_IMPORTED_MODULE_14___default()(label),
      link: link,
      queryMatches: queryMatches,
      type: type
    };
  }).map(function (suggestion, index) {
    var description = suggestion.description,
        image = suggestion.image,
        label = suggestion.label,
        _suggestion$queryMatc = suggestion.queryMatches,
        queryMatches = _suggestion$queryMatc === void 0 ? [] : _suggestion$queryMatc,
        type = suggestion.type;

    if (type === SUGGESTION_TYPES.EDITO) {
      var defaultPicture = {
        alt: label,
        src: image
      };
      var stripedDescription = striptags__WEBPACK_IMPORTED_MODULE_14___default()(description || '');
      var truncatedDescription = stripedDescription.length > 65 ? "".concat(stripedDescription.substring(0, 62), "...") : stripedDescription;
      var decoratedDescription = truncatedDescription;
      queryMatches.forEach(function (queryMatch) {
        decoratedDescription = decoratedDescription.replace(new RegExp("(".concat(queryMatch, ")"), 'ig'), "<span class='match'>$1</span>");
      });
      return __jsx("li", {
        key: label,
        className: "flex mb-px30 cursor-pointer",
        "data-testid": "".concat(type, "-link"),
        onClick: function onClick() {
          return onPress(suggestion);
        },
        onKeyUp: function onKeyUp(event) {
          /* Space & Enter */
          if (event.keyCode === 32 || event.keyCode === 13) {
            onPress(suggestion);
          }
        }
      }, isDesktop && __jsx("div", {
        className: "relative rtl:pr-px20 w-1/3"
      }, __jsx(_frameworks_image_Image__WEBPACK_IMPORTED_MODULE_15__[/* default */ "b"], {
        altMsg: defaultPicture.alt,
        imageUrl: defaultPicture.src,
        key: defaultPicture.src,
        groupKey: "thumbnails",
        ratioKey: _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"].XL,
        ratioDisplay: 1 / 3,
        hasLazyLoading: false
      })), __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('flex flex-col flex-start overflow-hidden', {
          'w-1/2': isDesktop,
          'w-full': !isDesktop
        }),
        role: "button",
        tabIndex: index
      }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_18__[/* Title */ "a"], {
        className: "leading-tight font-bold text-lg",
        color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_16__[/* COLORS */ "a"].GRAY,
        hLevel: 3,
        role: "presentation",
        theme: "none"
      }, label), __jsx("div", {
        className: "leading-tight text-base text-gray decorator-match pt-px10 flex-1" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: decoratedDescription
        }
      }), __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('font-bold text-sm text-gray underline', {
          'pt-px10': !isDesktop
        })
      }, Object(lodash__WEBPACK_IMPORTED_MODULE_12__["upperFirst"])(Object(_i18n__WEBPACK_IMPORTED_MODULE_19__[/* t */ "h"])('common.readMoreLabel')))));
    }

    return __jsx("li", {
      key: label,
      className: "flex mb-px10",
      "data-testid": "".concat(type, "-link")
    }, __jsx("span", {
      role: "button",
      tabIndex: index,
      className: "cursor-pointer font-bold leading-tight text-gray text-xl lg:text-2xl",
      onClick: function onClick() {
        return onPress(suggestion);
      },
      onKeyUp: function onKeyUp(event) {
        /* Space & Enter */
        if (event.keyCode === 32 || event.keyCode === 13) {
          onPress(suggestion);
        }
      }
    }, label));
  }));
};

/***/ }),

/***/ "RWUY":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("pfAP");
var isSymbol = __webpack_require__("km0D");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : String(key);
};


/***/ }),

/***/ "RqHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mixedToMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateToInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dateDiff; });
/* unused harmony export momentToInt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return maxDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return minDatepickerDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closedDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firstSiblingOpenDayOfSelectedMonthFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return siblingOpenDaysFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDisabledDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bestPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return lastRoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return flattenPrices; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("VtPb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("sW3P");














var mixedToMoment = function mixedToMoment(mixedDate) {
  return moment__WEBPACK_IMPORTED_MODULE_10___default()(mixedDate);
};
var dateToInt = function dateToInt(d) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* API_DATE_FORMAT */ "a"];
  return parseInt(mixedToMoment(d).format(format), 10);
};
var dateDiff = function dateDiff(day1, day2) {
  return Math.abs(moment__WEBPACK_IMPORTED_MODULE_10___default()(day2).diff(moment__WEBPACK_IMPORTED_MODULE_10___default()(day1), 'days'));
};
var momentToInt = function momentToInt(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* API_DATE_FORMAT */ "a"];
  return parseInt(date.format(format), 10);
};
var maxDatepickerDate = function maxDatepickerDate() {
  return moment__WEBPACK_IMPORTED_MODULE_10___default()().add(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_DATE_MAX_DATE */ "k"]).toDate();
};
var minDatepickerDate = function minDatepickerDate() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return moment__WEBPACK_IMPORTED_MODULE_10___default()().add({
    days: offset
  }).toDate();
};

function daysWithoutDepartureFactory(resolver, fromDate, toDate) {
  return function (day) {
    var _resolver = resolver(dateToInt(day)),
        _resolver$exclusivity = _resolver.exclusivity,
        exclusivity = _resolver$exclusivity === void 0 ? false : _resolver$exclusivity,
        _resolver$noFlight = _resolver.noFlight,
        noFlight = _resolver$noFlight === void 0 ? false : _resolver$noFlight,
        _resolver$full = _resolver.full,
        full = _resolver$full === void 0 ? false : _resolver$full;

    var available = !exclusivity && !noFlight && !full;

    if (!fromDate && !toDate) {
      return !available;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && !available;
  };
}

var daysWithNoAvailabilityFactory = function daysWithNoAvailabilityFactory(resolver) {
  return function (day) {
    var data = resolver(dateToInt(day));
    return Object(lodash__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(data) || data.noAvailability;
  };
};

var closedDaysFactory = function closedDaysFactory(resolver, fromDate, toDate, shouldAllowSelectingSiblingOpenDays) {
  return function (day) {
    var _resolver2 = resolver(dateToInt(day)),
        _resolver2$closed = _resolver2.closed,
        closed = _resolver2$closed === void 0 ? false : _resolver2$closed,
        _resolver2$siblingOpe = _resolver2.siblingOpen,
        siblingOpen = _resolver2$siblingOpe === void 0 ? false : _resolver2$siblingOpe;

    if (!fromDate && !toDate) {
      return closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays;
    }

    if (fromDate && !toDate) {
      return false;
    }

    var dayIsSelected = fromDate && toDate && dateToInt(day) >= dateToInt(fromDate) && dateToInt(day) <= dateToInt(toDate);
    return !dayIsSelected && (closed || siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  };
};
var firstSiblingOpenDayOfSelectedMonthFactory = function firstSiblingOpenDayOfSelectedMonthFactory(resolver, selectedMonth) {
  var firstSiblingOpenDayFound = false;
  return function (day) {
    var _resolver3;

    if (!selectedMonth) {
      return false;
    }

    var firstDayOfSelectedMonth = "".concat(selectedMonth.toString(), "01");
    var firstDayOfSelectedMonthAsDate = moment__WEBPACK_IMPORTED_MODULE_10___default()(firstDayOfSelectedMonth, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_12__[/* API_DATE_FORMAT */ "a"]);
    var firstDisplayedDayOfSelectedMonthAsInt = firstDayOfSelectedMonthAsDate.weekday() > 0 ? momentToInt(firstDayOfSelectedMonthAsDate.subtract(firstDayOfSelectedMonthAsDate.weekday(), 'days')) : momentToInt(firstDayOfSelectedMonthAsDate);
    var lastDisplayedDayOfSelectedMonthAsInt = momentToInt(moment__WEBPACK_IMPORTED_MODULE_10___default()(firstDayOfSelectedMonthAsDate).add(41, 'days'));
    var currentDayDateAsInt = dateToInt(day);

    if (firstSiblingOpenDayFound || currentDayDateAsInt < firstDisplayedDayOfSelectedMonthAsInt || currentDayDateAsInt > lastDisplayedDayOfSelectedMonthAsInt) {
      return false;
    }

    var hasSiblingOpen = ((_resolver3 = resolver(currentDayDateAsInt)) === null || _resolver3 === void 0 ? void 0 : _resolver3.siblingOpen) || false;

    if (hasSiblingOpen) {
      firstSiblingOpenDayFound = true;
    }

    return hasSiblingOpen;
  };
};
var siblingOpenDaysFactory = function siblingOpenDaysFactory(resolver) {
  return function (day) {
    var _resolver4;

    return ((_resolver4 = resolver(dateToInt(day))) === null || _resolver4 === void 0 ? void 0 : _resolver4.siblingOpen) || false;
  };
};

var unavailableReturnDaysFactory = function unavailableReturnDaysFactory(fromDate) {
  var durations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (day) {
    if (day < fromDate) return false;
    var duration = dateDiff(day, fromDate); // rule of max 30 days of reservation

    if (duration > 30) return true;
    return !!duration && !durations.includes(duration);
  };
};

function getDisabledDays(_ref) {
  var from = _ref.from,
      isSeller = _ref.isSeller,
      optionsDuration = _ref.optionsDuration,
      openingDates = _ref.openingDates,
      prices = _ref.prices,
      resolvePrice = _ref.resolvePrice,
      shouldAllowSelectingSiblingOpenDays = _ref.shouldAllowSelectingSiblingOpenDays,
      to = _ref.to;
  var disabledDays = [];
  var pricesIds = Object.keys(prices || {});
  var hasPrices = pricesIds.length > 0;
  var allClosedDays = pricesIds.filter(function (priceKey) {
    return prices && (prices[priceKey].closed || prices[priceKey].siblingOpen && !shouldAllowSelectingSiblingOpenDays);
  }).map(function (priceKey) {
    return parseInt(priceKey, 10);
  });

  if (hasPrices) {
    var dayIsWithoutDeparture = daysWithoutDepartureFactory(resolvePrice, from, to);
    var dayIsClosed = closedDaysFactory(resolvePrice, from, to, shouldAllowSelectingSiblingOpenDays);
    var dayIsSiblingOpen = siblingOpenDaysFactory(resolvePrice);
    var dayIsWithoutData = daysWithNoAvailabilityFactory(resolvePrice);
    disabledDays.push(dayIsWithoutDeparture);
    disabledDays.push(dayIsClosed);

    if (!shouldAllowSelectingSiblingOpenDays) {
      disabledDays.push(dayIsSiblingOpen);
    }

    disabledDays.push(dayIsWithoutData);
  }

  if (from && !to) {
    var fromDay = dateToInt(from);
    var closedDaysAfterFromDay = allClosedDays.filter(function (closedDay) {
      return closedDay > fromDay;
    });
    var firstClosedDay = hasPrices && closedDaysAfterFromDay.length > 0 && Math.min.apply(null, closedDaysAfterFromDay);
    disabledDays.push({
      before: moment__WEBPACK_IMPORTED_MODULE_10___default()(from).toDate(),
      after: firstClosedDay ? moment__WEBPACK_IMPORTED_MODULE_10___default()(firstClosedDay.toString()).toDate() : moment__WEBPACK_IMPORTED_MODULE_10___default()(from).add(30, 'days').toDate()
    });
  }

  if (from && !to && !Object(lodash__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(optionsDuration) && !isSeller) {
    disabledDays.push(unavailableReturnDaysFactory(from, optionsDuration));
  }

  if (openingDates === null || openingDates === void 0 ? void 0 : openingDates.length) {
    disabledDays.push.apply(disabledDays, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Object(_store_calendar_calendar_helper__WEBPACK_IMPORTED_MODULE_11__[/* getClosingDatesRanges */ "b"])(openingDates)));
  }

  return disabledDays;
}
function bestPrice(resolver) {
  return function (day) {
    var id = dateToInt(day);

    var _ref2 = resolver && resolver(id) || {
      isBestPrice: false
    },
        isBestPrice = _ref2.isBestPrice;

    return isBestPrice;
  };
}
var lastRoom = function lastRoom(resolver) {
  return function (day) {
    var id = dateToInt(day);

    var _ref3 = resolver && resolver(id) || {
      lastAvailability: false
    },
        lastAvailability = _ref3.lastAvailability;

    return lastAvailability;
  };
};
function flattenPrices(prices) {
  var pricesIds = Object.keys(prices);
  return pricesIds.map(function (priceId) {
    return prices[priceId].oldPrice;
  }).join();
}

/***/ }),

/***/ "SQLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("\n  fragment BookingAttendeesProfile on Profile {\n    gmNumber\n    civility\n    firstName\n    lastName\n    unicodeFirstName\n    unicodeLastName\n  }\n");

/***/ }),

/***/ "SRps":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "SUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductBanner; });
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_product_product_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("C9cF");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VHif");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;






var ICONS_HEIGHT = 50;
var ProductBanner = function ProductBanner(_ref) {
  var product = _ref.product;
  return __jsx("div", {
    className: "items-start hidden lg:flex"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, Object(_utils_product_product_utils__WEBPACK_IMPORTED_MODULE_3__[/* getProductBadgeIcon */ "d"])(product), {
    className: "flex-shrink-0 rounded-tiny",
    size: ICONS_HEIGHT
  })), product.isExplicitEC && product.badgeIcon && __jsx("span", {
    className: "font-brand mx-px5 text-base self-center"
  }, "&"), product.isExplicitEC && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_6__[/* ECBadge */ "a"], {
    height: ICONS_HEIGHT,
    iconWidth: "80%"
  }), __jsx("div", {
    className: "flex-auto mx-px10"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_7__[/* Title */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].GRAY_DARKER,
    hLevel: 1,
    theme: "none"
  }, __jsx("div", {
    className: "font-brand font-normal leading-tight text-xl"
  }, product.name), __jsx("div", {
    className: "font-sans font-bold leading-tight uppercase text-md"
  }, product.destination.country))));
};

/***/ }),

/***/ "TVUe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TrackingPageLoad_TrackingPageLoad; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/client/store/lead-info/leadInfo.selector.js
var leadInfo_selector = __webpack_require__("8fx4");

// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.jsx











var __jsx = react["createElement"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var tracking_component_TrackingComponent = function TrackingComponent(_ref) {
  var children = _ref.children,
      track = _ref.track,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["children", "track"]);

  var appContext = react["useContext"](ReactAppContext["b" /* default */]);
  var pageContext = react["useContext"](context_pageContext["a" /* ReactPageContext */]);
  var leadScoring = Object(es["e" /* useSelector */])(leadInfo_selector["a" /* getLeadScore */]); // in some cases (like the NotFoundView) the siteSection's value cannot be dynamically built
  // from the pageType and attached to the pageContext,
  // so we need to declare it in the props directly but this should be avoided

  var siteSection = props.siteSection || pageContext.siteSection;
  react["useEffect"](function () {
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      // $FlowFixMe
      id: props.resortCode,
      be: false,
      timestamp: Date.now()
    });
  }, [props.pageName]);
  react["useEffect"](function () {
    // pageId is not actually needed here, since the categoryGA is only used for events
    // not for page loading (the analytics team doesn't care), but it makes our API more
    // consistent
    tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      siteSection: siteSection
    }, siteSection && siteSection.includes(constants["l" /* PLE */]) ? {
      BE_customerStatus: appContext.customerStatus
    } : undefined), leadScoring ? {
      leadScoring: leadScoring
    } : null), appContext, pageContext.pageId);

    if (track) {
      track();
    }
  }, [props.pageName]);
  return __jsx("div", null, children);
};

/* harmony default export */ var tracking_component = (tracking_component_TrackingComponent);
// CONCATENATED MODULE: ./src/client/tracking/tracking-component/index.js

/* harmony default export */ var tracking_tracking_component = (tracking_component);
// EXTERNAL MODULE: ./src/client/tracking/tracking-storage-api/index.js
var tracking_storage_api = __webpack_require__("K0Lv");

// EXTERNAL MODULE: ./src/client/store/user-info/userInfo.selectors.js
var userInfo_selectors = __webpack_require__("apzf");

// CONCATENATED MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx










var TrackingPageLoad_jsx = react_default.a.createElement;

function TrackingPageLoad_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TrackingPageLoad_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TrackingPageLoad_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TrackingPageLoad_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var TrackingPageLoad_TrackingPageLoad = function TrackingPageLoad(props) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var trackingPageLoadAppendSuffix = location.queryParams.trackingPageLoadAppendSuffix;
  var profile = Object(es["e" /* useSelector */])(userInfo_selectors["a" /* userInfoSelector */]);

  function getTrackingProps() {
    var _profile$loyaltyProgr;

    var baseProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, props.trackingKey ?
    /**
     * We need to omit ski data because in case of 2 bookings from the same session,
     * when the first one has ski equipments and second one has none,
     * the second one get wrong ski data from locale storage
     * In case of new ski data exist, it will be added from props anyway
     */
    Object(lodash["omit"])(tracking_storage_api["a" /* get */](props.trackingKey), 'skiEquipment', 'skiingEquipment', 'snowboardingEquipment', 'hikingEquipment') : {}), {}, {
      event: constants["y" /* VIRTUAL_PAGE_LOAD */],
      fidelityStatus: (profile === null || profile === void 0 ? void 0 : (_profile$loyaltyProgr = profile.loyaltyProgram) === null || _profile$loyaltyProgr === void 0 ? void 0 : _profile$loyaltyProgr.status) || ''
    }, Object(lodash["omit"])(props, 'children', 'location', 'history', 'match', 'trackingKey'));

    if (trackingPageLoadAppendSuffix) {
      baseProps = TrackingPageLoad_objectSpread(TrackingPageLoad_objectSpread({}, baseProps), {}, {
        pageName: "".concat(baseProps.pageName, "_").concat(trackingPageLoadAppendSuffix)
      });
    }

    if (props.pageName === constants["b" /* BE_OPTION_CONFIRMATION */]) {
      return Object(lodash["omit"])(baseProps, ['upsellExcursion', 'upsellRevenue', 'donation', 'paymentDeposit', 'paymentMethod', 'paymentPlan', 'paymentStatus', 'paymentType', 'donation']);
    }

    return baseProps;
  }

  var trackingProps = getTrackingProps();
  react_default.a.useEffect(function () {
    if (props.event) {
      tracking_storage_api["b" /* set */](trackingProps);
    }
  }, [props.event]);
  return TrackingPageLoad_jsx(tracking_tracking_component, Object(esm_extends["a" /* default */])({}, trackingProps, {
    track: props.track
  }));
};

/***/ }),

/***/ "TYzI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIONS; });
/* unused harmony export CriteriaDisplayContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useCriteriaDisplayContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaDisplayProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("yH/f");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ACTIONS = Object.freeze({
  CLOSE_CRITERIA: 'CLOSE_CRITERIA',
  OPEN_CRITERIA: 'OPEN_CRITERIA',
  OPEN_NEXT_CRITERIA: 'OPEN_NEXT_CRITERIA'
});
var initialState = {
  criteriaWhenIsOpen: false,
  criteriaWhoIsOpen: false,
  criteriaTransportIsOpen: false
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  switch (action.type) {
    case ACTIONS.OPEN_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), true));

    case ACTIONS.CLOSE_CRITERIA:
      return _objectSpread(_objectSpread({}, state), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, "".concat(action.payload, "IsOpen"), false));

    case ACTIONS.OPEN_NEXT_CRITERIA:
      var _action$payload = action.payload,
          currentCriteria = _action$payload.currentCriteria,
          criteriaContext = _action$payload.criteriaContext;

      if (currentCriteria === 'criteriaTransport') {
        return state;
      }

      if (currentCriteria === 'criteriaWho' && !criteriaContext.criteriaTransportIsSet) {
        return _objectSpread(_objectSpread({}, state), {}, {
          criteriaTransportIsOpen: true
        });
      }

      if (currentCriteria === 'criteriaWhen') {
        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      if (currentCriteria === 'criteriaQuery') {
        if (!criteriaContext.criteriaWhenIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhenIsOpen: true
          });
        }

        if (!criteriaContext.criteriaWhoIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaWhoIsOpen: true
          });
        }

        if (!criteriaContext.criteriaTransportIsSet) {
          return _objectSpread(_objectSpread({}, state), {}, {
            criteriaTransportIsOpen: true
          });
        }
      }

      return state;

    default:
      return state;
  }
};

var CriteriaDisplayContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_9__["createContext"])([initialState, function () {}]);
var useCriteriaDisplayContext = function useCriteriaDisplayContext() {
  return Object(react__WEBPACK_IMPORTED_MODULE_9__["useContext"])(CriteriaDisplayContext);
};
var CriteriaDisplayProvider = function CriteriaDisplayProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_9__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return __jsx(CriteriaDisplayContext.Provider, {
    value: [state, dispatch]
  }, children);
};

/***/ }),

/***/ "TZT2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AmpStateContext = /*#__PURE__*/_react.default.createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ "U2fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ LAYER_HEADER_HEIGHT; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Layer; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 10 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/context/ToastContext.js
var ToastContext = __webpack_require__("waz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.themes.js
var themes = function themes(_ref) {
  var isActive = _ref.isActive;
  return {
    "default": {
      thRoot: "reset-button cursor-pointer flex flex-col sm:flex-row items-center p-px5 rounded-small text-sm transition-colors".concat(isActive ? ' bg-blue hover:bg-turquoise text-white' : ' hover:text-turquoise'),
      thIcon: 'm-px5 flex-shrink-0',
      thIconWidth: '1.25rem',
      thLabel: 'sr-only'
    },
    custom: {
      thRoot: "reset-button cursor-pointer flex flex-col sm:flex-row items-center p-px5 rounded-small text-sm transition-colors".concat(isActive ? ' bg-blue hover:bg-turquoise text-white' : ' hover:text-turquoise'),
      thIcon: 'm-px5 flex-shrink-0',
      thIconWidth: '1.25rem',
      thLabel: 'm-px5 text-center text-md'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/layer-header-button/LayerHeaderButton.jsx

var __jsx = react_default.a.createElement;




var LayerHeaderButton_LayerHeaderButton = function LayerHeaderButton(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconClassName = _ref.iconClassName,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      label = _ref.label,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!label && !iconName) {
    return null;
  }

  var _themes$theme = themes({
    isActive: isActive
  })[theme],
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;
  return __jsx("button", Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId,
    onClick: onClick
  }, tabIndex === -1 ? {
    tabIndex: tabIndex
  } : null, {
    type: "button"
  }), !!iconName && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thIcon, iconClassName),
    hasRtl: true,
    name: iconName,
    width: thIconWidth
  }), !!label && __jsx("span", {
    className: thLabel
  }, label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.themes.js
var LayerHeader_themes_themes = {
  "default": {
    thRoot: 'bg-white fixed overflow-hidden px-px20 shadow-diffuse transition-heights w-full z-3',
    thInner: 'flex h-full items-center w-full',
    thChild: 'flex-1',
    thClose: 'reset-button leading-none rtl:ml-auto order-1 p-px10 hover:text-turquoise transition-color',
    thCloseIconWidth: '1rem',
    thCloseLabel: 'sr-only'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/layer-header/LayerHeader.jsx

var LayerHeader_jsx = react_default.a.createElement;






var LayerHeader_LayerHeader = function LayerHeader(_ref) {
  var buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      hasContainer = _ref.hasContainer,
      height = _ref.height,
      onClose = _ref.onClose,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var layerButtonRef = Object(react["useRef"])();
  Object(react["useEffect"])(function () {
    layerButtonRef.current && layerButtonRef.current.focus();
  }, []);
  var _themes$theme = LayerHeader_themes_themes[theme],
      thButtonLeft = _themes$theme.thButtonLeft,
      thButtonRight = _themes$theme.thButtonRight,
      thChild = _themes$theme.thChild,
      thClose = _themes$theme.thClose,
      thCloseIconWidth = _themes$theme.thCloseIconWidth,
      thCloseLabel = _themes$theme.thCloseLabel,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  return LayerHeader_jsx("header", {
    className: classnames_default()(className, thRoot),
    style: {
      height: height,
      maxHeight: height
    }
  }, LayerHeader_jsx("div", {
    className: classnames_default()(thInner, {
      'm-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "LayerHeader-body"
  }, LayerHeader_jsx("button", {
    className: thClose,
    "data-testid": "Layer-close",
    onClick: onClose,
    ref: layerButtonRef,
    type: "button"
  }, !!closeLabel && LayerHeader_jsx("span", {
    className: thCloseLabel
  }, closeLabel), LayerHeader_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thCloseIconWidth
  })), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    className: thButtonLeft,
    dataTestId: "layer-header-button-left"
  }, buttonLeft, {
    theme: theme
  })), !!react["Children"].count(children) && LayerHeader_jsx("div", {
    className: thChild
  }, children), LayerHeader_jsx(LayerHeaderButton_LayerHeaderButton, Object(esm_extends["a" /* default */])({
    className: thButtonRight,
    dataTestId: "layer-header-button-right"
  }, buttonRight, {
    theme: theme
  }))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/layer/Layer.jsx





var Layer_jsx = react_default.a.createElement;










var LAYER_HEADER_HEIGHT = 60;
var onScroll = Object(lodash["throttle"])(function () {
  Object(lib["forceCheck"])();
}, 250);

var Layer_LayerComponent = function LayerComponent(_ref, layerRef) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? colors["a" /* COLORS */].GRAY_LIGHTER : _ref$bgColor,
      buttonLeft = _ref.buttonLeft,
      buttonRight = _ref.buttonRight,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'Layer' : _ref$dataTestId,
      _ref$enterAnimation = _ref.enterAnimation,
      enterAnimation = _ref$enterAnimation === void 0 ? 'slideInRight' : _ref$enterAnimation,
      _ref$externalFocusTra = _ref.externalFocusTrapRefs,
      externalFocusTrapRefs = _ref$externalFocusTra === void 0 ? [] : _ref$externalFocusTra,
      hasAnimateEnter = _ref.hasAnimateEnter,
      hasContainer = _ref.hasContainer,
      hasContainerHeader = _ref.hasContainerHeader,
      hasNoFocusTrap = _ref.hasNoFocusTrap,
      hasScrollLocked = _ref.hasScrollLocked,
      header = _ref.header,
      onClose = _ref.onClose,
      portalName = _ref.portalName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _useContext = Object(react["useContext"])(ToastContext["a" /* ToastContext */]),
      ref = _useContext.ref;

  var layerBody = Object(react["useRef"])(null);
  Object(react["useImperativeHandle"])(layerRef, function () {
    return layerBody.current;
  }, [layerBody]);
  Object(react["useEffect"])(function () {
    var _layerBody$current;

    (_layerBody$current = layerBody.current) === null || _layerBody$current === void 0 ? void 0 : _layerBody$current.addEventListener('scroll', onScroll);
    return function () {
      var _layerBody$current2;

      (_layerBody$current2 = layerBody.current) === null || _layerBody$current2 === void 0 ? void 0 : _layerBody$current2.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasHeader = buttonLeft || buttonRight || header;
  var shards = ref ? [ref].concat(Object(toConsumableArray["a" /* default */])(externalFocusTrapRefs)) : externalFocusTrapRefs;
  return Layer_jsx(Portal["a" /* default */], {
    name: portalName
  }, Layer_jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: !hasNoFocusTrap,
    onEscapeKey: onClose,
    shards: shards
  }, Layer_jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: true
  }, Layer_jsx("aside", {
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, Layer_jsx("div", {
    className: classnames_default()(className, 'fixed inset-0 w-full escape-responsive-helper', "bg-".concat(bgColor), Object(defineProperty["a" /* default */])({}, enterAnimation, hasAnimateEnter)),
    "data-testid": dataTestId,
    role: "document"
  }, hasHeader && Layer_jsx(LayerHeader_LayerHeader, {
    buttonLeft: buttonLeft,
    buttonRight: buttonRight,
    closeLabel: [closeLabel, ariaLabel].join(' ').trim(),
    hasContainer: hasContainerHeader,
    height: LAYER_HEADER_HEIGHT,
    onClose: onClose,
    theme: theme
  }, header), Layer_jsx("div", {
    className: "h-full z-0 transition-all".concat(hasScrollLocked ? ' overflow-hidden' : ' scroll-y').concat(hasContainer ? ' px-px20' : ''),
    "data-testid": "Layer-body",
    ref: layerBody,
    style: hasHeader ? {
      paddingTop: LAYER_HEADER_HEIGHT
    } : {}
  }, Layer_jsx("div", {
    className: classnames_default()('h-full min-h-full', {
      'mx-auto max-w-site w-full': hasContainer
    }),
    "data-testid": "Layer-content"
  }, children)))))));
}; // $FlowFixMe


var Layer = /*#__PURE__*/Object(react["forwardRef"])(Layer_LayerComponent);

/***/ }),

/***/ "U6GL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDown; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pWxA");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("sRHE");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("05v4");
/* harmony import */ var _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Q8Qh");










var __jsx = react__WEBPACK_IMPORTED_MODULE_10___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var DropDown = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(DropDown, _Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, DropDown);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "rootRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_10__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "contentRef", /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_10__["createRef"])());

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "expand", function () {
      _this.setState({
        isExpanded: true
      }, _this.toggleEventListeners);
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "collapse", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }

      if (!_this.props.unmountsOnClose) {
        _this.setState({
          isExpanded: false
        }, _this.toggleEventListeners);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onKeyDown", function (e) {
      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_13__[/* ESCAPE */ "g"]) {
        _this.collapse();
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "onClickOutside", function (e) {
      if (!_this.contentRef || // $FlowFixMe
      _this.contentRef.current.contains(e.target) || // $FlowFixMe
      _this.rootRef.current.contains(e.target) || // $FlowFixMe
      Object(lodash__WEBPACK_IMPORTED_MODULE_12__["get"])(_this.props, 'rootRef.current') && _this.props.rootRef.current.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      _this.collapse();
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isExpanded: !prevState.isExpanded
        };
      }, _this.toggleEventListeners);
    });

    _this.state = {
      isExpanded: props.isExpanded || false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(DropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isExpanded) {
        this.removeEventListeners();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.isExpanded !== this.props.isExpanded) {
        this.setState({
          isExpanded: nextProps.isExpanded
        }, this.toggleEventListeners);
      }
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      if (true) {
        document.addEventListener('mouseup', this.onClickOutside, false);
        document.addEventListener('touchstart', this.onClickOutside, false);
        document.addEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      if (true) {
        document.removeEventListener('mouseup', this.onClickOutside, false);
        document.removeEventListener('touchstart', this.onClickOutside, false);
        document.removeEventListener('keydown', this.onKeyDown, false);
      }
    }
  }, {
    key: "toggleEventListeners",
    value: function toggleEventListeners() {
      if (this.state.isExpanded) {
        this.addEventListeners();
      } else {
        this.removeEventListeners();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          contentStyle = _this$props.contentStyle,
          hasCloseOnClick = _this$props.hasCloseOnClick,
          renderTrigger = _this$props.renderTrigger,
          theme = _this$props.theme;
      var thBody = _DropDown_themes__WEBPACK_IMPORTED_MODULE_14__[/* themes */ "a"][theme].thBody;
      return __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_11___default()(className, 'inline-block relative'),
        ref: this.rootRef
      }, renderTrigger && renderTrigger(this.toggle, this.state.isExpanded), this.state.isExpanded && __jsx("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_11___default()('absolute left-1/2 min-w-full w-full -translate-x-50 z-4', thBody),
        "data-testid": "DropDown-body",
        onClick: hasCloseOnClick ? this.collapse : null,
        ref: this.contentRef,
        style: contentStyle
      }, children(this.toggle, this.state.isExpanded)));
    }
  }]);

  return DropDown;
}(react__WEBPACK_IMPORTED_MODULE_10__["Component"]);

Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(DropDown, "defaultProps", {
  isExpanded: false,
  theme: 'default',
  unmountsOnClose: false
});

/***/ }),

/***/ "UAs9":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("zaNA");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "UIAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACCOMMODATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ACCOMMODATION_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_TRANSFER_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_TRANSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPDATE_ATTENDEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLEAR_PROPOSALS; });
/* unused harmony export LOAD_PROPOSAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_PROPOSALS_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SELECTED_PROPOSAL_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REMOVE_TRANSFER_FROM_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SAVE_CUSTOMER_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UPDATE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PREPARE_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISPLAY_TOAST_ON_CONTEXT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_PROPOSALS_FROM_EDIT_CRITERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SAVE_DONATION_TO_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_PROMO_CODE; });
/* unused harmony export SET_PROMO_CODE_FAILURE_STATUS */
/* unused harmony export SET_PROMO_CODE_SUCCESS_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SWITCH_PROPOSALS_OFFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PRICE_COUNTER_PROPOSAL_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return INSURANCE_DELETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INSURANCE_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return INIT_INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TOGGLE_TERMS; });
var ADD_ACCOMMODATION = 'ADD_ACCOMMODATION';
var ADD_ACCOMMODATION_ERROR = 'ADD_ACCOMMODATION_ERROR';
var ADD_TRANSFER_TO_PROPOSALS = 'ADD_TRANSFER_TO_PROPOSALS';
var ADD_TRANSPORT = 'ADD_TRANSPORT';
var UPDATE_ATTENDEES = 'UPDATE_ATTENDEES';
var CLEAR_PROPOSALS = 'CLEAR_PROPOSALS';
var LOAD_PROPOSAL = 'LOAD_PROPOSAL';
var FETCH_PROPOSALS = 'FETCH_PROPOSALS';
var FETCH_PROPOSALS_BY_ID = 'FETCH_PROPOSALS_BY_ID';
var FETCH_SELECTED_PROPOSAL_PAYMENT = 'FETCH_SELECTED_PROPOSAL_PAYMENT';
var REMOVE_TRANSFER_FROM_PROPOSALS = 'REMOVE_TRANSFER_FROM_PROPOSALS';
var SET_PROPOSALS = 'SET_PROPOSALS';
var SAVE_CUSTOMER_PROPOSAL = 'SAVE_CUSTOMER_PROPOSAL';
var UPDATE_INSURANCES = 'UPDATE_INSURANCES';
var DELETE_INSURANCES = 'DELETE_INSURANCES';
var PREPARE_BE = 'PREPARE_BE';
var DISPLAY_TOAST_ON_CONTEXT_SHARE = 'DISPLAY_TOAST_ON_CONTEXT_SHARE';
var FETCH_PROPOSALS_FROM_EDIT_CRITERIA = 'FETCH_PROPOSALS_FROM_EDIT_CRITERIA';
var SAVE_DONATION_TO_PROPOSALS = 'SAVE_DONATION_TO_PROPOSALS';
var SET_PROMO_CODE = 'SET_PROMO_CODE';
var SET_PROMO_CODE_FAILURE_STATUS = 'failure';
var SET_PROMO_CODE_SUCCESS_STATUS = 'success';
var UPDATE_SERVICES = 'UPDATE_SERVICES';
var ADD_SERVICE = 'ADD_SERVICE';
var DELETE_SERVICE = 'DELETE_SERVICE';
var SWITCH_PROPOSALS_OFFERS = 'SWITCH_PROPOSALS_OFFERS';
var PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD = 30;
var PRICE_COUNTER_PROPOSAL_THRESHOLD = 10;
var PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD = 30;
var INSURANCE_DELETED = 'INSURANCE_DELETED';
var INSURANCE_ADDED = 'INSURANCE_ADDED';
var INIT_INSURANCES = 'INIT_INSURANCES';
var TOGGLE_TERMS = 'TOGGLE_TERMS';

/***/ }),

/***/ "Uey1":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "UlIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GOOGLE_API_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GOOGLE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GOOGLE_API_STREET_VIEW_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GOOGLE_API_JS_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GOOGLE_API_STATIC_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GOOGLE_PLACE_URL; });
var GOOGLE_API_DOMAIN = 'googlemap.api.domain';
var GOOGLE_API_KEY = 'googlemap.api.key';
var GOOGLE_API_STREET_VIEW_PATH = 'googlemap.api.streetViewPath';
var GOOGLE_API_JS_PATH = 'googlemap.api.jsPath';
var GOOGLE_API_STATIC_PATH = 'googlemap.api.staticPath';
var GOOGLE_PLACE_URL = 'http://www.google.com/maps/place';


/***/ }),

/***/ "Uqkn":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");
var inspectSource = __webpack_require__("/ExG");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "V/va":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (it instanceof Constructor) return it;
  throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
};


/***/ }),

/***/ "VBBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextSeeMore; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _see_more_SeeMore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NPTU");
/* harmony import */ var _text_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qqKu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var TextSeeMore = function TextSeeMore(_ref) {
  var className = _ref.className,
      hasNoScrollOnCollapse = _ref.hasNoScrollOnCollapse,
      isCollapseEnabled = _ref.isCollapseEnabled,
      offsetScrollSelector = _ref.offsetScrollSelector,
      onClick = _ref.onClick,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreSize = _ref.seeMoreSize,
      seeMoreTheme = _ref.seeMoreTheme,
      textProps = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, ["className", "hasNoScrollOnCollapse", "isCollapseEnabled", "offsetScrollSelector", "onClick", "seeLessLabel", "seeMoreLabel", "seeMoreSize", "seeMoreTheme"]);

  return __jsx(_see_more_SeeMore__WEBPACK_IMPORTED_MODULE_2__[/* SeeMore */ "a"], {
    className: className,
    hasNoScrollOnCollapse: hasNoScrollOnCollapse,
    isCollapseEnabled: isCollapseEnabled,
    offsetScrollSelector: offsetScrollSelector,
    onClick: onClick,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    theme: seeMoreTheme
  }, __jsx(_text_Text__WEBPACK_IMPORTED_MODULE_3__[/* Text */ "a"], textProps));
};

/***/ }),

/***/ "VGY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryIntroductionResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var countryIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* COUNTRY_INTRODUCTION */ "g"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      countryInfos(".concat(countryArgs, ") {\n        title\n        description\n      }\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_COMMON_COUNTRY_INTRODUCTION */ "wb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "VHif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Badge_Badge; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.themes.js


var variants = {
  diamond: {
    root: ' rotate-45',
    item: ' -rotate-45'
  },
  pill: {
    root: ' rounded-full',
    item: ''
  }
};
var themes = {
  "default": function _default(_ref) {
    var _ref$colorBg = _ref.colorBg,
        colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBg,
        _ref$colorBorder = _ref.colorBorder,
        colorBorder = _ref$colorBorder === void 0 ? colors["a" /* COLORS */].BLUE : _ref$colorBorder,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref$color,
        hasShadow = _ref.hasShadow,
        variant = _ref.variant;
    return {
      thRoot: "bg-".concat(colorBg, " border-").concat(colorBorder, " text-").concat(color, " border-2 flex-none inline-flex items-center justify-center leading-none overflow-hidden relative").concat(hasShadow ? ' shadow' : '').concat(variant ? variants[variant].root : ''),
      thImage: "absolute inset-0 ".concat(variant ? variants[variant].item : ''),
      thIcon: "absolute flex items-center justify-center inset-0".concat(variant ? variants[variant].item : ''),
      thIconSize: '65%',
      thLabel: "absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-center ".concat(variant ? variants[variant].item : ''),
      thLabelStyle: {
        fontSize: '1em'
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/badge/Badge.jsx
var __jsx = react_default.a.createElement;





var Badge_Badge = function Badge(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder,
      color = _ref.color,
      hasShadow = _ref.hasShadow,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      imageSrc = _ref.imageSrc,
      label = _ref.label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 50 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      variant = _ref.variant;

  if (!iconName && !imageSrc && !label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    colorBg: colorBg,
    colorBorder: colorBorder,
    color: color,
    hasShadow: hasShadow,
    variant: variant
  }),
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thImage = _themes$theme.thImage,
      thLabel = _themes$theme.thLabel,
      thLabelStyle = _themes$theme.thLabelStyle,
      thRoot = _themes$theme.thRoot;

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    style: styles
  }, !!imageSrc && __jsx("div", {
    className: thImage
  }, __jsx(Image["b" /* default */], {
    altMsg: alt,
    imageUrl: imageSrc,
    dimensions: imageSize
  })), !!iconName && __jsx("div", {
    className: thIcon
  }, __jsx(Icon["a" /* Icon */], {
    alt: alt,
    name: iconName,
    width: iconSize || thIconSize
  })), !!label && __jsx("div", {
    className: thLabel,
    style: thLabelStyle
  }, label));
};

/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdults; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ }),

/***/ "VO9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Notification_Notification; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.themes.js










function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var Notification_themes_defaultTheme = function defaultTheme(_ref) {
  var color = _ref.color,
      colorBg = _ref.colorBg,
      hasBorder = _ref.hasBorder,
      hasShadow = _ref.hasShadow,
      isCollapsed = _ref.isCollapsed,
      isStacked = _ref.isStacked;
  return {
    thRoot: classnames_default()("bg-".concat(colorBg, " flex p-px10 relative rounded-tiny text-").concat(color), {
      'items-center': !isStacked && !isCollapsed,
      'flex-col items-center sm:items-start': isStacked,
      'border-1 border-current': hasBorder,
      'shadow-sm': hasShadow
    }),
    thInner: 'flex flex-col flex-1 items-center sm:flex-row',
    thIcon: 'rtl:pr-px10',
    thMessage: 'sm:flex-1 p-px10',
    thTitle: 'font-bold font-sans text-base text-current',
    thText: 'font-sans text-base',
    thTextTheme: 'text-sans-1',
    thSlot: 'max-w-full overflow-hidden p-px10',
    thCloseButton: 'absolute p-px10 rtl:right-0 top-0 z-1',
    thCloseButtonLabel: 'sr-only'
  };
};

var themes = function themes(theme) {
  return {
    "default": Notification_themes_defaultTheme(theme),
    custom: _objectSpread(_objectSpread({}, Notification_themes_defaultTheme(theme)), {}, {
      thSlot: 'max-w-full overflow-hidden pl-px text-base'
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/notification/Notification.jsx
var __jsx = react_default.a.createElement;







var Notification_Notification = function Notification(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      _ref$colorBg = _ref.colorBg,
      colorBg = _ref$colorBg === void 0 ? colors["a" /* COLORS */].WHITE : _ref$colorBg,
      dataTestId = _ref.dataTestId,
      hasBorder = _ref.hasBorder,
      hasClose = _ref.hasClose,
      hasShadow = _ref.hasShadow,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].LIGHTBULB : _ref$icon,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '1.875rem' : _ref$iconWidth,
      id = _ref.id,
      isCollapsed = _ref.isCollapsed,
      isStacked = _ref.isStacked,
      onClose = _ref.onClose,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;

  if (!title && !text && !react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes({
    color: color,
    colorBg: colorBg,
    hasBorder: hasBorder,
    hasShadow: hasShadow,
    isCollapsed: isCollapsed,
    isStacked: isStacked
  })[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thIcon = _themes$theme.thIcon,
      thInner = _themes$theme.thInner,
      thMessage = _themes$theme.thMessage,
      thRoot = _themes$theme.thRoot,
      thSlot = _themes$theme.thSlot,
      thText = _themes$theme.thText,
      thTextTheme = _themes$theme.thTextTheme,
      thTitle = _themes$theme.thTitle;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId,
    id: id
  }, !!icon && __jsx("div", {
    className: classnames_default()('leading-none', thIcon)
  }, __jsx(Icon["a" /* Icon */], {
    name: icon,
    width: iconWidth
  })), __jsx("div", {
    className: thInner
  }, (text || title) && __jsx("div", {
    className: thMessage
  }, !!title && !text && __jsx("p", {
    className: classnames_default()('m-0', thTitle)
  }, title), !!title && !!text && __jsx("h3", {
    className: classnames_default()('reset-heading', thTitle)
  }, title), __jsx(Text["a" /* Text */], {
    className: thText,
    text: text,
    theme: thTextTheme
  })), react["Children"].count(children) > 0 && __jsx("div", {
    className: thSlot
  }, children)), hasClose && __jsx("button", {
    className: classnames_default()('leading-none reset-button', thCloseButton),
    onClick: onClose,
    type: "button"
  }, !!closeLabel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeLabel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })));
};

/***/ }),

/***/ "VQ9C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useBlockInputDepartureDate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("uDfI");
/* harmony import */ var _client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rueY");
/* harmony import */ var _client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("05PS");




function useBlockInputDepartureDate() {
  var checkIfDepartureDateIsBookable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var departureDateIsBookable = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getDepartureDateBookable */ "j"]);
  var blockInputDepartureDate = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "e"])(_client_store_calendar_calendar_selector__WEBPACK_IMPORTED_MODULE_3__[/* getBlockInputDepartureDate */ "b"]);
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "d"])();

  var setBlockInputDepartureDate = function setBlockInputDepartureDate(value) {
    if (value !== blockInputDepartureDate) {
      dispatch(Object(_client_store_calendar_calendar_action__WEBPACK_IMPORTED_MODULE_2__[/* setCalendarBlockInputDepartureDate */ "f"])(value));
    }
  };

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    if (departureDateIsBookable) {
      setBlockInputDepartureDate(false);
    }
  }, [departureDateIsBookable]);
  return {
    blockInputDepartureDate: checkIfDepartureDateIsBookable && blockInputDepartureDate,
    departureDateIsBookable: departureDateIsBookable,
    setBlockInputDepartureDate: setBlockInputDepartureDate
  };
}

/***/ }),

/***/ "VUEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productMultimediaResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var productMultimediaResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_MULTIMEDIA */ "lb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "{\n      config {\n        common {\n          close\n          galleries {\n            gallery\n            openProductSlideShowGalleryAt\n            openSlideShowGallery\n            productGallery\n            productPictureItem\n            productNextPicture\n            productPreviousPicture\n          }\n          next\n          photoTitle\n          previous\n          socialPicturesTitle\n          videoTitle\n          video360Title\n        }\n      }\n      media(".concat(productArgs, ") {\n        photos {url}\n        videos {url thumbnailUrl}\n        videos360 {url thumbnailUrl}\n      }\n      resort(").concat(productArgs, "){\n        name\n      }\n      socialPictures(").concat(productArgs, ") {\n        userName\n        imageSmall\n        imageLarge\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_PRODUCT_MULTIMEDIA */ "lc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_2__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {
      return {};
    });
  }
};

/***/ }),

/***/ "VqLN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var isInteger = __webpack_require__("JYr1");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ "VqO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prebookingFormResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("CcNa");











function getPrebookingQuery(resortIds, appContext, props) {
  var productIdsAsString = JSON.stringify(resortIds);
  var message = props.stay.minAgeInformation;
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease,
      country = appContext.country;
  return "{\n    config {\n      memberSpace {\n        accessButtonLoggedin\n      }\n    }\n    success: pageByPageId(pageId: \"prebooking-form-success\") { url }\n    error: pageByPageId(pageId: \"prebooking-form-error\") { url }\n    civilities {\n      adult {\n        name: label\n        value: code\n      }\n    }\n    travelAgencies(countryCode: \"".concat(country, "\" agencyTypes: [CLUBMED, FRANCHISE]) {\n      id\n      name\n      address {\n        city\n      }\n    }\n    bookingsCriteria(resortIds: ").concat(productIdsAsString, ") {\n      durations\n      departureCities {\n        value\n        name\n      }\n    }\n    resorts(resortIds: ").concat(productIdsAsString, ") {\n      id\n      name\n      destination {\n        country\n      }\n      accommodations {\n        id\n        label\n        categories {\n          id\n          label\n        }\n      }\n      openingDates {\n        opening\n        closing\n      }\n      adultOnly\n      minAuthorizedAge {\n        formattedValue(message: \"").concat(message, "\" content: \"").concat(cmsContent, "\" release: \"").concat(cmsRelease, "\")\n        value\n      }\n    }\n    accommodationCategories(productIds: ").concat(productIdsAsString, ") {\n      productId\n      accommodations {\n        id\n        label\n        ranking\n      }\n    }\n    legalInformations {\n      newsletterOptins {\n        id\n        title\n        description\n      }\n    }\n  }");
}

var prebookingFormResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_7__[/* PREBOOKING_FORM */ "H"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee(appContext, props) {
      var resortsQuery, products, _yield$graphQLClient$, resorts, productIds, prebookingProductIds, prebookingQuery;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resortsQuery = "{\n      resorts {\n        id\n      }\n    }";
              products = props.products;
              _context.next = 4;
              return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runQuery(resortsQuery, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_RESORTS */ "ab"],
                strictErrors: false
              });

            case 4:
              _yield$graphQLClient$ = _context.sent;
              resorts = _yield$graphQLClient$.resorts;
              productIds = products.map(function (_ref) {
                var productId = _ref.productId;
                return productId;
              });
              prebookingProductIds = resorts.filter(function (_ref2) {
                var id = _ref2.id;
                return productIds.includes(id);
              }).map(function (_ref3) {
                var id = _ref3.id;
                return id;
              });
              prebookingQuery = getPrebookingQuery(prebookingProductIds, appContext, props);
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].runQuery(prebookingQuery, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_9__[/* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_DATA */ "Z"],
                strictErrors: false
              }));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "VrMI":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("mwRp");
var IndexedObject = __webpack_require__("F9U4");
var toObject = __webpack_require__("A+R+");
var toLength = __webpack_require__("DOIJ");
var arraySpeciesCreate = __webpack_require__("kjCq");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "VtPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INITIAL_MONTH; });
/* unused harmony export calendarQuery */
/* unused harmony export bookableDatesQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return queryFetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return queryFetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDefaultSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPricesByDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getClosingDatesRanges; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("nv//");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ldK3");














var NO_TRANSPORT_VALUE = 'NO';
var DATE_FORMAT = 'YYYYMM';
var INITIAL_MONTH = 0;
function calendarQuery(args) {
  var resortId = args.resortId,
      duration = args.duration,
      departureCity = args.departureCity,
      urgentisationRate = args.urgentisationRate;
  return "\n      calendar(resortId: \"".concat(resortId, "\", duration: \"").concat(duration, "\", departureCity: \"").concat(departureCity, "\") {\n        basePrice {\n          currency\n          bestPrice {\n            value\n            currency\n            formattedValue\n          }\n          initialPrice {\n            value\n            currency\n            formattedValue\n          }\n          unit\n        }\n        blocks {\n          hasPrice\n          id\n          name\n          price {\n            value\n            currency\n            formattedValue\n          }\n          shortName\n          year\n        }\n        firstAvailableMonthIndex\n        months {\n          id\n          days {\n            dayContent {\n              arrivalDate\n              availability\n              canGoToBooking\n              id\n              isCurrentMonth\n              name\n              number\n              offer(urgentisationRate: ").concat(urgentisationRate, ")\n              shortName\n              siblingId\n            }\n            priceConfig {\n              bestPrice(forceAdultPerTrip: true) { value formattedValue }\n              currency\n              initialPrice(forceAdultPerTrip: true) { value formattedValue }\n              isBestPriceMonth\n              termsAndConditions {\n                accommodationComfortLabel\n                departureCity {\n                  value\n                  name\n                }\n                departureDate\n                duration\n                numberOfAdults\n              }\n              rawUnit\n              unit\n            }\n          }\n        }\n        weekDays\n      }\n    ");
}
function bookableDatesQuery(_ref) {
  var departureCity = _ref.departureCity,
      departureDate = _ref.departureDate,
      lastDate = _ref.lastDate,
      productId = _ref.productId;
  return "\n    bookableDates(productId: \"".concat(productId, "\", departureDate: \"").concat(departureDate, "\", lastDate: \"").concat(lastDate, "\", departureCity: \"").concat(departureCity, "\") {\n      months {\n        id\n        days {\n          id\n          availabilities {\n            status\n            durations\n          }\n        }\n      }\n    }\n  ");
}
function queryFetchCalendar(appContext, options) {
  var locale = appContext.locale;
  var _options$resortId = options.resortId,
      resortId = _options$resortId === void 0 ? '' : _options$resortId,
      _options$transport = options.transport,
      transport = _options$transport === void 0 ? '' : _options$transport,
      duration = options.duration,
      urgentisationRate = options.urgentisationRate;
  var calendarQueryArgs = {
    locale: locale,
    resortId: resortId,
    departureCity: transport || NO_TRANSPORT_VALUE,
    duration: duration,
    urgentisationRate: urgentisationRate
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(calendarQuery(calendarQueryArgs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_CALENDAR */ "yd"]
  }).then(function (_ref2) {
    var calendar = _ref2.calendar;
    return {
      calendar: calendar
    };
  });
}
function queryFetchBookableDates(appContext, options) {
  var _options$productId = options.productId,
      productId = _options$productId === void 0 ? '' : _options$productId,
      _options$departureDat = options.departureDate,
      departureDate = _options$departureDat === void 0 ? '' : _options$departureDat,
      _options$departureCit = options.departureCity,
      departureCity = _options$departureCit === void 0 ? '' : _options$departureCit,
      _options$lastDate = options.lastDate,
      lastDate = _options$lastDate === void 0 ? '' : _options$lastDate;
  var bookableDatesQueryArs = {
    productId: productId,
    departureDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* timestampToApiDate */ "l"])(departureDate || '') || '',
    lastDate: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* timestampToApiDate */ "l"])(lastDate || '') || '',
    departureCity: departureCity
  };
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].runQuery("query {".concat(bookableDatesQuery(bookableDatesQueryArs), "}"), appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_10__[/* STATE_PRODUCT_BOOKABLE_DATES */ "xd"]
  }).then(function (_ref3) {
    var bookableDates = _ref3.bookableDates;
    return {
      bookableDates: bookableDates
    };
  });
}
function getDefaultSelectedMonth() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var momentDate = value ? moment__WEBPACK_IMPORTED_MODULE_7___default()(value, format) : moment__WEBPACK_IMPORTED_MODULE_7___default()();
  return parseInt(momentDate.format(DATE_FORMAT), 10);
}
function getSelectedMonth(calendar, previousSelectedMonth) {
  var _calendar$months; // The query date param prevails


  var dateQueryParam = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_12__[/* getSpecificQueryParam */ "j"])(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_11__[/* QUERY_DEPARTURE_DATE */ "f"]);

  if (dateQueryParam) {
    return getDefaultSelectedMonth(dateQueryParam);
  }

  var firstCalendarMonth = ((_calendar$months = calendar.months) === null || _calendar$months === void 0 ? void 0 : _calendar$months[0].id) || getDefaultSelectedMonth();
  var firstAvailableMonthIndex = calendar.firstAvailableMonthIndex || INITIAL_MONTH;
  var firstAvailableMonth = parseInt(moment__WEBPACK_IMPORTED_MODULE_7___default()(firstCalendarMonth, DATE_FORMAT).add(firstAvailableMonthIndex, 'months').format(DATE_FORMAT), 10); // The previously selected month remains selected unless the first available dates are later

  if (previousSelectedMonth > firstAvailableMonth) {
    return previousSelectedMonth;
  }

  return firstAvailableMonth;
}
function getPricesByDays(calendar) {
  var prices = {};

  if (calendar.months) {
    calendar.months.forEach(function (_ref4) {
      var days = _ref4.days;

      if (days) {
        days.forEach(function (_ref5) {
          var _priceConfig$termsAnd, _priceConfig$termsAnd2;

          var dayContent = _ref5.dayContent,
              priceConfig = _ref5.priceConfig;

          var _ref6 = dayContent || {},
              availability = _ref6.availability,
              id = _ref6.id,
              offer = _ref6.offer,
              siblingId = _ref6.siblingId;

          var isBestPrice = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.isBestPriceMonth;
          var unit = priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.unit;
          var departureCityValue = (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd === void 0 ? void 0 : (_priceConfig$termsAnd2 = _priceConfig$termsAnd.departureCity) === null || _priceConfig$termsAnd2 === void 0 ? void 0 : _priceConfig$termsAnd2.value) || NO_TRANSPORT_VALUE;

          if (id) {
            var _priceConfig$termsAnd3, _priceConfig$termsAnd4, _priceConfig$initialP, _priceConfig$bestPric, _priceConfig$bestPric2;

            var available = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_OPEN */ "g"];
            var closed = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_CLOSED */ "a"];
            var exclusivity = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_EXCLUSIVITY */ "b"];
            var full = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_FULL */ "c"];
            var lastAvailability = offer === 'urgentisation';
            var noAvailability = availability === '';
            var noDeparture = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_DEPARTURE */ "e"];
            var noFlight = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_NO_FLIGHT */ "f"];
            var siblingOpen = availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_SUMMER */ "h"] || availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_8__[/* API_SIBLING_WINTER */ "i"];
            prices[id] = {
              availability: availability,
              available: available,
              closed: closed,
              currency: priceConfig === null || priceConfig === void 0 ? void 0 : priceConfig.currency,
              departureCity: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$termsAnd3 = priceConfig.termsAndConditions) === null || _priceConfig$termsAnd3 === void 0 ? void 0 : (_priceConfig$termsAnd4 = _priceConfig$termsAnd3.departureCity) === null || _priceConfig$termsAnd4 === void 0 ? void 0 : _priceConfig$termsAnd4.name) || '',
              exclusivity: exclusivity,
              full: full,
              hasTransport: departureCityValue !== NO_TRANSPORT_VALUE,
              isBestPrice: isBestPrice,
              lastAvailability: lastAvailability,
              noAvailability: noAvailability,
              noDeparture: noDeparture,
              noFlight: noFlight,
              oldPrice: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$initialP = priceConfig.initialPrice) === null || _priceConfig$initialP === void 0 ? void 0 : _priceConfig$initialP.formattedValue) || null,
              price: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric = priceConfig.bestPrice) === null || _priceConfig$bestPric === void 0 ? void 0 : _priceConfig$bestPric.formattedValue) || null,
              priceValue: (priceConfig === null || priceConfig === void 0 ? void 0 : (_priceConfig$bestPric2 = priceConfig.bestPrice) === null || _priceConfig$bestPric2 === void 0 ? void 0 : _priceConfig$bestPric2.value) || null,
              siblingId: siblingId,
              siblingOpen: siblingOpen,
              unit: unit
            };
          }
        });
      }
    });
  }

  return prices;
}
var getClosingDatesRanges = function getClosingDatesRanges(openingDatesRanges) {
  return openingDatesRanges.sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  }).map(function (openingDate, index, openingDates) {
    var _openingDates;

    return {
      after: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "h"])(openingDate.closing).toDate(),
      before: Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_13__[/* momentFromApiDate */ "h"])(((_openingDates = openingDates[index + 1]) === null || _openingDates === void 0 ? void 0 : _openingDates.opening) || openingDates[0].opening).toDate()
    };
  });
};

/***/ }),

/***/ "W+NJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputButton_InputButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.themes.js










function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var InputButton_themes_defaultTheme = function defaultTheme(_ref) {
  var _classnames;

  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].SUCCESS : _ref$color,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading;
  return {
    thRoot: classnames_default()('border-1 flex items-stretch rounded-tiny text-base transition-colors', (_classnames = {
      'bg-white border-gray-light text-gray-darker focus-within:border-blue hover:border-blue focus-within:text-blue hover:text-blue': !isActive && !isFilled && !isDisabled,
      'bg-white border-blue text-blue': isActive && !isFilled && !isDisabled
    }, Object(defineProperty["a" /* default */])(_classnames, "bg-white border-".concat(color, " text-gray-darker"), isFilled && !isDisabled), Object(defineProperty["a" /* default */])(_classnames, 'bg-gray-lighter border-gray-light text-gray-medium', isDisabled), Object(defineProperty["a" /* default */])(_classnames, 'pointer-events-none', isLoading), _classnames)),
    thHeightStyle: {
      minHeight: '3.125rem',
      // IE11 needs a height in addition to minHeight to center vertically.
      height: '1px'
    },
    thButton: 'reset-button flex items-center flex-1 justify-center overflow-hidden text-current text-initial',
    thIcon: classnames_default()('flex-shrink-0 lg:mx-px10', Object(defineProperty["a" /* default */])({
      'text-blue': isActive && !isFilled && !isDisabled
    }, "text-".concat(color), isFilled && !isDisabled)),
    thIconSize: '1.125rem',
    thLoader: 'px-px10 flex-shrink-0',
    thSpinnerColor: isFilled ? 'current' : 'blue',
    thIconSelect: classnames_default()('hidden lg:inline-block md:flex-shrink-0 mx-px10 transition-transform', {
      'rotate-180': isActive && !isDisabled
    }),
    thClear: 'reset-button px-px10 flex-shrink-0 text-current',
    thClearSize: '0.625rem',
    thSwitchButton: 'flex items-center reset-button',
    thSwitch: classnames_default()('bg-current border-1 border-current hidden lg:flex leading-none mx-px10 overflow-hidden rounded-tiny transition-all', {
      'text-gray-light': !isFilled,
      'text-success': isFilled
    }),
    thSwitchStyle: {
      width: 40,
      height: 20
    },
    thSwitchToggler: classnames_default()('bg-white flex font-bold items-center justify-center leading-none rounded-tiny text-center text-xs transition-all w-1/2', {
      'text-success rtl:translate-x-100': isFilled,
      'text-gray-light': !isFilled
    })
  };
};

var InputButton_themes_themes = function themes(props) {
  var _classnames4;

  var d = InputButton_themes_defaultTheme(props);
  return {
    "default": d,
    calendar: _objectSpread(_objectSpread({}, d), {}, {
      thIcon: classnames_default()('flex-shrink-0 mx-px10', Object(defineProperty["a" /* default */])({
        'text-blue': props.isActive && !props.isFilled && !props.isDisabled
      }, "text-".concat(props.color), props.isFilled && !props.isDisabled)),
      thIconSelect: classnames_default()('inline-block mx-px10 transition-transform', {
        'rotate-180': props.isActive && !props.isDisabled
      }),
      thSwitch: classnames_default()('bg-current border-1 border-current flex leading-none mx-px10 overflow-hidden rounded-tiny transition-all', {
        'text-gray-light': !props.isFilled,
        'text-success': props.isFilled
      })
    }),
    filter: _objectSpread(_objectSpread({}, d), {}, {
      thRoot: classnames_default()('border-1 flex items-stretch rounded-tiny text-base transition-colors', (_classnames4 = {
        'bg-white text-gray-darker': !props.isDisabled
      }, Object(defineProperty["a" /* default */])(_classnames4, "border-gray-light focus-within:border-".concat(props.color, " hover:border-").concat(props.color), !props.isActive && !props.isFilled && !props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, "border-".concat(props.color), props.isActive && !props.isFilled && !props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, 'border-success', props.isFilled && !props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, 'bg-gray-lighter border-gray-light pointer-events-none text-gray-medium', props.isDisabled), Object(defineProperty["a" /* default */])(_classnames4, 'pointer-events-none', props.isLoading), _classnames4)),
      thButton: 'reset-button flex items-center flex-1 justify-between overflow-hidden text-current text-initial',
      thHeightStyle: _objectSpread(_objectSpread({}, d.thHeightStyle), {}, {
        minHeight: '2.5rem'
      }),
      thIconSelect: classnames_default()('inline-block md:flex-shrink-0 mx-px10 transition-transform', {
        'rotate-180': props.isActive && !props.isDisabled
      })
    }),
    remote: _objectSpread(_objectSpread({}, d), {}, {
      thHeightStyle: _objectSpread(_objectSpread({}, d.thHeightStyle), {}, {
        minHeight: '3.625rem'
      })
    })
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-button/InputButton.jsx
var __jsx = react_default.a.createElement;






var InputButton_InputButton = function InputButton(_ref) {
  var children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      _ref$hasSwitch = _ref.hasSwitch,
      hasSwitch = _ref$hasSwitch === void 0 ? false : _ref$hasSwitch,
      iconName = _ref.iconName,
      isActive = _ref.isActive,
      isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLoading = _ref.isLoading,
      onClear = _ref.onClear,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var _themes$theme = InputButton_themes_themes({
    color: color,
    isActive: isActive,
    isDisabled: isDisabled,
    isFilled: isFilled,
    isLoading: isLoading
  })[theme],
      thButton = _themes$theme.thButton,
      thClear = _themes$theme.thClear,
      thClearSize = _themes$theme.thClearSize,
      thHeightStyle = _themes$theme.thHeightStyle,
      thIcon = _themes$theme.thIcon,
      thIconSelect = _themes$theme.thIconSelect,
      thIconSize = _themes$theme.thIconSize,
      thLoader = _themes$theme.thLoader,
      thRoot = _themes$theme.thRoot,
      thSpinnerColor = _themes$theme.thSpinnerColor,
      thSwitch = _themes$theme.thSwitch,
      thSwitchButton = _themes$theme.thSwitchButton,
      thSwitchStyle = _themes$theme.thSwitchStyle,
      thSwitchToggler = _themes$theme.thSwitchToggler;

  if (!iconName && !children) {
    return null;
  }

  var hasClear = onClear && !isLoading && !isDisabled && isFilled;
  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("button", {
    className: thButton,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: onClick,
    style: thHeightStyle,
    title: title,
    type: "button"
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    color: "none",
    name: iconName,
    width: thIconSize
  }), children, !hasClear && !hasSwitch && !isLoading && __jsx(Icon["a" /* Icon */], {
    className: thIconSelect,
    name: icons["a" /* ICONS */].SELECT,
    width: ".625rem"
  }), isLoading && __jsx(Spinner["a" /* Spinner */], {
    className: thLoader,
    color: thSpinnerColor,
    size: "small"
  })), !hasSwitch && hasClear && __jsx("button", {
    "data-testid": "InputButtonClear",
    className: thClear,
    disabled: isDisabled,
    onClick: onClear,
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearSize
  })), hasSwitch && __jsx("button", {
    className: thSwitchButton,
    "data-testid": "InputButtonClear",
    onClick: hasClear ? onClear : onClick,
    type: "button"
  }, __jsx("span", {
    className: thSwitch,
    style: thSwitchStyle
  }, __jsx("span", {
    "aria-hidden": true,
    className: thSwitchToggler
  }, isFilled ? '|' : 'O'))));
};

/***/ }),

/***/ "WSQK":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "WUtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productRestaurantsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productRestaurantsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_RESTAURANTS */ "pb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      restaurants(".concat(productArgs, "){\n        introduction { description }\n        restaurantsList { name images description }\n      }\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_RESTAURANTS */ "tc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "Wb8K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerSEOResolver; });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");






function generateOfferTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var offerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["messageFormat"])(title).format({
    offerName: offerName
  });
}

var offerSEOResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* OFFER_SEO */ "F"],
  props: function props() {
    return {
      title: function title(props) {
        return generateOfferTitle(props.title || Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(props, 'config.offer.seo.title'), Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(props, 'offer.name'));
      },
      meta: function meta(props) {
        return Object(lodash__WEBPACK_IMPORTED_MODULE_0__["get"])(props, 'offer.htmlHeader.meta', []);
      }
    };
  },
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var offerId = props.offerId;
    var query = "{\n      config {\n        offer {\n          seo {\n            title\n          }\n        }\n      }\n      offer(offerId: \"".concat(offerId, "\") {\n        name\n        htmlHeader {\n          meta {\n            name\n            content\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_OFFER_SEO */ "Sb"]
    })["catch"](function () {
      return {
        offer: null
      };
    });
  }
};

/***/ }),

/***/ "X95k":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("M4Qz");
var enumBugKeys = __webpack_require__("WSQK");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "XL2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BaiduSeoScript_BaiduSeoScript; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/media-server/index.js
var media_server = __webpack_require__("FLQK");

// CONCATENATED MODULE: ./src/seo/json-ld/index.js



function getBaiduStructuredPageData(title, description, imageUrls, pageUrl) {
  return {
    '@context': 'https://zhanzhang.baidu.com/contexts/cambrian.jsonld',
    '@id': pageUrl,
    title: title,
    description: description,
    images: imageUrls.map(function (url) {
      return media_server["a" /* getUrl */]({
        format: '_AUTOFORMAT_',
        url: url,
        width: 2000,
        height: 'auto',
        transform: 'resize',
        quality: 70
      });
    }),
    pubDate: moment_default()() // Set to the beginning of the current quarter,
    // 1st day of months, 12:00 am
    .startOf('quarter').format('YYYY-MM-DDThh:mm:ss')
  };
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/seo/sitemap/sitemap.utils.js


















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var SITEMAP_URL_CHANGE_FREQUENCY = 'weekly';
var SITEMAP_URL_PRIORITY = 0.5;
var XML_NAMESPACES = ['xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"', 'xmlns:xhtml="http://www.w3.org/1999/xhtml"'];
function isBaiduBot() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // Detects Baidu’s web crawler via the user agent string.
  // e.g. "Mozilla/5.0 (compatible; Baiduspider/2.0; +http://www.baidu.com/search/spider.html)"

  return new RegExp('Baiduspider', 'ig').test(userAgent);
}
function getXmlNamespaces(userAgent) {
  var xmlNamespaces = isBaiduBot(userAgent) ? [].concat(XML_NAMESPACES, ['xmlns:mobile="http://www.baidu.com/schemas/sitemap-mobile/1/"']) : XML_NAMESPACES;
  return xmlNamespaces.join(' ');
}
function getPageUrls(_x, _x2) {
  return _getPageUrls.apply(this, arguments);
}

function _getPageUrls() {
  _getPageUrls = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(pageTypes, _ref) {
    var appContext, pageTypesString, pagesQuery, _yield$graphQLClient$, pages;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            appContext = _ref.appContext;
            pageTypesString = pageTypes.map(function (pageType) {
              return "\"".concat(pageType, "\"");
            }).join(',');
            pagesQuery = "{\n    pages: pagesByTypes(pageTypes: [".concat(pageTypesString, "]) {\n      href: url\n      hrefLang {\n        locale\n        url\n      }\n    }\n  }");
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runQuery(pagesQuery, appContext, {
              requestName: requestDictionary["Oc" /* PAGE_SITEMAP */]
            });

          case 6:
            _yield$graphQLClient$ = _context.sent;
            pages = _yield$graphQLClient$.pages;
            return _context.abrupt("return", pages);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            logger_default.a.error(_context.t0);
            return _context.abrupt("return", []);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _getPageUrls.apply(this, arguments);
}

function getPageEntries(dataEntries, _ref2) {
  var appContext = _ref2.appContext,
      userAgent = _ref2.userAgent;
  var locale = appContext.locale,
      originalUrl = appContext.originalUrl;
  var uri = new URI_default.a(originalUrl);
  var hostname = uri.hostname();
  var tld = uri.tld();
  var isDomainDefaultLocale = dist_default.a.getLocaleFromHostname(tld) === locale;
  return dataEntries.map(function (entry) {
    var href = entry.href,
        hrefLang = entry.hrefLang; // Build full entry url

    var entryUri = new URI_default.a(href).protocol('https').hostname(hostname).tld(tld);
    if (!isDomainDefaultLocale) entryUri.addQuery({
      locale: locale
    });
    var url = entryUri.toString(); // Build localized links

    var links = hrefLang.map(function (link) {
      return {
        lang: link.locale,
        url: link.url
      };
    }); // Build complete entry

    return _objectSpread(_objectSpread({
      url: url,
      changefreq: SITEMAP_URL_CHANGE_FREQUENCY,
      priority: SITEMAP_URL_PRIORITY
    }, links.length > 0 && {
      links: links
    }), isBaiduBot(userAgent) && {
      mobile: 'pc mobile'
    });
  });
}
// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// CONCATENATED MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx






var __jsx = react_default.a.createElement;




var BaiduSeoScript_BaiduSeoScript = function BaiduSeoScript(_ref) {
  var lines = _ref.lines,
      locale = _ref.locale,
      userAgent = _ref.userAgent,
      originalUrl = _ref.originalUrl,
      pageTitle = _ref.pageTitle,
      pageDescription = _ref.pageDescription;

  var getImmersives = function getImmersives(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media;

      immersives = line.name === 'immersive' ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), [line.props.backgroundURL]) : immersives;
      immersives = line.name === 'product-immersive' ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), Object(toConsumableArray["a" /* default */])((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos.map(function (p) {
        return p.url;
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives;
  };

  return isBaiduBot(userAgent) && Object(localeUtils["a" /* isChineseLocale */])(locale) && __jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(getBaiduStructuredPageData(pageTitle, pageDescription, getImmersives(lines), originalUrl))
    }
  });
};

/***/ }),

/***/ "XTOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_Product; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// CONCATENATED MODULE: ./src/client/components/widgets/offer-discount/OfferDiscount.jsx
var __jsx = react_default.a.createElement;



var OfferDiscount_OfferDiscount = function OfferDiscount(_ref) {
  var className = _ref.className,
      _ref$discount = _ref.discount,
      discount = _ref$discount === void 0 ? {} : _ref$discount,
      _ref$i18n = _ref.i18n,
      i18n = _ref$i18n === void 0 ? {} : _ref$i18n;
  var offerName = (discount === null || discount === void 0 ? void 0 : discount.offerName) || i18n.defaultLabel || '';
  var backgroundColor = (discount === null || discount === void 0 ? void 0 : discount.offerColor) || i18n.defaultColor || null;
  return Object(lodash["get"])(discount, 'amount.value') ? __jsx("div", {
    className: classnames_default()(className, 'bg-current font-bold p-px5 text-center text-sm uppercase'),
    style: {
      backgroundColor: backgroundColor
    }
  }, __jsx("span", {
    className: "text-white"
  }, offerName)) : null;
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/Availability.jsx
var Availability_jsx = react_default.a.createElement;




var computeAvailabilityStatus = function computeAvailabilityStatus(_ref) {
  var availability = _ref.availability,
      remainingStock = _ref.remainingStock;

  switch (true) {
    case availability === 'UNAVAILABLE':
    case availability === 'AVAILABLE' && remainingStock === 0:
      return 'unavailable';

    case availability === 'AVAILABLE' && remainingStock !== null && +remainingStock < 10:
    case availability === 'PARTIAL':
      return 'remaining';

    case availability === 'AVAILABLE':
      return 'available';

    default:
      return 'unknown';
  }
};

var Availability_Availability = function Availability(_ref2) {
  var availability = _ref2.availability,
      config = _ref2.config,
      remainingStock = _ref2.remainingStock;
  var availabilityStatus = computeAvailabilityStatus({
    availability: availability,
    remainingStock: remainingStock
  });

  var _ref3 = config[availabilityStatus] || {},
      color = _ref3.color,
      icon = _ref3.icon,
      label = _ref3.label;

  return label ? Availability_jsx("span", {
    className: "flex flex-none flex-shrink items-center text-".concat(color, " rtl:text-right")
  }, icon && Availability_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    name: icon,
    width: "0.8rem"
  }), Object(dist["messageFormat"])(label).format({
    count: remainingStock
  })) : null;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/AvailabilityAge.jsx
var AvailabilityAge_jsx = react_default.a.createElement;



var shouldShowAgeInMonth = function shouldShowAgeInMonth(ageInNumberOfMonths) {
  return ageInNumberOfMonths <= 23;
};

var shouldShowAgeInYearsRange = function shouldShowAgeInYearsRange(ageMin, ageMax) {
  return !(Math.floor(ageMin / 12) === Math.floor(ageMax / 12));
};

var AvailabilityAge_AvailabilityAge = function AvailabilityAge(_ref) {
  var ageMax = _ref.ageMax,
      ageMin = _ref.ageMin,
      childcareLabel = _ref.childcareLabel,
      monthsLabel = _ref.monthsLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var message = '';

  if (shouldShowAgeInMonth(ageMax)) {
    message = Object(dist["messageFormat"])(monthsLabel).format({
      min: ageMin,
      max: ageMax
    });
  } else if (shouldShowAgeInYearsRange(ageMin, ageMax)) {
    message = Object(dist["messageFormat"])(yearsLabel).format({
      min: Math.floor(ageMin / 12),
      max: Math.floor(ageMax / 12)
    });
  } else {
    // Shows a single year age
    message = Object(dist["messageFormat"])(yearLabel).format({
      fixed: Math.floor(ageMin / 12)
    });
  }

  return AvailabilityAge_jsx(react["Fragment"], null, "".concat(childcareLabel, " "), AvailabilityAge_jsx("span", {
    className: "font-normal whitespace-no-wrap"
  }, "(", message, ")"));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product/product-childcare-availabilities/productChildcareAvailabilities.jsx

var productChildcareAvailabilities_jsx = react_default.a.createElement;







var productChildcareAvailabilities_ProductChildcareAvailabilities = function ProductChildcareAvailabilities(_ref) {
  var availableLabel = _ref.availableLabel,
      childcareLabel = _ref.childcareLabel,
      items = _ref.items,
      monthsLabel = _ref.monthsLabel,
      remainingLabel = _ref.remainingLabel,
      unavailableLabel = _ref.unavailableLabel,
      unknownLabel = _ref.unknownLabel,
      yearLabel = _ref.yearLabel,
      yearsLabel = _ref.yearsLabel;
  var renderConfig = {
    available: {
      color: colors["a" /* COLORS */].EMERALD,
      icon: icons["a" /* ICONS */].SMALL_CHECK,
      label: availableLabel
    },
    remaining: {
      color: colors["a" /* COLORS */].ORANGE,
      icon: icons["a" /* ICONS */].WARNING,
      label: remainingLabel
    },
    unavailable: {
      color: colors["a" /* COLORS */].RED,
      icon: icons["a" /* ICONS */].SMALL_CROSS,
      label: unavailableLabel
    },
    unknown: {
      color: colors["a" /* COLORS */].GRAY_MEDIUM,
      label: unknownLabel
    }
  };
  return productChildcareAvailabilities_jsx(react["Fragment"], null, items.map(function (_ref2) {
    var id = _ref2.id,
        ageMin = _ref2.ageMin,
        ageMax = _ref2.ageMax,
        availability = _ref2.availability,
        isIncluded = _ref2.isIncluded,
        remainingStock = _ref2.remainingStock;
    return productChildcareAvailabilities_jsx("p", {
      key: id,
      className: "flex font-bold items-start justify-between mt-px10 reset-paragraph text-base text-gray-darker"
    }, productChildcareAvailabilities_jsx("span", {
      className: "flex-1"
    }, productChildcareAvailabilities_jsx(AvailabilityAge_AvailabilityAge, {
      ageMax: ageMax,
      ageMin: ageMin,
      childcareLabel: childcareLabel,
      monthsLabel: monthsLabel,
      yearLabel: yearLabel,
      yearsLabel: yearsLabel
    }), productChildcareAvailabilities_jsx("span", {
      className: classnames_default()('font-brand font-normal ml-px5 text-sm', {
        'text-blue': isIncluded,
        'text-red': !isIncluded
      })
    }, isIncluded ? Object(src_i18n["h" /* t */])('common.included') : Object(src_i18n["h" /* t */])('common.onDemand'))), productChildcareAvailabilities_jsx(Availability_Availability, {
      availability: availability,
      config: renderConfig,
      remainingStock: remainingStock
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-comparison/ProductComparison.jsx

var ProductComparison_jsx = react_default.a.createElement;





var ProductComparison_ProductComparison = function ProductComparison(_ref) {
  var className = _ref.className,
      eligibilityLabel = _ref.eligibilityLabel,
      isEligible = _ref.isEligible,
      label = _ref.label,
      onComparisonClick = _ref.onComparisonClick,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? product_utils["b" /* IS_ENABLED */] : _ref$status;
  if (!isEligible) return ProductComparison_jsx("div", {
    className: "relative"
  }, ProductComparison_jsx("div", {
    className: "absolute bg-overlay-white-60 flex font-bold items-center justify-center inset-0 p-px20 text-base text-center z-1"
  }, eligibilityLabel));
  var isSelectable = status !== product_utils["a" /* IS_DISABLED */];
  var isSelected = status === product_utils["c" /* IS_SELECTED */];
  var buttonProps = isSelectable ? {
    onClick: onComparisonClick,
    type: 'button',
    title: label
  } : null;
  var TagName = isSelectable ? 'button' : 'div';
  return ProductComparison_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'absolute', 'z-1', 'inset-0', 'w-full', 'h-full', 'reset-button')
  }, buttonProps), ProductComparison_jsx("span", {
    className: classnames_default()('bg-overlay-gray-darker-40', 'flex', 'items-center', 'justify-center', 'p-px15', 'text-white', 'rounded-tiny', 'h-full', 'w-full', {
      'cursor-pointer': isSelectable
    })
  }, isSelectable && ProductComparison_jsx("span", {
    className: classnames_default()('flex', 'flex-col', 'items-center', 'opacity-100', 'p-px10', 'rounded-full', 'border-2', 'transition-colors', {
      'bg-transparent border-white': !isSelected
    }, {
      'bg-emerald border-emerald': isSelected
    })
  }, ProductComparison_jsx(Icon["a" /* Icon */], {
    name: isSelected ? icons["a" /* ICONS */].CHECK : icons["a" /* ICONS */].PLUS,
    width: "1.25rem"
  }))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/widgets/product/product-thumbnail/ProductThumbnail.jsx




var ProductThumbnail_jsx = react_default.a.createElement;










var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var ProductThumbnail_ProductThumbnail = /*#__PURE__*/Object(react["memo"])(function ProductThumbnail(_ref) {
  var closedLabel = _ref.closedLabel,
      className = _ref.className,
      hasBorder = _ref.hasBorder,
      hasTransport = _ref.hasTransport,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      nextLabel = _ref.nextLabel,
      openingStatus = _ref.openingStatus,
      openingSoonLabel = _ref.openingSoonLabel,
      _ref$pictures = _ref.pictures,
      pictures = _ref$pictures === void 0 ? [] : _ref$pictures,
      previousLabel = _ref.previousLabel,
      _ref$productTags = _ref.productTags,
      productTags = _ref$productTags === void 0 ? [] : _ref$productTags,
      _ref$tagsColor = _ref.tagsColor,
      tagsColor = _ref$tagsColor === void 0 ? colors["a" /* COLORS */].BLUE : _ref$tagsColor,
      _ref$tagsTextColor = _ref.tagsTextColor,
      tagsTextColor = _ref$tagsTextColor === void 0 ? colors["a" /* COLORS */].WHITE : _ref$tagsTextColor,
      transportLabel = _ref.transportLabel,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? icons["a" /* ICONS */].TRANSPORT : _ref$transportIcon,
      isSliderDisabled = _ref.isSliderDisabled,
      hasLazyLoading = _ref.hasLazyLoading;
  var TagName = isLinkDisabled ? 'div' : DynamicLink["a" /* default */];
  var defaultPicture = pictures[0] || {};
  return ProductThumbnail_jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()('block relative', className)
  }, isLinkDisabled ? null : link), !isSliderDisabled && pictures.length > 1 && openingStatus !== OPENING_STATUS.CLOSED ? ProductThumbnail_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasInsetBorder: hasBorder,
    hasLazyLoading: true,
    media: pictures,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["a" /* default */].XL,
    ratioDisplay: 1 / 3
  }) : ProductThumbnail_jsx(Image["b" /* default */], {
    altMsg: defaultPicture.alt,
    className: classnames_default()({
      'inset-border-after': hasBorder
    }),
    hasInsetBorder: hasBorder,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    groupKey: "thumbnails",
    ratioKey: ratios_utils["a" /* default */].XL,
    ratioDisplay: 1 / 3,
    hasLazyLoading: hasLazyLoading
  }), hasTransport && ProductThumbnail_jsx("div", {
    className: "bg-blue inline-flex items-center overflow-hidden p-px10 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-px20 rtl:mr-px20 rounded-tiny font-brand",
    "data-testid": "ProductThumbnail-transport"
  }, ProductThumbnail_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0 rtl:mr-px5",
    name: transportIcon,
    width: "calc(10rem / 16)"
  }), ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-transportLabel"
  }, transportLabel)), openingStatus === OPENING_STATUS.OPENING_SOON && ProductThumbnail_jsx("div", {
    className: "bg-orange inline-flex items-center overflow-hidden p-px10 text-xs text-white uppercase absolute top-0 rtl:right-0 mt-px20 rtl:mr-px20 rounded-tiny font-bold",
    "data-testid": "ProductThumbnail-openingSoon"
  }, ProductThumbnail_jsx("div", {
    className: "leading-tight text-xxs",
    "data-testid": "ProductThumbnail-openingSoonlabel"
  }, openingSoonLabel)), openingStatus === OPENING_STATUS.CLOSED && ProductThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 font-bold inline-flex items-center justify-center overflow-hidden inset-0 rounded-tiny text-white text-xl uppercase",
    "data-testid": "ProductThumbnail-closed"
  }, ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-closedLabel"
  }, closedLabel)), !!(productTags === null || productTags === void 0 ? void 0 : productTags.length) && ProductThumbnail_jsx("div", {
    "data-testid": "ProductThumbnail-bottomTags",
    className: classnames_default()('absolute flex leading-one font-brand uppercase left-1/2 bottom-0 rounded-tiny text-center text-xs -translate-x-50 whitespace-no-wrap max-w-9/10 truncate z-1')
  }, productTags.map(function (productTag, i) {
    return ProductThumbnail_jsx("div", {
      className: classnames_default()('p-px10 mb-px20 truncate', "bg-".concat(tagsColor, " text-").concat(tagsTextColor), {
        'rtl:ml-px10': i !== 0
      }),
      key: i
    }, productTag);
  })));
});
// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.jsx














var Product_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var Product_Product = function Product(_ref) {
  var _flag$price, _flag$price$bestPrice;

  var _ref$callToAction = _ref.callToAction,
      callToAction = _ref$callToAction === void 0 ? {} : _ref$callToAction,
      childcare = _ref.childcare,
      childcareIncluded = _ref.childcareIncluded,
      className = _ref.className,
      comfort = _ref.comfort,
      comparison = _ref.comparison,
      departureDateOn = _ref.departureDateOn,
      _ref$flag = _ref.flag,
      flag = _ref$flag === void 0 ? {} : _ref$flag,
      hasComparison = _ref.hasComparison,
      hasDiscount = _ref.hasDiscount,
      _ref$hasFadeIn = _ref.hasFadeIn,
      hasFadeIn = _ref$hasFadeIn === void 0 ? true : _ref$hasFadeIn,
      hasLazyLoading = _ref.hasLazyLoading,
      header = _ref.header,
      id = _ref.id,
      index = _ref.index,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      isLinkDisabled = _ref.isLinkDisabled,
      _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids,
      lineName = _ref.lineName,
      _ref$minAuthorizedAge = _ref.minAuthorizedAge,
      minAuthorizedAge = _ref$minAuthorizedAge === void 0 ? {} : _ref$minAuthorizedAge,
      offer = _ref.offer,
      offerDiscount = _ref.offerDiscount,
      onClick = _ref.onClick,
      onComparisonClick = _ref.onComparisonClick,
      thumbnail = _ref.thumbnail,
      url = _ref.url,
      _ref$cmtaLinks = _ref.cmtaLinks,
      cmtaLinks = _ref$cmtaLinks === void 0 ? {} : _ref$cmtaLinks;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var track = Object(useTracking["a" /* useTracking */])({});
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: typeof comfort === 'number' ? comfort : '',
    thumbnailPrice: (flag === null || flag === void 0 ? void 0 : (_flag$price = flag.price) === null || _flag$price === void 0 ? void 0 : (_flag$price$bestPrice = _flag$price.bestPrice) === null || _flag$price$bestPrice === void 0 ? void 0 : _flag$price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var linkShouldBeDisabled = isLinkDisabled || hasComparison;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  var minAuthorizedAgeMessage = (minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) === 0 ? Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcareFrom0') : Object(src_i18n["h" /* t */])('faceting.availabilities.noChildcare', {
    min_authorized_age_in_months: Math.floor((minAuthorizedAge === null || minAuthorizedAge === void 0 ? void 0 : minAuthorizedAge.value) / 12)
  });
  var childcareBirthdateAlert = (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && childcare && Object(lodash["isEmpty"])(childcare.items) && !childcareIncluded;
  var noChildcareAlert = kids && kids.length > 0 && kids.some(function (kid) {
    return !kid.birthdate;
  }) && childcareIncluded;
  return Product_jsx("article", {
    className: classnames_default()(className, 'relative', {
      fadeInLong: hasFadeIn
    }),
    onClick: onClick
  }, Product_jsx("div", {
    className: classnames_default()('relative', {
      flex: isCompact
    })
  }, Product_jsx("div", {
    "data-testid": "Product-Header-Wrapper",
    className: classnames_default()('relative', {
      'w-1/2 flex-shrink-0': isCompact
    })
  }, hasComparison && Product_jsx(ProductComparison_ProductComparison, Object(esm_extends["a" /* default */])({}, comparison, {
    onComparisonClick: onComparisonClick
  })), !!departureDateOn && Product_jsx("div", {
    className: "bg-white p-px10 z-2 absolute rtl:left-0 -mt-px20 rtl:ml-px10 rounded-tiny font-brand border-1 border-turquoise shadow-xs",
    "data-testid": "Product-departure"
  }, Product_jsx("div", {
    className: "leading-tight text-base text-black",
    "data-testid": "Product-departureLabel"
  }, departureDateOn)), hasDiscount && // $FlowFixMe
  Product_jsx(OfferDiscount_OfferDiscount, Object(esm_extends["a" /* default */])({}, offerDiscount, {
    className: "absolute opacity-75 inset-x-0 z-1"
  })), Product_jsx(ProductThumbnail_ProductThumbnail, Object(esm_extends["a" /* default */])({
    className: "rounded-tiny overflow-hidden"
  }, thumbnail, {
    hasLazyLoading: hasLazyLoading,
    isLinkDisabled: true,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous')
  }))), Product_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    className: classnames_default()({
      'pt-px20': !isCompact
    }),
    isCompact: isCompact,
    isLinkDisabled: linkShouldBeDisabled,
    link: appContext.isCmta && id && Object(Product_utils["d" /* localeHasCmtaLinks */])(cmtaLinks) ? Object(Product_utils["a" /* generateCmtaLinkProp */])(id, cmtaLinks) : Object(Product_utils["b" /* generateLinkProp */])(url, offer),
    onClick: function onClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    }
  }))), Product_jsx(ProductFlag["a" /* ProductFlag */], Object(esm_extends["a" /* default */])({}, flag, {
    isLinkDisabled: linkShouldBeDisabled,
    onClick: goOnResort,
    onCtaClick: function onCtaClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_discoverResort")
        }));
      }
    },
    onEmptyPriceClick: function onEmptyPriceClick() {
      if (clickThumbnailTrackingData) {
        track(clickThumbnailTrackingData);
      }
    },
    onPriceClick: function onPriceClick() {
      if (clickThumbnailTrackingData) {
        track(_objectSpread(_objectSpread({}, clickThumbnailTrackingData), {}, {
          labelGA: "".concat(id, "_bestPrice")
        }));
      }
    },
    price: flag.price
  })), childcareBirthdateAlert && Product_jsx("div", {
    className: "border-1 flex p-px10 rounded-tiny text-sm"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    color: colors["a" /* COLORS */].BLACK,
    name: icons["a" /* ICONS */].SMALL_WARNING,
    width: "1rem"
  }), minAuthorizedAgeMessage), noChildcareAlert && Product_jsx("button", {
    className: "bg-turquoise focus:bg-turquoise-active hover:bg-turquoise-active cursor-pointer font-bold leading-one p-px10 flex rounded-tiny text-initial text-sm text-white transition-colors",
    onClick: function onClick() {
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="CriteriaWho"]', 600);
    },
    type: "button"
  }, Product_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    name: icons["a" /* ICONS */].KIDS,
    width: "1rem"
  }), Object(src_i18n["h" /* t */])('faceting.availabilities.enterBirthdate')), !!(callToAction === null || callToAction === void 0 ? void 0 : callToAction.label) && Product_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, callToAction, {
    className: "mt-px10 w-full",
    colorBg: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    colorBorder: linkShouldBeDisabled ? colors["a" /* COLORS */].INFO : colors["a" /* COLORS */].BLUE,
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    isDisabled: linkShouldBeDisabled,
    onClick: goOnResort
  }), callToAction.label), Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('faceting.childcare') && childcare && !Object(lodash["isEmpty"])(childcare.items) && Product_jsx(productChildcareAvailabilities_ProductChildcareAvailabilities, childcare));
};

/***/ }),

/***/ "XiOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CriteriaContextProvider; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);








var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var initialState = {
  criteriaWhenIsSet: false,
  criteriaWhoIsSet: false,
  criteriaTransportIsSet: false,
  defaultValueForCalendar: null,
  isJoyview: false,
  layerButtonLabel: '',
  layerHeader: '',
  trackingActionName: '',
  setFacetHasSeeMore: function setFacetHasSeeMore() {}
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return _objectSpread(_objectSpread({}, state), action);
};

var CriteriaContext = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_8__["createContext"])([initialState, function () {}]);
var CriteriaContextProvider = function CriteriaContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_8__["useReducer"])(criteriaContextReducer, _objectSpread(_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return __jsx(CriteriaContext.Provider, {
    value: [state, dispatch]
  }, children);
};

/***/ }),

/***/ "XmKO":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var setPrototypeOf = __webpack_require__("iBXc");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "XygZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.anchor` method
// https://tc39.es/ecma262/#sec-string.prototype.anchor
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
  anchor: function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  }
});


/***/ }),

/***/ "XywU":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "Xzib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ PopOver_PopOver; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/click-outside/ClickOutside.jsx
var ClickOutside = __webpack_require__("EWLr");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.themes.js
var themes = {
  "default": {
    thTrigger: 'reset-button w-full',
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-px5',
    thContent: 'arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after mb-px20 rounded-tiny shadow-md',
    thCloseButton: 'absolute p-px5 reset-button rtl:right-0 text-gray-dark',
    thCloseIconWidth: '0.625rem'
  },
  infoBanner: {
    thTrigger: 'reset-button w-full',
    thContainer: 'absolute top-full fadeIn mt-px5 rounded-tiny',
    thContent: ' arrow-white bg-white',
    thCloseButton: 'absolute p-px5 reset-button rtl:right-0 text-gray-dark',
    thCloseIconWidth: '0.875rem'
  },
  fancy: {
    thTrigger: 'reset-button',
    thContainer: 'absolute bottom-full fadeIn inset-x-0 -mb-px5',
    thContent: 'arrow-bg arrow-bg-blue arrow-downLeft arrow-large arrow-white bg-white border-1 border-blue filter-drop-shadow-after mb-px20 rounded-tiny shadow-md',
    thCloseButton: 'absolute leading-none p-px10 reset-button rtl:right-0 top-0 text-gray-dark',
    thCloseIconWidth: '0.625rem'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx

var __jsx = react_default.a.createElement;









var PopOver_PopOver = function PopOver(_ref) {
  var ariaLabel = _ref.ariaLabel,
      children = _ref.children,
      className = _ref.className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? '' : _ref$contentClassName,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      containerStyle = _ref.containerStyle,
      content = _ref.content,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? false : _ref$hasCloseButton,
      _onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      triggerOnHover = _ref.triggerOnHover;

  var _useState = Object(react["useState"])(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thTrigger = _themes$theme.thTrigger,
      thContainer = _themes$theme.thContainer,
      thContent = _themes$theme.thContent,
      thCloseButton = _themes$theme.thCloseButton,
      thCloseIconWidth = _themes$theme.thCloseIconWidth;
  var shouldTriggerOnHover = triggerOnHover && isDesktop;
  return __jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'relative')
  }, shouldTriggerOnHover && {
    onMouseEnter: function onMouseEnter(e) {
      setIsVisible(true);
      _onClick && _onClick(e);
    },
    onMouseLeave: function onMouseLeave() {
      setIsVisible(false);
    }
  }), __jsx("button", {
    className: thTrigger,
    "data-testid": "PopOver-button",
    onClick: function onClick(e) {
      e.preventDefault();
      setIsVisible(!isVisible);
      !isVisible && _onClick && _onClick(e);
    },
    type: "button"
  }, children), isVisible && __jsx(react["Fragment"], null, isDesktop ? __jsx(ClickOutside["a" /* ClickOutside */], Object(esm_extends["a" /* default */])({
    className: classnames_default()(thContainer, containerClassName),
    onClick: function onClick() {
      return setIsVisible(false);
    }
  }, containerStyle ? {
    style: containerStyle
  } : {}), __jsx("div", {
    className: classnames_default()(thContent, contentClassName)
  }, hasCloseButton && __jsx("button", {
    className: thCloseButton,
    onClick: function onClick() {
      return setIsVisible(false);
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SMALL_CROSS,
    width: thCloseIconWidth
  })), content)) : __jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: function onClose(e) {
      e.preventDefault();
      setIsVisible(false);
    },
    size: "small"
  }, content)));
};

/***/ }),

/***/ "Y3fD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__("ERkP");
var factory = __webpack_require__("ttFy");

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ "Y8c0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var userAgent = __webpack_require__("xe/R");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "YKA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransportSummary; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("qBqs");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







var TransportSummary = function TransportSummary(_ref) {
  var departure = _ref.departure,
      _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      transportIcon = _ref.transportIcon;
  var noTransportIcon = _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].NO_TRANSPORT;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_3__[/* CRITERIA_SELECTORS */ "q"].TRANSPORT
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_6__[/* Icon */ "a"], {
    className: "PackagePriceSummary-icon",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].BLUE,
    hasRtl: true,
    name: departure ? transportIcon : noTransportIcon,
    width: "1.875rem"
  }), departure ? __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('common.transport.from'), ' ', __jsx("span", {
    className: "PackagePriceSummary-departure"
  }, departure)) : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('booking.priceDetails.packagePrice.noTransport'));
};

/***/ }),

/***/ "YQkA":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "YRNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AlternativeProposals; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.themes.js
var themes = {
  "default": {
    thRoot: 'w-full bg-white border-1 rounded-small shadow-sm relative',
    thHeightStyle: {
      minHeight: '3.125rem',
      // IE11 needs a height in addition to minHeight to center vertically.
      height: '1px'
    },
    thButton: 'flex flex-1 border-1 leading-none overflow-hidden rounded-small text-base bg-blue border-blue text-white items-center text-current text-initial lg:rtl:mr-px10 justify-center md:justify-between',
    thClear: 'reset-button px-px10 flex-shrink-0 text-current',
    thClearSize: '0.625rem',
    thIcon: 'flex-shrink-0 mx-px10',
    thLabel: 'flex-1 mx-px10 overflow-hidden flex items-center whitespace-no-wrap',
    thSubmitButton: 'reset-button bg-success cursor-pointer font-bold flex justify-center items-center leading-none rounded-small text-base text-white mt-px15 lg:mt-0 lg:flex-1 w-full lg:w-auto'
  }
};
// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product-banner/ProductBanner.jsx
var ProductBanner = __webpack_require__("SUcU");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// EXTERNAL MODULE: ./src/client/components/widgets/product-services/product-service/ProductService.jsx
var ProductService = __webpack_require__("9OZL");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-criteria-button/AlternativePriceCriteriaButton.jsx
var __jsx = react_default.a.createElement;




var AlternativePriceCriteriaButton_AlternativePriceCriteriaButton = function AlternativePriceCriteriaButton(_ref) {
  var children = _ref.children,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = themes[theme],
      thButton = _themes$theme.thButton,
      thHeightStyle = _themes$theme.thHeightStyle,
      thIcon = _themes$theme.thIcon,
      thLabel = _themes$theme.thLabel;
  return __jsx("button", {
    className: thButton,
    style: thHeightStyle,
    onClick: onClick
  }, __jsx(Icon["a" /* Icon */], {
    name: iconName,
    className: thIcon,
    width: "1em"
  }), __jsx("span", {
    className: classnames_default()('alternative-price-criteria-label', thLabel),
    style: thHeightStyle
  }, children));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/constants.js
var constants = __webpack_require__("393O");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/constants.js
var criteria_who_constants = __webpack_require__("PFSw");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/constants.js
var criteria_transport_constants = __webpack_require__("MX/n");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/constants.js
var ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD = 4;
var ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD = 2;
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price/AlternativePrice.jsx






var AlternativePrice_jsx = react_default.a.createElement;























var AlternativePrice_AlternativePrice = function AlternativePrice(_ref) {
  var proposals = _ref.proposals,
      resort = _ref.resort,
      _ref$searchCriteria = _ref.searchCriteria,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      duration = _ref$searchCriteria.duration,
      adultsCount = _ref$searchCriteria.adultsCount,
      kidsCount = _ref$searchCriteria.kidsCount,
      departureCity = _ref$searchCriteria.departureCity,
      departureCities = _ref.departureCities,
      seeOtherProposalsCallback = _ref.seeOtherProposalsCallback,
      onModify = _ref.onModify,
      bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      continueToBookingEngine = _ref.continueToBookingEngine,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      hasOtherProposals = _ref.hasOtherProposals;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var _proposals$ = proposals[0],
      price = _proposals$.price,
      allInclusiveServices = _proposals$.allInclusiveServices;

  if (!price) {
    return null;
  }

  var _themes$theme = themes[theme],
      thRoot = _themes$theme.thRoot,
      thSubmitButton = _themes$theme.thSubmitButton;
  var noTransport = departureCity === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  var openCriteriaWhenEvent = document.createEvent('Event');
  openCriteriaWhenEvent.initEvent(constants["a" /* OPEN_CRITERIA_WHEN_EVENT */], true, true);
  var openCriteriaWhoEvent = document.createEvent('Event');
  openCriteriaWhoEvent.initEvent(criteria_who_constants["a" /* OPEN_CRITERIA_WHO_EVENT */], true, true);
  var openCriteriaTransportEvent = document.createEvent('Event');
  openCriteriaTransportEvent.initEvent(criteria_transport_constants["a" /* OPEN_CRITERIA_TRANSPORT_EVENT */], true, true);

  var criteriaClickHandlerFactory = function criteriaClickHandlerFactory(event) {
    return function () {
      if (onModify) {
        onModify();
      }

      if (bookingEngineEntryPoint === booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE) {
        setTimeout(function () {
          document.dispatchEvent(event);
        }, 200);
      }
    };
  };

  var firstDay = moment_default()(arrivalDate);
  var city = departureCities.find(function (d) {
    return departureCity === d.value;
  });
  var bestPrice = price.bestPrice,
      total = price.total,
      currency = price.currency;
  var overflowThreshold = isDesktop ? ALL_INCLUSIVE_SERVICE_LIST_DESKTOP_OVERFLOW_THRESHOLD : ALL_INCLUSIVE_SERVICE_LIST_MOBILE_OVERFLOW_THRESHOLD;
  return AlternativePrice_jsx(react["Fragment"], null, hasOtherProposals ? AlternativePrice_jsx(Button["a" /* Button */], {
    color: isDesktop ? colors["a" /* COLORS */].WHITE : colors["a" /* COLORS */].TURQUOISE,
    colorBg: isDesktop ? colors["a" /* COLORS */].TURQUOISE : colors["a" /* COLORS */].GRAY_LIGHTER,
    colorBorder: isDesktop ? colors["a" /* COLORS */].TURQUOISE : colors["a" /* COLORS */].GRAY_LIGHTER,
    className: "lg:mt-px30 alternative-price-other-proposals-btn",
    onClick: seeOtherProposalsCallback,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'checkPriceKO',
      labelGA: 'seeOtherProposals'
    }
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.seeOtherProposalsButton')) : null, AlternativePrice_jsx("div", {
    className: classnames_default()('alternative-price-fake-remote-container', thRoot)
  }, AlternativePrice_jsx("div", {
    className: "p-px10 flex flex-col items-center"
  }, AlternativePrice_jsx("div", {
    className: "flex justify-between w-full"
  }, AlternativePrice_jsx(ProductBanner["a" /* ProductBanner */], {
    product: resort
  }), AlternativePrice_jsx("div", {
    className: "text-center w-full lg:w-auto lg:text-right lg:flex lg:items-center"
  }, AlternativePrice_jsx("div", {
    className: "hidden lg:flex lg:items-center"
  }, AlternativePrice_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "1.5rem"
  }), AlternativePrice_jsx("div", {
    className: "font-brand text-blue text-md rtl:ml-px10"
  }, Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.allInclusive'))), AlternativePrice_jsx(Price["a" /* Price */], {
    bestPrice: bestPrice,
    className: "inline-flex",
    currency: currency,
    hasInstalment: false,
    initialPrice: total,
    theme: "remote",
    unit: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  }))), AlternativePrice_jsx("div", {
    className: "search-criteria-container flex mt-px10 w-full flex-between flex-wrap lg:flex-no-wrap"
  }, AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].DATE,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhenEvent) : undefined
  }, "".concat(firstDay.format('DD MMM'), " - ").concat(firstDay.add(duration, 'd').format('DD MMM'))), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: icons["a" /* ICONS */].USERS,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaWhoEvent) : undefined
  }, Object(labelUtils["b" /* getAttendeesSummary */])({
    adultsCount: adultsCount,
    kidsCount: kidsCount
  })), AlternativePrice_jsx(AlternativePriceCriteriaButton_AlternativePriceCriteriaButton, {
    iconName: noTransport ? icons["a" /* ICONS */].NO_TRANSPORT : icons["a" /* ICONS */].TRANSPORT,
    onClick: onModify ? criteriaClickHandlerFactory(openCriteriaTransportEvent) : undefined
  }, city ? city.name : ''), AlternativePrice_jsx(Button["a" /* Button */], {
    style: {
      minWidth: 80,
      width: isDesktop ? 250 : '100%'
    },
    className: thSubmitButton,
    type: "submit",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'checkPriceKO',
      labelGA: 'rate_check'
    },
    colorBg: colors["a" /* COLORS */].SUCCESS,
    colorBorder: colors["a" /* COLORS */].SUCCESS,
    onClick: function onClick() {
      continueToBookingEngine();
    }
  }, Object(src_i18n["h" /* t */])('common.continue'))), onModify && AlternativePrice_jsx(Button["a" /* Button */], {
    iconLeft: {
      name: icons["a" /* ICONS */].PEN
    },
    color: colors["a" /* COLORS */].TURQUOISE,
    colorBg: colors["a" /* COLORS */].WHITE,
    className: "text-md underline",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'checkPriceKO',
      labelGA: 'rate_modify'
    },
    onClick: function onClick() {
      onModify();
    }
  }, Object(src_i18n["h" /* t */])('common.modify')), AlternativePrice_jsx("div", {
    className: "w-full px-px25"
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wrap proposal-services-container"
  }, allInclusiveServices.slice(0, overflowThreshold).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  })), allInclusiveServices.length > overflowThreshold && AlternativePrice_jsx(react["Fragment"], null, AlternativePrice_jsx(lib["Collapse"], {
    isOpened: isDetailOpened
  }, AlternativePrice_jsx("div", {
    className: "flex flex-wrap proposal-services-container"
  }, allInclusiveServices.slice(overflowThreshold, allInclusiveServices.length).map(function (service) {
    return AlternativePrice_jsx(ProductService["a" /* ProductService */], {
      service: service,
      className: "w-full lg:w-1/2",
      key: service.label
    });
  }))), !isDetailOpened ? AlternativePrice_jsx("div", {
    className: "proposal-services-container__overlay w-full"
  }) : null))), allInclusiveServices.length > overflowThreshold && AlternativePrice_jsx("div", {
    className: "flex items-center justify-center absolute left-1/2 -translate-x-50"
  }, AlternativePrice_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-blue text-sm underline",
    height: 30,
    onClick: function onClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    orientation: "bottom"
  }, AlternativePrice_jsx("div", {
    className: "flex items-center text-base"
  }, !isDetailOpened ? Object(src_i18n["h" /* t */])('priceRemote.openAllInclusiveDetails') : Object(src_i18n["h" /* t */])('priceRemote.closeAllInclusiveDetails'), AlternativePrice_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-blue rtl:ml-px10 transition-transform', Object(defineProperty["a" /* default */])({}, 'rotate-180', isDetailOpened)),
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    width: "0.625rem"
  }))))));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsUtils.js
var AlternativeProposalsUtils = __webpack_require__("/nu6");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionHeader.jsx

var AlternativeDateSuggestionHeader_jsx = react_default.a.createElement;









var AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader = function AlternativeDateSuggestionHeader(props) {
  var arrivalDate = props.arrivalDate,
      duration = props.duration,
      resort = props.resort;
  var getFormattedDateTitle = Object(dateUtils["a" /* formatDate */])('DD/MM');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return AlternativeDateSuggestionHeader_jsx("div", {
    className: "bg-white rounded-small md:flex md:justify-center md:w-full",
    "data-testid": "AlternativeDate"
  }, AlternativeDateSuggestionHeader_jsx("div", {
    className: "AlternativeProposalsModal-header flex py-px15 px-px25 md:py-px30 md:items-center md:w-full lg:mx-px25 lg:px-0"
  }, AlternativeDateSuggestionHeader_jsx(Icon["a" /* Icon */], {
    className: "AternativeProposalsModal-icon flex-shrink self-start",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].WARNING,
    width: "3rem",
    hasRtl: true
  }), AlternativeDateSuggestionHeader_jsx("div", {
    className: "AlternativeProposalsModal-title ml-px10 rtl:ml-px10 rtl:mr-0 md:ml-px25 md:rtl:ml-px25"
  }, AlternativeDateSuggestionHeader_jsx("div", {
    className: "text-blue"
  }, AlternativeDateSuggestionHeader_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.noAvailabilityOnCriterionLabel') // $FlowFixMe
    ,
    values: {
      resortName: resort.name
    }
  })), AlternativeDateSuggestionHeader_jsx("div", {
    className: "text-orange"
  }, AlternativeDateSuggestionHeader_jsx(TemplateString["a" /* TemplateString */], {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.notAvailableDates') // $FlowFixMe
    ,
    values: {
      arrivalDate: getFormattedDateTitle(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDateTitle(departureDate, 'YYYYMMDD') || ''
    }
  })))));
};
// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-price-title/AlternativePriceTitle.jsx
var AlternativePriceTitle_jsx = react_default.a.createElement;







var AlternativePriceTitle_AlternativePriceTitle = function AlternativePriceTitle(_ref) {
  var title = _ref.title,
      price = _ref.proposal.price;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  if (!price) {
    return null;
  }

  return AlternativePriceTitle_jsx("div", {
    className: "flex alternative-price-title-container"
  }, Object(sellerUtils["g" /* isSeller */])(appContext) && price.gap >= 30 || price.gap < 30 ? AlternativePriceTitle_jsx("div", {
    className: "flex"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon alternative-price-title-icon--full",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "6rem",
    hasRtl: true
  }), AlternativePriceTitle_jsx("span", {
    className: "alternative-price-title ml-px10 rtl:ml-px10 rtl:mr-0 md:ml-px25 md:rtl:ml-px25 text-blue"
  }, title)) : AlternativePriceTitle_jsx(react["Fragment"], null, AlternativePriceTitle_jsx("div", {
    className: "inline-flex items-center alternative-price-title-call-center-advise"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: "4rem",
    hasRtl: true
  }), AlternativePriceTitle_jsx("span", {
    className: "alternative-price-title ml-px10 rtl:ml-px10 rtl:mr-0 md:ml-px25 md:rtl:ml-px25 text-blue"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCenterAdvise'))), AlternativePriceTitle_jsx("div", {
    className: "flex alternative-price-title-please-call items-center"
  }, AlternativePriceTitle_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "4rem",
    hasRtl: true
  }), AlternativePriceTitle_jsx("div", {
    className: "ml-px15"
  }, AlternativePriceTitle_jsx("span", {
    className: "inline-block w-full text-blue text-lg"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.pleaseCallLabel')), AlternativePriceTitle_jsx("span", {
    className: "text-emerald font-bold text-lg"
  }, Object(src_i18n["h" /* t */])('travelAdvisor.phoneNumber')), AlternativePriceTitle_jsx("span", {
    className: "text-gray text-md alternative-price-title-call-cost"
  }, ' ', Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCost'))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-proposal-header/AlternativeProposalHeader.jsx
var AlternativeProposalHeader_jsx = react_default.a.createElement;





var AlternativeProposalHeader_AlternativeProposalHeader = function AlternativeProposalHeader(_ref) {
  var title = _ref.title,
      proposal = _ref.proposal,
      _ref$iconWidth = _ref.iconWidth,
      iconWidth = _ref$iconWidth === void 0 ? '6rem' : _ref$iconWidth;
  return AlternativeProposalHeader_jsx("div", {
    className: "bg-white rounded-small md:flex md:justify-center md:w-full"
  }, AlternativeProposalHeader_jsx("div", {
    className: "AlternativeProposalsModal-header flex py-px10 px-px25 md:py-px15 md:items-center md:w-full lg:mx-px25 lg:px-0"
  }, proposal ? AlternativeProposalHeader_jsx(AlternativePriceTitle_AlternativePriceTitle, {
    proposal: proposal,
    title: title
  }) : AlternativeProposalHeader_jsx("div", {
    className: "flex"
  }, AlternativeProposalHeader_jsx(Icon["a" /* Icon */], {
    className: "alternative-price-title-icon alternative-price-title-icon--full",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].LIGHTBULB,
    width: iconWidth,
    hasRtl: true
  }), AlternativeProposalHeader_jsx("span", {
    className: "alternative-proposal-title font-brand rtl:ml-px10 md:rtl:ml-px25 rtl:mr-0 text-blue"
  }, title))));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/flipper/Flipper.jsx
var Flipper = __webpack_require__("8zGh");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/DateSummary.jsx
var DateSummary = __webpack_require__("tF/N");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeSuggestionCriteria.jsx
var AlternativeSuggestionCriteria_jsx = react_default.a.createElement;








function AlternativeSuggestionCriteria(_ref) {
  var title = _ref.title,
      suggestion = _ref.suggestion,
      onSubmit = _ref.onSubmit,
      buttonLabel = _ref.buttonLabel,
      _ref$categoryGA = _ref.categoryGA,
      categoryGA = _ref$categoryGA === void 0 ? 'resort' : _ref$categoryGA;
  var getFormattedDate = Object(dateUtils["a" /* formatDate */])('D MMMM YYYY');
  return AlternativeSuggestionCriteria_jsx("div", {
    "data-testid": "AlternativeDateSuggestionCriteria",
    className: "AlternativeProposalsModal-criteria rtl:mr-px15 mt-px30"
  }, title, AlternativeSuggestionCriteria_jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      content: {
        padding: '20px',
        fontSize: '14px'
      }
    }
  }, AlternativeSuggestionCriteria_jsx(DateSummary["a" /* DateSummary */], {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(suggestion.resortArrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(suggestion.resortDepartureDate, 'YYYYMMDD') || ''
    }
  }), AlternativeSuggestionCriteria_jsx("div", {
    className: "AlternativeProposalsModal-criteriaPrice flex font-bold items-center ml-px40 justify-center text-blue"
  }, AlternativeSuggestionCriteria_jsx(Flipper["a" /* Flipper */], {
    value: suggestion.price.total
  }), AlternativeSuggestionCriteria_jsx(react["Fragment"], null, AlternativeSuggestionCriteria_jsx("span", {
    className: "AlternativeProposalsModal-criteriaLabelPrice ml-px10 rtl:ml-px10"
  }, "\xA0", AlternativeSuggestionCriteria_jsx(Flipper["a" /* Flipper */], {
    value: Object(src_i18n["h" /* t */])('booking.priceDetails.packagePrice.totalPrice')
  }), "\xA0"), AlternativeSuggestionCriteria_jsx("span", null, "\xA0"))), AlternativeSuggestionCriteria_jsx(Button["a" /* Button */], {
    dataTestId: "AlternativeProposalsModalButton",
    className: "w-full mt-px10",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    trackingData: {
      actionGA: 'checkPricesKO',
      labelGA: 'date_check',
      categoryGA: categoryGA
    },
    onClick: function onClick() {
      return onSubmit(suggestion.resortArrivalDate);
    }
  }, buttonLabel)));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionImmersive.jsx

var AlternativeDateSuggestionImmersive_jsx = react_default.a.createElement;






var AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive = function AlternativeDateSuggestionImmersive(props) {
  var onClose = props.onClose,
      resort = props.resort;
  var trackClick = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'resort',
    actionGA: 'checkPricesKO'
  });
  return AlternativeDateSuggestionImmersive_jsx("div", {
    className: "AlternativeProposalsModal-image w-full md:pt-px30 pb-px25 md:pb-0 md:rtl:pr-px25 lg:rtl:pr-0 lg:rtl:mr-px25 lg:rtl:ml-0"
  }, AlternativeDateSuggestionImmersive_jsx(Image["b" /* default */], {
    imageUrl: resort.image,
    altMsg: resort.name,
    hasLazyLoading: false,
    dimensions: {
      w: 734,
      h: 408
    }
  }), onClose ? AlternativeDateSuggestionImmersive_jsx("div", {
    className: "flex justify-end font-bold mt-px15"
  }, AlternativeDateSuggestionImmersive_jsx("button", {
    type: "button",
    className: "AlternativeProposalsModal-doNotCheckPrice reset-button TextLink TextLink--default text-blue cursor flex items-center p-0 pr-px10 rtl:pr-px10 md:pr-0 md:rtl:pr-0",
    onClick: function onClick() {
      onClose && onClose();
      trackClick({
        labelGA: 'backResortPage'
      });
    }
  }, AlternativeDateSuggestionImmersive_jsx("span", {
    className: "font-sans md:rtl:ml-px5"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.doNotCheckPriceLabel')), AlternativeDateSuggestionImmersive_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    className: "TextLink-iconRight"
  }))) : null);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-suggestions/AlternativeSuggestions.jsx
var AlternativeSuggestions_jsx = react_default.a.createElement;





var AlternativeSuggestions_AlternativeSuggestions = function AlternativeSuggestions(_ref) {
  var title = _ref.title,
      children = _ref.children,
      onClose = _ref.onClose,
      immersiveResort = _ref.immersiveResort;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isBrowserGreaterThan = _useResponsive.isBrowserGreaterThan;

  return AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-content-wrapper w-full flex flex-col md:flex-row justify-center mt-px15"
  }, AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-date-suggestion flex flex-col sm:flex-row w-full"
  }, AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-contentCriterias mb-px40 md:mb-0 md:mt-px30 lg:ml-px25"
  }, AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-titleSuggest text-blue text-xl font-bold px-px25 lg:pl-0"
  }, title), isBrowserGreaterThan.S ? AlternativeSuggestions_jsx("div", {
    className: "AlternativeProposalsModal-Criterias md:flex md:flex-wrap"
  }, children) : AlternativeSuggestions_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    childrenWrapperClassNames: "flex px-px25",
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }, children)), immersiveResort && AlternativeSuggestions_jsx(AlternativeDateSuggestionImmersive_AlternativeDateSuggestionImmersive, {
    onClose: onClose,
    resort: immersiveResort
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-duration-suggestions/AlternativeDurationSuggestions.jsx









var AlternativeDurationSuggestions_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var AlternativeDurationSuggestions_AlternativeDurationSuggestions = function AlternativeDurationSuggestions(_ref) {
  var durations = _ref.durations,
      onSelectNewDuration = _ref.onSelectNewDuration,
      categoryGA = _ref.categoryGA;
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'resort',
    actionGA: 'checkPriceKO'
  });
  return AlternativeDurationSuggestions_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationsLabel')
  }, durations.map(function (suggestion) {
    var duration = suggestion.data.duration;
    return AlternativeDurationSuggestions_jsx(AlternativeSuggestionCriteria, {
      key: duration,
      title: AlternativeDurationSuggestions_jsx("div", {
        className: "text-md mb-px5"
      }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationLabel'), ' ', AlternativeDurationSuggestions_jsx("span", {
        className: "font-bold text-blue text-lg"
      }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.durationsSuggestions', {
        duration: duration
      }))),
      buttonLabel: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabelDuration'),
      suggestion: _objectSpread(_objectSpread({}, suggestion.data), {}, {
        price: {
          total: suggestion.data.price.total.formattedValue
        }
      }),
      onSubmit: function onSubmit() {
        onSelectNewDuration({
          proposalIds: suggestion.ids,
          duration: duration
        });
        track({
          labelGA: 'duration_check'
        });
      },
      categoryGA: categoryGA
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestion.jsx


var AlternativeDateSuggestion_jsx = react_default.a.createElement;




var AlternativeDateSuggestion_AlternativeDateSuggestion = function AlternativeDateSuggestion(props) {
  var onSubmit = props.onSubmit,
      onClose = props.onClose,
      resort = props.resort,
      dates = props.dates,
      _props$categoryGA = props.categoryGA,
      categoryGA = _props$categoryGA === void 0 ? 'resort' : _props$categoryGA;
  return AlternativeDateSuggestion_jsx(AlternativeSuggestions_AlternativeSuggestions, {
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.weSuggestLabel', {
      resortName: resort.name
    }),
    onClose: onClose,
    immersiveResort: resort
  }, dates.map(function (suggestion) {
    return AlternativeDateSuggestion_jsx(AlternativeSuggestionCriteria, {
      key: suggestion.dateOffset,
      suggestion: suggestion,
      onSubmit: onSubmit,
      categoryGA: categoryGA,
      buttonLabel: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabel')
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposalsSeparatorDashed.jsx
var AlternativeProposalsSeparatorDashed_jsx = react_default.a.createElement;

 // $FlowFixMe

var AlternativeProposalsSeparatorDashed = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  return AlternativeProposalsSeparatorDashed_jsx("div", {
    "data-testid": "AlternativeProposalsSeparatorDashed",
    ref: ref,
    className: "flex mt-px15 w-full"
  }, AlternativeProposalsSeparatorDashed_jsx("div", {
    className: "self-center border-t border-dashed flex-1"
  }), AlternativeProposalsSeparatorDashed_jsx("div", {
    className: "font-bold mx-px25 text-2xl text-blue"
  }, Object(src_i18n["h" /* t */])('booking.common.or')), AlternativeProposalsSeparatorDashed_jsx("div", {
    className: "self-center border-t border-dashed flex-1"
  }));
});
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-summary/TripSummary.utils.js + 1 modules
var TripSummary_utils = __webpack_require__("h0Er");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortThumbnail.jsx


var AlternativeResortThumbnail_jsx = react_default.a.createElement;










var AlternativeResortThumbnail_AlternativeResortThumbnail = function AlternativeResortThumbnail(props) {
  var suggestion = props.suggestion,
      className = props.className,
      onClick = props.onClick,
      _props$categoryGA = props.categoryGA,
      categoryGA = _props$categoryGA === void 0 ? 'resort' : _props$categoryGA,
      scrollToBookingEngineEntryPoint = props.scrollToBookingEngineEntryPoint;
  var appContext = react_default.a.useContext(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var trackClick = Object(useTracking["a" /* useTracking */])({
    categoryGA: categoryGA,
    actionGA: 'checkPricesKO'
  });

  var handleClick = function handleClick() {
    var _suggestion$resort = suggestion.resort,
        id = _suggestion$resort.id,
        name = _suggestion$resort.name,
        href = _suggestion$resort.href;
    onClick ? onClick(id, name) : history.pushRoute(href).then(function () {
      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    });
  };

  return AlternativeResortThumbnail_jsx("div", {
    "data-testid": "AlternativeResortThumbnail",
    className: classnames_default()('AlternativeResortThumbnail flex flex-col mr-px15', className)
  }, AlternativeResortThumbnail_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
    className: "AlternativeProposalsModal-thumbnail"
  }, Object(TripSummary_utils["a" /* createPropsForProduct */])(suggestion.resort, undefined, appContext), {
    hasLazyLoading: false // Allows to avoid to launch the tracking on the arrows of the slider
    ,
    onClick: function onClick(e) {
      if (e.target instanceof HTMLImageElement) {
        handleClick();
        trackClick({
          labelGA: 'resort_checkThumbnail'
        });
      }
    }
  })), AlternativeResortThumbnail_jsx(Button["a" /* Button */], {
    dataTestId: "AlernativeResortThumbnailButton",
    className: "px-px25 my-px25 self-center",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    colorBorder: colors["a" /* COLORS */].TURQUOISE,
    trackingData: {
      actionGA: 'checkPricesKO',
      labelGA: 'resort_check',
      categoryGA: 'resort'
    },
    onClick: handleClick
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.checkPriceLabelResort')));
};
// EXTERNAL MODULE: ./src/client/components/widgets/package/price/AttendeesSummary.jsx
var AttendeesSummary = __webpack_require__("5q4R");

// EXTERNAL MODULE: ./src/client/components/widgets/package/price/TransportSummary.jsx
var TransportSummary = __webpack_require__("YKA5");

// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResortCriteria.jsx
var AlternativeResortCriteria_jsx = react_default.a.createElement;












var AlternativeResortCriteria_AlternativeResortCriteria = function AlternativeResortCriteria(props) {
  var adultsNumber = props.adultsNumber,
      arrivalDate = props.arrivalDate,
      departureCity = props.departureCity,
      duration = props.duration,
      kidsNumber = props.kidsNumber;
  var getFormattedDate = Object(dateUtils["a" /* formatDate */])('D MMMM YYYY');
  var departureDate = Object(AlternativeProposalsUtils["a" /* getDepartureDate */])({
    date: arrivalDate,
    duration: duration,
    format: apiDate["a" /* API_DATE_FORMAT */],
    unit: 'days'
  });
  return AlternativeResortCriteria_jsx("div", {
    "data-testid": "AlternativeResortCriteria",
    className: "AlternativeResort-criteria flex flex-col mt-px10 mb-px30 md:mt-0 md:mb-0 md:mr-px15 md:rtl:mr-px15 md:rtl:ml-0"
  }, AlternativeResortCriteria_jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      content: {
        padding: '20px',
        fontSize: '14px'
      }
    }
  }, AlternativeResortCriteria_jsx("div", null, AlternativeResortCriteria_jsx(DateSummary["a" /* DateSummary */], {
    template: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.fromTo'),
    values: {
      arrivalDate: getFormattedDate(arrivalDate, 'YYYYMMDD') || '',
      departureDate: getFormattedDate(departureDate, 'YYYYMMDD') || ''
    }
  })), AlternativeResortCriteria_jsx("div", {
    className: "mt-px15"
  }, AlternativeResortCriteria_jsx(AttendeesSummary["a" /* AttendeesSummary */], {
    adults: adultsNumber,
    kids: kidsNumber
  })), AlternativeResortCriteria_jsx("div", {
    className: "mt-px15"
  }, AlternativeResortCriteria_jsx(TransportSummary["a" /* TransportSummary */], {
    departure: departureCity !== 'NO' ? departureCity : null,
    transportIcon: icons["a" /* ICONS */].TRANSPORT
  })), AlternativeResortCriteria_jsx("div", {
    className: "flex mt-px15"
  }, AlternativeResortCriteria_jsx(Icon["a" /* Icon */], {
    className: "AlternativeResortCriteria-icon flex-shrink",
    color: colors["a" /* COLORS */].ORANGE,
    name: icons["a" /* ICONS */].WARNING,
    width: "2rem",
    hasRtl: true
  }), AlternativeResortCriteria_jsx("div", {
    className: "AlternativeResortCriteria-textWarning font-bold text-orange rtl:ml-px10 rtl:mr-0"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.resortCounterProposalTransportReassurance')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/alternative-resort/AlternativeResort.jsx

var AlternativeResort_jsx = react_default.a.createElement;






var AlternativeResort_AlternativeResort = function AlternativeResort(props) {
  var adultsNumber = props.adultsNumber,
      arrivalDate = props.arrivalDate,
      departureCity = props.departureCity,
      duration = props.duration,
      i18n = props.i18n,
      kidsNumber = props.kidsNumber,
      suggestions = props.suggestions,
      selectResortHandler = props.selectResortHandler,
      scrollToBookingEngineEntryPoint = props.scrollToBookingEngineEntryPoint,
      _props$categoryGA = props.categoryGA,
      categoryGA = _props$categoryGA === void 0 ? 'resort' : _props$categoryGA;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isBrowserGreaterThan = _useResponsive.isBrowserGreaterThan;

  return AlternativeResort_jsx("div", {
    className: "flex justify-center w-full mt-px40",
    "data-testid": "AlternativeResort"
  }, AlternativeResort_jsx("div", {
    className: "AlternativeResort-wrapper px-px25 w-full"
  }, AlternativeResort_jsx("div", {
    className: "AlternativeResort-title font-bold text-blue text-xl"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.resortCounterProposalTitle')), AlternativeResort_jsx("div", {
    className: "AlternativeResort-content md:flex md:mt-px15 md:flex-wrap"
  }, AlternativeResort_jsx(AlternativeResortCriteria_AlternativeResortCriteria, {
    adultsNumber: adultsNumber,
    arrivalDate: arrivalDate,
    departureCity: departureCity,
    duration: duration,
    i18n: i18n,
    kidsNumber: kidsNumber
  }), isBrowserGreaterThan.S ? AlternativeResort_jsx(react["Fragment"], null, suggestions.map(function (suggestion, index) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      key: suggestion.resort.id,
      suggestion: suggestion,
      className: index < suggestions.length - 1 ? 'mr-px15 rtl:mr-px15' : '',
      onClick: selectResortHandler,
      categoryGA: categoryGA,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint
    });
  })) : AlternativeResort_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward'),
    hasArrows: false,
    childrenWrapperClassNames: "flex px-px25"
  }, suggestions.map(function (suggestion, index) {
    return AlternativeResort_jsx(AlternativeResortThumbnail_AlternativeResortThumbnail, {
      key: suggestion.resort.id,
      suggestion: suggestion,
      className: index < suggestions.length - 1 ? 'rtl:mr-px15' : undefined,
      onClick: selectResortHandler,
      categoryGA: categoryGA,
      scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint
    });
  })))), AlternativeResort_jsx("div", {
    className: "md:border-t md:border-dotted md:mb-px25"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/alternative-proposals/AlternativeProposals.jsx
var AlternativeProposals_jsx = react_default.a.createElement;














function AlternativeProposals(_ref) {
  var _ref$searchCriteria = _ref.searchCriteria,
      arrivalDate = _ref$searchCriteria.arrivalDate,
      duration = _ref$searchCriteria.duration,
      adultsCount = _ref$searchCriteria.adultsCount,
      departureCity = _ref$searchCriteria.departureCity,
      kidsCount = _ref$searchCriteria.kidsCount,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit,
      i18n = _ref.i18n,
      proposals = _ref.proposals,
      resort = _ref.resort,
      scrollToBookingEngineEntryPoint = _ref.scrollToBookingEngineEntryPoint,
      bookingEngineEntryPoint = _ref.bookingEngineEntryPoint,
      goToBookingEngine = _ref.goToBookingEngine,
      _ref$suggestions = _ref.suggestions,
      dates = _ref$suggestions.dates,
      resorts = _ref$suggestions.resorts,
      durations = _ref$suggestions.durations,
      searchCriteria = _ref.searchCriteria,
      selectResortHandler = _ref.selectResortHandler,
      onSelectNewDuration = _ref.onSelectNewDuration,
      _ref$disableAlternati = _ref.disableAlternativePrice,
      disableAlternativePrice = _ref$disableAlternati === void 0 ? false : _ref$disableAlternati;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var separatorComponent = Object(react["useRef"])(null);
  var proposal = proposals[0];
  var shouldDisplayAlternativePriceCriteria = !disableAlternativePrice && proposal && proposal.price && proposal.price.gap && proposal.price.gap > proposals_constants["t" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] && (appContext.isSeller || proposal.price.gap < proposals_constants["s" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */]);
  var shouldDisplayAlternativePriceTitle = !disableAlternativePrice && proposal && proposal.price && proposal.price.gap && proposal.price.gap > proposals_constants["t" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];

  var seeOtherProposalsCallback = function seeOtherProposalsCallback() {
    if (separatorComponent.current) {
      separatorComponent.current.scrollIntoView();
    }
  };

  var atLeastOneDateCounterProposal = dates.length > 0;
  var atLeastOneResortCounterProposal = resorts.length > 0;
  var atLeastOneDurationCounterProposal = durations.length > 0;
  var hasSuggestions = atLeastOneDateCounterProposal || atLeastOneResortCounterProposal || atLeastOneDurationCounterProposal;
  return AlternativeProposals_jsx("div", {
    "data-testid": "AlternativeProposalsModal",
    className: "AlternativeProposalsModal rounded-small md:flex md:flex-col md:items-center"
  }, shouldDisplayAlternativePriceTitle ? AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.rateCounterProposalTitle'),
    proposal: proposal
  }) : null, shouldDisplayAlternativePriceCriteria && AlternativeProposals_jsx(react["Fragment"], null, AlternativeProposals_jsx("div", {
    className: "AlternativeProposalsModal-content flex flex-col items-center px-px30 w-full max-w-site"
  }, AlternativeProposals_jsx(AlternativePrice_AlternativePrice, {
    proposals: proposals,
    resort: resort,
    searchCriteria: searchCriteria,
    departureCities: i18n.bookingCriteria.departureCities,
    seeOtherProposalsCallback: seeOtherProposalsCallback,
    hasOtherProposals: hasSuggestions,
    onModify: onClose ? function () {
      onClose();

      if (scrollToBookingEngineEntryPoint) {
        scrollToBookingEngineEntryPoint();
      }
    } : undefined,
    bookingEngineEntryPoint: bookingEngineEntryPoint // $FlowFixMe
    ,
    continueToBookingEngine: goToBookingEngine
  })), hasSuggestions && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, {
    ref: separatorComponent
  })), hasSuggestions && !shouldDisplayAlternativePriceTitle && !disableAlternativePrice ? AlternativeProposals_jsx(AlternativeDateSuggestionHeader_AlternativeDateSuggestionHeader, {
    arrivalDate: arrivalDate,
    duration: duration,
    resort: resort
  }) : AlternativeProposals_jsx(AlternativeProposalHeader_AlternativeProposalHeader, {
    title: Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.otherProposals'),
    iconWidth: "3rem"
  }), atLeastOneDateCounterProposal && AlternativeProposals_jsx(AlternativeDateSuggestion_AlternativeDateSuggestion, {
    arrivalDate: arrivalDate,
    duration: duration,
    dates: dates,
    onSubmit: onSubmit,
    onClose: onClose,
    resort: resort
  }), atLeastOneDateCounterProposal && (atLeastOneDurationCounterProposal || atLeastOneResortCounterProposal) && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneDurationCounterProposal && AlternativeProposals_jsx(AlternativeDurationSuggestions_AlternativeDurationSuggestions, {
    onSelectNewDuration: onSelectNewDuration,
    durations: durations
  }), atLeastOneDurationCounterProposal && atLeastOneResortCounterProposal && AlternativeProposals_jsx(AlternativeProposalsSeparatorDashed, null), atLeastOneResortCounterProposal && AlternativeProposals_jsx(react["Fragment"], null, AlternativeProposals_jsx(AlternativeResort_AlternativeResort, {
    adultsNumber: adultsCount,
    arrivalDate: arrivalDate,
    departureCity: departureCity,
    duration: duration,
    i18n: i18n,
    kidsNumber: kidsCount,
    suggestions: resorts,
    scrollToBookingEngineEntryPoint: scrollToBookingEngineEntryPoint,
    selectResortHandler: selectResortHandler
  })), !appContext.isCmta && AlternativeProposals_jsx(react["Fragment"], null, AlternativeProposals_jsx("div", {
    className: "border-t border-solid mt-px20 mb-px10 md:mt-px50 md:mb-px30 w-full"
  }), AlternativeProposals_jsx("div", {
    className: "flex items-center mb-px30 px-px25"
  }, AlternativeProposals_jsx(Icon["a" /* Icon */], {
    className: "mr-px10 flex",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].PHONE_BUBBLE,
    width: "4rem",
    hasRtl: true
  }), AlternativeProposals_jsx("p", {
    className: "font-bold text-lg text-blue"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.contactCallCenter'), ' ', AlternativeProposals_jsx("span", {
    className: "AlternativeProposalsModal-callText"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCenterNumber')), ' ', AlternativeProposals_jsx("span", {
    className: "font-normal text-gray text-sm"
  }, Object(src_i18n["h" /* t */])('booking.counterProposalPopIn.callCost'))))));
}

/***/ }),

/***/ "YSwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrivalDepartureDate; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("kiXb");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var ArrivalDepartureDate = function ArrivalDepartureDate(_ref) {
  var arrivalDate = _ref.arrivalDate,
      departureDate = _ref.departureDate;
  return __jsx("div", {
    className: "block sm:hidden p-px10 mx-px10 text-base"
  }, __jsx("div", {
    className: "flex justify-between mb-px5"
  }, __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('faceting.when.arrivalDateTitle')), __jsx("span", {
    className: "font-bold text-blue"
  }, arrivalDate ? arrivalDate : ' -')), __jsx("div", {
    className: "flex justify-between mb-px5"
  }, __jsx("span", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_1__[/* t */ "h"])('faceting.when.departureDateTitle')), __jsx("span", {
    className: "font-bold text-blue"
  }, departureDate ? departureDate : ' -')));
};

/***/ }),

/***/ "YYl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productsFiltersResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");






var productsFiltersResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* PRODUCTS_FILTERS */ "I"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _props$offerId = props.offerId,
        offerId = _props$offerId === void 0 ? '' : _props$offerId;
    var query = "{\n      config {\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_2__[/* faceting */ "b"](), "\n        common { close thumbnailCTA next previous scrollBackward scrollForward }\n        remote {\n          date\n          searchAction\n          noResult {\n            zeroResult\n            explanation\n          }\n        }\n      }\n      offer(offerId: \"").concat(offerId, "\") {\n        id\n        name\n        seoName\n        color\n        products {\n          id\n          price {\n            bestPrice {\n              value\n              formattedValue\n            }\n            initialPrice {\n              value\n              formattedValue\n            }\n            unit\n            currency\n            termsAndConditions {\n              departureDate\n              duration\n              durationFormatted\n              numberOfAdults\n              accommodationComfortLabel\n            }\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_OFFER_PRODUCT_FILTER */ "Rb"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "YZTm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ID_LAYER_HEADER__BE__ACCOMMODATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ID_LAYER_HEADER__BE__CATEGORY_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ID_LAYER_HEADER__CA__ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ID_LAYER_HEADER__CA__CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ID_LAYER_HEADER__CA__EASYCHECKINOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ID_LAYER_HEADER__CA__EASYTRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ID_LAYER_HEADER__CA__ESF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ID_LAYER_HEADER__CA__INSURANCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ID_LAYER_HEADER__CA__PACKAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ID_LAYER_HEADER__CA__RENTALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ID_LAYER_HEADER__CA__STAFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ID_LAYER_HEADER__CA__TRANSFERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ID_LAYER_HEADER__CA__VOUCHERS; });
/* unused harmony export ID_LAYER_HEADER__PLE__PYR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ID_LAYER_HEADER__PLE__PYR_AGENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ID_MODAL_HEADER__BE__OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ID_MODAL_HEADER__BE__CXO_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ID_MODAL_HEADER__BE__PROMO_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return ID_MODAL_HEADER__BE__SHARE_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ID_MODAL_HEADER__BE__MISMATCH_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return ID_MODAL_HEADER__PLE__LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ID_MODAL_HEADER__BE__CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ID_MODAL_HEADER__PLE__NEWSLETTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW; });
// Layers header IDs
var ID_LAYER_HEADER__BE__ACCOMMODATIONS = 'AccommodationsLayerHeaderId';
var ID_LAYER_HEADER__BE__CATEGORY_LIST = 'CategoryListLayerHeaderId';
var ID_LAYER_HEADER__BE__CHOOSE_EQUIPEMENT = 'ChooseEquipmentLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_DESKTOP = 'TransportsDesktopLayerHeaderId';
var ID_LAYER_HEADER__BE__TRANSPORTS_MOBILE = 'TransportsMobileLayerHeaderId';
var ID_LAYER_HEADER__BE__OTHER_PROPOSALS_MOBILE = 'OtherProposalsMobileLayerHeaderId';
var ID_LAYER_HEADER__CA__ACTIVITIES = 'ActivitiesLayerHeaderId';
var ID_LAYER_HEADER__CA__CHILDCARES = 'ChildcaresLayerHeaderId';
var ID_LAYER_HEADER__CA__EASYCHECKINOUT = 'EasyCheckInOutLayerHeaderId';
var ID_LAYER_HEADER__CA__EASYTRANSFER = 'EasyTransferLayerHeaderId';
var ID_LAYER_HEADER__CA__ESF = 'ESFLayerHeaderId';
var ID_LAYER_HEADER__CA__INSURANCES = 'InsurancesLayerHeaderId';
var ID_LAYER_HEADER__CA__PACKAGES = 'PackagesLayerHeaderId';
var ID_LAYER_HEADER__CA__RENTALS = 'RentalsLayerHeaderId';
var ID_LAYER_HEADER__CA__STAFF = 'StaffLayerHeaderId';
var ID_LAYER_HEADER__CA__TRANSFERS = 'TransfersLayerHeaderId';
var ID_LAYER_HEADER__CA__VOUCHERS = 'VouchersLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR = 'PickYourRoomLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_AGENCY = 'PickYourRoomAgencyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_RESORT_ONLY = 'PYRResortOnlyLayerHeaderId';
var ID_LAYER_HEADER__PLE__PYR_ROOM_RESORT = 'PickYourRoomResortLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__COOKIE_PREFERENCES = 'CookiePreferencesLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL = 'CriteriaModalLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__CRITERIA_TRIGGER = 'CriteriaTriggerLayerHeaderId';
var ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS = 'PriceRemoteDetailsLayerHeaderId'; // Modals header IDs

var ID_MODAL_HEADER__BE__OPTION = 'OptionModalHeaderId';
var ID_MODAL_HEADER__BE__CXO_OPTION = 'CxoOptionModalHeaderId';
var ID_MODAL_HEADER__BE__PROMO_CODE = 'PromoCodeModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_CONFIRMATION = 'SaveCriteriaConfirmationModalHeaderId';
var ID_MODAL_HEADER__BE__SAVE_CRITERIA_LOGIN = 'SaveCriteriaLoginModalHeaderId';
var ID_MODAL_HEADER__BE__SHARE_CONTEXT = 'ShareContextModalHeaderId';
var ID_MODAL_HEADER__BE__MISMATCH_COUNTRY = 'MismatchCountryModalHeaderId';
var ID_MODAL_HEADER__PLE__LOGIN = 'ParticipantsLoginToPleModalHeaderId';
var ID_MODAL_HEADER__BE__CUSTOMER = 'ParticipantsCustomerModalHeaderId';
var ID_MODAL_HEADER__PLE__NEWSLETTER = 'NewsletterModalHeaderId';
var ID_MODAL_HEADER__SHOPPING__WEBCALLBACK_TRIGGER = 'WebCallBackTriggerModalHeaderId'; // SidePanel header IDs

var ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW = 'WibilongNarrowSidePanelHeaderId';

/***/ }),

/***/ "YbGu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productFlashInfoResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productFlashInfoResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_FLASH_INFO */ "hb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "query {\n      config {\n        common { close }\n      }\n      editorialZone(".concat(productArgs, ") {\n        texts\n        image\n        link\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_FLASH_INFO */ "ec"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "YjXp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSwitch_InputSwitch; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/shortid/index.js
var shortid = __webpack_require__("MIfU");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.themes.js










function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var DEFAULT_SIZES = {
  small: 15,
  medium: 23,
  large: 23
};
var themes = {
  "default": function _default(props) {
    var color = props.color,
        isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        size = props.size,
        validationState = props.validationState;
    return {
      thRoot: 'flex items-center',
      thLabel: classnames_default()('flex items-center text-base px-px10', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'font-bold text-blue text-lg': size === 'large',
        'text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: classnames_default()('leading-none bg-white border-1 border-solid border-gray-medium flex-shrink-0 p-px rounded-tiny', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'text-blue': isChecked,
        'bg-gray-light opacity-25': isDisabled
      }),
      thCheckedStyle: {
        width: DEFAULT_SIZES[size],
        height: DEFAULT_SIZES[size]
      },
      thLoading: 'rtl:ml-px10 flex items-center leading-none',
      thSwitch: classnames_default()('reset-button border-2 flex items-center transition-all', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), Object(defineProperty["a" /* default */])({
        'bg-gray-light border-gray-light': isDisabled,
        'bg-gray-darker border-gray-darker': !isChecked && !isDisabled
      }, "bg-".concat(color, " border-").concat(color), isChecked && !isDisabled)),
      thSwitchStyle: {
        width: 58,
        padding: '0 1px',
        height: 30,
        borderRadius: 30
      },
      thSwitchToggler: classnames_default()('bg-white block leading-none flex items-center justify-center rounded-half transition-all', Object(defineProperty["a" /* default */])({
        'rtl:translate-x-100': isChecked
      }, "text-".concat(color), isChecked && !isDisabled)),
      thSwitchTogglerStyle: {
        width: 28,
        height: 28
      }
    };
  },
  bubble: function bubble(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center shadow border-1 rounded py-px10 px-px20 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isDisabled,
        'bg-gray-light border-gray-light opacity-50': isDisabled,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-current text-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  },
  bubble2: function bubble2(props) {
    var isChecked = props.isChecked,
        isDisabled = props.isDisabled,
        isReadOnly = props.isReadOnly,
        validationState = props.validationState;
    return {
      thRoot: 'relative',
      thLabel: classnames_default()('flex items-center justify-center border-1 rounded py-px5 px-px5 text-base text-center transition-colors', Object(form_util["a" /* getCursorClass */])(_objectSpread({
        hasPointer: true
      }, props)), {
        'bg-white': !isChecked,
        'border-gray-light opacity-50': isDisabled && !isChecked,
        'border-gray-light': !isChecked && validationState === 'NOT_VALIDATED',
        'border-blue text-white bg-blue': isChecked && validationState === 'NOT_VALIDATED' && !isReadOnly && !isDisabled,
        'border-current text-success': validationState === 'IS_VALID' && !isReadOnly && !isDisabled,
        'border-current text-danger': validationState === 'IS_INVALID' && !isReadOnly && !isDisabled,
        'border-blue text-white bg-blue opacity-50': isDisabled && isChecked
      }),
      thChecked: 'hidden',
      thLoading: 'absolute flex h-full items-center leading-none left-1/2 -translate-x-50'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx


















var __jsx = react_default.a.createElement;

function InputSwitch_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InputSwitch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InputSwitch_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InputSwitch_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var InputSwitch_InputSwitch = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSwitch, _Component);

  var _super = _createSuper(InputSwitch);

  function InputSwitch(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSwitch);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function () {
      var _this$props = _this.props,
          isDisabled = _this$props.isDisabled,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange,
          _this$props$value = _this$props.value,
          value = _this$props$value === void 0 ? '' : _this$props$value;

      if (!isReadOnly && !isDisabled && !isLoading) {
        var isChecked = !_this.state.isChecked;

        _this.setState({
          isChecked: isChecked
        }, function () {
          return onChange(name, isChecked, value);
        });
      }
    });

    _this.state = {
      isChecked: props.isChecked || false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSwitch, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isChecked !== this.props.isChecked) {
        this.setState({
          isChecked: this.props.isChecked
        });
      }
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var _this$props2 = this.props,
          _this$props2$iconChec = _this$props2.iconChecked,
          iconChecked = _this$props2$iconChec === void 0 ? null : _this$props2$iconChec,
          _this$props2$iconUnCh = _this$props2.iconUnChecked,
          iconUnChecked = _this$props2$iconUnCh === void 0 ? null : _this$props2$iconUnCh;
      return this.state.isChecked ? iconChecked : iconUnChecked;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          ariaDescribedby = _this$props3.ariaDescribedby,
          ariaLabelledby = _this$props3.ariaLabelledby,
          className = _this$props3.className,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? "InputSwitch_".concat(shortid_default.a.generate()) : _this$props3$id,
          inputTestId = _this$props3.inputTestId,
          isDisabled = _this$props3.isDisabled,
          isLoading = _this$props3.isLoading,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          isSwitch = _this$props3.isSwitch,
          label = _this$props3.label,
          labelClassName = _this$props3.labelClassName,
          name = _this$props3.name,
          onClick = _this$props3.onClick,
          theme = _this$props3.theme,
          value = _this$props3.value,
          dataTestId = _this$props3.dataTestId;
      var isChecked = this.state.isChecked;

      var _themes$theme = themes[theme](InputSwitch_objectSpread({
        isChecked: isChecked
      }, this.props)),
          thChecked = _themes$theme.thChecked,
          thCheckedStyle = _themes$theme.thCheckedStyle,
          thLabel = _themes$theme.thLabel,
          thLoading = _themes$theme.thLoading,
          thRoot = _themes$theme.thRoot,
          thSwitch = _themes$theme.thSwitch,
          thSwitchStyle = _themes$theme.thSwitchStyle,
          thSwitchToggler = _themes$theme.thSwitchToggler,
          thSwitchTogglerStyle = _themes$theme.thSwitchTogglerStyle;

      return __jsx("div", {
        "data-testid": dataTestId,
        className: classnames_default()(className, thRoot)
      }, isSwitch ? __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: thSwitch,
        "data-testid": id,
        onClick: this.onChange,
        role: "checkbox",
        style: thSwitchStyle,
        type: "button"
      }, __jsx("span", {
        className: thSwitchToggler,
        style: thSwitchTogglerStyle
      }, isChecked ? __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK
      }) : __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CROSS,
        width: "0.7rem"
      }))) : __jsx("button", {
        "aria-checked": isChecked,
        "aria-describedby": ariaDescribedby,
        "aria-disabled": isDisabled,
        "aria-labelledby": ariaLabelledby,
        className: classnames_default()('reset-button', thChecked),
        "data-testid": id,
        disabled: isDisabled,
        onClick: this.onChange,
        role: "checkbox",
        style: thCheckedStyle,
        type: "button"
      }, __jsx(Icon["a" /* Icon */], {
        name: this.getIcon(),
        width: "100%"
      })), __jsx("input", {
        checked: isChecked,
        className: "hidden",
        disabled: isDisabled,
        id: id,
        "data-testid": inputTestId,
        label: label,
        name: name,
        onChange: this.onChange,
        onClick: onClick,
        required: isRequired,
        type: "checkbox",
        value: value
      }), isLoading && !isDisabled && !isReadOnly && __jsx("div", {
        className: thLoading
      }, __jsx(Spinner["a" /* Spinner */], {
        size: "small"
      })), !!label && __jsx("label", {
        className: classnames_default()(labelClassName, thLabel),
        htmlFor: id
      }, Object(lodash["isString"])(label) ? Object(form_util["b" /* getFormattedLabel */])(label, isRequired) : label));
    }
  }]);

  return InputSwitch;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSwitch_InputSwitch, "defaultProps", {
  color: colors["a" /* COLORS */].BLUE,
  iconChecked: icons["a" /* ICONS */].CHECK,
  iconUnChecked: null,
  isDisabled: false,
  isLoading: false,
  size: 'medium',
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "YpBQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("y/9h"),
    isFlattenable = __webpack_require__("oCTG");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "ZFcn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Slider; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/feature-testing/index.js + 1 modules
var feature_testing = __webpack_require__("qlAI");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var NAV_POSITION_CLASSES = {
  bottom: {
    thControls: 'flex justify-end -mx-px5 mt-px10',
    thControl: 'mx-px5'
  },
  center: {
    thInner: 'relative',
    thControls: 'z-2 absolute flex justify-between pointer-events-none top-1/2 -translate-y-50 w-full',
    thControl: 'pointer-events-auto click-zone-lg',
    thControlLeft: '-translate-x-50',
    thControlRight: 'translate-x-50',
    thControlDisabled: 'invisible'
  },
  side: {
    thRoot: 'flex',
    thInner: 'flex-1',
    thControls: 'flex px-px5',
    thControl: 'mx-px5'
  },
  top: {
    thRoot: 'flex flex-col',
    thControls: 'flex justify-end -mx-px5 mb-px10 -order-1',
    thControl: 'mx-px5'
  }
};
var themes = {
  "default": function _default(_ref) {
    var navPosition = _ref.navPosition;
    return _objectSpread(_objectSpread({}, NAV_POSITION_CLASSES[navPosition]), {}, {
      thControlColor: colors["a" /* COLORS */].WHITE,
      thControlColorBg: colors["a" /* COLORS */].BLUE
    });
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/slider/Slider.jsx







var __jsx = react_default.a.createElement;








if ( true && typeof document !== 'undefined' && // $FlowFixMe
!('scrollBehavior' in document.documentElement.style)) {
  // $FlowFixMe
  __webpack_require__("5siB").polyfill();
}

function Slider(props) {
  var className = props.className,
      children = props.children,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      hasControls = props.hasControls,
      hasTabindex = props.hasTabindex,
      id = props.id,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$navPosition = props.navPosition,
      navPosition = _props$navPosition === void 0 ? 'top' : _props$navPosition,
      _props$nbItemsToScrol = props.nbItemsToScroll,
      nbItemsToScroll = _props$nbItemsToScrol === void 0 ? 1 : _props$nbItemsToScrol,
      nextLabel = props.nextLabel,
      onChangeIndex = props.onChangeIndex,
      onNext = props.onNext,
      onPrevious = props.onPrevious,
      previousLabel = props.previousLabel,
      scrollAreaClassName = props.scrollAreaClassName,
      scrollAreaContainerClassName = props.scrollAreaContainerClassName,
      scrollControlsClassName = props.scrollControlsClassName,
      scrollItemClassName = props.scrollItemClassName,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;
  var childrenCount = react["Children"].count(children);
  var containerRef = Object(react["useRef"])(null);
  var refsArray = Object(react["useRef"])([]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var _useState = Object(react["useState"])(initialIndex),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])({
    hasReachedLeft: false,
    hasReachedRight: false
  }),
      reachedX = _useState2[0],
      setReachedX = _useState2[1];

  var _useState3 = Object(react["useState"])(react["Children"].map(children, function () {
    return false;
  })),
      hiddenIndexes = _useState3[0],
      setHiddenIndexes = _useState3[1];

  var _useState4 = Object(react["useState"])(null),
      prevInitialIndex = _useState4[0],
      setPrevInitialIndex = _useState4[1];

  Object(react["useEffect"])(function () {
    if (onChangeIndex) {
      onChangeIndex(activeIndex);
    }
  }, [activeIndex]);

  var getHiddenIndexes = function getHiddenIndexes() {
    if (cols > 0) {
      return;
    }

    if (containerRef.current) {
      var _containerRef$current = containerRef.current,
          clientWidth = _containerRef$current.clientWidth,
          scrollLeft = _containerRef$current.scrollLeft,
          containerOffsetLeft = _containerRef$current.offsetLeft;
      var indexes = refsArray.current.filter(Boolean).map(function (_ref) {
        var offsetLeft = _ref.offsetLeft,
            offsetWidth = _ref.offsetWidth;
        return offsetLeft < scrollLeft + containerOffsetLeft || offsetLeft + offsetWidth > scrollLeft + containerOffsetLeft + clientWidth;
      });
      setHiddenIndexes(indexes);
    }
  };

  var getReachedX = function getReachedX() {
    if (containerRef.current) {
      var _containerRef$current2 = containerRef.current,
          clientWidth = _containerRef$current2.clientWidth,
          scrollLeft = _containerRef$current2.scrollLeft,
          scrollWidth = _containerRef$current2.scrollWidth;

      var _hasReachedLeft = scrollLeft === 0;

      var _hasReachedRight = scrollLeft + clientWidth >= scrollWidth;

      setReachedX({
        hasReachedLeft: _hasReachedLeft,
        hasReachedRight: _hasReachedRight
      });
    }
  }; // get index in possible range


  var getSafeIndex = function getSafeIndex(idx) {
    if (idx < 0) {
      return 0;
    }

    var maxIndex = cols > 0 ? childrenCount - cols : childrenCount - 1;
    return idx > maxIndex ? maxIndex : idx;
  };

  var scrollToIndex = function scrollToIndex(index, e) {
    var _containerRef$current3;

    if (e) {
      e.preventDefault();
    }

    var idx = getSafeIndex(index);
    var scrollValue = refsArray.current.slice(0, idx).reduce(function (v, ref) {
      // $FlowFixMe
      return v + ref.offsetWidth;
    }, 0);

    if ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollTo) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: scrollValue
      });
    }
  };

  Object(react["useEffect"])(function () {
    getReachedX();
    getHiddenIndexes();
    scrollToIndex(initialIndex);
    setPrevInitialIndex(initialIndex);
  }, [children]);
  Object(react["useEffect"])(function () {
    if (initialIndex !== prevInitialIndex) {
      scrollToIndex(initialIndex);
      setPrevInitialIndex(initialIndex);
    }
  }, [initialIndex]);

  if (!childrenCount) {
    return null;
  }

  var onScroll = Object(lodash["throttle"])(function () {
    getReachedX();
    getHiddenIndexes(); // $FlowFixMe

    var _containerRef$current4 = containerRef.current,
        offsetLeft = _containerRef$current4.offsetLeft,
        scrollLeft = _containerRef$current4.scrollLeft;
    var positions = refsArray.current.filter(Boolean).map(function (ref) {
      return ref.offsetLeft;
    });
    var closest = positions.reduce(function (prev, curr) {
      return Math.abs(curr - scrollLeft) < Math.abs(prev - scrollLeft) ? curr : prev;
    }, offsetLeft);
    var pos = positions.indexOf(closest);

    if (activeIndex > pos) {
      onPrevious && onPrevious();
    } else if (activeIndex < pos) {
      onNext && onNext();
    }

    if (pos > -1) {
      setActiveIndex(pos);
      var el = refsArray.current[pos]; // $FlowFixMe

      var elFocused = hasTabindex ? el : el.firstChild; // $FlowFixMe

      elFocused.focus({
        preventScroll: true
      });
    }
  }, 250);

  var _themes$theme = themes[theme]({
    navPosition: navPosition
  }),
      thControl = _themes$theme.thControl,
      thControlLeft = _themes$theme.thControlLeft,
      thControlRight = _themes$theme.thControlRight,
      thControlColor = _themes$theme.thControlColor,
      thControlColorBg = _themes$theme.thControlColorBg,
      thControlDisabled = _themes$theme.thControlDisabled,
      thControls = _themes$theme.thControls,
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;

  var hasReachedLeft = reachedX.hasReachedLeft,
      hasReachedRight = reachedX.hasReachedRight;
  var isSnapScrollDisabled = isRTL && Object(feature_testing["a" /* hasTouch */])();
  return __jsx("div", {
    className: classnames_default()(className, thRoot, 'relative', {
      '-scale-x-1': isRTL
    }),
    dir: "ltr",
    id: id
  }, __jsx("div", {
    className: classnames_default()('h-full', thInner)
  }, __jsx("div", {
    className: scrollAreaClassName
  }, __jsx("div", {
    className: classnames_default()('flex flex-row flex-no-wrap w-full', scrollAreaContainerClassName),
    onScroll: onScroll,
    ref: containerRef
  }, react["Children"].map(children, function (child, idx) {
    var _classnames;

    var isHidden = cols > 0 ? idx < activeIndex || idx >= activeIndex + cols : hiddenIndexes[idx];
    return __jsx("div", Object(esm_extends["a" /* default */])({
      "aria-hidden": isHidden,
      className: classnames_default()(Object(lodash["isFunction"])(scrollItemClassName) ? scrollItemClassName(idx) : scrollItemClassName, (_classnames = {
        'scroll-snap-align-start': !isSnapScrollDisabled
      }, Object(defineProperty["a" /* default */])(_classnames, "w-1/".concat(cols), cols > 1), Object(defineProperty["a" /* default */])(_classnames, 'w-full', cols === 1), Object(defineProperty["a" /* default */])(_classnames, '-scale-x-1', isRTL), _classnames)),
      key: idx,
      ref: function ref(_ref2) {
        refsArray.current[idx] = _ref2;
      }
    }, hasTabindex ? {
      tabIndex: -1
    } : null), /*#__PURE__*/Object(react["cloneElement"])(child, {
      dir: isRTL ? 'rtl' : 'ltr',
      isHidden: isHidden
    }));
  })))), hasControls && !(hasReachedLeft && hasReachedRight) && __jsx("div", {
    className: classnames_default()(scrollControlsClassName, thControls)
  }, __jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlLeft, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedLeft)),
    color: thControlColor,
    colorBg: thControlColorBg,
    hasNoRtl: true,
    isDisabled: hasReachedLeft,
    label: previousLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex - nbItemsToScroll, e);
    }
  }), __jsx(ArrowButton["a" /* ArrowButton */], {
    className: classnames_default()(thControl, thControlRight, Object(defineProperty["a" /* default */])({}, thControlDisabled, hasReachedRight)),
    color: thControlColor,
    colorBg: thControlColorBg,
    hasNoRtl: true,
    isDisabled: hasReachedRight,
    label: nextLabel,
    onClick: function onClick(e) {
      return scrollToIndex(activeIndex + nbItemsToScroll, e);
    },
    rotation: 180
  })));
}

/***/ }),

/***/ "ZHrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "n", function() { return /* binding */ ContactInfoUtils_getOptinsInfos; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ ContactInfoUtils_getInitialAttendeesList; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ ContactInfoUtils_getInitialFormValues; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ getAddressValidators; });
__webpack_require__.d(__webpack_exports__, "o", function() { return /* binding */ ContactInfoUtils_getValidators; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ ContactInfoUtils_getAdultCivilities; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ ContactInfoUtils_getHeaderContactInfoTitle; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ cleanUselessAttendeesValues; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ ContactInfoUtils_getGmNumbersOptions; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ ContactInfoUtils_findDuplicateAttendees; });
__webpack_require__.d(__webpack_exports__, "u", function() { return /* binding */ ContactInfoUtils_trackAttendeesFormError; });
__webpack_require__.d(__webpack_exports__, "p", function() { return /* binding */ ContactInfoUtils_isChildWillBeAdultByArrivalDate; });
__webpack_require__.d(__webpack_exports__, "v", function() { return /* binding */ ContactInfoUtils_tripInformationToAttendeesList; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ ContactInfoUtils_getChildrenToAdultsTransferList; });
__webpack_require__.d(__webpack_exports__, "s", function() { return /* binding */ submitOption; });
__webpack_require__.d(__webpack_exports__, "t", function() { return /* binding */ submitOptionFromProposal; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ getLegalInputInformation; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ getAllLegalInputTypes; });
__webpack_require__.d(__webpack_exports__, "q", function() { return /* binding */ renderErrorUpdatingAttendees; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ getAllAttendeesIds; });
__webpack_require__.d(__webpack_exports__, "r", function() { return /* binding */ ContactInfoUtils_shouldHideField; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ getDocumentsFields; });

// UNUSED EXPORTS: getNextCharacter, createId, getCNILLegalMessage, getLegalInformation, shouldDisplayLegalInformation

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("fYnN");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");

// CONCATENATED MODULE: ./src/client/components/widgets/participants/utils.js








var STRICT_REGEX = /[.-]/g;
var NON_STRICT_REGEX = /[^\d]/g;
var REJECT_CPF_LIST = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
function digitsVerifier(numbers) {
  var numberList = numbers.split('').map(function (number) {
    return parseInt(number, 10);
  });
  var modulo = numberList.length + 1;
  var multiplied = numberList.map(function (number, index) {
    return number * (modulo - index);
  });
  var mod = multiplied.reduce(function (buffer, number) {
    return buffer + number;
  }) % 11;
  return mod < 2 ? 0 : 11 - mod;
}
function isValidCPF(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var stripped = strip(cpf, isStrict); // CPF must be defined

  if (!stripped) {
    return false;
  } // CPF must have 11 chars


  if (stripped.length !== 11) {
    return false;
  }

  if (REJECT_CPF_LIST.includes(stripped)) {
    return false;
  }

  var numbers = stripped.substr(0, 9);
  numbers += digitsVerifier(numbers);
  numbers += digitsVerifier(numbers);
  return numbers.substr(-2) === stripped.substr(-2);
}
function strip(cpf) {
  var isStrict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regex = isStrict ? STRICT_REGEX : NON_STRICT_REGEX;
  return (cpf || '').toString().replace(regex, '');
}
// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/client/components/widgets/payment-info/PaymentInfo.const.js
var PaymentInfo_const = __webpack_require__("BU6i");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/status-code/statusCode.constants.js
var statusCode_constants = __webpack_require__("PSHn");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// EXTERNAL MODULE: ./src/utils/booking-process/constants.js
var constants = __webpack_require__("XpIN");

// EXTERNAL MODULE: ./src/utils/locale/constants.js
var locale_constants = __webpack_require__("qFX+");

// EXTERNAL MODULE: ./src/utils/context/contextUtils.js
var contextUtils = __webpack_require__("igjW");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/constants.js
var contact_info_constants = __webpack_require__("ZOp8");

// CONCATENATED MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js































var _this = undefined;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






















function getCNILLegalMessage() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cnilLegalMessage = legalMessages.find(function (legalMessage) {
    return legalMessage.id === contact_info_constants["a" /* CNIL_LEGAL_MESSAGE_ID */];
  });
  return cnilLegalMessage && Object(lodash["pick"])(cnilLegalMessage, ['label', 'description', 'required']);
}

function getLegalInputInformation() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  var type = arguments.length > 2 ? arguments[2] : undefined;
  return legalMessages.find(function (legalMessage) {
    return legalMessage.id === id && (type && legalMessage.type ? legalMessage.type === type : true);
  });
}

function getAllLegalInputTypes() {
  var legalMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var id = arguments.length > 1 ? arguments[1] : undefined;
  return legalMessages.filter(function (legalMessage) {
    return legalMessage.id === id;
  });
}

function getLegalInformation(beLegalInfos) {
  return function (id) {
    return (beLegalInfos || []).find(function (legalInfo) {
      return legalInfo.id === id;
    });
  };
}

var ContactInfoUtils_getOptinsInfos = function getOptinsInfos(bookingProcess) {
  var getLegalInfo = getLegalInformation(bookingProcess);
  return {
    email: getLegalInfo(legalInformationIds_constants["h" /* EMAIL_OPTIN */]),
    sms: getLegalInfo(legalInformationIds_constants["q" /* SMS_OPTIN */]),
    mail: getLegalInfo(legalInformationIds_constants["l" /* MAIL_OPTIN */]),
    fosun: getLegalInfo(legalInformationIds_constants["i" /* FOSUN_PARTNERS */]),
    phone: getLegalInfo(legalInformationIds_constants["o" /* PHONE_OPTIN */]),
    clubmedPlus: getLegalInfo(legalInformationIds_constants["a" /* CLUBMED_PLUS */]),
    theo: getLegalInfo(constants["e" /* LEGAL_INFO_WEBTHEO_ID */]),
    ndc: getLegalInfo(constants["c" /* LEGAL_INFO_NDC_ID */])
  };
};

function shouldDisplayLegalInformation(beLegalInfos) {
  var getLegalInfo = getLegalInformation(beLegalInfos);
  return function (id) {
    return !!getLegalInfo(id);
  };
}

function _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel, salesmanID) {
  return "\n    mutation {\n      bookings(\n        proposalId: \"".concat(params.proposalId, "\"\n        ").concat(hasSaveOption || isChequeOrTransferPaymentLabel ? 'bookingStatus: OPTION' : 'bookingStatus: PENDING_PAYMENT', "\n        ").concat(params.sellerEmail ? "sellerEmail: \"".concat(params.sellerEmail, "\"") : '', "\n        ").concat(salesmanID ? "salesmanID: \"".concat(salesmanID, "\"") : '', "\n      ) {\n        bookingId\n      }\n    }");
}

function submitOptionFromProposal(appContext, sellerEmail, selectedProposalId, productId, hasSaveOption, salesmanID, hasNoRedirection, withfutureTravelCredits) {
  var redirectTo = redirectUtils["a" /* default */].redirectToUri();
  return function (proposal) {
    var params = {
      proposalId: (proposal === null || proposal === void 0 ? void 0 : proposal.id) || '',
      sellerEmail: sellerEmail
    };
    var paymentMethodLabel = js_cookie_default.a.get(PaymentInfo_const["p" /* PAYMENT_METHOD_LABEL */]);
    var isChequeOrTransferPaymentLabel = paymentMethodLabel === PaymentInfo_const["b" /* CHEQUE_LABEL */] || paymentMethodLabel === PaymentInfo_const["a" /* BANK_TRANSFER_LABEL */]; // hide by default the salesmanID warning message if we have a not empty salesmanID

    if (appContext.isSeller) {
      js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(selectedProposalId), salesmanID === '' ? 'show' : 'hide', {
        secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
      });
    }

    var queryWithSalesmanID = _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel, salesmanID);

    var queryWithoutSalesmanID = _getOptionSubmissionRequest(appContext, params, hasSaveOption, isChequeOrTransferPaymentLabel);

    var handleSuccess = function handleSuccess(response) {
      var _response$bookings;

      var queryParams = _objectSpread({
        bi: (response === null || response === void 0 ? void 0 : (_response$bookings = response.bookings) === null || _response$bookings === void 0 ? void 0 : _response$bookings.bookingId) || '',
        selectedProposalId: selectedProposalId,
        productId: productId
      }, hasSaveOption && {
        hasSaveOption: hasSaveOption
      });

      if (withfutureTravelCredits) {
        queryParams.futureTravelCreditOption = true;
      }

      !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmation', {
        status: statusCode_constants["a" /* STATUS_CODE_200 */]
      }, queryParams))();
    };

    var handleError = function handleError(error) {
      var status = Object(lodash["get"])(error, 'errors[0].responseBody.status_code', statusCode_constants["b" /* STATUS_CODE_400 */]);
      var error_code = Object(lodash["get"])(error, 'errors[0].responseBody.errors[0].error_code', 'BOOKING_UNAVAILABLE');
      var error_description = Object(lodash["get"])(error, 'errors[0].responseBody.errors[0].error_description');

      if (status === statusCode_constants["b" /* STATUS_CODE_400 */] && error_code === contact_info_constants["i" /* WRONG_SALESMAN_ID */]) {
        // hide the salesmanID warning message if we have a wrong salesmanId on the confirmation page
        js_cookie_default.a.set("".concat(contact_info_constants["f" /* SALESMAN_ID_WARNING_MESSAGE */], "-").concat(selectedProposalId), 'show', {
          secure: !Object(contextUtils["d" /* isStrictlyDevelopmentEnv */])()
        });
        return graphqlClient["a" /* default */].runNoCacheQuery(queryWithoutSalesmanID, appContext, {
          requestName: requestDictionary["rd" /* PROPOSAL_UPDATE */]
        }).then(handleSuccess)["catch"](handleError);
      }

      !hasNoRedirection && redirectTo(Object(routeBuilder["a" /* buildUrl */])('optionConfirmationError', {
        status: status,
        error_code: error_code,
        error_description: error_description
      }, {
        selectedProposalId: selectedProposalId,
        productId: productId
      }))();
    };

    return graphqlClient["a" /* default */].runNoCacheQuery(queryWithSalesmanID, appContext, {
      requestName: requestDictionary["rd" /* PROPOSAL_UPDATE */]
    }).then(handleSuccess)["catch"](handleError);
  };
}

function submitOption(appContext, location, sellerEmail, hasSaveOption, salesmanID, withfutureTravelCredits) {
  var _location$queryParams = location.queryParams,
      selectedProposalId = _location$queryParams.selectedProposalId,
      productId = _location$queryParams.product;
  return submitOptionFromProposal(appContext, sellerEmail, selectedProposalId, productId, hasSaveOption, salesmanID, undefined, withfutureTravelCredits);
}

function renderErrorUpdatingAttendees(statusCode, i18n) {
  var message = '';

  switch (statusCode) {
    case statusCode_constants["f" /* STATUS_CODE_500 */]:
    case statusCode_constants["c" /* STATUS_CODE_401 */]:
      message = Object(lodash["get"])(i18n, 'booking.form.errors.technicalErrorParticipants');
      break;

    default:
      message = Object(lodash["get"])(i18n, 'booking.form.errorLabel');
      break;
  }

  return message;
}

var getAttendeeId = function getAttendeeId(_ref) {
  var neolid = _ref.neolid;
  return neolid;
};

var getAllAttendeesIds = function getAllAttendeesIds(_ref2) {
  var adults = _ref2.adults,
      kids = _ref2.kids;
  var allAttendeesIds = {};

  if (adults.length > 0) {
    allAttendeesIds.adultsAttendeesIds = adults.map(getAttendeeId).filter(Boolean);
  }

  if (kids.length > 0) {
    allAttendeesIds.kidsAttendeesIds = kids.map(getAttendeeId).filter(Boolean);
  }

  return allAttendeesIds;
};

var ContactInfoUtils_getInitialAttendeesList = function getInitialAttendeesList(_ref3) {
  var attendees = _ref3.attendees,
      connectedUserInfo = _ref3.connectedUserInfo; // defined the default lastName to that of connectedUser

  var adults = attendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      lastName: connectedUserInfo && !adult.lastName ? connectedUserInfo.lastName : adult.lastName,
      isMain: index === 0 || !!adult.gmNumber && index === attendees.adults.findIndex(function (_ref4) {
        var gmNumber = _ref4.gmNumber;
        return gmNumber === adult.gmNumber;
      })
    });
  }); // defined the default lastName to this of connectedUser

  var children = attendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      lastName: connectedUserInfo && !child.lastName ? connectedUserInfo.lastName : child.lastName
    });
  });
  return {
    adults: adults,
    children: children,
    all: [].concat(Object(toConsumableArray["a" /* default */])(adults.map(function (adult, index) {
      return _objectSpread(_objectSpread({}, adult), {}, {
        attendeeIndex: index
      });
    })), Object(toConsumableArray["a" /* default */])(children.map(function (child, index) {
      return _objectSpread(_objectSpread({}, child), {}, {
        attendeeIndex: index,
        isChild: true
      });
    })))
  };
};
var ContactInfoUtils_getInitialFormValues = function getInitialFormValues(_ref5) {
  var i18n = _ref5.i18n,
      initialAttendeesList = _ref5.initialAttendeesList,
      connectedUserInfo = _ref5.connectedUserInfo,
      hasAddress = _ref5.hasAddress,
      locale = _ref5.locale,
      sellerEmail = _ref5.sellerEmail,
      salesmanID = _ref5.salesmanID,
      displayParticipantsSelectInput = _ref5.displayParticipantsSelectInput,
      restOfDocumentLegalInfo = Object(objectWithoutProperties["a" /* default */])(_ref5, ["i18n", "initialAttendeesList", "connectedUserInfo", "hasAddress", "locale", "sellerEmail", "salesmanID", "displayParticipantsSelectInput"]);

  var showOnlyCountryCode = i18n.booking.participants.postalAddress.displayCountryFieldOnly;
  var optins = ContactInfoUtils_getOptinsInfos(i18n.bookingProcess); // The opt-ins show are configurable from the CMS, but we also don't show them for identified
  // users who already checked them

  var getOptinValue = function getOptinValue(optin, optinName, userInfo) {
    if (!optin) {
      return;
    } // in case of a connected user return undefined to not show it if already checked


    if (connectedUserInfo[optinName] === true) {
      return undefined;
    }

    if (userInfo[optinName] !== undefined) {
      return userInfo[optinName];
    }

    return optin.preChecked;
  };

  var defaultCountryCode = locale.split('-')[1];

  var getDocumentInfo = function getDocumentInfo(document, type) {
    var getFieldDefaultValue = function getFieldDefaultValue(value, field) {
      var _restOfDocumentLegalI;

      var defaultValue = {};

      if (((_restOfDocumentLegalI = restOfDocumentLegalInfo[field]) === null || _restOfDocumentLegalI === void 0 ? void 0 : _restOfDocumentLegalI.find(function (legalInfo) {
        return (legalInfo === null || legalInfo === void 0 ? void 0 : legalInfo.type) === type;
      })) && !value) {
        defaultValue[field] = defaultCountryCode;
      }

      return defaultValue;
    };

    var formattedDocument = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, document || {}), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.nationality, 'nationality')), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.issuingCountry, 'issuingCountry')), getFieldDefaultValue(document === null || document === void 0 ? void 0 : document.birthCountry, 'birthCountry')); // type is to be sent in Put Attendees should be in [PASSPORT, IDCARD]


    return Object(lodash["isEmpty"])(formattedDocument) ? null : _objectSpread(_objectSpread({}, formattedDocument), {}, {
      type: type
    });
  };

  return {
    seller: {
      email: sellerEmail,
      salesmanID: salesmanID
    },
    // $FlowFixMe temporarily disabled: waiting for clic evolv
    adults: initialAttendeesList.adults.map(function (adult) {
      var _i18n$booking, _i18n$booking$partici, _i18n$booking$partici2, _i18n$booking$partici3, _i18n$booking$partici4, _adult$document, _adult$document2, _adult$address;

      return _objectSpread(_objectSpread(_objectSpread({
        civility: displayParticipantsSelectInput ? '' : i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$partici = _i18n$booking.participants) === null || _i18n$booking$partici === void 0 ? void 0 : (_i18n$booking$partici2 = _i18n$booking$partici.civilities) === null || _i18n$booking$partici2 === void 0 ? void 0 : (_i18n$booking$partici3 = _i18n$booking$partici2.adult) === null || _i18n$booking$partici3 === void 0 ? void 0 : (_i18n$booking$partici4 = _i18n$booking$partici3[0]) === null || _i18n$booking$partici4 === void 0 ? void 0 : _i18n$booking$partici4.value
      }, adult), {}, {
        document: {
          passport: getDocumentInfo((_adult$document = adult.document) === null || _adult$document === void 0 ? void 0 : _adult$document.passport, legalInformationIds_constants["n" /* PASSPORT */]),
          idcard: getDocumentInfo((_adult$document2 = adult.document) === null || _adult$document2 === void 0 ? void 0 : _adult$document2.idcard, legalInformationIds_constants["j" /* IDCARD */])
        },
        birthdate: typeof adult.birthdate === 'number' ? adult.birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(adult.birthdate),
        address: adult.isMain && hasAddress ? _objectSpread(_objectSpread({}, showOnlyCountryCode ? null : adult.address), {}, {
          countryCode: ((_adult$address = adult.address) === null || _adult$address === void 0 ? void 0 : _adult$address.countryCode) || defaultCountryCode
        }) : undefined
      }, adult.isMain ? {
        optinEmail: getOptinValue(optins.email, 'optinEmail', adult),
        optinSms: getOptinValue(optins.sms, 'optinSms', adult),
        optinMail: getOptinValue(optins.mail, 'optinMail', adult),
        optinFosun: getOptinValue(optins.fosun, 'optinFosun', adult),
        optinPhone: getOptinValue(optins.phone, 'optinPhone', adult),
        optinClubmedPlus: getOptinValue(optins.clubmedPlus, 'optinClubmedPlus', adult),
        legalAgreement: false,
        checkAll: false
      } : null), {}, {
        // clear user info we don't want to store in the form state and in the store
        isMain: undefined,
        mainContactId: !adult.gmNumber && initialAttendeesList.adults[0].neolid ? initialAttendeesList.adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    }),
    // $FlowFixMe temporarily disabled: waiting for clic evolv
    children: initialAttendeesList.children.map(function (child) {
      var _child$document, _child$document2;

      return _objectSpread(_objectSpread({}, child), {}, {
        document: {
          passport: getDocumentInfo((_child$document = child.document) === null || _child$document === void 0 ? void 0 : _child$document.passport, legalInformationIds_constants["n" /* PASSPORT */]),
          idcard: getDocumentInfo((_child$document2 = child.document) === null || _child$document2 === void 0 ? void 0 : _child$document2.idcard, legalInformationIds_constants["j" /* IDCARD */])
        },
        birthdate: typeof child.birthdate === 'number' ? child.birthdate : Object(apiDate["d" /* apiDateToTimestamp */])(child.birthdate),
        mainContactId: !child.gmNumber && initialAttendeesList.adults[0].neolid ? initialAttendeesList.adults[0].neolid : '-1' // temporarily disabled: waiting for clic evolv

      });
    })
  };
};
function getAddressValidators(addressSchema) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref6$withRequired = _ref6.withRequired,
      withRequired = _ref6$withRequired === void 0 ? true : _ref6$withRequired,
      _ref6$messages = _ref6.messages,
      messages = _ref6$messages === void 0 ? {} : _ref6$messages;

  return addressSchema.reduce(function (addressValidators, fieldValidation) {
    var rule = lib["string"]();

    if (withRequired) {
      if (fieldValidation.required) {
        rule = rule.required(Object(src_i18n["h" /* t */])('common.form.errors.requiredField'));
      }
    }

    fieldValidation.validators.forEach(function (validator) {
      var _messages$fieldValida;

      var message = messages === null || messages === void 0 ? void 0 : (_messages$fieldValida = messages[fieldValidation.name]) === null || _messages$fieldValida === void 0 ? void 0 : _messages$fieldValida[validator.name];

      switch (validator.name) {
        case 'pattern':
          rule = rule.matches(new RegExp(validator.value), message || Object(src_i18n["h" /* t */])('common.form.errors.invalidFieldFormat'));
          break;

        case 'minLength':
          rule = rule.transform(function (value) {
            return value === '' ? undefined : value;
          }, message).min(validator.value, message || Object(src_i18n["h" /* t */])('common.form.errors.invalidFieldTooShort', {
            minlength: validator.value
          }));
          break;

        case 'maxLength':
          rule = rule.max(validator.value, message || Object(src_i18n["h" /* t */])('common.form.errors.invalidFieldTooLong', {
            maxlength: validator.value
          }));
          break;

        default:
          // eslint-disable-next-line no-console
          console.error("Cannot handle rule ".concat(validator.name));
      }
    });
    return _objectSpread(_objectSpread({}, addressValidators), {}, Object(defineProperty["a" /* default */])({}, fieldValidation.name, rule));
  }, {});
}
var ContactInfoUtils_getValidators = function getValidators(_ref7) {
  var nationality = _ref7.nationality,
      identityNumberInformation = _ref7.identityNumberInformation,
      addressSchema = _ref7.addressSchema,
      documentNumber = _ref7.documentNumber,
      expirationDate = _ref7.expirationDate,
      issuingDate = _ref7.issuingDate,
      locale = _ref7.locale,
      departureDate = _ref7.departureDate,
      arrivalDate = _ref7.arrivalDate,
      adultCivilities = _ref7.adultCivilities,
      childCivilities = _ref7.childCivilities,
      userIsSeller = _ref7.userIsSeller,
      issuingCountry = _ref7.issuingCountry,
      birthCountry = _ref7.birthCountry;
  var strictNameValidator = lib["string"]().matches(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/);
  var baseWordValidator = strictNameValidator.matches(/^[\x20-\xFF]+$/); // ASCII

  var phoneRegex = Object(RegexHelper["b" /* getPhoneRegex */])(locale);
  var rawValidators = {
    adultCivilities: lib["string"]().oneOf(adultCivilities).required(),
    childCivilities: lib["string"]().oneOf(childCivilities).required(),
    firstName: baseWordValidator.max(20).required(),
    lastName: baseWordValidator.max(30).required(),
    unicodeFirstName: strictNameValidator.max(100).required(),
    unicodeLastName: strictNameValidator.max(100).required(),
    adultBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()(arrivalDate).subtract(contact_info_constants["j" /* YEAR_OF_MAJORITY */], 'y')).min(moment_default()().subtract(contact_info_constants["c" /* MAX_AGE */], 'y')).required(),
    childBirthDate: lib["date"]().transform(function (value, initialValue) {
      return initialValue ? new Date(initialValue) : initialValue;
    }).max(moment_default()()).min(moment_default()().subtract(contact_info_constants["j" /* YEAR_OF_MAJORITY */], 'y')).required(),
    email: lib["string"]().matches(RegexHelper["a" /* emailRegex */]).required(),
    mobile: lib["string"]().matches(phoneRegex).required(),
    healthPassId: lib["string"]().length(10),
    emailNotRequired: lib["string"]().email(),
    mobileNotRequired: lib["string"]().transform(function (v) {
      return !v ? undefined : v;
    }) // transform to undefined when empty string to pass the regex
    .matches(phoneRegex),
    documentNumber: function () {
      if (!documentNumber) {
        return;
      }

      var rule = lib["string"]().matches(/[a-zA-Z0-9]{6,}/, {
        excludeEmptyString: true
      }).transform(function (__, initialValue) {
        return initialValue ? initialValue.replace(/ /g, '') : initialValue;
      }).max(30); // redo the fields validation

      return documentNumber.required && !userIsSeller ? rule.required() : rule;
    }(),
    expirationDate: function () {
      if (!expirationDate) {
        return;
      }

      var rule = lib["date"]().transform(function (value, initialValue) {
        return initialValue ? new Date(initialValue) : initialValue;
      }).min(moment_default()(departureDate).add(1, 'd'));
      return expirationDate.required && !userIsSeller ? rule.required() : rule;
    }(),
    issuingDate: function () {
      if (!issuingDate) {
        return;
      }

      var rule = lib["date"]().transform(function (value, initialValue) {
        return initialValue ? new Date(initialValue) : initialValue;
      }).max(moment_default()(arrivalDate).subtract(1, 'd'));
      return issuingDate.required && !userIsSeller ? rule.required() : rule;
    }(),
    nationality: function () {
      if (!nationality) {
        return;
      }

      var rule = lib["string"]();
      return nationality.required && !userIsSeller ? rule.required() : rule;
    }(),
    issuingCountry: function () {
      if (!issuingCountry) {
        return;
      }

      var rule = lib["string"]();
      return issuingCountry.required && !userIsSeller ? rule.required() : rule;
    }(),
    birthCountry: function () {
      if (!birthCountry) {
        return;
      }

      var rule = lib["string"]();
      return birthCountry.required && !userIsSeller ? rule.required() : rule;
    }(),
    identityNumber: function () {
      if (!identityNumberInformation) {
        return;
      }

      var brazilCpfRule = lib["string"]().test('', '', function (value) {
        value && value.replace(/ /g, '');

        if (value.length < 11 || value.length > 14 || !isValidCPF(value)) {
          // $FlowFixMe should use the function syntax instead of the arrow, but it only works this way
          return _this.createError();
        }
      });
      var rule = lib["string"]().matches(/[a-zA-Z0-9]{6,}/, {
        excludeEmptyString: true
      }).transform(function (__, initialValue) {
        return initialValue ? initialValue.replace(/ /g, '') : initialValue;
      }).max(30);
      var finalRule = locale === locale_constants["a" /* LOCALES */].PT_BR ? brazilCpfRule : rule;
      return identityNumberInformation.required ? finalRule.required() : finalRule;
    }(),
    legalAgreement: lib["mixed"]().oneOf([true]).required(),
    gmNumber: lib["string"]().required(),
    salesmanID: lib["string"]().matches(RegexHelper["e" /* salesmanIDRegex */])
  }; // $FlowFixMe

  return _objectSpread(_objectSpread({}, rawValidators), {}, {
    address: getAddressValidators(addressSchema)
  });
};

function getDocumentsFields(bookingProcess) {
  return legalInformationIds_constants["g" /* DOCUMENT_TYPES */].reduce(function (fields, type) {
    var filteredFields = {
      type: type.toLowerCase(),
      values: bookingProcess.filter(function (field) {
        return field.type === type;
      })
    }; // returns all fields in bookingProcess or TransportBookingProcess with the current type(s)

    filteredFields.values.length > 0 && fields.push(filteredFields);
    return fields;
  }, []);
}

var ContactInfoUtils_getAdultCivilities = function getAdultCivilities(defaultCivilities, locale) {
  var adultCivilities = Object(dist["getAdultsCivilities"])(locale);
  return Object(lodash["isEmpty"])(adultCivilities) ? defaultCivilities : adultCivilities;
};
var ContactInfoUtils_getHeaderContactInfoTitle = function getHeaderContactInfoTitle(_ref8) {
  var isValid = _ref8.isValid,
      isMain = _ref8.isMain,
      isChild = _ref8.isChild,
      displayUnicodeFields = _ref8.displayUnicodeFields,
      formValues = _ref8.formValues,
      attendeeIdentifier = _ref8.attendeeIdentifier,
      attendeeIndex = _ref8.attendeeIndex;

  if (isValid) {
    if (displayUnicodeFields) {
      return "".concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".unicodeFirstName")), " ").concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".unicodeLastName")));
    }

    return "".concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".firstName")), " ").concat(Object(lodash["get"])(formValues, "".concat(attendeeIdentifier, ".lastName")));
  }

  if (isMain) {
    return Object(src_i18n["h" /* t */])('booking.participants.personnalInfosHeader.title');
  }

  if (isChild) {
    return "".concat(Object(src_i18n["h" /* t */])('booking.participants.otherKidsInfosHeader.title'), " ").concat(attendeeIndex + 1);
  }

  return "".concat(Object(src_i18n["h" /* t */])('booking.participants.otherAdultsInfosHeader.title'), " ").concat(attendeeIndex);
};
var cleanUselessAttendeesValues = function cleanUselessAttendeesValues(_ref9) {
  var adults = _ref9.adults,
      children = _ref9.children;
  return {
    children: children,
    // clear legalAgreement, it's not need in the store it's just to block the form
    adults: adults.map(function (adult) {
      return _objectSpread(_objectSpread({}, adult), {}, {
        legalAgreement: undefined
      });
    })
  };
};
var ContactInfoUtils_getGmNumbersOptions = function getGmNumbersOptions(_ref10) {
  var formik = _ref10.formik,
      i18n = _ref10.i18n,
      previousGmNumberOptions = _ref10.previousGmNumberOptions; // we use a negative gmNumber to know that it's a new gm

  var newGmNumber = -1;
  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(formik.values.adults), Object(toConsumableArray["a" /* default */])(formik.values.children)).filter(function (attendee) {
    return !Object(lodash["isNil"])(attendee);
  });
  return [].concat(Object(toConsumableArray["a" /* default */])(attendeesList === null || attendeesList === void 0 ? void 0 : attendeesList.reduce(function (accGmNumbersOptions, attendee, index) {
    if (attendee && !attendee.gmNumber && !attendee.mainContactId) {
      return accGmNumbersOptions;
    }

    var _attendee$firstName = attendee.firstName,
        firstName = _attendee$firstName === void 0 ? '' : _attendee$firstName,
        _attendee$lastName = attendee.lastName,
        lastName = _attendee$lastName === void 0 ? '' : _attendee$lastName;
    var gmNumbersOptionsIndex = accGmNumbersOptions.findIndex(function (_ref11) {
      var gmNumber = _ref11.gmNumber,
          value = _ref11.value;
      return gmNumber === attendee.gmNumber || value === attendee.mainContactId;
    });

    if (gmNumbersOptionsIndex > -1) {
      accGmNumbersOptions[gmNumbersOptionsIndex].name += ", ".concat(firstName, " ").concat(lastName);
      return accGmNumbersOptions;
    }

    if (!attendee.gmNumber && attendee.mainContactId < 0) {
      var previousNewHouseholdOption = previousGmNumberOptions.find(function (_ref12) {
        var gmNumber = _ref12.gmNumber;
        return gmNumber === attendee.mainContactId;
      });
      /**
       * if the main contact of a previously created new household is deleted (=> the user change his household)
       * and there is other attendees on this household, we prevent this household to be in the options
       * and we will reset them later in the provider
       */

      if (previousNewHouseholdOption && previousNewHouseholdOption.mainContactIndex !== index) {
        return accGmNumbersOptions;
      } // when a new household is created update the id for a potential next-one


      newGmNumber--;
      return [].concat(Object(toConsumableArray["a" /* default */])(accGmNumbersOptions), [{
        mainContactIndex: index,
        gmNumber: attendee.mainContactId,
        value: attendee.mainContactId,
        name: "".concat(i18n.booking.participants.labels.gmNumber, " ").concat(lastName, " - ").concat(firstName, " ").concat(lastName)
      }]);
    }

    return [].concat(Object(toConsumableArray["a" /* default */])(accGmNumbersOptions), [{
      gmNumber: attendee.gmNumber,
      value: attendee.neolid,
      name: "".concat(attendee.gmNumber, " - ").concat(firstName, " ").concat(lastName)
    }]);
  }, [// select placeholder
  {
    name: i18n.booking.participants.labels.selectGmNumber,
    value: '',
    gmNumber: null
  }])), [{
    // select new household action option
    name: i18n.booking.participants.labels.createGmNumber,
    value: newGmNumber
  }]);
};

var ContactInfoUtils_shouldHideField = function shouldHideField(_ref13) {
  var connectedUserInfo = _ref13.connectedUserInfo,
      userIsSeller = _ref13.userIsSeller,
      formInitialValues = _ref13.formInitialValues,
      fieldName = _ref13.fieldName,
      attendeeIdentifier = _ref13.attendeeIdentifier,
      fieldNameConnectedUserOverride = _ref13.fieldNameConnectedUserOverride;

  if (connectedUserInfo && (fieldNameConnectedUserOverride && connectedUserInfo[fieldNameConnectedUserOverride] || connectedUserInfo[fieldName])) {
    return true;
  } // if the attendee has a gmNumber he is identified and if he has a value for the field
  // we don't want to permit the seller to modified the field #11741


  return !!(userIsSeller && Object(lodash["get"])(formInitialValues, "".concat(attendeeIdentifier, ".neolid")) && Object(lodash["get"])(formInitialValues, "".concat(attendeeIdentifier, ".").concat(fieldName)));
};

var ContactInfoUtils_findDuplicateAttendees = function findDuplicateAttendees(attendees) {
  var duplicates = attendees.reduce(function (acc, _ref14, index) {
    var birthdate = _ref14.birthdate,
        lastName = _ref14.lastName,
        firstName = _ref14.firstName;

    if (birthdate && lastName && firstName) {
      var key = "".concat(birthdate).concat(lastName).concat(firstName).toLocaleLowerCase();

      if (acc[key]) {
        acc[key].push(index);
      } else {
        acc[key] = [index];
      }
    }

    return acc;
  }, {});
  Object.keys(duplicates).forEach(function (key) {
    if (duplicates[key].length < 2) {
      delete duplicates[key];
    }
  }); // $FlowFixMe return indexes of duplicate attendees

  return Object(lodash["flatten"])(Object.values(duplicates));
};
var ContactInfoUtils_trackAttendeesFormError = function trackAttendeesFormError(track, formik) {
  var _formik$errors, _formik$errors2;

  var duplicatedAttendeeFieldsInError = ['firstName', 'lastName', 'birthdate'];
  var hasDuplicatedAttendeesErrorAlreadyBeenTracked = false;
  var formErrors = [].concat(Object(toConsumableArray["a" /* default */])(((_formik$errors = formik.errors) === null || _formik$errors === void 0 ? void 0 : _formik$errors.adults) || []), Object(toConsumableArray["a" /* default */])(((_formik$errors2 = formik.errors) === null || _formik$errors2 === void 0 ? void 0 : _formik$errors2.children) || []));
  formErrors.forEach(function (error) {
    if (!error) {
      // formik.errors.adults and formik.errors.children (when they are present) are the same size
      // as formik.values.adults and formik.values.children with undefined at that index if there
      // is no error for this attendee
      return;
    }

    var errorEntries = Object.entries(error);
    errorEntries.forEach(function (_ref15) {
      var _ref16 = Object(slicedToArray["a" /* default */])(_ref15, 2),
          field = _ref16[0],
          errorValue = _ref16[1]; // when there is a duplicated attendees error,
      // firstName, lastName and birthdate are set in error whose value is true
      // when the field is in error for an other reason, the error value is an error message


      var isDuplicatedAttendeeError = duplicatedAttendeeFieldsInError.includes(field) && errorValue === true;

      if (isDuplicatedAttendeeError && !hasDuplicatedAttendeesErrorAlreadyBeenTracked) {
        hasDuplicatedAttendeesErrorAlreadyBeenTracked = true;
        track({
          categoryGA: 'bookingEngine',
          actionGA: 'participant',
          labelGA: 'error_sameAttendees'
        });
      }

      if (!isDuplicatedAttendeeError) {
        if (Object(lodash["isObject"])(errorValue)) {
          var nestedFieldsInError = Object.keys(errorValue);
          nestedFieldsInError.forEach(function (nestedField) {
            track({
              categoryGA: 'bookingEngine',
              actionGA: 'participant',
              labelGA: "error_fieldError_".concat(nestedField)
            });
          });
        } else {
          track({
            categoryGA: 'bookingEngine',
            actionGA: 'participant',
            labelGA: "error_fieldError_".concat(field)
          });
        }
      }
    });
  });
};

var ContactInfoUtils_parseBirthdate = function parseBirthdate(birthdate) {
  if (typeof birthdate === 'string') {
    return moment_default()(birthdate).valueOf();
  }

  return birthdate;
};

var ContactInfoUtils_isChildWillBeAdultByArrivalDate = function isChildWillBeAdultByArrivalDate(childBirthdate, arrivalDate) {
  var childBirthdateValue = ContactInfoUtils_parseBirthdate(childBirthdate);
  var childAge = moment_default()().diff(childBirthdateValue, 'years');
  var childAgeByArrivalDate = moment_default()(arrivalDate).diff(childBirthdateValue, 'years');
  return childAge < 18 && childAgeByArrivalDate >= 18;
};
var ContactInfoUtils_tripInformationToAttendeesList = function tripInformationToAttendeesList(tripInformation) {
  var attendeesList = [].concat(Object(toConsumableArray["a" /* default */])(tripInformation.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread({}, adult), {}, {
      isMain: index === 0
    });
  })), Object(toConsumableArray["a" /* default */])(tripInformation.kids.map(function (child) {
    return _objectSpread(_objectSpread({}, child), {}, {
      isChild: true
    });
  })));
  return {
    adults: attendeesList.filter(function (_ref17) {
      var isChild = _ref17.isChild;
      return !isChild;
    }),
    children: attendeesList.filter(function (_ref18) {
      var isChild = _ref18.isChild;
      return isChild;
    }),
    all: attendeesList.map(function (attendee, index) {
      return _objectSpread(_objectSpread({}, attendee), {}, {
        attendeeIndex: Number(index)
      });
    })
  };
};
var getNextCharacter = function getNextCharacter(_char) {
  return String.fromCharCode(_char.charCodeAt(0) + 1);
};
var createId = function createId(index, _char2) {
  return String.fromCharCode(_char2.charCodeAt(0) + index);
};
var ContactInfoUtils_getChildrenToAdultsTransferList = function getChildrenToAdultsTransferList(attendeesList, arrivalDate) {
  var adults = attendeesList.adults,
      children = attendeesList.children;

  var toBeAdultFilter = function toBeAdultFilter(_ref19) {
    var birthdate = _ref19.birthdate;
    return birthdate && ContactInfoUtils_isChildWillBeAdultByArrivalDate(birthdate, arrivalDate);
  };

  var indexMap = function indexMap(attendee, index) {
    return _objectSpread(_objectSpread({}, attendee), {}, {
      attendeeIndex: Number(index)
    });
  }; // $FlowFixMe


  var adultMapper = function adultMapper(_ref20) {
    var civility = _ref20.civility,
        firstName = _ref20.firstName,
        lastName = _ref20.lastName,
        birthdate = _ref20.birthdate,
        neolid = _ref20.neolid,
        gmNumber = _ref20.gmNumber;
    return {
      civility: civility,
      firstName: firstName,
      lastName: lastName,
      birthdate: birthdate,
      neolid: neolid,
      gmNumber: gmNumber,
      isMain: false
    };
  };

  var adultsList = [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(children.filter(toBeAdultFilter).map(adultMapper))).map(function (el, index) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: createId(index, 'A')
    });
  });
  var nextId = getNextCharacter(adultsList[adultsList.length - 1].id);
  var childrenList = children.filter(function (child) {
    return !children.filter(toBeAdultFilter).includes(child);
  }).map(function (el, index) {
    return _objectSpread(_objectSpread({}, el), {}, {
      id: createId(index, nextId)
    });
  });
  return {
    adultsList: adultsList,
    childrenList: childrenList,
    allList: [].concat(Object(toConsumableArray["a" /* default */])(adultsList.map(indexMap)), Object(toConsumableArray["a" /* default */])(childrenList.map(indexMap)))
  };
};


/***/ }),

/***/ "ZKlR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TabHeader; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.themes.js




var themes = {
  clean: function clean(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].TURQUOISE;
    return {
      thBody: 'flex h-full items-center',
      thChildren: 'flex-auto flex font-bold items-center justify-center leading-one text-sm md:text-md',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: "".concat(isActive ? "text-".concat(currentColor) : "text-gray-darker focus:text-".concat(currentColor, " hover:text-").concat(currentColor), " px-px15 py-px10 transition-color"),
      thToggleIcon: "flex-shrink-0 leading-none text-gray-dark rtl:ml-px10 ".concat(isActive ? 'rotate-360' : 'rotate-0'),
      thToggleIconWidth: '0.75rem'
    };
  },
  "default": function _default(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].BLUE;
    return {
      thBody: 'flex h-full items-center py-px15 px-px10',
      thChildren: 'flex-grow flex items-center justify-center leading-one px-px10 text-white',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: "bg-current ".concat(isActive ? "text-".concat(currentColor, "-active arrow-down arrow-").concat(currentColor, "-active") : "text-".concat(currentColor, " focus:text-").concat(currentColor, "-active hover:text-").concat(currentColor, "-active"), " text-base text-center transition-color w-full"),
      thToggleIcon: "flex-shrink-0 leading-none text-white rtl:ml-px10 ".concat(isActive ? 'rotate-360' : 'rotate-0'),
      thToggleIconWidth: '0.625rem'
    };
  },
  rounded: function rounded(_ref) {
    var isActive = _ref.isActive;
    return {
      thRoot: classnames_default()('border-1 border-gray-light border-solid rounded-t-tiny', {
        'bg-gray-lighter': !isActive,
        'bg-white border-b-0 arrow-down-top arrow-turquoise': isActive
      }),
      thBody: 'flex items-center justify-between',
      thChildren: 'flex-1 flex items-center justify-center',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 text-blue',
      thToggleIconWidth: '0.75rem'
    };
  },
  flat: function flat(_ref2) {
    var isActive = _ref2.isActive;
    return {
      thBody: classnames_default()('border-t-1 border-l-1 border-r-1 flex h-full items-center p-px10 md:px-px20 md:py-px10 transition-colors', {
        'bg-white border-b-white': isActive,
        'bg-gray-lighter border-b-1': !isActive
      }),
      thChildren: classnames_default()('justify-center flex-grow flex font-brand items-center leading-tight text-blue text-sm md:text-lg', {
        'opacity-50': !isActive
      }),
      thIcon: '',
      thIconWidth: '',
      thRoot: classnames_default()('overflow-hidden rounded-tiny', {
        'z-2': isActive
      }),
      thToggleIcon: '',
      thToggleIconWidth: ''
    };
  },
  simple: function simple(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].TURQUOISE;
    return {
      thRoot: "".concat(isActive ? "text-".concat(currentColor, " border-").concat(currentColor, " arrow-down arrow-").concat(currentColor) : "text-white hover:text-".concat(currentColor, " border-gray-light hover:border-").concat(currentColor), " bg-current border-1 flex-initial font-bold rounded text-sm text-center transition-colors uppercase"),
      thBody: "flex h-full items-center p-px10 ".concat(isActive ? 'text-white' : 'text-gray-darker focus:text-white hover:text-white transition-color'),
      thChildren: 'flex-grow flex items-center justify-center p-px10',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thToggleIcon: 'flex-shrink-0 leading-none m-px10',
      thToggleIconWidth: '0.625rem'
    };
  },
  lite: function lite(props) {
    var color = props.color,
        isActive = props.isActive;
    var currentColor = color || colors["a" /* COLORS */].GRAY_DARKER;
    return {
      thBody: 'flex items-center',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: classnames_default()("py-px5 px-px10 rounded-tiny text-".concat(currentColor, " text-md transition-bg-color"), {
        'bg-white': !isActive,
        'bg-overlay-blue-10 font-bold': isActive
      }),
      thToggleIcon: 'flex-shrink-0 leading-none m-px10',
      thToggleIconWidth: '0.625rem'
    };
  },
  buttons: function buttons(props) {
    var _classnames;

    var color = props.color,
        isActive = props.isActive,
        _props$modifierClassN = props.modifierClassNames,
        modifierClassNames = _props$modifierClassN === void 0 ? {} : _props$modifierClassN;
    var activeClassName = modifierClassNames.active,
        inactiveClassName = modifierClassNames.inactive;
    return {
      thBody: 'flex items-center justify-center',
      thIcon: 'flex-shrink-0 rtl:mr-px10',
      thIconWidth: '1em',
      thRoot: classnames_default()('py-px10 px-px20 text-base relative overflow-hidden flex-shrink-0 font-bold', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-white border-0 border-solid border-1 border-gray-light text-gray-darker rounded-tiny -mx-px ".concat(inactiveClassName), !isActive), Object(defineProperty["a" /* default */])(_classnames, "z-1 rounded-tiny border-gray-light border-1 border-solid ".concat(color ? "text-".concat(color) : 'text-blue', " shadow ").concat(activeClassName), isActive), _classnames)),
      thRootStyle: {
        minWidth: 'calc(140rem / 16)'
      },
      thToggleIcon: 'flex-shrink-0 leading-none m-px10',
      thToggleIconWidth: '0.625rem',
      thIndicator: classnames_default()({
        'absolute bg-current bottom-0 inset-x-0': isActive
      }),
      thIndicatorStyle: isActive ? {
        height: '3px'
      } : {}
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/tab-header/TabHeader.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







// $FlowFixMe
var TabHeader = /*#__PURE__*/Object(react["forwardRef"])(function (props, ref) {
  var children = props.children,
      className = props.className,
      collapseIconName = props.collapseIconName,
      controlsId = props.controlsId,
      _props$dataTestId = props.dataTestId,
      dataTestId = _props$dataTestId === void 0 ? 'tab-header' : _props$dataTestId,
      expandIconName = props.expandIconName,
      iconName = props.iconName,
      id = props.id,
      isAccordion = props.isAccordion,
      isActive = props.isActive,
      isDisabled = props.isDisabled,
      _onClick = props.onClick,
      onKeyDown = props.onKeyDown,
      role = props.role,
      style = props.style,
      tabIndex = props.tabIndex,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      trackingData = props.trackingData;
  var track = !isActive && trackingData ? Object(useTracking["a" /* useTracking */])(trackingData) : lodash["noop"];

  var _themes$theme = themes[theme](props),
      thBody = _themes$theme.thBody,
      thChildren = _themes$theme.thChildren,
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thRootStyle = _themes$theme.thRootStyle,
      thToggleIcon = _themes$theme.thToggleIcon,
      thToggleIconWidth = _themes$theme.thToggleIconWidth,
      thIndicator = _themes$theme.thIndicator,
      thIndicatorStyle = _themes$theme.thIndicatorStyle;

  var toggleIcon = isActive ? collapseIconName : expandIconName;

  var aria = _objectSpread(_objectSpread({}, controlsId ? {
    'aria-controls': controlsId
  } : null), isAccordion ? {
    'aria-expanded': isActive
  } : {
    'aria-selected': isActive
  });

  return __jsx("button", Object(esm_extends["a" /* default */])({}, aria, {
    className: classnames_default()(className, 'reset-button', thRoot),
    "data-cs-override-id": "TabHeader" // ContentSquare must ignore this id see https://docs.contentsquare.com/uxa-fr/#ignorer-remplacer-ou-ajouter-un-id
    ,
    "data-testid": dataTestId,
    disabled: isDisabled,
    onClick: function onClick() {
      _onClick && _onClick();
      track({});
    },
    onKeyDown: onKeyDown,
    id: id,
    ref: ref,
    role: role,
    style: _objectSpread(_objectSpread({}, style), thRootStyle),
    tabIndex: tabIndex,
    type: "button"
  }), __jsx("div", {
    className: thBody
  }, __jsx("div", {
    className: thChildren
  }, !!iconName && __jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), children), !!toggleIcon && __jsx(Icon["a" /* Icon */], {
    className: thToggleIcon,
    name: toggleIcon,
    width: thToggleIconWidth
  })), __jsx("div", {
    className: thIndicator,
    style: thIndicatorStyle
  }));
});

/***/ }),

/***/ "ZLJe":
/***/ (function(module) {

module.exports = JSON.parse("{\"amp\":\"&\",\"apos\":\"'\",\"gt\":\">\",\"lt\":\"<\",\"quot\":\"\\\"\"}");

/***/ }),

/***/ "ZP80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FETCH_PREBOOKING_TRAVELERS; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ fetchPrebookingTravelers; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/BookingAttendeesProfile.fragment.js
var BookingAttendeesProfile_fragment = __webpack_require__("SQLw");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngine.query.js
var BookingEngine_query = __webpack_require__("MAH5");

// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.queries.js



function travelerProfilesQuery(_ref) {
  var adults = _ref.adults,
      kids = _ref.kids;
  return "\n    {\n      ".concat(Object(BookingEngine_query["a" /* getCxoAttendeesData */])({
    adultsAttendeesIds: adults,
    kidsAttendeesIds: kids
  }), "\n    }\n    ").concat(adults && adults[0] || kids && kids[0] ? BookingAttendeesProfile_fragment["a" /* default */] : '', "\n  ");
}
// CONCATENATED MODULE: ./src/client/store/prebooking-form/prebookingform.action.js








var FETCH_PREBOOKING_TRAVELERS = 'FETCH_PREBOOKING_TRAVELERS';
function fetchPrebookingTravelers(params, appContext) {
  return function (dispatch) {
    if (!params.adults || params.adults.length === 0) {
      return Promise.reject();
    }

    var query = travelerProfilesQuery(params);
    var promise = graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
      requestName: requestDictionary["bb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_FETCH_TRAVELERS */]
    })["catch"](function (error) {
      if (error.errors && error.errors.some(function (e) {
        return e.statusCode === 401;
      })) {
        Object(sellerUtils["f" /* handle401GraphqlErrorSeller */])(error, appContext);
      }

      return {};
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(FETCH_PREBOOKING_TRAVELERS, params, {
      optimist: true,
      promise: promise
    }));
  };
}

/***/ }),

/***/ "ZS6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductPriceInfo; });
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qqKu");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("RPju");

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;









var ProductPriceInfo = function ProductPriceInfo(_ref) {
  var city = _ref.city,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      onClick = _ref.onClick,
      startDate = _ref.startDate,
      unit = _ref.unit;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_1__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_9__[/* ReactPageContext */ "a"]),
      pageType = _useContext.pageType;

  var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_2__["b2cPagesService"].isMicePage(pageType);
  var isAllInclusive = !isJoyview && !isTour; // eslint-disable-next-line no-nested-ternary

  var buttonLabel = isTour ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonTourLabel') : isCruise ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonCruiseLabel') : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.buttonLabel');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_1__["Fragment"], null, __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_8__[/* Text */ "a"], {
    className: "p-px20",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].GRAY_DARKER,
    text: isMice ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionForME', {
      unit: unit
    }) : [hasTransport ? Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithTransport', {
      unit: unit,
      city: city,
      endDate: endDate,
      startDate: startDate
    }) : Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
      endDate: endDate,
      startDate: startDate,
      unit: unit
    }), Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.roomAvailability')].join(' '),
    theme: "text-sans-2"
  }), (isAllInclusive || isJoyview || onClick) && __jsx("div", {
    className: "flex flex-col items-center border-t-1 border-gray-light p-px20"
  }, isAllInclusive && __jsx("p", {
    className: "flex flex-col sm:flex-row sm:flex-wrap sm:justify-center max-w-full reset-paragraph text-center text-gray-darker text-sm"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.pricePopin.priceIsLabel'), ' ', __jsx("span", {
    className: "font-brand rtl:ml-px5 text-blue text-md"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "-mt-px5 rtl:mr-px5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].ALL_INCLUSIVE,
    width: "1.2rem"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* t */ "h"])('resort.startingPrice.allInclusive'))), isJoyview && __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_7__[/* Icon */ "a"], {
    className: "-mt-px5 rtl:mr-px5",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].WATER_GREEN,
    isNotSquare: true,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_4__[/* ICONS */ "a"].CLUBMED_JOYVIEW,
    width: "10rem"
  }), onClick && __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_6__[/* Button */ "a"], {
    className: "mt-px10",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BOOKING,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].BOOKING,
    dataTestId: "ProductPriceInfo-button",
    onClick: onClick
  }, buttonLabel)));
};

/***/ }),

/***/ "ZVqJ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var getBuiltIn = __webpack_require__("x90g");
var aConstructor = __webpack_require__("jCye");
var anObject = __webpack_require__("ep/x");
var isObject = __webpack_require__("1YFU");
var create = __webpack_require__("Znn2");
var bind = __webpack_require__("C56r");
var fails = __webpack_require__("fhLv");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "ZiN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var IS_PURE = __webpack_require__("SRps");
var FunctionName = __webpack_require__("mu8A");
var isCallable = __webpack_require__("ANQd");
var createIteratorConstructor = __webpack_require__("oScl");
var getPrototypeOf = __webpack_require__("yvHl");
var setPrototypeOf = __webpack_require__("iBXc");
var setToStringTag = __webpack_require__("CGO5");
var createNonEnumerableProperty = __webpack_require__("g51W");
var redefine = __webpack_require__("L1Xj");
var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");
var IteratorsCore = __webpack_require__("JpEK");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          redefine(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return nativeIterator.call(this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "Znn2":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("ep/x");
var defineProperties = __webpack_require__("HKx7");
var enumBugKeys = __webpack_require__("WSQK");
var hiddenKeys = __webpack_require__("qXr/");
var html = __webpack_require__("QknU");
var documentCreateElement = __webpack_require__("a4SZ");
var sharedKey = __webpack_require__("mmil");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "ZoVA":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = fn.call(input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "ZpYc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ StripButton_StripButton; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.themes.js


var StripButton_themes_themes = function themes(_ref) {
  var color = _ref.color,
      colorBorder = _ref.colorBorder,
      onClick = _ref.onClick,
      orientation = _ref.orientation;
  return {
    "default": {
      thRoot: classnames_default()('flex relative', {
        'reset-button': onClick
      }),
      thInner: "bg-".concat(color, " border-").concat(orientation === 'top' ? 't' : 'b', "-1 border-").concat(colorBorder, " -m").concat(orientation === 'top' ? 'x' : '', "-px overflow-hidden px-px5 stripButton-text p").concat(orientation === 'top' ? 't' : 'b', "-px5 text-center whitespace-no-wrap")
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx

var __jsx = react_default.a.createElement;





var StripButton_StripButtonSvg = function StripButtonSvg(_ref) {
  var className = _ref.className,
      color = _ref.color,
      colorBorder = _ref.colorBorder,
      height = _ref.height,
      hasBottomOrientation = _ref.hasBottomOrientation;
  return __jsx("svg", {
    className: classnames_default()(className, 'fill-current', "text-".concat(color)),
    viewBox: "0 0 15 30",
    height: height,
    style: {
      flexBasis: height / 2
    }
  }, __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    d: "M10,21H-5L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))), __jsx("g", null, __jsx("g", {
    transform: "translate(-61.000000, ".concat(hasBottomOrientation ? -155.5 : -156.5, ")")
  }, __jsx("g", {
    transform: "translate(66.000000, 166.000000)"
  }, __jsx("g", null, __jsx("g", null, __jsx("path", {
    style: {
      strokeWidth: '1px'
    },
    className: "fill-transparent stroke-current text-".concat(colorBorder),
    d: "M-5,21L2.8-3.6C3.9-6.8,6.8-9,10-9"
  })))))));
};

var StripButton_StripButton = function StripButton(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$color,
      _ref2$colorBorder = _ref2.colorBorder,
      colorBorder = _ref2$colorBorder === void 0 ? colors["a" /* COLORS */].GRAY_LIGHT : _ref2$colorBorder,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'strip-button' : _ref2$dataTestId,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? 30 : _ref2$height,
      onClick = _ref2.onClick,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === void 0 ? 'top' : _ref2$orientation,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = StripButton_themes_themes({
    color: color,
    colorBorder: colorBorder,
    onClick: onClick,
    orientation: orientation
  })[theme],
      thInner = _themes$theme.thInner,
      thRoot = _themes$theme.thRoot;
  var hasBottomOrientation = orientation === 'bottom';
  var svgProps = {
    color: color,
    colorBorder: colorBorder,
    height: height,
    hasBottomOrientation: hasBottomOrientation
  };
  var TagName = onClick ? 'button' : 'div';
  var btnProps = onClick ? {
    onClick: onClick,
    type: 'button'
  } : null;
  return __jsx(TagName, Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId
  }, btnProps), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: hasBottomOrientation ? '-scale-y-1 rtl:-scale-y-1' : 'rtl:-scale-x-1'
  }, svgProps)), __jsx("span", {
    className: thInner,
    style: {
      height: height
    }
  }, children), __jsx(StripButton_StripButtonSvg, Object(esm_extends["a" /* default */])({
    className: hasBottomOrientation ? '-scale-1 rtl:-scale-1' : '-scale-x-1 rtl:translate-x-0'
  }, svgProps)));
};

/***/ }),

/***/ "ZuH9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");
var isArrayIteratorMethod = __webpack_require__("zcYo");
var toLength = __webpack_require__("DOIJ");
var bind = __webpack_require__("mwRp");
var getIterator = __webpack_require__("cUh7");
var getIteratorMethod = __webpack_require__("MU85");
var iteratorClose = __webpack_require__("yUod");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(String(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "a4SZ":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isObject = __webpack_require__("1YFU");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "aBEZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return travelRestrictionsResolver; });
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("CcNa");








var travelRestrictionsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_5__[/* TRAVEL_RESTRICTIONS */ "Jb"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pageContext = arguments.length > 2 ? arguments[2] : undefined;
    var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_4__["b2cPagesService"].PAGE_TYPES;
    var isResortPage = [PAGE_TYPES.RESORT, PAGE_TYPES.RESORT_MICE].includes(pageContext.pageType);
    var resortId = props.resortId;
    var query = "query {\n      resort( resortId:\"".concat(resortId, "\") {\n        travelSherpaOutbound\n        travelSherpaInbound\n      }\n    }");

    if (isResortPage) {
      return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"].runQuery(query, appContext, {
        requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__[/* LINE_COMMON_TRAVEL_RESTRICTIONS */ "Lb"],
        strictErrors: false
      });
    }

    return Promise.resolve({});
  }
};

/***/ }),

/***/ "aFmo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productQuotationFormResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productQuotationFormResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* QUOTATION_FORM */ "Z"],
  resolve: function resolve(appContext, _ref, _ref2) {
    var resortId = _ref.resortId,
        dateFormat = _ref.criteria.dateFormat;
    var pageType = _ref2.pageType;
    var isLandingPage = pageType === _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].PAGE_TYPES.LANDING;
    var productQuotationFormQuery = "{\n      product: resort(productId: \"".concat(resortId, "\") {\n        image,\n        productId: id\n        productLabel: name\n        productRangeLabel: rangeLabel\n        rangeId\n        seasonName\n        type\n      }\n      ").concat(isLandingPage ? '' : "price(productId: \"".concat(resortId, "\") {\n        initialPrice { value }\n      }"), "\n      bookingCriteria(resortId: \"").concat(resortId, "\") {\n        departureCities { value name }\n      }\n      ").concat(isLandingPage ? '' : "stopover(productId: \"".concat(resortId, "\") {\n        tour {\n          duration(message: \"{durationInNights}\")\n        }\n        extension {\n          duration(message: \"{durationInNights}\")\n          title(message: \"\")\n        }\n      }"), "\n      tour(productId: \"").concat(resortId, "\") {\n        availableDates {\n          value\n          name: formattedValue(dateFormat: \"").concat(dateFormat, "\")\n        }\n      }\n      civilities { adult { value: code name: label } }\n      newsletter(id: CLUBMED) { id description }\n      legalInformations { newsletterOptins { id title description } }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(productQuotationFormQuery, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_QUOTATION_FORM */ "qc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "aUQU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAutocomplete; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ub5k");
/* harmony import */ var _use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ngAq");
/* harmony import */ var _client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Qmkj");
/* harmony import */ var _utils_pertimm_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("y316");










function useAutocomplete() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_5__["useContext"])(_client_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"]);

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_5__["useState"])(keywords),
      autocompleteQuery = _useState[0],
      setAutocompleteQuery = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_5__["useState"])([]),
      autocompleteResults = _useState2[0],
      setAutocompleteResults = _useState2[1];

  var _useDebounce = Object(_use_debounce_useDebounce__WEBPACK_IMPORTED_MODULE_7__[/* useDebounce */ "a"])([autocompleteQuery], 300),
      _useDebounce2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_useDebounce, 1),
      debouncedAutocompleteQuery = _useDebounce2[0]; // This effect is used to fetch autocomplete suggestions when the query changes (with a 300ms debounce)


  Object(react__WEBPACK_IMPORTED_MODULE_5__["useEffect"])(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee() {
        var _yield$fetchAutocompl, _yield$fetchAutocompl2, answers, results;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(_utils_pertimm_client__WEBPACK_IMPORTED_MODULE_9__[/* suggest */ "d"])({
                  criteria: {
                    keywords: debouncedAutocompleteQuery
                  },
                  appContext: appContext
                });

              case 3:
                _yield$fetchAutocompl = _context.sent;
                _yield$fetchAutocompl2 = _yield$fetchAutocompl.answers;
                answers = _yield$fetchAutocompl2 === void 0 ? [] : _yield$fetchAutocompl2;
                results = answers.map(_client_store_utils_autocompleteItemHelper__WEBPACK_IMPORTED_MODULE_8__[/* getResultItem */ "b"]).sort(function (_ref2, _ref3) {
                  var productIdA = _ref2.productId;
                  var productIdB = _ref3.productId;

                  if (productIdA && !productIdB) {
                    return -1;
                  }

                  if (!productIdA && productIdB) {
                    return 1;
                  }

                  return 0;
                });
                setAutocompleteResults(results);
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                setAutocompleteResults([]);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    if (debouncedAutocompleteQuery) {
      fetchData();
    } else {
      setAutocompleteResults([]);
    }
  }, [debouncedAutocompleteQuery]);
  return {
    autocompleteQuery: autocompleteQuery,
    setAutocompleteQuery: setAutocompleteQuery,
    autocompleteResults: autocompleteResults,
    setAutocompleteResults: setAutocompleteResults
  };
}

/***/ }),

/***/ "afpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productAccessAndMapResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productAccessAndMapResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_ACCESS_AND_MAP */ "bb"],
  resolve: function resolve(appContext, _ref) {
    var resortId = _ref.resortId;
    var query = "query {\n      config {\n        common {\n          close\n          loadLess\n          maps {\n            productBaiduMap\n            productGoogleMap\n            productGoogleStreetView\n          }\n          viewMore\n        }\n      }\n      resort(resortId: \"".concat(resortId, "\") {\n        name\n        address {\n          streetNumber\n          streetName\n          additionalInformation1\n          additionalInformation2\n          addOn\n          city\n          town\n          zipCode\n          stateOrDistrict\n          country\n        }\n        coordinates {\n          latitude\n          longitude\n        }\n        accesses {\n          id\n          type\n          name\n          transfertDurationMin\n        }\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_ACCESS_AND_MAP */ "Tb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "akds":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("u/u4");
/* harmony import */ var _image_placeholder_ImagePlaceholder_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("D0nZ");
/* harmony import */ var _Video_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("JhHq");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





function Video(props) {
  var className = props.className,
      iFrameClassName = props.iFrameClassName,
      _props$ratioKey = props.ratioKey,
      ratioKey = _props$ratioKey === void 0 ? _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].L : _props$ratioKey,
      url = props.url;
  if (!Object(_Video_utils__WEBPACK_IMPORTED_MODULE_4__[/* isVideoUrl */ "b"])(url)) return null;
  return __jsx(_image_placeholder_ImagePlaceholder_jsx__WEBPACK_IMPORTED_MODULE_3__[/* ImagePlaceholder */ "a"], {
    aspectRatio: 100 * _utils_ratios_ratios_utils__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].VALUES[ratioKey],
    className: className
  }, __jsx("div", {
    className: "leading-none flex h-full items-center justify-center overflow-hidden"
  }, __jsx("iframe", {
    title: "Video iframe",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(iFrameClassName, 'border-0 fadeIn format-16/9 max-h-full'),
    src: Object(_Video_utils__WEBPACK_IMPORTED_MODULE_4__[/* getVideoUrl */ "a"])(url),
    allowFullScreen: true
  })));
}

/***/ }),

/***/ "bDrE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CITY_TRANSPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCityTransports; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("WGoB");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("rJ95");






var FETCH_CITY_TRANSPORTS = 'FETCH_CITY_TRANSPORTS';

var formatTransportsNames = function formatTransportsNames(node) {
  return node.map(function (transport) {
    return {
      value: transport.id,
      label: transport.label,
      name: Object(_utils_label_labelUtils__WEBPACK_IMPORTED_MODULE_3__[/* getTravelSectionSummary */ "c"])({
        travelSection: transport
      })
    };
  });
};

function fetchCityTransportsQuery(cityId, appContext) {
  var query = "{\n      cities(cityId: \"".concat(cityId, "\"){\n          airports {\n            id\n            label\n          }\n          train_stations {\n            id\n            label\n          }\n          ports {\n            id\n            label\n          }\n        }\n    }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runNoCacheQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* CITIES_GET_TRANSPORT_BY_CITY */ "b"]
  }).then(function (_ref) {
    var _ref$cities = _ref.cities,
        airports = _ref$cities.airports,
        train_stations = _ref$cities.train_stations,
        ports = _ref$cities.ports;
    return {
      airports: formatTransportsNames(airports),
      trainStations: formatTransportsNames(train_stations),
      ports: formatTransportsNames(ports)
    };
  });
}

function fetchCityTransports(cityId, appContext) {
  return function (dispatch) {
    dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(FETCH_CITY_TRANSPORTS, cityId));
    return fetchCityTransportsQuery(cityId, appContext).then(function (response) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["resolve"])(FETCH_CITY_TRANSPORTS), response));
      return response;
    })["catch"](function (error) {
      dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_5__[/* default */ "b"])(Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_1__["reject"])(FETCH_CITY_TRANSPORTS)));
      throw error;
    });
  };
}



/***/ }),

/***/ "bEXL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return destinationsResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("QsI/");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("psNz");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("jw1E");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("4VTZ");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["constants"].PRODUCT_TYPES;

var getFormattedDatesArgs = function getFormattedDatesArgs(_ref) {
  var departureDateStart = _ref.departureDateStart,
      departureDateEnd = _ref.departureDateEnd;
  var today = moment__WEBPACK_IMPORTED_MODULE_11___default()();
  var start = moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDateStart || null);
  var end = moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDateEnd || null);
  return {
    dateEnd: end.isValid() && !end.isSameOrBefore(today) ? Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* momentToApiDate */ "j"])(end) : '',
    dateStart: start.isValid() ? Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* momentToApiDate */ "j"])(start.isBefore(today) ? today : start) : ''
  };
};

var destinationsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_13__[/* DESTINATIONS */ "l"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(appContext, props, pageContext) {
      var displayPrices, _getFormattedDatesArg, dateEnd, dateStart, isMice, query;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              displayPrices = props.displayPrices;
              _getFormattedDatesArg = getFormattedDatesArgs(props), dateEnd = _getFormattedDatesArg.dateEnd, dateStart = _getFormattedDatesArg.dateStart;
              isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["b2cPagesService"].isMicePage(pageContext.pageType);
              query = "query {\n      config {\n        common {\n          close\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_18__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_18__[/* resort */ "e"](appContext), "\n      }\n      destinations(productType: \"").concat(PRODUCT_TYPES.RESORT, "\") {\n        countries {\n          id\n          label\n          products {\n            comfort\n            href\n            id\n            type\n            ").concat(displayPrices ? Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_17__[/* getPriceFields */ "c"])(Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_17__[/* cleanupArgs */ "a"])({
                dateEnd: dateEnd,
                dateStart: dateStart,
                isMice: isMice
              })) : '', "\n          }\n        }\n        id\n        isCruise\n        isJoyview\n        isTour\n        label\n      }\n    }");
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_16__[/* LINE_COMMON_DESTINATIONS */ "yb"]
              }).then(function (data) {
                return _objectSpread(_objectSpread({}, data), {}, {
                  productType: PRODUCT_TYPES.RESORT
                });
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2, _x3) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "bFjY":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("Q4oW"),
    isArrayLike = __webpack_require__("9y2L");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ "bGCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ getProductUrlFromDestinationLine; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ Product_mapper_getProductProps; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ Product_mapper_getProductPriceInfoProps; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ setProductHref; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ Product_mapper_updateProductUrl; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Product_mapper_createProductUrlWithParams; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ updateProduct; });

// UNUSED EXPORTS: getTagsAndBadgeColor, getProductTags, getProductOfferDiscountProps, getProductCallToActionProps, getProductChildcareAvailabilitiesProps, getProductComparisonProps, getProductFlagProps, getProductHeaderProps, getProductPriceProps, getProductThumbnailProps

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// CONCATENATED MODULE: ./src/client/components/widgets/products-comparison/ProductsComparisonUtils.js



function getAggregateDiscount(product) {
  var proposals = Object(lodash["get"])(product, 'proposals.proposals', []);
  var selectedProposal = proposals.find(function (proposal) {
    return Object(lodash["get"])(proposal, 'selected', true);
  });
  return Object(lodash["get"])(selectedProposal, 'price.aggregateDiscount', null);
}


// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/components/widgets/product/Product.mapper.js




















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}












var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var DEFAULT_COMPARISON = {
  isDisabled: false,
  isSelected: false
};

var getSubTitle = function getSubTitle(product) {
  var _product$destination;

  if (product.isCruise) {
    return product.timingDescription;
  }

  return ((_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country) || '';
};

var getProductUrl = function getProductUrl(props) {
  var _props$product$price;

  var isMice = !!props.product.mice;

  if (!props.contextualizeUrl) {
    return "".concat(isMice ? '/me' : '').concat(props.product.href);
  }

  var url = Product_mapper_getUrl(props.product.href, ((_props$product$price = props.product.price) === null || _props$product$price === void 0 ? void 0 : _props$product$price.termsAndConditions) || {});
  return "".concat(isMice ? '/me' : '').concat(url);
};

var Product_mapper_getUrl = function getUrl(href, termsAndConditions) {
  var _termsAndConditions$d;

  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var departureDate = "".concat((termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.departureDate) || '');
  var url = new URI_default.a(href).setQuery({
    locale: queryParams === null || queryParams === void 0 ? void 0 : queryParams.locale,
    departure_city: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : (_termsAndConditions$d = termsAndConditions.departureCity) === null || _termsAndConditions$d === void 0 ? void 0 : _termsAndConditions$d.value,
    duration: termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.duration,
    date: departureDate !== 'null' && departureDate ? Object(apiDate["e" /* formatApiDate */])(departureDate, constants["e" /* QUERY_DATE_FORMAT */]) : undefined
  });
  return url.toString();
};

var getProductUrlFromDestinationLine = function getProductUrlFromDestinationLine(price, queryParams) {
  return Product_mapper_getUrl(price.productHref || '', price.termsAndConditions, queryParams);
};

var Product_mapper_getTagsAndBadgeColor = function getTagsAndBadgeColor(product) {
  if (product.isTour || product.isCruise) {
    return product.color;
  }

  if (product.isSummer) {
    return colors["a" /* COLORS */].ORANGE;
  }

  return colors["a" /* COLORS */].BLUE;
};

var Product_mapper_getProductHeaderProps = function getProductHeaderProps(props) {
  var product = props.product;
  var badge = product.seasonTrad;
  var badgeColor = Product_mapper_getTagsAndBadgeColor(product); // $FlowFixMe

  var badgeIcon = Object(product_utils["d" /* getProductBadgeIcon */])(product);
  var link = {
    url: getProductUrl(props)
  };
  var heading = {
    title: product.name,
    subtitle: getSubTitle(product)
  };
  return {
    badge: badge,
    badgeColor: badgeColor,
    badgeIcon: badgeIcon,
    hasECLogo: product.isExplicitEC,
    heading: heading,
    link: link
  };
};

var Product_mapper_getProductComparisonProps = function getProductComparisonProps(_ref) {
  var _config$faceting;

  var _ref$comparison = _ref.comparison,
      comparison = _ref$comparison === void 0 ? DEFAULT_COMPARISON : _ref$comparison,
      config = _ref.config,
      product = _ref.product;

  var _ref2 = (config === null || config === void 0 ? void 0 : (_config$faceting = config.faceting) === null || _config$faceting === void 0 ? void 0 : _config$faceting.compare) || {},
      selected = _ref2.selected,
      selectResort = _ref2.selectResort,
      unavailableThumbnail = _ref2.unavailableThumbnail;

  var status = product_utils["b" /* IS_ENABLED */];

  if (comparison.isDisabled) {
    status = product_utils["a" /* IS_DISABLED */];
  } else if (comparison.isSelected) {
    status = product_utils["c" /* IS_SELECTED */];
  }

  var label = comparison.isSelected ? selected : selectResort;

  var _ref3 = product || {},
      isCruise = _ref3.isCruise,
      isTour = _ref3.isTour;

  return {
    status: status,
    label: label,
    isEligible: !isTour && !isCruise,
    eligibilityLabel: unavailableThumbnail
  };
};

var getProductCallToActionProps = function getProductCallToActionProps(_ref4) {
  var config = _ref4.config,
      product = _ref4.product;

  var _ref5 = product || {},
      isTour = _ref5.isTour;

  var _ref6 = (config === null || config === void 0 ? void 0 : config.common) || {},
      thumbnailCTA = _ref6.thumbnailCTA,
      thumbnailTourCTA = _ref6.thumbnailTourCTA;

  return {
    label: isTour ? thumbnailTourCTA : thumbnailCTA
  };
};

var Product_mapper_getProductPriceProps = function getProductPriceProps(_ref7) {
  var _config$price;

  var config = _ref7.config,
      product = _ref7.product,
      _ref7$offer = _ref7.offer,
      offer = _ref7$offer === void 0 ? {} : _ref7$offer;
  var color = product.isJoyview ? colors["a" /* COLORS */].WATER_GREEN : '';
  return _objectSpread(_objectSpread({
    style: {
      color: offer.color
    },
    color: offer.color || color
  }, (config === null || config === void 0 ? void 0 : (_config$price = config.price) === null || _config$price === void 0 ? void 0 : _config$price.format) || {}), product.price || product.mice || {});
};

var Product_mapper_getProductChildcareAvailabilitiesProps = function getProductChildcareAvailabilitiesProps(_ref8) {
  var _config$faceting2;

  var config = _ref8.config,
      product = _ref8.product;

  var _ref9 = (config === null || config === void 0 ? void 0 : (_config$faceting2 = config.faceting) === null || _config$faceting2 === void 0 ? void 0 : _config$faceting2.availabilities) || {},
      monthsLabel = _ref9.months,
      yearsLabel = _ref9.years,
      yearLabel = _ref9.year,
      availableLabel = _ref9.available,
      unknownLabel = _ref9.unknown,
      unavailableLabel = _ref9.unavailable,
      urgentizationSingular = _ref9.urgentizationSingular,
      urgentizationPlural = _ref9.urgentizationPlural,
      childcareLabel = _ref9.childcare;

  var sortedChildcareAvailabilities = (product.childcareAvailabilities || []).sort(function (a, b) {
    return a.ageMin - b.ageMin;
  });

  var _sortedChildcareAvail = sortedChildcareAvailabilities,
      _sortedChildcareAvail2 = Object(slicedToArray["a" /* default */])(_sortedChildcareAvail, 2),
      _sortedChildcareAvail3 = _sortedChildcareAvail2[0],
      first = _sortedChildcareAvail3 === void 0 ? {} : _sortedChildcareAvail3,
      _sortedChildcareAvail4 = _sortedChildcareAvail2[1],
      second = _sortedChildcareAvail4 === void 0 ? {} : _sortedChildcareAvail4;

  var hasChildBetween4And23Months = first.ageMin === 4 || first.ageMax === 23;
  var hasOnlyBetween4And13Months = first.ageMin === 4 && second.ageMax !== 23;
  var hasOnlyBetween14And23Months = first.ageMax === 23;
  if (hasOnlyBetween4And13Months) first.ageMax = 23;else if (hasOnlyBetween14And23Months) first.ageMin = 4;else if (hasChildBetween4And23Months) {
    var stock = first.remainingStock === null && second.remainingStock === null ? null : (first.remainingStock || 0) + (second.remainingStock || 0);
    var availability = 'UNKNOWN';
    if (stock === 0) availability = 'UNAVAILABLE';else if (stock) availability = stock <= 10 ? 'PARTIAL' : 'AVAILABLE';
    sortedChildcareAvailabilities = [_objectSpread(_objectSpread({}, second), {}, {
      remainingStock: stock,
      ageMin: 4,
      ageMax: 23,
      availability: availability
    })].concat(Object(toConsumableArray["a" /* default */])(sortedChildcareAvailabilities.slice(2)));
  }
  return {
    items: sortedChildcareAvailabilities,
    monthsLabel: monthsLabel,
    yearsLabel: yearsLabel,
    yearLabel: yearLabel,
    availableLabel: availableLabel,
    unavailableLabel: unavailableLabel,
    unknownLabel: unknownLabel,
    remainingLabel: {
      n: urgentizationPlural,
      _1: urgentizationSingular
    },
    childcareLabel: childcareLabel
  };
};

var Product_mapper_getProductPriceInfoProps = function getProductPriceInfoProps(_ref10) {
  var _config$resort, _config$resort$starti, _product$price, _product$price$termsA, _product$price2, _product$price2$terms, _product$price3, _product$price3$terms, _product$price4, _product$price4$terms, _product$price4$terms2, _product$price5, _product$price5$terms, _product$price5$terms2, _product$price6, _product$mice;

  var config = _ref10.config,
      product = _ref10.product;
  var startDate = '';
  var endDate = '';
  var dateFormat = (config === null || config === void 0 ? void 0 : (_config$resort = config.resort) === null || _config$resort === void 0 ? void 0 : (_config$resort$starti = _config$resort.startingPrice) === null || _config$resort$starti === void 0 ? void 0 : _config$resort$starti.dateFormat) || Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  startDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$termsA = _product$price.termsAndConditions) === null || _product$price$termsA === void 0 ? void 0 : _product$price$termsA.departureDate, apiDate["a" /* API_DATE_FORMAT */]).format(dateFormat);
  endDate = moment_default()(product === null || product === void 0 ? void 0 : (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : (_product$price2$terms = _product$price2.termsAndConditions) === null || _product$price2$terms === void 0 ? void 0 : _product$price2$terms.departureDate, apiDate["a" /* API_DATE_FORMAT */]).add({
    days: ((_product$price3 = product.price) === null || _product$price3 === void 0 ? void 0 : (_product$price3$terms = _product$price3.termsAndConditions) === null || _product$price3$terms === void 0 ? void 0 : _product$price3$terms.duration) || 0
  }).format(dateFormat);
  return {
    city: (product === null || product === void 0 ? void 0 : (_product$price4 = product.price) === null || _product$price4 === void 0 ? void 0 : (_product$price4$terms = _product$price4.termsAndConditions) === null || _product$price4$terms === void 0 ? void 0 : (_product$price4$terms2 = _product$price4$terms.departureCity) === null || _product$price4$terms2 === void 0 ? void 0 : _product$price4$terms2.name) || '',
    endDate: endDate,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price5 = product.price) === null || _product$price5 === void 0 ? void 0 : (_product$price5$terms = _product$price5.termsAndConditions) === null || _product$price5$terms === void 0 ? void 0 : (_product$price5$terms2 = _product$price5$terms.departureCity) === null || _product$price5$terms2 === void 0 ? void 0 : _product$price5$terms2.value),
    isCruise: product.isCruise,
    isJoyview: product.isJoyview,
    isTour: product.isTour,
    startDate: startDate,
    transportIcon: product.transportType,
    unit: ((_product$price6 = product.price) === null || _product$price6 === void 0 ? void 0 : _product$price6.unit) || ((_product$mice = product.mice) === null || _product$mice === void 0 ? void 0 : _product$mice.unit) || ''
  };
};

var Product_mapper_getProductTags = function getProductTags(product) {
  if (product.mice) {
    var _product$productMeeti, _product$productMeeti2, _product$accommodatio;

    var productTags = [];
    var maxConferenceRoomCapacity = (_product$productMeeti = product.productMeetingRooms) === null || _product$productMeeti === void 0 ? void 0 : (_product$productMeeti2 = _product$productMeeti.meetingRooms) === null || _product$productMeeti2 === void 0 ? void 0 : _product$productMeeti2.reduce(function (roomMaxCapacity, _ref11) {
      var shapes = _ref11.shapes;
      return Math.max(roomMaxCapacity, shapes.reduce(function (maxShape, _ref12) {
        var maxCapacity = _ref12.maxCapacity;
        return Math.max(maxCapacity, maxShape);
      }, 0));
    }, 0);

    if (maxConferenceRoomCapacity) {
      productTags.push(Object(i18n["h" /* t */])('common.conferenceRoomCapacity', {
        maxConferenceRoomCapacity: maxConferenceRoomCapacity
      }));
    }

    if ((_product$accommodatio = product.accommodationsIntroduction) === null || _product$accommodatio === void 0 ? void 0 : _product$accommodatio.roomsCount) {
      productTags.push(Object(i18n["h" /* t */])('common.numberOfRooms', {
        numberOfRooms: product.accommodationsIntroduction.roomsCount
      }));
    }

    return productTags;
  }

  if (product.isTour) {
    var rangeLabel = product.rangeLabel.toUpperCase();
    return product.duration ? ["".concat(rangeLabel, " : ").concat(product.duration)] : [rangeLabel];
  }

  if (product.isCruise) {
    var _product$thematics, _product$thematics$;

    return ["".concat((_product$thematics = product.thematics) === null || _product$thematics === void 0 ? void 0 : (_product$thematics$ = _product$thematics[0]) === null || _product$thematics$ === void 0 ? void 0 : _product$thematics$.label, " - ").concat(product.duration)];
  }
};

var Product_mapper_getProductThumbnailProps = function getProductThumbnailProps(props) {
  var _product$price7, _product$price7$terms, _product$price7$terms2;

  var product = props.product,
      _props$isSliderDisabl = props.isSliderDisabled,
      isSliderDisabled = _props$isSliderDisabl === void 0 ? false : _props$isSliderDisabl;
  var openingStatus = product.openingStatus;
  var isMice = !!product.mice;
  return {
    closedLabel: Object(i18n["h" /* t */])('common.closed'),
    hasBorder: product.isExclusiveCollection,
    hasTransport: !!(product === null || product === void 0 ? void 0 : (_product$price7 = product.price) === null || _product$price7 === void 0 ? void 0 : (_product$price7$terms = _product$price7.termsAndConditions) === null || _product$price7$terms === void 0 ? void 0 : (_product$price7$terms2 = _product$price7$terms.departureCity) === null || _product$price7$terms2 === void 0 ? void 0 : _product$price7$terms2.value),
    link: {
      url: getProductUrl(props)
    },
    openingSoonLabel: Object(i18n["h" /* t */])('common.openingSoon'),
    pictures: (product.images || []).map(function (image) {
      return {
        alt: product.name,
        src: image || ''
      };
    }),
    productTags: Product_mapper_getProductTags(product),
    tagsColor: isMice ? colors["a" /* COLORS */].WHITE : Product_mapper_getTagsAndBadgeColor(product),
    tagsTextColor: isMice ? colors["a" /* COLORS */].GRAY_DARKER : colors["a" /* COLORS */].WHITE,
    transportLabel: Object(i18n["h" /* t */])('price.format.flightIncluded'),
    isSliderDisabled: isSliderDisabled,
    openingStatus: openingStatus,
    transportIcon: product.transportType
  };
};

var getProductFlagProps = function getProductFlagProps(props) {
  var _props$isPriceLoading = props.isPriceLoading,
      isPriceLoading = _props$isPriceLoading === void 0 ? false : _props$isPriceLoading,
      product = props.product;
  var _product$openingStatu = product.openingStatus,
      openingStatus = _product$openingStatu === void 0 ? OPENING_STATUS.OPEN : _product$openingStatu;
  var price = openingStatus === OPENING_STATUS.OPEN ? Product_mapper_getProductPriceProps(props) : {};
  return {
    price: price,
    priceInfo: Product_mapper_getProductPriceInfoProps(props),
    isPriceLoading: isPriceLoading
  };
};

var Product_mapper_getProductOfferDiscountProps = function getProductOfferDiscountProps(_ref13) {
  var product = _ref13.product,
      config = _ref13.config;
  return {
    discount: getAggregateDiscount(product),
    i18n: config.offerDiscount
  };
};

var Product_mapper_createProductUrlWithParams = function createProductUrlWithParams(href, product) {
  var currentLocation = dist["windowWrapper"].getLocation();
  var possibleQueries = [constants["f" /* QUERY_DEPARTURE_DATE */], constants["g" /* QUERY_DURATION */], constants["k" /* QUERY_TRANSPORT */], constants["h" /* QUERY_KIDS */]];

  if (product.isCruise) {
    possibleQueries = [constants["k" /* QUERY_TRANSPORT */]];
  } else if (product.isTour) {
    possibleQueries = [constants["f" /* QUERY_DEPARTURE_DATE */], constants["k" /* QUERY_TRANSPORT */]];
  }

  var getDepartureDate = function getDepartureDate() {
    var _product$flag, _product$flag$price, _product$flag$price$t; // $FlowFixMe


    if (product.departureDateOn && (product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : (_product$flag$price = _product$flag.price) === null || _product$flag$price === void 0 ? void 0 : (_product$flag$price$t = _product$flag$price.termsAndConditions) === null || _product$flag$price$t === void 0 ? void 0 : _product$flag$price$t.departureDate)) {
      return Object(apiDate["h" /* momentFromApiDate */])(product.flag.price.termsAndConditions.departureDate).format(constants["e" /* QUERY_DATE_FORMAT */]);
    }

    return Object(uriUtils["i" /* getQueryParameters */])(currentLocation)[constants["f" /* QUERY_DEPARTURE_DATE */]] || '';
  };

  return Object(uriUtils["f" /* generateUrlWithParams */])(href, {
    queryParams: possibleQueries.reduce(function (acc, curr) {
      return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, curr, curr === constants["f" /* QUERY_DEPARTURE_DATE */] ? getDepartureDate() : Object(uriUtils["i" /* getQueryParameters */])(currentLocation)[curr] || ''));
    }, // $FlowFixMe
    {})
  });
};

var setProductHref = function setProductHref(props) {
  var _props$product = props.product,
      product = _props$product === void 0 ? {} : _props$product;
  var href = product.href;

  if (href && true) {
    return _objectSpread(_objectSpread({}, props), {}, {
      // $FlowFixMe
      product: _objectSpread(_objectSpread({}, product), {}, {
        href: Product_mapper_createProductUrlWithParams(href, product)
      })
    });
  }

  return props;
};

var Product_mapper_getProductProps = function getProductProps(props) {
  var _props$product3, _props$product3$child;

  var _props$hasComparison = props.hasComparison,
      hasComparison = _props$hasComparison === void 0 ? false : _props$hasComparison,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      _props$offer = props.offer,
      offer = _props$offer === void 0 ? {} : _props$offer,
      _props$product2 = props.product,
      product = _props$product2 === void 0 ? {} : _props$product2;
  var flag = getProductFlagProps(props);
  var flagPrice = flag.price || {};
  var matchingOfferProducts = offer.products && offer.products.length > 0 ? offer.products.filter(function (offerProduct) {
    return offerProduct.id === product.id;
  }) : [];
  var price = matchingOfferProducts.length === 1 ? matchingOfferProducts.map(function (matchingOfferProduct) {
    return matchingOfferProduct.price;
  }).shift() : flagPrice;
  return {
    callToAction: getProductCallToActionProps(props),
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    childcareIncluded: (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : (_props$product3$child = _props$product3.childcareDetails) === null || _props$product3$child === void 0 ? void 0 : _props$product3$child.some(function (childcare) {
      return childcare.included;
    }),
    comfort: product.comfort,
    comparison: Product_mapper_getProductComparisonProps(props),
    departureDateOn: product.departureDateOn,
    flag: flag,
    hasComparison: hasComparison,
    header: Product_mapper_getProductHeaderProps(props),
    id: product.id,
    isCruise: product.isCruise,
    isTour: product.isTour,
    kids: kids,
    minAuthorizedAge: props.product.minAuthorizedAge,
    price: !Object(lodash["isEmpty"])(price) ? price : undefined,
    thumbnail: Product_mapper_getProductThumbnailProps(props),
    type: product.type,
    url: getProductUrl(props)
  };
};

var updateProduct = function updateProduct(product, props) {
  return _objectSpread(_objectSpread({}, product), {}, {
    hasComparison: props.hasComparison,
    childcare: Product_mapper_getProductChildcareAvailabilitiesProps(props),
    comparison: Product_mapper_getProductComparisonProps(props),
    flag: getProductFlagProps(props)
  });
};

var Product_mapper_updateProductUrl = function updateProductUrl(product) {
  var newProductUrl = Product_mapper_createProductUrlWithParams(new URI_default.a(product.url).pathname(), product);
  return _objectSpread(_objectSpread({}, product), {}, {
    url: newProductUrl,
    header: _objectSpread(_objectSpread({}, product.header), {}, {
      link: {
        url: newProductUrl
      }
    }),
    // $FlowFixMe
    thumbnail: _objectSpread(_objectSpread({}, product.thumbnail), {}, {
      link: {
        url: newProductUrl
      }
    })
  });
};



/***/ }),

/***/ "bLh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productSpaceIntroductionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productSpaceIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* RESORT_SPACE_INTRODUCTION */ "rb"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_SPACE_INTRODUCTION */ "wc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "bMl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("HnW7");
var redefineAll = __webpack_require__("Bg8+");
var InternalMetadataModule = __webpack_require__("wKkN");
var collection = __webpack_require__("IYAN");
var collectionWeak = __webpack_require__("LFxm");
var isObject = __webpack_require__("1YFU");
var enforceIternalState = __webpack_require__("9jKB").enforce;
var NATIVE_WEAK_MAP = __webpack_require__("Uqkn");

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = module.exports = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ "bNYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productCommunityQuestionsResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("CcNa");





var productCommunityQuestionsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* PRODUCT_COMMUNITY_QUESTIONS */ "M"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common { close next previous scrollBackward scrollForward }\n      }\n      productCommunity(".concat(productArgs, ") {\n        linkAllQuestionsUrl\n        questions {\n          id\n          likesCount\n          authorName\n          date\n          title\n          text\n          answersCount\n          answers {\n            id\n            likesCount\n            authorName\n            date\n            text\n          }\n        }\n      }\n      resort(").concat(productArgs, ") {\n        icon\n      }\n     }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_4__[/* LINE_PRODUCT_COMMUNITY_QUESTIONS */ "bc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "bOkD":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("cHE3");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "bz5b":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("9y2L");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "c7Qd":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("DuXo"),
    baseIsNaN = __webpack_require__("z9Jh"),
    strictIndexOf = __webpack_require__("n1QJ");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "cGFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidationStateFromKid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationStateFromKids; });
/* unused harmony export updateValidationStateForKid */
/* unused harmony export addOrRemoveKidFromValidationState */
/* unused harmony export addOrRemoveKidFromKidsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasKidWithoutAValidBirthdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasOnlyValidKids; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return invalidateNotValidatedKids; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fGyu");
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wQ38");
/* harmony import */ var _facetingUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("kNiU");
/* harmony import */ var _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("45yR");











var getValidationStateFromKid = function getValidationStateFromKid(kid, isKidBirthdateRequired) {
  if (typeof kid !== 'object') {
    return _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
  }

  if (!kid.birthdate) {
    return isKidBirthdateRequired ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"];
  }

  return typeof kid === 'object' && Object(_facetingUtils__WEBPACK_IMPORTED_MODULE_9__[/* isKidMinor */ "j"])(kid.birthdate) ? _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_VALID */ "b"] : _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
};
var getValidationStateFromKids = function getValidationStateFromKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return kids.map(function (kid) {
    return getValidationStateFromKid(kid);
  });
};
var updateValidationStateForKid = function updateValidationStateForKid(_ref) {
  var index = _ref.index,
      kid = _ref.kid,
      _ref$kidsValidationSt = _ref.kidsValidationState,
      kidsValidationState = _ref$kidsValidationSt === void 0 ? [] : _ref$kidsValidationSt;
  var validationState = getValidationStateFromKid(kid);
  return kidsValidationState.map(function (kidValidation, indexKid) {
    var isNewKid = kidValidation === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"];
    var kidNeedsValidation = !!kid.birthdate || !isNewKid;
    return indexKid === index && kidNeedsValidation ? validationState : kidValidation;
  });
};
var addOrRemoveKidFromValidationState = function addOrRemoveKidFromValidationState(_ref2) {
  var _ref2$currentState = _ref2.currentState,
      currentState = _ref2$currentState === void 0 ? [] : _ref2$currentState,
      kidsNumber = _ref2.kidsNumber;

  if (kidsNumber > currentState.length) {
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(currentState), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Array(kidsNumber - currentState.length).fill(_client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__[/* VALIDATION_STATE_ENUM */ "f"].notvalidated)));
  }

  if (kidsNumber < currentState.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(currentState.slice(0, kidsNumber));
  }

  return currentState;
};
var addOrRemoveKidFromKidsList = function addOrRemoveKidFromKidsList(args) {
  var _args$kids = args.kids,
      kids = _args$kids === void 0 ? [] : _args$kids,
      kidsNumber = args.kidsNumber;

  if (kidsNumber > kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(kids).concat(Array(kidsNumber - kids.length).fill().map(function () {
      return _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_8__[/* DEFAULT_KID_VALUE */ "a"];
    }));
  }

  if (kidsNumber < kids.length) {
    return Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(kids.slice(0, kidsNumber));
  }

  return kids;
};
var hasKidWithoutAValidBirthdate = function hasKidWithoutAValidBirthdate(kidsValidationState) {
  return Boolean(kidsValidationState && kidsValidationState.find(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"];
  }));
};
var hasOnlyValidKids = function hasOnlyValidKids(kidsValidationState) {
  return kidsValidationState.every(function (kid) {
    return kid === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_VALID */ "b"];
  });
};
var invalidateNotValidatedKids = function invalidateNotValidatedKids(kidsValidationState) {
  return kidsValidationState.reduce(function (acc, current) {
    if (current === _client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* NOT_VALIDATED */ "c"]) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(acc), [_client_components_frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_10__[/* IS_INVALID */ "a"]]);
    }

    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(acc), [current]);
  }, []);
};

/***/ }),

/***/ "cHMM":
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__("tRRp");

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ "cMav":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("i2RQ");

var assertThisInitialized = __webpack_require__("N7I1");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "cUh7":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");
var anObject = __webpack_require__("ep/x");
var getIteratorMethod = __webpack_require__("MU85");

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(iteratorMethod.call(argument));
  throw TypeError(String(argument) + ' is not iterable');
};


/***/ }),

/***/ "cbTx":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("RNiq");
      }
    ]);
  

/***/ }),

/***/ "cjjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMAIL_PATTERN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GM_NUMBER_PATTERN; });
/* unused harmony export email */
/* unused harmony export firstName */
/* unused harmony export lastName */
/* unused harmony export unicodeFirstName */
/* unused harmony export unicodeLastName */
/* unused harmony export notContainsUnicode */
/* unused harmony export strictName */
/* unused harmony export ASCII */
/* unused harmony export minLength */
/* unused harmony export haveLength */
/* unused harmony export maxLength */
/* unused harmony export regexp */
/* unused harmony export enum */
/* unused harmony export phoneNumber */
/* unused harmony export mandatory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return minAge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return maxAge; });
/* unused harmony export gmNumber */
/* unused harmony export inRange */
/* unused harmony export legalAgreement */
/* unused harmony export optionalBirthdate */
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9BC+");




var EMAIL_PATTERN = /^(?!.*@.*\.{2})[^\s@]+@[^\s@]+\.[^\s@.]+$/;
var GM_NUMBER_PATTERN = /^[0-9]{0,9}$/;
var UNICODE_CHAR_REGEXP = /[^\u0000-\u00ff]/;

function _regexp(reg) {
  return function (value) {
    return reg.test(value);
  };
}

function _minLength(length) {
  return function (value) {
    return value.length >= length;
  };
}

function _maxLength(length) {
  return function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return value.length <= length;
  };
}

function _haveLength(length) {
  return function (value) {
    return value.length === length;
  };
}

function _enum(values) {
  return function (value) {
    return values.indexOf(value) !== -1;
  };
}

function _mandatory() {
  return function (value) {
    return !!value;
  };
}

function _checkDate(format) {
  return function (dateToCheck) {
    return !!(dateToCheck && format && moment__WEBPACK_IMPORTED_MODULE_2___default()(dateToCheck, format, true).isValid());
  };
}

function _getAge(birthday, birthdayFormat, onDate, onDateFormat) {
  var fromDate = onDate && onDateFormat ? moment__WEBPACK_IMPORTED_MODULE_2___default()(onDate, onDateFormat) : moment__WEBPACK_IMPORTED_MODULE_2___default()();
  return fromDate.diff(moment__WEBPACK_IMPORTED_MODULE_2___default()(birthday, birthdayFormat), 'years', true);
}

function _notContainsUnicode(str) {
  return !UNICODE_CHAR_REGEXP.test(str);
}

function _inRange(min, max) {
  return function (value) {
    return value >= min && value <= max;
  };
}
/* Validators */


var email = {
  name: 'email',
  isValid: _regexp(EMAIL_PATTERN)
};
var firstName = {
  name: 'firstName',
  isValid: function isValid(value) {
    return _maxLength(20)(value) && _notContainsUnicode(value);
  }
};
var lastName = {
  name: 'lastName',
  isValid: function isValid(value) {
    return _maxLength(30)(value) && _notContainsUnicode(value);
  }
};
var notContainsUnicode = {
  name: 'notContainsUnicode',
  isValid: function isValid(value) {
    return _notContainsUnicode(value);
  }
};
var unicodeFirstName = {
  name: 'unicodeFirstName',
  isValid: _maxLength(100)
};
var unicodeLastName = {
  name: 'unicodeLastName',
  isValid: _maxLength(100)
};
var strictName = {
  name: 'strictName',
  isValid: function isValid(value) {
    return _mandatory()(value) && _regexp(/^[^0-9!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]+$/)(value);
  }
};
var ASCII = {
  name: 'ASCII',
  isValid: _regexp(/^[\x20-\xFF]+$/)
};

function minLength(length) {
  return {
    name: 'minLength',
    isValid: _minLength(length)
  };
}

function haveLength(length) {
  return {
    name: 'haveLength',
    isValid: _haveLength(length)
  };
}

function maxLength(length) {
  return {
    name: 'maxLength',
    isValid: _maxLength(length)
  };
}

function regexp(exp) {
  return {
    name: 'regexp',
    isValid: _regexp(exp)
  };
}

function enum1() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return {
    name: 'enum',
    isValid: _enum(values)
  };
}

function phoneNumber(locale) {
  var phoneRegexp = Object(_utils_regex_RegexHelper__WEBPACK_IMPORTED_MODULE_3__[/* getPhoneRegex */ "b"])(locale);
  return {
    name: 'phoneNumber',
    isValid: _regexp(phoneRegexp)
  };
}

function mandatory() {
  return {
    name: 'mandatory',
    isValid: _mandatory()
  };
}

function date(format) {
  return {
    name: 'date',
    isValid: _checkDate(format)
  };
}

var optionalBirthdate = function optionalBirthdate(_ref) {
  var ageRequired = _ref.ageRequired,
      birthdayFormat = _ref.birthdayFormat,
      onDate = _ref.onDate,
      onDateFormat = _ref.onDateFormat;
  return {
    name: 'optionalBirthdate',
    isValid: function isValid(birthdate) {
      return !birthdate || birthdayFormat && moment__WEBPACK_IMPORTED_MODULE_2___default()(birthdate, birthdayFormat, true).isValid() && Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthdate) && _getAge(birthdate, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
};

function minAge(_ref2) {
  var ageRequired = _ref2.ageRequired,
      birthdayFormat = _ref2.birthdayFormat,
      onDate = _ref2.onDate,
      onDateFormat = _ref2.onDateFormat;
  return {
    name: 'minAge',
    isValid: function isValid(birthday) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) >= ageRequired;
    }
  };
}

function maxAge() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      ageRequired = _ref3.ageRequired,
      birthdayFormat = _ref3.birthdayFormat,
      onDate = _ref3.onDate,
      onDateFormat = _ref3.onDateFormat;

  return {
    name: 'maxAge',
    isValid: function isValid(birthday) {
      return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["isNumber"])(ageRequired) && _checkDate(birthdayFormat)(birthday) && _getAge(birthday, birthdayFormat, onDate, onDateFormat) < ageRequired;
    }
  };
}

function inRange(min, max) {
  return {
    name: 'inRange',
    isValid: _inRange(min, max)
  };
}

var gmNumber = {
  name: 'gmNumber',
  isValid: function isValid(value) {
    return _regexp(GM_NUMBER_PATTERN)(value);
  }
};

function legalAgreement(required) {
  return {
    name: 'legalAgreement',
    // if legalAgreement is not required, return true to bypass validation
    isValid: function isValid(value) {
      return required ? value === true : true;
    }
  };
}



/***/ }),

/***/ "cvSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SYNC_WITH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SEARCH_SET_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TRIP_INFORMATION_SET_DEPARTURE_CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TRIP_INFORMATION_SET_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_USER_PAST_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RESET_USER_PAST_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_USER_FUTURE_TRIPS_FETCHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER_FUTURE_TRIPS_RESOLVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_USER_FUTURE_TRIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_USER_SEARCHES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_USER_SEARCHES_RESOLVED; });
/* unused harmony export SET_PARTICIPANTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CALENDAR_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CALENDAR_TRIP_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CALENDAR_TRIP_PRICE_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_BOOKABLE_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_BOOKABLE_DATES_ABORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_CHANGE_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALENDAR_SET_INITIAL_DURATION; });
/* unused harmony export QUOTATION_FORM_UPDATE */
/* unused harmony export QUOTATION_FORM_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_TRIP_DATE_CRITERIA; });
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b0q8");
/* harmony import */ var redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__);

var SYNC_WITH_LOCATION = 'SYNC_WITH_LOCATION';
var SEARCH_SET_KEYWORDS = 'SEARCH_SET_KEYWORDS';
var TRIP_INFORMATION_SET_DEPARTURE_CITY = 'TRIP_INFORMATION_SET_DEPARTURE_CITY';
var TRIP_INFORMATION_SET_DEPARTURE_DATE = 'TRIP_INFORMATION_SET_DEPARTURE_DATE';
var FETCH_USER_PAST_TRIPS = 'FETCH_USER_PAST_TRIPS';
var FETCH_USER_PAST_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_PAST_TRIPS);
var RESET_USER_PAST_TRIPS = 'RESET_USER_PAST_TRIPS';
var FETCH_USER_FUTURE_TRIPS = 'FETCH_USER_FUTURE_TRIPS';
var FETCH_USER_FUTURE_TRIPS_FETCHED = 'FETCH_USER_FUTURE_TRIPS_FETCHED';
var FETCH_USER_FUTURE_TRIPS_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_FUTURE_TRIPS);
var RESET_USER_FUTURE_TRIPS = 'RESET_USER_FUTURE_TRIPS';
var FETCH_USER_SEARCHES = 'FETCH_USER_SEARCHES';
var FETCH_USER_SEARCHES_RESOLVED = Object(redux_optimist_promise__WEBPACK_IMPORTED_MODULE_0__["resolve"])(FETCH_USER_SEARCHES);
var SET_PARTICIPANTS = 'SET_PARTICIPANTS';
var FETCH_CALENDAR = 'FETCH_CALENDAR';
var FETCH_CALENDAR_ABORT = 'FETCH_CALENDAR_ABORT';
var FETCH_CALENDAR_TRIP_PRICE = 'FETCH_CALENDAR_TRIP_PRICE';
var FETCH_CALENDAR_TRIP_PRICE_ABORT = 'FETCH_CALENDAR_TRIP_PRICE_ABORT';
var FETCH_BOOKABLE_DATES = 'FETCH_BOOKABLE_DATES';
var FETCH_BOOKABLE_DATES_ABORT = 'FETCH_BOOKABLE_DATES_ABORT';
var CALENDAR_CHANGE_MONTH = 'CALENDAR_CHANGE_MONTH';
var CLEAR_CALENDAR = 'CLEAR_CALENDAR';
var CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE = 'CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE';
var CALENDAR_SET_INITIAL_DURATION = 'CALENDAR_SET_INITIAL_DURATION';
var QUOTATION_FORM_UPDATE = 'QUOTATION_FORM_UPDATE';
var QUOTATION_FORM_REQUEST = 'QUOTATION_FORM_REQUEST';
var UPDATE_TRIP_DATE_CRITERIA = 'UPDATE_TRIP_DATE_CRITERIA';

/***/ }),

/***/ "d4In":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CapsuleCollapseLists_CapsuleCollapseLists; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx + 1 modules
var Capsule = __webpack_require__("jldR");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.themes.js

var themes = {
  "default": {
    thMessage: 'decorator-border-bottom-list font-bold p-px20 text-base',
    thCollapse: 'decorator-border-bottom-list border-gray-light',
    thCollapseTheme: 'limpidSmall',
    thCollapseIconCollapse: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    thCollapseIconExpand: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    thItems: 'reset-list pb-px20 text-base',
    thItem: 'flex items-center px-px20 py-px5',
    thItemIcon: 'flex-shrink-0 rtl:mr-px15 text-blue',
    thItemIconWidth: '1.5rem',
    thItemLabel: 'flex-1'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx

var __jsx = react_default.a.createElement;





var CapsuleCollapseLists_CapsuleCollapseLists = function CapsuleCollapseLists(_ref) {
  var className = _ref.className,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$lists = _ref.lists,
      lists = _ref$lists === void 0 ? [] : _ref$lists,
      message = _ref.message,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!lists || !lists.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCollapse = _themes$theme.thCollapse,
      thCollapseIconCollapse = _themes$theme.thCollapseIconCollapse,
      thCollapseIconExpand = _themes$theme.thCollapseIconExpand,
      thCollapseTheme = _themes$theme.thCollapseTheme,
      thItems = _themes$theme.thItems,
      thItem = _themes$theme.thItem,
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconWidth = _themes$theme.thItemIconWidth,
      thItemLabel = _themes$theme.thItemLabel,
      thMessage = _themes$theme.thMessage;
  return __jsx(Capsule["a" /* Capsule */], {
    additionalStyle: {
      root: style
    },
    className: className,
    color: header.color,
    header: "large",
    icon: header.iconName,
    label: header.title
  }, !!message && __jsx("div", {
    className: thMessage
  }, message), lists.map(function (el, index) {
    var _el$items;

    return !!((_el$items = el.items) === null || _el$items === void 0 ? void 0 : _el$items.length) && __jsx(CollapsePanel["a" /* CollapsePanel */], {
      className: thCollapse,
      collapseIconName: thCollapseIconCollapse,
      expandIconName: thCollapseIconExpand,
      isExpanded: index === 0,
      key: el.title,
      theme: thCollapseTheme,
      title: el.title
    }, __jsx("ul", {
      className: thItems
    }, el.items.map(function (_ref2) {
      var iconName = _ref2.iconName,
          label = _ref2.label;
      return __jsx("li", {
        className: thItem,
        key: label
      }, __jsx(Icon["a" /* Icon */], {
        className: thItemIcon,
        name: iconName,
        width: thItemIconWidth
      }), __jsx("span", {
        className: thItemLabel
      }, label));
    })));
  }));
};

/***/ }),

/***/ "dNjr":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("F9U4");
var requireObjectCoercible = __webpack_require__("4gXF");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "dnX/":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("a88S");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "dq4L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

var _ampContext = __webpack_require__("TZT2");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react.default.useContext(_ampContext.AmpStateContext));
}

/***/ }),

/***/ "e4lk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Address; });
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



function toLine() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.filter(Boolean).join(' ');
}

function AddressLine(_ref) {
  var children = _ref.children;
  return children ? __jsx("li", {
    className: "leading-normal text-base text-gray-darker"
  }, children) : null;
}

var Address = function Address(_ref2) {
  var additionalInformation1 = _ref2.additionalInformation1,
      additionalInformation2 = _ref2.additionalInformation2,
      addOn = _ref2.addOn,
      city = _ref2.city,
      className = _ref2.className,
      country = _ref2.country,
      stateOrDistrict = _ref2.stateOrDistrict,
      streetNumber = _ref2.streetNumber,
      streetName = _ref2.streetName,
      town = _ref2.town,
      zipCode = _ref2.zipCode;
  return __jsx("ul", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'reset-list')
  }, __jsx(AddressLine, null, toLine(streetNumber, streetName)), __jsx(AddressLine, null, toLine(additionalInformation1)), __jsx(AddressLine, null, toLine(additionalInformation2)), __jsx(AddressLine, null, toLine(addOn, city)), __jsx(AddressLine, null, toLine(town, zipCode)), __jsx(AddressLine, null, toLine(stateOrDistrict, country)));
};

/***/ }),

/***/ "eGzU":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var tryToString = __webpack_require__("xS1b");

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "eHpp":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("H87J"),
    baseGet = __webpack_require__("w2Tz"),
    baseIteratee = __webpack_require__("S3pA"),
    baseMap = __webpack_require__("bFjY"),
    baseSortBy = __webpack_require__("4jPf"),
    baseUnary = __webpack_require__("SU8Q"),
    compareMultiple = __webpack_require__("5WP5"),
    identity = __webpack_require__("zWgn"),
    isArray = __webpack_require__("wxYD");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "eN33":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "eVJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cruiseProgramResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var cruiseProgramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* CRUISE_PROGRAM */ "k"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var titlePlaceholder = props.titlePlaceholder,
        subtitlePlaceholder = props.subtitlePlaceholder,
        dateFormat = props.dateFormat,
        dayPlaceholder = props.dayPlaceholder,
        departureTimePlaceholder = props.departureTimePlaceholder,
        arrivalTimePlaceholder = props.arrivalTimePlaceholder;
    var urlParams = location.urlParams;
    var cruiseArgs = "cruiseDepartureDate: \"".concat(urlParams.departureDate, "\" cruiseArrivalDate: \"").concat(urlParams.arrivalDate, "\"");
    var query = "{\n      cruise(".concat(cruiseArgs, ") {\n        stopover {\n          title(message : \"").concat(titlePlaceholder, "\")\n          subtitle(message : \"").concat(subtitlePlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")\n          stops {\n            day(message : \"").concat(dayPlaceholder, "\")\n            title\n            description\n            departureTime(message : \"").concat(departureTimePlaceholder, "\")\n            arrivalTime(message : \"").concat(arrivalTimePlaceholder, "\")\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_CRUISE_PROGRAM */ "Nb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "eaHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productInstagramResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productInstagramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* INSTAGRAM_GRID */ "t"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var resortId = props.resortId;
    var urlParams = location.urlParams;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(resortId, urlParams);
    var query = "query {\n      socialPictures(".concat(productArgs, ") {\n        imageLarge,\n        imageSmall,\n        userName,\n        canonicalUrl,\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_INSTAGRAM_GRID */ "ic"],
      strictErrors: false
    })["catch"](function () {
      return [];
    });
  }
};

/***/ }),

/***/ "edYw":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");

module.exports = function (key, value) {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ep/x":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "evRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLastVisitedProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLastVisitedProductIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLastVisitedProducts; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("fGyu");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("1RIK");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("829J");













var _b2cPagesService$PAGE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["b2cPagesService"].PAGE_TYPES,
    RESORT = _b2cPagesService$PAGE.RESORT,
    TOUR = _b2cPagesService$PAGE.TOUR,
    CRUISE = _b2cPagesService$PAGE.CRUISE,
    RESORT_MICE = _b2cPagesService$PAGE.RESORT_MICE;
function getLastVisitedProducts() {
  var trackingShopping = Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_11__[/* getFromLocalStorage */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_TRACKING */ "u"]);
  var lastVisitedProducts = (trackingShopping === null || trackingShopping === void 0 ? void 0 : trackingShopping[_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"]]) || []; // it handles old data: string[]
  // to delete when it's safe

  return lastVisitedProducts.map(function (visitedProduct, index) {
    if (typeof visitedProduct === 'string') {
      return {
        id: visitedProduct,
        be: false,
        timestamp: Date.now() + index
      };
    }

    return visitedProduct;
  });
}
function getLastVisitedProductIds() {
  return getLastVisitedProducts().map(function (_ref) {
    var id = _ref.id;
    return id;
  });
}
function trackLastVisitedProducts(pageType, product) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageType) && (product === null || product === void 0 ? void 0 : product.id)) {
    var lastVisitedProducts = getLastVisitedProducts();
    var targetProduct = lastVisitedProducts.find(function (visitedProduct) {
      return visitedProduct.id === product.id;
    });

    if (targetProduct) {
      // once it's true (BE) it can't go back to false
      targetProduct.be = product.be || targetProduct.be;
    } else {
      lastVisitedProducts = [product].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(lastVisitedProducts));
    }

    lastVisitedProducts = lastVisitedProducts.sort(function (a, b) {
      return Number(b.be) - Number(a.be) || b.timestamp - a.timestamp;
    }).slice(0, _constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS_NUMBER */ "t"]);
    Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_11__[/* setInLocalStorage */ "c"])(_constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_TRACKING */ "u"], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])({}, _constants__WEBPACK_IMPORTED_MODULE_12__[/* SHOPPING_LAST_VISITED_PRODUCTS */ "s"], lastVisitedProducts));
  }
}

/***/ }),

/***/ "fGxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryEventsResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");






var countryEventsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* COUNTRY_EVENTS */ "e"],
  resolve: function resolve(appContext) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var countryId = props.countryId,
        isForFamily = props.isForFamily;
    var countryArgs = "countryId:\"".concat(countryId, "\" isForFamily:").concat(isForFamily.toString());
    var query = "query {\n      config {\n        common { close }\n      }\n      countryEvents(".concat(countryArgs, ") {\n        title\n        description\n        media {\n          mediaUrl\n          mediaAlt\n        }\n        startDate\n        endDate\n        associatedProducts {\n          name\n          href\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_COMMON_COUNTRY_EVENTS */ "ub"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "fO+d":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseRest = __webpack_require__("R3TX"),
    baseUniq = __webpack_require__("s+R0"),
    isArrayLikeObject = __webpack_require__("Ndl3"),
    last = __webpack_require__("p1C/");

/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = baseRest(function(arrays) {
  var comparator = last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
});

module.exports = unionWith;


/***/ }),

/***/ "fYnN":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "fflk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setDepartureDate; });
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cvSI");



function setDepartureDate(departureDate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_DEPARTURE_DATE */ "w"], {
    departureDate: departureDate
  });
}



/***/ }),

/***/ "fhLv":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "g3/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productActivitiesResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("H0gB");




var productActivitiesResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_ACTIVITIES */ "J"],
  resolve: function resolve(appContext, props, pageContext, _ref) {
    var urlParams = _ref.urlParams;
    var productId = props.resortId,
        defaultLabel = props.otherSports.label;
    var query = Object(_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__[/* productActivitiesQuery */ "a"])({
      productId: productId,
      defaultLabel: defaultLabel,
      urlParams: urlParams
    });
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_ACTIVITIES */ "Wb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "g51W":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var definePropertyModule = __webpack_require__("87KK");
var createPropertyDescriptor = __webpack_require__("OouP");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "g73z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productIntroductionResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("NLwV");





var productIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* RESORT_INTRODUCTION */ "jb"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_4__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common {\n          loadLess\n          viewMore\n        }\n        resort {\n          resortIntroduction {\n            communityLabel\n            toSummerLabel\n            toWinterLabel\n          }\n        }\n      }\n      productCommunity(".concat(productArgs, ") {\n        questions {\n          id\n        }\n      }\n      resort(resortId:\"").concat(productId, "\"){\n        descriptionTitle\n        description\n        destination {\n          country\n        }\n        icon\n        id\n        images\n        isDoubleSeason\n        isExclusiveCollection\n        isWinter\n        linkedResort{\n          href\n        }\n        name\n        tripadvisor(resortId:\"").concat(productId, "\") {\n          rating\n          ratingImageUrl\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_INTRODUCTION */ "jc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "gA51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CollapsePanel_CollapsePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/toggler/Toggler.jsx
var Toggler = __webpack_require__("7CPK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.themes.js

var themes = {
  "default": function _default() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'border-b-1 flex relative',
      thHeaderDecorator: 'absolute arrow-down arrow-large arrow-white arrow-bg arrow-bg-large arrow-bg-turquoise border-b-2 border-turquoise -mb-px opacity-0 bottom-0 rtl:left-0 w-full sm:w-1/5 sm:rtl:ml-px25 transition-opacity z-1',
      thHeaderDecoratorActive: 'opacity-100',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden py-px20 text-initial text-gray-darker hover:text-turquoise transition-color',
      thTitle: 'flex-1 flex items-center font-bold font-sans leading-tight max-w-full text-current text-xl',
      thTitleHasEllipsis: true,
      thTitleIconColor: colors["a" /* COLORS */].BLUE,
      thLabels: 'flex-shrink-0 font-bold flex items-center text-base text-blue uppercase whitespace-no-wrap',
      thLabel: 'hidden sm:inline-block',
      thLabelIcon: 'text-gray-darker transition-transform rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.8125rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden shadow-inner-bottom shadow-inner-top',
      thContentInner: 'py-px40'
    };
  },
  lite: function lite() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden pt-px10 pb-0 text-initial text-gray-darker hover:text-blue transition-color',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'flex-shrink-0 flex items-center font-bold rtl:ml-auto text-blue text-base whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thContent: ' arrow-up arrow-large arrow-bg arrow-white arrow-bg-gray-light border-1 p-px20 mt-px20 shadow-md'
    };
  },
  liteFlexible: function liteFlexible() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden pt-px15 pb-0 text-initial text-gray-darker hover:text-blue transition-color',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'w-full border-t-1 py-px15 flex items-center justify-center text-base text-gray-600',
      thLabel: 'underline',
      thLabelIcon: 'rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thContent: 'flex',
      thContentInner: 'w-full'
    };
  },
  limpid: function limpid() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue uppercase whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  limpidSmall: function limpidSmall() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative text-base',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden p-px20 text-initial text-gray-darker',
      thTitle: 'flex-1 font-bold max-w-full',
      thTitleHasEllipsis: false,
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-blue uppercase whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  homeDetails: function homeDetails() {
    return {
      thRoot: 'fadeIn',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
      thTitle: 'flex-1 flex max-w-full text-base font-bold',
      thTitleHasEllipsis: false,
      thTitleIconColor: colors["a" /* COLORS */].BLUE,
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue uppercase whitespace-no-wrap',
      thLabel: 'underline',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.75rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden'
    };
  },
  remote: function remote() {
    return {
      thRoot: 'fadeIn border-b-1',
      thHeader: 'py-px20 flex relative',
      thButton: 'reset-button flex items-center flex-1 max-w-full overflow-hidden text-initial text-gray-darker',
      thTitle: 'flex-1 flex items-center max-w-full',
      thTitleIcon: 'rtl:mr-px10',
      thTitleIconColor: colors["a" /* COLORS */].BLUE,
      thTitleIconSize: '1.375rem',
      thLabels: 'flex-shrink-0 font-bold flex items-center rtl:ml-auto text-base text-blue whitespace-no-wrap',
      thLabelIcon: 'text-gray-darker rtl:ml-px10',
      thLabelIconActive: 'rotate-180',
      thLabelIconWidth: '0.625rem',
      thBody: 'overflow-hidden',
      thContent: 'overflow-hidden',
      thInner: 'w-full'
    };
  },
  searchDestinationsFacet: function searchDestinationsFacet(_ref) {
    var isDesktop = _ref.isDesktop;
    return {
      thRoot: 'fadeIn flex-1 max-w-full border-0',
      thHeader: 'flex relative',
      thButton: 'reset-button flex items-center justify-center flex-1 max-w-full overflow-hidden pt-px10 pb-0 text-initial text-gray-darker transition-color',
      thTitle: 'flex-1 max-w-full',
      thTitleHasEllipsis: true,
      thLabels: 'flex-shrink-0 flex items-center justify-center text-base whitespace-no-wrap',
      thBody: '',
      thLabel: 'underline',
      thLabelIcon: 'rtl:ml-px10',
      thLabelIconWidth: '0.625rem',
      thContent: '',
      thContentInner: 'lg:flex',
      thCollapsedTagInitialStyle: {
        'min-height': isDesktop ? '26rem' : '52rem'
      },
      thSemiTransparentDivStyle: {
        position: 'absolute',
        bottom: '0',
        width: '100%',
        height: '100%',
        'pointer-events': 'none',
        background: "linear-gradient(to top, rgba(247, 247, 247, 1) 0%, rgba(247, 247, 247, 0) ".concat(isDesktop ? '30%' : '15%', ")")
      }
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var POSITIONS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

var hasLabels = function hasLabels(_ref, isActive) {
  var collapseIconName = _ref.collapseIconName,
      collapseLabel = _ref.collapseLabel,
      expandIconName = _ref.expandIconName,
      expandLabel = _ref.expandLabel;
  return isActive ? collapseIconName || collapseLabel : expandIconName || expandLabel;
};

var CollapsePanel_LoadMoreButton = function LoadMoreButton(_ref2) {
  var ariaId = _ref2.ariaId,
      isActive = _ref2.isActive,
      isDesktop = _ref2.isDesktop,
      toggle = _ref2.toggle,
      collapsePanelProps = Object(objectWithoutProperties["a" /* default */])(_ref2, ["ariaId", "isActive", "isDesktop", "toggle"]);

  var _collapsePanelProps$a = collapsePanelProps.as,
      HeaderTag = _collapsePanelProps$a === void 0 ? 'div' : _collapsePanelProps$a,
      collapseLabel = collapsePanelProps.collapseLabel,
      _collapsePanelProps$c = collapsePanelProps.collapseIconName,
      collapseIconName = _collapsePanelProps$c === void 0 ? icons["a" /* ICONS */].CROSS : _collapsePanelProps$c,
      expandLabel = collapsePanelProps.expandLabel,
      _collapsePanelProps$e = collapsePanelProps.expandIconName,
      expandIconName = _collapsePanelProps$e === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN : _collapsePanelProps$e,
      iconName = collapsePanelProps.iconName,
      iconSize = collapsePanelProps.iconSize,
      isExpanded = collapsePanelProps.isExpanded,
      noIcons = collapsePanelProps.noIcons,
      _collapsePanelProps$t = collapsePanelProps.theme,
      theme = _collapsePanelProps$t === void 0 ? 'default' : _collapsePanelProps$t,
      title = collapsePanelProps.title,
      trackingData = collapsePanelProps.trackingData;

  var _themes$theme = themes[theme]({
    isDesktop: isDesktop
  }),
      thButton = _themes$theme.thButton,
      thHeader = _themes$theme.thHeader,
      thHeaderDecorator = _themes$theme.thHeaderDecorator,
      thHeaderDecoratorActive = _themes$theme.thHeaderDecoratorActive,
      thLabels = _themes$theme.thLabels,
      thLabel = _themes$theme.thLabel,
      thLabelIcon = _themes$theme.thLabelIcon,
      thLabelIconActive = _themes$theme.thLabelIconActive,
      thLabelIconWidth = _themes$theme.thLabelIconWidth,
      thTitle = _themes$theme.thTitle,
      thTitleHasEllipsis = _themes$theme.thTitleHasEllipsis,
      thTitleIcon = _themes$theme.thTitleIcon,
      thTitleIconColor = _themes$theme.thTitleIconColor,
      thTitleIconSize = _themes$theme.thTitleIconSize;

  return __jsx(HeaderTag, {
    className: classnames_default()('reset-heading', thHeader)
  }, __jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    "aria-controls": ariaId,
    "aria-expanded": isActive,
    className: thButton,
    onClick: toggle,
    type: "button",
    trackingData: isExpanded ? null : trackingData
  }, !!title && __jsx("div", {
    className: thTitle
  }, __jsx(Icon["a" /* Icon */], {
    className: classnames_default()('rtl:mr-px10 flex-shrink-0', thTitleIcon),
    color: thTitleIconColor,
    name: iconName,
    width: iconSize || thTitleIconSize || '1em'
  }), thTitleHasEllipsis ? __jsx("span", {
    className: "truncate w-full"
  }, title) : title), hasLabels(collapsePanelProps, isActive) && __jsx("div", {
    className: thLabels
  }, __jsx("span", {
    className: thLabel,
    "data-testid": "CollapsePanel-label"
  }, isActive ? collapseLabel : expandLabel), !noIcons && __jsx(Icon["a" /* Icon */], {
    className: classnames_default()(thLabelIcon, Object(defineProperty["a" /* default */])({}, thLabelIconActive, isActive)),
    name: isActive ? collapseIconName : expandIconName,
    width: thLabelIconWidth
  }))), (thHeaderDecorator || thHeaderDecoratorActive) && __jsx("div", {
    className: classnames_default()(thHeaderDecorator, Object(defineProperty["a" /* default */])({}, thHeaderDecoratorActive, isActive))
  }));
};

var CollapsePanel_CollapsePanel = function CollapsePanel(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(props.isExpanded),
      isVisible = _useState[0],
      setVisible = _useState[1];

  if (!react["Children"].count(props.children)) {
    return null;
  }

  var children = props.children,
      className = props.className,
      _props$hasKeepCollaps = props.hasKeepCollapsedContent,
      hasKeepCollapsedContent = _props$hasKeepCollaps === void 0 ? true : _props$hasKeepCollaps,
      id = props.id,
      isExpanded = props.isExpanded,
      isSemiTransparent = props.isSemiTransparent,
      _props$loadMoreButton = props.loadMoreButtonPosition,
      loadMoreButtonPosition = _props$loadMoreButton === void 0 ? POSITIONS.TOP : _props$loadMoreButton,
      onClick = props.onClick,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;

  var _themes$theme2 = themes[theme]({
    isDesktop: isDesktop
  }),
      thBody = _themes$theme2.thBody,
      thCollapsedTagInitialStyle = _themes$theme2.thCollapsedTagInitialStyle,
      thContent = _themes$theme2.thContent,
      thContentInner = _themes$theme2.thContentInner,
      thRoot = _themes$theme2.thRoot,
      thSemiTransparentDivStyle = _themes$theme2.thSemiTransparentDivStyle;

  var ariaId = Object(uniqueId["b" /* generateUniqueId */])([id || title || ''], 'CollapsePanel_');
  var CollapsedTag = hasKeepCollapsedContent ? lib["Collapse"] : lib["UnmountClosed"];
  return __jsx(Toggler["a" /* Toggler */], {
    isActive: isExpanded,
    onToggle: onClick
  }, function (toggle, isActive) {
    return __jsx("section", {
      className: classnames_default()(className, thRoot),
      id: id
    }, loadMoreButtonPosition === POSITIONS.TOP && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })), __jsx("div", {
      "aria-hidden": !isActive,
      className: classnames_default()(thBody, {
        invisible: !isVisible
      }),
      id: ariaId
    }, __jsx(CollapsedTag, {
      initialStyle: isSemiTransparent ? _objectSpread({
        height: 'auto',
        overflow: 'initial'
      }, thCollapsedTagInitialStyle) : thCollapsedTagInitialStyle,
      isOpened: isActive,
      onWork: function onWork() {
        setVisible(true);
      },
      onRest: function onRest(_ref3) {
        var isFullyClosed = _ref3.isFullyClosed;
        setVisible(!isFullyClosed);
      }
    }, __jsx("div", {
      className: thContent
    }, __jsx("div", {
      className: thContentInner
    }, children), isSemiTransparent && !isActive && __jsx("div", {
      style: thSemiTransparentDivStyle
    })))), loadMoreButtonPosition === POSITIONS.BOTTOM && __jsx(CollapsePanel_LoadMoreButton, Object(esm_extends["a" /* default */])({}, props, {
      ariaId: ariaId,
      isActive: isActive,
      isDesktop: isDesktop,
      toggle: toggle
    })));
  });
};

/***/ }),

/***/ "gIGD":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("XywU");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "gqY9":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("aokA");

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');


/***/ }),

/***/ "h0Er":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ getBookingEngineUrl; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ createPropsForProduct; });

// UNUSED EXPORTS: forgeBookingUrl

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/utils/legacy-booking-engine/legacyBookingUrlBuilder.js
var legacyBookingUrlBuilder = __webpack_require__("EieQ");

// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-summary/TripSummary.tracking.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var TripSummary_tracking_track = function track(payload, appContext) {
  if (Object(lodash["isEmpty"])(payload)) {
    return false;
  }

  tracking_api["b" /* setDataLayer */](_objectSpread(_objectSpread({}, constants["i" /* GA_DEFAULT_PAYLOAD */]), payload), appContext);
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-summary/TripSummary.utils.js








/* eslint-disable max-params */

function forgeBookingUrl(booking) {
  var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var queryParams = arguments.length > 2 ? arguments[2] : undefined;
  var stayId = arguments.length > 3 ? arguments[3] : undefined;
  var bookingId = Object(lodash["get"])(booking, 'information.bookingId');
  var bookingDetailUrl = bookingId && stayId ? routeBuilder["a" /* buildUrl */]('bookings', {
    bookingId: bookingId,
    stayId: stayId
  }, queryParams) : '';
  return "".concat(bookingDetailUrl).concat(hash);
}
function getBookingEngineUrl(reference, appContext, stay, location) {
  if (Object(lodash["isEmpty"])(reference) || Object(lodash["isEmpty"])(appContext) || Object(lodash["isEmpty"])(stay)) {
    return null;
  }

  var params = {
    reference: reference ? reference : '',
    resortId: Object(lodash["get"])(stay, 'resort.id', '')
  };
  return legacyBookingUrlBuilder["a" /* buildUrlFromContextNumber */](params, appContext, location);
}

function createPropsForPictures(images) {
  if (!Array.isArray(images)) {
    return [];
  }

  return images.map(function (link) {
    return {
      src: link
    };
  });
}

function createPropsForProduct(resort, tracking, appContext) {
  var _resort$destination;

  return {
    id: resort.id,
    header: {
      className: 'border-r-1',
      badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(resort),
      hasECLogo: resort.isExplicitEC,
      heading: {
        subtitle: resort === null || resort === void 0 ? void 0 : (_resort$destination = resort.destination) === null || _resort$destination === void 0 ? void 0 : _resort$destination.country,
        title: resort.name || ''
      },
      link: {
        url: resort.href,
        onClick: function onClick() {
          return TripSummary_tracking_track(tracking, appContext);
        }
      },
      productId: resort.id,
      productType: resort.type
    },
    thumbnail: {
      link: {
        url: resort.href
      },
      pictures: createPropsForPictures(resort.images),
      productId: resort.id,
      productType: resort.type,
      hasBorder: resort.isExclusiveCollection
    },
    url: resort.href,
    type: resort.type || ''
  };
}

/***/ }),

/***/ "h3D+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Multimedia; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/utils/medias/medias.js


var _ICONS;


var MEDIA_TYPES = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  VIDEOS360: 'videos360',
  SOCIALPICTURES: 'socialPictures',
  STREETVIEWS: 'streetViews'
};
var ORDERED_MEDIAS = [MEDIA_TYPES.PHOTOS, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.SOCIALPICTURES, MEDIA_TYPES.STREETVIEWS];
var ORDERED_MEDIAS_LAUNCHER = [MEDIA_TYPES.VIDEOS360, MEDIA_TYPES.VIDEOS, MEDIA_TYPES.PHOTOS, MEDIA_TYPES.SOCIALPICTURES];
var ICONS = (_ICONS = {}, Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.PHOTOS, icons["a" /* ICONS */].PHOTO_ALBUM), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.VIDEOS, icons["a" /* ICONS */].VIDEOS), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.VIDEOS360, icons["a" /* ICONS */].VIDEOS_360), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.SOCIALPICTURES, icons["a" /* ICONS */].INSTAGRAM), Object(defineProperty["a" /* default */])(_ICONS, MEDIA_TYPES.STREETVIEWS, icons["a" /* ICONS */].STREET_VIEWS_360), _ICONS);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.themes.js

var ActionButtonsGroup_themes_themes = function themes(_ref) {
  var isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      reverseLabelAndNumber = _ref.reverseLabelAndNumber;
  return {
    "default": {
      thRoot: 'flex flex-wrap -m-px',
      thButton: 'cursor-pointer bg-blue focus:bg-turquoise hover:bg-turquoise capitalize flex flex-1 font-bold items-center justify-center m-px p-px10 text-base text-white transition-bg-color w-full',
      thButtonActive: 'cursor-default bg-turquoise focus:bg-turquoise hover:bg-turquoise capitalize flex flex-1 font-bold items-center justify-center m-px pointer-events-none p-px10 text-base text-white transition-bg-color w-full',
      thIcon: '',
      thIconWithLabel: 'rtl:mr-px10',
      thIconLgSize: '3.25rem',
      thIconSize: '1.625rem',
      thText: 'text-initial',
      thNumber: 'block leading-one'
    },
    overlay: {
      thRoot: classnames_default()({
        'flex flex-wrap justify-center -m-px mt-auto': !isScrollable,
        'flex overflow-x-scroll sm:overflow-hidden mt-auto': isScrollable
      }),
      thButton: 'cursor-pointer bg-white focus:bg-overlay-black-60 hover:bg-overlay-black-60 capitalize flex font-bold items-center justify-center m-px5 p-px10 rounded-tiny text-sm text-gray focus:text-white hover:text-white transition-all',
      thButtonActive: 'cursor-default bg-overlay-black-60 focus:bg-overlay-black-60 hover:bg-overlay-black-60 capitalize flex font-bold items-center justify-center mx-px5 p-px10 pointer-events-none rounded-tiny text-sm text-white transition-all',
      thIcon: 'flex-shrink-0 overflow-visible',
      thIconWithLabel: 'rtl:mr-px5',
      thIconLgSize: '3rem',
      thIconSize: '1rem',
      thText: "flex ".concat(reverseLabelAndNumber ? 'flex-row-reverse ' : '', "font-bold justify-between w-full text-initial"),
      thNumber: 'rtl:pl-px5'
    },
    accommodation: {
      thRoot: "flex h-full justify-center w-full border-1 border-t-0 border-r-0 border-".concat(isExclusiveCollection ? 'deepBlue' : 'gray-light'),
      thButton: "flex w-full items-center justify-center flex-grow cursor-pointer bg-white capitalize font-bold p-px10 rounded-tiny text-base border-r-1 border-".concat(isExclusiveCollection ? 'deepBlue' : 'gray-light'),
      thButtonActive: "flex w-full items-center justify-center flex-grow cursor-pointer bg-white capitalize font-bold p-px10 rounded-tiny text-base border-r-1 border-".concat(isExclusiveCollection ? 'deepBlue' : 'gray-light'),
      thIcon: "overflow-visible text-".concat(isExclusiveCollection ? 'deepBlue' : 'blue'),
      thIconWithLabel: 'rtl:mr-px5',
      thIconLgSize: '4rem',
      thIconSize: '2rem',
      thText: 'font-bold text-initial text-gray transition-all',
      thNumber: 'rtl:pl-px5'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/action-buttons-group/ActionButtonsGroup.jsx


var __jsx = react_default.a.createElement;





var ActionButtonsGroup_ActionButtonsGroup = function ActionButtonsGroup(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isScrollable = _ref.isScrollable,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$minWidth = _ref.minWidth,
      minWidthProp = _ref$minWidth === void 0 ? 'initial' : _ref$minWidth,
      _ref$reverseLabelAndN = _ref.reverseLabelAndNumber,
      reverseLabelAndNumber = _ref$reverseLabelAndN === void 0 ? true : _ref$reverseLabelAndN,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!items.length) {
    return null;
  }

  var _themes$theme = ActionButtonsGroup_themes_themes({
    isExclusiveCollection: isExclusiveCollection,
    isScrollable: isScrollable,
    reverseLabelAndNumber: reverseLabelAndNumber
  })[theme],
      thRoot = _themes$theme.thRoot,
      thButton = _themes$theme.thButton,
      thButtonActive = _themes$theme.thButtonActive,
      thIcon = _themes$theme.thIcon,
      thIconWithLabel = _themes$theme.thIconWithLabel,
      thIconLgSize = _themes$theme.thIconLgSize,
      thIconSize = _themes$theme.thIconSize,
      thText = _themes$theme.thText,
      thNumber = _themes$theme.thNumber;

  var getActionButton = function getActionButton(item) {
    var ariaLabel = item.ariaLabel,
        buttonClassName = item.buttonClassName,
        dataTestId = item.dataTestId,
        iconIsNotSquare = item.iconIsNotSquare,
        iconName = item.iconName,
        id = item.id,
        isActive = item.isActive,
        label = item.label,
        minWidth = item.minWidth,
        number = item.number,
        onClick = item.onClick,
        trackingData = item.trackingData;
    return __jsx(TrackClick["a" /* TrackClick */], {
      "aria-disabled": isActive,
      "aria-label": ariaLabel,
      as: "button",
      className: classnames_default()(buttonClassName, Object(defineProperty["a" /* default */])({}, thButtonActive, isActive), Object(defineProperty["a" /* default */])({}, thButton, !isActive)),
      "data-testid": dataTestId,
      key: "ActionButtonsGroup-".concat(id),
      onClick: onClick,
      style: {
        minWidth: minWidth || minWidthProp
      },
      trackingData: trackingData,
      type: "button"
    }, iconName && __jsx(Icon["a" /* Icon */], {
      className: classnames_default()(thIcon, Object(defineProperty["a" /* default */])({}, thIconWithLabel, label)),
      isNotSquare: iconIsNotSquare,
      name: iconName,
      width: iconIsNotSquare ? thIconLgSize : thIconSize
    }), label && __jsx("span", {
      className: thText
    }, number && __jsx("span", {
      className: thNumber
    }, "".concat(number, " ")), label));
  };

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, items.map(function (item) {
    return getActionButton(item);
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/frameworks/avatar/Avatar.themes.js
var Avatar_themes_themes = {
  "default": {
    thRoot: 'flex items-center justify-center leading-normal max-w-full',
    thPicture: 'bg-gray-light flex-shrink-0 overflow-hidden rounded-full',
    thTexts: 'rtl:ml-px10',
    thName: 'text-base truncate text-inherit',
    thTextTheme: 'text-sans-2',
    thDescription: ''
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/avatar/Avatar.jsx
var Avatar_jsx = react_default.a.createElement;





var Avatar_Avatar = function Avatar(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 35 : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      userDescription = _ref.userDescription,
      userName = _ref.userName,
      userPictureUrl = _ref.userPictureUrl;

  if (!userPictureUrl && !userName) {
    return null;
  }

  var styles = {
    width: size,
    height: size
  };
  var imageSize = {
    w: size,
    h: size
  };
  var _themes$theme = Avatar_themes_themes[theme],
      thDescription = _themes$theme.thDescription,
      thName = _themes$theme.thName,
      thPicture = _themes$theme.thPicture,
      thRoot = _themes$theme.thRoot,
      thTexts = _themes$theme.thTexts,
      thTextTheme = _themes$theme.thTextTheme;
  return Avatar_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, userPictureUrl && Avatar_jsx("div", {
    className: thPicture,
    "data-testid": "Avatar-picture",
    style: styles
  }, Avatar_jsx(Image["b" /* default */], {
    altMsg: userName,
    imageUrl: userPictureUrl,
    dimensions: imageSize
  })), (!!userName || !!userDescription) && Avatar_jsx("div", {
    className: thTexts
  }, !!userName && Avatar_jsx("div", {
    className: thName,
    "data-testid": "Avatar-name"
  }, userName), !!userDescription && Avatar_jsx(Text["a" /* Text */], {
    className: thDescription,
    text: userDescription,
    theme: thTextTheme
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx + 1 modules
var ProgressBar = __webpack_require__("woxT");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// CONCATENATED MODULE: ./src/client/components/frameworks/carousel/Carousel.jsx

var Carousel_jsx = react_default.a.createElement;






function Carousel(props) {
  var children = props.children,
      className = props.className,
      hasInfiniteScroll = props.hasInfiniteScroll,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      nextLabel = props.nextLabel,
      previousLabel = props.previousLabel;
  var childrenCount = react["Children"].toArray(children).filter(Boolean).length;

  if (!childrenCount) {
    return null;
  }

  return Carousel_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden relative')
  }, Carousel_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "h-full w-full",
    hasInfiniteScroll: hasInfiniteScroll,
    hasKeyboardSupport: true,
    hasSwipeSupport: true,
    initialIndex: initialIndex,
    items: children
  }, function (_ref) {
    var hasControls = _ref.hasControls,
        index = _ref.index,
        isNextControlDisabled = _ref.isNextControlDisabled,
        isPreviousControlDisabled = _ref.isPreviousControlDisabled,
        itemsNode = _ref.itemsNode,
        onNext = _ref.onNext,
        onPrevious = _ref.onPrevious;
    return Carousel_jsx("div", {
      className: "flex-1 flex pb-px20 relative"
    }, itemsNode, hasControls && Carousel_jsx("div", {
      className: "absolute flex items-center justify-between m-auto inset-0 pointer-events-none px-px20 w-full"
    }, !isPreviousControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "rtl:mr-auto pointer-events-auto shadow-sm z-1",
      label: previousLabel,
      onClick: onPrevious
    }), !isNextControlDisabled && Carousel_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "rtl:ml-auto pointer-events-auto shadow-sm z-1",
      label: nextLabel,
      onClick: onNext,
      rotation: 180
    })), hasControls && Carousel_jsx("div", {
      className: "absolute bottom-0 left-0 w-full"
    }, Carousel_jsx(ProgressBar["a" /* ProgressBar */], {
      color: colors["a" /* COLORS */].WHITE,
      max: childrenCount,
      min: 1,
      value: index + 1
    })));
  }));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/errors/errors.js + 4 modules
var errors = __webpack_require__("wNDy");

// CONCATENATED MODULE: ./src/client/components/utils/youku-api/index.js






function getVideoThumbnailUrl(videoId) {
  var clientId = config_default.a.get('youku.clientId');

  if (!clientId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku client Id'));
  }

  if (!videoId) {
    return Promise.reject(new errors["b" /* BadRequest */]('Missing Youku video Id'));
  }

  return axios_default.a.get("https://api.youku.com/videos/show.json?client_id=".concat(clientId, "&video_id=").concat(videoId)).then(function (response) {
    return response.data.bigThumbnail || response.data.thumbnail || new errors["d" /* NotFoundError */]('Youku video not found');
  })["catch"](function () {
    return null;
  });
}
// CONCATENATED MODULE: ./src/client/components/frameworks/image/YoukuThumbnail.jsx











var YoukuThumbnail_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var YoukuThumbnail_YoukuThumbnail = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(YoukuThumbnail, _Component);

  var _super = _createSuper(YoukuThumbnail);

  function YoukuThumbnail(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, YoukuThumbnail);

    _this = _super.call(this, props);
    _this.state = {
      thumbnailUrl: null
    };
    return _this;
  }

  Object(createClass["a" /* default */])(YoukuThumbnail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var youkuRegEx = new RegExp('https://vthumb.ykimg.com/([a-zA-Z0-9]+)');
      var urlMatch = youkuRegEx.exec(this.props.imageUrl);

      if (urlMatch && urlMatch[1]) {
        getVideoThumbnailUrl(urlMatch[1]).then(function (youkuThumbnail) {
          _this2.setState({
            thumbnailUrl: youkuThumbnail
          });
        }).catch(function () {
          return null;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var thumbnailUrl = this.state.thumbnailUrl;
      return YoukuThumbnail_jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, this.props, {
        imageUrl: thumbnailUrl
      }));
    }
  }]);

  return YoukuThumbnail;
}(react["Component"]);
// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/media-thumbnail/MediaThumbnail.jsx
var MediaThumbnail_jsx = react_default.a.createElement;







var MediaThumbnail_MediaThumbnail = function MediaThumbnail(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className,
      hasLazyLoading = _ref.hasLazyLoading,
      iconName = _ref.iconName,
      onClick = _ref.onClick,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["a" /* default */].M : _ref$ratio,
      src = _ref.src,
      trackingData = _ref.trackingData,
      ratioDisplay = _ref.ratioDisplay;
  var hasChildren = !!react["Children"].count(children);

  if (!hasChildren && Object(lodash["isEmpty"])(src)) {
    return null;
  }

  return MediaThumbnail_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: classnames_default()(className, 'bg-white reset-button block overflow-hidden relative w-full hover:opacity-75 transition-opacity h-full'),
    onClick: onClick,
    trackingData: trackingData,
    type: "button"
  }, hasChildren ? children : MediaThumbnail_jsx(Image["b" /* default */], {
    altMsg: alt,
    hasLazyLoading: hasLazyLoading,
    imageUrl: src,
    ratioKey: ratio,
    ratioDisplay: ratioDisplay
  }), !!iconName && MediaThumbnail_jsx("div", {
    className: "absolute bg-overlay-black-60 leading-none m-px5 p-px10 top-0 rtl:right-0 text-white",
    style: {
      width: '3.125rem',
      height: '3.125rem'
    }
  }, MediaThumbnail_jsx(Icon["a" /* Icon */], {
    name: iconName,
    width: "100%"
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/multimedia-launcher/MultimediaLauncher.jsx





var MultimediaLauncher_jsx = react_default.a.createElement;









var YOUKU_SRC = 'vthumb.ykimg.com';

function MultimediaLauncherThumbnail(props) {
  return props.src ? MultimediaLauncher_jsx(MediaThumbnail_MediaThumbnail, Object(esm_extends["a" /* default */])({}, props, {
    hasLazyLoading: props.hasLazyLoading
  }), props.src.includes(YOUKU_SRC) ? MultimediaLauncher_jsx(YoukuThumbnail_YoukuThumbnail, {
    imageUrl: props.src,
    ratioKey: props.ratio
  }) : null) : null;
}

function MultimediaLauncher(_ref) {
  var buttons = _ref.buttons,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      hasLazyLoading = _ref.hasLazyLoading,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isImageSlideShow = _ref.isImageSlideShow,
      isOverlay = _ref.isOverlay,
      _ref$medias = _ref.medias,
      medias = _ref$medias === void 0 ? [] : _ref$medias,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      theme = _ref.theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var defaultTheme = isOverlay ? 'overlay' : 'default';
  return MultimediaLauncher_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden')
  }, !isOverlay && !isImageSlideShow && MultimediaLauncher_jsx(react["Fragment"], null, isTablet ? MultimediaLauncher_jsx("div", {
    className: "fadeIn flex -m-px border-b-1 border-transparent"
  }, MultimediaLauncher_jsx("div", {
    className: "p-px w-1/2"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading,
    ratioDisplay: 1 / 2
  }))), MultimediaLauncher_jsx("div", {
    className: "flex flex-wrap w-1/2"
  }, medias.slice(1, 5).map(function (media) {
    return MultimediaLauncher_jsx("div", {
      className: "p-px w-1/2",
      key: "MultimediaLauncherThumbnail-".concat(media.src)
    }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, media, {
      hasLazyLoading: hasLazyLoading,
      ratioDisplay: 1 / 4
    })));
  }))) : MultimediaLauncher_jsx("div", {
    className: "fadeIn border-b-2 border-transparent"
  }, MultimediaLauncher_jsx(MultimediaLauncherThumbnail, Object(esm_extends["a" /* default */])({}, medias[0], {
    hasLazyLoading: hasLazyLoading
  })))), !isOverlay && isImageSlideShow && MultimediaLauncher_jsx("div", {
    className: "fadeIn"
  }, medias.length > 0 ? MultimediaLauncher_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    className: className,
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    hasInfiniteScroll: true,
    hasInsetBorder: isExclusiveCollection,
    hasLazyLoading: false,
    media: medias.map(function (_ref2) {
      var alt = _ref2.alt,
          onClick = _ref2.onClick,
          src = _ref2.src;
      return {
        alt: alt,
        onClick: onClick,
        src: src
      };
    }),
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratios_utils["a" /* default */].XL
  }) : MultimediaLauncher_jsx(Image["b" /* default */], {
    altMsg: medias[0].alt,
    imageUrl: medias[0].src,
    ratioKey: ratios_utils["a" /* default */].XL,
    hasLazyLoading: false
  })), MultimediaLauncher_jsx(ActionButtonsGroup_ActionButtonsGroup, {
    className: "fadeIn",
    isExclusiveCollection: isExclusiveCollection,
    items: buttons,
    minWidth: isOverlay ? '6.25rem' : '8.4375rem',
    theme: theme ? theme : defaultTheme
  }));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/map/StreetView.jsx
var StreetView = __webpack_require__("HKmi");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/views/booking/constants.js
var booking_constants = __webpack_require__("taV1");

// CONCATENATED MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx






















var Multimedia_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Multimedia_createSuper(Derived) { var hasNativeReflectConstruct = Multimedia_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Multimedia_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



















var DIMENSIONS = {
  w: 'auto',
  h: 'auto'
};

var Multimedia_Multimedia = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_Multimedia, _Component);

  var _super = Multimedia_createSuper(_Multimedia);

  function _Multimedia(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _Multimedia);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "closeCarousel", function () {
      _this.setState({
        activeMedias: '',
        carouselIndex:  false || _this.props.initialIndex
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "showCarousel", function (type) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _this.setState({
        activeMedias: type,
        carouselIndex: index
      });
    });

    _this.state = {
      activeMedias: '',
      carouselIndex: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_Multimedia, [{
    key: "getCarouselItem",

    /* Carousel */
    value: function getCarouselItem(type, _ref, altMsg) {
      var fov = _ref.fov,
          heading = _ref.heading,
          imageLarge = _ref.imageLarge,
          latitude = _ref.latitude,
          longitude = _ref.longitude,
          url = _ref.url,
          userName = _ref.userName;

      switch (type) {
        case MEDIA_TYPES.PHOTOS:
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaPhoto",
            className: "flex flex-1 h-full items-center justify-center max-w-full w-full overflow-hidden relative"
          }, Multimedia_jsx(Image["b" /* default */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 max-w-2xl -translate-50",
            hasLazyLoading: false,
            key: "CarouselItem-".concat(type, "-").concat(url),
            imageUrl: url,
            dimensions: DIMENSIONS
          }));

        case MEDIA_TYPES.SOCIALPICTURES:
          return Multimedia_jsx("div", {
            "data-testid": "MultimediaSocialPicture",
            className: "flex flex-1 h-full items-center justify-center max-w-full w-full overflow-hidden relative"
          }, Multimedia_jsx(Image["b" /* default */], {
            altMsg: altMsg,
            classNameImg: "absolute top-1/2 left-1/2 -translate-50",
            hasLazyLoading: false,
            imageUrl: imageLarge,
            key: "CarouselItem-".concat(type, "-").concat(imageLarge),
            dimensions: DIMENSIONS
          }), Multimedia_jsx("div", {
            className: "absolute inset-x-0 bottom-0 p-px15 text-center text-white w-full gradient-linear-transparent-black-80"
          }, Multimedia_jsx(Avatar_Avatar, {
            userName: userName
          })));

        case MEDIA_TYPES.STREETVIEWS:
          return Multimedia_jsx(StreetView["a" /* StreetView */], {
            fov: fov,
            heading: heading,
            hideFloorControls: true,
            key: "CarouselItem-".concat(type, "-").concat(latitude, "-").concat(longitude),
            latitude: latitude,
            longitude: longitude
          });

        case MEDIA_TYPES.VIDEOS:
        case MEDIA_TYPES.VIDEOS360:
          return Multimedia_jsx(Video["a" /* Video */], {
            className: "flex flex-1 h-full items-center justify-center m-auto md:max-w-4/5 overflow-hidden static md:w-4/5",
            key: "CarouselItem-".concat(type, "-").concat(url),
            url: url
          });

        default:
          return null;
      }
    }
  }, {
    key: "getCarouselItems",
    value: function getCarouselItems(type) {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$descripti = _this$props.descriptionLabels,
          descriptionLabels = _this$props$descripti === void 0 ? {} : _this$props$descripti,
          medias = _this$props.medias,
          _this$props$pictureAl = _this$props.pictureAltLabel,
          pictureAltLabel = _this$props$pictureAl === void 0 ? '' : _this$props$pictureAl;
      return (medias[type] || []).map(function (media, idx) {
        var altMsg = (media === null || media === void 0 ? void 0 : media.alt) || Object(dist["messageFormat"])(pictureAltLabel).format({
          nb: idx + 1,
          total: medias[type].length
        });

        var carouselItem = _this2.getCarouselItem(type, media, altMsg);

        var descriptionLabel = descriptionLabels[type];
        return Multimedia_jsx(react["Fragment"], {
          key: "CarouselItemWrapper-".concat(type, "-").concat(media.url)
        }, carouselItem && descriptionLabel ? Multimedia_jsx("div", {
          className: "flex flex-1 flex-col h-full w-full"
        }, carouselItem, Multimedia_jsx("div", {
          className: "flex justify-center p-px20 pb-0 w-full"
        }, Multimedia_jsx("span", {
          className: "text-sm text-white text-center"
        }, descriptionLabel))) : carouselItem);
      });
    }
    /* Medias */

  }, {
    key: "hasMedias",
    value: function hasMedias(isDesktop) {
      var _this3 = this;

      return Object.keys(this.props.medias).reduce(function (has, type) {
        return has || _this3.hasTypeMedias(type, isDesktop);
      }, false);
    }
  }, {
    key: "hasTypeMedias",
    value: function hasTypeMedias(type, isDesktop) {
      var hasTypeMedias = Array.isArray(Object(lodash["get"])(this.props, ['medias', type])) && Object(lodash["get"])(this.props, ['medias', type]).length > 0;

      if (type === MEDIA_TYPES.VIDEOS360) {
        return hasTypeMedias && isDesktop;
      }

      return hasTypeMedias;
    }
  }, {
    key: "mapLauncherMedias",
    value: function mapLauncherMedias(type, isDesktop) {
      var _this4 = this;

      var medias = this.hasTypeMedias(type, isDesktop) ? this.props.medias[type] : [];
      return medias.map(function (media, index) {
        return {
          alt: Object(dist["messageFormat"])(_this4.props.launcherPictureAltLabel || '').format({
            nb: index + 1,
            mediaType: _this4.props.labels && _this4.props.labels[type]
          }),
          hasForcedImage: !!media.thumbnailUrl,
          iconName: type === MEDIA_TYPES.PHOTOS ? '' : ICONS[type],
          onClick: function onClick() {
            return _this4.showCarousel(type, index);
          },
          ratio: _this4.props.ratioKey,
          src: media.thumbnailUrl || media.url || media.imageLarge || '',
          trackingData: {
            actionGA: 'media',
            labelGA: type
          }
        };
      });
    }
  }, {
    key: "getLauncherMedias",
    value: function getLauncherMedias(isDesktop, hasImageSlideShowLauncher) {
      var _this5 = this;

      var types = hasImageSlideShowLauncher ? [MEDIA_TYPES.PHOTOS] : ORDERED_MEDIAS_LAUNCHER;
      return Object(lodash["flattenDeep"])(types.map(function (type) {
        return _this5.mapLauncherMedias(type, isDesktop);
      })).filter(function (i) {
        return !!i.src;
      });
    }
  }, {
    key: "getLauncherProps",
    value: function getLauncherProps(isDesktop) {
      var _location$queryParams,
          _this6 = this;

      var _this$props2 = this.props,
          _this$props2$hasImage = _this$props2.hasImageSlideShowLauncher,
          hasImageSlideShowLauncher = _this$props2$hasImage === void 0 ? false : _this$props2$hasImage,
          _this$props2$hasFullS = _this$props2.hasFullScreenButton,
          hasFullScreenButton = _this$props2$hasFullS === void 0 ? false : _this$props2$hasFullS,
          _this$props2$labels = _this$props2.labels,
          labels = _this$props2$labels === void 0 ? {} : _this$props2$labels,
          _this$props2$location = _this$props2.location,
          location = _this$props2$location === void 0 ? {} : _this$props2$location,
          _this$props2$medias = _this$props2.medias,
          medias = _this$props2$medias === void 0 ? {} : _this$props2$medias,
          openGalleryLabel = _this$props2.openGalleryLabel,
          initialIndex = _this$props2.initialIndex;
      var hasPhotosTypeMedias = this.hasTypeMedias(MEDIA_TYPES.PHOTOS, isDesktop);
      var currentPathname = location.pathname;

      var getIndexToOpenTo = function getIndexToOpenTo(type, index) {
        if (type !== MEDIA_TYPES.PHOTOS) {
          return index;
        }

        return initialIndex || index;
      };

      var actionGA;

      switch (currentPathname) {
        case constants["a" /* BOOKING_ACCOMMODATION_PATHNAME */]:
          var isMoreRoomsLayer = (location === null || location === void 0 ? void 0 : (_location$queryParams = location.queryParams) === null || _location$queryParams === void 0 ? void 0 : _location$queryParams.openLayer) === booking_constants["b" /* BE_ACCOMMODATIONS_LAYER_NAME */];
          actionGA = isMoreRoomsLayer ? 'moreRooms' : 'accommodation';
          break;

        case constants["e" /* COMPARATOR_PATHNAME */]:
          actionGA = 'compare';
          break;

        default:
          actionGA = 'media';
          break;
      }

      var getButton = function getButton(type, index) {
        return {
          ariaLabel: openGalleryLabel ? "".concat(labels[type], " (").concat(Object(lodash["get"])(medias, [type], []).length, ") - ").concat(openGalleryLabel) : null,
          dataTestId: "Multimedia-".concat(type, "-button"),
          iconIsNotSquare: type === MEDIA_TYPES.STREETVIEWS,
          iconName: ICONS[type],
          id: type,
          isActive: type === _this6.state.activeMedias,
          label: labels[type],
          number: Array.isArray(medias === null || medias === void 0 ? void 0 : medias[type]) ? medias[type].length : null,
          onClick: function onClick() {
            return _this6.showCarousel(type, getIndexToOpenTo(type, index));
          },
          trackingData: {
            actionGA: actionGA,
            labelGA: type === MEDIA_TYPES.STREETVIEWS ? 'GoogleStreetView' : type
          }
        };
      };

      var buttons = ORDERED_MEDIAS.map(function (type, index) {
        return _this6.hasTypeMedias(type, isDesktop) ? getButton(type, index) : null;
      }).filter(Boolean);
      var extraButtons = [hasFullScreenButton ? _objectSpread(_objectSpread({}, getButton(MEDIA_TYPES.PHOTOS)), {}, {
        iconName: icons["a" /* ICONS */].FULLSCREEN,
        label: '',
        minWidth: 'initial',
        buttonClassName: 'absolute rtl:right-0 md:bottom-0 md:top-auto top-0 mt-px10 md:mx-px10 md:mx-px20 mb-0'
      }) : null].filter(Boolean);
      return {
        buttons: buttons,
        extraButtons: extraButtons,
        medias: hasImageSlideShowLauncher && hasPhotosTypeMedias ? this.getLauncherMedias(isDesktop, hasImageSlideShowLauncher) // $FlowFixMe
        : this.getLauncherMedias(isDesktop).slice(0, 5)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return Multimedia_jsx(responsiveContext["a" /* default */].Consumer, null, function (_ref2) {
        var isDesktop = _ref2.isDesktop;

        if (!_this7.hasMedias(isDesktop)) {
          return null;
        }

        var _this7$state = _this7.state,
            activeMedias = _this7$state.activeMedias,
            carouselIndex = _this7$state.carouselIndex;
        var _this7$props = _this7.props,
            className = _this7$props.className,
            closeLabel = _this7$props.closeLabel,
            galleryLabel = _this7$props.galleryLabel,
            hasImageSlideShowLauncher = _this7$props.hasImageSlideShowLauncher,
            isExclusiveCollection = _this7$props.isExclusiveCollection,
            isOverlay = _this7$props.isOverlay,
            nextLabel = _this7$props.nextLabel,
            previousLabel = _this7$props.previousLabel,
            theme = _this7$props.theme;

        var items = _this7.getCarouselItems(activeMedias);

        var launcherProps = _this7.getLauncherProps(isDesktop);

        return Multimedia_jsx(react["Fragment"], null, Multimedia_jsx(MultimediaLauncher, {
          buttons: [].concat(Object(toConsumableArray["a" /* default */])(launcherProps.buttons), Object(toConsumableArray["a" /* default */])(launcherProps.extraButtons)),
          className: className,
          closeLabel: closeLabel,
          galleryLabel: galleryLabel,
          isExclusiveCollection: isExclusiveCollection,
          hasLazyLoading: true,
          isImageSlideShow: hasImageSlideShowLauncher,
          isOverlay: isOverlay,
          medias: launcherProps.medias,
          nextLabel: nextLabel,
          previousLabel: previousLabel,
          theme: theme
        }), !!activeMedias && Multimedia_jsx(Backdrop["a" /* Backdrop */], {
          ariaLabel: galleryLabel,
          className: "frosted-glass-desaturated",
          closeLabel: closeLabel,
          hasCloseButton: true,
          onClose: _this7.closeCarousel
        }, Multimedia_jsx("div", {
          className: "h-full w-full flex flex-col"
        }, Multimedia_jsx(Carousel, {
          className: "flex-1 flex",
          hasInfiniteScroll: true,
          initialIndex: carouselIndex,
          key: Math.random(),
          nextLabel: nextLabel,
          previousLabel: previousLabel
        }, items), Multimedia_jsx("div", {
          className: "flex items-center justify-center px-px10",
          style: {
            height: '72px'
          }
        }, Multimedia_jsx(ActionButtonsGroup_ActionButtonsGroup, {
          isScrollable: true,
          items: launcherProps.buttons,
          minWidth: "6.25rem",
          reverseLabelAndNumber: theme !== 'accommodation',
          theme: "overlay"
        })))));
      });
    }
  }]);

  return _Multimedia;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Multimedia_Multimedia, "defaultProps", {
  medias: {},
  ratioKey: ratios_utils["a" /* default */].L
});

var Multimedia = Object(withRouter["a" /* withRouter */])(Multimedia_Multimedia);

/***/ }),

/***/ "h9IM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if ( true && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else {}
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),

/***/ "hA0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductLogo_ProductLogo; });

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.theme.js

var themes = {
  "default": function _default(_ref) {
    var isExclusiveCollection = _ref.isExclusiveCollection;
    return {
      thRoot: 'text-center',
      thIcon: classnames_default()('mb-px15', {
        'bg-blue rounded-full text-white p-px15': !isExclusiveCollection
      }, {
        'border-5 border-deepBlue text-deepBlue p-px10': isExclusiveCollection
      }),
      thIconWidth: 'calc(100rem / 16)',
      thIsNotSquare: false,
      thProductInfo: 'flex flex-col-reverse text-initial',
      thProductCountry: 'text-sm truncate w-full font-bold',
      thProductName: 'text-md font-brand leading-tight'
    };
  },
  calendar: function calendar() {
    return {
      thRoot: 'font-brand sm:inline-block text-blue text-center text-xs md:text-sm',
      thIconWidth: '5rem',
      thIsNotSquare: true
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx
var __jsx = react_default.a.createElement;




var ProductLogo_ProductLogo = function ProductLogo(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      iconName = _ref.iconName,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  var _themes$theme = themes[theme]({
    isExclusiveCollection: isExclusiveCollection
  }),
      thIcon = _themes$theme.thIcon,
      thIconWidth = _themes$theme.thIconWidth,
      thRoot = _themes$theme.thRoot,
      thIsNotSquare = _themes$theme.thIsNotSquare,
      thProductInfo = _themes$theme.thProductInfo,
      thProductName = _themes$theme.thProductName,
      thProductCountry = _themes$theme.thProductCountry;

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx(Icon["a" /* Icon */], {
    alt: productName,
    isNotSquare: thIsNotSquare,
    className: thIcon,
    name: iconName,
    width: thIconWidth
  }), __jsx("div", {
    className: thProductInfo
  }, productName && __jsx("p", {
    className: classnames_default()('reset-paragraph', thProductName)
  }, productName), productCountry && __jsx("p", {
    className: classnames_default()('reset-paragraph', thProductCountry)
  }, productCountry)));
};

/***/ }),

/***/ "hBvt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "hPQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FACET_QUERY_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return navigateToSearchPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return navigateToResortPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentUrlContainsSearchQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentUrlHasNoQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFacetsAsString; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("U2CP");
/* harmony import */ var _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sW3P");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("k9PE");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("nv//");
















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var FACET_QUERY_PARAMS = [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_KIDS */ "h"], _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* QUERY_QUERY_PARAM */ "C"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_TRANSPORT */ "k"], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* facetsQueryParamMapping */ "a"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* ACTIVITIES_FACET_ID */ "a"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* facetsQueryParamMapping */ "a"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* COUNTRIES_FACET_ID */ "e"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* facetsQueryParamMapping */ "a"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* DESTINATIONS_FACET_ID */ "n"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* facetsQueryParamMapping */ "a"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* TYPES_OF_STAY_FACET_ID */ "E"]], _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* facetsQueryParamMapping */ "a"][_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* FACET_COMFORT_ID */ "p"]]];

var computeQueryParamsForUrl = function computeQueryParamsForUrl(args) {
  var _objectSpread2;

  var activeFacetsQueries = args.activeFacetsQueries,
      criteriaKeysToPersist = args.criteriaKeysToPersist,
      searchCriteria = args.searchCriteria;
  var formattedDate = searchCriteria.departureDate && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* getDepartureDateDisplayValue */ "g"])(Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* formatDepartureDateForStore */ "b"])(searchCriteria.departureDate, ''));
  var searchQuery = searchCriteria.query ? searchCriteria.query.label : '';
  return _objectSpread((_objectSpread2 = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_objectSpread2, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DEPARTURE_DATE */ "f"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DEPARTURE_DATE */ "f"]) && formattedDate || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_objectSpread2, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DURATION */ "g"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DURATION */ "g"]) && searchCriteria.duration || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_objectSpread2, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_TRANSPORT */ "k"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_TRANSPORT */ "k"]) && searchCriteria.departureCity || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_objectSpread2, _utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* QUERY_QUERY_PARAM */ "C"], criteriaKeysToPersist.includes(_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* QUERY_QUERY_PARAM */ "C"]) && (searchCriteria.keywords || searchQuery) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(_objectSpread2, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_KIDS */ "h"], criteriaKeysToPersist.includes(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_KIDS */ "h"]) && searchCriteria.kids.length > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_18__[/* serializeKidsToQueryParam */ "k"])({
    kids: searchCriteria.kids,
    kidsValidationState: searchCriteria.kidsValidationState
  }) || undefined), _objectSpread2), activeFacetsQueries);
};

var navigateToSearchPage = function navigateToSearchPage(args) {
  var activeFacetsQueries = args.activeFacetsQueries,
      criteriaKeysToPersist = args.criteriaKeysToPersist,
      location = args.location,
      searchCriteria = args.searchCriteria,
      searchPageRouteName = args.searchPageRouteName;
  var queryParams = computeQueryParamsForUrl({
    activeFacetsQueries: activeFacetsQueries,
    criteriaKeysToPersist: criteriaKeysToPersist,
    searchCriteria: searchCriteria
  }); // NOTE: URI.setQuery() does not remove existing queries

  var searchPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_21__[/* convertLocationToURI */ "c"])(location).setQuery(queryParams);
  var previousPathname = searchPageUrl.pathname();
  var pathname = searchPageRouteName ? _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_16__[/* urlPattern */ "b"](searchPageRouteName) : null;

  if (pathname) {
    searchPageUrl.pathname(pathname);
  }

  var isShallow = searchPageUrl.pathname() === previousPathname;
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].redirectTo()(searchPageUrl, {
    replace: isShallow,
    shallow: isShallow
  });
};
var navigateToResortPage = function navigateToResortPage(args) {
  var location = args.location,
      query = args.query,
      searchCriteria = args.searchCriteria;
  var queryParams = computeQueryParamsForUrl({
    criteriaKeysToPersist: [_utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DEPARTURE_DATE */ "f"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_DURATION */ "g"], _utils_uri_constants__WEBPACK_IMPORTED_MODULE_19__[/* QUERY_TRANSPORT */ "k"]],
    searchCriteria: searchCriteria
  });
  var resortPageUrl = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_21__[/* convertLocationToURI */ "c"])(location).pathname(query.link).setQuery(queryParams);
  _utils_uri_redirectUtils__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"].redirectTo()(resortPageUrl);
};
var currentUrlContainsSearchQueryParam = function currentUrlContainsSearchQueryParam(location) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_15__["isEmpty"])(location.queryParams[_utils_faceting_constants__WEBPACK_IMPORTED_MODULE_17__[/* QUERY_QUERY_PARAM */ "C"]]);
};
var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams(location) {
  return FACET_QUERY_PARAMS.every(function (queryKey) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_15__["isEmpty"])(location.queryParams[queryKey]);
  });
};
var getFacetsAsString = function getFacetsAsString(filters, facetCategoryId) {
  var facetsInCategory = filters.filter(function (filter) {
    return filter.id === facetCategoryId;
  });

  if (facetsInCategory.length === 0) {
    return null;
  }

  return facetsInCategory.map(function (filter) {
    return filter.name;
  }).join('|');
};

/***/ }),

/***/ "hfZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ABTestContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ABTestContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({});

/***/ }),

/***/ "hgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductHeader; });
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("VHif");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("i5Mr");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;







var ICONS_HEIGHT = 32;
var ProductHeader = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_2__["memo"])(function ProductHeader(_ref) {
  var badge = _ref.badge,
      _ref$badgeColor = _ref.badgeColor,
      badgeColor = _ref$badgeColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].BLUE : _ref$badgeColor,
      _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? {} : _ref$badgeIcon,
      className = _ref.className,
      hasECLogo = _ref.hasECLogo,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? {} : _ref$heading,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      isLinkDisabled = _ref.isLinkDisabled,
      link = _ref.link,
      onClick = _ref.onClick;
  var _heading$title = heading.title,
      title = _heading$title === void 0 ? '' : _heading$title,
      _heading$subtitle = heading.subtitle,
      subtitle = _heading$subtitle === void 0 ? '' : _heading$subtitle;
  var TagName = isLinkDisabled ? 'div' : _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"];
  return __jsx("header", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(className, 'flex', {
      'flex-col-reverse justify-end rtl:pl-px15 w-1/2': isCompact
    }),
    onClick: onClick,
    "data-testid": "Product-Header"
  }, __jsx(TagName, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('reset-anchor flex z-1 min-w-0', {
      'mt-px10': isCompact
    }, {
      'flex-1': !isCompact
    }),
    "data-testid": "ProductHeader-link"
  }, isLinkDisabled ? null : link), !isLinkDisabled && __jsx("div", {
    className: "absolute inset-0",
    "data-testid": "ProductHeader-link-overlay"
  }), __jsx("div", {
    className: "relative flex-1 flex flex-col-reverse justify-center -mb-px overflow-hidden rtl:pr-px5"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_8__[/* Title */ "a"], {
    className: "flex items-center font-brand leading-one text-lg",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].GRAY_DARKER,
    hasEllipsis: true,
    hLevel: 2,
    role: "presentation",
    theme: "none"
  }, title), __jsx("div", {
    className: "flex"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_8__[/* Title */ "a"], {
    className: "flex min-w-0 items-center font-bold font-sans text-sm uppercase tracking-tight",
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_4__[/* COLORS */ "a"].GRAY_MEDIUM,
    hasEllipsis: true,
    hLevel: 3,
    role: "presentation",
    theme: "none"
  }, subtitle), !!badge && __jsx("div", {
    "data-testid": "ProductHeader-seasonBadge",
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("bg-".concat(badgeColor), 'leading-one p-px5 font-bold uppercase rounded-tiny text-center text-white text-xs whitespace-no-wrap rtl:ml-px10')
  }, __jsx("div", {
    className: "-mb-px"
  }, badge))))), __jsx("div", {
    className: "flex -mx-px5"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_5__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])({}, badgeIcon, {
    className: "mx-px5 rounded-tiny",
    size: ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && __jsx("span", {
    className: "font-brand leading-none text-sm self-center"
  }, "&"), hasECLogo && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_7__[/* ECBadge */ "a"], {
    className: "flex-none mx-px5",
    height: ICONS_HEIGHT,
    iconWidth: "95%"
  })));
});

/***/ }),

/***/ "hqKg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "i0/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productWellnessResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("H0gB");




var productWellnessResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_WELLNESS */ "Y"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var query = Object(_product_utils_productFeatures_queries__WEBPACK_IMPORTED_MODULE_3__[/* productWellnessQuery */ "f"])(productId, {
      urlParams: urlParams
    });
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_WELLNESS */ "Bc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "i2OK":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("4I0e");
var redefine = __webpack_require__("L1Xj");
var toString = __webpack_require__("3dm5");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "i3Ve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Ub5k");
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("d1HQ");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("829J");
/* harmony import */ var _modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("EvYw");
/* harmony import */ var _toggler_Toggler_jsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("7CPK");









var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function Tooltip(props) {
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_9__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_10__[/* default */ "b"]);
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_9__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_11__[/* ReactPageContext */ "a"]);
  var children = props.children,
      isExpanded = props.isExpanded,
      modalProps = props.modalProps,
      renderTrigger = props.renderTrigger,
      trackingData = props.trackingData;
  return __jsx(_toggler_Toggler_jsx__WEBPACK_IMPORTED_MODULE_15__[/* Toggler */ "a"], {
    isActive: isExpanded,
    onToggle: function onToggle(isActive) {
      if (trackingData && isActive) {
        _tracking_tracking_api__WEBPACK_IMPORTED_MODULE_12__[/* setDataLayer */ "b"](_objectSpread(_objectSpread({}, _tracking_constants__WEBPACK_IMPORTED_MODULE_13__[/* GA_DEFAULT_PAYLOAD */ "i"]), trackingData), appContext, pageContext.pageType);
      }
    }
  }, function (toggle, isActive) {
    return __jsx(react__WEBPACK_IMPORTED_MODULE_9__["Fragment"], null, renderTrigger(toggle, isActive), isActive && __jsx(_modal_Modal_jsx__WEBPACK_IMPORTED_MODULE_14__[/* Modal */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])({}, modalProps, {
      onClose: toggle
    }), children));
  });
}

/***/ }),

/***/ "iBXc":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("ep/x");
var aPossiblePrototype = __webpack_require__("2CYk");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "iN+R":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("bOkD");

var iterableToArray = __webpack_require__("DSo7");

var unsupportedIterableToArray = __webpack_require__("D7XE");

var nonIterableSpread = __webpack_require__("uYlf");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "ieZH":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toObject = __webpack_require__("A+R+");
var nativeGetPrototypeOf = __webpack_require__("yvHl");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "igjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isStrictlyProductionEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isStrictlyStagingEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isStrictlyIntegrationEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isStrictlyTestEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isStrictlyDevelopmentEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentLocale; });
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("rOcY");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_config__WEBPACK_IMPORTED_MODULE_2__);



function getCurrentUri(req) {
  return new urijs__WEBPACK_IMPORTED_MODULE_0___default.a(decodeURI(req.originalUrl)).protocol(req.protocol).host(req.get('host'));
}
function isProduction() {
  return _config__WEBPACK_IMPORTED_MODULE_2___default.a.get('DEPLOYMENT_ENV') === 'production';
}
function isStrictlyProductionEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && (cfg.get('DEPLOYMENT_ENV') === 'production' || cfg.get('DEPLOYMENT_ENV') === 'prod');
}
function isStrictlyStagingEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'staging';
}
function isStrictlyIntegrationEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'production' && cfg.get('DEPLOYMENT_ENV') === 'integration';
}
function isStrictlyTestEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'test';
}
function isStrictlyDevelopmentEnv() {
  var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _config__WEBPACK_IMPORTED_MODULE_2___default.a;
  return cfg.get('NODE_ENV') === 'development' || cfg.get('NODE_ENV') === 'dev';
}
function getCurrentLocale(requestedLocale, hostname) {
  if (requestedLocale) {
    return requestedLocale;
  }

  var domainServiceForHostname = _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_1___default.a.forHostname(hostname);
  return domainServiceForHostname.getDefaultLocale();
}

/***/ }),

/***/ "ih3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offerDescriptionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var offerDescriptionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* OFFER_DESCRIPTION */ "D"],
  resolve: function resolve(appContext, props) {
    var offerId = props.offerId;
    var query = "{\n      offer(offerId: \"".concat(offerId, "\") {color timingArgument description}\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_OFFER_DESCRIPTION */ "Ob"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "iiKe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ CheckedList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.themes.js

var themes = {
  "default": {
    thTitle: 'mb-px20',
    thList: 'reset-list sm:column-count-2 -m-px5',
    thListItem: 'flex p-px5',
    thIcon: 'bg-emerald flex-shrink-0 p-px5 rounded-full rtl:mr-px10',
    thIconColor: colors["a" /* COLORS */].WHITE,
    thIconWidth: '1em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx

var __jsx = react_default.a.createElement;






function CheckedList(props) {
  var children = props.children,
      className = props.className,
      itemClassName = props.itemClassName,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title;
  if (!react["Children"].count(children)) return null;
  var _themes$theme = themes[theme],
      thTitle = _themes$theme.thTitle,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thIcon = _themes$theme.thIcon,
      thIconColor = _themes$theme.thIconColor,
      thIconWidth = _themes$theme.thIconWidth;
  return __jsx(react["Fragment"], null, title && __jsx(Title["a" /* Title */], {
    className: thTitle,
    theme: "title-sans-3"
  }, title), __jsx("ul", {
    className: classnames_default()(className, thList)
  }, react["Children"].map(children, function (child, idx) {
    return __jsx("li", {
      className: classnames_default()(itemClassName, thListItem),
      key: idx
    }, __jsx(Icon["a" /* Icon */], {
      color: thIconColor,
      className: thIcon,
      name: icons["a" /* ICONS */].CHECK,
      width: thIconWidth
    }), child);
  })));
}

/***/ }),

/***/ "j2ob":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "jCye":
/***/ (function(module, exports, __webpack_require__) {

var isConstructor = __webpack_require__("ydRd");
var tryToString = __webpack_require__("xS1b");

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "jD8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TextLink_TextLink; });

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.themes.js

var themes = {
  "default": function _default(_ref) {
    var _ref$color = _ref.color,
        color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-base focus:underline hover:underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  link: function link(_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref2$color;
    return {
      thIconWidth: '.7em',
      thRoot: "text-".concat(color, " font-bold font-sans leading-tight text-base focus:underline hover:underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  fancy: function fancy(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref3$color;
    return {
      thIconWidth: '0.4375rem',
      thRoot: "text-".concat(color, " font-bold font-sans leading-normal text-sm"),
      thLabel: '',
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  },
  solid: function solid(_ref4) {
    var _ref4$color = _ref4.color,
        color = _ref4$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref4$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " bg-current font-bold font-sans leading-one p-px10 rounded-tiny text-base uppercase"),
      thLabel: 'text-white',
      thIconLeft: 'text-white rtl:mr-px10',
      thIconRight: 'text-white rtl:ml-px10'
    };
  },
  simple: function simple(_ref5) {
    var _ref5$color = _ref5.color,
        color = _ref5$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref5$color;
    return {
      thIconWidth: '1em',
      thRoot: "text-".concat(color, " font-sans leading-loose text-base underline"),
      thIconLeft: 'rtl:mr-px10',
      thIconRight: 'rtl:ml-px10'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx

var __jsx = react_default.a.createElement;







var TextLink_TextLink = function TextLink(_ref) {
  var ariaHidden = _ref.ariaHidden,
      ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      color = _ref.color,
      iconLeftName = _ref.iconLeftName,
      _ref$iconRightName = _ref.iconRightName,
      iconRightName = _ref$iconRightName === void 0 ? icons["a" /* ICONS */].BOLDER_ARROW_FORTH : _ref$iconRightName,
      isExternalLink = _ref.isExternalLink,
      label = _ref.label,
      onClick = _ref.onClick,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      target = _ref.target,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData,
      url = _ref.url;

  if (!label) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color
  }),
      thIconLeft = _themes$theme.thIconLeft,
      thIconRight = _themes$theme.thIconRight,
      thIconWidth = _themes$theme.thIconWidth,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot;

  return __jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    as: url ? DynamicLink["a" /* default */] : 'button',
    className: classnames_default()(className, 'reset-button inline-flex items-center', thRoot),
    onClick: onClick,
    tabIndex: tabIndex,
    target: target,
    trackingData: trackingData
  }, url ? {
    url: url,
    isExternalLink: isExternalLink
  } : {
    type: 'button'
  }), !!iconLeftName && __jsx(Icon["a" /* Icon */], {
    className: thIconLeft,
    hasRtl: true,
    name: iconLeftName,
    width: thIconWidth
  }), __jsx("span", {
    className: thLabel
  }, label), !!iconRightName && __jsx(Icon["a" /* Icon */], {
    className: thIconRight,
    hasRtl: true,
    name: iconRightName,
    width: thIconWidth
  }));
};

/***/ }),

/***/ "jVcT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productStrengthsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productStrengthsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_STRENGTHS */ "W"],
  resolve: function resolve(appContext, _ref) {
    var resortId = _ref.resortId;
    var query = "query {\n      resort(resortId:\"".concat(resortId, "\"){\n        comfort\n        isExclusiveCollection\n        isJoyview\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_STRENGTHS */ "yc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "jldR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Capsule_Capsule; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.styles.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var style = {
  capsule: {
    width: '100%',
    position: 'relative'
  },
  upsideCapsule: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  header: {
    borderRadius: '5px 5px 0 0',
    backgroundColor: '#0480a9',
    height: '4px',
    position: 'static',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1
  },
  upsideHeader: {
    borderRadius: '0 0 5px 5px'
  },
  headerLarge: {
    backgroundColor: '#005589',
    height: '48px',
    position: 'relative'
  },
  headerAuto: {
    backgroundColor: '#005589',
    position: 'relative',
    padding: '10px',
    height: 'auto'
  },
  content: {
    position: 'relative',
    borderRadius: '0 0 5px 5px',
    backgroundColor: '#fff',
    overflow: 'hidden',
    boxShadow: '0 10px 20px 0 rgba(0,0,0,0.05)',
    border: 'solid 1px #d4d1d1'
  },
  upsideContent: {
    marginTop: '-1px',
    borderRadius: '5px 5px 0 0'
  },
  contentNoHeader: {
    marginTop: '-1px',
    borderRadius: '5px'
  },
  contentLargeHeader: {
    paddingTop: '34px',
    marginTop: '-35px'
  },
  upsideContentLargeHeader: {
    paddingTop: '0',
    marginTop: '0',
    paddingBottom: '34px',
    marginBottom: '-35px'
  },
  label: {
    fontFamily: 'Trident, HappinessBeta, HappinessBeta-New, HappinessBeta wf, Verdana, Arial, sans-serif',
    verticalAlign: '-3px'
  },
  checkIcon: {
    position: 'absolute',
    display: 'flex',
    top: '-12px',
    right: '-9px',
    left: '-9px',
    justifyContent: 'flex-end'
  }
};
var styles = function styles(_ref) {
  var _ref$additionalStyle = _ref.additionalStyle,
      additionalStyle = _ref$additionalStyle === void 0 ? {
    header: {},
    content: {},
    icon: {},
    label: {}
  } : _ref$additionalStyle,
      color = _ref.color,
      isHeaderNone = _ref.isHeaderNone,
      isLargeHeader = _ref.isLargeHeader,
      isHeaderAuto = _ref.isHeaderAuto,
      upside = _ref.upside;
  return {
    computedCapsuleStyle: _objectSpread(_objectSpread(_objectSpread({}, style.capsule), upside ? style.upsideCapsule : null), additionalStyle.root),
    computedHeaderStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedHeaderFullStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), {}, {
      justifyContent: 'space-between',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer'
    }, isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header),
    computedHeaderFullStyleCollapsed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.header), {}, {
      justifyContent: 'space-between',
      paddingLeft: '20px',
      paddingRight: '20px',
      cursor: 'pointer'
    }, isLargeHeader ? style.headerLarge : null), isHeaderAuto ? style.headerAuto : null), upside ? style.upsideHeader : null), color ? {
      backgroundColor: color
    } : null), additionalStyle.header), {}, {
      borderRadius: '5px'
    }),
    computedContentStyle: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, style.content), upside ? style.upsideContent : null), isLargeHeader ? style.contentLargeHeader : null), isLargeHeader && upside ? style.upsideContentLargeHeader : null), isHeaderNone ? style.contentNoHeader : null), additionalStyle.content),
    computedIconWrapperStyle: _objectSpread({}, additionalStyle.icon),
    computedLabelStyle: _objectSpread(_objectSpread(_objectSpread({}, style.label), additionalStyle.label), {}, {
      marginLeft: '10px'
    }),
    computedCheckIconStyle: _objectSpread({}, style.checkIcon),
    computedChevronIconlStyle: {
      display: 'flex',
      width: '9px',
      height: '9px',
      stroke: 'white',
      strokeWidth: '2px',
      alignItems: 'center',
      marginTop: '-3px'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/frameworks/capsule/Capsule.jsx
var __jsx = react_default.a.createElement;







var SMALL = 'small';
var LARGE = 'large';
var AUTO = 'auto';
var NONE = 'none';
var Capsule_Capsule = function Capsule(_ref) {
  var additionalStyle = _ref.additionalStyle,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      contentClassName = _ref.contentClassName,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? SMALL : _ref$header,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].ALL_INCLUSIVE : _ref$icon,
      label = _ref.label,
      upside = _ref.upside,
      validated = _ref.validated,
      _ref$isAccordion = _ref.isAccordion,
      isAccordion = _ref$isAccordion === void 0 ? false : _ref$isAccordion;
  var isLargeHeader = header === LARGE;
  var isHeaderNone = header === NONE;
  var isHeaderAuto = header === AUTO;

  var _styles = styles({
    additionalStyle: additionalStyle,
    color: color,
    isHeaderNone: isHeaderNone,
    isLargeHeader: isLargeHeader,
    isHeaderAuto: isHeaderAuto,
    upside: upside
  }),
      computedCapsuleStyle = _styles.computedCapsuleStyle,
      computedCheckIconStyle = _styles.computedCheckIconStyle,
      computedContentStyle = _styles.computedContentStyle,
      computedHeaderStyle = _styles.computedHeaderStyle,
      computedHeaderFullStyle = _styles.computedHeaderFullStyle,
      computedHeaderFullStyleCollapsed = _styles.computedHeaderFullStyleCollapsed,
      computedIconWrapperStyle = _styles.computedIconWrapperStyle,
      computedLabelStyle = _styles.computedLabelStyle,
      computedChevronIconlStyle = _styles.computedChevronIconlStyle;

  var _useState = Object(react["useState"])(!isAccordion ? true : false),
      displayed = _useState[0],
      setDisplayed = _useState[1];

  if (!react["Children"].count(children)) {
    return null;
  }

  var toggleDisplay = function toggleDisplay() {
    setDisplayed(function (display) {
      return !display;
    });
  };

  var custsomAccordionStyle = function custsomAccordionStyle() {
    if (isAccordion) {
      if (displayed) {
        return computedHeaderFullStyle;
      }

      return computedHeaderFullStyleCollapsed;
    }

    return computedHeaderStyle;
  };

  return __jsx("section", {
    className: classnames_default()(className, 'Capsule'),
    style: computedCapsuleStyle
  }, header !== 'none' && __jsx("div", {
    onClick: isAccordion ? toggleDisplay : function () {},
    style: custsomAccordionStyle()
  }, (isLargeHeader || isHeaderAuto) && __jsx(react["Fragment"], null, __jsx("div", {
    style: {
      display: 'flex'
    }
  }, __jsx("div", {
    style: computedIconWrapperStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: icon,
    width: computedIconWrapperStyle.width || '1.25rem'
  })), __jsx("span", {
    style: computedLabelStyle
  }, label)), isAccordion && __jsx("span", {
    style: computedChevronIconlStyle
  }, __jsx(Icon["a" /* Icon */], {
    name: "select",
    width: "1em",
    className: displayed ? 'rotate-180' : '',
    style: {
      display: 'flex'
    }
  })))), __jsx("div", {
    className: contentClassName,
    style: computedContentStyle
  }, validated && __jsx("div", {
    style: {
      position: 'relative'
    }
  }, __jsx("div", {
    style: computedCheckIconStyle
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].SUCCESS,
    name: icons["a" /* ICONS */].SMALL_CIRCLE_CHECK,
    width: "3rem"
  }))), isAccordion ? __jsx(lib["UnmountClosed"], {
    isOpened: displayed
  }, children) : __jsx(react_default.a.Fragment, null, children)));
};

/***/ }),

/***/ "jw1E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupArgs; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);






var generateCmsArgs = function generateCmsArgs(content, release) {
  return "content : \"".concat(content, "\" release : \"").concat(release, "\"");
};

var getPriceArgs = function getPriceArgs(args) {
  return ['offerId', 'offerName', 'date', 'dateStart', 'dateEnd', 'duration', 'departureCity', 'forceWithoutTransport', 'optimizedPriceCalls'].filter(function (key) {
    return args[key];
  }).map(function (key) {
    var value = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["isString"])(args[key]) ? "\"".concat(args[key], "\"") : args[key];
    return [key, value];
  });
};

var buildPriceGraphqlArgs = function buildPriceGraphqlArgs(args) {
  return args.length ? "(".concat(args.map(function (priceArg) {
    return priceArg.join(' : ');
  }).join(' '), ")") : '';
};

function getPriceFields(args) {
  var content = args.content,
      release = args.release,
      isMice = args.isMice;
  var cmsArgs = generateCmsArgs(content, release);
  var priceArgs = buildPriceGraphqlArgs(getPriceArgs(args));

  if (isMice) {
    return "\n    mice {\n      bestPrice {\n        value\n        formattedValue\n      }\n      unit(".concat(cmsArgs, ")\n    }\n    ");
  }

  return "\n    price ".concat(priceArgs, " {\n      bestPrice {\n        value\n        formattedValue\n      }\n      initialPrice {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        numberOfAdults\n        departureCity {\n          value\n          name\n        }\n        accommodationComfortLabel\n      }\n    }");
}

function getThumbnailBaseFields(args) {
  var isMice = args.isMice,
      offerName = args.offerName,
      tourDurationPlaceholder = args.tourDurationPlaceholder,
      cruiseTimingPlaceholder = args.cruiseTimingPlaceholder,
      cruiseDurationPlaceholder = args.cruiseDurationPlaceholder,
      dateFormat = args.dateFormat,
      content = args.content,
      release = args.release; // use typeof string since we cannot be sure that there are no empty strings on the CMS

  var durationArgs = typeof tourDurationPlaceholder === 'string' && typeof cruiseDurationPlaceholder === 'string' ? "(message : \"".concat(tourDurationPlaceholder, "\", cruiseMessage : \"").concat(cruiseDurationPlaceholder, "\")") : '';
  var timingDescriptionArgs = typeof cruiseTimingPlaceholder === 'string' && typeof dateFormat === 'string' ? "(message : \"".concat(cruiseTimingPlaceholder, "\" dateFormat : \"").concat(dateFormat, "\")") : '';
  return "\n    accommodationsIntroduction {\n      roomsCount\n    }\n    badgeIcon\n    childcareDetails {\n      id\n      included\n    }\n    color\n    comfort\n    comfortLabel\n    destination {\n      area\n      country\n    }\n    duration".concat(durationArgs, "\n    href(offerName : \"").concat(offerName, "\")\n    id\n    images\n    isCruise\n    isDoubleSeason\n    isExclusiveCollection\n    isExplicitEC\n    isJoyview\n    isResort\n    isSummer\n    isTour\n    isVilla\n    isWinter\n    minAuthorizedAge {\n      value\n    }\n    ").concat(isMice ? "productMeetingRooms {\n      meetingRooms {\n        shapes {\n          maxCapacity\n        }\n      }\n    }" : '', "\n    name\n    openingStatus\n    rangeId\n    rangeLabel\n    resortId\n    seasonName\n    seasonTrad(").concat(generateCmsArgs(content, release), ")\n    thematics {\n      label\n    }\n    timingDescription").concat(timingDescriptionArgs, "\n    title\n    transportType\n    type");
}

function cleanupArgs(args) {
  return {
    content: args.content || '',
    isMice: args.isMice,
    release: args.release || '',
    cruiseTimingPlaceholder: args.cruiseTimingPlaceholder,
    cruiseDurationPlaceholder: args.cruiseDurationPlaceholder,
    date: args.date || '',
    dateFormat: args.dateFormat,
    departureCity: args.departureCity || '',
    duration: args.duration || null,
    dateStart: args.dateStart || '',
    dateEnd: args.dateEnd || '',
    forceWithoutTransport: !!args.forceWithoutTransport,
    offerId: args.offerId || '',
    offerName: args.offerName || '',
    optimizedPriceCalls: args.optimizedPriceCalls || false,
    tourDurationPlaceholder: args.tourDurationPlaceholder
  };
}

function makeResortThumbnailQuery(args, options) {
  var _ref = options || {},
      _ref$withoutPrice = _ref.withoutPrice,
      withoutPrice = _ref$withoutPrice === void 0 ? false : _ref$withoutPrice;

  var priceFields = !withoutPrice ? getPriceFields(cleanupArgs(args)) : '';
  return "".concat(getThumbnailBaseFields(cleanupArgs(args))).concat(priceFields);
}

/* harmony default export */ __webpack_exports__["b"] = (makeResortThumbnailQuery);

/***/ }),

/***/ "k4ez":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("a4SZ");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "k9PE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("LJOr");
/* harmony import */ var core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_search__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("qm5D");
/* harmony import */ var _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Mkub");
/* harmony import */ var _graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ESA2");
/* harmony import */ var _ple_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("6jSF");










 // TODO This was a curried function. It should be just redirectTo(uri: string): void

function redirectTo(currentUrl) {
  return function (uri, options) {
    if (true) {
      var dynamicLinkHelper = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"](currentUrl || window.location.href, uri);

      if (dynamicLinkHelper.isExternalUrl()) {
        _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["windowWrapper"].setLocation(uri);
      } else {
        var objectUri = new urijs__WEBPACK_IMPORTED_MODULE_6___default.a(uri); // next/router is not happy if you only pass him the query parameters. So get the pathname
        // when not provided

        if (objectUri.pathname() === '') {
          objectUri.pathname(window.location.pathname);
        }

        var currentUri = new urijs__WEBPACK_IMPORTED_MODULE_6___default.a(window.location.href);

        if (currentUri.resource() !== objectUri.resource()) {
          // URI().resource() prevent domain name to be passed to the history
          // http://domain/foo -> /foo
          // /foo -> /foo
          if (options === null || options === void 0 ? void 0 : options.shallow) {
            if (options.replace) {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5__["Router"].shallowReplaceRoute(objectUri.resource());
            } else {
              _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5__["Router"].shallowPushRoute(objectUri.resource());
            }
          } else if (options === null || options === void 0 ? void 0 : options.replace) {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5__["Router"].replaceRoute(objectUri.resource());
          } else {
            _routes_nextRoutes__WEBPACK_IMPORTED_MODULE_5__["Router"].pushRoute(objectUri.resource(), undefined, options);
          }
        }
      }
    }
  };
}

function redirectToUri() {
  return function (uri) {
    return function () {
      var redirectUri = new _client_components_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"](_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["windowWrapper"].getLocation(), uri).toString();
      redirectTo()(redirectUri);
    };
  };
}

function redirectToOidc(appContext) {
  var locale = appContext.locale,
      isSeller = appContext.isSeller,
      isCmta = appContext.isCmta;

  if (true) {
    var currentLocation = new urijs__WEBPACK_IMPORTED_MODULE_6___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["windowWrapper"].getLocation()).removeSearch('forceAuth');
    var redirectPath = currentLocation.pathname();
    var redirectUri = new urijs__WEBPACK_IMPORTED_MODULE_6___default.a(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["windowWrapper"].getOrigin()).path(redirectPath).query(currentLocation.search()).hash(_clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["windowWrapper"].getLocationPart('hash')).toString();
    Object(_graphql_client_cacheFront__WEBPACK_IMPORTED_MODULE_9__[/* clearAllCacheFront */ "a"])();
    _clubmed_utils__WEBPACK_IMPORTED_MODULE_7__["windowWrapper"].setLocation(isSeller ? Object(_ple_utils__WEBPACK_IMPORTED_MODULE_10__[/* buildSellerSigninUrl */ "e"])({
      locale: locale,
      redirectUri: redirectUri,
      isCmta: isCmta
    }) : Object(_ple_utils__WEBPACK_IMPORTED_MODULE_10__[/* buildSigninUrl */ "f"])({
      locale: locale,
      redirectUri: redirectUri
    }));
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  redirectTo: redirectTo,
  redirectToUri: redirectToUri,
  redirectToOidc: redirectToOidc
});

/***/ }),

/***/ "kG2z":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "kH/m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addressFragment; });
var addressFragment = "\nfragment Address on Address {\n    additionalInformation1\n    additionalInformation2\n    addOn\n    city\n    country\n    countryCode\n    stateOrDistrict\n    streetName\n    streetNumber\n    town\n    zipCode\n  }\n";

/***/ }),

/***/ "kNiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return serializeKidsToQueryParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getKidAgeInMonths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return facetsQueryParamMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getActiveFacetsFromQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateActiveFacetsQueries; });
/* unused harmony export findFacetCategoryById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDepartureDateForStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getChildcareFacets; });
/* unused harmony export getChildren */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDepartureCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDepartureDateDisplayValue; });
/* unused harmony export getFormattedDepartureDate */
/* unused harmony export getSelectedDepartureCity */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isDateInThePast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isKidMinor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return unserializeKidsFromQueryParam; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("i4UL");
/* harmony import */ var core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("VqLN");
/* harmony import */ var core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_is_integer__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("wQ38");
/* harmony import */ var _uri_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("Sj1w");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("sW3P");





















var _facetsQueryParamMapp;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}







function findFacetCategoryById(facets, facetCategoryId) {
  return facets.find(function (facetCategory) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_20__["get"])(facetCategory, 'id') === facetCategoryId;
  });
}

function _getFacetValues(facets, categoryId) {
  var category = findFacetCategoryById(facets, categoryId);
  return Object(lodash__WEBPACK_IMPORTED_MODULE_20__["get"])(category, 'list', []);
}

function getChildcareFacets(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_24__[/* CHILDCARE_FACET_ID */ "d"]);
}

function getDepartureCities(facets) {
  return _getFacetValues(facets, _constants__WEBPACK_IMPORTED_MODULE_24__[/* DEPARTURE_CITY_FACET_ID */ "i"]);
}

function getSelectedDepartureCity(facets) {
  var selectedCity = getDepartureCities(facets).find(function (facet) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_20__["get"])(facet, 'selected');
  });
  return selectedCity ? Object(lodash__WEBPACK_IMPORTED_MODULE_20__["get"])(selectedCity, 'name') : null;
}

function formatDepartureDateForStore(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants__WEBPACK_IMPORTED_MODULE_24__[/* DATE_FORMAT */ "f"];
  return date !== null ? moment__WEBPACK_IMPORTED_MODULE_21___default()(date, format).valueOf() : null;
}

function getDepartureDateDisplayValue() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var momentDate = moment__WEBPACK_IMPORTED_MODULE_21___default()(date);
  return momentDate.isValid() ? momentDate.format(_constants__WEBPACK_IMPORTED_MODULE_24__[/* DATE_FORMAT */ "f"]) : '';
}

function isDateInThePast(timestampDate) {
  return timestampDate ? moment__WEBPACK_IMPORTED_MODULE_21___default()(timestampDate).isBefore() : false;
}

function getFormattedDepartureDate(date, dateFormat) {
  return date ? moment__WEBPACK_IMPORTED_MODULE_21___default()(date).format(dateFormat) : '';
}

function isKidMinor(birthdate) {
  if (!birthdate) {
    return false;
  }

  var minBirthdate = moment__WEBPACK_IMPORTED_MODULE_21___default()().subtract(18, 'years');
  var momentBirthdate = moment__WEBPACK_IMPORTED_MODULE_21___default()(birthdate);
  return momentBirthdate.isValid() && momentBirthdate.isBetween(minBirthdate, moment__WEBPACK_IMPORTED_MODULE_21___default()());
}

function getChildren(numberOfChildren, childrenBirthdates) {
  if (Number.isInteger(numberOfChildren) && numberOfChildren >= 0 && numberOfChildren <= _constants__WEBPACK_IMPORTED_MODULE_24__[/* KIDS_NUMBER_MAX */ "t"]) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_20__["times"])(numberOfChildren, function (idx) {
      return childrenBirthdates && childrenBirthdates.length > idx ? {
        birthdate: moment__WEBPACK_IMPORTED_MODULE_21___default()(childrenBirthdates[idx], 'YYYYMMDD', true).valueOf(),
        childcareIncluded: false
      } : {
        childcareIncluded: false
      };
    });
  }

  return null;
}

function unserializeKidsFromQueryParam(value) {
  if (!value) return [];
  var kidsNumber = Number(value); // NOTE: DO NOT USE parseInt() !!! parseInt('2010-12-10c') will return 2010 ...

  if (kidsNumber > _constants__WEBPACK_IMPORTED_MODULE_24__[/* KIDS_NUMBER_MAX */ "t"]) {
    return [];
  }

  if (Number.isInteger(kidsNumber)) return new Array(kidsNumber).fill(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_22__[/* DEFAULT_KID_VALUE */ "a"]));
  var kids = value.split(_uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_KIDS_DELIMITER */ "i"]).map(function (serializedKidString) {
    var hasChildcareFlag = serializedKidString.substr(-1) === _uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_CHILDCARE_FLAG */ "c"];
    var strBirthdate = serializedKidString.replace(_uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_CHILDCARE_FLAG */ "c"], '');
    var birthdate = moment__WEBPACK_IMPORTED_MODULE_21___default()(strBirthdate, _uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_DATE_FORMAT */ "e"], true);
    var childcareIncluded = birthdate.isValid() ? hasChildcareFlag : _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_22__[/* DEFAULT_KID_VALUE */ "a"].childcareIncluded;
    return _objectSpread(_objectSpread({}, _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_22__[/* DEFAULT_KID_VALUE */ "a"]), {}, {
      childcareIncluded: childcareIncluded,
      birthdate: birthdate.isValid() ? birthdate.valueOf() : undefined
    });
  });
  return kids.length > _constants__WEBPACK_IMPORTED_MODULE_24__[/* KIDS_NUMBER_MAX */ "t"] ? [] : kids;
}
/**
 * Helper to serialize kids array as a URI query parameter.
 *
 * Example of returns:
 *
 * - `kids=1` (1 kid, no birthdate)
 * - `kids=2010-10-30` (1 kid, with birthdate)
 * - `kids=_` (2 kids)
 * - `kids=2010-10-30=_` (2 kids, 1 birthdate)
 * - `kids=2010-10-30c=___`
 * - `kids=2010-10-30c_2009-04-01!`
 */


var serializeKidsToQueryParam = function serializeKidsToQueryParam(params) {
  var kids = params.kids,
      kidsValidationState = params.kidsValidationState;
  var serializedKids = kids.map(function (_ref, index) {
    var birthdate = _ref.birthdate;

    if (!birthdate || !kidsValidationState || kidsValidationState[index] !== _client_store_trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_22__[/* VALIDATION_STATE_ENUM */ "f"].valid) {
      return '';
    }

    var formattedBirthdate = moment__WEBPACK_IMPORTED_MODULE_21___default()(birthdate).format(_uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_DATE_FORMAT */ "e"]);
    return formattedBirthdate;
  }).filter(function (birthdate) {
    return birthdate !== '';
  }); // Special case when there is only one kid, as we can't make a join('_') with only one item

  var serializedOutput = '';

  if (serializedKids.length === 1) {
    if (serializedKids.filter(Boolean).length === 0) {
      serializedOutput = '1';
    } // Return kid's birthdate


    if (serializedOutput !== '1') {
      serializedOutput = serializedKids.shift();
    }

    var childcareIncluded = kids.some(function (kid) {
      return kid.childcareIncluded;
    });

    if (childcareIncluded) {
      serializedOutput = "".concat(serializedOutput).concat(_uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_CHILDCARE_FLAG */ "c"]);
    }

    return serializedOutput;
  }

  return serializedKids.join(_uri_constants__WEBPACK_IMPORTED_MODULE_23__[/* QUERY_KIDS_DELIMITER */ "i"]);
};
var getKidAgeInMonths = function getKidAgeInMonths(_ref2) {
  var birthdate = _ref2.birthdate,
      departureDate = _ref2.departureDate;
  var defaultDepartureDate = moment__WEBPACK_IMPORTED_MODULE_21___default()().add(_constants__WEBPACK_IMPORTED_MODULE_24__[/* DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH */ "j"], 'months').valueOf();
  var b = birthdate ? moment__WEBPACK_IMPORTED_MODULE_21___default()(birthdate) : moment__WEBPACK_IMPORTED_MODULE_21___default()().subtract(8, 'y');
  return moment__WEBPACK_IMPORTED_MODULE_21___default()(departureDate || defaultDepartureDate).diff(b, 'months');
};
var facetsQueryParamMapping = (_facetsQueryParamMapp = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_24__[/* ACTIVITIES_FACET_ID */ "a"], 'a'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_24__[/* COUNTRIES_FACET_ID */ "e"], 'c'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_24__[/* DESTINATIONS_FACET_ID */ "n"], 'd'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_24__[/* TYPES_OF_STAY_FACET_ID */ "E"], 't'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])(_facetsQueryParamMapp, _constants__WEBPACK_IMPORTED_MODULE_24__[/* FACET_COMFORT_ID */ "p"], 'cft'), _facetsQueryParamMapp);
var getActiveFacetsFromQueryParams = function getActiveFacetsFromQueryParams(queryParams) {
  return Object.keys(facetsQueryParamMapping).reduce(function (facets, facetId) {
    var _queryParams$facetsQu;

    var activeFacets = ((_queryParams$facetsQu = queryParams[facetsQueryParamMapping[facetId]]) === null || _queryParams$facetsQu === void 0 ? void 0 : _queryParams$facetsQu.split('_')) || [];
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])({}, facetId, activeFacets.reduce(function (acc, activeFacet) {
      acc[decodeURI(activeFacet)] = true;
      return acc;
    }, {})));
    return facets;
  }, {});
};
var generateActiveFacetsQueries = function generateActiveFacetsQueries(activeFacets) {
  return Object.keys(facetsQueryParamMapping).reduce(function (facets, facetId) {
    var facet = Object.keys(activeFacets[facetId] || {});
    facets = _objectSpread(_objectSpread({}, facets), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_19__[/* default */ "a"])({}, facetsQueryParamMapping[facetId], facet.length ? facet.join('_') : undefined));
    return facets;
  }, {});
};


/***/ }),

/***/ "kWb8":
/***/ (function(module) {

module.exports = JSON.parse("{\"Aacute\":\"Á\",\"aacute\":\"á\",\"Acirc\":\"Â\",\"acirc\":\"â\",\"acute\":\"´\",\"AElig\":\"Æ\",\"aelig\":\"æ\",\"Agrave\":\"À\",\"agrave\":\"à\",\"amp\":\"&\",\"AMP\":\"&\",\"Aring\":\"Å\",\"aring\":\"å\",\"Atilde\":\"Ã\",\"atilde\":\"ã\",\"Auml\":\"Ä\",\"auml\":\"ä\",\"brvbar\":\"¦\",\"Ccedil\":\"Ç\",\"ccedil\":\"ç\",\"cedil\":\"¸\",\"cent\":\"¢\",\"copy\":\"©\",\"COPY\":\"©\",\"curren\":\"¤\",\"deg\":\"°\",\"divide\":\"÷\",\"Eacute\":\"É\",\"eacute\":\"é\",\"Ecirc\":\"Ê\",\"ecirc\":\"ê\",\"Egrave\":\"È\",\"egrave\":\"è\",\"ETH\":\"Ð\",\"eth\":\"ð\",\"Euml\":\"Ë\",\"euml\":\"ë\",\"frac12\":\"½\",\"frac14\":\"¼\",\"frac34\":\"¾\",\"gt\":\">\",\"GT\":\">\",\"Iacute\":\"Í\",\"iacute\":\"í\",\"Icirc\":\"Î\",\"icirc\":\"î\",\"iexcl\":\"¡\",\"Igrave\":\"Ì\",\"igrave\":\"ì\",\"iquest\":\"¿\",\"Iuml\":\"Ï\",\"iuml\":\"ï\",\"laquo\":\"«\",\"lt\":\"<\",\"LT\":\"<\",\"macr\":\"¯\",\"micro\":\"µ\",\"middot\":\"·\",\"nbsp\":\" \",\"not\":\"¬\",\"Ntilde\":\"Ñ\",\"ntilde\":\"ñ\",\"Oacute\":\"Ó\",\"oacute\":\"ó\",\"Ocirc\":\"Ô\",\"ocirc\":\"ô\",\"Ograve\":\"Ò\",\"ograve\":\"ò\",\"ordf\":\"ª\",\"ordm\":\"º\",\"Oslash\":\"Ø\",\"oslash\":\"ø\",\"Otilde\":\"Õ\",\"otilde\":\"õ\",\"Ouml\":\"Ö\",\"ouml\":\"ö\",\"para\":\"¶\",\"plusmn\":\"±\",\"pound\":\"£\",\"quot\":\"\\\"\",\"QUOT\":\"\\\"\",\"raquo\":\"»\",\"reg\":\"®\",\"REG\":\"®\",\"sect\":\"§\",\"shy\":\"­\",\"sup1\":\"¹\",\"sup2\":\"²\",\"sup3\":\"³\",\"szlig\":\"ß\",\"THORN\":\"Þ\",\"thorn\":\"þ\",\"times\":\"×\",\"Uacute\":\"Ú\",\"uacute\":\"ú\",\"Ucirc\":\"Û\",\"ucirc\":\"û\",\"Ugrave\":\"Ù\",\"ugrave\":\"ù\",\"uml\":\"¨\",\"Uuml\":\"Ü\",\"uuml\":\"ü\",\"Yacute\":\"Ý\",\"yacute\":\"ý\",\"yen\":\"¥\",\"yuml\":\"ÿ\"}");

/***/ }),

/***/ "kWbI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTrackQueryChange; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("RPju");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zwLB");









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var useTrackQueryChange = function useTrackQueryChange() {
  var pageContext = Object(react__WEBPACK_IMPORTED_MODULE_8__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_9__[/* ReactPageContext */ "a"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_10__[/* useTracking */ "a"])();

  var executeTracking = function executeTracking(query, payload) {
    if (query) {
      var isFromAutoComplete = Boolean(query.type);
      track(_objectSpread({
        categoryGA: pageContext.pageId,
        actionGA: 'search',
        labelGA: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_11__[/* getSearchMappedTypeForLabelGA */ "d"])(query.type),
        internalSearchEngineNbResults: '',
        searchReferrer: pageContext.pageId,
        searchRequestType: isFromAutoComplete ? 'Autocomplete' : 'Nocomplete',
        searchTerms: query.label || null
      }, payload));
    }
  };

  return executeTracking;
};

/***/ }),

/***/ "kawP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productSummaryResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("psNz");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("4VTZ");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("jw1E");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("CcNa");








var productSummaryResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_2__[/* RESORT_SUMMARY */ "sb"],
  resolve: function resolve(appContext, props, pageContext) {
    var _appContext$cmsConten = appContext.cmsContent,
        cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
        _appContext$cmsReleas = appContext.cmsRelease,
        cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
    var cmsArgs = "content : \"".concat(cmsContent, "\", release : \"").concat(cmsRelease, "\"");
    var isMice = _clubmed_utils__WEBPACK_IMPORTED_MODULE_1__["b2cPagesService"].isMicePage(pageContext.pageType);
    var resortId = props.resortId,
        tourDurationPlaceholder = props.tourDurationPlaceholder,
        cruiseTimingPlaceholder = props.cruiseTimingPlaceholder,
        cruiseDurationPlaceholder = props.cruiseDurationPlaceholder,
        dateFormat = props.dateFormat;
    var resortThumbnailQueryString = Object(_utils_resort_thumbnail_query_resortThumbnailQuery__WEBPACK_IMPORTED_MODULE_6__[/* default */ "b"])({
      content: cmsContent,
      release: cmsRelease,
      isMice: isMice,
      tourDurationPlaceholder: tourDurationPlaceholder,
      cruiseTimingPlaceholder: cruiseTimingPlaceholder,
      cruiseDurationPlaceholder: cruiseDurationPlaceholder,
      dateFormat: dateFormat
    });
    var query = "query {\n      product : resort(productId : \"".concat(resortId, "\") {\n        description\n        ").concat(resortThumbnailQueryString, "\n      }\n      config(").concat(cmsArgs, ") {\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_3__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_3__[/* price */ "c"](), "\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n          thumbnailTourCTA\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_7__[/* LINE_PRODUCT_SUMMARY */ "zc"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_5__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    })["catch"](function () {});
  }
};

/***/ }),

/***/ "kjCq":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("yhbn");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "klIi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tourIntroductionResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var tourIntroductionResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TOUR_INTRODUCTION */ "Gb"],
  resolve: function resolve(appContext, props) {
    var resortId = props.resortId;
    var query = "query {\n      resort(resortId: \"".concat(resortId, "\") {\n        strengths\n        details\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_TOUR_INTRODUCTION */ "Cc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "km0D":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("ANQd");
var getBuiltIn = __webpack_require__("x90g");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && Object(it) instanceof $Symbol;
};


/***/ }),

/***/ "l6h7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var setGlobal = __webpack_require__("edYw");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "lW4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withOpenAndScrollToHash; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vrRf");
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zygG");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _tabs_util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("GzVq");
/* harmony import */ var _scroll_scrollToHash__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("34at");












var __jsx = react__WEBPACK_IMPORTED_MODULE_12___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function getWithIds(_ref) {
  var id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;
  var mainId = id || Object(_tabs_util__WEBPACK_IMPORTED_MODULE_14__[/* getTabsMainId */ "c"])(items);
  var itemsWithIds = items.map(function (item, index) {
    var _getTabsItemIds = Object(_tabs_util__WEBPACK_IMPORTED_MODULE_14__[/* getTabsItemIds */ "b"])({
      id: item.id,
      index: index,
      mainId: mainId,
      title: item.header && item.header.title
    }),
        _getTabsItemIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getTabsItemIds, 2),
        headerId = _getTabsItemIds2[0],
        panelId = _getTabsItemIds2[1];

    return _objectSpread(_objectSpread({}, item), {}, {
      headerId: headerId,
      panelId: panelId
    });
  });
  return [mainId, itemsWithIds];
}
/* scroll to Tabs or Accordion item #id and open it */


function withOpenAndScrollToHash(WrappedComponent) {
  return function OpenTabAndScrollToHash(props) {
    var _useState = Object(react__WEBPACK_IMPORTED_MODULE_12__["useState"])({
      initialSelectedItem: props.initialSelectedItem,
      initialSelectedItems: props.initialSelectedItems
    }),
        _useState$ = _useState[0],
        initialSelectedItem = _useState$.initialSelectedItem,
        initialSelectedItems = _useState$.initialSelectedItems,
        setIntialItems = _useState[1];

    var _getWithIds = getWithIds({
      id: props.id,
      items: props.items
    }),
        _getWithIds2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_getWithIds, 2),
        mainId = _getWithIds2[0],
        itemsWithIds = _getWithIds2[1];

    Object(react__WEBPACK_IMPORTED_MODULE_12__["useEffect"])(function () {
      var hash = _clubmed_utils__WEBPACK_IMPORTED_MODULE_13__["windowWrapper"].getLocationPart('hash');

      if (hash.length < 2) {
        setIntialItems({
          initialSelectedItem: props.initialSelectedItem,
          initialSelectedItems: props.initialSelectedItems
        });
        return;
      }

      var ids = itemsWithIds.map(function (_ref2) {
        var _ref2$headerId = _ref2.headerId,
            headerId = _ref2$headerId === void 0 ? '' : _ref2$headerId;
        return "#".concat(headerId);
      });
      var index = ids.indexOf(hash);

      if (index !== -1) {
        setIntialItems({
          initialSelectedItem: index,
          initialSelectedItems: [index]
        });
        setTimeout(function () {
          Object(_scroll_scrollToHash__WEBPACK_IMPORTED_MODULE_15__[/* goToHash */ "a"])(hash);
        }, 250);
      }
    }, [props.initialSelectedItem, props.initialSelectedItems]);
    return __jsx(WrappedComponent, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])({}, props, {
      id: mainId,
      initialSelectedItems: initialSelectedItems,
      initialSelectedItem: initialSelectedItem,
      items: itemsWithIds,
      key: mainId // to reinitialize state when it is new tabs, see : https://fr.reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key

    }));
  };
}

/***/ }),

/***/ "loSl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toggleFacet; });
/* unused harmony export changeKids */
/* unused harmony export changeKidsNumberWith */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeKidsNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeDepartureCity; });
/* unused harmony export changeDepartureDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return clearDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeTripDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setInitialProductPrices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return setKidsValidationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return clearFacets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetRedirection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetSearch; });
/* unused harmony export setFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateFilters; });
/* unused harmony export resetFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetCriteria; });
/* unused harmony export setIsDateRequired */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setIsSearchEnabled; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("uDfI");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("rJ95");
/* harmony import */ var _search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("0ibg");
/* harmony import */ var _search_search_selector__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("B3yO");
/* harmony import */ var _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("wQ38");
/* harmony import */ var _trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("1bWg");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("fflk");
/* harmony import */ var _trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("+mhw");
/* harmony import */ var _trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("C5R2");
/* harmony import */ var _trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("RBvG");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("Jsmy");
/* harmony import */ var _faceting_selector__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("vIa8");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("9QcM");















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
















function setActiveFacet(categoryId, value, isSelected) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_TOGGLE_FACET_SELECTED */ "q"], {
    categoryId: categoryId,
    value: value,
    isSelected: isSelected
  });
}

function toggleFacet(_ref) {
  var categoryId = _ref.categoryId,
      isSelected = _ref.isSelected,
      value = _ref.value;
  return setActiveFacet(categoryId, value, isSelected);
}
function changeKids(value) {
  return function (dispatch, getState) {
    var oldKids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_25__[/* getKids */ "c"])(getState());
    var newKids = value.map(function (kid, index) {
      return _objectSpread(_objectSpread({}, kid), {}, {
        neolid: Object(lodash__WEBPACK_IMPORTED_MODULE_14__["get"])(oldKids, "[".concat(index, "].neolid"))
      });
    });
    return dispatch(Object(_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_20__[/* setKids */ "b"])(newKids));
  };
}

function _changeKidsSize(kids, newSize) {
  var emptyKids = Object(lodash__WEBPACK_IMPORTED_MODULE_14__["times"])(newSize - kids.length, function () {
    return _objectSpread({}, _trip_information_kids_constants__WEBPACK_IMPORTED_MODULE_19__[/* DEFAULT_KID_VALUE */ "a"]);
  });

  if (newSize < kids.length) {
    return kids.slice(0, newSize);
  }

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(kids), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])(emptyKids));
} // use this export when testing.


var changeKidsNumberWith = function changeKidsNumberWith(changeKidsFunc) {
  return function changeKidsNumber(value) {
    return function (dispatch, getState) {
      var kids = Object(_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_25__[/* getKids */ "c"])(getState());

      var newKids = _changeKidsSize(kids, value);

      return dispatch(changeKidsFunc(newKids));
    };
  };
}; // use this export in app code.

var changeKidsNumber = changeKidsNumberWith(changeKids);
function changeDepartureCity(value) {
  return Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureCity */ "a"])({
    value: value
  });
}
function changeDepartureDate(_ref2) {
  var value = _ref2.value;
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_21__[/* setDepartureDate */ "a"])(value);
}
var clearDepartureDate = function clearDepartureDate() {
  return Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_21__[/* setDepartureDate */ "a"])(null);
};
var setSearchQuery = function setSearchQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    label: ''
  };
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_SET_SEARCH_QUERY */ "p"], {
    value: query
  });
};
function clearTripDuration() {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_23__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_24__[/* DEFAULT_NO_DURATION */ "a"]);
}
function changeSearchQuery(value) {
  return function (dispatch, getState) {
    var store = getState();
    var keywords = Object(_search_search_selector__WEBPACK_IMPORTED_MODULE_18__[/* keywordsSelector */ "a"])(store);
    var searchQuery = Object(_faceting_selector__WEBPACK_IMPORTED_MODULE_26__[/* searchQuerySelector */ "m"])(getState());
    Object(react_redux__WEBPACK_IMPORTED_MODULE_15__[/* batch */ "b"])(function () {
      if (keywords) {
        dispatch(Object(_search_query_searchQuery_action__WEBPACK_IMPORTED_MODULE_17__[/* setKeywords */ "a"])(''));
      }

      if (searchQuery.label !== value.label) {
        dispatch(setSearchQuery(value));
      }
    });
  };
}
function changeTripDuration(value) {
  return Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_23__[/* setDuration */ "a"])(value);
}
function setInitialProductPrices(initialProductPrices) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_SET_INITIAL_PRICES */ "k"], {
    initialProductPrices: initialProductPrices
  });
}
function setKidsValidationState(kidsValidationState) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_SET_KIDS_VALIDATION_STATE */ "n"], {
    kidsValidationState: kidsValidationState
  });
}
function clearFacets(categoryId) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_CLEAR_FACETS */ "b"], {
    categoryId: categoryId
  });
}
function resetRedirection() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_RESET_REDIRECTION */ "g"]);
}
function resetSearch() {
  return /*#__PURE__*/function () {
    var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_RESET_SEARCH */ "h"])));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
}
function setFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_SET_FILTERS */ "j"], {
    filters: filters
  });
}
function updateFilters(filters) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_UPDATE_FILTERS */ "t"], {
    filters: filters
  });
}
function resetFilters() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_RESET_FILTERS */ "f"]);
}
function resetCriteria() {
  return /*#__PURE__*/function () {
    var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee2(dispatch) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Object(react_redux__WEBPACK_IMPORTED_MODULE_15__[/* batch */ "b"])(function () {
                dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_21__[/* setDepartureDate */ "a"])(null));
                dispatch(Object(_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_22__[/* setDepartureCity */ "a"])({
                  value: null
                }));
                dispatch(Object(_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_23__[/* setDuration */ "a"])(_trip_criteria_duration_duration_constants__WEBPACK_IMPORTED_MODULE_24__[/* DEFAULT_NO_DURATION */ "a"]));
                dispatch(resetFilters());
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function setIsDateRequired(isDateRequired) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_SET_IS_DATE_REQUIRED */ "l"], {
    isDateRequired: isDateRequired
  });
}
function setIsSearchEnabled(isSearchEnabled) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_16__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_27__[/* FACETING_SET_IS_SEARCH_ENABLED */ "m"], {
    isSearchEnabled: isSearchEnabled
  });
}

/***/ }),

/***/ "m4Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productPriceTicketCustomResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var productPriceTicketCustomResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_PRICE_TICKET_CUSTOM */ "R"],
  resolve: function resolve(appContext, props, pageContext, location) {
    var urlParams = location.urlParams;
    var productId = props.resortId;
    var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_2__[/* buildProductArgs */ "c"])(productId, urlParams);
    var query = "query {\n      config {\n        common {\n          comparator {\n            backToSearch\n          }\n        }\n      }\n      resort(".concat(productArgs, ") {\n        badgeIcon\n        color\n        comfortLabel\n        destination {\n          country\n        }\n        isExplicitEC\n        mice {\n          bestPrice {\n            value\n            formattedValue\n          }\n          unit\n        }\n        name\n        type\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_PRODUCT_PRICE_TICKET_CUSTOM */ "pc"]
    });
  }
};

/***/ }),

/***/ "mmil":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("8+jV");
var uid = __webpack_require__("rvZv");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "mu8A":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("uGjT");
var has = __webpack_require__("DZWw");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = has(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "muDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productGoogleStreetViewResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var productGoogleStreetViewResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* PRODUCT_STREET_VIEW */ "V"],
  resolve: function resolve(appContext, props) {
    var query = "query {\n      config {\n        common { close }\n      }\n      resort(resortId: \"".concat(props.resortId, "\") {\n        name\n        streetView {\n          latitude\n          longitude\n          heading\n          pitch\n          fov\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_PRODUCT_STREET_VIEW */ "xc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "mwRp":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("eGzU");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aCallable(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "n1QJ":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "nJrx":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var shared = __webpack_require__("8+jV");
var has = __webpack_require__("DZWw");
var uid = __webpack_require__("rvZv");
var NATIVE_SYMBOL = __webpack_require__("wEFx");
var USE_SYMBOL_AS_UID = __webpack_require__("1a7w");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "nT6P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InfoBanner_InfoBanner; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/InfoBanner.themes.js

var themes = function themes(_ref) {
  var color = _ref.color,
      textColor = _ref.textColor;
  var thDescriptionBloc = "bg-".concat(color, " px-px5 flex flex-col flex-grow sm:flex-grow-0\n      justify-center rtl:pr-px10 rounded-tiny text-").concat(textColor, " w-auto");
  var thPopinContent = "border-1 border-".concat(color, " lg:border-0 flex flex-col");
  return {
    "default": {
      thDescriptionBloc: thDescriptionBloc,
      thPopinContent: "".concat(thPopinContent, " lg:flex-row"),
      thPopinContentImage: 'flex-shrink-0 px-px20 pt-px20 lg:rtl:pl-px20 lg:rtl:pr-0 lg:py-px15'
    },
    comparator: {
      thDescriptionBloc: "".concat(thDescriptionBloc, " sm:w-full"),
      thPopinContent: thPopinContent,
      thPopinContentImage: 'flex-shrink-0 lg:rtl:pl-px10 lg:rtl:pr-px10 lg:py-px10 mt-px15'
    }
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/info-banner/InfoBanner.jsx










var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var positions = {
  left: 'rtl:left-0',
  right: 'rtl:right-0',
  center: 'inset-x-0'
};

var InfoBanner_getMaxContrastTextColor = function getMaxContrastTextColor(color) {
  var textColor = color === colors["a" /* COLORS */].GRAY_LIGHT || color === colors["a" /* COLORS */].GRAY_LIGHTER || color === colors["a" /* COLORS */].SANDPEARL || color === colors["a" /* COLORS */].WHITE || color === colors["a" /* COLORS */].YELLOW ? colors["a" /* COLORS */].BLACK : colors["a" /* COLORS */].WHITE;
  return textColor;
};

var InfoBanner_InfoBanner = function InfoBanner(_ref) {
  var className = _ref.className,
      contentClassName = _ref.contentClassName,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref$color,
      _ref$containerStyle = _ref.containerStyle,
      containerStyle = _ref$containerStyle === void 0 ? {
    width: 'calc(774rem / 16)'
  } : _ref$containerStyle,
      countdown = _ref.countdown,
      illustration = _ref.illustration,
      popin = _ref.popin,
      _ref$popinPosition = _ref.popinPosition,
      popinPosition = _ref$popinPosition === void 0 ? 'left' : _ref$popinPosition,
      subtitle = _ref.subtitle,
      title = _ref.title,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      trackingData = _ref.trackingData;
  var track = Object(useTracking["a" /* useTracking */])(trackingData || {});
  var trackBtnClick = !Object(lodash["isEmpty"])(trackingData) ? track : lodash["noop"];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var hasModal = !!popin && (!!(popin === null || popin === void 0 ? void 0 : popin.title) || !!(popin === null || popin === void 0 ? void 0 : popin.text) || !!(popin === null || popin === void 0 ? void 0 : popin.subtitle));
  var hasCountdown = !Object(lodash["isEmpty"])(countdown) && countdown.dateTimeEnd;
  var textColor = InfoBanner_getMaxContrastTextColor(color);
  var _themes$theme = themes({
    color: color,
    textColor: textColor
  })[theme],
      thDescriptionBloc = _themes$theme.thDescriptionBloc,
      thPopinContent = _themes$theme.thPopinContent,
      thPopinContentImage = _themes$theme.thPopinContentImage;

  if (!title && !subtitle && !illustration && !hasCountdown) {
    return null;
  }

  var content = __jsx("div", {
    className: classnames_default()('flex text-initial', contentClassName)
  }, illustration && __jsx("div", {
    className: "border-".concat(color, " border-1 rounded-tiny"),
    style: {
      height: 'calc(56rem / 16)'
    }
  }, __jsx("img", {
    alt: "",
    className: "h-full",
    src: illustration
  })), hasCountdown && __jsx("div", {
    className: "\n          bg-white\n            border-".concat(color, "\n            border-1\n            flex\n            flex-col\n            flex-grow\n            sm:flex-grow-0\n            items-center\n            justify-center\n            sm:order-1\n            overflow-hidden\n            rounded-tiny\n            text-").concat(color, "\n          "),
    style: {
      height: 'calc(56rem / 16)'
    }
  }, __jsx(Countdown["a" /* Countdown */], Object(esm_extends["a" /* default */])({}, countdown, {
    dateTimeEnd: countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd,
    theme: "infoBanner"
  }))), (title || subtitle) && __jsx("div", {
    className: thDescriptionBloc,
    style: {
      height: 'calc(56rem / 16)'
    }
  }, __jsx("h6", {
    className: "reset-paragraph text-xs"
  }, subtitle), __jsx("h5", {
    className: "ont-brand reset-paragraph text-md funderline"
  }, title)));

  var popinColor = colors["a" /* COLORS */].SUCCESS;
  var popinTextColor = colors["a" /* COLORS */].SUCCESS;

  if (hasModal) {
    popinColor = (popin === null || popin === void 0 ? void 0 : popin.color) ? popin.color : colors["a" /* COLORS */].SUCCESS;
    popinTextColor = InfoBanner_getMaxContrastTextColor(popinTextColor);
  }

  var imageProps = isDesktop ? {
    dimensions: {
      w: 300,
      h: 170
    }
  } : {
    dontChangeAnything: true
  };
  var tooltipContent = hasModal ? __jsx("div", {
    className: thPopinContent
  }, (popin === null || popin === void 0 ? void 0 : popin.image) && __jsx("div", {
    className: thPopinContentImage,
    style: isDesktop ? {
      height: '220px'
    } : {}
  }, __jsx(Image["a" /* Image */], Object(esm_extends["a" /* default */])({
    className: "h-full overflow-hidden rounded",
    imageUrl: popin.image
  }, imageProps))), __jsx("div", {
    className: "pt-px5 pb-px15 px-px20 lg:py-px15"
  }, (popin === null || popin === void 0 ? void 0 : popin.title) && __jsx(Text["a" /* Text */], {
    className: "font-brand font-normal leading-tight reset-paragraph text-2xl text-".concat(popinColor),
    hLevel: 3,
    text: popin.title,
    theme: "none"
  }), (popin === null || popin === void 0 ? void 0 : popin.subtitle) && __jsx(Text["a" /* Text */], {
    className: "font-bold leading-tight reset-paragraph text-base",
    hLevel: 4,
    text: popin.subtitle,
    theme: "none"
  }), (popin === null || popin === void 0 ? void 0 : popin.text) && __jsx(Text["a" /* Text */], {
    className: "py-px10 leading-tight lg:leading-loose text-base",
    text: popin.text
  }), (popin === null || popin === void 0 ? void 0 : popin.url) && __jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({
    color: popinTextColor,
    colorBg: popinColor,
    url: popin.url
  }, trackingData ? {
    trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
      actionGA: 'bannerInfo',
      labelGA: 'clickBannerInfo_link'
    })
  } : {}), popin.buttonLabel))) : null;
  var position = popinPosition === 'left' ? 'left' : 'right';
  return __jsx("div", {
    className: className
  }, hasModal ? __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: (popin === null || popin === void 0 ? void 0 : popin.title) ? popin.title : '',
    className: "flex justify-end",
    containerClassName: "z-3 border-1 border-".concat(color, " ").concat(positions[popinPosition]),
    containerStyle: containerStyle,
    contentClassName: "arrow-bg arrow-bg-".concat(color, " arrow-up").concat(Object(lodash["capitalize"])(position)),
    content: tooltipContent,
    hasCloseButton: true,
    onClick: function onClick() {
      return trackBtnClick({
        actionGA: 'bannerInfo',
        labelGA: 'clickBannerInfo'
      });
    },
    theme: "infoBanner"
  }, content) : content);
};

/***/ }),

/***/ "ngAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useDebounce; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
 // Our hook

function useDebounce(values, delay) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(values),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    var handler = setTimeout(function () {
      setDebouncedValue(values);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}

/***/ }),

/***/ "nnRT":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("NYSw");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "nnm9":
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "nvU9":
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__("I1fX"),
    isObject = __webpack_require__("tQYX"),
    isSymbol = __webpack_require__("a88S");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "oCTG":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("Syyo"),
    isArguments = __webpack_require__("bvyN"),
    isArray = __webpack_require__("wxYD");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "oG87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("OZaJ");
/* harmony import */ var core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9fIP");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MMYH");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("8K1b");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("K/z8");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("sRHE");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("aPQG");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(ErrorBoundary, [{
    key: "componentDidCatch",
    // eslint-disable-next-line class-methods-use-this
    value: function componentDidCatch(error, info) {
      Object(_errors_clientErrorHandler__WEBPACK_IMPORTED_MODULE_9__[/* handleComponentError */ "a"])(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError && !this.props.useNativeErrorHandling) {
        return null;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);

  return ErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_8___default.a.Component);

/***/ }),

/***/ "oMzG":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("MaE1");
var has = __webpack_require__("DZWw");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineProperty = __webpack_require__("87KK").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "oNVP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("F63i")))

/***/ }),

/***/ "oScl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("JpEK").IteratorPrototype;
var create = __webpack_require__("Znn2");
var createPropertyDescriptor = __webpack_require__("OouP");
var setToStringTag = __webpack_require__("CGO5");
var Iterators = __webpack_require__("oa0l");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "oW49":
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__("8PLQ"),
    legacyMap = __webpack_require__("kWb8"),
    xmlMap    = __webpack_require__("ZLJe"),
    decodeCodePoint = __webpack_require__("cHMM");

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ "oWz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputSelect_InputSelect; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative w-full',
      thInput: classnames_default()('reset-input reset-select h-full relative text-base text-gray-darker w-full', Object(form_util["a" /* getCursorClass */])(props)),
      thPlaceholder: '',
      thCaret: classnames_default()('absolute flex h-full items-center rtl:pl-px10 pointer-events-none rtl:right-0 top-0', {
        'text-current': !props.isDisabled,
        'text-gray-darker': props.isDisabled
      })
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx













var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var InputSelect_InputSelect = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputSelect, _Component);

  var _super = _createSuper(InputSelect);

  function InputSelect(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputSelect);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = {
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputSelect, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var options = this.props.options;

      if (Object(lodash["isEmpty"])(options)) {
        return null;
      }

      return options.map(function (_ref2) {
        var isDisabled = _ref2.isDisabled,
            isSelected = _ref2.isSelected,
            label = _ref2.label,
            value = _ref2.value;
        return label ? __jsx("option", {
          disabled: isDisabled,
          key: label,
          label: label,
          selected: isSelected,
          value: value
        }, label) : null;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          bgTransparent = _this$props2.bgTransparent,
          caretIcon = _this$props2.caretIcon,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputSelect_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          name = _this$props2.name,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          placeholder = _this$props2.placeholder,
          size = _this$props2.size,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState,
          dataTestId = _this$props2.dataTestId,
          inputId = _this$props2.inputId;
      var value = this.state.value;
      var hasClearEnabled = Boolean(hasClear && this.state.value);
      var hasValue = Boolean(value);
      var placeholderFormatted = Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired);

      var _themes$theme = themes[theme](this.props),
          thCaret = _themes$theme.thCaret,
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper,
          thPlaceholder = _themes$theme.thPlaceholder;

      return __jsx(FormControl["a" /* FormControl */], {
        bgTransparent: bgTransparent,
        className: className,
        hasClear: hasClearEnabled,
        id: id,
        iconLeft: iconLeft,
        iconRight: iconRight,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, __jsx("div", {
        className: thInputWrapper
      }, __jsx("select", Object(esm_extends["a" /* default */])({
        className: thInput,
        disabled: Boolean(isDisabled || isLoading || isReadOnly),
        id: inputId ? inputId : id
      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        required: isRequired,
        value: value,
        "data-testid": dataTestId
      }), !!placeholderFormatted && __jsx("option", {
        className: thPlaceholder,
        label: placeholderFormatted,
        disabled: true,
        value: ""
      }, placeholderFormatted), this.getOptions()), !(isDisabled || isLoading || isReadOnly) && __jsx("div", {
        className: thCaret,
        "data-testid": "InputSelectCaret"
      }, __jsx(Icon["a" /* Icon */], {
        name: caretIcon,
        width: "0.625rem",
        dataTestid: caretIcon ? "caret-".concat(caretIcon) : ''
      }))));
    }
  }]);

  return InputSelect;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputSelect_InputSelect, "defaultProps", {
  caretIcon: icons["a" /* ICONS */].SELECT,
  options: [],
  size: 'medium',
  theme: 'default'
});

/***/ }),

/***/ "oa0l":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "ontP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FacetSearch_FacetSearch; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// CONCATENATED MODULE: ./src/client/router/useRouterEvents.js


function useRouterEvents() {
  var _useState = Object(react["useState"])(false),
      transitioning = _useState[0],
      setTransitioning = _useState[1];

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  Object(react["useEffect"])(function () {
    var routeChangeStartHandler = function routeChangeStartHandler() {
      setTransitioning(true);
    };

    var routeChangeCompleteHandler = function routeChangeCompleteHandler() {
      setTransitioning(false);
    };

    history.events.on('routeChangeStart', routeChangeStartHandler);
    history.events.on('routeChangeComplete', routeChangeCompleteHandler);
    return function () {
      history.events.off('routeChangeStart', routeChangeStartHandler);
      history.events.off('routeChangeComplete', routeChangeCompleteHandler);
    };
  }, []);
  return {
    transitioning: transitioning
  };
}
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsive_responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaContext.jsx
var CriteriaContext = __webpack_require__("XiOS");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.utils.js
var FacetSearch_utils = __webpack_require__("hPQF");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackQueryChange.js
var useTrackQueryChange = __webpack_require__("kWbI");

// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/useTrackSearchResults.js
var useTrackSearchResults = __webpack_require__("NrqW");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/webcallback/WebCallbackTrigger.jsx + 3 modules
var WebCallbackTrigger = __webpack_require__("PZXw");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/CallCenterBlock.jsx

var __jsx = react_default.a.createElement;









var CallCenterBlock_Contact = function Contact(_ref) {
  var text = _ref.text,
      textLtr = _ref.textLtr,
      secondaryText = _ref.secondaryText,
      iconName = _ref.iconName,
      className = _ref.className,
      url = _ref.url;
  var Comp = url ? 'a' : 'div';
  var link = url ? {
    href: url
  } : undefined;
  return __jsx(Comp, Object(esm_extends["a" /* default */])({
    className: className
  }, link), __jsx(Icon["a" /* Icon */], {
    name: iconName,
    color: colors["a" /* COLORS */].BLUE,
    width: "1.875rem"
  }), __jsx("div", {
    className: "text-blue"
  }, __jsx("p", {
    className: "text-xl font-bold m-0",
    dir: textLtr ? 'ltr' : ''
  }, text), __jsx("p", {
    className: classnames_default()('text-sm m-0', {
      underline: !url
    })
  }, secondaryText)));
};

function CallCenterBlock() {
  var isWebCallbackEnabled = config_default.a.get('freespee.enabled');
  return __jsx("div", {
    style: {
      background: 'rgba(0,85,137,0.05)'
    }
  }, __jsx("div", {
    className: "text-center p-px15"
  }, __jsx("p", {
    className: "text-2xl text-blue font-brand m-0 mt-px15"
  }, Object(src_i18n["h" /* t */])('navigationBar.contact.title')), __jsx("p", {
    className: "text-md text-sans"
  }, Object(src_i18n["h" /* t */])('remote.noResult.contactAdvisors')), __jsx("div", {
    className: "lg:flex justify-around"
  }, __jsx(CallCenterBlock_Contact, {
    text: Object(src_i18n["h" /* t */])('navigationBar.contact.phoneNumber'),
    textLtr: true,
    secondaryText: Object(src_i18n["h" /* t */])('navigationBar.contact.toll'),
    url: "tel:".concat(Object(src_i18n["h" /* t */])('navigationBar.contact.phoneNumber')),
    iconName: icons["a" /* ICONS */].PHONE_BUBBLE
  }), isWebCallbackEnabled && __jsx(WebCallbackTrigger["a" /* WebCallbackTrigger */], {
    trackingData: {
      actionGA: 'search'
    },
    theme: "search"
  }, __jsx(CallCenterBlock_Contact, {
    text: Object(src_i18n["h" /* t */])('remote.noResult.callBackLabel'),
    secondaryText: Object(src_i18n["h" /* t */])('remote.noResult.callBackSchedule'),
    className: "mt-px15 lg:mt-0",
    iconName: icons["a" /* ICONS */].CALLMEBACK
  })))));
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.selector.js + 1 modules
var faceting_selector = __webpack_require__("vIa8");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/search/query/searchQuery.action.js
var searchQuery_action = __webpack_require__("0ibg");

// EXTERNAL MODULE: ./src/client/store/search/search.selector.js
var search_selector = __webpack_require__("B3yO");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.action.js
var departureCity_action = __webpack_require__("+mhw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/CriteriaControl.jsx
var CriteriaControl_jsx = react_default.a.createElement;



function CriteriaControl(props) {
  var children = props.children,
      iconLeft = props.iconLeft,
      onClear = props.onClear,
      id = props.id;
  if (!react["Children"].count(children)) return null;
  return CriteriaControl_jsx("div", {
    className: "inline-block rtl:mr-px10 mb-px10"
  }, CriteriaControl_jsx("div", {
    className: "border-1 rounded-sm flex outline-custom px-px10 relative rounded-tiny transition-colors bg-white border-gray-medium text-gray-darker",
    style: {
      height: 41
    }
  }, !!iconLeft && CriteriaControl_jsx("div", {
    className: "flex items-center justify-center rtl:pr-px10"
  }, CriteriaControl_jsx(Icon["a" /* Icon */], {
    name: iconLeft,
    width: "0.875rem"
  })), CriteriaControl_jsx("div", {
    className: "flex relative"
  }, CriteriaControl_jsx("span", {
    className: "flex items-center justify-center rtl:pr-px10 font-sans text-base leading-4 capitalize"
  }, children), CriteriaControl_jsx("button", {
    className: "reset-button leading-none rtl:pl-px10 transition-color text-gray-darker",
    "data-testid": id,
    onClick: onClear,
    type: "button"
  }, CriteriaControl_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "0.625rem"
  })))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/CriteriaControls.jsx












var CriteriaControls_jsx = react_default.a.createElement;





















var CriteriaControls_CriteriaControls = function CriteriaControls() {
  var searchQuery = Object(es["e" /* useSelector */])(faceting_selector["m" /* searchQuerySelector */]);
  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var facettesFilters = Object(es["e" /* useSelector */])(faceting_selector["h" /* filtersSelector */]);

  var _useState = Object(react["useState"])(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.label),
      searchQueryLabel = _useState[0],
      setSearchQueryLabel = _useState[1];

  var _useState2 = Object(react["useState"])(facettesFilters),
      facettes = _useState2[0],
      setFacettes = _useState2[1];

  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);

  var _useState3 = Object(react["useState"])(departureDate),
      departureDateCriteria = _useState3[0],
      setDepartureDateCriteria = _useState3[1];

  var tripDuration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var adultsNumber = Object(es["e" /* useSelector */])(storeHelper["b" /* getAdultsNumber */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);

  var _useState4 = Object(react["useState"])(adultsNumber),
      adultsNumberState = _useState4[0],
      setAdultsNumberState = _useState4[1];

  var departureCityCode = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  Object(react["useEffect"])(function () {
    setFacettes(facettesFilters);
    setAdultsNumberState(adultsNumber);
  }, [JSON.stringify(facettesFilters), adultsNumber]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var labelParts = '';

  if (adultsNumberState > 0) {
    var labelPartsTmp = [];
    var lengthPeople = adultsNumber + kids.length;

    if (lengthPeople) {
      if (adultsNumber >= 1) {
        labelPartsTmp.push(Object(src_i18n["h" /* t */])('booking.form.selectAdultsLabels', {
          count: adultsNumber
        }));
      }

      if (kids.length >= 1) {
        labelPartsTmp.push(Object(src_i18n["h" /* t */])('booking.form.selectChildrenLabels', {
          count: kids.length
        }));
      }

      labelParts = labelPartsTmp.join(' - ');
    }
  }

  var isFromAutoComplete = Boolean(searchQuery.type);
  var searchTerms = isFromAutoComplete || searchQuery.label ? searchQuery.label : keywords;
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: 'search',
    actionGA: 'search',
    searchReferrer: 'search',
    searchTerms: searchTerms || ''
  });

  var removeDepartureDateCriteria = function removeDepartureDateCriteria() {
    return setDepartureDateCriteria(null);
  };

  var removeFacetCriteria = function removeFacetCriteria(_ref) {
    var id = _ref.id,
        name = _ref.name;
    return setFacettes(Object(toConsumableArray["a" /* default */])(facettes).filter(function (_ref2) {
      var facetteId = _ref2.id,
          facetteName = _ref2.name;
      return id !== facetteId || name !== facetteName;
    }));
  };

  var clearSearchQuery = function clearSearchQuery() {
    return setSearchQueryLabel('');
  };

  var submitFilters = function submitFilters() {
    track({
      labelGA: 'noResult_applyCriterias'
    });
    Object(es["b" /* batch */])(function () {
      dispatch(Object(facetingSearch_action["p" /* updateFilters */])(facettes));

      if (!departureDateCriteria) {
        dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
      }

      if (searchQueryLabel !== (searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.label)) {
        if (keywords) {
          dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
        }

        dispatch(Object(facetingSearch_action["n" /* setSearchQuery */])({
          label: ''
        }));
      }

      var previousDepartureCity = facettesFilters.find(function (_ref3) {
        var id = _ref3.id;
        return id === constants["i" /* DEPARTURE_CITY_FACET_ID */];
      });
      var departureCity = facettes.find(function (_ref4) {
        var id = _ref4.id;
        return id === constants["i" /* DEPARTURE_CITY_FACET_ID */];
      });

      if (!departureCity && previousDepartureCity) {
        dispatch(Object(departureCity_action["a" /* setDepartureCity */])({
          value: null
        }));
      }

      if (!adultsNumberState && adultsNumber) {
        dispatch(Object(adults_action["b" /* setAdultsNumber */])(0));
        dispatch(Object(kids_action["b" /* setKids */])([]));
        dispatch(Object(facetingSearch_action["b" /* changeKidsNumber */])(0));
        dispatch(Object(facetingSearch_action["m" /* setKidsValidationState */])([]));
      }
    });
  };

  var cleanCriteria = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              track({
                labelGA: 'noResult_resetCriterias'
              });
              Object(es["b" /* batch */])(function () {
                if (adultsNumberState) {
                  dispatch(Object(adults_action["b" /* setAdultsNumber */])(0));
                  dispatch(Object(kids_action["b" /* setKids */])([]));
                  dispatch(Object(facetingSearch_action["b" /* changeKidsNumber */])(0));
                  dispatch(Object(facetingSearch_action["m" /* setKidsValidationState */])([]));
                }

                if (keywords) {
                  dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
                }
              });
              return _context.abrupt("return", dispatch(Object(facetingSearch_action["h" /* resetCriteria */])()));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function cleanCriteria() {
      return _ref5.apply(this, arguments);
    };
  }();

  var clearParticipants = function clearParticipants() {
    return setAdultsNumberState(0);
  };

  var noTransport = departureCityCode === 'NO';
  return CriteriaControls_jsx(react["Fragment"], null, searchQueryLabel && CriteriaControls_jsx(CriteriaControl, {
    onClear: clearSearchQuery,
    iconLeft: icons["a" /* ICONS */].SEARCH_GLASS
  }, searchQueryLabel), departureDateCriteria && CriteriaControls_jsx(CriteriaControl, {
    onClear: removeDepartureDateCriteria,
    iconLeft: icons["a" /* ICONS */].DATE,
    id: "departure_date"
  }, "".concat(moment_default()(departureDateCriteria).format('DD MMM'), " - ").concat(moment_default()(departureDateCriteria).add({
    days: tripDuration || duration_constants["b" /* DEFAULT_TRIP_DURATION */]
  }).format('DD MMM'))), !!labelParts && CriteriaControls_jsx(CriteriaControl, {
    onClear: clearParticipants,
    iconLeft: icons["a" /* ICONS */].USERS,
    key: "participants",
    id: "participants"
  }, labelParts), facettes.filter(function (_ref6) {
    var id = _ref6.id;
    return id === constants["i" /* DEPARTURE_CITY_FACET_ID */];
  }).map(function (_ref7) {
    var id = _ref7.id,
        name = _ref7.name,
        label = _ref7.label;
    return CriteriaControls_jsx(CriteriaControl, {
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      },
      iconLeft: noTransport ? icons["a" /* ICONS */].NO_TRANSPORT : icons["a" /* ICONS */].TRANSPORT,
      key: name,
      id: name
    }, noTransport ? label : "".concat(Object(src_i18n["h" /* t */])('common.transport.from'), " ").concat(label));
  }), facettes.filter(function (_ref8) {
    var id = _ref8.id;
    return id === constants["n" /* DESTINATIONS_FACET_ID */] || id === constants["e" /* COUNTRIES_FACET_ID */];
  }).map(function (_ref9) {
    var id = _ref9.id,
        name = _ref9.name;
    return CriteriaControls_jsx(CriteriaControl, {
      iconLeft: icons["a" /* ICONS */].EARTH_PLANE,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      },
      key: name,
      id: name
    }, name);
  }), facettes.filter(function (_ref10) {
    var id = _ref10.id;
    return id === constants["a" /* ACTIVITIES_FACET_ID */];
  }).map(function (_ref11) {
    var id = _ref11.id,
        name = _ref11.name;
    return CriteriaControls_jsx(CriteriaControl, {
      iconLeft: icons["a" /* ICONS */].ACTIVITIES,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      },
      key: name,
      id: name
    }, name.split('|')[1]);
  }), facettes.filter(function (_ref12) {
    var id = _ref12.id;
    return id === constants["E" /* TYPES_OF_STAY_FACET_ID */];
  }).map(function (_ref13) {
    var id = _ref13.id,
        name = _ref13.name;
    return CriteriaControls_jsx(CriteriaControl, {
      key: name,
      id: name,
      iconLeft: icons["a" /* ICONS */].BEACH,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      }
    }, Object(src_i18n["h" /* t */])("faceting.typesOfStay.label_".concat(name.toLowerCase())));
  }), facettes.filter(function (_ref14) {
    var id = _ref14.id;
    return id === constants["p" /* FACET_COMFORT_ID */];
  }).map(function (_ref15) {
    var id = _ref15.id,
        name = _ref15.name;
    return CriteriaControls_jsx(CriteriaControl, {
      key: name,
      id: name,
      iconLeft: icons["a" /* ICONS */].TRIDENT1,
      onClear: function onClear() {
        return removeFacetCriteria({
          id: id,
          name: name
        });
      }
    }, name);
  }), CriteriaControls_jsx("div", null, CriteriaControls_jsx("div", {
    className: "inline-flex flex-col-reverse md:flex md:flex-row mt-px15 justify-between"
  }, CriteriaControls_jsx("button", {
    className: "cursor-pointer text-gray-darker inline-flex flex items-center bg-transparent mt-px15 md:mt-0",
    type: "button",
    "data-testid": "reset-filters",
    onClick: cleanCriteria
  }, CriteriaControls_jsx("span", {
    className: "text-base underline"
  }, Object(src_i18n["h" /* t */])('common.comparator.resetCriteria'))), CriteriaControls_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    onClick: submitFilters,
    dataTestId: "apply-filters",
    size: "medium"
  }, Object(src_i18n["h" /* t */])('common.apply')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-no-results/SearchNoResults.jsx
var SearchNoResults_jsx = react_default.a.createElement;



var SearchNoResults = /*#__PURE__*/Object(react["memo"])(function (_ref) {
  var explanation = _ref.explanation,
      isSeller = _ref.isSeller,
      title = _ref.title;
  return SearchNoResults_jsx("div", {
    className: "sm:flex text-center md:text-initial"
  }, SearchNoResults_jsx("div", {
    className: "sm:rtl:pr-px20 sm:w-2/3"
  }, SearchNoResults_jsx("div", {
    className: "my-px15 lg:my-px25"
  }, SearchNoResults_jsx("p", {
    className: "my-px15 font-brand text-md md:text-xl lg:text-2xl"
  }, title), SearchNoResults_jsx("p", null, explanation), SearchNoResults_jsx(CriteriaControls_CriteriaControls, null))), !isSeller ? SearchNoResults_jsx("div", {
    className: "sm:w-1/3"
  }, SearchNoResults_jsx("div", {
    className: "my-px15 lg:my-px25"
  }, SearchNoResults_jsx(CallCenterBlock, null))) : null);
});
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__("LJOr");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /opt/webapp/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 2 modules
var SeeMore = __webpack_require__("NPTU");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-banners/SearchBanners.themes.js
var themes = {
  "default": function _default() {
    return {
      thRoot: 'flex max-w-full flex-col',
      thBannerRoot: 'max-w-full',
      thBannerHtml: '',
      thBannerImg: 'max-w-full',
      thBannerText: ''
    };
  },
  top: function top() {
    return {
      thRoot: 'flex max-w-full flex-col justify-center items-center',
      thBannerRoot: 'max-w-full',
      thBannerHtml: '',
      thBannerImg: 'max-w-full',
      thBannerText: ''
    };
  },
  terms: function terms() {
    return {
      thRoot: 'flex max-w-full flex-col text-grey',
      thBannerRoot: 'max-w-full',
      thBannerHtml: 'leading-normal text-sm text-gray-medium',
      thBannerImg: 'max-w-full',
      thBannerText: 'leading-normal text-sm text-gray-medium'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-banners/SearchBanners.jsx












var SearchBanners_jsx = react_default.a.createElement;















var getResponsiveClasses = function getResponsiveClasses(screenSizes) {
  var classes = [];

  if (screenSizes.length === 0) {
    return classes;
  }

  if (!screenSizes.includes('xs')) {
    classes.push('hidden');
  }

  classes.push(screenSizes.includes('sm') ? 'sm:flex' : 'sm:hidden');
  classes.push(screenSizes.includes('md') ? 'md:flex' : 'md:hidden');
  classes.push(screenSizes.includes('lg') ? 'lg:flex' : 'lg:hidden');
  classes.push(screenSizes.includes('xl') ? 'xl:flex' : 'xl:hidden');
  return classes;
};

var filterByPosition = function filterByPosition(_ref, position) {
  var _ref$position = _ref.position,
      type = _ref$position.type,
      value = _ref$position.value;
  return type === position || value === position;
};

var filterBySeason = function filterBySeason(_ref2, seasons) {
  var _ref2$content$filters = _ref2.content.filters,
      filters = _ref2$content$filters === void 0 ? [] : _ref2$content$filters;
  var productsHaveSeasons = seasons && seasons.length > 0;
  var bannerHasSeasonFilter = filters && filters.seasons && filters.seasons.length > 0;

  if (!productsHaveSeasons || !bannerHasSeasonFilter) {
    return true;
  }

  return filters.seasons.some(function (filterSeasons) {
    return seasons.sort().join() === filterSeasons.sort().join();
  });
};

var SearchBanners_filterByKidsAge = function filterByKidsAge(_ref3, kids, departureDate) {
  var _ref3$content$filters = _ref3.content.filters,
      filters = _ref3$content$filters === void 0 ? [] : _ref3$content$filters;
  var searchHasKids = kids && kids.length > 0 && kids.some(function (kid) {
    return !!kid.birthdate;
  });
  var bannerHasKidsAgeFilter = filters && filters.kidsAgeInMonths && filters.kidsAgeInMonths.length > 0;

  if (!bannerHasKidsAgeFilter) {
    return true;
  }

  if ((!searchHasKids || !departureDate) && bannerHasKidsAgeFilter) {
    return false;
  }

  return kids.some(function (kid) {
    var ageInMonths = moment_default()(departureDate).diff(moment_default()(kid.birthdate), 'months');
    return filters.kidsAgeInMonths.some(function (ageFilter) {
      var _ageFilter$split = ageFilter.split('-'),
          _ageFilter$split2 = Object(slicedToArray["a" /* default */])(_ageFilter$split, 2),
          min = _ageFilter$split2[0],
          max = _ageFilter$split2[1];

      return Object(lodash["inRange"])(ageInMonths, parseInt(min, 10), parseInt(max, 10));
    });
  });
};

var SearchBanners_filterByProductIds = function filterByProductIds(_ref4, productIds) {
  var _ref4$content$filters = _ref4.content.filters,
      filters = _ref4$content$filters === void 0 ? [] : _ref4$content$filters;
  var searchHasProductIds = productIds && productIds.length > 0;
  var bannerHasProductIdsFilter = filters && filters.products && filters.products.length > 0;

  if (!bannerHasProductIdsFilter) {
    return true;
  }

  if (!searchHasProductIds && bannerHasProductIdsFilter) {
    return false;
  }

  return lodash["without"].apply(void 0, [productIds].concat(Object(toConsumableArray["a" /* default */])(filters.products))).length === 0;
};

var SearchBanners_SearchBanners = function SearchBanners(_ref5) {
  var position = _ref5.position,
      className = _ref5.className;

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var bannerContents = Object(es["e" /* useSelector */])(function (state) {
    var seasons = Object(faceting_selector["f" /* filteredProductsSeasonsSelector */])(state);
    var kids = Object(storeHelper["c" /* getKids */])(state);
    var departureDate = Object(tripCriteria_selector["b" /* getDepartureDate */])(state);
    var banners = Object(faceting_selector["b" /* bannersSelector */])(state);
    var productIds = Object(faceting_selector["i" /* getFacetingProductIds */])(state);

    if (!position) {
      return banners;
    }

    return banners.filter(function (banner) {
      return filterByPosition(banner, position);
    }).filter(function (banner) {
      return SearchBanners_filterByProductIds(banner, productIds);
    }).filter(function (banner) {
      return SearchBanners_filterByKidsAge(banner, kids, departureDate);
    }).filter(function (banner) {
      return filterBySeason(banner, seasons);
    });
  });

  if (!bannerContents || bannerContents.length === 0) {
    return null;
  }

  var _themes = themes[position || 'default'](),
      thRoot = _themes.thRoot,
      thBannerRoot = _themes.thBannerRoot,
      thBannerHtml = _themes.thBannerHtml,
      thBannerImg = _themes.thBannerImg,
      thBannerText = _themes.thBannerText;

  var WithSeeMore = function WithSeeMore(_ref6) {
    var children = _ref6.children,
        seeMoreClassName = _ref6.className;
    return SearchBanners_jsx(SeeMore["a" /* SeeMore */], {
      className: seeMoreClassName,
      isCollapseEnabled: !isDesktop,
      seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
      seeMoreLabel: Object(src_i18n["h" /* t */])('common.loadMore')
    }, children);
  };

  return SearchBanners_jsx(SiteContainer["a" /* SiteContainer */], null, SearchBanners_jsx("div", {
    className: classnames_default()(thRoot, className)
  }, bannerContents.map(function (_ref7) {
    var content = _ref7.content;
    return SearchBanners_jsx("div", {
      className: classnames_default()(thBannerRoot, content.screenSizes ? getResponsiveClasses(content.screenSizes) : ''),
      key: content.text
    }, content.type === 'img' && SearchBanners_jsx("img", {
      className: thBannerImg,
      src: content.imgUrl,
      alt: content.text
    }), content.type === 'text' && SearchBanners_jsx("div", null, SearchBanners_jsx(WithSeeMore, {
      className: thBannerText
    }, SearchBanners_jsx(Text["a" /* Text */], {
      text: content.text
    }))), content.type === 'html' && SearchBanners_jsx("div", null, SearchBanners_jsx(WithSeeMore, {
      className: thBannerHtml
    }, SearchBanners_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: content.text
      }
    }))));
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/frameworks/drop-zone/DropZone.themes.js
var DropZone_themes_themes = {
  "default": {
    thRoot: 'border-1 border-dashed border-gray-light flex items-center justify-center px-px20 text-gray-light relative rounded',
    thNumber: 'absolute rtl:left-0 flex inset-y-0 italic items-center leading-one mx-px20 text-15xl',
    thLabel: 'flex-1 font-bold text-center text-md text-gray-darker px-px10',
    thRootFilled: 'flex shadow',
    thChildren: 'flex-1 p-px10 w-9/10',
    thClear: 'reset-button border-0 border-l-1 rtl:border-l-1 border-solid border-gray-light leading-none p-px10',
    thClearIconSize: '0.625rem'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/drop-zone/DropZone.jsx
var DropZone_jsx = react_default.a.createElement;





var DropZone_DropZone = function DropZone(_ref) {
  var children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? '5.625rem' : _ref$minHeight,
      number = _ref.number,
      onClear = _ref.onClear,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var _themes$theme = DropZone_themes_themes[theme],
      thChildren = _themes$theme.thChildren,
      thClear = _themes$theme.thClear,
      thClearIconSize = _themes$theme.thClearIconSize,
      thLabel = _themes$theme.thLabel,
      thNumber = _themes$theme.thNumber,
      thRoot = _themes$theme.thRoot,
      thRootFilled = _themes$theme.thRootFilled;
  return children ? DropZone_jsx("div", {
    className: classnames_default()(className, thRootFilled),
    style: {
      minHeight: minHeight
    }
  }, DropZone_jsx("div", {
    className: thChildren
  }, children), DropZone_jsx("button", {
    className: thClear,
    onClick: onClear,
    type: "button"
  }, DropZone_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: thClearIconSize
  }))) : DropZone_jsx("div", {
    className: classnames_default()(className, thRoot),
    style: {
      minHeight: minHeight
    }
  }, !!number && DropZone_jsx("span", {
    className: thNumber
  }, number), !!label && DropZone_jsx("span", {
    className: thLabel
  }, label));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.utils.js
var Product_utils = __webpack_require__("Fe0B");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-header/ProductHeader.jsx
var ProductHeader = __webpack_require__("hgS3");

// EXTERNAL MODULE: ./src/client/components/widgets/product/product-flag/ProductFlag.jsx + 1 modules
var ProductFlag = __webpack_require__("ELg1");

// CONCATENATED MODULE: ./src/client/components/widgets/product-condensed/ProductCondensed.jsx



var ProductCondensed_jsx = react_default.a.createElement;








var ProductCondensed_ProductCondensed = function ProductCondensed(_ref) {
  var className = _ref.className,
      header = _ref.header,
      offer = _ref.offer,
      price = _ref.price,
      priceInfo = _ref.priceInfo,
      url = _ref.url;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var goOnResort = function goOnResort() {
    var newHistoryState = new DynamicLinkUtil["a" /* default */](dist["windowWrapper"].getLocation(), url ? Object(Product_utils["c" /* generateProductLink */])(url, offer) : '');
    history.pushRoute(newHistoryState.toString());
  };

  return ProductCondensed_jsx("article", {
    className: classnames_default()(className, 'flex flex-col')
  }, ProductCondensed_jsx(ProductHeader["a" /* ProductHeader */], Object(esm_extends["a" /* default */])({}, header, {
    isLinkDisabled: true
  })), ProductCondensed_jsx(ProductFlag["a" /* ProductFlag */], {
    isLinkDisabled: true,
    onClick: goOnResort,
    price: price,
    priceInfo: priceInfo,
    theme: "thumbnail"
  }));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare-button/SearchCompareButton.jsx

var SearchCompareButton_jsx = react_default.a.createElement;





function SearchCompareButton(props) {
  var className = props.className,
      comparisonClick = props.comparisonClick,
      comparisonToggle = props.comparisonToggle,
      comparisonUrl = props.comparisonUrl,
      isComparisonActive = props.isComparisonActive,
      isComparisonSubmitable = props.isComparisonSubmitable,
      label = props.label,
      mandatoryMessage = props.mandatoryMessage,
      selectedItemsCount = props.selectedItemsCount,
      selectedItemsMax = props.selectedItemsMax,
      style = props.style;
  var isDisabled = isComparisonActive && !isComparisonSubmitable;

  var getToggleOrComparisonOnClick = function getToggleOrComparisonOnClick() {
    if (isComparisonSubmitable) return comparisonClick;
    return isComparisonActive ? lodash["noop"] : comparisonToggle;
  };

  var trackingData = isComparisonSubmitable ? {
    actionGA: 'overlayCTA',
    labelGA: 'compareMySelection'
  } : {
    actionGA: 'overlayCTA',
    labelGA: 'compareAndBook'
  };
  return SearchCompareButton_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-disabled": isDisabled,
    as: isComparisonSubmitable ? DynamicLink["a" /* default */] : 'button',
    trackingData: trackingData,
    className: classnames_default()(className, 'reset-anchor reset-button flex items-stretch font-bold overflow-hidden rounded-small text-md text-white', {
      'bg-gray-light cursor-default': isDisabled,
      'bg-turquoise': !isComparisonActive && !isComparisonSubmitable,
      'bg-emerald': isComparisonSubmitable
    }),
    onClick: getToggleOrComparisonOnClick(),
    style: style,
    title: !isComparisonSubmitable ? mandatoryMessage : ''
  }, isComparisonSubmitable ? {
    url: comparisonUrl
  } : {
    type: 'button'
  }, {
    "data-testid": "search-compare-button"
  }), SearchCompareButton_jsx("span", {
    className: "flex-1 p-px10 text-center"
  }, label), !!selectedItemsCount && SearchCompareButton_jsx("span", {
    className: "bg-overlay-black-15 p-px10"
  }, selectedItemsCount, "/", selectedItemsMax));
}
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare/large/SearchCompareLarge.jsx


var SearchCompareLarge_jsx = react_default.a.createElement;








var SearchCompareLarge_SearchCompareLarge = function SearchCompareLarge(_ref) {
  var buttonLabel = _ref.buttonLabel,
      cancelLabel = _ref.cancelLabel,
      children = _ref.children,
      className = _ref.className,
      comparisonClick = _ref.comparisonClick,
      comparisonToggle = _ref.comparisonToggle,
      comparisonUrl = _ref.comparisonUrl,
      dropzoneLabel = _ref.dropzoneLabel,
      isComparisonActive = _ref.isComparisonActive,
      isComparisonSubmitable = _ref.isComparisonSubmitable,
      mandatoryMessage = _ref.mandatoryMessage,
      resultsCount = _ref.resultsCount,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
      _ref$selectedItemsMax = _ref.selectedItemsMax,
      selectedItemsMax = _ref$selectedItemsMax === void 0 ? 3 : _ref$selectedItemsMax,
      toggleProductSelectedForComparison = _ref.toggleProductSelectedForComparison;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setSticky = _useState[1];

  var onStateChange = function onStateChange(status) {
    setSticky(status.status !== Sticky_default.a.STATUS_ORIGINAL);
  };

  return SearchCompareLarge_jsx(Sticky_default.a, {
    bottomBoundary: "#SearchCompareBeacon",
    innerZ: 3,
    onStateChange: onStateChange
  }, SearchCompareLarge_jsx("section", {
    className: classnames_default()(className, 'bg-white py-px10', {
      'border-b-1 border-gray-light shadow-bottom': isSticky
    })
  }, SearchCompareLarge_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareLarge_jsx("div", {
    className: "flex items-center justify-between"
  }, SearchCompareLarge_jsx("div", {
    className: "flex-1"
  }, children), isComparisonActive && SearchCompareLarge_jsx("button", {
    className: "reset-button font-bold text-base mx-px20",
    onClick: comparisonToggle,
    type: "button"
  }, cancelLabel), resultsCount && resultsCount > 0 && SearchCompareLarge_jsx(SearchCompareButton, {
    comparisonToggle: comparisonToggle,
    comparisonClick: comparisonClick,
    comparisonUrl: comparisonUrl,
    isComparisonActive: isComparisonActive,
    isComparisonSubmitable: isComparisonSubmitable,
    label: buttonLabel,
    mandatoryMessage: mandatoryMessage,
    selectedItemsCount: selectedItems.length,
    selectedItemsMax: selectedItemsMax,
    style: {
      minWidth: 280,
      minHeight: 40
    }
  }))), SearchCompareLarge_jsx(lib["UnmountClosed"], {
    isOpened: isComparisonActive
  }, SearchCompareLarge_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareLarge_jsx("div", {
    className: "flex -mx-px10 pt-px10"
  }, Array(selectedItemsMax).fill().map(function (_, idx) {
    var product = selectedItems[idx];
    var productId = product && product.id;
    return SearchCompareLarge_jsx("div", {
      className: "p-px10 w-1/3",
      key: productId || idx
    }, SearchCompareLarge_jsx(DropZone_DropZone, {
      className: "h-full",
      label: dropzoneLabel,
      number: idx + 1,
      onClear: productId && toggleProductSelectedForComparison ? function () {
        return toggleProductSelectedForComparison(productId);
      } : undefined
    }, product && SearchCompareLarge_jsx(ProductCondensed_ProductCondensed, product)));
  }))))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare/narrow/SearchCompareNarrow.jsx


var SearchCompareNarrow_jsx = react_default.a.createElement;










var SearchCompareNarrow_SearchCompareNarrow = function SearchCompareNarrow(_ref) {
  var buttonLabel = _ref.buttonLabel,
      cancelLabel = _ref.cancelLabel,
      collapseLabel = _ref.collapseLabel,
      expandLabel = _ref.expandLabel,
      children = _ref.children,
      className = _ref.className,
      comparisonClick = _ref.comparisonClick,
      comparisonToggle = _ref.comparisonToggle,
      comparisonUrl = _ref.comparisonUrl,
      dropzoneLabel = _ref.dropzoneLabel,
      isComparisonActive = _ref.isComparisonActive,
      isComparisonSubmitable = _ref.isComparisonSubmitable,
      isProductsTopInViewport = _ref.isProductsTopInViewport,
      isProductsBottomInViewport = _ref.isProductsBottomInViewport,
      mandatoryMessage = _ref.mandatoryMessage,
      resultsCount = _ref.resultsCount,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
      _ref$selectedItemsMax = _ref.selectedItemsMax,
      selectedItemsMax = _ref$selectedItemsMax === void 0 ? 3 : _ref$selectedItemsMax,
      toggleProductSelectedForComparison = _ref.toggleProductSelectedForComparison;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  var selectedItemsCount = selectedItems.length;
  return SearchCompareNarrow_jsx(react["Fragment"], null, SearchCompareNarrow_jsx(SiteContainer["a" /* SiteContainer */], {
    className: className
  }, children), resultsCount && resultsCount > 0 && SearchCompareNarrow_jsx("section", {
    className: classnames_default()('bg-white border-t-1 border-gray-light bottom-0 w-full z-3', {
      fixed: isProductsTopInViewport,
      absolute: isProductsBottomInViewport
    })
  }, !!selectedItemsCount && SearchCompareNarrow_jsx("div", {
    className: "absolute bottom-full flex justify-center w-full"
  }, SearchCompareNarrow_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-blue text-sm underline",
    height: 30,
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    }
  }, isExpanded ? collapseLabel : expandLabel, SearchCompareNarrow_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-px10 flex-shrink-0",
    name: isExpanded ? icons["a" /* ICONS */].SELECT : icons["a" /* ICONS */].SELECT_UP,
    width: "0.625rem"
  }))), SearchCompareNarrow_jsx(lib["UnmountClosed"], {
    isOpened: isExpanded
  }, SearchCompareNarrow_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareNarrow_jsx("div", {
    className: "pt-px20 pb-px5"
  }, Array(selectedItemsMax).fill().map(function (_, idx) {
    var product = selectedItems[idx];
    var productId = product && product.id;
    return SearchCompareNarrow_jsx("div", {
      className: "mb-px20",
      key: productId || idx
    }, SearchCompareNarrow_jsx(DropZone_DropZone, {
      label: dropzoneLabel,
      number: idx + 1,
      onClear: productId && toggleProductSelectedForComparison ? function () {
        toggleProductSelectedForComparison(productId);
        if (selectedItemsCount - 1 === 0) setExpanded(!isExpanded);
      } : undefined
    }, product && SearchCompareNarrow_jsx(ProductCondensed_ProductCondensed, product)));
  })))), SearchCompareNarrow_jsx(SiteContainer["a" /* SiteContainer */], null, SearchCompareNarrow_jsx("div", {
    className: "flex items-center justify-between py-px10"
  }, isComparisonActive && SearchCompareNarrow_jsx("button", {
    className: "reset-button font-bold text-base rtl:mr-px20",
    onClick: function onClick() {
      comparisonToggle();
      setExpanded(false);
    },
    type: "button"
  }, cancelLabel), SearchCompareNarrow_jsx(SearchCompareButton, {
    className: "flex-1",
    comparisonToggle: comparisonToggle,
    comparisonClick: comparisonClick,
    comparisonUrl: comparisonUrl,
    isComparisonActive: isComparisonActive,
    isComparisonSubmitable: isComparisonSubmitable,
    label: buttonLabel,
    mandatoryMessage: mandatoryMessage,
    selectedItemsCount: selectedItemsCount,
    selectedItemsMax: selectedItemsMax,
    style: {
      minHeight: 40
    }
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-compare/SearchCompare.jsx
var SearchCompare_jsx = react_default.a.createElement;




var SearchCompare_SearchCompare = function SearchCompare(props) {
  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  return isDesktop ? SearchCompare_jsx(SearchCompareLarge_SearchCompareLarge, props) : SearchCompare_jsx(SearchCompareNarrow_SearchCompareNarrow, props);
};
// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.mapper.js + 1 modules
var Product_mapper = __webpack_require__("bGCG");

// EXTERNAL MODULE: ./src/client/components/widgets/products-grid/ProductsGrid.jsx
var ProductsGrid = __webpack_require__("w04c");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-results/SearchResults.jsx



























var SearchResults_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var ProductsGridVirtualized = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(33), __webpack_require__.e(119)]).then(__webpack_require__.bind(null, "GbXy")).then(function (c) {
    return c.ProductsGridVirtualized;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("GbXy")];
    },
    modules: ["../../products-grid-virtualized/ProductsGridVirtualized"]
  }
});
var defaultProps = {
  config: {},
  resorts: [],
  displayValidationButton: true,
  isProductComparisonSelectionModeEnabled: false,
  productsSelectedForComparison: [],
  maxSelectableItems: 3,
  filteredProductsId: [],
  kids: [],
  toggleProductSelectedForComparison: lodash["noop"],
  isPriceLoading: false,
  prices: [],
  childcareAvailabilities: [],
  isSynchronousGrid: false
};
var SearchResults_SearchResults = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SearchResults, _Component);

  var _super = _createSuper(SearchResults);

  function SearchResults() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SearchResults);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "flattenResort", function (product) {
      var _price$termsAndCondit;

      var _this$props = _this.props,
          productsSelectedForComparison = _this$props.productsSelectedForComparison,
          maxSelectableItems = _this$props.maxSelectableItems,
          isProductComparisonSelectionModeEnabled = _this$props.isProductComparisonSelectionModeEnabled,
          displayValidationButton = _this$props.displayValidationButton,
          config = _this$props.config,
          isPriceLoading = _this$props.isPriceLoading,
          kids = _this$props.kids,
          departureDate = _this$props.departureDate;
      var productId = product.id;
      var isSelectedForComparison = productsSelectedForComparison.includes(productId);
      var maxSelectableItemsReached = productsSelectedForComparison.length === maxSelectableItems;

      var price = _this.getPriceForProduct(productId);

      var priceDepartureDate = price === null || price === void 0 ? void 0 : (_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.departureDate;
      var departureDateOn;

      if (departureDate && priceDepartureDate && moment_default()(departureDate).format(apiDate["a" /* API_DATE_FORMAT */]) !== String(priceDepartureDate)) {
        departureDateOn = Object(src_i18n["h" /* t */])('faceting.flexibility.resultIndication', {
          departure_date: moment_default()(priceDepartureDate, apiDate["a" /* API_DATE_FORMAT */]).format('DD/MM')
        });
      }

      return {
        hasComparison: isProductComparisonSelectionModeEnabled,
        isSliderDisabled: isProductComparisonSelectionModeEnabled,
        comparison: {
          isDisabled: isProductComparisonSelectionModeEnabled && !isSelectedForComparison && maxSelectableItemsReached,
          isSelectable: isProductComparisonSelectionModeEnabled && (isSelectedForComparison || !maxSelectableItemsReached),
          isSelected: isSelectedForComparison
        },
        displayValidationButton: displayValidationButton,
        config: config,
        offerColor: Object(lodash["get"])(_this.props, ['offer', 'color']),
        isPriceLoading: isPriceLoading,
        kids: kids,
        product: _objectSpread(_objectSpread({}, product), {}, {
          childcareAvailabilities: _this.getChildcareAvailabilitiesForProduct(productId),
          departureDateOn: departureDateOn,
          price: price
        })
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getProducts", Object(lodash["memoize"])(function (_ref) {
      var products = _ref.products;
      return products.map(function (product) {
        return Object(redux["d" /* compose */])(Product_mapper["g" /* updateProductUrl */], Product_mapper["c" /* getProductProps */], Product_mapper["e" /* setProductHref */], _this.flattenResort)(product);
      });
    }));

    return _this;
  }

  Object(createClass["a" /* default */])(SearchResults, [{
    key: "getPriceForProduct",
    value: function getPriceForProduct(productId) {
      var product = this.props.prices.find(function (p) {
        return p.id === productId;
      });
      return Object(lodash["get"])(product, 'price', {});
    }
  }, {
    key: "getChildcareAvailabilitiesForProduct",
    value: function getChildcareAvailabilitiesForProduct(productId) {
      return this.props.childcareAvailabilities.filter(function (childcareAvailability) {
        return childcareAvailability.productId === productId;
      });
    }
  }, {
    key: "getProductWithModifier",

    /**
     * Mutate the products to set the price or the comparison mode
     * We mutate the product to re-render only the subcomponents which needed it
     */
    value: function getProductWithModifier() {
      var _this2 = this;

      return this.getProducts({
        products: this.props.resorts,
        prices: this.props.prices
      }).map(function (product, index) {
        return Object(Product_mapper["f" /* updateProduct */])(product, _this2.flattenResort(_this2.props.resorts[index]));
      });
    }
  }, {
    key: "withCallToAction",
    value: function withCallToAction() {
      var _this$props$config, _this$props$config$co, _this$props$config$co2, _this$props$config$co3;

      var _get = Object(lodash["get"])(this.props, 'config.common', {}),
          thumbnailCTA = _get.thumbnailCTA,
          thumbnailTourCTA = _get.thumbnailTourCTA;

      var seeMoreText = !!((_this$props$config = this.props.config) === null || _this$props$config === void 0 ? void 0 : (_this$props$config$co = _this$props$config.common) === null || _this$props$config$co === void 0 ? void 0 : (_this$props$config$co2 = _this$props$config$co.editorial) === null || _this$props$config$co2 === void 0 ? void 0 : (_this$props$config$co3 = _this$props$config$co2.search) === null || _this$props$config$co3 === void 0 ? void 0 : _this$props$config$co3.seeMoreText);
      return Boolean(thumbnailCTA || thumbnailTourCTA || seeMoreText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          comparisonUrl = _this$props2.comparisonUrl,
          config = _this$props2.config,
          flexibility = _this$props2.flexibility,
          isProductComparisonModeAuthorized = _this$props2.isProductComparisonModeAuthorized,
          isProductComparisonSelectionModeEnabled = _this$props2.isProductComparisonSelectionModeEnabled,
          isProductsBottomInViewport = _this$props2.isProductsBottomInViewport,
          isProductsTopInViewport = _this$props2.isProductsTopInViewport,
          onClickCompareButton = _this$props2.onClickCompareButton,
          productsSelectedForComparison = _this$props2.productsSelectedForComparison,
          toggleProductComparisonSelectionMode = _this$props2.toggleProductComparisonSelectionMode,
          toggleProductSelectedForComparison = _this$props2.toggleProductSelectedForComparison,
          hasDepartureDate = _this$props2.hasDepartureDate,
          hasDepartureCity = _this$props2.hasDepartureCity,
          offer = _this$props2.offer,
          isSynchronousGrid = _this$props2.isSynchronousGrid,
          hasSeeMore = _this$props2.hasSeeMore;
      var display;

      if (hasSeeMore) {
        if (isSynchronousGrid) {
          display = {
            mobile: 1,
            phablet: 2,
            tablet: 3,
            desktop: 3
          };
        } else {
          display = {
            mobile: 2,
            phablet: 4,
            tablet: 6,
            desktop: 6
          };
        }
      }

      var products = this.props.prices.length === 0 && this.props.childcareAvailabilities.length === 0 ? this.getProducts({
        products: this.props.resorts,
        prices: this.props.prices
      }) : this.getProductWithModifier();
      var hasChildcareIncluded = this.props.childcareAvailabilities.length > 0;
      var childrenClassName = flexibility ? 'pt-px20' : '';
      return SearchResults_jsx(react["Fragment"], null, isProductComparisonModeAuthorized ? SearchResults_jsx(SearchCompare_SearchCompare, {
        className: "mb-px25",
        buttonLabel: Object(lodash["get"])(config, 'faceting.compare.buttonLabel'),
        cancelLabel: Object(lodash["get"])(config, 'faceting.compare.cancelLabel'),
        comparisonToggle: toggleProductComparisonSelectionMode,
        comparisonClick: onClickCompareButton,
        comparisonUrl: comparisonUrl,
        collapseLabel: Object(lodash["get"])(config, 'faceting.compare.collapseLabel'),
        dropzoneLabel: Object(lodash["get"])(config, 'faceting.compare.dropzoneLabel'),
        expandLabel: Object(lodash["get"])(config, 'faceting.compare.expandLabel'),
        isComparisonActive: isProductComparisonSelectionModeEnabled,
        isComparisonSubmitable: productsSelectedForComparison.length > 0 && hasDepartureDate && hasDepartureCity,
        isProductsBottomInViewport: isProductsBottomInViewport,
        isProductsTopInViewport: isProductsTopInViewport,
        mandatoryMessage: !hasDepartureDate || !hasDepartureCity ? Object(lodash["get"])(config, 'faceting.compare.dateAndTransportMandatory') : '',
        resultsCount: products.length,
        selectedItems: products.filter(function (product) {
          return productsSelectedForComparison.includes(product.id);
        }).map(function (product) {
          var _product$flag;

          return {
            header: product.header,
            id: product.id,
            order: productsSelectedForComparison.findIndex(function (p) {
              return p === product.id;
            }),
            picture: Object(lodash["get"])(product, 'thumbnail.pictures[0]'),
            price: Object(lodash["get"])(product, 'flag.price'),
            priceInfo: product === null || product === void 0 ? void 0 : (_product$flag = product.flag) === null || _product$flag === void 0 ? void 0 : _product$flag.priceInfo,
            url: product.url,
            offer: offer
          };
        }).sort(function (a, b) {
          return a.order - b.order;
        }),
        selectedItemsMax: constants["w" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */],
        toggleProductSelectedForComparison: toggleProductSelectedForComparison
      }, this.props.title) : SearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, this.props.title), SearchResults_jsx(SearchBanners_SearchBanners, {
        position: "top"
      }), SearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, this.props.virtualizedGrid && !hasChildcareIncluded && !this.withCallToAction() ? SearchResults_jsx(ProductsGridVirtualized, {
        childrenClassName: childrenClassName,
        className: this.props.className,
        products: products,
        onComparisonClick: toggleProductSelectedForComparison
      }) : SearchResults_jsx(ProductsGrid["a" /* ProductsGrid */], {
        childrenClassName: childrenClassName,
        className: this.props.className,
        products: products,
        totalNumberToDisplay: this.props.resorts.length,
        seeMore: this.props.seeMore,
        onComparisonClick: toggleProductSelectedForComparison,
        hasSeeMore: hasSeeMore,
        display: display,
        offer: offer,
        isSynchronousGrid: isSynchronousGrid,
        sortByPriceAscending: this.props.sortByPriceAscending
      }), SearchResults_jsx("div", {
        id: "SearchCompareBeacon"
      })), SearchResults_jsx(SearchBanners_SearchBanners, {
        position: "terms"
      }));
    }
  }]);

  return SearchResults;
}(react["Component"]);

Object(defineProperty["a" /* default */])(SearchResults_SearchResults, "defaultProps", defaultProps);
// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-results-placeholder/SearchResultsPlaceholder.jsx

var SearchResultsPlaceholder_jsx = react_default.a.createElement;




var ratio = ratios_utils["a" /* default */].VALUES.XL;
var SearchResultsPlaceholder_SearchResultsPlaceholder = function SearchResultsPlaceholder(_ref) {
  var nbItems = _ref.nbItems;
  return SearchResultsPlaceholder_jsx(Grid["a" /* default */], null, Object(lodash["fill"])(Array(nbItems)).map(function (a, i) {
    return SearchResultsPlaceholder_jsx("article", {
      className: "relative flex flex-col bg-white",
      "data-testid": "search-results-placeholder-item",
      key: i
    }, SearchResultsPlaceholder_jsx("div", {
      className: "bg-gray-lighter",
      style: {
        paddingBottom: "".concat(100 * ratio, "%")
      }
    }), SearchResultsPlaceholder_jsx("div", {
      className: "relative bg-white"
    }, SearchResultsPlaceholder_jsx("div", {
      className: "flex items-stretch w-full no-underline text-inherit"
    }, SearchResultsPlaceholder_jsx("div", {
      className: "flex-col flex-1 overflow-hidden py-px5"
    }, SearchResultsPlaceholder_jsx("div", {
      className: "bg-gray-lighter mb-px5 flex w-3/5 mt-px5 mb-px10 w-4/5",
      style: {
        height: '0.6rem'
      }
    }), SearchResultsPlaceholder_jsx("div", {
      className: "bg-gray-lighter mb-px5 flex w-3/5",
      style: {
        height: '0.6rem'
      }
    })))));
  }));
};
// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/faceting/constants.js
var faceting_constants = __webpack_require__("9QcM");

// CONCATENATED MODULE: ./src/client/store/faceting/productComparison.action.js



function productComparison_action_toggleProductComparisonSelectionMode() {
  return function (dispatch) {
    return dispatch(Object(createAction["b" /* default */])(faceting_constants["r" /* FACETING_TOGGLE_PRODUCT_COMPARISON_SELECTION_MODE */]));
  };
}

function setProductComparisonSelectionMode(enable) {
  return function (dispatch) {
    dispatch(Object(createAction["b" /* default */])(faceting_constants["o" /* FACETING_SET_PRODUCT_COMPARISON_SELECTION_MODE */], {
      enable: enable
    }));
  };
}

function toggleProductSelected(productId) {
  return function (dispatch) {
    return dispatch(Object(createAction["b" /* default */])(faceting_constants["s" /* FACETING_TOGGLE_PRODUCT_SELECTED_FOR_COMPARISON */], {
      productId: productId
    }));
  };
}


// EXTERNAL MODULE: ./src/client/store/utils/searchHelper.js
var searchHelper = __webpack_require__("4+vj");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/client/store/faceting/searchRequest.action.js









function searchRequest_action_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function searchRequest_action_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      searchRequest_action_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      searchRequest_action_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








function facetingSearchRequest(_ref) {
  var appContext = _ref.appContext,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  return function (dispatch, getState) {
    var state = getState();
    var departureDate = Object(tripCriteria_selector["b" /* getDepartureDate */])(state);

    if (departureDate && Object(facetingUtils["i" /* isDateInThePast */])(departureDate)) {
      dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    }

    var boutique = options.boutique,
        defaultDepartureCity = options.defaultDepartureCity,
        offerId = options.offerId,
        productIds = options.productIds,
        screenSize = options.screenSize;

    var _searchQuerySelector = Object(faceting_selector["m" /* searchQuerySelector */])(state),
        query = _searchQuerySelector.label;

    var facetingCriteria = Object(faceting_selector["c" /* facetingCriteriaSelector */])(state);
    var flexibility = Object(tripCriteria_selector["d" /* getTripFlexibility */])(state);

    var criteria = searchRequest_action_objectSpread(searchRequest_action_objectSpread({}, facetingCriteria), {}, {
      boutique: boutique,
      defaultDepartureCity: defaultDepartureCity,
      flexibility: flexibility,
      offerId: offerId,
      productIds: productIds,
      query: query,
      screenSize: screenSize
    });

    var promise = Object(searchHelper["f" /* searchWithFacets */])({
      criteria: criteria,
      options: options,
      appContext: appContext
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(faceting_constants["i" /* FACETING_SEARCH_REQUEST */], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function facetingLoadOffsetSellRequest(_ref2) {
  var appContext = _ref2.appContext;
  return function (dispatch) {
    var promise = Object(searchHelper["c" /* loadOffsetSell */])({
      appContext: appContext
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(faceting_constants["c" /* FACETING_LOAD_OFFSET_SELL_REQUEST */], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function facetingLoadProductsRequest(_ref3) {
  var appContext = _ref3.appContext,
      _ref3$productIds = _ref3.productIds,
      productIds = _ref3$productIds === void 0 ? [] : _ref3$productIds;
  return function (dispatch) {
    var promise = Object(searchHelper["e" /* loadProductsWithIds */])({
      appContext: appContext,
      productIds: productIds
    });
    return dispatch(Object(createAction["a" /* createOptimisticAction */])(faceting_constants["d" /* FACETING_LOAD_PRODUCTS_REQUEST */], {}, {
      optimist: true,
      promise: promise
    }));
  };
}
function pricesRequestAction(_ref4) {
  var appContext = _ref4.appContext,
      criteria = _ref4.criteria,
      withFlexibility = _ref4.withFlexibility;
  var promise = Object(searchHelper["d" /* loadPrices */])({
    appContext: appContext,
    criteria: criteria,
    withFlexibility: withFlexibility
  });
  return Object(createAction["a" /* createOptimisticAction */])(faceting_constants["e" /* FACETING_PRICES_REQUEST */], {}, {
    optimist: true,
    promise: promise
  });
}
function childcareRequestAction(_ref5) {
  var appContext = _ref5.appContext,
      _ref5$criteria = _ref5.criteria,
      criteria = _ref5$criteria === void 0 ? {} : _ref5$criteria;
  var promise = Object(searchHelper["b" /* loadChildcareAvailabilities */])({
    appContext: appContext,
    criteria: criteria
  });
  return Object(createAction["a" /* createOptimisticAction */])(faceting_constants["a" /* FACETING_CHILDCARE_REQUEST */], {}, {
    optimist: true,
    promise: promise
  });
}
// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/constants.js
var departure_city_constants = __webpack_require__("PFCZ");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// CONCATENATED MODULE: ./src/utils/faceting/unpersistedFacetUtils.js








function getCriteriaFromQueryParams(url) {
  return function (criteria) {
    var facetQueryParams = url ? new URI_default.a(url).query(true) : {};
    return Object(lodash["get"])(facetQueryParams, criteria, null);
  };
}

function getUrlWithUnpersistedData(options) {
  var url = options.url,
      query = options.query,
      _options$productIdsTo = options.productIdsToCompare,
      productIdsToCompare = _options$productIdsTo === void 0 ? [] : _options$productIdsTo,
      departureCity = options.departureCity,
      departureDate = options.departureDate,
      duration = options.duration;

  var queryParams = Object(defineProperty["a" /* default */])({}, constants["A" /* PRODUCTS_TO_COMPARE_QUERY_PARAM */], productIdsToCompare);

  if (!Object(lodash["isEmpty"])(query)) {
    queryParams[constants["C" /* QUERY_QUERY_PARAM */]] = query.label;
  }

  if (!Object(lodash["isEmpty"])(departureCity)) {
    queryParams[uri_constants["k" /* QUERY_TRANSPORT */]] = departureCity;
  }

  var departureDateTimestamp = departureDate;

  if (moment_default.a.isMoment(departureDate) && departureDate.isValid()) {
    departureDateTimestamp = departureDate.valueOf();
  }

  if (Object(lodash["isInteger"])(departureDateTimestamp)) {
    queryParams[uri_constants["f" /* QUERY_DEPARTURE_DATE */]] = Object(uriUtils["d" /* formatDateForHashParams */])(departureDateTimestamp);
  }

  if (Object(lodash["isInteger"])(duration) && duration > 0) {
    queryParams[uri_constants["g" /* QUERY_DURATION */]] = "".concat(duration);
  }

  return Object(uriUtils["f" /* generateUrlWithParams */])(url, {
    queryParams: queryParams
  });
}


// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var pertimm_client_filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/label/labelUtils.js
var labelUtils = __webpack_require__("WGoB");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/search-results-title/SearchResultsTitle.jsx
var SearchResultsTitle_jsx = react_default.a.createElement;
// $FlowFixMe (see https://github.com/facebook/flow/pull/7111)



function SearchResultsTitle(props) {
  var dataTestId = props.dataTestId,
      pluralLabel = props.pluralLabel,
      resultsCount = props.resultsCount,
      singularLabel = props.singularLabel;

  if (!pluralLabel || !resultsCount || !singularLabel) {
    return null;
  }

  return SearchResultsTitle_jsx("p", {
    "data-testid": dataTestId,
    className: "reset-heading font-brand font-bold leading-tight text-xl md:text-3xl"
  }, SearchResultsTitle_jsx("span", {
    className: "font-normal",
    dangerouslySetInnerHTML: {
      __html: Object(dist["messageFormat"])(Object(labelUtils["d" /* pluralizeLabel */])(singularLabel, pluralLabel, resultsCount)).format({
        nbResults: "<strong class=\"text-blue\">".concat(resultsCount, "</strong>")
      })
    }
  }));
}
/* harmony default export */ var search_results_title_SearchResultsTitle = (/*#__PURE__*/Object(react["memo"])(SearchResultsTitle));
// CONCATENATED MODULE: ./src/client/components/widgets/facet-search-results/FacetSearchResults.jsx









var FacetSearchResults_jsx = react_default.a.createElement;






























function mapStateToProps(state) {
  var _state$faceting = state.faceting,
      _state$faceting$child = _state$faceting.childcareAvailabilities,
      childcareAvailabilities = _state$faceting$child === void 0 ? [] : _state$faceting$child,
      isDateRequired = _state$faceting.isDateRequired,
      isLoading = _state$faceting.isLoading,
      _state$faceting$isPri = _state$faceting.isPriceLoading,
      isPriceLoading = _state$faceting$isPri === void 0 ? false : _state$faceting$isPri,
      isSelectionModeEnabled = _state$faceting.isSelectionModeEnabled,
      _state$faceting$noRes = _state$faceting.noResults,
      noResults = _state$faceting$noRes === void 0 ? false : _state$faceting$noRes,
      pertimmInterpretations = _state$faceting.pertimmInterpretations,
      _state$faceting$price = _state$faceting.prices,
      prices = _state$faceting$price === void 0 ? [] : _state$faceting$price,
      productsSelectedForComparison = _state$faceting.productsSelectedForComparison,
      query = _state$faceting.query,
      _state$tripInformatio = state.tripInformation,
      _state$tripInformatio2 = _state$tripInformatio.adults,
      adults = _state$tripInformatio2 === void 0 ? [] : _state$tripInformatio2,
      kids = _state$tripInformatio.kids;
  return {
    activeFacets: Object(faceting_selector["a" /* activeFacetsSelector */])(state),
    adultsNumber: adults.length || adults_constants["a" /* DEFAULT_ADULTS_NB */],
    childcareAvailabilities: childcareAvailabilities,
    departureCity: Object(tripCriteria_selector["a" /* getDepartureCity */])(state),
    departureDate: Object(tripCriteria_selector["b" /* getDepartureDate */])(state),
    duration: Object(tripCriteria_selector["c" /* getTripDuration */])(state),
    filteredProducts: Object(faceting_selector["g" /* filteredProductsSelector */])(state),
    filters: Object(faceting_selector["j" /* getFiltersSelector */])(state),
    flexibility: Object(tripCriteria_selector["d" /* getTripFlexibility */])(state),
    isDateRequired: isDateRequired,
    isLoading: isLoading,
    isPriceLoading: isPriceLoading,
    isProductComparisonSelectionModeEnabled: isSelectionModeEnabled,
    kids: kids,
    noResults: noResults,
    pertimmInterpretations: pertimmInterpretations,
    prices: prices,
    productsSelectedForComparison: productsSelectedForComparison,
    query: query,
    recommandedProducts: Object(faceting_selector["l" /* recommandedProductsSelector */])(state)
  };
}

var FacetSearchResults_FacetSearchResults = function FacetSearchResults(_ref) {
  var i18n = _ref.i18n,
      initialProducts = _ref.initialProducts,
      _ref$isProductCompari = _ref.isProductComparisonModeAuthorized,
      isProductComparisonModeAuthorized = _ref$isProductCompari === void 0 ? false : _ref$isProductCompari,
      _ref$isSynchronousGri = _ref.isSynchronousGrid,
      isSynchronousGrid = _ref$isSynchronousGri === void 0 ? false : _ref$isSynchronousGri,
      _ref$resortGridProps = _ref.resortGridProps,
      resortGridProps = _ref$resortGridProps === void 0 ? {} : _ref$resortGridProps,
      resultsHasSeeMore = _ref.resultsHasSeeMore,
      resultsSeeMore = _ref.resultsSeeMore,
      _ref$searchOptions = _ref.searchOptions,
      searchOptions = _ref$searchOptions === void 0 ? {} : _ref$searchOptions,
      _ref$shouldSetDefault = _ref.shouldSetDefaultDepartureCityOnCompare,
      shouldSetDefaultDepartureCityOnCompare = _ref$shouldSetDefault === void 0 ? false : _ref$shouldSetDefault,
      virtualizedGrid = _ref.virtualizedGrid,
      _ref$offer = _ref.offer,
      offer = _ref$offer === void 0 ? {} : _ref$offer,
      sortByPriceAscending = _ref.sortByPriceAscending;

  var _useSelector = Object(es["e" /* useSelector */])(mapStateToProps),
      activeFacets = _useSelector.activeFacets,
      adultsNumber = _useSelector.adultsNumber,
      childcareAvailabilities = _useSelector.childcareAvailabilities,
      departureCity = _useSelector.departureCity,
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration,
      filteredProducts = _useSelector.filteredProducts,
      filters = _useSelector.filters,
      flexibility = _useSelector.flexibility,
      isDateRequired = _useSelector.isDateRequired,
      isLoading = _useSelector.isLoading,
      isPriceLoading = _useSelector.isPriceLoading,
      isProductComparisonSelectionModeEnabled = _useSelector.isProductComparisonSelectionModeEnabled,
      kids = _useSelector.kids,
      noResults = _useSelector.noResults,
      pertimmInterpretations = _useSelector.pertimmInterpretations,
      prices = _useSelector.prices,
      productsSelectedForComparison = _useSelector.productsSelectedForComparison,
      query = _useSelector.query,
      recommandedProducts = _useSelector.recommandedProducts;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var filteredProductsRef = Object(react["useRef"])(null);
  var dispatch = Object(es["d" /* useDispatch */])(); // This state, the updateCompareButtonStickyStatus function and the first effect should be moved to SearchCompare

  var _useState = Object(react["useState"])(true),
      isProductsTopInViewport = _useState[0],
      setProductsTopInViewport = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isProductsBottomInViewport = _useState2[0],
      setProductsBottomInViewport = _useState2[1];

  var updateCompareButtonStickyStatus = Object(lodash["throttle"])(function () {
    if (filteredProducts.length > 0 && filteredProductsRef.current) {
      var searchResultsWrapperClientRect = filteredProductsRef.current.getBoundingClientRect();
      var clientHeight = dist["windowWrapper"].getClientHeight();
      setProductsTopInViewport(searchResultsWrapperClientRect.top <= clientHeight);
      setProductsBottomInViewport(searchResultsWrapperClientRect.bottom <= clientHeight);
    }
  }, 200);
  Object(react["useEffect"])(function () {
    if (isProductComparisonModeAuthorized) {
      document.removeEventListener('scroll', updateCompareButtonStickyStatus, false);
      document.addEventListener('scroll', updateCompareButtonStickyStatus, false);
    }

    if (initialProducts && initialProducts.length > 0) {
      dispatch(Object(facetingSearch_action["k" /* setInitialProductPrices */])(initialProducts));
    }
  }, []);
  var productIds = [];
  productIds = Object(react["useMemo"])(function () {
    return (filteredProducts.length !== 0 ? filteredProducts : recommandedProducts).map(function (product) {
      return product.id;
    });
  }, [filteredProducts.length !== 0 ? filteredProducts : recommandedProducts]);
  Object(react["useEffect"])(function () {
    if (productIds && productIds.length > 0 && !isLoading) {
      var _ref2 = pertimmInterpretations || {},
          minDate = _ref2.minDate,
          maxDate = _ref2.maxDate;

      var boutique = searchOptions.boutique,
          defaultDepartureCity = searchOptions.defaultDepartureCity,
          offerId = searchOptions.offerId,
          offerName = searchOptions.offerName;

      var _getFlexibilityDates = Object(pertimm_client_filters["f" /* getFlexibilityDates */])({
        departureDate: departureDate,
        flexibility: flexibility
      }),
          minDepartureDate = _getFlexibilityDates.minDepartureDate,
          maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

      var withFlexibility = flexibility && departureDate;
      var today = moment_default()();
      var departureDateEnd = resortGridProps.departureDateEnd,
          departureDateStart = resortGridProps.departureDateStart;
      var start = departureDateStart && moment_default()(departureDateStart);
      var end = departureDateEnd && moment_default()(departureDateEnd);
      var dateStart = start && Object(apiDate["j" /* momentToApiDate */])(start.isBefore(today) ? today : start);
      var dateEnd = end && Object(apiDate["j" /* momentToApiDate */])(end);
      dispatch(pricesRequestAction({
        appContext: appContext,
        criteria: {
          boutique: boutique,
          defaultDepartureCity: defaultDepartureCity || resortGridProps.departureCity,
          departureDate: departureDate,
          duration: duration || resortGridProps.duration,
          filters: filters,
          maxDate: withFlexibility ? Number(maxDepartureDate) : maxDate || dateEnd,
          minDate: withFlexibility ? Number(minDepartureDate) : minDate || dateStart,
          offerId: offerId,
          offerName: offerName,
          productIds: productIds,
          query: query ? query.label : ''
        },
        withFlexibility: withFlexibility
      }));
    }
    /**
     * Component should fetch childcare availabilities
     * if availabilities don't exist yet
     * and if there are eligeable kids
     */


    var childcareProductIds = childcareAvailabilities.map(function (childcareAvailability) {
      return childcareAvailability.productId;
    });
    var productsWithoutChildcareAvailabilities = productIds.filter(function (id) {
      return !childcareProductIds.includes(id);
    });
    var kidsWithChildcare = kids.filter(function (kid) {
      return kid.birthdate;
    });

    if (productsWithoutChildcareAvailabilities.length > 0 && kidsWithChildcare.length > 0 && departureDate) {
      dispatch(childcareRequestAction({
        appContext: appContext,
        criteria: {
          departureDate: departureDate,
          duration: duration || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
          kids: kidsWithChildcare,
          productIds: productIds
        }
      }));
    }
  }, [isLoading]);
  Object(react["useEffect"])(function () {
    if (!isDateRequired && !departureDate) {
      dispatch(setProductComparisonSelectionMode(false));
    }
  }, [isDateRequired]);

  var computeFacetsToCXOParams = function computeFacetsToCXOParams() {
    var destinations = filteredProducts.filter(function (product) {
      return productsSelectedForComparison.indexOf(Object(lodash["get"])(product, 'id')) !== -1;
    }).map(function (destination) {
      return Object(lodash["get"])(destination, 'name');
    });
    var activities = activeFacets[constants["a" /* ACTIVITIES_FACET_ID */]] ? Object.keys(activeFacets[constants["a" /* ACTIVITIES_FACET_ID */]]) : null;
    return [Object(facetingUtils["g" /* getDepartureDateDisplayValue */])(departureDate), departureCity, destinations && destinations.length > 0 ? destinations.join(' / ') : null, adultsNumber, kids.length, activities && activities.length > 0 ? activities.join(' / ') : null, // activities
    adultsNumber + kids.length, // participants
    kids.some(function (kid) {
      return kid.childcareIncluded;
    })];
  };

  var onClickCompareButton = function onClickCompareButton() {
    dispatch(Object(globalLoader_action["d" /* startLoading */])());

    if (Object(sellerUtils["g" /* isSeller */])(appContext)) {
      Object(sellerUtils["l" /* sendFacetsToCxO */])(computeFacetsToCXOParams());
    }
  };

  var toggleProductComparisonSelectionMode = function toggleProductComparisonSelectionMode() {
    dispatch(setProductComparisonSelectionMode(!isProductComparisonSelectionModeEnabled));

    if (shouldSetDefaultDepartureCityOnCompare && !departureCity && !isProductComparisonSelectionModeEnabled) {
      dispatch(Object(facetingSearch_action["a" /* changeDepartureCity */])(departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */]));
    }
  };

  var getCompareUrl = function getCompareUrl() {
    var url = routeBuilder["b" /* urlPattern */]('comparator');
    return getUrlWithUnpersistedData({
      url: url,
      query: query,
      productIdsToCompare: productsSelectedForComparison,
      departureCity: departureCity,
      departureDate: departureDate,
      duration: duration
    });
  };

  var toggleProductSelectedForComparison = function toggleProductSelectedForComparison() {
    if (isProductComparisonSelectionModeEnabled) {
      return function (productId) {
        return dispatch(toggleProductSelected(productId));
      };
    }
  };

  var hasDepartureDate = !!departureDate;
  var hasDepartureCity = !!departureCity;
  var resultsCount = filteredProducts.length;
  var shouldDisplayResults = resultsCount > 0 && !isLoading && !noResults;
  var comparisonUrl = getCompareUrl();

  if (noResults && !isLoading) {
    var _title = FacetSearchResults_jsx(Title["a" /* Title */], {
      dataTestId: "facet-search-results-title",
      theme: "title-brand-9"
    }, Object(src_i18n["h" /* t */])('remote.noResult.recommendation.title'));

    return FacetSearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, FacetSearchResults_jsx("div", {
      "data-testid": "facet-search-no-results"
    }, FacetSearchResults_jsx(SearchNoResults, {
      explanation: Object(src_i18n["h" /* t */])('remote.noResult.updateCriteria'),
      isSeller: Object(sellerUtils["g" /* isSeller */])(appContext),
      title: Object(src_i18n["h" /* t */])('remote.noResult.explanation')
    })), recommandedProducts.length !== 0 ? FacetSearchResults_jsx("div", {
      "data-testid": "facet-search-recommanded-results"
    }, FacetSearchResults_jsx(SearchResults_SearchResults, {
      childcareAvailabilities: childcareAvailabilities,
      className: "pb-px95 lg:pb-px40",
      comparisonUrl: comparisonUrl,
      config: i18n,
      displayValidationButton: !Object(sellerUtils["g" /* isSeller */])(appContext),
      hasSeeMore: resultsHasSeeMore,
      isPriceLoading: isPriceLoading,
      isProductsBottomInViewport: isProductsBottomInViewport,
      isProductComparisonSelectionModeEnabled: false,
      isProductComparisonModeAuthorized: false,
      isProductsTopInViewport: isProductsTopInViewport,
      isSynchronousGrid: isSynchronousGrid,
      offer: offer,
      onClickCompareButton: onClickCompareButton,
      prices: prices,
      resorts: recommandedProducts,
      sortByPriceAscending: sortByPriceAscending,
      title: _title,
      toggleProductComparisonSelectionMode: toggleProductComparisonSelectionMode,
      virtualizedGrid: virtualizedGrid
    })) : FacetSearchResults_jsx("div", null));
  }

  if (isLoading || !resultsCount) {
    return FacetSearchResults_jsx("div", {
      "data-testid": "facet-search-results"
    }, FacetSearchResults_jsx(SiteContainer["a" /* SiteContainer */], null, FacetSearchResults_jsx(SearchResultsPlaceholder_SearchResultsPlaceholder, {
      nbItems: 8
    })), ")");
  }

  var title = FacetSearchResults_jsx(SearchResultsTitle, {
    dataTestId: "facet-search-results-title",
    pluralLabel: Object(src_i18n["h" /* t */])('faceting.nbResortsThatMatchYourCriteria'),
    resultsCount: filteredProducts.length,
    singularLabel: Object(src_i18n["h" /* t */])('faceting.oneResortThatMatchYourCriteria')
  });

  return FacetSearchResults_jsx("div", {
    ref: filteredProductsRef,
    "data-testid": "facet-search-results"
  }, shouldDisplayResults && FacetSearchResults_jsx(SearchResults_SearchResults, {
    className: "pb-px95 lg:pb-px40",
    departureDate: departureDate,
    flexibility: flexibility,
    title: title,
    config: i18n,
    offer: offer,
    resorts: filteredProducts,
    prices: prices,
    isPriceLoading: isPriceLoading,
    childcareAvailabilities: childcareAvailabilities,
    isProductComparisonSelectionModeEnabled: isProductComparisonSelectionModeEnabled && resultsCount > 0,
    productsSelectedForComparison: productsSelectedForComparison,
    maxSelectableItems: constants["w" /* MAX_NUMBER_OF_SELECTED_PRODUCTS */],
    toggleProductSelectedForComparison: toggleProductSelectedForComparison(),
    toggleProductComparisonSelectionMode: toggleProductComparisonSelectionMode,
    displayValidationButton: !Object(sellerUtils["g" /* isSeller */])(appContext),
    hasSeeMore: resultsHasSeeMore,
    seeMore: resultsSeeMore,
    isSynchronousGrid: isSynchronousGrid,
    kids: kids,
    virtualizedGrid: virtualizedGrid,
    isProductComparisonModeAuthorized: isProductComparisonModeAuthorized,
    onClickCompareButton: onClickCompareButton,
    comparisonUrl: comparisonUrl,
    isProductsBottomInViewport: isProductsBottomInViewport,
    isProductsTopInViewport: isProductsTopInViewport,
    hasDepartureDate: hasDepartureDate,
    hasDepartureCity: hasDepartureCity,
    sortByPriceAscending: sortByPriceAscending
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/store/faceting/faceting.reducer.js
var faceting_reducer = __webpack_require__("8WCa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/frameworks/choice-list/ChoiceList.jsx



var ChoiceList_jsx = react_default.a.createElement;





var ChoiceList_ChoiceList = function ChoiceList(_ref) {
  var _ref$choices = _ref.choices,
      choices = _ref$choices === void 0 ? [] : _ref$choices,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      listClassName = _ref.listClassName,
      name = _ref.name,
      onChange = _ref.onChange,
      showToggleAll = _ref.showToggleAll,
      title = _ref.title,
      toggleAllValue = _ref.toggleAllValue;

  var onToggle = function onToggle(_, isSelected, value) {
    onChange(name, isSelected, value);
  };

  return ChoiceList_jsx("fieldset", {
    className: classnames_default()('border-0 p-0 m-0', className),
    "data-testid": dataTestId
  }, title && ChoiceList_jsx("legend", {
    className: classnames_default()('mb-px5 p-none', {
      'font-bold text-xl text-blue': !showToggleAll
    })
  }, showToggleAll ? ChoiceList_jsx(InputSwitch["a" /* InputSwitch */], {
    isChecked: choices.every(function (choice) {
      return choice.isSelected;
    }),
    label: title,
    name: name,
    onChange: onChange,
    size: "large",
    value: toggleAllValue
  }) : title), choices.length > 0 && ChoiceList_jsx("ul", {
    className: classnames_default()(listClassName, 'list-none p-0')
  }, choices.map(function (choice) {
    return ChoiceList_jsx("li", {
      className: "flex items-center mb-px10",
      key: choice.value
    }, choice.icon && ChoiceList_jsx(Icon["a" /* Icon */], {
      className: "mr-px10",
      color: colors["a" /* COLORS */].BLUE,
      name: choice.icon,
      width: "1.5rem"
    }), ChoiceList_jsx(InputSwitch["a" /* InputSwitch */], {
      isChecked: !!choice.isSelected,
      label: choice.label,
      name: "".concat(name, "[]"),
      onChange: onToggle,
      value: choice.value
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/choice-lists/ChoiceLists.jsx



var ChoiceLists_jsx = react_default.a.createElement;




function ChoiceLists(props) {
  var _props$choiceLists = props.choiceLists,
      choiceLists = _props$choiceLists === void 0 ? [] : _props$choiceLists,
      className = props.className,
      listClassName = props.listClassName,
      name = props.name,
      onChange = props.onChange,
      showToggleAll = props.showToggleAll,
      title = props.title,
      toggleAllValue = props.toggleAllValue,
      dataTestId = props.dataTestId;
  return ChoiceLists_jsx("fieldset", {
    className: classnames_default()('p-0 m-0 border-0', className),
    "data-testid": dataTestId
  }, title && ChoiceLists_jsx("legend", {
    className: classnames_default()('p-none mb-px25', {
      'text-xl text-blue font-bold': !showToggleAll
    })
  }, showToggleAll ? ChoiceLists_jsx(InputSwitch["a" /* InputSwitch */], {
    label: title,
    isChecked: choiceLists.every(function (choiceList) {
      return choiceList.choices.every(function (choice) {
        return choice.isSelected;
      });
    }),
    onChange: onChange,
    name: name,
    size: "large",
    value: toggleAllValue
  }) : title), choiceLists.length > 0 && ChoiceLists_jsx(react["Fragment"], null, choiceLists.map(function (choiceList) {
    return ChoiceLists_jsx(react["Fragment"], {
      key: choiceList.value
    }, ChoiceLists_jsx("legend", {
      className: classnames_default()('capitalize p-none mb-px5', {
        'text-xl text-blue font-bold': !showToggleAll
      })
    }, showToggleAll ? ChoiceLists_jsx(InputSwitch["a" /* InputSwitch */], {
      label: choiceList.label,
      isChecked: choiceList.choices.every(function (choice) {
        return choice.isSelected;
      }),
      onChange: onChange,
      name: name,
      size: "large",
      value: toggleAllValue
    }) : choiceList.label), ChoiceLists_jsx(ChoiceList_ChoiceList, {
      choices: choiceList.choices,
      className: classnames_default()('FacetList', className),
      listClassName: listClassName,
      name: name,
      onChange: onChange,
      title: ""
    }));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetLabel.jsx
var FacetLabel_jsx = react_default.a.createElement;

function FacetLabel(_ref) {
  var children = _ref.children,
      count = _ref.count;

  if (!children) {
    // Safeguard: API can return facets with null names, that must be ignored.
    return null;
  }

  return FacetLabel_jsx(react["Fragment"], null, FacetLabel_jsx("span", {
    className: "capitalize"
  }, children.toLowerCase()), FacetLabel_jsx("span", {
    className: "mx-px10 font-bold text-gray-medium"
  }, "(", count, ")"));
}
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetList.jsx










var FacetList_jsx = react_default.a.createElement;

function FacetList_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FacetList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FacetList_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FacetList_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var FacetList_defaultProps = {
  listClassName: ''
};

var getChoiceLists = function getChoiceLists(props) {
  // Safeguard: API can return facets with null names, that must be ignored.
  return props.facets.filter(function (_ref) {
    var label = _ref.label;
    return !!label;
  }).map(function (facet) {
    var label = facet.label,
        value = facet.value;
    return {
      choices: facet.list && facet.list.length > 0 ? FacetList_getChoices(FacetList_objectSpread(FacetList_objectSpread({}, props), {}, {
        facets: facet.list
      })) : [],
      label: label,
      value: value
    };
  });
};

var FacetList_getChoices = function getChoices(_ref2) {
  var facets = _ref2.facets,
      activeFacets = _ref2.activeFacets;
  // Safeguard: API can return facets with null names, that must be ignored.
  return facets.filter(function (_ref3) {
    var label = _ref3.label;
    return !!label;
  }).map(function (_ref4) {
    var label = _ref4.label,
        count = _ref4.count,
        value = _ref4.value;
    return {
      isSelected: activeFacets && activeFacets[value],
      label: FacetList_jsx(FacetLabel, {
        count: count
      }, label),
      value: value
    };
  });
};

var FacetList_FacetList = function FacetList(props) {
  var name = props.name;
  return name === constants["e" /* COUNTRIES_FACET_ID */] ? FacetList_jsx(ChoiceLists, {
    choiceLists: getChoiceLists(props),
    className: classnames_default()('FacetList', props.className),
    listClassName: props.listClassName,
    name: name,
    onChange: props.onChange,
    title: props.title
  }) : FacetList_jsx(ChoiceList_ChoiceList, {
    choices: FacetList_getChoices(props),
    className: classnames_default()('FacetList', props.className),
    listClassName: props.listClassName,
    name: name,
    onChange: props.onChange,
    title: props.title
  });
};
FacetList_FacetList.defaultProps = FacetList_defaultProps;
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetLists.jsx











var FacetLists_jsx = react_default.a.createElement;

function FacetLists_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FacetLists_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FacetLists_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FacetLists_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var FacetLists_FacetLists = function FacetLists(_ref) {
  var activeFacets = _ref.activeFacets,
      facetsFromSearch = _ref.facetsFromSearch,
      onChange = _ref.onChange,
      templateConfig = _ref.templateConfig;
  var _templateConfig$facet = templateConfig.facetLists,
      facetListsConfig = _templateConfig$facet === void 0 ? [] : _templateConfig$facet;

  var localizeFacetLabel = function localizeFacetLabel(facet, facetLabelsFolder) {
    if (!facetLabelsFolder) {
      return facet;
    }

    var localizedLabel = Object(src_i18n["h" /* t */])("".concat(facetLabelsFolder, ".label_").concat(facet.value.toLowerCase()));

    if (!localizedLabel) {
      return facet;
    }

    return FacetLists_objectSpread(FacetLists_objectSpread({}, facet), {}, {
      label: localizedLabel
    });
  };

  return FacetLists_jsx(react["Fragment"], null, facetListsConfig.map(function (_ref2) {
    var deep = _ref2.deep,
        subFacetId = _ref2.id,
        facetLabels = _ref2.facetLabels,
        titleLabel = _ref2.titleLabel;
    var facetFromSearch = facetsFromSearch.find(function (_ref3) {
      var id = _ref3.id;
      return id === subFacetId;
    });

    if (!facetFromSearch || !facetFromSearch.list) {
      return;
    }

    if (!deep) {
      return FacetLists_jsx(FacetList_FacetList, {
        activeFacets: activeFacets[subFacetId],
        className: "FacetList-".concat(subFacetId),
        facets: facetFromSearch.list.map(function (facet) {
          return localizeFacetLabel(facet, facetLabels);
        }),
        key: subFacetId,
        name: subFacetId,
        onChange: onChange,
        title: Object(src_i18n["h" /* t */])(titleLabel)
      });
    }

    return facetFromSearch.list.map(function (_ref4) {
      var label = _ref4.label,
          _ref4$list = _ref4.list,
          list = _ref4$list === void 0 ? [] : _ref4$list,
          value = _ref4.value;
      return FacetLists_jsx(FacetList_FacetList, {
        activeFacets: activeFacets[subFacetId],
        className: classnames_default()('lg:flex-1', "FacetList-".concat(subFacetId)),
        facets: list.map(function (facet) {
          return localizeFacetLabel(facet, facetLabels);
        }) || [],
        key: value,
        name: subFacetId,
        onChange: onChange,
        title: label || Object(src_i18n["h" /* t */])(titleLabel)
      });
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/FacetCategory.jsx

var FacetCategory_jsx = react_default.a.createElement;









var FacetCategory_FacetCategory = function FacetCategory(props) {
  var _useResponsive = Object(responsive_responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var facetId = props.templateConfig.id;
  var MAX_REGION_COUNT = isDesktop ? 4 : 6;
  var MAX_COUNTRY_COUNT = isDesktop ? 27 : 20;
  return FacetCategory_jsx("div", {
    className: classnames_default()('lg:flex', 'FacetCategory', "FacetCategory-".concat(facetId)),
    key: facetId
  }, facetId === constants["n" /* DESTINATIONS_FACET_ID */] && props.facetsFromSearch.filter(function (facet) {
    var _facet$id = facet.id,
        id = _facet$id === void 0 ? '' : _facet$id,
        _facet$list = facet.list,
        list = _facet$list === void 0 ? [] : _facet$list;

    if (id !== constants["e" /* COUNTRIES_FACET_ID */]) {
      return false;
    }

    var regionCount = list.length;
    var countryCount = Object(faceting_reducer["b" /* getTotalLabelsCount */])(facet);
    return regionCount > MAX_REGION_COUNT || countryCount > MAX_COUNTRY_COUNT;
  }).length > 0 ? FacetCategory_jsx(CollapsePanel["a" /* CollapsePanel */], {
    collapseLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    expandLabel: Object(src_i18n["h" /* t */])('common.loadMoreDestinations'),
    isSemiTransparent: true,
    loadMoreButtonPosition: "bottom",
    onClick: function onClick(isActive) {
      if (!isActive) {
        Object(scrollToElement["a" /* scrollToElement */])('.Line-ProductsFilters', 250, '.Navigation-bar');
      }
    },
    noIcons: true,
    theme: "searchDestinationsFacet"
  }, FacetCategory_jsx(FacetLists_FacetLists, props)) : FacetCategory_jsx(FacetLists_FacetLists, props));
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/SearchFacets.utils.js
function getLabelGA(facetId) {
  switch (facetId) {
    case '':
      return null;

    case 'activities':
      return 'whichActivities';

    case 'destinations':
      return 'whichDestinations';

    default:
      // 'when', 'who', 'where'
      return facetId;
  }
}

var getActiveFacetTabTrackingData = function getActiveFacetTabTrackingData(_ref) {
  var facetId = _ref.facetId;
  return {
    actionGA: 'smartCriterias',
    labelGA: getLabelGA(facetId)
  };
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/search-facets/SearchFacets.jsx











var SearchFacets_jsx = react_default.a.createElement;











var SearchFacets_SearchFacets = function SearchFacets(props) {
  var activeFacets = props.activeFacets,
      facets = props.facets,
      _props$facetTemplateC = props.facetTemplateConfig,
      facetTemplateConfig = _props$facetTemplateC === void 0 ? [] : _props$facetTemplateC,
      facetTrackingConfig = props.facetTrackingConfig;

  var _useState = Object(react["useState"])(-1),
      selectedFacetTab = _useState[0],
      setSelectedFacetTab = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])();

  if (facets.length <= 0) {
    return null;
  }

  var onClearFacets = function onClearFacets(id) {
    var templateConfig = facetTemplateConfig.find(function (_ref) {
      var facetId = _ref.id;
      return id === facetId;
    });

    if (!templateConfig) {
      return;
    }

    props.clearFacets(id);
    templateConfig.facetLists.forEach(function (_ref2) {
      var facetListId = _ref2.id;
      props.clearFacets(facetListId);
    });
  };

  var trackFacetChange = function trackFacetChange(name, checked, value) {
    if (!checked) {
      return;
    }

    var labelSuffix = value.toString().replace(/[|\s]/g, '_').toLowerCase();
    var trackingConfig = facetTrackingConfig.find(function (_ref3) {
      var id = _ref3.id;
      return id === name.replace('[]', '');
    });

    if (!trackingConfig) {
      return;
    }

    var labelGA = "".concat(trackingConfig.trackingPrefixLabel, "_").concat(labelSuffix);

    if (labelGA) {
      track({
        actionGA: 'smartCriterias',
        labelGA: labelGA
      });
    }
  };

  var changeFacet = function changeFacet(name, checked, value) {
    setSelectedFacetTab(-1);
    trackFacetChange(name, checked, value);
    props.toggleFacet({
      categoryId: name,
      isSelected: checked,
      value: value
    });
    Object(scrollToElement["a" /* scrollToElement */])('.Line-ProductsFilters', 250, '.Navigation-bar');
  };

  var getTabItems = function getTabItems() {
    return facetTemplateConfig.map(function (templateConfig) {
      var id = templateConfig.id,
          dataLabel = templateConfig.dataLabel,
          iconName = templateConfig.iconName,
          titleLabel = templateConfig.titleLabel,
          facetLists = templateConfig.facetLists;
      var count = facetLists.map(function (_ref4) {
        var facetId = _ref4.id;
        return activeFacets[facetId] ? Object.keys(activeFacets[facetId]).length : 0;
      }).reduce(function (acc, facetCount) {
        return acc + facetCount;
      }, 0);
      var title = Object(src_i18n["h" /* t */])(titleLabel);
      return {
        id: id,
        header: {
          iconName: iconName,
          title: title,
          trackingData: getActiveFacetTabTrackingData({
            facetId: dataLabel
          })
        },
        customHeader: count > 0 ? function (_ref5, setRef) {
          var controlsId = _ref5.controlsId,
              itemId = _ref5.id,
              onClick = _ref5.onClick,
              onKeyDown = _ref5.onKeyDown,
              isActive = _ref5.isActive,
              style = _ref5.style,
              tabIndex = _ref5.tabIndex;
          return SearchFacets_jsx("div", {
            className: "p-px10 decorator-separator-left",
            key: title,
            style: style
          }, SearchFacets_jsx(Tag["a" /* Tag */], {
            "aria-controls": controlsId,
            "area-selected": String(isActive),
            badge: SearchFacets_jsx(TemplateString["a" /* TemplateString */], {
              staticClassName: "sr-only",
              template: count > 1 ? Object(src_i18n["h" /* t */])('common.selectedCriteriasLabel.n') : Object(src_i18n["h" /* t */])('common.selectedCriteriasLabel._1'),
              values: {
                count: count.toString()
              }
            }),
            closeLabel: "".concat(Object(src_i18n["h" /* t */])('faceting.reset'), " ").concat(title),
            id: itemId,
            label: title,
            onClick: onClick,
            onClose: function onClose() {
              return onClearFacets(id);
            },
            onKeyDown: onKeyDown,
            ref: setRef,
            role: "tab",
            tabIndex: tabIndex,
            trackingData: !isActive ? getActiveFacetTabTrackingData({
              facetId: dataLabel,
              isActive: isActive
            }) : null
          }));
        } : null,
        content: [SearchFacets_jsx(FacetCategory_FacetCategory, {
          templateConfig: templateConfig,
          facetsFromSearch: facets,
          onChange: changeFacet,
          activeFacets: activeFacets,
          key: id,
          name: id
        })]
      };
    });
  };

  var onActiveFacetTabChanged = function onActiveFacetTabChanged(index) {
    setSelectedFacetTab(selectedFacetTab === index ? -1 : index);
  };

  return SearchFacets_jsx(Tabs["a" /* Tabs */], {
    areAllCollapsable: true,
    className: "mb-px25",
    collapseIconName: icons["a" /* ICONS */].SELECT_UP,
    expandIconName: icons["a" /* ICONS */].SELECT,
    hasBackground: true,
    initialSelectedItem: selectedFacetTab,
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: getTabItems(),
    onSelect: onActiveFacetTabChanged,
    scrollBackwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    scrollForwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward'),
    theme: "clean"
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-facets/CriteriaFacets.jsx
var CriteriaFacets_jsx = react_default.a.createElement;







var CriteriaFacets_CriteriaFacets = function CriteriaFacets() {
  var dispatch = Object(es["d" /* useDispatch */])();
  var activeFacets = Object(es["e" /* useSelector */])(faceting_selector["a" /* activeFacetsSelector */]);
  var facets = Object(es["e" /* useSelector */])(faceting_selector["d" /* facetsSelector */]);

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0];

  return CriteriaFacets_jsx(SearchFacets_SearchFacets, {
    facets: facets,
    activeFacets: activeFacets,
    toggleFacet: function toggleFacet(_ref) {
      var categoryId = _ref.categoryId,
          isSelected = _ref.isSelected,
          value = _ref.value;
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(facetingSearch_action["o" /* toggleFacet */])({
        categoryId: categoryId,
        isSelected: isSelected,
        value: value
      }));
    },
    clearFacets: function clearFacets(categoryId) {
      dispatch(Object(facetingSearch_action["f" /* clearFacets */])(categoryId));
    },
    facetLabels: true,
    facetTemplateConfig: constants["r" /* FILTERABLE_FACETS_TEMPLATE_CONFIG */],
    facetTrackingConfig: constants["s" /* FILTERABLE_FACETS_TRACKING_CONFIG */]
  });
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("3voH");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/hooks/use-autocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__("aUQU");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx + 4 modules
var InputDatalist = __webpack_require__("wRBU");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-query/CriteriaQuery.jsx






var CriteriaQuery_jsx = react_default.a.createElement;




















var ItemLayout = function ItemLayout(_ref) {
  var label = _ref.label;

  if (!label) {
    return null;
  }

  return CriteriaQuery_jsx("div", {
    className: "focus:bg-turquoise hover:bg-turquoise cursor-pointer flex items-center overflow-hidden py-px15 focus:text-white hover:text-white transition-colors p-px10"
  }, CriteriaQuery_jsx("span", {
    className: "decorator-match font-sans text-sm truncate"
  }, label));
};

var ItemTitle = function ItemTitle(_ref2) {
  var title = _ref2.title;
  return CriteriaQuery_jsx("div", {
    className: "text-blue text-xs font-sans font-bold py-px10"
  }, title);
};

var edito = 'edito';
var CriteriaQuery_CriteriaQuery = function CriteriaQuery(props) {
  var _props$suggestedReque, _props$suggestedReque2, _props$suggestedReque3, _props$suggestedReque4;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageId = _useContext.pageId;

  var _useContext2 = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      isSeller = _useContext2.isSeller;

  var _useContext3 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext3[0];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var query = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.query;
  });
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      locale = _useRouter.location.queryParams.locale,
      history = _useRouter.history;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'search'
  });

  var _useAutocomplete = Object(useAutocomplete["a" /* useAutocomplete */])(keywords),
      setAutocompleteQuery = _useAutocomplete.setAutocompleteQuery,
      autocompleteResults = _useAutocomplete.autocompleteResults,
      setAutocompleteResults = _useAutocomplete.setAutocompleteResults;

  var value = query && query.label ? query.label : keywords;
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var hasSuggestedRequests = !!((_props$suggestedReque = props.suggestedRequests) === null || _props$suggestedReque === void 0 ? void 0 : (_props$suggestedReque2 = _props$suggestedReque.items) === null || _props$suggestedReque2 === void 0 ? void 0 : _props$suggestedReque2.length);
  return CriteriaQuery_jsx(InputDatalist["a" /* InputDatalist */], {
    dataList: value || isSeller ? autocompleteResults : (((_props$suggestedReque3 = props.suggestedRequests) === null || _props$suggestedReque3 === void 0 ? void 0 : _props$suggestedReque3.items) || []).map(function (_ref3) {
      var label = _ref3.label,
          link = _ref3.url;
      return {
        id: label,
        label: label,
        link: link
      };
    }),
    hasClear: true,
    hasValidationIcon: false,
    iconLeft: icons["a" /* ICONS */].SEARCH_GLASS,
    isAnimated: true,
    itemLayout: !value ? ItemLayout : undefined,
    itemTitle: !value && hasSuggestedRequests ? CriteriaQuery_jsx(ItemTitle, {
      title: (_props$suggestedReque4 = props.suggestedRequests) === null || _props$suggestedReque4 === void 0 ? void 0 : _props$suggestedReque4.title
    }) : undefined,
    onChange: function onChange(_, v) {
      var cleanKeywords = striptags_default()(v);
      dispatch(Object(searchQuery_action["a" /* setKeywords */])(cleanKeywords));
      setAutocompleteQuery(cleanKeywords);
      props.onQueryChange({
        label: cleanKeywords
      });
    },
    onClear: function onClear() {
      setAutocompleteResults([]);
      var emptyQuery = {
        label: ''
      };

      if (!keywords) {
        // User is clearing the search query
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(emptyQuery));
      }

      props.onQueryChange(emptyQuery);
      dispatch(Object(searchQuery_action["a" /* setKeywords */])(''));
      setAutocompleteQuery('');
    },
    onFocus: function onFocus() {
      if (!isSeller && !value && hasSuggestedRequests) {
        track({
          labelGA: 'requestsDisplay'
        });
      }
    },
    onSelect: function onSelect(_ref4) {
      var label = _ref4.label,
          _ref4$item = _ref4.item,
          type = _ref4$item.type,
          productType = _ref4$item.productType,
          link = _ref4$item.link;
      var isEdito = type === edito;

      if (value && !isEdito) {
        var searchQuery = {
          label: label,
          link: link,
          productType: productType,
          type: type
        };
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(searchQuery));
        dispatchCriteriaDisplayContext({
          type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaQuery',
            criteriaContext: criteriaContext
          }
        });
        props.onQueryChange(searchQuery);
      } else if (link) {
        var redirection = isEdito ? 'redirection_editorial' : 'redirection_suggestedRequest';
        var isSearchUrl = link.startsWith('/s');
        track({
          internalSearchEngineNbResults: isSearchUrl ? '' : redirection,
          labelGA: isEdito ? 'editorial' : 'suggestedRequest',
          searchReferrer: pageId,
          searchRequestType: 'Autocomplete',
          searchTerms: label
        });
        var url = locale ? new URI_default.a(link).addQuery({
          locale: locale
        }).toString() : link;
        history.pushRoute(url);

        if (!isSearchUrl) {
          trackSearchResults({
            internalSearchEngineNbResults: redirection,
            searchRequestType: 'Autocomplete',
            searchResorts: [],
            searchTerms: label
          });
        }
      }
    },
    placeholder: Object(src_i18n["h" /* t */])('faceting.searchTitle'),
    size: "large",
    value: value,
    validationState: value ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/CriteriaTransport.jsx
var CriteriaTransport = __webpack_require__("NWzG");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhen.jsx
var CriteriaWhen = __webpack_require__("Go22");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/CriteriaWho.jsx
var CriteriaWho = __webpack_require__("wKzQ");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx + 1 modules
var FilterWhen = __webpack_require__("qLhN");

// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria-modal/CriteriaModal.jsx
var CriteriaModal_jsx = react_default.a.createElement;










var CriteriaModal_CriteriaModal = function CriteriaModal(_ref) {
  var children = _ref.children,
      _onClose = _ref.onClose,
      onReset = _ref.onReset,
      onValidate = _ref.onValidate;

  var _useContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  var _useContext2 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext2[0];

  var buttons = CriteriaModal_jsx("div", {
    className: "relative p-px10 px-px25 lg:px-0 w-full flex items-center justify-between mt-auto bg-white".concat(isDesktop ? '' : ' shadow')
  }, CriteriaModal_jsx(Button["a" /* Button */], {
    theme: "link",
    onClick: function onClick() {
      onReset && onReset();
    },
    className: "text-sm cursor-pointer"
  }, Object(src_i18n["h" /* t */])('faceting.reset')), CriteriaModal_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    onClick: function onClick() {
      onValidate && onValidate();
    },
    className: "text-sm cursor-pointer"
  }, Object(src_i18n["h" /* t */])('faceting.validate')));

  var ariaLabel = Object(src_i18n["h" /* t */])('faceting.when.duration');
  var closeLabel = Object(src_i18n["h" /* t */])('common.close');

  var onCloseModal = function onCloseModal() {
    _onClose && _onClose();
  };

  return isDesktop ? CriteriaModal_jsx(Modal["a" /* Modal */], {
    ariaLabel: ariaLabel,
    className: "text-center px-px40 py-px20",
    closeLabel: closeLabel,
    onClose: function onClose() {
      _onClose && _onClose();
    },
    size: "small"
  }, children, buttons) : CriteriaModal_jsx(Layer["b" /* Layer */], {
    ariaLabel: ariaLabel,
    ariaLabelledby: identifiers_constants["v" /* ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL */],
    buttonLeft: {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: onCloseModal
    },
    closeLabel: closeLabel,
    hasAnimateEnter: true,
    header: CriteriaModal_jsx("div", {
      className: "text-center font-normal text-xl text-gray-darker",
      dangerouslySetInnerHTML: {
        __html: criteriaContext.layerHeader
      },
      id: identifiers_constants["v" /* ID_LAYER_HEADER__SHOPPING__CRITERIA_MODAL */]
    }),
    onClose: onCloseModal
  }, CriteriaModal_jsx("div", {
    className: "scroll-y",
    style: {
      height: 'calc(100% - 70px)'
    }
  }, children), buttons);
};
// CONCATENATED MODULE: ./src/client/components/widgets/criteria-modal/criteria-modal-when/CriteriaModalWhen.jsx
var CriteriaModalWhen_jsx = react_default.a.createElement;












var CriteriaModalWhen_CriteriaModalWhen = function CriteriaModalWhen(_ref) {
  var durationOptions = _ref.durationOptions,
      _onClose = _ref.onClose;

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);

  var _useState = Object(react["useState"])(departureDate),
      inputDepartureDate = _useState[0],
      setInputDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      inputDuration = _useState2[0],
      setInputDuration = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      validated = _useState3[0],
      setValidated = _useState3[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])();

  var persistDepartureDate = function persistDepartureDate() {
    var invalid = !(departureDate || moment_default.a.isMoment(inputDepartureDate) || moment_default()(inputDepartureDate).isValid());

    if (invalid) {
      return dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    }

    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(moment_default()(inputDepartureDate).valueOf()));
    setCriteriaContext({
      defaultValueForCalendar: departureDate
    });

    if (criteriaContext.trackingActionName) {
      track({
        actionGA: criteriaContext.trackingActionName,
        labelGA: "when_".concat(moment_default()(inputDepartureDate).format('DD/MM/YYYY'))
      });
    }
  };

  var persistDuration = function persistDuration() {
    var durationToPersist = inputDuration;

    if (!inputDuration && inputDepartureDate) {
      durationToPersist = duration_constants["b" /* DEFAULT_TRIP_DURATION */];
    }

    if (durationToPersist) {
      dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(durationToPersist));

      if (criteriaContext.trackingActionName) {
        var labelGA = "duration_".concat(durationToPersist);
        track({
          actionGA: criteriaContext.trackingActionName,
          labelGA: labelGA
        });
      }
    }
  };

  Object(react["useEffect"])(function () {
    if (validated) {
      _onClose();
    }
  }, [validated]);
  return CriteriaModalWhen_jsx(CriteriaModal_CriteriaModal, {
    onValidate: function onValidate() {
      if (inputDepartureDate && inputDuration) {
        persistDepartureDate();
        persistDuration();
        setValidated(true);
      }
    },
    onClose: function onClose() {
      _onClose();
    },
    onReset: function onReset() {
      setInputDuration(0);
      setInputDepartureDate(null);
    }
  }, CriteriaModalWhen_jsx(FilterWhen["a" /* FilterWhen */], {
    optionsDuration: durationOptions,
    changeTripDuration: function changeTripDuration(time) {
      setInputDuration(time);
    },
    changeDepartureDate: function changeDepartureDate(value) {
      setInputDepartureDate(moment_default()(value, moment_default.a.defaultFormat));
    },
    clearDepartureDate: function clearDepartureDate() {
      setInputDepartureDate(null);
    },
    clearTripDuration: function clearTripDuration() {
      setInputDuration(0);
    },
    duration: inputDuration,
    departureDate: inputDepartureDate,
    openCalendarToDate: criteriaContext.defaultValueForCalendar,
    dateFormat: Object(src_i18n["h" /* t */])('booking.form.dateFormat'),
    label: Object(src_i18n["h" /* t */])('faceting.compare.warningMessage'),
    isSubmittable: true
  }));
};
// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// EXTERNAL MODULE: ./node_modules/entities/index.js
var entities = __webpack_require__("4oK2");

// CONCATENATED MODULE: ./src/client/components/widgets/search-form/SearchForm.utils.js









var SearchForm_utils_getDepartureCitiesFromFacets = function getDepartureCitiesFromFacets(facets, placeholderLabel) {
  var departureCities = Object(facetingUtils["f" /* getDepartureCities */])(facets);

  if (departureCities.length === 0) {
    return [];
  }

  var options = placeholderLabel ? [{
    value: '',
    label: placeholderLabel
  }] : [];
  var noTransportOption = departureCities.find(function (city) {
    return city.value === departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  });

  if (noTransportOption) {
    var value = noTransportOption.value,
        label = noTransportOption.label;
    options.push({
      value: value,
      label: Object(entities["decodeHTML"])(label)
    });
  }

  var citiesOptions = departureCities.filter(function (city) {
    return city.value !== departure_city_constants["a" /* DEFAULT_DEPARTURE_CITY */];
  }).map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return {
      value: value,
      label: Object(entities["decodeHTML"])(label)
    };
  }).sort(function (a, b) {
    return a.value.localeCompare(b.value);
  });
  return [].concat(options, Object(toConsumableArray["a" /* default */])(citiesOptions));
};
// CONCATENATED MODULE: ./src/client/components/widgets/search-form/SearchForm.jsx




var SearchForm_jsx = react_default.a.createElement;


























var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

var SearchForm_SubmitButton = function SubmitButton(_ref) {
  var className = _ref.className,
      colorBg = _ref.colorBg,
      colorBorder = _ref.colorBorder;
  return SearchForm_jsx("div", {
    className: className
  }, SearchForm_jsx(Button["a" /* Button */], {
    className: "leading-none w-full",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colorBg,
    colorBorder: colorBorder,
    minWidth: "5.625rem",
    size: "large",
    type: "submit"
  }, SearchForm_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS
  })));
};

var SearchForm_SearchForm = function SearchForm(props) {
  var _props$i18n, _props$i18n$faceting, _props$i18n2, _props$i18n2$faceting, _props$i18n2$faceting2;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useContext = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 1),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0];

  var _useState = Object(react["useState"])(false),
      criteriaQueryIsJoyviewProduct = _useState[0],
      setCriteriaQueryIsJoyviewProduct = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      criteriaModalWhenIsOpen = _useState2[0],
      setCriteriaModalWhenIsOpen = _useState2[1];

  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    var _state$tripCriteria;

    return state === null || state === void 0 ? void 0 : (_state$tripCriteria = state.tripCriteria) === null || _state$tripCriteria === void 0 ? void 0 : _state$tripCriteria.departureDate;
  });
  var duration = Object(es["e" /* useSelector */])(function (state) {
    return Object(lodash["get"])(state, 'tripCriteria.duration', 0);
  });
  var facets = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["d" /* facetsSelector */])(state);
  });
  var resultsCount = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["e" /* filteredProductsCountSelector */])(state);
  });
  var isLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.isLoading;
  });
  var isProductComparisonSelectionModeEnabled = Object(es["e" /* useSelector */])(function (state) {
    var _state$faceting;

    return state === null || state === void 0 ? void 0 : (_state$faceting = state.faceting) === null || _state$faceting === void 0 ? void 0 : _state$faceting.isSelectionModeEnabled;
  });
  var joyviewOffsetSell = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.joyviewOffsetSell;
  });
  var resortOffsetSell = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.resortOffsetSell;
  });
  var offsetSell = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale) && criteriaQueryIsJoyviewProduct && joyviewOffsetSell > -1 ? joyviewOffsetSell : resortOffsetSell;
  var submitButtonColor = Object(localeUtils["a" /* isChineseLocale */])(appContext.locale) ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].SUCCESS;

  var getOptionsDuration = function getOptionsDuration() {
    var results = (facets.find(function (f) {
      return f.id === constants["o" /* DURATION_FACET */];
    }) || {
      list: []
    }).list;
    return results.map(function (opt) {
      return parseInt(opt.value, 10);
    }).sort(function (a, b) {
      return a < b ? -1 : 1;
    });
  };

  Object(react["useEffect"])(function () {
    setCriteriaContext({
      layerButtonLabel: props.layerButtonLabel,
      layerHeader: props.showNbResultsInLayer ? Object(src_i18n["h" /* t */])('faceting.viewResorts', {
        n: "<span class=\"font-bold text-blue\">".concat(resultsCount || 0, "</span>")
      }) : ''
    });
  }, [props.showNbResultsInLayer, resultsCount, props.layerButtonLabel]);
  Object(react["useEffect"])(function () {
    if (criteriaDisplayContext.criteriaWhenIsOpen || criteriaDisplayContext.criteriaTransportIsOpen) {
      dispatch(Object(facetingSearch_action["l" /* setIsSearchEnabled */])(true));
    }
  }, [criteriaDisplayContext.criteriaTransportIsOpen, criteriaDisplayContext.criteriaWhenIsOpen]);

  var updateTranslationKeys = function updateTranslationKeys() {
    Object(src_i18n["a" /* addTranslationKeys */])({
      common: Object(lodash["get"])(props, 'i18n.common'),
      booking: Object(lodash["get"])(props, 'i18n.booking'),
      faceting: Object(lodash["get"])(props, 'i18n.faceting')
    });
  };

  updateTranslationKeys();
  Object(react["useEffect"])(function () {
    updateTranslationKeys();
  }, [props.i18n]);
  Object(react["useEffect"])(function () {
    var dateIsMissing = !departureDate || !duration;

    if (isProductComparisonSelectionModeEnabled && dateIsMissing && !criteriaDisplayContext.criteriaWhenIsOpen && !criteriaModalWhenIsOpen) {
      setCriteriaModalWhenIsOpen(true);
    }
  }, [criteriaDisplayContext.criteriaWhenIsOpen, isProductComparisonSelectionModeEnabled, departureDate]);
  var departureCitiesOptions = SearchForm_utils_getDepartureCitiesFromFacets(facets, null);

  var onSubmit = function onSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    if (Object(lodash["isFunction"])(props.onSubmit)) {
      props.onSubmit(event);
    }
  };

  var onQueryChange = function onQueryChange(query) {
    setCriteriaQueryIsJoyviewProduct(query && query.productType === PRODUCT_TYPES.JOYVIEW);

    if (query && query.label && query.type) {
      return props.doTrackQueryChange && trackQueryChange(query);
    }
  };

  var onClose = function onClose() {
    setCriteriaModalWhenIsOpen(false);

    if (!departureDate && !duration) {
      dispatch(setProductComparisonSelectionMode(false));
    }
  };

  var durations = getOptionsDuration();
  return SearchForm_jsx("form", {
    className: "relative",
    onSubmit: onSubmit
  }, SearchForm_jsx(SiteContainer["a" /* SiteContainer */], null, SearchForm_jsx("div", {
    className: "bg-white border-1 border-gray-light lg:flex mb-px20 p-px5 rounded-small shadow-lg"
  }, props.withQuery && SearchForm_jsx("div", {
    className: "flex lg:flex-1 p-px5"
  }, SearchForm_jsx("div", {
    className: "flex-1",
    "data-testid": "search-form-criteria-query"
  }, SearchForm_jsx(CriteriaQuery_CriteriaQuery, {
    onQueryChange: onQueryChange,
    suggestedRequests: (_props$i18n = props.i18n) === null || _props$i18n === void 0 ? void 0 : (_props$i18n$faceting = _props$i18n.faceting) === null || _props$i18n$faceting === void 0 ? void 0 : _props$i18n$faceting.suggestedRequests
  })), SearchForm_jsx(SearchForm_SubmitButton, {
    className: "lg:hidden rtl:ml-px10",
    colorBg: submitButtonColor,
    colorBorder: submitButtonColor
  })), SearchForm_jsx("div", {
    className: "flex lg:flex-2"
  }, SearchForm_jsx("div", {
    className: "flex-none p-px5 w-1/3",
    "data-testid": "search-form-criteria-when"
  }, SearchForm_jsx(CriteriaWhen["a" /* CriteriaWhen */], {
    durationOptions: durations,
    offsetSell: offsetSell > -1 ? offsetSell : null,
    withFlexibility: true
  })), SearchForm_jsx("div", {
    className: "flex-none p-px5 w-1/3",
    "data-testid": "search-form-criteria-who"
  }, SearchForm_jsx(CriteriaWho["a" /* CriteriaWho */], null)), SearchForm_jsx("div", {
    className: "flex-none p-px5 w-1/3",
    "data-testid": "search-form-criteria-transport"
  }, SearchForm_jsx(CriteriaTransport["a" /* CriteriaTransport */], {
    departureCitiesOptions: departureCitiesOptions,
    isLoading: isLoading,
    reassurance: (_props$i18n2 = props.i18n) === null || _props$i18n2 === void 0 ? void 0 : (_props$i18n2$faceting = _props$i18n2.faceting) === null || _props$i18n2$faceting === void 0 ? void 0 : (_props$i18n2$faceting2 = _props$i18n2$faceting.transport) === null || _props$i18n2$faceting2 === void 0 ? void 0 : _props$i18n2$faceting2.reassurance
  }))), SearchForm_jsx(SearchForm_SubmitButton, {
    className: "lg:block hidden m-px5",
    colorBg: submitButtonColor,
    colorBorder: submitButtonColor
  }))), props.withFacets && SearchForm_jsx(CriteriaFacets_CriteriaFacets, null), criteriaModalWhenIsOpen && SearchForm_jsx(CriteriaModalWhen_CriteriaModalWhen, {
    durationOptions: durations,
    onClose: onClose
  }));
};
// EXTERNAL MODULE: ./src/routes/constants.js
var routes_constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/store/utils/autocompleteItemHelper.js
var autocompleteItemHelper = __webpack_require__("Qmkj");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// CONCATENATED MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx








var FacetSearch_jsx = react_default.a.createElement;




























var FacetSearch_FacetSearch = function FacetSearch(props) {
  var _props$shouldRedirect = props.shouldRedirectToResortPage,
      shouldRedirectToResortPage = _props$shouldRedirect === void 0 ? false : _props$shouldRedirect,
      _props$withSearchResu = props.withSearchResults,
      withSearchResults = _props$withSearchResu === void 0 ? false : _props$withSearchResu,
      resultsHasSeeMore = props.resultsHasSeeMore,
      resortGridProps = props.resortGridProps;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var routerEvents = useRouterEvents();
  var responsiveContext = Object(react["useContext"])(responsive_responsiveContext["a" /* default */]);

  var _useState = Object(react["useState"])(false),
      searchDone = _useState[0],
      setSearchDone = _useState[1];

  var _useState2 = Object(react["useState"])(resultsHasSeeMore),
      facetHasSeeMore = _useState2[0],
      setFacetHasSeeMore = _useState2[1];

  var dispatch = Object(es["d" /* useDispatch */])();
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var activeFacets = Object(es["e" /* useSelector */])(faceting_selector["a" /* activeFacetsSelector */]);
  var facetingCriteria = Object(es["e" /* useSelector */])(faceting_selector["c" /* facetingCriteriaSelector */]);
  var isLoading = Object(es["e" /* useSelector */])(function (_ref) {
    var faceting = _ref.faceting;
    return faceting.isLoading;
  });
  var noResults = Object(es["e" /* useSelector */])(function (_ref2) {
    var faceting = _ref2.faceting;
    return faceting.noResults;
  });
  var isSearchEnabled = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.isSearchEnabled;
  });
  var keywords = Object(es["e" /* useSelector */])(search_selector["a" /* keywordsSelector */]);
  var kids = Object(es["e" /* useSelector */])(storeHelper["c" /* getKids */]);
  var kidsValidationState = Object(es["e" /* useSelector */])(faceting_selector["k" /* getKidsValidationState */]);
  var products = Object(es["e" /* useSelector */])(function (state) {
    return Object(faceting_selector["g" /* filteredProductsSelector */])(state) || [];
  });
  var productIds = products.map(function (_ref3) {
    var resortId = _ref3.resortId;
    return resortId;
  }).join('|');
  var query = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.query || {};
  });
  var redirection = Object(es["e" /* useSelector */])(function (state) {
    return state.faceting.redirection;
  });
  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);
  var trackQueryChange = Object(useTrackQueryChange["a" /* useTrackQueryChange */])();
  var trackSearchResults = Object(useTrackSearchResults["a" /* useTrackSearchResults */])();
  var searchCriteria = {
    departureCity: departureCity,
    departureDate: departureDate,
    duration: duration,
    keywords: keywords,
    kids: kids,
    kidsValidationState: kidsValidationState,
    query: query
  };
  var searchOptions = Object(react["useMemo"])(function () {
    var _props$offer, _props$offer2;

    return {
      boutique: props.boutique,
      offerId: (_props$offer = props.offer) === null || _props$offer === void 0 ? void 0 : _props$offer.id,
      offerName: (_props$offer2 = props.offer) === null || _props$offer2 === void 0 ? void 0 : _props$offer2.seoName,
      productIds: (props.initialProducts || []).map(function (product) {
        return product.id;
      }),
      query: query.label || '',
      screenSize: responsiveContext.currentBreakpoint
    };
  }, [props.boutique, props.initialProducts, props.offer, props.i18n, query, responsiveContext.currentBreakpoint]);

  var search = function search() {
    // We check routerReady to ensure that we do not update URL
    // or results while the router is transitioning between routes.
    if (isSearchEnabled) {
      if (props.shouldPersistCriteriaInUrl && !routerEvents.transitioning) {
        var activeFacetsQueries = Object(facetingUtils["c" /* generateActiveFacetsQueries */])(activeFacets);
        Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
          activeFacetsQueries: activeFacetsQueries,
          criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
          location: location,
          searchCriteria: searchCriteria,
          searchPageRouteName: props.searchPageRouteName
        });
      }

      dispatch(facetingSearchRequest({
        appContext: appContext,
        options: searchOptions
      }));
      setSearchDone(true);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(facetingLoadOffsetSellRequest({
      appContext: appContext
    }));
  }, []);
  Object(react["useEffect"])(function () {
    if (typeof products !== 'undefined' && pageContext.pageId === routes_constants["C" /* SEARCH_PAGE_ID */] && withSearchResults && isLoading === false && searchDone) {
      trackSearchResults();
    }
  }, [productIds, isLoading]);
  Object(react["useEffect"])(function () {
    var _props$i18n$remote, _props$i18n$remote$no, _props$i18n$remote$no2, _props$i18n$remote$no3;

    if (!isLoading && noResults && ((_props$i18n$remote = props.i18n.remote) === null || _props$i18n$remote === void 0 ? void 0 : (_props$i18n$remote$no = _props$i18n$remote.noResult) === null || _props$i18n$remote$no === void 0 ? void 0 : (_props$i18n$remote$no2 = _props$i18n$remote$no.recommendation) === null || _props$i18n$remote$no2 === void 0 ? void 0 : (_props$i18n$remote$no3 = _props$i18n$remote$no2.resortIds) === null || _props$i18n$remote$no3 === void 0 ? void 0 : _props$i18n$remote$no3.length) > 0) {
      dispatch(facetingLoadProductsRequest({
        appContext: appContext,
        productIds: props.i18n.remote.noResult.recommendation.resortIds
      }));
    }
  }, [products]);

  var cleanSearch = /*#__PURE__*/function () {
    var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(Object(facetingSearch_action["j" /* resetSearch */])()));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function cleanSearch() {
      return _ref4.apply(this, arguments);
    };
  }();

  var cleanCriteria = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch(Object(facetingSearch_action["h" /* resetCriteria */])()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function cleanCriteria() {
      return _ref5.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    dispatch(setProductComparisonSelectionMode(false));
    var _props$initialIsSearc = props.initialIsSearchEnabled,
        initialIsSearchEnabled = _props$initialIsSearc === void 0 ? false : _props$initialIsSearc;

    if (!Object(FacetSearch_utils["b" /* currentUrlContainsSearchQueryParam */])(location)) {
      // We always want to reset the search query, unless it's in the URL.
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])({
        label: ''
      }));
    } // useEffect cannot be async because it's supposed to return a cleaning callback.
    // This immediatly invoked function is a workaround to this.


    Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(Object(FacetSearch_utils["c" /* currentUrlHasNoQueryParams */])(location) && props.resetSearchAtMount)) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return cleanSearch();

            case 3:
              _context3.next = 5;
              return cleanCriteria();

            case 5:
              if (departureCity) {
                // If transport is set in store, we need to trigger
                // the search request to get the departureCities facet from Pertimm.
                dispatch(Object(facetingSearch_action["l" /* setIsSearchEnabled */])(true));
              } else {
                dispatch(Object(facetingSearch_action["l" /* setIsSearchEnabled */])(initialIsSearchEnabled));
              }

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();

    return function () {
      cleanSearch();
    };
  }, []);
  Object(react["useEffect"])(function () {
    // In case PERTIMM response indicates a redirection, go to this page...
    if (redirection) {
      dispatch(Object(globalLoader_action["d" /* startLoading */])());
      redirectUtils["a" /* default */].redirectTo()(dist["url"].normalizeUrl(redirection), {
        replace: true,
        shallow: false
      });
      return function () {
        // clear search query to avoid infinite loop on back #14970
        dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])({
          label: ''
        }));
        dispatch(Object(facetingSearch_action["i" /* resetRedirection */])());
      };
    }
  }, [redirection]);
  var filtersKeysToIgnore = [constants["l" /* DEPARTURE_DATE_MAX_FACET_ID */], constants["m" /* DEPARTURE_DATE_MIN_FACET_ID */], constants["o" /* DURATION_FACET */], constants["B" /* PRODUCT_FACET_ID */]];
  Object(react["useEffect"])(function () {
    search();
  }, [JSON.stringify(kids), JSON.stringify(query), isSearchEnabled, departureDate, duration, JSON.stringify((facetingCriteria.filters || []).filter(function (facet) {
    return !filtersKeysToIgnore.includes(facet.id);
  })), props.offer, flexibility]);

  var onSubmit = function onSubmit(event) {
    var searchPageRouteName = props.searchPageRouteName;

    if (event) {
      event.preventDefault();
    }

    var searchQuery = keywords ? {
      label: keywords
    } : query;

    if (keywords) {
      dispatch(Object(facetingSearch_action["c" /* changeSearchQuery */])(searchQuery));
    }

    if (!keywords && shouldRedirectToResortPage && searchQuery.type === autocompleteItemHelper["a" /* RESORT_PRODUCT_TYPE */]) {
      trackQueryChange(searchQuery, {
        internalSearchEngineNbResults: 'redirection'
      });
      trackSearchResults({
        internalSearchEngineNbResults: 'redirection',
        searchResorts: []
      });
      Object(FacetSearch_utils["e" /* navigateToResortPage */])({
        location: location,
        query: searchQuery,
        searchCriteria: searchCriteria
      });
    } else {
      if (!withSearchResults) {
        trackQueryChange(searchQuery);
        cleanSearch();
      }

      Object(FacetSearch_utils["f" /* navigateToSearchPage */])({
        criteriaKeysToPersist: FacetSearch_utils["a" /* FACET_QUERY_PARAMS */],
        location: location,
        searchCriteria: searchCriteria,
        searchPageRouteName: searchPageRouteName
      });
    }
  };

  return FacetSearch_jsx("div", {
    "data-testid": "facetSearch",
    className: "relative z-3"
  }, FacetSearch_jsx(CriteriaContext["b" /* CriteriaContextProvider */], {
    value: {
      trackingActionName: 'smartCriterias',
      setFacetHasSeeMore: setFacetHasSeeMore
    }
  }, FacetSearch_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, props.withSearchForm && FacetSearch_jsx(SearchForm_SearchForm, {
    doTrackQueryChange: withSearchResults,
    i18n: props.i18n,
    onSubmit: onSubmit,
    withFacets: props.withSearchFacets,
    withQuery: !props.hideSearchInput,
    showNbResultsInLayer: props.withSearchResults,
    layerButtonLabel: props.withSearchResults ? props.i18n.remote && props.i18n.remote.searchAction || 'search' : props.i18n.booking.editCriteria.validateCriteria
  }), props.withSearchResults && FacetSearch_jsx(FacetSearchResults_FacetSearchResults, {
    resortGridProps: resortGridProps,
    i18n: props.i18n,
    initialProducts: props.initialProducts,
    isProductComparisonModeAuthorized: props.isProductComparisonModeAuthorized,
    offer: props.offer,
    resultsHasSeeMore: facetHasSeeMore,
    resultsSeeMore: props.resultsSeeMore,
    isSynchronousGrid: props.isSynchronousGrid,
    searchOptions: searchOptions,
    shouldSetDefaultDepartureCityOnCompare: props.shouldSetDefaultDepartureCityOnCompare,
    virtualizedGrid: props.virtualizedGrid,
    sortByPriceAscending: props.sortByPriceAscending
  }))));
};

/***/ }),

/***/ "op+c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HeadManagerContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("ERkP"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HeadManagerContext = /*#__PURE__*/_react.default.createContext({});

exports.HeadManagerContext = HeadManagerContext;

if (false) {}

/***/ }),

/***/ "oweP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useFocusInside */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("aWzz");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("R6jJ");
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("s5tn");
/* harmony import */ var _medium__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("7LZv");






var useFocusInside = function useFocusInside(observedRef) {
  react__WEBPACK_IMPORTED_MODULE_1__["useEffect"](function () {
    var enabled = true;
    _medium__WEBPACK_IMPORTED_MODULE_5__[/* mediumEffect */ "b"].useMedium(function (car) {
      var observed = observedRef && observedRef.current;

      if (enabled && observed) {
        if (!car.focusInside(observed)) {
          car.moveFocusInside(observed, null);
        }
      }
    });
    return function () {
      enabled = false;
    };
  }, [observedRef]);
};

function MoveFocusInside(_ref) {
  var isDisabled = _ref.disabled,
      className = _ref.className,
      children = _ref.children;
  var ref = react__WEBPACK_IMPORTED_MODULE_1__["useRef"](null);
  useFocusInside(isDisabled ? undefined : ref);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__["createElement"]("div", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, Object(_util__WEBPACK_IMPORTED_MODULE_4__[/* inlineProp */ "b"])(focus_lock_constants__WEBPACK_IMPORTED_MODULE_3__[/* FOCUS_AUTO */ "b"], !isDisabled), {
    ref: ref,
    className: className
  }), children);
}

MoveFocusInside.propTypes =  false ? undefined : {};
MoveFocusInside.defaultProps = {
  disabled: false,
  className: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (MoveFocusInside);

/***/ }),

/***/ "p1C/":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "p7XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ SidePanel_SidePanel; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__("pKEY");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-on/dist/es2015/Combination.js + 10 modules
var Combination = __webpack_require__("Qt1m");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-focus-lock/dist/es2015/AutoFocusInside.js
var AutoFocusInside = __webpack_require__("JPie");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/body-locker/BodyLocker.jsx
var BodyLocker = __webpack_require__("DHMe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.jsx
var Portal = __webpack_require__("3uBn");

// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.themes.js
var themes = {
  "default": {
    thRoot: 'bg-white',
    thCloseButton: 'reset-button bg-white cursor-pointer leading-none m-px20 p-px15 rounded-full text-gray-darker text-md',
    thCloseButtonLabel: 'sr-only'
  }
};
var POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'bottom-0 rtl:right-0 rtl:slideInRight'
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-100',
    style: {
      maxHeight: 'calc(100% - 100px)'
    },
    button: 'top-0 rtl:right-0 rtl:slideInRight'
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 right-0'
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-100',
    style: {
      maxWidth: 'calc(100vw - 100px)'
    },
    button: 'top-0 left-0'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var SidePanel_SidePanel = function SidePanel(_ref) {
  var _classnames;

  var ariaLabel = _ref.ariaLabel,
      ariaLabelledby = _ref.ariaLabelledby,
      _ref$backdropColor = _ref.backdropColor,
      backdropColor = _ref$backdropColor === void 0 ? '#000' : _ref$backdropColor,
      _ref$backdropOpacity = _ref.backdropOpacity,
      backdropOpacity = _ref$backdropOpacity === void 0 ? 0.8 : _ref$backdropOpacity,
      children = _ref.children,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      height = _ref.height,
      isExpanded = _ref.isExpanded,
      onClose = _ref.onClose,
      _ref$portalName = _ref.portalName,
      portalName = _ref$portalName === void 0 ? Portal_constants["d" /* OVER_BOT */] : _ref$portalName,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom' : _ref$position,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var sidePanelBodyref = Object(react["useRef"])();
  var onScroll = Object(lodash["throttle"])(function () {
    Object(lib["forceCheck"])();
  }, 250);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      sidePanelBodyref && sidePanelBodyref.current && sidePanelBodyref.current.removeEventListener('scroll', onScroll);
    };
  }, []);
  Object(react["useEffect"])(function () {
    if (isExpanded) {
      Object(lib["forceCheck"])();
    }
  }, [isExpanded]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var _themes$theme = themes[theme],
      thCloseButton = _themes$theme.thCloseButton,
      thCloseButtonLabel = _themes$theme.thCloseButtonLabel,
      thRoot = _themes$theme.thRoot;
  var positionClasses = POSITIONS_CLASSES[position];
  var closeBtnSidePanel = closeLabel && ariaLabel ? [closeLabel, ariaLabel].join(' ') : closeLabel;
  return __jsx(Portal["a" /* default */], {
    name: portalName
  }, __jsx(BodyLocker["a" /* BodyLocker */], {
    isLocked: isExpanded
  }, isExpanded && __jsx("div", {
    className: "fadeIn fixed h-screen inset-0",
    "data-testid": "SidePanel-backdrop",
    style: {
      backgroundColor: backdropColor,
      opacity: backdropOpacity
    }
  }), __jsx("div", {
    "aria-hidden": !isExpanded,
    "aria-label": ariaLabelledby ? null : ariaLabel,
    "aria-labelledby": ariaLabelledby,
    role: "dialog"
  }, __jsx("div", {
    role: "document"
  }, __jsx(Combination["a" /* FocusOn */], {
    allowPinchZoom: true,
    enabled: isExpanded,
    onClickOutside: onClose,
    onEscapeKey: onClose
  }, isExpanded && __jsx(AutoFocusInside["a" /* default */], null, __jsx("button", {
    className: classnames_default()('fixed z-2', thCloseButton, positionClasses.button),
    onClick: onClose,
    type: "button"
  }, closeBtnSidePanel && __jsx("span", {
    className: thCloseButtonLabel
  }, closeBtnSidePanel), __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  }))), __jsx("aside", {
    className: classnames_default()(className, thRoot, positionClasses.pin, 'fixed h-full overflow-y-scroll transition-all w-full z-1', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, positionClasses.transform, !isExpanded), Object(defineProperty["a" /* default */])(_classnames, 'translate-0', isExpanded), _classnames)),
    ref: sidePanelBodyref,
    style: _objectSpread({
      height: height
    }, positionClasses.style)
  }, isExpanded && children))))));
};

/***/ }),

/***/ "pIL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return immersiveResolver; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("JtPf");
/* harmony import */ var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("4VTZ");














function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var immersiveResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_13__[/* IMMERSIVE */ "r"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.mark(function _callee(appContext, props) {
      var displaySearch, query;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_10___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              displaySearch = props.displaySearch;
              query = "query {\n      config {\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_16__[/* searchRemote */ "g"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_16__[/* resort */ "e"](appContext), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_16__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_16__[/* faceting */ "b"](), "\n      }\n    }");

              if (!displaySearch) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* LINE_COMMON_IMMERSIVE */ "Ab"]
              }).then(function (data) {
                return _objectSpread({}, data);
              }));

            case 4:
              return _context.abrupt("return", Promise.resolve({}));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "pNXd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Introduction_Introduction; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__("uFXj");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.themes.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaultTheme = {
  thRoot: 'overflow-hidden sm:flex -mx-px10',
  thLeft: 'flex-1 px-px10',
  thRight: 'flex-1 mt-px20 sm:mt-0 px-px10',
  thTitleTheme: 'title-brand-10',
  thSmall: 'lowercase text-base rtl:ml-px5',
  thSubtitle: 'mt-px10',
  thSubtitleTheme: 'title-sans-11'
};
var themes = {
  "default": defaultTheme,
  fancy: _objectSpread(_objectSpread({}, defaultTheme), {}, {
    thTitleTheme: 'title-serif-5'
  }),
  column: {
    thRoot: 'overflow-hidden -mx-px10',
    thLeft: 'px-px10 flex justify-center',
    thRight: 'px-px10 mt-px20',
    thTitleTheme: 'title-brand-8',
    thSmall: 'lowercase text-base rtl:ml-px5',
    thSubtitle: 'text-md leading-normal',
    thSubtitleTheme: 'none'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx

var __jsx = react_default.a.createElement;





var Introduction_Introduction = function Introduction(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      iconName = _ref.iconName,
      isTextSeeMoreCollapseEnabled = _ref.isTextSeeMoreCollapseEnabled,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel,
      small = _ref.small,
      subtitle = _ref.subtitle,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      title = _ref.title;
  var hasHeading = !!title || !!subtitle;
  var hasText = !!text;

  if (!hasHeading && !hasText) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLeft = _themes$theme.thLeft,
      thRight = _themes$theme.thRight,
      thRoot = _themes$theme.thRoot,
      thSmall = _themes$theme.thSmall,
      thSubtitle = _themes$theme.thSubtitle,
      thSubtitleTheme = _themes$theme.thSubtitleTheme,
      thTitleTheme = _themes$theme.thTitleTheme;
  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    "data-testid": dataTestId
  }, hasHeading && __jsx("div", {
    className: thLeft
  }, __jsx(Title["a" /* Title */], {
    hLevel: 2,
    iconName: iconName,
    theme: thTitleTheme
  }, title, !!small && __jsx("small", {
    className: thSmall
  }, small)), __jsx(Title["a" /* Title */], {
    className: thSubtitle,
    hLevel: 3,
    theme: thSubtitleTheme
  }, subtitle)), hasText && __jsx("div", {
    className: thRight
  }, __jsx(TextSeeMore["a" /* TextSeeMore */], {
    isCollapseEnabled: isTextSeeMoreCollapseEnabled,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    text: text
  })));
};

/***/ }),

/***/ "pP7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_CMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setCms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_BOOKING_ENGINE_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBookingEngineI18n; });
/* harmony import */ var _views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9LZ4");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");


var SET_CMS = 'SET_CMS';
var setCms = function setCms(config, legalInformations) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SET_CMS, {
    config: config,
    legalInformations: legalInformations
  });
};
var GET_BOOKING_ENGINE_I18N = 'GET_BOOKING_ENGINE_I18N';
var getBookingEngineI18n = function getBookingEngineI18n(appContext) {
  return function (dispatch) {
    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(GET_BOOKING_ENGINE_I18N, {}, {
      promise: Object(_views_booking_BookingEngineI18n_query__WEBPACK_IMPORTED_MODULE_0__[/* fetchBookingEngineI18nQuery */ "a"])(appContext)
    }));
  };
};

/***/ }),

/***/ "pSQP":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "pUua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tourProgramResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var tourProgramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* TOUR_PROGRAM */ "Ib"],
  resolve: function resolve(appContext, props) {
    var productId = props.resortId,
        yourItinerary = props.yourItinerary,
        tourDurationPlaceholder = props.tourDurationPlaceholder,
        tourDayPlaceholder = props.tourDayPlaceholder,
        yourExtension = props.yourExtension,
        extensionDurationPlaceholder = props.extensionDurationPlaceholder,
        extensionDayPlaceholder = props.extensionDayPlaceholder;
    var query = "query {\n      stopover(productId:\"".concat(productId, "\"){\n        tour{\n          title(message:\"").concat(yourItinerary, "\")\n          duration(message:\"").concat(tourDurationPlaceholder, "\")\n          stops{\n            day(message:\"").concat(tourDayPlaceholder, "\")\n            title\n            description\n          }\n        }\n        extension{\n          title(message:\"").concat(yourExtension, "\")\n          duration(message:\"").concat(extensionDurationPlaceholder, "\")\n          stops{\n            day(message:\"").concat(extensionDayPlaceholder, "\")\n            title\n            description\n          }\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_TOUR_PROGRAM */ "Ec"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "pfAP":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1YFU");
var isSymbol = __webpack_require__("km0D");
var getMethod = __webpack_require__("Uey1");
var ordinaryToPrimitive = __webpack_require__("ZoVA");
var wellKnownSymbol = __webpack_require__("nJrx");

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = exoticToPrim.call(input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "psNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BRAND_PROMISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUNTRY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COUNTRY_INFOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COUNTRY_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COUNTRY_POI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CRISIS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CRUISE_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CRUISE_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DOWNLOAD_LINKS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EDITORIAL_FOLDING_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EVENT_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EVENT_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUTTON_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INSTAGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return INSTAGRAM_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LAST_SEEN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MEDIA_TEXT_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MEDIA_TEXT_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MEDIA_THUMBNAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MUST_TRY_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NAVIGATION_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NAVIGATION_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return OFFER_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return OFFER_LEGAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return OFFER_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return OFFERS_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return OFFERS_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PAGE_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PREBOOKING_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PRODUCT_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PRODUCT_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PRODUCT_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PRODUCT_COMMUNITY_QUESTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PRODUCT_EXCLUSIVE_COLLECTION_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_IMAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PRODUCT_IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PRODUCT_INFORMATION_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PRODUCT_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PRODUCT_SIGNATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PRODUCT_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PRODUCT_STREET_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PRODUCT_STRENGTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return PRODUCT_WELLNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PRODUCTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PRODUCT_PRICE_TICKET_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return PRODUCT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return QUOTATION_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return RELATED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return RESORT_ACCESS_AND_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return RESORT_ACCOMMODATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return RESORT_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return RESORT_BOOKING_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return RESORT_DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return RESORT_FLASH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return RESORT_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return RESORT_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return RESORT_MEETING_ROOM_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return RESORT_MULTIMEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return RESORT_PRICE_REMOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return RESORT_PRICE_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return RESORT_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return RESORT_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return RESORT_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return RESORT_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return RESORT_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return RESORT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return RESORT_TRIPADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return SMART_FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return SUBMISSION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return TEASER_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return TEST_AB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return THEMATIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return TITLE_AND_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return TRAVEL_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return TOUR_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return TOUR_PRACTICAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return TOUR_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Kb", function() { return TRIPADVISOR_TESTIMONY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Lb", function() { return VIDEO; });
var ALL_INCLUSIVE_PUSH = 'all-inclusive-push';
var BRAND_PROMISE = 'brand-promise';
var CHECKLIST = 'checklist';
var COUNTRY_EVENTS = 'country-events';
var COUNTRY_INFOS = 'country-infos';
var COUNTRY_INTRODUCTION = 'country-introduction';
var COUNTRY_POI = 'country-poi';
var CRISIS_ALERT = 'crisis-alert';
var CRUISE_BOOKING = 'cruise-booking';
var CRUISE_PROGRAM = 'cruise-program';
var DESTINATIONS = 'destinations';
var DOWNLOAD_LINKS_LIST = 'download-links-list';
var EDITORIAL_FOLDING_BLOCK = 'editorial-folding-block';
var EVENT_ANIMATION = 'event-animation';
var EVENT_FORM = 'event-form';
var BUTTON_TICKET = 'button-ticket';
var HIGHLIGHT = 'highlight';
var IMMERSIVE = 'immersive';
var INSTAGRAM = 'instagram';
var INSTAGRAM_GRID = 'instagram-grid';
var LAST_SEEN_PRODUCTS = 'last-seen-products';
var MEDIA_TEXT_HORIZONTAL = 'media-text-horizontal';
var MEDIA_TEXT_VERTICAL = 'media-text-vertical';
var MEDIA_THUMBNAIL = 'media-thumbnail';
var MUST_TRY_EXPERIENCES = 'must-try-experiences';
var NAVIGATION_TAB = 'navigation-tab';
var NAVIGATION_TABS = 'navigation-tabs';
var OFFER_DESCRIPTION = 'offer-description';
var OFFER_LEGAL_INFORMATION = 'offer-legal-information';
var OFFER_SEO = 'offer-seo';
var OFFERS_GRID = 'offers-grid';
var OFFERS_PUSH = 'offers-push';
var PAGE_TRACKING = 'page-tracking';
var PREBOOKING_FORM = 'prebooking-form';
var PRODUCT_ACTIVITIES = 'product-activities';
var PRODUCT_BREADCRUMB = 'product-breadcrumb';
var PRODUCT_CHILDCARES = 'product-childcares';
var PRODUCT_COMMUNITY_QUESTIONS = 'product-community-questions';
var PRODUCT_EXCLUSIVE_COLLECTION_SPACE = 'product-exclusive-collection-space';
var PRODUCT_IMAGE_MAP = 'product-image-map';
var PRODUCT_IMMERSIVE = 'product-immersive';
var PRODUCT_INFORMATION_SUMMARY = 'product-information-summary';
var PRODUCT_SERVICES = 'product-services';
var PRODUCT_SIGNATURES = 'product-signatures';
var PRODUCT_SPACE_INTRODUCTION = 'product-space-introduction';
var PRODUCT_STREET_VIEW = 'product-street-view';
var PRODUCT_STRENGTHS = 'product-strengths';
var PRODUCT_WELLNESS = 'product-wellness';
var PRODUCTS_FILTERS = 'products-filters';
var PRODUCT_PRICE_TICKET_CUSTOM = 'product-price-ticket-custom';
var PRODUCT_TAGS = 'product-tags';
var QUOTATION_FORM = 'quotation-form';
var RELATED_PRODUCTS = 'related-products';
var RESORT_ACCESS_AND_MAP = 'resort-access-and-map';
var RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION = 'resort-accommodation-exclusivecollection';
var RESORT_ACCOMMODATION_TYPES = 'resort-accommodationTypes';
var RESORT_BARS = 'resort-bars';
var RESORT_BOOKING_BE = 'resort-bookingBE';
var RESORT_DESTINATION = 'resort-destination';
var RESORT_FLASH_INFO = 'resort-flash-info';
var RESORT_GRID = 'resort-grid';
var RESORT_INTRODUCTION = 'resort-introduction';
var RESORT_MEETING_ROOM_INFO = 'resort-meeting-room-info';
var RESORT_MULTIMEDIA = 'resort-multimedia';
var RESORT_PRICE_REMOTE = 'resort-price-remote';
var RESORT_PRICE_TICKET = 'resort-price-ticket';
var RESORT_RECOMMENDATIONS = 'resort-recommendations';
var RESORT_RESTAURANTS = 'resort-restaurants';
var RESORT_SEO = 'resort-seo';
var RESORT_SPACE_INTRODUCTION = 'resort-space-introduction';
var RESORT_SUMMARY = 'resort-summary';
var RESORT_TAGS = 'product-tags';
var RESORT_TRIPADVISOR = 'resort-tripadvisor';
var SECTION = 'section';
var SECTIONS = 'sections';
var SMART_FAQ = 'smart-faq';
var SUBMISSION_STATUS = 'submission-status';
var TAB = 'tab';
var TABS = 'tabs';
var TEASER_CARDS = 'teaser-cards';
var TEST_AB = 'test-ab';
var TEXT = 'text';
var THEMATIC = 'thematic';
var TITLE_AND_TEXT = 'title-and-text';
var TRAVEL_RESTRICTIONS = 'travel-restrictions';
var TOUR_INTRODUCTION = 'tour-introduction';
var TOUR_PRACTICAL_INFORMATION = 'tour-practical-information';
var TOUR_PROGRAM = 'tour-program';
var TRIPADVISOR_TESTIMONY = 'tripadvisor-testimony';
var VIDEO = 'video';

/***/ }),

/***/ "pteD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ TripDatePicker_TripDatePicker; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-day-picker/DayPicker.js
var DayPicker = __webpack_require__("nFOY");
var DayPicker_default = /*#__PURE__*/__webpack_require__.n(DayPicker);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var apiDate = __webpack_require__("ldK3");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/datepicker/Datepicker.utils.js
var Datepicker_utils = __webpack_require__("szYs");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/DatepickerArrow.jsx
var __jsx = react_default.a.createElement;







var DatepickerArrow_DatepickerArrow = function DatepickerArrow(_ref) {
  var className = _ref.className,
      fromMonth = _ref.fromMonth,
      locale = _ref.locale,
      month = _ref.month,
      _ref$onPrevious = _ref.onPrevious,
      onPrevious = _ref$onPrevious === void 0 ? lodash["noop"] : _ref$onPrevious,
      _ref$onNext = _ref.onNext,
      onNext = _ref$onNext === void 0 ? lodash["noop"] : _ref$onNext,
      toMonth = _ref.toMonth;
  return __jsx("div", {
    className: className
  }, !DayPicker["DateUtils"].isSameMonth(month, fromMonth) ? __jsx("button", {
    className: "reset-button",
    "data-testid": "datepicker-arrow-prev",
    onClick: function onClick() {
      return onPrevious();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.625rem"
  })) : __jsx("div", {
    style: {
      width: 30,
      height: 30
    }
  }), __jsx("span", {
    className: "flex-1"
  }, Object(Datepicker_utils["formatMonthTitle"])(month, locale)), !DayPicker["DateUtils"].isSameMonth(month, toMonth) ? __jsx("button", {
    className: "reset-button",
    "data-testid": "datepicker-arrow-next",
    onClick: function onClick() {
      return onNext();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, __jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })) : __jsx("div", {
    style: {
      width: 30,
      height: 30
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/DatepickerCaption.jsx
var DatepickerCaption_jsx = react_default.a.createElement;





var DatepickerCaption_DatepickerCaption = function DatepickerCaption(_ref) {
  var className = _ref.className,
      _ref$date = _ref.date,
      date = _ref$date === void 0 ? new Date() : _ref$date,
      fromMonth = _ref.fromMonth,
      hasNavigationByYear = _ref.hasNavigationByYear,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious,
      toMonth = _ref.toMonth;

  if (!hasNavigationByYear) {
    return null;
  }

  var currentYear = date.getFullYear();
  var fromYear = fromMonth.getFullYear();
  var toYear = toMonth.getFullYear();
  return DatepickerCaption_jsx("div", {
    className: classnames_default()(className, 'flex items-center justify-between')
  }, currentYear > fromYear && DatepickerCaption_jsx("button", {
    className: "reset-button",
    onClick: function onClick() {
      return onPrevious();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, DatepickerCaption_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    rotation: 180,
    width: "0.625rem"
  })), DatepickerCaption_jsx("span", {
    className: "flex-1"
  }, date.getFullYear(), " "), currentYear < toYear && DatepickerCaption_jsx("button", {
    className: "reset-button",
    onClick: function onClick() {
      return onNext();
    },
    style: {
      width: 30,
      height: 30
    },
    type: "button"
  }, DatepickerCaption_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/Datepicker.themes.js
var Datepicker_themes_themes = {
  "default": {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'relative sm:bg-white sm:rounded',
      // The container element
      wrapper: '',
      // The wrapper element, used for keyboard interaction
      interactionDisabled: '',
      // Added to the container when there's no interaction with the calendar
      navBar: 'flex items-center justify-between pb-px10',
      // The navigation bar with the arrows to switch between months
      navButtonPrev: '',
      // Button to switch to the previous month
      navButtonNext: '',
      // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default',
      // Added to the navbuttons when disabled with fromMonth/toMonth props
      months: 'flex -m-px10',
      // Container of the months table
      month: 'flex-1 p-px10',
      // The month's main table
      caption: 'font-bold mb-px20 text-center text-md text-gray-darker',
      // The caption element, containing the current month's name and year
      weekdays: '',
      // Table header displaying the weekdays names
      weekdaysRow: 'flex',
      // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase',
      // Cell displaying the weekday name
      body: 'body border-l border-b border-gray-light',
      // Table's body with the weeks
      week: 'flex',
      // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center md:h-25 h-13 p-px5 text-base text-center transition-all border-t border-r border-gray-light',
      // The single day cell
      footer: 'mt-px10',
      // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button',
      // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline',
      // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-30 opacity-100 Datepicker-selected',
      // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium',
      // Added to the day's cell specified in the "disabledDays" prop
      outside: 'text-gray-light' // Added to the day's cell outside the current month

    },
    thDayStart: 'thDayStart bg-emerald-active text-white',
    thDayEnd: 'thDayEnd bg-emerald-active text-white',
    thDayMiddle: 'thDayMiddle bg-emerald text-white'
  },
  compact: {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'overflow-hidden relative sm:bg-white sm:rounded',
      // The container element
      wrapper: '',
      // The wrapper element, used for keyboard interaction
      interactionDisabled: '',
      // Added to the container when there's no interaction with the calendar
      navBar: 'flex items-center justify-between pb-px10',
      // The navigation bar with the arrows to switch between months
      navButtonPrev: '',
      // Button to switch to the previous month
      navButtonNext: '',
      // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default',
      // Added to the navbuttons when disabled with fromMonth/toMonth props
      months: 'flex -m-px10',
      // Container of the months table
      month: 'flex-1 p-px10',
      // The month's main table
      caption: 'font-bold mb-px20 text-center text-md text-gray-darker',
      // The caption element, containing the current month's name and year
      weekdays: '',
      // Table header displaying the weekdays names
      weekdaysRow: 'flex',
      // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase',
      // Cell displaying the weekday name
      body: 'body',
      // Table's body with the weeks
      week: 'flex',
      // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center h-10 p-px5 text-base text-center transition-all',
      // The single day cell
      footer: 'mt-px10',
      // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button',
      // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline',
      // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-40 opacity-100 Datepicker-selected',
      // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium',
      // Added to the day's cell specified in the "disabledDays" prop
      outside: 'opacity-50' // Added to the day's cell outside the current month

    },
    thDayStart: 'bg-emerald rtl:rounded-l text-white',
    thDayEnd: 'bg-emerald rtl:rounded-r text-white',
    thDayMiddle: 'bg-emerald text-white'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/datepicker/Datepicker.jsx










var Datepicker_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function isSelectingFirstDay(from, to, day) {
  var isBeforeFirstDay = Boolean(from && DayPicker["DateUtils"].isDayBefore(day, from));
  var isRangeSelected = Boolean(from && to);
  return !from || isBeforeFirstDay || isRangeSelected;
}

function isChangingSelection(from, to, day) {
  return Boolean(from && to && day >= from && day <= to);
}

function isSelectingSameDay(from, to, day) {
  return Boolean(from && !to && DayPicker["DateUtils"].isSameDay(from, day));
}

var Datepicker_Datepicker = function Datepicker(_ref) {
  var _objectSpread2;

  var className = _ref.className,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      navbarElement = _ref.navbarElement,
      hasNavigationByYear = _ref.hasNavigationByYear,
      initialMonth = _ref.initialMonth,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? moment_default.a.locale() : _ref$locale,
      renderDay = _ref.renderDay,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$customModifiers = _ref.customModifiers,
      customModifiers = _ref$customModifiers === void 0 ? {} : _ref$customModifiers,
      _ref$modifiersStyles = _ref.modifiersStyles,
      modifiersStyles = _ref$modifiersStyles === void 0 ? {} : _ref$modifiersStyles,
      _ref$datePickerClassN = _ref.datePickerClassNames,
      datePickerClassNames = _ref$datePickerClassN === void 0 ? {} : _ref$datePickerClassN,
      _ref$disabledDays = _ref.disabledDays,
      disabledDays = _ref$disabledDays === void 0 ? [] : _ref$disabledDays,
      selectedDays = _ref.selectedDays,
      hasRangeMode = _ref.hasRangeMode,
      onSelect = _ref.onSelect,
      onMouseOver = _ref.onMouseOver,
      _ref$shouldHoverSibli = _ref.shouldHoverSiblingOpenDays,
      shouldHoverSiblingOpenDays = _ref$shouldHoverSibli === void 0 ? false : _ref$shouldHoverSibli,
      weekdayElement = _ref.weekdayElement;

  var _ref2 = !selectedDays || DayPicker["DateUtils"].isDate(selectedDays) ? {
    from: selectedDays,
    to: selectedDays
  } : selectedDays,
      from = _ref2.from,
      to = _ref2.to;

  var month = initialMonth || from || minDate || new Date();

  var _useState = Object(react["useState"])(null),
      hovered = _useState[0],
      setHovered = _useState[1];

  var _useState2 = Object(react["useState"])(month),
      activeMonth = _useState2[0],
      setActiveMonth = _useState2[1];

  Object(react["useEffect"])(function () {
    setActiveMonth(month);
  }, [moment_default()(month, moment_default.a.defaultFormat).format('YYYYMMDD')]);

  var handleDayClick = function handleDayClick(day, modifiers) {
    setHovered(null);

    if (onSelect) {
      if (!hasRangeMode) {
        onSelect({
          from: day,
          to: day,
          modifiers: modifiers
        });
      } else if (isSelectingFirstDay(from, to, day) || isChangingSelection(from, to, day)) {
        onSelect({
          from: day,
          to: null,
          modifiers: modifiers
        });
      } else if (isSelectingSameDay(from, to, day)) {
        onSelect({
          from: null,
          to: null,
          modifiers: modifiers
        });
      } else {
        onSelect({
          from: from,
          to: day,
          modifiers: modifiers
        });
      }
    }
  };

  var handleDayMouseEnter = function handleDayMouseEnter(day, modifiers) {
    if (!modifiers.siblingOpenDays || shouldHoverSiblingOpenDays) {
      setHovered(day);
    }

    if (onMouseOver) {
      onMouseOver(day);
    }
  };

  var handleDayMouseLeave = function handleDayMouseLeave() {
    setHovered(null);
  };

  var addMonthsInRange = function addMonthsInRange(date, number) {
    var targetMonth = moment_default()(date).add({
      months: number
    }).toDate();
    if (minDate && DayPicker["DateUtils"].isDayBefore(targetMonth, minDate)) return minDate;
    if (maxDate && DayPicker["DateUtils"].isDayAfter(targetMonth, maxDate)) return maxDate;
    return targetMonth;
  };

  var handleNextMonth = function handleNextMonth() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, 1));
  };

  var handlePreviousMonth = function handlePreviousMonth() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, -1));
  };

  var handleNextYear = function handleNextYear() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, 12));
  };

  var handlePreviousYear = function handlePreviousYear() {
    if (!activeMonth) return;
    setActiveMonth(addMonthsInRange(activeMonth, -12));
  };

  var allDisabledDays = [].concat(Object(toConsumableArray["a" /* default */])(disabledDays), [{
    before: minDate,
    after: maxDate
  }]);
  var _themes$theme = Datepicker_themes_themes[theme],
      thDayEnd = _themes$theme.thDayEnd,
      thDayStart = _themes$theme.thDayStart,
      thDayMiddle = _themes$theme.thDayMiddle,
      thDayPicker = _themes$theme.thDayPicker,
      thRoot = _themes$theme.thRoot;
  var allSelectedDays = [from, {
    from: from,
    to: to || hovered
  }, hovered];

  var modifiers = _objectSpread(_objectSpread({}, customModifiers), {}, (_objectSpread2 = {}, Object(defineProperty["a" /* default */])(_objectSpread2, thDayStart, from || !from && hovered), Object(defineProperty["a" /* default */])(_objectSpread2, thDayEnd, to || from && hovered), Object(defineProperty["a" /* default */])(_objectSpread2, thDayMiddle, hovered), _objectSpread2));

  return Datepicker_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, Datepicker_jsx(DayPicker_default.a, {
    canChangeMonth: true,
    firstDayOfWeek: moment_default.a.localeData().firstDayOfWeek(),
    fixedWeeks: true,
    locale: locale,
    localeUtils: Datepicker_utils,
    showOutsideDays: true,
    showWeekDays: true,
    captionElement: Datepicker_jsx(DatepickerCaption_DatepickerCaption, {
      className: thDayPicker.caption,
      fromMonth: minDate,
      hasNavigationByYear: hasNavigationByYear,
      onNext: handleNextYear,
      onPrevious: handlePreviousYear,
      toMonth: maxDate
    }),
    classNames: _objectSpread(_objectSpread({}, thDayPicker), datePickerClassNames),
    disabledDays: allDisabledDays,
    fromMonth: minDate,
    initialMonth: initialMonth,
    modifiers: modifiers,
    modifiersStyles: modifiersStyles,
    month: activeMonth,
    navbarElement: navbarElement || Datepicker_jsx(DatepickerArrow_DatepickerArrow, {
      onNext: handleNextMonth,
      onPrevious: handlePreviousMonth,
      fromMonth: minDate,
      locale: locale,
      toMonth: maxDate
    }),
    onDayClick: handleDayClick,
    onDayMouseEnter: handleDayMouseEnter,
    onDayMouseLeave: handleDayMouseLeave,
    renderDay: renderDay,
    selectedDays: allSelectedDays,
    toMonth: maxDate,
    weekdayElement: weekdayElement
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.themes.js

var TripDatePicker_themes_themes = function themes(_ref) {
  var isSelectable = _ref.isSelectable,
      isTablet = _ref.isTablet,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      siblingOpen = _ref.siblingOpen;
  return {
    "default": {
      modifiersStyles: {},
      thDay: classnames_default()("cursor-pointer flex flex-1 flex-col items-center justify-center ".concat(isTablet ? 'h-25 p-px5' : 'h-13', " text-base text-center transition-all border-t border-r border-gray-light relative"), {
        'text-black hover:text-white': isSelectable
      }),
      thDayCornerMark: classnames_default()({
        'corner-mark-tr-southSea': siblingOpen && isTablet,
        'corner-mark-tr-southSea-sm': siblingOpen && !isTablet
      }),
      thDayMessage: 'hidden md:inline w-full font-normal text-sm',
      thDayNumber: classnames_default()('md:absolute top-0 left-0 md:p-px5 text-xs', {
        'font-normal md:text-sm': !isSelectable,
        'font-bold md:text-md': isSelectable,
        'text-southSea': siblingOpen
      }),
      thDayOldPrice: 'text-sm line-through hidden md:block',
      thDayPrice: 'text-sm md:text-md',
      thStatusMessage: shouldDisplayDoubleSeasonButton ? "bg-southSea cursor-pointer font-bold p-px md:px-px5 rounded-tiny text-xs md:text-lg text-white uppercase".concat(!isTablet ? ' w-full' : '') : 'hidden md:inline w-full font-normal',
      thFrom: 'hidden md:inline w-full font-normal'
    },
    compact: {
      modifiersStyles: {},
      thDay: classnames_default()('cursor-pointer flex flex-1 flex-col items-center justify-center h-9 leading-tight text-base text-center relative'),
      thDayCornerMark: classnames_default()({
        'corner-mark-rounded-tr-southSea-sm': siblingOpen
      }),
      thDayMessage: 'hidden',
      thDayNumber: '',
      thDayOldPrice: 'hidden',
      thDayPrice: 'mx-auto self-end block font-hairline text-xs',
      thStatusMessage: 'hidden',
      thFrom: 'hidden'
    }
  };
};
// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDetails.jsx
var DayPriceDetails_jsx = react_default.a.createElement;




var DayPriceDetails_DayPriceDetails = function DayPriceDetails(_ref) {
  var day = _ref.day,
      duration = _ref.duration,
      departureCity = _ref.departureCity,
      hasTransport = _ref.hasTransport,
      isJoyview = _ref.isJoyview,
      isVisible = _ref.isVisible,
      setIsVisible = _ref.setIsVisible,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      unit = _ref.unit;
  Object(react["useEffect"])(function () {
    setIsVisible(shouldDisplayDetails);
  }, [shouldDisplayDetails]);
  var dateFormat = Object(i18n["h" /* t */])('resort.startingPrice.dateFormat');
  var startDate = moment_default()(day).format(dateFormat);
  var endDate = moment_default()(day).add({
    days: duration
  }).format(dateFormat);
  return DayPriceDetails_jsx(react["Fragment"], null, isVisible && shouldDisplayDetails && DayPriceDetails_jsx("div", {
    className: "absolute font-normal left-1/2 text-initial top-0 -translate-x-50 z-2",
    style: {
      width: '25rem'
    }
  }, DayPriceDetails_jsx("div", {
    className: "absolute bottom-full fadeIn inset-x-0"
  }, DayPriceDetails_jsx("div", {
    className: "arrow-down arrow-large arrow-white bg-white filter-drop-shadow-after rounded-tiny shadow-md"
  }, DayPriceDetails_jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
    city: departureCity,
    endDate: endDate,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    startDate: startDate,
    unit: unit
  })))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/modal/Modal.jsx + 1 modules
var Modal = __webpack_require__("EvYw");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeasonPopin.jsx
var DayPriceDoubleSeasonPopin = __webpack_require__("uMuQ");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayPriceDoubleSeason.jsx
var DayPriceDoubleSeason_jsx = react_default.a.createElement;





var DayPriceDoubleSeason_DayPriceDoubleSeason = function DayPriceDoubleSeason(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      isMouseOverDoubleSeasonPopin = _ref.isMouseOverDoubleSeasonPopin,
      isVisible = _ref.isVisible,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var stopEventBubbling = function stopEventBubbling(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var closeModal = function closeModal(e) {
    stopEventBubbling(e);
    setInvisible();
  };

  var trackingData = {
    actionGA: 'calendarPrice'
  };
  return DayPriceDoubleSeason_jsx(react["Fragment"], null, (isVisible || isMouseOverDoubleSeasonPopin) && DayPriceDoubleSeason_jsx("div", {
    onClick: stopEventBubbling
  }, isTablet ? DayPriceDoubleSeason_jsx("div", {
    className: "absolute font-normal left-1/2 text-initial top-0 -translate-x-50 z-2",
    style: {
      width: '17.5rem'
    }
  }, DayPriceDoubleSeason_jsx("div", {
    className: "absolute arrow arrow-bg-gray-lighter arrow-down arrow-white bg-white border border-gray-light fadeIn inset-x-0 rounded-tiny shadow-lg",
    style: {
      bottom: '-20px'
    }
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))) : DayPriceDoubleSeason_jsx(Modal["a" /* Modal */], {
    closeLabel: Object(i18n["h" /* t */])('common.close'),
    onClose: closeModal,
    size: "small"
  }, DayPriceDoubleSeason_jsx(DayPriceDoubleSeasonPopin["a" /* DayPriceDoubleSeasonPopin */], {
    availability: availability,
    product: product,
    statusMessageKey: statusMessageKey,
    trackingData: trackingData
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/day-with-price/DayWithPrice.jsx


var DayWithPrice_jsx = react_default.a.createElement;

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */












var COMPACT_MAX_CHARACTERS = 5;
var DayWithPrice_DayWithPrice = function DayWithPrice(_ref) {
  var day = _ref.day,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 7 : _ref$duration,
      _ref$hasInstalment = _ref.hasInstalment,
      hasInstalment = _ref$hasInstalment === void 0 ? false : _ref$hasInstalment,
      isJoyview = _ref.isJoyview,
      isLoading = _ref.isLoading,
      _ref$isSelectable = _ref.isSelectable,
      isSelectable = _ref$isSelectable === void 0 ? false : _ref$isSelectable,
      locale = _ref.locale,
      _ref$price = _ref.price,
      availability = _ref$price.availability,
      currency = _ref$price.currency,
      departureCity = _ref$price.departureCity,
      hasTransport = _ref$price.hasTransport,
      formattedPriceValue = _ref$price.price,
      oldPrice = _ref$price.oldPrice,
      priceValue = _ref$price.priceValue,
      _ref$price$siblingOpe = _ref$price.siblingOpen,
      siblingOpen = _ref$price$siblingOpe === void 0 ? false : _ref$price$siblingOpe,
      unit = _ref$price.unit,
      product = _ref.product,
      shouldDisplayDetails = _ref.shouldDisplayDetails,
      shouldDisplayDoubleSeasonButton = _ref.shouldDisplayDoubleSeasonButton,
      shouldDisplayPrice = _ref.shouldDisplayPrice,
      shouldDisplaySelectedDepartureDateMessage = _ref.shouldDisplaySelectedDepartureDateMessage,
      shouldDisplayStatusMessage = _ref.shouldDisplayStatusMessage,
      theme = _ref.theme,
      withPriceDetails = _ref.withPriceDetails;

  var _useState = Object(react["useState"])(false),
      isMouseOverDoubleSeasonPopin = _useState[0],
      setIsMouseOverDoubleSeasonPopin = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isVisible = _useState2[0],
      setIsVisibleState = _useState2[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var statusMessageKey = "booking.priceCalendar.priceStatus.".concat(availability);
  var _themes$theme = TripDatePicker_themes_themes({
    isSelectable: isSelectable,
    isTablet: isTablet,
    shouldDisplayDoubleSeasonButton: shouldDisplayDoubleSeasonButton,
    siblingOpen: siblingOpen
  })[theme],
      thDayCornerMark = _themes$theme.thDayCornerMark,
      thDayMessage = _themes$theme.thDayMessage,
      thDayNumber = _themes$theme.thDayNumber,
      thDayOldPrice = _themes$theme.thDayOldPrice,
      thDayPrice = _themes$theme.thDayPrice,
      thStatusMessage = _themes$theme.thStatusMessage,
      thFrom = _themes$theme.thFrom;
  var setIsVisible = Object(lodash["debounce"])(function (visible) {
    setIsVisibleState(visible);
  }, 150);

  var setVisible = function setVisible() {
    if (!isVisible) {
      setIsVisible(true);
    }
  };

  var setInvisible = function setInvisible() {
    setIsVisible(false);
  };

  var getCompactPrice = function getCompactPrice(rawPrice) {
    var compactPrice = (rawPrice === null || rawPrice === void 0 ? void 0 : rawPrice.replace(/[\s|.,]/gi, '')) || '';
    return compactPrice.length <= COMPACT_MAX_CHARACTERS ? compactPrice : '';
  };

  var price = hasInstalment ? Object(price_util["b" /* getInstallmentPrice */])({
    currency: currency,
    formattedValue: formattedPriceValue,
    value: priceValue
  }, locale) : formattedPriceValue;
  return DayWithPrice_jsx(react["Fragment"], null, DayWithPrice_jsx("div", {
    className: classnames_default()({
      'absolute h-full inset-0 w-full z-3': withPriceDetails || shouldDisplayDoubleSeasonButton,
      'pointer-events-auto': shouldDisplayDoubleSeasonButton
    }),
    onBlur: function onBlur() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onClick: function onClick(e) {
      if (shouldDisplayDoubleSeasonButton) {
        e.preventDefault();
        e.stopPropagation();

        if (!isDesktop) {
          setVisible();
        }
      }
    },
    onFocus: function onFocus() {
      if (isDesktop) {
        setVisible();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (isDesktop) {
        setInvisible();
      }
    },
    onMouseOver: function onMouseOver() {
      if (isDesktop) {
        setVisible();
      }
    },
    tabIndex: 0
  }), siblingOpen && DayWithPrice_jsx("span", {
    className: thDayCornerMark
  }), withPriceDetails && DayWithPrice_jsx(DayPriceDetails_DayPriceDetails, {
    duration: duration,
    departureCity: departureCity,
    hasTransport: hasTransport,
    isJoyview: isJoyview,
    isVisible: isVisible,
    setIsVisible: setIsVisible,
    shouldDisplayDetails: !!price && shouldDisplayDetails,
    day: day,
    unit: unit
  }), product && siblingOpen && shouldDisplayDoubleSeasonButton && DayWithPrice_jsx(DayPriceDoubleSeason_DayPriceDoubleSeason, {
    availability: availability,
    product: product,
    isMouseOverDoubleSeasonPopin: isMouseOverDoubleSeasonPopin,
    isVisible: isVisible,
    setInvisible: setInvisible,
    setIsMouseOverDoubleSeasonPopin: setIsMouseOverDoubleSeasonPopin,
    setVisible: setVisible,
    statusMessageKey: statusMessageKey
  }), (!shouldDisplayDoubleSeasonButton || isTablet) && DayWithPrice_jsx("span", {
    className: thDayNumber
  }, moment_default()(day).format('D')), shouldDisplayStatusMessage && Object(i18n["f" /* has */])(statusMessageKey) && !price && !isLoading && DayWithPrice_jsx(react["Fragment"], null, siblingOpen ? DayWithPrice_jsx(react["Fragment"], null, shouldDisplayDoubleSeasonButton && DayWithPrice_jsx("span", {
    className: classnames_default()(thStatusMessage, {
      'shadow-md': isVisible || isMouseOverDoubleSeasonPopin
    })
  }, Object(i18n["h" /* t */])(statusMessageKey))) : DayWithPrice_jsx("span", {
    className: thStatusMessage
  }, Object(i18n["h" /* t */])(statusMessageKey))), shouldDisplaySelectedDepartureDateMessage && DayWithPrice_jsx("div", {
    className: thDayMessage
  }, Object(i18n["h" /* t */])('booking.priceCalendar.selectedDepartureDateMessage'), ' ', DayWithPrice_jsx("div", {
    className: "mt-px5"
  }, Object(i18n["h" /* t */])('booking.priceCalendar.endDateMessage'))), isLoading && DayWithPrice_jsx(Spinner["a" /* Spinner */], {
    size: "tiny",
    color: colors["a" /* COLORS */].GRAY
  }), shouldDisplayPrice && !isLoading && DayWithPrice_jsx(react["Fragment"], null, !!price && DayWithPrice_jsx("span", {
    className: thFrom
  }, Object(i18n["h" /* t */])('price.format.from')), DayWithPrice_jsx("span", {
    "data-testid": "price",
    className: thDayPrice
  }, theme === 'compact' ? getCompactPrice(price) : price), price !== oldPrice && DayWithPrice_jsx("span", {
    className: thDayOldPrice
  }, oldPrice)));
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx







var TripDatePicker_jsx = react_default.a.createElement;















var selector = function selector(state) {
  var _state$calendar;

  return {
    isBookableDatesLoading: state === null || state === void 0 ? void 0 : (_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.bookableDatesLoading
  };
}; // $FlowFixMe


var Weekday = function Weekday(_ref) {
  var weekday = _ref.weekday,
      className = _ref.className,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale;
  var weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return TripDatePicker_jsx("div", {
    className: className,
    title: weekdayName
  }, weekdayName);
};

var TripDatePicker_TripDatePicker = function TripDatePicker(_ref2) {
  var _modifiers;

  var className = _ref2.className,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      hasInstalment = _ref2.hasInstalment,
      isJoyview = _ref2.isJoyview,
      navbarElement = _ref2.navbarElement,
      navigationByYear = _ref2.navigationByYear,
      offsetCalendar = _ref2.offsetCalendar,
      onDayMouseOver = _ref2.onDayMouseOver,
      onSelect = _ref2.onSelect,
      openCalendarToDate = _ref2.openCalendarToDate,
      openingDates = _ref2.openingDates,
      optionsDuration = _ref2.optionsDuration,
      prices = _ref2.prices,
      product = _ref2.product,
      _ref2$selectedDays = _ref2.selectedDays,
      from = _ref2$selectedDays.from,
      to = _ref2$selectedDays.to,
      selectedMonth = _ref2.selectedMonth,
      _ref2$shouldAllowSele = _ref2.shouldAllowSelectingSiblingOpenDays,
      shouldAllowSelectingSiblingOpenDays = _ref2$shouldAllowSele === void 0 ? false : _ref2$shouldAllowSele,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'default' : _ref2$theme,
      withLongDayFormat = _ref2.withLongDayFormat,
      _ref2$withPriceDetail = _ref2.withPriceDetails,
      withPriceDetails = _ref2$withPriceDetail === void 0 ? false : _ref2$withPriceDetail,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["className", "departureDate", "duration", "hasInstalment", "isJoyview", "navbarElement", "navigationByYear", "offsetCalendar", "onDayMouseOver", "onSelect", "openCalendarToDate", "openingDates", "optionsDuration", "prices", "product", "selectedDays", "selectedMonth", "shouldAllowSelectingSiblingOpenDays", "theme", "withLongDayFormat", "withPriceDetails"]);

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var _props$displayPrices = props.displayPrices,
      displayPrices = _props$displayPrices === void 0 ? Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('datePicker.displayPrices') : _props$displayPrices;

  var _useSelector = Object(es["e" /* useSelector */])(selector),
      isBookableDatesLoading = _useSelector.isBookableDatesLoading;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var onMouseOver = function onMouseOver(day) {
    onDayMouseOver && onDayMouseOver(day);
  };

  var pricesIds = Object.keys(prices || {});
  var flattenedPrices = prices ? Object(TripDatePicker_utils["f" /* flattenPrices */])(prices) : '';
  var hasPrices = pricesIds.length > 0;
  var doDisplayPricesInDatePicker = hasPrices && displayPrices;
  var resolvePrice = Object(react["useCallback"])(function (dayId) {
    return Object(lodash["get"])(prices, "[".concat(dayId, "]"), {});
  }, [flattenedPrices]);
  var isSeller = appContext.isSeller,
      locale = appContext.locale;
  var disabledDays = Object(react["useMemo"])(function () {
    return Object(TripDatePicker_utils["g" /* getDisabledDays */])({
      from: from,
      to: to,
      prices: prices,
      isSeller: isSeller,
      optionsDuration: optionsDuration,
      openingDates: openingDates,
      resolvePrice: resolvePrice,
      shouldAllowSelectingSiblingOpenDays: shouldAllowSelectingSiblingOpenDays
    });
  }, [from, isSeller, optionsDuration.join(), flattenedPrices, to]);
  var dayIsClosed = Object(react["useCallback"])(Object(TripDatePicker_utils["b" /* closedDaysFactory */])(resolvePrice, from, moment_default()(to).subtract(1, 'day').toDate(), shouldAllowSelectingSiblingOpenDays), [from, to, flattenedPrices]);
  var classColorGreen = 'text-emerald';
  var classColorOrange = 'text-orange';
  var modifiers = (_modifiers = {}, Object(defineProperty["a" /* default */])(_modifiers, classColorGreen, hasPrices ? Object(TripDatePicker_utils["a" /* bestPrice */])(resolvePrice) : []), Object(defineProperty["a" /* default */])(_modifiers, classColorOrange, hasPrices ? Object(TripDatePicker_utils["h" /* lastRoom */])(resolvePrice) : []), Object(defineProperty["a" /* default */])(_modifiers, "disabledDays", disabledDays), Object(defineProperty["a" /* default */])(_modifiers, "firstSiblingOpenDayOfSelectedMonth", Object(TripDatePicker_utils["e" /* firstSiblingOpenDayOfSelectedMonthFactory */])(resolvePrice, selectedMonth)), Object(defineProperty["a" /* default */])(_modifiers, "siblingOpenDays", Object(TripDatePicker_utils["k" /* siblingOpenDaysFactory */])(resolvePrice)), Object(defineProperty["a" /* default */])(_modifiers, 'pointer-events-none', function pointerEventsNone(day) {
    var dayIsSelected = from && to && Object(TripDatePicker_utils["d" /* dateToInt */])(day) >= Object(TripDatePicker_utils["d" /* dateToInt */])(from) && Object(TripDatePicker_utils["d" /* dateToInt */])(day) <= Object(TripDatePicker_utils["d" /* dateToInt */])(to);

    if (hasPrices && dayIsSelected) {
      return dayIsClosed(day);
    }
  }), _modifiers);
  var firstDateWithPrices = Object(react["useMemo"])(function () {
    var today = Object(TripDatePicker_utils["d" /* dateToInt */])(new Date());
    var dayWithPrice = pricesIds.find(function (pricesKey) {
      return Object(TripDatePicker_utils["d" /* dateToInt */])(moment_default()(pricesKey, apiDate["a" /* API_DATE_FORMAT */]).toDate()) > today && prices && prices[pricesKey].available;
    });
    return dayWithPrice || null;
  }, [flattenedPrices]);
  var firstDateOpened = Object(react["useMemo"])(function () {
    if (!Array.isArray(openingDates) || openingDates.length === 0) {
      return null;
    }

    var _openingDates = Object(slicedToArray["a" /* default */])(openingDates, 1),
        opening = _openingDates[0].opening;

    return opening;
  }, [openingDates]);
  var _themes$theme = TripDatePicker_themes_themes({
    isTablet: isTablet
  })[theme],
      modifiersStyles = _themes$theme.modifiersStyles,
      thDay = _themes$theme.thDay; // If bookable dates are loading only define current or selected day as range

  var datesRange = isBookableDatesLoading ? {
    min: moment_default()(from).toDate(),
    max: moment_default()(from).toDate()
  } : {
    min: Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar),
    max: Object(TripDatePicker_utils["i" /* maxDatepickerDate */])()
  };

  var _useState = Object(react["useState"])(openCalendarToDate),
      openCalendarDate = _useState[0],
      setOpenCalendarDate = _useState[1];

  Object(react["useEffect"])(function () {
    setOpenCalendarDate(openCalendarToDate);
  }, [moment_default()(openCalendarToDate).format(apiDate["a" /* API_DATE_FORMAT */])]);
  Object(react["useEffect"])(function () {
    if (from) {
      setOpenCalendarDate(from);
    }
  }, [moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */])]);
  var initialMonth = Object(react["useMemo"])(function () {
    return moment_default()(openCalendarDate || from || firstDateWithPrices || firstDateOpened || Object(TripDatePicker_utils["j" /* minDatepickerDate */])(offsetCalendar)).toDate();
  }, [moment_default()(openCalendarDate).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(from).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateWithPrices).format(apiDate["a" /* API_DATE_FORMAT */]), moment_default()(firstDateOpened).format(apiDate["a" /* API_DATE_FORMAT */]), offsetCalendar]);
  return TripDatePicker_jsx(Datepicker_Datepicker, Object(esm_extends["a" /* default */])({
    hasRangeMode: true,
    className: className,
    selectedDays: {
      from: from,
      to: to
    },
    disabledDays: disabledDays,
    customModifiers: modifiers,
    hasNavigationByYear: navigationByYear,
    minDate: datesRange.min,
    maxDate: datesRange.max,
    navbarElement: navbarElement,
    modifiersStyles: modifiersStyles,
    initialMonth: initialMonth,
    onSelect: onSelect,
    onMouseOver: onMouseOver,
    onFocus: onMouseOver,
    theme: theme,
    shouldHoverSiblingOpenDays: shouldAllowSelectingSiblingOpenDays,
    weekdayElement: withLongDayFormat ? TripDatePicker_jsx(Weekday, null) : undefined
  }, doDisplayPricesInDatePicker ? {
    // eslint-disable-next-line clubmed/no-fake-component
    renderDay: function renderDay(day, dayModifiers) {
      return TripDatePicker_jsx(DayWithPrice_DayWithPrice, {
        day: day,
        duration: duration,
        hasInstalment: hasInstalment,
        isSelectable: Boolean(!dayModifiers.disabledDays && from && !to && !DayPicker["DateUtils"].isSameDay(day, from)),
        isLoading: departureDate && isBookableDatesLoading && moment_default()(day).isAfter(departureDate) ? true : false,
        isJoyview: isJoyview,
        locale: locale,
        price: resolvePrice(Object(TripDatePicker_utils["d" /* dateToInt */])(day)),
        product: product,
        shouldDisplayDetails: withPriceDetails && !!dayModifiers[Datepicker_themes_themes[theme].thDayPicker.selected] && !from && !to,
        shouldDisplayDoubleSeasonButton: dayModifiers.firstSiblingOpenDayOfSelectedMonth,
        shouldDisplayPrice: hasPrices && !from,
        shouldDisplaySelectedDepartureDateMessage: !!from && !to && moment_default()(from).isSame(day, 'day'),
        shouldDisplayStatusMessage: !from,
        withPriceDetails: withPriceDetails,
        theme: theme
      });
    },
    datePickerClassNames: {
      day: thDay
    }
  } : null));
};

/***/ }),

/***/ "q/8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPrice; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("NLwV");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("Sj1w");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_5__);







function fetchPrice(_ref) {
  var appContext = _ref.appContext,
      duration = _ref.duration,
      _ref$forceAdultPerTri = _ref.forceAdultPerTrip,
      forceAdultPerTrip = _ref$forceAdultPerTri === void 0 ? false : _ref$forceAdultPerTri,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport,
      _ref$withDate = _ref.withDate,
      withDate = _ref$withDate === void 0 ? true : _ref$withDate;
  var urlParams = location.urlParams,
      queryParams = location.queryParams;
  var offerName = _clubmed_utils__WEBPACK_IMPORTED_MODULE_5__["url"].decodePath(queryParams.offer) || '';
  var tripDuration = withDate ? duration || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DURATION */ "g"]] : null;
  var productArgsToBuild = {};
  productArgsToBuild.offerName = offerName;
  productArgsToBuild.date = withDate ? queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_DEPARTURE_DATE */ "f"]] || '' : '';
  productArgsToBuild.departureCity = transport || queryParams[_utils_uri_constants__WEBPACK_IMPORTED_MODULE_4__[/* QUERY_TRANSPORT */ "k"]] || '';

  if (tripDuration) {
    productArgsToBuild.duration = parseInt(tripDuration, 10);
  }

  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var productArgs = Object(_utils_graphql__WEBPACK_IMPORTED_MODULE_1__[/* buildProductArgs */ "c"])(productId, urlParams, productArgsToBuild);
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var query = "query {\n    price(".concat(productArgs, ") {\n      offerColor( offerName : \"").concat(offerName, "\")\n      bestPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      initialPrice(forceAdultPerTrip: ").concat(String(forceAdultPerTrip), ") {\n        value\n        formattedValue\n      }\n      unit(").concat(cmsArgs, ")\n      currency\n      termsAndConditions {\n        departureDate\n        duration\n        durationFormatted(").concat(cmsArgs, ")\n        departureCity {\n          value\n          name\n        }\n        numberOfAdults\n        accommodationComfortLabel\n        accommodationId\n        productId\n      }\n    }\n  }");
  return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
    requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* STATE_PRODUCT_PRICE_TICKET */ "Ad"]
  });
}



/***/ }),

/***/ "qFX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCALES_TO_DISPLAY_DIDOMI; });
var LOCALES = {
  EN_CN: 'en-CN',
  PT_BR: 'pt-BR',
  ZH_CN: 'zh-CN',
  FR_FR: 'fr-FR',
  UK_UA: 'uk-UA'
};
var LOCALES_TO_DISPLAY_DIDOMI = [LOCALES.FR_FR];


/***/ }),

/***/ "qLhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWhen_FilterWhen; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-select/InputSelect.jsx + 1 modules
var InputSelect = __webpack_require__("oWz2");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/flipper/Flipper.jsx
var Flipper = __webpack_require__("8zGh");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 8 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.constants.js
var flexibility_constants = __webpack_require__("45Yg");

// CONCATENATED MODULE: ./src/client/store/trip-criteria/flexibility/flexibility.action.js


function setFlexibility(value) {
  return Object(createAction["b" /* default */])(flexibility_constants["a" /* TRIP_INFORMATION_SET_FLEXIBILITY */], {
    value: value
  });
}
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/ArrivalDepartureDate.jsx
var ArrivalDepartureDate = __webpack_require__("YSwF");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/FilterWhen.jsx


var __jsx = react_default.a.createElement;
















var FilterWhen_PriceLegend = function PriceLegend(_ref) {
  var seasonLabel = _ref.seasonLabel;

  var dot = __jsx("div", {
    className: "bg-current rounded-full flex-shrink-0 rtl:mr-px5",
    style: {
      width: '4px',
      height: '4px'
    }
  });

  return __jsx("div", {
    className: "content-start flex flex-wrap"
  }, __jsx("div", {
    className: "rtl:pl-px10 pb-px5 text-center text-emerald text-sm w-1/2 items-center flex"
  }, dot, Object(i18n["h" /* t */])('faceting.when.bestPrice')), !!seasonLabel && __jsx("div", {
    className: "rtl:pl-px10 pb-px5 text-center text-southSea text-sm w-1/2 items-center flex"
  }, dot, Object(i18n["h" /* t */])(seasonLabel)), __jsx("div", {
    className: "rtl:pl-px10 pb-px5 text-center text-orange text-sm w-1/2 items-center flex"
  }, dot, Object(i18n["h" /* t */])('faceting.when.lastAvailability')), __jsx("div", {
    className: "rtl:pl-px10 pb-px5 text-center text-gray-light text-sm w-1/2 items-center flex"
  }, dot, Object(i18n["h" /* t */])('faceting.when.notAvailable')));
};

var FilterWhen_FilterWhen = function FilterWhen(_ref2) {
  var changeDepartureDate = _ref2.changeDepartureDate,
      changeTripDuration = _ref2.changeTripDuration,
      dateFormat = _ref2.dateFormat,
      _ref2$defaultDuration = _ref2.defaultDuration,
      defaultDuration = _ref2$defaultDuration === void 0 ? 7 : _ref2$defaultDuration,
      departureDate = _ref2.departureDate,
      duration = _ref2.duration,
      isSubmittable = _ref2.isSubmittable,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label,
      navigationByYear = _ref2.navigationByYear,
      openCalendarToDate = _ref2.openCalendarToDate,
      _ref2$openingDates = _ref2.openingDates,
      openingDates = _ref2$openingDates === void 0 ? [] : _ref2$openingDates,
      _ref2$optionsDuration = _ref2.optionsDuration,
      optionsDuration = _ref2$optionsDuration === void 0 ? [] : _ref2$optionsDuration,
      _ref2$prices = _ref2.prices,
      prices = _ref2$prices === void 0 ? {} : _ref2$prices,
      _ref2$showDurationLab = _ref2.showDurationLabel,
      showDurationLabel = _ref2$showDurationLab === void 0 ? true : _ref2$showDurationLab,
      offsetCalendar = _ref2.offsetCalendar,
      seasonLabel = _ref2.seasonLabel,
      _ref2$withFlexibility = _ref2.withFlexibility,
      withFlexibility = _ref2$withFlexibility === void 0 ? false : _ref2$withFlexibility;
  var track = Object(useTracking["a" /* useTracking */])({});
  var dispatch = Object(es["d" /* useDispatch */])();
  var from = departureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && duration ? moment_default()(from).add({
    days: duration
  }).toDate() : null;

  var _useState = Object(react["useState"])(from),
      hovered = _useState[0],
      setHovered = _useState[1];

  var hasPrices = Object.keys(prices || {}).length > 0;

  var computeDisplayedDuration = function computeDisplayedDuration() {
    var displayedDuration = from && (to || !hasPrices && hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || !hasPrices && hovered || from) || duration || defaultDuration : 0;
    return displayedDuration || defaultDuration || 0;
  };

  var displayedDuration = computeDisplayedDuration();
  var flexibility = Object(es["e" /* useSelector */])(tripCriteria_selector["d" /* getTripFlexibility */]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onFlexibilityChange = function onFlexibilityChange(name, value) {
    var flexibilityValue = parseInt(value, 10);
    track({
      actionGA: 'smartCriterias',
      labelGA: "flexibility_".concat(flexibilityValue || 'none')
    });
    dispatch(setFlexibility(flexibilityValue));
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var onSelect = function onSelect(dates) {
    changeDepartureDate(dates.from);

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      changeTripDuration(updatedDuration);
    } else {
      changeTripDuration(null);
    }
  };

  var cls = ['bg-white border-1 border-gray-light mb-px10 mx-px20 p-px10 rounded', 'lg:border-0 md:mx-auto lg:m-px5 lg:mr-px5 lg:p-0 lg:rounded-none'];
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(i18n["h" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(i18n["h" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  return __jsx("div", {
    "data-testid": "FilterWhen",
    className: "block p-px10 mb-px40 sm:m-0"
  }, label ? __jsx(react["Fragment"], null, isSubmittable ? __jsx("div", {
    className: "flex font-bold items-center text-left text-orange text-sm"
  }, __jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].WARNING,
    width: "2.5em",
    className: "flex mr-px10"
  }), __jsx("span", null, label)) : __jsx("div", {
    className: "font-bold lg:text-center text-lg"
  }, label)) : null, __jsx(ArrivalDepartureDate["a" /* ArrivalDepartureDate */], {
    arrivalDate: from && moment_default()(from).format(dateFormat),
    departureDate: to && moment_default()(to).format(dateFormat)
  }), __jsx("div", {
    className: cls.join(' ')
  }, showDurationLabel && !hasPrices ? __jsx("div", {
    className: "px-px20 py-px10 mb-px5 lg:px-px10 sm:border-b"
  }, __jsx("div", {
    className: "flex items-center justify-between mt-px5 text-base"
  }, __jsx("span", null, Object(i18n["h" /* t */])('faceting.when.duration')), __jsx("span", {
    "data-testid": "duration-label"
  }, durationLabel))) : null, hasPrices ? __jsx("div", {
    className: "sm:border-b border-gray-light py-px5 mb-px10 w-full"
  }, __jsx(FilterWhen_PriceLegend, {
    seasonLabel: seasonLabel
  })) : null, __jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "pb-0",
    departureDate: departureDate,
    navigationByYear: navigationByYear,
    offsetCalendar: offsetCalendar,
    onDayMouseOver: onDayMouseOver,
    openCalendarToDate: openCalendarToDate,
    openingDates: openingDates,
    optionsDuration: optionsDuration,
    onSelect: onSelect,
    prices: prices,
    selectedDays: {
      from: from,
      to: to
    },
    shouldAllowSelectingSiblingOpenDays: true,
    theme: "compact"
  }), hasPrices ? __jsx("div", {
    className: "text-center text-base font-bold pt-px10"
  }, __jsx("strong", {
    "data-testid": "prices-duration-label"
  }, __jsx(Flipper["a" /* Flipper */], {
    value: Object(i18n["h" /* t */])('faceting.when.pricesBasedOn') + ' ' + durationLabel
  }))) : null, withFlexibility && __jsx("div", {
    className: "border-t py-px10"
  }, __jsx("span", {
    className: "flex font-bold font-sans mb-px5 text-base text-gray-darker"
  }, Object(i18n["h" /* t */])('faceting.flexibility.label')), __jsx(InputSelect["a" /* InputSelect */], {
    dataTestId: "flexibility-input",
    onChange: onFlexibilityChange,
    options: [{
      label: Object(i18n["h" /* t */])('faceting.flexibility.duration_0'),
      value: 0
    }, {
      label: Object(i18n["h" /* t */])('faceting.flexibility.duration_1'),
      value: 1
    }, {
      label: Object(i18n["h" /* t */])('faceting.flexibility.duration_3'),
      value: 3
    }, {
      label: Object(i18n["h" /* t */])('faceting.flexibility.duration_7'),
      value: 7
    }],
    value: flexibility
  }))));
};

/***/ }),

/***/ "qPLk":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "qXr/":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "qs2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("LTtw");
var DESCRIPTORS = __webpack_require__("uGjT");
var global = __webpack_require__("HnW7");
var has = __webpack_require__("DZWw");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var defineProperty = __webpack_require__("87KK").f;
var copyConstructorProperties = __webpack_require__("sfoL");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var nativeSymbol = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = nativeSymbol ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "rJ95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOptimisticAction; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("zjfJ");









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function createAction(type, payload) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}

function createOptimisticAction(type, payload, meta) {
  return _objectSpread(_objectSpread({
    type: type
  }, payload ? {
    payload: payload
  } : null), {}, {
    meta: meta
  });
}


/* harmony default export */ __webpack_exports__["b"] = (createAction);

/***/ }),

/***/ "rcxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAGE_BE_ACCOMMODATION; });
/* unused harmony export PAGE_BE_TRANSPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAGE_BE_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_BE_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_BE_SERVICES_ALL_INCLUSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAGE_BE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_BE_BANKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getBookingEngineUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBookingCriteriaOffsetSell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return checkIsDepartureDateAvailaible; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("QsI/");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("U2CP");
/* harmony import */ var _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("PIvV");
/* harmony import */ var _proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("oL6k");
/* harmony import */ var _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("CcNa");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}






var PAGE_BE_ACCOMMODATION = 'accommodation';
var PAGE_BE_TRANSPORT = 'transport';
var PAGE_BE_SERVICES = 'services';
var PAGE_BE_ACTIVITIES = 'activities';
var PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
var PAGE_BE_PARTICIPANTS = 'participants';
var PAGE_BE_BANKING = 'banking';
function getBookingEngineUri() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PAGE_BE_ACCOMMODATION;
  var proposals = arguments.length > 1 ? arguments[1] : undefined;
  var resort = arguments.length > 2 ? arguments[2] : undefined;
  var selectedProposalId = arguments.length > 3 ? arguments[3] : undefined;
  var otherQueryParameters = arguments.length > 4 ? arguments[4] : undefined;
  var proposalIds = proposals.map(function (proposal) {
    return proposal.id;
  });
  var defaultProposal = Object(_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_14__[/* getDefaultProposal */ "f"])(proposals, resort);

  var queryParams = _objectSpread(_objectSpread({}, otherQueryParameters), {}, {
    proposalIds: proposalIds,
    selectedProposalId: selectedProposalId || defaultProposal.id,
    coderesort: resort === null || resort === void 0 ? void 0 : resort.id
  });

  return _routes_routeBuilder__WEBPACK_IMPORTED_MODULE_12__[/* buildUrl */ "a"]('booking', {
    page: page
  }, queryParams);
}
var getBookingCriteriaOffsetSell = /*#__PURE__*/function () {
  var _ref = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee(productId, appContext) {
    var getQuery, query;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getQuery = function getQuery() {
              return "query {\n                  bookingCriteria(productId: \"".concat(productId, "\") {\n                    offsetSell\n                  }\n            }");
            };

            query = getQuery();
            return _context.abrupt("return", _graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_13__[/* default */ "a"].runQuery(query, appContext, {
              requestName: _request_requestDictionary__WEBPACK_IMPORTED_MODULE_15__[/* CRITERIA_OFFSETSELL */ "g"]
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getBookingCriteriaOffsetSell(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API

var checkIsDepartureDateAvailaible = function checkIsDepartureDateAvailaible(departureDate, offsetSell) {
  return moment__WEBPACK_IMPORTED_MODULE_11___default()(departureDate).isBefore(moment__WEBPACK_IMPORTED_MODULE_11___default()().add(offsetSell, 'd'), 'day');
};

/***/ }),

/***/ "rueY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchCalendarTripPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchBookableDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setPossibleDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setInitialDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setCalendarBlockInputDepartureDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCalendar; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("uDfI");
/* harmony import */ var _calendar_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("VtPb");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("cvSI");
/* harmony import */ var _priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("q/8t");
/* harmony import */ var _trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("fflk");
/* harmony import */ var _trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Mn1B");
/* harmony import */ var _trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6wD6");
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("L73y");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("Sj1w");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("nv//");


















function fetchCalendar(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar, _state$calendar2;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar = state.calendar) === null || _state$calendar === void 0 ? void 0 : _state$calendar.isLoading) && ((_state$calendar2 = state.calendar) === null || _state$calendar2 === void 0 ? void 0 : _state$calendar2.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_ABORT */ "h"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR */ "g"], {
      departureCity: options.transport,
      productId: options.resortId
    }, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchCalendar */ "g"])(appContext, options)
    }));
  };
}
function fetchCalendarTripPrice(options) {
  return function (dispatch, getState) {
    var _state$calendar3, _state$calendar4;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar3 = state.calendar) === null || _state$calendar3 === void 0 ? void 0 : _state$calendar3.isLoading) && ((_state$calendar4 = state.calendar) === null || _state$calendar4 === void 0 ? void 0 : _state$calendar4.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE_ABORT */ "j"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_CALENDAR_TRIP_PRICE */ "i"], {}, {
      optimist: true,
      promise: Object(_priceTicket_priceTicket_helper__WEBPACK_IMPORTED_MODULE_9__[/* fetchPrice */ "a"])(options)
    }));
  };
}
function fetchBookableDates(options, appContext) {
  return function (dispatch, getState) {
    var _state$calendar5, _state$calendar6;

    var state = getState();
    var calendarRequestInProgress = ((_state$calendar5 = state.calendar) === null || _state$calendar5 === void 0 ? void 0 : _state$calendar5.isLoading) && ((_state$calendar6 = state.calendar) === null || _state$calendar6 === void 0 ? void 0 : _state$calendar6.lastRequestId) !== -1;

    if (calendarRequestInProgress) {
      return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES_ABORT */ "f"], {}));
    }

    return dispatch(Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* createOptimisticAction */ "a"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* FETCH_BOOKABLE_DATES */ "e"], {}, {
      optimist: true,
      promise: Object(_calendar_helper__WEBPACK_IMPORTED_MODULE_7__[/* queryFetchBookableDates */ "f"])(appContext, options)
    }));
  };
}
function selectMonth(selectedMonth) {
  // format YYYYMM (number)
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_13__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_CHANGE_MONTH */ "a"], {
    selectedMonth: selectedMonth
  });
}

function determineDepartureDate(state) {
  if (!Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state)) {
    var departureDateFromUrl = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_17__[/* getQueryParameters */ "i"])(_clubmed_utils__WEBPACK_IMPORTED_MODULE_3__["windowWrapper"].getLocation()), _utils_uri_constants__WEBPACK_IMPORTED_MODULE_16__[/* QUERY_DEPARTURE_DATE */ "f"]);
    return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(departureDateFromUrl, _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]) || Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state);
  }

  return Object(_utils_date_dateUtils__WEBPACK_IMPORTED_MODULE_15__[/* formatTimestampDate */ "b"])(Object(_trip_date_criteria_storeHelper__WEBPACK_IMPORTED_MODULE_11__[/* getDepartureDate */ "b"])(state), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]);
}

function setPossibleDepartureDate() {
  return function (dispatch, getState) {
    var findDayInMonths = function findDayInMonths() {
      var months = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var dayId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var id = parseInt(dayId, 10);
      var allDays = months.reduce(function (acc, m) {
        return [].concat(acc, m.days);
      }, []);
      return allDays.find(function (d) {
        return Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(d, 'dayContent.id') === id;
      });
    };

    var departureDate = determineDepartureDate(getState());

    if (departureDate) {
      var calendarMonth = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(getState(), 'calendar.calendar.months');
      var day = findDayInMonths(calendarMonth, departureDate);
      var dayContent = Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(day, 'dayContent', null);

      if (dayContent) {
        if (Object(lodash__WEBPACK_IMPORTED_MODULE_4__["get"])(dayContent, 'canGoToBooking')) {
          var yearAndMonth = parseInt(dayContent.id / 100, 10);
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: dayContent
            })); // makes sure tripCriteria.departureDate in store is synchronised
            // TODO: merge tripDateCriteria into tripCriteria #12563

            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_5___default()("".concat(dayContent.id), _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_14__[/* API_DATE_FORMAT */ "a"]).valueOf()));
            dispatch(selectMonth(yearAndMonth));
          });
        } else {
          Object(react_redux__WEBPACK_IMPORTED_MODULE_6__[/* batch */ "b"])(function () {
            dispatch(Object(_trip_date_criteria_tripDateCriteria_action__WEBPACK_IMPORTED_MODULE_12__[/* updateTripDateCriteria */ "a"])({
              day: null
            }));
            dispatch(Object(_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_10__[/* setDepartureDate */ "a"])(null));
          });
        }
      }
    }
  };
}
var setInitialDuration = function setInitialDuration(duration) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_INITIAL_DURATION */ "c"],
    payload: {
      duration: duration
    }
  };
};
var setCalendarBlockInputDepartureDate = function setCalendarBlockInputDepartureDate(blockInputDepartureDate) {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CALENDAR_SET_BLOCK_INPUT_DEPARTURE_DATE */ "b"],
    payload: {
      blockInputDepartureDate: blockInputDepartureDate
    }
  };
};
var clearCalendar = function clearCalendar() {
  return {
    type: _constants__WEBPACK_IMPORTED_MODULE_8__[/* CLEAR_CALENDAR */ "d"]
  };
};

/***/ }),

/***/ "rvZv":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "s+R0":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("JBn+"),
    arrayIncludes = __webpack_require__("OfKG"),
    arrayIncludesWith = __webpack_require__("sCL+"),
    cacheHas = __webpack_require__("S0iI"),
    createSet = __webpack_require__("9TP6"),
    setToArray = __webpack_require__("XlL0");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "sCL+":
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "sW3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADULTS_ONLY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULTS_NUMBER_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MAX_PAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MAX_PAX_SELLER; });
/* unused harmony export AREA_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHILDCARE_FACET_ID; });
/* unused harmony export COUNTRY_FACET_PREFIX_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_DEPARTURE_CITY_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEPARTURE_CITY_FACET_ID; });
/* unused harmony export DEPARTURE_DATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEPARTURE_DATE_MAX_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEPARTURE_DATE_MAX_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DEPARTURE_DATE_MIN_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DURATION_FACET; });
/* unused harmony export KIDS_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return KIDS_NUMBER_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return KIDS_NUMBER_MAX_SELLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOCALE_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MAX_NUMBER_OF_SELECTED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return OFFER_ID_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PRODUCT_FACET_ID; });
/* unused harmony export WHEN_FACET_ID */
/* unused harmony export WHERE_FACET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DESTINATIONS_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUNTRIES_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return TOP_COUNTRIES_FACET_LIST_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TYPES_OF_STAY_FACET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FACET_COMFORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return QUERY_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PRODUCTS_TO_COMPARE_QUERY_PARAM; });
/* unused harmony export FACET_QUERY_PARAMS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DEFAULT_CHILDCARE_FACETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FILTERABLE_FACETS_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FILTERABLE_FACETS_TRACKING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FILTERABLE_FACETS_TEMPLATE_CONFIG; });
/* unused harmony export FACETS */
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("SPKZ");


var ADULTS_ONLY_FACET_ID = 'facette_adult_only';
var ADULTS_NUMBER_MIN = 1;
var MAX_PAX = 6;
var MAX_PAX_SELLER = 8;
var AREA_FACET_PREFIX_ID = 'AREA';
var CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
var COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
var DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
var DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
var DEPARTURE_DATE = 'date';
var DEPARTURE_DATE_MAX_DATE = {
  years: 2
};
var DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
var DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
var DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
var DURATION_FACET = 'facette_duration';
var KIDS_FACET_ID = 'facette_kids';
var KIDS_NUMBER_MAX = 5;
var KIDS_NUMBER_MAX_SELLER = 7;
var LOCALE_FACET_ID = 'locale';
var MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
var OFFER_ID_FACET_ID = 'facette_offer_id';
var PRODUCT_FACET_ID = 'product_id';
var WHEN_FACET_ID = 'facette_when';
var WHERE_FACET_ID = 'facette_where';
var ACTIVITIES_FACET_ID = 'activities_tree';
var DESTINATIONS_FACET_ID = 'destinations_tree';
var COUNTRIES_FACET_ID = 'facette_destination_country';
var TOP_COUNTRIES_FACET_LIST_ID = 'facet_list_top_destination_countries';
var TYPES_OF_STAY_FACET_ID = 'facette_type';
var FACET_COMFORT_ID = 'facette_comfort_label';
var QUERY_QUERY_PARAM = 'search';
var PRODUCTS_TO_COMPARE_QUERY_PARAM = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].productsComparison.productIds;
var FACET_QUERY_PARAMS = [{
  id: 'destination',
  facetId: COUNTRIES_FACET_ID
}, {
  id: 'departure_city',
  facetId: DEPARTURE_CITY_FACET_ID
}];
var DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];
var FILTERABLE_FACETS_IDS = [ACTIVITIES_FACET_ID, DESTINATIONS_FACET_ID, COUNTRIES_FACET_ID, TYPES_OF_STAY_FACET_ID, FACET_COMFORT_ID];
var FILTERABLE_FACETS_TRACKING_CONFIG = [{
  id: ACTIVITIES_FACET_ID,
  trackingPrefixLabel: 'activities'
}, {
  id: DESTINATIONS_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: COUNTRIES_FACET_ID,
  trackingPrefixLabel: 'destinations'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  trackingPrefixLabel: 'comfort'
}];
var FILTERABLE_FACETS_TEMPLATE_CONFIG = [{
  id: DESTINATIONS_FACET_ID,
  dataLabel: 'where',
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].EARTH_PLANE,
  facetLists: [{
    deep: false,
    id: DESTINATIONS_FACET_ID,
    titleLabel: 'faceting.where.destinationTitle'
  }, {
    deep: false,
    id: COUNTRIES_FACET_ID,
    titleLabel: 'faceting.where.countriesTitle'
  }],
  titleLabel: 'faceting.where.title'
}, {
  id: ACTIVITIES_FACET_ID,
  dataLabel: 'activities',
  facetLists: [{
    deep: true,
    id: ACTIVITIES_FACET_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].ACTIVITIES,
  titleLabel: 'faceting.activities.title'
}, {
  id: TYPES_OF_STAY_FACET_ID,
  dataLabel: 'typeofstay',
  facetLists: [{
    deep: false,
    id: TYPES_OF_STAY_FACET_ID,
    facetLabels: 'faceting.typesOfStay'
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].BEACH,
  titleLabel: 'faceting.typesOfStay.title',
  trackingPrefixLabel: 'typeofstay'
}, {
  id: FACET_COMFORT_ID,
  dataLabel: 'comfort',
  facetLists: [{
    deep: false,
    id: FACET_COMFORT_ID
  }],
  iconName: _client_components_utils_icon_icons__WEBPACK_IMPORTED_MODULE_1__[/* ICONS */ "a"].TRIDENT1,
  titleLabel: 'faceting.comfort.title'
}];
var FACETS = {
  when: 'when',
  who: 'who',
  where: 'where'
};

/***/ }),

/***/ "sfoL":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var ownKeys = __webpack_require__("1m4l");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "ssvU":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
$({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});


/***/ }),

/***/ "syQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INLINE_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INLINE_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSITE_1; });
var INLINE_1 = 'Inline1';
var INLINE_2 = 'Inline2';
var COLUMN_1 = 'Column1';
var COLUMN_2 = 'Column2';
var COMPOSITE_1 = 'Composite1';

/***/ }),

/***/ "tCJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Sections_Sections; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/createIntersectionObserver.js
if (true) {
  // Polyfills for intersection-observer
  __webpack_require__("LNcM");
}

function createIntersectionObserver(callback, options) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  return new IntersectionObserver(callback, options);
}
// CONCATENATED MODULE: ./src/client/components/frameworks/intersection-observer/IntersectionObserver.jsx













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



var IntersectionObserver_IntersectionObserver = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(IntersectionObserver, _Component);

  var _super = _createSuper(IntersectionObserver);

  function IntersectionObserver() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, IntersectionObserver);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleIntersection", function (_ref) {
      var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 1),
          entry = _ref2[0];

      _this.props.onChange(entry);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "observe", function () {
      if (_this.target && _this.observer) {
        _this.observer.observe(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "unobserve", function () {
      if (_this.target && _this.observer) {
        _this.observer.unobserve(_this.target);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setRefTarget", function (target) {
      _this.targetChanged = _this.previousTarget && _this.previousTarget !== target;

      if (_this.targetChanged) {
        _this.unobserve();
      }

      _this.target = target;
    });

    return _this;
  }

  Object(createClass["a" /* default */])(IntersectionObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          rootMargin = _this$props.rootMargin,
          threshold = _this$props.threshold;
      this.observer = createIntersectionObserver(this.handleIntersection, {
        rootMargin: rootMargin,
        threshold: threshold
      });
      this.observe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unobserve();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // @todo remove this
      this.previousTarget = this.target;
      return /*#__PURE__*/react_default.a.cloneElement(react_default.a.Children.only(this.props.children), {
        ref: this.setRefTarget
      });
    }
  }]);

  return IntersectionObserver;
}(react["Component"]);

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "displayName", 'IntersectionObserver');

Object(defineProperty["a" /* default */])(IntersectionObserver_IntersectionObserver, "defaultProps", {
  rootMargin: '0px',
  threshold: 0
});
// CONCATENATED MODULE: ./src/client/components/frameworks/section/Section.jsx











var __jsx = react_default.a.createElement;

function Section_createSuper(Derived) { var hasNativeReflectConstruct = Section_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Section_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var Section_Section = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(Section, _PureComponent);

  var _super = Section_createSuper(Section);

  function Section(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Section);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "intersectionObserverThreshold", void 0);

    _this.intersectionObserverThreshold = [];

    for (var i = 0; i <= 1.0; i += 0.01) {
      // Get notified of every percent of visiblity change in the viewport (1% of intersection to 100%)
      _this.intersectionObserverThreshold.push(Math.round(i * 100) / 100);
    }

    return _this;
  }

  Object(createClass["a" /* default */])(Section, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          index = _this$props.index,
          name = _this$props.name;
      var anchor = name ? dist["url"].normalizeSlug(name) : null;
      return __jsx(IntersectionObserver_IntersectionObserver, {
        onChange: this.props.onSectionIntersectViewport,
        threshold: this.intersectionObserverThreshold
      }, __jsx("section", {
        className: className,
        "data-cs-override-id": "Section",
        "data-index": index,
        "data-testid": "section",
        id: anchor || null
      }, children));
    }
  }]);

  return Section;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(Section_Section, "defaultProps", {
  name: ''
});
// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// CONCATENATED MODULE: ./src/client/components/frameworks/sections/Sections.jsx



var Sections_jsx = react_default.a.createElement;











var Sections_Sections = function Sections(_ref) {
  var children = _ref.children,
      className = _ref.className,
      navItems = _ref.navItems,
      getTrackingData = _ref.getTrackingData,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel,
      pageType = _ref.pageType;
  var track = Object(useTracking["a" /* useTracking */])();
  var navBarRef = Object(react["useRef"])(null);
  var onSectionIntersectViewport = Object(react["useRef"])(lodash["noop"]);

  var _useState = Object(react["useState"])(0),
      selectedIndex = _useState[0],
      setSelectedIndex = _useState[1];

  var navSelector = pageType || 'Sections'; // eslint-disable-next-line no-unused-vars

  var _useState2 = Object(react["useState"])(false),
      isSticky = _useState2[0],
      setIsSticky = _useState2[1];

  var onStateChange = Object(react["useCallback"])(function (status) {
    setIsSticky(status.status !== Sticky_default.a.STATUS_ORIGINAL);
  }, []);
  Object(react["useEffect"])(function () {
    onSectionIntersectViewport.current = function (event) {
      var visiblePercentage = Math.floor(event.intersectionRatio * 100);
      var navBarHeight = navBarRef && Object(lodash["get"])(navBarRef, 'current.offsetHeight');
      var selected = Number(event.target.dataset.index);

      if (event.isIntersecting && visiblePercentage > 10 && event.intersectionRect.top <= navBarHeight) {
        setSelectedIndex(selected);
      }
    };
  }, []);
  var onNavItemClick = Object(react["useCallback"])(function (anchor, index, label) {
    return function (e) {
      e.preventDefault(); // $FlowFixMe

      var selected = Number(index);
      var scrollRootOffsetSelector = "#".concat(navSelector);

      if (getTrackingData) {
        track(getTrackingData(label));
      }

      Object(scrollToElement["a" /* scrollToElement */])("#".concat(anchor), 600, scrollRootOffsetSelector).then(function () {
        setSelectedIndex(selected);
      });
    };
  }, []);
  var navbarItems = Object(react["useMemo"])(function () {
    return navItems.map(function (label, index) {
      var anchor = label ? dist["url"].normalizeSlug(label) : '';
      return {
        label: label,
        onClick: anchor ? onNavItemClick(anchor, index, label) : undefined,
        href: "#".concat(anchor)
      };
    });
  }, []);
  return Sections_jsx("div", {
    className: className
  }, Sections_jsx(Sticky_default.a, {
    className: "relative z-4",
    onStateChange: onStateChange
  }, Sections_jsx("div", {
    ref: navBarRef,
    id: navSelector,
    className: classnames_default()('flex bg-white flex-wrap w-full mx-auto', {
      'border-b-1': isSticky
    })
  }, Sections_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    childrenWrapperClassNames: "flex",
    className: "max-w-site py-px10 bg-white lg:mx-auto w-full",
    forceDisplayControls: true,
    forwardLabel: scrollForwardLabel
  }, navbarItems.map(function (item, index) {
    var isActive = index === selectedIndex;
    return Sections_jsx(Tag["a" /* Tag */], Object(esm_extends["a" /* default */])({}, item, {
      active: isActive,
      borderColor: isActive ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_LIGHT,
      className: classnames_default()('rtl:mr-px10', {
        'rtl:ml-px20 lg:rtl:ml-0': index === 0,
        'rtl:mr-px20 lg:rtl:mr-0': index === navbarItems.length - 1
      }),
      color: isActive ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_DARKER,
      key: item.label,
      theme: "outlinedThin"
    }));
  })))), children.map(function (sectionLines, index) {
    return Sections_jsx(Section_Section, {
      index: index,
      key: navItems[index],
      name: navItems[index],
      onSectionIntersectViewport: onSectionIntersectViewport.current
    }, sectionLines);
  }));
};
Sections_Sections.defaultProps = {
  children: [],
  navItems: [],
  pageType: ''
};

/***/ }),

/***/ "tF/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateSummary; });
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("lTEL");
/* harmony import */ var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("kYxP");
/* harmony import */ var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("UCZK");
/* harmony import */ var _views_booking_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("taV1");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("SPKZ");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Ohju");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;







var DateSummary = function DateSummary(_ref) {
  var _ref$extendedDataset = _ref.extendedDataset,
      extendedDataset = _ref$extendedDataset === void 0 ? false : _ref$extendedDataset,
      template = _ref.template,
      values = _ref.values,
      _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? 'div' : _ref$as;
  return __jsx(Comp, {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('PackagePriceSummary-section', {
      'PackagePriceSummary-section--extended': extendedDataset
    }),
    "data-testid": _views_booking_constants__WEBPACK_IMPORTED_MODULE_6__[/* CRITERIA_SELECTORS */ "q"].DEPARTURE
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_8__[/* Icon */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_5__[/* COLORS */ "a"].BLUE,
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_7__[/* ICONS */ "a"].DATE,
    className: "PackagePriceSummary-icon",
    width: "1.875rem",
    hasRtl: true
  }), __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_9__[/* TemplateString */ "a"], {
    template: template // $FlowFixMe
    ,
    values: values,
    valuesClassName: {
      arrivalDate: 'PackagePriceSummary-arrivalDate',
      departureDate: 'PackagePriceSummary-departureDate'
    }
  }));
};

/***/ }),

/***/ "tRRp":
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":65533,\"128\":8364,\"130\":8218,\"131\":402,\"132\":8222,\"133\":8230,\"134\":8224,\"135\":8225,\"136\":710,\"137\":8240,\"138\":352,\"139\":8249,\"140\":338,\"142\":381,\"145\":8216,\"146\":8217,\"147\":8220,\"148\":8221,\"149\":8226,\"150\":8211,\"151\":8212,\"152\":732,\"153\":8482,\"154\":353,\"155\":8250,\"156\":339,\"158\":382,\"159\":376}");

/***/ }),

/***/ "tUgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FilterWho_FilterWho; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInputWrapper: 'relative decorator-slash-separator flex-1 h-full',
      thInput: classnames_default()('reset-input h-full text-center text-current w-full', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-date/InputDate.jsx






















var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }







var DAY = 'd';
var MONTH = 'm';
var YEAR = 'y';
var DAY_LENGTH = 2;
var MONTH_LENGTH = 2;
var YEAR_LENGTH = 4;

function getInputsState(_ref) {
  var value = _ref.value;
  var date = value ? moment_default()(value) : moment_default()(null);
  return {
    dayValue: date.isValid() ? date.format('DD') : '',
    monthValue: date.isValid() ? date.format('MM') : '',
    yearValue: date.isValid() ? date.format('YYYY') : ''
  };
}

var InputDate_InputDate = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputDate, _Component);

  var _super = _createSuper(InputDate);

  function InputDate(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDate);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (inputRef, value, maxLength, nextRef) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        _this.setState(Object(defineProperty["a" /* default */])({}, inputRef, value), function () {
          return onChange(_this.props.name || '', _this.getDate());
        });

        if (nextRef && value.length === maxLength) {
          var _this$nextRef;

          // $FlowFixMe
          (_this$nextRef = _this[nextRef]) === null || _this$nextRef === void 0 ? void 0 : _this$nextRef.focus();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        dayValue: '',
        monthValue: '',
        yearValue: ''
      }, function () {
        return onClear(e);
      });
    });

    _this.state = _objectSpread({}, getInputsState(props));
    return _this;
  }

  Object(createClass["a" /* default */])(InputDate, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState(getInputsState(nextProps));
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      var _this$state = this.state,
          dayValue = _this$state.dayValue,
          monthValue = _this$state.monthValue,
          yearValue = _this$state.yearValue;
      var allFields = dayValue.length === DAY_LENGTH && monthValue.length === MONTH_LENGTH && yearValue.length === YEAR_LENGTH;

      if (allFields) {
        var date = moment_default()([parseInt(yearValue, 10), parseInt(monthValue, 10) - 1, parseInt(dayValue, 10)]);
        return date.isValid() ? date.valueOf() : false;
      }

      return null;
    }
  }, {
    key: "getInputOrder",
    value: function getInputOrder(type) {
      var _this$props$dateForma = this.props.dateFormat,
          dateFormat = _this$props$dateForma === void 0 ? '' : _this$props$dateForma;
      return dateFormat.toLowerCase().indexOf(type);
    }
  }, {
    key: "getInputs",
    value: function getInputs() {
      return [{
        ref: 'dayValue',
        placeholder: this.props.placeholderDay || '',
        value: this.state.dayValue,
        order: this.getInputOrder(DAY),
        maxLength: DAY_LENGTH
      }, {
        ref: 'monthValue',
        placeholder: this.props.placeholderMonth || '',
        value: this.state.monthValue,
        order: this.getInputOrder(MONTH),
        maxLength: MONTH_LENGTH
      }, {
        ref: 'yearValue',
        placeholder: this.props.placeholderYear || '',
        value: this.state.yearValue,
        order: this.getInputOrder(YEAR),
        maxLength: YEAR_LENGTH
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          hasClear = _this$props2.hasClear,
          iconLeft = _this$props2.iconLeft,
          iconRight = _this$props2.iconRight,
          _this$props2$id = _this$props2.id,
          id = _this$props2$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputDate_') : _this$props2$id,
          isDisabled = _this$props2.isDisabled,
          isFilled = _this$props2.isFilled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          isRequired = _this$props2.isRequired,
          label = _this$props2.label,
          notes = _this$props2.notes,
          onBlur = _this$props2.onBlur,
          onClick = _this$props2.onClick,
          onFocus = _this$props2.onFocus,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          size = _this$props2.size,
          theme = _this$props2.theme,
          validationState = _this$props2.validationState;
      var _this$state2 = this.state,
          dayValue = _this$state2.dayValue,
          monthValue = _this$state2.monthValue,
          yearValue = _this$state2.yearValue;
      var hasValue = Boolean(dayValue) || Boolean(monthValue) || Boolean(yearValue);
      var hasClearEnabled = Boolean(hasClear && hasValue);
      var inputs = Object(lodash["sortBy"])(this.getInputs(), ['order']);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thInputWrapper = _themes$theme.thInputWrapper;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        iconLeft: iconLeft,
        iconRight: iconRight,
        id: id,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, inputs.map(function (input, index) {
        var nextRef = index + 1 < inputs.length ? inputs[index + 1].ref : null;
        return __jsx("span", {
          key: index,
          className: thInputWrapper
        }, __jsx("input", Object(esm_extends["a" /* default */])({
          className: thInput,
          "data-testid": input.ref,
          disabled: isDisabled
        }, index === 0 ? {
          id: id
        } : null, {
          maxLength: input.maxLength,
          onBlur: onBlur,
          onChange: function onChange(e) {
            return _this2.onChange(input.ref, e.target.value, input.maxLength, nextRef);
          },
          onClick: onClick,
          onFocus: onFocus,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          placeholder: input.placeholder,
          readOnly: Boolean(isReadOnly || isLoading),
          ref: function ref(node) {
            // $FlowFixMe
            _this2[input.ref] = node;
          },
          required: isRequired,
          type: "tel",
          value: input.value
        })));
      }));
    }
  }]);

  return InputDate;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputDate_InputDate, "defaultProps", {
  dateFormat: 'DDMMYYYY',
  onChange: function onChange() {
    return Promise.resolve();
  },
  size: 'medium',
  theme: 'default'
});
// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-switch/InputSwitch.jsx + 1 modules
var InputSwitch = __webpack_require__("YjXp");

// CONCATENATED MODULE: ./src/client/components/widgets/criteria/criteria-who/filter-who/FilterWho.jsx













var FilterWho_jsx = react_default.a.createElement;

function FilterWho_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FilterWho_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FilterWho_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FilterWho_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var FilterWho_FilterWho = function FilterWho(_ref) {
  var addChildcareLabel = _ref.addChildcareLabel,
      adultsLabel = _ref.adultsLabel,
      adultsNumber = _ref.adultsNumber,
      _ref$birthdaysErrorMe = _ref.birthdaysErrorMessage,
      birthdaysErrorMessage = _ref$birthdaysErrorMe === void 0 ? '' : _ref$birthdaysErrorMe,
      changeKidsNumber = _ref.changeKidsNumber,
      changeKid = _ref.changeKid,
      dateFormat = _ref.dateFormat,
      dayPlaceholder = _ref.dayPlaceholder,
      hasChildcareSwitch = _ref.hasChildcareSwitch,
      _ref$informationLabel = _ref.informationLabel,
      informationLabel = _ref$informationLabel === void 0 ? '' : _ref$informationLabel,
      isShrink = _ref.isShrink,
      kids = _ref.kids,
      kidsAgeLabel = _ref.kidsAgeLabel,
      kidsAgeLimitLabel = _ref.kidsAgeLimitLabel,
      kidsLabel = _ref.kidsLabel,
      kidsValidationState = _ref.kidsValidationState,
      label = _ref.label,
      _ref$minAdultsNumber = _ref.minAdultsNumber,
      minAdultsNumber = _ref$minAdultsNumber === void 0 ? 1 : _ref$minAdultsNumber,
      monthPlaceholder = _ref.monthPlaceholder,
      setAdultsNumber = _ref.setAdultsNumber,
      validateKidsBirthdate = _ref.validateKidsBirthdate,
      yearPlaceholder = _ref.yearPlaceholder;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useState = Object(react["useState"])(kids.some(function (kid) {
    return kid.childcareIncluded;
  })),
      childcareIncluded = _useState[0],
      setChildcareIncluded = _useState[1];

  var handleKidsNumber = function handleKidsNumber(name, value) {
    if (changeKidsNumber) {
      changeKidsNumber(value);
    }
  };

  var handleKidAge = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(index, kid) {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!kid.birthdate) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return validateKidsBirthdate(index, kid);

            case 3:
              // $FlowFixMe
              if (Object(facetingUtils["j" /* isKidMinor */])(kid.birthdate)) {
                changeKid(index, kid);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleKidAge(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var maxPax = appContext.isSeller ? constants["y" /* MAX_PAX_SELLER */] : constants["x" /* MAX_PAX */];

  var getMaxAdultsAvailable = function getMaxAdultsAvailable() {
    return maxPax - kids.length;
  };

  var getMaxKidsAvailable = function getMaxKidsAvailable() {
    return maxPax - adultsNumber;
  };

  Object(react["useEffect"])(function () {
    kids.forEach(function (kid, index) {
      return changeKid(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
        childcareIncluded: childcareIncluded
      }));
    });
  }, [childcareIncluded]);
  return FilterWho_jsx("div", {
    "data-testid": "FilterWho",
    className: "FilterWho"
  }, FilterWho_jsx("div", {
    className: "p-px20"
  }, FilterWho_jsx("div", {
    className: "font-bold mb-px20 lg:text-center text-lg"
  }, label), FilterWho_jsx("div", {
    className: "lg:flex lg:items-center text-left"
  }, FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: adultsLabel,
    attendeeType: "adults",
    className: "lg:flex-auto lg:mx-px20 my-px20 lg:my-0 lg:w-1/2",
    dataTestId: "FilterWho-Adults",
    hasColumnLayout: isShrink,
    label: adultsLabel,
    max: getMaxAdultsAvailable(),
    min: minAdultsNumber,
    onChange: function onChange(name, value) {
      setAdultsNumber(value || 0);
    },
    value: adultsNumber
  }), FilterWho_jsx(InputNumber["a" /* InputNumber */], {
    ariaLabel: kidsLabel,
    attendeeType: "kids",
    className: "lg:flex-auto lg:mx-px20 my-px20 lg:my-0 lg:w-1/2",
    dataTestId: "FilterWho-Children",
    hasColumnLayout: isShrink,
    label: kidsLabel,
    max: getMaxKidsAvailable(),
    notes: kidsAgeLimitLabel,
    onChange: handleKidsNumber,
    value: kids.length
  }))), kids.length > 0 && hasChildcareSwitch && FilterWho_jsx("div", {
    className: "border-gray-light border-t-1 p-px10"
  }, FilterWho_jsx(InputSwitch["a" /* InputSwitch */], {
    inputTestId: "childcare-switch" // $FlowFixMe
    ,
    isChecked: childcareIncluded,
    label: addChildcareLabel,
    labelClassName: "font-bold text-blue",
    onChange: function onChange(name, isChecked) {
      return setChildcareIncluded(isChecked);
    } // $FlowFixMe
    ,
    value: childcareIncluded
  })), kids.length > 0 && FilterWho_jsx("div", {
    className: "border-gray-light border-t-1 p-px10"
  }, FilterWho_jsx("div", {
    className: "mb-px10"
  }, FilterWho_jsx("p", {
    className: "font-bold reset-paragraph text-base text-blue"
  }, kidsAgeLabel), informationLabel && FilterWho_jsx("p", {
    className: "reset-paragraph text-xs"
  }, informationLabel)), Object(kidsValidationStateUtils["c" /* hasKidWithoutAValidBirthdate */])(kidsValidationState) && birthdaysErrorMessage && FilterWho_jsx(FormFeedback["a" /* FormFeedback */], {
    isError: true,
    message: birthdaysErrorMessage
  }), FilterWho_jsx("div", {
    className: !isShrink ? 'lg:flex lg:flex-wrap lg:-mx-px10' : null
  }, kids.map(function (kid, index) {
    return FilterWho_jsx("div", {
      className: !isShrink ? 'flex-none lg:px-px10 w-full lg:w-1/2' : null,
      key: String(kid.birthdate) + String(index)
    }, FilterWho_jsx(InputDate_InputDate, {
      className: "mb-px10",
      dateFormat: dateFormat,
      onChange: function onChange(name, birthdate) {
        return handleKidAge(index, FilterWho_objectSpread(FilterWho_objectSpread({}, kid), {}, {
          birthdate: birthdate
        }));
      },
      placeholderDay: dayPlaceholder,
      placeholderMonth: monthPlaceholder,
      placeholderYear: yearPlaceholder,
      validationState: kidsValidationState[index],
      value: kid.birthdate
    }));
  }))));
};

/***/ }),

/***/ "ttFy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__("Km8e");

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {}

var validateFormat = function validateFormat(format) {};

if (false) {}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) { var printWarning; }

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ "u6DZ":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("YpBQ"),
    baseOrderBy = __webpack_require__("eHpp"),
    baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),

/***/ "uFXj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var createHTML = __webpack_require__("gIHd");
var forcedStringHTMLMethod = __webpack_require__("sHxg");

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ "uGNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SELECTED_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELECT_PROPOSAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return selectProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clearSelectedProposal; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rJ95");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nv//");
/* harmony import */ var _views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("47Eh");




var SELECT_PROPOSAL = 'SELECT_PROPOSAL';
var CLEAR_SELECTED_PROPOSAL = 'CLEAR_SELECTED_PROPOSAL';

function clearSelectedProposal() {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(CLEAR_SELECTED_PROPOSAL, {});
}

function selectProposal(proposalId, location, history) {
  var updatedUri = Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_2__[/* convertLocationToURI */ "c"])(location).setQuery(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["appQueryParameters"].booking.selectedProposalId, proposalId);
  Object(_views_booking_BookingEngine_utils__WEBPACK_IMPORTED_MODULE_3__[/* navigateInBookingEngine */ "e"])({
    location: updatedUri,
    history: history,
    replace: true
  });
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"])(SELECT_PROPOSAL, {
    proposalId: proposalId
  });
}



/***/ }),

/***/ "uGjT":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "uL19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addUserInfosToAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getCustomerSearchResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterProposalBySamePackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAdditionalTransportsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getCityTransportsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getIsLoadingAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getIsLoadingAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getProposals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAdditionalAccommodations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdditionalAccommodationsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAdditionalAccommodationsError; });
/* unused harmony export getFilteredAdditionalAccommodations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getFilteredAdditionalAccommodationsSets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAdditionalTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getSearchCriteriaTransports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getSearchCriteriaTransportsInbound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getAdditionalTransportsFilters; });
/* unused harmony export getFilteredAdditionalTransports */
/* unused harmony export getAdditionalTransportsSorters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getReservedServicesByAttendee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getSelectedProposalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getCurrentResort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getPaymentProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getProposalsWithMappedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getCurrentProposal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getCurrentTotalPrice; });
/* unused harmony export getProposalHasAnyEquipmentForRent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getDetailedAttendees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAttendeesWithInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getConnectedUserInfoSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return proposalsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getInsurancesStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getStreetViews; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vfdX");
/* harmony import */ var core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ZVkB");
/* harmony import */ var core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_entries__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("1IsZ");
/* harmony import */ var core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_values__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("zjfJ");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("hqKg");
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(reselect__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("oL6k");
/* harmony import */ var _user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("apzf");
/* harmony import */ var _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("ldK3");



















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var bookingSelector = function bookingSelector(_ref) {
  var booking = _ref.booking;
  return booking || {};
};

var additionalTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref2) {
  var additionalTransports = _ref2.additionalTransports;
  return additionalTransports || {};
});
var getCityTransportsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref3) {
  var additionalTransports = _ref3.additionalTransports;
  return additionalTransports.transports.cityTransports || {};
});
var getPaymentProviders = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref4) {
  var paymentProviders = _ref4.paymentProviders;
  return paymentProviders;
});
var getInsurancesStore = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref5) {
  var insurance = _ref5.insurance;
  return insurance;
});
var getSearchCriteriaTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref6) {
  var searchCriteria = _ref6.searchCriteria;
  return searchCriteria;
});
var getSearchCriteriaTransportsInbound = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref7) {
  var searchCriteria = _ref7.searchCriteria;
  return searchCriteria && searchCriteria[0];
});
var getAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref8) {
  var transports = _ref8.transports;
  return transports;
});
var getAdditionalTransportsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref9) {
  var filters = _ref9.filters;
  return filters;
});
var getFilteredAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref10) {
  var filteredTransports = _ref10.filteredTransports;
  return filteredTransports;
});
var getAdditionalTransportsSorters = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref11) {
  var sorters = _ref11.sorters;
  return sorters || [];
});
var getAdditionalTransportsError = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref12) {
  var error = _ref12.error;
  return error;
});
var getIsLoadingAdditionalTransports = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalTransportsSelector, function (_ref13) {
  var isLoading = _ref13.isLoading;
  return isLoading;
});
var additionalAccommodationsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref14) {
  var additionalAccommodations = _ref14.additionalAccommodations;
  return additionalAccommodations || {};
});
var getIsLoadingAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalAccommodationsSelector, function (_ref15) {
  var isLoading = _ref15.isLoading;
  return isLoading;
});
var getAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalAccommodationsSelector, function (_ref16) {
  var accommodationsSets = _ref16.accommodationsSets;
  return accommodationsSets;
});
var getAdditionalAccommodationsFilters = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalAccommodationsSelector, function (_ref17) {
  var filters = _ref17.filters;
  return filters;
});
var getAdditionalAccommodationsError = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalAccommodationsSelector, function (_ref18) {
  var error = _ref18.error;
  return error;
});
var getFilteredAdditionalAccommodations = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(additionalAccommodationsSelector, function (_ref19) {
  var filteredAccommodations = _ref19.filteredAccommodations;
  return filteredAccommodations;
});
var getFilteredAdditionalAccommodationsSets = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(getFilteredAdditionalAccommodations, getAdditionalAccommodations, function (filteredAccommodations, additionalAccommodations) {
  return filteredAccommodations && filteredAccommodations.length > 0 ? filteredAccommodations : additionalAccommodations;
});
var proposalsSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref20) {
  var proposals = _ref20.proposals;
  return proposals || [];
});
var getCurrentResort = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref21) {
  var resort = _ref21.resort;
  return resort;
});

var findAttendeeByNeolid = function findAttendeeByNeolid(attendees, neolid) {
  return attendees.find(function (attendee) {
    return attendee.neolid === neolid;
  });
};

var getSelectedProposalId = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref22) {
  var selectedProposalId = _ref22.selectedProposalId;
  return selectedProposalId;
});
/**
 * It should be getSelectedProposal but there is a selector getSelectedProposal
 * witch get the proposal from paymentInfoSelector
 * I do not know why...
 */

var getCurrentProposal = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref23) {
  var proposals = _ref23.proposals,
      selectedProposalId = _ref23.selectedProposalId;
  return (
    /**
     * return the selected proposal if found,
     * if not (for any reason) the default proposal for keeping the return shape value consistent
     */
    proposals.find(function (proposal) {
      return proposal.id === selectedProposalId;
    }) || Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_20__[/* getDefaultProposal */ "f"])(proposals)
  );
});
var getCurrentTotalPrice = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(getCurrentProposal, function (proposal) {
  return proposal.price.total.value;
});

var filterProposalBySamePackage = function filterProposalBySamePackage(proposals, selectedProposal) {
  var errorsProposals = proposals.filter(function (proposal) {
    return proposal.errorCode;
  });

  if (errorsProposals.length) {
    return errorsProposals;
  }

  return proposals.filter(function (item) {
    var _item$accommodations = item.accommodations,
        accommodations = _item$accommodations === void 0 ? [] : _item$accommodations,
        packageId = item.packageId;
    return accommodations.length && packageId === selectedProposal.packageId;
  });
};

var getProposals = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(proposalsSelector, getCurrentProposal, filterProposalBySamePackage);
var getProposalsWithMappedAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(getProposals, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"], function (proposals, tripInformation) {
  if (!proposals) {
    return proposals;
  }

  return proposals.map(function (proposal) {
    return _objectSpread(_objectSpread({}, proposal), {}, {
      attendees: _objectSpread(_objectSpread({}, proposal.attendees), {}, {
        list: proposal.attendees.list.map(function (attendee) {
          // if there is a birthdate it's a children otherwise it's an adult
          var attendeeData = attendee.birthdate ? findAttendeeByNeolid(tripInformation.kids, attendee.customerId) : findAttendeeByNeolid(tripInformation.adults, attendee.customerId);

          if (!attendeeData) {
            return attendee;
          }

          return _objectSpread(_objectSpread({}, attendee), {}, {
            firstName: attendeeData.firstName,
            lastName: attendeeData.lastName
          });
        })
      })
    });
  });
});
var getProposalHasAnyEquipmentForRent = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref24) {
  var rentalEquipments = _ref24.rentalEquipments;
  return rentalEquipments.hasAnyEquipmentForRent;
});
var getAttendees = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(getCurrentProposal, function (_ref25) {
  var attendees = _ref25.attendees;
  return attendees;
});
var getConnectedUserInfoSelector = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(_user_info_userInfo_selectors__WEBPACK_IMPORTED_MODULE_21__[/* userInfoSelector */ "a"], function (connectedUserInfo) {
  return connectedUserInfo.isQuickLoggedIn ? {} : Object(lodash__WEBPACK_IMPORTED_MODULE_19__["omit"])(_objectSpread(_objectSpread({}, connectedUserInfo), {}, {
    birthdate: connectedUserInfo.dateOfBirth,
    neolid: connectedUserInfo.neolaneId,
    // harmonize the neolid between user and seller
    mobile: connectedUserInfo.mobilePhoneNumber
  }), ['dateOfBirth', 'GMNumber', 'homePhoneNumber', 'isProspect', 'neolaneId', 'unicodeCivility', 'expirationDate', 'mobilePhoneNumber']);
});
var getStreetViews = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref26) {
  var streetViews = _ref26.streetViews;
  return streetViews;
});
var getSuggestions = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (_ref27) {
  var suggestions = _ref27.suggestions;
  return suggestions;
});
/**
 * The comparator does not put proposal in store
 * We need to use this function instead of the getAttendeesWithInfos selector
 */

var addUserInfosToAttendees = function addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo) {
  var getSortAttendeesByGmNumber = function getSortAttendeesByGmNumber(attendee1, attendee2) {
    if (!attendee1.gmNumber || !attendee2.gmNumber) {
      return 0;
    }

    return tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee1.gmNumber;
    }) - tripAttendees.adults.findIndex(function (attendee) {
      return attendee.gmNumber === attendee2.gmNumber;
    });
  }; // defensive code if store is not available (ex: confirmation page)


  if (!tripAttendees || !proposalAttendees) {
    return {
      adults: [],
      children: []
    };
  }

  var sortedAdultsAttendees = tripAttendees.adults.sort(getSortAttendeesByGmNumber);
  var adultsList = proposalAttendees.adults.map(function (adult, index) {
    return _objectSpread(_objectSpread(_objectSpread({}, index === 0 ? connectedUserInfo : null), adult), Object(lodash__WEBPACK_IMPORTED_MODULE_19__["omitBy"])(sortedAdultsAttendees[index], function (value) {
      return value === undefined;
    }));
  });
  var childrenList = proposalAttendees.children.map(function (child) {
    return _objectSpread(_objectSpread({}, child), Object(lodash__WEBPACK_IMPORTED_MODULE_19__["omitBy"])(tripAttendees.kids.find(function (kid) {
      if (kid.id) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.id === child.id;
      }

      if (kid.neolid && child.customerId) {
        return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* apiDateToTimestamp */ "d"])(child.birthdate) && kid.neolid === child.customerId;
      }

      return kid.birthdate === Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_23__[/* apiDateToTimestamp */ "d"])(child.birthdate);
    }), function (value, key) {
      return value === undefined || key === 'birthdate';
    }));
  }).sort(getSortAttendeesByGmNumber).sort(function (child1, child2) {
    // for seller set children with neolid (so with his fields already filled) first
    if (child1.neolid && !child2.neolid) {
      return -1;
    }

    if (!child1.neolid && child2.neolid) {
      return 1;
    }

    return 0;
  });
  return {
    adults: adultsList,
    children: childrenList
  };
};
var getCustomerSearchResult = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(bookingSelector, function (booking) {
  return booking.customerSearch;
});

var addSearchDataToAttendees = function addSearchDataToAttendees(attendeesWithInfo, attendeesFromSearch) {
  var enrichedAdults = attendeesWithInfo.adults.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.adults[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  var enrichedChildren = attendeesWithInfo.children.map(function (attendee, index) {
    var attendeeFromSearch = attendeesFromSearch.children[index];
    return _objectSpread(_objectSpread({}, attendee), attendeeFromSearch ? _objectSpread(_objectSpread({}, attendeeFromSearch), {}, {
      /**
       * attendeeFromSearch has a "fake" id which is in reality customerId (see commonProfileFieldsFragment)
       * we want to have the proposal attendee id here because it's what the api is waiting for
       *  */
      id: attendee.id,
      customerId: attendeeFromSearch.id
    }) : null);
  });
  return {
    adults: enrichedAdults,
    children: enrichedChildren
  };
};

var enrichAttendeesWithAvailableData = function enrichAttendeesWithAvailableData(proposalAttendees, tripAttendees, connectedUserInfo, searchResult) {
  var attendeesWithInfo = addUserInfosToAttendees(proposalAttendees, tripAttendees, connectedUserInfo);
  return searchResult && searchResult.data ? addSearchDataToAttendees(attendeesWithInfo, searchResult.data) : attendeesWithInfo;
};

var getAttendeesWithInfos = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(getAttendees, _trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_22__[/* tripInformationSelector */ "d"], getConnectedUserInfoSelector, getCustomerSearchResult, enrichAttendeesWithAvailableData);
var getReservedServicesByAttendee = Object(reselect__WEBPACK_IMPORTED_MODULE_18__["createSelector"])(getCurrentProposal, getAttendeesWithInfos, function (_ref28, attendeesWithInfos) {
  var additionalServices = _ref28.additionalServices; // defensive code if store is not available (ex: confirmation page)

  if (!additionalServices || !attendeesWithInfos) {
    return [];
  }

  var attendeesWithServiceRented = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.activities), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(additionalServices.rentals)).reduce(function (acc, service) {
    var pricingInfo = service.pricingInfo,
        productInfo = service.productInfo;
    pricingInfo.attendees.forEach(function (attendee) {
      var product = {
        price: attendee.rentedAmount.value,
        services: [service]
      };

      if (attendee.rentedAmount.value > 0) {
        if (!acc[attendee.id]) {
          acc[attendee.id] = Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])({}, productInfo.id, _objectSpread({}, product));
        } else if (!acc[attendee.id][productInfo.id]) {
          acc[attendee.id][productInfo.id] = _objectSpread({}, product);
        } else {
          acc[attendee.id][productInfo.id].services.push(service);
        }
      }
    });
    return acc;
  }, {});
  return Object.entries(attendeesWithServiceRented).reduce(function (reservedServicesByAttendee, _ref29) {
    var _ref30 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_ref29, 2),
        id = _ref30[0],
        rentedServices = _ref30[1];

    var childIndex = attendeesWithInfos.children.findIndex(function (attendee) {
      return attendee.id === id;
    });

    if (childIndex > -1) {
      return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.children[childIndex]), {}, {
        id: id,
        index: childIndex + 1,
        isAdult: false,
        // $FlowFixMe 🤷‍️
        rentedServices: Object.values(rentedServices)
      })]);
    }

    var adultIndex = attendeesWithInfos.adults.findIndex(function (attendee) {
      return attendee.id === id;
    });
    return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(reservedServicesByAttendee), [_objectSpread(_objectSpread({}, attendeesWithInfos.adults[adultIndex]), {}, {
      id: id,
      index: adultIndex + 1,
      isAdult: true,
      // $FlowFixMe 🤷‍️
      rentedServices: Object.values(rentedServices)
    })]);
  }, []).sort(function (a, b) {
    if (a.isAdult && !b.isAdult) {
      return -1;
    }

    if (!a.isAdult && b.isAdult) {
      return 1;
    }

    return a.index - b.index;
  });
});

var getDetailedAttendees = function getDetailedAttendees(_ref31) {
  var booking = _ref31.booking;
  return booking.attendees;
};



/***/ }),

/***/ "uLWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: Grid

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/Responsive.jsx
var Responsive = __webpack_require__("Gqxm");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.themes.js
var themes = {
  "default": {
    thRoot: 'flex pt-px10 w-full',
    thContent: 'bg-white flex flex-wrap relative content-center h-full w-full',
    thButton: 'absolute bottom-0 flex left-0 justify-center w-full',
    thPlaceholders: 'w-full flex'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/more-results/MoreResults.jsx
var __jsx = react_default.a.createElement;








var PLACEHOLDER_URLS = ['https://ns.clubmed.com/it/2019/shop/dummy.png', 'https://ns.clubmed.com/it/2019/shop/dummy2.png', 'https://ns.clubmed.com/it/2019/shop/dummy3.png'];
var overallMaxNumberOfPlaceholders = 3;
var MoreResults_MoreResults = function MoreResults(_ref) {
  var className = _ref.className,
      isLoading = _ref.isLoading,
      _ref$number = _ref.number,
      number = _ref$number === void 0 ? 0 : _ref$number,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? lodash["noop"] : _ref$onClick,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      maxPlaceholders = _ref.maxPlaceholders;

  if (!number) {
    return null;
  }

  var _themes$theme = themes[theme],
      thContent = _themes$theme.thContent,
      thButton = _themes$theme.thButton,
      thPlaceholders = _themes$theme.thPlaceholders,
      thRoot = _themes$theme.thRoot;

  var renderPlaceholders = function renderPlaceholders() {
    var placeholders = [];
    var numberOfPlaceholders = Math.min(maxPlaceholders, overallMaxNumberOfPlaceholders);

    for (var i = 0; i < number && i < numberOfPlaceholders; i++) {
      placeholders.push(__jsx("div", {
        className: "px-px10 w-full sm:w-1/2 md:w-1/3 lg:w-1/3",
        key: "product-".concat(i)
      }, __jsx(Image["b" /* default */], {
        className: "fadeIn",
        imageUrl: PLACEHOLDER_URLS[i % 3],
        key: PLACEHOLDER_URLS[i % 3] + i,
        ratioKey: ratios_utils["a" /* default */].R_1_BY_5,
        ratioDisplay: 1 / 3
      })));
    }

    return placeholders;
  };

  return __jsx("div", {
    className: classnames_default()(className, thRoot)
  }, __jsx("div", {
    className: thContent
  }, __jsx("div", {
    className: thPlaceholders
  }, renderPlaceholders(), __jsx("div", {
    style: {
      position: 'absolute',
      bottom: '0',
      left: '0',
      right: '0',
      top: '0',
      background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%)'
    }
  })), __jsx("div", {
    className: thButton
  }, __jsx(Button["a" /* Button */], {
    onClick: onClick,
    dataTestId: "more-results-btn",
    iconRight: {
      name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH
    },
    minWidth: "220px",
    isLoading: isLoading
  }, __jsx("span", {
    "data-testid": "Moreresults-number"
  }, number), " ", text))));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/grid/Grid.jsx
















var Grid_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






function getWidth() {
  var fraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return fraction < 2 || fraction > 6 ? 'w-full' : "w-1/".concat(fraction);
}

function filterContext(hasOneRemaining, itemsByLine, isSeeMoreVisible) {
  return function (item, index) {
    if (isSeeMoreVisible) {
      return index < itemsByLine;
    }

    return true;
  };
}

var Grid_Grid = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Grid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      isExpanded: !_this.props.hasSeeMore
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickSeeMore", function () {
      var _this$props = _this.props,
          _this$props$totalNumb = _this$props.totalNumberToDisplay,
          totalNumberToDisplay = _this$props$totalNumb === void 0 ? 0 : _this$props$totalNumb,
          _this$props$getChildr = _this$props.getChildren,
          getChildren = _this$props$getChildr === void 0 ? function () {
        return Promise.resolve({});
      } : _this$props$getChildr,
          _this$props$isSynchro = _this$props.isSynchronousGrid,
          isSynchronousGrid = _this$props$isSynchro === void 0 ? false : _this$props$isSynchro;

      if (isSynchronousGrid || totalNumberToDisplay === _this.getItemsByLine()) {
        _this.setState({
          isExpanded: true
        });
      }

      if (totalNumberToDisplay > _this.getItemsByLine()) {
        getChildren();
      }
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Grid, [{
    key: "getGrid",
    value: function getGrid() {
      var _this$props$grid = this.props.grid,
          grid = _this$props$grid === void 0 ? {} : _this$props$grid;
      var desktop = grid.desktop,
          tablet = grid.tablet,
          phablet = grid.phablet,
          mobile = grid.mobile;
      return "".concat(getWidth(mobile), " sm:").concat(getWidth(phablet), " md:").concat(getWidth(tablet), " lg:").concat(getWidth(desktop));
    }
  }, {
    key: "getItemsByLine",
    value: function getItemsByLine() {
      var _this$props2 = this.props,
          _this$props2$display = _this$props2.display,
          display = _this$props2$display === void 0 ? {} : _this$props2$display,
          _this$props2$responsi = _this$props2.responsive,
          responsive = _this$props2$responsi === void 0 ? {} : _this$props2$responsi;
      var _display$desktop = display.desktop,
          desktop = _display$desktop === void 0 ? 1 : _display$desktop,
          _display$tablet = display.tablet,
          tablet = _display$tablet === void 0 ? 1 : _display$tablet,
          _display$phablet = display.phablet,
          phablet = _display$phablet === void 0 ? 1 : _display$phablet,
          _display$mobile = display.mobile,
          mobile = _display$mobile === void 0 ? 1 : _display$mobile;
      var _responsive$isBrowser = responsive.isBrowserGreaterThan,
          isBrowserGreaterThan = _responsive$isBrowser === void 0 ? {} : _responsive$isBrowser;

      if (isBrowserGreaterThan.M && desktop > -1) {
        return desktop;
      }

      if (isBrowserGreaterThan.S && tablet > -1) {
        return tablet;
      }

      if (isBrowserGreaterThan.XS && phablet > -1) {
        return phablet;
      }

      return mobile;
    }
  }, {
    key: "getNumberOfItemsByLineExcludingSeeMore",
    value: function getNumberOfItemsByLineExcludingSeeMore() {
      return this.getItemsByLine();
    }
  }, {
    key: "getRest",
    value: function getRest() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          totalNumberToDisplay = _this$props3.totalNumberToDisplay;
      return totalNumberToDisplay ? totalNumberToDisplay - this.getItemsByLine() : react["Children"].count(children) - this.getItemsByLine();
    }
  }, {
    key: "getSeeMore",
    value: function getSeeMore() {
      var _this$props4 = this.props,
          hasSeeMore = _this$props4.hasSeeMore,
          isLoading = _this$props4.isLoading,
          seeMore = _this$props4.seeMore;
      return hasSeeMore && this.getRest() > 0 && !this.state.isExpanded ? Grid_jsx(MoreResults_MoreResults, Object(esm_extends["a" /* default */])({}, seeMore, {
        className: "h-full",
        isLoading: isLoading,
        number: this.getRest(),
        onClick: this.onClickSeeMore,
        grid: this.getGrid(),
        maxPlaceholders: this.getItemsByLine()
      })) : null;
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this2 = this;

      var hasOneRemaining = this.getRest() === 1;
      var filterItem = filterContext(hasOneRemaining, this.getNumberOfItemsByLineExcludingSeeMore(), !this.state.isExpanded);
      return react["Children"].toArray(this.props.children).filter(filterItem).map(function (item) {
        return Grid_jsx("div", {
          className: classnames_default()('fadeIn p-px10', _this2.getGrid(), _this2.props.childrenClassName),
          "data-testid": "Grid-item",
          key: item.key
        }, item);
      });
    }
  }, {
    key: "getItems",
    value: function getItems() {
      return [].concat(Object(toConsumableArray["a" /* default */])(this.getChildren()), [this.getSeeMore()]).filter(function (i) {
        return i;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isLoading = _ref.isLoading;

      if (isLoading && !this.props.isLoading && !this.state.isExpanded) {
        this.setState({
          isExpanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var items = this.getItems();
      return items.length ? Grid_jsx("div", {
        className: classnames_default()(className, 'flex flex-wrap -m-px10'),
        "data-testid": "grid"
      }, items.map(function (item, index) {
        return (
          /* eslint-disable react/no-array-index-key */
          Grid_jsx(react["Fragment"], {
            key: index
          }, item)
        );
      })) : null;
    }
  }]);

  return Grid;
}(react["Component"]);

Object(defineProperty["a" /* default */])(Grid_Grid, "defaultProps", {
  display: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  },
  getChildren: function getChildren() {
    return Promise.resolve({});
  },
  grid: {
    mobile: 1,
    phablet: 2,
    tablet: 3,
    desktop: 3
  }
});

/* harmony default export */ var grid_Grid = __webpack_exports__["a"] = (Object(Responsive["a" /* default */])(Grid_Grid));

/***/ }),

/***/ "uMuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DayPriceDoubleSeasonPopin; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("MvUL");
/* harmony import */ var core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("fGyu");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _router_useRouter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("7jla");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("Mkub");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("UCZK");
/* harmony import */ var _product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("hA0C");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("/FsK");
/* harmony import */ var _utils_keyCodes__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("05v4");
/* harmony import */ var _utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("nv//");


















var __jsx = react__WEBPACK_IMPORTED_MODULE_18___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */










var DayPriceDoubleSeasonPopin = function DayPriceDoubleSeasonPopin(_ref) {
  var availability = _ref.availability,
      product = _ref.product,
      setInvisible = _ref.setInvisible,
      setIsMouseOverDoubleSeasonPopin = _ref.setIsMouseOverDoubleSeasonPopin,
      statusMessageKey = _ref.statusMessageKey,
      trackingData = _ref.trackingData;

  var _useRouter = Object(_router_useRouter__WEBPACK_IMPORTED_MODULE_19__[/* useRouter */ "a"])(),
      location = _useRouter.location,
      history = _useRouter.history;

  var uri = Object(_frameworks_dynamic_link_DynamicLinkUtil__WEBPACK_IMPORTED_MODULE_21__[/* getSpaUrl */ "b"])(Object(_utils_uri_uriUtils__WEBPACK_IMPORTED_MODULE_27__[/* convertLocationToURI */ "c"])(location)).toString();
  var doubleSeasonPopinMessageKey = "booking.priceCalendar.priceStatus.".concat(availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_25__[/* API_SIBLING_SUMMER */ "h"] ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter');
  var productCountry = product.destination.country,
      _product$href = product.href,
      href = _product$href === void 0 ? '' : _product$href,
      productName = product.name,
      iconName = product.resortId;
  var splittedHref = href.split('/');
  var siblingHref = [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"])(splittedHref.slice(0, splittedHref.length - 1)), [availability === _utils_api_availability_constants__WEBPACK_IMPORTED_MODULE_25__[/* API_SIBLING_SUMMER */ "h"] ? 's' : 'w']).join('/');

  var handleBlur = function handleBlur() {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(function () {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  var handleFocus = function handleFocus() {
    return setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);
  };

  return __jsx("div", {
    className: "bg-white cursor-default flex flex-col items-center justify-center pointer-events-auto",
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseOver: handleFocus,
    onMouseLeave: handleBlur,
    onKeyDown: function onKeyDown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.keyCode === _utils_keyCodes__WEBPACK_IMPORTED_MODULE_26__[/* ENTER */ "f"]) {
        history.pushRoute(uri.replace(href, siblingHref));
      } else {
        handleBlur();
      }
    },
    tabIndex: -1
  }, __jsx("div", {
    className: "flex flex-col justify-center items-center"
  }, __jsx(_product_logo_ProductLogo__WEBPACK_IMPORTED_MODULE_23__[/* ProductLogo */ "a"], {
    className: "mt-px20",
    iconName: iconName,
    productCountry: productCountry,
    productName: productName,
    theme: "calendar"
  }), __jsx("span", {
    className: "bg-southSea font-bold mt-px10 px-px5 py-px pointer-events-none rounded-tiny text-white text-xs uppercase cursor-pointer"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])(statusMessageKey))), __jsx("span", {
    className: "mt-px20 pl-px20 pr-px20 font-normal text-gray-darker text-sm leading-tight sm:leading-normal text-center sm:rtl:text-left"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])(doubleSeasonPopinMessageKey)), __jsx("div", {
    className: "px-px20 pt-px40 pb-px30 sm:p-px20 w-full"
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_20__[/* Button */ "a"], {
    className: "pointer-events-auto w-full",
    colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_22__[/* COLORS */ "a"].BOOKING,
    colorBorder: _utils_color_colors__WEBPACK_IMPORTED_MODULE_22__[/* COLORS */ "a"].BOOKING,
    dataTestId: "DayWithPrice-DoubleSeasonPopin-seeOtherSeason",
    onBlur: handleBlur,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      history.pushRoute(uri.replace(href, siblingHref));
    },
    onFocus: handleFocus,
    sendTrackingDataBeforeOnClick: true,
    trackingData: _objectSpread({
      categoryGA: 'resort',
      labelGA: 'switchSeason'
    }, trackingData),
    size: "medium",
    tabIndex: 0
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_24__[/* t */ "h"])('booking.priceCalendar.priceStatus.siblingButton'))));
};

/***/ }),

/***/ "uRnh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return themes; });
var themes = {
  "default": {
    thRoot: 'cursor-pointer flex items-center font-bold font-sans leading-one no-underline text-sm text-white',
    thIcon: 'rtl:mr-px5',
    thIconWidth: '2.5rem',
    thSText: 'text-base uppercase',
    thCustomText1: 'text-base uppercase'
  },
  black: {
    thRoot: 'flex justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-gray-darker text-md',
    thIcon: 'text-gray-darker mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '2rem',
    thCustomText2: 'text-booking'
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row items-center text-center lg:text-initial text-blue',
    thIcon: 'lg:flex-shrink-0 mb-px10 lg:mb-0 lg:rtl:mr-px10',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-gray-darker text-base',
    thCustomText0: 'font-bold text-blue text-md',
    thCustomText1: 'font-bold text-blue text-md'
  },
  contact: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.75rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-light'
  },
  contact2: {
    thRoot: 'flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '3rem',
    thCustomText1: 'font-normal text-base text-gray-light',
    thCustomText2: 'font-normal text-base text-gray-darker'
  },
  smallFooterLite: {
    thRoot: 'cursor-pointer flex flex-col sm:flex-row items-center sm:items-start font-bold font-sans leading-tight no-underline text-center sm:text-initial text-md text-blue',
    thIcon: 'text-blue mb-px5 sm:mb-0 sm:rtl:mr-px10',
    thIconWidth: '1.2rem',
    thSText: 'hidden sm:block font-normal text-base text-gray-darker'
  },
  search: {
    thRoot: 'cursor-pointer items-center font-sans no-underline text-sm text-white'
  }
};

/***/ }),

/***/ "uYlf":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "v78B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navigationTabsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var navigationTabsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* NAVIGATION_TABS */ "A"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* CORE_GET_COMMON_I18N */ "d"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "v7Z5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tourPracticalInformationResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var tourPracticalInformationResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TOUR_PRACTICAL_INFORMATION */ "Hb"],
  resolve: function resolve(appContext, props) {
    var productId = props.resortId;
    var query = "query {\n      resort(resortId:\"".concat(productId, "\"){\n        practicalInformation {\n          healthFormalities\n          passportAndVisas\n          includedInPackage\n          excludedInPackage\n        }\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_TOUR_PRACTICAL_INFO */ "Dc"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "vIa8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ activeFacetsSelector; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ bannersSelector; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ facetingCriteriaSelector; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ facetsSelector; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* binding */ filteredProductsSelector; });
__webpack_require__.d(__webpack_exports__, "l", function() { return /* binding */ recommandedProductsSelector; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* binding */ filteredProductsCountSelector; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* binding */ filteredProductsSeasonsSelector; });
__webpack_require__.d(__webpack_exports__, "h", function() { return /* binding */ filtersSelector; });
__webpack_require__.d(__webpack_exports__, "i", function() { return /* binding */ getFacetingProductIds; });
__webpack_require__.d(__webpack_exports__, "j", function() { return /* binding */ getFiltersSelector; });
__webpack_require__.d(__webpack_exports__, "k", function() { return /* binding */ getKidsValidationState; });
__webpack_require__.d(__webpack_exports__, "m", function() { return /* binding */ searchQuerySelector; });

// UNUSED EXPORTS: facetingSelector, facetingPricesSelector

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("ZVkB");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var lib = __webpack_require__("hqKg");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var constants = __webpack_require__("sW3P");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/utils/faceting/facetingFilters.js













var facetingFilters_FacetFilters = /*#__PURE__*/function () {
  function FacetFilters(list) {
    Object(classCallCheck["a" /* default */])(this, FacetFilters);

    Object(defineProperty["a" /* default */])(this, "_list", void 0);

    this._list = list || [];
  }

  Object(createClass["a" /* default */])(FacetFilters, [{
    key: "addFilter",
    value: function addFilter(filter) {
      this._list.push({
        id: filter.id,
        name: filter.name
      });

      return this;
    }
  }, {
    key: "addFilters",
    value: function addFilters(filters) {
      if (filters) {
        filters.map(this.addFilter.bind(this));
      }

      return this;
    }
  }, {
    key: "removeFilters",
    value: function removeFilters(ids) {
      this._list = this._list.filter(function (item) {
        return !Object(lodash["includes"])(ids, item.id);
      });
      return this;
    }
  }, {
    key: "addChildcareFilters",
    value: function addChildcareFilters(args) {
      var kids = args.kids,
          _args$childcareFacets = args.childcareFacets,
          facets = _args$childcareFacets === void 0 ? [] : _args$childcareFacets,
          departureDate = args.departureDate;
      var childcareFacets = Object(lodash["isEmpty"])(facets) ? constants["g" /* DEFAULT_CHILDCARE_FACETS */].map(function (f) {
        return {
          label: f,
          value: f
        };
      }) : facets;
      var childcareRanges = childcareFacets.map(function (_ref) {
        var name = _ref.label;
        var facetRange = name.split('-');
        return {
          name: name,
          min: parseInt(facetRange[0], 10),
          max: parseInt(facetRange[1], 10)
        };
      });
      var childcareFilters = kids.filter(function (_ref2) {
        var childcareIncluded = _ref2.childcareIncluded;
        return childcareIncluded;
      }).map(function (_ref3) {
        var birthdate = _ref3.birthdate;
        var kidAgeInMonths = Object(facetingUtils["h" /* getKidAgeInMonths */])({
          birthdate: birthdate,
          departureDate: departureDate
        });
        var matchingFacet = childcareRanges.find(function (_ref4) {
          var min = _ref4.min,
              max = _ref4.max;
          return Object(lodash["inRange"])(kidAgeInMonths, min, max + 1);
        }); // lodash inRange exludes the max value

        if (!matchingFacet || !matchingFacet.name) {
          return null;
        }

        return {
          id: constants["d" /* CHILDCARE_FACET_ID */],
          name: matchingFacet.name
        };
      }).filter(Boolean);
      this._list = this._list.concat(Object(lodash["uniqWith"])(childcareFilters, lodash["isEqual"]));
      return this;
    }
  }, {
    key: "addAdultOnlyFilter",
    value: function addAdultOnlyFilter() {
      var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return Object(lodash["isEmpty"])(kids) ? this : this.addFilter({
        id: constants["c" /* ADULTS_ONLY_FACET_ID */],
        name: false
      });
    }
  }, {
    key: "value",
    value: function value() {
      return this._list.map(function (item) {
        return Object(lodash["pick"])(item, ['id', 'name']);
      });
    }
  }]);

  return FacetFilters;
}();
// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var storeHelper = __webpack_require__("Jsmy");

// CONCATENATED MODULE: ./src/client/store/faceting/faceting.selector.js









/* eslint-disable max-params */








var facetingSelector = function facetingSelector(_ref) {
  var faceting = _ref.faceting;
  return faceting || {};
};

var activeFacetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref2) {
  var activeFacets = _ref2.activeFacets;
  return activeFacets || {};
});
var searchQuerySelector = Object(lib["createSelector"])(facetingSelector, function (_ref3) {
  var query = _ref3.query;
  return query || {
    label: ''
  };
});
var facetsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref4) {
  var facets = _ref4.facets;
  return facets || [];
});
var filtersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref5) {
  var filters = _ref5.filters;
  return filters || [];
});
var facetingPricesSelector = Object(lib["createSelector"])(facetingSelector, function (_ref6) {
  var prices = _ref6.prices;
  return prices;
});
var filteredProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref7) {
  var _ref7$products = _ref7.products,
      products = _ref7$products === void 0 ? [] : _ref7$products;
  return products;
});
var recommandedProductsSelector = Object(lib["createSelector"])(facetingSelector, function (_ref8) {
  var _ref8$recommandedProd = _ref8.recommandedProducts,
      recommandedProducts = _ref8$recommandedProd === void 0 ? [] : _ref8$recommandedProd;
  return recommandedProducts;
});
var bannersSelector = Object(lib["createSelector"])(facetingSelector, function (_ref9) {
  var banners = _ref9.banners;
  return banners || [];
});
var filteredProductsCountSelector = Object(lib["createSelector"])(facetingSelector, function (_ref10) {
  var _ref10$products = _ref10.products,
      products = _ref10$products === void 0 ? [] : _ref10$products;
  return products.length;
});
var filteredProductsSeasonsSelector = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.reduce(function (seasons, product) {
    return seasons.includes(product.seasonName) ? seasons : [].concat(Object(toConsumableArray["a" /* default */])(seasons), [product.seasonName]);
  }, []);
});
var getFacetingProductIds = Object(lib["createSelector"])(filteredProductsSelector, function () {
  var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return products.map(function (_ref11) {
    var id = _ref11.id;
    return id;
  });
});
var getKidsValidationState = Object(lib["createSelector"])(facetingSelector, function (_ref12) {
  var _ref12$kidsValidation = _ref12.kidsValidationState,
      kidsValidationState = _ref12$kidsValidation === void 0 ? [] : _ref12$kidsValidation;
  return kidsValidationState;
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * representing active facets to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var activeFacetsCriteriaSelector = Object(lib["createSelector"])(activeFacetsSelector, function (activeFacets) {
  return Object.keys(activeFacets).reduce(function (acc, categoryId) {
    Object.entries(activeFacets[categoryId]).map(function (_ref13) {
      var _ref14 = Object(slicedToArray["a" /* default */])(_ref13, 2),
          filter = _ref14[0],
          isSelected = _ref14[1];

      if (isSelected) {
        acc.push({
          id: categoryId,
          name: filter
        });
      }
    });
    return acc;
  }, []);
});
/**
 * Returns an array of objects [{id: <filter_name>, name: <filter_value>}]
 * containing aggregation of both facets and criterias to send to Pertimm.
 *
 * Example:
 * ```json
 * [
 *   { id: 'facette_adult_only', name: false },
 *   { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 * ]
 * ```
 */

var getFiltersSelector = Object(lib["createSelector"])(storeHelper["c" /* getKids */], tripCriteria_selector["b" /* getDepartureDate */], activeFacetsCriteriaSelector, filtersSelector, tripCriteria_selector["a" /* getDepartureCity */], facetsSelector, function (kids, departureDate, activeFacets, filters, departureCity, facets) {
  var allFilters = new facetingFilters_FacetFilters(filters).removeFilters([constants["a" /* ACTIVITIES_FACET_ID */], constants["c" /* ADULTS_ONLY_FACET_ID */], constants["d" /* CHILDCARE_FACET_ID */], constants["i" /* DEPARTURE_CITY_FACET_ID */]].concat(Object(toConsumableArray["a" /* default */])(constants["q" /* FILTERABLE_FACETS_IDS */]))).addAdultOnlyFilter(kids).addChildcareFilters({
    kids: kids,
    childcareFacets: Object(facetingUtils["e" /* getChildcareFacets */])(facets),
    departureDate: departureDate
  }).addFilters(activeFacets);

  if (departureCity) {
    allFilters.addFilter({
      id: constants["i" /* DEPARTURE_CITY_FACET_ID */],
      name: departureCity
    });
  }

  return allFilters.value();
});
/**
 * Returns an object with an aggregation of criterias for Pertimm:
 *
 * Example:
 * ```json
 * {
 *    departureDate: '',
 *    tripDuration: '7',
 *    filters: [
 *      { id: 'facette_departure_city',  name: 'PAR' },
 *      { id: 'activities_tree', name: 'Sports Terrestres|Ski' }
 *    ]
 * }
 * ```
 */

var facetingCriteriaSelector = Object(lib["createSelector"])([tripCriteria_selector["b" /* getDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], getFiltersSelector, storeHelper["c" /* getKids */]], function (departureDate, tripDuration, filters, kids) {
  return {
    departureDate: departureDate,
    tripDuration: tripDuration,
    filters: filters,
    kids: kids
  };
});


/***/ }),

/***/ "vnfA":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("3LIW");

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "vpUC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ysqo")


/***/ }),

/***/ "vt7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return instagramResolver; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("VtSi");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("QsI/");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("CcNa");
/* harmony import */ var _views_configQueries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("4VTZ");








var priceQuery = function priceQuery(displayPrices) {
  if (displayPrices) {
    return "\n      price {\n        bestPrice {\n          formattedValue\n          value\n        }\n        termsAndConditions {\n          accommodationComfortLabel\n          arrivalDate\n          departureCity {\n            name\n            value\n          }\n          departureDate\n          duration\n          durationFormatted\n          numberOfAdults\n        }\n        unit\n      }";
  }

  return '';
};

var instagramResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_3__[/* INSTAGRAM */ "s"],
  resolve: function () {
    var _resolve = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(appContext, props) {
      var displayPrices, resortIds, resortIdsAsString, query;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              displayPrices = props.displayPrices, resortIds = props.resortIds;
              resortIdsAsString = JSON.stringify(resortIds);
              query = "query {\n      config {\n        common {\n          close\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n        ".concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* price */ "c"](), "\n        ").concat(_views_configQueries__WEBPACK_IMPORTED_MODULE_6__[/* resort */ "e"](appContext), "\n      }\n      products: resorts(resortIds: ").concat(resortIdsAsString, ") {\n        color\n        comfort\n        duration,\n        href\n        id\n        isCruise\n        isJoyview\n        isTour\n        name\n        ").concat(priceQuery(displayPrices), "\n        socialPictures {\n          canonicalUrl,\n          imageLarge,\n          imageSmall,\n          userName,\n        }\n      }\n    }");
              return _context.abrupt("return", _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].runQuery(query, appContext, {
                requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_5__[/* LINE_COMMON_INSTAGRAM */ "Bb"]
              }));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function resolve(_x, _x2) {
      return _resolve.apply(this, arguments);
    }

    return resolve;
  }()
};

/***/ }),

/***/ "vuE1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("LTtw");
var global = __webpack_require__("HnW7");
var getBuiltIn = __webpack_require__("x90g");
var IS_PURE = __webpack_require__("SRps");
var DESCRIPTORS = __webpack_require__("uGjT");
var NATIVE_SYMBOL = __webpack_require__("wEFx");
var fails = __webpack_require__("fhLv");
var has = __webpack_require__("DZWw");
var isArray = __webpack_require__("gIGD");
var isCallable = __webpack_require__("ANQd");
var isObject = __webpack_require__("1YFU");
var isSymbol = __webpack_require__("km0D");
var anObject = __webpack_require__("ep/x");
var toObject = __webpack_require__("A+R+");
var toIndexedObject = __webpack_require__("dNjr");
var toPropertyKey = __webpack_require__("RWUY");
var $toString = __webpack_require__("vnfA");
var createPropertyDescriptor = __webpack_require__("OouP");
var nativeObjectCreate = __webpack_require__("Znn2");
var objectKeys = __webpack_require__("X95k");
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternal = __webpack_require__("Ed3r");
var getOwnPropertySymbolsModule = __webpack_require__("qPLk");
var getOwnPropertyDescriptorModule = __webpack_require__("5h8T");
var definePropertyModule = __webpack_require__("87KK");
var propertyIsEnumerableModule = __webpack_require__("z7Vv");
var redefine = __webpack_require__("L1Xj");
var shared = __webpack_require__("8+jV");
var sharedKey = __webpack_require__("mmil");
var hiddenKeys = __webpack_require__("qXr/");
var uid = __webpack_require__("rvZv");
var wellKnownSymbol = __webpack_require__("nJrx");
var wrappedWellKnownSymbolModule = __webpack_require__("9YYj");
var defineWellKnownSymbol = __webpack_require__("oMzG");
var setToStringTag = __webpack_require__("CGO5");
var InternalStateModule = __webpack_require__("9jKB");
var $forEach = __webpack_require__("VrMI").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = $toString(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  var valueOf = $Symbol[PROTOTYPE].valueOf;
  redefine($Symbol[PROTOTYPE], TO_PRIMITIVE, function () {
    return valueOf.apply(this, arguments);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "w04c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductsGrid; });
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("tQbP");
/* harmony import */ var core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_sort__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("fGyu");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("g/E1");
/* harmony import */ var _clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _frameworks_grid_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("uLWw");
/* harmony import */ var _frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("ZNfd");
/* harmony import */ var _facet_search_FacetSearch__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ontP");
/* harmony import */ var _line_title_LineTitle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("2Ufl");
/* harmony import */ var _product_Product__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("XTOr");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("L7OA");




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;









var ProductsGrid = function ProductsGrid(_ref) {
  var childrenClassName = _ref.childrenClassName,
      className = _ref.className,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      departureCity = _ref.departureCity,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      display = _ref.display,
      _ref$displaySearch = _ref.displaySearch,
      displaySearch = _ref$displaySearch === void 0 ? false : _ref$displaySearch,
      duration = _ref.duration,
      fetchData = _ref.fetchData,
      grid = _ref.grid,
      hasSeeMore = _ref.hasSeeMore,
      isLoading = _ref.isLoading,
      _ref$isSynchronousGri = _ref.isSynchronousGrid,
      isSynchronousGrid = _ref$isSynchronousGri === void 0 ? false : _ref$isSynchronousGri,
      lineName = _ref.lineName,
      products = _ref.products,
      offer = _ref.offer,
      onComparisonClick = _ref.onComparisonClick,
      seeMore = _ref.seeMore,
      _ref$sortByPriceAscen = _ref.sortByPriceAscending,
      sortByPriceAscending = _ref$sortByPriceAscen === void 0 ? false : _ref$sortByPriceAscen,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      totalNumberToDisplay = _ref.totalNumberToDisplay;
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_4__["useContext"])(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_11__[/* default */ "b"]);
  var isProductComparisonModeAuthorized = Object(_utils_feature_flipping_featureFlippingUtils__WEBPACK_IMPORTED_MODULE_12__[/* isFeatureFlipped */ "a"])(appContext)('search.productComparison');

  if (products.length === 0) {
    return null;
  }

  var cmtaLinks = Object(_clubmed_domains_service__WEBPACK_IMPORTED_MODULE_5__["getCmtaLinks"])(appContext.locale);
  var resortGridProps = {
    departureCity: departureCity,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    duration: duration
  };
  /**
   * Sort resort grid list
   * @param {Object} priceA The price
   * @param {Object} priceB The price
   * @returns The list sorted
   */

  var sortProductsByPrice = function sortProductsByPrice(_ref2, _ref3) {
    var _priceA$bestPrice, _priceB$bestPrice;

    var priceA = _ref2.price;
    var priceB = _ref3.price;

    // equal items sort equally
    if ((priceA === null || priceA === void 0 ? void 0 : (_priceA$bestPrice = priceA.bestPrice) === null || _priceA$bestPrice === void 0 ? void 0 : _priceA$bestPrice.value) === (priceB === null || priceB === void 0 ? void 0 : (_priceB$bestPrice = priceB.bestPrice) === null || _priceB$bestPrice === void 0 ? void 0 : _priceB$bestPrice.value)) {
      return 0;
    } // nulls sort after anything else


    if (!(priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice)) {
      return 1;
    }

    if (!(priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice)) {
      return -1;
    }

    return (priceA === null || priceA === void 0 ? void 0 : priceA.bestPrice.value) < (priceB === null || priceB === void 0 ? void 0 : priceB.bestPrice.value) ? -1 : 1;
  };

  var productListSorted = sortByPriceAscending ? Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(products).sort(sortProductsByPrice) : products;
  return __jsx("div", {
    className: className
  }, !!title && __jsx(_line_title_LineTitle__WEBPACK_IMPORTED_MODULE_9__[/* LineTitle */ "a"], null, title), displaySearch ? __jsx(_facet_search_FacetSearch__WEBPACK_IMPORTED_MODULE_8__[/* FacetSearch */ "a"], {
    hideSearchInput: true,
    i18n: config,
    initialIsSearchEnabled: true,
    initialProducts: productListSorted || [],
    isProductComparisonModeAuthorized: isProductComparisonModeAuthorized,
    isSynchronousGrid: true,
    resultsHasSeeMore: hasSeeMore,
    resultsSeeMore: seeMore,
    offer: offer,
    resetSearchAtMount: true,
    resortGridProps: resortGridProps,
    sortByPriceAscending: sortByPriceAscending,
    shouldPersistCriteriaInUrl: true,
    shouldSetDefaultDepartureCityOnCompare: true,
    withSearchFacets: true,
    withSearchForm: true,
    withSearchResults: true
  }) : __jsx(_frameworks_site_container_SiteContainer__WEBPACK_IMPORTED_MODULE_7__[/* SiteContainer */ "a"], null, __jsx(_frameworks_grid_Grid__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {
    childrenClassName: childrenClassName,
    display: display || grid,
    getChildren: fetchData,
    grid: grid,
    hasSeeMore: hasSeeMore,
    isLoading: isLoading,
    seeMore: seeMore,
    totalNumberToDisplay: totalNumberToDisplay,
    isSynchronousGrid: isSynchronousGrid
  }, productListSorted.map(function (product, index) {
    return __jsx(_product_Product__WEBPACK_IMPORTED_MODULE_10__[/* Product */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({
      cmtaLinks: cmtaLinks,
      index: index,
      key: product.id,
      lineName: lineName,
      offer: offer,
      onComparisonClick: onComparisonClick ? function () {
        return onComparisonClick(product.id);
      } : undefined
    }, product));
  }))));
};
ProductsGrid.defaultProps = {
  hasSeeMore: false,
  products: []
};

/***/ }),

/***/ "wEFx":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("Y8c0");
var fails = __webpack_require__("fhLv");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "wFPu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("ax0f");
var isArray = __webpack_require__("xt6W");

var nativeReverse = [].reverse;
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse.call(this);
  }
});


/***/ }),

/***/ "wKkN":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var hiddenKeys = __webpack_require__("qXr/");
var isObject = __webpack_require__("1YFU");
var has = __webpack_require__("DZWw");
var defineProperty = __webpack_require__("87KK").f;
var getOwnPropertyNamesModule = __webpack_require__("8D46");
var getOwnPropertyNamesExternalModule = __webpack_require__("Ed3r");
var uid = __webpack_require__("rvZv");
var FREEZING = __webpack_require__("+pJz");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = [].splice;
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice.call(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "wKzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CriteriaWho; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("M+/F");
/* harmony import */ var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("fGyu");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("zygG");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("uDfI");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("SPKZ");
/* harmony import */ var _CriteriaContext__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("XiOS");
/* harmony import */ var _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("TYzI");
/* harmony import */ var _CriteriaTrigger__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("+Rc+");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("PFSw");
/* harmony import */ var _filter_who_FilterWho__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("tUgU");
/* harmony import */ var _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("45yR");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("kiXb");
/* harmony import */ var _store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("loSl");
/* harmony import */ var _store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("ORYz");
/* harmony import */ var _store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("VO7D");
/* harmony import */ var _store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("1bWg");
/* harmony import */ var _store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Jsmy");
/* harmony import */ var _utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("cGFA");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("sRdV");

















var __jsx = react__WEBPACK_IMPORTED_MODULE_17___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_16__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var KIDS_ACTIONS = {
  CHANGE_KID: 'CHANGE_KID',
  CHANGE_KIDS_COUNT: 'CHANGE_KIDS_COUNT',
  REMOVE_KIDS: 'REMOVE_KIDS',
  SYNC_KIDS: 'SYNC_KIDS'
};

var getKidBirthdateAndChildcare = function getKidBirthdateAndChildcare(kid) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_19__["pick"])(kid, ['birthdate', 'childcareIncluded']);
};

var getKidWithoutStatus = function getKidWithoutStatus(kid) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_19__["omit"])(kid, ['status']);
};

var getKidWithStatus = function getKidWithStatus(kid, isKidBirthdateRequired) {
  return _objectSpread(_objectSpread({}, kid), {}, {
    status: Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_34__[/* getValidationStateFromKid */ "a"])(kid, isKidBirthdateRequired)
  });
};

var CriteriaWho = function CriteriaWho(props) {
  var _props$hasChildcareSw = props.hasChildcareSwitch,
      hasChildcareSwitch = _props$hasChildcareSw === void 0 ? true : _props$hasChildcareSw,
      isKidBirthdateRequired = props.isKidBirthdateRequired,
      isJoyview = props.isJoyview;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_17__["useContext"])(_CriteriaContext__WEBPACK_IMPORTED_MODULE_22__[/* CriteriaContext */ "a"]),
      criteriaContext = _useContext[0],
      setCriteriaContext = _useContext[1];

  var _useCriteriaDisplayCo = Object(_CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_23__[/* useCriteriaDisplayContext */ "c"])(),
      _useCriteriaDisplayCo2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"])(_useCriteriaDisplayCo, 2),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0],
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_18__[/* useDispatch */ "d"])();
  var adultsNumber = Object(react_redux__WEBPACK_IMPORTED_MODULE_18__[/* useSelector */ "e"])(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_33__[/* getAdultsNumber */ "b"]);
  var kids = Object(react_redux__WEBPACK_IMPORTED_MODULE_18__[/* useSelector */ "e"])(_store_trip_information_storeHelper__WEBPACK_IMPORTED_MODULE_33__[/* getKids */ "c"]);
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_35__[/* useTracking */ "a"])({
    actionGA: criteriaContext.trackingActionName
  });

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_17__["useState"])(adultsNumber || _store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_30__[/* DEFAULT_ADULTS_NB */ "a"]),
      inputAdultsNumber = _useState[0],
      setInputAdultsNumber = _useState[1];

  var _useReducer = Object(react__WEBPACK_IMPORTED_MODULE_17__["useReducer"])(function (state, action) {
    switch (action.type) {
      case KIDS_ACTIONS.SYNC_KIDS:
        return action.payload;

      case KIDS_ACTIONS.REMOVE_KIDS:
        return [];

      case KIDS_ACTIONS.CHANGE_KIDS_COUNT:
        return action.payload > state.length ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"])(state), [{
          birthdate: undefined,
          childcareIncluded: false,
          neolid: undefined,
          status: _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_27__[/* NOT_VALIDATED */ "c"]
        }]) : state.slice(0, -1);

      case KIDS_ACTIONS.CHANGE_KID:
        return state.map(function (kid, index) {
          return index === action.payload.index ? getKidWithStatus(action.payload.kid, isKidBirthdateRequired) : kid;
        });

      default:
        return state;
    }
  }, kids.map(getKidWithStatus)),
      inputKids = _useReducer[0],
      setInputKids = _useReducer[1];

  var inputKidsValidationState = inputKids.map(function (kid) {
    return kid.status;
  });
  var hasInvalidKidsStatus = inputKidsValidationState.some(function (status) {
    return status === _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_27__[/* NOT_VALIDATED */ "c"] || status === _frameworks_form_validator_hoc_validationStates__WEBPACK_IMPORTED_MODULE_27__[/* IS_INVALID */ "a"];
  });
  var inputKidsEqualKids = Object(lodash__WEBPACK_IMPORTED_MODULE_19__["isEqual"])(inputKids.map(getKidBirthdateAndChildcare), kids.map(getKidBirthdateAndChildcare));
  var inputAdultsNumberEqualsAdultsNumber = inputAdultsNumber === adultsNumber; // Store update effect

  Object(react__WEBPACK_IMPORTED_MODULE_17__["useEffect"])(function () {
    var adultsAreSet = adultsNumber > 0;
    var kidsAreSet = Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_34__[/* hasOnlyValidKids */ "d"])(Object(_utils_faceting_kidsValidationStateUtils__WEBPACK_IMPORTED_MODULE_34__[/* getValidationStateFromKids */ "b"])(kids)); // Is also true when there are no kids

    setCriteriaContext({
      criteriaWhoIsSet: adultsAreSet && kidsAreSet
    });
  }, [adultsNumber, kids]);

  var openCriteriaEventHandler = function openCriteriaEventHandler() {
    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_23__[/* ACTIONS */ "a"].OPEN_CRITERIA,
      payload: 'criteriaWho'
    });
  }; // Open/Close effect


  Object(react__WEBPACK_IMPORTED_MODULE_17__["useEffect"])(function () {
    document.addEventListener(_constants__WEBPACK_IMPORTED_MODULE_25__[/* OPEN_CRITERIA_WHO_EVENT */ "a"], openCriteriaEventHandler);
    return function () {
      return document.removeEventListener(_constants__WEBPACK_IMPORTED_MODULE_25__[/* OPEN_CRITERIA_WHO_EVENT */ "a"], openCriteriaEventHandler);
    };
  }, []);

  var saveParticipants = function saveParticipants() {
    if (!inputKidsEqualKids) {
      criteriaContext.setFacetHasSeeMore(false);
      dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_32__[/* setKids */ "b"])(inputKids.map(getKidWithoutStatus)));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_29__[/* setKidsValidationState */ "m"])(inputKidsValidationState));

      if (kids.length !== inputKids.length) {
        dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_29__[/* changeKidsNumber */ "b"])(inputKids.length));
      }
    } else {
      // Sync kids store with inputKids
      setInputKids({
        type: KIDS_ACTIONS.SYNC_KIDS,
        payload: inputKids
      });
    }

    if (inputKids.length > 0 && inputAdultsNumber === 0) {
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_31__[/* setAdultsNumber */ "b"])(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_30__[/* DEFAULT_ADULTS_NB */ "a"]));
    } else if (!inputAdultsNumberEqualsAdultsNumber) {
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_31__[/* setAdultsNumber */ "b"])(inputAdultsNumber));
    }

    dispatchCriteriaDisplayContext({
      type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_23__[/* ACTIONS */ "a"].CLOSE_CRITERIA,
      payload: 'criteriaWho'
    });
  };

  var labelParts = '';
  var labelPartsMobile = '';

  if (adultsNumber > 0) {
    var labelPartsTmp = [];
    var lengthPeople = adultsNumber + kids.length;

    if (lengthPeople) {
      labelPartsMobile = lengthPeople.toString(10);

      if (adultsNumber >= 1) {
        labelPartsTmp.push(Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.selectAdultsLabels', {
          count: adultsNumber
        }));
      }

      if (kids.length >= 1) {
        labelPartsTmp.push(Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.selectChildrenLabels', {
          count: kids.length
        }));
      }

      labelParts = labelPartsTmp.join(' - ');
    }
  } else {
    labelParts = Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.title');
  }

  var buttonLabel = __jsx(react__WEBPACK_IMPORTED_MODULE_17__["Fragment"], null, __jsx("span", {
    className: "flex-1 hidden lg:inline truncate"
  }, labelParts), __jsx("span", {
    className: "lg:hidden rtl:ml-px5"
  }, labelPartsMobile));

  var trackKidsNumberChange = function trackKidsNumberChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: 'who_child',
        valueGA: value
      });
    }
  };

  var trackAdultsNumberChange = function trackAdultsNumberChange(value) {
    if (criteriaContext.trackingActionName) {
      track({
        labelGA: 'who_adult',
        valueGA: value
      });
    }
  };

  return __jsx(_CriteriaTrigger__WEBPACK_IMPORTED_MODULE_24__[/* CriteriaTrigger */ "a"], {
    buttonLabel: buttonLabel,
    buttonIcon: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_21__[/* ICONS */ "a"].USERS,
    buttonIsFilled: criteriaContext.criteriaWhoIsSet,
    dataTestId: "CriteriaWho",
    dropDownMinWidth: 500,
    isOpen: criteriaDisplayContext.criteriaWhoIsOpen,
    isJoyview: isJoyview,
    trackingLabel: "who",
    onOpen: function onOpen() {
      dispatchCriteriaDisplayContext({
        type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_23__[/* ACTIONS */ "a"].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
    },
    onClose: saveParticipants,
    onClear: function onClear() {
      setCriteriaContext({
        criteriaWhoIsSet: false
      });
      dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_31__[/* setAdultsNumber */ "b"])(0));
      dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_32__[/* setKids */ "b"])([]));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_29__[/* changeKidsNumber */ "b"])(0));
      dispatch(Object(_store_faceting_facetingSearch_action__WEBPACK_IMPORTED_MODULE_29__[/* setKidsValidationState */ "m"])([]));
      setInputKids({
        type: KIDS_ACTIONS.REMOVE_KIDS
      });
      setInputAdultsNumber(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_30__[/* DEFAULT_ADULTS_NB */ "a"]);
    },
    buttons: [{
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputAdultsNumber(_store_trip_information_adults_constants__WEBPACK_IMPORTED_MODULE_30__[/* DEFAULT_ADULTS_NB */ "a"]);
        setInputKids({
          type: KIDS_ACTIONS.REMOVE_KIDS
        });
      },
      className: 'text-sm cursor-pointer',
      dataTestId: 'criteria-who-reset'
    }, {
      children: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.validate'),
      colorBg: _utils_color_colors__WEBPACK_IMPORTED_MODULE_20__[/* COLORS */ "a"].TURQUOISE,
      dataTestId: 'criteria-who-validate',
      isDisabled: isKidBirthdateRequired && hasInvalidKidsStatus,
      onClick: function onClick() {
        saveParticipants();
        dispatchCriteriaDisplayContext({
          type: _CriteriaDisplayContext__WEBPACK_IMPORTED_MODULE_23__[/* ACTIONS */ "a"].OPEN_NEXT_CRITERIA,
          payload: {
            currentCriteria: 'criteriaWho',
            criteriaContext: criteriaContext
          }
        });
      }
    }]
  }, __jsx(_filter_who_FilterWho__WEBPACK_IMPORTED_MODULE_26__[/* FilterWho */ "a"], {
    hasChildcareSwitch: hasChildcareSwitch,
    adultsNumber: inputAdultsNumber,
    kids: inputKids,
    placeholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.title'),
    label: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.subTitle'),
    adultsLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.adults'),
    kidsLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.kids'),
    kidsAgeLabel: isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.ageSectionSubtitle') : Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.ageSectionChildcareSubtitle'),
    kidsAgeLimitLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.kidsAgeLimit'),
    dateFormat: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.dateFormat'),
    dayPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.dayPlaceholder'),
    monthPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.monthPlaceholder'),
    yearPlaceholder: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.yearPlaceholder'),
    informationLabel: !isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.ageComment') : undefined,
    addChildcareLabel: Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('faceting.who.addChildcare'),
    birthdaysErrorMessage: isKidBirthdateRequired ? Object(_i18n__WEBPACK_IMPORTED_MODULE_28__[/* t */ "h"])('booking.form.errors.birthdayFormat') : '',
    changeKidsNumber: function changeKidsNumber(value) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KIDS_COUNT,
        payload: value
      });
      trackKidsNumberChange(value);
    },
    changeKid: function changeKid(index, kid) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KID,
        payload: {
          index: index,
          kid: kid
        }
      });
    },
    kidsValidationState: inputKidsValidationState,
    validateKidsBirthdate: function validateKidsBirthdate(index, kid) {
      setInputKids({
        type: KIDS_ACTIONS.CHANGE_KID,
        payload: {
          index: index,
          kid: kid
        }
      });
    },
    setAdultsNumber: function setAdultsNumber(number) {
      setInputAdultsNumber(number);
      trackAdultsNumberChange(number);
    }
  }));
};

/***/ }),

/***/ "wQ38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIP_INFORMATION_SET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIP_INFORMATION_UPDATE_KID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRIP_INFORMATION_RESET_KIDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_KID_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VALIDATION_STATE_ENUM; });
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("yH/f");
/* harmony import */ var core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze__WEBPACK_IMPORTED_MODULE_0__);

var TRIP_INFORMATION_SET_KIDS = 'TRIP_INFORMATION_UPDATE_KIDS';
var TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS = 'TRIP_INFORMATION_SET_KIDS_WITHOUT_CLEAR_PROPOSALS';
var TRIP_INFORMATION_UPDATE_KID = 'TRIP_INFORMATION_UPDATE_KID';
var TRIP_INFORMATION_RESET_KIDS = 'TRIP_INFORMATION_RESET_KID';
var DEFAULT_KID_VALUE = {
  birthdate: undefined,
  neolid: undefined,
  childcareIncluded: true
};
var VALIDATION_STATE_ENUM = Object.freeze({
  valid: 'IS_VALID',
  invalid: 'IS_INVALID',
  notvalidated: 'NOT_VALIDATED'
});

/***/ }),

/***/ "wRBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputDatalist_InputDatalist; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: /opt/webapp/node_modules/striptags/striptags.js
var striptags = __webpack_require__("47go");
var striptags_default = /*#__PURE__*/__webpack_require__.n(striptags);

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/form/form.util.js
var form_util = __webpack_require__("1P7A");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/form-control/FormControl.jsx + 1 modules
var FormControl = __webpack_require__("Jcrg");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.themes.js


var themes = {
  "default": function _default(props) {
    return {
      thInput: classnames_default()('reset-input text-md sm:text-base w-full', Object(form_util["a" /* getCursorClass */])(props), {
        'text-white': props.isFilled,
        'text-darker-gray': !props.isFilled,
        'button-medium': props.size === 'medium',
        'button-default': props.size === 'large'
      }),
      thToggler: classnames_default()('reset-button leading-none px-px10 text-base', Object(form_util["a" /* getCursorClass */])(props))
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-text/InputText.jsx












var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









var InputText_InputText = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputText, _Component);

  var _super = _createSuper(InputText);

  function InputText(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputText);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = e.target.value;

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props$onKeyDown = _this.props.onKeyDown,
          onKeyDown = _this$props$onKeyDown === void 0 ? lodash["noop"] : _this$props$onKeyDown;
      e.persist();
      onKeyDown(e);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        value: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "toggleType", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          _this$props2$typeTogg = _this$props2.typeToggler,
          typeToggler = _this$props2$typeTogg === void 0 ? {} : _this$props2$typeTogg;

      _this.setState({
        type: _this.state.type !== typeToggler.antiType ? typeToggler.antiType : type
      });
    });

    _this.state = {
      type: props.type || 'text',
      value: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputText, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value,
          type = _ref.type;
      this.setState(function (prevState) {
        if (prevState.value !== value || prevState.type !== type) {
          return {
            type: type,
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          autoComplete = _this$props3.autoComplete,
          className = _this$props3.className,
          hasClear = _this$props3.hasClear,
          hasTypeToggler = _this$props3.hasTypeToggler,
          hasValidationIcon = _this$props3.hasValidationIcon,
          iconLeft = _this$props3.iconLeft,
          iconRight = _this$props3.iconRight,
          _this$props3$id = _this$props3.id,
          id = _this$props3$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputText_') : _this$props3$id,
          isActive = _this$props3.isActive,
          isDisabled = _this$props3.isDisabled,
          isFilled = _this$props3.isFilled,
          isLoading = _this$props3.isLoading,
          isNotEditable = _this$props3.isNotEditable,
          isReadOnly = _this$props3.isReadOnly,
          isRequired = _this$props3.isRequired,
          label = _this$props3.label,
          maxLength = _this$props3.maxLength,
          minLength = _this$props3.minLength,
          name = _this$props3.name,
          notes = _this$props3.notes,
          onBlur = _this$props3.onBlur,
          onClick = _this$props3.onClick,
          onFocus = _this$props3.onFocus,
          onKeyUp = _this$props3.onKeyUp,
          pattern = _this$props3.pattern,
          placeholder = _this$props3.placeholder,
          size = _this$props3.size,
          _this$props3$theme = _this$props3.theme,
          theme = _this$props3$theme === void 0 ? 'default' : _this$props3$theme,
          _this$props3$typeTogg = _this$props3.typeToggler,
          typeToggler = _this$props3$typeTogg === void 0 ? {} : _this$props3$typeTogg,
          validationState = _this$props3.validationState,
          dataTestId = _this$props3.dataTestId;
      var _this$state = this.state,
          type = _this$state.type,
          value = _this$state.value;
      var hasClearEnabled = Boolean(hasClear && value);
      var hasValue = Boolean(value);

      var _themes$theme = themes[theme](this.props),
          thInput = _themes$theme.thInput,
          thToggler = _themes$theme.thToggler;

      return __jsx(FormControl["a" /* FormControl */], {
        className: className,
        hasClear: hasClearEnabled,
        hasValidationIcon: hasValidationIcon,
        iconLeft: iconLeft,
        iconRight: iconRight,
        id: id,
        isActive: isActive,
        isDisabled: isDisabled,
        isFilled: isFilled && hasValue,
        isLoading: isLoading,
        isReadOnly: isReadOnly,
        isRequired: isRequired,
        label: label,
        notes: notes,
        onClear: this.onClear,
        size: size,
        theme: theme,
        validationState: validationState
      }, __jsx("input", Object(esm_extends["a" /* default */])({
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        "data-testid": dataTestId,
        id: id
      }, Object(lodash["isInteger"])(maxLength) ? {
        maxLength: maxLength
      } : null, Object(lodash["isInteger"])(minLength) ? {
        minLength: minLength
      } : null, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: this.onKeyDown,
        onKeyUp: onKeyUp // $FlowFixMe

      }, pattern ? {
        pattern: pattern
      } : null, placeholder ? {
        placeholder: Object(form_util["b" /* getFormattedLabel */])(placeholder, isRequired)
      } : null, {
        readOnly: Boolean(isReadOnly || isLoading || isNotEditable),
        required: isRequired,
        role: type === 'search' ? 'search' : 'textbox',
        type: type,
        value: value
      })), hasTypeToggler && __jsx("button", {
        className: thToggler,
        disabled: isDisabled,
        onClick: this.toggleType,
        type: "button",
        "data-testid": "InputTextToggler"
      }, __jsx(Icon["a" /* Icon */], {
        name: type === this.props.type ? typeToggler.icon : typeToggler.antiIcon
      })));
    }
  }]);

  return InputText;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputText_InputText, "defaultProps", {
  autoComplete: 'off',
  size: 'medium',
  theme: 'default',
  type: 'text',
  typeToggler: {
    antiIcon: icons["a" /* ICONS */].CLOSED_EYE_PASSWORD,
    antiType: 'text',
    icon: icons["a" /* ICONS */].EYE_PASSWORD
  }
});
// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.layouts.jsx
var InputDatalist_layouts_jsx = react_default.a.createElement;





var InputDatalist_layouts_DefaultLayout = function DefaultLayout(_ref) {
  var icon = _ref.icon,
      isActive = _ref.isActive,
      label = _ref.label,
      subLabel1 = _ref.subLabel1,
      subLabel2 = _ref.subLabel2,
      type = _ref.type;

  var _useState = Object(react["useState"])(false),
      hover = _useState[0],
      setHover = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!label) {
    return null;
  }

  return InputDatalist_layouts_jsx("div", {
    className: classnames_default()('focus:bg-turquoise hover:bg-turquoise cursor-pointer flex items-center overflow-hidden p-px10 focus:text-white hover:text-white transition-colors', {
      'bg-turquoise text-white': isActive
    }),
    onMouseEnter: function onMouseEnter() {
      return isDesktop && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return isDesktop && setHover(false);
    }
  }, icon ? InputDatalist_layouts_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('flex-shrink-0', {
      'text-blue': !hover && !isActive
    }),
    name: icon,
    width: "1.25rem"
  }) : InputDatalist_layouts_jsx(ECBadge["a" /* ECBadge */], {
    className: "flex-shrink-0",
    height: 30
  }), InputDatalist_layouts_jsx("div", {
    className: "decorator-match flex-1 rtl:ml-px10 text-md"
  }, !!subLabel1 && !!subLabel2 && InputDatalist_layouts_jsx("div", {
    className: classnames_default()('leading-one text-sm', {
      'text-gray-medium': !isActive && !hover,
      'text-current': isActive || hover
    })
  }, !!subLabel1 && InputDatalist_layouts_jsx("span", {
    className: "font-bold uppercase"
  }, subLabel1), !!subLabel1 && !!subLabel2 && InputDatalist_layouts_jsx("span", null, " - "), !!subLabel2 && InputDatalist_layouts_jsx("span", null, subLabel2)), InputDatalist_layouts_jsx("div", {
    className: classnames_default()({
      'font-brand text-md': type === 'resort'
    }) // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.themes.js
var InputDatalist_themes_themes = {
  "default": {
    thRoot: 'relative',
    thDatalist: 'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-px20 p-px10 rounded-small shadow-lg top-full w-full z-6'
  },
  pyr: {
    thRoot: 'fixed',
    thDatalist: 'reset-list absolute arrow-up arrow-large arrow-white arrow-bg arrow-bg-blue bg-white border-1 border-blue mt-px20 p-px10 rounded-small shadow-lg top-full w-full z-6'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-datalist/InputDatalist.jsx



















var InputDatalist_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function InputDatalist_createSuper(Derived) { var hasNativeReflectConstruct = InputDatalist_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function InputDatalist_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-env browser */








var InputDatalist_InputDatalist = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(InputDatalist, _PureComponent);

  var _super = InputDatalist_createSuper(InputDatalist);

  function InputDatalist(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputDatalist);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "dataListElementRef", null);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickOutside", function (e) {
      var isActive = _this.state.isActive;

      if (!_this.dataListElementRef || !isActive) {
        return;
      }

      var dataListNode = _this.dataListElementRef.current;

      if (!dataListNode || !dataListNode.contains(e.target)) {
        _this.setState({
          isActive: false
        });

        if (_this.props.onClickOutside) {
          _this.props.onClickOutside();
        }
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openList", function () {
      _this.setState(function (prevState) {
        if (!prevState.isActive) {
          return {
            isActive: true
          };
        }
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (e) {
      var _this$props = _this.props,
          _this$props$dataList = _this$props.dataList,
          dataList = _this$props$dataList === void 0 ? [] : _this$props$dataList,
          onClear = _this$props.onClear,
          onKeyDown = _this$props.onKeyDown,
          onValidate = _this$props.onValidate;
      var _this$state = _this.state,
          index = _this$state.index,
          selected = _this$state.selected;

      if (e.keyCode === keyCodes["a" /* ARROW_DOWN */] && index < dataList.length - 1) {
        _this.goToIndex(1);
      } else if (e.keyCode === keyCodes["d" /* ARROW_UP */] && index > 0) {
        _this.goToIndex(-1);
      } else if (e.keyCode === keyCodes["f" /* ENTER */]) {
        var item = dataList[index];

        _this.setState({
          isActive: false
        });

        if (item) {
          _this.onSelect(item);
        } else if (selected === '' && Object(lodash["isFunction"])(onClear)) {
          onClear();
        } else if (Object(lodash["isFunction"])(onValidate)) {
          onValidate();
        }
      }

      if (Object(lodash["isFunction"])(onKeyDown)) {
        onKeyDown(e);
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFocus", function (e) {
      var onFocus = _this.props.onFocus;

      if (Object(lodash["isFunction"])(onFocus) && !_this.state.isActive) {
        onFocus(e);
      }

      _this.openList();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (name, value) {
      _this.setState({
        isActive: true,
        selected: value
      }, function () {
        if (_this.props.onChange) _this.props.onChange(name, value);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClear", function (e) {
      var _this$props$onClear = _this.props.onClear,
          onClear = _this$props$onClear === void 0 ? lodash["noop"] : _this$props$onClear;

      _this.setState({
        index: -1,
        isActive: false,
        selected: ''
      }, function () {
        return onClear(e);
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onClickItem", function (item) {
      return function () {
        return _this.onSelect(item);
      };
    });

    _this.dataListElementRef = /*#__PURE__*/Object(react["createRef"])();
    _this.state = {
      index: -1,
      isActive: false,
      selected: props.value || ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputDatalist, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        document.addEventListener('click', this.onClickOutside);
        document.addEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (true) {
        document.removeEventListener('click', this.onClickOutside);
        document.removeEventListener('focus', this.onClickOutside);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var selected = this.props.value;

      if (!Object(lodash["isUndefined"])(selected) && !prevState.isActive && prevState.selected !== selected) {
        this.setState({
          selected: selected
        });
      }
    }
  }, {
    key: "goToIndex",
    value: function goToIndex(offset) {
      this.setState(function (prevState) {
        var index = prevState.index + offset;
        return {
          index: index
        };
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(item) {
      var _this$props$onSelect = this.props.onSelect,
          onSelect = _this$props$onSelect === void 0 ? lodash["noop"] : _this$props$onSelect;
      var sanitizedItem = {
        item: item,
        label: striptags_default()(Object(lodash["get"])(item, 'label'))
      };
      this.setState({
        index: -1,
        isActive: false,
        selected: sanitizedItem.label
      });
      onSelect(sanitizedItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dataList = _this$props2.dataList,
          id = _this$props2.id,
          isAnimated = _this$props2.isAnimated,
          isDisabled = _this$props2.isDisabled,
          isLoading = _this$props2.isLoading,
          isReadOnly = _this$props2.isReadOnly,
          itemLayout = _this$props2.itemLayout,
          itemTitle = _this$props2.itemTitle,
          theme = _this$props2.theme;
      var _themes$theme = InputDatalist_themes_themes[theme],
          thDatalist = _themes$theme.thDatalist,
          thRoot = _themes$theme.thRoot;
      var _this$state2 = this.state,
          isActive = _this$state2.isActive,
          selected = _this$state2.selected;
      return InputDatalist_jsx("div", {
        className: thRoot,
        ref: this.dataListElementRef
      }, InputDatalist_jsx(InputText_InputText, Object(esm_extends["a" /* default */])({}, Object(lodash["pick"])(this.props, ['hasClear', 'hasValidationIcon', 'iconLeft', 'iconRight', 'isDisabled', 'isFilled', 'isLoading', 'isReadOnly', 'isRequired', 'label', 'name', 'notes', 'onBlur', 'onClick', 'onKeyUp', 'placeholder', 'size', 'theme', 'validationState']), {
        autoComplete: "off",
        dataTestId: "InputDatalistQuery",
        id: id,
        isActive: isActive && !isReadOnly,
        onChange: this.onChange,
        onClear: this.onClear,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        type: "text",
        value: selected
      })), isActive && !isReadOnly && !isDisabled && !isLoading && !!dataList.length && InputDatalist_jsx("ul", {
        className: classnames_default()(thDatalist, {
          fadeIn: isAnimated
        }),
        "data-testid": "InputDatalistList",
        role: "listbox"
      }, !!itemTitle && InputDatalist_jsx("li", {
        className: "decorator-border-bottom-list"
      }, itemTitle), dataList.map(function (item, index) {
        if (!item.label) {
          return null;
        }

        var indexFromState = _this2.state.index;

        var newItem = _objectSpread(_objectSpread({}, item), {}, {
          isActive: index === indexFromState
        });

        var hasCustomLayout = Object(lodash["isFunction"])(itemLayout);
        return InputDatalist_jsx("li", {
          className: "decorator-border-bottom-list",
          "data-testid": item.id,
          key: item.id ? item.id : index,
          onClick: // $FlowFixMe
          _this2.onClickItem(item)
        }, // $FlowFixMe
        hasCustomLayout ? itemLayout(newItem) : InputDatalist_jsx(InputDatalist_layouts_DefaultLayout, newItem));
      })));
    }
  }]);

  return InputDatalist;
}(react["PureComponent"]);

Object(defineProperty["a" /* default */])(InputDatalist_InputDatalist, "defaultProps", {
  dataList: [],
  size: 'medium',
  theme: 'default'
});

/***/ }),

/***/ "waz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToastContext; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var ToastContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createContext"]({
  ref: null
});

/***/ }),

/***/ "wgpp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getInfoBannerQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBannerContainer; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _context_pageContext__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("RPju");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("0JpG");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("CcNa");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("829J");
/* harmony import */ var _InfoBanner__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("nT6P");













var _pageMappings;

var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var getInfoBannerQuery = function getInfoBannerQuery(productId) {
  return "query {\n    productInformationBanners(productId:\"".concat(productId, "\") {\n        productId\n        countdown {\n          dateTimeEnd\n        }\n        popin {\n          title\n          subtitle\n          text: description\n          buttonLabel\n          url\n          image\n          color\n        }\n        salesChannel {\n          context\n          tags\n        }\n        startDate\n        endDate\n        toaster {\n          title\n          subtitle: description\n          illustration: picto\n          color\n        }\n    }\n  }");
};
var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["b2cPagesService"].PAGE_TYPES;
var pageMappings = (_pageMappings = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_pageMappings, PAGE_TYPES.RESORT, 'resort_page'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_pageMappings, PAGE_TYPES.PLE, 'customer_area'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(_pageMappings, _tracking_constants__WEBPACK_IMPORTED_MODULE_20__[/* STATIC_PAGE_TYPES */ "v"].SHOPPING_SEARCH, 'comparator'), _pageMappings);

var shouldDisplayInfoBanner = function shouldDisplayInfoBanner(_ref) {
  var context = _ref.context,
      departureDate = _ref.departureDate,
      page = _ref.page;
  return function (_ref2) {
    var salesChannel = _ref2.salesChannel,
        startDate = _ref2.startDate,
        endDate = _ref2.endDate;
    var saleChannel = salesChannel.find(function (_ref3) {
      var saleChannelContext = _ref3.context;
      return saleChannelContext === context;
    });

    if (!(saleChannel === null || saleChannel === void 0 ? void 0 : saleChannel.tags.includes(page && pageMappings[page]))) {
      return false;
    }

    if (startDate && endDate) {
      var momentStartDate = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_17__[/* momentFromApiDate */ "h"])(startDate);
      var momentEndDate = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_17__[/* momentFromApiDate */ "h"])(endDate);
      var momentDepartureDate = departureDate && moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate);
      return !!departureDate && (moment__WEBPACK_IMPORTED_MODULE_12___default()(departureDate).isBetween(momentStartDate, momentEndDate) || momentStartDate.isSame(momentDepartureDate) || momentEndDate.isSame(momentDepartureDate));
    }

    return true;
  };
};

var InfoBannerContainer = function InfoBannerContainer(_ref4) {
  var _data$productInformat;

  var className = _ref4.className,
      contentClassName = _ref4.contentClassName,
      _ref4$context = _ref4.context,
      context = _ref4$context === void 0 ? 'B2C' : _ref4$context,
      departureDate = _ref4.departureDate,
      popinPosition = _ref4.popinPosition,
      _ref4$containerStyle = _ref4.containerStyle,
      containerStyle = _ref4$containerStyle === void 0 ? {
    width: 'calc(774rem / 16)'
  } : _ref4$containerStyle,
      productId = _ref4.productId,
      _ref4$theme = _ref4.theme,
      theme = _ref4$theme === void 0 ? 'default' : _ref4$theme,
      trackingData = _ref4.trackingData;
  var appContext = Object(react__WEBPACK_IMPORTED_MODULE_13__["useContext"])(_context_pageContext__WEBPACK_IMPORTED_MODULE_15__[/* ReactPageContext */ "a"]);

  var _useGQL = Object(_utils_graphql_client_use_gql_useGQL__WEBPACK_IMPORTED_MODULE_18__[/* useGQL */ "a"])({
    query: getInfoBannerQuery(productId),
    queryOptions: {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_19__[/* WIDGET_PRODUCT_FETCH_INFORMATION_BANNERS */ "Ld"]
    },
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  var productInformationBanner = !isLoading && (data === null || data === void 0 ? void 0 : (_data$productInformat = data.productInformationBanners) === null || _data$productInformat === void 0 ? void 0 : _data$productInformat.find(shouldDisplayInfoBanner({
    context: context,
    departureDate: departureDate,
    page: appContext.pageType
  })));

  if (productInformationBanner) {
    var countdown = productInformationBanner.countdown,
        popin = productInformationBanner.popin,
        toaster = productInformationBanner.toaster;

    var infoBannerCountdown = _objectSpread(_objectSpread({}, countdown), {}, {
      dateTimeEnd: countdown && moment__WEBPACK_IMPORTED_MODULE_12___default()(countdown.dateTimeEnd, 'YYYYMMDD HH:mm:ss'),
      days: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('options.countdownLabels.days'),
      hours: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('options.countdownLabels.hours'),
      minutes: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('options.countdownLabels.minutes'),
      seconds: Object(_i18n__WEBPACK_IMPORTED_MODULE_16__[/* t */ "h"])('options.countdownLabels.seconds')
    });

    return __jsx(_InfoBanner__WEBPACK_IMPORTED_MODULE_21__[/* InfoBanner */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])({}, toaster, {
      className: className,
      contentClassName: contentClassName,
      containerStyle: containerStyle,
      countdown: infoBannerCountdown,
      popin: popin,
      popinPosition: popinPosition,
      theme: theme,
      trackingData: trackingData
    }));
  }

  return null;
};

/***/ }),

/***/ "whR3":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("c72w"),
    copyObject = __webpack_require__("LtXa"),
    createAssigner = __webpack_require__("wpQC"),
    isArrayLike = __webpack_require__("9y2L"),
    isPrototype = __webpack_require__("CbIe"),
    keys = __webpack_require__("BlJA");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),

/***/ "woxT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProgressBar_ProgressBar; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.themes.js
var themes = {
  "default": {
    thSize: '0.125rem',
    thRoot: 'bg-gray-darker leading-none overflow-hidden relative',
    thBar: 'transition-width'
  },
  rounded: {
    thSize: '0.875rem',
    thRoot: 'bg-gray-light leading-none overflow-hidden relative rounded',
    thBar: 'rounded transition-width'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/progress-bar/ProgressBar.jsx
var __jsx = react_default.a.createElement;





var ProgressBar_ProgressBar = function ProgressBar(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 10 : _ref$max,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      value = _ref.value;

  if (!Object(lodash["isInteger"])(value) || value < 0) {
    return null;
  }

  var stepPercent = 100 / (max - min);
  var currentPercent = stepPercent * (value - min);
  var _themes$theme = themes[theme],
      thBar = _themes$theme.thBar,
      thRoot = _themes$theme.thRoot,
      thSize = _themes$theme.thSize;
  return __jsx("div", {
    "aria-valuemax": max,
    "aria-valuemin": min,
    "aria-valuenow": value,
    className: classnames_default()(className, thRoot),
    role: "progressbar"
  }, __jsx("div", {
    className: classnames_default()(thBar, "bg-".concat(color)),
    "data-testid": "progress-bar",
    style: {
      width: "".concat(currentPercent, "%"),
      height: thSize
    }
  }));
};

/***/ }),

/***/ "wpQC":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("R3TX"),
    isIterateeCall = __webpack_require__("R5u7");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "wxLG":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "x90g":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("HnW7");
var isCallable = __webpack_require__("ANQd");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "xGYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ InputNumber_InputNumber; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/utils/unique-id/uniqueId.js
var uniqueId = __webpack_require__("m1JM");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.themes.js

var themes = {
  "default": function _default(_ref) {
    var hasColumnLayout = _ref.hasColumnLayout,
        hasValue = _ref.hasValue,
        isDisabled = _ref.isDisabled,
        isReadOnly = _ref.isReadOnly,
        validationState = _ref.validationState;
    return {
      thRoot: hasColumnLayout ? 'flex flex-col text-center' : 'flex items-center justify-between',
      thLabel: classnames_default()('text-base', {
        'rtl:mr-px10': !hasColumnLayout,
        'mb-px5': hasColumnLayout,
        'text-gray-darker': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thNotes: 'text-xs text-gray-medium',
      thInputs: 'flex-shrink-0',
      thInput: classnames_default()('reset-input reset-input-number mx-px5 px-px5 text-center text-base outline-custom', {
        'font-bold': hasValue && !isReadOnly && !isDisabled,
        'text-blue': validationState === 'NOT_VALIDATED' && hasValue && !isReadOnly && !isDisabled,
        'text-success': validationState === 'IS_VALID' && hasValue && !isReadOnly && !isDisabled,
        'text-danger': validationState === 'IS_INVALID' && hasValue && !isReadOnly && !isDisabled
      }),
      thButton: 'reset-button cursor-default bg-gray-light border-gray-light rounded-tiny h-full text-gray-medium transition-colors',
      thButtonEnabled: 'cursor-pointer focus:bg-turquoise hover:bg-turquoise focus:border-turquoise hover:border-turquoise focus:text-white hover:text-white',
      thButtonStyle: {
        height: '1.875rem',
        width: '1.875rem'
      },
      thButtonIconWidth: '0.625rem'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx













var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }








var InputNumber_InputNumber = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(InputNumber, _Component);

  var _super = _createSuper(InputNumber);

  function InputNumber(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, InputNumber);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onChange", function (e) {
      var _this$props = _this.props,
          isLoading = _this$props.isLoading,
          isReadOnly = _this$props.isReadOnly,
          _this$props$name = _this$props.name,
          name = _this$props$name === void 0 ? '' : _this$props$name,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? lodash["noop"] : _this$props$onChange;

      if (!isReadOnly && !isLoading) {
        e.persist(); // $FlowFixMe

        var _value = Number(e.target.value);

        _this.setState({
          value: _value
        }, function () {
          return onChange(name, _value);
        });
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "decrease", function () {
      var _this$props2 = _this.props,
          _this$props2$name = _this$props2.name,
          name = _this$props2$name === void 0 ? '' : _this$props2$name,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? 0 : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 1 : _this$props2$step,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? lodash["noop"] : _this$props2$onChange;
      var currentValue = _this.state.value || min;
      var decreasedValue = currentValue - step;
      var nextValue = decreasedValue >= min ? decreasedValue : min;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "increase", function () {
      var _this$props3 = _this.props,
          _this$props3$name = _this$props3.name,
          name = _this$props3$name === void 0 ? '' : _this$props3$name,
          _this$props3$min = _this$props3.min,
          min = _this$props3$min === void 0 ? 0 : _this$props3$min,
          _this$props3$max = _this$props3.max,
          max = _this$props3$max === void 0 ? 10 : _this$props3$max,
          _this$props3$step = _this$props3.step,
          step = _this$props3$step === void 0 ? 1 : _this$props3$step,
          _this$props3$onChange = _this$props3.onChange,
          onChange = _this$props3$onChange === void 0 ? lodash["noop"] : _this$props3$onChange;
      var currentValue = _this.state.value || min;
      var increasedValue = currentValue + step;
      var nextValue = increasedValue <= max ? increasedValue : max;

      _this.setState({
        value: nextValue
      });

      onChange(name, nextValue);
    });

    _this.state = {
      value: props.value
    };
    return _this;
  }

  Object(createClass["a" /* default */])(InputNumber, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(_ref) {
      var value = _ref.value;
      this.setState(function (prevState) {
        if (prevState.value !== value) {
          return {
            value: value
          };
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ariaLabel = _this$props4.ariaLabel,
          autoComplete = _this$props4.autoComplete,
          className = _this$props4.className,
          dataTestId = _this$props4.dataTestId,
          hasColumnLayout = _this$props4.hasColumnLayout,
          _this$props4$id = _this$props4.id,
          id = _this$props4$id === void 0 ? Object(uniqueId["b" /* generateUniqueId */])([typeof this.props.label === 'string' ? this.props.label : ''], 'InputNumber_') : _this$props4$id,
          isDisabled = _this$props4.isDisabled,
          isLoading = _this$props4.isLoading,
          isReadOnly = _this$props4.isReadOnly,
          isRequired = _this$props4.isRequired,
          label = _this$props4.label,
          attendeeType = _this$props4.attendeeType,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? 10 : _this$props4$max,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? 1 : _this$props4$min,
          name = _this$props4.name,
          notes = _this$props4.notes,
          onBlur = _this$props4.onBlur,
          onClick = _this$props4.onClick,
          onFocus = _this$props4.onFocus,
          onKeyDown = _this$props4.onKeyDown,
          onKeyUp = _this$props4.onKeyUp,
          placeholder = _this$props4.placeholder,
          step = _this$props4.step,
          theme = _this$props4.theme,
          validationState = _this$props4.validationState;
      var value = this.state.value;
      var hasValue = Boolean(value);
      var decreaseDisabled = isDisabled || isLoading || Number(value) <= min;
      var increaseDisabled = isDisabled || isLoading || Number(value) >= max;

      var _themes$theme = themes[theme]({
        hasColumnLayout: hasColumnLayout,
        hasValue: hasValue,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        validationState: validationState
      }),
          thButton = _themes$theme.thButton,
          thButtonEnabled = _themes$theme.thButtonEnabled,
          thButtonIconWidth = _themes$theme.thButtonIconWidth,
          thButtonStyle = _themes$theme.thButtonStyle,
          thInput = _themes$theme.thInput,
          thInputs = _themes$theme.thInputs,
          thLabel = _themes$theme.thLabel,
          thNotes = _themes$theme.thNotes,
          thRoot = _themes$theme.thRoot;

      if (false) {}

      return __jsx("div", {
        className: classnames_default()(className, thRoot),
        "data-testid": dataTestId
      }, !!label && __jsx("label", {
        className: thLabel,
        htmlFor: id
      }, label, !!notes && __jsx("div", {
        className: thNotes
      }, notes)), __jsx("div", {
        className: thInputs
      }, !isReadOnly && __jsx("button", {
        className: classnames_default()(thButton, Object(defineProperty["a" /* default */])({}, thButtonEnabled, !decreaseDisabled)),
        disabled: decreaseDisabled,
        onClick: this.decrease,
        style: thButtonStyle,
        type: "button",
        "data-testid": attendeeType ? "".concat(attendeeType, "DecrementButton") : 'DecrementButton'
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].MINUS,
        width: thButtonIconWidth
      })), __jsx("input", Object(esm_extends["a" /* default */])({
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: thInput,
        disabled: isDisabled,
        id: id,
        max: max,
        min: min // $FlowFixMe

      }, name ? {
        name: name
      } : null, {
        onBlur: onBlur,
        onChange: this.onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
      }, placeholder ? {
        placeholder: placeholder
      } : null, {
        readOnly: true,
        required: isRequired,
        step: step,
        style: {
          width: "".concat(max.toString().length + 1, "em"),
          height: '1.875em',
          lineHeight: '1.875em'
        },
        type: "number",
        value: value
      })), !isReadOnly && __jsx("button", {
        className: classnames_default()(thButton, Object(defineProperty["a" /* default */])({}, thButtonEnabled, !increaseDisabled)),
        disabled: increaseDisabled,
        onClick: this.increase,
        style: thButtonStyle,
        type: "button",
        "data-testid": attendeeType ? "".concat(attendeeType, "IncrementButton") : 'IncrementButton'
      }, __jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].PLUS,
        width: thButtonIconWidth
      }))));
    }
  }]);

  return InputNumber;
}(react["Component"]);

Object(defineProperty["a" /* default */])(InputNumber_InputNumber, "defaultProps", {
  autoComplete: 'off',
  max: 10,
  min: 0,
  step: 1,
  theme: 'default',
  validationState: 'NOT_VALIDATED'
});

/***/ }),

/***/ "xS1b":
/***/ (function(module, exports) {

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "xVJP":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "xXeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return offersGridResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");



var offersGridResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* OFFERS_GRID */ "B"],
  resolve: function resolve(appContext) {
    var query = "query {\n      offers {\n        id name image commercialArgument timingArgument legalInformation color description href\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_OFFER_GRID */ "Pb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "xe/R":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("x90g");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "y0S3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeFiltersAsPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getLocaleFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFlexibilityDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureDateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDurationFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getProductIdsFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getOfferFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFacetsFilters; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jQ3i");
/* harmony import */ var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7xRU");
/* harmony import */ var core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_join__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("x4t0");
/* harmony import */ var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("fGyu");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("4+vj");
/* harmony import */ var _faceting_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("sW3P");














var FILTER_PARAM = 'filters';
function composeFiltersAsPayload() {
  for (var _len = arguments.length, filters = new Array(_len), _key = 0; _key < _len; _key++) {
    filters[_key] = arguments[_key];
  }

  var formData = Object(lodash__WEBPACK_IMPORTED_MODULE_9__["flattenDeep"])(filters).reduce(function (acc, _ref) {
    var name = _ref.name,
        value = _ref.value,
        operation = _ref.operation;
    if (value) acc.push("".concat(FILTER_PARAM, "[").concat(name, "][values][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_11___default.a.encode(value)));

    if (value && operation) {
      acc.push("".concat(FILTER_PARAM, "[").concat(name, "][operations][]=").concat(urijs__WEBPACK_IMPORTED_MODULE_11___default.a.encode(operation)));
    }

    return acc;
  }, []);
  return formData.join('&');
}

function buildFilters(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      operation = _ref2.operation;
  return value ? [{
    name: name,
    value: value,
    operation: operation
  }] : [];
}

function getLocaleFilters(locale) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* LOCALE_FACET_ID */ "v"],
    value: locale,
    operation: operation
  });
}
var getFlexibilityDates = function getFlexibilityDates(_ref3) {
  var departureDate = _ref3.departureDate,
      flexibility = _ref3.flexibility;

  if (!flexibility || !departureDate) {
    return {
      minDepartureDate: departureDate,
      maxDepartureDate: departureDate
    };
  }

  var minDepartureDate = moment__WEBPACK_IMPORTED_MODULE_10___default()(departureDate).subtract(flexibility, 'days');
  return {
    minDepartureDate: minDepartureDate.isAfter(moment__WEBPACK_IMPORTED_MODULE_10___default()().add(1, 'days')) ? minDepartureDate.valueOf() : moment__WEBPACK_IMPORTED_MODULE_10___default()().add(1, 'days').valueOf(),
    maxDepartureDate: moment__WEBPACK_IMPORTED_MODULE_10___default()(departureDate).add(flexibility, 'days').valueOf()
  };
};
function getDepartureDateFilters(_ref4) {
  var departureDate = _ref4.departureDate,
      _ref4$flexibility = _ref4.flexibility,
      flexibility = _ref4$flexibility === void 0 ? 0 : _ref4$flexibility,
      locale = _ref4.locale,
      _ref4$operation = _ref4.operation,
      operation = _ref4$operation === void 0 ? 'and' : _ref4$operation;

  var _getFlexibilityDates = getFlexibilityDates({
    departureDate: departureDate,
    flexibility: flexibility
  }),
      minDepartureDate = _getFlexibilityDates.minDepartureDate,
      maxDepartureDate = _getFlexibilityDates.maxDepartureDate;

  return [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_DATE_MIN_FACET_ID */ "m"],
    value: minDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_12__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_10___default()(minDepartureDate), locale),
    operation: operation
  })), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"],
    value: maxDepartureDate && Object(_client_store_utils_searchHelper__WEBPACK_IMPORTED_MODULE_12__[/* formatPertimmDate */ "a"])(moment__WEBPACK_IMPORTED_MODULE_10___default()(maxDepartureDate), locale),
    operation: operation
  })));
}
function getDepartureCityFilters(_ref5) {
  var _ref5$facets = _ref5.facets,
      facets = _ref5$facets === void 0 ? [] : _ref5$facets,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? '' : _ref5$defaultValue,
      _ref5$operation = _ref5.operation,
      operation = _ref5$operation === void 0 ? 'and' : _ref5$operation;
  var departureCityFacet = Object(lodash__WEBPACK_IMPORTED_MODULE_9__["findLast"])(facets, function (_ref6) {
    var id = _ref6.id;
    return id === _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_CITY_FACET_ID */ "i"];
  }) || {};
  var value = departureCityFacet.name || defaultValue;
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_CITY_FACET_ID */ "i"],
    value: value,
    operation: operation
  });
}
function getDurationFilters(duration) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DURATION_FACET */ "o"],
    value: duration,
    operation: operation
  });
}

function getProductIdFilters(id) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'or';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* PRODUCT_FACET_ID */ "B"],
    value: id,
    operation: operation
  });
}

function getProductIdsFilters() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 ? arguments[1] : undefined;
  return Object(lodash__WEBPACK_IMPORTED_MODULE_9__["flatten"])(ids.map(function (id) {
    return getProductIdFilters(id, operation);
  }));
}
function getOfferFilters(offerId) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  return buildFilters({
    name: _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* OFFER_ID_FACET_ID */ "z"],
    value: offerId,
    operation: operation
  });
}
var FACETS_TO_OMIT = [_faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_DATE_MIN_FACET_ID */ "m"], _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_DATE_MAX_FACET_ID */ "l"], _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DEPARTURE_CITY_FACET_ID */ "i"], _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* DURATION_FACET */ "o"], _faceting_constants__WEBPACK_IMPORTED_MODULE_13__[/* OFFER_ID_FACET_ID */ "z"]];
function getFacetsFilters() {
  var facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'and';
  var filters = facets.filter(function (facet) {
    return !FACETS_TO_OMIT.includes(facet.id);
  }).map(function (facet) {
    return buildFilters({
      name: facet.id,
      value: facet.name,
      operation: operation
    });
  });
  return Object(lodash__WEBPACK_IMPORTED_MODULE_9__["flatten"])(filters);
}

/***/ }),

/***/ "y147":
/***/ (function(module) {

module.exports = JSON.parse("[\"ase\",\"art\",\"bmp\",\"blp\",\"cd5\",\"cit\",\"cpt\",\"cr2\",\"cut\",\"dds\",\"dib\",\"djvu\",\"egt\",\"exif\",\"gif\",\"gpl\",\"grf\",\"icns\",\"ico\",\"iff\",\"jng\",\"jpeg\",\"jpg\",\"jfif\",\"jp2\",\"jps\",\"lbm\",\"max\",\"miff\",\"mng\",\"msp\",\"nitf\",\"ota\",\"pbm\",\"pc1\",\"pc2\",\"pc3\",\"pcf\",\"pcx\",\"pdn\",\"pgm\",\"PI1\",\"PI2\",\"PI3\",\"pict\",\"pct\",\"pnm\",\"pns\",\"ppm\",\"psb\",\"psd\",\"pdd\",\"psp\",\"px\",\"pxm\",\"pxr\",\"qfx\",\"raw\",\"rle\",\"sct\",\"sgi\",\"rgb\",\"int\",\"bw\",\"tga\",\"tiff\",\"tif\",\"vtf\",\"xbm\",\"xcf\",\"xpm\",\"3dv\",\"amf\",\"ai\",\"awg\",\"cgm\",\"cdr\",\"cmx\",\"dxf\",\"e2d\",\"egt\",\"eps\",\"fs\",\"gbr\",\"odg\",\"svg\",\"stl\",\"vrml\",\"x3d\",\"sxd\",\"v2d\",\"vnd\",\"wmf\",\"emf\",\"art\",\"xar\",\"png\",\"webp\",\"jxr\",\"hdp\",\"wdp\",\"cur\",\"ecw\",\"iff\",\"lbm\",\"liff\",\"nrrd\",\"pam\",\"pcx\",\"pgf\",\"sgi\",\"rgb\",\"rgba\",\"bw\",\"int\",\"inta\",\"sid\",\"ras\",\"sun\",\"tga\"]");

/***/ }),

/***/ "y316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "d", function() { return /* binding */ suggest; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ search; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ searchWithFacets; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ getIdsFromProducts; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/utils/pertimm-client/filters.js
var filters = __webpack_require__("y0S3");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/axios/index.js
var axios = __webpack_require__("ggb3");

// EXTERNAL MODULE: /opt/webapp/node_modules/error.js/index.js
var error_js = __webpack_require__("x5Ag");
var error_js_default = /*#__PURE__*/__webpack_require__.n(error_js);

// CONCATENATED MODULE: ./src/utils/pertimm-client/request.js












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PertimmRequestFailed = error_js_default.a.create({
  name: 'PertimmRequestFailed',
  message: 'The Pertimm request failed'
});

var request_getAxiosConfig = function getAxiosConfig() {
  var proxyConfig = config_default.a.get('pertimm.proxy');
  var httpsAgent;

  if (false) {}

  return {
    httpsAgent: httpsAgent,
    proxy: httpsAgent ? false : undefined
  };
};

var START_INDEX_PARAM = 'res_sf';

function recursivePostRequest(_ref) {
  var axiosConfig = _ref.axiosConfig,
      url = _ref.url,
      payload = _ref.payload,
      queryparams = _ref.queryparams,
      acc = _ref.acc;
  return Object(axios["request"])(_objectSpread(_objectSpread({}, axiosConfig), {}, {
    method: 'POST',
    url: url,
    data: payload,
    params: queryparams
  })).then(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        data = _ref2.data;

    if (!acc) acc = _objectSpread({}, data);else acc.answers = [].concat(Object(toConsumableArray["a" /* default */])(acc.answers), Object(toConsumableArray["a" /* default */])(data.answers || []));
    var nextStart = Number(data.start_answer) + Number(data.returned_answers_count) - 1;
    var hasMoreAnswers = nextStart + 1 < Number(data.available_answers_count);
    return hasMoreAnswers ? recursivePostRequest({
      axiosConfig: axiosConfig,
      url: url,
      payload: payload,
      queryparams: _objectSpread(_objectSpread({}, queryparams), {}, Object(defineProperty["a" /* default */])({}, START_INDEX_PARAM, nextStart)),
      acc: acc
    }) : acc;
  })["catch"](function () {
    var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _error$response = error.response;
    _error$response = _error$response === void 0 ? {} : _error$response;
    var _error$response$statu = _error$response.status,
        status = _error$response$statu === void 0 ? 500 : _error$response$statu,
        _error$response$data = _error$response.data,
        data = _error$response$data === void 0 ? '' : _error$response$data;
    throw new PertimmRequestFailed({
      statusCode: status,
      errors: data
    });
  });
}

function postSearchRequest(_ref3) {
  var _objectSpread3;

  var locale = _ref3.locale,
      _ref3$payload = _ref3.payload,
      payload = _ref3$payload === void 0 ? '' : _ref3$payload,
      _ref3$queryparams = _ref3.queryparams,
      queryparams = _ref3$queryparams === void 0 ? {} : _ref3$queryparams;
  return recursivePostRequest({
    url: config_default.a.get('pertimm.apiUrl'),
    axiosConfig: request_getAxiosConfig(),
    payload: payload,
    queryparams: _objectSpread((_objectSpread3 = {
      enable_interpretation_explanation: true
    }, Object(defineProperty["a" /* default */])(_objectSpread3, START_INDEX_PARAM, 0), Object(defineProperty["a" /* default */])(_objectSpread3, "search_locale", locale), Object(defineProperty["a" /* default */])(_objectSpread3, "user_locale", locale), _objectSpread3), queryparams),
    acc: undefined
  });
}
// CONCATENATED MODULE: ./src/utils/pertimm-client/index.js






var ACTIONS = {
  WORD_WHEEL: 'wordWheel',
  PERTIMM_SEARCH: 'pertimmSearch'
};
var pertimm_client_getApiKey = Object(lodash["memoize"])(function getApiKey(appContext) {
  return config_default.a.get( // eslint-disable-next-line no-nested-ternary
  appContext.isCmta ? 'api.cm_ta_api_key' : Object(sellerUtils["g" /* isSeller */])(appContext) ? 'api.seller.api_key' : 'api.api_key');
});

function suggest(_ref) {
  var appContext = _ref.appContext,
      _ref$criteria = _ref.criteria,
      criteria = _ref$criteria === void 0 ? {} : _ref$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords = criteria.keywords,
      keywords = _criteria$keywords === void 0 ? '' : _criteria$keywords,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.WORD_WHEEL,
      max_suggests: config_default.a.get('pertimm.max_suggests'),
      enable_interpretation_explanation: 'true',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }))
  });
}

function search(_ref2) {
  var appContext = _ref2.appContext,
      _ref2$criteria = _ref2.criteria,
      criteria = _ref2$criteria === void 0 ? {} : _ref2$criteria;
  var departureDate = criteria.departureDate,
      _criteria$keywords2 = criteria.keywords,
      keywords = _criteria$keywords2 === void 0 ? '' : _criteria$keywords2,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: keywords
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  });
}

function searchWithFacets(_ref3) {
  var _ref3$criteria = _ref3.criteria,
      criteria = _ref3$criteria === void 0 ? {} : _ref3$criteria,
      appContext = _ref3.appContext;
  var departureDate = criteria.departureDate,
      flexibility = criteria.flexibility;
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      query: criteria.query || '',
      'contexts[boutique]': criteria.boutique,
      'contexts[screenSize]': criteria.screenSize
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["c" /* getDepartureDateFilters */])({
      departureDate: departureDate,
      flexibility: flexibility,
      locale: appContext.locale
    }), Object(filters["g" /* getLocaleFilters */])(appContext.locale), Object(filters["b" /* getDepartureCityFilters */])({
      facets: criteria.filters,
      defaultValue: criteria.defaultDepartureCity
    }), Object(filters["d" /* getDurationFilters */])(criteria.tripDuration), Object(filters["i" /* getProductIdsFilters */])(criteria.productIds), Object(filters["e" /* getFacetsFilters */])(criteria.filters), Object(filters["h" /* getOfferFilters */])(criteria.offerId))
  });
}

function getIdsFromProducts(appContext) {
  return postSearchRequest({
    locale: appContext.locale,
    queryparams: {
      api_key: pertimm_client_getApiKey(appContext),
      action: ACTIONS.PERTIMM_SEARCH,
      max_files: config_default.a.get('pertimm.max_files'),
      format: 'json',
      disable_catalogs: 1
    },
    payload: Object(filters["a" /* composeFiltersAsPayload */])(Object(filters["g" /* getLocaleFilters */])(appContext.locale))
  }).then(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$answers = _ref4.answers,
        answers = _ref4$answers === void 0 ? [] : _ref4$answers;

    return answers.map(function (result) {
      return Object(lodash["get"])(result, 'meta.product_id[0]');
    });
  });
}



/***/ }),

/***/ "y5Lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CNIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EMAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SMS_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return MAIL_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DOCUMENT_ID; });
/* unused harmony export CGV */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IDENTITY_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PHONE_OPTIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PROFILING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FOSUN_PARTNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOCUMENT_EXPIRATION_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DOCUMENT_ISSUING_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NATIONALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLUBMED_PLUS; });
/* unused harmony export THEO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DOCUMENT_ISSUING_PLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENT_BIRTHCOUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PASSPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IDCARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DOCUMENT_TYPES; });
/* unused harmony export DOCUMENT_FIELDS */
var CNIL = 'CNIL';
var EMAIL_OPTIN = 'EMAIL_OPTIN';
var SMS_OPTIN = 'SMS_OPTIN';
var MAIL_OPTIN = 'MAIL_OPTIN';
var DOCUMENT_ID = 'DOCUMENT_ID';
var CGV = 'CGV';
var IDENTITY_NUMBER = 'IDENTITY_NUMBER';
var PHONE_OPTIN = 'PHONE_OPTIN';
var PROFILING = 'PROFILING';
var FOSUN_PARTNERS = 'FOSUN_PARTNERS';
var DOCUMENT_EXPIRATION_DATE = 'DOCUMENT_EXPIRATION_DATE';
var DOCUMENT_ISSUING_DATE = 'DOCUMENT_ISSUING_DATE';
var NATIONALITY = 'NATIONALITY';
var CLUBMED_PLUS = 'CLUBMED_PLUS';
var THEO = 'WEBTHEO';
var DOCUMENT_ISSUING_PLACE = 'DOCUMENT_ISSUING_PLACE';
var DOCUMENT_BIRTHCOUNTRY = 'DOCUMENT_BIRTHCOUNTRY';
var PASSPORT = 'PASSPORT';
var IDCARD = 'IDCARD'; // right now we only manage these two document types

var DOCUMENT_TYPES = [PASSPORT, IDCARD];
var DOCUMENT_FIELDS = [DOCUMENT_ID, DOCUMENT_ISSUING_PLACE, DOCUMENT_BIRTHCOUNTRY, DOCUMENT_EXPIRATION_DATE, DOCUMENT_ISSUING_DATE, NATIONALITY];

/***/ }),

/***/ "yH/f":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("ax0f");
var FREEZING = __webpack_require__("la3R");
var fails = __webpack_require__("ct80");
var isObject = __webpack_require__("dSaG");
var onFreeze = __webpack_require__("4CM2").onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "yLnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return teaserCardsResolver; });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("CcNa");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("kiXb");




var teaserCardsResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_0__[/* TEASER_CARDS */ "Bb"],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          backNavigation\n          next\n          previous\n          scrollBackward\n          scrollForward\n        }\n      }\n    }";
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_2__[/* LINE_COMMON_TEASER_CARDS */ "Ib"],
      strictErrors: false
    }).then(function (data) {
      Object(_i18n__WEBPACK_IMPORTED_MODULE_3__[/* addTranslationKeys */ "a"])(data.config);
      return data;
    });
  }
};

/***/ }),

/***/ "yTc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tabResolver; });
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("XygZ");
/* harmony import */ var core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_anchor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");


var tabResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* TAB */ "zb"],
  props: function props() {
    return {
      header: function header(props) {
        var data = {
          title: props.title
        };

        if (props.anchor) {
          data.id = props.anchor;
        }

        if (props.icon) {
          data.iconName = props.icon;
        }

        return data;
      }
    };
  }
};

/***/ }),

/***/ "yUod":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("ep/x");
var getMethod = __webpack_require__("Uey1");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = innerResult.call(iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "yWy0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventFormResolver; });
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("psNz");
/* harmony import */ var _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("PIvV");
/* harmony import */ var _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("CcNa");




var eventFormResolver = {
  name: _constants__WEBPACK_IMPORTED_MODULE_1__[/* EVENT_FORM */ "p"],
  resolve: function resolve(appContext) {
    var PRODUCT_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_0__["constants"].PRODUCT_TYPES;
    var query = "{\n      resorts(productType: ".concat(PRODUCT_TYPES.RESORT, ") {\n        id: resortId\n        name\n        destination {\n          area\n        }\n        openingStatus\n      }\n    }");
    return _utils_graphql_client_graphqlClient__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].runQuery(query, appContext, {
      requestName: _utils_request_requestDictionary__WEBPACK_IMPORTED_MODULE_3__[/* LINE_COMMON_EVENT_FORM */ "zb"],
      strictErrors: false
    });
  }
};

/***/ }),

/***/ "ybtA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Line; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__("uDfI");

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// EXTERNAL MODULE: ./src/client/router/useRouter.js
var useRouter = __webpack_require__("7jla");

// EXTERNAL MODULE: ./src/client/tracking/tracking-pageload/TrackingPageLoad.jsx + 2 modules
var TrackingPageLoad = __webpack_require__("TVUe");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/lodash.js
var lodash = __webpack_require__("nsO7");

// EXTERNAL MODULE: ./src/client/store/booking/booking.selector.js
var booking_selector = __webpack_require__("uL19");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/proposals.action.js + 1 modules
var proposals_action = __webpack_require__("AnR0");

// EXTERNAL MODULE: ./src/client/store/booking/selected-proposal-id/selectedProposalId.action.js
var selectedProposalId_action = __webpack_require__("uGNg");

// EXTERNAL MODULE: ./src/client/store/cms/cms.actions.js
var cms_actions = __webpack_require__("pP7N");

// EXTERNAL MODULE: ./src/client/store/global-loader/globalLoader.action.js
var globalLoader_action = __webpack_require__("R2jv");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.constants.js
var duration_constants = __webpack_require__("RBvG");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-date/departureDate.action.js
var departureDate_action = __webpack_require__("fflk");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/tripCriteria.selector.js
var tripCriteria_selector = __webpack_require__("RBO1");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/storeHelper.js
var storeHelper = __webpack_require__("Mn1B");

// EXTERNAL MODULE: ./src/client/store/trip-date-criteria/tripDateCriteria.action.js
var tripDateCriteria_action = __webpack_require__("6wD6");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/adults.action.js
var adults_action = __webpack_require__("VO7D");

// EXTERNAL MODULE: ./src/client/store/trip-information/adults/constants.js
var adults_constants = __webpack_require__("ORYz");

// EXTERNAL MODULE: ./src/client/store/trip-information/storeHelper.js
var trip_information_storeHelper = __webpack_require__("Jsmy");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("i4UL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/constants.js
var kids_constants = __webpack_require__("wQ38");

// CONCATENATED MODULE: ./src/utils/trip-information/tripInformationUtils.js












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint-disable flowtype/no-weak-types */






function getAdultsWithoutMainContact(adults) {
  return (adults || []).slice(1);
}

function getKidsBirthdate(kids) {
  return (kids || []).map(function (kid) {
    return Object(lodash["get"])(kid, 'birthdate');
  }).filter(Boolean) // kids may not have a birthdate
  .map(function (birthdate) {
    return moment_default()(birthdate);
  });
}

function getFormattedKidsBirthdate(kids, dateFormat) {
  return getKidsBirthdate(kids).map(function (birthdate) {
    return moment_default()(birthdate).format(dateFormat);
  });
}

function getResortInitialKids() {
  var kids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var initialKidsNumber = arguments.length > 1 ? arguments[1] : undefined;
  var isAdultOnlyResort = arguments.length > 2 ? arguments[2] : undefined;

  if (isAdultOnlyResort) {
    return [];
  }

  return Object(lodash["isEmpty"])(kids) && initialKidsNumber > -1 ? Array(initialKidsNumber).fill(_objectSpread({}, kids_constants["a" /* DEFAULT_KID_VALUE */])) : kids;
}


// EXTERNAL MODULE: ./src/utils/uri/constants.js
var uri_constants = __webpack_require__("Sj1w");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("hBpG");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__("5BYb");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("OZaJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("3yYM");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("9fIP");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("MMYH");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("pWxA");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("8K1b");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("K/z8");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("sRHE");

// EXTERNAL MODULE: ./src/client/store/booking/constants.js
var booking_constants = __webpack_require__("2N/j");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/constants.js
var BOOKING_ENGINE_FORM_SELECTOR = '#booking';
// EXTERNAL MODULE: ./src/client/components/widgets/navigation/Navigation.constants.js
var Navigation_constants = __webpack_require__("1cDg");

// EXTERNAL MODULE: ./src/client/store/booking/proposals/constants.js
var proposals_constants = __webpack_require__("UIAR");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/constants.js
var PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME = 'PriceRemoteStickyWrapper-initialPosition';
var PRICE_REMOTE_STICKY_WRAPPER_SELECTOR = ".".concat(PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME);
var PRICE_REMOTE_FORM_ID = 'price-remote-form';
// EXTERNAL MODULE: ./src/routes/routeBuilder.js
var routeBuilder = __webpack_require__("U2CP");

// EXTERNAL MODULE: ./src/client/router/withRouter.js
var withRouter = __webpack_require__("MGbB");

// EXTERNAL MODULE: ./src/utils/proposal/proposalUtils.js
var proposalUtils = __webpack_require__("oL6k");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/utils/resort/resortUtils.js
var resortUtils = __webpack_require__("1qsz");

// EXTERNAL MODULE: ./src/client/components/utils/scroll/scrollToElement.js + 1 modules
var scrollToElement = __webpack_require__("RUiN");

// EXTERNAL MODULE: ./src/utils/seller/sellerUtils.js + 1 modules
var sellerUtils = __webpack_require__("KL6I");

// EXTERNAL MODULE: ./src/client/components/widgets/contact-info/ContactInfoUtils.js + 1 modules
var ContactInfoUtils = __webpack_require__("ZHrn");

// EXTERNAL MODULE: ./src/i18n.js
var src_i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/views/booking/BookingEngineI18n.query.js
var BookingEngineI18n_query = __webpack_require__("9LZ4");

// EXTERNAL MODULE: ./src/utils/booking-engine-pages/BookingPagesUtils.js
var BookingPagesUtils = __webpack_require__("rcxx");

// EXTERNAL MODULE: ./src/client/components/widgets/alternative-proposals-modal/AlternativeProposalsModal.jsx
var AlternativeProposalsModal = __webpack_require__("BhBy");

// EXTERNAL MODULE: /opt/webapp/node_modules/redux/es/redux.js
var redux = __webpack_require__("9OUN");

// EXTERNAL MODULE: ./src/client/store/faceting/facetingSearch.action.js
var facetingSearch_action = __webpack_require__("loSl");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/departure-city/departureCity.action.js
var departureCity_action = __webpack_require__("+mhw");

// EXTERNAL MODULE: ./src/client/store/trip-criteria/duration/duration.action.js
var duration_action = __webpack_require__("C5R2");

// EXTERNAL MODULE: ./src/client/store/trip-information/kids/kids.action.js
var kids_action = __webpack_require__("1bWg");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-feedback/FormFeedback.jsx
var FormFeedback = __webpack_require__("DwNm");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-booking/participantsErrors.jsx
var __jsx = react_default.a.createElement;


var participantsErrors_ParticipantsErrors = function ParticipantsErrors(_ref) {
  var className = _ref.className,
      config = _ref.config,
      errors = _ref.errors,
      isSubmitted = _ref.isSubmitted;
  var maxPax = errors.maxPax,
      departureDate = errors.departureDate,
      birthdays = errors.birthdays,
      birthdaysErrorMessage = errors.birthdaysErrorMessage;

  if (maxPax) {
    return __jsx(FormFeedback["a" /* FormFeedback */], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.errorMaxGuestsLabel
    });
  }

  if (isSubmitted && departureDate) {
    return __jsx(FormFeedback["a" /* FormFeedback */], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: config.departureDateErrorMessage
    });
  }

  if (isSubmitted && birthdays) {
    return __jsx(FormFeedback["a" /* FormFeedback */], {
      className: className,
      hasAutoScroll: true,
      isError: true,
      message: birthdaysErrorMessage
    });
  }

  return null;
};
// EXTERNAL MODULE: ./src/client/components/utils/common-validator/CommonValidators.js
var CommonValidators = __webpack_require__("cjjV");

// EXTERNAL MODULE: ./src/utils/faceting/constants.js
var faceting_constants = __webpack_require__("sW3P");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-booking/participants.validator.js




var maxAge = CommonValidators["c" /* maxAge */],
    minAge = CommonValidators["d" /* minAge */],
    participants_validator_date = CommonValidators["b" /* date */];
var API_DATE_FORMAT = 'YYYYMMDD';

function hasTooManyPax(adults, children, isSeller) {
  if (isSeller) {
    return false;
  }

  return adults + children > faceting_constants["x" /* MAX_PAX */];
}

function getBirthDayErrorMessage(params) {
  var departureDate = params.departureDate,
      birthday = params.birthday,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      childAge = params.childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage;
  var onDate = departureDate ? String(departureDate) : '';
  var nowDate = moment_default()().format(API_DATE_FORMAT);
  var adultAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: nowDate,
    onDateFormat: API_DATE_FORMAT
  });
  var maxAgeValidator = maxAge({
    ageRequired: +adultAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var minAgeValidator = minAge({
    ageRequired: +childAge,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var isChildBorn = minAge({
    ageRequired: 0,
    birthdayFormat: dateFormat,
    onDate: onDate,
    onDateFormat: API_DATE_FORMAT
  });
  var dateValidator = participants_validator_date(dateFormat);

  if (!dateValidator.isValid(birthday) || !adultAgeValidator.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!isChildBorn.isValid(birthday)) {
    return birthdayFormatErrorMessage;
  }

  if (!maxAgeValidator.isValid(birthday)) {
    return adultAgeErrorMessage;
  }

  if (!minAgeValidator.isValid(birthday)) {
    return minAgeErrorMessage;
  }

  return '';
}

function participants_validator_checkFormErrors(params) {
  var _params$adults = params.adults,
      adults = _params$adults === void 0 ? 2 : _params$adults,
      _params$children = params.children,
      children = _params$children === void 0 ? 0 : _params$children,
      _params$departureDate = params.departureDate,
      departureDate = _params$departureDate === void 0 ? '' : _params$departureDate,
      _params$birthdays = params.birthdays,
      birthdays = _params$birthdays === void 0 ? [] : _params$birthdays,
      dateFormat = params.dateFormat,
      adultAge = params.adultAge,
      _params$childAge = params.childAge,
      childAge = _params$childAge === void 0 ? 0 : _params$childAge,
      birthdayFormatErrorMessage = params.birthdayFormatErrorMessage,
      adultAgeErrorMessage = params.adultAgeErrorMessage,
      minAgeErrorMessage = params.minAgeErrorMessage,
      isSeller = params.isSeller;
  var birthdaysErrorMessage = birthdays.reduce(function (errorMessage, birthday) {
    return errorMessage || getBirthDayErrorMessage({
      dateFormat: dateFormat,
      departureDate: departureDate,
      adultAge: adultAge,
      childAge: childAge,
      birthday: birthday,
      birthdayFormatErrorMessage: birthdayFormatErrorMessage,
      adultAgeErrorMessage: adultAgeErrorMessage,
      minAgeErrorMessage: minAgeErrorMessage
    });
  }, null);
  var birthdaysNotValid = birthdays.length !== children || !!birthdaysErrorMessage;
  return {
    maxPax: hasTooManyPax(+adults, +children, isSeller),
    departureDate: !departureDate,
    birthdays: birthdaysNotValid,
    birthdaysErrorMessage: birthdaysErrorMessage || birthdaysNotValid && birthdayFormatErrorMessage || ''
  };
}

/* harmony default export */ var participants_validator = ({
  checkFormErrors: participants_validator_checkFormErrors
});
// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/notification/Notification.jsx + 1 modules
var Notification = __webpack_require__("VO9w");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// CONCATENATED MODULE: ./src/client/components/utils/watch-location-query-change/WatchLocationQueryChange.jsx









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var WatchLocationQueryChange_WatchLocationQueryChange = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_WatchLocationQueryChange, _Component);

  var _super = _createSuper(_WatchLocationQueryChange);

  function _WatchLocationQueryChange() {
    Object(classCallCheck["a" /* default */])(this, _WatchLocationQueryChange);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(_WatchLocationQueryChange, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          location = _this$props.location,
          queryKey = _this$props.queryKey,
          onChange = _this$props.onChange;

      if (location.queryParams[queryKey]) {
        onChange(location.queryParams[queryKey]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          location = _this$props2.location,
          queryKey = _this$props2.queryKey,
          onChange = _this$props2.onChange;

      if (prevProps.location.queryParams[queryKey] !== location.queryParams[queryKey] && prevProps.location.pathname === location.pathname) {
        onChange(location.queryParams[queryKey]);
      }
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _WatchLocationQueryChange;
}(react["Component"]);

var WatchLocationQueryChange = Object(withRouter["a" /* withRouter */])(WatchLocationQueryChange_WatchLocationQueryChange);
// CONCATENATED MODULE: ./src/client/components/widgets/booking-step-title/BookingStepTitle.jsx
var BookingStepTitle_jsx = react_default.a.createElement;

var BookingStepTitle = function BookingStepTitle(_ref) {
  var number = _ref.number,
      title = _ref.title;
  return BookingStepTitle_jsx("h3", {
    className: "font-bold font-sans leading-tight mb-px20 reset-heading text-xl",
    "data-selector": "BookingCriteriaStep-title--".concat(number)
  }, BookingStepTitle_jsx("span", {
    className: "rtl:mr-px10 text-3xl text-blue"
  }, number, "."), title);
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("hCOa");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("87if");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("vrRf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("WNMA");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: /opt/webapp/node_modules/create-react-class/index.js
var create_react_class = __webpack_require__("Y3fD");
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-dom/index.js
var react_dom = __webpack_require__("7nmT");
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./src/client/components/frameworks/form-field/FormField.jsx
var FormField = __webpack_require__("QPdA");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-input-tel-date/FormInputTelDate.jsx
















var FormInputTelDate_jsx = react_default.a.createElement;

function FormInputTelDate_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FormInputTelDate_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormInputTelDate_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormInputTelDate_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var dayDefaultStruct = {
  ref: 'day',
  stateName: 'dayValue',
  placeholderPropName: 'dayPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var monthDefaultStruct = {
  ref: 'month',
  stateName: 'monthValue',
  placeholderPropName: 'monthPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null
};
var yearDefaultStruct = {
  ref: 'year',
  stateName: 'yearValue',
  placeholderPropName: 'yearPlaceholder',
  maxLength: 4,
  onChange: null,
  placeholder: null
};
var datePatterns = [{
  key: 'd',
  struct: dayDefaultStruct
}, {
  key: 'm',
  struct: monthDefaultStruct
}, {
  key: 'y',
  struct: yearDefaultStruct
}];
/* DEPRECATED : DO NOT USE ANYMORE */

var FormInputTelDate = create_react_class_default()({
  displayName: "FormInputTelDate",
  getDefaultProps: function getDefaultProps() {
    return {
      dateFormat: 'DDMMYYYY',
      dataSelector: 'FormInputTelDate',
      isActive: false,
      isDisabled: false,
      isReadOnly: false,
      isRequired: false,
      onBlur: function onBlur() {},
      onChange: function onChange() {},
      onClear: function onClear() {},
      onClick: function onClick() {},
      onKeyDown: function onKeyDown() {},
      onKeyUp: function onKeyUp() {}
    };
  },
  getInitialState: function getInitialState() {
    var formattedDate = moment_default()(this.props.value, this.props.dateFormat);
    return this.props.value && formattedDate.isValid() ? {
      dayValue: formattedDate.format('DD'),
      monthValue: formattedDate.format('MM'),
      yearValue: formattedDate.format('YYYY')
    } : {
      dayValue: '',
      monthValue: '',
      yearValue: ''
    };
  },
  areAllInputsFilled: function areAllInputsFilled() {
    return this.state.dayValue.length === dayDefaultStruct.maxLength && this.state.monthValue.length === monthDefaultStruct.maxLength && this.state.yearValue.length === yearDefaultStruct.maxLength;
  },
  getFormattedDate: function getFormattedDate() {
    if (Object(lodash["isEmpty"])(this.state.yearValue) && Object(lodash["isEmpty"])(this.state.monthValue) && Object(lodash["isEmpty"])(this.state.dayValue)) {
      return '';
    }

    return this.areAllInputsFilled() ? moment_default()([+this.state.yearValue, +this.state.monthValue - 1, +this.state.dayValue]).format(this.props.dateFormat) : moment_default.a.invalid().toString();
  },
  handleChange: function handleChange(value, event, nextInput, maxLength) {
    var _this = this;

    this.setState(Object(defineProperty["a" /* default */])({}, value, event.target.value), function () {
      _this.props.onChange(_this.getFormattedDate());
    });

    if (nextInput && maxLength && event.target.value.length === maxLength) {
      react_dom_default.a.findDOMNode(nextInput).focus();
    }
  },
  handleBlur: function handleBlur(value, event, nextInput) {
    if (!nextInput || Object(lodash["get"])(event, 'relatedTarget.className', '').indexOf('FormInputTelDate-input') === -1) {
      this.props.onBlur(this.getFormattedDate());
    }
  },
  getHandleChangeFunction: function getHandleChangeFunction(field, nextRef, maxLength) {
    var _this2 = this;

    return function (event) {
      return _this2.handleChange(field, event, nextRef, maxLength);
    };
  },
  getHandleBlurFunction: function getHandleBlurFunction(field, nextRef) {
    var _this3 = this;

    return function (event) {
      return _this3.handleBlur(field, event, nextRef);
    };
  },
  buildFormatStructure: function buildFormatStructure(_ref, index, patterns) {
    var struct = _ref.struct,
        size = _ref.size;
    var nextRef = index + 1 < patterns.length ? Object(lodash["get"])(this.refs, patterns[index + 1].struct.ref) : null;
    return FormInputTelDate_objectSpread(FormInputTelDate_objectSpread({}, struct), {}, {
      id: "".concat(this.props.id, "-").concat(index),
      maxLength: size,
      onChange: this.getHandleChangeFunction(struct.stateName, nextRef, size),
      onBlur: this.getHandleBlurFunction(struct.stateName, nextRef),
      placeholder: Object(lodash["get"])(this.props, struct.placeholderPropName)
    });
  },
  getPatternPos: function getPatternPos(dateFormat) {
    return function (datePattern) {
      return FormInputTelDate_objectSpread(FormInputTelDate_objectSpread({}, datePattern), {}, {
        pos: dateFormat.indexOf(datePattern.key)
      });
    };
  },
  getPatternSize: function getPatternSize(dateFormat) {
    return function (datePattern) {
      return FormInputTelDate_objectSpread(FormInputTelDate_objectSpread({}, datePattern), {}, {
        size: (dateFormat.match(new RegExp(datePattern.key, 'g')) || []).length
      });
    };
  },
  getDateStructure: function getDateStructure(dateFormat) {
    return Object(lodash["sortBy"])(datePatterns.map(this.getPatternPos(dateFormat)), ['pos']).map(this.getPatternSize(dateFormat)).map(this.buildFormatStructure);
  },
  render: function render() {
    var _this4 = this;

    var structures = this.getDateStructure(this.props.dateFormat.toLowerCase());
    return FormInputTelDate_jsx("div", {
      className: "flex items-center text-base w-full",
      "data-selector": this.props.dataSelector,
      onFocus: this.props.onFocus ? this.props.onFocus : null
    }, structures.map(function (structure, index) {
      return FormInputTelDate_jsx("div", {
        className: "decorator-slash-separator flex flex-1 items-center",
        key: "".concat(_this4.state[structure.id], "-").concat(index)
      }, FormInputTelDate_jsx("input", {
        className: classnames_default()('reset-input bg-transparent text-center w-full', {
          'cursor-not-allowed': _this4.props.isDisabled,
          'cursor-progress': _this4.props.isLoading && !_this4.props.isDisabled
        }),
        disabled: _this4.props.isDisabled,
        id: _this4.state[structure.id],
        maxLength: structure.maxLength,
        onBlur: structure.onBlur,
        onChange: structure.onChange,
        placeholder: structure.placeholder,
        ref: structure.ref,
        style: {
          height: _this4.props.height
        },
        type: "tel",
        value: _this4.state[structure.stateName]
      }));
    }));
  }
});
/* harmony default export */ var form_input_tel_date_FormInputTelDate = (Object(FormField["a" /* default */])(FormInputTelDate));
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("1IsZ");

// CONCATENATED MODULE: ./src/utils/immutability/immutability.js










function immutability_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function immutability_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      immutability_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      immutability_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function updateArrayIndexFp(array, index, updater) {
  // $FlowFixMe
  return Object.values(immutability_objectSpread(immutability_objectSpread({}, array), {}, Object(defineProperty["a" /* default */])({}, index, updater(array[index]))));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/form-validator-hoc/validationStates.js
var validationStates = __webpack_require__("45yR");

// CONCATENATED MODULE: ./src/client/components/frameworks/form-validator-hoc/FormValidator.jsx























function FormValidator_createSuper(Derived) { var hasNativeReflectConstruct = FormValidator_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function FormValidator_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function FormValidator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function FormValidator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormValidator_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormValidator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable flowtype/no-weak-types */





function _isFormValid(fields) {
  return fields.every(function (field) {
    return field.validationState === validationStates["b" /* IS_VALID */];
  });
}

function _isFieldValid(field) {
  var fieldValidators = Object(lodash["get"])(field, 'validators') || [];
  return !Object(lodash["isEmpty"])(fieldValidators) ? fieldValidators.every(function (validator) {
    return validator.isValid(field.value);
  }) : true;
}

function _setFieldValidationState(field) {
  if (Object(lodash["isEmpty"])(Object(lodash["get"])(field, 'validators'))) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: validationStates["b" /* IS_VALID */]
    });
  }

  if (!field.value) {
    return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
      validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["c" /* NOT_VALIDATED */]
    });
  }

  return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
    validationState: _isFieldValid(field) ? validationStates["b" /* IS_VALID */] : validationStates["a" /* IS_INVALID */]
  });
}

var FormValidator_FormValidator = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FormValidator, _React$Component);

  var _super = FormValidator_createSuper(FormValidator);

  function FormValidator(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FormValidator);

    _this = _super.call(this, props);
    var formFields = _this.getFields(_this.props) || [];
    _this.state = FormValidator_objectSpread(FormValidator_objectSpread({}, _this.state), {}, {
      fields: formFields.map(function (field) {
        return _setFieldValidationState(field);
      })
    });
    Object(assertThisInitialized["a" /* default */])(_this).setFieldsInState = _this.setFieldsInState.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFormSubmittable = _this.isFormSubmittable.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).isFieldValid = _this.isFieldValid.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).onSubmit = _this.onSubmit.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).updateFieldValue = _this.updateFieldValue.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).validateFields = _this.validateFields.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldByName = _this.getFieldByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    Object(assertThisInitialized["a" /* default */])(_this).getFieldValueByName = _this.getFieldValueByName.bind(Object(assertThisInitialized["a" /* default */])(_this));
    return _this;
  }

  Object(createClass["a" /* default */])(FormValidator, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!Object(lodash["isEqual"])(this.props, prevProps)) {
        this.setFieldsInState(this.props);
      }
    }
  }, {
    key: "setFieldsInState",
    value: function setFieldsInState(props) {
      var formFields = this.getFields(props) || [];
      this.setState({
        fields: formFields.map(function (field) {
          return _setFieldValidationState(field);
        })
      });
    }
    /**
     * getFields has to be implemented by the inherited form class
     *
     * @param props (the props used to get/calculate the form fields)
     * @returns the list of form fields
     *
     * const someValidFormField = {
     *    name : a string to eventually identify the field
     *    value : anything
     *    validators : a list of validators to validate the field
     *        -> ex: utils/common-validator/CommonValidators
     * }
     */
    // eslint-disable-next-line no-unused-vars

  }, {
    key: "getFields",
    value: function getFields(props) {
      return [];
    }
  }, {
    key: "validateFields",
    value: function validateFields(callback) {
      var fieldsWithValidation = this.state.fields.map(_setFieldValidationState);
      this.setState({
        fields: fieldsWithValidation
      }, callback);
      return fieldsWithValidation;
    }
  }, {
    key: "updateFieldValue",
    value: function updateFieldValue(fieldName, options, callback) {
      var _this2 = this;

      return function (newFieldValue) {
        var indexToUpdate = Object(lodash["findIndex"])(_this2.state.fields, {
          name: fieldName
        });
        var newFields = updateArrayIndexFp(_this2.state.fields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            value: newFieldValue
          });
        });

        _this2.setState({
          fields: newFields
        }, function () {
          return Object(lodash["get"])(options, 'validate') ? _this2.validateFields(callback) : callback;
        });
      };
    }
  }, {
    key: "updateFieldsValue",
    value: function updateFieldsValue(keyValues, options, callback) {
      var _this3 = this;

      var newFields = keyValues.reduce(function (updatedFields, _ref) {
        var fieldName = _ref.fieldName,
            value = _ref.value;
        var indexToUpdate = Object(lodash["findIndex"])(updatedFields, {
          name: fieldName
        });
        return updateArrayIndexFp(updatedFields, indexToUpdate, function (field) {
          return FormValidator_objectSpread(FormValidator_objectSpread({}, field), {}, {
            name: fieldName,
            value: value
          });
        });
      }, this.state.fields);
      this.setState({
        fields: newFields
      }, function () {
        return Object(lodash["get"])(options, 'validate') ? _this3.validateFields(callback) : callback;
      });
    }
  }, {
    key: "isFormSubmittable",
    value: function isFormSubmittable(callback) {
      return Object(lodash["flow"])(this.validateFields, _isFormValid)(callback);
    }
  }, {
    key: "isFieldValid",
    value: function isFieldValid(field) {
      return _isFieldValid(field);
    }
  }, {
    key: "isFormValid",
    value: function isFormValid() {
      return _isFormValid(this.state.fields);
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      return this.isFormSubmittable() && this.props.onSubmit(this.state.fields);
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(fieldName) {
      return Object(lodash["get"])(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });
    }
  }, {
    key: "getFieldValueByName",
    value: function getFieldValueByName(fieldName) {
      var formField = Object(lodash["get"])(this.state, 'fields', []).find(function (field) {
        return field.name === fieldName;
      });
      return Object(lodash["get"])(formField, 'value');
    }
  }]);

  return FormValidator;
}(react["Component"]);

/* harmony default export */ var form_validator_hoc_FormValidator = (FormValidator_FormValidator);
// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/form-inputs/input-number/InputNumber.jsx + 1 modules
var InputNumber = __webpack_require__("xGYs");

// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/participants/participants.constants.js
var DEFAULT_MIN_AGE = 0;
var DEFAULT_MAX_AGE = 18;
// CONCATENATED MODULE: ./src/client/components/widgets/trip-information/participants/Participants.jsx






















var Participants_jsx = react_default.a.createElement;

function Participants_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Participants_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Participants_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Participants_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Participants_createSuper(Derived) { var hasNativeReflectConstruct = Participants_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function Participants_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var Participants_Participants = /*#__PURE__*/function (_FormValidator) {
  Object(inherits["a" /* default */])(Participants, _FormValidator);

  var _super = Participants_createSuper(Participants);

  function Participants() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Participants);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onAdultsNumberChange", function (_, value) {
      _this.props.setAdultsNumber(value);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKidsNumberChange", function (_, value) {
      var kids = Array(value).fill(undefined).map(function (kid, i) {
        if (_this.props.kids[i]) return _this.props.kids[i];
        return kid;
      });

      var kidsValidations = _this.state.fields.map(function (_ref) {
        var validationState = _ref.validationState;
        return validationState;
      });

      _this.props.setKids({
        kids: kids,
        kidsValidations: kidsValidations
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleKids", function (idx) {
      return function (value) {
        var kidsValidations = _this.validateFields().map(function (kidsValidation) {
          return kidsValidation.validationState;
        });

        var kids = _this.props.kids.map(function (kid, index) {
          return idx !== index ? kid : Participants_objectSpread(Participants_objectSpread({}, kid), {}, {
            birthdate: moment_default()(value, _this.props.dateFormat).valueOf()
          });
        });

        _this.props.setKids({
          kids: kids,
          kidsValidations: kidsValidations
        });
      };
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Participants, [{
    key: "getFields",
    value: function getFields(props) {
      var _this2 = this;

      var dateFormat = props.dateFormat,
          kids = props.kids,
          _props$adultAge = props.adultAge,
          adultAge = _props$adultAge === void 0 ? DEFAULT_MAX_AGE : _props$adultAge,
          _props$childAge = props.childAge,
          childAge = _props$childAge === void 0 ? DEFAULT_MIN_AGE : _props$childAge,
          departureDate = props.departureDate;
      return kids.map(function (kid, idx) {
        var birthdate = _this2.getKidBirthdate(idx);

        var adultAgeInYear = +adultAge;
        var childAgeInYear = +childAge / 12;
        var params = {
          birthdayFormat: dateFormat,
          onDate: departureDate,
          onDateFormat: 'YYYYMMDD'
        };
        return {
          name: "birthdate.".concat(idx),
          value: birthdate,
          validators: [Object(CommonValidators["c" /* maxAge */])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: adultAgeInYear
          })), Object(CommonValidators["d" /* minAge */])(Participants_objectSpread(Participants_objectSpread({}, params), {}, {
            ageRequired: childAgeInYear
          }))]
        };
      });
    }
  }, {
    key: "getKidBirthdate",
    value: function getKidBirthdate(idx) {
      var birthdate = Object(lodash["get"])(this.props.kids[idx], 'birthdate');
      return Object(lodash["get"])(this.state, "fields.".concat(idx, ".value")) || (birthdate ? moment_default()(birthdate).format(this.props.dateFormat) : '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          adultsLabel = _this$props.adultsLabel,
          adultsNumber = _this$props.adultsNumber,
          childrenBirthdayDateFormatPlaceholder = _this$props.childrenBirthdayDateFormatPlaceholder,
          kids = _this$props.kids,
          kidsAgeLimit = _this$props.kidsAgeLimit,
          kidsLabel = _this$props.kidsLabel,
          minAgeInformation = _this$props.minAgeInformation;
      var maxPax = this.context.isSeller ? faceting_constants["y" /* MAX_PAX_SELLER */] : faceting_constants["x" /* MAX_PAX */] + 1;
      return Participants_jsx(react["Fragment"], null, Participants_jsx("div", {
        className: "flex flex-col md:flex-row md:items-start -mx-px20"
      }, Participants_jsx("div", {
        className: "pb-px20 px-px20 md:w-1/2"
      }, Participants_jsx("div", {
        className: "bg-white flex flex-col md:flex-row justify-between px-px20 py-px10 rounded-tiny"
      }, Participants_jsx(InputNumber["a" /* InputNumber */], {
        className: "m-px10",
        dataTestId: "ParticipantsAdultsSelect",
        min: 1,
        max: maxPax,
        step: 1,
        value: adultsNumber,
        label: adultsLabel,
        onChange: this.onAdultsNumberChange,
        attendeeType: "adults"
      }), !this.props.adultOnly && Participants_jsx(InputNumber["a" /* InputNumber */], {
        className: "mx-px10 my-px10",
        dataTestId: "ParticipantsChildrenSelect",
        min: 0,
        max: maxPax,
        step: 1,
        value: kids.length,
        label: kidsLabel,
        notes: kidsAgeLimit,
        onChange: this.onKidsNumberChange,
        attendeeType: "kids"
      })), minAgeInformation && kids.length > 0 && Participants_jsx("div", {
        className: "flex items-center md:justify-end font-sans mt-px10 text-blue text-xs",
        "data-selector": "ParticipantsKidsAgeMessage"
      }, Participants_jsx(Icon["a" /* Icon */], {
        className: "rtl:mr-px10",
        name: icons["a" /* ICONS */].SMALL_WARNING,
        size: "1rem"
      }), minAgeInformation)), kids.length > 0 && Participants_jsx("div", {
        className: "pb-px20 px-px20 md:w-1/2"
      }, Participants_jsx("ul", {
        className: "reset-list md:flex md:flex-wrap md:-m-px10"
      }, Array.from({
        length: this.props.kids.length
      }).map(function (child, idx) {
        var label = Object(dist["messageFormat"])(childrenBirthdayDateFormatPlaceholder).format({
          childIndex: "".concat(idx + 1)
        });

        var birthdate = _this3.getKidBirthdate(idx);

        var _get = Object(lodash["get"])(_this3.state, "fields.".concat(idx), {}),
            validationState = _get.validationState;

        return Participants_jsx("li", {
          className: "mb-px20 md:mb-0 last-child-mb-0 md:p-px10 md:w-1/2",
          key: idx
        }, Participants_jsx(form_input_tel_date_FormInputTelDate, {
          dateFormat: _this3.props.dateFormat,
          dayPlaceholder: _this3.props.dayPlaceholder,
          id: "birthday".concat(idx),
          label: label,
          monthPlaceholder: _this3.props.monthPlaceholder,
          yearPlaceholder: _this3.props.yearPlaceholder,
          onBlur: _this3.handleKids(idx),
          onChange: _this3.updateFieldValue("birthdate.".concat(idx)),
          value: birthdate,
          isRequired: true,
          validationState: validationState
        }));
      })))));
    }
  }]);

  return Participants;
}(form_validator_hoc_FormValidator);

Object(defineProperty["a" /* default */])(Participants_Participants, "defaultProps", {
  kids: []
});

Object(defineProperty["a" /* default */])(Participants_Participants, "contextType", ReactAppContext["b" /* default */]);
// EXTERNAL MODULE: ./src/client/context/pageContext.js
var context_pageContext = __webpack_require__("RPju");

// EXTERNAL MODULE: ./src/utils/feature-flipping/featureFlippingUtils.js
var featureFlippingUtils = __webpack_require__("L7OA");

// EXTERNAL MODULE: ./src/client/tracking/last-visited-tracking-api/index.js
var last_visited_tracking_api = __webpack_require__("evRn");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/see-more/SeeMore.jsx + 2 modules
var SeeMore = __webpack_require__("NPTU");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/responsiveContext.js
var responsiveContext = __webpack_require__("/Mt0");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/ReassuranceBlock.jsx

var ReassuranceBlock_jsx = react_default.a.createElement;









var ReassuranceBlock_ReassuranceBlock = function ReassuranceBlock(_ref) {
  var items = _ref.items;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var reinsuranceLinkURL = Object(src_i18n["d" /* getKeyValue */])('booking.form.reinsuranceLinkURL');
  var reinsuranceLegalMentions = Object(src_i18n["d" /* getKeyValue */])('booking.form.reinsuranceLegalMentions');
  var TagName = isTablet ? react["Fragment"] : SeeMore["a" /* SeeMore */];
  var seeMoreProps = isTablet ? null : {
    classNameButton: 'rtl:text-right',
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: !isTablet,
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.loadMore'),
    seeMoreSize: 110,
    theme: 'gray'
  };
  return ReassuranceBlock_jsx(TagName, seeMoreProps, ReassuranceBlock_jsx("div", {
    className: "border-1 border-blue font-sans rounded-tiny p-px10"
  }, ReassuranceBlock_jsx("div", {
    className: "text-sm md:text-md text-blue font-bold"
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceTitle')), ReassuranceBlock_jsx("div", {
    className: "text-xs md:text-base"
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceSubtitle')), items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return ReassuranceBlock_jsx("span", {
      key: iconName,
      className: "flex items-center max-w-full overflow-hidden pt-px10 text-xs md:text-base text-gray-darker"
    }, ReassuranceBlock_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-px15 flex-shrink-0",
      color: colors["a" /* COLORS */].BLUE,
      name: iconName,
      width: "1.25rem"
    }), label);
  }), !!reinsuranceLinkURL && ReassuranceBlock_jsx("div", {
    className: "md:py-px15"
  }, ReassuranceBlock_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "text-xs md:text-base text-gray-darker underline",
    url: reinsuranceLinkURL,
    target: "_blank",
    trackingData: {
      siteSection: 'Shopping_Resort',
      actionGA: 'calendarPrice',
      labelGA: 'reinsuranceTravel_readMore'
    }
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceLinkLabel'))), !!reinsuranceLegalMentions && ReassuranceBlock_jsx("div", {
    className: classnames_default()('text-xs md:text-sm text-gray-dark', {
      'pt-px10': !reinsuranceLinkURL
    })
  }, Object(src_i18n["h" /* t */])('booking.form.reinsuranceLegalMentions'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaTrigger.jsx
var CriteriaTrigger = __webpack_require__("+Rc+");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/filter-transport/FilterTransport.jsx
var FilterTransport = __webpack_require__("M3jp");

// EXTERNAL MODULE: ./src/hooks/use-sync-departure-city/useSyncDepartureCity.js
var useSyncDepartureCity = __webpack_require__("Akr5");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/TransportCriteria.jsx

var TransportCriteria_jsx = react_default.a.createElement;











var NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE;
var TransportCriteria_TransportCriteria = function TransportCriteria(_ref) {
  var departureCitiesOptions = _ref.departureCitiesOptions,
      departureCity = _ref.departureCity,
      handleDepartureCity = _ref.handleDepartureCity,
      initialTransport = _ref.initialTransport,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      reassurance = _ref.reassurance,
      _ref$transportIcon = _ref.transportIcon,
      transportIcon = _ref$transportIcon === void 0 ? icons["a" /* ICONS */].TRANSPORT : _ref$transportIcon,
      withIntroduction = _ref.withIntroduction,
      withValidDepartureCity = _ref.withValidDepartureCity;
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useState = Object(react["useState"])(false),
      isTransportCriteriaOpen = _useState[0],
      setTransportCriteriaIsOpen = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isTransportCriteriaSet = _useState2[0],
      setTransportCriteriaIsSet = _useState2[1]; // Store update effect


  var _useSyncDepartureCity = Object(useSyncDepartureCity["a" /* useSyncDepartureCity */])({
    departureCitiesOptions: departureCitiesOptions,
    departureCity: departureCity,
    initialTransport: initialTransport,
    onChange: function onChange(newDepartureCity) {
      setTransportCriteriaIsSet(Boolean(newDepartureCity));
    },
    withValidDepartureCity: withValidDepartureCity
  }),
      inputDepartureCity = _useSyncDepartureCity.inputDepartureCity,
      setInputDepartureCity = _useSyncDepartureCity.setInputDepartureCity;

  var noDepartureCitiesOptions = [{
    isDisabled: true,
    isSelected: true,
    label: Object(src_i18n["h" /* t */])('booking.priceCalendar.priceStatus.noFlight'),
    value: ''
  }];

  var saveTransport = function saveTransport() {
    if (inputDepartureCity !== departureCity) {
      if (handleDepartureCity) {
        handleDepartureCity(inputDepartureCity);
      } else {
        dispatch(Object(facetingSearch_action["a" /* changeDepartureCity */])(inputDepartureCity));
      }
    }

    setTransportCriteriaIsOpen(false);
    setTransportCriteriaIsSet(Boolean(inputDepartureCity));
  };

  var getIcon = function getIcon() {
    if (!departureCity || departureCity === NO_TRANSPORT_VALUE) {
      return icons["a" /* ICONS */].NO_TRANSPORT;
    }

    return transportIcon;
  };

  var getLabel = function getLabel() {
    if (!isTransportCriteriaSet) {
      return Object(src_i18n["h" /* t */])('faceting.transport.subTitle');
    }

    var valueToMatch = departureCity || NO_TRANSPORT_VALUE;
    var selectedOption = departureCitiesOptions.find(function (item) {
      return item.value === valueToMatch;
    });
    return selectedOption ? selectedOption.label : Object(src_i18n["h" /* t */])('faceting.transport.subTitle');
  };

  var buttonLabel = TransportCriteria_jsx("span", {
    className: "flex-1 block truncate"
  }, getLabel());

  return TransportCriteria_jsx(CriteriaTrigger["a" /* CriteriaTrigger */], {
    dataTestId: "TransportCriteria-trigger",
    buttonLabel: buttonLabel,
    buttonIcon: getIcon(),
    buttonIsFilled: Boolean(isTransportCriteriaSet && departureCity && departureCity !== NO_TRANSPORT_VALUE),
    buttons: [{
      children: Object(src_i18n["h" /* t */])('faceting.reset'),
      theme: 'link',
      onClick: function onClick() {
        setInputDepartureCity('');
      },
      className: 'cursor-pointer text-sm'
    }, {
      children: Object(src_i18n["h" /* t */])('faceting.validate'),
      color: colors["a" /* COLORS */].WHITE,
      colorBg: colors["a" /* COLORS */].TURQUOISE,
      dataTestId: 'TransportCriteria-trigger-validate',
      onClick: saveTransport
    }],
    hasSwitch: true,
    isJoyview: isJoyview,
    isOpen: isTransportCriteriaOpen,
    onClear: function onClear() {
      if (handleDepartureCity) {
        handleDepartureCity('');
      } else {
        dispatch(Object(facetingSearch_action["a" /* changeDepartureCity */])(''));
      }

      setTransportCriteriaIsSet(false);
    },
    onClose: saveTransport,
    onOpen: function onOpen() {
      setTransportCriteriaIsOpen(true);
      Object(scrollToElement["a" /* scrollToElement */])('[data-testid="TransportCriteria-trigger"]');
    },
    theme: "calendar",
    trackingLabel: "departureCity"
  }, TransportCriteria_jsx(FilterTransport["a" /* FilterTransport */], {
    changeDepartureCity: function changeDepartureCity(newDepartureCity) {
      setInputDepartureCity(newDepartureCity);
    },
    className: "h-full",
    dataTestId: "TransportCriteria-input",
    departureCity: !departureCitiesOptions.length ? '' : inputDepartureCity,
    isDisabled: !departureCitiesOptions.length,
    labelDepartingFrom: Object(src_i18n["h" /* t */])('faceting.transport.departingFrom'),
    optionsDepartureCities: departureCitiesOptions.length > 0 ? departureCitiesOptions : noDepartureCitiesOptions,
    placeholderFrom: Object(src_i18n["h" /* t */])('faceting.transport.titleFrom'),
    reassurance: reassurance,
    selectPlaceholder: Object(src_i18n["h" /* t */])('faceting.transport.selectPlaceholder'),
    withIntroduction: withIntroduction
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.jsx






var BookingCriteria_jsx = react_default.a.createElement;






























var BookingCriteria_BookingCriteriaComponent = function BookingCriteriaComponent(props) {
  var _i18n$bookingCriteria, _i18n$bookingCriteria2, _i18n$booking, _i18n$booking$form, _bookingConfig$form;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);
  var adultOnly = props.adultOnly,
      _props$adultsNumber = props.adultsNumber,
      adultsNumber = _props$adultsNumber === void 0 ? 2 : _props$adultsNumber,
      bookingConfig = props.bookingConfig,
      _props$childAge = props.childAge,
      childAge = _props$childAge === void 0 ? 0 : _props$childAge,
      children = props.children,
      config = props.config,
      _props$departureCity = props.departureCity,
      departureCity = _props$departureCity === void 0 ? '' : _props$departureCity,
      _props$i18n = props.i18n,
      i18n = _props$i18n === void 0 ? {} : _props$i18n,
      isDepartureDateAvailaible = props.isDepartureDateAvailaible,
      _props$isWinterResort = props.isWinterResort,
      isWinterResort = _props$isWinterResort === void 0 ? false : _props$isWinterResort,
      _props$kids = props.kids,
      kids = _props$kids === void 0 ? [] : _props$kids,
      resort = props.resort;

  var _useState = Object(react["useState"])(props.departureDate),
      departureDate = _useState[0],
      setDepartureDate = _useState[1];

  var _useState2 = Object(react["useState"])(props.tripDurationCriteria),
      tripDurationCriteria = _useState2[0],
      setTripDurationCriteria = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isLoading = _useState3[0];

  var _useState4 = Object(react["useState"])(false),
      hasCheckedPrice = _useState4[0],
      setHasCheckedPrice = _useState4[1];

  var departureCities = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria = i18n.bookingCriteria) === null || _i18n$bookingCriteria === void 0 ? void 0 : _i18n$bookingCriteria.departureCities.map(function (departureCityToMap) {
    return {
      value: departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.value,
      label: (departureCityToMap === null || departureCityToMap === void 0 ? void 0 : departureCityToMap.name) || ''
    };
  })) || [];
  var initialTransport = (i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingCriteria2 = i18n.bookingCriteria) === null || _i18n$bookingCriteria2 === void 0 ? void 0 : _i18n$bookingCriteria2.initialTransport) || '';
  var transportIcon = (resort === null || resort === void 0 ? void 0 : resort.transportType) || '';
  var withTransport = departureCities.some(function (_ref) {
    var value = _ref.value;
    return value !== 'NO';
  });

  if (departureDate !== props.departureDate || tripDurationCriteria !== props.tripDurationCriteria) {
    setDepartureDate(props.departureDate);
    setHasCheckedPrice(false);
    setTripDurationCriteria(props.tripDurationCriteria);
  }

  Object(react["useEffect"])(function () {
    var _kids = props.tripInformation.kids;

    if (adultOnly && _kids.length) {
      props.resetKids();
    }
  }, []);

  var checkFormErrors = function checkFormErrors() {
    var dateFormat = Object(lodash["get"])(props, 'i18n.dateFormat', 'DD/MM/YYYY');
    var birthdays = getFormattedKidsBirthdate(kids, dateFormat);
    var adultAgeInYear = +Object(lodash["get"])(props, 'i18n.adultAge', DEFAULT_MAX_AGE);

    var _childAge = typeof childAge === 'number' ? childAge : DEFAULT_MIN_AGE;

    var childAgeInYear = _childAge / 12;
    return participants_validator.checkFormErrors({
      adults: adultsNumber,
      children: kids.length,
      departureDate: tripDurationCriteria ? departureDate : null,
      birthdays: birthdays,
      dateFormat: dateFormat,
      adultAge: adultAgeInYear,
      childAge: childAgeInYear,
      birthdayFormatErrorMessage: Object(lodash["get"])(props, 'i18n.birthdayFormatErrorMessage'),
      adultAgeErrorMessage: Object(lodash["get"])(props, 'i18n.adultAgeErrorMessage'),
      minAgeErrorMessage: Object(lodash["get"])(props, 'i18n.minAgeErrorMessage'),
      isSeller: appContext.isSeller
    });
  };

  var handleChange = function handleChange(action) {
    return function (payload) {
      setHasCheckedPrice(false); // $FlowExpectedError

      action(payload);
    };
  };

  var handleCheckPrice = function handleCheckPrice() {
    var haveError = Object(lodash["values"])(checkFormErrors()).some(function (error) {
      return error;
    });

    if (!haveError) {
      return props.getPackages(departureDate);
    }
  };

  var onSubmit = function onSubmit() {
    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      id: resort.resortId,
      be: true,
      timestamp: Date.now()
    });
    setHasCheckedPrice(!!isDepartureDateAvailaible || hasCheckedPrice);

    if (isDepartureDateAvailaible) {
      handleCheckPrice();
    }
  };

  return BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
    queryKey: uri_constants["g" /* QUERY_DURATION */],
    onChange: function onChange(value) {
      return value && Object(duration_action["a" /* setDuration */])(parseInt(value, 10) || duration_constants["a" /* DEFAULT_NO_DURATION */]);
    }
  }), withTransport && BookingCriteria_jsx(react["Fragment"], null, BookingCriteria_jsx(WatchLocationQueryChange, {
    queryKey: uri_constants["k" /* QUERY_TRANSPORT */],
    onChange: function onChange(value) {
      return value && Object(departureCity_action["a" /* setDepartureCity */])({
        value: value
      });
    }
  }), BookingCriteria_jsx(BookingStepTitle, {
    number: 1,
    title: Object(src_i18n["h" /* t */])('booking.form.transportFrom')
  }), BookingCriteria_jsx("div", {
    className: "md:flex mb-px20 md:mb-px30"
  }, BookingCriteria_jsx("div", {
    className: "mb-px20 md:mb-0 md:flex-1"
  }, BookingCriteria_jsx(TransportCriteria_TransportCriteria, {
    departureCitiesOptions: departureCities,
    departureCity: departureCity,
    initialTransport: initialTransport,
    isJoyview: resort.isJoyview,
    transportIcon: transportIcon,
    withIntroduction: false,
    withValidDepartureCity: true
  }), BookingCriteria_jsx(Text["a" /* Text */], {
    className: "hidden md:block md:mt-px30 px-px5",
    text: Object(src_i18n["h" /* t */])('bookingConfig.form.legalNotice'),
    theme: "text-sans-2"
  })), BookingCriteria_jsx("div", {
    className: "md:flex-2 md:rtl:ml-px95"
  }, BookingCriteria_jsx(ReassuranceBlock_ReassuranceBlock, {
    items: (i18n === null || i18n === void 0 ? void 0 : (_i18n$booking = i18n.booking) === null || _i18n$booking === void 0 ? void 0 : (_i18n$booking$form = _i18n$booking.form) === null || _i18n$booking$form === void 0 ? void 0 : _i18n$booking$form.items) || []
  }), BookingCriteria_jsx(Text["a" /* Text */], {
    className: "md:hidden mt-px20",
    text: Object(src_i18n["h" /* t */])('bookingConfig.form.legalNotice'),
    theme: "text-sans-2"
  })))), BookingCriteria_jsx(BookingStepTitle, {
    number: withTransport ? 2 : 1,
    title: Object(src_i18n["h" /* t */])('booking.form.resortCriteriaDatesSelectionTitle')
  }), react["Children"].map(children, function (child) {
    return /*#__PURE__*/Object(react["cloneElement"])(child, {
      handleChange: handleChange
    });
  }), isWinterResort && Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('booking.reinsuranceSkiPass') && BookingCriteria_jsx(Notification["a" /* Notification */], {
    className: "mb-px40",
    color: colors["a" /* COLORS */].GRENADINE,
    hasBorder: true,
    text: i18n === null || i18n === void 0 ? void 0 : i18n.skiPassIncludedDescription,
    title: i18n === null || i18n === void 0 ? void 0 : i18n.skiPassIncludedLabel
  }), BookingCriteria_jsx(BookingStepTitle, {
    number: withTransport ? 3 : 2,
    title: bookingConfig === null || bookingConfig === void 0 ? void 0 : (_bookingConfig$form = bookingConfig.form) === null || _bookingConfig$form === void 0 ? void 0 : _bookingConfig$form.guestCriteriaTitle
  }), BookingCriteria_jsx(Participants_Participants, {
    dateFormat: Object(lodash["get"])(props, 'i18n.dateFormat'),
    dayPlaceholder: Object(lodash["get"])(props, 'i18n.dayPlaceholder'),
    monthPlaceholder: Object(lodash["get"])(props, 'i18n.monthPlaceholder'),
    yearPlaceholder: Object(lodash["get"])(props, 'i18n.yearPlaceholder'),
    adultOnly: adultOnly,
    childrenBirthdayDateFormatPlaceholder: Object(lodash["get"])(props, 'i18n.childrenBirthdayDateFormatPlaceholder', ''),
    setKids: handleChange(function (_ref2) {
      var _kids = _ref2.kids,
          kidsValidations = _ref2.kidsValidations;
      Object(es["b" /* batch */])(function () {
        props.setKids(_kids);
        Object(facetingSearch_action["m" /* setKidsValidationState */])(kidsValidations);
      });
    }),
    setAdultsNumber: handleChange(props.setAdultsNumber),
    kids: kids,
    adultsNumber: adultsNumber,
    selectAdultsLabels: Object(lodash["get"])(props, 'i18n.selectAdultsLabels'),
    selectChildrenLabels: Object(lodash["get"])(props, 'i18n.selectChildrenLabels'),
    minAgeInformation: Object(lodash["get"])(props, 'i18n.minAgeInformation'),
    adultAge: Object(lodash["get"])(props, 'i18n.adultAge'),
    childAge: Object(lodash["get"])(props, 'childAge'),
    departureDate: Object(lodash["get"])(props, 'departureDate'),
    kidsLabel: Object(lodash["get"])(props, 'i18n.common.participants.kidsLabel'),
    adultsLabel: Object(lodash["get"])(props, 'i18n.common.participants.adultsLabel'),
    kidsAgeLimit: Object(lodash["get"])(props, 'i18n.common.participants.kidsAgeLimit')
  }), (resort === null || resort === void 0 ? void 0 : resort.isResort) && kids.length > 0 && BookingCriteria_jsx("div", {
    className: "mb-px20 md:pr-px20 md:w-1/2"
  }, BookingCriteria_jsx(Notification["a" /* Notification */], {
    color: colors["a" /* COLORS */].GRENADINE,
    hasBorder: true,
    text: "**".concat(i18n.didYouKnowLabel, "** ").concat(i18n.kidStayIncludedDescription),
    title: i18n === null || i18n === void 0 ? void 0 : i18n.kidStayIncludedLabel
  })), BookingCriteria_jsx(participantsErrors_ParticipantsErrors, {
    className: "justify-end",
    config: Object(lodash["pick"])(config.booking.form, ['errorMaxGuestsLabel', 'departureDateErrorMessage']),
    errors: checkFormErrors(),
    isSubmitted: hasCheckedPrice
  }), BookingCriteria_jsx("section", {
    className: "rtl:text-right"
  }, BookingCriteria_jsx(Button["a" /* Button */], {
    className: "uppercase w-full",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    dataTestId: "BookingCriteria-checkPrice",
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_FORTH
    },
    isDisabled: isLoading,
    onClick: onSubmit,
    size: "large",
    style: {
      maxWidth: 360
    }
  }, i18n === null || i18n === void 0 ? void 0 : i18n.checkPriceLabel)));
}; // $FlowFixMe


var BookingCriteria_BookingCriteria = function BookingCriteria(_ref3) {
  var myRef = _ref3.myRef,
      otherProps = Object(objectWithoutProperties["a" /* default */])(_ref3, ["myRef"]);

  return BookingCriteria_jsx(BookingCriteria_BookingCriteriaComponent, Object(esm_extends["a" /* default */])({
    ref: myRef
  }, otherProps));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-criteria/BookingCriteria.container.jsx












var mapDispatchToProps = {
  resetKids: kids_action["a" /* resetKids */],
  setKidsValidationState: facetingSearch_action["m" /* setKidsValidationState */],
  setAdultsNumber: adults_action["b" /* setAdultsNumber */],
  setDepartureCity: departureCity_action["a" /* setDepartureCity */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  setDuration: duration_action["a" /* setDuration */],
  setKids: kids_action["b" /* setKids */],
  endLoading: globalLoader_action["c" /* endLoading */]
};

var BookingCriteria_container_mapStateToProps = function mapStateToProps(state) {
  return {
    tripInformation: Object(trip_information_storeHelper["d" /* tripInformationSelector */])(state),
    tripDurationCriteria: Object(tripCriteria_selector["c" /* getTripDuration */])(state)
  };
};

var BookingCriteriaContainer = Object(redux["d" /* compose */])(Object(es["c" /* connect */])(BookingCriteria_container_mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true
}))(BookingCriteria_BookingCriteria);
// CONCATENATED MODULE: ./src/client/components/widgets/booking-errors/BookingErrors.jsx
var BookingErrors_jsx = react_default.a.createElement;




var PROPOSAL_SEARCH_ERROR_MAPPING = {
  invalidProductId: 'calendar.resortNotOnSale',
  invalidBookingCriteria: 'invalidBookingCriteria',
  noAccommodation: 'noAccommodation',
  noProposalAvailable: 'noProposalAvailable',
  noProposalWithFlight: 'noProposalWithFlight',
  notOnSaleForThePeriod: 'calendar.resortNotOnSale',
  noTransport: 'noTransport',
  technicalError: 'technicalError',
  unableToMakeProposal: 'unableToMakeProposal',
  unavailableForBirthdates: 'ageIncorrectOrUnauthorized'
};
var BookingErrors_BookingErrors = function BookingErrors(_ref) {
  var className = _ref.className,
      errorCode = _ref.errorCode;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return BookingErrors_jsx("div", {
    id: "Package-error",
    className: classnames_default()(className, {
      'arrow-upRight arrow-large arrow-gray-lighter arrow-bg arrow-bg-gray-light md:border-t-1 relative': isTablet
    })
  }, BookingErrors_jsx("div", {
    className: "md:max-w-1/2 md:py-px25 m-auto text-blue text-center text-xl"
  }, errorCode && PROPOSAL_SEARCH_ERROR_MAPPING[errorCode] ? Object(src_i18n["h" /* t */])("booking.accommodation.errorMessages.".concat(PROPOSAL_SEARCH_ERROR_MAPPING[errorCode])) : Object(src_i18n["h" /* t */])('booking.accommodation.errorMessageNoProposal')));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("6U7i");

// EXTERNAL MODULE: ./src/client/components/utils/price/price.util.js
var price_util = __webpack_require__("NXDx");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("vfdX");

// EXTERNAL MODULE: ./src/client/components/frameworks/scrollable/Scrollable.jsx + 1 modules
var Scrollable = __webpack_require__("cVnM");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/month/BookingCalendarMonth.jsx

var BookingCalendarMonth_jsx = react_default.a.createElement;



var BookingCalendarMonth_BookingCalendarMonth = function BookingCalendarMonth(_ref) {
  var className = _ref.className,
      id = _ref.id,
      isActive = _ref.isActive,
      name = _ref.name,
      _onClick = _ref.onClick,
      price = _ref.price,
      shortName = _ref.shortName,
      style = _ref.style,
      year = _ref.year;
  return BookingCalendarMonth_jsx("button", {
    className: classnames_default()(className, 'border-1 cursor-pointer flex flex-col font-bold items-center justify-center overflow-hidden sm:p-px10 w-full', {
      'bg-white border-gray-medium text-gray-darker': !isActive,
      'bg-turquoise border-turquoise text-white': isActive
    }),
    onClick: function onClick() {
      return _onClick(id);
    },
    style: style,
    type: "button"
  }, BookingCalendarMonth_jsx("div", {
    className: "text-center text-sm sm:text-base truncate uppercase w-full"
  }, isActive ? name : shortName, isActive && BookingCalendarMonth_jsx("span", null, " ", year)), !!price && BookingCalendarMonth_jsx(react["Fragment"], null, BookingCalendarMonth_jsx("div", {
    className: "text-xs sm:text-sm truncate uppercase w-full"
  }, Object(src_i18n["h" /* t */])('price.format.from')), BookingCalendarMonth_jsx("div", {
    className: "sm:mt-px10 text-xs sm:text-base"
  }, price)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-months/BookingCalendarMonths.jsx



var BookingCalendarMonths_jsx = react_default.a.createElement;






var BookingCalendarMonths_BookingCalendarMonths = function BookingCalendarMonths(_ref) {
  var _ref$current;

  var className = _ref.className,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$months = _ref.months,
      months = _ref$months === void 0 ? [] : _ref$months,
      onClick = _ref.onClick;

  var _useState = Object(react["useState"])(null),
      hovering = _useState[0],
      setHovering = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      initialPosition = _useState2[0],
      setInitialPosition = _useState2[1];

  var ref = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      setInitialPosition(months.findIndex(function (m) {
        return m.isActive;
      }));
    }
  }, [isLoading]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var containerWidth = (ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth) || 0; // eslint-disable-next-line no-nested-ternary

  var width = !isTablet ? containerWidth / 4 : isDesktop ? containerWidth / 8 : containerWidth / 5;
  var elementWidth = isTablet ? width : width * 0.95;
  return BookingCalendarMonths_jsx("div", {
    className: (className, 'relative')
  }, BookingCalendarMonths_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('booking.common.previousMonths'),
    className: "z-1",
    controlsClassName: "mb-px20 pb-px10 sm:pb-px20",
    deltaScrollFactorClick: elementWidth * 2,
    elementWidth: elementWidth,
    forwardLabel: Object(src_i18n["h" /* t */])('booking.common.nextMonths'),
    initialPosition: elementWidth ? initialPosition : null,
    innerClassName: "md:px-px40"
  }, BookingCalendarMonths_jsx("div", {
    className: "flex mb-px20 mx-px5 sm:mx-px15 md:mx-0",
    ref: ref
  }, months.map(function (month) {
    return BookingCalendarMonths_jsx("div", {
      className: classnames_default()('flex-none px-px5 sm:px-px10 relative transition-width', {
        'w-1/4 sm:w-1/5 md:w-1/8': !month.isActive && hovering !== month.id,
        'w-1/2 sm:w-2/5 md:w-1/4': month.isActive,
        'w-3/10 sm:w-1/4 md:w-1/6': !month.isActive && hovering === month.id
      }),
      key: month.id,
      onMouseEnter: function onMouseEnter() {
        return setHovering(month.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovering(null);
      },
      style: !isTablet && elementWidth ? {
        width: month.isActive ? elementWidth * 2 : elementWidth
      } : null
    }, BookingCalendarMonths_jsx(BookingCalendarMonth_BookingCalendarMonth, Object(esm_extends["a" /* default */])({}, month, {
      className: "mb-px10 sm:mb-px15",
      onClick: onClick,
      style: {
        height: isTablet ? 85 : 52
      }
    })), month.isActive && BookingCalendarMonths_jsx("div", {
      className: "arrow-down arrow-large arrow-gray-lighter arrow-bg arrow-bg-large arrow-bg-turquoise border-b-2 border-turquoise -mb-px bottom-0 rtl:left-0 w-full transition-opacity"
    }));
  }))), BookingCalendarMonths_jsx("hr", {
    className: "absolute block border-0 border-solid border-gray-medium border-t-1 h-px m-0 -mt-px20 p-0 w-full z-0"
  }));
};
// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/template-string/TemplateString.jsx
var TemplateString = __webpack_require__("Ohju");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-calendar-resume/BookingCalendarResume.jsx

var BookingCalendarResume_jsx = react_default.a.createElement;








var BookingCalendarResume_BookingCalendarResume = function BookingCalendarResume(_ref) {
  var className = _ref.className,
      duration = _ref.duration,
      endDate = _ref.endDate,
      hasTransport = _ref.hasTransport,
      id = _ref.id,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      onClose = _ref.onClose,
      onReset = _ref.onReset,
      price = _ref.price,
      priceIsLoading = _ref.priceIsLoading,
      startDate = _ref.startDate,
      style = _ref.style;
  var track = Object(useTracking["a" /* useTracking */])();
  return BookingCalendarResume_jsx("aside", {
    className: classnames_default()(className, 'bg-white rounded-small shadow'),
    id: id,
    style: style
  }, BookingCalendarResume_jsx("div", {
    className: "relative"
  }, BookingCalendarResume_jsx("button", {
    className: "absolute leading-none reset-button rtl:right-0 text-base top-0 m-px10",
    onClick: onClose,
    type: "button"
  }, BookingCalendarResume_jsx("span", {
    className: "sr-only"
  }, Object(src_i18n["h" /* t */])('common.close')), BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CROSS,
    width: "1em"
  })), BookingCalendarResume_jsx("div", {
    className: "border-b-1 border-gray-medium p-px20"
  }, BookingCalendarResume_jsx("p", {
    className: "flex items-start mb-px30 reset-paragraph text-sm sm:text-base"
  }, BookingCalendarResume_jsx("span", {
    className: "leading-none rtl:mr-px10 text-emerald text-3xl"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CONFIRMATION,
    width: "1em"
  })), ' ', BookingCalendarResume_jsx("span", null, BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "inline-flex",
    template: Object(src_i18n["h" /* t */])('resort.startingPrice.stayDeparture'),
    values: {
      departure_date: startDate.charAt(0).toUpperCase() + startDate.slice(1)
    },
    valuesClassName: {
      departure_date: 'rtl:ml-px5 text-turquoise'
    }
  }), BookingCalendarResume_jsx("br", null), BookingCalendarResume_jsx(TemplateString["a" /* TemplateString */], {
    className: "inline-flex",
    template: Object(src_i18n["h" /* t */])('resort.startingPrice.endDateLabel'),
    values: {
      end_date: endDate.charAt(0).toUpperCase() + endDate.slice(1)
    },
    valuesClassName: {
      end_date: 'rtl:ml-px5 text-turquoise'
    }
  }))), priceIsLoading && BookingCalendarResume_jsx("div", {
    className: "flex justify-center"
  }, BookingCalendarResume_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), price && !priceIsLoading && BookingCalendarResume_jsx("p", {
    className: "mb-px20 reset-paragraph text-center text-sm"
  }, BookingCalendarResume_jsx("span", {
    className: "hidden md:inline-block leading-none rtl:mr-px10 -mb-px5 text-blue text-lg"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ACCOMODATIONS,
    width: "1em"
  }), hasTransport && BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-px5",
    name: icons["a" /* ICONS */].TRANSPORT,
    width: "1em"
  })), Object(src_i18n["h" /* t */])('price.format.from'), ' ', BookingCalendarResume_jsx("span", {
    className: "font-bold text-turquoise text-xl"
  }, price), ' ', Object(src_i18n["h" /* t */])('booking.form.duration', {
    N: duration
  }, "For ".concat(duration, " nights"))), BookingCalendarResume_jsx("p", {
    className: "flex flex-col reset-paragraph text-center text-xs sm:text-sm"
  }, isJoyview ? BookingCalendarResume_jsx("span", {
    className: "leading-one text-waterGreen"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].CLUBMED_JOYVIEW,
    isNotSquare: true,
    width: "10em"
  })) : BookingCalendarResume_jsx(react["Fragment"], null, price && !priceIsLoading ? Object(src_i18n["h" /* t */])('booking.form.priceIsLabel') : '', ' ', BookingCalendarResume_jsx("span", {
    className: "font-brand leading-one text-blue text-base sm:text-md"
  }, BookingCalendarResume_jsx(Icon["a" /* Icon */], {
    className: "-mb-2px",
    name: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), ' ', Object(src_i18n["h" /* t */])('resort.startingPrice.allInclusive'))))), BookingCalendarResume_jsx("button", {
    className: "px-px20 py-px10 reset-button text-center text-sm underline w-full",
    onClick: function onClick() {
      onReset();
      track({
        actionGA: 'calendarPrice',
        labelGA: 'resetDates'
      });
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.priceCalendar.resetCalendar'))));
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/filter-when/ArrivalDepartureDate.jsx
var ArrivalDepartureDate = __webpack_require__("YSwF");

// EXTERNAL MODULE: ./src/client/components/widgets/loading/async-loader/AsyncLoader.jsx + 1 modules
var AsyncLoader = __webpack_require__("4A3Y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("MvUL");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.action.js
var calendar_action = __webpack_require__("rueY");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.selector.js + 1 modules
var calendar_selector = __webpack_require__("05PS");

// EXTERNAL MODULE: ./src/utils/date/apiDate.js
var date_apiDate = __webpack_require__("ldK3");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-form/useAvailableDurations.js












var SUMMER = 'SUMMER';
var WINTER = 'WINTER';
var useAvailableDurations_useAvailableDurations = function useAvailableDurations(_ref) {
  var _prices$apiDate;

  var initialTransport = _ref.initialTransport,
      productId = _ref.productId;
  var availableDurations = Object(es["e" /* useSelector */])(calendar_selector["a" /* getAvailableDurations */]);
  var prices = Object(es["e" /* useSelector */])(calendar_selector["l" /* getPricesByDays */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var departureCity = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var dispatch = Object(es["d" /* useDispatch */])();
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var apiDate = Object(date_apiDate["l" /* timestampToApiDate */])(departureDate);
  var isSiblingOpen = !!(prices === null || prices === void 0 ? void 0 : (_prices$apiDate = prices[apiDate]) === null || _prices$apiDate === void 0 ? void 0 : _prices$apiDate.siblingOpen);
  var seasonProductId = isSiblingOpen ? productId.includes(SUMMER) && productId.replace(SUMMER, WINTER) || productId.replace(WINTER, SUMMER) : productId;
  Object(react["useEffect"])(function () {
    if (departureDate && !availableDurations) {
      // Get 15 next and previous availability's days
      var lastDate = moment_default()(departureDate).add(15, 'days').valueOf();
      var firstDate = moment_default()(departureDate).subtract(15, 'days').valueOf();
      dispatch(Object(calendar_action["b" /* fetchBookableDates */])({
        departureCity: departureCity || initialTransport,
        departureDate: firstDate,
        lastDate: lastDate,
        productId: seasonProductId
      }, appContext));
    }
  }, [prices, departureDate, seasonProductId]);
  return availableDurations;
};
// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.jsx + 8 modules
var TripDatePicker = __webpack_require__("pteD");

// EXTERNAL MODULE: ./src/client/components/widgets/trip-date-picker/TripDatePicker.utils.js
var TripDatePicker_utils = __webpack_require__("RqHf");

// EXTERNAL MODULE: ./src/hooks/use-block-input-departure-date/useBlockInputDepartureDate.js
var useBlockInputDepartureDate = __webpack_require__("VQ9C");

// EXTERNAL MODULE: ./src/utils/uri/redirectUtils.js
var redirectUtils = __webpack_require__("k9PE");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceLegend.jsx
var PriceLegend_jsx = react_default.a.createElement;





var PriceLegend_PriceLegend = function PriceLegend(_ref) {
  var canReset = _ref.canReset,
      durationLabel = _ref.durationLabel,
      onReset = _ref.onReset;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])();
  var discSize = isTablet ? 'calc(10rem / 16)' : 'calc(6rem / 16)';
  return PriceLegend_jsx("div", {
    className: "w-full px-px20 md:px-0"
  }, PriceLegend_jsx("div", {
    className: "pt-px10 text-base sm:text-md flex justify-between"
  }, PriceLegend_jsx("span", null, Object(src_i18n["h" /* t */])('faceting.when.pricesBasedOn'), PriceLegend_jsx("strong", {
    "data-testid": "prices-duration-label"
  }, "\xA0", durationLabel)), PriceLegend_jsx("button", {
    className: classnames_default()('rtl:pl-px10 reset-button rtl:text-right text-base underline text-gray-medium-dark cursor-pointer', {
      'opacity-50 pointer-events-none': !canReset
    }),
    "data-testid": "PriceLegend-calendarReset",
    onClick: function onClick() {
      onReset();
      track({
        categoryGA: 'resort',
        actionGA: 'calendarPrice',
        labelGA: 'resetCalendar'
      });
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.priceCalendar.resetCalendar'))), PriceLegend_jsx("div", {
    className: "flex flex-wrap font-bold pb-px10 pt-px40 sm:py-px20"
  }, PriceLegend_jsx("div", {
    className: "text-sm sm:text-base text-emerald"
  }, PriceLegend_jsx("span", {
    className: "rounded-full inline-block bg-current rtl:mr-px5",
    style: {
      width: discSize,
      height: discSize
    }
  }), Object(src_i18n["h" /* t */])('faceting.when.bestPrice')), PriceLegend_jsx("div", {
    className: "rtl:pl-px15 sm:rtl:pl-px20 text-sm sm:text-base text-orange"
  }, PriceLegend_jsx("span", {
    className: "rounded-full inline-block bg-current rtl:mr-px5",
    style: {
      width: discSize,
      height: discSize
    }
  }), Object(src_i18n["h" /* t */])('faceting.when.lastAvailability')), PriceLegend_jsx("div", {
    className: "rtl:pl-px15 sm:rtl:pl-px20 text-sm sm:text-base text-gray-light"
  }, PriceLegend_jsx("span", {
    className: "rounded-full inline-block bg-current rtl:mr-px5",
    style: {
      width: discSize,
      height: discSize
    }
  }), Object(src_i18n["h" /* t */])('faceting.when.notAvailable'))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/booking-form/price-calendar/PriceCalendar.jsx





var PriceCalendar_jsx = react_default.a.createElement;

































var PriceCalendar_NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE;
var HASH = 'PriceCalendarResume';
var SCROLL_ANCHOR = 'PriceCalendar';
var YEAR_MONTH = 'YYYYMM';

var defaultHandleChange = function defaultHandleChange(cb) {
  return function () {
    return cb();
  };
};

var PriceCalendar_PriceCalendar = function PriceCalendar(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var queryParams = location.queryParams;
  var bookingConfig = props.bookingConfig,
      _props$handleChange = props.handleChange,
      handleChange = _props$handleChange === void 0 ? defaultHandleChange : _props$handleChange,
      didMountCallback = props.didMountCallback,
      duration = props.duration,
      isJoyview = props.isJoyview,
      product = props.product,
      productId = props.productId,
      transport = props.transport;
  var urgentisationRate = bookingConfig.priceCalendar.offers.urgentisation.rateToDisplay;
  var dispatch = Object(es["d" /* useDispatch */])();
  var calendar = Object(es["e" /* useSelector */])(calendar_selector["c" /* getCalendar */]);
  var days = Object(es["e" /* useSelector */])(calendar_selector["i" /* getDays */]);
  var selectedMonth = Object(es["e" /* useSelector */])(calendar_selector["m" /* getSelectedMonth */]);
  var selectedDay = Object(es["e" /* useSelector */])(storeHelper["b" /* getDepartureDate */]);
  var isLoading = Object(es["e" /* useSelector */])(calendar_selector["e" /* getCalendarLoading */]);
  var prices = Object(es["e" /* useSelector */])(calendar_selector["l" /* getPricesByDays */]);
  var tripDuration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var departureDate = Object(es["e" /* useSelector */])(function (state) {
    return state.tripCriteria.departureDate;
  });

  var _useBlockInputDepartu = Object(useBlockInputDepartureDate["a" /* useBlockInputDepartureDate */])(true),
      blockInputDepartureDate = _useBlockInputDepartu.blockInputDepartureDate,
      setBlockInputDepartureDate = _useBlockInputDepartu.setBlockInputDepartureDate;

  var _useState = Object(react["useState"])(duration),
      durationPrice = _useState[0];

  var price = Object(es["e" /* useSelector */])(calendar_selector["g" /* getCalendarTripPrice */]);
  var priceIsLoading = Object(es["e" /* useSelector */])(calendar_selector["h" /* getCalendarTripPriceLoading */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'calendarPrice'
  });

  var _useState2 = Object(react["useState"])(false),
      hasToaster = _useState2[0],
      setHasToaster = _useState2[1];

  var _useState3 = Object(react["useState"])(tripDuration),
      inputDuration = _useState3[0],
      setInputDuration = _useState3[1];

  Object(react["useEffect"])(function () {
    if (inputDuration && inputDuration !== durationPrice) dispatch(Object(calendar_action["d" /* fetchCalendarTripPrice */])({
      appContext: appContext,
      duration: inputDuration,
      forceAdultPerTrip: true,
      location: location,
      productId: productId,
      transport: transport
    }));
  }, [productId, inputDuration, transport]);

  var _useState4 = Object(react["useState"])(!blockInputDepartureDate && departureDate ? moment_default()(departureDate) : moment_default()(selectedMonth, YEAR_MONTH)),
      openCalendarToDate = _useState4[0],
      setCalendarToDate = _useState4[1];

  Object(react["useEffect"])(function () {
    if (tripDuration !== inputDuration) {
      setInputDuration(tripDuration);
    }
  }, [tripDuration]);
  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }
  }, [selectedMonth]);
  var availableDurations = useAvailableDurations_useAvailableDurations({
    productId: productId,
    initialTransport: transport
  });

  var setUrlQueries = function setUrlQueries(queries) {
    var uri = Object(uriUtils["c" /* convertLocationToURI */])(location);
    var searchPageUrl = uri.clone().setQuery(queries);
    redirectUtils["a" /* default */].redirectTo()(searchPageUrl, {
      replace: true,
      shallow: true
    });
  };

  var onSelect = function onSelect(dates) {
    var timestamp = dates.from && moment_default()(dates.from).valueOf();

    if (blockInputDepartureDate) {
      setBlockInputDepartureDate(false);
    }

    if (departureDate !== timestamp) {
      handleChange(function () {
        Object(es["b" /* batch */])(function () {
          dispatch(Object(departureDate_action["a" /* setDepartureDate */])(timestamp));
          dispatch(Object(facetingSearch_action["g" /* clearTripDuration */])());
        });
        setInputDuration(null);
        requestAnimationFrame(function () {
          var _setUrlQueries;

          setUrlQueries((_setUrlQueries = {}, Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["f" /* QUERY_DEPARTURE_DATE */], (timestamp || undefined) && moment_default()(timestamp).format(uri_constants["e" /* QUERY_DATE_FORMAT */])), Object(defineProperty["a" /* default */])(_setUrlQueries, uri_constants["g" /* QUERY_DURATION */], undefined), _setUrlQueries));
        });

        if (timestamp) {
          track({
            labelGA: "when_".concat(moment_default()(timestamp).format('DD/MM/YYYY'))
          });
          setCalendarToDate(moment_default()(timestamp));
        }
      })();
    }

    if (dates.from && dates.to) {
      var updatedDuration = Object(TripDatePicker_utils["c" /* dateDiff */])(dates.from, dates.to);
      track({
        labelGA: "duration_".concat(updatedDuration)
      });
      setInputDuration(updatedDuration);
      Object(es["b" /* batch */])(function () {
        dispatch(Object(facetingSearch_action["d" /* changeTripDuration */])(updatedDuration));
        var dayId = parseInt(moment_default()(dates.from).format(date_apiDate["a" /* API_DATE_FORMAT */]), 10);
        var day = days.find(function (calendarDay) {
          return calendarDay.dayContent.id === dayId;
        });
        day && dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])({
          day: day.dayContent
        }));
      });
      setHasToaster(true);
      setUrlQueries(Object(defineProperty["a" /* default */])({}, uri_constants["g" /* QUERY_DURATION */], updatedDuration));
    } else {
      setInputDuration(null);
      dispatch(Object(tripDateCriteria_action["a" /* updateTripDateCriteria */])(null));
      setHasToaster(false);
    }
  };

  Object(react["useEffect"])(function () {
    dispatch(Object(calendar_action["g" /* setInitialDuration */])(duration));
    return function () {
      dispatch(Object(calendar_action["a" /* clearCalendar */])());
    };
  }, []);
  var transportQueryValue = queryParams[uri_constants["k" /* QUERY_TRANSPORT */]];
  Object(react["useEffect"])(function () {
    var hasProposalIdQueryParam = Object(lodash["has"])(queryParams, 'proposalId');

    if (hasProposalIdQueryParam || !productId || transportQueryValue && transportQueryValue !== transport) {
      return; // because a Redux action will fetch the calendar
    }

    if (selectedMonth) {
      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
    }

    dispatch(Object(calendar_action["c" /* fetchCalendar */])({
      resortId: productId,
      transport: transport,
      duration: durationPrice,
      urgentisationRate: urgentisationRate
    }, appContext));

    if (hasToaster) {
      setHasToaster(false);
    }
  }, [productId, transport, transportQueryValue, urgentisationRate]);
  Object(react["useEffect"])(function () {
    dispatch(Object(calendar_action["h" /* setPossibleDepartureDate */])());
    /**
     * Should fetch proposals after state update for arrivaldate
     * see BookingEngineForm, ligne 170.
     * */

    didMountCallback && didMountCallback();
  }, [calendar.months]);

  var onSelectDate = function onSelectDate(day) {
    props.onSelectDate(day);
  };
  /**
   * make sure the selected date is up to date after a transport update
   */


  Object(react["useEffect"])(function () {
    if (selectedDay) {
      var day = days.find(function (calendarDay) {
        return calendarDay.dayContent.id === selectedDay;
      });
      day && onSelectDate(day.dayContent);
    }
  }, [calendar, transport, selectedDay]);
  Object(react["useEffect"])(function () {
    if (hasToaster) {
      requestAnimationFrame(function () {
        Object(scrollToElement["a" /* scrollToElement */])("#".concat(HASH), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
      });
    }
  }, [hasToaster]);
  var from = departureDate && !blockInputDepartureDate ? moment_default()(departureDate).toDate() : null;
  var to = from && inputDuration ? moment_default()(from).add({
    days: inputDuration
  }).toDate() : null;

  var _useState5 = Object(react["useState"])(from),
      hovered = _useState5[0],
      setHovered = _useState5[1];

  Object(react["useEffect"])(function () {
    if (!departureDate) {
      setHovered(null);
    }
  }, [departureDate]);

  var onSelectMonth = function onSelectMonth(monthId) {
    if (monthId !== selectedMonth) {
      if (!from && departureDate) {
        var _setUrlQueries3;

        setUrlQueries((_setUrlQueries3 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["f" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries3, uri_constants["g" /* QUERY_DURATION */], undefined), _setUrlQueries3));
        dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
        dispatch(Object(facetingSearch_action["g" /* clearTripDuration */])());
      }

      setCalendarToDate(moment_default()(selectedMonth, YEAR_MONTH));
      requestAnimationFrame(function () {
        setCalendarToDate(moment_default()(monthId, YEAR_MONTH));
        dispatch(Object(calendar_action["e" /* selectMonth */])(monthId));
      });
    }
  };

  var onReset = function onReset() {
    var _setUrlQueries4;

    requestAnimationFrame(function () {
      Object(scrollToElement["a" /* scrollToElement */])("[data-scroll-anchor=\"".concat(SCROLL_ANCHOR, "\"]"), 500, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
    });
    setUrlQueries((_setUrlQueries4 = {}, Object(defineProperty["a" /* default */])(_setUrlQueries4, uri_constants["f" /* QUERY_DEPARTURE_DATE */], undefined), Object(defineProperty["a" /* default */])(_setUrlQueries4, uri_constants["g" /* QUERY_DURATION */], undefined), _setUrlQueries4));
    dispatch(Object(departureDate_action["a" /* setDepartureDate */])(null));
    dispatch(Object(facetingSearch_action["g" /* clearTripDuration */])());
    setInputDuration(null);
    setHasToaster(false);
  };

  var onDayMouseOver = function onDayMouseOver(day) {
    setHovered(day);
  };

  var displayedDuration = from && (to || hovered) ? Object(TripDatePicker_utils["c" /* dateDiff */])(from, to || hovered || from) || durationPrice : durationPrice;
  var durationLabel = Object(dist["messageFormat"])({
    n: Object(src_i18n["h" /* t */])('faceting.when.durationPlural'),
    _0: '-',
    _1: Object(src_i18n["h" /* t */])('faceting.when.durationSingular')
  }).format({
    n: displayedDuration,
    count: displayedDuration
  });
  var locale = appContext.locale;
  var selectedDayPrice = selectedDay && prices && prices[selectedDay];
  var instalmentSelectedDayPrice = Object(price_util["b" /* getInstallmentPrice */])({
    currency: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.currency,
    formattedValue: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.price,
    value: selectedDayPrice === null || selectedDayPrice === void 0 ? void 0 : selectedDayPrice.priceValue
  }, locale);
  var dateFormat = Object(src_i18n["h" /* t */])('booking.form.dateFormat');
  var longDateFormat = Object(src_i18n["h" /* t */])('resort.startingPrice.longDateFormat');
  return PriceCalendar_jsx("div", {
    id: "calendar",
    "data-scroll-anchor": SCROLL_ANCHOR
  }, PriceCalendar_jsx("div", {
    className: "-mx-px20 md:mx-0 relative",
    style: {
      minHeight: 450
    }
  }, !Object(lodash["isEmpty"])(calendar) && PriceCalendar_jsx(react["Fragment"], null, PriceCalendar_jsx(BookingCalendarMonths_BookingCalendarMonths, {
    isLoading: isLoading,
    months: calendar.blocks.map(function (b) {
      return {
        id: b.id,
        isActive: b.id === selectedMonth,
        name: b.name,
        price: Object(price_util["b" /* getInstallmentPrice */])(b.price, locale),
        shortName: b.shortName,
        year: b.year
      };
    }),
    onClick: onSelectMonth
  }), PriceCalendar_jsx(PriceLegend_PriceLegend, {
    durationLabel: durationLabel,
    canReset: !!from,
    onReset: onReset
  }), PriceCalendar_jsx(TripDatePicker["a" /* TripDatePicker */], {
    className: "md:mb-px20 md:mb-px40 -mx-px md:mx-0",
    displayPrices: true,
    duration: durationPrice,
    hasInstalment: true,
    isJoyview: isJoyview,
    navbarElement: function navbarElement(_ref) {
      var month = _ref.month;
      var datePickerMonth = Number(moment_default()(month).format(YEAR_MONTH));

      if (datePickerMonth !== selectedMonth && !isLoading && (from || to)) {
        dispatch(Object(calendar_action["e" /* selectMonth */])(datePickerMonth));
      }

      return null;
    },
    onSelect: onSelect,
    onDayMouseOver: onDayMouseOver,
    optionsDuration: (availableDurations === null || availableDurations === void 0 ? void 0 : availableDurations.length) ? availableDurations : [],
    openCalendarToDate: openCalendarToDate,
    prices: prices,
    product: product,
    selectedDays: {
      from: from,
      to: to
    },
    selectedMonth: selectedMonth,
    withLongDayFormat: isTablet,
    withPriceDetails: isDesktop
  }), PriceCalendar_jsx(ArrivalDepartureDate["a" /* ArrivalDepartureDate */], {
    arrivalDate: from && moment_default()(from).format(dateFormat),
    departureDate: to && moment_default()(to).format(dateFormat)
  }), from && to && hasToaster && !isLoading && PriceCalendar_jsx(BookingCalendarResume_BookingCalendarResume, {
    className: "absolute bottom-0 md:bottom-auto rtl:right-0 rtl:slideInRight mx-px20 md:mx-0 z-3",
    duration: inputDuration ? inputDuration : 0,
    hasTransport: Boolean(transport && transport !== PriceCalendar_NO_TRANSPORT_VALUE),
    id: HASH,
    isJoyview: isJoyview,
    endDate: moment_default()(to).format(longDateFormat),
    onClose: function onClose() {
      return setHasToaster(false);
    },
    onReset: onReset,
    price: inputDuration && inputDuration !== durationPrice ? Object(price_util["b" /* getInstallmentPrice */])(price === null || price === void 0 ? void 0 : price.bestPrice, locale) : instalmentSelectedDayPrice,
    priceIsLoading: priceIsLoading,
    startDate: moment_default()(from).format(longDateFormat),
    style: isTablet ? {
      marginTop: -200,
      width: 380
    } : {
      marginTop: -100,
      width: 'calc(100% - 2.5rem)'
    }
  })), isLoading && PriceCalendar_jsx("div", {
    className: "absolute bg-gray-lighter flex items-center justify-center inset-0 w-full z-1"
  }, PriceCalendar_jsx(AsyncLoader["a" /* AsyncLoader */], null))));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.jsx






















var BookingEngineForm_jsx = react_default.a.createElement;

function BookingEngineForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngineForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngineForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngineForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function BookingEngineForm_createSuper(Derived) { var hasNativeReflectConstruct = BookingEngineForm_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function BookingEngineForm_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }


























var defaultProps = {
  clearProposals: lodash["noop"],
  kids: [],
  i18n: null,
  dataSelector: 'BookingEngineForm',
  fetchProposalsAndRedirect: lodash["noop"],
  suggestions: {
    dates: [],
    resorts: []
  }
};

var BookingEngineForm_BookingEngineForm = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(BookingEngineForm, _Component);

  var _super = BookingEngineForm_createSuper(BookingEngineForm);

  function BookingEngineForm(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, BookingEngineForm);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "bookingCriteriaNode", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setShouldFetchProposals", function () {
      var queryParams = _this.props.location.queryParams;
      var fetch = queryParams.fetch;
      var shouldFetch = Boolean(fetch && "".concat(fetch) === '1');
      return function () {
        _this.setState({
          shouldFetchProposals: shouldFetch
        });
      };
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "checkLoading", function () {
      if (_this.props.suggestions.dates.length > 0 || _this.props.suggestions.durations.length > 0 || _this.props.suggestions.resorts.length > 0 || // errors are so badly handle that it's easier to check if there is no proposal rather that there is an error
      _this.props.proposals.some(function (_ref) {
        var id = _ref.id;
        return !id;
      }) || _this.props.proposals.some(function (proposal) {
        return proposal.price.gap > proposals_constants["t" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
      })) {
        _this.props.endLoading();
      }
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleDepartureDate", function () {
      var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var newDepartureDate = moment_default()(String(day === null || day === void 0 ? void 0 : day.id)).valueOf();

      if (_this.props.departureDate !== (day === null || day === void 0 ? void 0 : day.id)) {
        _this.props.setDepartureDate(newDepartureDate);
      }

      _this.props.updateTripDateCriteria({
        day: day
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onFormSubmit", function (event) {
      event.preventDefault();
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "getPackages", function (newArrivalDate) {
      var fetchParams = BookingEngineForm_objectSpread(BookingEngineForm_objectSpread({
        productId: _this.props.resort.id,
        departureCity: _this.props.departureCity,
        duration: _this.props.duration,
        isJoyView: _this.props.resort.isJoyview,
        // $FlowFixMe it's a recomposition
        globalLoaderLabel: _this.context.isSeller ? _this.props.i18n.booking.partners.form.proposalsLoaderLabel : _this.props.i18n.booking.form.proposalsLoaderLabel
      }, Object(sellerUtils["g" /* isSeller */])(_this.context) ? Object(ContactInfoUtils["e" /* getAllAttendeesIds */])(_this.props.tripInformation) : null), {}, {
        newArrivalDate: newArrivalDate,
        bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR
      });

      return _this.props.fetchProposalsAndRedirect(fetchParams, _this.context, _this.props.location);
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirectToBE", function (newArrivalDate) {
      _this.setState({
        showModal: false
      });

      _this.getPackages(newArrivalDate).then(function () {
        _this.setState({
          showModal: true
        });
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "shouldDisplayModal", function () {
      return _this.hasCounterProposals() && _this.canDisplayCounterProposals() && _this.state.showModal;
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "goToBookingEngine", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props, resort, proposals, attendees, setCms, setAttendees, prepareBe, history, location, _yield$fetchBookingEn, config, legalInformations, proposalId;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, resort = _this$props.resort, proposals = _this$props.proposals, attendees = _this$props.attendees, setCms = _this$props.setCms, setAttendees = _this$props.setAttendees, prepareBe = _this$props.prepareBe, history = _this$props.history, location = _this$props.location;

              _this.setState({
                showModal: false
              });

              _context.next = 4;
              return Object(BookingEngineI18n_query["a" /* fetchBookingEngineI18nQuery */])(_this.context);

            case 4:
              _yield$fetchBookingEn = _context.sent;
              config = _yield$fetchBookingEn.config;
              legalInformations = _yield$fetchBookingEn.legalInformations;

              if (config && legalInformations) {
                setCms(config, legalInformations);
                setAttendees(attendees);
              }

              proposalId = proposals[0].id;
              prepareBe({
                resort: resort,
                proposals: {
                  proposals: proposals,
                  resort: resort
                },
                proposalId: proposalId
              });
              history.pushRoute(Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals, resort, proposalId, location.queryParams));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.state = {
      showModal: true,
      shouldFetchProposals: false,
      isDepartureDateAvailaible: true
    };
    _this.bookingCriteriaNode = /*#__PURE__*/Object(react["createRef"])();
    return _this;
  }

  Object(createClass["a" /* default */])(BookingEngineForm, [{
    key: "scrollToBookingEngineEntryPoint",
    value: function scrollToBookingEngineEntryPoint() {
      var _this2 = this;

      /**
       * The setTimeout is needed to make sure the modal is closed before trying to scroll
       */
      setTimeout(function () {
        var bookingEngineEntry = _this2.props.bookingEngineEntry;
        var PRICE_CALENDAR = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_CALENDAR,
            PRICE_REMOTE = booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE;
        var bookingEngineFormSelector = document.querySelector(BOOKING_ENGINE_FORM_SELECTOR);
        var priceRemoteSelector = document.querySelector(PRICE_REMOTE_STICKY_WRAPPER_SELECTOR);

        if (bookingEngineEntry === PRICE_CALENDAR && bookingEngineFormSelector) {
          // $FlowFixMe the validity of this check in the condition above
          bookingEngineFormSelector.scrollIntoView();
        } else if (bookingEngineEntry === PRICE_REMOTE && priceRemoteSelector) {
          // $FlowFixMe the validity of this check in the condition above
          priceRemoteSelector.scrollIntoView();
        }
      }, 0);
    }
  }, {
    key: "setIsDepartureDateAvailaible",
    value: function () {
      var _setIsDepartureDateAvailaible = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(departureDate) {
        var _yield$getBookingCrit, bookingCriteria;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(BookingPagesUtils["h" /* getBookingCriteriaOffsetSell */])(this.props.resort.id, this.context);

              case 2:
                _yield$getBookingCrit = _context2.sent;
                bookingCriteria = _yield$getBookingCrit.bookingCriteria;
                this.setState({
                  isDepartureDateAvailaible: !Object(BookingPagesUtils["g" /* checkIsDepartureDateAvailaible */])(String(departureDate), bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.offsetSell)
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setIsDepartureDateAvailaible(_x) {
        return _setIsDepartureDateAvailaible.apply(this, arguments);
      }

      return setIsDepartureDateAvailaible;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var _this3 = this;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // We assume that if we have proposals, it implies we come from the booking engine.
                this.props.clearSelectedProposal();
                this.props.clearProposals();
                _context3.next = 4;
                return this.setIsDepartureDateAvailaible(this.props.departureDate);

              case 4:
                /**
                 * This setTimeout is needed also (plus the one used in scrollToBookingEngineEntryPoint)
                 * because of a race condition with RouteChangeListener scroll (a bugfix for hash)
                 * See RouteChangeListener line 29
                 */
                setTimeout(function () {
                  return _this3.scrollToBookingEngineEntryPoint();
                }, 0);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
    /**
     * #10731
     * This means the user comes from a metasearch and has already selected trip criterias.
     * We force fetching proposals to avoid one more click on continue button
     * but we cannot make the query on componentDidMount hook because state is not yet hydrated from query params
     * arrivalDate is mandatory and will be set after calendar did mount.
     * See PriceCalendar & didMountCallback
     * url format: ?duration=6&date=2019-04-30&number_of_adults=2&kids=2015-03-02_2014-12-20&fetch=1&_ab2=b
     */

  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4(prevProps, prevState) {
        var oldProposal, newProposal;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.props.departureDate !== prevProps.departureDate)) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.setIsDepartureDateAvailaible(this.props.departureDate);

              case 3:
                if (this.state.shouldFetchProposals && !prevState.shouldFetchProposals && this.bookingCriteriaNode.current) {
                  // $FlowFixMe
                  this.bookingCriteriaNode.current.onSubmit();
                }

                oldProposal = prevProps.proposals[0];
                newProposal = this.props.proposals[0];

                if (!Object(lodash["isEqual"])(oldProposal, newProposal) || !Object(lodash["isEqual"])(prevProps.suggestions, this.props.suggestions)) {
                  this.checkLoading(); // scroll to errors if any

                  if (Object(proposalUtils["r" /* hasErroredProposals */])(this.props.proposals) || this.hasCounterProposals() && !this.canDisplayCounterProposals()) {
                    // the setTimeout is needed to make sure the global loader is closed before trying to scroll
                    setTimeout(function () {
                      Object(scrollToElement["a" /* scrollToElement */])('#Package-error', 600, ".".concat(Navigation_constants["b" /* NAVIGATION_OFFSET_SELECTOR */]));
                    });
                  }
                } // makes sure the counter proposal modal will be closed on resort change


                if (prevProps.resort.id !== this.props.resort.id) {
                  this.setState({
                    showModal: false
                  });
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidUpdate(_x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
    /**
     * In case the fetch proposals return counter proposals the global loader stay so we need to end it ourself
     * IT stay because we want to keep it when we redirect to the BE for prevent any flickering
     */

  }, {
    key: "canDisplayCounterProposals",
    value: function canDisplayCounterProposals() {
      var _this4 = this;

      return !this.props.proposals.some(function (proposal) {
        return proposal.price.gap >= proposals_constants["s" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */] && !Object(sellerUtils["g" /* isSeller */])(_this4.context);
      }) || this.props.suggestions.dates.length > 0 || this.props.suggestions.durations.length > 0 || this.props.suggestions.resorts.length > 0;
    }
  }, {
    key: "hasCounterProposals",
    value: function hasCounterProposals() {
      var proposal = this.props.proposals[0];
      var _this$props$suggestio = this.props.suggestions,
          dates = _this$props$suggestio.dates,
          durations = _this$props$suggestio.durations,
          resorts = _this$props$suggestio.resorts;
      return dates.length > 0 || durations.length > 0 || resorts.length > 0 || !Object(lodash["isEmpty"])(proposal) && proposal.price && proposal.price.gap > proposals_constants["t" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$bookingCo,
          _this$props$bookingCo2,
          _this$props$bookingCo3,
          _this$props$bookingCo4,
          _this$props$resort,
          _this$props$resort2,
          _this5 = this,
          _this$props$proposals;

      var failedProposals = Object(proposalUtils["r" /* hasErroredProposals */])(this.props.proposals);

      var i18n = BookingEngineForm_objectSpread(BookingEngineForm_objectSpread({}, this.props.i18n), {}, {
        adultAge: Object(lodash["get"])(this.props, 'bookingConfig.form.adultAge'),
        bookingCriteria: this.props.bookingCriteria,
        childrenBirthdayDateFormatPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.childrenBirthdayDateFormatPlaceholder'),
        dateFormat: Object(lodash["get"])(this.props, 'bookingConfig.form.dateFormat'),
        dayPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.dayPlaceholder'),
        monthPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.monthPlaceholder'),
        yearPlaceholder: Object(lodash["get"])(this.props, 'bookingConfig.form.yearPlaceholder'),
        dateValidate: Object(lodash["get"])(this.props, 'bookingConfig.form.dateValidate'),
        durationTitle: Object(lodash["get"])(this.props, 'bookingConfig.form.durationTitle'),
        durationOptionsFormat: Object(lodash["get"])(this.props, 'bookingConfig.form.selectDuration'),
        selectAdultsLabels: Object(lodash["get"])(this.props, 'bookingConfig.form.selectAdultsLabels'),
        selectChildrenLabels: Object(lodash["get"])(this.props, 'bookingConfig.form.selectChildrenLabels'),
        legalNotice: Object(lodash["get"])(this.props, 'bookingConfig.form.legalNotice'),
        minAgeInformation: Object(lodash["get"])(this.props, 'resort.minAuthorizedAge.formattedValue'),
        birthdayFormatErrorMessage: Object(lodash["get"])(this.props, 'bookingConfig.form.errors.birthdayFormat'),
        adultAgeErrorMessage: Object(lodash["get"])(this.props, 'bookingConfig.form.errors.adultChild'),
        skiPassIncludedLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedLabel'),
        skiPassIncludedDescription: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.skiPassIncludedDescription'),
        kidStayIncludedLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedLabel'),
        didYouKnowLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.didYouKnowLabel'),
        kidStayIncludedDescription: Object(lodash["get"])(this.props, 'bookingConfig.form.reinsurance.kidStayIncludedDescription'),
        minAgeErrorMessage: Object(lodash["get"])(this.props, 'resort.minAgeErrorMessage.formattedValue'),
        proposalsLoaderLabel: Object(lodash["get"])(this.props, 'bookingConfig.form.proposalsLoaderLabel')
      });

      Object(src_i18n["a" /* addTranslationKeys */])({
        booking: this.props.i18n.booking,
        common: this.props.i18n.common,
        package: this.props.i18n.package,
        priceRemote: this.props.i18n.priceRemote,
        resort: this.props.i18n.resort,
        bookingConfig: {
          form: {
            legalNotice: (_this$props$bookingCo = this.props.bookingConfig) === null || _this$props$bookingCo === void 0 ? void 0 : (_this$props$bookingCo2 = _this$props$bookingCo.form) === null || _this$props$bookingCo2 === void 0 ? void 0 : _this$props$bookingCo2.legalNotice
          }
        }
      });
      return BookingEngineForm_jsx("div", {
        className: "bg-gray-lighter border-b-1 border-t-1 border-gray-light shadow-inner-bottom shadow-inner-top"
      }, BookingEngineForm_jsx(SiteContainer["a" /* SiteContainer */], null, BookingEngineForm_jsx("form", {
        className: "py-px30",
        id: "booking",
        onSubmit: this.onFormSubmit
      }, BookingEngineForm_jsx("h2", {
        className: "border-b-1 border-gray-light font-bold leading-tight mb-px20 pb-px10 reset-heading text-blue text-2xl md:text-4xl air360-replay-ignore",
        "data-cs-mask": true
      }, (_this$props$bookingCo3 = this.props.bookingConfig) === null || _this$props$bookingCo3 === void 0 ? void 0 : (_this$props$bookingCo4 = _this$props$bookingCo3.form) === null || _this$props$bookingCo4 === void 0 ? void 0 : _this$props$bookingCo4.title), BookingEngineForm_jsx(BookingCriteriaContainer, {
        myRef: this.bookingCriteriaNode,
        adultOnly: Object(lodash["get"])(this.props, 'resort.adultOnly'),
        isWinterResort: Object(resortUtils["b" /* isWinterResort */])(this.props.resort),
        adultsNumber: this.props.adultsNumber,
        bookingConfig: this.props.bookingConfig,
        duration: this.props.duration,
        departureDate: this.props.departureDate,
        isDepartureDateAvailaible: this.state.isDepartureDateAvailaible,
        departureCity: this.props.departureCity,
        enableTransfer: Object(lodash["get"])(this.props, 'bookingConfig.enableTransfer'),
        kids: this.props.kids,
        getPackages: this.getPackages,
        isJoyView: Object(lodash["get"])(this.props, 'resort.isJoyview', false),
        isTransportEnabled: Object(lodash["get"])(this.props, 'package.transport.enableTransport', false),
        pushImage: this.props.pushImage,
        config: this.props.config,
        childAge: Object(lodash["get"])(this.props, 'resort.minAuthorizedAge.value'),
        resort: Object(lodash["get"])(this.props, 'resort'),
        i18n: i18n
      }, BookingEngineForm_jsx(PriceCalendar_PriceCalendar, {
        bookingConfig: this.props.bookingConfig,
        cmsPrice: this.props.cmsPrice,
        cmsStartingPrice: this.props.cmsStartingPrice,
        duration: this.props.duration,
        didMountCallback: this.setShouldFetchProposals(),
        isJoyview: !!((_this$props$resort = this.props.resort) === null || _this$props$resort === void 0 ? void 0 : _this$props$resort.isJoyview),
        key: (_this$props$resort2 = this.props.resort) === null || _this$props$resort2 === void 0 ? void 0 : _this$props$resort2.id,
        onSelectDate: this.handleDepartureDate,
        product: this.props.resort,
        productId: this.props.resort.id,
        selectedDay: this.props.departureDate,
        transport: this.props.departureCity,
        travelAdvisorConfig: this.props.travelAdvisorConfig
      })), !this.state.isDepartureDateAvailaible || failedProposals || this.props.proposals.some(function (proposal) {
        return proposal.price && proposal.price.gap >= proposals_constants["s" /* PRICE_COUNTER_PROPOSAL_SELLER_THRESHOLD */] && !Object(sellerUtils["g" /* isSeller */])(_this5.context);
      }) ? BookingEngineForm_jsx(BookingErrors_BookingErrors, {
        className: "mt-px20 md:mt-px30",
        errorCode: (_this$props$proposals = this.props.proposals.find(function (_ref3) {
          var errorCode = _ref3.errorCode;
          return !!errorCode;
        })) === null || _this$props$proposals === void 0 ? void 0 : _this$props$proposals.errorCode
      }) : null, this.shouldDisplayModal() && BookingEngineForm_jsx(AlternativeProposalsModal["a" /* AlternativeProposalsModal */], {
        trackingDefaultPayload: {
          categoryGA: 'resort',
          actionGA: 'checkPricesKO'
        },
        searchCriteria: {
          arrivalDate: String(this.props.arrivalDate),
          duration: this.props.duration,
          adultsCount: this.props.adultsNumber,
          kidsCount: this.props.kids.length,
          departureCity: this.props.departureCity
        },
        i18n: i18n,
        onClose: this.props.clearProposals,
        onSubmit: this.redirectToBE,
        proposals: this.props.proposals,
        suggestions: this.props.suggestions,
        resort: this.props.resort,
        goToBookingEngine: this.goToBookingEngine,
        bookingEngineEntryPoint: this.props.bookingEngineEntry,
        scrollToBookingEngineEntryPoint: function scrollToBookingEngineEntryPoint() {
          return _this5.scrollToBookingEngineEntryPoint();
        },
        onSelectNewDuration: function onSelectNewDuration(_ref4) {
          var proposalIds = _ref4.proposalIds;

          var queryParams = BookingEngineForm_objectSpread(BookingEngineForm_objectSpread({}, _this5.props.location.queryParams), {}, {
            proposalIds: proposalIds,
            selectedProposalId: proposalIds[0]
          });

          _this5.props.history.pushRoute(routeBuilder["a" /* buildUrl */]('booking', {
            page: BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */]
          }, queryParams));
        }
      }))));
    }
  }]);

  return BookingEngineForm;
}(react["Component"]);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "defaultProps", defaultProps);

Object(defineProperty["a" /* default */])(BookingEngineForm_BookingEngineForm, "contextType", ReactAppContext["b" /* default */]);

/* harmony default export */ var booking_engine_form_BookingEngineForm = (Object(withRouter["a" /* withRouter */])(BookingEngineForm_BookingEngineForm));
// CONCATENATED MODULE: ./src/client/components/widgets/booking-engine-form/BookingEngineForm.container.jsx












function BookingEngineForm_container_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function BookingEngineForm_container_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { BookingEngineForm_container_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { BookingEngineForm_container_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















function getValue(value, initialValue) {
  return !value && initialValue ? initialValue : value;
}

function getQueryParamValue(name, location) {
  return Object(lodash["get"])(location.queryParams, name);
}

function getValidDepartureCity(state, props) {
  var availableTransports = Object(lodash["get"])(props, 'bookingCriteria.departureCities') || [];
  var transportIATACodes = availableTransports.map(function (t) {
    return t.value;
  });
  var departureCity = Object(tripCriteria_selector["a" /* getDepartureCity */])(state) || getQueryParamValue(uri_constants["k" /* QUERY_TRANSPORT */], props.location);
  return transportIATACodes.includes(departureCity) ? departureCity : '';
}

function BookingEngineForm_container_mapStateToProps(state, props) {
  var kids = Object(trip_information_storeHelper["c" /* getKids */])(state) || [];
  var adults = (Object(trip_information_storeHelper["a" /* getAdults */])(state) || []).length;
  var duration = Object(tripCriteria_selector["c" /* getTripDuration */])(state);
  var departureCity = getValidDepartureCity(state, props);
  var departureDate = Object(storeHelper["b" /* getDepartureDate */])(state);
  return {
    adultsNumber: getValue(adults, Object(lodash["get"])(props, 'bookingCriteria.initialNumberOfAdults')) || adults_constants["a" /* DEFAULT_ADULTS_NB */],
    arrivalDate: Object(storeHelper["a" /* getArrivalDate */])(state),
    bookingEngineEntry: state.booking.bookingEngineEntry,
    departureDate: departureDate,
    departureCity: departureCity,
    duration: getValue(duration, Object(lodash["get"])(props, 'bookingCriteria.initialDuration')) || duration_constants["b" /* DEFAULT_TRIP_DURATION */],
    kids: getResortInitialKids(kids, Object(lodash["get"])(props, 'bookingCriteria.initialNumberOfChildren'), Object(lodash["get"])(props, 'resort.adultOnly')),
    proposals: Object(booking_selector["v" /* getProposals */])(state),
    selectedProposalId: Object(booking_selector["A" /* getSelectedProposalId */])(state),
    resort: BookingEngineForm_container_objectSpread(BookingEngineForm_container_objectSpread({}, Object(booking_selector["m" /* getCurrentResort */])(state)), props.resort),
    attendees: Object(booking_selector["p" /* getDetailedAttendees */])(state),
    tripInformation: Object(trip_information_storeHelper["d" /* tripInformationSelector */])(state),
    suggestions: Object(booking_selector["C" /* getSuggestions */])(state)
  };
}
var BookingEngineForm_container_mapDispatchToProps = {
  clearProposals: proposals_action["e" /* clearProposals */],
  endLoading: globalLoader_action["c" /* endLoading */],
  startLoading: globalLoader_action["d" /* startLoading */],
  updateTripDateCriteria: tripDateCriteria_action["a" /* updateTripDateCriteria */],
  setDepartureDate: departureDate_action["a" /* setDepartureDate */],
  clearSelectedProposal: selectedProposalId_action["c" /* clearSelectedProposal */],
  selectProposal: selectedProposalId_action["d" /* selectProposal */],
  fetchProposalsAndRedirect: proposals_action["j" /* fetchProposalsAndRedirect */],
  setCms: cms_actions["d" /* setCms */],
  setAttendees: adults_action["c" /* setAttendees */],
  prepareBe: proposals_action["n" /* prepareBe */]
};
/* harmony default export */ var BookingEngineForm_container = (Object(es["c" /* connect */])(BookingEngineForm_container_mapStateToProps, BookingEngineForm_container_mapDispatchToProps)(booking_engine_form_BookingEngineForm));
// EXTERNAL MODULE: ./src/client/cms/toolkit/tracking/pageTracking.resolver.js + 2 modules
var pageTracking_resolver = __webpack_require__("9wHB");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tracking/pageTracking.descriptor.js









var pageTracking_descriptor_jsx = react_default.a.createElement;

function pageTracking_descriptor_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function pageTracking_descriptor_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      pageTracking_descriptor_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      pageTracking_descriptor_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









function DynamicPageLoadTracking(_ref) {
  var trackingData = _ref.trackingData; // $FlowFixMe

  return pageTracking_descriptor_jsx(TrackingPageLoad["a" /* TrackingPageLoad */], trackingData);
}

function pageTracking_descriptor_mapStateToProps(state, props) {
  var location = props.location,
      _props$trackingData = props.trackingData,
      trackingData = _props$trackingData === void 0 ? {} : _props$trackingData,
      _props$resort = props.resort,
      resort = _props$resort === void 0 ? {} : _props$resort;
  var _trackingData$isProdu = trackingData.isProductPage,
      isProductPage = _trackingData$isProdu === void 0 ? false : _trackingData$isProdu;
  if (!isProductPage) return {
    trackingData: trackingData
  };

  var _mapDefaultToCurrentB = BookingEngineForm_container_mapStateToProps(state, pageTracking_descriptor_objectSpread(pageTracking_descriptor_objectSpread({}, trackingData), {}, {
    location: location,
    resort: resort
  })),
      adultsNumber = _mapDefaultToCurrentB.adultsNumber,
      kids = _mapDefaultToCurrentB.kids,
      duration = _mapDefaultToCurrentB.duration;

  var kidsNumber = kids.length;
  delete trackingData.bookingCriteria;
  return {
    trackingData: pageTracking_descriptor_objectSpread(pageTracking_descriptor_objectSpread({}, trackingData), {}, {
      resortAdult: adultsNumber,
      resortChildren: kidsNumber,
      resortNightNumber: duration,
      resortTotalParticipant: adultsNumber + kidsNumber
    })
  };
}

var ConnectedDynamicPageLoadTracking = Object(es["c" /* connect */])(pageTracking_descriptor_mapStateToProps)(DynamicPageLoadTracking);

var pageTracking_descriptor_Component = function Component(props) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  return pageTracking_descriptor_jsx(ConnectedDynamicPageLoadTracking, Object(esm_extends["a" /* default */])({}, props, {
    location: location
  }));
};

var pageTrackingDescriptor = {
  name: constants["G" /* PAGE_TRACKING */],
  component: pageTracking_descriptor_Component,
  props: pageTracking_resolver["b" /* pageTrackingResolver */].props,
  resolve: pageTracking_resolver["b" /* pageTrackingResolver */].resolve
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/frameworks/image-placeholder/ImagePlaceholder.jsx
var ImagePlaceholder = __webpack_require__("D0nZ");

// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-icon/AdditionItemIcon.themes.js
var themes = {
  "default": {
    thItemIcon: 'flex items-center justify-center h-full text-blue',
    thItemIconSize: '75%',
    thItemLabel: 'font-bold inline-flex items-center mt-px10 text-base text-blue',
    thItemLabelIcon: 'rtl:ml-px10'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-icon/AdditionItemIcon.jsx
var AdditionItemIcon_jsx = react_default.a.createElement;






var AdditionItemIcon_AdditionItemIcon = function AdditionItemIcon(_ref) {
  var alt = _ref.alt,
      iconName = _ref.iconName,
      label = _ref.label,
      symbol = _ref.symbol,
      _ref$ratioKey = _ref.ratioKey,
      ratioKey = _ref$ratioKey === void 0 ? ratios_utils["a" /* default */].XL : _ref$ratioKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!iconName) {
    return null;
  }

  var _themes$theme = themes[theme],
      thItemIcon = _themes$theme.thItemIcon,
      thItemIconSize = _themes$theme.thItemIconSize,
      thItemLabel = _themes$theme.thItemLabel,
      thItemLabelIcon = _themes$theme.thItemLabelIcon;
  return AdditionItemIcon_jsx(react["Fragment"], null, AdditionItemIcon_jsx(ImagePlaceholder["a" /* ImagePlaceholder */], {
    aspectRatio: 100 * ratios_utils["a" /* default */].VALUES[ratioKey]
  }, AdditionItemIcon_jsx("span", {
    className: thItemIcon
  }, AdditionItemIcon_jsx(Icon["a" /* Icon */], {
    name: iconName,
    isNotSquare: true,
    width: thItemIconSize
  })), symbol), alt && AdditionItemIcon_jsx("span", {
    className: "sr-only"
  }, alt, " "), !!label && AdditionItemIcon_jsx("span", {
    className: thItemLabel,
    "data-testid": "AdditionItemIcon-label"
  }, label, AdditionItemIcon_jsx(Icon["a" /* Icon */], {
    className: thItemLabelIcon,
    hasRtl: true,
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "1em"
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx + 1 modules
var Image = __webpack_require__("0IQ5");

// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-image/AdditionItemImage.themes.js
var AdditionItemImage_themes_themes = {
  "default": {
    thItemImage: 'relative flex-none',
    thItemLabel: 'flex items-baseline font-bold leading-normal mt-px10 overflow-hidden text-base text-gray-darker',
    thItemLabelIcon: 'flex-shrink-0 text-blue rtl:mr-px5',
    thItemLabelIconSize: '1em'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/item-image/AdditionItemImage.jsx
var AdditionItemImage_jsx = react_default.a.createElement;






var AdditionItemImage_AdditionItemImage = function AdditionItemImage(_ref) {
  var _ref$image = _ref.image,
      image = _ref$image === void 0 ? {} : _ref$image,
      label = _ref.label,
      symbol = _ref.symbol,
      _ref$ratioDisplay = _ref.ratioDisplay,
      ratioDisplay = _ref$ratioDisplay === void 0 ? 0.5 : _ref$ratioDisplay,
      _ref$ratioKey = _ref.ratioKey,
      ratioKey = _ref$ratioKey === void 0 ? ratios_utils["a" /* default */].XL : _ref$ratioKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!image.src) {
    return null;
  }

  var _themes$theme = AdditionItemImage_themes_themes[theme],
      thItemImage = _themes$theme.thItemImage,
      thItemLabel = _themes$theme.thItemLabel,
      thItemLabelIcon = _themes$theme.thItemLabelIcon,
      thItemLabelIconSize = _themes$theme.thItemLabelIconSize;
  return AdditionItemImage_jsx(react["Fragment"], null, AdditionItemImage_jsx("div", {
    className: thItemImage
  }, AdditionItemImage_jsx(Image["b" /* default */], {
    altMsg: image.alt,
    imageUrl: image.src,
    ratioDisplay: ratioDisplay,
    ratioKey: ratioKey
  }), symbol), !!label && AdditionItemImage_jsx("div", {
    className: thItemLabel,
    "data-testid": "AdditionItemImage-label"
  }, AdditionItemImage_jsx(Icon["a" /* Icon */], {
    className: thItemLabelIcon,
    name: icons["a" /* ICONS */].CHECK,
    width: thItemLabelIconSize
  }), label));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/Addition.themes.js
var Addition_themes_themes = {
  "default": {
    thRoot: '-mx-px10',
    thList: 'reset-list flex max-w-full',
    thItem: 'flex-1 px-px10 relative flex flex-col items-stretch',
    thSymbol: 'absolute bg-white flex font-bold items-center justify-center leading-none -mx-px10 p-px10 rounded-full text-blue text-2xl top-1/2 rtl:-translate-50-x-reverse z-1',
    thSymbolStyle: {
      width: '2.8rem',
      height: '2.8rem'
    }
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/addition/Addition.jsx











var Addition_jsx = react_default.a.createElement;

function Addition_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Addition_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Addition_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Addition_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Addition_Addition = function Addition(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      ratioKey = _ref.ratioKey,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var filteredItems = items.filter(function (_ref2) {
    var _ref2$icon = _ref2.icon,
        icon = _ref2$icon === void 0 ? {} : _ref2$icon,
        _ref2$image = _ref2.image,
        image = _ref2$image === void 0 ? {} : _ref2$image;
    return icon.name || image.src;
  });
  if (!filteredItems.length) return null;
  var _themes$theme = Addition_themes_themes[theme],
      thItem = _themes$theme.thItem,
      thList = _themes$theme.thList,
      thRoot = _themes$theme.thRoot,
      thSymbol = _themes$theme.thSymbol,
      thSymbolStyle = _themes$theme.thSymbolStyle;
  var width = 100 / filteredItems.length;
  return Addition_jsx("div", {
    className: classnames_default()(className, thRoot)
  }, Addition_jsx("ul", {
    className: thList
  }, filteredItems.map(function (_ref3, idx) {
    var _ref3$icon = _ref3.icon,
        icon = _ref3$icon === void 0 ? {} : _ref3$icon,
        image = _ref3.image,
        label = _ref3.label,
        _ref3$link = _ref3.link,
        link = _ref3$link === void 0 ? {} : _ref3$link;
    var isLink = !!link.url;
    var TagName = isLink ? DynamicLink["a" /* default */] : react["Fragment"];
    var tagProps = isLink ? Addition_objectSpread(Addition_objectSpread({}, link), {}, {
      className: 'block'
    }) : null;
    var symbol = idx > 0 ? Addition_jsx("div", {
      className: thSymbol,
      style: thSymbolStyle
    }, idx === filteredItems.length - 1 ? '=' : '+') : null;
    return Addition_jsx("li", {
      className: thItem,
      key: label,
      style: {
        maxWidth: "".concat(width, "%"),
        minWidth: "".concat(width, "%")
      }
    }, Addition_jsx(TagName, tagProps, icon.name ? Addition_jsx(AdditionItemIcon_AdditionItemIcon, {
      alt: icon.alt,
      iconName: icon.name,
      label: label,
      ratioKey: ratioKey,
      symbol: symbol,
      theme: theme
    }) : Addition_jsx(AdditionItemImage_AdditionItemImage, {
      image: image,
      label: label,
      ratioKey: ratioKey,
      ratioDisplay: width / 100,
      symbol: symbol,
      theme: theme
    })));
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-link/TextLink.jsx + 1 modules
var TextLink = __webpack_require__("jD8k");

// CONCATENATED MODULE: ./src/client/components/widgets/all-inclusive-push/AllInclusivePush.jsx




var AllInclusivePush_jsx = react_default.a.createElement;







function AllInclusivePush(props) {
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  if (!items.length) {
    return null;
  }

  var filteredItems = items.filter(function (item) {
    return item.label || item.icon;
  });

  var _ref = filteredItems.pop() || {},
      _ref$icon = _ref.icon,
      lastIcon = _ref$icon === void 0 ? {} : _ref$icon,
      _ref$label = _ref.label,
      lastLabel = _ref$label === void 0 ? '' : _ref$label,
      _ref$link = _ref.link,
      lastLink = _ref$link === void 0 ? {} : _ref$link;

  return isTablet ? AllInclusivePush_jsx(Addition_Addition, {
    items: items
  }) : AllInclusivePush_jsx("ul", {
    className: "list-none p-0"
  }, filteredItems.map(function (_ref2) {
    var label = _ref2.label;
    return AllInclusivePush_jsx("li", {
      className: "flex items-center font-bold pb-px10 text-base text-gray-darker",
      key: label
    }, AllInclusivePush_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-px10",
      color: colors["a" /* COLORS */].BLUE,
      name: icons["a" /* ICONS */].CHECK,
      width: "1em"
    }), label);
  }), AllInclusivePush_jsx("li", {
    className: "flex flex-col mt-px10"
  }, AllInclusivePush_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    isNotSquare: true,
    name: lastIcon.name,
    width: "40%"
  }), lastIcon.alt && AllInclusivePush_jsx("span", {
    className: "sr-only"
  }, lastIcon.alt, " "), AllInclusivePush_jsx(TextLink["a" /* TextLink */], {
    className: "mt-px10 self-end",
    label: lastLabel,
    url: lastLink.url
  })));
}
// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// CONCATENATED MODULE: ./src/client/components/lines/all-inclusive-push-line/AllInclusivePushLine.jsx




var AllInclusivePushLine_jsx = react_default.a.createElement;




var AllInclusivePushLine_AllInclusivePushLine = function AllInclusivePushLine(_ref) {
  var id = _ref.id,
      title = _ref.title,
      _ref$lastItem = _ref.lastItem,
      lastItem = _ref$lastItem === void 0 ? {} : _ref$lastItem,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  if (!items.length) {
    return null;
  }

  return AllInclusivePushLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, AllInclusivePushLine_jsx(LineTitle["a" /* LineTitle */], null, title), AllInclusivePushLine_jsx(AllInclusivePush, {
    items: [].concat(Object(toConsumableArray["a" /* default */])(items.map(function (item) {
      return {
        image: {
          alt: '',
          src: item.mediaUrl
        },
        label: item.label,
        link: {
          url: item.link
        }
      };
    })), [{
      icon: {
        alt: lastItem.mediaAlt,
        name: lastItem.icon
      },
      label: lastItem.label,
      link: {
        url: lastItem.link
      }
    }])
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/all-inclusive-push/allInclusivePush.descriptor.js


var allInclusivePushDescriptor = {
  name: constants["a" /* ALL_INCLUSIVE_PUSH */],
  component: AllInclusivePushLine_AllInclusivePushLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/checked-list/CheckedList.jsx + 1 modules
var CheckedList = __webpack_require__("iiKe");

// CONCATENATED MODULE: ./src/client/components/lines/checklist-line/ChecklistLine.jsx

var ChecklistLine_jsx = react_default.a.createElement;



function ChecklistLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return ChecklistLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, ChecklistLine_jsx(CheckedList["a" /* CheckedList */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/checklist/checklist.descriptor.js


var checklistDescriptor = {
  name: constants["d" /* CHECKLIST */],
  component: ChecklistLine
};
// CONCATENATED MODULE: ./src/client/components/widgets/crisis-alert/CrisisAlert.jsx
var CrisisAlert_jsx = react_default.a.createElement;






var CrisisAlert_CrisisAlert = function CrisisAlert(_ref) {
  var hasSeeMore = _ref.hasSeeMore,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? icons["a" /* ICONS */].WARNING : _ref$icon,
      linkLabel = _ref.linkLabel,
      linkUrl = _ref.linkUrl,
      message = _ref.message,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;

  if (!message) {
    return null;
  }

  var content = CrisisAlert_jsx(Notification["a" /* Notification */], {
    color: colors["a" /* COLORS */].WARNING,
    hasBorder: true,
    isCollapsed: true,
    icon: icon,
    text: message
  }, CrisisAlert_jsx(TextLink["a" /* TextLink */], {
    className: "uppercase",
    label: linkLabel,
    url: linkUrl
  }));

  if (hasSeeMore) {
    return CrisisAlert_jsx(SeeMore["a" /* SeeMore */], {
      classNameButton: "rtl:text-right",
      hasNoScrollOnCollapse: true,
      isCollapseEnabled: true,
      seeLessLabel: seeLessLabel,
      seeMoreLabel: seeMoreLabel,
      seeMoreSize: 110
    }, content);
  }

  return CrisisAlert_jsx(react["Fragment"], null, content);
};
// CONCATENATED MODULE: ./src/client/components/lines/crisis-alert-line/CrisisAlertLine.jsx


var CrisisAlertLine_jsx = react_default.a.createElement;



function CrisisAlertLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  if (!props.message) {
    return null;
  }

  return CrisisAlertLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, CrisisAlertLine_jsx(CrisisAlert_CrisisAlert, {
    message: props.message,
    linkLabel: props.link.label,
    linkUrl: props.link.url,
    hasSeeMore: props.displayLoadMore
  }));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/crisis-alert/crisisAlert.descriptor.js


var crisisAlertDescriptor = {
  name: constants["i" /* CRISIS_ALERT */],
  component: CrisisAlertLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// EXTERNAL MODULE: ./src/client/components/frameworks/tag/Tag.jsx + 1 modules
var Tag = __webpack_require__("N5WC");

// CONCATENATED MODULE: ./src/client/components/lines/destinations-line/DestinationsLine.utils.js
















function DestinationsLine_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function DestinationsLine_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      DestinationsLine_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      DestinationsLine_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var TOP_DESTINATIONS_AREA_ID = 'top-destinations';
var DestinationsLine_utils_getPricedDestinations = function getPricedDestinations(destinations) {
  var pricedAreas = [];
  var pricedCountries = [];
  destinations === null || destinations === void 0 ? void 0 : destinations.forEach(function (area) {
    var _area$countries;

    var areaPrice = {};
    var types = {
      isCruise: area.isCruise,
      isJoyview: area.isJoyview,
      isTour: area.isTour
    };
    area === null || area === void 0 ? void 0 : (_area$countries = area.countries) === null || _area$countries === void 0 ? void 0 : _area$countries.forEach(function (country) {
      if (country.products.length > 0) {
        var countryPrice = {};
        country.products.forEach(function (_ref) {
          var _areaPrice$bestPrice, _countryPrice$bestPri, _price$bestPrice;

          var id = _ref.id,
              href = _ref.href,
              price = _ref.price,
              comfort = _ref.comfort;
          var areaPriceValue = (_areaPrice$bestPrice = areaPrice.bestPrice) === null || _areaPrice$bestPrice === void 0 ? void 0 : _areaPrice$bestPrice.value;
          var countryPriceValue = (_countryPrice$bestPri = countryPrice.bestPrice) === null || _countryPrice$bestPri === void 0 ? void 0 : _countryPrice$bestPri.value;
          var productPriceValue = price === null || price === void 0 ? void 0 : (_price$bestPrice = price.bestPrice) === null || _price$bestPrice === void 0 ? void 0 : _price$bestPrice.value;

          if (!areaPriceValue || productPriceValue && areaPriceValue > productPriceValue) {
            areaPrice = DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, price), {}, {
              productId: id,
              productComfort: comfort,
              productHref: href,
              countryId: country.id
            });
          }

          if (!countryPriceValue || productPriceValue && countryPriceValue > productPriceValue) {
            countryPrice = DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, price), {}, {
              productId: id,
              productHref: href,
              productComfort: comfort
            });
          }
        });
        pricedCountries.push(DestinationsLine_utils_objectSpread({
          id: country.id,
          label: Object(lodash["capitalize"])(country.label),
          price: countryPrice
        }, types));
      }
    });
    var areaLabel = area.label;
    pricedAreas.push(DestinationsLine_utils_objectSpread({
      id: area.id,
      label: areaLabel.charAt(0).toUpperCase() + areaLabel.slice(1),
      price: areaPrice
    }, types));
  });
  return {
    pricedAreas: pricedAreas,
    pricedCountries: pricedCountries
  };
};
var DestinationsLine_utils_getTopDestinations = function getTopDestinations(topDestinations, _ref2) {
  var _ref3;

  var pricedAreas = _ref2.pricedAreas,
      pricedCountries = _ref2.pricedCountries;

  var areaDestinations = (_ref3 = []).concat.apply(_ref3, Object(toConsumableArray["a" /* default */])(topDestinations.destinations.map(function (destination) {
    return Object.values(destination);
  })));

  return {
    areaId: TOP_DESTINATIONS_AREA_ID,
    areaLabel: topDestinations.label,
    destinations: areaDestinations.reduce(function (destinations, destination) {
      var pricedDestination = pricedAreas.find(function (area) {
        return area.id === destination.id;
      }) || pricedCountries.find(function (country) {
        return country.id === destination.id;
      });

      if (pricedDestination) {
        destinations.push(DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, pricedDestination), destination));
      }

      return destinations;
    }, [])
  };
};
var getOtherDestinations = function getOtherDestinations(otherDestinations, _ref4) {
  var pricedAreas = _ref4.pricedAreas,
      pricedCountries = _ref4.pricedCountries;
  return otherDestinations.reduce(function (destinations, destination) {
    var pricedArea = pricedAreas.find(function (area) {
      return area.id === destination.id;
    });

    if (pricedArea) {
      destinations.push({
        areaId: pricedArea.id,
        areaLabel: pricedArea.label,
        destinations: destination.countries.reduce(function (countries, country) {
          var pricedCountry = pricedCountries.find(function (c) {
            return c.id === country.id;
          });

          if (pricedCountry) {
            countries.push(DestinationsLine_utils_objectSpread(DestinationsLine_utils_objectSpread({}, pricedCountry), country));
          }

          return countries;
        }, [])
      });
    }

    return destinations;
  }, []);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/price/Price.jsx + 10 modules
var Price = __webpack_require__("IuYR");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.mapper.js + 1 modules
var Product_mapper = __webpack_require__("bGCG");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx + 1 modules
var ProductPriceModal = __webpack_require__("yfdt");

// EXTERNAL MODULE: ./src/utils/string/stringUtils.js
var stringUtils = __webpack_require__("E8Xq");

// CONCATENATED MODULE: ./src/client/components/widgets/destinations/DestinationCard.jsx



var DestinationCard_jsx = react_default.a.createElement;
















var DestinationCard_DestinationCard = function DestinationCard(props) {
  var hasDateSetFromLine = props.hasDateSetFromLine,
      id = props.id,
      index = props.index,
      isCruise = props.isCruise,
      isJoyview = props.isJoyview,
      isTour = props.isTour,
      label = props.label,
      lineName = props.lineName,
      link = props.link,
      mediaUrl = props.mediaUrl,
      price = props.price,
      trackingData = props.trackingData;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';

  var handleProductPriceModalClick = function handleProductPriceModalClick(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    track({
      labelGA: "".concat(trackingData.labelGA, "_bestPrice")
    });
  };

  var handleProductPriceModalClickButton = function handleProductPriceModalClickButton(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    track({
      labelGA: "".concat(trackingData.labelGA, "_discoverResort")
    });

    if (typeof index === 'number') {
      var _price$bestPrice;

      track({
        actionGA: 'clickThumbnail',
        labelGA: (price === null || price === void 0 ? void 0 : price.productId) ? "".concat(price.productId, "_discoverResort") : '_discoverResort',
        resortCode: (price === null || price === void 0 ? void 0 : price.productId) || '',
        resortTrident: typeof (price === null || price === void 0 ? void 0 : price.productComfort) === 'number' ? price.productComfort : '',
        thumbnailPrice: (price === null || price === void 0 ? void 0 : (_price$bestPrice = price.bestPrice) === null || _price$bestPrice === void 0 ? void 0 : _price$bestPrice.value) || '',
        thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
        thumbnailPosition: index + 1
      });
    }

    if (price.productHref) {
      var productUrl = Object(uriUtils["f" /* generateUrlWithParams */])(price.productHref, {
        queryParams: location.queryParams
      });
      var route = hasDateSetFromLine ? Object(Product_mapper["d" /* getProductUrlFromDestinationLine */])(price, location.queryParams) : Object(Product_mapper["a" /* createProductUrlWithParams */])(productUrl, {
        isCruise: isCruise,
        isTour: isTour
      });
      history.pushRoute(route);
    }
  };

  var handleFocus = function handleFocus() {
    setHover(true);
  };

  var handleBlur = function handleBlur() {
    setHover(false);
  };

  return DestinationCard_jsx("article", {
    className: "bg-gray-darker overflow-hidden relative rounded-tiny",
    "data-testid": "destination-card"
  }, DestinationCard_jsx(Image["b" /* default */], {
    altMsg: label,
    className: classnames_default()('transition-transform opacity-75', {
      'scale-105': isHover
    }),
    groupKey: "destinations",
    hasLazyLoading: true,
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["a" /* default */].R_38_BY_28
  }), DestinationCard_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "absolute inset-0",
    "data-testid": "destination-card-".concat(id, "-link"),
    onBlur: handleBlur,
    onFocus: handleFocus,
    onMouseEnter: handleFocus,
    onMouseLeave: handleBlur,
    trackingData: trackingData,
    url: link
  }, DestinationCard_jsx("h3", {
    className: "absolute bottom-0 capitalize font-bold leading-tight p-px10 pb-px60 reset-heading text-center text-white text-xl w-full"
  }, label)), DestinationCard_jsx("div", {
    className: "absolute bottom-0 mb-px30 w-full"
  }, DestinationCard_jsx(ProductPriceModal["a" /* ProductPriceModal */] // $FlowFixMe
  , Object(esm_extends["a" /* default */])({}, Object(Product_mapper["b" /* getProductPriceInfoProps */])({
    product: {
      price: price
    }
  }), {
    className: "m-px5",
    isCruise: isCruise,
    isJoyview: isJoyview,
    isTour: isTour,
    onClick: handleProductPriceModalClick,
    onClickButton: handleProductPriceModalClickButton
  }), DestinationCard_jsx(Price["a" /* Price */], {
    bestPrice: price.bestPrice,
    className: "justify-center",
    containerStyle: {
      minHeight: '1.5rem'
    },
    from: Object(stringUtils["a" /* capitalize */])(Object(src_i18n["h" /* t */])('price.format.from')),
    theme: "instagram",
    unit: price.unit
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/destinations/Destinations.jsx











var Destinations_jsx = react_default.a.createElement;

function Destinations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Destinations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Destinations_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Destinations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var Destinations_Destinations = function Destinations(_ref) {
  var destinations = _ref.destinations,
      _ref$hasDateSetFromLi = _ref.hasDateSetFromLine,
      hasDateSetFromLine = _ref$hasDateSetFromLi === void 0 ? false : _ref$hasDateSetFromLi,
      header = _ref.header,
      lineName = _ref.lineName,
      productType = _ref.productType,
      trackingData = _ref.trackingData;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(0),
      selectedDestinationIndex = _useState[0],
      setSelectedDestinationIndex = _useState[1];

  var _destinations$selecte = destinations[selectedDestinationIndex],
      selectedAreaId = _destinations$selecte.areaId,
      selectedAreaLabel = _destinations$selecte.areaLabel,
      selectedAreaDestinations = _destinations$selecte.destinations;
  return Destinations_jsx("div", {
    className: "flex flex-wrap w-full max-w-site"
  }, Destinations_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    childrenWrapperClassNames: "flex",
    className: "w-screen lg:w-full -mx-px20 lg:mx-0 mb-px15",
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward'),
    header: header,
    navPosition: "top"
  }, destinations.map(function (area, index) {
    return Destinations_jsx(Tag["a" /* Tag */], {
      active: index === selectedDestinationIndex,
      borderColor: index === selectedDestinationIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_LIGHT,
      className: classnames_default()('rtl:mr-px10 mb-px10', {
        'rtl:ml-px20 lg:rtl:ml-0': index === 0
      }),
      color: index === selectedDestinationIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_DARKER,
      key: area.areaId,
      label: area.areaLabel,
      onClick: function onClick() {
        return setSelectedDestinationIndex(index);
      },
      trackingData: Destinations_objectSpread(Destinations_objectSpread({}, trackingData), {}, {
        labelGA: area.areaId === TOP_DESTINATIONS_AREA_ID ? 'topDestinations_tab' : "".concat(area.areaLabel, "_tab")
      }),
      theme: "outlinedThin"
    });
  })), Destinations_jsx(Slider["a" /* Slider */], {
    className: "w-screen lg:w-full -mx-px20 lg:mx-0",
    cols: 0,
    hasControls: isDesktop && selectedAreaDestinations.length > 3,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto lg:overflow-hidden",
    scrollControlsClassName: "-mx-px20 lg:mx-0"
  }, selectedAreaDestinations.map(function (destination, index) {
    return Destinations_jsx("div", {
      key: destination.id,
      className: classnames_default()('relative rtl:mr-px20 h-full', {
        'rtl:ml-px20 lg:rtl:ml-0': index === 0,
        'lg:rtl:mr-0': index === selectedAreaDestinations.length - 1
      }),
      style: {
        width: '55vw',
        maxWidth: '280px'
      }
    }, Destinations_jsx(DestinationCard_DestinationCard, Object(esm_extends["a" /* default */])({}, destination, {
      hasDateSetFromLine: hasDateSetFromLine,
      index: index,
      lineName: lineName,
      productType: productType,
      trackingData: Destinations_objectSpread(Destinations_objectSpread({}, trackingData), {}, {
        labelGA: selectedAreaId === TOP_DESTINATIONS_AREA_ID ? "topDestinations_".concat(destination.label) : "".concat(selectedAreaLabel, "_").concat(destination.label)
      })
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/destinations-line/DestinationsLine.jsx










var DestinationsLine_jsx = react_default.a.createElement;

function DestinationsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function DestinationsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DestinationsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DestinationsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var DestinationsLine_DestinationsLine = function DestinationsLine(_ref) {
  var areas = _ref.areas,
      config = _ref.config,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      destinations = _ref.destinations,
      id = _ref.id,
      productType = _ref.productType,
      _ref$seeAllDestinatio = _ref.seeAllDestinationsLink,
      seeAllDestinationsLabel = _ref$seeAllDestinatio.label,
      seeAllDestinationsUrl = _ref$seeAllDestinatio.url,
      title = _ref.title,
      topDestinations = _ref.topDestinations,
      _ref$viewMapLink = _ref.viewMapLink,
      viewMapLabel = _ref$viewMapLink.label,
      viewMapUrl = _ref$viewMapLink.url;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  Object(src_i18n["a" /* addTranslationKeys */])(config);

  var _getPricedDestination = DestinationsLine_utils_getPricedDestinations(destinations),
      pricedAreas = _getPricedDestination.pricedAreas,
      pricedCountries = _getPricedDestination.pricedCountries;

  var topAreas = DestinationsLine_utils_getTopDestinations(topDestinations, {
    pricedAreas: pricedAreas,
    pricedCountries: pricedCountries
  });
  var otherAreas = getOtherDestinations(areas, {
    pricedAreas: pricedAreas,
    pricedCountries: pricedCountries
  });
  var allAreas = [topAreas].concat(Object(toConsumableArray["a" /* default */])(otherAreas));
  var trackingData = {
    actionGA: 'push_content_destinations'
  };
  var hasAllDestinationsLink = Boolean(seeAllDestinationsLabel) && Boolean(seeAllDestinationsUrl);
  var hasViewMapLink = Boolean(viewMapLabel) && Boolean(viewMapUrl);

  var header = DestinationsLine_jsx(react["Fragment"], null, DestinationsLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), DestinationsLine_jsx("div", {
    className: "m-auto md:mx-0 mt-px20 md:mt-px5 order-last md:order-none"
  }, hasViewMapLink && DestinationsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: DestinationsLine_objectSpread(DestinationsLine_objectSpread({}, trackingData), {}, {
      labelGA: 'viewMap'
    }),
    url: viewMapUrl
  }, viewMapLabel), hasAllDestinationsLink && DestinationsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: classnames_default()('text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline', {
      'rtl:ml-px15': hasViewMapLink
    }),
    trackingData: DestinationsLine_objectSpread(DestinationsLine_objectSpread({}, trackingData), {}, {
      labelGA: 'seeAllDestinations'
    }),
    url: seeAllDestinationsUrl
  }, seeAllDestinationsLabel)));

  var desktopHeader = isDesktop ? DestinationsLine_jsx("div", {
    className: "flex justify-between w-full"
  }, header) : null;
  return DestinationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, DestinationsLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, isDesktop ? null : header, DestinationsLine_jsx(Destinations_Destinations, {
    destinations: allAreas,
    hasDateSetFromLine: !!departureDateStart || !!departureDateEnd,
    header: desktopHeader,
    lineName: constants["l" /* DESTINATIONS */],
    productType: productType,
    trackingData: trackingData
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/destinations/destinations.resolver.js
var destinations_resolver = __webpack_require__("bEXL");

// CONCATENATED MODULE: ./src/client/cms/toolkit/destinations/destinations.descriptor.js



var destinationsDescriptor = {
  name: constants["l" /* DESTINATIONS */],
  component: DestinationsLine_DestinationsLine,
  resolver: destinations_resolver["a" /* destinationsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.themes.js
var DownloadLinksList_themes_themes = {
  "default": {
    thRoot: 'flex flex-col sm:flex-row sm:items-center',
    thLabel: 'flex flex-col sm:flex-row sm:flex-1 items-center sm:rtl:mr-px20 text-center',
    thLabelIconSize: '1.25rem',
    thText: 'font-bold mt-px10 sm:mt-0 sm:rtl:ml-px10',
    thList: 'reset-list flex flex-col sm:flex-row flex-shrink-0 flex-start',
    thListItem: 'flex justify-center mt-px15 sm:mt-0 sm:px-px10',
    thListItemIcon: 'flex-shrink-0 rtl:mr-px5',
    thLink: 'reset-anchor inline-flex flex-row-reverse font-bold items-center text-blue hover:text-blue-active focus:text-blue-active text-sm transition-color underline uppercase'
  },
  lite: {
    thRoot: 'flex flex-col sm:flex-row sm:items-center',
    thLabel: 'flex flex-row items-center sm:rtl:mr-px20',
    thLabelIconSize: '1rem',
    thText: 'font-bold mt-px10 sm:mt-0 rtl:ml-px10',
    thList: 'reset-list flex flex-col sm:flex-row flex-shrink-0 sm:-mx-px5',
    thListItem: 'flex items-center sm:mt-0 sm:px-px5 text-blue w-full sm:w-auto',
    thListItemIcon: 'flex-shrink-0 rtl:mr-px5',
    thListItemIconSize: '1.3rem',
    thLink: 'reset-anchor inline-block font-bold items-center text-blue hover:text-blue-active focus:text-blue-active text-md transition-color underline w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.jsx

var DownloadLinksList_jsx = react_default.a.createElement;









function DownloadLinksList(props) {
  var className = props.className,
      _props$links = props.links,
      links = _props$links === void 0 ? [] : _props$links,
      text = props.text,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;

  if (!links.length) {
    return null;
  }

  var _themes$theme = DownloadLinksList_themes_themes[theme],
      thLabel = _themes$theme.thLabel,
      thLabelIconSize = _themes$theme.thLabelIconSize,
      thLink = _themes$theme.thLink,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thListItemIcon = _themes$theme.thListItemIcon,
      thListItemIconSize = _themes$theme.thListItemIconSize,
      thRoot = _themes$theme.thRoot,
      thText = _themes$theme.thText;
  return DownloadLinksList_jsx("section", {
    className: classnames_default()(className, thRoot)
  }, !!text && DownloadLinksList_jsx("div", {
    className: thLabel
  }, DownloadLinksList_jsx(Icon["a" /* Icon */], {
    className: "flex-shrink-0",
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].DOWNLOAD,
    width: thLabelIconSize
  }), DownloadLinksList_jsx(Text["a" /* Text */], {
    className: thText,
    text: text
  })), DownloadLinksList_jsx("ul", {
    className: thList
  }, links.map(function (_ref) {
    var iconName = _ref.iconName,
        label = _ref.label,
        onClick = _ref.onClick,
        target = _ref.target,
        trackingData = _ref.trackingData,
        url = _ref.url;
    return url && label ? DownloadLinksList_jsx("li", {
      className: thListItem,
      key: label
    }, DownloadLinksList_jsx(Icon["a" /* Icon */], {
      className: thListItemIcon,
      name: iconName,
      width: thListItemIconSize
    }), DownloadLinksList_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      trackingData: trackingData,
      className: thLink,
      onClick: onClick,
      target: target,
      url: url
    }, label)) : null;
  })));
}
// CONCATENATED MODULE: ./src/client/components/lines/download-links-list-line/DownloadLinksListLine.jsx
var DownloadLinksListLine_jsx = react_default.a.createElement;



var DownloadLinksListLine_DownloadLinksListLine = function DownloadLinksListLine(_ref) {
  var id = _ref.id,
      _ref$links = _ref.links,
      links = _ref$links === void 0 ? [] : _ref$links,
      text = _ref.text;

  if (!links.length) {
    return null;
  }

  return DownloadLinksListLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-DownloadLinksList",
    id: id
  }, DownloadLinksListLine_jsx(DownloadLinksList, {
    className: "bg-white py-px20 shadow-bottom",
    links: links,
    text: text
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/download-links-list/downloadLinksList.descriptor.js


var downloadLinksListDescriptor = {
  name: constants["m" /* DOWNLOAD_LINKS_LIST */],
  component: DownloadLinksListLine_DownloadLinksListLine
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// EXTERNAL MODULE: ./src/client/components/frameworks/collapse-panel/CollapsePanel.jsx + 1 modules
var CollapsePanel = __webpack_require__("gA51");

// EXTERNAL MODULE: ./src/client/cms/toolkit/editorial-folding-block/collapsePanel.resolver.js
var collapsePanel_resolver = __webpack_require__("+BJN");

// CONCATENATED MODULE: ./src/client/cms/toolkit/editorial-folding-block/collapsePanel.descriptor.js


var collapsePanel_descriptor_jsx = react_default.a.createElement;







var panelProps = collapsePanel_resolver["a" /* props */];
var collapsePanel_descriptor_Panel = function Panel(_ref) {
  var displayed = _ref.displayed,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? collapsePanel_descriptor_jsx("div", null) : _ref$children,
      componentId = _ref.componentId,
      header = _ref.header,
      icon = _ref.icon,
      _ref$collapseLabel = _ref.collapseLabel,
      collapseLabel = _ref$collapseLabel === void 0 ? '' : _ref$collapseLabel,
      _ref$expandLabel = _ref.expandLabel,
      expandLabel = _ref$expandLabel === void 0 ? '' : _ref$expandLabel;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      hash = _useRouter.location.hash;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  var cleanedHash = hash && isAppMounted ? hash.split(uri_constants["b" /* HASH_PARAMS_DELIMITER */])[0] : null;
  var defaultExpanded = cleanedHash ? cleanedHash === "#".concat(componentId) : false;

  if (!displayed) {
    return null;
  }

  return collapsePanel_descriptor_jsx("div", {
    className: "Line Line-ProductInformation"
  }, collapsePanel_descriptor_jsx(SiteContainer["a" /* SiteContainer */], null, collapsePanel_descriptor_jsx(CollapsePanel["a" /* CollapsePanel */], {
    as: "h2",
    collapseLabel: collapseLabel,
    expandLabel: expandLabel,
    iconName: icon,
    id: componentId,
    isExpanded: defaultExpanded,
    title: header,
    trackingData: {
      actionGA: 'blockInfos',
      labelGA: componentId
    }
  }, children)));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/editorial-folding-block/editorialFoldingBlock.resolver.js
var editorialFoldingBlock_resolver = __webpack_require__("3OB6");

// CONCATENATED MODULE: ./src/client/cms/toolkit/editorial-folding-block/editorialFoldingBlock.descriptor.js
var editorialFoldingBlock_descriptor_jsx = react_default.a.createElement;





var editorialFoldingBlockDescriptor = {
  name: constants["n" /* EDITORIAL_FOLDING_BLOCK */],
  component: function component(props) {
    return editorialFoldingBlock_descriptor_jsx(Line, {
      component: collapsePanel_descriptor_Panel,
      props: props
    });
  },
  props: editorialFoldingBlock_resolver["a" /* editorialFoldingBlockResolver */].props
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/event-animation/EventAnimation.jsx













var EventAnimation_jsx = react_default.a.createElement;

function EventAnimation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EventAnimation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EventAnimation_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EventAnimation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var EventAnimation_EventAnimation = function EventAnimation(_ref) {
  var offers = _ref.offers;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var getTags = function getTags() {
    var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var countdown = arguments.length > 1 ? arguments[1] : undefined;

    if (!tags.length) {
      return [];
    }

    var maxNumberOfTags = (countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd) ? 1 : 2;
    var renderedTags = tags.map(function (_ref2) {
      var text = _ref2.text,
          theming = _ref2.theming;
      var backgroundColor = theming.backgroundColor,
          textColor = theming.textColor;
      return EventAnimation_jsx("div", {
        key: text,
        className: "bg-".concat(backgroundColor, " text-").concat(textColor, " leading-tight py-px5 px-px10 m-px5 sm:m-0 sm:mx-0 sm:mb-px10 rounded-tiny font-bold text-base uppercase flex items-center shadow-lg sm:shadow-none")
      }, text);
    }).slice(0, maxNumberOfTags);

    var renderedCountdown = countdown && EventAnimation_jsx(Countdown["a" /* Countdown */], {
      bgColor: countdown.backgroundColor,
      className: "leading-tight text-base py-px5 px-px10 m-px5 sm:m-0 shadow-lg sm:shadow-none",
      color: countdown.textColor,
      dataTestId: "eventAnimation-countdown",
      dateTimeEnd: countdown.dateTimeEnd,
      days: countdown.days,
      hours: countdown.hours,
      minutes: countdown.minutes,
      seconds: countdown.seconds,
      theme: "offerPush"
    });

    return [].concat(Object(toConsumableArray["a" /* default */])(renderedTags), [renderedCountdown]);
  };

  var offerSlides = offers.map(function (_ref3) {
    var content = _ref3.content,
        visual = _ref3.visual;
    return EventAnimation_jsx("div", {
      key: content.title,
      className: "rounded-small overflow-hidden relative bg-white h-full shadow-md sm:shadow-none flex flex-col sm:block",
      style: isTablet ? {
        minHeight: 'calc(360rem / 16)'
      } : {}
    }, EventAnimation_jsx("div", {
      className: "relative sm:static sm:h-full"
    }, EventAnimation_jsx("div", {
      className: "absolute top-0 rtl:left-0 bottom-0 pointer-events-none flex items-center justify-center bg-".concat(content.theming.backgroundColor),
      style: isTablet ? {
        width: '49%'
      } : {
        right: 0,
        left: 0
      }
    }, EventAnimation_jsx(Icon["a" /* Icon */], {
      name: content.icon,
      className: "opacity-10 flex-shrink-0 relative rtl:right-1/2 rtl:ml-px40",
      width: "calc(500rem / 16)",
      color: colors["a" /* COLORS */].WHITE
    })), EventAnimation_jsx("div", {
      className: "sm:w-5/6 mx-auto relative flex items-center h-full text-".concat(content.theming.textColor)
    }, EventAnimation_jsx("div", {
      className: "p-px15 sm:py-px20 sm:px-0"
    }, EventAnimation_jsx(Icon["a" /* Icon */], {
      name: content.icon,
      width: "calc(40rem / 16)"
    }), EventAnimation_jsx(Title["a" /* Title */], {
      theme: "none",
      hLevel: 3,
      className: "my-px20 font-brand text-inherit text-xl"
    }, content.title), EventAnimation_jsx(Text["a" /* Text */], {
      theme: "none",
      className: "text-inherit text-base sm:text-md",
      text: content.description
    }), EventAnimation_jsx("div", {
      className: "flex flex-wrap flex-col sm:flex-row items-center mt-px30"
    }, EventAnimation_jsx(Text["a" /* Text */], {
      theme: "none",
      className: "text-inherit text-base pb-px10 sm:p-0 sm:rtl:pr-px10 sm:rtl:mr-auto",
      text: content.subtitle
    }), content.button.label && content.button.url && EventAnimation_jsx(Button["a" /* Button */], {
      url: content.button.url,
      color: content.button.textColor,
      colorBg: content.button.backgroundColor,
      className: "flex-shrink-0 mt-px5",
      trackingData: EventAnimation_objectSpread(EventAnimation_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
        actionGA: 'eventAnimation',
        labelGA: content.title
      })
    }, content.button.label))), isTablet && EventAnimation_jsx("div", {
      className: "w-3/5 flex-shrink-0 rtl:pl-px20 relative"
    }, EventAnimation_jsx("div", {
      className: "absolute inset-0 px-px40 py-px20 flex flex-col items-start"
    }, getTags(visual.tags, visual.countdown)), EventAnimation_jsx(Image["b" /* default */], {
      className: "rtl:-mr-px40 rounded-small overflow-hidden",
      imageUrl: visual.imageUrl,
      ratioKey: ratios_utils["a" /* default */].M
    })))), !isTablet && EventAnimation_jsx("div", {
      className: "flex items-center flex-wrap justify-center px-px10 py-px25 my-auto"
    }, getTags(visual.tags, visual.countdown)));
  });

  var getBottomControls = function getBottomControls(isPreviousControlDisabled, isNextControlDisabled, onPrevious, onNext, index) {
    return EventAnimation_jsx("div", {
      className: "flex items-center mt-px20 justify-center"
    }, EventAnimation_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "flex-none text-xxs rtl:mr-px20",
      isDisabled: isPreviousControlDisabled,
      label: Object(src_i18n["h" /* t */])('common.previous'),
      size: 12,
      color: colors["a" /* COLORS */].GRAY_DARKER,
      colorBg: "transparent",
      colorBgDisabled: "transparent",
      onClick: onPrevious
    }), EventAnimation_jsx("span", {
      className: "flex justify-center items-baseline text-gray-darker text-sm"
    }, EventAnimation_jsx("span", {
      className: "text-base font-bold"
    }, index + 1), "/", offers.length), EventAnimation_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "flex-none text-xxs rtl:ml-px20",
      isDisabled: isNextControlDisabled,
      label: Object(src_i18n["h" /* t */])('common.next'),
      size: 12,
      color: colors["a" /* COLORS */].GRAY_DARKER,
      colorBg: "transparent",
      colorBgDisabled: "transparent",
      onClick: onNext,
      rotation: 180
    }));
  };

  var getScrollableTitles = function getScrollableTitles(activeIndex, onIndex) {
    var buttons = offers.map(function (_ref4, offerIndex) {
      var content = _ref4.content;
      var isActive = offerIndex === activeIndex;
      var color = content.theming.backgroundColor;
      return EventAnimation_jsx("button", {
        key: offerIndex,
        onClick: function onClick(e) {
          onIndex(e, offerIndex);
        },
        className: classnames_default()(["relative whitespace-no-wrap sm:whitespace-normal pb-px5 sm:mx-px20 mb-px20 text-base reset-button text-".concat(color, " hover:text-").concat(color, "-active active:text-").concat(color, "-active")], {
          'font-bold': isActive
        }, {
          'rtl:ml-px20': offerIndex !== 0
        })
      }, content.title, EventAnimation_jsx("div", {
        className: classnames_default()(["bg-".concat(color, " absolute top-full w-full scale-x-0 transition-transform")], {
          'scale-x-1': isActive
        }),
        style: {
          height: '2px'
        }
      }));
    });
    return !isTablet ? EventAnimation_jsx(Slider["a" /* Slider */], {
      cols: 0,
      hasControls: false,
      navPosition: "center",
      nbItemsToScroll: 1,
      initialIndex: activeIndex,
      nextLabel: Object(src_i18n["h" /* t */])('common.next'),
      previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
      scrollAreaClassName: "overflow-hidden",
      scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
      scrollItemClassName: "overflow-hidden flex-none max-w-full"
    }, buttons) : EventAnimation_jsx("div", {
      className: "flex justify-center items-center"
    }, buttons);
  };

  return EventAnimation_jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    className: "w-full rounded-small sm:shadow-lg rtl:pr-px50 sm:rtl:pr-0 pb-px10 sm:pb-0",
    items: offerSlides,
    spacerWidth: isTablet ? 0 : 10
  }, function (_ref5) {
    var hasControls = _ref5.hasControls,
        isNextControlDisabled = _ref5.isNextControlDisabled,
        isPreviousControlDisabled = _ref5.isPreviousControlDisabled,
        itemsNode = _ref5.itemsNode,
        index = _ref5.index,
        onNext = _ref5.onNext,
        onPrevious = _ref5.onPrevious,
        onIndex = _ref5.onIndex;
    return EventAnimation_jsx("div", null, getScrollableTitles(index, onIndex), EventAnimation_jsx("div", {
      className: "relative -mx-px10 sm:mx-0"
    }, itemsNode, hasControls && isTablet && EventAnimation_jsx("div", {
      className: classnames_default()('absolute w-5/6 top-1/2 left-1/2 -translate-50 flex items-center justify-between pointer-events-none')
    }, EventAnimation_jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none rtl:-ml-px20 shadow-sm pointer-events-auto rtl:-translate-x-100', {
        invisible: isPreviousControlDisabled
      }),
      isDisabled: isPreviousControlDisabled,
      label: Object(src_i18n["h" /* t */])('common.previous'),
      size: 40,
      color: colors["a" /* COLORS */].WHITE,
      colorBg: colors["a" /* COLORS */].BLUE,
      onClick: onPrevious
    }), EventAnimation_jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none rtl:-mr-px20 shadow-sm pointer-events-auto rtl:translate-x-100', {
        invisible: isNextControlDisabled
      }),
      isDisabled: isNextControlDisabled,
      label: Object(src_i18n["h" /* t */])('common.next'),
      size: 40,
      color: colors["a" /* COLORS */].WHITE,
      colorBg: colors["a" /* COLORS */].BLUE,
      onClick: onNext,
      rotation: 180
    }))), getBottomControls(isPreviousControlDisabled, isNextControlDisabled, onPrevious, onNext, index));
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/event-animation-line/EventAnimationLine.jsx
var EventAnimationLine_jsx = react_default.a.createElement;




var EventAnimationLine_EventAnimationLine = function EventAnimationLine(_ref) {
  var items = _ref.items,
      title = _ref.title;
  return EventAnimationLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    dataTestId: "Line-EventAnimation"
  }, EventAnimationLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "md:justify-start"
  }, title), EventAnimationLine_jsx(EventAnimation_EventAnimation, {
    offers: items
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/event-animation/eventAnimation.descriptor.js


var eventAnimationDescriptor = {
  name: constants["o" /* EVENT_ANIMATION */],
  component: EventAnimationLine_EventAnimationLine
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("lTEL");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("tQbP");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("kYxP");

// EXTERNAL MODULE: /opt/webapp/node_modules/formik/dist/formik.esm.js + 115 modules
var formik_esm = __webpack_require__("ljKo");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__("yjkv");
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// EXTERNAL MODULE: ./src/client/components/frameworks/formik/FormikInput.jsx + 15 modules
var FormikInput = __webpack_require__("/HC4");

// EXTERNAL MODULE: ./src/client/components/widgets/confirmation/Confirmation.jsx
var Confirmation = __webpack_require__("Fmrk");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: /opt/webapp/node_modules/yup/lib/index.js
var lib = __webpack_require__("luEP");

// CONCATENATED MODULE: ./src/client/components/widgets/event-form/eventForm.utils.js












function eventForm_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function eventForm_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      eventForm_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      eventForm_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var EVENT_TYPES = dist["constants"].EVENT_TYPES,
    USER_SALUTATIONS = dist["constants"].USER_SALUTATIONS;
var eventForm_utils_getInitialFormValues = function getInitialFormValues() {
  return {
    type: '',
    numberOfParticipants: '',
    withRooms: false,
    numberOfRooms: '',
    withServices: false,
    withTransport: false,
    departureCity: '',
    logisticsComment: '',
    withMeetingRooms: false,
    region: '',
    resort: '',
    dates: {
      from: null,
      to: null
    },
    withFlexibleDates: false,
    company: '',
    salutation: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    postcode: '',
    city: '',
    country: '',
    optinPersonalInformation: false,
    generalComment: '',
    optinEmail: false,
    optinSMS: false,
    optinPhone: false
  };
};
var eventForm_utils_getEventQuery = function getEventQuery(values) {
  var address = values.address,
      city = values.city,
      company = values.company,
      country = values.country,
      dates = values.dates,
      departureCity = values.departureCity,
      email = values.email,
      firstName = values.firstName,
      generalComment = values.generalComment,
      lastName = values.lastName,
      logisticsComment = values.logisticsComment,
      numberOfParticipants = values.numberOfParticipants,
      numberOfRooms = values.numberOfRooms,
      optinEmail = values.optinEmail,
      optinPersonalInformation = values.optinPersonalInformation,
      optinPhone = values.optinPhone,
      optinSMS = values.optinSMS,
      phone = values.phone,
      postcode = values.postcode,
      resort = values.resort,
      salutation = values.salutation,
      type = values.type,
      withFlexibleDates = values.withFlexibleDates,
      withMeetingRooms = values.withMeetingRooms,
      withRooms = values.withRooms,
      withTransport = values.withTransport;
  var departureDate = dates.from ? "\"".concat(moment_default()(dates.from).format('YYYY-MM-DD'), "\"") : 'null';
  var returnDate = dates.to ? "\"".concat(moment_default()(dates.to).format('YYYY-MM-DD'), "\"") : 'null';
  var numberOfRoomsValue = withRooms ? numberOfRooms : 'null';
  return "mutation {\n    event(eventInput: {\n      address: \"".concat(address, "\",\n      city: \"").concat(city, "\",\n      company: \"").concat(company, "\",\n      country: \"").concat(country, "\",\n      departureDate: ").concat(departureDate, ",\n      departureCity: \"").concat(departureCity, "\",\n      email: \"").concat(email, "\",\n      firstName: \"").concat(firstName, "\",\n      generalComment: \"").concat(generalComment, "\",\n      interest: ").concat(type, ",\n      lastName: \"").concat(lastName, "\",\n\t\t\tlogisticsComment: \"").concat(logisticsComment, "\",\n      numberOfParticipants: ").concat(numberOfParticipants, ",\n      numberOfRooms: ").concat(numberOfRoomsValue, ",\n      optinEmail: ").concat(optinEmail.toString(), ",\n      optinPersonalInformation: ").concat(optinPersonalInformation.toString(), ",\n      optinPhone: ").concat(optinPhone.toString(), ",\n      optinSMS: ").concat(optinSMS.toString(), ",\n      phone: \"").concat(phone, "\",\n      postcode: \"").concat(postcode, "\",\n      resort: \"").concat(resort, "\",\n      returnDate: ").concat(returnDate, ",\n      salutation: ").concat(salutation, ",\n      withFlexibleDates: ").concat(withFlexibleDates.toString(), ",\n      withMeetingRooms: ").concat(withMeetingRooms.toString(), ",\n      withTransport: ").concat(withTransport.toString(), ",\n    }) {\n      __typename\n      ...on EventError {\n        statusCode\n        statusMessage\n        errorCode\n        errorDescription\n      }\n      ...on Event {\n        id\n      }\n    }\n  }");
};
var eventForm_utils_getEventSchema = function getEventSchema(_ref) {
  var displayAddressFields = _ref.displayAddressFields,
      resortIds = _ref.resortIds;
  var addressGroupSchema = displayAddressFields ? {
    address: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.streetPlaceholder')),
    postcode: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.postcodePlaceholder')),
    city: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.cityPlaceholder')),
    country: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.countryPlaceholder'))
  } : null;
  return lib["object"]().shape(eventForm_utils_objectSpread(eventForm_utils_objectSpread({
    type: lib["mixed"]().oneOf(Object.keys(EVENT_TYPES)).required(Object(src_i18n["h" /* t */])('eventForm.packageSection.eventTypePlaceholder')),
    numberOfParticipants: lib["number"]().min(1, Object(src_i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder')).required(Object(src_i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder')),
    numberOfRooms: lib["number"]().min(1),
    withFlexibleDates: lib["boolean"](),
    withMeetingRooms: lib["boolean"](),
    withRooms: lib["boolean"](),
    withServices: lib["boolean"](),
    withTransport: lib["boolean"](),
    departureCity: lib["string"](),
    logisticsComment: lib["string"](),
    resort: lib["mixed"]().oneOf(resortIds),
    dates: lib["object"]().shape({
      from: lib["date"]().nullable(),
      to: lib["date"]().nullable()
    }),
    company: lib["string"](),
    salutation: lib["mixed"]().oneOf(Object.keys(USER_SALUTATIONS)).required(Object(src_i18n["h" /* t */])('eventForm.userSection.salutationPlaceholder')),
    firstName: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.firstNamePlaceholder')),
    lastName: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.lastNamePlaceholder')),
    email: lib["string"]().email(Object(src_i18n["h" /* t */])('eventForm.userSection.emailPlaceholder')).required(Object(src_i18n["h" /* t */])('eventForm.userSection.emailPlaceholder')),
    phone: lib["string"]().required(Object(src_i18n["h" /* t */])('eventForm.userSection.phonePlaceholder'))
  }, addressGroupSchema), {}, {
    optinPersonalInformation: lib["boolean"]().oneOf([true]).required(),
    generalComment: lib["string"](),
    optinEmail: lib["boolean"](),
    optinSMS: lib["boolean"](),
    optinPhone: lib["boolean"]()
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/event-form/EventForm.jsx


















var EventForm_jsx = react_default.a.createElement;

function EventForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function EventForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { EventForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { EventForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var FORM_ACTIONS = {
  SUBMIT_EVENT: 'SUBMIT_EVENT',
  SUBMIT_EVENT_ERROR: 'SUBMIT_EVENT_ERROR',
  SUBMIT_EVENT_SUCCESS: 'SUBMIT_EVENT_SUCCESS'
};
var FORM_STATUS = {
  NEW: 'neutral',
  SUCCESS: 'success',
  ERROR: 'error'
};
var OPENING_STATUS = dist["constants"].OPENING_STATUS;
var EventForm_EventForm = function EventForm(_ref) {
  var _ref$displayAddressFi = _ref.displayAddressFields,
      displayAddressFields = _ref$displayAddressFi === void 0 ? true : _ref$displayAddressFi,
      eventTypeOptions = _ref.eventTypeOptions,
      formError = _ref.formError,
      formSuccess = _ref.formSuccess,
      regions = _ref.regions,
      resorts = _ref.resorts,
      userSalutationOptions = _ref.userSalutationOptions;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var track = Object(useTracking["a" /* useTracking */])({
    categoryGA: tracking_constants["j" /* MEETING_EVENT */].REQUEST
  });

  var _useReducer = Object(react["useReducer"])(function (state, action) {
    switch (action.type) {
      case FORM_ACTIONS.SUBMIT_EVENT:
        return EventForm_objectSpread(EventForm_objectSpread({}, state), {}, {
          isSending: true
        });

      case FORM_ACTIONS.SUBMIT_EVENT_ERROR:
        return {
          isSending: false,
          formStatus: FORM_STATUS.ERROR,
          confirmation: formError
        };

      case FORM_ACTIONS.SUBMIT_EVENT_SUCCESS:
        return {
          isSending: false,
          formStatus: FORM_STATUS.SUCCESS,
          confirmation: formSuccess
        };

      default:
        return state;
    }
  }, {
    isSending: false,
    formStatus: FORM_STATUS.NEW,
    confirmation: {}
  }),
      _useReducer$ = _useReducer[0],
      isSending = _useReducer$.isSending,
      formStatus = _useReducer$.formStatus,
      confirmation = _useReducer$.confirmation,
      dispatch = _useReducer[1];

  var openedResorts = resorts.filter(function (_ref2) {
    var openingStatus = _ref2.openingStatus;
    return openingStatus === OPENING_STATUS.OPEN;
  });
  return EventForm_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "py-px40",
    id: "event-form"
  }, EventForm_jsx(LineTitle["a" /* LineTitle */], null, Object(src_i18n["h" /* t */])('eventForm.formTitle')), EventForm_jsx(formik_esm["d" /* Formik */], {
    initialValues: eventForm_utils_getInitialFormValues(),
    validationSchema: eventForm_utils_getEventSchema({
      displayAddressFields: displayAddressFields,
      resortIds: openedResorts.map(function (resort) {
        return resort.id;
      })
    }),
    onSubmit: /*#__PURE__*/function () {
      var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values) {
        var query, labelGA, _yield$graphQLClient$, event;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: FORM_ACTIONS.SUBMIT_EVENT
                });
                query = eventForm_utils_getEventQuery(values);
                labelGA = values.resort || null;
                _context.prev = 3;
                _context.next = 6;
                return graphqlClient["a" /* default */].runNoCacheQuery(query, appContext, {
                  requestName: requestDictionary["Jd" /* WIDGET_EVENT_FORM_SUBMIT */]
                });

              case 6:
                _yield$graphQLClient$ = _context.sent;
                event = _yield$graphQLClient$.event;

                if (event.errorCode) {
                  dispatch({
                    type: FORM_ACTIONS.SUBMIT_EVENT_ERROR
                  });
                  track({
                    actionGA: tracking_constants["j" /* MEETING_EVENT */].SEND_REQUEST_ERROR,
                    labelGA: labelGA
                  });
                } else {
                  dispatch({
                    type: FORM_ACTIONS.SUBMIT_EVENT_SUCCESS
                  });
                  track({
                    actionGA: tracking_constants["j" /* MEETING_EVENT */].SEND_REQUEST_SUCCESS,
                    labelGA: labelGA
                  });
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                dispatch({
                  type: FORM_ACTIONS.SUBMIT_EVENT_ERROR
                });
                track({
                  actionGA: tracking_constants["j" /* MEETING_EVENT */].SEND_REQUEST_ERROR,
                  labelGA: labelGA
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()
  }, function (_ref4) {
    var values = _ref4.values,
        isValid = _ref4.isValid;
    return EventForm_jsx(formik_esm["c" /* Form */], {
      "data-testid": "form"
    }, EventForm_jsx(Title["a" /* Title */], {
      className: "mt-px30 mb-px10 px-px10",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["h" /* t */])('eventForm.packageSection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-type",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.eventTypeLabel'),
      name: "type",
      options: uniqBy_default()(eventTypeOptions, 'value'),
      placeholder: Object(src_i18n["h" /* t */])('eventForm.packageSection.eventTypePlaceholder'),
      type: "select"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-participants",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsLabel'),
      min: 1,
      name: "numberOfParticipants",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.packageSection.numberOfParticipantsPlaceholder'),
      type: "number"
    })), EventForm_jsx("p", {
      className: "w-full mb-px10 px-px10 pt-px10 text-base font-bold"
    }, Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.packageServicesLabel')), EventForm_jsx("div", {
      className: "flex flex-wrap w-full md:w-1/2"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      dataTestId: "event-with-rooms",
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.roomsCheckboxLabel'),
      name: "withRooms",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-number-rooms",
      hideErrorMessage: true,
      isDisabled: !values.withRooms,
      isRequired: values.withRooms,
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.roomsInputLabel'),
      min: 1,
      name: "numberOfRooms",
      placeholder: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.roomsInputPlaceholder'),
      type: "number"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.transportationCheckboxLabel'),
      name: "withTransport",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: !values.withTransport,
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.transportationInputLabel'),
      name: "departureCity",
      placeholder: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.transportationInputPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.meetingRoomsCheckboxLabel'),
      name: "withMeetingRooms",
      optimized: true,
      type: "checkbox"
    }))), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesCheckboxLabel'),
      name: "withServices",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      isDisabled: !values.withServices,
      label: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesInputLabel'),
      name: "logisticsComment",
      maxLength: 130,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.packageSection.packageServicesSection.otherServicesInputPlaceholder'),
      type: "textarea"
    }))), EventForm_jsx(Title["a" /* Title */], {
      className: "mt-px30 mb-px10 px-px10",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["h" /* t */])('eventForm.staySection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2"
    }, EventForm_jsx("div", {
      className: "w-full p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-region",
      label: Object(src_i18n["h" /* t */])('eventForm.staySection.destinationLabel'),
      name: "region",
      options: regions.map(function (region) {
        return {
          name: region,
          value: region
        };
      }).sort(),
      placeholder: Object(src_i18n["h" /* t */])('eventForm.staySection.destinationPlaceholder'),
      type: "select"
    })), EventForm_jsx("div", {
      className: "w-full p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-resort",
      label: Object(src_i18n["h" /* t */])('eventForm.staySection.resortLabel'),
      name: "resort",
      options: openedResorts.filter(function (resort) {
        return !values.region || resort.region === values.region;
      }).map(function (resort) {
        return {
          name: resort.name,
          value: resort.id
        };
      }),
      placeholder: Object(src_i18n["h" /* t */])('eventForm.staySection.resortPlaceholder'),
      type: "select"
    }))), EventForm_jsx("div", {
      className: "w-full md:w-1/4 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      isDateRange: true,
      label: Object(src_i18n["h" /* t */])('eventForm.staySection.datesLabel'),
      minDate: moment_default()().add({
        days: 1
      }).toDate(),
      name: "dates",
      placeholder: Object(src_i18n["h" /* t */])('eventForm.staySection.datesPlaceholder'),
      type: "datepicker"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/4 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10 md:mt-px30",
      label: Object(src_i18n["h" /* t */])('eventForm.staySection.flexibleDatesLabel'),
      name: "withFlexibleDates",
      type: "checkbox"
    }))), EventForm_jsx(Title["a" /* Title */], {
      className: "mt-px30 mb-px10 px-px10",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["h" /* t */])('eventForm.userSection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-company",
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.companyLabel'),
      name: "company",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.companyPlaceholder'),
      type: "text"
    }))), EventForm_jsx("div", {
      className: "w-1/2 md:w-1/6 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-salutation",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.salutationLabel'),
      name: "salutation",
      optimized: true,
      options: userSalutationOptions,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.salutationPlaceholder'),
      type: "select"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/3 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-firstName",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.firstNameLabel'),
      name: "firstName",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.firstNamePlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-lastName",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.lastNameLabel'),
      name: "lastName",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.lastNamePlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-email",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.emailLabel'),
      name: "email",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.emailPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-phone",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.phoneLabel'),
      name: "phone",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.phonePlaceholder'),
      type: "text"
    })), displayAddressFields && EventForm_jsx("div", {
      className: "flex flex-wrap w-full"
    }, EventForm_jsx("p", {
      className: "w-full mb-px10 px-px10 pt-px10 text-base font-bold"
    }, Object(src_i18n["h" /* t */])('eventForm.userSection.addressLabel')), EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-address",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.streetLabel'),
      name: "address",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.streetPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-1/2 md:w-1/6 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-postcode",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.postcodeLabel'),
      name: "postcode",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.postcodePlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full md:w-1/3"
    }, EventForm_jsx("div", {
      className: "w-full p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-city",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.cityLabel'),
      name: "city",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.cityPlaceholder'),
      type: "text"
    })), EventForm_jsx("div", {
      className: "w-full p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      dataTestId: "event-owner-country",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.countryLabel'),
      name: "country",
      optimized: true,
      placeholder: Object(src_i18n["h" /* t */])('eventForm.userSection.countryPlaceholder'),
      type: "text"
    })))), EventForm_jsx("div", {
      className: "w-full"
    }, EventForm_jsx("div", {
      className: "w-full md:w-1/2 p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      dataTestId: "event-owner-personal-information",
      isRequired: true,
      label: Object(src_i18n["h" /* t */])('eventForm.userSection.personalInformationOptinLabel'),
      name: "optinPersonalInformation",
      optimized: true,
      type: "checkbox"
    })))), EventForm_jsx(Title["a" /* Title */], {
      className: "mt-px30 mb-px10 px-px10",
      color: colors["a" /* COLORS */].BLUE,
      hLevel: 3,
      theme: "title-sans-4"
    }, Object(src_i18n["h" /* t */])('eventForm.commentSection.title')), EventForm_jsx("div", {
      className: "flex flex-wrap"
    }, EventForm_jsx("div", {
      className: "w-full p-px10"
    }, EventForm_jsx(FormikInput["a" /* FormikInput */], {
      label: Object(src_i18n["h" /* t */])('eventForm.commentSection.commentLabel'),
      name: "generalComment",
      placeholder: Object(src_i18n["h" /* t */])('eventForm.commentSection.commentPlaceholder'),
      type: "textarea"
    })), EventForm_jsx("div", {
      className: "w-full p-px10"
    }, EventForm_jsx("p", null, Object(src_i18n["h" /* t */])('eventForm.commentSection.optinLabel')), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      label: Object(src_i18n["h" /* t */])('eventForm.commentSection.emailOptinLabel'),
      name: "optinEmail",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      label: Object(src_i18n["h" /* t */])('eventForm.commentSection.smsOptinLabel'),
      name: "optinSMS",
      optimized: true,
      type: "checkbox"
    }), EventForm_jsx(FormikInput["a" /* FormikInput */], {
      className: "mb-px10",
      label: Object(src_i18n["h" /* t */])('eventForm.commentSection.phoneOptinLabel'),
      name: "optinPhone",
      optimized: true,
      type: "checkbox"
    }))), EventForm_jsx("div", {
      className: classnames_default()('mt-px15', {
        'text-right': formStatus === FORM_STATUS.NEW,
        'flex justify-center': formStatus !== FORM_STATUS.NEW
      })
    }, formStatus === FORM_STATUS.NEW ? EventForm_jsx(Button["a" /* Button */], {
      colorBg: colors["a" /* COLORS */].BLUE,
      colorBorder: colors["a" /* COLORS */].BLUE,
      dataTestId: "event-submit",
      isDisabled: !isValid,
      isLoading: isSending,
      type: "submit"
    }, Object(src_i18n["h" /* t */])('eventForm.formButton')) : EventForm_jsx(Confirmation["a" /* Confirmation */], Object(esm_extends["a" /* default */])({}, confirmation, {
      status: formStatus
    }))));
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__("LqLs");

// CONCATENATED MODULE: ./src/client/components/lines/event-form-line/EventFormLine.utils.js










var EventFormLine_utils_getEventFormResorts = function getEventFormResorts(resorts) {
  return Object(lodash["sortBy"])(Object(lodash["uniqBy"])(resorts, 'id').map(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        destination = _ref.destination,
        openingStatus = _ref.openingStatus;
    return {
      id: id,
      name: name,
      openingStatus: openingStatus,
      region: destination.area
    };
  }), function (resort) {
    return Object(lodash["toUpper"])(resort.name);
  });
};
var getEventFormRegions = function getEventFormRegions(resorts) {
  return Array.from(new Set(resorts.map(function (resort) {
    return resort.region;
  }))).sort();
};
// CONCATENATED MODULE: ./src/client/components/lines/event-form-line/EventFormLine.jsx
var EventFormLine_jsx = react_default.a.createElement;




function EventFormLine(props) {
  Object(src_i18n["a" /* addTranslationKeys */])({
    eventForm: props
  });
  var formError = props.formError,
      formSuccess = props.formSuccess,
      resorts = props.resorts,
      eventTypeOptions = props.packageSection.eventTypeOptions,
      _props$userSection = props.userSection,
      displayAddressFields = _props$userSection.displayAddressFields,
      salutationOptions = _props$userSection.salutationOptions;
  var formResorts = EventFormLine_utils_getEventFormResorts(resorts);
  var formRegions = getEventFormRegions(formResorts);
  return EventFormLine_jsx(EventForm_EventForm, {
    displayAddressFields: displayAddressFields,
    eventTypeOptions: eventTypeOptions,
    formError: formError,
    formSuccess: formSuccess,
    regions: formRegions,
    resorts: formResorts,
    userSalutationOptions: salutationOptions
  });
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/event-form/eventForm.resolver.js
var eventForm_resolver = __webpack_require__("yWy0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/event-form/eventForm.descriptor.js



var eventFormDescriptor = {
  name: constants["p" /* EVENT_FORM */],
  component: EventFormLine,
  resolve: eventForm_resolver["a" /* eventFormResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/button-ticket-line/ButtonTicketLine.jsx
var ButtonTicketLine_jsx = react_default.a.createElement;






var ButtonTicketLine_ButtonTicketLine = function ButtonTicketLine(_ref) {
  var buttonLabel = _ref.buttonLabel,
      buttonLink = _ref.buttonLink,
      title = _ref.title;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var trackingData = {
    categoryGA: pageType,
    actionGA: 'priceBar',
    labelGA: 'getAQuote'
  };
  return ButtonTicketLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ButtonTicket"
  }, ButtonTicketLine_jsx("div", {
    className: "bg-white shadow-diffuse rounded-tiny border-1 border-gray-light flex items-center p-px10 flex-col md:flex-row mt-px30 md:mt-0"
  }, ButtonTicketLine_jsx(Text["a" /* Text */], {
    className: "flex-1 md:rtl:ml-px10 text-center md:text-initial px-px10 md:px-0",
    text: title
  }), ButtonTicketLine_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BOOKING,
    url: buttonLink,
    trackingData: trackingData,
    dataTestId: "getButtonTicketLineBtn",
    className: "w-full md:w-auto mt-px15 sm:mt-0"
  }, buttonLabel)));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/button-ticket/buttonTicket.descriptor.js


var buttonTicketDescriptor = {
  name: constants["c" /* BUTTON_TICKET */],
  component: ButtonTicketLine_ButtonTicketLine
};
// EXTERNAL MODULE: ./src/client/components/widgets/facet-search/FacetSearch.jsx + 35 modules
var FacetSearch = __webpack_require__("ontP");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/components/lines/immersive-line/ImmersiveLine.utils.js








var ImmersiveLine_utils_getMinPrice = function getMinPrice(_ref, minPrice) {
  var name = _ref.name,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(objectWithoutProperties["a" /* default */])(_ref$props, ["lines"]);

  if ([constants["I" /* PRODUCTS_FILTERS */], constants["ib" /* RESORT_GRID */], constants["ob" /* RESORT_RECOMMENDATIONS */]].includes(name)) {
    var _props$recommendation, _props$offer;

    var products = props.products || ((_props$recommendation = props.recommendations) === null || _props$recommendation === void 0 ? void 0 : _props$recommendation.products) || ((_props$offer = props.offer) === null || _props$offer === void 0 ? void 0 : _props$offer.products) || [];
    minPrice = products.reduce(function (min, product) {
      var _product$price, _product$price$bestPr, _min$bestPrice, _min$bestPrice2;

      return ((_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$bestPr = _product$price.bestPrice) === null || _product$price$bestPr === void 0 ? void 0 : _product$price$bestPr.value) && product.price.bestPrice.value < (min === null || min === void 0 ? void 0 : (_min$bestPrice = min.bestPrice) === null || _min$bestPrice === void 0 ? void 0 : _min$bestPrice.value) || !(min === null || min === void 0 ? void 0 : (_min$bestPrice2 = min.bestPrice) === null || _min$bestPrice2 === void 0 ? void 0 : _min$bestPrice2.value) ? product.price : min;
    }, minPrice);
  }

  if (lines.length > 0) {
    lines.forEach(function (line) {
      minPrice = getMinPrice(line, minPrice);
    });
  }

  return minPrice;
};
// CONCATENATED MODULE: ./src/client/components/lines/immersive-line/ImmersiveLine.jsx



var ImmersiveLine_jsx = react_default.a.createElement;







var ImmersiveLine_formatLabelWithPrice = function formatLabelWithPrice(_ref) {
  var label = _ref.label,
      price = _ref.price;
  return Object(dist["messageFormat"])(label || '').format({
    best_price_on_page: price
  });
};

var ImmersiveLine_ImmersiveLine = function ImmersiveLine(_ref2) {
  var _minPrice$bestPrice, _dynamicPrice$link, _dynamicPrice$link2;

  var backgroundURL = _ref2.backgroundURL,
      config = _ref2.config,
      _ref2$dynamicPrice = _ref2.dynamicPrice,
      dynamicPrice = _ref2$dynamicPrice === void 0 ? {} : _ref2$dynamicPrice,
      _ref2$displaySearch = _ref2.displaySearch,
      displaySearch = _ref2$displaySearch === void 0 ? false : _ref2$displaySearch,
      id = _ref2.id,
      _ref2$pageLines = _ref2.pageLines,
      pageLines = _ref2$pageLines === void 0 ? [] : _ref2$pageLines,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["backgroundURL", "config", "dynamicPrice", "displaySearch", "id", "pageLines"]);

  var displayDynamicPrice = dynamicPrice.displayDynamicPrice;
  var minPrice = displayDynamicPrice ? ImmersiveLine_utils_getMinPrice({
    props: {
      lines: pageLines
    }
  }) : undefined;
  var formattedMinPrice = (minPrice === null || minPrice === void 0 ? void 0 : (_minPrice$bestPrice = minPrice.bestPrice) === null || _minPrice$bestPrice === void 0 ? void 0 : _minPrice$bestPrice.formattedValue) || '';
  var dynamicPriceLabels = displayDynamicPrice && !!formattedMinPrice ? {
    title: ImmersiveLine_formatLabelWithPrice({
      label: dynamicPrice.title,
      price: formattedMinPrice
    }),
    subtitle: ImmersiveLine_formatLabelWithPrice({
      label: dynamicPrice.subtitle,
      price: formattedMinPrice
    }),
    link: {
      url: ((_dynamicPrice$link = dynamicPrice.link) === null || _dynamicPrice$link === void 0 ? void 0 : _dynamicPrice$link.url) || '',
      label: ImmersiveLine_formatLabelWithPrice({
        label: (_dynamicPrice$link2 = dynamicPrice.link) === null || _dynamicPrice$link2 === void 0 ? void 0 : _dynamicPrice$link2.label,
        price: formattedMinPrice
      })
    }
  } : {};
  return ImmersiveLine_jsx(react["Fragment"], null, ImmersiveLine_jsx("div", {
    className: "Line Line-Immersive",
    id: id
  }, ImmersiveLine_jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    hasOverlap: displaySearch,
    url: backgroundURL
  }, dynamicPriceLabels))), displaySearch && ImmersiveLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-Search"
  }, ImmersiveLine_jsx(FacetSearch["a" /* FacetSearch */], {
    i18n: config,
    searchPageRouteName: "search",
    shouldRedirectToResortPage: true,
    withSearchForm: true
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/immersive/immersive.resolver.js
var immersive_resolver = __webpack_require__("pIL7");

// CONCATENATED MODULE: ./src/client/cms/toolkit/immersive/immersive.descriptor.js



var immersiveDescriptor = {
  name: constants["r" /* IMMERSIVE */],
  component: ImmersiveLine_ImmersiveLine,
  resolver: immersive_resolver["a" /* immersiveResolver */]
};
// EXTERNAL MODULE: ./src/client/components/frameworks/social-picture/SocialPicture.jsx + 1 modules
var SocialPicture = __webpack_require__("JHNY");

// CONCATENATED MODULE: ./src/client/components/widgets/instagram/InstagramCard.jsx











var InstagramCard_jsx = react_default.a.createElement;

function InstagramCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InstagramCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InstagramCard_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InstagramCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var InstagramCard_InstagramCard = function InstagramCard(_ref) {
  var _price$bestPrice;

  var comfort = _ref.comfort,
      href = _ref.href,
      id = _ref.id,
      index = _ref.index,
      isCruise = _ref.isCruise,
      isJoyview = _ref.isJoyview,
      isTour = _ref.isTour,
      lineName = _ref.lineName,
      name = _ref.name,
      price = _ref.price,
      socialPicture = _ref.socialPicture;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'push_content_instagram',
    labelGA: id
  });
  var pageContext = react_default.a.useContext(context_pageContext["a" /* ReactPageContext */]);
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var clickThumbnailTrackingData = typeof index === 'number' ? {
    actionGA: 'clickThumbnail',
    labelGA: id,
    resortCode: id,
    resortTrident: comfort || '',
    thumbnailPrice: (price === null || price === void 0 ? void 0 : (_price$bestPrice = price.bestPrice) === null || _price$bestPrice === void 0 ? void 0 : _price$bestPrice.value) || '',
    thumbnailList: lineName ? "".concat(siteSection, "_").concat(Object(lodash["camelCase"])(lineName)) : siteSection,
    thumbnailPosition: index + 1
  } : null;
  var hasPrice = !!price && (!!(price === null || price === void 0 ? void 0 : price.initialPrice) || !!(price === null || price === void 0 ? void 0 : price.bestPrice));

  var handleDynamicLinkClick = function handleDynamicLinkClick() {
    track({});

    if (clickThumbnailTrackingData) {
      track(clickThumbnailTrackingData);
    }
  };

  var handleProductPriceModalClick = function handleProductPriceModalClick(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    e.stopPropagation(); // Prevent event from bubbling to Dynamic Link

    track({});

    if (clickThumbnailTrackingData) {
      track(InstagramCard_objectSpread(InstagramCard_objectSpread({}, clickThumbnailTrackingData), {}, {
        labelGA: "".concat(id, "_bestPrice")
      }));
    }
  };

  var handleProductPriceModalClickButton = function handleProductPriceModalClickButton(e) {
    e.preventDefault(); // Prevent event from propagating to card link

    e.stopPropagation(); // Prevent event from bubbling to Dynamic Link

    track({});

    if (clickThumbnailTrackingData) {
      track(InstagramCard_objectSpread(InstagramCard_objectSpread({}, clickThumbnailTrackingData), {}, {
        labelGA: "".concat(id, "_discoverResort")
      }));
    }

    if (href) {
      var productUrl = Object(uriUtils["f" /* generateUrlWithParams */])(href, {
        queryParams: location.queryParams
      });
      history.pushRoute(Object(Product_mapper["a" /* createProductUrlWithParams */])(productUrl, {
        isCruise: isCruise,
        isTour: isTour
      }));
    }
  };

  return InstagramCard_jsx("div", {
    className: classnames_default()('flex-none lg:flex-auto', {
      'rtl:ml-px20': index !== 0
    }),
    style: {
      width: '60vw',
      maxWidth: '280px'
    }
  }, InstagramCard_jsx(DynamicLink["a" /* default */], {
    className: "block relative",
    "data-testid": "instagram-card-link",
    onClick: handleDynamicLinkClick,
    url: href
  }, InstagramCard_jsx(SocialPicture["a" /* SocialPicture */], {
    src: socialPicture.imageLarge,
    theme: "cards",
    userName: socialPicture.userName
  }), InstagramCard_jsx("div", {
    className: "absolute gradient-linear-transparent-black-80 inset-x-0 bottom-0 py-px10 sm:py-px20 rounded-tiny text-white"
  }, InstagramCard_jsx("p", {
    className: "reset-paragraph font-brand px-px10 sm:px-px20 text-md sm:text-lg truncate"
  }, name), hasPrice && InstagramCard_jsx(ProductPriceModal["a" /* ProductPriceModal */] // $FlowFixMe
  , Object(esm_extends["a" /* default */])({}, Object(Product_mapper["b" /* getProductPriceInfoProps */])({
    product: {
      price: price
    }
  }), {
    className: "m-px5",
    isCruise: isCruise,
    isJoyview: isJoyview,
    isTour: isTour,
    onClick: handleProductPriceModalClick,
    onClickButton: handleProductPriceModalClickButton
  }), InstagramCard_jsx(Price["a" /* Price */], {
    bestPrice: price === null || price === void 0 ? void 0 : price.bestPrice,
    className: "px-px10 sm:px-px20",
    containerStyle: null,
    from: Object(src_i18n["h" /* t */])('price.format.from'),
    style: {
      minHeight: 'none'
    },
    theme: "instagram",
    unit: price === null || price === void 0 ? void 0 : price.unit
  })))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/instagram/Instagram.jsx


var Instagram_jsx = react_default.a.createElement;



var Instagram_Instagram = function Instagram(_ref) {
  var cards = _ref.cards,
      lineName = _ref.lineName,
      title = _ref.title;

  if (!cards.length) {
    return null;
  }

  return Instagram_jsx(react["Fragment"], null, !!title && Instagram_jsx(LineTitle["a" /* LineTitle */], null, title), Instagram_jsx("div", {
    className: "-mx-px20 overflow-x-scroll lg:overflow-x-visible",
    style: {
      maxHeight: '280px'
    }
  }, Instagram_jsx("div", {
    className: "flex flex-no-wrap px-px20"
  }, cards.map(function (item, index) {
    return Instagram_jsx(InstagramCard_InstagramCard, Object(esm_extends["a" /* default */])({}, item, {
      index: index,
      key: item.href,
      lineName: lineName
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/instagram-line/InstagramLine.jsx










var InstagramLine_jsx = react_default.a.createElement;

function InstagramLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function InstagramLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { InstagramLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { InstagramLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var InstagramLine_InstagramLine = function InstagramLine(_ref) {
  var config = _ref.config,
      displayPrices = _ref.displayPrices,
      id = _ref.id,
      products = _ref.products,
      title = _ref.title;

  if (!products || products.length === 0) {
    return null;
  }

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var cards = products.filter(function (_ref2) {
    var socialPictures = _ref2.socialPictures;
    return socialPictures.length > 0;
  }).map(function (_ref3) {
    var socialPictures = _ref3.socialPictures,
        rest = Object(objectWithoutProperties["a" /* default */])(_ref3, ["socialPictures"]);

    return InstagramLine_objectSpread(InstagramLine_objectSpread({}, rest), {}, {
      price: displayPrices ? rest.price : null,
      socialPicture: socialPictures[0]
    });
  });
  return cards.length > 0 ? InstagramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, InstagramLine_jsx(Instagram_Instagram, {
    cards: cards,
    lineName: constants["s" /* INSTAGRAM */],
    title: title
  })) : null;
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/instagram/instagram.resolver.js
var instagram_resolver = __webpack_require__("vt7b");

// CONCATENATED MODULE: ./src/client/cms/toolkit/instagram/instagram.descriptor.js



var instagramDescriptor = {
  name: constants["s" /* INSTAGRAM */],
  component: InstagramLine_InstagramLine,
  resolver: instagram_resolver["a" /* instagramResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/grid/Grid.jsx + 2 modules
var Grid = __webpack_require__("uLWw");

// EXTERNAL MODULE: ./src/client/components/widgets/product/Product.jsx + 6 modules
var Product = __webpack_require__("XTOr");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/resort-thumbnail-query/resortThumbnailQuery.js
var resortThumbnailQuery = __webpack_require__("jw1E");

// EXTERNAL MODULE: ./src/client/views/configQueries.js
var configQueries = __webpack_require__("4VTZ");

// CONCATENATED MODULE: ./src/client/components/lines/last-seen-products-line/LastSeenProductsLine.jsx








var LastSeenProductsLine_jsx = react_default.a.createElement;
























var MAX_LAST_SEEN_PRODUCTS = 3;

function lastSeenProductsQuery(appContext, productIds, pageContext) {
  var _appContext$cmsConten = appContext.cmsContent,
      cmsContent = _appContext$cmsConten === void 0 ? '' : _appContext$cmsConten,
      _appContext$cmsReleas = appContext.cmsRelease,
      cmsRelease = _appContext$cmsReleas === void 0 ? '' : _appContext$cmsReleas;
  var cmsArgs = "content: \"".concat(cmsContent, "\", release: \"").concat(cmsRelease, "\"");
  var isMice = dist["b2cPagesService"].isMicePage(pageContext.pageType);
  var resortThumbnailQueryString = Object(resortThumbnailQuery["b" /* default */])({
    content: cmsContent,
    release: cmsRelease,
    isMice: isMice
  });
  var query = "query {\n      products: resorts(resortIds : ".concat(JSON.stringify(productIds), ") {\n        ").concat(resortThumbnailQueryString, "\n      },\n      config(").concat(cmsArgs, ") {\n        common {\n          next\n          previous\n          close\n          thumbnailCTA\n          thumbnailTourCTA\n        }\n        ").concat(configQueries["c" /* price */](), "\n        ").concat(configQueries["e" /* resort */](appContext), "\n      }\n    }");
  return query;
} // Placeholder styling replicates Product card image aspect ratio


var LastSeenPlaceholder = function LastSeenPlaceholder(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles;
  return LastSeenProductsLine_jsx("div", {
    className: className,
    style: styles
  }, LastSeenProductsLine_jsx("div", {
    className: "relative",
    style: {
      height: '0',
      paddingBottom: 'calc(240 / 380 * 100%)'
    }
  }, LastSeenProductsLine_jsx("div", {
    className: "absolute pin h-full w-full border-2 border-dashed"
  })));
};

var LastSeenProductsLine_LastSeenProductsLine = function LastSeenProductsLine(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      seeMoreResortsLabel = _ref2.seeMoreResortsLabel;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted,
      isDesktop = _useResponsive.isDesktop;

  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'lastSeenProducts'
  }); // Get last seen products from localStorage

  var productIds = Object(last_visited_tracking_api["a" /* getLastVisitedProductIds */])().slice(0, MAX_LAST_SEEN_PRODUCTS);

  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: lastSeenProductsQuery(appContext, productIds, pageContext),
    queryOptions: {
      requestName: requestDictionary["Cb" /* LINE_COMMON_LAST_SEEN_PRODUCTS */]
    },
    ignore: productIds.length <= 0,
    cache: true
  }),
      data = _useGQL.data,
      isLoading = _useGQL.isLoading;

  if (!isAppMounted) {
    return null;
  }

  var lastSeenProducts = [];

  if (!isLoading && data && data.products) {
    lastSeenProducts = Object(lodash["sortBy"])(data.products.map(function (product) {
      return Object(redux["d" /* compose */])(Product_mapper["c" /* getProductProps */], Product_mapper["e" /* setProductHref */])({
        config: data.config,
        product: product,
        isSliderDisabled: true
      });
    }), function (product) {
      return Object(lodash["indexOf"])(productIds, product.id);
    });
  }

  var numberOfProducts = lastSeenProducts.length;
  var numberOfPlaceholders = MAX_LAST_SEEN_PRODUCTS - numberOfProducts;
  return LastSeenProductsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, numberOfProducts > 0 && title && seeMoreResortsLabel && LastSeenProductsLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, LastSeenProductsLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), LastSeenProductsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-px20 md:mt-px5 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'lastSeenProducts',
      labelGA: 'seeMore'
    },
    url: "/s"
  }, seeMoreResortsLabel), LastSeenProductsLine_jsx("div", {
    className: "w-full lg:order-1"
  }, isDesktop ? LastSeenProductsLine_jsx(Grid["a" /* default */], {
    totalNumberToDisplay: MAX_LAST_SEEN_PRODUCTS
  }, lastSeenProducts.map(function (product, index) {
    return LastSeenProductsLine_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      index: index,
      key: product.id,
      lineName: constants["u" /* LAST_SEEN_PRODUCTS */],
      offer: product.offer,
      onClick: function onClick() {
        return track({
          labelGA: product.id
        });
      }
    }, product));
  }), Object(toConsumableArray["a" /* default */])(Array(numberOfPlaceholders).keys()).map(function (pId) {
    return LastSeenProductsLine_jsx(LastSeenPlaceholder, {
      key: "lastSeenPlaceHolder-".concat(pId)
    });
  })) : LastSeenProductsLine_jsx(Slider["a" /* Slider */], {
    className: "w-screen -mx-px20",
    cols: 0,
    hasControls: false,
    navPosition: "center",
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto"
  }, [].concat(Object(toConsumableArray["a" /* default */])(lastSeenProducts.map(function (product, index) {
    return LastSeenProductsLine_jsx("div", {
      key: product.id,
      className: classnames_default()('relative pr-px20', {
        'ml-px20': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      }
    }, LastSeenProductsLine_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({
      index: index,
      lineName: constants["u" /* LAST_SEEN_PRODUCTS */],
      offer: product.offer,
      onClick: function onClick() {
        return track({
          labelGA: product.id
        });
      }
    }, product)));
  })), Object(toConsumableArray["a" /* default */])(numberOfProducts < MAX_LAST_SEEN_PRODUCTS ? [LastSeenProductsLine_jsx(LastSeenPlaceholder, {
    key: "lastSeenPlaceHolder",
    className: "pr-px20",
    styles: {
      width: '85vw',
      maxWidth: '380px'
    }
  })] : []))))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/last-seen-products/lastSeenProducts.descriptor.js


var lastSeenProductsDescriptor = {
  name: constants["u" /* LAST_SEEN_PRODUCTS */],
  component: LastSeenProductsLine_LastSeenProductsLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.constants.js
var Card_constants = __webpack_require__("syQ6");

// CONCATENATED MODULE: ./src/client/components/utils/cards/cards.utils.js


var cards_utils_mapColToCard = function mapColToCard(_ref) {
  var color = _ref.color,
      cta = _ref.cta,
      icon = _ref.icon,
      introduction = _ref.introduction,
      link = _ref.link,
      mediaRatio = _ref.mediaRatio,
      mediaUrl = _ref.mediaUrl,
      smallTitle = _ref.smallTitle,
      subTitle = _ref.subTitle,
      text = _ref.text,
      title = _ref.title;
  return {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.seeMore'),
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    color: color,
    ctaLabel: cta,
    heading: {
      iconName: icon,
      title: title,
      small: smallTitle,
      subtitle: subTitle
    },
    introduction: {
      text: introduction
    },
    link: {
      url: link
    },
    media: {
      alt: '',
      ratioKey: mediaRatio,
      url: mediaUrl
    },
    text: {
      text: text
    }
  };
};
// EXTERNAL MODULE: ./src/client/components/frameworks/card/Card.jsx + 11 modules
var Card = __webpack_require__("786X");

// CONCATENATED MODULE: ./src/client/components/lines/media-text-horizontal-line/MediaTextHorizontalLine.jsx


var MediaTextHorizontalLine_jsx = react_default.a.createElement;





var LEFT = 'left';
var MediaTextHorizontalLine_MediaTextHorizontalLine = function MediaTextHorizontalLine(_ref) {
  var id = _ref.id,
      mediaPosition = _ref.mediaPosition,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["id", "mediaPosition"]);

  return MediaTextHorizontalLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, rest.mediaUrl ? MediaTextHorizontalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(rest), {
    layout: mediaPosition === LEFT ? Card_constants["d" /* INLINE_1 */] : Card_constants["e" /* INLINE_2 */]
  })) : MediaTextHorizontalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(rest), {
    layout: Card_constants["d" /* INLINE_1 */]
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/media-text-horizontal/mediaTextHorizontal.resolver.js
var mediaTextHorizontal_resolver = __webpack_require__("PT2a");

// CONCATENATED MODULE: ./src/client/cms/toolkit/media-text-horizontal/mediaTextHorizontal.descriptor.js



var mediaTextHorizontalDescriptor = {
  name: constants["v" /* MEDIA_TEXT_HORIZONTAL */],
  component: MediaTextHorizontalLine_MediaTextHorizontalLine,
  resolve: mediaTextHorizontal_resolver["a" /* mediaTextHorizontalResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/media-text-vertical-line/MediaTextVerticalLine.jsx










var MediaTextVerticalLine_jsx = react_default.a.createElement;

function MediaTextVerticalLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MediaTextVerticalLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MediaTextVerticalLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MediaTextVerticalLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var MediaTextVerticalLine_MediaTextVerticalLine = function MediaTextVerticalLine(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      displayLoadMore = _ref.displayLoadMore,
      id = _ref.id;

  if (!columns.length) {
    return null;
  }

  return MediaTextVerticalLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, columns.length > 1 ? MediaTextVerticalLine_jsx("div", {
    className: "sm:flex -m-px10"
  }, columns.map(function (col) {
    return MediaTextVerticalLine_jsx("div", {
      className: "p-px10 pb-px40 sm:pb-px10 sm:w-1/2",
      key: col.title
    }, MediaTextVerticalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(MediaTextVerticalLine_objectSpread({}, col)), {
      displayLoadMore: displayLoadMore,
      layout: Card_constants["a" /* COLUMN_1 */]
    })));
  })) : MediaTextVerticalLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(MediaTextVerticalLine_objectSpread({}, columns[0])), {
    displayLoadMore: displayLoadMore,
    layout: Card_constants["c" /* COMPOSITE_1 */]
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/media-text-vertical/mediaTextVertical.descriptor.js


var mediaTextVerticalDescriptor = {
  name: constants["w" /* MEDIA_TEXT_VERTICAL */],
  component: MediaTextVerticalLine_MediaTextVerticalLine
};
// CONCATENATED MODULE: ./src/client/components/lines/media-thumbnail-line/MediaThumbnailLine.jsx










var MediaThumbnailLine_jsx = react_default.a.createElement;

function MediaThumbnailLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function MediaThumbnailLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MediaThumbnailLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MediaThumbnailLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MediaThumbnailLine_MediaThumbnailLine = function MediaThumbnailLine(_ref) {
  var _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      displayLoadMore = _ref.displayLoadMore,
      id = _ref.id,
      title = _ref.title;

  if (!columns.length) {
    return null;
  }

  return MediaThumbnailLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, MediaThumbnailLine_jsx(LineTitle["a" /* LineTitle */], null, title), MediaThumbnailLine_jsx("div", {
    className: "sm:flex -m-px10"
  }, columns.map(function (col, idx) {
    return MediaThumbnailLine_jsx("div", {
      className: "p-px10 sm:w-1/3",
      key: idx
    }, MediaThumbnailLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards_utils_mapColToCard(MediaThumbnailLine_objectSpread({}, col)), {
      className: "h-full",
      displayLoadMore: displayLoadMore,
      layout: Card_constants["b" /* COLUMN_2 */],
      theme: "thumbnail"
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/media-thumbnail/mediaThumbnail.descriptor.js


var mediaThumbnailDescriptor = {
  name: constants["x" /* MEDIA_THUMBNAIL */],
  component: MediaThumbnailLine_MediaThumbnailLine
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/navigation-tab/navigationTab.descriptor.js
var navigationTab_descriptor_jsx = react_default.a.createElement;



var navigationTabDescriptor = {
  name: constants["z" /* NAVIGATION_TAB */],
  component: function component(props) {
    return navigationTab_descriptor_jsx(Line, {
      props: props
    });
  }
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-stickynode/dist/Sticky.js
var Sticky = __webpack_require__("Phb7");
var Sticky_default = /*#__PURE__*/__webpack_require__.n(Sticky);

// EXTERNAL MODULE: ./src/client/components/utils/tabs/tabs.hoc.jsx
var tabs_hoc = __webpack_require__("lW4u");

// EXTERNAL MODULE: ./src/utils/keyCodes.js
var keyCodes = __webpack_require__("05v4");

// CONCATENATED MODULE: ./src/client/components/widgets/navigation-tabs/header/NavigationTabsHeader.jsx



var NavigationTabsHeader_jsx = react_default.a.createElement;




function NavigationTabsHeader(props) {
  var _classnames;

  var children = props.children,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].BLUE : _props$color,
      controlsId = props.controlsId,
      id = props.id,
      isActive = props.isActive,
      _props$isNewTabs = props.isNewTabs,
      isNewTabs = _props$isNewTabs === void 0 ? false : _props$isNewTabs,
      onClick = props.onClick,
      trackingData = props.trackingData;
  return NavigationTabsHeader_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({
    "aria-controls": controlsId,
    "aria-selected": isActive,
    as: "button",
    className: classnames_default()(className, 'cursor-pointer text-base transition-colors', "focus:bg-".concat(color, " focus:text-white hover:bg-").concat(color, " ").concat(isNewTabs ? 'p-px5 h-navigation-tabs-sm' : 'p-px10 h-navigation-tabs', " hover:text-white"), (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(color, " text-white ").concat(isNewTabs ? 'arrow-down-top arrow-small arrow-white lg:arrow-none font-bold' : ''), isActive), Object(defineProperty["a" /* default */])(_classnames, 'bg-white text-gray-darker', !isActive), _classnames)),
    id: id,
    onClick: onClick,
    role: "tab",
    style: {
      minWidth: '7.5rem'
    },
    tabIndex: isActive ? 0 : -1
  }, trackingData ? {
    trackingData: trackingData
  } : null), children);
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation-tabs/NavigationTabs.utils.js
function getClassNames(length) {
  switch (length) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      return 'w-auto flex-none sm:flex-1';

    case 6:
      return 'w-auto flex-none sm:w-1/5 md:w-auto md:flex-1';

    case 7:
      return 'w-auto flex-none sm:w-1/5 md:w-1/6 lg:w-auto lg:flex-1';

    default:
      return 'w-auto flex-none sm:w-1/5 md:w-1/6 lg:w-1/8';
  }
}
// CONCATENATED MODULE: ./src/client/components/widgets/navigation-tabs/NavigationTabs.jsx













var NavigationTabs_jsx = react_default.a.createElement;

function NavigationTabs_createSuper(Derived) { var hasNativeReflectConstruct = NavigationTabs_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function NavigationTabs_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }














var NavigationTabs_NavigationTabs = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(_NavigationTabs, _Component);

  var _super = NavigationTabs_createSuper(_NavigationTabs);

  function _NavigationTabs(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _NavigationTabs);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "refsArray", void 0);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "onKeyDown", function (event) {
      var items = _this.props.items;

      if (items.length > 1) {
        _this.setState(function (_ref) {
          var index = _ref.index;

          switch (event.which) {
            case keyCodes["c" /* ARROW_RIGHT */]:
            case keyCodes["a" /* ARROW_DOWN */]:
              event.preventDefault();
              return {
                index: index === items.length - 1 ? 0 : index + 1
              };

            case keyCodes["b" /* ARROW_LEFT */]:
            case keyCodes["d" /* ARROW_UP */]:
              event.preventDefault();
              return {
                index: index === 0 ? items.length - 1 : index - 1
              };

            case keyCodes["h" /* HOME */]:
              event.preventDefault();
              return {
                index: 0
              };

            case keyCodes["e" /* END */]:
              event.preventDefault();
              return {
                index: items.length - 1
              };

            default:
          }
        }, function () {
          return _this.refsArray[_this.state.index] && _this.refsArray[_this.state.index].firstChild.focus();
        });
      }
    });

    _this.refsArray = [];
    _this.state = {
      index: props.initialSelectedItem,
      initialOffsetLeft: 0
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_NavigationTabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.initialSelectedItem !== this.props.initialSelectedItem) {
        var initialSelectedItem = this.props.initialSelectedItem || 0;
        this.setState({
          index: initialSelectedItem,
          initialOffsetLeft: this.getInitialOffsetLeft(initialSelectedItem)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        initialOffsetLeft: this.getInitialOffsetLeft(this.props.initialSelectedItem)
      });

      if (this.refsArray.length) {
        // $FlowFixMe
        this.refsArray.forEach(function (ref) {
          return ref.addEventListener('keydown', _this2.onKeyDown, false);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this.refsArray.length) {
        // $FlowFixMe
        this.refsArray.forEach(function (ref) {
          return ref.removeEventListener('keydown', _this3.onKeyDown, false);
        });
      }
    }
  }, {
    key: "getInitialOffsetLeft",
    value: function getInitialOffsetLeft() {
      var initialSelectedItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var ref = this.refsArray[initialSelectedItem];
      return ref ? ref.offsetLeft : 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          className = _this$props.className,
          _this$props$id = _this$props.id,
          mainId = _this$props$id === void 0 ? 'NavigationTabs' : _this$props$id,
          items = _this$props.items,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!items.length) {
        return null;
      }

      var _this$state = this.state,
          index = _this$state.index,
          initialOffsetLeft = _this$state.initialOffsetLeft;
      var isNewTabs = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(this.context)('displayNewTabs');
      var activeItem = items[index] || {};
      var activeColor = activeItem.color || colors["a" /* COLORS */].BLUE;
      var content = items.map(function (_ref2, idx) {
        var color = _ref2.color,
            id = _ref2.id,
            title = _ref2.title,
            trackingData = _ref2.trackingData;
        return NavigationTabs_jsx("div", {
          className: classnames_default()(isNewTabs ? 'border-gray-dark leading-one' : 'border-gray-light', getClassNames(items.length), {
            'rtl:border-l-1': idx !== 0
          }),
          key: id || title,
          ref: function ref(_ref3) {
            _this4.refsArray[idx] = _ref3;
          }
        }, NavigationTabs_jsx(NavigationTabsHeader, {
          className: "w-full",
          color: color,
          controlsId: "".concat(id, "-tab"),
          id: id,
          isActive: idx === index,
          isNewTabs: isNewTabs,
          onClick: function onClick() {
            _this4.setState({
              index: idx
            }, function () {
              Object(scrollToElement["a" /* scrollToElement */])("#".concat(mainId), 100); // $FlowFixMe

              _this4.refsArray[idx].firstChild.focus();
            });
          },
          trackingData: trackingData
        }, title));
      });
      return NavigationTabs_jsx("div", {
        className: classnames_default()(className, {
          'lg:-mt-px20': isNewTabs
        }),
        id: mainId
      }, NavigationTabs_jsx(Sticky_default.a, {
        bottomBoundary: "#NavigationTabsBeacon",
        innerZ: 5
      }, NavigationTabs_jsx("div", {
        className: classnames_default()('px-px20', {
          'lg:pt-px20': isNewTabs
        })
      }, NavigationTabs_jsx("div", {
        className: isNewTabs ? 'rounded-small border border-gray-light overflow-hidden lg:max-w-site lg:m-auto shadow-diffuse' : "bg-white border-b-2 border-".concat(activeColor, " lg:max-w-site lg:m-auto shadow-lg")
      }, NavigationTabs_jsx(Scrollable["a" /* Scrollable */], {
        backwardLabel: scrollBackwardLabel,
        forwardLabel: scrollForwardLabel,
        forceDisplayControls: isNewTabs,
        hasShadow: !isNewTabs,
        initialScrollLeft: initialOffsetLeft,
        theme: isNewTabs ? 'nav' : 'default',
        navPosition: "center"
      }, NavigationTabs_jsx("div", {
        className: "bg-white flex",
        role: "tablist"
      }, content))))), NavigationTabs_jsx("div", {
        "aria-labelledby": activeItem.id,
        className: "outline-none py-px20",
        id: "".concat(activeItem.id, "-tab"),
        role: "tabpanel"
      }, activeItem.content), NavigationTabs_jsx("div", {
        id: "NavigationTabsBeacon"
      }));
    }
  }]);

  return _NavigationTabs;
}(react["Component"]);

Object(defineProperty["a" /* default */])(NavigationTabs_NavigationTabs, "defaultProps", {
  initialSelectedItem: 0,
  items: []
});

Object(defineProperty["a" /* default */])(NavigationTabs_NavigationTabs, "contextType", ReactAppContext["b" /* default */]);

var NavigationTabs = Object(tabs_hoc["a" /* withOpenAndScrollToHash */])(NavigationTabs_NavigationTabs);
// CONCATENATED MODULE: ./src/client/components/lines/navigation-tabs-line/NavigationTabsLine.jsx

var NavigationTabsLine_jsx = react_default.a.createElement;





function NavigationTabsLine(_ref) {
  var _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? [] : _ref$lines;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  var items = lines.map(function (line) {
    var _line$props = line.props,
        id = _line$props.id,
        isExclusiveCollection = _line$props.isExclusiveCollection,
        title = _line$props.title,
        tabLines = _line$props.lines;
    return {
      id: id,
      color: isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE,
      title: title,
      content: tabLines.map(Line),
      trackingData: {
        categoryGA: pageType,
        actionGA: 'blockInfos',
        labelGA: id || 'productInfos'
      }
    };
  });

  if (!items.length) {
    return null;
  }

  return items.length > 1 ? NavigationTabsLine_jsx(NavigationTabs, {
    className: "Line",
    items: items,
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }) : items[0].content;
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/navigation-tabs/navigationTabs.resolver.js
var navigationTabs_resolver = __webpack_require__("v78B");

// CONCATENATED MODULE: ./src/client/cms/toolkit/navigation-tabs/navigationTabs.descriptor.js



var navigationTabsDescriptor = {
  name: constants["A" /* NAVIGATION_TABS */],
  component: NavigationTabsLine,
  resolve: navigationTabs_resolver["a" /* navigationTabsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/utils/string/string.util.js
var string_util = __webpack_require__("tX1K");

// CONCATENATED MODULE: ./src/client/components/widgets/offers-grid/OffersGrid.jsx





var OffersGrid_jsx = react_default.a.createElement;








var OffersGrid_OffersGrid = function OffersGrid(_ref) {
  var _ref$offers = _ref.offers,
      offers = _ref$offers === void 0 ? [] : _ref$offers,
      _ref$textLimit = _ref.textLimit,
      textLimit = _ref$textLimit === void 0 ? 250 : _ref$textLimit;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!offers.length) {
    return null;
  }

  return OffersGrid_jsx("section", {
    className: "sm:flex flex-wrap"
  }, offers.map(function () {
    var offer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _offer$color = offer.color,
        color = _offer$color === void 0 ? 'black' : _offer$color,
        commercialArgument = offer.commercialArgument,
        _offer$description = offer.description,
        description = _offer$description === void 0 ? '' : _offer$description,
        href = offer.href,
        id = offer.id,
        image = offer.image,
        _offer$name = offer.name,
        name = _offer$name === void 0 ? '' : _offer$name;
    var truncatedText = textLimit > 0 ? Object(string_util["d" /* truncate */])(description, textLimit) : description;
    var classNames = isTablet ? 'decorator-border-grid pt-px30 px-px10 pb-px50 w-1/2' : 'decorator-border-bottom-list py-px20';
    return OffersGrid_jsx("div", {
      className: classNames,
      key: id
    }, OffersGrid_jsx("div", {
      className: "m-auto",
      style: {
        maxWidth: '23.75rem'
      }
    }, OffersGrid_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({
      ctaLabel: name,
      customMedia: image ? OffersGrid_jsx(DynamicLink["a" /* default */], {
        className: "block leading-none m-0 no-underline",
        "data-testid": "OffersGrid-captionLink",
        url: href
      }, OffersGrid_jsx(Image["b" /* default */], {
        className: "w-7/10",
        imageUrl: image,
        dimensions: {
          w: 250,
          h: 250 * ratios_utils["a" /* default */].VALUES[ratios_utils["a" /* default */].S]
        }
      }), OffersGrid_jsx("span", {
        className: "flex font-bold items-center leading-one no-underline p-px5 text-center text-lg text-white uppercase w-3/10",
        "data-testid": "OffersGrid-captionLink-caption",
        style: {
          backgroundColor: color,
          wordWrap: 'break-word'
        }
      }, commercialArgument)) : null,
      heading: {
        title: name
      }
    }, id ? {
      id: id
    } : null, {
      layout: Card_constants["a" /* COLUMN_1 */],
      link: {
        url: href
      },
      text: {
        text: truncatedText
      }
    }))));
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-grid-line/OffersGridLine.jsx
var OffersGridLine_jsx = react_default.a.createElement;




var OffersGridLine_OffersGridLine = function OffersGridLine(_ref) {
  var id = _ref.id,
      offers = _ref.offers,
      title = _ref.title;

  if (!offers.length) {
    return null;
  }

  return OffersGridLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, OffersGridLine_jsx(LineTitle["a" /* LineTitle */], null, title), OffersGridLine_jsx(OffersGrid_OffersGrid, {
    offers: offers
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/offers-grid/offersGrid.resolver.js
var offersGrid_resolver = __webpack_require__("xXeT");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offers-grid/offersGrid.descriptor.js



var offersGridDescriptor = {
  name: constants["B" /* OFFERS_GRID */],
  component: OffersGridLine_OffersGridLine,
  resolve: offersGrid_resolver["a" /* offersGridResolver */].resolve
};
// EXTERNAL MODULE: /opt/webapp/node_modules/react-collapse/lib/index.js
var react_collapse_lib = __webpack_require__("3OwS");

// CONCATENATED MODULE: ./src/client/components/widgets/offers-push/OfferPush.themes.js



var OfferPush_themes_themes = {
  "default": function _default(_ref) {
    var titleColor = _ref.titleColor,
        subtitleColor = _ref.subtitleColor;
    return {
      thRoot: 'bg-gray-darker h-full overflow-hidden relative rounded-tiny',
      thHeader: 'flex absolute justify-center mt-px20 text-center top-0 w-full',
      thImage: 'opacity-75 transition-transform-opacity hover:scale-105',
      thHeaderItem: function thHeaderItem(_ref2) {
        var _classnames;

        var _ref2$textColor = _ref2.textColor,
            textColor = _ref2$textColor === void 0 ? colors["a" /* COLORS */].WHITE : _ref2$textColor,
            _ref2$backgroundColor = _ref2.backgroundColor,
            backgroundColor = _ref2$backgroundColor === void 0 ? colors["a" /* COLORS */].BLACK : _ref2$backgroundColor;
        return classnames_default()('font-brand font-normal leading-one max-w-1/2 m-0 mx-px5 p-px10 rounded-tiny text-xs', (_classnames = {}, Object(defineProperty["a" /* default */])(_classnames, "text-".concat(textColor), true), Object(defineProperty["a" /* default */])(_classnames, "bg-".concat(backgroundColor), true), _classnames));
      },
      thTitle: classnames_default()('font-bold leading-tight mb-px10 reset-heading text-2xl text-center', Object(defineProperty["a" /* default */])({}, "text-".concat(titleColor || colors["a" /* COLORS */].WHITE), true)),
      thSubTitle: classnames_default()('m-0 pb-px15 text-center text-md', Object(defineProperty["a" /* default */])({}, "text-".concat(subtitleColor || colors["a" /* COLORS */].WHITE), true)),
      thFooter: 'absolute bottom-0 p-px10 pb-px20 transition-transform w-full'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/widgets/offers-push/OfferPush.jsx










var OfferPush_jsx = react_default.a.createElement;

function OfferPush_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function OfferPush_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OfferPush_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OfferPush_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var OfferPush_OfferPush = function OfferPush(_ref) {
  var _tag$, _tag$2;

  var countdown = _ref.countdown,
      id = _ref.id,
      link = _ref.link,
      mediaUrl = _ref.mediaUrl,
      subTitle = _ref.subTitle,
      tag = _ref.tag,
      _ref$theming = _ref.theming,
      titleColor = _ref$theming.titleColor,
      subtitleColor = _ref$theming.subtitleColor,
      title = _ref.title;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var _themes$default = OfferPush_themes_themes.default({
    titleColor: titleColor,
    subtitleColor: subtitleColor,
    isHover: isHover
  }),
      thRoot = _themes$default.thRoot,
      thImage = _themes$default.thImage,
      thHeader = _themes$default.thHeader,
      thHeaderItem = _themes$default.thHeaderItem,
      thTitle = _themes$default.thTitle,
      thFooter = _themes$default.thFooter,
      thSubTitle = _themes$default.thSubTitle;

  var trackingData = OfferPush_objectSpread(OfferPush_objectSpread({}, tracking_constants["i" /* GA_DEFAULT_PAYLOAD */]), {}, {
    actionGA: tracking_constants["k" /* OFFER_PUSH */].ACTION,
    labelGA: "".concat(title, "-").concat(id)
  });

  var shouldDisplayOffer = !countdown.dateTimeEnd && ((_tag$ = tag[1]) === null || _tag$ === void 0 ? void 0 : _tag$.text);
  var shouldDisplayCountdown = countdown.dateTimeEnd;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  return OfferPush_jsx("article", {
    className: thRoot,
    "data-testid": "offer-push-container",
    dir: isRTL ? 'rtl' : 'ltr'
  }, OfferPush_jsx(TrackClick["a" /* TrackClick */], {
    className: "block relative overflow-hidden h-full",
    as: DynamicLink["a" /* default */],
    "data-testid": "offer-push-".concat(id, "-link"),
    onBlur: function onBlur() {
      return setHover(false);
    },
    onFocus: function onFocus() {
      return setHover(true);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    trackingData: trackingData,
    url: link
  }, OfferPush_jsx(Image["b" /* default */], {
    altMsg: title,
    className: thImage,
    groupKey: "offers-push",
    hasLazyLoading: true,
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["a" /* default */].XL
  }), OfferPush_jsx("span", {
    className: thHeader
  }, ((_tag$2 = tag[0]) === null || _tag$2 === void 0 ? void 0 : _tag$2.text) && OfferPush_jsx("p", {
    className: thHeaderItem(tag[0].theming, true),
    "data-testid": "offer-push-".concat(id, "-tag-first")
  }, OfferPush_jsx("span", {
    className: "block -mb-px truncate"
  }, tag[0].text.toUpperCase())), shouldDisplayCountdown && OfferPush_jsx(Countdown["a" /* Countdown */], {
    bgColor: countdown.backgroundColor,
    className: "leading-one mx-px5 py-px5",
    color: countdown.textColor,
    dataTestId: "offer-push-".concat(id, "-countdown"),
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds,
    theme: "offerPush"
  }), shouldDisplayOffer && OfferPush_jsx("p", {
    className: thHeaderItem(tag[1].theming, false),
    "data-testid": "offer-push-".concat(id, "-tag-second")
  }, OfferPush_jsx("span", {
    className: "block -mb-px truncate"
  }, tag[1].text.toUpperCase()))), OfferPush_jsx("div", {
    className: thFooter
  }, title && OfferPush_jsx("h3", {
    className: thTitle,
    "data-testid": "offer-push-".concat(id, "-title")
  }, title), subTitle && OfferPush_jsx(react_collapse_lib["Collapse"], {
    isOpened: isHover
  }, OfferPush_jsx("p", {
    className: thSubTitle,
    "data-testid": "offer-push-".concat(id, "-subtitle")
  }, Object(string_util["d" /* truncate */])(subTitle, 115))))));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLineNarrow.jsx


var OffersPushLineNarrow_jsx = react_default.a.createElement;








var OffersPushLineNarrow_OffersPushLineNarrow = function OffersPushLineNarrow(_ref) {
  var title = _ref.title,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLink = _ref.seeMoreLink,
      columns = _ref.columns;
  return OffersPushLineNarrow_jsx(react["Fragment"], null, !!title && OffersPushLineNarrow_jsx(LineTitle["a" /* LineTitle */], null, title), OffersPushLineNarrow_jsx("div", {
    className: "-mx-px20 lg:mx-0 w-screen lg:w-full"
  }, OffersPushLineNarrow_jsx(Slider["a" /* Slider */], {
    cols: 0,
    hasControls: false,
    navPosition: "center",
    nbItemsToScroll: 1,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory"
  }, columns.map(function (columnProps, index) {
    return OffersPushLineNarrow_jsx("div", {
      className: classnames_default()('flex-1 sm:w-1/3 rtl:ml-px20', {
        'lg:rtl:ml-0': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      },
      key: index
    }, OffersPushLineNarrow_jsx(OfferPush_OfferPush, Object(esm_extends["a" /* default */])({}, columnProps, {
      id: index + 1
    })));
  }), OffersPushLineNarrow_jsx("div", {
    style: {
      width: '20px',
      height: '1px',
      flexShrink: '0'
    },
    className: "lg:hidden rtl:-order-1"
  }))), seeMoreLabel && seeMoreLink && OffersPushLineNarrow_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    url: seeMoreLink,
    className: "block mx-auto mt-px15 text-center text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'main_push_offers',
      labelGA: 'seeMore'
    }
  }, seeMoreLabel));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLineLarge.jsx


var OffersPushLineLarge_jsx = react_default.a.createElement;









var OffersPushLineLarge_OffersPushLineLarge = function OffersPushLineLarge(_ref) {
  var title = _ref.title,
      seeMoreLabel = _ref.seeMoreLabel,
      seeMoreLink = _ref.seeMoreLink,
      columns = _ref.columns;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return OffersPushLineLarge_jsx(react["Fragment"], null, OffersPushLineLarge_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, title && OffersPushLineLarge_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), seeMoreLabel && seeMoreLink && OffersPushLineLarge_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-px20 md:mt-px5 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'main_push_offers',
      labelGA: 'seeMore'
    },
    url: seeMoreLink
  }, seeMoreLabel)), OffersPushLineLarge_jsx("div", {
    className: "-mx-px20 lg:mx-0 w-screen lg:w-full"
  }, OffersPushLineLarge_jsx(Slider["a" /* Slider */], {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: 2,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto lg:overflow-hidden",
    scrollControlsClassName: "-mx-px20 lg:mx-0"
  }, columns.map(function (column, index) {
    return OffersPushLineLarge_jsx("div", {
      className: classnames_default()('flex-1 sm:w-1/3 rtl:ml-px20 h-full', {
        'lg:rtl:ml-0': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      },
      key: index
    }, OffersPushLineLarge_jsx(OfferPush_OfferPush, Object(esm_extends["a" /* default */])({}, column, {
      id: index + 1
    })));
  }), OffersPushLineLarge_jsx("div", {
    style: {
      width: '20px',
      height: '1px',
      flexShrink: '0'
    },
    className: "lg:hidden rtl:-order-1"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/offers-push-line/OffersPushLine.jsx
var OffersPushLine_jsx = react_default.a.createElement;





var OffersPushLine_OffersPushLine = function OffersPushLine(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return OffersPushLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: props.id
  }, isTablet ? OffersPushLine_jsx(OffersPushLineLarge_OffersPushLineLarge, props) : OffersPushLine_jsx(OffersPushLineNarrow_OffersPushLineNarrow, props));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/offers-push/offersPush.descriptor.js


var offersPushDescriptor = {
  name: constants["C" /* OFFERS_PUSH */],
  component: OffersPushLine_OffersPushLine
};
// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__("zygG");

// EXTERNAL MODULE: ./src/utils/ple-utils/index.js + 1 modules
var ple_utils = __webpack_require__("6jSF");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormLogin.jsx


var PrebookingFormLogin_jsx = react_default.a.createElement;








var PrebookingFormLogin_PrebookingFormLogin = function PrebookingFormLogin(props) {
  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      locale = _useContext.locale;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  if (!props.hasLoginButton || props.hasSeller || props.hasUser) {
    return null;
  }

  return PrebookingFormLogin_jsx("div", {
    className: "flex flex-wrap lg:w-4/5 lg:mx-auto"
  }, PrebookingFormLogin_jsx("div", {
    className: "my-px10 px-px10 w-full md:w-2/3"
  }, PrebookingFormLogin_jsx("p", {
    className: "w-full my-0 text-base"
  }, Object(src_i18n["h" /* t */])('prebookingForm.login.memberSpace'))), PrebookingFormLogin_jsx("div", {
    className: "flex items-center justify-center my-px10 px-px10 w-full md:w-1/3"
  }, PrebookingFormLogin_jsx(Button["a" /* Button */], {
    dataTestId: "prebooking-form-login",
    iconLeft: {
      name: icons["a" /* ICONS */].USER
    },
    trackingData: {
      categoryGA: 'prebooking-form',
      actionGA: 'logIn',
      labelGA: 'logIn'
    },
    url: ple_utils["f" /* buildSigninUrl */]({
      locale: locale,
      redirectUri: Object(uriUtils["c" /* convertLocationToURI */])(location).toString()
    }),
    isExternalLink: true
  }, Object(src_i18n["h" /* t */])('prebookingForm.login.labelCTA'))), PrebookingFormLogin_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-px15 mx-0 p-0"
  }));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: ./src/client/store/prebooking-form/prebookingform.action.js + 1 modules
var prebookingform_action = __webpack_require__("ZP80");

// EXTERNAL MODULE: ./src/client/store/calendar/calendar.helper.js
var calendar_helper = __webpack_require__("VtPb");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.constants.js
var ADULTS = 'adults';
var KIDS = 'kids';
var COMPANION_GROUPS = {
  ADULTS: ADULTS,
  KIDS: KIDS
};
var MAX_FORM_ADULTS = 10;
var MAX_FORM_KIDS = 10;
var MIN_FORM_ADULTS = 1;
var MIN_FORM_KIDS = 0;
var MAX_COMPANIONS = 7;
// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/index.js
var tracking_api = __webpack_require__("d1HQ");

// EXTERNAL MODULE: ./src/utils/regex/RegexHelper.js
var RegexHelper = __webpack_require__("9BC+");

// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.utils.js



















function PrebookingForm_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function PrebookingForm_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      PrebookingForm_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      PrebookingForm_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}













 // Map Traveler in User Context

var PrebookingForm_utils_getDateTimestamp = function getDateTimestamp(birthdate) {
  return moment_default()(birthdate).valueOf();
};

var getFormUser = function getFormUser(user) {
  var _user$civility = user.civility,
      civility = _user$civility === void 0 ? '' : _user$civility,
      dateOfBirth = user.dateOfBirth,
      _user$email = user.email,
      email = _user$email === void 0 ? '' : _user$email,
      _user$firstName = user.firstName,
      firstName = _user$firstName === void 0 ? '' : _user$firstName,
      _user$GMNumber = user.GMNumber,
      GMNumber = _user$GMNumber === void 0 ? '' : _user$GMNumber,
      _user$lastName = user.lastName,
      lastName = _user$lastName === void 0 ? '' : _user$lastName,
      _user$mobilePhoneNumb = user.mobilePhoneNumber,
      mobilePhoneNumber = _user$mobilePhoneNumb === void 0 ? '' : _user$mobilePhoneNumb,
      unicodeFirstName = user.unicodeFirstName,
      unicodeLastName = user.unicodeLastName;
  return {
    civility: civility,
    birthdate: dateOfBirth ? PrebookingForm_utils_getDateTimestamp(dateOfBirth) : null,
    email: email,
    firstName: firstName,
    firstNameUnicode: unicodeFirstName,
    memberNumber: GMNumber,
    lastName: lastName,
    lastNameUnicode: unicodeLastName,
    phone: mobilePhoneNumber
  };
};
var getFormOptins = function getFormOptins(optins) {
  var _ref = optins || {},
      _ref$optinEmail = _ref.optinEmail,
      optinEmail = _ref$optinEmail === void 0 ? false : _ref$optinEmail,
      _ref$optinPhone = _ref.optinPhone,
      optinPhone = _ref$optinPhone === void 0 ? false : _ref$optinPhone,
      _ref$optinSms = _ref.optinSms,
      optinSms = _ref$optinSms === void 0 ? false : _ref$optinSms;

  return {
    optinEmail: optinEmail,
    optinPhone: optinPhone,
    optinSms: optinSms
  };
}; // Map Traveler and Companions in CXO/Seller Context

var getFormTraveler = function getFormTraveler(traveler) {
  var _ref2 = traveler || {},
      birthdate = _ref2.birthdate,
      civility = _ref2.civility,
      email = _ref2.email,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName,
      gmNumber = _ref2.gmNumber,
      mobile = _ref2.mobile,
      unicodeFirstName = _ref2.unicodeFirstName,
      unicodeLastName = _ref2.unicodeLastName;

  return {
    birthdate: birthdate || null,
    civility: civility || '',
    email: email || '',
    firstName: firstName || '',
    firstNameUnicode: unicodeFirstName || '',
    lastName: lastName || '',
    lastNameUnicode: unicodeLastName || '',
    memberNumber: gmNumber || '',
    phone: mobile || ''
  };
};

var getFormCompanion = function getFormCompanion(companion) {
  return {
    birthdate: companion.birthdate || null,
    civility: typeof companion.civility !== 'string' ? '' : companion.civility,
    firstName: companion.firstName || '',
    lastName: companion.lastName || ''
  };
};

var PrebookingForm_utils_getFormTravelerAndCompanions = function getFormTravelerAndCompanions(_ref3) {
  var adults = _ref3.adults,
      kids = _ref3.kids;
  var formTraveler = adults.length > 0 ? getFormTraveler(adults[0]) : getFormTraveler(null);
  var adultCompanions = adults.slice(1);
  var formKids = kids.map(getFormCompanion);
  var formAdults = adultCompanions.map(getFormCompanion);
  return PrebookingForm_utils_objectSpread({
    traveler: formTraveler,
    adultsNumber: (formAdults.length + MIN_FORM_ADULTS).toString(),
    kidsNumber: formKids.length.toString(),
    adults: formAdults,
    kids: formKids
  }, adults.length > 0 ? getFormOptins(adults[0]) : getFormOptins(null));
}; // Initialize Form

var PrebookingForm_utils_getInitialFormValues = function getInitialFormValues(agency) {
  return {
    accommodation: '',
    accommodationCategory: '',
    adults: [],
    adultsNumber: MIN_FORM_ADULTS.toString(),
    agency: agency || '',
    departureCity: '',
    departureDate: {
      from: null,
      to: null
    },
    duration: '',
    kids: [],
    kidsNumber: MIN_FORM_KIDS.toString(),
    optinEmail: false,
    optinPhone: false,
    optinSms: false,
    productId: '',
    traveler: {
      birthdate: null,
      civility: '',
      email: '',
      firstName: '',
      lastName: '',
      memberNumber: '',
      phone: ''
    }
  };
}; // Set Form Schema
// Birthdate from 1920

var minBirthdateTimestamp = moment_default()('1920-01-01').valueOf(); // Birthdate less than 18 years old

var kidBirthdateTimestamp = moment_default()().subtract(18, 'years').valueOf();
var adultBirthdateSchema = lib["number"]().min(minBirthdateTimestamp).max(kidBirthdateTimestamp).nullable();
var getAdultBirthdateValidator = function getAdultBirthdateValidator() {
  return adultBirthdateSchema;
};
var PrebookingForm_utils_getKidFutureBithdateValidator = function getKidFutureBithdateValidator() {
  return lib["number"]().test('', '', function (value) {
    var context = this.options.context;

    if (value && (context === null || context === void 0 ? void 0 : context.values.departureDate.from)) {
      var departureDate = moment_default()(context === null || context === void 0 ? void 0 : context.values.departureDate.from).startOf('day');
      var kidBirthdate = moment_default()(value).startOf('day');
      return kidBirthdate.isBefore(departureDate);
    }

    return false;
  });
};
var PrebookingForm_utils_getFormSchema = function getFormSchema(t, _ref4) {
  var agencies = _ref4.agencies,
      civilities = _ref4.civilities,
      locale = _ref4.locale,
      productIds = _ref4.productIds;
  var agencySchema = lib["mixed"]().oneOf(agencies).required();
  var fistNameSchema = lib["string"]().required(t('prebookingForm.mainTraveler.firstNamePlaceholder')).max(20, t('prebookingForm.mainTraveler.firstNamePlaceholder'));
  var lastNameSchema = lib["string"]().required(t('prebookingForm.mainTraveler.firstNamePlaceholder')).max(30, t('prebookingForm.mainTraveler.firstNamePlaceholder'));
  var adultCivilities = civilities.adults.map(function (civility) {
    return civility.value;
  });
  var kidCivilities = civilities.kids.map(function (civility) {
    return civility.value;
  });
  var adultCompanionSchema = lib["object"]().shape({
    civility: lib["mixed"]().oneOf(adultCivilities).required(),
    birthdate: adultBirthdateSchema,
    firstName: fistNameSchema,
    lastName: lastNameSchema
  });
  var kidCompanionSchema = lib["object"]().shape({
    civility: lib["mixed"]().oneOf(kidCivilities),
    birthdate: lib["number"]().min(kidBirthdateTimestamp).nullable().required(),
    firstName: fistNameSchema,
    lastName: lastNameSchema
  });
  var travelerSchema = lib["object"]().shape({
    birthdate: adultBirthdateSchema,
    civility: lib["mixed"]().oneOf(adultCivilities).required(),
    email: lib["string"]().email(t('prebookingForm.mainTraveler.emailPlaceholder')).required(t('prebookingForm.mainTraveler.emailPlaceholder')),
    firstName: fistNameSchema,
    lastName: lastNameSchema,
    memberNumber: lib["string"]().matches(CommonValidators["a" /* GM_NUMBER_PATTERN */]),
    phone: lib["string"]().required(t('prebookingForm.mainTraveler.phonePlaceholder')).matches(Object(RegexHelper["b" /* getPhoneRegex */])(locale), {
      excludeEmptyString: true,
      message: t('prebookingForm.mainTraveler.phonePlaceholder')
    })
  });
  return lib["object"]().shape(PrebookingForm_utils_objectSpread(PrebookingForm_utils_objectSpread({
    accommodation: lib["string"](),
    accommodationCategory: lib["string"]().required(),
    adults: lib["array"]().min(MIN_FORM_ADULTS - 1).max(MAX_FORM_ADULTS - 1).of(adultCompanionSchema),
    adultsNumber: lib["string"]().required()
  }, agencies.length ? {
    agency: agencySchema
  } : null), {}, {
    departureCity: lib["string"]().required(),
    departureDate: lib["object"]().shape({
      from: lib["date"](),
      to: lib["date"]().nullable()
    }).required(),
    duration: lib["string"]().required().matches(/^[0-9]{1,2}$/),
    // 1 or 2 digits
    kids: lib["array"]().min(MIN_FORM_KIDS).max(MAX_FORM_KIDS).of(kidCompanionSchema),
    kidsNumber: lib["string"]().required(),
    optinEmail: lib["boolean"](),
    optinPhone: lib["boolean"](),
    optinSms: lib["boolean"](),
    productId: lib["mixed"]().oneOf(productIds).required(),
    traveler: travelerSchema
  }));
}; // Submit prebooking form

var PrebookingForm_utils_formatDate = function formatDate(date) {
  return Object(date_apiDate["j" /* momentToApiDate */])(moment_default()(date));
};

var getCompanionQuery = function getCompanionQuery(companion) {
  var birthdate = companion.birthdate,
      civility = companion.civility,
      firstName = companion.firstName,
      _companion$firstNameU = companion.firstNameUnicode,
      firstNameUnicode = _companion$firstNameU === void 0 ? '' : _companion$firstNameU,
      lastName = companion.lastName,
      _companion$lastNameUn = companion.lastNameUnicode,
      lastNameUnicode = _companion$lastNameUn === void 0 ? '' : _companion$lastNameUn;
  return "{\n    ".concat(birthdate ? "birthdate: \"".concat(PrebookingForm_utils_formatDate(birthdate), "\"") : '', "\n    civility: \"").concat(civility, "\"\n    lastName: \"").concat(lastName, "\"\n    unicodeLastName: \"").concat(lastNameUnicode, "\"\n    firstName: \"").concat(firstName, "\"\n    unicodeFirstName: \"").concat(firstNameUnicode, "\"\n  }");
};

var getCompanionsQuery = function getCompanionsQuery(companions) {
  return companions.reduce(function (acc, companion) {
    return "".concat(acc).concat(getCompanionQuery(companion));
  }, '');
};

var PrebookingForm_utils_getPrebookingFormQuery = function getPrebookingFormQuery(values, cxoId, appContext) {
  var accommodation = values.accommodation,
      accommodationCategory = values.accommodationCategory,
      adults = values.adults,
      agency = values.agency,
      departureCity = values.departureCity,
      departureDate = values.departureDate,
      duration = values.duration,
      kids = values.kids,
      optinEmail = values.optinEmail,
      optinPhone = values.optinPhone,
      optinSms = values.optinSms,
      productId = values.productId,
      traveler = values.traveler;
  var birthdate = traveler.birthdate,
      civility = traveler.civility,
      email = traveler.email,
      firstName = traveler.firstName,
      _traveler$firstNameUn = traveler.firstNameUnicode,
      firstNameUnicode = _traveler$firstNameUn === void 0 ? '' : _traveler$firstNameUn,
      lastName = traveler.lastName,
      _traveler$lastNameUni = traveler.lastNameUnicode,
      lastNameUnicode = _traveler$lastNameUni === void 0 ? '' : _traveler$lastNameUni,
      _traveler$memberNumbe = traveler.memberNumber,
      memberNumber = _traveler$memberNumbe === void 0 ? '' : _traveler$memberNumbe,
      phone = traveler.phone;
  return "mutation {\n    prebooking(\n      productId: \"".concat(productId, "\"\n      departureCity: \"").concat(departureCity, "\"\n      departureDate: \"").concat(PrebookingForm_utils_formatDate(departureDate.from || Date.now()), "\"\n      duration: ").concat(parseInt(duration, 10), "\n      accommodation: ").concat(accommodation ? "\"".concat(accommodation, "\"") : 'null', "\n      accommodationCategory: \"").concat(accommodationCategory, "\"\n      agency: ").concat(agency ? "\"".concat(agency, "\"") : 'null', "\n      ").concat(Object(sellerUtils["g" /* isSeller */])(appContext) && cxoId ? "agentId : \"".concat(Object(sellerUtils["a" /* decryptHeptaSeller */])(cxoId), "\"") : '', "\n      mainContact: {\n        gmNumber: \"").concat(memberNumber, "\"\n        civility: \"").concat(civility, "\"\n        lastName: \"").concat(lastName, "\"\n        unicodeLastName: \"").concat(lastNameUnicode, "\"\n        firstName: \"").concat(firstName, "\"\n        unicodeFirstName: \"").concat(firstNameUnicode, "\"\n        ").concat(birthdate ? "birthdate: \"".concat(PrebookingForm_utils_formatDate(birthdate), "\"") : '', "\n        email: \"").concat(email, "\"\n        mobile: \"").concat(phone, "\"\n        ").concat(typeof optinSms !== 'undefined' ? "optinSms: ".concat(optinSms.toString()) : '', "\n        ").concat(typeof optinPhone !== 'undefined' ? "optinPhone: ".concat(optinPhone.toString()) : '', "\n        ").concat(typeof optinEmail !== 'undefined' ? "optinEmail: ".concat(optinEmail.toString()) : '', "\n      }\n      adults: [").concat(getCompanionsQuery(adults), "]\n      children: [").concat(getCompanionsQuery(kids), "]\n    ) {\n      errors {\n        errorKey\n        errorCode\n      }\n      neolaneID\n    }\n  }");
};
var handleSubmit = /*#__PURE__*/function () {
  var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, params) {
    var actions, appContext, cxoId, history, location, redirects, errorUrl, successUrl, prebookingFormQuery, _yield$graphQLClient$, prebooking, neolaneId, requestHasSucceeded, redirectUri;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            actions = params.actions, appContext = params.appContext, cxoId = params.cxoId, history = params.history, location = params.location, redirects = params.redirects;
            errorUrl = redirects.errorUrl, successUrl = redirects.successUrl;
            prebookingFormQuery = PrebookingForm_utils_getPrebookingFormQuery(values, cxoId, appContext);
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(prebookingFormQuery, appContext, {
              requestName: requestDictionary["cb" /* CUSTOMER_BOOKING_PREBOOKING_FORM_SUBMIT */]
            });

          case 6:
            _yield$graphQLClient$ = _context.sent;
            prebooking = _yield$graphQLClient$.prebooking; // Set isLoading to false

            actions.setSubmitting(false); // Track

            neolaneId = prebooking.neolaneID;

            if (neolaneId) {
              tracking_api["b" /* setDataLayer */]({
                categoryGA: 'prebooking-form',
                actionGA: 'CTASendRequest',
                labelGA: values.productId,
                user: {
                  neolaneID: neolaneId
                }
              }, appContext);
            } // Redirect


            requestHasSucceeded = prebooking.errors.length === 0;
            redirectUri = requestHasSucceeded ? successUrl : errorUrl;

            if (Object(sellerUtils["g" /* isSeller */])(appContext) && requestHasSucceeded) {
              redirectUri = routeBuilder["a" /* buildUrl */]('prebookingformSuccessSeller');
            }

            history.push(new URI_default.a(redirectUri).query(PrebookingForm_utils_objectSpread(PrebookingForm_utils_objectSpread({}, location.queryParams), {}, {
              trackingPageLoadAppendSuffix: values.productId
            })).toString());
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](3);

            if (ple_utils["l" /* hasAuthResponseError */](_context.t0)) {
              ple_utils["o" /* redirectOnLoginPage */]({
                locale: appContext.locale,
                redirectPath: location.pathname // state: values,

              });
            } else {
              history.push(new URI_default.a(errorUrl).query(PrebookingForm_utils_objectSpread(PrebookingForm_utils_objectSpread({}, location.queryParams), {}, {
                trackingPageLoadAppendSuffix: values.productId
              })).toString());
            }

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 17]]);
  }));

  return function handleSubmit(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormCompanion.jsx

var PrebookingFormCompanion_jsx = react_default.a.createElement;





var PrebookingFormCompanion_PrebookingFormCompanion = function PrebookingFormCompanion(props) {
  var companionGroup = props.companionGroup,
      dateFormat = props.dateFormat,
      hasUnicodeFields = props.hasUnicodeFields,
      index = props.index,
      civilities = props.civilities;
  var formHeader = companionGroup === COMPANION_GROUPS.ADULTS ? "".concat(Object(src_i18n["h" /* t */])('prebookingForm.pax.adultCompanionLabel'), " ").concat(index + 1) : "".concat(Object(src_i18n["h" /* t */])('prebookingForm.pax.childCompanionLabel'), " ").concat(index + 1);
  var isRequiredForAdults = companionGroup === COMPANION_GROUPS.ADULTS;
  var isRequiredForKids = companionGroup === COMPANION_GROUPS.KIDS;
  return PrebookingFormCompanion_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingFormCompanion_jsx("p", {
    className: "w-full mb-px10 px-px10 text-base font-bold"
  }, formHeader), PrebookingFormCompanion_jsx("div", {
    className: "w-full"
  }, PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-civility-field"),
    isRequired: isRequiredForAdults,
    name: "".concat(companionGroup, ".").concat(index, ".civility"),
    options: civilities,
    placeholder: "".concat(Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder')).concat(isRequiredForAdults ? '*' : ''),
    type: "select"
  }))), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstName-field"),
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".firstName"),
    optimized: true,
    placeholder: "".concat(Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'), "*"),
    type: "text"
  })), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastName-field"),
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastName"),
    optimized: true,
    placeholder: "".concat(Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'), "*"),
    type: "text"
  })), hasUnicodeFields && PrebookingFormCompanion_jsx(react["Fragment"], null, PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-firstNameUnicode-field"),
    name: "".concat(companionGroup, ".").concat(index, ".firstNameUnicode"),
    optimized: true,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-lastNameUnicode-field"),
    isRequired: true,
    name: "".concat(companionGroup, ".").concat(index, ".lastNameUnicode"),
    optimized: true,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), PrebookingFormCompanion_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingFormCompanion_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "".concat(companionGroup, "-").concat(index, "-birthdate-field"),
    isRequired: isRequiredForKids,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    name: "".concat(companionGroup, ".").concat(index, ".birthdate"),
    placeholder: "".concat(Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation')).concat(isRequiredForKids ? '*' : '', "}"),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat,
    validate: isRequiredForKids ? PrebookingForm_utils_getKidFutureBithdateValidator() : getAdultBirthdateValidator()
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingForm.jsx





















var PrebookingForm_jsx = react_default.a.createElement;

function PrebookingForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var DEFAULT_COMPANION = {
  birthdate: null,
  civility: '',
  firstName: '',
  lastName: ''
};
function PrebookingForm(_ref) {
  var _sortedOpeningDates$, _sortedOpeningDates;

  var adultsOptions = _ref.adultsOptions,
      agencies = _ref.agencies,
      civilities = _ref.civilities,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      hasSeller = _ref.hasSeller,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      initialFormData = _ref.initialFormData,
      kidsOptions = _ref.kidsOptions,
      newsletterOptins = _ref.newsletterOptins,
      productOptions = _ref.productOptions,
      products = _ref.products;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isValid = _useFormikContext.isValid,
      values = _useFormikContext.values,
      setValues = _useFormikContext.setValues,
      isSubmitting = _useFormikContext.isSubmitting; // CXO/Auth: update traveler information


  Object(react["useEffect"])(function () {
    setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), initialFormData));
  }, [initialFormData]);
  Object(react["useEffect"])(function () {
    var _products$values$prod;

    var departureDate = values.departureDate.from;

    if (values.productId && departureDate && !((_products$values$prod = products[values.productId]) === null || _products$values$prod === void 0 ? void 0 : _products$values$prod.openingDates.some(function (_ref2) {
      var opening = _ref2.opening,
          closing = _ref2.closing;
      return moment_default()(departureDate).isBetween(Object(date_apiDate["h" /* momentFromApiDate */])(opening), Object(date_apiDate["h" /* momentFromApiDate */])(closing));
    }))) {
      setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), {}, {
        departureDate: {
          from: null,
          to: null
        }
      }));
    }
  }, [values.productId]);
  var optinEmail = newsletterOptins.optinEmail,
      optinPhone = newsletterOptins.optinPhone,
      optinSms = newsletterOptins.optinSms,
      optinProfile = newsletterOptins.optinProfile;
  var productId = values.productId,
      accommodationCategory = values.accommodationCategory,
      adults = values.adults,
      adultsNumber = values.adultsNumber,
      kids = values.kids,
      kidsNumber = values.kidsNumber;
  var product = productId ? products[productId] : null;
  var minAuthorizedAge = product ? product.minAuthorizedAge : null;
  var durationOptions = product ? product.durations : [];
  var transportOptions = product ? product.transports : [];
  var accommodationCategoryOptions = product ? product.accommodations : [];

  var _ref3 = product && accommodationCategory ? product.accommodations.find(function (a) {
    return a.value === accommodationCategory;
  }) || {} : {},
      _ref3$types = _ref3.types,
      accommodationOptions = _ref3$types === void 0 ? [] : _ref3$types;

  var adultsInt = parseInt(adultsNumber, 10);
  var kidsInt = parseInt(kidsNumber, 10);
  var hasAddtionnalTravelers = adultsInt > MIN_FORM_ADULTS || kidsInt > MIN_FORM_KIDS;

  var handleAdultsNumber = function handleAdultsNumber(e) {
    var updatedAdultsNumber = e.target.value;
    var updatedAdultsInt = parseInt(updatedAdultsNumber, 10);
    var newAdults = updatedAdultsInt - adultsInt;
    var updatedAdults = newAdults > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(adults), Object(toConsumableArray["a" /* default */])(Array(newAdults).fill(null).map(function () {
      return DEFAULT_COMPANION;
    }))) : adults.slice(0, updatedAdultsInt - MIN_FORM_ADULTS);
    setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), {}, {
      adultsNumber: updatedAdultsNumber,
      adults: updatedAdults
    }));
  };

  var handleKidsNumber = function handleKidsNumber(e) {
    var updatedKidsNumber = e.target.value;
    var updatedKidsInt = parseInt(updatedKidsNumber, 10);
    var newKids = updatedKidsInt - kidsInt;
    var updatedKids = newKids > 0 ? [].concat(Object(toConsumableArray["a" /* default */])(kids), Object(toConsumableArray["a" /* default */])(Array(newKids).fill(null).map(function () {
      return DEFAULT_COMPANION;
    }))) : kids.slice(0, updatedKidsInt);
    setValues(PrebookingForm_objectSpread(PrebookingForm_objectSpread({}, values), {}, {
      kidsNumber: updatedKidsNumber,
      kids: updatedKids
    }));
  };

  var sortedOpeningDates = Object(toConsumableArray["a" /* default */])((product === null || product === void 0 ? void 0 : product.openingDates) || []).sort(function (date1, date2) {
    return Number(date1.opening) - Number(date2.opening);
  });

  var disabledDays = Object(calendar_helper["b" /* getClosingDatesRanges */])(sortedOpeningDates);
  var firstOpeningDate = (_sortedOpeningDates$ = sortedOpeningDates[0]) === null || _sortedOpeningDates$ === void 0 ? void 0 : _sortedOpeningDates$.opening;
  var minDate = firstOpeningDate && Object(date_apiDate["h" /* momentFromApiDate */])(firstOpeningDate).isAfter(moment_default()(departureDateStart)) ? Object(date_apiDate["h" /* momentFromApiDate */])(firstOpeningDate).toDate() : departureDateStart;
  var lastClosingDate = (_sortedOpeningDates = sortedOpeningDates[sortedOpeningDates.length - 1]) === null || _sortedOpeningDates === void 0 ? void 0 : _sortedOpeningDates.closing;
  var maxDate = lastClosingDate && moment_default()(departureDateEnd).isAfter(Object(date_apiDate["h" /* momentFromApiDate */])(lastClosingDate)) ? Object(date_apiDate["h" /* momentFromApiDate */])(lastClosingDate).toDate() : departureDateEnd;
  var isClosed = !!lastClosingDate && Object(date_apiDate["h" /* momentFromApiDate */])(lastClosingDate).isBefore(moment_default()());

  var MandatoryFieldsNote = function MandatoryFieldsNote() {
    return PrebookingForm_jsx("p", {
      className: "m-0 mb-px10 px-px10 text-small"
    }, Object(src_i18n["h" /* t */])('prebookingForm.mandatoryFieldsInformation'));
  };

  return PrebookingForm_jsx(formik_esm["c" /* Form */], {
    id: "prebooking-form-form",
    "data-testid": "prebooking-form-form"
  }, PrebookingForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('prebookingForm.stay.title')), PrebookingForm_jsx(MandatoryFieldsNote, null), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "product-id-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.stay.productLabel'),
    name: "productId",
    options: productOptions,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.stay.productPlaceholder'),
    type: "select"
  }), minAuthorizedAge ? PrebookingForm_jsx(Notification["a" /* Notification */], {
    className: "px-0 py-0",
    text: minAuthorizedAge
  }) : null), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-city-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.stay.departureCityLabel'),
    name: "departureCity",
    options: transportOptions,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.stay.departureCityPlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    dateFormat: dateFormat,
    hideErrorMessage: true,
    isDisabled: !productId || isClosed,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.stay.departureDateLabel'),
    maxDate: maxDate,
    minDate: minDate,
    disabledDays: disabledDays,
    name: "departureDate",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.stay.departureDatePlaceholder'),
    type: "datepicker"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "duration-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.stay.durationLabel'),
    name: "duration",
    options: durationOptions,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.stay.durationPlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("p", {
    className: classnames_default()('w-full mt-px10 mb-0 px-px10 text-base font-bold', {
      'text-gray-darker': !!productId,
      'text-gray-light': !productId
    })
  }, Object(src_i18n["h" /* t */])('prebookingForm.stay.accommodationsLabel'), '*'), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "accommodation-category-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    isRequired: true,
    name: "accommodationCategory",
    options: accommodationCategoryOptions,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.stay.accommodationsCategoryPlaceholder'),
    type: "select"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "accommodation-field",
    hideErrorMessage: true,
    isDisabled: !productId,
    name: "accommodation",
    options: accommodationOptions,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.stay.accommodationsTypePlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("p", {
    className: "w-full mt-px10 mb-0 px-px10 text-base font-bold"
  }, Object(src_i18n["h" /* t */])('prebookingForm.stay.numberOfParticipantsLabel'), '*'), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "adults-number-field",
    hideErrorMessage: true,
    name: "adultsNumber",
    options: adultsOptions,
    onChange: handleAdultsNumber,
    type: "select"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-number-field",
    hideErrorMessage: true,
    name: "kidsNumber",
    options: kidsOptions,
    onChange: handleKidsNumber,
    type: "select"
  }))), PrebookingForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.title')), PrebookingForm_jsx(MandatoryFieldsNote, null), PrebookingForm_jsx("div", {
    className: "flex flex-wrap"
  }, PrebookingForm_jsx("div", {
    className: "w-full"
  }, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-civility-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'),
    name: "traveler.civility",
    options: civilities.adults,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.civilityPlaceholder'),
    type: "select"
  }))), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstName-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'),
    name: "traveler.firstName",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.firstNamePlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastName-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'),
    name: "traveler.lastName",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.lastNamePlaceholder'),
    type: "text"
  })), hasUnicodeFields && PrebookingForm_jsx(react["Fragment"], null, PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    name: "traveler.firstNameUnicode",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.firstNameUnicodePlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastNameUnicode-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    name: "traveler.lastNameUnicode",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.lastNameUnicodePlaceholder'),
    type: "text"
  }))), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-birthdate-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    name: "traveler.birthdate",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.birthDateInformation'),
    type: "birthdate",
    dayPlaceholder: "DD",
    monthPlaceholder: "MM",
    yearPlaceholder: "YYYY",
    dateFormat: dateFormat
  })), !hasSeller && PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-gm-number-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.gmNumberPlaceholder'),
    name: "traveler.memberNumber",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.gmNumberPlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-email-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.emailPlaceholder'),
    name: "traveler.email",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.emailPlaceholder'),
    type: "text"
  })), PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-phone-field",
    hideErrorMessage: true,
    isDisabled: hasUser,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.phoneNumberPlaceholder'),
    name: "traveler.phone",
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.phoneNumberPlaceholder'),
    type: "text"
  })), agencies.length > 0 && PrebookingForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-agency-field",
    hideErrorMessage: true,
    isDisabled: hasSeller,
    label: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.favoriteTravelAgencyLabel'),
    name: "agency",
    options: agencies,
    placeholder: Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.favoriteTravelAgencyPlaceholder'),
    type: "select"
  })), hasAddtionnalTravelers && PrebookingForm_jsx("div", {
    className: "w-full p-px10"
  }, PrebookingForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('prebookingForm.pax.title')), PrebookingForm_jsx(MandatoryFieldsNote, null), adults.map(function (adult, index) {
    return PrebookingForm_jsx(PrebookingFormCompanion_PrebookingFormCompanion, {
      key: "adult-".concat(index),
      companionGroup: ADULTS,
      dateFormat: dateFormat,
      civilities: civilities.adults,
      hasUnicodeFields: hasUnicodeFields,
      index: index
    });
  }), kids.map(function (kid, index) {
    return PrebookingForm_jsx(PrebookingFormCompanion_PrebookingFormCompanion, {
      key: "kid-".concat(index),
      companionGroup: KIDS,
      dateFormat: dateFormat,
      civilities: civilities.kids,
      hasUnicodeFields: hasUnicodeFields,
      index: index
    });
  })), !hasSeller && PrebookingForm_jsx("div", {
    className: "w-full p-px10"
  }, PrebookingForm_jsx("p", {
    className: "w-full mb-px10 text-base font-bold"
  }, Object(src_i18n["h" /* t */])('prebookingForm.mainTraveler.optinCommunicationsInformation')), optinEmail && PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-px10",
    dataTestId: "optin-email-field",
    label: optinEmail.title,
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), optinPhone && PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-px10",
    dataTestId: "optin-phone-field",
    label: optinPhone.title,
    name: "optinPhone",
    optimized: true,
    type: "checkbox"
  }), optinSms && PrebookingForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-px10",
    dataTestId: "optin-sms-field",
    label: optinSms.title,
    name: "optinSms",
    optimized: true,
    type: "checkbox"
  }), optinEmail && optinEmail.description && PrebookingForm_jsx(Text["a" /* Text */], {
    className: "mt-px15",
    theme: "text-sans-2",
    text: optinEmail.description
  }), optinProfile && optinProfile.description && PrebookingForm_jsx(Text["a" /* Text */], {
    className: "mt-px15",
    theme: "text-sans-2",
    text: optinProfile.description
  }))), PrebookingForm_jsx("div", {
    className: "mt-px15 px-px10 text-right"
  }, PrebookingForm_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "prebooking-submit",
    isDisabled: !isValid,
    isLoading: isSubmitting,
    type: "submit"
  }, Object(src_i18n["h" /* t */])('prebookingForm.sendRequest'))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/prebooking-form/PrebookingFormContainer.jsx















var PrebookingFormContainer_jsx = react_default.a.createElement;

function PrebookingFormContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingFormContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingFormContainer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingFormContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function PrebookingFormContainer(_ref) {
  var adultsOptions = _ref.adultsOptions,
      agencies = _ref.agencies,
      civilities = _ref.civilities,
      cxoAgency = _ref.cxoAgency,
      cxoId = _ref.cxoId,
      dateFormat = _ref.dateFormat,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      hasSeller = _ref.hasSeller,
      hasUnicodeFields = _ref.hasUnicodeFields,
      hasUser = _ref.hasUser,
      kidsOptions = _ref.kidsOptions,
      newsletterOptins = _ref.newsletterOptins,
      productOptions = _ref.productOptions,
      products = _ref.products,
      redirectUris = _ref.redirectUris;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history,
      location = _useRouter.location;

  var redirects = {
    errorUrl: redirectUris.error || '/',
    successUrl: redirectUris.success || '/'
  };
  var productIds = productOptions.map(function (productOption) {
    return productOption.value;
  }).filter(Boolean);
  var dispatch = Object(es["d" /* useDispatch */])();

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var userInfo = state.userInfo,
        _state$seller = state.seller,
        seller = _state$seller === void 0 ? {
      neolids: []
    } : _state$seller,
        _state$tripInformatio = state.tripInformation;
    _state$tripInformatio = _state$tripInformatio === void 0 ? {
      adults: [],
      kids: []
    } : _state$tripInformatio;
    var adults = _state$tripInformatio.adults,
        kids = _state$tripInformatio.kids;

    if (seller.neolids.length > 0) {
      return {
        initialFormData: PrebookingForm_utils_getFormTravelerAndCompanions({
          adults: adults,
          kids: kids
        }),
        travelers: {
          adults: adults.map(function (adult) {
            return adult.neolid;
          }).filter(Boolean),
          kids: kids.map(function (kid) {
            return kid.neolid;
          }).filter(Boolean)
        }
      };
    }

    return {
      initialFormData: PrebookingFormContainer_objectSpread({
        traveler: getFormUser(userInfo)
      }, getFormOptins(userInfo)),
      travelers: null
    };
  }),
      initialFormData = _useSelector.initialFormData,
      travelers = _useSelector.travelers;

  var travelerIds = travelers ? [].concat(Object(toConsumableArray["a" /* default */])(travelers.adults), Object(toConsumableArray["a" /* default */])(travelers.kids)).join() : ''; // CXO: fetch complete traveler information

  Object(react["useEffect"])(function () {
    if (hasSeller && travelerIds.length > 0) {
      dispatch(Object(prebookingform_action["b" /* fetchPrebookingTravelers */])(travelers, appContext));
    }
  }, [travelerIds]);
  return PrebookingFormContainer_jsx(formik_esm["d" /* Formik */], {
    initialValues: PrebookingForm_utils_getInitialFormValues(cxoAgency),
    validationSchema: PrebookingForm_utils_getFormSchema(src_i18n["h" /* t */], {
      agencies: agencies.map(function (agency) {
        return agency.value;
      }),
      civilities: civilities,
      locale: appContext.locale,
      productIds: productIds
    }),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, actions) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return handleSubmit(values, {
                  actions: actions,
                  appContext: appContext,
                  cxoId: cxoId,
                  dateFormat: dateFormat,
                  history: history,
                  location: location,
                  redirects: redirects
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, PrebookingFormContainer_jsx(PrebookingForm, {
    adultsOptions: adultsOptions,
    agencies: agencies,
    civilities: civilities,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    hasUnicodeFields: hasUnicodeFields,
    initialFormData: initialFormData,
    hasUser: hasUser,
    hasSeller: hasSeller,
    kidsOptions: kidsOptions,
    newsletterOptins: newsletterOptins,
    productOptions: productOptions,
    products: products
  }));
}
// EXTERNAL MODULE: ../domains-service/dist/index.js
var domains_service_dist = __webpack_require__("g/E1");

// EXTERNAL MODULE: ./src/utils/legal-information/legalInformationIds.constants.js
var legalInformationIds_constants = __webpack_require__("y5Lu");

// CONCATENATED MODULE: ./src/client/store/utils/selectOptionsBuilders.js





function getCountOptions(labels, initial, limit) {
  var options = [];
  var messageFormat = Object(dist["messageFormat"])(labels);

  for (var count = initial; count <= limit + 1; count++) {
    options.push({
      label: messageFormat.format({
        count: count
      }),
      value: count
    });
  }

  return options;
}
function getAdultsOptions(selectAdultsLabels) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  return getCountOptions(selectAdultsLabels, initial, limit);
}
function getChildrenOptions(selectChildrenLabels) {
  var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
  return getCountOptions(selectChildrenLabels, initial, limit);
}
function getDurationOptions(messageFormat, durations) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'duration';
  var durationMessage = Object(dist["messageFormat"])(messageFormat);
  return durations.map(function (duration) {
    return {
      name: durationMessage.format(Object(defineProperty["a" /* default */])({}, key, duration)),
      label: durationMessage.format(Object(defineProperty["a" /* default */])({}, key, duration)),
      value: duration.toString()
    };
  });
}
// CONCATENATED MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.utils.js






















 // Line props
// CIVILITIES

var PrebookingFormLine_utils_getCivilities = function getCivilities(adultCivilities, locale) {
  return {
    adults: adultCivilities,
    kids: Object(domains_service_dist["getKidsCivilities"])(locale).map(function (_ref) {
      var value = _ref.value,
          label = _ref.label;
      return {
        value: value,
        name: label
      };
    })
  };
}; // TRAVEL AGENCY OPTIONS

var getAgencyName = function getAgencyName(travelAgency) {
  var _travelAgency$address;

  return "".concat(((_travelAgency$address = travelAgency.address) === null || _travelAgency$address === void 0 ? void 0 : _travelAgency$address.city) || '', " - ").concat(travelAgency.name);
};

var getFilteredAgencyName = function getFilteredAgencyName(travelAgency) {
  /**
   * ^[.+?\s]*            Match 0 or more chars or white space at the beginning
   * (?:<T1>|<T2>)?       Do not capture group of 1st or 2nd potential terms
   * \s*                  Match 0 or more white spaces
   * (.+?)$               Capture group of any chars up to the end
   * /i                   Case insensitive Flags
   */
  var agencyNameFilter = /^[.+?\s]*(?:CLUB MED VOYAGES|APPARTEMENT BOUTIQUE)?\s*(.+?)$/i;
  var trimmedName = agencyNameFilter.exec(travelAgency.name);
  return trimmedName && trimmedName[1] ? trimmedName[1] : getAgencyName(travelAgency);
};

var getTravelAgencyOptions = function getTravelAgencyOptions(travelAgencies, locale) {
  if (!travelAgencies) {
    return [];
  }

  return travelAgencies.map(function (travelAgency) {
    return {
      name: locale === 'fr-FR' ? getFilteredAgencyName(travelAgency) : getAgencyName(travelAgency),
      value: travelAgency.id
    };
  }).sort(function (travelAgencyA, travelAgencyB) {
    return travelAgencyA.name.localeCompare(travelAgencyB.name) > 0 ? 1 : -1;
  });
}; // ADULTS/KIDS NUMBER OPTIONS

var PrebookingFormLine_utils_getAdultsNumberOptions = function getAdultsNumberOptions(adultsAge) {
  return getAdultsOptions(adultsAge, MIN_FORM_ADULTS, MAX_FORM_ADULTS).map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      name: label,
      value: value.toString()
    };
  });
};
var PrebookingFormLine_utils_getKidsNumberOptions = function getKidsNumberOptions(kidsAge) {
  return getChildrenOptions(kidsAge, MIN_FORM_KIDS, MAX_FORM_KIDS).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      name: label,
      value: value.toString()
    };
  });
}; // NEWSLETTER OPTINS

var getNewsletterOptin = function getNewsletterOptin(optin) {
  return optin ? {
    title: optin.title,
    description: optin.description
  } : null;
};

var PrebookingFormLine_utils_getNewsletterOptins = function getNewsletterOptins(newsletterOptins) {
  var optinEmail = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["h" /* EMAIL_OPTIN */];
  });
  var optinPhone = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["o" /* PHONE_OPTIN */];
  });
  var optinSms = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["q" /* SMS_OPTIN */];
  });
  var optinProfile = newsletterOptins.find(function (optin) {
    return optin.id === legalInformationIds_constants["p" /* PROFILING */];
  });
  return {
    optinEmail: getNewsletterOptin(optinEmail),
    optinPhone: getNewsletterOptin(optinPhone),
    optinSms: getNewsletterOptin(optinSms),
    optinProfile: getNewsletterOptin(optinProfile)
  };
}; // PRODUCT OPTIONS

var PrebookingFormLine_utils_getProductOption = function getProductOption(isTopProduct) {
  return function (product) {
    return {
      key: "".concat(product.productId, "-").concat(isTopProduct ? 'top' : 'regular'),
      name: "".concat(product.name, ", ").concat(Object(string_util["c" /* titleCase */])(product.destination.country)),
      value: product.productId
    };
  };
};

function getProductOptions(lineProducts, products) {
  var topProducts = lineProducts.filter(function (lineProduct) {
    return lineProduct.sortedFirst;
  }).map(function (_ref4) {
    var productId = _ref4.productId;
    return products[productId];
  }).filter(Boolean).map(PrebookingFormLine_utils_getProductOption(true));
  return [].concat(Object(toConsumableArray["a" /* default */])(topProducts), Object(toConsumableArray["a" /* default */])(topProducts.length ? [{
    key: 'separator',
    name: '──────────',
    value: null,
    isDisabled: true
  }] : []), Object(toConsumableArray["a" /* default */])(Object.values(products).map(PrebookingFormLine_utils_getProductOption(false)).sort(function (productOptionA, productOptionB) {
    if (!productOptionA.name) return 1;
    if (!productOptionB.name) return -1;
    return productOptionA.name.localeCompare(productOptionB.name);
  })));
} // PRODUCT DATA

function getAccommodationsOptions() {
  var accommodations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var accommodationCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return accommodationCategories.map(function (accommodationCategory) {
    var categoryId = accommodationCategory.id,
        categoryLabel = accommodationCategory.label,
        categoryRanking = accommodationCategory.ranking;
    var types = accommodations.filter(function (accommodation) {
      return accommodation.categories.map(function (_ref5) {
        var id = _ref5.id;
        return id;
      }).includes(categoryId);
    }).map(function (_ref6) {
      var id = _ref6.id,
          label = _ref6.label;
      return {
        name: label,
        value: id
      };
    });
    return {
      value: categoryId,
      name: categoryLabel,
      rankingIndex: Object.values(dist["constants"].RANKINGS).findIndex(function (ranking) {
        return ranking === categoryRanking;
      }),
      types: types
    };
  }).sort(function (accommodationsOptionA, accommodationsOptionB) {
    return accommodationsOptionB.rankingIndex - accommodationsOptionA.rankingIndex;
  });
}

function getFormProducts(_ref7) {
  var resorts = _ref7.resorts,
      bookingsCriteria = _ref7.bookingsCriteria,
      accommodationCategories = _ref7.accommodationCategories,
      durationLabels = _ref7.durationLabels;
  return resorts.reduce(function (products, product, productIndex) {
    var _bookingsCriteria$pro, _bookingsCriteria$pro2;

    var name = product.name,
        destination = product.destination,
        adultOnly = product.adultOnly,
        openingDates = product.openingDates,
        accommodations = product.accommodations,
        minAuthorizedAge = product.minAuthorizedAge;
    var durations = ((_bookingsCriteria$pro = bookingsCriteria[productIndex]) === null || _bookingsCriteria$pro === void 0 ? void 0 : _bookingsCriteria$pro.durations) || [];
    var transports = ((_bookingsCriteria$pro2 = bookingsCriteria[productIndex]) === null || _bookingsCriteria$pro2 === void 0 ? void 0 : _bookingsCriteria$pro2.departureCities) || [];
    var productAccommodationCategories = accommodationCategories.find(function (category) {
      return category.productId === product.id;
    });
    var categories = (productAccommodationCategories === null || productAccommodationCategories === void 0 ? void 0 : productAccommodationCategories.accommodations) || [];
    products[product.id] = {
      productId: product.id,
      name: name,
      destination: destination,
      openingDates: openingDates,
      minAuthorizedAge: minAuthorizedAge.formattedValue || '',
      minAuthorizedAgeInMonths: minAuthorizedAge.value || '',
      durations: getDurationOptions(durationLabels, durations, 'count'),
      transports: transports,
      accommodations: getAccommodationsOptions(accommodations, categories),
      adultOnly: adultOnly
    };
    return products;
  }, {});
}
// CONCATENATED MODULE: ./src/client/components/lines/prebooking-form-line/PrebookingFormLine.jsx













var PrebookingFormLine_jsx = react_default.a.createElement;

function PrebookingFormLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PrebookingFormLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PrebookingFormLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PrebookingFormLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function PrebookingFormLine(props) {
  var accommodationCategories = props.accommodationCategories,
      bookingsCriteria = props.bookingsCriteria,
      adultCivilities = props.civilities,
      config = props.config,
      dateFormat = props.dateFormat,
      error = props.error,
      legalInformations = props.legalInformations,
      login = props.login,
      mainTraveler = props.mainTraveler,
      mandatoryFieldsInformation = props.mandatoryFieldsInformation,
      pax = props.pax,
      products = props.products,
      resorts = props.resorts,
      sendRequest = props.sendRequest,
      stay = props.stay,
      success = props.success,
      travelAgencies = props.travelAgencies;
  Object(src_i18n["a" /* addTranslationKeys */])({
    prebookingForm: {
      login: login,
      mainTraveler: mainTraveler,
      mandatoryFieldsInformation: mandatoryFieldsInformation,
      pax: pax,
      sendRequest: sendRequest,
      stay: stay
    }
  });
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var hasUnicodeFields = appContext.displayUnicodeFields,
      locale = appContext.locale,
      hasSeller = appContext.isDirectCxo,
      hasUser = appContext.isUserLogged;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location; // CXO: set seller agency and id


  var agencies = getTravelAgencyOptions(travelAgencies, locale);

  var _useMemo = Object(react["useMemo"])(function () {
    var salesIds = {
      cxoAgency: null,
      cxoId: location.queryParams.cxo_id || null
    };
    var salesNetworkId = location.queryParams.cxo_sales_network_id;

    if (salesNetworkId) {
      var _salesNetworkId$split = salesNetworkId.split('_'),
          _salesNetworkId$split2 = Object(slicedToArray["a" /* default */])(_salesNetworkId$split, 1),
          sellerAgency = _salesNetworkId$split2[0];

      salesIds = PrebookingFormLine_objectSpread(PrebookingFormLine_objectSpread({}, salesIds), {}, {
        cxoAgency: agencies.map(function (a) {
          return a.value;
        }).find(function (travelAgencyId) {
          return travelAgencyId === sellerAgency;
        }) || null
      });
    }

    return salesIds;
  }, [location.queryParams]),
      cxoAgency = _useMemo.cxoAgency,
      cxoId = _useMemo.cxoId;

  var civilities = PrebookingFormLine_utils_getCivilities(adultCivilities.adult, locale);
  var hasLoginButton = !!config.memberSpace.accessButtonLoggedin;
  var formProducts = getFormProducts({
    accommodationCategories: accommodationCategories,
    bookingsCriteria: bookingsCriteria,
    resorts: resorts,
    durationLabels: props.stay.durationValue
  });
  var productOptions = getProductOptions(products, formProducts);
  var departureDateStart = new Date(props.departureDateStart);
  var departureDateEnd = new Date(props.departureDateEnd);
  var redirectUris = {
    error: error ? error.url : null,
    success: success ? success.url : null
  };
  var adultsOptions = PrebookingFormLine_utils_getAdultsNumberOptions(props.stay.adultsAge);
  var kidsOptions = PrebookingFormLine_utils_getKidsNumberOptions(props.stay.childrenAge);
  var newsletterOptins = PrebookingFormLine_utils_getNewsletterOptins(legalInformations.newsletterOptins || []);
  return PrebookingFormLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: "prebookingform"
  }, PrebookingFormLine_jsx(PrebookingFormLogin_PrebookingFormLogin, {
    hasLoginButton: hasLoginButton,
    hasUser: hasUser,
    hasSeller: hasSeller
  }), PrebookingFormLine_jsx(PrebookingFormContainer, {
    adultsOptions: adultsOptions,
    agencies: agencies,
    civilities: civilities,
    cxoAgency: cxoAgency,
    cxoId: cxoId,
    dateFormat: dateFormat,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    hasSeller: hasSeller,
    hasUnicodeFields: hasUnicodeFields,
    hasUser: hasUser,
    kidsOptions: kidsOptions,
    locale: locale,
    newsletterOptins: newsletterOptins,
    productOptions: productOptions,
    products: formProducts,
    redirectUris: redirectUris
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/prebooking-form/prebookingForm.resolver.js
var prebookingForm_resolver = __webpack_require__("VqO2");

// CONCATENATED MODULE: ./src/client/cms/toolkit/prebooking-form/prebookingForm.descriptor.js



var prebookingFormDescriptor = {
  name: constants["H" /* PREBOOKING_FORM */],
  component: PrebookingFormLine,
  resolve: prebookingForm_resolver["a" /* prebookingFormResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-tags/ProductTags.jsx











var ProductTags_jsx = react_default.a.createElement;

function ProductTags_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductTags_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductTags_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductTags_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var ProductTags_ProductTags = function ProductTags(_ref) {
  var lineName = _ref.lineName,
      tags = _ref.tags,
      trackingData = _ref.trackingData;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(0),
      selectedTagIndex = _useState[0],
      setSelectedTagIndex = _useState[1];

  var track = Object(useTracking["a" /* useTracking */])(trackingData);
  var _tags$selectedTagInde = tags[selectedTagIndex],
      selectedProducts = _tags$selectedTagInde.products,
      selectedTagLabel = _tags$selectedTagInde.label;
  return ProductTags_jsx("div", {
    className: "flex flex-wrap w-full max-w-site"
  }, ProductTags_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: Object(src_i18n["h" /* t */])('common.scrollBackward'),
    childrenWrapperClassNames: "flex",
    className: "w-screen lg:w-full -mx-px20 lg:mx-0 mb-px15",
    forwardLabel: Object(src_i18n["h" /* t */])('common.scrollForward')
  }, tags.map(function (tag, index) {
    return ProductTags_jsx(Tag["a" /* Tag */], {
      active: index === selectedTagIndex,
      borderColor: index === selectedTagIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_LIGHT,
      className: classnames_default()('rtl:mr-px10 mb-px10', {
        'rtl:ml-px20 lg:rtl:ml-0': index === 0
      }),
      color: index === selectedTagIndex ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].GRAY_DARKER,
      key: tag.label,
      label: tag.label,
      onClick: function onClick() {
        return setSelectedTagIndex(index);
      },
      trackingData: ProductTags_objectSpread(ProductTags_objectSpread({}, trackingData), {}, {
        labelGA: "tag_".concat(tag.label)
      }),
      theme: "outlinedThin"
    });
  })), ProductTags_jsx(Slider["a" /* Slider */], {
    className: "-mx-px20 lg:mx-0 w-screen lg:w-full",
    cols: 0,
    hasControls: isDesktop && selectedProducts.length > 3,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "overflow-x-auto lg:overflow-hidden",
    scrollControlsClassName: "-mx-px20 lg:mx-0"
  }, selectedProducts.map(function (product, index) {
    return ProductTags_jsx("div", {
      key: product.id,
      className: classnames_default()('relative rtl:pr-px20', {
        'rtl:ml-px20 lg:rtl:ml-0': index === 0
      }),
      style: {
        width: '85vw',
        maxWidth: '380px'
      }
    }, ProductTags_jsx(Product["a" /* Product */], Object(esm_extends["a" /* default */])({}, product, {
      index: index,
      lineName: lineName,
      onClick: function onClick() {
        return track({
          labelGA: "".concat(selectedTagLabel, "_").concat(product.id)
        });
      }
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-tags-line/ProductTagsLine.jsx










var ProductTagsLine_jsx = react_default.a.createElement;

function ProductTagsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductTagsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductTagsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductTagsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var ProductTagsLine_ProductTagsLine = function ProductTagsLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      products = _ref.products,
      seeAllProductsLink = _ref.seeAllProductsLink,
      tags = _ref.tags,
      title = _ref.title;

  if (!tags || tags.length === 0 || !products || products.length === 0) {
    return null;
  }

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var formattedProducts = products.map(function (product) {
    return Object(redux["d" /* compose */])(Product_mapper["c" /* getProductProps */], Product_mapper["e" /* setProductHref */])({
      config: config,
      product: product,
      isSliderDisabled: true
    });
  });
  var tagsWithProducts = tags.map(function (tag) {
    var productsInTag = tag.productIds.map(function (productId) {
      return formattedProducts.find(function (p) {
        return p.id === productId;
      });
    }).filter(Boolean);
    return productsInTag.length > 0 ? ProductTagsLine_objectSpread(ProductTagsLine_objectSpread({}, tag), {}, {
      products: productsInTag
    }) : null;
  }).filter(Boolean);
  var trackingData = {
    actionGA: 'push_content_IdealResort'
  };
  return tagsWithProducts.length > 0 && ProductTagsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    dataTestId: "Line-ProductTags",
    id: id
  }, ProductTagsLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, ProductTagsLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), ProductTagsLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-px15 md:mt-px5 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: ProductTagsLine_objectSpread(ProductTagsLine_objectSpread({}, trackingData), {}, {
      labelGA: 'seeAllResorts'
    }),
    url: seeAllProductsLink.url
  }, seeAllProductsLink.label), ProductTagsLine_jsx(ProductTags_ProductTags, {
    lineName: constants["tb" /* RESORT_TAGS */],
    tags: tagsWithProducts,
    trackingData: trackingData
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-tags/productTags.resolver.js
var productTags_resolver = __webpack_require__("2dUC");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-tags/productTags.descriptor.js



var productTagsDescriptor = {
  name: constants["X" /* PRODUCT_TAGS */],
  component: ProductTagsLine_ProductTagsLine,
  resolver: productTags_resolver["a" /* productTagsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/products-filters-line/ProductsFiltersLine.jsx
var ProductsFiltersLine_jsx = react_default.a.createElement;




var ProductsFiltersLine_ProductsFiltersLine = function ProductsFiltersLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      offer = _ref.offer;
  var appContext = react_default.a.useContext(ReactAppContext["b" /* default */]);

  if (!offer) {
    return null;
  }

  var isProductComparisonModeAuthorized = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('search.productComparison');
  return ProductsFiltersLine_jsx("div", {
    className: "Line Line-ProductsFilters",
    id: id
  }, ProductsFiltersLine_jsx(FacetSearch["a" /* FacetSearch */], {
    hideSearchInput: true,
    i18n: config,
    initialIsSearchEnabled: true,
    initialProducts: offer.products || [],
    isProductComparisonModeAuthorized: isProductComparisonModeAuthorized,
    offer: offer,
    resetSearchAtMount: true,
    shouldPersistCriteriaInUrl: true,
    shouldSetDefaultDepartureCityOnCompare: true,
    withSearchFacets: true,
    withSearchForm: true,
    withSearchResults: true
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/products-filters/productsFilters.resolver.js
var productsFilters_resolver = __webpack_require__("YYl6");

// CONCATENATED MODULE: ./src/client/cms/toolkit/products-filters/productsFilters.descriptor.js



var productsFiltersDescriptor = {
  name: constants["I" /* PRODUCTS_FILTERS */],
  component: ProductsFiltersLine_ProductsFiltersLine,
  resolve: productsFilters_resolver["a" /* productsFiltersResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/widgets/products-grid/ProductsGrid.jsx
var ProductsGrid = __webpack_require__("w04c");

// CONCATENATED MODULE: ./src/client/components/lines/products-grid-line/ProductsGridLine.utils.js







var ProductsGridLine_utils_productsMapper = function productsMapper(props) {
  var _props$products = props.products,
      products = _props$products === void 0 ? [] : _props$products,
      _props$productIds = props.productIds,
      productIds = _props$productIds === void 0 ? [] : _props$productIds,
      config = props.config,
      _props$offer = props.offer,
      offer = _props$offer === void 0 ? {} : _props$offer;
  return productIds.reduce(function (prev, next) {
    if (products === null || products === void 0 ? void 0 : products.length) {
      var product = products.find(function (_ref) {
        var id = _ref.id;
        return next === id;
      });

      if (product) {
        prev.push(product);
      }
    }

    return prev;
  }, []).map(function (product) {
    return Object(Product_mapper["c" /* getProductProps */])({
      config: config,
      product: product,
      contextualizeUrl: !!(props.departureDateStart && props.departureDateEnd),
      offer: !Object(lodash["isEmpty"])(offer) ? offer : undefined
    });
  });
};
var ProductsGridLine_utils_asyncPropsMapper = function asyncPropsMapper(initialProps, moreProducts) {
  var _initialProps$product = initialProps.products,
      products = _initialProps$product === void 0 ? [] : _initialProps$product;
  return {
    products: [].concat(Object(toConsumableArray["a" /* default */])(products), Object(toConsumableArray["a" /* default */])(moreProducts))
  };
};
// CONCATENATED MODULE: ./src/client/components/lines/products-grid-line/ProductsGridLine.jsx


var ProductsGridLine_jsx = react_default.a.createElement;




var ProductsGridLine_ProductsGridLine = function ProductsGridLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var moreResultsColor = props.moreResultsColor,
      moreResultsLabel = props.moreResultsLabel,
      moreResultsButtonLabel = props.moreResultsButtonLabel,
      unfoldList = props.unfoldList,
      _props$productIds = props.productIds,
      productIds = _props$productIds === void 0 ? [] : _props$productIds;
  return ProductsGridLine_jsx("div", {
    className: "Line Line-ProductsGrid",
    id: id
  }, ProductsGridLine_jsx(ProductsGrid["a" /* ProductsGrid */], Object(esm_extends["a" /* default */])({}, props, {
    hasSeeMore: !unfoldList,
    isSynchronousGrid: true,
    lineName: constants["ib" /* RESORT_GRID */],
    products: ProductsGridLine_utils_productsMapper(props),
    productsMapper: ProductsGridLine_utils_productsMapper,
    seeMore: {
      color: moreResultsColor,
      text: moreResultsLabel,
      label: moreResultsButtonLabel
    },
    totalNumberToDisplay: productIds.length
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/products-grid/productsGrid.resolver.js
var productsGrid_resolver = __webpack_require__("3zhs");

// CONCATENATED MODULE: ./src/client/cms/toolkit/products-grid/productsGrid.descriptor.js



var productsGridDescriptor = {
  name: constants["ib" /* RESORT_GRID */],
  component: ProductsGridLine_ProductsGridLine,
  resolve: productsGrid_resolver["a" /* productsGridResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/section/section.descriptor.js
var section_descriptor_jsx = react_default.a.createElement;



var sectionDescriptor = {
  name: constants["vb" /* SECTION */],
  component: function component(props) {
    return section_descriptor_jsx(Line, {
      props: props
    });
  }
};
// EXTERNAL MODULE: ./src/client/components/frameworks/sections/Sections.jsx + 3 modules
var Sections = __webpack_require__("tCJK");

// CONCATENATED MODULE: ./src/client/components/lines/sections-line/SectionsLine.jsx


var SectionsLine_jsx = react_default.a.createElement;


var SectionsLine_SectionsLine = function SectionsLine(_ref) {
  var children = _ref.children,
      _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? [] : _ref$lines;
  return SectionsLine_jsx(Sections["a" /* Sections */], {
    navItems: lines.map(function (l) {
      return l.props.name;
    }),
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    className: "pt-px10"
  }, children);
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/sections/sections.resolver.js
var sections_resolver = __webpack_require__("6TMq");

// CONCATENATED MODULE: ./src/client/cms/toolkit/sections/sections.descriptor.js



var sectionsDescriptor = {
  name: constants["wb" /* SECTIONS */],
  component: SectionsLine_SectionsLine,
  resolve: sections_resolver["a" /* sectionsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/smart-faq-line/SmartFaqLine.jsx
var SmartFaqLine_jsx = react_default.a.createElement;

function SmartFaqLine() {
  return SmartFaqLine_jsx("div", {
    id: "st-faq"
  });
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/smart-faq/smartFaq.descriptor.js


var smartFaqDescriptor = {
  name: constants["xb" /* SMART_FAQ */],
  component: SmartFaqLine
};
// CONCATENATED MODULE: ./src/client/components/lines/submission-status-line/SubmissionStatusLine.jsx

var SubmissionStatusLine_jsx = react_default.a.createElement;




var SubmissionStatusLine_SubmissionStatusLine = function SubmissionStatusLine(_ref) {
  var id = _ref.id,
      hasShadow = _ref.hasShadow,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id", "hasShadow"]);

  return SubmissionStatusLine_jsx("div", {
    className: classnames_default()('Line Line-SubmissionStatus', {
      'border-b-1 border-t-1 border-gray-light shadow-md': hasShadow
    })
  }, SubmissionStatusLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    size: "small"
  }, SubmissionStatusLine_jsx(Confirmation["a" /* Confirmation */], props)));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/submission-status/submissionStatus.descriptor.js


var submissionStatusDescriptor = {
  name: constants["yb" /* SUBMISSION_STATUS */],
  component: SubmissionStatusLine_SubmissionStatusLine
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/tab/tab.resolver.js
var tab_resolver = __webpack_require__("yTc0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tab/tab.descriptor.js
var tab_descriptor_jsx = react_default.a.createElement;




var tabDescriptor = {
  name: constants["zb" /* TAB */],
  component: function component(props) {
    return tab_descriptor_jsx(Line, {
      props: props
    });
  },
  props: tab_resolver["a" /* tabResolver */].props
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.anchor.js
var es_string_anchor = __webpack_require__("XygZ");

// EXTERNAL MODULE: ./src/client/components/frameworks/tabs/Tabs.jsx + 1 modules
var Tabs = __webpack_require__("4/4b");

// CONCATENATED MODULE: ./src/client/components/lines/tabs-line/TabsLine.jsx






var TabsLine_jsx = react_default.a.createElement;





var TabsLine_TabsLine = function TabsLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var items = props.lines.map(function (line) {
    var TabContent = descriptorsLibrary[line.name].component;
    return {
      header: {
        color: line.props.color,
        iconName: line.props.header.icon,
        title: line.props.header.title
      },
      id: line.props.anchor || null,
      content: [TabsLine_jsx(TabContent, Object(esm_extends["a" /* default */])({}, line.props, {
        key: "1"
      }))]
    };
  });
  var initialSelectedItems = props.lines.map(function (line, index) {
    return line.props.isExpanded ? index : -1;
  }).filter(function (i) {
    return i > -1;
  });
  return TabsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, TabsLine_jsx(Tabs["a" /* Tabs */], {
    initialSelectedItems: isTablet ? [0] : initialSelectedItems,
    items: items,
    theme: "buttons",
    isScrollable: true,
    hasControlsOnTouch: true
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/tabs/tabs.descriptor.js


var tabsDescriptor = {
  name: constants["Ab" /* TABS */],
  component: TabsLine_TabsLine
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLinkUtil.js + 1 modules
var DynamicLinkUtil = __webpack_require__("Mkub");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.jsx




















var ProductInformationSlider_jsx = react_default.a.createElement;

function ProductInformationSlider_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationSlider_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationSlider_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationSlider_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function ProductInformationSlider_createSuper(Derived) { var hasNativeReflectConstruct = ProductInformationSlider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function ProductInformationSlider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }




var ProductInformationSlider_themes = {
  default: {
    largeCols: 2,
    desktopCols: 4,
    tabletCols: 3,
    navPosition: ''
  },
  short: {
    largeCols: 2,
    desktopCols: 3,
    tabletCols: 3,
    navPosition: 'center'
  }
};
var ProductInformationSlider_ProductInformationSlider = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ProductInformationSlider, _Component);

  var _super = ProductInformationSlider_createSuper(ProductInformationSlider);

  function ProductInformationSlider() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ProductInformationSlider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "openLayer", function (activeItem) {
      return _this.props.toggleLayer(activeItem, true);
    });

    return _this;
  }

  Object(createClass["a" /* default */])(ProductInformationSlider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          isLarge = _this$props.isLarge,
          _this$props$theme = _this$props.theme,
          theme = _this$props$theme === void 0 ? 'default' : _this$props$theme,
          queryLayer = _this$props.queryLayer,
          scrollBackwardLabel = _this$props.scrollBackwardLabel,
          scrollForwardLabel = _this$props.scrollForwardLabel;

      if (!react["Children"].count(children)) {
        return null;
      }

      var _this$context = this.context,
          isDesktop = _this$context.isDesktop,
          isTablet = _this$context.isTablet;
      var _themes$theme = ProductInformationSlider_themes[theme],
          largeCols = _themes$theme.largeCols,
          desktopCols = _themes$theme.desktopCols,
          tabletCols = _themes$theme.tabletCols,
          navPosition = _themes$theme.navPosition;

      var renderItem = function renderItem(element, index) {
        var _element$props$link = element.props.link,
            link = _element$props$link === void 0 ? {} : _element$props$link;

        if (!link.url) {
          link = ProductInformationSlider_objectSpread(ProductInformationSlider_objectSpread({}, link), {}, {
            onClick: function onClick() {
              return _this2.openLayer(index);
            }
          });
        }

        return /*#__PURE__*/react_default.a.createElement('div', {
          className: 'h-full',
          style: {
            width: !isTablet ? 280 : null
          }
        }, /*#__PURE__*/react_default.a.cloneElement(element, {
          link: link,
          isLarge: isLarge
        }));
      };

      var getCols = function getCols() {
        if (isTablet) {
          if (isLarge) return largeCols;
          if (isDesktop) return desktopCols;
          return tabletCols;
        }

        return 0;
      };

      var clonedChildren = react["Children"].map(children, renderItem);
      return ProductInformationSlider_jsx("section", null, ProductInformationSlider_jsx(Slider["a" /* Slider */], {
        cols: getCols(),
        hasControls: isTablet,
        id: queryLayer,
        navPosition: navPosition || (isTablet ? 'top' : 'center'),
        nbItemsToScroll: isTablet ? 2 : 1,
        nextLabel: scrollForwardLabel,
        previousLabel: scrollBackwardLabel,
        scrollAreaClassName: "overflow-hidden -mx-px10",
        scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
        scrollItemClassName: "overflow-hidden px-px10 pb-px10 flex-none max-w-full"
      }, clonedChildren));
    }
  }]);

  return ProductInformationSlider;
}(react["Component"]);

Object(defineProperty["a" /* default */])(ProductInformationSlider_ProductInformationSlider, "contextType", responsiveContext["a" /* default */]);
// EXTERNAL MODULE: ./src/client/components/frameworks/backdrop/Backdrop.jsx + 1 modules
var Backdrop = __webpack_require__("NZxu");

// EXTERNAL MODULE: ./src/client/components/frameworks/layer/Layer.jsx + 4 modules
var Layer = __webpack_require__("U2fG");

// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationLayer.jsx








var ProductInformationLayer_jsx = react_default.a.createElement;

function ProductInformationLayer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductInformationLayer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductInformationLayer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductInformationLayer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var ProductInformationLayer_ProductInformationLayer = function ProductInformationLayer(_ref) {
  var activeItem = _ref.activeItem,
      backNavigationLabel = _ref.backNavigationLabel,
      children = _ref.children,
      errorMessage = _ref.errorMessage,
      renderDetail = _ref.renderDetail,
      toggleLayer = _ref.toggleLayer;

  var _useState = Object(react["useState"])({
    activeItem: activeItem,
    isLoading: false,
    isOpen: false
  }),
      state = _useState[0],
      setState = _useState[1];

  Object(react["useEffect"])(function () {
    loadDetails();
  }, [activeItem]);

  var closeLayer = function closeLayer() {
    setState(ProductInformationLayer_objectSpread(ProductInformationLayer_objectSpread({}, state), {}, {
      isLoading: false,
      isOpen: false
    })); // -1 to indicate that no product has been selected

    toggleLayer(-1, false);
  };

  var updateDetail = function updateDetail(active, detailInfo) {
    setState({
      activeItem: active,
      detail: detailInfo,
      isLoading: false,
      isOpen: true
    });
  };

  var getItem = function getItem(index) {
    return react["Children"].toArray(children)[index];
  };

  var loadDetails = function loadDetails() {
    var item = getItem(activeItem) || {};
    var props = item.props;

    if (props && props.fetchDetail) {
      setState(ProductInformationLayer_objectSpread(ProductInformationLayer_objectSpread({}, state), {}, {
        isLoading: true
      }));
      props.fetchDetail().then(function (data) {
        updateDetail(activeItem, data);
      }).catch(function () {
        updateDetail(activeItem, null);
      });
    }
  };

  var renderActiveDetail = function renderActiveDetail() {
    var item = getItem(activeItem);

    if (!item) {
      return null;
    }

    var leftButton = {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      onClick: closeLayer,
      label: backNavigationLabel
    };
    var ariaLabel = state.detail ? state.detail.label || state.detail.title : '';
    return ProductInformationLayer_jsx(Layer["b" /* Layer */], {
      ariaLabel: ariaLabel,
      bgColor: colors["a" /* COLORS */].WHITE,
      buttonLeft: leftButton,
      closeLabel: Object(src_i18n["h" /* t */])('common.close'),
      hasAnimateEnter: true,
      hasContainerHeader: true,
      onClose: closeLayer
    }, state.detail ? renderDetail(state.detail) : ProductInformationLayer_jsx("div", {
      "data-testid": "error",
      className: "p-px20"
    }, ProductInformationLayer_jsx("div", {
      className: "max-w-site mx-auto flex justify-center"
    }, ProductInformationLayer_jsx(Confirmation["a" /* Confirmation */], {
      status: "error",
      title: errorMessage
    }))));
  };

  return state.isOpen && !state.isLoading ? renderActiveDetail() : state.isLoading && ProductInformationLayer_jsx("div", {
    id: "loading",
    className: "relative z-4"
  }, ProductInformationLayer_jsx(Backdrop["a" /* Backdrop */], {
    bgColor: "#fff",
    opacity: 0.95
  }, ProductInformationLayer_jsx("div", {
    "aria-live": "polite",
    className: "absolute text-center top-1/2 left-1/2 -translate-50",
    style: {
      width: '13rem'
    }
  }, ProductInformationLayer_jsx("span", {
    className: "sr-only"
  }, "Loading"), ProductInformationLayer_jsx(Spinner["a" /* Spinner */], {
    "data-testid": "Spinner",
    iconName: icons["a" /* ICONS */].TRIDENT1
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-information-slider/ProductInformationSlider.container.jsx







var ProductInformationSlider_container_jsx = react_default.a.createElement;








var ProductInformationSlider_container_ProductInformationSliderContainer = function _ProductInformationSliderContainer(props) {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  var _useState = Object(react["useState"])(-1),
      activeItem = _useState[0],
      setActiveItem = _useState[1];

  var queryLayer = props.queryLayer,
      sliderIndex = props.sliderIndex,
      location = props.location;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location); // -1_-1 is the default value of queryparam to initialise sliderIndex and activeItem (-1)

  var active = Object(lodash["get"])(uri.query(true), queryLayer, '-1_-1');

  var _active$split = active.split('_'),
      _active$split2 = Object(slicedToArray["a" /* default */])(_active$split, 2),
      uriSliderIndex = _active$split2[0],
      uriActiveItem = _active$split2[1];

  Object(react["useEffect"])(function () {
    if (uri.hasQuery(queryLayer, /^[0-9]_[0-9]*$/) && Number(uriSliderIndex) === sliderIndex) {
      setActiveItem(uriActiveItem);
    }
  }, [location]);

  var toggleLayer = function toggleLayer(item, layer) {
    // using window.history replaceState to add or remove queryParam in silent mode (without triggering component rerender)
    var newUrl = uri.clone();

    if (layer) {
      newUrl = newUrl.addQuery(Object(defineProperty["a" /* default */])({}, queryLayer, "".concat(sliderIndex, "_").concat(item)));
      window.history.pushState(null, null, Object(DynamicLinkUtil["b" /* getSpaUrl */])(newUrl));
    } else {
      newUrl = newUrl.removeQuery(Object(defineProperty["a" /* default */])({}, queryLayer, "".concat(sliderIndex, "_").concat(uriActiveItem)));
      window.history.replaceState(null, null, Object(DynamicLinkUtil["b" /* getSpaUrl */])(newUrl));
    }

    setActiveItem(item);
  };

  return ProductInformationSlider_container_jsx(react["Fragment"], null, ProductInformationSlider_container_jsx(ProductInformationSlider_ProductInformationSlider, Object(esm_extends["a" /* default */])({}, props, {
    toggleLayer: toggleLayer
  })), ProductInformationSlider_container_jsx(ProductInformationLayer_ProductInformationLayer, Object(esm_extends["a" /* default */])({}, props, {
    activeItem: activeItem,
    toggleLayer: toggleLayer
  })));
};

var ProductInformationSliderContainer = Object(withRouter["a" /* withRouter */])(ProductInformationSlider_container_ProductInformationSliderContainer);
// EXTERNAL MODULE: ./src/client/components/frameworks/image-slideshow/ImageSlideShow.jsx
var ImageSlideShow = __webpack_require__("DQFb");

// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.themes.js
var TeaserCard_themes_themes = {
  "default": {
    thRoot: 'flex flex-col',
    thRootActive: '',
    thChildren: '',
    thChildrenActive: '',
    thImage: 'bg-gray-darker rounded-tiny -order-1 overflow-hidden transition-all',
    thImageActive: 'opacity-75 scale-095'
  },
  "short": {
    thRoot: 'flex flex-col shadow-sm relative rounded-small overflow-hidden h-full transition-all',
    thChildren: 'p-px15 md:p-px20 h-full',
    thRootActive: 'shadow-md',
    thImage: 'bg-gray-darker rounded-tiny -order-1 flex-shrink-0 overflow-hidden transition-all'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/teaser-card/TeaserCard.jsx

var TeaserCard_jsx = react_default.a.createElement;






var TeaserCard_TeaserCard = function TeaserCard(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasInsetBorder = _ref.hasInsetBorder,
      isActive = _ref.isActive,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel,
      _ref$ratio = _ref.ratio,
      ratio = _ref$ratio === void 0 ? ratios_utils["a" /* default */].R_38_BY_28 : _ref$ratio,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      width = _ref.width;
  var defaultPicture = media[0] || {};
  var _themes$theme = TeaserCard_themes_themes[theme],
      thRoot = _themes$theme.thRoot,
      thRootActive = _themes$theme.thRootActive,
      thChildren = _themes$theme.thChildren,
      thChildrenActive = _themes$theme.thChildrenActive,
      thImage = _themes$theme.thImage,
      thImageActive = _themes$theme.thImageActive;
  return TeaserCard_jsx("div", {
    className: classnames_default()(className, thRoot, Object(defineProperty["a" /* default */])({
      'h-full': media.length <= 1
    }, thRootActive, isActive)),
    style: {
      width: width
    }
  }, TeaserCard_jsx("div", {
    className: classnames_default()(thChildren, Object(defineProperty["a" /* default */])({}, thChildrenActive, isActive))
  }, children), TeaserCard_jsx("div", {
    className: classnames_default()(thImage, Object(defineProperty["a" /* default */])({}, thImageActive, isActive))
  }, media.length > 1 ? TeaserCard_jsx(ImageSlideShow["a" /* ImageSlideShow */], {
    hasControlsOnHover: true,
    hasInsetBorder: hasInsetBorder,
    hasLazyLoading: true,
    media: media,
    nextLabel: nextLabel,
    previousLabel: previousLabel,
    ratio: ratio
  }) : TeaserCard_jsx(Image["b" /* default */], {
    altMsg: defaultPicture.alt,
    className: hasInsetBorder ? 'inset-border-after' : '',
    groupKey: "thumbnails",
    hasLazyLoading: true,
    imageUrl: defaultPicture.src,
    key: defaultPicture.src,
    ratioKey: ratio,
    ratioDisplay: 1 / 4
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/teaser-cards/teaser-cards-card/TeaserCardsCard.jsx


var TeaserCardsCard_jsx = react_default.a.createElement;






var TeaserCardsCard_TeaserCardsCard = function TeaserCardsCard(_ref) {
  var card = _ref.card,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      trackingData = _ref.trackingData;
  var image = card.image,
      title = card.title,
      subtitle = card.subtitle,
      seeMoreLabel = card.seeMoreLabel;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return TeaserCardsCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, link, {
    as: link.onClick ? 'button' : DynamicLink["a" /* default */],
    className: "reset-button block relative tap-highlight-color-transparent text-initial w-full",
    "data-testid": "TeaserCard",
    onMouseEnter: isDesktop ? function () {
      return setHovering(true);
    } : null,
    onMouseLeave: isDesktop ? function () {
      return setHovering(false);
    } : null,
    trackingData: trackingData
  }), TeaserCardsCard_jsx(TeaserCard_TeaserCard, {
    className: "w-full",
    isActive: isHovering,
    media: [{
      src: image
    }]
  }, !!title && TeaserCardsCard_jsx("p", {
    className: "reset-paragraph my-px15 text-center text-md"
  }, Object(string_util["d" /* truncate */])(title, 35, true)), !!subtitle && TeaserCardsCard_jsx("p", {
    className: "reset-paragraph font-normal font-sans leading-normal my-px15 text-base text-gray-darker"
  }, Object(string_util["d" /* truncate */])(subtitle, 65, true)), !!seeMoreLabel && TeaserCardsCard_jsx("p", {
    className: "reset-paragraph my-px15 text-center text-sm underline"
  }, seeMoreLabel)));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/badge/Badge.jsx + 1 modules
var Badge = __webpack_require__("VHif");

// EXTERNAL MODULE: ./src/client/components/widgets/multimedia/Multimedia.jsx + 10 modules
var Multimedia = __webpack_require__("h3D+");

// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.themes.js
var Sheet_themes_themes = {
  "default": function _default(_ref) {
    var hasDiamond = _ref.hasDiamond,
        hasSlideshow = _ref.hasSlideshow,
        isDesktop = _ref.isDesktop,
        isTablet = _ref.isTablet,
        isExclusiveCollection = _ref.isExclusiveCollection;
    var thTopStyles = isDesktop ? {
      marginBottom: '3.4375rem'
    } : {
      marginBottom: '2.1875rem'
    };
    var thTopStylesWithoutDiamond = isTablet ? {
      marginBottom: '0.6875rem',
      marginTop: '3.375rem'
    } : {};
    return {
      thRoot: 'bg-white',
      thHeader: '',
      thHeaderContainer: 'mx-auto w-full max-w-site-medium',
      thTop: 'relative',
      thTopStyles: hasDiamond ? thTopStyles : thTopStylesWithoutDiamond,
      thHero: hasSlideshow ? 'absolute overflow-hidden inset-0' : '',
      thHeroStyles: hasSlideshow ? {
        minHeight: '102%',
        filter: 'blur(10px)',
        opacity: '0.25'
      } : {},
      thSlideshow: "my-0 mx-auto w-full ".concat(isExclusiveCollection ? 'bg-nude' : 'bg-gray-darker'),
      thSlideshowStyles: {},
      thMultimediaOverlay: 'absolute inset-0 mb-px10',
      thDiamond: 'absolute bottom-0 left-1/2 -translate-x-50 translate-y-50 -mb-2px',
      thDiamondClassName: 'font-bold uppercase text-xs sm:text-sm',
      thDiamondSize: isDesktop ? 75 : 60,
      thBody: 'px-px20 py-px20 lg:py-px15',
      thContent: 'max-w-site-medium mx-auto w-full',
      thFooter: 'bg-gray-lighter overflow-hidden px-px20'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/sheet/Sheet.jsx


var Sheet_jsx = react_default.a.createElement;










function Sheet(props) {
  var children = props.children,
      header = props.header,
      className = props.className,
      diamond = props.diamond,
      immersive = props.immersive,
      isExclusiveCollection = props.isExclusiveCollection,
      footer = props.footer,
      multimedia = props.multimedia,
      _props$slideshow = props.slideshow,
      slideshow = _props$slideshow === void 0 ? {} : _props$slideshow,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop,
      isTablet = _useContext.isTablet;

  var _useState = Object(react["useState"])(0),
      imageIndex = _useState[0],
      setImageIndex = _useState[1];

  if (!react["Children"].count(children)) return null;
  var hasSlideshow = !Object(lodash["isEmpty"])(slideshow.media);
  var hasDiamond = !Object(lodash["isEmpty"])(diamond);

  var _themes$theme = Sheet_themes_themes[theme]({
    hasDiamond: hasDiamond,
    hasSlideshow: hasSlideshow,
    isDesktop: isDesktop,
    isTablet: isTablet,
    isExclusiveCollection: isExclusiveCollection
  }),
      thBody = _themes$theme.thBody,
      thContent = _themes$theme.thContent,
      thDiamond = _themes$theme.thDiamond,
      thDiamondClassName = _themes$theme.thDiamondClassName,
      thDiamondSize = _themes$theme.thDiamondSize,
      thFooter = _themes$theme.thFooter,
      thHeader = _themes$theme.thHeader,
      thHeaderContainer = _themes$theme.thHeaderContainer,
      thHero = _themes$theme.thHero,
      thHeroStyles = _themes$theme.thHeroStyles,
      thMultimediaOverlay = _themes$theme.thMultimediaOverlay,
      thRoot = _themes$theme.thRoot,
      thSlideshow = _themes$theme.thSlideshow,
      thSlideshowStyles = _themes$theme.thSlideshowStyles,
      thTop = _themes$theme.thTop,
      thTopStyles = _themes$theme.thTopStyles;

  return Sheet_jsx("section", {
    className: classnames_default()(thRoot, className)
  }, header && Sheet_jsx("div", {
    className: thHeaderContainer,
    "data-testid": "Sheet-header"
  }, Sheet_jsx("div", {
    className: thHeader
  }, header)), (!Object(lodash["isEmpty"])(immersive) || hasSlideshow) && Sheet_jsx("div", {
    className: thTop,
    style: thTopStyles
  }, !Object(lodash["isEmpty"])(immersive) && !hasSlideshow && Sheet_jsx("div", {
    className: thHero
  }, Sheet_jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, immersive, {
    size: "medium",
    style: thHeroStyles
  }))), hasSlideshow && Sheet_jsx(react_default.a.Fragment, null, Sheet_jsx("div", {
    className: thSlideshow,
    style: thSlideshowStyles
  }, Sheet_jsx(ImageSlideShow["a" /* ImageSlideShow */], Object(esm_extends["a" /* default */])({
    media: slideshow.media,
    nbItemsToShow: 1,
    center: isTablet,
    fadeUnseenItems: isTablet,
    spacerWidth: isTablet ? 5 : 0,
    ratio: ratios_utils["a" /* default */].XL,
    onChangeIndex: setImageIndex
  }, slideshow)), Sheet_jsx("div", {
    className: "absolute rtl:left-0 md:bottom-0 md:top-auto top-0 mx-px10 md:mx-px20 my-px10 px-px15 py-px10 bg-overlay-gray-darker-80 text-white rounded-small text-base shadow-sm"
  }, "".concat(imageIndex + 1, "/").concat(slideshow.media.length))), !Object(lodash["isEmpty"])(multimedia) && Sheet_jsx("div", {
    className: thMultimediaOverlay
  }, Sheet_jsx(Multimedia["a" /* Multimedia */], Object(esm_extends["a" /* default */])({}, multimedia, {
    className: "h-full flex flex-col",
    hasFullScreenButton: true,
    initialIndex: imageIndex
  })))), hasDiamond && Sheet_jsx("div", {
    className: thDiamond
  }, Sheet_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({
    className: thDiamondClassName,
    size: thDiamondSize
  }, diamond, {
    variant: "diamond"
  })))), Sheet_jsx("div", {
    className: thBody,
    "data-testid": "Sheet-body"
  }, Sheet_jsx("div", {
    className: thContent
  }, children)), !!footer && Sheet_jsx("footer", {
    className: thFooter
  }, Sheet_jsx("div", {
    className: thContent
  }, footer)));
}
// CONCATENATED MODULE: ./src/client/components/widgets/teaser-cards/teaser-cards-layer/TeaserCardsLayer.jsx



var TeaserCardsLayer_jsx = react_default.a.createElement;







var TeaserCardsLayer_TeaserCardsLayer = function TeaserCardsLayer(_ref) {
  var image = _ref.image,
      title = _ref.title,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? '' : _ref$description,
      _ref$blocks = _ref.blocks,
      blocks = _ref$blocks === void 0 ? [] : _ref$blocks;
  return TeaserCardsLayer_jsx(Sheet, {
    immersive: {
      url: image
    }
  }, !!title && TeaserCardsLayer_jsx(Title["a" /* Title */], {
    className: "mb-px30",
    theme: "title-sans-8"
  }, title), !!description && TeaserCardsLayer_jsx(Text["a" /* Text */], {
    className: "mb-px30",
    text: description
  }), !Object(lodash["isEmpty"])(blocks) && TeaserCardsLayer_jsx("div", {
    className: "flex flex-wrap -mx-px10 -my-px20"
  }, blocks.map(function (_ref2, index) {
    var blockTitle = _ref2.title,
        blockText = _ref2.text;
    return blockTitle && blockText ? TeaserCardsLayer_jsx("div", {
      className: "px-px10 py-px20 w-full sm:w-1/2",
      key: index
    }, TeaserCardsLayer_jsx(Card["a" /* Card */], {
      heading: {
        hLevel: 3,
        title: blockTitle
      },
      layout: Card_constants["a" /* COLUMN_1 */],
      text: {
        text: blockText
      }
    })) : null;
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/teaser-cards/TeaserCards.jsx




var TeaserCards_jsx = react_default.a.createElement;




function resolveLayerData(cardData) {
  var image = cardData.image,
      title = cardData.layerTitle,
      description = cardData.layerDescription,
      blocks = cardData.layerBlocks;
  return Promise.resolve({
    image: image,
    title: title,
    description: description,
    blocks: blocks
  });
}
var TeaserCards_TeaserCards = function TeaserCards(props) {
  var _props$cards = props.cards,
      cards = _props$cards === void 0 ? [] : _props$cards,
      backNavigationLabel = props.backNavigationLabel,
      scrollBackwardLabel = props.scrollBackwardLabel,
      scrollForwardLabel = props.scrollForwardLabel,
      sliderQueryName = props.sliderQueryName;
  return TeaserCards_jsx(ProductInformationSliderContainer, {
    backNavigationLabel: backNavigationLabel,
    isExpanded: true,
    queryLayer: sliderQueryName,
    renderDetail: function renderDetail(layerData) {
      return TeaserCards_jsx(TeaserCardsLayer_TeaserCardsLayer, layerData);
    },
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel,
    sliderIndex: 1
  }, cards.map(function (card, index) {
    return TeaserCards_jsx(TeaserCardsCard_TeaserCardsCard, {
      card: card,
      fetchDetail: function fetchDetail() {
        return resolveLayerData(card);
      },
      key: index,
      link: card.link // Component takes card link as separate prop so it can be cloned with a slider link
      ,
      trackingData: card.trackingData
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/teaser-cards-line/TeaserCardsLine.jsx










var TeaserCardsLine_jsx = react_default.a.createElement;

function TeaserCardsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TeaserCardsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TeaserCardsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TeaserCardsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var TeaserCardsLine_TeaserCardsLine = function TeaserCardsLine(_ref) {
  var cards = _ref.cards,
      _ref$config$common = _ref.config.common,
      backNavigation = _ref$config$common.backNavigation,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      header = _ref.header,
      id = _ref.id,
      title = _ref.title;
  var teaserCards = (cards || []).map(function (card) {
    var seeMoreUrl = card.seeMoreUrl,
        cardtitle = card.title,
        rest = Object(objectWithoutProperties["a" /* default */])(card, ["seeMoreUrl", "title"]);

    var link = {};

    if (seeMoreUrl) {
      link.url = seeMoreUrl;
    }

    return TeaserCardsLine_objectSpread(TeaserCardsLine_objectSpread({}, rest), {}, {
      title: cardtitle,
      link: link,
      trackingData: {
        actionGA: title,
        labelGA: title
      }
    });
  });
  return TeaserCardsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, TeaserCardsLine_jsx(LineTitle["a" /* LineTitle */], null, title), TeaserCardsLine_jsx(TeaserCards_TeaserCards, {
    backNavigationLabel: backNavigation,
    cards: teaserCards,
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    sliderQueryName: Object(string_util["a" /* camelCasify */])(header)
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/teaser-cards/teaserCards.resolver.js
var teaserCards_resolver = __webpack_require__("yLnO");

// CONCATENATED MODULE: ./src/client/cms/toolkit/teaser-cards/teaserCards.descriptor.js



var teaserCardsDescriptor = {
  name: constants["Bb" /* TEASER_CARDS */],
  component: TeaserCardsLine_TeaserCardsLine,
  resolve: teaserCards_resolver["a" /* teaserCardsResolver */].resolve
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.number.is-nan.js
var es_number_is_nan = __webpack_require__("ssvU");

// EXTERNAL MODULE: ./src/client/context/ABTestContext.js
var ABTestContext = __webpack_require__("hfZn");

// CONCATENATED MODULE: ./src/client/cms/toolkit/test-ab/TestAB.jsx



var TestAB_jsx = react_default.a.createElement;




var TestAB_TestAB = function TestAB(props) {
  var tests = Object(react["useContext"])(ABTestContext["a" /* ABTestContext */]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isAppMounted = _useContext.isAppMounted;

  if (!isAppMounted) {
    return null;
  }

  var idx = tests[props.name] ? Number(tests[props.name]) : 0;
  var variation = props.lines[!Number.isNaN(idx) ? idx : 0];
  var VariationComponent = descriptorsLibrary[variation.name].component;
  return TestAB_jsx(react["Fragment"], null, TestAB_jsx(VariationComponent, variation.props));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/test-ab/testAB.descriptor.js


var testABDescriptor = {
  name: constants["Cb" /* TEST_AB */],
  component: TestAB_TestAB
};
// CONCATENATED MODULE: ./src/client/components/lines/text-line/TextLine.jsx

var TextLine_jsx = react_default.a.createElement;



function TextLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return TextLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, TextLine_jsx(Text["a" /* Text */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/text/text.descriptor.js


var textDescriptor = {
  name: constants["Db" /* TEXT */],
  component: TextLine
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// CONCATENATED MODULE: ./src/client/components/lines/thematic-line/ThematicCard.jsx










var ThematicCard_jsx = react_default.a.createElement;

function ThematicCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ThematicCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ThematicCard_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ThematicCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var ThematicCard_ThematicCard = function ThematicCard(_ref) {
  var _ref2;

  var isExclusiveCollection = _ref.isExclusiveCollection,
      mediaUrl = _ref.mediaUrl,
      itemTitle = _ref.itemTitle,
      link = _ref.link,
      isFirst = _ref.isFirst;

  var _useState = Object(react["useState"])(false),
      isHover = _useState[0],
      setHover = _useState[1];

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet;

  var blockDimensions = isTablet ? {
    height: '235px',
    width: '180px'
  } : {
    height: '313px',
    width: '240px'
  };

  var handleFocus = function handleFocus() {
    setHover(true);
  };

  var handleBlur = function handleBlur() {
    setHover(false);
  };

  var TagName = link ? TrackClick["a" /* TrackClick */] : react["Fragment"];
  var thematicTitle = itemTitle ? itemTitle : '';
  var trackingData = {
    actionGA: 'push_content_thematic',
    labelGA: "".concat(thematicTitle).trim()
  };
  var conditionalTagNameProps = link ? {
    as: DynamicLink["a" /* default */],
    url: link,
    trackingData: trackingData,
    className: 'z-1'
  } : {};
  return ThematicCard_jsx("div", {
    style: ThematicCard_objectSpread(ThematicCard_objectSpread({}, blockDimensions), {}, {
      flexShrink: '0'
    }),
    onMouseEnter: handleFocus,
    onMouseLeave: handleBlur,
    onFocus: handleFocus,
    onBlur: handleBlur,
    "data-testid": "ThematicLine-item",
    className: classnames_default()('rounded-tiny overflow-hidden p-px10 py-px25 rtl:ml-px20 text-center flex items-end justify-center relative', {
      'inset-border-after font-serif': isExclusiveCollection
    }, {
      'lg:rtl:ml-0': isFirst
    })
  }, ThematicCard_jsx(Image["b" /* default */], {
    className: classnames_default()('absolute inset-0 transition-transform', {
      'scale-105': isHover && link
    }),
    altMsg: "",
    imageUrl: mediaUrl,
    dimensions: {
      h: 313,
      w: 240
    },
    ratioDisplay: 1 / 3
  }), ThematicCard_jsx("div", {
    style: (_ref2 = {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,

      /* eslint-disable no-dupe-keys */
      background: '-moz-linear-gradient(top, rgba(0,0,0,0) 50%, rgba(0,0,0,0.4) 100%)'
    }, Object(defineProperty["a" /* default */])(_ref2, "background", '-webkit-linear-gradient(top, rgba(0,0,0,0) 50%,rgba(0,0,0,0.4) 100%)'), Object(defineProperty["a" /* default */])(_ref2, "background", 'linear-gradient(to bottom, rgba(0,0,0,0) 50%,rgba(0,0,0,0.4) 100%)'), _ref2)
  }), ThematicCard_jsx(TagName, conditionalTagNameProps, ThematicCard_jsx("div", {
    className: classnames_default()('absolute inset-0', {
      'z-1': !!link
    })
  }), ThematicCard_jsx("div", {
    className: "relative text-white text-xl leading-tight font-bold"
  }, itemTitle)));
};
// CONCATENATED MODULE: ./src/client/components/lines/thematic-line/ThematicLine.jsx


var ThematicLine_jsx = react_default.a.createElement;








var ThematicLine_ThematicLine = function ThematicLine(_ref) {
  var title = _ref.title,
      items = _ref.items,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  return ThematicLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: "thematic"
  }, ThematicLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, !!title && ThematicLine_jsx(LineTitle["a" /* LineTitle */], {
    color: color
  }, title), ThematicLine_jsx("div", {
    className: "-mx-px20 lg:m-0 w-screen lg:w-full"
  }, ThematicLine_jsx(Slider["a" /* Slider */], {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollControlsClassName: "-mx-px20 lg:mx-0",
    scrollItemClassName: "overflow-hidden flex-none max-w-full"
  }, items.map(function (_ref2, index) {
    var isExclusiveCollection = _ref2.isExclusiveCollection,
        itemTitle = _ref2.itemTitle,
        link = _ref2.link,
        mediaUrl = _ref2.mediaUrl;
    return ThematicLine_jsx(ThematicCard_ThematicCard, {
      isExclusiveCollection: isExclusiveCollection,
      isFirst: index === 0,
      itemTitle: itemTitle,
      link: link,
      key: itemTitle,
      mediaUrl: mediaUrl
    });
  })))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/thematic/thematic.resolver.js




var thematicResolver = {
  name: constants["Eb" /* THEMATIC */],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common { next previous scrollBackward scrollForward }\n      }\n    }";
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Jb" /* LINE_COMMON_THEMATIC */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return data;
    });
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/thematic/thematic.descriptor.js



var thematicDescriptor = {
  name: constants["Eb" /* THEMATIC */],
  component: ThematicLine_ThematicLine,
  resolve: thematicResolver.resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/introduction/Introduction.jsx + 1 modules
var Introduction = __webpack_require__("pNXd");

// CONCATENATED MODULE: ./src/client/components/lines/title-and-text-line/TitleAndTextLine.jsx
var TitleAndTextLine_jsx = react_default.a.createElement;




var TitleAndTextLine_TitleAndTextLine = function TitleAndTextLine(_ref) {
  var config = _ref.config,
      hasShadow = _ref.hasShadow,
      icon = _ref.icon,
      id = _ref.id,
      smallTitle = _ref.smallTitle,
      subTitle = _ref.subTitle,
      text = _ref.text,
      theme = _ref.theme,
      title = _ref.title;
  return TitleAndTextLine_jsx("div", {
    className: classnames_default()('Line', {
      'border-b-1 border-t-1 border-gray-light Line-Introduction shadow-md': hasShadow,
      'Line-TitleAndText': !hasShadow
    }),
    id: id
  }, TitleAndTextLine_jsx(SiteContainer["a" /* SiteContainer */], null, TitleAndTextLine_jsx(Introduction["a" /* Introduction */], {
    className: hasShadow ? 'py-px20' : '',
    iconName: icon,
    isTextSeeMoreCollapseEnabled: true,
    small: smallTitle,
    seeMoreLabel: config.common.viewMore,
    seeLessLabel: config.common.loadLess,
    subtitle: subTitle,
    text: text,
    theme: theme,
    title: title
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/title-and-text/titleAndText.resolver.js
var titleAndText_resolver = __webpack_require__("BXQg");

// CONCATENATED MODULE: ./src/client/cms/toolkit/title-and-text/titleAndText.descriptor.js



var titleAndTextDescriptor = {
  name: constants["Fb" /* TITLE_AND_TEXT */],
  component: TitleAndTextLine_TitleAndTextLine,
  resolve: titleAndText_resolver["a" /* titleAndTextResolver */].resolve
};
// EXTERNAL MODULE: ./config/index.js
var config_0 = __webpack_require__("rOcY");
var config_default = /*#__PURE__*/__webpack_require__.n(config_0);

// EXTERNAL MODULE: ./src/hooks/use-debounce/useDebounce.js
var useDebounce = __webpack_require__("ngAq");

// EXTERNAL MODULE: ./src/hooks/use-script-loader/useScriptLoader.js
var useScriptLoader = __webpack_require__("/WwO");

// CONCATENATED MODULE: ./src/client/components/lines/travel-restrictions-line/TravelSherpaWidget.jsx









var TravelSherpaWidget_jsx = react_default.a.createElement;

function TravelSherpaWidget_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function TravelSherpaWidget_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TravelSherpaWidget_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TravelSherpaWidget_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var supportedLang = ['de', 'en', 'es', 'fr', 'it', 'ja-JP', 'ko', 'pt-BR', 'pt-PT', 'nl', 'ru', 'sv-SE', 'tr', 'zh'];

var getLang = function getLang(_ref) {
  var locale = _ref.locale,
      language = _ref.language;

  if (locale === 'se-SE') {
    return 'sv-SE';
  }

  if (supportedLang.includes(locale)) {
    return locale;
  }

  if (supportedLang.includes(language)) {
    return language;
  }

  return 'en';
};

var travelSherpaScriptUrl = config_default.a.get('travelSherpa.scriptUrl');

var TravelSherpaWidget_formatDateforTravelSherpa = function formatDateforTravelSherpa(date) {
  return moment_default()(date).format('YYYY-MM-DD');
};

var elementConfig = function elementConfig(_ref2) {
  var departureDate = _ref2.departureDate,
      returnDate = _ref2.returnDate,
      lang = _ref2.lang,
      resort = _ref2.resort,
      withInboundOutbound = _ref2.withInboundOutbound;
  return TravelSherpaWidget_objectSpread({
    language: lang,
    placement: 'mmb'
  }, resort && TravelSherpaWidget_objectSpread({
    travellers: [{
      nationality: resort.travelSherpaOutbound
    }]
  }, withInboundOutbound && resort.travelSherpaOutbound !== resort.travelSherpaInbound && {
    segments: [TravelSherpaWidget_objectSpread({
      segmentType: 'OUTBOUND',
      origin: {
        countryCode: resort.travelSherpaOutbound
      },
      destination: {
        countryCode: resort.travelSherpaInbound
      }
    }, departureDate && {
      departureDate: TravelSherpaWidget_formatDateforTravelSherpa(departureDate)
    }), TravelSherpaWidget_objectSpread(TravelSherpaWidget_objectSpread({
      segmentType: 'RETURN',
      origin: {
        countryCode: resort.travelSherpaInbound
      },
      destination: {
        countryCode: resort.travelSherpaOutbound
      }
    }, returnDate && {
      arrivalDate: returnDate
    }), returnDate && {
      departureDate: returnDate
    })]
  }));
};

var TravelSherpaWidget_TravelSherpaWidget = function TravelSherpaWidget(_ref3) {
  var className = _ref3.className,
      disclaimer = _ref3.disclaimer,
      resort = _ref3.resort,
      _ref3$withInboundOutb = _ref3.withInboundOutbound,
      withInboundOutbound = _ref3$withInboundOutb === void 0 ? true : _ref3$withInboundOutb;
  Object(useScriptLoader["a" /* useScriptLoader */])(travelSherpaScriptUrl);

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      language = _useContext.language,
      locale = _useContext.locale;

  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var returnDate = departureDate && duration && TravelSherpaWidget_formatDateforTravelSherpa(moment_default()(departureDate).add(duration, 'days'));
  var debouncedCriteria = Object(useDebounce["a" /* useDebounce */])([departureDate, duration], 500);
  var lang = getLang({
    language: language,
    locale: locale
  });
  Object(react["useEffect"])(function () {
    var travelSherpaconfig = elementConfig({
      departureDate: departureDate,
      returnDate: returnDate,
      lang: lang,
      resort: resort,
      withInboundOutbound: withInboundOutbound
    });

    if (typeof window.$sherpa !== 'undefined') {
      // $FlowFixMe
      window.$sherpa.V2.createElement('trip', travelSherpaconfig).mount('#sherpa-trip-element');
    } else {
      window.onSherpaEvent = function (event) {
        if (event.type === 'sdkLoaded') {
          // sdk is ready, create and mount new elements
          // $FlowFixMe
          window.$sherpa.V2.createElement('trip', travelSherpaconfig).mount('#sherpa-trip-element');
        }
      };
    }
  }, withInboundOutbound && resort && resort.travelSherpaOutbound !== resort.travelSherpaInbound ? [debouncedCriteria] : []);
  return TravelSherpaWidget_jsx("div", {
    className: className
  }, TravelSherpaWidget_jsx("div", {
    id: "sherpa-trip-element"
  }), TravelSherpaWidget_jsx("p", {
    className: "text-xs font-sans"
  }, disclaimer));
};
// CONCATENATED MODULE: ./src/client/components/lines/travel-restrictions-line/TravelRestrictionsLine.jsx

var TravelRestrictionsLine_jsx = react_default.a.createElement;










function TravelRestrictionsLine(_ref) {
  var crisisAlert = _ref.crisisAlert,
      id = _ref.id,
      loadMore = _ref.loadMore,
      resort = _ref.resort,
      title = _ref.title,
      disclaimer = _ref.travelSherpa.disclaimer;
  var track = Object(useTracking["a" /* useTracking */])();

  var trackExpand = function trackExpand(_, isExpanded) {
    if (!isExpanded) {
      track({
        actionGA: 'travelRestrictions',
        labelGA: 'checkCountryRestrictions'
      });
    }
  };

  var shouldShowTravelSherpaWidget = !resort || resort.travelSherpaOutbound !== resort.travelSherpaInbound;

  if (!shouldShowTravelSherpaWidget && !(crisisAlert === null || crisisAlert === void 0 ? void 0 : crisisAlert.message)) {
    return null;
  }

  return TravelRestrictionsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, TravelRestrictionsLine_jsx("span", {
    className: "font-brand text-xl text-blue"
  }, title), TravelRestrictionsLine_jsx("div", {
    className: "md:flex pt-px20"
  }, TravelRestrictionsLine_jsx("div", {
    className: "flex justify-center mx-px40"
  }, TravelRestrictionsLine_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].SAFE_TOGETHER,
    width: "135px"
  })), (crisisAlert === null || crisisAlert === void 0 ? void 0 : crisisAlert.message) ? TravelRestrictionsLine_jsx(SeeMore["a" /* SeeMore */], {
    className: "mt-px10 md:mt-0",
    classNameButton: "rtl:text-right",
    hasDynamicHeight: shouldShowTravelSherpaWidget,
    hasNoScrollOnCollapse: !shouldShowTravelSherpaWidget,
    isCollapseEnabled: true,
    onClick: trackExpand,
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: loadMore,
    seeMoreSize: 90
  }, TravelRestrictionsLine_jsx(CrisisAlert_CrisisAlert, {
    icon: icons["a" /* ICONS */].WARNING,
    message: crisisAlert.message,
    linkLabel: crisisAlert.link.label,
    linkUrl: crisisAlert.link.url
  }), shouldShowTravelSherpaWidget && TravelRestrictionsLine_jsx(TravelSherpaWidget_TravelSherpaWidget, {
    disclaimer: disclaimer,
    resort: resort,
    className: "mt-px25 md:mt-px30"
  })) : TravelRestrictionsLine_jsx(TravelSherpaWidget_TravelSherpaWidget, {
    disclaimer: disclaimer,
    resort: resort,
    withInboundOutbound: false
  })));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/travel-restrictions/travelRestrictions.resolver.js
var travelRestrictions_resolver = __webpack_require__("aBEZ");

// CONCATENATED MODULE: ./src/client/cms/toolkit/travel-restrictions/travelRestrictions.descriptor.js



var travelRestrictionsDescriptor = {
  name: constants["Jb" /* TRAVEL_RESTRICTIONS */],
  component: TravelRestrictionsLine,
  resolve: travelRestrictions_resolver["a" /* travelRestrictionsResolver */]
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-testimony/TripadvisorTestimony.jsx

var TripadvisorTestimony_jsx = react_default.a.createElement;









var TRIPADVISOR_RATINGS_SVG = {
  '4': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/4.0-24206-5.svg',
  '5': 'https://www.tripadvisor.fr/img/cdsi/img2/ratings/traveler/5.0-24206-5.svg'
};
var QUOTATION_MARK_COLOR = '#E6EEF3';
var TripadvisorTestimony_TripadvisorTestimony = function TripadvisorTestimony(_ref) {
  var author = _ref.author,
      className = _ref.className,
      date = _ref.date,
      fullCommentLink = _ref.fullCommentLink,
      link = _ref.link,
      onBy = _ref.onBy,
      stars = _ref.stars,
      style = _ref.style,
      text = _ref.text;
  return TripadvisorTestimony_jsx("blockquote", {
    cite: fullCommentLink,
    className: classnames_default()(className, 'flex flex-col items-center m-0 py-px15'),
    style: style
  }, TripadvisorTestimony_jsx("div", {
    className: "flex flex-col md:rtl:flex-row items-center justify-center w-full"
  }, TripadvisorTestimony_jsx(Icon["a" /* Icon */], {
    className: "md:self-start mb-px15 md:rtl:mr-px25",
    hasRtl: true,
    name: icons["a" /* ICONS */].QUOTATION_MARK,
    style: {
      color: QUOTATION_MARK_COLOR
    },
    width: "2rem"
  }), TripadvisorTestimony_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    rel: "nofollow",
    trackingData: {
      actionGA: 'push_content_testimony',
      labelGA: 'seeFullComment'
    },
    url: fullCommentLink
  }, TripadvisorTestimony_jsx(Text["a" /* Text */], {
    theme: "text-brand-1",
    text: text,
    color: colors["a" /* COLORS */].BLUE,
    className: "text-center max-w-site-small"
  })), TripadvisorTestimony_jsx(Icon["a" /* Icon */], {
    className: "hidden md:inline-block self-end rtl:ml-px25",
    hasRtl: true,
    name: icons["a" /* ICONS */].QUOTATION_MARK,
    rotation: 180,
    style: {
      color: QUOTATION_MARK_COLOR
    },
    width: "2rem"
  })), TripadvisorTestimony_jsx("p", {
    className: "flex flex-col md:rtl:flex-row items-center justify-center"
  }, TripadvisorTestimony_jsx("img", {
    alt: "",
    className: "md:rtl:mr-px10 my-px10 md:my-0",
    src: TRIPADVISOR_RATINGS_SVG[stars]
  }), TripadvisorTestimony_jsx(TemplateString["a" /* TemplateString */], {
    className: "text-center mt-px5",
    dataTestId: "tripadvisor-testimony-onby",
    template: onBy,
    values: {
      author: author,
      date: date
    },
    valuesClassName: {
      author: 'font-bold',
      date: 'font-bold'
    }
  }), (link === null || link === void 0 ? void 0 : link.url) && TripadvisorTestimony_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "mt-px5 md:rtl:ml-px10 text-gray-darker underline",
    "data-testid": "tripadvisor-testimony-seemore",
    rel: "nofollow",
    trackingData: {
      actionGA: 'push_content_testimony',
      labelGA: 'seeMore'
    },
    url: link.url
  }, link.label)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-testimonies/TripadvisorTestimonies.jsx



var TripadvisorTestimonies_jsx = react_default.a.createElement;






var TripadvisorTestimonies_TripadvisorTestimonies = function TripadvisorTestimonies(_ref) {
  var className = _ref.className,
      items = _ref.items;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!(items === null || items === void 0 ? void 0 : items.length)) {
    return null;
  }

  if (items.length === 1) {
    return TripadvisorTestimonies_jsx(TripadvisorTestimony_TripadvisorTestimony, Object(esm_extends["a" /* default */])({}, items[0], {
      className: className
    }));
  }

  return TripadvisorTestimonies_jsx(Slider["a" /* Slider */], {
    className: className,
    cols: isTablet ? 1 : 0,
    hasControls: isTablet,
    navPosition: "center",
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollItemClassName: function scrollItemClassName(i) {
      return classnames_default()('overflow-hidden pl-px20 md:pl-0 flex-none max-w-full', {
        'pr-px20 md:pr-0': i === items.length - 1
      });
    }
  }, items.map(function (_ref2) {
    var author = _ref2.author,
        date = _ref2.date,
        fullCommentLink = _ref2.fullCommentLink,
        link = _ref2.link,
        onBy = _ref2.onBy,
        stars = _ref2.stars,
        text = _ref2.text;
    return TripadvisorTestimonies_jsx(TripadvisorTestimony_TripadvisorTestimony, {
      author: author,
      date: date,
      fullCommentLink: fullCommentLink,
      key: link.url,
      link: link,
      onBy: onBy,
      stars: stars,
      text: text,
      style: isTablet ? null : {
        width: '80vw'
      }
    });
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/tripadvisor-testimony-line/TripadvisorTestimonyLine.jsx
var TripadvisorTestimonyLine_jsx = react_default.a.createElement;




var TripadvisorTestimonyLine_TripadvisorTestimonyLine = function TripadvisorTestimonyLine(_ref) {
  var id = _ref.id,
      reviews = _ref.reviews;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  return TripadvisorTestimonyLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    dataTestId: "Line-TripadvisorTestimony",
    id: id,
    isWide: !isTablet
  }, TripadvisorTestimonyLine_jsx(TripadvisorTestimonies_TripadvisorTestimonies, {
    items: reviews
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/tripadvisor-testimony/tripadvisorTestimony.descriptor.js


var tripadvisorTestimonyDescriptor = {
  name: constants["Kb" /* TRIPADVISOR_TESTIMONY */],
  component: TripadvisorTestimonyLine_TripadvisorTestimonyLine
};
// EXTERNAL MODULE: ./src/client/components/frameworks/video/Video.jsx
var Video = __webpack_require__("akds");

// CONCATENATED MODULE: ./src/client/components/lines/video-line/VideoLine.jsx

var VideoLine_jsx = react_default.a.createElement;



function VideoLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return VideoLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, VideoLine_jsx(Video["a" /* Video */], props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/video/video.descriptor.js


var videoDescriptor = {
  name: constants["Lb" /* VIDEO */],
  component: VideoLine
};
// CONCATENATED MODULE: ./src/client/components/lines/highlight-line/HighlightLine.jsx


var HighlightLine_jsx = react_default.a.createElement;


var HighlightLine_HighlightLine = function HighlightLine(_ref) {
  var backgroundURL = _ref.backgroundURL,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["backgroundURL"]);

  return HighlightLine_jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    className: "Line Line-Highlight",
    hLevel: 2,
    size: props.size === 'small' ? 'highlightSmall' : 'highlight',
    trackingData: {
      actionGA: 'highlight'
    },
    url: backgroundURL
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/highlight/highlight.descriptor.js


var highlightDescriptor = {
  name: constants["q" /* HIGHLIGHT */],
  component: HighlightLine_HighlightLine
};
// CONCATENATED MODULE: ./src/client/components/lines/brand-promise-line/BrandPromiseLine.jsx




var BrandPromiseLine_jsx = react_default.a.createElement;














function getBadgeStylesFromIcon(isExclusiveCollectionIcon) {
  if (isExclusiveCollectionIcon) {
    return {
      iconContainer: '',
      iconContainerWidth: '122',
      iconContainerHeight: '72',
      icon: 'border-5 border-current p-px10',
      iconWidth: 'calc(100rem / 16)',
      isNotSquare: true
    };
  }

  return {
    iconContainer: 'rounded-full',
    iconContainerWidth: '84',
    iconContainerHeight: '84',
    icon: '',
    iconWidth: 'calc(31rem / 16)',
    isNotSquare: false
  };
}

function getTextStyles(isExclusiveCollection) {
  if (isExclusiveCollection) {
    return 'text-deepBlue font-serif';
  }

  return 'text-blue';
}

function getItemsToRender(items, hoveredItem, setHoveredItem) {
  var shouldShowPictures = items.every(function (item) {
    return !!item.mediaUrl;
  });
  return items.map(function (_ref, index) {
    var text = _ref.text,
        iconName = _ref.iconName,
        isExclusiveCollection = _ref.isExclusiveCollection,
        mediaUrl = _ref.mediaUrl,
        mediaAlt = _ref.mediaAlt,
        link = _ref.link;
    var TagName = link ? TrackClick["a" /* TrackClick */] : react["Fragment"];
    var iconTitle = iconName || '';
    var trackingData = {
      actionGA: 'push_content_brandPromise',
      labelGA: "".concat(iconTitle).trim()
    };
    var conditionalTagNameProps = link ? {
      as: DynamicLink["a" /* default */],
      url: link,
      trackingData: trackingData
    } : {};
    var isXCIcon = iconName === icons["a" /* ICONS */].EXCLUSIVE_COLLECTION;
    var isXC = isExclusiveCollection || isXCIcon;
    var textStyles = getTextStyles(isXC);
    var badgeStyles = getBadgeStylesFromIcon(isXCIcon);
    /* I know how tedious this looks but we're concentrating the complexity
    in those four lines, the rest should be smooth sailing. I hope. */

    return BrandPromiseLine_jsx("div", {
      key: text,
      onMouseEnter: function onMouseEnter() {
        setHoveredItem(index);
      },
      onMouseLeave: function onMouseLeave() {
        setHoveredItem(null);
      },
      "data-testid": "BrandPromiseLine-item",
      className: classnames_default()('relative rtl:ml-px20', {
        'lg:rtl:ml-0': index === 0
      })
    }, shouldShowPictures ? BrandPromiseLine_jsx("div", {
      style: {
        height: '235px',
        width: '180px',
        flexShrink: '0'
      },
      className: classnames_default()('rounded-tiny p-px10 overflow-hidden text-center flex items-end justify-center relative', {
        'inset-border-after': isXC
      })
    }, BrandPromiseLine_jsx(Image["b" /* default */], {
      className: classnames_default()('absolute inset-0 transition-transform', {
        'scale-105': hoveredItem === index && link
      }),
      altMsg: mediaAlt,
      imageUrl: mediaUrl,
      dimensions: {
        h: 235,
        w: 180
      }
    })) : null, BrandPromiseLine_jsx(TagName, conditionalTagNameProps, shouldShowPictures ? BrandPromiseLine_jsx("div", {
      className: "relative",
      style: {
        height: '235px',
        marginTop: '-235px'
      }
    }) : null, BrandPromiseLine_jsx("div", {
      style: {
        width: '180px'
      },
      className: textStyles
    }, BrandPromiseLine_jsx("div", {
      style: {
        width: '126px',
        height: '72px',
        marginTop: shouldShowPictures ? '-42px' : ''
      },
      className: "relative m-auto overflow-hidden will-change-transform"
    }, BrandPromiseLine_jsx("div", {
      className: classnames_default()('bg-white m-auto flex items-center justify-center', badgeStyles.iconContainer),
      style: {
        width: "calc(".concat(badgeStyles.iconContainerWidth, "rem / 16)"),
        height: "calc(".concat(badgeStyles.iconContainerHeight, "rem / 16)")
      }
    }, BrandPromiseLine_jsx(Icon["a" /* Icon */], {
      name: iconName,
      className: badgeStyles.icon,
      width: badgeStyles.iconWidth,
      isNotSquare: badgeStyles.isNotSquare
    }))), BrandPromiseLine_jsx(Text["a" /* Text */], {
      className: "text-base text-center",
      color: "current",
      text: text
    }))));
  });
}

var BrandPromiseLine_BrandPromiseLine = function BrandPromiseLine(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      items = _ref2.items,
      learnMoreLink = _ref2.learnMoreLink,
      learnMoreLabel = _ref2.learnMoreLabel;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(null),
      hoveredItem = _useState[0],
      setHoveredItem = _useState[1];

  return BrandPromiseLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, BrandPromiseLine_jsx("div", {
    className: "flex flex-wrap justify-between"
  }, !!title && BrandPromiseLine_jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), learnMoreLabel && learnMoreLink && BrandPromiseLine_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-px15 md:mt-px5 order-last md:order-none text-base text-gray-darker hover:text-gray-active focus:text-gray-active underline",
    trackingData: {
      actionGA: 'push_content_brandPromise',
      labelGA: 'learnMore'
    },
    url: learnMoreLink
  }, learnMoreLabel), BrandPromiseLine_jsx("div", {
    className: "-mx-px20 lg:mx-0 w-screen lg:w-full"
  }, BrandPromiseLine_jsx(Slider["a" /* Slider */], {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    scrollAreaClassName: "overflow-hidden",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollControlsClassName: "-mx-px20 lg:mx-0",
    scrollItemClassName: "overflow-hidden flex-none max-w-full"
  }, getItemsToRender(items, hoveredItem, setHoveredItem), BrandPromiseLine_jsx("div", {
    style: {
      width: '20px',
      height: '1px',
      flexShrink: '0'
    },
    className: "lg:hidden rtl:-order-1"
  })))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/brand-promise/brandPromise.descriptor.js


var brandPromiseDescriptor = {
  name: constants["b" /* BRAND_PROMISE */],
  component: BrandPromiseLine_BrandPromiseLine
};
// CONCATENATED MODULE: ./src/client/components/lines/country-events-line/CountryEventsLine.jsx









var CountryEventsLine_jsx = react_default.a.createElement;





var ORIGINAL_DATE_FORMAT = 'DD/MM/YYYY';
var TARGET_DATE_FORMAT = 'DD MMMM YYYY';

function CountryEventsLine_formatDate(startDate, endDate) {
  return [startDate, endDate].filter(Boolean).map(function (date) {
    return moment_default()(date, ORIGINAL_DATE_FORMAT).format(TARGET_DATE_FORMAT);
  }).join(' - ');
}

function getCtaLabel(associatedProductLabel, productName) {
  return productName ? "".concat(associatedProductLabel, " ").concat(productName).trim() : '';
}

function CountryEventsLine(_ref) {
  var associatedProductLabel = _ref.associatedProductLabel,
      close = _ref.config.common.close,
      _ref$countryEvents = _ref.countryEvents,
      countryEvents = _ref$countryEvents === void 0 ? [] : _ref$countryEvents,
      id = _ref.id,
      seeMoreLabel = _ref.seeMoreLabel;
  var countryEventsCards = countryEvents.map(function (_ref2) {
    var _ref2$associatedProdu = _ref2.associatedProducts,
        associatedProducts = _ref2$associatedProdu === void 0 ? [] : _ref2$associatedProdu,
        description = _ref2.description,
        endDate = _ref2.endDate,
        media = _ref2.media,
        startDate = _ref2.startDate,
        title = _ref2.title;
    var associatedProduct = associatedProducts.length > 0 ? associatedProducts[0] : {};
    return {
      closeLabel: close,
      ctaLabel: getCtaLabel(associatedProductLabel, associatedProduct.name),
      heading: {
        title: title,
        hLevel: 3
      },
      introduction: {
        text: CountryEventsLine_formatDate(startDate, endDate)
      },
      link: {
        url: associatedProduct.url
      },
      media: {
        alt: media ? media.mediaAlt : '',
        url: media ? media.mediaUrl : ''
      },
      text: {
        text: description,
        seeMoreLabel: seeMoreLabel
      }
    };
  });

  if (countryEventsCards.length === 0) {
    return null;
  }

  return CountryEventsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, countryEventsCards.length > 1 ? CountryEventsLine_jsx("div", {
    className: "sm:flex sm:flex-wrap -m-px10"
  }, countryEventsCards.map(function (countryEventCard) {
    return CountryEventsLine_jsx("div", {
      className: "sm:w-1/2 p-px10",
      key: countryEventCard.heading.title
    }, CountryEventsLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, countryEventCard, {
      layout: Card_constants["a" /* COLUMN_1 */]
    })));
  })) : CountryEventsLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, countryEventsCards[0], {
    layout: Card_constants["c" /* COMPOSITE_1 */]
  })));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-events/countryEvents.resolver.js
var countryEvents_resolver = __webpack_require__("fGxS");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-events/countryEvents.descriptor.js



var countryEventsDescriptor = {
  name: constants["e" /* COUNTRY_EVENTS */],
  component: CountryEventsLine,
  resolve: countryEvents_resolver["a" /* countryEventsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/country-infos-line/CountryInfosLine.jsx





var CountryInfosLine_jsx = react_default.a.createElement;




var CountryInfosLine_CountryInfosLine = function CountryInfosLine(_ref) {
  var close = _ref.config.common.close,
      _ref$countryInfos$tex = _ref.countryInfos.texts,
      texts = _ref$countryInfos$tex === void 0 ? [] : _ref$countryInfos$tex,
      _ref$cta = _ref.cta,
      cta = _ref$cta === void 0 ? [] : _ref$cta,
      id = _ref.id;
  var cards = texts.map(function (_ref2, index) {
    var _ref2$description = _ref2.description,
        description = _ref2$description === void 0 ? '' : _ref2$description,
        _ref2$media = _ref2.media;
    _ref2$media = _ref2$media === void 0 ? {} : _ref2$media;
    var _ref2$media$mediaAlt = _ref2$media.mediaAlt,
        mediaAlt = _ref2$media$mediaAlt === void 0 ? '' : _ref2$media$mediaAlt,
        _ref2$media$mediaUrl = _ref2$media.mediaUrl,
        mediaUrl = _ref2$media$mediaUrl === void 0 ? '' : _ref2$media$mediaUrl,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return {
      closeLabel: close,
      ctaLabel: cta[index] && cta[index].label,
      heading: {
        title: title,
        hLevel: 3
      },
      link: {
        url: cta[index] && cta[index].link
      },
      media: {
        url: mediaUrl,
        alt: mediaAlt
      },
      text: {
        text: description
      }
    };
  });

  if (!cards.length) {
    return null;
  }

  return CountryInfosLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, cards.map(function (card, index) {
    return CountryInfosLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, card, {
      key: card.heading.title,
      className: index ? 'mt-px20' : '',
      layout: index % 2 === 0 ? Card_constants["d" /* INLINE_1 */] : Card_constants["e" /* INLINE_2 */]
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-infos/countryInfos.resolver.js
var countryInfos_resolver = __webpack_require__("6X2a");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-infos/countryInfos.descriptor.js



var countryInfosDescriptor = {
  name: constants["f" /* COUNTRY_INFOS */],
  component: CountryInfosLine_CountryInfosLine,
  resolve: countryInfos_resolver["a" /* countryInfosResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/country-introduction-line/CountryIntroductionLine.jsx


var CountryIntroductionLine_jsx = react_default.a.createElement;



function CountryIntroductionLine(_ref) {
  var _ref$countryInfos = _ref.countryInfos,
      _ref$countryInfos$des = _ref$countryInfos.description,
      description = _ref$countryInfos$des === void 0 ? '' : _ref$countryInfos$des,
      _ref$countryInfos$tit = _ref$countryInfos.title,
      title = _ref$countryInfos$tit === void 0 ? '' : _ref$countryInfos$tit,
      _ref$config$common = _ref.config.common,
      viewMore = _ref$config$common.viewMore,
      loadLess = _ref$config$common.loadLess,
      id = _ref.id;
  return CountryIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, CountryIntroductionLine_jsx(Introduction["a" /* Introduction */], {
    text: description,
    title: title,
    seeMoreLabel: viewMore,
    seeLessLabel: loadLess
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-introduction/countryIntroduction.resolver.js
var countryIntroduction_resolver = __webpack_require__("VGY0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-introduction/countryIntroduction.descriptor.js



var countryIntroductionDescriptor = {
  name: constants["g" /* COUNTRY_INTRODUCTION */],
  component: CountryIntroductionLine,
  resolve: countryIntroduction_resolver["a" /* countryIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/country-poi-line/CountryPoiLine.jsx







var CountryPoiLine_jsx = react_default.a.createElement;





function CountryPoiLine_getCtaLabel(associatedProductLabel, productName) {
  return productName ? "".concat(associatedProductLabel, " ").concat(productName).trim() : '';
}

function CountryPoiLine(_ref) {
  var _ref$associatedProduc = _ref.associatedProductLabel,
      associatedProductLabel = _ref$associatedProduc === void 0 ? '' : _ref$associatedProduc,
      close = _ref.config.common.close,
      _ref$countryPoi = _ref.countryPoi,
      countryPoi = _ref$countryPoi === void 0 ? [] : _ref$countryPoi,
      id = _ref.id;
  var cards = countryPoi.map(function (_ref2) {
    var _ref2$associatedProdu = _ref2.associatedProducts,
        associatedProducts = _ref2$associatedProdu === void 0 ? [] : _ref2$associatedProdu,
        _ref2$description = _ref2.description,
        description = _ref2$description === void 0 ? '' : _ref2$description,
        media = _ref2.media,
        _ref2$seeMoreLabel = _ref2.seeMoreLabel,
        seeMoreLabel = _ref2$seeMoreLabel === void 0 ? '' : _ref2$seeMoreLabel,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return {
      closeLabel: close,
      ctaLabel: CountryPoiLine_getCtaLabel(associatedProductLabel, associatedProducts && associatedProducts[0] ? associatedProducts[0].name : ''),
      heading: {
        title: title,
        hLevel: 3
      },
      link: {
        url: associatedProducts && associatedProducts[0] ? associatedProducts[0].href : ''
      },
      media: {
        url: media ? media.mediaUrl : '',
        alt: media ? media.mediaAlt : ''
      },
      text: {
        text: description,
        seeMoreLabel: seeMoreLabel
      }
    };
  });

  if (!cards.length) {
    return null;
  }

  return CountryPoiLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, cards.length > 1 ? CountryPoiLine_jsx("div", {
    className: "sm:flex sm:flex-wrap -m-px10"
  }, cards.map(function (card) {
    return CountryPoiLine_jsx("div", {
      className: "sm:w-1/2 p-px10",
      key: card.heading.title
    }, CountryPoiLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, card, {
      layout: Card_constants["a" /* COLUMN_1 */]
    })));
  })) : CountryPoiLine_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({}, cards[0], {
    layout: Card_constants["c" /* COMPOSITE_1 */]
  })));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/country-poi/countryPoi.resolver.js
var countryPoi_resolver = __webpack_require__("A7XF");

// CONCATENATED MODULE: ./src/client/cms/toolkit/country-poi/countryPoi.descriptor.js



var countryPoiDescriptor = {
  name: constants["h" /* COUNTRY_POI */],
  component: CountryPoiLine,
  resolve: countryPoi_resolver["a" /* countryPoiResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/offer-description-line/OfferDescriptionLine.jsx


var OfferDescriptionLine_jsx = react_default.a.createElement;




var OfferDescriptionLine_OfferDescriptionLine = function OfferDescriptionLine(_ref) {
  var config = _ref.config,
      _ref$offer = _ref.offer,
      offer = _ref$offer === void 0 ? {} : _ref$offer;

  if (Object(lodash["isEmpty"])(offer)) {
    return null;
  }

  return OfferDescriptionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, OfferDescriptionLine_jsx(Introduction["a" /* Introduction */], {
    color: offer.color,
    text: offer.description,
    title: offer.timingArgument,
    seeLessLabel: config.common.loadLess,
    seeMoreLabel: config.common.viewMore
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-description/offerDescription.resolver.js
var offerDescription_resolver = __webpack_require__("ih3X");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offer-description/offerDescription.descriptor.js



var offerDescriptionDescriptor = {
  name: constants["D" /* OFFER_DESCRIPTION */],
  component: OfferDescriptionLine_OfferDescriptionLine,
  resolve: offerDescription_resolver["a" /* offerDescriptionResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/text-see-more/TextSeeMore.jsx
var TextSeeMore = __webpack_require__("VBBE");

// CONCATENATED MODULE: ./src/client/components/lines/offer-legal-information-line/OfferLegalInformationLine.jsx
var OfferLegalInformationLine_jsx = react_default.a.createElement;




var OfferLegalInformationLine_OfferLegalInformationLine = function OfferLegalInformationLine(_ref) {
  var config = _ref.config,
      offer = _ref.offer,
      seeMore = _ref.seeMore;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  if (!offer || !offer.legalInformation) {
    return null;
  }

  return OfferLegalInformationLine_jsx("div", {
    className: "Line Line-Offer-Legal-Information"
  }, OfferLegalInformationLine_jsx(SiteContainer["a" /* SiteContainer */], null, OfferLegalInformationLine_jsx(TextSeeMore["a" /* TextSeeMore */], {
    text: offer.legalInformation,
    theme: "text-sans-2",
    seeMoreLabel: seeMore,
    seeLessLabel: config.common.loadLess,
    isCollapseEnabled: !isDesktop
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-legal-information/offerLegalInformation.resolver.js
var offerLegalInformation_resolver = __webpack_require__("9Kh7");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offer-legal-information/offerLegalInformation.descriptor.js



var offerLegalInformationDescriptor = {
  name: constants["E" /* OFFER_LEGAL_INFORMATION */],
  component: OfferLegalInformationLine_OfferLegalInformationLine,
  resolve: offerLegalInformation_resolver["a" /* offerLegalInformationResolver */].resolve
};
// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./src/client/cms/toolkit/offer-seo/offerSeo.resolver.js
var offerSeo_resolver = __webpack_require__("Wb8K");

// CONCATENATED MODULE: ./src/client/cms/toolkit/offer-seo/offerSeo.descriptor.js


var offerSeo_descriptor_jsx = react["createElement"];





var offerSeo_descriptor_SeoComponent = function SeoComponent(_ref) {
  var title = _ref.title,
      meta = _ref.meta;
  return offerSeo_descriptor_jsx(head_default.a, null, offerSeo_descriptor_jsx("title", {
    key: "title"
  }, title), meta.map(function (_ref2) {
    var name = _ref2.name,
        content = _ref2.content;
    return offerSeo_descriptor_jsx("meta", {
      key: name,
      content: content,
      name: name
    });
  }));
};

var offerSEODescriptor = {
  name: constants["F" /* OFFER_SEO */],
  component: offerSeo_descriptor_SeoComponent,
  props: offerSeo_resolver["a" /* offerSEOResolver */].props,
  resolve: offerSeo_resolver["a" /* offerSEOResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/frameworks/fieldset/Fieldset.themes.js
var Fieldset_themes_themes = {
  "default": {
    thRoot: 'border-0 m-0 p-0 relative',
    thLegends: 'font-bold mb-px20 text-2xl text-blue w-full',
    thHead: 'flex items-center leading-tight',
    thIcon: 'rtl:mr-px15 flex-shrink-0',
    thIconSize: '1.9rem',
    thLegendsInner: 'flex-1',
    thLegend: 'after-decorator-line flex items-baseline',
    thSmall: 'block font-normal leading-one text-sm text-gray-darker',
    thDescription: 'mb-px20'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/fieldset/Fieldset.jsx


var Fieldset_jsx = react_default.a.createElement;





var Fieldset_Fieldset = function Fieldset(_ref) {
  var children = _ref.children,
      className = _ref.className,
      description = _ref.description,
      iconName = _ref.iconName,
      legend = _ref.legend,
      subLegend = _ref.subLegend,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;

  if (!react["Children"].count(children)) {
    return null;
  }

  var hasLegend = !!iconName || !!legend || !!subLegend;
  var _themes$theme = Fieldset_themes_themes[theme],
      thDescription = _themes$theme.thDescription,
      thHead = _themes$theme.thHead,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLegend = _themes$theme.thLegend,
      thLegends = _themes$theme.thLegends,
      thLegendsInner = _themes$theme.thLegendsInner,
      thRoot = _themes$theme.thRoot,
      thSmall = _themes$theme.thSmall;
  return Fieldset_jsx("fieldset", {
    className: classnames_default()(className, thRoot)
  }, hasLegend && Fieldset_jsx("legend", {
    className: thLegends
  }, Fieldset_jsx("div", {
    className: thHead
  }, Fieldset_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: iconName,
    width: thIconSize
  }), (legend || subLegend) && Fieldset_jsx("div", {
    className: thLegendsInner
  }, Fieldset_jsx("div", {
    className: thLegend,
    "data-testid": "Fieldset-legend"
  }, legend), subLegend && Fieldset_jsx("small", {
    className: thSmall
  }, subLegend)))), Fieldset_jsx(Text["a" /* Text */], {
    className: thDescription,
    text: description
  }), children);
};
// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseBooking.utils.js





var CruiseBooking_utils_callPrice = function callPrice(_ref) {
  var appContext = _ref.appContext,
      _ref$departureCity = _ref.departureCity,
      departureCity = _ref$departureCity === void 0 ? '' : _ref$departureCity,
      offer = _ref.location.queryParams.offer,
      productId = _ref.productId;
  var offerName = offer ? dist["url"].decodePath(offer) : '';
  var productArgs = Object(graphql["c" /* buildProductArgs */])(productId, {}, {
    offerName: offerName,
    departureCity: departureCity
  });
  var cmsContent = appContext.cmsContent,
      cmsRelease = appContext.cmsRelease;
  var cmsArgs = "content : \"".concat(cmsContent, "\" release : \"").concat(cmsRelease, "\"");
  var query = "{\n          price(".concat(productArgs, ") {\n            bestPrice {\n              value\n              formattedValue\n            }\n            termsAndConditions {\n              departureDate\n              arrivalDate\n              duration\n            }\n            unit(").concat(cmsArgs, ")\n          }\n        }");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["Id" /* WIDGET_CRUISE_BOOKING_CALL_PRICE */]
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseCriteriaFieldset.jsx

var CruiseCriteriaFieldset_jsx = react_default.a.createElement;






var CruiseCriteriaFieldset_CruiseCriteriaFieldset = function CruiseCriteriaFieldset(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      cruise = _ref.cruise,
      departureCity = _ref.departureCity,
      handleDepartureCity = _ref.handleDepartureCity,
      product = _ref.product;
  var departureCities = (bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.departureCities) || [];
  var initialTransport = (bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialTransport) || '';
  var transportIcon = (product === null || product === void 0 ? void 0 : product.transportType) || '';
  var withTransport = departureCities.some(function (_ref2) {
    var value = _ref2.value;
    return value !== 'NO';
  });
  return CruiseCriteriaFieldset_jsx(react_default.a.Fragment, null, CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-px10",
    "data-testid": "cruiseBookingForm-cruiseDates"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].DATE,
    theme: "title-sans-3"
  }, Object(src_i18n["h" /* t */])('criteria.dateLabel')), CruiseCriteriaFieldset_jsx("p", {
    className: "py-px10 px-px15 text-md text-gray-dark"
  }, product.dateRange || '')), CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-px10",
    "data-testid": "cruiseBookingForm-cruiseLocation"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].ADDRESS,
    theme: "title-sans-3"
  }, Object(src_i18n["h" /* t */])('criteria.fromToLabel')), CruiseCriteriaFieldset_jsx("p", {
    className: "py-px10 px-px15 text-md text-gray-dark"
  }, cruise.fromToDestination || '')), CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-px10",
    "data-testid": "cruiseBookingForm-cruiseDuration"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].DURATION,
    theme: "title-sans-3"
  }, Object(src_i18n["h" /* t */])('criteria.durationLabel')), CruiseCriteriaFieldset_jsx("p", {
    className: "py-px10 px-px15 text-md text-gray-dark"
  }, product.duration || '')), withTransport && CruiseCriteriaFieldset_jsx("div", {
    className: "w-full sm:w-1/3 p-px10",
    "data-testid": "cruiseBookingForm-transports"
  }, CruiseCriteriaFieldset_jsx(Title["a" /* Title */], {
    className: "my-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 3,
    iconName: icons["a" /* ICONS */].TRANSPORT,
    theme: "title-sans-3"
  }, Object(src_i18n["h" /* t */])('criteria.transportationLabel')), CruiseCriteriaFieldset_jsx(TransportCriteria_TransportCriteria, {
    departureCitiesOptions: departureCities,
    departureCity: departureCity,
    handleDepartureCity: handleDepartureCity,
    initialTransport: initialTransport,
    isJoyview: product.isJoyview,
    transportIcon: transportIcon,
    withValidDepartureCity: true
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseFooter.jsx

var CruiseFooter_jsx = react_default.a.createElement;








var CruiseFooter_CruiseFooter = function CruiseFooter(_ref) {
  var config = _ref.config,
      loading = _ref.loading,
      price = _ref.price,
      onClick = _ref.onClick;

  if (loading) {
    return true ? CruiseFooter_jsx("div", {
      className: "flex flex-col items-center justify-center",
      "data-testid": "cruiseBooking-loader"
    }, CruiseFooter_jsx("p", null, Object(src_i18n["h" /* t */])('booking.loadingPrice')), CruiseFooter_jsx(Spinner["a" /* Spinner */], {
      size: "small",
      color: colors["a" /* COLORS */].GRAY
    })) : undefined;
  }

  return CruiseFooter_jsx("div", {
    className: "flex flex-col items-center justify-center"
  }, CruiseFooter_jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({
    hasInitialPrice: false
  }, Object(lodash["get"])(config, 'price.format', {}), price, {
    theme: "remote"
  })), CruiseFooter_jsx(Button["a" /* Button */], {
    className: "mt-px25",
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    iconRight: {
      name: icons["a" /* ICONS */].ARROW_FORTH
    },
    onClick: onClick,
    size: "large",
    theme: "formSubmit",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'cruiseForm',
      labelGA: 'checkPrices'
    },
    type: "button"
  }, Object(src_i18n["h" /* t */])('booking.labelCTA')), CruiseFooter_jsx("div", {
    className: "leading-normal max-w-full mt-px25 text-base text-center text-gray-darker",
    "data-testid": "cruiseBookingForm-disclaimer"
  }, Object(src_i18n["h" /* t */])('booking.disclaimer')));
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseParticipants.jsx
var CruiseParticipants_jsx = react_default.a.createElement;





var CruiseParticipants_CruiseParticipants = function CruiseParticipants(_ref) {
  var adultsNumber = _ref.adultsNumber,
      _ref$cruise = _ref.cruise,
      cruise = _ref$cruise === void 0 ? {} : _ref$cruise,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? DEFAULT_DATE_FORMAT : _ref$dateFormat,
      kids = _ref.kids,
      product = _ref.product,
      setAdultsNumber = _ref.setAdultsNumber,
      _setKids = _ref.setKids,
      setKidsValidationState = _ref.setKidsValidationState;
  return CruiseParticipants_jsx(Participants_Participants, {
    dateFormat: dateFormat,
    dayPlaceholder: Object(src_i18n["h" /* t */])('config.booking.form.dayPlaceholder'),
    monthPlaceholder: Object(src_i18n["h" /* t */])('config.booking.form.monthPlaceholder'),
    yearPlaceholder: Object(src_i18n["h" /* t */])('config.booking.form.yearPlaceholder'),
    adultOnly: product.adultOnly,
    childrenBirthdayDateFormatPlaceholder: Object(src_i18n["h" /* t */])('config.booking.form.childrenBirthdayDateFormatPlaceholder'),
    setKids: function setKids(_ref2) {
      var allKids = _ref2.kids,
          kidsValidations = _ref2.kidsValidations;
      Object(es["b" /* batch */])(function () {
        _setKids(allKids);

        setKidsValidationState(kidsValidations);
      });
    },
    setAdultsNumber: setAdultsNumber,
    kids: kids,
    adultsNumber: adultsNumber,
    departureDate: cruise.departureDate,
    minAgeInformation: product.minAuthorizedAge.formattedValue || '',
    adultAge: Object(src_i18n["h" /* t */])('config.booking.form.adultAge'),
    childAge: product.minAuthorizedAge.value,
    kidsLabel: Object(src_i18n["h" /* t */])('config.common.participants.kidsLabel'),
    adultsLabel: Object(src_i18n["h" /* t */])('config.common.participants.adultsLabel'),
    kidsAgeLimit: Object(src_i18n["h" /* t */])('config.common.participants.kidsAgeLimit')
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseBooking.jsx




























var CruiseBooking_jsx = react_default.a.createElement;

function CruiseBooking_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function CruiseBooking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CruiseBooking_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CruiseBooking_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CruiseBooking_createSuper(Derived) { var hasNativeReflectConstruct = CruiseBooking_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function CruiseBooking_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }



























var CruiseBooking_NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE;
var DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
var CruiseBooking_CruiseBooking = /*#__PURE__*/function (_FormValidator) {
  Object(inherits["a" /* default */])(_CruiseBooking, _FormValidator);

  var _super = CruiseBooking_createSuper(_CruiseBooking);

  function _CruiseBooking(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, _CruiseBooking);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleDepartureCity", function (value) {
      var uri = Object(uriUtils["c" /* convertLocationToURI */])(_this.props.location);
      var pageUrl = value && value !== CruiseBooking_NO_TRANSPORT_VALUE ? uri.clone().setQuery(Object(defineProperty["a" /* default */])({}, uri_constants["k" /* QUERY_TRANSPORT */], value)) : uri.clone().removeQuery(uri_constants["k" /* QUERY_TRANSPORT */]);
      redirectUtils["a" /* default */].redirectTo()(pageUrl, {
        replace: true,
        shallow: true
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "redirectToBookingEngine", /*#__PURE__*/Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _this$props, cruise, product, adults, kids, simpleFetchProposals, location, getBookingEngineI18n, arrivalDate, criterias, _yield$Promise$all, _yield$Promise$all2, proposals, failedProposals;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, cruise = _this$props.cruise, product = _this$props.product, adults = _this$props.adults, kids = _this$props.kids, simpleFetchProposals = _this$props.simpleFetchProposals, location = _this$props.location, getBookingEngineI18n = _this$props.getBookingEngineI18n;
              arrivalDate = Object(lodash["get"])(_this.state.price, 'termsAndConditions.arrivalDate');

              if (!arrivalDate) {
                // If the `/v0/search_price` API do not send back a price (e.g. when there is a departureCity added), the `termsAndConditions.arrivalDate` is empty. In that case, we fallback to the `departureDate` of the cruise - as the parameter `arrivalDate` means "arrival on the site" and _not_ the end of the cruise (#8962).
                arrivalDate = cruise.departureDate;
              }

              criterias = {
                productId: product.id,
                arrivalDate: arrivalDate,
                duration: Object(lodash["get"])(_this.state.price, 'termsAndConditions.duration'),
                attendees: {
                  adults: adults,
                  kids: kids
                },
                departureCity: Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["k" /* QUERY_TRANSPORT */]) || CruiseBooking_NO_TRANSPORT_VALUE,
                bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].CRUISE_BOOKING
              };
              _context.prev = 4;
              _context.next = 7;
              return Promise.all([simpleFetchProposals(criterias, Object(lodash["get"])(_this.props, _this.context.isSeller ? 'config.booking.partners.form.proposalsLoaderLabel' : 'config.booking.form.proposalsLoaderLabel', 'loading'), _this.context, location), getBookingEngineI18n(_this.context)]);

            case 7:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = Object(slicedToArray["a" /* default */])(_yield$Promise$all, 1);
              proposals = _yield$Promise$all2[0].proposals;
              failedProposals = Object(proposalUtils["s" /* hasFetchProposalsFailed */])(proposals);

              if (!failedProposals) {
                _this.props.history.pushRoute(Object(BookingPagesUtils["i" /* getBookingEngineUri */])(BookingPagesUtils["a" /* PAGE_BE_ACCOMMODATION */], proposals.proposals, proposals.resort, proposals.proposals[0].id, location.queryParams));
              } else {
                _this.setState({
                  proposalError: proposals.errors
                });
              }

              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);

              if (_context.t0.errors[0].name === 'UnauthorizedError' && _context.t0.errors[0].statusCode === 401) {
                redirectUtils["a" /* default */].redirectToOidc(_this.context);
              }

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 14]]);
    })));

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleSubmit", function (e) {
      e.preventDefault();
      Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageTracking_resolver["a" /* CRUISE */], {
        // $FlowFixMe
        id: _this.props.product.id,
        be: true,
        timestamp: Date.now()
      });

      _this.setState({
        hasBeenSubmitted: true,
        proposalError: ''
      }, function () {
        var haveError = Object.values(_this.checkFormErrors()).some(function (error) {
          return error;
        });
        if (haveError) return;
        return _this.redirectToBookingEngine();
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "handleChange", function (action) {
      return function (payload) {
        _this.setState({
          hasBeenSubmitted: false
        }, function () {
          return action(payload);
        });
      };
    });

    _this.state = {
      loading: true,
      price: {},
      fields: [],
      hasBeenSubmitted: false,
      departureCity: '',
      proposalError: ''
    };
    return _this;
  }

  Object(createClass["a" /* default */])(_CruiseBooking, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updatePrice();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState && prevState.departureCity !== this.state.departureCity) {
        this.updatePrice();
      }
    }
  }, {
    key: "updatePrice",
    value: function updatePrice() {
      var _this2 = this;

      CruiseBooking_utils_callPrice({
        departureCity: this.state.departureCity,
        appContext: this.context,
        location: this.props.location,
        productId: this.props.product.id
      }).then(function (_ref2) {
        var price = _ref2.price;

        _this2.setState({
          loading: false,
          price: price
        });
      });
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(name) {
      return Object(lodash["find"])(this.state.fields, {
        name: name
      });
    }
  }, {
    key: "checkFormErrors",
    value: function checkFormErrors() {
      var _this$props$dateForma = this.props.dateFormat,
          dateFormat = _this$props$dateForma === void 0 ? DEFAULT_DATE_FORMAT : _this$props$dateForma;
      var birthdays = getFormattedKidsBirthdate(this.props.kids, dateFormat);
      var adultAgeInYear = +Object(lodash["get"])(this.props, 'config.booking.form.adultAge', DEFAULT_MAX_AGE);
      var childAgeInYear = +Object(lodash["get"])(this.props, 'product.minAuthorizedAge.value', DEFAULT_MIN_AGE) / 12;
      var minAgeErrorMessage = Object(lodash["get"])(this.props, 'product.minAgeErrorMessage.formattedValue');
      var _this$props2 = this.props,
          _this$props2$adultsNu = _this$props2.adultsNumber,
          adultsNumber = _this$props2$adultsNu === void 0 ? 0 : _this$props2$adultsNu,
          kids = _this$props2.kids,
          _this$props2$cruise = _this$props2.cruise,
          cruise = _this$props2$cruise === void 0 ? {} : _this$props2$cruise;
      return participants_validator.checkFormErrors({
        adults: adultsNumber,
        children: kids.length,
        departureDate: cruise.departureDate,
        birthdays: birthdays,
        dateFormat: dateFormat,
        adultAge: adultAgeInYear,
        childAge: childAgeInYear,
        birthdayFormatErrorMessage: Object(lodash["get"])(this.props, 'config.booking.form.errors.birthdayFormat'),
        adultAgeErrorMessage: Object(lodash["get"])(this.props, 'config.booking.form.errors.adultChild'),
        minAgeErrorMessage: minAgeErrorMessage,
        isSeller: this.context.isSeller
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$proposalE;

      var _this$state = this.state,
          loading = _this$state.loading,
          price = _this$state.price,
          departureCity = _this$state.departureCity;
      var _this$props3 = this.props,
          adultsNumber = _this$props3.adultsNumber,
          bookingCriteria = _this$props3.bookingCriteria,
          config = _this$props3.config,
          criteria = _this$props3.criteria,
          cruise = _this$props3.cruise,
          dateFormat = _this$props3.dateFormat,
          kids = _this$props3.kids,
          _this$props3$pax = _this$props3.pax,
          pax = _this$props3$pax === void 0 ? {} : _this$props3$pax,
          product = _this$props3.product,
          setAdultsNumber = _this$props3.setAdultsNumber,
          setKids = _this$props3.setKids,
          setKidsValidationState = _this$props3.setKidsValidationState,
          title = _this$props3.title;
      return CruiseBooking_jsx(react_default.a.Fragment, null, CruiseBooking_jsx("div", {
        className: "PriceTicket-sticky-beacon"
      }), CruiseBooking_jsx("section", {
        id: "booking",
        className: "py-px40"
      }, CruiseBooking_jsx("form", {
        "data-testid": "CruiseBookingForm-form",
        onSubmit: this.handleSubmit
      }, CruiseBooking_jsx(Title["a" /* Title */], {
        "data-testid": "CruiseBookingForm-title",
        color: colors["a" /* COLORS */].GRAY_DARKER,
        className: "mb-px30",
        theme: "title-sans-4"
      }, title), CruiseBooking_jsx(Fieldset_Fieldset, {
        className: "mb-px50",
        legend: criteria.title,
        "data-testid": "CruiseBookingForm-criteriaFieldset"
      }, CruiseBooking_jsx("div", {
        className: "sm:flex sm:flex-wrap -m-px10"
      }, CruiseBooking_jsx(CruiseCriteriaFieldset_CruiseCriteriaFieldset, {
        bookingCriteria: bookingCriteria,
        cruise: cruise,
        departureCity: departureCity,
        handleDepartureCity: this.handleDepartureCity,
        product: product
      }))), CruiseBooking_jsx(Fieldset_Fieldset, {
        className: "mb-px50",
        legend: pax.title,
        "data-testid": "CruiseBookingForm-paxFieldset"
      }, CruiseBooking_jsx(CruiseParticipants_CruiseParticipants, {
        adultsNumber: adultsNumber,
        cruise: cruise,
        dateFormat: dateFormat,
        kids: kids,
        setKidsValidationState: setKidsValidationState,
        product: product,
        setAdultsNumber: this.handleChange(setAdultsNumber),
        setKids: this.handleChange(setKids)
      }), this.state.proposalError && CruiseBooking_jsx(BookingErrors_BookingErrors, {
        errorCode: (_this$state$proposalE = this.state.proposalError[0]) === null || _this$state$proposalE === void 0 ? void 0 : _this$state$proposalE.errorCode
      }), CruiseBooking_jsx(participantsErrors_ParticipantsErrors, {
        config: Object(lodash["pick"])(config.booking.form, ['errorMaxGuestsLabel', 'departureDateErrorMessage']),
        errors: this.checkFormErrors(),
        isSubmitted: this.state.hasBeenSubmitted
      })), CruiseBooking_jsx(CruiseFooter_CruiseFooter, {
        config: config,
        loading: loading,
        price: price,
        onClick: this.handleSubmit
      }))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var departureCityValueFromQueryParams = Object(uriUtils["j" /* getSpecificQueryParam */])(uri_constants["k" /* QUERY_TRANSPORT */]) || '';

      if (departureCityValueFromQueryParams !== state.departureCity) {
        return CruiseBooking_objectSpread(CruiseBooking_objectSpread({}, state), {}, {
          loading: true,
          departureCity: departureCityValueFromQueryParams
        });
      }

      return null;
    }
  }]);

  return _CruiseBooking;
}(form_validator_hoc_FormValidator);

Object(defineProperty["a" /* default */])(CruiseBooking_CruiseBooking, "contextType", ReactAppContext["b" /* default */]);

Object(defineProperty["a" /* default */])(CruiseBooking_CruiseBooking, "defaultProps", {
  adultsNumber: 2,
  adults: [],
  kids: [],
  resortId: ''
});

var CruiseBooking = Object(withRouter["a" /* withRouter */])(CruiseBooking_CruiseBooking);
// CONCATENATED MODULE: ./src/client/components/widgets/cruise-booking/CruiseBooking.container.js













function CruiseBooking_container_getValue(value, cmsDefaultValue) {
  return !value && cmsDefaultValue ? cmsDefaultValue : value;
}

function CruiseBooking_container_mapStateToProps(state, props) {
  var bookingCriteria = props.bookingCriteria,
      resort = props.resort;
  var kids = Object(trip_information_storeHelper["c" /* getKids */])(state);
  var adults = Object(trip_information_storeHelper["a" /* getAdults */])(state) || [];
  var adultsNumber = CruiseBooking_container_getValue(adults.length, Object(lodash["get"])(bookingCriteria, 'initialNumberOfAdults')) || adults_constants["a" /* DEFAULT_ADULTS_NB */];

  if (!adults.length) {
    // $FlowFixMe
    adults = new Array(adultsNumber).fill({});
  }

  return {
    adults: adults,
    adultsNumber: adultsNumber,
    kids: getResortInitialKids(kids, Object(lodash["get"])(bookingCriteria, 'initialNumberOfChildren'), Object(lodash["get"])(resort, 'adultOnly')),
    i18n: state.cms
  };
}
var CruiseBooking_container_mapDispatchToProps = {
  setKids: kids_action["b" /* setKids */],
  setKidsValidationState: facetingSearch_action["m" /* setKidsValidationState */],
  setAdultsNumber: adults_action["b" /* setAdultsNumber */],
  simpleFetchProposals: proposals_action["s" /* simpleFetchProposals */],
  getBookingEngineI18n: cms_actions["c" /* getBookingEngineI18n */]
};
var CruiseBookingContainer = Object(es["c" /* connect */])(CruiseBooking_container_mapStateToProps, CruiseBooking_container_mapDispatchToProps)(CruiseBooking);
// CONCATENATED MODULE: ./src/client/components/lines/cruise-booking-line/CruiseBookingLine.jsx






var CruiseBookingLine_jsx = react_default.a.createElement;





var CruiseBookingLine_CruiseBookingLine = function CruiseBookingLine(_ref) {
  var id = _ref.id,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? '' : _ref$description,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? [] : _ref$meta,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id", "description", "meta", "title"]);

  Object(src_i18n["a" /* addTranslationKeys */])({
    booking: props.booking,
    criteria: props.criteria,
    config: props.config,
    faceting: props.config.faceting
  });
  return CruiseBookingLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line bg-white z-6",
    id: id
  }, CruiseBookingLine_jsx(head_default.a, null, CruiseBookingLine_jsx("title", {
    key: "title"
  }, title), meta.map(function (_ref2) {
    var content = _ref2.content,
        key = _ref2.key,
        name = _ref2.name,
        property = _ref2.property;
    return CruiseBookingLine_jsx("meta", Object(esm_extends["a" /* default */])({
      key: key || name || property
    }, property ? {
      property: property
    } : {
      name: name
    }, {
      content: content
    }));
  }), CruiseBookingLine_jsx("meta", {
    name: "description",
    content: description
  })), CruiseBookingLine_jsx(CruiseBookingContainer, props));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/cruise-booking/cruiseBooking.resolver.js
var cruiseBooking_resolver = __webpack_require__("Qabk");

// CONCATENATED MODULE: ./src/client/cms/toolkit/cruise-booking/cruiseBooking.descriptor.js



var cruiseBookingDescriptor = {
  name: constants["j" /* CRUISE_BOOKING */],
  component: CruiseBookingLine_CruiseBookingLine,
  props: cruiseBooking_resolver["a" /* cruiseBookingResolver */].props,
  resolve: cruiseBooking_resolver["a" /* cruiseBookingResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-program/ProductProgram.jsx






var ProductProgram_jsx = react_default.a.createElement;






function ProductProgramSectionTitles(_ref) {
  var className = _ref.className,
      subtitle = _ref.subtitle,
      title = _ref.title;
  return ProductProgram_jsx("div", {
    className: className
  }, ProductProgram_jsx(Title["a" /* Title */], {
    hLevel: 2,
    theme: "title-brand-11"
  }, title), ProductProgram_jsx(Title["a" /* Title */], {
    hLevel: 3,
    theme: "title-sans-11"
  }, subtitle));
}

function ProductProgramFull(_ref2) {
  var className = _ref2.className,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      stops = _ref2.stops;
  return Object(lodash["isEmpty"])(stops) ? null : ProductProgram_jsx(react["Fragment"], null, ProductProgram_jsx(ProductProgramSectionTitles, {
    className: classnames_default()(className, 'mb-px30'),
    subtitle: subtitle,
    title: title
  }), ProductProgram_jsx("div", {
    className: "flex flex-wrap -m-px10"
  }, stops.map(function (_ref3) {
    var day = _ref3.day,
        description = _ref3.description,
        stopTitle = _ref3.title,
        departureTime = _ref3.departureTime,
        arrivalTime = _ref3.arrivalTime;
    var departureArrivalTime = [arrivalTime, departureTime].filter(Boolean).join('\n');
    return day || description || stopTitle ? ProductProgram_jsx("div", {
      className: "w-full sm:w-1/2 p-px10"
    }, ProductProgram_jsx(Title["a" /* Title */], {
      className: "mb-px5",
      hLevel: 3,
      theme: "title-sans-3"
    }, "".concat(day, " - ").concat(stopTitle)), ProductProgram_jsx(Text["a" /* Text */], {
      text: description
    }), !!departureArrivalTime && ProductProgram_jsx(Text["a" /* Text */], {
      text: departureArrivalTime
    })) : null;
  })));
}

function ProductProgramLite(_ref4) {
  var className = _ref4.className,
      title = _ref4.title,
      subtitle = _ref4.subtitle,
      stops = _ref4.stops;
  return Object(lodash["isEmpty"])(stops) ? null : ProductProgram_jsx("section", {
    className: classnames_default()(className, 'flex flex-wrap -m-px10')
  }, ProductProgram_jsx(ProductProgramSectionTitles, {
    className: "w-full sm:w-1/2 p-px10",
    subtitle: subtitle,
    title: title
  }), ProductProgram_jsx("div", {
    className: "w-full sm:w-1/2 p-px10"
  }, ProductProgram_jsx("ul", {
    className: "reset-list leading-normal text-base text-gray-darker"
  }, stops.map(function (_ref5) {
    var day = _ref5.day,
        stopTitle = _ref5.title;
    return day || stopTitle ? ProductProgram_jsx("li", {
      className: "list-disc py-px5",
      key: day
    }, ProductProgram_jsx("strong", null, day), " - ", stopTitle) : null;
  }))));
}

function ProductProgram(props) {
  var _props$extension = props.extension,
      extension = _props$extension === void 0 ? {} : _props$extension,
      isDetailed = props.isDetailed,
      _props$program = props.program,
      program = _props$program === void 0 ? {} : _props$program;
  if (Object(lodash["isEmpty"])(program.stops)) return null;
  return isDetailed ? ProductProgram_jsx(react["Fragment"], null, ProductProgram_jsx(ProductProgramFull, {
    stops: program.stops,
    subtitle: program.subtitle,
    title: program.title
  }), ProductProgram_jsx(ProductProgramFull, {
    className: "mt-px40",
    stops: extension.stops,
    subtitle: extension.subtitle,
    title: extension.title
  })) : ProductProgram_jsx(react["Fragment"], null, ProductProgram_jsx(ProductProgramLite, {
    stops: program.stops,
    subtitle: program.subtitle,
    title: program.title
  }), ProductProgram_jsx(ProductProgramLite, {
    className: "mt-px40",
    stops: extension.stops,
    subtitle: extension.subtitle,
    title: extension.title
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/cruise-program-line/CruiseProgramLine.jsx
var CruiseProgramLine_jsx = react_default.a.createElement;



var CruiseProgramLine_CruiseProgramLine = function CruiseProgramLine(_ref) {
  var id = _ref.id,
      isDetailed = _ref.isDetailed,
      _ref$cruise = _ref.cruise;
  _ref$cruise = _ref$cruise === void 0 ? {} : _ref$cruise;
  var _ref$cruise$stopover = _ref$cruise.stopover,
      stopover = _ref$cruise$stopover === void 0 ? {} : _ref$cruise$stopover;
  return CruiseProgramLine_jsx("div", {
    className: "Line Line-Cruise-Program",
    id: id
  }, CruiseProgramLine_jsx(SiteContainer["a" /* SiteContainer */], null, CruiseProgramLine_jsx(ProductProgram, {
    isDetailed: isDetailed,
    program: stopover
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/cruise-program/cruiseProgram.resolver.js
var cruiseProgram_resolver = __webpack_require__("eVJY");

// CONCATENATED MODULE: ./src/client/cms/toolkit/cruise-program/cruiseProgram.descriptor.js



var cruiseProgramDescriptor = {
  name: constants["k" /* CRUISE_PROGRAM */],
  component: CruiseProgramLine_CruiseProgramLine,
  resolve: cruiseProgram_resolver["a" /* cruiseProgramResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/utils/google/google.constants.js
var google_constants = __webpack_require__("UlIv");

// CONCATENATED MODULE: ./src/client/components/utils/google/google.utils.js






function getGoogleBaseUrl() {
  var googleDomain = config_default.a.get(google_constants["a" /* GOOGLE_API_DOMAIN */]);
  var googleKey = config_default.a.get(google_constants["c" /* GOOGLE_API_KEY */]);
  return new URI_default.a(googleDomain).query({
    key: googleKey
  });
}
function getGoogleScriptUrl() {
  return getGoogleBaseUrl().path(config_default.a.get(google_constants["b" /* GOOGLE_API_JS_PATH */])).toString();
}
function google_utils_getStaticMapURL(path, query) {
  var baseUrl = getGoogleBaseUrl();
  baseUrl.path(config_default.a.get(path));
  baseUrl.addQuery(query);
  return baseUrl.toString();
}
function getGoogleMapURL(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  return "".concat(google_constants["f" /* GOOGLE_PLACE_URL */], "/").concat(latitude, ",").concat(longitude);
}
// CONCATENATED MODULE: ./src/client/components/utils/baidu/baidu.constants.js
var API_VERSION = '2.0';
var BAIDU_CALLBACK = 'baiduloadedcallback';
var BAIDU_MARKER_URL = 'http://api.map.baidu.com/marker';

// CONCATENATED MODULE: ./src/client/components/utils/baidu/baidu.utils.js


function getBaiduMapURL(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  return "".concat(BAIDU_MARKER_URL, "?location=").concat(longitude, ",").concat(latitude, "&output=html");
}
// EXTERNAL MODULE: ./src/client/components/frameworks/address/Address.jsx
var Address = __webpack_require__("e4lk");

// CONCATENATED MODULE: ./src/client/components/utils/async-script-loader/AsyncScriptLoader.jsx
/* eslint-disable react/no-did-mount-set-state */



var LOADING_STATE_NOT_LOADED = 'NOT_LOADED';
var LOADING_STATE_STARTED = 'STARTED';
var LOADING_STATE_LOADED = 'LOADED';
/* harmony default export */ var AsyncScriptLoader = (create_react_class_default()({
  displayName: 'AsyncScriptLoader',
  getInitialState: function getInitialState() {
    return {
      loadingState: LOADING_STATE_NOT_LOADED
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      preload: lodash["noop"],
      callback: lodash["noop"],
      loader: function loader() {
        return lodash["noop"];
      }
    };
  },
  isUnmounted: false,
  handleLoaded: function handleLoaded() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      loadingState: LOADING_STATE_LOADED
    });
  },
  componentDidMount: function componentDidMount() {
    if (this.state.loadingState !== LOADING_STATE_NOT_LOADED) {
      return;
    }

    this.props.preload();
    this.setState({
      loadingState: LOADING_STATE_STARTED
    });
    var loader = this.props.loader();
    loader(this.props.scriptURL, this.handleLoaded);
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.loadingState === LOADING_STATE_LOADED) {
      this.props.callback();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.isUnmounted = true;
  },
  render: function render() {
    return this.state.loadingState === LOADING_STATE_LOADED ? this.props.children : null;
  }
}));
// CONCATENATED MODULE: ./src/client/components/frameworks/map/Map.jsx
var Map_jsx = react_default.a.createElement;





function Map(props) {
  var children = props.children,
      className = props.className,
      closeLabel = props.closeLabel,
      dataTestId = props.dataTestId,
      imageSrc = props.imageSrc,
      _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? {
    w: 29,
    h: 32
  } : _props$ratio,
      title = props.title,
      trackingData = props.trackingData;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  if (!imageSrc) return null;
  return Map_jsx(react["Fragment"], null, Map_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: classnames_default()(className, 'reset-button block cursor-pointer overflow-hidden relative w-full'),
    onClick: function onClick() {
      return setOpen(true);
    },
    trackingData: !isOpen ? trackingData : null,
    type: "button",
    "data-testid": dataTestId
  }, Map_jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    dimensions: ratio
  })), isOpen && Map_jsx(Backdrop["a" /* Backdrop */], {
    ariaLabel: title,
    closeLabel: closeLabel,
    hasCloseButton: true,
    onClose: function onClose() {
      return setOpen(false);
    }
  }, Map_jsx("div", {
    className: "flex-1 h-full"
  }, children)));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/map/BaiduMap.jsx



var BaiduMap_jsx = react["createElement"];









var SQUARE_MARKER = '/markers/squareMarker.png';
var MARKER = '/markers/marker.png';
var BaiduMap_BaiduMap = function BaiduMap(_ref) {
  var className = _ref.className,
      closeLabel = _ref.closeLabel,
      latitude = _ref.latitude,
      longitude = _ref.longitude,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 780 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 420 : _ref$height,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 2 : _ref$scale,
      title = _ref.title,
      _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? 7 : _ref$zoom,
      _ref$loader = _ref.loader,
      loader = _ref$loader === void 0 ? function () {
    return __webpack_require__("h9IM");
  } : _ref$loader;
  var responsive = react["useContext"](responsiveContext["a" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var mapRef = react["useRef"]();

  var getBaiduBaseUrl = function getBaiduBaseUrl() {
    var apiConfig = config_default.a.get('baidumap.api');
    return new URI_default.a(apiConfig.domain).addQuery({
      ak: apiConfig.key,
      v: API_VERSION
    });
  };

  var getMarkerUrl = function getMarkerUrl(marker) {
    return "".concat(location.origin).concat(marker);
  };

  var initInteractiveMap = function initInteractiveMap(isLarge) {
    var BMap = dist["windowWrapper"].get('BMap');
    var centerPt = new BMap.Point(longitude, latitude);
    var markerPt = new BMap.Point(longitude, latitude);
    var icon = new BMap.Icon(getMarkerUrl(MARKER), new BMap.Size(58, 70), {
      anchor: new BMap.Size(29, 70),
      infoWindowAnchor: new BMap.Size(29, 0)
    });
    var marker = new BMap.Marker(markerPt, {
      icon: icon
    });
    var map = new BMap.Map(mapRef.current); // Workaround a BaiduMap bug for pinchzoom on mobile

    if (isLarge) {
      // $FlowFixMe
      Object.defineProperty(mapRef.current, 'offsetParent', {
        get: function get() {
          return dist["windowWrapper"].get('document.body');
        }
      });
    }

    map.enableScrollWheelZoom();
    map.centerAndZoom(centerPt, zoom + 1);
    map.addOverlay(marker);
  };

  var isBaiduMapLoaded = function isBaiduMapLoaded() {
    var BMap = dist["windowWrapper"].get('BMap');
    return BMap && BMap.version;
  };

  var getStaticMapOptions = function getStaticMapOptions() {
    return {
      width: width,
      height: height,
      scale: scale,
      zoom: zoom,
      center: "".concat(longitude, ",").concat(latitude),
      markers: "".concat(longitude, ",").concat(latitude),
      markerStyles: "-1,".concat(getMarkerUrl(SQUARE_MARKER))
    };
  };

  var getStaticMapURL = function getStaticMapURL() {
    var baseUrl = getBaiduBaseUrl();
    baseUrl.path(config_default.a.get('baidumap.api.staticPath'));
    baseUrl.addQuery(getStaticMapOptions());
    return baseUrl.toString();
  };

  var getBaiduScriptUrl = function getBaiduScriptUrl() {
    var baseUrl = getBaiduBaseUrl();
    baseUrl.path(config_default.a.get('baidumap.api.jsPath'));
    baseUrl.addQuery('callback', BAIDU_CALLBACK);
    return baseUrl.toString();
  };

  return BaiduMap_jsx(Map, {
    className: className,
    closeLabel: closeLabel,
    imageSrc: getStaticMapURL(),
    isLarge: responsive.isTablet,
    ratio: {
      w: width,
      h: height
    },
    title: title,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'BaiduMap'
    }
  }, BaiduMap_jsx(AsyncScriptLoader, {
    scriptURL: getBaiduScriptUrl(),
    loader: loader,
    preload: function preload() {
      dist["windowWrapper"].set(BAIDU_CALLBACK, function () {
        initInteractiveMap(responsive.isTablet);
      });
    },
    callback: function callback() {
      isBaiduMapLoaded() ? dist["windowWrapper"].get(BAIDU_CALLBACK)() : function () {};
    }
  }, BaiduMap_jsx("div", {
    className: "h-full",
    "data-testid": "BaiduMapContainer",
    ref: mapRef
  })));
};
// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// CONCATENATED MODULE: ./src/client/components/frameworks/map/GoogleMap.jsx




var GoogleMap_jsx = react["createElement"];








var GoogleMapReact = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 41).then(__webpack_require__.t.bind(null, "h6Ot", 7));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("h6Ot")];
    },
    modules: ['google-map-react']
  }
});

var createMapOptions = function createMapOptions() {
  return {
    fullscreenControl: false
  };
};

var addMarker = function addMarker(_ref) {
  var map = _ref.map,
      maps = _ref.maps,
      position = _ref.position,
      icon = _ref.icon;
  // eslint-disable-next-line no-new
  new maps.Marker({
    icon: icon,
    map: map,
    position: position
  });
};

var GoogleMap_GoogleMap = function GoogleMap(props) {
  var className = props.className,
      closeLabel = props.closeLabel,
      _props$format = props.format,
      format = _props$format === void 0 ? 'jpeg' : _props$format,
      _props$height = props.height,
      height = _props$height === void 0 ? 420 : _props$height,
      _props$latitude = props.latitude,
      latitude = _props$latitude === void 0 ? 0 : _props$latitude,
      _props$longitude = props.longitude,
      longitude = _props$longitude === void 0 ? 0 : _props$longitude,
      _props$maptype = props.maptype,
      maptype = _props$maptype === void 0 ? 'roadmap' : _props$maptype,
      _props$scale = props.scale,
      scale = _props$scale === void 0 ? 2 : _props$scale,
      title = props.title,
      _props$width = props.width,
      width = _props$width === void 0 ? 780 : _props$width,
      _props$zoom = props.zoom,
      zoom = _props$zoom === void 0 ? 8 : _props$zoom;
  var coordinates = {
    lat: latitude,
    lng: longitude
  };
  var appContext = react["useContext"](ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var iconUrl = "".concat(location.origin, "/markers/marker.png");
  var staticMapOptions = {
    center: "".concat(latitude, ",").concat(longitude),
    zoom: zoom,
    size: "".concat(width, "x").concat(height),
    scale: scale,
    maptype: maptype,
    language: appContext.locale,
    format: format,
    markers: "icon:".concat(iconUrl, "|scale:").concat(scale, "|").concat(latitude, ",").concat(longitude)
  };
  return GoogleMap_jsx(Map, {
    className: className,
    closeLabel: closeLabel,
    dataTestId: "map-preview",
    imageSrc: google_utils_getStaticMapURL(google_constants["d" /* GOOGLE_API_STATIC_PATH */], staticMapOptions),
    ratio: {
      w: width,
      h: height
    },
    title: title,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'GoogleMap'
    }
  }, GoogleMap_jsx("div", {
    className: "h-full"
  }, GoogleMap_jsx(GoogleMapReact, {
    bootstrapURLKeys: {
      key: config_default.a.get(google_constants["c" /* GOOGLE_API_KEY */])
    },
    defaultCenter: coordinates,
    defaultZoom: zoom,
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref2) {
      var map = _ref2.map,
          maps = _ref2.maps;
      return addMarker({
        map: map,
        maps: maps,
        position: coordinates,
        icon: iconUrl
      });
    },
    options: createMapOptions,
    yesIWantToUseGoogleMapApiInternals: true
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/map/StreetView.jsx
var StreetView = __webpack_require__("HKmi");

// CONCATENATED MODULE: ./src/client/components/frameworks/map/GoogleStreetView.jsx

var GoogleStreetView_jsx = react_default.a.createElement;





function GoogleStreetView(props) {
  var className = props.className,
      closeLabel = props.closeLabel,
      _props$fov = props.fov,
      fov = _props$fov === void 0 ? 2 : _props$fov,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 2 : _props$heading,
      _props$height = props.height,
      height = _props$height === void 0 ? 120 : _props$height,
      latitude = props.latitude,
      longitude = props.longitude,
      title = props.title,
      _props$width = props.width,
      width = _props$width === void 0 ? 640 : _props$width;
  var staticMapOptions = {
    size: "".concat(width, "x").concat(height),
    location: "".concat(latitude, ",").concat(longitude),
    fov: fov,
    heading: heading,
    pitch: 0 // guess what, the pitch that gets returned from the API is all kinds of wrong
    // because it really likes looking at ceilings; people don't want to look at
    // ceilings, so we hardcode the pitch to 0 until the API gets its act together
    // and returns 0; tbh we shouldn't even need the API to provide this to us.

  };
  return GoogleStreetView_jsx(Map, {
    className: className,
    closeLabel: closeLabel,
    dataTestId: "streetview-preview",
    imageSrc: google_utils_getStaticMapURL(google_constants["e" /* GOOGLE_API_STREET_VIEW_PATH */], staticMapOptions),
    ratio: {
      w: width,
      h: height
    },
    title: title,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'GoogleStreetView'
    }
  }, GoogleStreetView_jsx(StreetView["a" /* StreetView */], {
    fov: fov,
    heading: heading,
    latitude: latitude,
    longitude: longitude
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/access-and-map/AccessAndMap.jsx










var AccessAndMap_jsx = react_default.a.createElement;

function AccessAndMap_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function AccessAndMap_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccessAndMap_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccessAndMap_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var AccessAndMap_AccessAndMap = function AccessAndMap(_ref) {
  var _ref$access = _ref.access,
      access = _ref$access === void 0 ? [] : _ref$access,
      accessTitle = _ref.accessTitle,
      address = _ref.address,
      className = _ref.className,
      isBaidu = _ref.isBaidu,
      map = _ref.map,
      productName = _ref.productName,
      _ref$streetView = _ref.streetView,
      streetView = _ref$streetView === void 0 ? {} : _ref$streetView;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!map) {
    return null;
  }

  var ratio = isTablet ? {
    w: 780,
    h: 420
  } : {
    w: 290,
    h: 320
  };

  var mapProps = AccessAndMap_objectSpread(AccessAndMap_objectSpread({}, map), {}, {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    width: ratio.w,
    height: ratio.h
  });

  var coords = {
    latitude: mapProps.latitude,
    longitude: mapProps.longitude
  };
  var streetViewRatio = {
    w: 170,
    h: 90
  };
  var mapUrl = isBaidu ? getBaiduMapURL(coords) : getGoogleMapURL(coords);
  var hasStreetView = !!streetView.latitude && !!streetView.longitude;
  return AccessAndMap_jsx("div", {
    className: classnames_default()(className, 'flex flex-col sm:flex-row')
  }, AccessAndMap_jsx("div", {
    className: "relative mb-px20 sm:mb-0 sm:w-2/3"
  }, isBaidu ? AccessAndMap_jsx(BaiduMap_BaiduMap, Object(esm_extends["a" /* default */])({}, mapProps, {
    className: "rounded-tiny",
    title: Object(dist["messageFormat"])(Object(src_i18n["h" /* t */])('common.maps.productBaiduMap')).format({
      productName: productName
    })
  })) : AccessAndMap_jsx("div", {
    className: "relative"
  }, AccessAndMap_jsx(GoogleMap_GoogleMap, Object(esm_extends["a" /* default */])({}, mapProps, {
    className: "rounded-tiny",
    title: Object(dist["messageFormat"])(Object(src_i18n["h" /* t */])('common.maps.productGoogleMap')).format({
      productName: productName
    })
  })), hasStreetView && AccessAndMap_jsx("div", {
    style: {
      height: streetViewRatio.h,
      width: streetViewRatio.w
    },
    className: "absolute bottom-0 right-0 m-px20"
  }, AccessAndMap_jsx(GoogleStreetView, Object(esm_extends["a" /* default */])({}, streetView, {
    className: "border-5 border-solid border-white rounded-tiny shadow z-1",
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    height: streetViewRatio.h,
    title: Object(dist["messageFormat"])(Object(src_i18n["h" /* t */])('common.maps.productGoogleStreetView')).format({
      productName: productName
    }),
    width: streetViewRatio.w
  }))))), AccessAndMap_jsx("div", {
    className: "sm:rtl:ml-px20 sm:w-1/3"
  }, address && AccessAndMap_jsx("div", {
    className: "bg-white border-1 flex items-center last-child-mb-0 mb-px20 py-px10 px-px20 rounded-tiny"
  }, AccessAndMap_jsx(Address["a" /* Address */], Object(esm_extends["a" /* default */])({}, address, {
    className: "flex-1"
  })), mapUrl && AccessAndMap_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "leading-none p-px15 rtl:-mr-px15 text-gray-darker",
    "data-testid": "address-link",
    url: mapUrl,
    target: "_blank",
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'mapClick',
      labelGA: 'GoogleMapPage'
    }
  }, AccessAndMap_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ARROW_FORTH,
    hasRtl: true,
    width: "0.625rem"
  }))), !Object(lodash["isEmpty"])(access) && accessTitle && AccessAndMap_jsx("h3", {
    className: "reset-heading text-base mb-px15"
  }, accessTitle), AccessAndMap_jsx(SeeMore["a" /* SeeMore */], {
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreSize: 250,
    isCollapseEnabled: access.length > 3,
    classNameButton: "rtl:text-right"
  }, access.map(function (_ref2, i) {
    var iconName = _ref2.iconName,
        _ref2$texts = _ref2.texts,
        texts = _ref2$texts === void 0 ? [] : _ref2$texts;
    return AccessAndMap_jsx("div", {
      className: "bg-white border-1 flex items-center justify-between last-child-mb-0 mb-px15 py-px10 px-px20 rounded-tiny",
      "data-testid": "AccessAndMap-access",
      key: i
    }, AccessAndMap_jsx("div", null, texts.map(function (accessTextLine, j) {
      return AccessAndMap_jsx("p", {
        className: classnames_default()('reset-paragraph leading-normal text-gray-darker', {
          'text-sm': j,
          'text-base': !j
        }),
        key: j
      }, j ? accessTextLine : AccessAndMap_jsx("strong", {
        className: "font-bold"
      }, accessTextLine));
    })), AccessAndMap_jsx(Icon["a" /* Icon */], {
      className: "rtl:ml-px20 flex-shrink-0",
      color: colors["a" /* COLORS */].GRAY_DARKER,
      name: iconName,
      width: "1rem"
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-access-and-map-line/ProductAccessAndMapLine.jsx







var ProductAccessAndMapLine_jsx = react_default.a.createElement;






var ICON_MAPPING = {
  TRAIN_STATION: icons["a" /* ICONS */].TRAIN,
  AIRPORT: icons["a" /* ICONS */].TRANSPORT,
  PORT: icons["a" /* ICONS */].BOAT
};

var buildAccess = function buildAccess(hours, minutes) {
  return function (_ref) {
    var name = _ref.name,
        transfertDurationMin = _ref.transfertDurationMin,
        type = _ref.type;
    return type ? {
      iconName: ICON_MAPPING[type.toUpperCase()],
      texts: [name, transfertDurationMin ? transfertDurationConverter(transfertDurationMin, hours, minutes) : null].filter(Boolean)
    } : null;
  };
};
/**
 * Convert transfertDuration format
 * @param {number} transfertDuration The duration to format
 * @param {string} hours Value from content
 * @param {string} minutes Value from content
 * @returns {string} The duration formatted
 */


var transfertDurationConverter = function transfertDurationConverter(transfertDuration, hours, minutes) {
  var hoursValue = Math.floor(transfertDuration / 60);
  var minutesDuration = transfertDuration - hoursValue * 60;
  var minutesValue = minutesDuration > 0 ? "".concat(minutesDuration, " ").concat(minutes) : '';
  return hoursValue ? "".concat(hoursValue).concat(hours).concat(minutesValue) : minutesValue;
};

var sortAccessByDuration = function sortAccessByDuration(accessesA, accessesB) {
  return accessesA.transfertDurationMin && accessesB.transfertDurationMin ? accessesA.transfertDurationMin - accessesB.transfertDurationMin : 0;
};

var ProductAccessAndMapLine_ProductAccessAndMapLine = function ProductAccessAndMapLine(props) {
  var accessTitle = props.accessTitle,
      config = props.config,
      hours = props.hours,
      mapType = props.mapType,
      minutes = props.minutes,
      _props$resort = props.resort,
      resort = _props$resort === void 0 ? {} : _props$resort,
      title = props.title;
  var accessesFiltered = resort.accesses.filter(function (access) {
    return access.id && !access.id.includes('MICE');
  }).sort(sortAccessByDuration);
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  return ProductAccessAndMapLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, ProductAccessAndMapLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductAccessAndMapLine_jsx(AccessAndMap_AccessAndMap, {
    accessTitle: accessTitle,
    access: [].concat(accessesFiltered || []).map(buildAccess(hours, minutes)).filter(Boolean),
    address: resort.address,
    isBaidu: mapType === 'BAIDU',
    map: resort.coordinates,
    productName: resort.name,
    streetView: resort.streetView
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-access-and-map/productAccessAndMap.resolver.js
var productAccessAndMap_resolver = __webpack_require__("afpJ");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-access-and-map/productAccessAndMap.descriptor.js



var productAccessAndMapDescriptor = {
  name: constants["bb" /* RESORT_ACCESS_AND_MAP */],
  component: ProductAccessAndMapLine_ProductAccessAndMapLine,
  resolve: productAccessAndMap_resolver["a" /* productAccessAndMapResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/labeled-icons-list/LabeledIconsList.jsx + 1 modules
var LabeledIconsList = __webpack_require__("LR4h");

// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparator.utils.js
var ITEMS_ORDER = ['services', 'equipments', 'bathroomEquipments'];
var SECTION_LABELS = {
  equipments: 'common.accommodations.equipments',
  services: 'common.accommodations.services',
  bathroomEquipments: 'common.accommodations.bathroomEquipments'
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLarge.jsx



var ProductRoomsComparatorLarge_jsx = react_default.a.createElement;










var ProductRoomsComparatorLarge_ProductRoomsComparatorLarge = function ProductRoomsComparatorLarge(_ref) {
  var availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns,
      allCategoriesItems = _ref.allCategoriesItems;
  var _thTitle$thInfoTitle$ = {
    thTitle: 'font-brand text-xl text-blue text-center',
    thInfoTitle: 'text-gray-medium-dark flex items-center py-px10',
    thInfo: 'font-bold text-md flex items-center justify-center',
    thStrength: 'py-px10 flex items-center justify-center',
    thSectionHeader: 'flex mb-px20',
    thSectionTitle: 'text-2xl font-bold text-blue',
    thSectionHeaderItem: 'flex items-center justify-center',
    thIcon: 'text-blue rtl:mr-px15 flex-shrink-0',
    thTableCell: 'px-px10',
    thCheck: 'flex items-center justify-center',
    thExclusiveCollection: 'text-deepBlue font-serif font-bold'
  },
      thTitle = _thTitle$thInfoTitle$.thTitle,
      thInfoTitle = _thTitle$thInfoTitle$.thInfoTitle,
      thInfo = _thTitle$thInfoTitle$.thInfo,
      thStrength = _thTitle$thInfoTitle$.thStrength,
      thSectionHeader = _thTitle$thInfoTitle$.thSectionHeader,
      thSectionTitle = _thTitle$thInfoTitle$.thSectionTitle,
      thSectionHeaderItem = _thTitle$thInfoTitle$.thSectionHeaderItem,
      thIcon = _thTitle$thInfoTitle$.thIcon,
      thTableCell = _thTitle$thInfoTitle$.thTableCell,
      thCheck = _thTitle$thInfoTitle$.thCheck,
      thExclusiveCollection = _thTitle$thInfoTitle$.thExclusiveCollection;
  var columnWidth = "".concat(100 / (columns.length + 1), "%");

  var getHorizontalAvailabilityLinesFromItemType = function getHorizontalAvailabilityLinesFromItemType(itemType) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].map(function (item, index) {
      return ProductRoomsComparatorLarge_jsx("div", {
        className: "flex",
        key: index
      }, ProductRoomsComparatorLarge_jsx("div", {
        className: "flex items-center text-md py-px10",
        style: {
          width: columnWidth
        }
      }, ProductRoomsComparatorLarge_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        alt: "",
        className: thIcon,
        width: "calc(20rem / 16)"
      }), item.label), availabilityBoards.map(function (board, boardIndex) {
        var activeColor = columns[boardIndex].isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].TURQUOISE;
        return ProductRoomsComparatorLarge_jsx("div", {
          key: boardIndex,
          className: classnames_default()(thTableCell, thCheck),
          style: {
            width: columnWidth
          }
        }, ProductRoomsComparatorLarge_jsx(Icon["a" /* Icon */], {
          name: icons["a" /* ICONS */].CHECK,
          color: board[itemType][index] ? activeColor : colors["a" /* COLORS */].GRAY_LIGHT,
          width: "calc(16rem / 16)"
        }));
      }));
    });
  };

  return ProductRoomsComparatorLarge_jsx("div", {
    className: "px-px20 pt-px60"
  }, ProductRoomsComparatorLarge_jsx("div", {
    className: "max-w-site mx-auto"
  }, ProductRoomsComparatorLarge_jsx("div", {
    className: "flex justify-end"
  }, columns.map(function (column, index) {
    return ProductRoomsComparatorLarge_jsx("div", {
      key: index,
      className: classnames_default()('text-center', thTableCell),
      style: {
        width: columnWidth
      }
    }, ProductRoomsComparatorLarge_jsx("div", {
      className: classnames_default()(thTitle, Object(defineProperty["a" /* default */])({}, thExclusiveCollection, column.isExclusiveCollection))
    }, column.title), ProductRoomsComparatorLarge_jsx(Image["a" /* Image */], {
      altMsg: column.title,
      className: classnames_default()('mt-px30', {
        'inset-border-after': column.isExclusiveCollection
      }),
      hasLazyLoading: true,
      imageUrl: column.picture.url,
      ratioKey: ratios_utils["a" /* default */].XL
    }));
  })), ProductRoomsComparatorLarge_jsx("div", {
    className: "flex"
  }, ProductRoomsComparatorLarge_jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, ProductRoomsComparatorLarge_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SINGLE_ROOM,
    className: "rtl:mr-px15",
    width: "calc(30rem / 16)",
    color: colors["a" /* COLORS */].BLUE
  }), Object(src_i18n["h" /* t */])('common.accommodations.size')), columns.map(function (column, index) {
    return ProductRoomsComparatorLarge_jsx("div", {
      key: index,
      className: classnames_default()(thTableCell, thInfo, Object(defineProperty["a" /* default */])({}, thExclusiveCollection, column.isExclusiveCollection)),
      style: {
        width: columnWidth
      }
    }, column.surface);
  })), ProductRoomsComparatorLarge_jsx("div", {
    className: "flex"
  }, ProductRoomsComparatorLarge_jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, ProductRoomsComparatorLarge_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].USERS,
    className: "rtl:mr-px15",
    width: "calc(30rem / 16)",
    color: colors["a" /* COLORS */].BLUE
  }), Object(src_i18n["h" /* t */])('common.accommodations.capacity')), columns.map(function (column, index) {
    return ProductRoomsComparatorLarge_jsx("div", {
      key: index,
      className: classnames_default()(thTableCell, thInfo, Object(defineProperty["a" /* default */])({}, thExclusiveCollection, column.isExclusiveCollection)),
      style: {
        width: columnWidth
      }
    }, column.capacity);
  })), ProductRoomsComparatorLarge_jsx("div", {
    className: "flex"
  }, ProductRoomsComparatorLarge_jsx("div", {
    className: thInfoTitle,
    style: {
      width: columnWidth
    }
  }, Object(src_i18n["h" /* t */])('common.accommodations.strengths')), columns.map(function (column, index) {
    return ProductRoomsComparatorLarge_jsx("div", {
      key: index,
      className: classnames_default()(thTableCell, thStrength, Object(defineProperty["a" /* default */])({}, thExclusiveCollection, column.isExclusiveCollection)),
      style: {
        width: columnWidth
      }
    }, ProductRoomsComparatorLarge_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      theme: "comparator",
      items: column.strengths.map(function (strength) {
        return {
          icon: icons["a" /* ICONS */][strength.id] || icons["a" /* ICONS */].TRIDENT1,
          labels: [strength.label]
        };
      }),
      color: column.isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE
    }));
  })), ITEMS_ORDER.map(function (itemType) {
    return ProductRoomsComparatorLarge_jsx("div", {
      key: itemType,
      className: "py-px30 border-t-1"
    }, ProductRoomsComparatorLarge_jsx("div", {
      className: thSectionHeader
    }, ProductRoomsComparatorLarge_jsx("div", {
      className: thSectionTitle,
      style: {
        width: columnWidth
      }
    }, Object(src_i18n["h" /* t */])(SECTION_LABELS[itemType])), columns.map(function (column, index) {
      return ProductRoomsComparatorLarge_jsx("div", {
        key: index,
        className: classnames_default()(thTitle, thSectionHeaderItem, thTableCell, Object(defineProperty["a" /* default */])({}, thExclusiveCollection, column.isExclusiveCollection)),
        style: {
          width: columnWidth
        }
      }, column.title);
    })), getHorizontalAvailabilityLinesFromItemType(itemType));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorNarrow.jsx



var ProductRoomsComparatorNarrow_jsx = react_default.a.createElement;










var ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow = function ProductRoomsComparatorNarrow(_ref) {
  var availabilityBoards = _ref.availabilityBoards,
      columns = _ref.columns,
      allCategoriesItems = _ref.allCategoriesItems;
  var _thColumn$thTitle$thI = {
    thColumn: 'border-1 rounded-small bg-white shadow-diffuse',
    thTitle: 'p-px15 leading-tight font-brand text-xl text-blue',
    thInfoTitle: 'text-gray-dark text-base flex items-center pt-px10',
    thInfo: 'rtl:ml-auto font-bold text-md',
    thSectionHeader: 'flex',
    thSectionTitle: 'text-lg font-bold text-blue',
    thIcon: 'text-blue rtl:mr-px15 flex-shrink-0',
    thCheck: 'flex items-center justify-center',
    thExclusiveCollection: 'text-deepBlue font-serif font-bold'
  },
      thColumn = _thColumn$thTitle$thI.thColumn,
      thTitle = _thColumn$thTitle$thI.thTitle,
      thInfoTitle = _thColumn$thTitle$thI.thInfoTitle,
      thInfo = _thColumn$thTitle$thI.thInfo,
      thSectionHeader = _thColumn$thTitle$thI.thSectionHeader,
      thSectionTitle = _thColumn$thTitle$thI.thSectionTitle,
      thIcon = _thColumn$thTitle$thI.thIcon,
      thCheck = _thColumn$thTitle$thI.thCheck,
      thExclusiveCollection = _thColumn$thTitle$thI.thExclusiveCollection;

  var getItemsAvailability = function getItemsAvailability(itemType, columnIndex) {
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].map(function (item, index) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: index,
        className: "flex justify-between items-baseline"
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: "flex items-center text-md pt-px20"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */][item.id] || icons["a" /* ICONS */].TRIDENT1,
        alt: "",
        className: thIcon,
        width: "calc(20rem / 16)"
      }), item.label), ProductRoomsComparatorNarrow_jsx("div", {
        className: classnames_default()(thCheck)
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].CHECK,
        color: availabilityBoards[columnIndex][itemType][index] ? colors["a" /* COLORS */].TURQUOISE : colors["a" /* COLORS */].GRAY_LIGHT,
        width: "calc(16rem / 16)"
      })));
    });
  };

  return ProductRoomsComparatorNarrow_jsx("div", {
    className: "px-px20 pt-px30"
  }, ProductRoomsComparatorNarrow_jsx("div", {
    className: "max-w-site mx-auto"
  }, ProductRoomsComparatorNarrow_jsx(Slider["a" /* Slider */], {
    cols: 0,
    navPosition: "center",
    nbItemsToScroll: 1,
    scrollAreaClassName: "overflow-hidden -mx-px10",
    scrollAreaContainerClassName: "overflow-auto scroll-snap-area scroll-snap-type-x-mandatory",
    scrollItemClassName: "overflow-hidden px-px10 pb-px20 flex-none max-w-full"
  }, columns.map(function (column, columnIndex) {
    return ProductRoomsComparatorNarrow_jsx("div", {
      key: columnIndex,
      className: thColumn,
      style: {
        width: '80vw'
      }
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: classnames_default()(thTitle, Object(defineProperty["a" /* default */])({}, thExclusiveCollection, column.isExclusiveCollection))
    }, column.title), ProductRoomsComparatorNarrow_jsx(Image["a" /* Image */], {
      altMsg: column.title,
      className: classnames_default()({
        'inset-border-after': column.isExclusiveCollection
      }),
      hasLazyLoading: true,
      imageUrl: column.picture.url,
      ratioKey: ratios_utils["a" /* default */].XL
    }), ProductRoomsComparatorNarrow_jsx("div", {
      className: "flex px-px15 items-baseline"
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thInfoTitle
    }, Object(src_i18n["h" /* t */])('common.accommodations.size')), ProductRoomsComparatorNarrow_jsx("div", {
      className: classnames_default()(thInfo)
    }, column.surface)), ProductRoomsComparatorNarrow_jsx("div", {
      className: "flex px-px15 items-baseline"
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thInfoTitle
    }, Object(src_i18n["h" /* t */])('common.accommodations.capacity')), ProductRoomsComparatorNarrow_jsx("div", {
      className: classnames_default()(thInfo)
    }, column.capacity)), column.strengths.length > 0 && ProductRoomsComparatorNarrow_jsx("div", {
      className: "px-px15 pt-px10 pb-px15"
    }, ProductRoomsComparatorNarrow_jsx("div", {
      className: thInfoTitle
    }, Object(src_i18n["h" /* t */])('common.accommodations.strengths')), column.strengths.map(function (strength) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: strength.id,
        className: "flex pt-px5 items-center"
      }, ProductRoomsComparatorNarrow_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */][strength.id],
        color: colors["a" /* COLORS */].BLUE,
        width: "calc(16rem / 16)",
        className: "rtl:mr-px5"
      }), strength.label);
    })), ITEMS_ORDER.map(function (itemType, itemIndex) {
      return ProductRoomsComparatorNarrow_jsx("div", {
        key: itemIndex,
        className: classnames_default()('pt-px20 pb-px30 px-px15 border-t-1', {
          'mt-px10': itemIndex === 0
        })
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionHeader
      }, ProductRoomsComparatorNarrow_jsx("div", {
        className: thSectionTitle
      }, Object(src_i18n["h" /* t */])(SECTION_LABELS[itemType]))), getItemsAvailability(itemType, columnIndex));
    }));
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-rooms-comparator/ProductRoomsComparatorLauncher.jsx









var ProductRoomsComparatorLauncher_jsx = react_default.a.createElement;












var ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher = function ProductRoomsComparatorLauncher(_ref) {
  var accommodationCategories = _ref.accommodationCategories,
      activeIndex = _ref.activeIndex,
      _ref$resortIsExclusiv = _ref.resortIsExclusiveCollection,
      resortIsExclusiveCollection = _ref$resortIsExclusiv === void 0 ? false : _ref$resortIsExclusiv;

  var _useState = Object(react["useState"])(false),
      isLayerOpened = _useState[0],
      setIsLayerOpened = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var allCategoriesItems = ITEMS_ORDER.map(function (itemType) {
    return productAccommodations_utils_getAllAvailableItems(accommodationCategories, itemType);
  });
  var columns = accommodationCategories.map(function (category) {
    return {
      title: category.categoryLabel,
      picture: category.media.photos[0],
      isExclusiveCollection: category.exclusiveCollection || resortIsExclusiveCollection,
      isExclusiveCollectionSpace: category.exclusiveCollection && !resortIsExclusiveCollection,
      surface: ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(src_i18n["h" /* t */])('common.accommodations.sizeFrom'),
        values: {
          min_area: "".concat(category.area.min).concat(category.area.unit),
          max_area: "".concat(category.area.max).concat(category.area.unit)
        }
      }),
      capacity: ProductRoomsComparatorLauncher_jsx(TemplateString["a" /* TemplateString */], {
        template: Object(src_i18n["h" /* t */])('common.accommodations.capacityFrom'),
        values: {
          min_capacity: "".concat(category.minCapacity),
          max_capacity: "".concat(category.maxCapacity)
        }
      }),
      strengths: productAccommodations_utils_getAllAvailableItems([category], 'strengths').slice(0, 4)
    };
  });

  var getAvailabilityBoard = function getAvailabilityBoard(set, itemType) {
    var availableInCategory = new Set(set.map(function (_ref2) {
      var id = _ref2.id;
      return id;
    }));
    return allCategoriesItems[ITEMS_ORDER.indexOf(itemType)].map(function (_ref3) {
      var id = _ref3.id;
      return availableInCategory.has(id);
    });
  };

  var availabilityBoards = accommodationCategories.map(function (category) {
    var availableEquipments = category.equipments;
    var availableServices = category.services;
    var availableBathroomEquipments = category.bathroomEquipments;
    var equipmentsAvailability = getAvailabilityBoard(availableEquipments, 'equipments');
    var servicesAvailability = getAvailabilityBoard(availableServices, 'services');
    var bathroomEquipmentsAvailability = getAvailabilityBoard(availableBathroomEquipments, 'bathroomEquipments');
    return {
      equipments: equipmentsAvailability,
      services: servicesAvailability,
      bathroomEquipments: bathroomEquipmentsAvailability
    };
  });
  return ProductRoomsComparatorLauncher_jsx(react["Fragment"], null, ProductRoomsComparatorLauncher_jsx(Button["a" /* Button */], {
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].TURQUOISE,
    iconLeft: {
      name: icons["a" /* ICONS */].COMPARE
    },
    onClick: function onClick() {
      return setIsLayerOpened(true);
    },
    className: "w-full",
    trackingData: {
      actionGA: 'blockInfos',
      labelGA: "accommodation_".concat(accommodationCategories[activeIndex].categoryLabel, "_compareRooms")
    }
  }, Object(src_i18n["h" /* t */])('common.accommodations.compareRooms')), isLayerOpened && ProductRoomsComparatorLauncher_jsx(Layer["b" /* Layer */], {
    ariaLabel: Object(src_i18n["h" /* t */])('common.accommodations.compareRooms'),
    bgColor: colors["a" /* COLORS */].WHITE,
    buttonLeft: {
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      onClick: function onClick() {
        setIsLayerOpened(false);
      }
    },
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    hasAnimateEnter: true,
    hasContainerHeader: true,
    header: ProductRoomsComparatorLauncher_jsx("div", {
      className: "text-center font-bold text-blue"
    }, Object(src_i18n["h" /* t */])('common.accommodations.compareRooms')),
    onClose: function onClose() {
      setIsLayerOpened(false);
    }
  }, isDesktop ? ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorLarge_ProductRoomsComparatorLarge, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  }) : ProductRoomsComparatorLauncher_jsx(ProductRoomsComparatorNarrow_ProductRoomsComparatorNarrow, {
    columns: columns,
    availabilityBoards: availabilityBoards,
    allCategoriesItems: allCategoriesItems,
    accommodationCategories: accommodationCategories
  })));
};
// CONCATENATED MODULE: ./src/client/components/utils/markup/markup.js









function markup_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function markup_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      markup_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      markup_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}



var markup_getLinkTagName = function getLinkTagName(link) {
  if (Object(lodash["isEmpty"])(link)) {
    return 'div';
  }

  return link.onClick ? 'button' : DynamicLink["a" /* default */];
};
var getLinkProps = function getLinkProps(link) {
  return (link === null || link === void 0 ? void 0 : link.onClick) ? markup_objectSpread(markup_objectSpread({}, link), {}, {
    type: 'button'
  }) : link;
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-room-card/ProductRoomCard.jsx




var ProductRoomCard_jsx = react_default.a.createElement;









var ProductRoomCard_ProductRoomCard = function ProductRoomCard(_ref) {
  var className = _ref.className,
      isExclusiveCollection = _ref.isExclusiveCollection,
      isHidden = _ref.isHidden,
      isLarge = _ref.isLarge,
      _ref$labeledIconsList = _ref.labeledIconsList,
      labeledIconsList = _ref$labeledIconsList === void 0 ? [] : _ref$labeledIconsList,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title,
      trackingData = _ref.trackingData,
      width = _ref.width;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isTablet = _useResponsive.isTablet;

  var tagName = markup_getLinkTagName(link);
  var linkProps = getLinkProps(link);

  var content = ProductRoomCard_jsx(react["Fragment"], null, ProductRoomCard_jsx(Title["a" /* Title */], {
    className: classnames_default()('mb-px20 flex w-full text-lg text-blue font-brand', {
      'font-serif font-bold text-deepBlue': isExclusiveCollection
    }),
    hasEllipsis: true,
    theme: "none"
  }, title), ProductRoomCard_jsx("ul", {
    className: classnames_default()('reset-list mb-px15 w-full', {
      'font-serif': isExclusiveCollection
    })
  }, labeledIconsList.map(function (_ref2, index) {
    var labels = _ref2.labels;
    return ProductRoomCard_jsx("li", {
      className: "flex justify-between mt-px5 overflow-hidden text-base",
      key: index,
      style: {
        minHeight: '1.25rem'
      }
    }, !!labels && ProductRoomCard_jsx("span", {
      className: "inline-flex items-center justify-between w-full"
    }, labels.map(function (label, labelIndex) {
      return ProductRoomCard_jsx("span", {
        className: classnames_default()('text-base', {
          'text-gray-dark': labelIndex === 0
        }, {
          'text-gray-darker font-bold rtl:text-right': labelIndex !== 0
        }),
        key: label
      }, label, "\xA0");
    })));
  })), !!seeMoreLabel && ProductRoomCard_jsx("p", {
    className: "reset-paragraph w-full mt-auto text-center text-blue text-sm underline"
  }, seeMoreLabel));

  var ratio = isLarge && isTablet ? ratios_utils["a" /* default */].R_38_BY_58 : ratios_utils["a" /* default */].XL;
  return isDesktop ? ProductRoomCard_jsx(TeaserCard_TeaserCard, {
    "aria-hidden": isHidden,
    className: classnames_default()(className, 'tap-highlight-color-transparent transition-transform w-full'),
    hasInsetBorder: isExclusiveCollection,
    isActive: isHovering,
    media: media,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous'),
    ratio: ratio,
    width: width,
    theme: "short"
  }, ProductRoomCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkProps, {
    as: tagName,
    className: "reset-button text-initial w-full h-full flex flex-col",
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    },
    tabIndex: isHidden ? -1 : 0,
    trackingData: trackingData
  }), content)) : ProductRoomCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkProps, {
    "aria-hidden": isHidden,
    as: tagName,
    className: classnames_default()(className, 'block reset-button tap-highlight-color-transparent text-initial w-full h-full'),
    style: {
      width: width
    },
    tabIndex: isHidden ? -1 : 0,
    trackingData: trackingData
  }), ProductRoomCard_jsx(TeaserCard_TeaserCard, {
    hasInsetBorder: isExclusiveCollection,
    media: media.slice(0, 1),
    ratio: ratio,
    theme: "short"
  }, content));
};
// CONCATENATED MODULE: ./src/client/components/frameworks/zoom/Zoom.jsx
var Zoom_jsx = react_default.a.createElement;




var Zoom_Zoom = function Zoom(_ref) {
  var imageUrl = _ref.imageUrl,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$hint = _ref.hint,
      hint = _ref$hint === void 0 ? '' : _ref$hint;
  return Zoom_jsx("div", {
    className: "relative",
    style: {
      height: '400px'
    }
  }, hint && Zoom_jsx("span", {
    className: "font-brand text-blue text-base absolute top-0 inset-x-0 mt-px20 flex items-center justify-center leading-none"
  }, Zoom_jsx(Icon["a" /* Icon */], {
    width: "calc(20rem / 16)",
    name: icons["a" /* ICONS */].LIGHTBULB
  }), Zoom_jsx("span", {
    className: "rtl:ml-px5"
  }, hint)), Zoom_jsx("div", {
    className: "overflow-x-scroll overflow-y-hidden scrolling-touch h-full w-full flex items-center"
  }, Zoom_jsx(Image["a" /* Image */], {
    imageUrl: imageUrl,
    altMsg: alt,
    dimensions: {
      w: 'auto',
      h: 'auto'
    },
    style: {
      maxWidth: 'initial',
      maxHeight: 'initial',
      height: '100%'
    },
    className: "py-px20 pt-px60 h-full"
  })));
};
// EXTERNAL MODULE: ./src/client/components/frameworks/tooltip/Tooltip.jsx
var Tooltip = __webpack_require__("i3Ve");

// CONCATENATED MODULE: ./src/client/components/widgets/product-room-detail/ProductRoomDetail.jsx











var ProductRoomDetail_jsx = react_default.a.createElement;

function ProductRoomDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductRoomDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductRoomDetail_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductRoomDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















var ProductRoomDetail_ProductRoomDetail = function ProductRoomDetail(_ref) {
  var description = _ref.description,
      immersive = _ref.immersive,
      _ref$isExclusiveColle = _ref.isExclusiveCollection,
      isExclusiveCollection = _ref$isExclusiveColle === void 0 ? false : _ref$isExclusiveColle,
      _ref$overviewCompact = _ref.overviewCompact,
      overviewCompact = _ref$overviewCompact === void 0 ? [] : _ref$overviewCompact,
      _ref$overviewAlternat = _ref.overviewAlternate,
      overviewAlternate = _ref$overviewAlternat === void 0 ? [] : _ref$overviewAlternat,
      strengthsLabel = _ref.strengthsLabel,
      amenitiesLabel = _ref.amenitiesLabel,
      _ref$services = _ref.services,
      services = _ref$services === void 0 ? [] : _ref$services,
      _ref$slideshow = _ref.slideshow,
      slideshow = _ref$slideshow === void 0 ? {} : _ref$slideshow,
      _ref$multimedia = _ref.multimedia,
      multimedia = _ref$multimedia === void 0 ? {} : _ref$multimedia,
      _ref$floorPlan = _ref.floorPlan,
      floorPlan = _ref$floorPlan === void 0 ? '' : _ref$floorPlan,
      title = _ref.title,
      subtitle = _ref.subtitle;

  var slideshowProps = ProductRoomDetail_objectSpread(ProductRoomDetail_objectSpread({}, slideshow), {}, {
    groupKey: 'roomDetail',
    hasInsetBorder: isExclusiveCollection,
    media: slideshow.media,
    hasInfiniteScroll: true,
    nextLabel: Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: Object(src_i18n["h" /* t */])('common.previous')
  });

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var numberOfPhotos = multimedia && multimedia.photos ? multimedia.photos.length : 0;
  var multimediaProps = {
    galleryLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productGallery', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.galleries.gallery'),
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    descriptionLabels: {
      photos: '',
      streetViews: Object(src_i18n["h" /* t */])('common.view360Disclaimer')
    },
    isOverlay: true,
    labels: {
      photos: Object(src_i18n["h" /* t */])('common.photoTitle')
    },
    nextLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productNextPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.next'),
    previousLabel: title ? Object(src_i18n["h" /* t */])('common.galleries.productPreviousPicture', {
      productName: title
    }) : Object(src_i18n["h" /* t */])('common.previous'),
    pictureAltLabel: Object(src_i18n["h" /* t */])('common.galleries.productPictureItem', {
      total: numberOfPhotos,
      productName: title
    }),
    medias: multimedia
  };
  var color = isExclusiveCollection ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE;

  var header = ProductRoomDetail_jsx("section", {
    className: "p-px20 md:pt-px80"
  }, ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: classnames_default()('text-md md:text-xl mb-px5', {
      'font-serif': isExclusiveCollection
    }),
    text: subtitle,
    theme: "text-sans-1"
  }), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: "text-3xl md:text-7xl leading-tight ".concat(isExclusiveCollection ? 'font-serif font-bold' : 'font-brand'),
    color: color,
    theme: "none"
  }, title), ProductRoomDetail_jsx("div", {
    className: classnames_default()('font-base flex mt-px20 mb-px25 md:mb-px50', {
      'font-serif': isExclusiveCollection
    })
  }, overviewCompact.map(function (item, index) {
    return ProductRoomDetail_jsx("div", {
      className: "w-1/2 md:w-1/5 rtl:pr-px5",
      key: index
    }, item.map(function (line, idx) {
      return ProductRoomDetail_jsx("div", {
        className: idx === 0 ? 'font-bold' : '',
        key: "".concat(index, "-").concat(idx)
      }, line);
    }));
  })), ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: classnames_default()('text-md md:text-xl mx-auto w-full max-w-site-small', {
      'font-serif': isExclusiveCollection
    }),
    text: description,
    theme: "text-sans-1"
  }));

  return ProductRoomDetail_jsx(Sheet, {
    slideshow: slideshowProps,
    immersive: immersive,
    multimedia: multimediaProps,
    isExclusiveCollection: isExclusiveCollection,
    header: header
  }, ProductRoomDetail_jsx("div", {
    className: isExclusiveCollection ? 'font-serif' : 'font-sans'
  }, !!overviewAlternate.length && ProductRoomDetail_jsx("section", {
    className: "pb-px20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: classnames_default()('text-xl md:text-4xl mb-px15', {
      'font-brand': !isExclusiveCollection,
      'font-bold': isExclusiveCollection
    }),
    color: color,
    hLevel: 3,
    theme: "none"
  }, strengthsLabel), ProductRoomDetail_jsx("div", {
    className: "max-w-site-small w-full mx-auto"
  }, ProductRoomDetail_jsx("div", {
    style: {
      maxWidth: 'calc(680rem / 16)'
    }
  }, ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
    color: color,
    items: overviewAlternate
  })))), floorPlan && ProductRoomDetail_jsx("section", {
    className: "pb-px20"
  }, ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: classnames_default()('text-xl md:text-4xl mb-px40', {
      'font-brand': !isExclusiveCollection,
      'font-bold': isExclusiveCollection
    }),
    color: color,
    hLevel: 3,
    theme: "none"
  }, Object(src_i18n["h" /* t */])('common.roomPlan.title')), ProductRoomDetail_jsx("div", {
    className: "max-w-site-small w-full mx-auto"
  }, ProductRoomDetail_jsx("div", {
    className: "flex flex-col"
  }, !isTablet && ProductRoomDetail_jsx(Tooltip["a" /* Tooltip */], {
    renderTrigger: function renderTrigger(toggle) {
      return ProductRoomDetail_jsx("button", {
        onClick: function onClick() {
          toggle();
        },
        className: "reset-button bg-white mb-px15 rtl:ml-auto focus:bg-overlay-black-60 hover:bg-overlay-black-60 rounded-tiny p-px5 leading-none shadow-sm text-gray-darker hover:text-white focus:text-white transition-bg-color"
      }, ProductRoomDetail_jsx(Icon["a" /* Icon */], {
        name: icons["a" /* ICONS */].FULLSCREEN,
        width: "calc(20rem / 16)"
      }));
    },
    modalProps: {
      children: '',
      addendum: ProductRoomDetail_jsx(Text["a" /* Text */], {
        className: "py-px20 px-px10 text-center leading-tight text-sm text-white",
        theme: "none",
        text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer')
      })
    }
  }, ProductRoomDetail_jsx(Zoom_Zoom, {
    imageUrl: floorPlan,
    alt: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
    hint: Object(src_i18n["h" /* t */])('common.roomPlan.swipeInstruction')
  })), ProductRoomDetail_jsx(Image["a" /* Image */], {
    imageUrl: floorPlan,
    altMsg: "".concat(Object(src_i18n["h" /* t */])('common.roomPlan.title'), " ").concat(title),
    dimensions: {
      w: 'auto',
      h: 'auto'
    },
    className: "w-full"
  }), ProductRoomDetail_jsx(Text["a" /* Text */], {
    className: classnames_default()('pt-px60 pb-px40 md:pt-px25 md:pb-px80 md:text-center leading-tight text-base', {
      'font-sans': !isTablet
    }),
    text: Object(src_i18n["h" /* t */])('common.roomPlan.disclaimer')
  })))), ProductRoomDetail_jsx(Title["a" /* Title */], {
    className: classnames_default()('text-xl md:text-4xl mb-px15 md:mb-0', {
      'font-brand': !isExclusiveCollection,
      'font-bold': isExclusiveCollection
    }),
    color: color,
    hLevel: 3,
    theme: "none"
  }, amenitiesLabel), services.map(function (_ref2) {
    var label = _ref2.label,
        items = _ref2.items;
    return ProductRoomDetail_jsx("section", {
      className: "py-px15 md:py-px30",
      key: label
    }, ProductRoomDetail_jsx("div", {
      className: "max-w-site-small w-full mx-auto"
    }, ProductRoomDetail_jsx(Title["a" /* Title */], {
      className: "text-md md:text-xl font-bold pb-px10 mb-px30 border-b-1 border-deepBlue",
      hLevel: 4,
      theme: "none"
    }, label), ProductRoomDetail_jsx(LabeledIconsList["a" /* LabeledIconsList */], {
      items: items,
      theme: "list",
      color: color
    })));
  })));
};
// EXTERNAL MODULE: ./src/utils/proposal/constants.js
var proposal_constants = __webpack_require__("tI+f");

// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/productAccommodations.utils.js

















var productAccommodations_utils_jsx = react_default.a.createElement;










var PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES,
    RANKINGS = dist["constants"].RANKINGS;
var DEFAULT_RANKING = RANKINGS.LOW;
function getSurfaceIconItem(i18n, surface, roomType) {
  return {
    icon: icons["a" /* ICONS */][roomType] || null,
    labels: [Object(lodash["get"])(i18n, Object(lodash["camelCase"])(roomType)), surface || roomType && ' ' || '']
  };
}
function getCapacityIconItem(i18n, capacity) {
  var peopleLabel = Object(lodash["get"])(i18n, 'numberOfPeopleLabel');

  if (!capacity || !peopleLabel) {
    return null;
  }

  return {
    icon: icons["a" /* ICONS */].PEOPLE,
    labels: [Object(lodash["get"])(i18n, 'capacityOfPeopleLabel'), Object(dist["messageFormat"])(peopleLabel).format({
      count: capacity
    })]
  };
}
function getViewIconItem(view) {
  return view ? {
    icon: icons["a" /* ICONS */][Object(lodash["get"])(view, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [view.label]
  } : null;
}
function getOutsideFacilitiesIconItems(outsideFacilities) {
  if (Object(lodash["isEmpty"])(outsideFacilities)) {
    return null;
  }

  return outsideFacilities.map(function (item) {
    return {
      icon: icons["a" /* ICONS */][Object(lodash["get"])(item, 'id')],
      labels: [item.label]
    };
  });
}

function getServiceIconItem(service) {
  return service ? {
    icon: icons["a" /* ICONS */][Object(lodash["get"])(service, 'id')] || icons["a" /* ICONS */].TRIDENT1,
    labels: [service.label]
  } : null;
}

function aggregateIconList(_ref) {
  var surfaceItem = _ref.surfaceItem,
      capacityItem = _ref.capacityItem,
      outsideFacilitiesItems = _ref.outsideFacilitiesItems,
      strengths = _ref.strengths,
      viewItem = _ref.viewItem;
  var maxAccomodationsToDisplay = 4;
  var accomodationsWithoutStrengthsCount = [capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem]).filter(function (item) {
    return Object(lodash["get"])(item, 'labels.0');
  }).length;
  var availableSpacesForStrengths = maxAccomodationsToDisplay - accomodationsWithoutStrengthsCount;
  var strengthsItems = (strengths || []).slice(0, availableSpacesForStrengths).map(function (strength) {
    return {
      icon: icons["a" /* ICONS */][Object(lodash["get"])(strength, 'id')] || icons["a" /* ICONS */].TRIDENT1,
      labels: [Object(lodash["get"])(strength, 'label') || '']
    };
  }); // $FlowFixMe

  return Object(lodash["compact"])([surfaceItem, capacityItem].concat(Object(toConsumableArray["a" /* default */])(outsideFacilitiesItems || []), [viewItem], Object(toConsumableArray["a" /* default */])(strengthsItems))).filter(function (_ref2) {
    var _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels;
    return labels.length && labels[0];
  }).slice(0, 4);
}

function mapAccommodationStrengths(i18n, accommodation) {
  var maxCapacity = accommodation.maxCapacity,
      roomType = accommodation.roomType,
      strengths = accommodation.strengths,
      surface = accommodation.surface,
      view = accommodation.view,
      outsideFacilities = accommodation.outsideFacilities;
  var surfaceItem = getSurfaceIconItem(i18n, surface, roomType);
  var capacityItem = getCapacityIconItem(i18n, maxCapacity);
  var viewItem = getViewIconItem(view);
  var outsideFacilitiesItems = getOutsideFacilitiesIconItems(outsideFacilities);
  return {
    strengths: aggregateIconList({
      surfaceItem: surfaceItem,
      capacityItem: capacityItem
    }),
    strengthsCompact: [surfaceItem === null || surfaceItem === void 0 ? void 0 : surfaceItem.labels, capacityItem === null || capacityItem === void 0 ? void 0 : capacityItem.labels].filter(Boolean),
    strengthsAlternate: aggregateIconList({
      outsideFacilitiesItems: outsideFacilitiesItems,
      viewItem: viewItem,
      strengths: strengths
    })
  };
}

function mapAccommodationServices(i18n, accommodation, isExclusiveCollection) {
  var _accommodation$bathro = accommodation.bathroomEquipments,
      bathroomEquipments = _accommodation$bathro === void 0 ? [] : _accommodation$bathro,
      _accommodation$equipm = accommodation.equipments,
      equipments = _accommodation$equipm === void 0 ? [] : _accommodation$equipm,
      _accommodation$servic = accommodation.services,
      services = _accommodation$servic === void 0 ? [] : _accommodation$servic;
  var isSuiteAccommodation = (accommodation === null || accommodation === void 0 ? void 0 : accommodation.comfortId) === proposal_constants["c" /* COMFORT_TYPE_SUITE */];
  return [{
    label: isExclusiveCollection || isSuiteAccommodation ? Object(lodash["get"])(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }, {
    label: Object(lodash["get"])(i18n, 'equipmentLabel', ''),
    items: equipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: Object(lodash["get"])(i18n, 'bathroomLabel', ''),
    items: bathroomEquipments.map(function (equipment) {
      return getServiceIconItem(equipment);
    })
  }, {
    label: !(isExclusiveCollection || isSuiteAccommodation) ? Object(lodash["get"])(i18n, 'servicesLabel', '') : null,
    items: Array.isArray(services) && services.map(function (service) {
      return getServiceIconItem(service);
    })
  }].filter(function (service) {
    return service.label;
  });
}

function getRankingIndex(ranking) {
  return Object.values(RANKINGS).findIndex(function (r) {
    return r === ranking;
  });
}

function productAccommodations_utils_isProductExclusiveCollection(comfort) {
  return comfort > 4;
} // eslint-disable-next-line clubmed/no-fake-component


function getAccommodation(_ref3) {
  var accommodation = _ref3.accommodation,
      categoryLabel = _ref3.categoryLabel,
      resortComfort = _ref3.resortComfort,
      streetView = _ref3.streetView,
      i18n = _ref3.i18n;
  var categoryId = accommodation.categoryId,
      comfortId = accommodation.comfortId,
      comfortType = accommodation.comfortType,
      description = accommodation.description,
      floorPlan = accommodation.floorPlan,
      id = accommodation.id,
      label = accommodation.label,
      photos = accommodation.media.photos;

  var _mapAccommodationStre = mapAccommodationStrengths(i18n, accommodation),
      strengths = _mapAccommodationStre.strengths,
      strengthsCompact = _mapAccommodationStre.strengthsCompact,
      strengthsAlternate = _mapAccommodationStre.strengthsAlternate;

  var isDisplayable = [strengths.length, comfortType, label, description].every(function (item) {
    return !!item;
  });
  var isExclusiveCollection = productAccommodations_utils_isProductExclusiveCollection(resortComfort) || accommodation.exclusiveCollection;
  var images = photos.map(function (_ref4) {
    var url = _ref4.url;
    return {
      src: url
    };
  });
  var streetViews = !Object(lodash["isEmpty"])(streetView) && !!streetView.streetView ? [streetView.streetView] : undefined;
  var details = {
    categoryId: categoryId,
    comfort: resortComfort,
    comfortType: comfortType,
    comfortId: comfortId,
    description: description,
    floorPlan: floorPlan,
    immersive: {
      url: Object(lodash["get"])(photos, '[0].url')
    },
    isExclusiveCollection: isExclusiveCollection,
    label: label,
    categoryLabel: categoryLabel,
    overview: strengths,
    overviewCompact: strengthsCompact,
    overviewAlternate: strengthsAlternate,
    strengthsLabel: i18n.strengthsLabel,
    amenitiesLabel: i18n.amenitiesLabel,
    services: mapAccommodationServices(i18n, accommodation, isExclusiveCollection),
    slideshow: {
      groupeKey: 'roomCard',
      media: images
    },
    multimedia: {
      photos: photos,
      streetViews: streetViews
    }
  };
  return isDisplayable && productAccommodations_utils_jsx(ProductRoomCard_ProductRoomCard, {
    fetchDetail: function fetchDetail() {
      return Promise.resolve(details);
    },
    isExclusiveCollection: isExclusiveCollection,
    key: id,
    labeledIconsList: strengths,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'blockInfos',
      labelGA: "accommodation_".concat(categoryLabel, "_seeMore")
    },
    media: images,
    seeMoreLabel: i18n.seeMore,
    title: label
  });
}

function productAccommodations_utils_renderDetail() {
  return function (_ref5) {
    var comfort = _ref5.comfort,
        comfortType = _ref5.comfortType,
        description = _ref5.description,
        floorPlan = _ref5.floorPlan,
        isExclusiveCollection = _ref5.isExclusiveCollection,
        immersive = _ref5.immersive,
        label = _ref5.label,
        categoryLabel = _ref5.categoryLabel,
        overview = _ref5.overview,
        overviewCompact = _ref5.overviewCompact,
        overviewAlternate = _ref5.overviewAlternate,
        strengthsLabel = _ref5.strengthsLabel,
        amenitiesLabel = _ref5.amenitiesLabel,
        services = _ref5.services,
        slideshow = _ref5.slideshow,
        multimedia = _ref5.multimedia;
    var customProps = {
      description: description,
      title: label,
      subtitle: categoryLabel,
      diamond: {
        color: colors["a" /* COLORS */].LILAS,
        label: comfortType
      },
      floorPlan: floorPlan,
      immersive: immersive,
      isExclusiveCollection: productAccommodations_utils_isProductExclusiveCollection(comfort) || isExclusiveCollection,
      overview: overview,
      overviewCompact: overviewCompact,
      overviewAlternate: overviewAlternate,
      strengthsLabel: strengthsLabel,
      amenitiesLabel: amenitiesLabel,
      services: services,
      slideshow: slideshow,
      multimedia: multimedia
    };
    return productAccommodations_utils_jsx(ProductRoomDetail_ProductRoomDetail, customProps);
  };
}

var productAccommodations_utils_getAllAvailableItems = function getAllAvailableItems(accommodationCategories, itemType) {
  return Object(dist["sortByRanking"])(accommodationCategories.reduce(function (items, accommodationCategory) {
    return Object(lodash["unionBy"])(items, accommodationCategory[itemType], 'id');
  }, []));
};

var isHighOrVeryHighRanking = function isHighOrVeryHighRanking(_ref6) {
  var ranking = _ref6.ranking;
  return [RANKINGS.VERY_HIGH, RANKINGS.HIGH].includes(ranking);
};

function groupAccommodationsByCategory(props) {
  var _props$accommodationC = props.accommodationCategory;
  _props$accommodationC = _props$accommodationC === void 0 ? {} : _props$accommodationC;
  var _props$accommodationC2 = _props$accommodationC.rankedCategories,
      rankedCategories = _props$accommodationC2 === void 0 ? [] : _props$accommodationC2,
      bathroomLabel = props.bathroomLabel,
      capacityOfPeopleLabel = props.capacityOfPeopleLabel,
      strengthsLabel = props.strengthsLabel,
      amenitiesLabel = props.amenitiesLabel,
      _props$config = props.config;
  _props$config = _props$config === void 0 ? {} : _props$config;
  var _props$config$accommo = _props$config.accommodations;
  _props$config$accommo = _props$config$accommo === void 0 ? {} : _props$config$accommo;
  var surfaceLabel = _props$config$accommo.surfaceLabel,
      equipmentLabel = props.equipmentLabel,
      numberOfPeopleLabel = props.numberOfPeopleLabel,
      _props$resort = props.resort,
      _props$resort$accommo = _props$resort.accommodations,
      accommodations = _props$resort$accommo === void 0 ? [] : _props$resort$accommo,
      _props$resort$comfort = _props$resort.comfort,
      resortComfort = _props$resort$comfort === void 0 ? 3 : _props$resort$comfort,
      type = _props$resort.type,
      _props$roomConfigurat = props.roomConfiguration;
  _props$roomConfigurat = _props$roomConfigurat === void 0 ? {} : _props$roomConfigurat;
  var singleRoom = _props$roomConfigurat.singleRoom,
      connectingRooms = _props$roomConfigurat.connectingRooms,
      separatedRooms = _props$roomConfigurat.separatedRooms,
      seeMore = props.seeMore,
      servicesLabel = props.servicesLabel,
      streetViews = props.streetViews;
  var i18n = {
    bathroomLabel: bathroomLabel,
    capacityOfPeopleLabel: capacityOfPeopleLabel,
    strengthsLabel: strengthsLabel,
    amenitiesLabel: amenitiesLabel,
    connectingRooms: connectingRooms,
    equipmentLabel: equipmentLabel,
    numberOfPeopleLabel: numberOfPeopleLabel,
    seeMore: seeMore,
    separatedRooms: separatedRooms,
    servicesLabel: servicesLabel,
    singleRoom: singleRoom,
    surfaceLabel: surfaceLabel
  }; // $FlowFixMe

  return Object.values(accommodations.reduce(function (categories, accommodation) {
    // Ranking index to sort categories and accommodations within a category
    var rankedCategory = rankedCategories.find(function (c) {
      return c.id === accommodation.categoryId;
    });
    var categoryRanking = rankedCategory ? rankedCategory.ranking : DEFAULT_RANKING;
    var categoryIndex = getRankingIndex(categoryRanking);
    var streetView = streetViews && (streetViews === null || streetViews === void 0 ? void 0 : streetViews.length) > 0 ? streetViews.find(function (sv) {
      return sv.accommodationCategoryId === accommodation.categoryId;
    }) : []; // Accommodation tabs are now based on accommodation comfort, not category...

    var categoryId = accommodation.comfortId;
    var categoryLabel = accommodation.comfortType; // ...except for VILLA products

    if (type === PRODUCT_TYPES.VILLA) {
      // eslint-disable-next-line prefer-destructuring
      categoryId = accommodation.categoryId;
      categoryLabel = accommodation.category;
    }

    if (!categoryId) return categories; // Ranking index to sort accommodations within a category

    var accommodationIndex = getRankingIndex(accommodation.ranking);
    var accommodationProps = {
      accommodation: accommodation,
      accommodationIndex: accommodationIndex,
      categoryLabel: categoryLabel,
      categoryIndex: categoryIndex,
      colorId: accommodation.categoryId,
      resortComfort: resortComfort,
      streetView: streetView,
      i18n: i18n
    };

    if (categories[categoryId]) {
      var _accommodation$area, _accommodation$area2; // Add accommodation to category if it exists


      categories[categoryId].categoryAccommodations.push(accommodationProps);

      if (categories[categoryId].minCapacity > accommodation.minCapacity) {
        categories[categoryId].minCapacity = accommodation.minCapacity;
      }

      if (categories[categoryId].maxCapacity < accommodation.maxCapacity) {
        categories[categoryId].maxCapacity = accommodation.maxCapacity;
      }

      if (((_accommodation$area = accommodation.area) === null || _accommodation$area === void 0 ? void 0 : _accommodation$area.min) && accommodation.area.min < categories[categoryId].area.min) {
        categories[categoryId].area.min = accommodation.area.min;
      }

      if (((_accommodation$area2 = accommodation.area) === null || _accommodation$area2 === void 0 ? void 0 : _accommodation$area2.max) && accommodation.area.max > categories[categoryId].area.max) {
        categories[categoryId].area.max = accommodation.area.max;
      }

      categories[categoryId].exclusiveCollection = accommodation.exclusiveCollection && categories[categoryId].exclusiveCollection;
      categories[categoryId].equipments = Object(lodash["unionBy"])(categories[categoryId].equipments, accommodation.equipments.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].services = Object(lodash["unionBy"])(categories[categoryId].services, accommodation.services.filter(isHighOrVeryHighRanking), 'id');
      categories[categoryId].strengths = Object(lodash["unionBy"])(categories[categoryId].strengths, [].concat(Object(toConsumableArray["a" /* default */])(accommodation.strengths || []), Object(toConsumableArray["a" /* default */])(accommodation.view ? [accommodation.view] : []), Object(toConsumableArray["a" /* default */])(accommodation.outsideFacilities || [])), 'id');
      categories[categoryId].bathroomEquipments = Object(lodash["unionBy"])(categories[categoryId].bathroomEquipments, accommodation.bathroomEquipments, 'id');
    } else {
      // Create category if it doesn't exist
      categories[categoryId] = {
        area: accommodation.area,
        bathroomEquipments: accommodation.bathroomEquipments,
        categoryAccommodations: [accommodationProps],
        categoryId: categoryId,
        categoryIndex: categoryIndex,
        categoryLabel: categoryLabel,
        equipments: accommodation.equipments.filter(isHighOrVeryHighRanking),
        exclusiveCollection: accommodation.exclusiveCollection,
        media: accommodation.media,
        maxCapacity: accommodation.maxCapacity,
        minCapacity: accommodation.minCapacity,
        services: accommodation.services.filter(isHighOrVeryHighRanking),
        strengths: [].concat(Object(toConsumableArray["a" /* default */])(accommodation.strengths || []), Object(toConsumableArray["a" /* default */])(accommodation.view ? [accommodation.view] : []), Object(toConsumableArray["a" /* default */])(accommodation.outsideFacilities || []))
      };
    }

    return categories;
  }, {}) // $FlowFixMe
  ).sort(function (a, b) {
    return b.categoryIndex - a.categoryIndex;
  });
}
function getTabsItemsAndPropsFromAccommodations(props, accommodationCategories) {
  var _props$config2 = props.config;
  _props$config2 = _props$config2 === void 0 ? {} : _props$config2;
  var _props$config2$common = _props$config2.common;
  _props$config2$common = _props$config2$common === void 0 ? {} : _props$config2$common;
  var backNavigation = _props$config2$common.backNavigation,
      exclusiveCollectionLabel = _props$config2$common.exclusiveCollectionLabel,
      scrollBackward = _props$config2$common.scrollBackward,
      scrollForward = _props$config2$common.scrollForward,
      isLineExclusiveCollection = props.isLineExclusiveCollection,
      resortIsExclusiveCollection = props.resort.isExclusiveCollection;
  var items = // I have no idea what's going on there and to be honest I don't care enough
  // sorry to the person who'll be reading that in the future but I give up
  // $FlowFixMe
  accommodationCategories.map(function (accommodationCategory, index) {
    // $FlowFixMe
    var categoryAccommodations = accommodationCategory.categoryAccommodations,
        categoryLabel = accommodationCategory.categoryLabel; // We need to sort with the upper index first. Since Array.sort is broken client side (why??),
    // we use the lodash function which only sorts from the lower to the upper. We knows that the
    // accomodations are already sorted by accomodationIdex so we have to sort by categoryIndex.
    // The tricky part is here: we cannot reverse the output of lodash.sortBy, so we sort with a
    // negative categoryIndex.

    var categoryAccommodationsProps = Object(lodash["sortBy"])(Object(toConsumableArray["a" /* default */])(categoryAccommodations), function (_ref7) {
      var categoryIndex = _ref7.categoryIndex;
      return -1 * categoryIndex;
    });
    var content = categoryAccommodationsProps.map(getAccommodation).filter(Boolean); // $FlowFixMe

    var isLarge = content.every(function (item) {
      return item.props.isExclusiveCollection;
    });
    var shouldDisplayAsExclusiveCollection = isLarge && !resortIsExclusiveCollection || resortIsExclusiveCollection;
    return isLineExclusiveCollection && isLarge || !isLineExclusiveCollection ? {
      header: {
        title: "".concat(categoryLabel, " ").concat(isLarge && !resortIsExclusiveCollection ? ' ' + exclusiveCollectionLabel : ''),
        trackingData: {
          categoryGA: 'resort',
          actionGA: 'blockInfos',
          labelGA: "accommodations_".concat(categoryLabel)
        },
        headerClassNames: shouldDisplayAsExclusiveCollection ? {
          active: 'font-serif text-deepBlue',
          inactive: 'font-serif'
        } : {}
      },
      content: [productAccommodations_utils_jsx(ProductInformationSliderContainer, {
        backNavigationLabel: backNavigation,
        theme: "short",
        errorMessage: "error",
        isLarge: isLarge,
        key: "ProductAccommodationsSlider_".concat(categoryLabel),
        queryLayer: "acommodationLayer",
        renderDetail: productAccommodations_utils_renderDetail(),
        scrollBackwardLabel: scrollBackward,
        scrollForwardLabel: scrollForward,
        sliderIndex: index
      }, content)]
    } : null;
  }).filter(function (item) {
    return item !== null;
  });

  var slot = function slot(activeIndexes) {
    return productAccommodations_utils_jsx(ProductRoomsComparatorLauncher_ProductRoomsComparatorLauncher, {
      resortIsExclusiveCollection: resortIsExclusiveCollection,
      accommodationCategories: accommodationCategories,
      activeIndex: activeIndexes[0]
    });
  };

  return {
    items: items,
    slot: slot
  };
}
// CONCATENATED MODULE: ./src/client/components/lines/product-accommodations-line/ProductAccommodationsLine.jsx


var ProductAccommodationsLine_jsx = react_default.a.createElement;









var ProductAccommodationsLine_ProductAccommodationsLine = function ProductAccommodationsLine(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var accommodationCategories = groupAccommodationsByCategory(props);

  var _getTabsItemsAndProps = getTabsItemsAndPropsFromAccommodations(props, accommodationCategories),
      items = _getTabsItemsAndProps.items,
      slot = _getTabsItemsAndProps.slot;

  var _props$config = props.config;
  _props$config = _props$config === void 0 ? {} : _props$config;
  var _props$config$common = _props$config.common;
  _props$config$common = _props$config$common === void 0 ? {} : _props$config$common;
  var loadLess = _props$config$common.loadLess,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      accommodationsIntroduction = props.resort.accommodationsIntroduction;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var displayRoomsComparator = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('displayRoomsComparator');

  var content = ProductAccommodationsLine_jsx(react["Fragment"], null, accommodationsIntroduction && ProductAccommodationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: isTablet
  }, ProductAccommodationsLine_jsx(Introduction["a" /* Introduction */], {
    className: "mt-px30 mb-px50 text-center",
    dataTestId: "Line-Product-Accommodations__Introduction",
    isTextSeeMoreCollapseEnabled: true,
    title: accommodationsIntroduction.shortDescription,
    text: accommodationsIntroduction.description,
    seeMoreLabel: viewMore,
    seeLessLabel: loadLess,
    theme: "column"
  })), ProductAccommodationsLine_jsx(Tabs["a" /* Tabs */], {
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    id: "product-accommodations-line-tabs",
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward,
    slotRight: displayRoomsComparator ? function (activeIndexes) {
      return slot(activeIndexes);
    } : null,
    theme: "buttons"
  }));

  return ProductAccommodationsLine_jsx("div", {
    className: classnames_default()('Line', {
      'mx-auto px-px20 relative site-container w-full': isTablet
    }),
    id: id,
    style: {
      maxWidth: 'calc(76.25rem)'
    }
  }, content);
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-accommodations/productAccommodations.resolver.js
var productAccommodations_resolver = __webpack_require__("JEY5");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-accommodations/productAccommodations.descriptor.js



var productAccommodationsDescriptor = {
  name: constants["db" /* RESORT_ACCOMMODATION_TYPES */],
  component: ProductAccommodationsLine_ProductAccommodationsLine,
  resolve: productAccommodations_resolver["b" /* productAccommodationsResolver */].resolve
};
var productAccommodationsExclusiveCollectionDescriptor = {
  name: constants["cb" /* RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION */],
  component: ProductAccommodationsLine_ProductAccommodationsLine,
  resolve: productAccommodations_resolver["a" /* productAccommodationsExclusiveCollectionResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/utils/product/product.utils.js
var product_utils = __webpack_require__("C9cF");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-utils/productFeatures.icons.js


var featuresIcons = {
  /* activities */
  activity_search_criterion_archery: {
    icon: icons["a" /* ICONS */].ARCHERY
  },
  activity_search_criterion_climbing: {
    icon: icons["a" /* ICONS */].CLIMBING
  },
  activity_search_criterion_creactive: {
    icon: icons["a" /* ICONS */].CREACTIVE
  },
  activity_search_criterion_cycling_mountain_biking: {
    icon: icons["a" /* ICONS */].VTT
  },
  activity_search_criterion_dance: {
    icon: icons["a" /* ICONS */].DANCE
  },
  activity_search_criterion_entertainment: {
    icon: icons["a" /* ICONS */].ENTERTAINMENT
  },
  activity_search_criterion_fitness: {
    icon: icons["a" /* ICONS */].FITNESS
  },
  activity_search_criterion_flying_trapeze_circus: {
    icon: icons["a" /* ICONS */].TRAPEZE
  },
  activity_search_criterion_football: {
    icon: icons["a" /* ICONS */].SPORT
  },
  activity_search_criterion_golf: {
    icon: icons["a" /* ICONS */].GOLF
  },
  activity_search_criterion_horseriding: {
    icon: icons["a" /* ICONS */].RIDING
  },
  activity_search_criterion_kayak: {
    icon: icons["a" /* ICONS */].KAYAK
  },
  activity_search_criterion_kitesurfing: {
    icon: icons["a" /* ICONS */].KITESURF
  },
  activity_search_criterion_nordic_walking: {
    icon: icons["a" /* ICONS */].NORDIC_WALKING
  },
  activity_search_criterion_sailing: {
    icon: icons["a" /* ICONS */].SAILING
  },
  activity_search_criterion_scuba_diving: {
    icon: icons["a" /* ICONS */].DIVING
  },
  activity_search_criterion_skiing_snowboarding: {
    icon: icons["a" /* ICONS */].SKI
  },
  activity_search_criterion_snorkelling: {
    icon: icons["a" /* ICONS */].SNORKELLING
  },
  activity_search_criterion_snowboard: {
    icon: icons["a" /* ICONS */].SNOWBOARD
  },
  activity_search_criterion_snow_shoe_walks: {
    icon: icons["a" /* ICONS */].SKI_IN_OUT
  },
  activity_search_criterion_stand_up_paddle: {
    icon: icons["a" /* ICONS */].STAND_UP_PADDLE
  },
  activity_search_criterion_volleyball: {
    icon: icons["a" /* ICONS */].SPORT_SCHOOL
  },
  activity_search_criterion_surfing: {
    icon: icons["a" /* ICONS */].TRIDENT1
  },
  activity_search_criterion_swimming: {
    icon: icons["a" /* ICONS */].SWIM
  },
  activity_search_criterion_tai_chi: {
    icon: icons["a" /* ICONS */].TRIDENT1
  },
  activity_search_criterion_tennis: {
    icon: icons["a" /* ICONS */].TENNIS
  },
  activity_search_criterion_treeetop_adventure: {
    icon: icons["a" /* ICONS */].TREETOP_ADVENTURE
  },
  activity_search_criterion_walking_hiking: {
    icon: icons["a" /* ICONS */].WALKING
  },
  activity_search_criterion_waterskiing_wakeboarding: {
    icon: icons["a" /* ICONS */].WATERSKI
  },
  activity_search_criterion_whitewater_sports: {
    icon: icons["a" /* ICONS */].TRIDENT1
  },
  activity_search_criterion_windsurfing: {
    icon: icons["a" /* ICONS */].SURF
  },
  activity_search_criterion_yoga: {
    icon: icons["a" /* ICONS */].YOGA
  },

  /* childcare */
  activity_search_criterion_petit_club: {
    color: colors["a" /* COLORS */].ORANGE,
    icon: icons["a" /* ICONS */].PETIT_CLUB
  },
  activity_search_criterion_mini_club: {
    color: colors["a" /* COLORS */].EMERALD,
    icon: icons["a" /* ICONS */].MINI_CLUB
  },
  activity_search_criterion_baby_club: {
    color: colors["a" /* COLORS */].GRENADINE,
    icon: icons["a" /* ICONS */].BABY_CLUB
  },
  activity_search_criterion_passworld: {
    color: colors["a" /* COLORS */].BLACK,
    icon: icons["a" /* ICONS */].PASSWORLD
  },
  activity_search_criterion_junior: {
    color: colors["a" /* COLORS */].BLACK,
    icon: icons["a" /* ICONS */].JUNIOR
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-utils/productFeatures.utils.js


























function productFeatures_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productFeatures_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productFeatures_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productFeatures_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}











function mapOpeningHours(openingHours) {
  return openingHours.reduce(function (acc, openingHour) {
    if (!openingHour.start || !openingHour.end) return acc;
    var label = Object(src_i18n["h" /* t */])('productChildcaresInformation.openingHours', {
      ' opening_hours - start ': Object(date_apiDate["f" /* formatApiTime */])(openingHour.start, 'LT').toLowerCase(),
      ' opening_hours - end ': Object(date_apiDate["f" /* formatApiTime */])(openingHour.end, 'LT').toLowerCase()
    });
    return acc.length ? "".concat(acc, " ").concat(label) : label;
  }, '');
}

function mapClosingDays(closingWeekdays) {
  if (!closingWeekdays.length) {
    return '';
  }

  var weekdays = closingWeekdays.map(function (closingWeekday) {
    return Object(lodash["capitalize"])(moment_default()().day(closingWeekday).format('dddd'));
  }).join(', ');
  return Object(src_i18n["h" /* t */])('productChildcaresInformation.closingDays', {
    closing_weekdays: weekdays
  });
}

function getRank(item) {
  return Object.values(dist["constants"].RANKINGS).findIndex(function (ranking) {
    return ranking === item.ranking;
  });
}

function sortActivities(a, b) {
  return getRank(b) - getRank(a);
}

function getHowToBookDesc(_ref) {
  var hasBookingOnline = _ref.hasBookingOnline,
      hasBookingOnsite = _ref.hasBookingOnsite,
      config = _ref.config;

  if (!hasBookingOnline && !hasBookingOnsite) {
    return '';
  }

  if (hasBookingOnline && hasBookingOnsite) {
    return config.common.bookOnlineOrOnsite;
  }

  return hasBookingOnline ? config.common.bookOnlineOnly : config.common.bookOnsiteOnly;
}

function mapRentalEquipments(rentalEquipments, _ref2) {
  var age = _ref2.age,
      size = _ref2.size;
  return rentalEquipments.map(function (_ref3) {
    var _practiceLevels$;

    var ageInMonths = _ref3.ageInMonths,
        id = _ref3.id,
        label = _ref3.label,
        longDescription = _ref3.longDescription,
        practiceLevels = _ref3.practiceLevels,
        sizes = _ref3.sizes;
    var items = [{
      description: longDescription
    }, {
      label: age,
      description: Object(product_utils["e" /* getRentalAgesLabel */])(ageInMonths)
    }, {
      label: size,
      description: sizes.min ? "".concat(sizes.min).concat(sizes.max ? ' - ' + sizes.max : '', " ").concat(sizes.unit) : ''
    }].filter(function (item) {
      return item.description;
    });
    var level = (_practiceLevels$ = practiceLevels[0]) === null || _practiceLevels$ === void 0 ? void 0 : _practiceLevels$.label;
    return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({
      id: id,
      items: items
    }, level ? {
      level: level
    } : {}), {}, {
      title: label
    });
  });
}

function mapServices() {
  var services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
      included = _ref4.included,
      onDemand = _ref4.onDemand,
      age = _ref4.age,
      group = _ref4.group,
      equipmentsLabel = _ref4.equipmentsLabel,
      utilitiesLabel = _ref4.utilitiesLabel,
      durationLabel = _ref4.durationLabel,
      config = _ref4.config,
      _ref4$excursionPackin = _ref4.excursionPackingLabel,
      excursionPackingLabel = _ref4$excursionPackin === void 0 ? '' : _ref4$excursionPackin,
      _ref4$excursionSeason = _ref4.excursionSeasonalityLabel,
      excursionSeasonalityLabel = _ref4$excursionSeason === void 0 ? '' : _ref4$excursionSeason,
      _ref4$excursionTransp = _ref4.excursionTransportationLabel,
      excursionTransportationLabel = _ref4$excursionTransp === void 0 ? '' : _ref4$excursionTransp;

  return services.map(function (_ref5) {
    var hasBookingOnline = _ref5.hasBookingOnline,
        hasBookingOnsite = _ref5.hasBookingOnsite,
        id = _ref5.id,
        isIdealForFamily = _ref5.isIdealForFamily,
        description = _ref5.description,
        detailedDescription = _ref5.detailedDescription,
        ageRestriction = _ref5.ageRestriction,
        durationDescription = _ref5.durationDescription,
        label = _ref5.label,
        level = _ref5.level,
        note = _ref5.note,
        groupDescription = _ref5.group,
        specificConditions = _ref5.specificConditions,
        equipments = _ref5.equipments,
        utilities = _ref5.utilities,
        seasonality = _ref5.seasonality,
        transportation = _ref5.transportation,
        whatToBring = _ref5.whatToBring,
        targetPrice = _ref5.targetPrice;
    var items = [{
      description: description
    }, {
      label: config.common.treatmentsLabel,
      description: detailedDescription
    }, {
      label: group,
      description: groupDescription
    }, productFeatures_utils_objectSpread({
      label: age,
      description: ageRestriction
    }, specificConditions ? {
      note: specificConditions
    } : {}), {
      label: excursionSeasonalityLabel,
      description: seasonality
    }, {
      label: excursionTransportationLabel,
      description: transportation
    }, {
      label: excursionPackingLabel,
      description: whatToBring
    }, {
      label: equipmentsLabel,
      items: (equipments || []).map(function (equipment) {
        return {
          description: equipment.label,
          tag: equipment.included ? {
            color: colors["a" /* COLORS */].BLUE,
            label: included
          } : {
            color: colors["a" /* COLORS */].AMBER,
            label: onDemand
          }
        };
      })
    }, {
      label: utilitiesLabel,
      items: (utilities || []).map(function (utility) {
        return {
          description: utility.label,
          tag: utility.included ? {
            color: colors["a" /* COLORS */].BLUE,
            label: included
          } : {
            color: colors["a" /* COLORS */].AMBER,
            label: onDemand
          }
        };
      })
    }, {
      label: config.common.howToBookLabel,
      description: getHowToBookDesc({
        hasBookingOnline: hasBookingOnline,
        hasBookingOnsite: hasBookingOnsite,
        config: config
      })
    }].filter(function (item) {
      return item.description || item.items && !Object(lodash["isEmpty"])(item.items);
    });
    var price = targetPrice && targetPrice.price ? productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, targetPrice), {}, {
      label: Object(lodash["get"])(config, 'common.price.priceFrom', '+{price}{currency}')
    }) : null;
    var badges = isIdealForFamily ? [{
      label: config.common.idealForFamilyLabel,
      iconName: icons["a" /* ICONS */].IDEAL_FOR_FAMILY
    }] : null;
    return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread(productFeatures_utils_objectSpread(productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, badges ? {
      badges: badges
    } : {}), {}, {
      id: id,
      items: items
    }, level ? {
      level: level
    } : {}), durationDescription ? {
      duration: {
        label: durationLabel,
        description: durationDescription
      }
    } : {}), {}, {
      title: label
    }, note ? {
      note: note
    } : {}), price ? {
      targetPrice: price
    } : {});
  });
}

function mapFacilities() {
  var facilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var inside = arguments.length > 2 ? arguments[2] : undefined;
  var distanceLabel = props.distance,
      indoorLabel = props.indoor,
      nightLightingLabel = props.nightLighting,
      openingHoursLabel = props.openingHours,
      outdoorLabel = props.outdoor,
      typeDescriptionLabel = props.typeDescription,
      locationLabel = props.location;
  return facilities.filter(function (_ref6) {
    var onSite = _ref6.onSite;
    return onSite === inside;
  }).map(function (_ref7) {
    var id = _ref7.id,
        description = _ref7.description,
        distance = _ref7.distance,
        label = _ref7.label,
        nightLighting = _ref7.nightLighting,
        openingHours = _ref7.openingHours,
        outdoor = _ref7.outdoor,
        quantity = _ref7.quantity,
        _ref7$specificInforma = _ref7.specificInformation,
        specificInformation = _ref7$specificInforma === void 0 ? [] : _ref7$specificInforma,
        _ref7$technicalSpecif = _ref7.technicalSpecificities,
        technicalSpecificities = _ref7$technicalSpecif === void 0 ? {} : _ref7$technicalSpecif,
        localisation = _ref7.localisation;
    var basicInformation = [{
      label: distanceLabel,
      description: distance.toString()
    }, {
      description: nightLighting ? nightLightingLabel : ''
    }, {
      description: outdoor ? outdoorLabel : indoorLabel
    }, {
      label: locationLabel,
      description: localisation
    }, {
      label: openingHoursLabel,
      description: "".concat(Object(lodash["get"])(openingHours, 'opening', ''), " ").concat(Object(lodash["get"])(openingHours, 'closing', '')).trim()
    }];
    var mapSpecificInformation = specificInformation.map(function (information) {
      return {
        label: Object(lodash["get"])(props, Object(lodash["get"])(information, 'type'), ''),
        description: Object(lodash["get"])(information, 'value', '')
      };
    });
    var mapTechnicalSpecificities = Object.keys(technicalSpecificities).filter(function (key) {
      return key !== 'unit' && technicalSpecificities[key] && !Object(lodash["isEmpty"])(technicalSpecificities[key].toString());
    }).map(function (key) {
      if (key === 'typeDescription') {
        return {
          label: typeDescriptionLabel,
          description: technicalSpecificities.typeDescription
        };
      }

      return {
        label: Object(lodash["get"])(props, key, ''),
        description: "".concat(technicalSpecificities[key], " ").concat(Object(lodash["get"])(technicalSpecificities, 'unit', 'm'))
      };
    });
    var items = [].concat(basicInformation, Object(toConsumableArray["a" /* default */])(mapTechnicalSpecificities), Object(toConsumableArray["a" /* default */])(mapSpecificInformation)).filter(function (item) {
      return item && item.description;
    });
    return {
      id: id,
      description: description,
      items: items,
      title: label,
      quantity: quantity
    };
  });
}

function mapGeneralInformation(activityId, props, activities) {
  var activity = activities.find(function (_ref8) {
    var id = _ref8.id;
    return id === activityId;
  });
  if (!activity) return [];
  var bookingLabel = props.bookingLabel,
      termsAndConditionsLabel = props.termsAndConditionsLabel,
      supervisionLabel = props.supervisionLabel,
      equipmentRentalLabel = props.equipmentRentalLabel;
  var bookingDescription = activity.bookingDescription,
      termsAndConditionsDescription = activity.termsAndConditionsDescription,
      supervisionDescription = activity.supervisionDescription,
      equipmentRentalDescription = activity.equipmentRentalDescription;
  return [{
    label: bookingLabel,
    description: bookingDescription || ''
  }, {
    label: termsAndConditionsLabel,
    description: termsAndConditionsDescription || ''
  }, {
    label: supervisionLabel,
    description: supervisionDescription || ''
  }, {
    label: equipmentRentalLabel,
    description: equipmentRentalDescription || ''
  }].filter(function (info) {
    return info.description && info.description.trim();
  });
}

function mapChildcareInformation(_ref9) {
  var _childcare$openingHou, _childcare$closingWee;

  var opening = _ref9.opening,
      philosophy = _ref9.philosophy;
  var childcare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (Object(lodash["isEmpty"])(childcare)) return {};
  var items = [{
    label: philosophy,
    description: childcare.philosophy
  }].filter(function (item) {
    return Object(lodash["has"])(item, 'description') || Object(lodash["has"])(item, 'note');
  });
  var openingHoursLabel = (childcare === null || childcare === void 0 ? void 0 : (_childcare$openingHou = childcare.openingHours) === null || _childcare$openingHou === void 0 ? void 0 : _childcare$openingHou.length) ? mapOpeningHours(childcare.openingHours) : null;
  var closingDaysLabel = (childcare === null || childcare === void 0 ? void 0 : (_childcare$closingWee = childcare.closingWeekdays) === null || _childcare$closingWee === void 0 ? void 0 : _childcare$closingWee.length) ? mapClosingDays(childcare.closingWeekdays) : null;
  var description = openingHoursLabel ? "".concat(openingHoursLabel) : '';

  if (closingDaysLabel) {
    description += description.length ? " ".concat(closingDaysLabel) : closingDaysLabel;
  }

  return {
    duration: {
      label: opening,
      description: description
    },
    items: items,
    note: childcare.furtherInformation
  };
}

function mapActivityData(_ref10) {
  var _productFeaturesLineD;

  var _ref10$activityDetail = _ref10.activityDetail,
      _ref10$activityDetail2 = _ref10$activityDetail.childcare,
      childcare = _ref10$activityDetail2 === void 0 ? {} : _ref10$activityDetail2,
      _ref10$activityDetail3 = _ref10$activityDetail.facilities,
      facilities = _ref10$activityDetail3 === void 0 ? [] : _ref10$activityDetail3,
      _ref10$activityDetail4 = _ref10$activityDetail.includedServices,
      includedServices = _ref10$activityDetail4 === void 0 ? [] : _ref10$activityDetail4,
      _ref10$activityDetail5 = _ref10$activityDetail.onDemandServices,
      onDemandServices = _ref10$activityDetail5 === void 0 ? [] : _ref10$activityDetail5,
      _ref10$activityDetail6 = _ref10$activityDetail.rentalEquipments,
      rentalEquipments = _ref10$activityDetail6 === void 0 ? [] : _ref10$activityDetail6,
      _ref10$activityDetail7 = _ref10$activityDetail.resort,
      resort = _ref10$activityDetail7 === void 0 ? {} : _ref10$activityDetail7,
      _ref10$activityId = _ref10.activityId,
      activityId = _ref10$activityId === void 0 ? '' : _ref10$activityId,
      _ref10$color = _ref10.color,
      color = _ref10$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref10$color,
      description = _ref10.description,
      _ref10$icon = _ref10.icon,
      icon = _ref10$icon === void 0 ? icons["a" /* ICONS */].TRIDENT1 : _ref10$icon,
      image = _ref10.image,
      isIncluded = _ref10.isIncluded,
      title = _ref10.title,
      notIncludedMessage = _ref10.notIncludedMessage,
      productFeaturesLineData = _ref10.productFeaturesLineData,
      activities = _ref10.activities,
      philosophy = _ref10.philosophy,
      brandLogoUrl = _ref10.brandLogoUrl,
      bookletUrl = _ref10.bookletUrl;
  var isFacilityActivity = ['services_and_facilities_0_2', 'services_and_facilities_2_3', 'services_and_facilities_4_10'].some(function (id) {
    return activityId.includes(id);
  });
  var config = productFeaturesLineData.config,
      facilitiesTitle = productFeaturesLineData.facilitiesTitle,
      generalInformationTitle = productFeaturesLineData.generalInformationTitle,
      includedTitle = productFeaturesLineData.includedTitle,
      onDemandEquipments = productFeaturesLineData.onDemandEquipments,
      onDemandTitle = productFeaturesLineData.onDemandTitle,
      outsideFacilitiesTitle = productFeaturesLineData.outsideFacilitiesTitle,
      resortFacilitiesTitle = productFeaturesLineData.resortFacilitiesTitle;
  return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, description ? {
    description: description
  } : null), {}, {
    diamond: {
      colorBg: color,
      colorBorder: color,
      iconName: icon
    },
    downloadLinksList: [{
      iconName: icons["a" /* ICONS */].DOWNLOAD,
      label: config.common.downloadLeafletLabel,
      // $FlowFixMe
      url: bookletUrl
    }].filter(function (i) {
      return i.url;
    }),
    equipmentsTitle: Object(lodash["get"])(config, 'common.allInclusive', ''),
    equipments: isFacilityActivity ? [].concat(Object(toConsumableArray["a" /* default */])(resort.facilities || []), Object(toConsumableArray["a" /* default */])(resort.productActivities || [])).map(function (e) {
      return {
        items: e.equipments.map(function (i) {
          return {
            iconName: icons["a" /* ICONS */][i.id],
            label: i.label
          };
        }),
        title: e.subtitle || e.label
      };
    }) : null,
    immersive: {
      url: image
    },
    brandInformation: Object(lodash["isEmpty"])(childcare) ? {
      title: config.common.philosophyLabel,
      description: philosophy,
      imageSrc: brandLogoUrl
    } : null,
    mainInformationTitle: Object(lodash["get"])(childcare, 'label', ''),
    // $FlowFixMe
    mainInformation: mapChildcareInformation(productFeaturesLineData, childcare),
    isIncluded: isIncluded,
    notIncludedMessage: notIncludedMessage || '',
    includedMessage: '',
    // $FlowFixMe
    includedServices: mapServices(includedServices, productFeaturesLineData),
    includedTitle: includedTitle,
    onDemandEquipmentsTitle: onDemandEquipments,
    // $FlowFixMe
    onDemandServices: mapServices(onDemandServices, productFeaturesLineData),
    onDemandTitle: onDemandTitle,
    // $FlowFixMe
    insideFacilities: mapFacilities(facilities, productFeaturesLineData, true),
    // $FlowFixMe
    outsideFacilities: mapFacilities(facilities, productFeaturesLineData, false),
    facilitiesTitle: facilitiesTitle,
    insideFacilitiesTitle: resortFacilitiesTitle,
    outsideFacilitiesTitle: outsideFacilitiesTitle,
    targetPrice: productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, Object(lodash["get"])(childcare, 'targetPrice', {})), {}, {
      label: (productFeaturesLineData === null || productFeaturesLineData === void 0 ? void 0 : (_productFeaturesLineD = productFeaturesLineData.config.common.price) === null || _productFeaturesLineD === void 0 ? void 0 : _productFeaturesLineD.priceFrom) || ''
    }),
    generalInformation: mapGeneralInformation(activityId, productFeaturesLineData, activities),
    generalInformationTitle: generalInformationTitle,
    generalInformationExtraCost: productFeaturesLineData.config.common.extraCost,
    rentalEquipments: mapRentalEquipments(rentalEquipments, productFeaturesLineData),
    title: title,
    titleColor: color
  });
}

function resolveActivityServices(_ref11) {
  var activityId = _ref11.activityId,
      color = _ref11.color,
      description = _ref11.description,
      hasBanner = _ref11.hasBanner,
      icon = _ref11.icon,
      image = _ref11.image,
      isIncluded = _ref11.isIncluded,
      title = _ref11.title,
      notIncludedMessage = _ref11.notIncludedMessage,
      productFeaturesLineData = _ref11.productFeaturesLineData,
      activities = _ref11.activities,
      philosophy = _ref11.philosophy,
      brandLogoUrl = _ref11.brandLogoUrl,
      bookletUrl = _ref11.bookletUrl;
  return function (_ref12) {
    var productActivities = _ref12.productActivities;
    return mapActivityData({
      activityId: activityId,
      color: color,
      description: description,
      hasBanner: hasBanner,
      icon: icon,
      image: image,
      isIncluded: isIncluded,
      title: title,
      activityDetail: productActivities,
      notIncludedMessage: notIncludedMessage,
      productFeaturesLineData: productFeaturesLineData,
      activities: activities,
      philosophy: philosophy,
      brandLogoUrl: brandLogoUrl,
      bookletUrl: bookletUrl
    });
  };
}

function getActivityKeyword() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyword = keywords.find(function (k) {
    return featuresIcons.hasOwnProperty(k);
  });
  return keyword ? featuresIcons[keyword] : {
    icon: icons["a" /* ICONS */].TRIDENT1,
    color: undefined
  };
}

function mapActivitiesPerCategory(_ref13) {
  var _ref13$activities = _ref13.activities,
      activities = _ref13$activities === void 0 ? [] : _ref13$activities,
      _ref13$categoryId = _ref13.categoryId,
      categoryId = _ref13$categoryId === void 0 ? '' : _ref13$categoryId,
      fetchActivityServices = _ref13.fetchActivityServices,
      _ref13$hasBanner = _ref13.hasBanner,
      hasBanner = _ref13$hasBanner === void 0 ? false : _ref13$hasBanner,
      notIncludedMessage = _ref13.notIncludedMessage,
      productFeaturesLineData = _ref13.productFeaturesLineData,
      labelGAPrefix = _ref13.labelGAPrefix;
  var config = productFeaturesLineData.config,
      includedTitle = productFeaturesLineData.includedTitle,
      onDemandTitle = productFeaturesLineData.onDemandTitle,
      resortId = productFeaturesLineData.resortId,
      seeMore = productFeaturesLineData.seeMore;
  return activities.sort(sortActivities).map(function (_ref14) {
    var activityId = _ref14.id,
        isChildrenClub = _ref14.isChildrenClub,
        isIncluded = _ref14.isIncluded,
        label = _ref14.label,
        name = _ref14.name,
        description = _ref14.description,
        keywords = _ref14.keywords,
        image = _ref14.image,
        numberOfIncludedActivities = _ref14.numberOfIncludedActivities,
        numberOfOnDemandActivities = _ref14.numberOfOnDemandActivities,
        philosophy = _ref14.philosophy,
        brandLogoUrl = _ref14.brandLogoUrl,
        bookletUrl = _ref14.bookletUrl,
        rentalEquipmentsUsecasesId = _ref14.rentalEquipmentsUsecasesId;

    if (!image) {
      image = 'invalid';
    }

    if (!activityId || !name || !label) {
      return null;
    }

    var _getActivityKeyword = getActivityKeyword(keywords || []),
        icon = _getActivityKeyword.icon,
        color = _getActivityKeyword.color;

    var hasOnDemandBanner = hasBanner && !isIncluded;
    var hasIncludedBanner = hasBanner && isChildrenClub && isIncluded; // $FlowFixMe

    return productFeatures_utils_objectSpread(productFeatures_utils_objectSpread({}, hasOnDemandBanner || hasIncludedBanner ? {
      banner: {
        color: isIncluded ? colors["a" /* COLORS */].BLUE : colors["a" /* COLORS */].AMBER,
        iconName: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
        label: isIncluded ? config.common.included : config.common.childcarealacarte
      }
    } : {}), {}, {
      counters: [{
        color: colors["a" /* COLORS */].BLUE,
        count: numberOfIncludedActivities || 0,
        icon: icons["a" /* ICONS */].ALL_INCLUSIVE,
        label: includedTitle
      }, {
        color: colors["a" /* COLORS */].AMBER,
        count: numberOfOnDemandActivities || 0,
        icon: icons["a" /* ICONS */].ON_DEMAND,
        label: rentalEquipmentsUsecasesId ? Object(src_i18n["h" /* t */])('common.onDemand') : onDemandTitle
      }],
      fetchDetail: function fetchDetail() {
        return fetchActivityServices && fetchActivityServices({
          productId: resortId,
          activityId: activityId,
          rentalEquipmentsUsecasesId: rentalEquipmentsUsecasesId
        }).then(resolveActivityServices({
          activityId: activityId,
          color: color,
          description: description,
          hasBanner: hasBanner,
          icon: icon,
          image: image,
          isIncluded: isIncluded,
          notIncludedMessage: notIncludedMessage,
          philosophy: philosophy,
          brandLogoUrl: brandLogoUrl,
          title: label,
          productFeaturesLineData: productFeaturesLineData,
          activities: activities,
          bookletUrl: bookletUrl
        }));
      },
      imageSrc: image,
      trackingData: {
        actionGA: 'blockInfos',
        labelGA: "".concat(labelGAPrefix, "_").concat(categoryId, "_").concat(name)
      },
      seeMoreLabel: seeMore,
      title: label,
      titleColor: color ? color : colors["a" /* COLORS */].GRAY_DARKER
    });
  }).filter(Boolean);
}
function mapCategories(_ref15) {
  var fetchActivityServices = _ref15.fetchActivityServices,
      hasBanner = _ref15.hasBanner,
      labelGAPrefix = _ref15.labelGAPrefix,
      notIncludedMessage = _ref15.notIncludedMessage,
      productActivitiesCategories = _ref15.productActivitiesCategories,
      productFeaturesLineData = _ref15.productFeaturesLineData;
  return productActivitiesCategories.sort(sortActivities).map(function () {
    var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref16.id,
        activities = _ref16.activities,
        label = _ref16.label;

    if (!id || !label) {
      return null;
    }

    var activitiesItems = mapActivitiesPerCategory({
      activities: activities,
      categoryId: id,
      fetchActivityServices: fetchActivityServices,
      hasBanner: hasBanner,
      labelGAPrefix: labelGAPrefix,
      notIncludedMessage: notIncludedMessage,
      productActivitiesCategories: productActivitiesCategories,
      productFeaturesLineData: productFeaturesLineData
    });
    return {
      backNavigationLabel: productFeaturesLineData.config.common.backNavigation,
      errorMessage: productFeaturesLineData.noDetailsErrorMessage,
      id: id,
      title: label,
      activities: activitiesItems
    };
  }).filter(Boolean);
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-utils/productFeatures.queries.js
var productFeatures_queries = __webpack_require__("H0gB");

// EXTERNAL MODULE: ./src/utils/tracking/resort.js
var tracking_resort = __webpack_require__("zCbR");

// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-card/ProductFeatureCard.jsx



var ProductFeatureCard_jsx = react_default.a.createElement;










var ProductFeatureCard_ProductFeatureCard = function ProductFeatureCard(_ref) {
  var _ref$banner = _ref.banner,
      banner = _ref$banner === void 0 ? {} : _ref$banner,
      className = _ref.className,
      _ref$counters = _ref.counters,
      counters = _ref$counters === void 0 ? [] : _ref$counters,
      imageSrc = _ref.imageSrc,
      isHidden = _ref.isHidden,
      link = _ref.link,
      seeMoreLabel = _ref.seeMoreLabel,
      title = _ref.title,
      titleColor = _ref.titleColor,
      trackingData = _ref.trackingData,
      width = _ref.width;

  var _useState = Object(react["useState"])(false),
      isHovering = _useState[0],
      setHovering = _useState[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var media = [{
    src: imageSrc
  }];
  var tagName = markup_getLinkTagName(link);
  var linkProps = getLinkProps(link);
  return ProductFeatureCard_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkProps, {
    "aria-hidden": isHidden,
    as: tagName,
    className: classnames_default()(className, 'reset-button block relative tap-highlight-color-transparent text-initial w-full h-full'),
    onMouseEnter: isDesktop ? function () {
      return setHovering(true);
    } : null,
    onMouseLeave: isDesktop ? function () {
      return setHovering(false);
    } : null,
    style: {
      width: width
    },
    tabIndex: isHidden ? -1 : 0,
    trackingData: trackingData
  }), !!banner.label && ProductFeatureCard_jsx("div", {
    className: classnames_default()("bg-".concat(banner.color || colors["a" /* COLORS */].BLUE, " absolute flex font-brand items-center justify-center p-px10 round-t-tiny text-base sm:text-sm lg:text-base text-center text-white w-full z-1 transition-transform"), {
      'scale-095': isHovering
    })
  }, ProductFeatureCard_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: banner.iconName,
    width: "0.625rem"
  }), banner.label), ProductFeatureCard_jsx(TeaserCard_TeaserCard, {
    isActive: isHovering,
    media: media
  }, ProductFeatureCard_jsx(Title["a" /* Title */], {
    className: "my-px15",
    color: titleColor,
    hasEllipsis: true,
    theme: "title-sans-3"
  }, title), !Object(lodash["isEmpty"])(counters) && ProductFeatureCard_jsx("ul", {
    className: "reset-list my-px15",
    style: {
      height: '2.5rem'
    }
  }, counters.map(function (_ref2) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref2$color,
        icon = _ref2.icon,
        label = _ref2.label,
        count = _ref2.count;
    return count ? ProductFeatureCard_jsx("li", {
      className: "flex font-brand justify-between my-px5 overflow-hidden text-base text-".concat(color),
      key: label
    }, !!label && !!count && ProductFeatureCard_jsx(react["Fragment"], null, ProductFeatureCard_jsx("span", {
      className: "inline-flex items-center max-w-4/5"
    }, ProductFeatureCard_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0 rtl:mr-px10",
      name: icon,
      width: "1em"
    }), ProductFeatureCard_jsx("span", {
      className: "truncate"
    }, label)), count)) : null;
  })), !!seeMoreLabel && ProductFeatureCard_jsx("p", {
    className: "reset-paragraph my-px15 text-center text-sm underline"
  }, seeMoreLabel)));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-features-slider/ProductFeaturesSlider.jsx



var ProductFeaturesSlider_jsx = react_default.a.createElement;



var ProductFeaturesSlider_ProductFeaturesSlider = function ProductFeaturesSlider(_ref) {
  var items = _ref.items,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["items"]);

  return ProductFeaturesSlider_jsx(ProductInformationSliderContainer, rest, items.map(function (item) {
    return ProductFeaturesSlider_jsx(ProductFeatureCard_ProductFeatureCard, Object(esm_extends["a" /* default */])({
      key: item.title
    }, item));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-information/ProductInformation.jsx

var ProductInformation_jsx = react_default.a.createElement;




var ProductInformation_ProductInformation = function ProductInformation(_ref) {
  var introduction = _ref.introduction,
      items = _ref.items,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  return ProductInformation_jsx(react["Fragment"], null, !Object(lodash["isEmpty"])(introduction) && ProductInformation_jsx(Introduction["a" /* Introduction */], Object(esm_extends["a" /* default */])({
    className: "mb-px15"
  }, introduction, {
    isTextSeeMoreCollapseEnabled: true
  })), ProductInformation_jsx(Tabs["a" /* Tabs */], {
    isContentUnmountedOnCollapse: true,
    isScrollable: true,
    items: items,
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel,
    theme: "lite"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-features/ProductFeatures.jsx


var ProductFeatures_jsx = react_default.a.createElement;




var ProductFeatures_getItems = function getItems(_ref) {
  var categories = _ref.categories,
      labelGAPrefix = _ref.labelGAPrefix,
      queryLayer = _ref.queryLayer,
      renderDetail = _ref.renderDetail,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  return (categories || []).map(function (category, index) {
    return {
      header: {
        title: category.title,
        trackingData: {
          categoryGA: 'resort',
          actionGA: 'blockInfos',
          labelGA: "".concat(labelGAPrefix, "_").concat(category.id)
        }
      },
      content: [ProductFeatures_jsx(ProductFeaturesSlider_ProductFeaturesSlider, {
        backNavigationLabel: category.backNavigationLabel,
        errorMessage: category.errorMessage,
        items: category.activities,
        key: category.id,
        queryLayer: queryLayer,
        renderDetail: renderDetail,
        scrollBackwardLabel: scrollBackwardLabel,
        scrollForwardLabel: scrollForwardLabel,
        sliderIndex: index
      })]
    };
  });
};

var ProductFeatures_ProductFeatures = function ProductFeatures(_ref2) {
  var categories = _ref2.categories,
      introduction = _ref2.introduction,
      labelGAPrefix = _ref2.labelGAPrefix,
      _ref2$queryLayer = _ref2.queryLayer,
      queryLayer = _ref2$queryLayer === void 0 ? 'productActivitiesLayer' : _ref2$queryLayer,
      renderDetail = _ref2.renderDetail,
      scrollBackwardLabel = _ref2.scrollBackwardLabel,
      scrollForwardLabel = _ref2.scrollForwardLabel;
  return ProductFeatures_jsx(ProductInformation_ProductInformation, {
    introduction: introduction,
    items: ProductFeatures_getItems({
      categories: categories,
      labelGAPrefix: labelGAPrefix,
      queryLayer: queryLayer,
      renderDetail: renderDetail,
      scrollBackwardLabel: scrollBackwardLabel,
      scrollForwardLabel: scrollForwardLabel
    }),
    scrollBackwardLabel: scrollBackwardLabel,
    scrollForwardLabel: scrollForwardLabel
  });
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-brand-information/ProductFeatureDetailBrandInformation.jsx


var ProductFeatureDetailBrandInformation_jsx = react_default.a.createElement;





function ProductFeatureDetailBrandInformation(_ref) {
  var className = _ref.className,
      description = _ref.description,
      imageSrc = _ref.imageSrc,
      title = _ref.title;

  if (!description) {
    return null;
  }

  var desc = ProductFeatureDetailBrandInformation_jsx(Text["a" /* Text */], {
    text: description
  });

  return ProductFeatureDetailBrandInformation_jsx("section", {
    className: className
  }, ProductFeatureDetailBrandInformation_jsx(Title["a" /* Title */], {
    className: "mb-px30",
    hLevel: 3,
    theme: "title-brand-6"
  }, title), imageSrc ? // flow static analysis can't even get a boolean cast...
  ProductFeatureDetailBrandInformation_jsx("div", {
    className: "flex flex-col sm:flex-row -mx-px20"
  }, ProductFeatureDetailBrandInformation_jsx("div", {
    className: "flex-none px-px20 sm:w-1/2"
  }, desc), ProductFeatureDetailBrandInformation_jsx("div", {
    className: "flex-none px-px20 mt-px20 sm:mt-0 sm:w-1/2"
  }, ProductFeatureDetailBrandInformation_jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].XL
  }))) : desc);
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-facilities/ProductFeatureDetailFacility.jsx



var ProductFeatureDetailFacility_jsx = react_default.a.createElement;





function ProductFeatureDetailFacility(props) {
  var className = props.className,
      id = props.id,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      description = props.description,
      quantity = props.quantity,
      title = props.title;

  if (!title) {
    return null;
  }

  return ProductFeatureDetailFacility_jsx("article", {
    className: className,
    id: id
  }, ProductFeatureDetailFacility_jsx(Title["a" /* Title */], {
    className: "mb-0",
    hLevel: 5,
    theme: "title-sans-1"
  }, title, !!quantity && ": ".concat(quantity)), ProductFeatureDetailFacility_jsx(Text["a" /* Text */], {
    className: "m-0",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: description,
    theme: "text-sans-2"
  }), !Object(lodash["isEmpty"])(items) && ProductFeatureDetailFacility_jsx("ul", {
    className: "font-sans list-none p-0 mt-px10 text-gray-darker text-sm"
  }, items.map(function (item) {
    return !!item.description && ProductFeatureDetailFacility_jsx("li", {
      className: "list-disc",
      key: item.description
    }, item.label && ProductFeatureDetailFacility_jsx("span", {
      className: "font-bold"
    }, item.label, ": "), item.description);
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-facilities/ProductFeatureDetailFacilities.jsx

var ProductFeatureDetailFacilities_jsx = react_default.a.createElement;





var ProductFeatureDetailFacilities_ProductFeatureDetailFacilities = function ProductFeatureDetailFacilities(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref$color,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;

  if (!items.length) {
    return null;
  }

  return ProductFeatureDetailFacilities_jsx("section", {
    className: className
  }, ProductFeatureDetailFacilities_jsx(Title["a" /* Title */], {
    color: color,
    hLevel: 4,
    theme: "title-brand-3"
  }, title), ProductFeatureDetailFacilities_jsx("ul", {
    className: "sm:column-count-2 list-none p-0 my-px10"
  }, items.map(function (item, idx) {
    return !Object(lodash["isEmpty"])(item) && ProductFeatureDetailFacilities_jsx("li", {
      className: "break-inside-avoid-column my-px10".concat(idx === 0 ? ' mt-0' : ''),
      key: item.id
    }, ProductFeatureDetailFacilities_jsx(ProductFeatureDetailFacility, item));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-informations/ProductFeatureDetailInformation.jsx


var ProductFeatureDetailInformation_jsx = react_default.a.createElement;



function ProductFeatureDetailInformation(props) {
  var className = props.className,
      description = props.description,
      label = props.label;

  if (!description) {
    return null;
  }

  return ProductFeatureDetailInformation_jsx("article", {
    className: className
  }, !!label && ProductFeatureDetailInformation_jsx("div", {
    className: "font-sans font-bold text-gray-darker text-sm"
  }, label, ": "), ProductFeatureDetailInformation_jsx(Text["a" /* Text */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: description,
    theme: "text-sans-2"
  }));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-informations/ProductFeatureDetailInformations.jsx



var ProductFeatureDetailInformations_jsx = react_default.a.createElement;





var ProductFeatureDetailInformations_ProductFeatureDetailInformations = function ProductFeatureDetailInformations(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref$color,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      notes = _ref.notes,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;

  if (!items.length) {
    return null;
  }

  return ProductFeatureDetailInformations_jsx("section", {
    className: className
  }, ProductFeatureDetailInformations_jsx(Title["a" /* Title */], {
    className: "mb-px20",
    color: color,
    hLevel: 3,
    theme: "title-brand-4"
  }, title), ProductFeatureDetailInformations_jsx("ul", {
    className: "sm:column-count-2 list-none p-0 m-0"
  }, items.map(function (item, idx) {
    return item && item.description ? ProductFeatureDetailInformations_jsx("li", {
      className: "break-inside-avoid-column list-disc my-px10".concat(idx === 0 ? ' mt-0' : ''),
      key: item.description
    }, ProductFeatureDetailInformations_jsx(ProductFeatureDetailInformation, item)) : null;
  })), !!notes && ProductFeatureDetailInformations_jsx(Text["a" /* Text */], {
    className: "mt-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    text: notes,
    theme: "text-sans-2"
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-main-information/ProductFeatureDetailMainInformation.jsx



var ProductFeatureDetailMainInformation_jsx = react_default.a.createElement;




function ProductFeatureDetailMainInformation(props) {
  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _props$color,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? {} : _props$duration,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      note = props.note,
      smallTitle = props.smallTitle,
      title = props.title;

  if (!duration.description && !items.length) {
    return null;
  }

  return ProductFeatureDetailMainInformation_jsx("section", {
    className: className
  }, ProductFeatureDetailMainInformation_jsx(Title["a" /* Title */], {
    className: "mb-px20 sm:mb-px15",
    color: color,
    hLevel: 3,
    theme: "title-brand-5"
  }, smallTitle ? ProductFeatureDetailMainInformation_jsx("span", {
    className: "flex flex-col sm:flex-row sm:justify-between w-full"
  }, title, " ", smallTitle) : title), ProductFeatureDetailMainInformation_jsx("div", {
    className: "rtl:pr-px10 w-full sm:w-1/2"
  }, !!duration.description && ProductFeatureDetailMainInformation_jsx("div", {
    className: "text-1 mt-px10 mb-px10"
  }, !!duration.label && ProductFeatureDetailMainInformation_jsx("span", {
    className: "font-bold"
  }, "".concat(duration.label, ": ")), duration.description), !!items.length && ProductFeatureDetailMainInformation_jsx("ul", {
    className: "list-none p-0 leading-normal text-base text-gray-darker"
  }, items.map(function (item) {
    return (item.description || item.note) && ProductFeatureDetailMainInformation_jsx("li", {
      className: "my-px5 py-px10 list-disc",
      key: item.label
    }, !!item.label && ProductFeatureDetailMainInformation_jsx("div", {
      className: "font-bold"
    }, item.label), !!item.description && ProductFeatureDetailMainInformation_jsx(Text["a" /* Text */], {
      className: "inline-block mb-px5",
      text: item.description
    }), !!item.note && ProductFeatureDetailMainInformation_jsx("small", {
      className: "block"
    }, item.note));
  })), !!note && ProductFeatureDetailMainInformation_jsx("div", {
    className: "italic mt-px15 text-sm"
  }, note)));
}
// EXTERNAL MODULE: ./src/client/components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx + 1 modules
var CapsuleCollapseLists = __webpack_require__("d4In");

// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-services/ProductFeatureDetailServiceItem.jsx



var ProductFeatureDetailServiceItem_jsx = react_default.a.createElement;



function ProductFeatureDetailServiceItem(props) {
  var className = props.className,
      description = props.description,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      label = props.label,
      note = props.note,
      _props$tag = props.tag,
      tag = _props$tag === void 0 ? {} : _props$tag;
  return ProductFeatureDetailServiceItem_jsx("li", {
    className: className
  }, !!label && ProductFeatureDetailServiceItem_jsx("div", {
    className: "font-bold"
  }, label), !!description && ProductFeatureDetailServiceItem_jsx(Text["a" /* Text */], {
    className: "inline-block mb-px5",
    text: description
  }), !!(tag === null || tag === void 0 ? void 0 : tag.label) && ProductFeatureDetailServiceItem_jsx("span", {
    className: "font-bold text-".concat(tag.color || colors["a" /* COLORS */].GRAY_DARKER, " mb-px5")
  }, " ".concat(tag.label)), !!note && ProductFeatureDetailServiceItem_jsx("small", {
    className: "block"
  }, note), !!items.length && ProductFeatureDetailServiceItem_jsx("ul", {
    className: "list-none p-0 leading-normal text-base text-gray-darker"
  }, items.map(function (item, i) {
    return ProductFeatureDetailServiceItem_jsx(ProductFeatureDetailServiceItem, {
      className: "list-hyphen",
      description: item.description,
      index: i,
      items: item.items,
      key: item.description,
      label: item.label,
      note: item.note,
      tag: item.tag
    });
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-services/ProductFeatureDetailService.jsx



var ProductFeatureDetailService_jsx = react_default.a.createElement;









var ProductFeatureDetailService_ProductFeatureDetailService = function ProductFeatureDetailService(_ref) {
  var _ref$badges = _ref.badges,
      badges = _ref$badges === void 0 ? [] : _ref$badges,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _ref$color,
      duration = _ref.duration,
      id = _ref.id,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      level = _ref.level,
      note = _ref.note,
      _ref$targetPrice = _ref.targetPrice,
      targetPrice = _ref$targetPrice === void 0 ? {} : _ref$targetPrice,
      title = _ref.title;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      locale = _useContext.locale;

  if (!title) {
    return null;
  }

  var instalmentValue = Object(src_i18n["d" /* getKeyValue */])('common.price.instalmentValue');
  return ProductFeatureDetailService_jsx("article", {
    className: className,
    "data-id": id
  }, ProductFeatureDetailService_jsx(Title["a" /* Title */], {
    className: "sm:text-lg justify-between items-baseline",
    color: color,
    hLevel: 2,
    theme: "title-sans-3"
  }, title), ProductFeatureDetailService_jsx(Title["a" /* Title */], {
    className: "sm:text-md",
    hLevel: 3,
    theme: "title-sans-1"
  }, level), (targetPrice === null || targetPrice === void 0 ? void 0 : targetPrice.price) && ProductFeatureDetailService_jsx(TemplateString["a" /* TemplateString */], {
    className: "block text-base py-px10",
    template: targetPrice.label,
    values: {
      currency: targetPrice.currency ? Object(price_util["a" /* getCurrencySymbol */])(locale, targetPrice.currency) : '',
      price: Object(src_i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') ? Object(src_i18n["h" /* t */])('common.price.instalmentPrice', {
        instalmentValue: instalmentValue,
        dividedPrice: Math.floor(targetPrice.price / instalmentValue)
      }) : Math.floor(targetPrice.price) || ''
    },
    valuesClassName: {
      currency: "text-xl text-".concat(color, " font-bold"),
      price: "text-xl text-".concat(color, " font-bold")
    }
  }), (duration === null || duration === void 0 ? void 0 : duration.description) && ProductFeatureDetailService_jsx("div", {
    className: "text-1 my-px10"
  }, duration.label ? ProductFeatureDetailService_jsx("span", {
    className: "font-bold"
  }, "".concat(duration.label, ": ")) : null, duration.description), badges.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label;
    return ProductFeatureDetailService_jsx("div", {
      className: "flex items-center my-px10",
      key: iconName
    }, ProductFeatureDetailService_jsx(Badge["a" /* Badge */], {
      className: "rtl:mr-px10",
      color: colors["a" /* COLORS */].WHITE,
      colorBg: colors["a" /* COLORS */].BLUE,
      colorBorder: colors["a" /* COLORS */].BLUE,
      iconName: iconName,
      iconSize: "2.375rem",
      size: 50,
      variant: "pill"
    }), ProductFeatureDetailService_jsx("span", {
      className: "font-brand text-blue text-md"
    }, label));
  }), !!items.length && ProductFeatureDetailService_jsx("ul", {
    className: "list-none p-0 leading-normal text-base text-gray-darker"
  }, items.map(function (item) {
    return ProductFeatureDetailService_jsx(ProductFeatureDetailServiceItem, {
      className: "my-px5 py-px10 list-disc",
      description: item.description,
      items: item.items,
      key: item.description,
      label: item.label,
      note: item.note,
      tag: item.tag
    });
  })), !!note && ProductFeatureDetailService_jsx("div", {
    className: "italic mt-px15 text-sm"
  }, note));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/product-feature-detail-services/ProductFeatureDetailServices.jsx

var ProductFeatureDetailServices_jsx = react_default.a.createElement;







function ProductFeatureDetailServices(props) {
  var className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? colors["a" /* COLORS */].GRAY_DARKER : _props$color,
      _props$equipmentsTitl = props.equipmentsTitle,
      equipmentsTitle = _props$equipmentsTitl === void 0 ? '' : _props$equipmentsTitl,
      _props$equipments = props.equipments,
      equipments = _props$equipments === void 0 ? [] : _props$equipments,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      _props$title = props.title,
      title = _props$title === void 0 ? '' : _props$title,
      titleIcon = props.titleIcon;

  if (!items.length) {
    return null;
  }

  var hasEquipements = !!(equipments === null || equipments === void 0 ? void 0 : equipments.length);
  return ProductFeatureDetailServices_jsx("section", {
    className: className
  }, ProductFeatureDetailServices_jsx(Title["a" /* Title */], {
    className: "mb-px20 sm:mb-px15",
    color: color,
    hLevel: 3,
    iconName: titleIcon,
    theme: "title-brand-5"
  }, title), ProductFeatureDetailServices_jsx("div", {
    className: classnames_default()({
      'sm:flex -m-px10': hasEquipements
    })
  }, ProductFeatureDetailServices_jsx("div", {
    className: hasEquipements ? 'sm:w-1/2' : 'sm:flex flex-wrap -m-px10'
  }, items.map(function (item) {
    return !!(item === null || item === void 0 ? void 0 : item.title) && ProductFeatureDetailServices_jsx("div", {
      className: classnames_default()('p-px10', {
        'sm:w-1/2': !hasEquipements
      }),
      key: item.id
    }, ProductFeatureDetailServices_jsx(ProductFeatureDetailService_ProductFeatureDetailService, {
      badges: item.badges,
      color: color,
      duration: item.duration,
      id: item.id,
      items: item.items,
      level: item.level,
      note: item.note,
      targetPrice: item.targetPrice,
      title: item.title
    }));
  })), hasEquipements && ProductFeatureDetailServices_jsx("div", {
    className: "sm:w-1/2 p-px10"
  }, ProductFeatureDetailServices_jsx(CapsuleCollapseLists["a" /* CapsuleCollapseLists */], {
    header: {
      iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
      title: equipmentsTitle
    },
    lists: equipments,
    style: {
      maxWidth: 380
    }
  }))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-feature-detail/ProductFeatureDetail.jsx



var ProductFeatureDetail_jsx = react_default.a.createElement;



















function ProductFeatureDetail(_ref) {
  var brandInformation = _ref.brandInformation,
      description = _ref.description,
      diamond = _ref.diamond,
      _ref$downloadLinksLis = _ref.downloadLinksList,
      downloadLinksList = _ref$downloadLinksLis === void 0 ? [] : _ref$downloadLinksLis,
      _ref$facilitiesTitle = _ref.facilitiesTitle,
      facilitiesTitle = _ref$facilitiesTitle === void 0 ? '' : _ref$facilitiesTitle,
      mainInformationTitle = _ref.mainInformationTitle,
      mainInformation = _ref.mainInformation,
      equipments = _ref.equipments,
      equipmentsTitle = _ref.equipmentsTitle,
      generalInformationTitle = _ref.generalInformationTitle,
      _ref$generalInformati = _ref.generalInformation,
      generalInformation = _ref$generalInformati === void 0 ? [] : _ref$generalInformati,
      generalInformationExtraCost = _ref.generalInformationExtraCost,
      immersive = _ref.immersive,
      isIncluded = _ref.isIncluded,
      includedMessage = _ref.includedMessage,
      notIncludedMessage = _ref.notIncludedMessage,
      _ref$includedServices = _ref.includedServices,
      includedServices = _ref$includedServices === void 0 ? [] : _ref$includedServices,
      includedTitle = _ref.includedTitle,
      _ref$insideFacilities = _ref.insideFacilities,
      insideFacilities = _ref$insideFacilities === void 0 ? [] : _ref$insideFacilities,
      insideFacilitiesTitle = _ref.insideFacilitiesTitle,
      onDemandEquipmentsTitle = _ref.onDemandEquipmentsTitle,
      _ref$onDemandServices = _ref.onDemandServices,
      onDemandServices = _ref$onDemandServices === void 0 ? [] : _ref$onDemandServices,
      onDemandTitle = _ref.onDemandTitle,
      _ref$outsideFacilitie = _ref.outsideFacilities,
      outsideFacilities = _ref$outsideFacilitie === void 0 ? [] : _ref$outsideFacilitie,
      outsideFacilitiesTitle = _ref.outsideFacilitiesTitle,
      _ref$rentalEquipments = _ref.rentalEquipments,
      rentalEquipments = _ref$rentalEquipments === void 0 ? [] : _ref$rentalEquipments,
      _ref$targetPrice = _ref.targetPrice,
      targetPrice = _ref$targetPrice === void 0 ? {} : _ref$targetPrice,
      title = _ref.title,
      _ref$titleColor = _ref.titleColor,
      titleColor = _ref$titleColor === void 0 ? colors["a" /* COLORS */].BLUE : _ref$titleColor;

  var _useContext = Object(react["useContext"])(ReactAppContext["b" /* default */]),
      locale = _useContext.locale;

  var footer = ProductFeatureDetail_jsx(ProductFeatureDetailInformations_ProductFeatureDetailInformations, {
    className: "my-px10",
    items: generalInformation,
    notes: generalInformationExtraCost,
    title: generalInformationTitle
  });

  var message = isIncluded ? includedMessage : notIncludedMessage;
  var instalmentValue = Object(src_i18n["d" /* getKeyValue */])('common.price.instalmentValue');
  return ProductFeatureDetail_jsx(Sheet, {
    diamond: diamond,
    footer: footer,
    immersive: immersive
  }, !!title && ProductFeatureDetail_jsx(Title["a" /* Title */], {
    className: message ? 'mb-px10' : 'mb-px30',
    theme: "title-sans-8",
    color: titleColor
  }, title), !!message && ProductFeatureDetail_jsx("p", {
    className: classnames_default()('reset-paragraph flex items-center justify-center font-brand mb-px30 text-center text-lg sm:text-3xl', {
      'text-blue': isIncluded,
      'text-amber': !isIncluded
    })
  }, ProductFeatureDetail_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: isIncluded ? icons["a" /* ICONS */].ALL_INCLUSIVE : icons["a" /* ICONS */].ON_DEMAND,
    width: "1em"
  }), message), ProductFeatureDetail_jsx(Text["a" /* Text */], {
    className: "mb-px30",
    text: description
  }), ProductFeatureDetail_jsx(DownloadLinksList, {
    className: "mb-px30",
    links: downloadLinksList,
    theme: "lite"
  }), ProductFeatureDetail_jsx(ProductFeatureDetailMainInformation, Object(esm_extends["a" /* default */])({
    className: "my-px20",
    smallTitle: targetPrice.price ? ProductFeatureDetail_jsx(TemplateString["a" /* TemplateString */], {
      className: "text-base font-sans",
      template: targetPrice.label,
      values: {
        currency: Object(price_util["a" /* getCurrencySymbol */])(locale, targetPrice.currency),
        price: Object(src_i18n["d" /* getKeyValue */])('common.price.displayInstalmentsPrice') ? Object(src_i18n["h" /* t */])('common.price.instalmentPrice', {
          instalmentValue: instalmentValue,
          dividedPrice: Math.floor(targetPrice.price / instalmentValue)
        }) : Math.floor(targetPrice.price)
      },
      valuesClassName: {
        currency: 'text-amber text-xl font-bold',
        price: 'text-amber text-xl font-bold'
      }
    }) : null,
    title: mainInformationTitle
  }, mainInformation)), ProductFeatureDetail_jsx(ProductFeatureDetailBrandInformation, {
    className: "mt-px20 mb-px40 sm:mb-px80",
    description: brandInformation === null || brandInformation === void 0 ? void 0 : brandInformation.description,
    imageSrc: brandInformation === null || brandInformation === void 0 ? void 0 : brandInformation.imageSrc,
    title: brandInformation === null || brandInformation === void 0 ? void 0 : brandInformation.title
  }), !!includedServices.length && ProductFeatureDetail_jsx(ProductFeatureDetailServices, {
    className: "my-px20",
    color: colors["a" /* COLORS */].BLUE,
    equipments: equipments,
    equipmentsTitle: equipmentsTitle,
    items: includedServices,
    title: includedTitle,
    titleIcon: icons["a" /* ICONS */].ALL_INCLUSIVE
  }), !!onDemandServices.length && ProductFeatureDetail_jsx(ProductFeatureDetailServices, {
    className: "my-px20",
    color: colors["a" /* COLORS */].AMBER,
    items: onDemandServices,
    title: onDemandTitle,
    titleIcon: icons["a" /* ICONS */].ON_DEMAND
  }), !!rentalEquipments.length && ProductFeatureDetail_jsx(ProductFeatureDetailServices, {
    className: "my-px20",
    color: colors["a" /* COLORS */].AMBER,
    items: rentalEquipments,
    title: onDemandEquipmentsTitle,
    titleIcon: icons["a" /* ICONS */].ON_DEMAND
  }), (!Object(lodash["isEmpty"])(insideFacilities) || !Object(lodash["isEmpty"])(outsideFacilities)) && ProductFeatureDetail_jsx("section", null, ProductFeatureDetail_jsx(Title["a" /* Title */], {
    className: "my-px20",
    hLevel: 3,
    theme: "title-brand-6"
  }, facilitiesTitle), insideFacilities.length && ProductFeatureDetail_jsx(ProductFeatureDetailFacilities_ProductFeatureDetailFacilities, {
    className: "my-px20",
    items: insideFacilities,
    title: insideFacilitiesTitle
  }), outsideFacilities && ProductFeatureDetail_jsx(ProductFeatureDetailFacilities_ProductFeatureDetailFacilities, {
    className: "my-px20",
    items: outsideFacilities,
    title: outsideFacilitiesTitle
  })));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-activities-line/ProductActivitiesLine.jsx








var ProductActivitiesLine_jsx = react_default.a.createElement;

function ProductActivitiesLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductActivitiesLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductActivitiesLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductActivitiesLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductActivitiesLine_ProductActivitiesLine = function ProductActivitiesLine(props) {
  var _props$config$common = props.config.common,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      id = props.id,
      resort = props.resort;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  if (!resort) {
    return null;
  }

  var fetchActivityServices = function fetchActivityServices(_ref) {
    var productId = _ref.productId,
        activityId = _ref.activityId,
        rentalEquipmentsUsecasesId = _ref.rentalEquipmentsUsecasesId;
    var query = Object(productFeatures_queries["b" /* productActivityDetailQuery */])({
      productId: productId,
      activityId: activityId,
      rentalEquipmentsUsecasesId: rentalEquipmentsUsecasesId
    }, {
      lineProps: props,
      urlParams: location.urlParams
    });
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Kd" /* WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return {
        productActivities: ProductActivitiesLine_objectSpread(ProductActivitiesLine_objectSpread({}, data.productActivities), {}, {
          includedServices: data.includedServices,
          onDemandServices: data.onDemandServices,
          rentalEquipments: data.rentalEquipments
        })
      };
    });
  };

  var productActivitiesCategories = resort.categories && resort.categories.leisure ? resort.categories.leisure.filter(function (_ref2) {
    var activities = _ref2.activities;
    return activities && activities.length !== 0;
  }) : [];
  var productCategories = mapCategories({
    fetchActivityServices: fetchActivityServices,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].ACTIVITIES,
    productActivitiesCategories: productActivitiesCategories,
    productFeaturesLineData: props
  });
  return ProductActivitiesLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductActivitiesLine_jsx(ProductFeatures_ProductFeatures, {
    categories: productCategories,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].ACTIVITIES,
    queryLayer: "productActivitiesLayer",
    renderDetail: function renderDetail(data) {
      return ProductActivitiesLine_jsx(ProductFeatureDetail, data);
    },
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-activities/productActivities.resolver.js
var productActivities_resolver = __webpack_require__("g3/4");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-activities/productActivities.descriptor.js



var productActivitiesDescriptor = {
  name: constants["J" /* PRODUCT_ACTIVITIES */],
  component: ProductActivitiesLine_ProductActivitiesLine,
  resolve: productActivities_resolver["a" /* productActivitiesResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-catering/ProductCatering.jsx




var ProductCatering_jsx = react_default.a.createElement;




var ProductCatering_ProductCatering = function ProductCatering(_ref) {
  var _ref$intros = _ref.intros,
      intros = _ref$intros === void 0 ? [] : _ref$intros,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;
  var hasIntros = !!intros.length;
  var hasList = !!list.length;

  if (!hasIntros && !hasList) {
    return null;
  }

  return ProductCatering_jsx("div", {
    className: "pb-px30"
  }, hasIntros && ProductCatering_jsx("div", {
    className: "flex"
  }, intros.map(function (_ref2) {
    var description = _ref2.description,
        _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title;
    return ProductCatering_jsx(Card["a" /* Card */], {
      className: "w-full md:w-1/2",
      key: title,
      heading: {
        title: title
      },
      text: {
        text: description
      }
    });
  })), hasIntros && hasList && ProductCatering_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-px20 mx-0 p-0"
  }), hasList && list.map(function (_ref3, index) {
    var description = _ref3.description,
        _ref3$image = _ref3.image,
        image = _ref3$image === void 0 ? '' : _ref3$image,
        _ref3$name = _ref3.name,
        name = _ref3$name === void 0 ? '' : _ref3$name;
    return (description || name) && ProductCatering_jsx(react["Fragment"], {
      key: name
    }, index > 0 && ProductCatering_jsx("hr", {
      className: "block border-0 border-solid border-gray-light border-t-1 h-px my-px20 mx-0 p-0"
    }), ProductCatering_jsx(Card["a" /* Card */], {
      heading: {
        title: name
      },
      layout: Card_constants["d" /* INLINE_1 */],
      media: {
        url: image,
        ratioKey: ratios_utils["a" /* default */].M
      },
      seeLessLabel: seeLessLabel,
      seeMoreLabel: seeMoreLabel,
      text: {
        text: description
      }
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-bars/productBars.resolver.js
var productBars_resolver = __webpack_require__("9Ts2");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-bars/productBars.descriptor.js










var productBars_descriptor_jsx = react_default.a.createElement;

function productBars_descriptor_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productBars_descriptor_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productBars_descriptor_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productBars_descriptor_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var productBars_descriptor_ProductBarsLine = function ProductBarsLine(_ref) {
  var bars = _ref.bars,
      _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      priceInclude = _ref.priceInclude,
      title = _ref.title,
      withSupplement = _ref.withSupplement;
  var intros = bars.introduction ? [{
    title: priceInclude,
    description: bars.introduction.included
  }, {
    title: withSupplement,
    description: bars.introduction.withSupplement
  }] : [];
  var list = bars.barsList.map(function (bar) {
    var _bar$images = Object(slicedToArray["a" /* default */])(bar.images, 1),
        image = _bar$images[0];

    return productBars_descriptor_objectSpread(productBars_descriptor_objectSpread({}, bar), {}, {
      image: image
    });
  });
  return productBars_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productBars_descriptor_jsx(LineTitle["a" /* LineTitle */], null, title), productBars_descriptor_jsx(ProductCatering_ProductCatering, {
    intros: intros,
    list: list,
    seeLessLabel: config.common.loadLess,
    seeMoreLabel: config.common.viewMore
  }));
};

var productBarsDescriptor = {
  name: constants["eb" /* RESORT_BARS */],
  component: productBars_descriptor_ProductBarsLine,
  resolve: productBars_resolver["a" /* productBarsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-booking-line/ProductBookingLine.utils.js









function ProductBookingLine_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProductBookingLine_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ProductBookingLine_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ProductBookingLine_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var ProductBookingLine_utils_NO_TRANSPORT_VALUE = 'NO';
var ProductBookingLine_utils_getBookingConfig = function getBookingConfig(props) {
  var checkPriceLabel = props.checkPriceLabel,
      config = props.config,
      enableTransfer = props.enableTransfer,
      minAgeErrorMessage = props.minAgeErrorMessage,
      minAgeInformation = props.minAgeInformation,
      bookingPackage = props["package"],
      resortId = props.resortId;
  return ProductBookingLine_utils_objectSpread(ProductBookingLine_utils_objectSpread({}, config), {}, {
    booking: Object(lodash["merge"])(config.booking, {
      checkPriceLabel: checkPriceLabel,
      departureCity: ProductBookingLine_utils_NO_TRANSPORT_VALUE,
      enableTransfer: enableTransfer,
      minAgeErrorMessage: minAgeErrorMessage,
      minAgeInformation: minAgeInformation,
      "package": bookingPackage,
      resortId: resortId
    })
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/product-booking-line/ProductBookingLine.jsx








var ProductBookingLine_jsx = react["createElement"];

function ProductBookingLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductBookingLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductBookingLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductBookingLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ProductBookingLine_ProductBookingLine = function ProductBookingLine(props) {
  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  if (!props.resort) {
    return null;
  }

  var bookingConfig = ProductBookingLine_utils_getBookingConfig(props);
  return ProductBookingLine_jsx("div", {
    className: "Line Line-BookingEngine relative z-3"
  }, ProductBookingLine_jsx("div", {
    className: "PriceTicket-sticky-beacon"
  }), ProductBookingLine_jsx(BookingEngineForm_container, {
    bookingConfig: bookingConfig.booking,
    bookingCriteria: props.bookingCriteria,
    checkPriceLabel: props.checkPriceLabel,
    config: bookingConfig,
    cmsPrice: bookingConfig.price,
    cmsStartingPrice: bookingConfig.resort.startingPrice,
    enableTransfer: props.enableTransfer,
    i18n: ProductBookingLine_objectSpread(ProductBookingLine_objectSpread({}, bookingConfig), {}, {
      package: props.package,
      checkPriceLabel: props.checkPriceLabel,
      errorMessageNoProposal: props.package.errorMessageNoProposal,
      errorMessageNoMorePackages: props.package.errorMessageNoMorePackages,
      legalInformations: props.legalInformations
    }),
    legalInformations: props.legalInformations,
    location: location,
    package: props.package,
    pushImage: bookingConfig.booking.form.pushImage ? bookingConfig.booking.form.pushImage : null,
    resort: props.resort,
    resortId: props.resortId,
    travelAdvisorConfig: bookingConfig.travelAdvisor
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-booking/productBookingBE.resolver.js
var productBookingBE_resolver = __webpack_require__("4NBB");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-booking/productBookingBE.descriptor.js



var productBookingBEDescriptor = {
  name: constants["fb" /* RESORT_BOOKING_BE */],
  component: ProductBookingLine_ProductBookingLine,
  resolve: productBookingBE_resolver["a" /* productBookingBEResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-breadcrumb-line/ProductBreadcrumbLine.jsx














var ProductBreadcrumbLine_jsx = react_default.a.createElement;

function ProductBreadcrumbLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductBreadcrumbLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductBreadcrumbLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductBreadcrumbLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductBreadcrumbLine_BreadcrumbCell = function BreadcrumbCell(_ref) {
  var className = _ref.className,
      isCurrent = _ref.isCurrent,
      label = _ref.label,
      url = _ref.url;
  return url ? ProductBreadcrumbLine_jsx(DynamicLink["a" /* default */], Object(esm_extends["a" /* default */])({
    className: classnames_default()(className, 'underline'),
    url: url
  }, isCurrent ? {
    'aria-current': 'location'
  } : null), ProductBreadcrumbLine_jsx("span", {
    className: "max-w-full truncate"
  }, label)) : ProductBreadcrumbLine_jsx("span", {
    className: classnames_default()(className, 'font-bold')
  }, ProductBreadcrumbLine_jsx("span", {
    className: "max-w-full truncate"
  }, label));
};

var ProductBreadcrumbLine_ProductBreadcrumbLine = function ProductBreadcrumbLine(_ref2) {
  var countryPage = _ref2.countryPage,
      originalUrl = _ref2.originalUrl,
      regionPage = _ref2.regionPage,
      resort = _ref2.resort;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      breadcrumb = _useContext.breadcrumb,
      pageRegion = _useContext.pageRegion,
      pageCountry = _useContext.pageCountry,
      pageType = _useContext.pageType;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var origin = new URI_default.a(originalUrl).origin().toString();
  var _b2cPagesService$PAGE = dist["b2cPagesService"].PAGE_TYPES,
      DESTINATION = _b2cPagesService$PAGE.DESTINATION,
      DESTINATION_CRUISE = _b2cPagesService$PAGE.DESTINATION_CRUISE,
      DESTINATION_TOUR = _b2cPagesService$PAGE.DESTINATION_TOUR,
      DESTINATION_TRAVEL = _b2cPagesService$PAGE.DESTINATION_TRAVEL,
      LANDING = _b2cPagesService$PAGE.LANDING,
      LANDING_MICE = _b2cPagesService$PAGE.LANDING_MICE,
      OFFER = _b2cPagesService$PAGE.OFFER,
      RESORT_PAGE = _b2cPagesService$PAGE.RESORT;
  var breadcrumbItems = [{
    label: dist["constants"].WEBSITE_NAME,
    url: '/'
  }];

  switch (pageType) {
    case LANDING:
    case LANDING_MICE:
    case OFFER:
      if (breadcrumb) {
        breadcrumbItems.push.apply(breadcrumbItems, Object(toConsumableArray["a" /* default */])(breadcrumb));
      }

      break;

    case DESTINATION:
    case DESTINATION_CRUISE:
    case DESTINATION_TOUR:
    case DESTINATION_TRAVEL:
      var destinationItems = [regionPage ? {
        label: regionPage.pageRegion.breadcrumbLabel,
        url: regionPage.url
      } : null, pageRegion && pageCountry ? {
        label: pageCountry.breadcrumbLabel,
        url: ''
      } : null, pageRegion && !pageCountry ? {
        label: pageRegion.breadcrumbLabel,
        url: ''
      } : null];
      breadcrumbItems.push.apply(breadcrumbItems, Object(toConsumableArray["a" /* default */])(destinationItems.filter(Boolean)));
      break;

    case RESORT_PAGE:
      var resortItems = [regionPage ? {
        label: regionPage.pageRegion.breadcrumbLabel,
        url: regionPage.url
      } : null, countryPage ? {
        label: countryPage.pageCountry.breadcrumbLabel,
        url: countryPage.url
      } : null, resort ? {
        label: resort.name,
        url: ''
      } : null];
      breadcrumbItems.push.apply(breadcrumbItems, Object(toConsumableArray["a" /* default */])(resortItems.filter(Boolean)));
      break;

    default:
  }

  if (breadcrumbItems.length <= 1) {
    return null;
  }

  return ProductBreadcrumbLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-Breadcrumb"
  }, [{
    type: 'application/ld+json',
    innerHTML: JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map(function (item, index) {
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@id': item.url ? origin + item.url : Object(uriUtils["c" /* convertLocationToURI */])(ProductBreadcrumbLine_objectSpread(ProductBreadcrumbLine_objectSpread({}, location), {}, {
              origin: origin
            })).readable(),
            name: item.label
          }
        };
      })
    })
  }].map(function (script, idx) {
    return ProductBreadcrumbLine_jsx("script", {
      key: idx,
      type: script.type,
      dangerouslySetInnerHTML: {
        __html: script.innerHTML
      }
    });
  }), ProductBreadcrumbLine_jsx("nav", {
    className: "flex items-end sm:overflow-x-visible scroll-snap-area",
    "aria-label": "breadcrumbs"
  }, ProductBreadcrumbLine_jsx(Icon["a" /* Icon */], {
    className: "mb-px flex-shrink-0",
    name: icons["a" /* ICONS */].HOME,
    width: "0.75rem"
  }), ProductBreadcrumbLine_jsx("ol", {
    className: "flex items-center leading-one rtl:pr-px20 sm:rtl:pr-0 reset-list"
  }, breadcrumbItems.map(function (item, i) {
    return ProductBreadcrumbLine_jsx("li", {
      className: "flex items-center rtl:ml-px5",
      key: i
    }, ProductBreadcrumbLine_jsx(ProductBreadcrumbLine_BreadcrumbCell, Object(esm_extends["a" /* default */])({}, item, {
      className: "text-gray-darker text-sm whitespace-no-wrap",
      isCurrent: i === breadcrumbItems.length - 1
    })), i < breadcrumbItems.length - 1 && ProductBreadcrumbLine_jsx("span", {
      className: "leading-none rtl:ml-px5",
      "aria-hidden": "true"
    }, ">"));
  }))));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-breadcrumb/productBreadcrumb.resolver.js
var productBreadcrumb_resolver = __webpack_require__("9smd");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-breadcrumb/productBreadcrumb.descriptor.js



var productBreadcrumbDescriptor = {
  name: constants["K" /* PRODUCT_BREADCRUMB */],
  component: ProductBreadcrumbLine_ProductBreadcrumbLine,
  props: productBreadcrumb_resolver["a" /* productBreadcrumbResolver */].props,
  resolve: productBreadcrumb_resolver["a" /* productBreadcrumbResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-childcares-line/ProductChildcaresLine.jsx









var ProductChildcaresLine_jsx = react_default.a.createElement;

function ProductChildcaresLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductChildcaresLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductChildcaresLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductChildcaresLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductChildcaresLine_ProductChildcaresLine = function ProductChildcaresLine(props) {
  var closingDays = props.closingDays,
      openingHours = props.openingHours,
      _props$config$common = props.config.common,
      childcarealacarte = _props$config$common.childcarealacarte,
      loadLess = _props$config$common.loadLess,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      resort = props.resort;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  Object(src_i18n["a" /* addTranslationKeys */])({
    'productChildcaresInformation.closingDays': closingDays,
    'productChildcaresInformation.openingHours': openingHours
  });

  if (!resort) {
    return null;
  }

  var fetchActivityServices = function fetchActivityServices(_ref) {
    var productId = _ref.productId,
        activityId = _ref.activityId;
    var query = Object(productFeatures_queries["c" /* productChildcareDetailQuery */])(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams
    });
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Kd" /* WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return {
        productActivities: ProductChildcaresLine_objectSpread(ProductChildcaresLine_objectSpread({}, data.productActivities), {}, {
          resort: data.resort,
          includedServices: data.includedServices,
          onDemandServices: data.onDemandServices
        })
      };
    });
  };

  var introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text: resort.kidsActivitiesIntroduction && resort.kidsActivitiesIntroduction.description || '',
    title: resort.kidsActivitiesIntroduction && resort.kidsActivitiesIntroduction.shortDescription || ''
  };
  var productActivitiesCategories = resort.categories && resort.categories.children ? resort.categories.children.filter(function (_ref2) {
    var activities = _ref2.activities;
    return activities && activities.length !== 0;
  }) : [];
  var productCategories = mapCategories({
    fetchActivityServices: fetchActivityServices,
    hasBanner: true,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].CHILDCARE,
    notIncludedMessage: childcarealacarte,
    productActivitiesCategories: productActivitiesCategories,
    productFeaturesLineData: props
  });
  return ProductChildcaresLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductChildcaresLine_jsx(ProductFeatures_ProductFeatures, {
    categories: productCategories,
    introduction: introduction,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].CHILDCARE,
    queryLayer: "productChildcaresLayer",
    renderDetail: function renderDetail(data) {
      return ProductChildcaresLine_jsx(ProductFeatureDetail, data);
    },
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-childcares/productChildcares.resolver.js
var productChildcares_resolver = __webpack_require__("27iJ");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-childcares/productChildcares.descriptor.js



var productChildcaresDescriptor = {
  name: constants["L" /* PRODUCT_CHILDCARES */],
  component: ProductChildcaresLine_ProductChildcaresLine,
  resolve: productChildcares_resolver["a" /* productChildcaresResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/active-indexes/ActiveIndexes.jsx
var ActiveIndexes = __webpack_require__("1Wgj");

// CONCATENATED MODULE: ./src/client/components/frameworks/post-answer/PostAnswer.themes.js
var PostAnswer_themes_themes = {
  "default": {
    thTag: 'mb-px20',
    thTextTheme: 'text-sans-3',
    thBottom: 'flex items-center justify-between mt-px20',
    thAuthor: 'font-bold',
    thDate: 'text-gray-medium',
    thLikesLabel: 'font-bold text-gray-darker rtl:mr-px10',
    thLikes: 'inline-flex items-center text-red rtl:mr-px10',
    thIcon: 'rtl:mr-px10',
    thIconSize: '1.25rem'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/post-answer/PostAnswer.jsx

var PostAnswer_jsx = react_default.a.createElement;






function PostAnswer(props) {
  var author = props.author,
      className = props.className,
      date = props.date,
      hasLabel = props.hasLabel,
      id = props.id,
      _props$likesCount = props.likesCount,
      likesCount = _props$likesCount === void 0 ? 0 : _props$likesCount,
      likesLabel = props.likesLabel,
      tag = props.tag,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      text = props.text;
  if (!text) return null;
  var _themes$theme = PostAnswer_themes_themes[theme],
      thAuthor = _themes$theme.thAuthor,
      thBottom = _themes$theme.thBottom,
      thDate = _themes$theme.thDate,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLikes = _themes$theme.thLikes,
      thLikesLabel = _themes$theme.thLikesLabel,
      thTag = _themes$theme.thTag,
      thTextTheme = _themes$theme.thTextTheme;
  return PostAnswer_jsx("article", {
    id: id,
    className: className
  }, PostAnswer_jsx(Tag["a" /* Tag */], Object(esm_extends["a" /* default */])({
    className: thTag
  }, tag)), PostAnswer_jsx(Text["a" /* Text */], {
    text: text,
    theme: thTextTheme
  }), (!!author || !!date || !!likesCount) && PostAnswer_jsx("div", {
    className: thBottom
  }, PostAnswer_jsx("div", null, !!author && PostAnswer_jsx("span", {
    className: thAuthor
  }, author), !!author && !!date && ' - ', !!date && PostAnswer_jsx("span", {
    className: thDate
  }, date)), PostAnswer_jsx("div", {
    className: thLikes
  }, hasLabel && !!likesLabel && PostAnswer_jsx("span", {
    className: thLikesLabel
  }, likesLabel), PostAnswer_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].HEART_FILLED,
    width: thIconSize
  }), likesCount)));
}
// CONCATENATED MODULE: ./src/client/components/frameworks/post-question/PostQuestion.themes.js
var PostQuestion_themes_themes = {
  "default": function _default(_ref) {
    var _ref$author = _ref.author,
        author = _ref$author === void 0 ? {} : _ref$author;
    return {
      thRoot: 'flex flex-col',
      thTop: 'flex items-center mb-px10',
      thBadge: 'rtl:mr-px10 flex-shrink-0',
      thBadgeIconSize: '1rem',
      thBadgeSize: 40,
      thBadgeVariant: 'pill',
      thAuthor: "text-".concat(author.color ? author.color : 'gray-dark', " text-base"),
      thDate: 'text-base text-gray-light rtl:ml-px20',
      thTitleTheme: 'title-sans-3',
      thText: 'mt-px10',
      thBottom: 'flex items-center mt-auto pt-px10 text-md',
      thIcon: 'rtl:mr-px5',
      thIconSize: '1.25rem',
      thLikes: 'inline-flex items-center text-red rtl:mr-px10',
      thAnswers: 'inline-flex items-center text-turquoise',
      thSeeMore: 'font-bold text-turquoise text-md underline rtl:ml-auto'
    };
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/post-question/PostQuestion.jsx


var PostQuestion_jsx = react_default.a.createElement;









function PostQuestion(props) {
  var _props$answersCount = props.answersCount,
      answersCount = _props$answersCount === void 0 ? 0 : _props$answersCount,
      _props$author = props.author,
      author = _props$author === void 0 ? {} : _props$author,
      className = props.className,
      date = props.date,
      id = props.id,
      _props$likesCount = props.likesCount,
      likesCount = _props$likesCount === void 0 ? 0 : _props$likesCount,
      seeMoreLabel = props.seeMoreLabel,
      text = props.text,
      _props$textLimit = props.textLimit,
      textLimit = _props$textLimit === void 0 ? 130 : _props$textLimit,
      _props$theme = props.theme,
      theme = _props$theme === void 0 ? 'default' : _props$theme,
      title = props.title,
      titleId = props.titleId,
      _props$titleLimit = props.titleLimit,
      titleLimit = _props$titleLimit === void 0 ? -1 : _props$titleLimit;
  if (!title) return null;

  var _themes$theme = PostQuestion_themes_themes[theme](props),
      thAnswers = _themes$theme.thAnswers,
      thAuthor = _themes$theme.thAuthor,
      thBadge = _themes$theme.thBadge,
      thBadgeIconSize = _themes$theme.thBadgeIconSize,
      thBadgeSize = _themes$theme.thBadgeSize,
      thBadgeVariant = _themes$theme.thBadgeVariant,
      thBottom = _themes$theme.thBottom,
      thDate = _themes$theme.thDate,
      thIcon = _themes$theme.thIcon,
      thIconSize = _themes$theme.thIconSize,
      thLikes = _themes$theme.thLikes,
      thRoot = _themes$theme.thRoot,
      thSeeMore = _themes$theme.thSeeMore,
      thText = _themes$theme.thText,
      thTitle = _themes$theme.thTitle,
      thTitleTheme = _themes$theme.thTitleTheme,
      thTop = _themes$theme.thTop;

  return PostQuestion_jsx("article", {
    id: id,
    className: classnames_default()(thRoot, className)
  }, PostQuestion_jsx("div", {
    className: thTop
  }, PostQuestion_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({
    alt: author.avatarImg && author.name,
    className: thBadge,
    colorBg: author.color,
    colorBorder: author.color,
    iconSize: thBadgeIconSize,
    size: thBadgeSize,
    variant: thBadgeVariant
  }, author.avatarImg ? {
    imageSrc: author.avatarImg
  } : {
    iconName: icons["a" /* ICONS */].USER
  })), !!author.name && PostQuestion_jsx("span", {
    className: thAuthor
  }, author.name), !!date && PostQuestion_jsx("span", {
    className: thDate
  }, date)), PostQuestion_jsx(Title["a" /* Title */], {
    id: titleId,
    className: thTitle,
    theme: thTitleTheme
  }, titleLimit > 0 ? Object(string_util["d" /* truncate */])(title, titleLimit) : title), !!text && PostQuestion_jsx(Text["a" /* Text */], {
    className: thText,
    text: textLimit > 0 ? Object(string_util["d" /* truncate */])(text, textLimit) : text
  }), PostQuestion_jsx("div", {
    className: thBottom
  }, PostQuestion_jsx("span", {
    className: thLikes
  }, PostQuestion_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].HEART_FILLED,
    width: thIconSize
  }), likesCount), PostQuestion_jsx("span", {
    className: thAnswers
  }, PostQuestion_jsx(Icon["a" /* Icon */], {
    className: thIcon,
    name: icons["a" /* ICONS */].ANSWERS,
    width: thIconSize
  }), answersCount), !!seeMoreLabel && PostQuestion_jsx("span", {
    className: thSeeMore
  }, seeMoreLabel)));
}
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/large/WibilongLarge.jsx




var WibilongLarge_jsx = react_default.a.createElement;
















var clearAndScroll = function clearAndScroll(_ref) {
  var clear = _ref.clear,
      scrollTo = _ref.scrollTo;
  return function () {
    clear();
    scrollTo();
  };
};

function WibilongLarge(props) {
  var noAnswerstext = props.noAnswerstext,
      _props$questions = props.questions,
      questions = _props$questions === void 0 ? [] : _props$questions,
      _props$scrollTo = props.scrollTo,
      scrollTo = _props$scrollTo === void 0 ? lodash["noop"] : _props$scrollTo,
      seeMoreLabel = props.seeMoreLabel;

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isDesktop = _useContext.isDesktop;

  if (Object(lodash["isEmpty"])(questions)) {
    return null;
  }

  return WibilongLarge_jsx(SiteContainer["a" /* SiteContainer */], null, WibilongLarge_jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    hasNoIndexEnabled: true
  }, function (_ref2) {
    var activeIndexes = _ref2.activeIndexes,
        clear = _ref2.clear,
        update = _ref2.update;
    var answers = questions[activeIndexes[0]] && questions[activeIndexes[0]].answers ? questions[activeIndexes[0]].answers : [];
    var onClear = clearAndScroll({
      clear: clear,
      scrollTo: scrollTo
    });
    var items = questions.map(function (q, i) {
      var isActive = activeIndexes.includes(i);
      var hasSomeSelected = !!activeIndexes.length;
      return WibilongLarge_jsx("div", {
        className: "p-px10",
        key: q.id
      }, WibilongLarge_jsx(TrackClick["a" /* TrackClick */], {
        as: "div",
        className: classnames_default()('bg-white cursor-pointer flex overflow-hidden p-px20 rounded shadow-md transition-all', {
          'opacity-50': hasSomeSelected && !isActive,
          'hover:scale-1025': !hasSomeSelected,
          'scale-1025': isActive
        }),
        "data-testid": "Wibilong-question",
        onClick: function onClick() {
          update(i);
          scrollTo();
        },
        role: "button",
        style: {
          minHeight: 250
        },
        tabIndex: 0,
        trackingData: !hasSomeSelected ? q.trackingData : null
      }, WibilongLarge_jsx(PostQuestion, Object(esm_extends["a" /* default */])({}, q, {
        className: "w-full",
        textLimit: isActive ? -1 : 100,
        titleLimit: isActive ? -1 : 60,
        seeMoreLabel: !Object(lodash["isEmpty"])(q.answers) ? seeMoreLabel : ''
      }))));
    });
    return WibilongLarge_jsx(react["Fragment"], null, WibilongLarge_jsx(SliderHandler["a" /* SliderHandler */], {
      className: "flex-1",
      items: items,
      onNext: onClear,
      onPrevious: onClear,
      hasKeyboardSupport: true,
      hasLazyload: true,
      hasSwipeSupport: true,
      nbItemsToScroll: 1,
      nbItemsToShow: isDesktop ? 3 : 2
    }, function (_ref3) {
      var hasControls = _ref3.hasControls,
          isNextControlDisabled = _ref3.isNextControlDisabled,
          isPreviousControlDisabled = _ref3.isPreviousControlDisabled,
          itemsNode = _ref3.itemsNode,
          onNext = _ref3.onNext,
          onPrevious = _ref3.onPrevious;
      return WibilongLarge_jsx("div", {
        className: "flex"
      }, hasControls && WibilongLarge_jsx("div", {
        className: classnames_default()('flex-none rtl:mr-px10', {
          invisible: isPreviousControlDisabled
        }),
        style: {
          marginTop: '118px'
        }
      }, WibilongLarge_jsx(ArrowButton["a" /* ArrowButton */], {
        className: "shadow-sm",
        isDisabled: isPreviousControlDisabled,
        label: Object(src_i18n["h" /* t */])('common.previous'),
        onClick: onPrevious
      })), itemsNode, hasControls && WibilongLarge_jsx("div", {
        className: classnames_default()('flex-none rtl:ml-px10', {
          invisible: isNextControlDisabled
        }),
        style: {
          marginTop: '118px'
        }
      }, WibilongLarge_jsx(ArrowButton["a" /* ArrowButton */], {
        className: "shadow-sm",
        isDisabled: isNextControlDisabled,
        label: Object(src_i18n["h" /* t */])('common.next'),
        onClick: onNext,
        rotation: 180
      })));
    }), !Object(lodash["isEmpty"])(activeIndexes) && WibilongLarge_jsx("div", {
      className: "fadeIn flex flex-col items-center mt-px40 relative"
    }, !Object(lodash["isEmpty"])(answers) && WibilongLarge_jsx("button", {
      "data-testid": "Wibilong-clear",
      className: "reset-button absolute bg-white leading-none mt-px10 p-px10 rtl:right-0 rtl:mr-px40 rounded-full shadow-md text-gray-medium",
      onClick: onClear,
      type: "button"
    }, WibilongLarge_jsx(Icon["a" /* Icon */], {
      name: icons["a" /* ICONS */].CROSS,
      width: "1.25rem"
    })), WibilongLarge_jsx("div", {
      className: "border-t-1 max-w-site-small w-full"
    }, !Object(lodash["isEmpty"])(answers) ? answers.map(function (answer) {
      return WibilongLarge_jsx(PostAnswer, Object(esm_extends["a" /* default */])({}, answer, {
        className: "py-px30 border-b-1",
        key: answer.id
      }));
    }) : WibilongLarge_jsx(Notification["a" /* Notification */], {
      className: "mt-px30",
      hasBorder: true,
      hasClose: true,
      onClose: onClear,
      text: noAnswerstext
    }))));
  }));
}
// EXTERNAL MODULE: ./src/client/components/utils/identifiers/constants.js
var identifiers_constants = __webpack_require__("YZTm");

// EXTERNAL MODULE: ./src/client/components/frameworks/side-panel/SidePanel.jsx + 1 modules
var SidePanel = __webpack_require__("p7XS");

// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/popin-button/WibilongPopinButton.jsx

var WibilongPopinButton_jsx = react_default.a.createElement;







var WibilongPopinButton_WibilongPopinButton = function WibilongPopinButton(props) {
  var dataUrl = config_default.a.get('social.wibilong.appUrl');
  var isEnabled = config_default.a.get('social.wibilong.enabled');
  var scriptUrl = config_default.a.get('social.wibilong.scriptUrl');

  var _useScriptLoader = Object(useScriptLoader["a" /* useScriptLoader */])(scriptUrl),
      scriptLoaded = _useScriptLoader.scriptLoaded;

  Object(react["useEffect"])(function () {
    if (isEnabled) {
      var wibilongPopin = dist["windowWrapper"].get('wibilongPopin');

      if (wibilongPopin && Object(lodash["isFunction"])(wibilongPopin.init)) {
        wibilongPopin.init();
      }
    }
  }, [scriptLoaded]);
  var className = props.className,
      country = props.country,
      language = props.language,
      productId = props.productId,
      trackingData = props.trackingData;
  return WibilongPopinButton_jsx(react["Fragment"], null, !isEnabled ? null : WibilongPopinButton_jsx(TrackClick["a" /* TrackClick */], {
    as: "div",
    className: classnames_default()(className, 'WibilongPopinButton'),
    trackingData: trackingData
  }, WibilongPopinButton_jsx("div", {
    id: "PopinDiv",
    "data-url": dataUrl,
    "data-product": "".concat(productId).concat(country).concat(language)
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/catchblock/WibilongCatchBlock.jsx


var WibilongCatchBlock_jsx = react_default.a.createElement;






var WibilongCatchBlock_WibilongCatchBlock = function WibilongCatchBlock(_ref) {
  var button = _ref.button,
      text = _ref.text,
      className = _ref.className,
      _ref$link = _ref.link,
      link = _ref$link === void 0 ? {} : _ref$link;
  return WibilongCatchBlock_jsx("div", {
    className: classnames_default()(className, 'text-center flex flex-col justify-center')
  }, WibilongCatchBlock_jsx(Text["a" /* Text */], {
    theme: "text-sans-4",
    text: text
  }), WibilongCatchBlock_jsx(WibilongPopinButton_WibilongPopinButton, Object(esm_extends["a" /* default */])({}, button, {
    className: "mt-px10"
  })), !!link.url && WibilongCatchBlock_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "font-bold mt-px10 text-md text-blue focus:text-turquoise hover:text-turquoise underline transition-color",
    target: link.target,
    trackingData: link.trackingData,
    url: link.url
  }, link.label));
};
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/narrow/WibilongNarrow.jsx




var WibilongNarrow_jsx = react_default.a.createElement;












function WibilongNarrow(props) {
  var button = props.button,
      hasLinkAllQuestions = props.hasLinkAllQuestions,
      _props$linkAllQuestio = props.linkAllQuestions,
      linkAllQuestions = _props$linkAllQuestio === void 0 ? {} : _props$linkAllQuestio,
      noAnswerstext = props.noAnswerstext,
      _props$questions = props.questions,
      questions = _props$questions === void 0 ? [] : _props$questions,
      scrollBackwardLabel = props.scrollBackwardLabel,
      scrollForwardLabel = props.scrollForwardLabel,
      seeMoreLabel = props.seeMoreLabel,
      text = props.text;
  if (Object(lodash["isEmpty"])(questions)) return null;
  var boxStyles = {
    minHeight: 230,
    width: '80vw'
  };
  return WibilongNarrow_jsx(ActiveIndexes["a" /* ActiveIndexes */], {
    hasNoIndexEnabled: true
  }, function (_ref) {
    var update = _ref.update,
        activeIndexes = _ref.activeIndexes,
        clear = _ref.clear;
    var activeQuestion = questions[activeIndexes[0]] || {};
    var answers = activeQuestion.answers ? activeQuestion.answers : [];
    var ariaLabel = activeQuestion.title;
    var ariaLabelledby = activeQuestion.id && "".concat(identifiers_constants["J" /* ID_SIDEPANEL_HEADER__SHOPPING__WIBILONG_NARROW */], "-").concat(activeQuestion.id);
    return WibilongNarrow_jsx("div", {
      className: "mt-px25"
    }, WibilongNarrow_jsx(Scrollable["a" /* Scrollable */], {
      backwardLabel: scrollBackwardLabel,
      forwardLabel: scrollForwardLabel,
      navPosition: "center"
    }, WibilongNarrow_jsx("div", {
      className: "flex px-px15"
    }, questions.map(function (q, i) {
      return WibilongNarrow_jsx("div", {
        className: "flex-none p-px10",
        key: q.id,
        style: boxStyles
      }, WibilongNarrow_jsx(TrackClick["a" /* TrackClick */], {
        as: "div",
        className: "bg-white cursor-pointer h-full p-px20 rounded shadow-md",
        "data-testid": "Wibilong-question",
        onClick: function onClick() {
          return update(i);
        },
        role: "button",
        tabIndex: 0,
        trackingData: q.trackingData
      }, WibilongNarrow_jsx(PostQuestion, Object(esm_extends["a" /* default */])({}, q, {
        className: "h-full",
        seeMoreLabel: !Object(lodash["isEmpty"])(q.answers) ? seeMoreLabel : ''
      }))));
    }), WibilongNarrow_jsx("div", {
      className: "pr-px15 pointer-events-none"
    }))), WibilongNarrow_jsx(SidePanel["a" /* SidePanel */], {
      ariaLabel: ariaLabel,
      ariaLabelledby: ariaLabelledby,
      className: "px-px15 py-px20",
      closeLabel: Object(src_i18n["h" /* t */])('common.close'),
      isExpanded: !Object(lodash["isEmpty"])(activeIndexes),
      onClose: clear
    }, !Object(lodash["isEmpty"])(activeIndexes) && WibilongNarrow_jsx("div", {
      className: "fadeIn"
    }, WibilongNarrow_jsx(PostQuestion, Object(esm_extends["a" /* default */])({}, questions[activeIndexes[0]], {
      className: "bg-white cursor-pointer flex-none m-px10 p-px20 rounded shadow-md",
      textLimit: -1,
      titleId: ariaLabelledby
    })), WibilongNarrow_jsx("div", {
      className: "border-t-1 mt-px30"
    }, !Object(lodash["isEmpty"])(answers) ? answers.map(function (answer) {
      return WibilongNarrow_jsx(PostAnswer, Object(esm_extends["a" /* default */])({}, answer, {
        className: "py-px30 border-b-1",
        key: answer.id
      }));
    }) : WibilongNarrow_jsx(Notification["a" /* Notification */], {
      className: "mt-px30",
      closeLabel: ariaLabel ? [Object(src_i18n["h" /* t */])('common.close'), ariaLabel].join(' - ') : '',
      hasBorder: true,
      hasClose: true,
      onClose: clear,
      text: noAnswerstext
    }), hasLinkAllQuestions && WibilongNarrow_jsx(WibilongCatchBlock_WibilongCatchBlock, {
      className: "mt-px30",
      button: button,
      link: linkAllQuestions,
      text: text
    })))));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/wibilong/Wibilong.jsx

var Wibilong_jsx = react_default.a.createElement;

















var Wibilong_scrollToQuestions = function scrollToQuestions(id) {
  return function () {
    Object(scrollToElement["a" /* scrollToElement */])("#".concat(id), 300, '.Line-PriceTicket');
  };
};

function Wibilong(props) {
  var button = props.button,
      className = props.className,
      hasLinkAllQuestions = props.hasLinkAllQuestions,
      icon = props.icon,
      _props$linkAllQuestio = props.linkAllQuestions,
      linkAllQuestions = _props$linkAllQuestio === void 0 ? {} : _props$linkAllQuestio,
      _props$questions = props.questions,
      questions = _props$questions === void 0 ? [] : _props$questions,
      text = props.text,
      title = props.title;

  if (Object(lodash["isEmpty"])(questions)) {
    return null;
  }

  var id = 'wibilong';
  var scrollTo = Wibilong_scrollToQuestions(id);
  return Wibilong_jsx("section", {
    className: classnames_default()(className, 'bg-white relative shadow-inner-top shadow-inner-bottom'),
    id: id
  }, Wibilong_jsx("div", {
    className: "absolute inset-0",
    style: {
      opacity: '0.05'
    }
  }, Wibilong_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].TURQUOISE,
    name: icon,
    width: "40rem"
  })), Wibilong_jsx("div", {
    className: "py-px30"
  }, Wibilong_jsx(responsiveContext["a" /* default */].Consumer, null, function (_ref) {
    var isTablet = _ref.isTablet,
        isDesktop = _ref.isDesktop;
    return Wibilong_jsx(react["Fragment"], null, (!!text || !!title) && Wibilong_jsx(SiteContainer["a" /* SiteContainer */], null, Wibilong_jsx("header", {
      className: "flex flex-col sm:flex-row items-center justify-end sm:px-px60 text-center sm:text-initial"
    }, !!text && Wibilong_jsx("div", {
      className: "flex flex-col sm:flex-row items-center sm:rtl:mr-auto w-full"
    }, Wibilong_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-px20",
      color: colors["a" /* COLORS */].BLUE,
      name: icons["a" /* ICONS */].COMMUNITY,
      width: isTablet ? '3.2rem' : '4rem'
    }), Wibilong_jsx(Text["a" /* Text */], {
      className: "mt-px15 sm:mt-0",
      theme: "text-sans-4",
      text: text
    })), !!title && Wibilong_jsx(Title["a" /* Title */], {
      className: "mt-px15 sm:mt-0 w-full",
      theme: isDesktop ? 'title-sans-9' : 'title-sans-4'
    }, title))), isTablet ? Wibilong_jsx(WibilongLarge, Object(esm_extends["a" /* default */])({}, props, {
      scrollTo: scrollTo
    })) : Wibilong_jsx(WibilongNarrow, props));
  }), Wibilong_jsx(SiteContainer["a" /* SiteContainer */], null, Wibilong_jsx("footer", {
    className: "flex flex-col items-center mt-px15"
  }, Wibilong_jsx(WibilongPopinButton_WibilongPopinButton, Object(esm_extends["a" /* default */])({
    className: "inline-block"
  }, button)), hasLinkAllQuestions && linkAllQuestions && linkAllQuestions.url && Wibilong_jsx(TrackClick["a" /* TrackClick */], Object(esm_extends["a" /* default */])({}, linkAllQuestions, {
    as: DynamicLink["a" /* default */],
    className: "font-bold mt-px15 mx-px30 text-md text-blue focus:text-turquoise hover:text-turquoise underline transition-color"
  }), linkAllQuestions.label)))));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-community-questions-line/productCommunityQuestionsLine.utils.js











function productCommunityQuestionsLine_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productCommunityQuestionsLine_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productCommunityQuestionsLine_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productCommunityQuestionsLine_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}





var DATE_FORMAT = 'D MMM YYYY';

function getTag(_ref) {
  var idx = _ref.idx,
      lastAnswerLabel = _ref.lastAnswerLabel;
  return idx === 0 ? {
    color: colors["a" /* COLORS */].WATER_GREEN,
    label: lastAnswerLabel
  } : null;
}

function mapAnswer(answers) {
  var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lastAnswerLabel = labels.lastAnswerLabel,
      usefullLabel = labels.usefullLabel;
  return answers.map(function (a, idx) {
    var tag = getTag({
      idx: idx,
      lastAnswerLabel: lastAnswerLabel
    });
    return productCommunityQuestionsLine_utils_objectSpread(productCommunityQuestionsLine_utils_objectSpread({
      id: a.id,
      author: a.authorName,
      date: Object(date_apiDate["e" /* formatApiDate */])(a.date, DATE_FORMAT),
      likesCount: a.likesCount,
      likesLabel: usefullLabel
    }, tag ? {
      tag: tag
    } : null), {}, {
      text: a.text
    });
  });
}

function mapQuestionsAndAnswers(props) {
  var bestAnswerLabel = props.bestAnswerLabel,
      lastAnswerLabel = props.lastAnswerLabel,
      usefullLabel = props.usefullLabel,
      _props$productCommuni = props.productCommunity.questions,
      questions = _props$productCommuni === void 0 ? [] : _props$productCommuni;
  var avatarsColors = [colors["a" /* COLORS */].AMBER, colors["a" /* COLORS */].OCHER, colors["a" /* COLORS */].PINE];
  return questions.sort(function (a, b) {
    return moment_default()(b.date, date_apiDate["a" /* API_DATE_FORMAT */]).toDate().getTime() - moment_default()(a.date, date_apiDate["a" /* API_DATE_FORMAT */]).toDate().getTime() || a.likesCount - b.likesCount;
  }).map(function (q, idx) {
    return {
      id: q.id,
      answers: mapAnswer(q.answers, {
        bestAnswerLabel: bestAnswerLabel,
        lastAnswerLabel: lastAnswerLabel,
        usefullLabel: usefullLabel
      }),
      answersCount: q.answersCount,
      author: {
        color: avatarsColors[idx % avatarsColors.length],
        name: q.authorName
      },
      date: Object(date_apiDate["e" /* formatApiDate */])(q.date, DATE_FORMAT),
      likesCount: q.likesCount,
      text: q.text,
      title: q.title,
      trackingData: {
        event: 'eventGA',
        categoryGA: 'resort',
        actionGA: 'wibilong',
        labelGA: 'seeAnswers',
        valueGA: '0',
        nonInteraction: '0'
      }
    };
  });
}

function mapCommunityQuestions(props) {
  var buttonLabel = props.buttonLabel,
      config = props.config,
      noAnswersLabel = props.noAnswersLabel,
      popinButton = props.popinButton,
      linkAllQuestionsUrl = props.productCommunity.linkAllQuestionsUrl,
      icon = props.resort.icon,
      seeAllQuestionsLabel = props.seeAllQuestionsLabel,
      seeMoreLabel = props.seeMoreLabel,
      text = props.text;
  return {
    button: productCommunityQuestionsLine_utils_objectSpread(productCommunityQuestionsLine_utils_objectSpread({
      label: buttonLabel
    }, popinButton), {}, {
      trackingData: {
        event: 'eventGA',
        categoryGA: 'resort',
        actionGA: 'wibilong',
        labelGA: 'askQuestion',
        valueGA: '0',
        nonInteraction: '0'
      }
    }),
    icon: icon,
    linkAllQuestions: linkAllQuestionsUrl ? {
      label: seeAllQuestionsLabel,
      target: '_blank',
      url: linkAllQuestionsUrl,
      trackingData: {
        event: 'eventGA',
        categoryGA: 'resort',
        actionGA: 'wibilong',
        labelGA: 'seeQuestion',
        valueGA: '0',
        nonInteraction: '0'
      }
    } : {},
    noAnswerstext: noAnswersLabel,
    questions: mapQuestionsAndAnswers(props),
    scrollBackwardLabel: Object(lodash["get"])(config, 'common.scrollBackward'),
    scrollForwardLabel: Object(lodash["get"])(config, 'common.scrollForward'),
    seeMoreLabel: seeMoreLabel,
    text: text
  };
}
// CONCATENATED MODULE: ./src/client/components/lines/product-community-questions-line/ProductCommunityQuestionsLine.jsx








var ProductCommunityQuestionsLine_jsx = react_default.a.createElement;

function ProductCommunityQuestionsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductCommunityQuestionsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductCommunityQuestionsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductCommunityQuestionsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var WIBILONG_ENABLED = config_default.a.get('social.wibilong.enabled');
var ProductCommunityQuestionsLine_ProductCommunityQuestionsLine = function ProductCommunityQuestionsLine(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isAppMounted = _useResponsive.isAppMounted;

  Object(src_i18n["a" /* addTranslationKeys */])(props.config);
  var hasCommunityQuestions = Boolean(props.productCommunity.questions.length);
  var isDisplayed = WIBILONG_ENABLED && isAppMounted && hasCommunityQuestions;

  if (!isDisplayed) {
    return null;
  }

  var popinButton = {
    country: appContext.country.toUpperCase(),
    language: appContext.language.toUpperCase(),
    productId: props.resortId
  };
  var communityQuestionsProps = mapCommunityQuestions(ProductCommunityQuestionsLine_objectSpread(ProductCommunityQuestionsLine_objectSpread({}, props), {}, {
    popinButton: popinButton
  }));
  return ProductCommunityQuestionsLine_jsx("div", {
    className: "Line"
  }, ProductCommunityQuestionsLine_jsx(Wibilong, communityQuestionsProps));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-community-questions/productCommunityQuestions.resolver.js
var productCommunityQuestions_resolver = __webpack_require__("bNYI");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-community-questions/productCommunityQuestions.descriptor.js



var productCommunityQuestionsDescriptor = {
  name: constants["M" /* PRODUCT_COMMUNITY_QUESTIONS */],
  component: ProductCommunityQuestionsLine_ProductCommunityQuestionsLine,
  resolve: productCommunityQuestions_resolver["a" /* productCommunityQuestionsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/frameworks/responsive-tabs/ResponsiveTabs.jsx + 1 modules
var ResponsiveTabs = __webpack_require__("QPCF");

// EXTERNAL MODULE: ./src/client/cms/toolkit/product-destination/productDestination.resolver.js
var productDestination_resolver = __webpack_require__("IpDy");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-destination/productDestination.descriptor.js




var productDestination_descriptor_jsx = react_default.a.createElement;












function renderArea(props) {
  var _props$resort = props.resort,
      _props$resort$name = _props$resort.name,
      title = _props$resort$name === void 0 ? '' : _props$resort$name,
      _props$resort$descrip = _props$resort.description,
      description = _props$resort$descrip === void 0 ? '' : _props$resort$descrip,
      productVideo = _props$resort.productVideo,
      _props$resort$strengt = _props$resort.strengths,
      strengths = _props$resort$strengt === void 0 ? [] : _props$resort$strengt;
  return productDestination_descriptor_jsx("div", {
    className: "sm:flex"
  }, productDestination_descriptor_jsx(Title["a" /* Title */], {
    className: "sm:w-1/4",
    theme: "title-sans-2"
  }, title), productDestination_descriptor_jsx("div", {
    className: "sm:w-3/4"
  }, productDestination_descriptor_jsx(Text["a" /* Text */], {
    text: description
  }), description ? productDestination_descriptor_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-px20 mx-0 p-0"
  }) : null, productDestination_descriptor_jsx("div", {
    className: "sm:flex"
  }, productDestination_descriptor_jsx("div", {
    className: "mb-px20 sm:rtl:mr-px20 sm:mb-0 sm:w-1/3"
  }, productDestination_descriptor_jsx(Image["b" /* default */], {
    imageUrl: productVideo,
    ratioKey: ratios_utils["a" /* default */].XL
  })), !Object(lodash["isEmpty"])(strengths) ? productDestination_descriptor_jsx("ul", {
    "data-testid": "Destination-strengths",
    className: "reset-list text-base sm:w-2/3"
  }, strengths.map(function (strength, index) {
    return productDestination_descriptor_jsx("li", {
      className: "list-disc",
      key: index
    }, strength);
  })) : null)));
}

function renderResponsiveTabsContent(content, id) {
  return content ? productDestination_descriptor_jsx(Text["a" /* Text */], {
    key: id,
    text: content
  }) : null;
}

function getResponsiveTabsItems(titles, practicalInformation) {
  var _titles$healthFormali = titles.healthFormalities,
      healthFormalities = _titles$healthFormali === void 0 ? '' : _titles$healthFormali,
      _titles$passportAndVi = titles.passportAndVisas,
      passportAndVisas = _titles$passportAndVi === void 0 ? '' : _titles$passportAndVi;
  return [{
    header: {
      iconName: icons["a" /* ICONS */].HEALTH,
      title: healthFormalities
    },
    content: [renderResponsiveTabsContent(practicalInformation.healthFormalities, 'health')]
  }, {
    header: {
      iconName: icons["a" /* ICONS */].PASSPORT,
      title: passportAndVisas
    },
    content: [renderResponsiveTabsContent(practicalInformation.passportAndVisas, 'passport')]
  }];
}

function hasResponsiveTabs(props) {
  return Object(lodash["get"])(props, 'resort.practicalInformation.healthFormalities', null) || Object(lodash["get"])(props, 'resort.practicalInformation.passportAndVisas', null);
}

var productDestination_descriptor_ProductDestinationsLine = function ProductDestinationsLine(props) {
  var healthFormalities = props.healthFormalities,
      passportAndVisas = props.passportAndVisas,
      resort = props.resort;
  var _resort$strengths = resort.strengths,
      strengths = _resort$strengths === void 0 ? [] : _resort$strengths;
  var shouldRenderArea = strengths.length > 0 || !!resort.productVideo;
  var description = Object(lodash["get"])(resort, 'destination.description', '');
  return productDestination_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productDestination_descriptor_jsx("div", {
    className: "pt-px20",
    "data-testid": "ProductInformationDestination"
  }, productDestination_descriptor_jsx("div", {
    className: "sm:flex"
  }, productDestination_descriptor_jsx(Title["a" /* Title */], {
    className: "sm:w-1/4 mb-px20",
    theme: "title-sans-2"
  }, Object(lodash["get"])(props, 'resort.destination.country', '')), productDestination_descriptor_jsx("div", {
    className: "sm:w-3/4"
  }, productDestination_descriptor_jsx(Text["a" /* Text */], {
    text: description
  }), hasResponsiveTabs(props) ? productDestination_descriptor_jsx(react["Fragment"], null, productDestination_descriptor_jsx(ResponsiveTabs["a" /* ResponsiveTabs */], {
    areAllCollapsable: true,
    className: "mt-px20",
    expandIconName: icons["a" /* ICONS */].PLUS,
    items: getResponsiveTabsItems({
      healthFormalities: healthFormalities,
      passportAndVisas: passportAndVisas
    }, Object(lodash["get"])(props, 'resort.practicalInformation'))
  }), productDestination_descriptor_jsx("hr", {
    className: "block border-0 border-solid border-gray-light border-t-1 h-px my-px20 mx-0 p-0"
  })) : null)), shouldRenderArea ? renderArea(props) : null));
};

var productDestinationDescriptor = {
  name: constants["gb" /* RESORT_DESTINATION */],
  component: productDestination_descriptor_ProductDestinationsLine,
  resolve: productDestination_resolver["a" /* productDestinationResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-exclusive-collection-space/ProductExclusiveCollectionSpace.jsx
var ProductExclusiveCollectionSpace_jsx = react_default.a.createElement;











var ProductExclusiveCollectionSpace_ProductExclusiveCollectionSpace = function ProductExclusiveCollectionSpace(_ref) {
  var mediaUrl = _ref.mediaUrl,
      text = _ref.text,
      title = _ref.title;
  return ProductExclusiveCollectionSpace_jsx("article", {
    className: "flex"
  }, ProductExclusiveCollectionSpace_jsx("div", {
    className: "text-center md:text-initial md:w-1/2 md:rtl:pr-px30 pt-px20 md:pt-px60"
  }, ProductExclusiveCollectionSpace_jsx("div", {
    style: {
      width: '10rem'
    },
    className: "m-auto md:m-0"
  }, ProductExclusiveCollectionSpace_jsx(ImagePlaceholder["a" /* ImagePlaceholder */], {
    aspectRatio: 100 * ratios_utils["a" /* default */].VALUES[ratios_utils["a" /* default */].XL]
  }, ProductExclusiveCollectionSpace_jsx("span", {
    className: "flex items-center justify-center h-full text-blue"
  }, ProductExclusiveCollectionSpace_jsx(Icon["a" /* Icon */], {
    className: "mb-px20",
    color: colors["a" /* COLORS */].DEEP_BLUE,
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_EXCLUSIVE,
    width: "10rem"
  })))), ProductExclusiveCollectionSpace_jsx(Title["a" /* Title */], {
    theme: "title-serif-1",
    className: "md:max-w-4/5 pt-px15"
  }, Object(string_util["d" /* truncate */])(title, 60)), ProductExclusiveCollectionSpace_jsx(TextSeeMore["a" /* TextSeeMore */], {
    className: "mt-px20 max-w-9/10",
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    seeMoreSize: 110,
    text: text,
    theme: "text-sans-3"
  })), ProductExclusiveCollectionSpace_jsx("div", {
    className: "hidden md:block h-full inset-border-after mb-px60 sm:mb-0 w-1/2"
  }, ProductExclusiveCollectionSpace_jsx(Image["b" /* default */], {
    imageUrl: mediaUrl,
    ratioKey: ratios_utils["a" /* default */].R_13_BY_12,
    ratioDisplay: 1 / 2
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-exclusive-collection-space-line/ProductExclusiveCollectionSpaceLine.jsx
var ProductExclusiveCollectionSpaceLine_jsx = react_default.a.createElement;




function ProductExclusiveCollectionSpaceLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      mediaUrl = _ref.mediaUrl,
      text = _ref.text,
      title = _ref.title;
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  return ProductExclusiveCollectionSpaceLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line",
    size: "medium"
  }, ProductExclusiveCollectionSpaceLine_jsx(ProductExclusiveCollectionSpace_ProductExclusiveCollectionSpace, {
    mediaUrl: mediaUrl,
    text: text,
    title: title
  }));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-exclusive-collection-space/productExclusiveCollectionSpace.resolver.js



var productExclusiveCollectionSpaceResolver = {
  name: constants["N" /* PRODUCT_EXCLUSIVE_COLLECTION_SPACE */],
  resolve: function resolve(appContext) {
    var query = "query {\n      config {\n        common {\n          viewMore\n          loadLess\n        }\n      }\n    }";
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["dc" /* LINE_PRODUCT_EXCLUSIVE_COLLECTION_SPACE */],
      strictErrors: false
    });
  }
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-exclusive-collection-space/productExclusiveCollectionSpace.descriptor.js



var productExclusiveCollectionSpaceDescriptor = {
  name: constants["N" /* PRODUCT_EXCLUSIVE_COLLECTION_SPACE */],
  component: ProductExclusiveCollectionSpaceLine,
  resolver: productExclusiveCollectionSpaceResolver.resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-flash-info-line/ProductFlashInfoLine.jsx


var ProductFlashInfoLine_jsx = react_default.a.createElement;





var ProductFlashInfoLine_ProductFlashInfoLine = function ProductFlashInfoLine(_ref) {
  var close = _ref.config.common.close,
      editorialZone = _ref.editorialZone,
      id = _ref.id,
      seeMore = _ref.seeMore,
      title = _ref.title;

  if (!editorialZone) {
    return null;
  }

  var image = editorialZone.image,
      link = editorialZone.link,
      texts = editorialZone.texts;

  var _texts = Object(slicedToArray["a" /* default */])(texts, 3),
      _texts$ = _texts[0],
      headingTitle = _texts$ === void 0 ? '' : _texts$,
      _texts$2 = _texts[1],
      headingSubtitle = _texts$2 === void 0 ? '' : _texts$2,
      _texts$3 = _texts[2],
      text = _texts$3 === void 0 ? '' : _texts$3;

  return ProductFlashInfoLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductFlashInfoLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductFlashInfoLine_jsx(Card["a" /* Card */], {
    closeLabel: close,
    ctaLabel: seeMore,
    heading: {
      title: headingTitle,
      subtitle: headingSubtitle
    },
    link: {
      url: link
    },
    media: {
      alt: headingTitle,
      ratioKey: ratios_utils["a" /* default */].XS,
      url: image
    },
    text: {
      seeMoreLabel: seeMore,
      text: text
    }
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-flash-info/productFlashInfo.resolver.js
var productFlashInfo_resolver = __webpack_require__("YbGu");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-flash-info/productFlashInfo.descriptor.js



var productFlashInfoDescriptor = {
  name: constants["hb" /* RESORT_FLASH_INFO */],
  component: ProductFlashInfoLine_ProductFlashInfoLine,
  resolve: productFlashInfo_resolver["a" /* productFlashInfoResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-google-street-view-line/ProductGoogleStreetViewLine.jsx


var ProductGoogleStreetViewLine_jsx = react_default.a.createElement;





var ProductGoogleStreetViewLine_ProductGoogleStreetViewLine = function ProductGoogleStreetViewLine(_ref) {
  var _ref$config$common = _ref.config.common,
      close = _ref$config$common.close,
      productGoogleStreetView = _ref$config$common.maps.productGoogleStreetView,
      id = _ref.id,
      _ref$resort = _ref.resort,
      name = _ref$resort.name,
      streetView = _ref$resort.streetView;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var ratio = isTablet ? {
    w: 1280,
    h: 240
  } : {
    w: 852,
    h: 340
  };
  return ProductGoogleStreetViewLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, ProductGoogleStreetViewLine_jsx(GoogleStreetView, Object(esm_extends["a" /* default */])({}, streetView, {
    closeLabel: close,
    height: ratio.h,
    title: Object(dist["messageFormat"])(productGoogleStreetView).format({
      name: name
    }),
    width: ratio.w
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-google-street-view/productGoogleStreetView.resolver.js
var productGoogleStreetView_resolver = __webpack_require__("muDs");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-google-street-view/productGoogleStreetView.descriptor.js




var productGoogleStreetViewDescriptor = {
  name: constants["V" /* PRODUCT_STREET_VIEW */],
  component: ProductGoogleStreetViewLine_ProductGoogleStreetViewLine,
  resolve: productGoogleStreetView_resolver["a" /* productGoogleStreetViewResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-image-map-line/ProductImageMapLine.jsx


var ProductImageMapLine_jsx = react_default.a.createElement;






var ProductImageMapLine_ProductImageMapLine = function ProductImageMapLine(_ref) {
  var _ref$mapMobileDimensi = _ref.mapMobileDimensions,
      mapMobileDimensions = _ref$mapMobileDimensi === void 0 ? {
    w: 600,
    h: 500
  } : _ref$mapMobileDimensi,
      _ref$mapTabletRatio = _ref.mapTabletRatio,
      mapTabletRatio = _ref$mapTabletRatio === void 0 ? ratios_utils["a" /* default */].S : _ref$mapTabletRatio,
      _ref$resort = _ref.resort,
      resort = _ref$resort === void 0 ? {} : _ref$resort,
      title = _ref.title;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var altMsg = resort.name,
      imageUrl = resort.mapUrl;
  if (!imageUrl) return null;
  var map = {
    altMsg: altMsg,
    imageUrl: imageUrl
  };
  var mapConf = isTablet ? {
    ratioKey: mapTabletRatio,
    transformation: 'resize'
  } : {
    dimensions: mapMobileDimensions
  };
  return ProductImageMapLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-ProductImageMap"
  }, ProductImageMapLine_jsx(Title["a" /* Title */], {
    className: "mb-px30",
    theme: "title-sans-4"
  }, title), ProductImageMapLine_jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({}, map, mapConf)));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-image-map/productImageMap.resolver.js
var productImageMap_resolver = __webpack_require__("+MSq");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-image-map/productImageMap.descriptor.js



var productImageMapDescriptor = {
  name: constants["O" /* PRODUCT_IMAGE_MAP */],
  component: ProductImageMapLine_ProductImageMapLine,
  resolve: productImageMap_resolver["a" /* productImageMapResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/item/ImmersiveSlideShowItem.jsx
var ImmersiveSlideShowItem_jsx = react_default.a.createElement;



var ImmersiveSlideShowItem_ImmersiveSlideShowItem = function ImmersiveSlideShowItem(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      hasInsetBorder = _ref.hasInsetBorder,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$insetBorderOffse = _ref.insetBorderOffset,
      insetBorderOffset = _ref$insetBorderOffse === void 0 ? 0 : _ref$insetBorderOffse,
      src = _ref.src;
  return ImmersiveSlideShowItem_jsx("div", {
    className: classnames_default()(className, 'relative'),
    key: src
  }, ImmersiveSlideShowItem_jsx(Hero["a" /* Hero */], {
    alt: alt,
    size: immersiveSize,
    url: src
  }), hasInsetBorder && ImmersiveSlideShowItem_jsx("div", {
    className: "absolute bottom-0 fadeIn h-full inset-border inset-x-0 pointer-events-none",
    style: {
      height: "calc(100% - ".concat(insetBorderOffset, "px)")
    }
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/hero/heroUtils.js
var heroUtils = __webpack_require__("5xkM");

// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/controls/ImmersiveSlideShowControls.jsx
var ImmersiveSlideShowControls_jsx = react_default.a.createElement;



var ImmersiveSlideShowControls_ImmersiveSlideShowControls = function ImmersiveSlideShowControls(_ref) {
  var className = _ref.className,
      style = _ref.style,
      isNextDisabled = _ref.isNextDisabled,
      isPrevDisabled = _ref.isPrevDisabled,
      nextLabel = _ref.nextLabel,
      onNext = _ref.onNext,
      onPrev = _ref.onPrev,
      previousLabel = _ref.previousLabel;
  return ImmersiveSlideShowControls_jsx("div", {
    className: classnames_default()(className, 'absolute flex items-center justify-between max-w-site m-auto inset-0 pointer-events-none w-full'),
    style: style
  }, !isPrevDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: "rtl:ml-px10 lg:rtl:ml-0 rtl:mr-auto pointer-events-auto shadow-sm z-1",
    label: previousLabel,
    onClick: onPrev
  }), !isNextDisabled && ImmersiveSlideShowControls_jsx(ArrowButton["a" /* ArrowButton */], {
    className: "rtl:mr-px10 lg:rtl:mr-0 rtl:ml-auto pointer-events-auto shadow-sm z-1",
    label: nextLabel,
    onClick: onNext,
    rotation: 180
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/large/ImmersiveSlideShowLarge.jsx



var ImmersiveSlideShowLarge_jsx = react_default.a.createElement;





var getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).map(function (_, idx) {
    return idx === length - 1 || idx < 2;
  });
};

var ImmersiveSlideShowLarge_ImmersiveSlideShowLarge = function ImmersiveSlideShowLarge(_ref) {
  var className = _ref.className,
      _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) return;
    var newDisplayedIndex = displayedIndex.map(function (isDisplayed, idx) {
      return isDisplayed || idx === activeIndex + 1 || idx === activeIndex - 1;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  var increase = function increase() {
    activeIndex === items.length - 1 ? setActiveIndex(0) : setActiveIndex(activeIndex + 1);
  };

  var decrease = function decrease() {
    activeIndex === 0 ? setActiveIndex(items.length - 1) : setActiveIndex(activeIndex - 1);
  };

  var _getHeroDimensions = Object(heroUtils["f" /* getHeroDimensions */])(immersiveSize, true),
      height = _getHeroDimensions.height;

  return ImmersiveSlideShowLarge_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden relative'),
    style: {
      height: height
    }
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowLarge_jsx("div", {
      "aria-hidden": idx !== activeIndex,
      className: classnames_default()('absolute inset-0 transition-opacity-long', {
        'opacity-100': idx === activeIndex,
        'opacity-0': idx !== activeIndex
      }),
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  }), items.length > 1 && ImmersiveSlideShowLarge_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    nextLabel: nextLabel,
    onNext: increase,
    onPrev: decrease,
    previousLabel: previousLabel
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/narrow/ImmersiveSlideShowNarrow.jsx



var ImmersiveSlideShowNarrow_jsx = react_default.a.createElement;





var PRELOADED_ITEMS_NB = 3;

var ImmersiveSlideShowNarrow_getInitialDisplayedIndex = function getInitialDisplayedIndex(length) {
  return Array(length).fill(false).fill(true, 0, PRELOADED_ITEMS_NB);
};

var ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow = function ImmersiveSlideShowNarrow(_ref) {
  var className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      nextLabel = _ref.nextLabel,
      previousLabel = _ref.previousLabel;

  var _useState = Object(react["useState"])(0),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var _useState2 = Object(react["useState"])(ImmersiveSlideShowNarrow_getInitialDisplayedIndex(items.length)),
      displayedIndex = _useState2[0],
      setDisplayedIndex = _useState2[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isRTL = _useResponsive.isRTL;

  var coef = isRTL ? -1 : 1;
  var containerRef = Object(react["useRef"])(null);

  var scroll = function scroll(index, e) {
    if (e) {
      e.preventDefault();
    }

    if (containerRef && containerRef.current) {
      containerRef.current.scrollTo({
        behavior: 'smooth',
        left: coef * containerRef.current.scrollWidth * (index / items.length)
      });
    }

    setActiveIndex(index);
  };

  var onScroll = Object(lodash["debounce"])(function () {
    if (containerRef && containerRef.current) {
      var pos = Math.round(coef * containerRef.current.scrollLeft / containerRef.current.scrollWidth * items.length);
      setActiveIndex(pos);
    }
  }, 150);
  Object(react["useEffect"])(function () {
    // $FlowFixMe
    containerRef.current.addEventListener('scroll', onScroll);
    return function () {
      // $FlowFixMe
      containerRef.current.removeEventListener('scroll', onScroll);
    };
  }, [coef]);
  Object(react["useEffect"])(function () {
    if (displayedIndex.every(Boolean)) return;
    var newDisplayedIndex = displayedIndex.map(function (_, idx) {
      return idx < activeIndex + PRELOADED_ITEMS_NB;
    });
    setDisplayedIndex(newDisplayedIndex);
  }, [activeIndex]);

  if (!items.length) {
    return null;
  }

  return ImmersiveSlideShowNarrow_jsx("div", {
    className: classnames_default()(className, 'overflow-hidden relative')
  }, ImmersiveSlideShowNarrow_jsx("div", {
    className: classnames_default()(className, 'flex flex-row flex-no-wrap overflow-auto scroll-snap-type-x-mandatory w-full'),
    dir: isRTL ? 'rtl' : 'ltr',
    ref: containerRef
  }, items.map(function (item, idx) {
    return ImmersiveSlideShowNarrow_jsx("div", {
      className: "flex-none overflow-visible scroll-snap-align-center w-full",
      key: idx,
      tabIndex: -1
    }, displayedIndex[idx] ? item : null);
  })), items.length > 1 && ImmersiveSlideShowNarrow_jsx(ImmersiveSlideShowControls_ImmersiveSlideShowControls, {
    className: isRTL ? 'rotate-180' : '',
    isNextDisabled: isRTL ? activeIndex === 0 : activeIndex === items.length - 1,
    isPrevDisabled: isRTL ? activeIndex === items.length - 1 : activeIndex === 0,
    nextLabel: nextLabel,
    onNext: function onNext(e) {
      return scroll(activeIndex + coef, e);
    },
    onPrev: function onPrev(e) {
      return scroll(activeIndex - coef, e);
    },
    previousLabel: previousLabel,
    style: {
      bottom: '50px'
    }
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx



var ImmersiveSlideShow_jsx = react_default.a.createElement;






var ImmersiveSlideShow_ImmersiveSlideShow = function ImmersiveSlideShow(_ref) {
  var _ref$immersiveSize = _ref.immersiveSize,
      immersiveSize = _ref$immersiveSize === void 0 ? 'large' : _ref$immersiveSize,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      nextLabel = _ref.nextLabel,
      _ref$pictureAltLabel = _ref.pictureAltLabel,
      pictureAltLabel = _ref$pictureAltLabel === void 0 ? '' : _ref$pictureAltLabel,
      previousLabel = _ref.previousLabel,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["immersiveSize", "media", "nextLabel", "pictureAltLabel", "previousLabel"]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!media.length) {
    return null;
  }

  var items = media.map(function (src, idx) {
    return ImmersiveSlideShow_jsx(ImmersiveSlideShowItem_ImmersiveSlideShowItem, Object(esm_extends["a" /* default */])({}, rest, {
      alt: Object(dist["messageFormat"])(pictureAltLabel).format({
        nb: idx + 1
      }),
      immersiveSize: immersiveSize,
      key: src,
      src: src
    }));
  });
  return isDesktop ? ImmersiveSlideShow_jsx(ImmersiveSlideShowLarge_ImmersiveSlideShowLarge, {
    items: items,
    immersiveSize: immersiveSize,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  }) : ImmersiveSlideShow_jsx(ImmersiveSlideShowNarrow_ImmersiveSlideShowNarrow, {
    items: items,
    nextLabel: nextLabel,
    previousLabel: previousLabel
  });
};
// EXTERNAL MODULE: ./src/client/components/widgets/exclusive-collection-badge/ECBadge.jsx
var ECBadge = __webpack_require__("Itgl");

// CONCATENATED MODULE: ./src/client/components/widgets/product-immersive/product-immersive-narrow/ProductImmersiveNarrow.jsx

var ProductImmersiveNarrow_jsx = react_default.a.createElement;







var ICONS_HEIGHT = 27;
var ProductImmersiveNarrow_ProductImmersiveNarrow = function ProductImmersiveNarrow(_ref) {
  var _ref$badgeIcon = _ref.badgeIcon,
      badgeIcon = _ref$badgeIcon === void 0 ? {} : _ref$badgeIcon,
      hasInsetBorder = _ref.hasInsetBorder,
      hasECLogo = _ref.hasECLogo,
      infos = _ref.infos,
      media = _ref.media,
      nextLabel = _ref.nextLabel,
      pictureAltLabel = _ref.pictureAltLabel,
      previousLabel = _ref.previousLabel,
      size = _ref.size,
      title = _ref.title;
  return ProductImmersiveNarrow_jsx(react["Fragment"], null, ProductImmersiveNarrow_jsx("div", {
    className: "fadeInLong bg-white flex items-start p-px5 py-px10 w-full z-2",
    style: {
      marginTop: Navigation_constants["e" /* heights */].NAVIGATION_NARROW_HEIGHT
    }
  }, ProductImmersiveNarrow_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, badgeIcon, {
    className: "mx-px5 rounded-tiny",
    size: ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && ProductImmersiveNarrow_jsx("span", {
    className: "font-brand leading-none self-center text-sm"
  }, "&"), hasECLogo && ProductImmersiveNarrow_jsx(ECBadge["a" /* ECBadge */], {
    className: "mx-px5",
    height: ICONS_HEIGHT
  }), ProductImmersiveNarrow_jsx("div", {
    className: "mx-px5 flex-1"
  }, ProductImmersiveNarrow_jsx(Title["a" /* Title */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    className: "font-brand leading-one text-md w-full",
    hLevel: 1,
    theme: "none"
  }, ProductImmersiveNarrow_jsx("div", {
    "data-testid": "ProductImmersiveNarrow-title"
  }, title), !!(infos === null || infos === void 0 ? void 0 : infos.length) && ProductImmersiveNarrow_jsx("div", {
    className: "flex"
  }, ProductImmersiveNarrow_jsx("div", {
    className: "rtl:mr-px5 font-brand leading-one text-sm text-gray-dark uppercase",
    "data-testid": "ProductImmersiveNarrow-info"
  }, infos[0]))))), ProductImmersiveNarrow_jsx("div", {
    className: "relative"
  }, ProductImmersiveNarrow_jsx(ImmersiveSlideShow_ImmersiveSlideShow, {
    hasInsetBorder: hasInsetBorder,
    immersiveSize: size,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-immersive/ProductImmersive.jsx

var ProductImmersive_jsx = react_default.a.createElement;







var ProductImmersive_ProductImmersive = function ProductImmersive(_ref) {
  var badgeIcon = _ref.badgeIcon,
      className = _ref.className,
      closeLabel = _ref.closeLabel,
      galleryLabel = _ref.galleryLabel,
      hasInsetBorder = _ref.hasInsetBorder,
      hasECLogo = _ref.hasECLogo,
      id = _ref.id,
      _ref$infos = _ref.infos,
      infos = _ref$infos === void 0 ? [] : _ref$infos,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? [] : _ref$media,
      multimedia = _ref.multimedia,
      multimediaLabels = _ref.multimediaLabels,
      nextLabel = _ref.nextLabel,
      openGalleryLabel = _ref.openGalleryLabel,
      pictureAltLabel = _ref.pictureAltLabel,
      previousLabel = _ref.previousLabel,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      title = _ref.title;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!media.length) {
    return null;
  }

  var multimediaStyle = isDesktop ? {
    bottom: '45px'
  } : {
    bottom: '80px'
  };
  return ProductImmersive_jsx("div", Object(esm_extends["a" /* default */])({
    className: classnames_default()('relative', className)
  }, id ? {
    id: id
  } : null), isDesktop ? ProductImmersive_jsx(ImmersiveSlideShow_ImmersiveSlideShow, {
    hasInsetBorder: hasInsetBorder,
    immersiveSize: size,
    insetBorderOffset: Navigation_constants["e" /* heights */].NAVIGATION_LARGE_HEIGHT,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  }) : ProductImmersive_jsx(ProductImmersiveNarrow_ProductImmersiveNarrow, {
    badgeIcon: badgeIcon,
    hasECLogo: hasECLogo,
    hasInsetBorder: hasInsetBorder,
    infos: infos,
    media: media,
    nextLabel: nextLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel,
    size: size,
    title: title
  }), ProductImmersive_jsx("div", {
    className: "absolute w-full",
    style: multimediaStyle
  }, ProductImmersive_jsx(Multimedia["a" /* Multimedia */], {
    closeLabel: closeLabel,
    galleryLabel: galleryLabel,
    isOverlay: true,
    labels: multimediaLabels,
    medias: multimedia,
    nextLabel: nextLabel,
    openGalleryLabel: openGalleryLabel,
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-immersive-line/ProductImmersiveLine.jsx









var ProductImmersiveLine_jsx = react_default.a.createElement;

function ProductImmersiveLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductImmersiveLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductImmersiveLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductImmersiveLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ProductImmersiveLine_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;

var getProductInfos = function getProductInfos(_ref) {
  var dateRange = _ref.dateRange,
      duration = _ref.duration,
      _ref$destination = _ref.destination,
      destination = _ref$destination === void 0 ? {} : _ref$destination,
      fromToDestination = _ref.fromToDestination,
      type = _ref.type;
  var country = destination.country,
      area = destination.area;

  switch (type) {
    case ProductImmersiveLine_PRODUCT_TYPES.TOUR:
      return [duration].filter(Boolean);

    case ProductImmersiveLine_PRODUCT_TYPES.CRUISE:
      return [fromToDestination, dateRange].filter(Boolean);

    default:
      return [country, area].filter(Boolean);
  }
};

var ProductImmersiveLine_ProductImmersiveLine = function ProductImmersiveLine(_ref2) {
  var config = _ref2.config,
      cruise = _ref2.cruise,
      id = _ref2.id,
      media = _ref2.media,
      resort = _ref2.resort,
      socialPictures = _ref2.socialPictures;

  var _ref3 = resort || {},
      _ref3$images = _ref3.images,
      images = _ref3$images === void 0 ? [] : _ref3$images,
      isExclusiveCollection = _ref3.isExclusiveCollection,
      isExplicitEC = _ref3.isExplicitEC,
      name = _ref3.name;

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var galleryLabel = name ? Object(src_i18n["h" /* t */])('common.galleries.productGallery', {
    productName: name
  }) : Object(src_i18n["h" /* t */])('common.galleries.gallery');
  var nextLabel = name ? Object(src_i18n["h" /* t */])('common.galleries.productNextPicture', {
    productName: name
  }) : Object(src_i18n["h" /* t */])('common.next');
  var previousLabel = name ? Object(src_i18n["h" /* t */])('common.galleries.productPreviousPicture', {
    productName: name
  }) : Object(src_i18n["h" /* t */])('common.previous');
  var pictureAltLabel = Object(src_i18n["h" /* t */])('common.galleries.productPictureItem', {
    total: images.length,
    productName: name
  });
  return ProductImmersiveLine_jsx(ProductImmersive_ProductImmersive, {
    badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(resort),
    className: "Line Line-Immersive",
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    galleryLabel: galleryLabel,
    hasECLogo: isExplicitEC,
    hasInsetBorder: isExclusiveCollection,
    id: id,
    infos: getProductInfos(ProductImmersiveLine_objectSpread(ProductImmersiveLine_objectSpread({}, resort), cruise)),
    media: images,
    multimedia: ProductImmersiveLine_objectSpread(ProductImmersiveLine_objectSpread({}, media), {}, {
      socialPictures: socialPictures
    }),
    multimediaLabels: {
      photos: Object(src_i18n["h" /* t */])('common.photoTitle'),
      socialPictures: Object(src_i18n["h" /* t */])('common.socialPicturesTitle'),
      videos: Object(src_i18n["h" /* t */])('common.videoTitle'),
      videos360: Object(src_i18n["h" /* t */])('common.video360Title')
    },
    nextLabel: nextLabel,
    openGalleryLabel: Object(src_i18n["h" /* t */])('common.galleries.openSlideShowGallery'),
    pictureAltLabel: pictureAltLabel,
    previousLabel: previousLabel,
    title: name
  });
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-immersive/productImmersive.resolver.js
var productImmersive_resolver = __webpack_require__("AaDX");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-immersive/productImmersive.descriptor.js



var productImmersiveDescriptor = {
  name: constants["P" /* PRODUCT_IMMERSIVE */],
  component: ProductImmersiveLine_ProductImmersiveLine,
  resolve: productImmersive_resolver["a" /* productImmersiveResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-information-summary-line/ProductInformationSummaryLine.jsx
var ProductInformationSummaryLine_jsx = react_default.a.createElement;



function ProductInformationSummaryLine(_ref) {
  var downloadLabel = _ref.downloadLabel,
      id = _ref.id,
      factSheetUrl = _ref.resort.factSheetUrl,
      resortId = _ref.resortId,
      text = _ref.text;

  if (!factSheetUrl) {
    return null;
  }

  var links = [{
    label: downloadLabel,
    target: '_blank',
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'CTA_download_factsheet',
      labelGA: resortId
    },
    url: factSheetUrl
  }];
  return ProductInformationSummaryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line Line-DownloadLinksList"
  }, ProductInformationSummaryLine_jsx(DownloadLinksList, {
    className: "bg-white py-px20 shadow-bottom",
    links: links,
    text: text
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-information-summary/productInformationSummary.resolver.js
var productInformationSummary_resolver = __webpack_require__("C2l2");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-information-summary/productInformationSummary.descriptor.js



var productInformationSummaryDescriptor = {
  name: constants["Q" /* PRODUCT_INFORMATION_SUMMARY */],
  component: ProductInformationSummaryLine,
  resolve: productInformationSummary_resolver["a" /* productInformationSummaryResolver */].resolve
};
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("Ee2X");

// CONCATENATED MODULE: ./src/client/components/widgets/social-pictures-grid/SocialPicturesGrid.utils.js









function SocialPicturesGrid_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function SocialPicturesGrid_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      SocialPicturesGrid_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      SocialPicturesGrid_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var smallPictureStyle = {
  width: 'calc(50% - 8px)',
  display: 'inline-flex',
  flexGrow: '0'
};

var smallPictureOnTopStyle = SocialPicturesGrid_utils_objectSpread(SocialPicturesGrid_utils_objectSpread({}, smallPictureStyle), {}, {
  marginBottom: '16px',
  alignSelf: 'flex-end'
});

var smallPictureOnBottomStyle = SocialPicturesGrid_utils_objectSpread(SocialPicturesGrid_utils_objectSpread({}, smallPictureStyle), {}, {
  marginTop: '16px',
  alignSelf: 'flex-start'
});

function getSocialPictureGridLayout(length) {
  var styles = [];

  if (length < 9) {
    styles.push([{}, smallPictureOnBottomStyle, smallPictureOnBottomStyle]);
    styles.push([{}, smallPictureOnBottomStyle, smallPictureOnBottomStyle]);
    styles.push([smallPictureOnTopStyle, smallPictureOnTopStyle, {}]); // see, I wrote a nifty lil' thang back in the day (below), but now we've got
    // to make our component be pretty with less than the ideal number of pictures
    // so we ain't relying on anything random unless we're at 9 pictures because,
    // well, there aren't that many ways to make 5 pictures look great on 3 columns,
    // so for every other case, we're hardcoding these styles
  }

  for (var i = 0; i < 3; i++) {
    if (Math.random() > 0.5) {
      // just to spice it up a little, either we're returning styles for
      // picture(small, small, big) or picture(big, small, small) because
      // predictibility is overrated and truth is only hearsay
      styles.push([smallPictureOnTopStyle, smallPictureOnTopStyle, {}]);
    }

    styles.push([{}, smallPictureOnBottomStyle, smallPictureOnBottomStyle]);
  }

  return styles;
}
// CONCATENATED MODULE: ./src/client/components/widgets/social-pictures-grid/SocialPicturesGrid.jsx











var SocialPicturesGrid_jsx = react_default.a.createElement;

function SocialPicturesGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function SocialPicturesGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { SocialPicturesGrid_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { SocialPicturesGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var fillUpScheme = {
  // hardcoding how we're filling the grid depending on how many pictures we have
  // is this the best way to do it? idk but It Works™
  // note: if we had the precise dimensions of the pictures beforehand we actually
  // could build a much more powerful layout engine but maybe that'd be overkill?
  '5': [1, 0, 1, 1, 0, 0, 1, 0, 1],
  '6': [1, 0, 1, 1, 1, 0, 1, 0, 1],
  '7': [1, 0, 1, 1, 1, 1, 1, 0, 1],
  '8': [1, 1, 1, 1, 1, 1, 1, 0, 1],
  '9': [1, 1, 1, 1, 1, 1, 1, 1, 1]
};
var SocialPicturesGrid_SocialPicturesGrid = function SocialPicturesGrid(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var _props$pictures = props.pictures,
      pictures = _props$pictures === void 0 ? [] : _props$pictures;
  var numberOfPictures = pictures.length;
  var imageStyles = getSocialPictureGridLayout(numberOfPictures);

  if (Object(lodash["isEmpty"])(pictures)) {
    return null;
  }

  var paddedPictures = pictures.slice(0);
  var currentFillUpScheme = fillUpScheme[numberOfPictures];

  for (var i = 0; i < currentFillUpScheme.length; i++) {
    if (currentFillUpScheme[i] === 0) {
      paddedPictures.splice(i, 0, {});
    }
  }

  var MAX_NUMBER_OF_COLUMNS = isTablet ? 3 : 1;
  var formattedArray = [];

  for (var column = 0; column < MAX_NUMBER_OF_COLUMNS; column++) {
    var subArray = [];

    for (var item = 0; item < 3; item++) {
      if (isTablet) {
        subArray.push(paddedPictures[item + column * 3]);
      } else {
        subArray.push(pictures[item + column * 3]);
      }
    }

    formattedArray.push(subArray);
  }

  return SocialPicturesGrid_jsx("div", {
    className: "flex justify-center -mx-px10"
  }, formattedArray.map(function (array, primaryArrayIndex) {
    var currentImageStyles = imageStyles[primaryArrayIndex];
    return SocialPicturesGrid_jsx("div", {
      className: "flex flex-wrap self-center justify-between px-px10 sm:w-1/3",
      key: primaryArrayIndex
    }, array.map(function (picture, secondaryArrayIndex) {
      return Object(lodash["isEmpty"])(picture) ? SocialPicturesGrid_jsx("div", {
        style: SocialPicturesGrid_objectSpread({
          borderRadius: '2px',
          width: '100%'
        }, currentImageStyles[secondaryArrayIndex])
      }) : SocialPicturesGrid_jsx("div", {
        className: "overflow-hidden",
        "data-testid": "SocialPicturesGrid-thumbnail",
        key: picture.src,
        style: SocialPicturesGrid_objectSpread({
          borderRadius: '2px',
          width: '100%'
        }, currentImageStyles[secondaryArrayIndex])
      }, SocialPicturesGrid_jsx(SocialPicture["a" /* SocialPicture */], {
        src: picture.src,
        userName: picture.userName
      }));
    }));
  }));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-instagram-line/ProductInstagramLine.jsx

var ProductInstagramLine_jsx = react_default.a.createElement;





var MIN_PICTURES_TO_SHOW = 5;
var MAX_PICTURES_TO_SHOW = 9;
var ProductInstagramLine_ProductInstagramLine = function ProductInstagramLine(_ref) {
  var _ref$socialPictures = _ref.socialPictures,
      socialPictures = _ref$socialPictures === void 0 ? [] : _ref$socialPictures,
      title = _ref.title;

  if (socialPictures.length < MIN_PICTURES_TO_SHOW) {
    return null;
  }

  var pictures = Object(lodash["slice"])(socialPictures, 0, MAX_PICTURES_TO_SHOW).map(function (_ref2) {
    var imageLarge = _ref2.imageLarge,
        imageSmall = _ref2.imageSmall,
        userName = _ref2.userName,
        canonicalUrl = _ref2.canonicalUrl;
    return {
      src: imageLarge,
      thumbnailSrc: imageSmall,
      canonicalUrl: canonicalUrl,
      userName: userName
    };
  });
  return ProductInstagramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    size: "medium"
  }, ProductInstagramLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductInstagramLine_jsx(SocialPicturesGrid_SocialPicturesGrid, {
    pictures: pictures
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-instagram/productInstagram.resolver.js
var productInstagram_resolver = __webpack_require__("eaHo");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-instagram/productInstagram.descriptor.js



var productInstagramDescriptor = {
  name: constants["t" /* INSTAGRAM_GRID */],
  component: ProductInstagramLine_ProductInstagramLine,
  resolve: productInstagram_resolver["a" /* productInstagramResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction-actions/ProductIntroductionActions.jsx
var ProductIntroductionActions_jsx = react_default.a.createElement;





var ProductIntroductionActions_ProductIntroductionActions = function ProductIntroductionActions(_ref) {
  var className = _ref.className,
      _ref$ratingImage = _ref.ratingImage,
      ratingImage = _ref$ratingImage === void 0 ? {} : _ref$ratingImage;
  return ProductIntroductionActions_jsx("div", {
    className: classnames_default()(className, 'flex flex-col items-center sm:items-stretch')
  }, ratingImage && ratingImage.src && ProductIntroductionActions_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'practicalInfos',
      labelGA: 'tripAdvisorAnchor'
    },
    className: "border-1 border-solid leading-none text-center p-px10 reset-anchor rounded-tiny",
    url: "#tripadvisor"
  }, ProductIntroductionActions_jsx(Image["b" /* default */], {
    altMsg: ratingImage.alt,
    dontChangeAnything: true,
    imageUrl: ratingImage.src,
    ratioDisplay: 3 / 20
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-logo/ProductLogo.jsx + 1 modules
var ProductLogo = __webpack_require__("hA0C");

// CONCATENATED MODULE: ./src/client/components/widgets/product-introduction/ProductIntroduction.jsx








var ProductIntroduction_jsx = react_default.a.createElement;

function ProductIntroduction_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductIntroduction_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductIntroduction_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductIntroduction_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var ProductIntroduction_ProductIntroduction = function ProductIntroduction(_ref) {
  var className = _ref.className,
      iconName = _ref.iconName,
      isExclusiveCollection = _ref.isExclusiveCollection,
      imageSrc = _ref.imageSrc,
      productCountry = _ref.productCountry,
      productName = _ref.productName,
      ratingImage = _ref.ratingImage,
      reduceLabel = _ref.reduceLabel,
      seasonLink = _ref.seasonLink,
      seeMoreLabel = _ref.seeMoreLabel,
      text = _ref.text,
      title = _ref.title;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!title) {
    return null;
  }

  var seeMoreSize = isDesktop ? 120 : 90;

  var top = ProductIntroduction_jsx("div", {
    className: "mx-auto bg-white shadow-subtle rounded-small p-px15 pt-px20 inset-x-0 z-1",
    style: ProductIntroduction_objectSpread({}, isDesktop ? {
      width: 'calc(180rem / 16)',
      position: 'absolute',
      top: 'calc(-60rem / 16)'
    } : {
      width: 'calc(160rem / 16)',
      position: 'relative',
      top: 'calc(-100rem / 16)',
      marginBottom: 'calc(-100rem / 16)'
    })
  }, ProductIntroduction_jsx(ProductLogo["a" /* ProductLogo */], {
    className: "mb-px30",
    iconName: iconName,
    isExclusiveCollection: isExclusiveCollection,
    productCountry: productCountry,
    productName: productName
  }), ProductIntroduction_jsx(ProductIntroductionActions_ProductIntroductionActions, {
    className: "",
    ratingImage: ratingImage
  }));

  var seasonSwitch = seasonLink && seasonLink.url && ProductIntroduction_jsx(DynamicLink["a" /* default */], {
    className: "font-bold inline-flex items-center justify-center leading-one p-px15 rounded-large text-base lg:text-md text-gray-darker hover:text-turquoise transition-colors shadow-subtle",
    url: seasonLink.url
  }, ProductIntroduction_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px10",
    name: seasonLink.iconName,
    width: isDesktop ? 'calc(22rem / 16)' : 'calc(16rem / 16)'
  }), seasonLink.label, ProductIntroduction_jsx(Icon["a" /* Icon */], {
    className: "rtl:ml-px15",
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    width: "calc(10rem / 16)"
  }));

  var content = ProductIntroduction_jsx(react["Fragment"], null, ProductIntroduction_jsx(Title["a" /* Title */], {
    className: classnames_default()('mb-px20 text-3xl md:text-7xl leading-tight', {
      'font-brand': !isExclusiveCollection,
      'font-serif font-bold': isExclusiveCollection
    }),
    theme: "none"
  }, Object(string_util["d" /* truncate */])(title, 50)), ProductIntroduction_jsx(TextSeeMore["a" /* TextSeeMore */], {
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: reduceLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: seeMoreSize,
    text: text,
    theme: "text-sans-3"
  }));

  return isDesktop ? ProductIntroduction_jsx("article", {
    className: (className, 'relative mt-px60 pt-px20')
  }, top, ProductIntroduction_jsx("div", {
    className: "flex"
  }, ProductIntroduction_jsx("div", {
    className: "relative w-1/2 z-0 overflow-hidden",
    style: {
      borderRadius: 'calc(10rem / 16)'
    }
  }, ProductIntroduction_jsx(Image["b" /* default */], {
    className: classnames_default()({
      'inset-border-after': isExclusiveCollection
    }),
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].R_63_BY_58,
    ratioDisplay: 1 / 2
  })), ProductIntroduction_jsx("div", {
    className: "w-1/2 flex py-px60 items-center relative"
  }, ProductIntroduction_jsx("div", {
    className: "absolute top-0 rtl:right-0"
  }, seasonSwitch), ProductIntroduction_jsx("div", {
    className: "w-5/6 rtl:ml-auto rtl:pl-px20"
  }, content)))) : ProductIntroduction_jsx("article", {
    className: className
  }, ProductIntroduction_jsx("div", {
    className: "pt-px20 mb-px40"
  }, ProductIntroduction_jsx("div", {
    className: "mx-auto overflow-hidden",
    style: {
      maxWidth: 400,
      borderRadius: 'calc(10rem / 16)'
    }
  }, ProductIntroduction_jsx(Image["b" /* default */], {
    className: classnames_default()({
      'inset-border-after': isExclusiveCollection
    }),
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].SQUARE
  })), top, ProductIntroduction_jsx("div", {
    className: "flex justify-center pt-px15"
  }, seasonSwitch)), content);
};
// EXTERNAL MODULE: ./src/client/components/widgets/info-banner/InfoBannerContainer.jsx
var InfoBannerContainer = __webpack_require__("wgpp");

// CONCATENATED MODULE: ./src/client/components/lines/product-introduction-line/ProductIntroductionLine.jsx



var ProductIntroductionLine_jsx = react_default.a.createElement;








var ProductIntroductionLine_ProductIntroductionLine = function ProductIntroductionLine(_ref) {
  var _ref$config = _ref.config,
      _ref$config$common = _ref$config.common,
      loadLess = _ref$config$common.loadLess,
      viewMore = _ref$config$common.viewMore,
      _ref$config$resort$re = _ref$config.resort.resortIntroduction,
      communityLabel = _ref$config$resort$re.communityLabel,
      toSummerLabel = _ref$config$resort$re.toSummerLabel,
      toWinterLabel = _ref$config$resort$re.toWinterLabel,
      hasCommunityButton = _ref.hasCommunityButton,
      hasSeasonButton = _ref.hasSeasonButton,
      hasTripadvisorButton = _ref.hasTripadvisorButton,
      id = _ref.id,
      imageSrc = _ref.imageSrc,
      questions = _ref.productCommunity.questions,
      _ref$resort = _ref.resort,
      descriptionTitle = _ref$resort.descriptionTitle,
      description = _ref$resort.description,
      country = _ref$resort.destination.country,
      icon = _ref$resort.icon,
      productId = _ref$resort.id,
      _ref$resort$images = _ref$resort.images,
      images = _ref$resort$images === void 0 ? [] : _ref$resort$images,
      isDoubleSeason = _ref$resort.isDoubleSeason,
      isExclusiveCollection = _ref$resort.isExclusiveCollection,
      isWinter = _ref$resort.isWinter,
      linkedResort = _ref$resort.linkedResort,
      name = _ref$resort.name,
      _ref$resort$tripadvis = _ref$resort.tripadvisor,
      _ref$resort$tripadvis2 = _ref$resort$tripadvis.rating,
      rating = _ref$resort$tripadvis2 === void 0 ? '' : _ref$resort$tripadvis2,
      _ref$resort$tripadvis3 = _ref$resort$tripadvis.ratingImageUrl,
      ratingImageUrl = _ref$resort$tripadvis3 === void 0 ? '' : _ref$resort$tripadvis3;
  var props = {
    communityLabel: config_default.a.get('social.wibilong.enabled') && questions.length && hasCommunityButton ? communityLabel : '',
    iconName: icon,
    imageSrc: imageSrc || images[2] || images[1] || images[0],
    productCountry: country,
    productName: name,
    ratingImage: hasTripadvisorButton ? {
      alt: "Tripadvisor: ".concat(rating),
      src: ratingImageUrl
    } : null,
    reduceLabel: loadLess,
    seasonLink: isDoubleSeason || !hasSeasonButton ? null : {
      iconName: isWinter ? icons["a" /* ICONS */].SUN : icons["a" /* ICONS */].MOUNTAIN,
      label: isWinter ? toSummerLabel : toWinterLabel,
      url: linkedResort && linkedResort.href
    },
    seeMoreLabel: viewMore,
    title: descriptionTitle,
    text: description,
    isExclusiveCollection: isExclusiveCollection
  };
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  return ProductIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line pt-px",
    size: "large"
  }, ProductIntroductionLine_jsx(InfoBannerContainer["a" /* InfoBannerContainer */], {
    className: "pt-px40 pb-px20 lg:py-px80",
    contentClassName: "justify-center",
    departureDate: departureDate,
    productId: productId,
    trackingData: {
      categoryGA: 'resort'
    },
    popinPosition: "center"
  }), ProductIntroductionLine_jsx(ProductIntroduction_ProductIntroduction, props));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-introduction/productIntroduction.resolver.js
var productIntroduction_resolver = __webpack_require__("g73z");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-introduction/productIntroduction.descriptor.js



var productIntroductionDescriptor = {
  name: constants["jb" /* RESORT_INTRODUCTION */],
  component: ProductIntroductionLine_ProductIntroductionLine,
  resolve: productIntroduction_resolver["a" /* productIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-meeting-room-info-line/ProductMeetingRoomInfoLine.jsx











var ProductMeetingRoomInfoLine_jsx = react_default.a.createElement;

function ProductMeetingRoomInfoLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductMeetingRoomInfoLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductMeetingRoomInfoLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductMeetingRoomInfoLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var TABLE_HEADER_HEIGHT = 64;
var TABLE_ROW_HEIGHT = 72;
var COLLAPSED_HEIGHT = TABLE_HEADER_HEIGHT + 6 * TABLE_ROW_HEIGHT;
var MEETING_ROOM_SHAPES = dist["constants"].MEETING_ROOM_SHAPES;
var SHAPE_NOT_AVAILABLE = '-';

var ProductMeetingRoomInfoLine_getMeetingRoomCapacityByShape = function getMeetingRoomCapacityByShape(_ref) {
  var meetingRoom = _ref.meetingRoom,
      shape = _ref.shape;
  var meetingRoomShape = meetingRoom.shapes.find(function (_ref2) {
    var type = _ref2.type;
    return type === shape;
  });
  return meetingRoomShape && meetingRoomShape.maxCapacity ? Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.people', {
    max_capacity: meetingRoomShape.maxCapacity
  }) : SHAPE_NOT_AVAILABLE;
};

var ProductMeetingRoomInfoLine_ProductMeetingRoomInfoLine = function ProductMeetingRoomInfoLine(_ref3) {
  var _shapeLabels;

  var productMeetingRooms = _ref3.productMeetingRooms,
      translationKeys = Object(objectWithoutProperties["a" /* default */])(_ref3, ["productMeetingRooms"]);

  var _useContext = Object(react["useContext"])(responsiveContext["a" /* default */]),
      isTablet = _useContext.isTablet,
      isRTL = _useContext.isRTL;

  Object(src_i18n["a" /* addTranslationKeys */])({
    productMeetingRoomInfoLine: translationKeys
  });

  if (productMeetingRooms.meetingRooms.length === 0 || productMeetingRooms.availableMeetingRoomShapes.length === 0) {
    return null;
  }

  var availableMeetingRoomShapes = productMeetingRooms.availableMeetingRoomShapes,
      meetingRooms = productMeetingRooms.meetingRooms;
  var shapeLabels = (_shapeLabels = {}, Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.USHAPE, Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.ushape')), Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.BOARDROOM, Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.boardroom')), Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.CLASSROOM, Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.classroom')), Object(defineProperty["a" /* default */])(_shapeLabels, MEETING_ROOM_SHAPES.THEATRE, Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.theatre')), _shapeLabels);
  var headerCellStyle = 'bg-blue text-white h-16 font-brand text-md text-center font-normal leading-tight';
  var firstColStickyStyle = 'border-none px-px25 absolute md:static rtl:left-0 md:inset-auto break-words';
  var contentRowClasses = 'text-center h-16 text-base font-sans leading-one';
  var stickyWrapperStyle = isRTL ? {
    marginRight: !isTablet ? '12.1rem' : undefined
  } : {
    marginLeft: !isTablet ? '12.1rem' : undefined
  };
  var colBorderStyle = !isTablet ? '2px solid white' : undefined;
  var colBorder = isRTL ? {
    borderLeft: colBorderStyle
  } : {
    borderRight: colBorderStyle
  };
  var firstColWidth = !isTablet ? '12rem' : undefined;

  var contentToRender = ProductMeetingRoomInfoLine_jsx(SeeMore["a" /* SeeMore */], {
    seeMoreSize: COLLAPSED_HEIGHT,
    classNameButton: "rtl:ml-px10 sm:rtl:-ml-0"
  }, ProductMeetingRoomInfoLine_jsx("div", {
    className: classnames_default()('overflow-x-scroll md:overflow-x-hidden md:w-full', {
      Line: !isTablet
    }),
    style: stickyWrapperStyle
  }, ProductMeetingRoomInfoLine_jsx("table", {
    className: "w-full",
    style: {
      borderSpacing: isTablet ? '2px' : '0px'
    }
  }, ProductMeetingRoomInfoLine_jsx("thead", null, ProductMeetingRoomInfoLine_jsx("tr", null, ProductMeetingRoomInfoLine_jsx("th", {
    className: "".concat(firstColStickyStyle, " ").concat(headerCellStyle, " flex justify-center items-center"),
    style: {
      width: firstColWidth
    }
  }, Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.meetingRoomsTitle')), availableMeetingRoomShapes.map(function (shape) {
    return ProductMeetingRoomInfoLine_jsx("th", {
      key: shape,
      className: headerCellStyle,
      style: ProductMeetingRoomInfoLine_objectSpread({
        minWidth: '8rem'
      }, colBorder)
    }, shapeLabels[shape]);
  }))), ProductMeetingRoomInfoLine_jsx("tbody", null, meetingRooms.map(function (meetingRoom, index) {
    var _meetingRoom$length, _meetingRoom$width, _meetingRoom$length2, _meetingRoom$width2, _meetingRoom$area, _meetingRoom$area2;

    return ProductMeetingRoomInfoLine_jsx("tr", {
      key: meetingRoom.label,
      className: contentRowClasses
    }, ProductMeetingRoomInfoLine_jsx("td", {
      className: classnames_default()(firstColStickyStyle, {
        'bg-gray-lighter': index % 2 === 0
      }),
      style: {
        width: firstColWidth,
        lineHeight: !meetingRoom.length && !meetingRoom.width && !meetingRoom.area ? 3 : undefined
      }
    }, ProductMeetingRoomInfoLine_jsx("p", {
      className: "font-bold break-words truncate"
    }, meetingRoom.label), ProductMeetingRoomInfoLine_jsx("p", null, meetingRoom.length && meetingRoom.width ? Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.lengthWidth', {
      length_value: ((_meetingRoom$length = meetingRoom.length) === null || _meetingRoom$length === void 0 ? void 0 : _meetingRoom$length.value) || '',
      width_value: ((_meetingRoom$width = meetingRoom.width) === null || _meetingRoom$width === void 0 ? void 0 : _meetingRoom$width.value) || '',
      length_width_unit: ((_meetingRoom$length2 = meetingRoom.length) === null || _meetingRoom$length2 === void 0 ? void 0 : _meetingRoom$length2.unit) || ((_meetingRoom$width2 = meetingRoom.width) === null || _meetingRoom$width2 === void 0 ? void 0 : _meetingRoom$width2.unit) || ''
    }) : null, meetingRoom.length && meetingRoom.width && meetingRoom.area ? " ".concat(Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.lengthWidthAreaSeparator'), " ") : null, meetingRoom.area ? Object(src_i18n["h" /* t */])('productMeetingRoomInfoLine.area', {
      area_value: ((_meetingRoom$area = meetingRoom.area) === null || _meetingRoom$area === void 0 ? void 0 : _meetingRoom$area.value) || '',
      area_unit: ((_meetingRoom$area2 = meetingRoom.area) === null || _meetingRoom$area2 === void 0 ? void 0 : _meetingRoom$area2.unit) || ''
    }) : null)), availableMeetingRoomShapes.map(function (shape) {
      var meetingRoomCapacity = ProductMeetingRoomInfoLine_getMeetingRoomCapacityByShape({
        meetingRoom: meetingRoom,
        shape: shape
      });
      return ProductMeetingRoomInfoLine_jsx("td", {
        key: shape,
        className: classnames_default()('leading-tight', {
          'bg-gray-lighter': index % 2 === 0
        }),
        style: ProductMeetingRoomInfoLine_objectSpread({
          minWidth: '8rem',
          lineHeight: '5'
        }, colBorder),
        "aria-hidden": meetingRoomCapacity === SHAPE_NOT_AVAILABLE
      }, meetingRoomCapacity);
    }));
  })))));

  return isTablet ? ProductMeetingRoomInfoLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, contentToRender) : contentToRender;
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-meeting-room-info/productMeetingRoomInfo.resolver.js
var productMeetingRoomInfo_resolver = __webpack_require__("+dj+");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-meeting-room-info/productMeetingRoomInfo.descriptor.js



var productMeetingRoomInfoDescriptor = {
  name: constants["kb" /* RESORT_MEETING_ROOM_INFO */],
  component: ProductMeetingRoomInfoLine_ProductMeetingRoomInfoLine,
  resolve: productMeetingRoomInfo_resolver["a" /* productMeetingRoomInfoResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-multimedia-line/ProductMultimediaLine.jsx









var ProductMultimediaLine_jsx = react_default.a.createElement;

function ProductMultimediaLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductMultimediaLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductMultimediaLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductMultimediaLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ProductMultimediaLine_ProductMultimediaLine = function ProductMultimediaLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {} : _ref$media,
      name = _ref.resort.name,
      socialPictures = _ref.socialPictures,
      title = _ref.title;
  var photos = media.photos,
      videos = media.videos,
      videos360 = media.videos360;
  Object(src_i18n["a" /* addTranslationKeys */])(config);

  if (!(photos === null || photos === void 0 ? void 0 : photos.length) && !(videos === null || videos === void 0 ? void 0 : videos.length) && !(videos360 === null || videos360 === void 0 ? void 0 : videos360.length) && !(socialPictures === null || socialPictures === void 0 ? void 0 : socialPictures.length)) {
    return null;
  }

  var galleryLabel = name ? Object(src_i18n["h" /* t */])('common.galleries.productGallery', {
    productName: name
  }) : Object(src_i18n["h" /* t */])('common.galleries.gallery');
  var nextLabel = name ? Object(src_i18n["h" /* t */])('common.galleries.productNextPicture', {
    productName: name
  }) : Object(src_i18n["h" /* t */])('common.next');
  var previousLabel = name ? Object(src_i18n["h" /* t */])('common.galleries.productPreviousPicture', {
    productName: name
  }) : Object(src_i18n["h" /* t */])('common.previous');
  return ProductMultimediaLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductMultimediaLine_jsx(LineTitle["a" /* LineTitle */], null, title), ProductMultimediaLine_jsx(Multimedia["a" /* Multimedia */], {
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    galleryLabel: galleryLabel,
    labels: {
      photos: Object(src_i18n["h" /* t */])('common.photoTitle'),
      socialPictures: Object(src_i18n["h" /* t */])('common.socialPicturesTitle'),
      videos: Object(src_i18n["h" /* t */])('common.videoTitle'),
      videos360: Object(src_i18n["h" /* t */])('common.video360Title')
    },
    launcherPictureAltLabel: Object(src_i18n["h" /* t */])('common.galleries.openProductSlideShowGalleryAt', {
      productName: name
    }),
    medias: ProductMultimediaLine_objectSpread(ProductMultimediaLine_objectSpread({}, media), {}, {
      socialPictures: socialPictures
    }),
    nextLabel: nextLabel,
    openGalleryLabel: Object(src_i18n["h" /* t */])('common.galleries.openSlideShowGallery'),
    pictureAltLabel: Object(src_i18n["h" /* t */])('common.galleries.productPictureItem', {
      productName: name
    }),
    previousLabel: previousLabel
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-multimedia/productMultimedia.resolver.js
var productMultimedia_resolver = __webpack_require__("VUEF");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-multimedia/productMultimedia.descriptor.js



var productMultimediaDescriptor = {
  name: constants["lb" /* RESORT_MULTIMEDIA */],
  component: ProductMultimediaLine_ProductMultimediaLine,
  resolve: productMultimedia_resolver["a" /* productMultimediaResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try-card/ProductMustTryCard.jsx


var ProductMustTryCard_jsx = react_default.a.createElement;





function ProductMustTryCard(props) {
  var className = props.className,
      description = props.description,
      imageSrc = props.imageSrc,
      seeMoreLabel = props.seeMoreLabel,
      title = props.title,
      trackingData = props.trackingData;

  var _useState = Object(react["useState"])(false),
      isExpanded = _useState[0],
      setExpanded = _useState[1];

  return ProductMustTryCard_jsx(TrackClick["a" /* TrackClick */], {
    as: "button",
    className: classnames_default()(className, 'reset-button overflow-hidden relative text-initial w-full h-full'),
    "data-testid": "ProductMustTryCard",
    onClick: function onClick() {
      return setExpanded(!isExpanded);
    },
    trackingData: trackingData
  }, ProductMustTryCard_jsx("div", {
    className: "relative h-full pb-px50"
  }, ProductMustTryCard_jsx("div", {
    className: "bg-gray-darker rounded-tiny overflow-hidden"
  }, ProductMustTryCard_jsx(Image["b" /* default */], {
    altMsg: "",
    groupKey: "thumbnails",
    hasLazyLoading: false,
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].R_38_BY_28,
    ratioDisplay: 1 / 4
  })), ProductMustTryCard_jsx("p", {
    className: "reset-paragraph px-px15 pt-px15 text-center text-md leading-tight overflow-hidden",
    style: {
      maxHeight: '55px'
    }
  }, title), !!seeMoreLabel && ProductMustTryCard_jsx("p", {
    className: "reset-paragraph my-px15 text-center text-sm underline absolute bottom-0 inset-x-0"
  }, seeMoreLabel), ProductMustTryCard_jsx("div", {
    className: classnames_default()('absolute top-full bg-white max-h-full overflow-y-auto mt-px5 mx-px5 pt-px20 px-px20 pb-px5 rounded-tiny text-center transition-transform', {
      '-translate-y-100': isExpanded,
      'translate-y-0': !isExpanded
    })
  }, ProductMustTryCard_jsx("p", {
    className: "reset-paragraph mb-px20 text-lg"
  }, title), ProductMustTryCard_jsx("p", {
    className: "reset-paragraph text-base"
  }, description))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try/ProductMustTryLarge.jsx

var ProductMustTryLarge_jsx = react_default.a.createElement;










var ProductMustTryLarge_ProductMustTryLarge = function ProductMustTryLarge(_ref) {
  var className = _ref.className,
      isFrench = _ref.isFrench,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      productColor = _ref.productColor,
      productIconName = _ref.productIconName;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return ProductMustTryLarge_jsx("div", {
    className: classnames_default()(className, 'relative -mx-px20 overflow-hidden')
  }, ProductMustTryLarge_jsx("div", {
    className: "absolute bg-".concat(productColor, " flex justify-center overflow-hidden p-px20 top-0 rounded-tiny w-full"),
    style: {
      height: '24.375rem'
    }
  }, ProductMustTryLarge_jsx("div", {
    className: classnames_default()('relative px-px60', {
      'pt-px10': isFrench
    })
  }, ProductMustTryLarge_jsx("div", {
    className: "absolute opacity-25 top-0 rtl:left-0"
  }, ProductMustTryLarge_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLACK,
    isNotSquare: true,
    name: productIconName,
    width: "8.75rem"
  })), ProductMustTryLarge_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: isFrench ? icons["a" /* ICONS */].MUST_TRY_EXPERIENCES_FR : icons["a" /* ICONS */].MUST_TRY_EXPERIENCES,
    width: isFrench ? '11rem' : '10rem'
  }))), ProductMustTryLarge_jsx(SliderHandler["a" /* SliderHandler */], {
    className: "-mx-px10",
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: items.map(function (item) {
      return ProductMustTryLarge_jsx("div", {
        className: "px-px10 relative h-full",
        key: item.title
      }, ProductMustTryLarge_jsx(ProductMustTryCard, item));
    }),
    nbItemsToScroll: 1,
    nbItemsToShow: isDesktop ? 4 : 3
  }, function (_ref2) {
    var hasControls = _ref2.hasControls,
        isNextControlDisabled = _ref2.isNextControlDisabled,
        isPreviousControlDisabled = _ref2.isPreviousControlDisabled,
        itemsNode = _ref2.itemsNode,
        onNext = _ref2.onNext,
        onPrevious = _ref2.onPrevious;
    return ProductMustTryLarge_jsx("div", {
      className: "relative mt-px95 mx-px20"
    }, itemsNode, hasControls && ProductMustTryLarge_jsx("div", {
      className: "absolute flex items-center justify-between inset-0 pointer-events-none w-full"
    }, !isPreviousControlDisabled && ProductMustTryLarge_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto rtl:-ml-px10",
      colorBg: colors["a" /* COLORS */].WHITE,
      color: colors["a" /* COLORS */].GRAY_DARKER,
      label: Object(src_i18n["h" /* t */])('common.previous'),
      onClick: onPrevious
    }), !isNextControlDisabled && ProductMustTryLarge_jsx(ArrowButton["a" /* ArrowButton */], {
      className: "pointer-events-auto rtl:-mr-px10 rtl:ml-auto",
      colorBg: colors["a" /* COLORS */].WHITE,
      color: colors["a" /* COLORS */].GRAY_DARKER,
      label: Object(src_i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180
    })));
  }));
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-must-try/ProductMustTryNarrow.jsx



var ProductMustTryNarrow_jsx = react_default.a.createElement;







var ProductMustTryNarrow_ProductMustTryNarrow = function ProductMustTryNarrow(_ref) {
  var className = _ref.className,
      isFrench = _ref.isFrench,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      productColor = _ref.productColor,
      productIconName = _ref.productIconName,
      scrollBackwardLabel = _ref.scrollBackwardLabel,
      scrollForwardLabel = _ref.scrollForwardLabel;
  return ProductMustTryNarrow_jsx("div", {
    className: classnames_default()(className, 'relative')
  }, ProductMustTryNarrow_jsx("div", {
    className: "absolute bg-".concat(productColor, " p-px20 inset-0 text-center"),
    style: {
      height: '24.375rem'
    }
  }, ProductMustTryNarrow_jsx("div", {
    className: "absolute opacity-25 top-0 rtl:left-0 pt-px10"
  }, ProductMustTryNarrow_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLACK,
    isNotSquare: true,
    name: productIconName,
    width: "8.75rem"
  })), ProductMustTryNarrow_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].WHITE,
    name: isFrench ? icons["a" /* ICONS */].MUST_TRY_EXPERIENCES_FR : icons["a" /* ICONS */].MUST_TRY_EXPERIENCES,
    width: isFrench ? '12.5rem' : '10rem'
  })), ProductMustTryNarrow_jsx(Scrollable["a" /* Scrollable */], {
    backwardLabel: scrollBackwardLabel,
    className: "pt-px95",
    forwardLabel: scrollForwardLabel,
    navPosition: "center"
  }, ProductMustTryNarrow_jsx("div", {
    className: "flex px-px10"
  }, items.map(function (_ref2) {
    var description = _ref2.description,
        id = _ref2.id,
        imageSrc = _ref2.imageSrc,
        seeMoreLabel = _ref2.seeMoreLabel,
        title = _ref2.title,
        trackingData = _ref2.trackingData;
    return ProductMustTryNarrow_jsx("div", {
      key: id,
      className: "flex-none m-px10",
      style: {
        width: '280px'
      }
    }, ProductMustTryNarrow_jsx(ProductMustTryCard, {
      description: description,
      imageSrc: imageSrc,
      seeMoreLabel: seeMoreLabel,
      title: title,
      trackingData: trackingData
    }));
  }), ProductMustTryNarrow_jsx("div", {
    className: "pr-px10"
  }))));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-must-try-line/ProductMustTryLine.jsx





var ProductMustTryLine_jsx = react_default.a.createElement;







var ProductMustTryLine_ProductMustTryLine = function ProductMustTryLine(_ref) {
  var _ref$config$common = _ref.config.common,
      scrollBackward = _ref$config$common.scrollBackward,
      scrollForward = _ref$config$common.scrollForward,
      id = _ref.id,
      isFrench = _ref.isFrench,
      mustTryExperiences = _ref.mustTryExperiences,
      _ref$resort = _ref.resort,
      productColor = _ref$resort.color,
      productName = _ref$resort.name,
      productIconName = _ref$resort.icon,
      seeMore = _ref.seeMore,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;
  var items = (mustTryExperiences || []).map(function (_ref2) {
    var itemId = _ref2.id,
        itemTitle = _ref2.title,
        image = _ref2.image,
        description = _ref2.description;
    return {
      description: description,
      id: itemId,
      imageSrc: image,
      seeMoreLabel: seeMore,
      title: itemTitle,
      trackingData: {
        categoryGA: 'cards',
        actionGA: 'must_try',
        labelGA: itemTitle || null
      }
    };
  });

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!items.length) {
    return null;
  }

  var props = {
    isFrench: isFrench,
    items: items,
    productColor: productColor,
    productIconName: productIconName
  };

  var titleNode = ProductMustTryLine_jsx(LineTitle["a" /* LineTitle */], null, Object(dist["messageFormat"])(title).format({
    productName: productName
  }));

  return isTablet ? ProductMustTryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, titleNode, ProductMustTryLine_jsx(ProductMustTryLarge_ProductMustTryLarge, props)) : ProductMustTryLine_jsx("div", Object(esm_extends["a" /* default */])({}, id ? {
    id: id
  } : null, {
    className: "Line"
  }), titleNode, ProductMustTryLine_jsx(ProductMustTryNarrow_ProductMustTryNarrow, Object(esm_extends["a" /* default */])({}, props, {
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  })));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-must-try-experiences/productMustTryExperiences.resolver.js
var productMustTryExperiences_resolver = __webpack_require__("BthO");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-must-try-experiences/productMustTryExperiences.descriptor.js



var productMustTryExperiencesDescriptor = {
  name: constants["y" /* MUST_TRY_EXPERIENCES */],
  component: ProductMustTryLine_ProductMustTryLine,
  props: productMustTryExperiences_resolver["a" /* productMustTryExperiencesResolver */].props,
  resolve: productMustTryExperiences_resolver["a" /* productMustTryExperiencesResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaContext.jsx
var CriteriaContext = __webpack_require__("XiOS");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/CriteriaDisplayContext.js
var CriteriaDisplayContext = __webpack_require__("TYzI");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/PriceRemoteContext.js








var PriceRemoteContext_jsx = react_default.a.createElement;

function PriceRemoteContext_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function PriceRemoteContext_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      PriceRemoteContext_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      PriceRemoteContext_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}


var initialState = {
  isCompact: false,
  isDetailOpened: false,
  hasOpenedDetailsAtLeastOnce: false,
  isInLayer: false,
  isJoyview: false,
  isOverrideSticky: true,
  isTotalPrice: false,
  submitPriceRemoteForm: function submitPriceRemoteForm() {}
};

var criteriaContextReducer = function criteriaContextReducer(state, action) {
  return PriceRemoteContext_objectSpread(PriceRemoteContext_objectSpread({}, state), action);
};

var PriceRemoteContext = /*#__PURE__*/Object(react["createContext"])([initialState, function () {}]);
var PriceRemoteContext_PriceRemoteContextProvider = function PriceRemoteContextProvider(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value;

  var _useReducer = Object(react["useReducer"])(criteriaContextReducer, PriceRemoteContext_objectSpread(PriceRemoteContext_objectSpread({}, initialState), value)),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return PriceRemoteContext_jsx(PriceRemoteContext.Provider, {
    value: [state, dispatch]
  }, children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/portal/Portal.constants.js
var Portal_constants = __webpack_require__("Yd/I");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-transport/CriteriaTransport.jsx
var CriteriaTransport = __webpack_require__("NWzG");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-when/CriteriaWhen.jsx
var CriteriaWhen = __webpack_require__("Go22");

// EXTERNAL MODULE: ./src/client/components/widgets/criteria/criteria-who/CriteriaWho.jsx
var CriteriaWho = __webpack_require__("wKzQ");

// EXTERNAL MODULE: ./src/utils/faceting/facetingUtils.js
var facetingUtils = __webpack_require__("kNiU");

// CONCATENATED MODULE: ./src/hooks/use-set-url-with-facetings/useSetUrlWithFacetings.js










var useSetUrlWithFacetings_NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE;
var FACET_QUERY_PARAMS = [uri_constants["f" /* QUERY_DEPARTURE_DATE */], uri_constants["g" /* QUERY_DURATION */], uri_constants["h" /* QUERY_KIDS */], uri_constants["k" /* QUERY_TRANSPORT */]];
var useSetUrlWithFacetings_useSetUrlWithFacetings = function useSetUrlWithFacetings(props) {
  var currentUrlHasNoQueryParams = function currentUrlHasNoQueryParams() {
    var currentQuery = props.uri.query(true);
    return FACET_QUERY_PARAMS.every(function (queryKey) {
      return Object(lodash["isEmpty"])(currentQuery[queryKey]);
    });
  };

  var computeQueryParamsForUrl = function computeQueryParamsForUrl(_ref) {
    var _ref2;

    var criteriaKeysToPersist = _ref.criteriaKeysToPersist;
    var departureCity = props.departureCity,
        departureDate = props.departureDate,
        duration = props.duration,
        kids = props.kids,
        kidsValidationState = props.kidsValidationState;
    var formattedDate = departureDate && Object(facetingUtils["g" /* getDepartureDateDisplayValue */])(Object(facetingUtils["b" /* formatDepartureDateForStore */])(departureDate, ''));
    return _ref2 = {}, Object(defineProperty["a" /* default */])(_ref2, uri_constants["f" /* QUERY_DEPARTURE_DATE */], criteriaKeysToPersist.includes(uri_constants["f" /* QUERY_DEPARTURE_DATE */]) && formattedDate || undefined), Object(defineProperty["a" /* default */])(_ref2, uri_constants["g" /* QUERY_DURATION */], criteriaKeysToPersist.includes(uri_constants["g" /* QUERY_DURATION */]) && duration || undefined), Object(defineProperty["a" /* default */])(_ref2, uri_constants["k" /* QUERY_TRANSPORT */], criteriaKeysToPersist.includes(uri_constants["k" /* QUERY_TRANSPORT */]) && departureCity !== useSetUrlWithFacetings_NO_TRANSPORT_VALUE && departureCity || undefined), Object(defineProperty["a" /* default */])(_ref2, uri_constants["h" /* QUERY_KIDS */], criteriaKeysToPersist.includes(uri_constants["h" /* QUERY_KIDS */]) && kids.length > 0 && Object(facetingUtils["k" /* serializeKidsToQueryParam */])({
      kids: kids,
      kidsValidationState: kidsValidationState
    }) || undefined), _ref2;
  };

  var persistCriteriaInUrl = function persistCriteriaInUrl(options) {
    // NOTE: URI.setQuery() does not remove existing queries
    var queryParams = computeQueryParamsForUrl(options);
    var searchPageUrl = props.uri.clone().hash(null).setQuery(queryParams);
    redirectUtils["a" /* default */].redirectTo()(searchPageUrl, {
      replace: true,
      shallow: true
    });
  };

  var isInitialMount = Object(react["useRef"])(true);
  Object(react["useEffect"])(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;

      if (currentUrlHasNoQueryParams()) {
        persistCriteriaInUrl({
          criteriaKeysToPersist: [uri_constants["f" /* QUERY_DEPARTURE_DATE */], uri_constants["g" /* QUERY_DURATION */], uri_constants["k" /* QUERY_TRANSPORT */], uri_constants["h" /* QUERY_KIDS */]]
        });
      }
    } else {
      persistCriteriaInUrl({
        criteriaKeysToPersist: FACET_QUERY_PARAMS
      });
    }
  }, [props.departureDate, props.duration, props.departureCity, props.kids]);
};
// EXTERNAL MODULE: /opt/webapp/node_modules/reselect/lib/index.js
var reselect_lib = __webpack_require__("hqKg");

// CONCATENATED MODULE: ./src/client/store/price-remote/priceRemote.selector.js
var priceRemote_selector_priceRemoteSelector = function priceRemoteSelector(_ref) {
  var priceRemote = _ref.priceRemote;
  return priceRemote || {};
};
// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.selector.js





var priceOfStaySelector = Object(reselect_lib["createSelector"])(priceRemote_selector_priceRemoteSelector, function (_ref) {
  var data = _ref.priceOfStay.data;
  return data;
});
var proposalsSelector = Object(reselect_lib["createSelector"])(priceOfStaySelector, function (_ref2) {
  var proposals = _ref2.proposals;
  return proposals || {};
});
var priceOfStayIsLoadingSelector = Object(reselect_lib["createSelector"])(calendar_selector["e" /* getCalendarLoading */], priceRemote_selector_priceRemoteSelector, function (state) {
  return state.priceTicket.isLoading;
}, tripCriteria_selector["b" /* getDepartureDate */], calendar_selector["b" /* getBlockInputDepartureDate */], tripCriteria_selector["c" /* getTripDuration */], function (calendarIsLoading, _ref3, priceTicketIsLoading, departureDate, blockInputDepartureDate, duration) {
  var _ref3$priceOfStay = _ref3.priceOfStay,
      priceOfStayIsLoading = _ref3$priceOfStay.isLoading,
      lastRequestId = _ref3$priceOfStay.lastRequestId;
  return calendarIsLoading || priceTicketIsLoading || (lastRequestId !== -1 || !blockInputDepartureDate && !!departureDate && !!duration) && priceOfStayIsLoading;
});
var shouldDisplayAlternativePriceTitleSelector = Object(reselect_lib["createSelector"])(priceRemote_selector_priceRemoteSelector, function (_ref4) {
  var _data$gap;

  var data = _ref4.priceOfStay.data;
  var gap = (_data$gap = data === null || data === void 0 ? void 0 : data.gap) !== null && _data$gap !== void 0 ? _data$gap : 0;
  return gap >= proposals_constants["t" /* PRICE_COUNTER_PROPOSAL_THRESHOLD */] && gap < proposals_constants["r" /* PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD */];
});
// EXTERNAL MODULE: ./src/utils/faceting/kidsValidationStateUtils.js
var kidsValidationStateUtils = __webpack_require__("cGFA");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-form/PriceRemoteForm.jsx










var PriceRemoteForm_jsx = react_default.a.createElement;

function PriceRemoteForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PriceRemoteForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PriceRemoteForm_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PriceRemoteForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










































var PriceRemoteForm_NO_TRANSPORT_VALUE = dist["constants"].NO_TRANSPORT_VALUE; // TODO: A sortir dans un fichier, mutaliser avec SearchForm

var PriceRemoteForm_SubmitButton = function SubmitButton(_ref) {
  var label = _ref.label,
      isStickyAndIsDesktop = _ref.isStickyAndIsDesktop;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var stickyAndDesktopWidth = isStickyAndIsDesktop ? 180 : 250;
  var width = isDesktop ? stickyAndDesktopWidth : '100%';
  return PriceRemoteForm_jsx(Button["a" /* Button */], {
    className: "flex flex-1 justify-center items-center px-px5 lg:px-0 max-w-full",
    color: colors["a" /* COLORS */].WHITE,
    colorBg: colors["a" /* COLORS */].SUCCESS,
    colorBorder: colors["a" /* COLORS */].SUCCESS,
    minWidth: "initial",
    size: "large",
    style: {
      minWidth: 80,
      height: 52,
      width: width
    },
    type: "submit"
  }, label && Object(string_util["d" /* truncate */])(label, 40) || PriceRemoteForm_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].SEARCH_GLASS
  }));
};

var PriceRemoteForm_selector = function selector(state) {
  return {
    adults: Object(trip_information_storeHelper["a" /* getAdults */])(state),
    adultsNumber: Object(trip_information_storeHelper["b" /* getAdultsNumber */])(state),
    departureCity: Object(tripCriteria_selector["a" /* getDepartureCity */])(state),
    departureDate: Object(tripCriteria_selector["b" /* getDepartureDate */])(state),
    duration: Object(tripCriteria_selector["c" /* getTripDuration */])(state),
    kids: Object(trip_information_storeHelper["c" /* getKids */])(state),
    kidsValidationState: Object(lodash["get"])(state, 'faceting.kidsValidationState'),
    prices: Object(calendar_selector["l" /* getPricesByDays */])(state),
    shouldDisplayAlternativePriceTitle: shouldDisplayAlternativePriceTitleSelector(state)
  };
};

var PriceRemoteForm_PriceRemoteForm = function PriceRemoteForm(_ref2) {
  var className = _ref2.className,
      departureCities = _ref2.departureCities,
      initialDuration = _ref2.initialDuration,
      initialTransport = _ref2.initialTransport,
      isJoyview = _ref2.isJoyview,
      isStickyAndIsDesktop = _ref2.isStickyAndIsDesktop,
      product = _ref2.product,
      productId = _ref2.productId,
      reassurance = _ref2.reassurance,
      transportIcon = _ref2.transportIcon,
      urgentisationRate = _ref2.urgentisationRate;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      priceRemoteContext = _useContext[0],
      setPriceRemoteContext = _useContext[1];

  var _useContext2 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext2[0];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 2),
      dispatchCriteriaDisplayContext = _useCriteriaDisplayCo2[1];

  var _useSelector = Object(es["e" /* useSelector */])(PriceRemoteForm_selector),
      adults = _useSelector.adults,
      adultsNumber = _useSelector.adultsNumber,
      departureCity = _useSelector.departureCity,
      departureDate = _useSelector.departureDate,
      duration = _useSelector.duration,
      kids = _useSelector.kids,
      kidsValidationState = _useSelector.kidsValidationState,
      prices = _useSelector.prices,
      shouldDisplayAlternativePriceTitle = _useSelector.shouldDisplayAlternativePriceTitle;

  var dispatch = Object(es["d" /* useDispatch */])();

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var track = Object(useTracking["a" /* useTracking */])();

  var _useState = Object(react["useState"])(duration || initialDuration || duration_constants["b" /* DEFAULT_TRIP_DURATION */]),
      priceDuration = _useState[0];

  var isReadyForBookingEngine = criteriaContext.criteriaWhenIsSet && criteriaContext.criteriaWhoIsSet && criteriaContext.criteriaTransportIsSet;
  var uri = Object(uriUtils["c" /* convertLocationToURI */])(location);
  useSetUrlWithFacetings_useSetUrlWithFacetings({
    adultsNumber: adultsNumber,
    departureCity: departureCity || PriceRemoteForm_NO_TRANSPORT_VALUE,
    departureDate: departureDate,
    duration: duration,
    kids: kids,
    kidsValidationState: kidsValidationState,
    uri: uri
  });

  var changeCity = function changeCity(value) {
    var sendGAEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    dispatchCriteriaDisplayContext({
      type: CriteriaDisplayContext["a" /* ACTIONS */].CLOSE_CRITERIA,
      payload: 'criteriaTransport'
    });
    dispatch(Object(facetingSearch_action["a" /* changeDepartureCity */])(value));

    if (sendGAEvent) {
      track({
        actionGA: 'priceBar',
        labelGA: "departureCity_".concat(value),
        categoryGA: pageContext.pageId
      });
    }
  };

  var isDepartureCityAvailable = departureCities.some(function (_ref3) {
    var value = _ref3.value;
    return value === departureCity;
  });
  Object(react["useEffect"])(function () {
    if (initialTransport && (!departureCity || !isDepartureCityAvailable)) {
      changeCity(initialTransport, initialTransport !== faceting_constants["h" /* DEFAULT_DEPARTURE_CITY_VALUE */]);
    }
  }, [initialTransport]);
  var transportQueryValue = location.queryParams[uri_constants["k" /* QUERY_TRANSPORT */]];
  var transport = (isDepartureCityAvailable ? departureCity : initialTransport) || initialTransport || '';
  Object(react["useEffect"])(function () {
    if (!productId || transportQueryValue && transportQueryValue !== transport) {
      return;
    }

    dispatch(Object(calendar_action["c" /* fetchCalendar */])({
      resortId: productId,
      duration: priceDuration,
      transport: transport,
      urgentisationRate: urgentisationRate
    }, appContext));
  }, [productId, transport, transportQueryValue, urgentisationRate]);
  var availableDurations = useAvailableDurations_useAvailableDurations({
    initialTransport: initialTransport,
    productId: productId
  });

  var handleMandatoryFields = function handleMandatoryFields() {
    if (!criteriaContext.criteriaWhenIsSet) {
      setPriceRemoteContext({
        isCompact: false
      });
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWhen'
      });
    } else if (!criteriaContext.criteriaWhoIsSet) {
      var validationState = Object(kidsValidationStateUtils["e" /* invalidateNotValidatedKids */])(kidsValidationState);
      dispatch(Object(facetingSearch_action["m" /* setKidsValidationState */])(validationState));
      setPriceRemoteContext({
        isCompact: false
      });
      dispatchCriteriaDisplayContext({
        type: CriteriaDisplayContext["a" /* ACTIONS */].OPEN_CRITERIA,
        payload: 'criteriaWho'
      });
    }

    if (!departureCity) {
      changeCity(faceting_constants["h" /* DEFAULT_DEPARTURE_CITY_VALUE */]);
    }
  };

  var onSubmit = function onSubmit(event) {
    if (event) {
      event.preventDefault();
    }

    Object(last_visited_tracking_api["b" /* trackLastVisitedProducts */])(pageContext.pageType, {
      id: productId,
      be: true,
      timestamp: Date.now()
    });
    handleMandatoryFields();

    if (isReadyForBookingEngine) {
      var newArrivalDate = Object(date_apiDate["l" /* timestampToApiDate */])(departureDate);

      var fetchParams = PriceRemoteForm_objectSpread(PriceRemoteForm_objectSpread({}, newArrivalDate ? {
        newArrivalDate: newArrivalDate
      } : null), {}, {
        departureCity: departureCity,
        duration: duration || 7,
        globalLoaderLabel: Object(src_i18n["h" /* t */])(appContext.isSeller ? 'booking.partners.form.proposalsLoaderLabel' : 'booking.form.proposalsLoaderLabel'),
        isJoyView: isJoyview,
        productId: productId,
        bookingEngineEntry: booking_constants["a" /* BOOKING_ENGINE_ENTRIES */].PRICE_REMOTE
      }, appContext.isSeller ? Object(ContactInfoUtils["e" /* getAllAttendeesIds */])({
        adults: adults,
        kids: kids
      }) : null);

      if (shouldDisplayAlternativePriceTitle) {
        track({
          actionGA: 'remotePrice',
          labelGA: 'counterProposal_rate10_check'
        });
      }

      dispatch(Object(proposals_action["j" /* fetchProposalsAndRedirect */])(fetchParams, appContext, location));
    } else {
      track({
        actionGA: 'priceBar',
        labelGA: 'organise_your_holiday',
        categoryGA: pageContext.pageId
      });
    }
  };

  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      submitPriceRemoteForm: onSubmit
    });
  }, [isReadyForBookingEngine, departureCity]);
  return PriceRemoteForm_jsx("form", {
    className: className,
    id: PRICE_REMOTE_FORM_ID,
    onSubmit: onSubmit
  }, PriceRemoteForm_jsx("div", {
    className: "lg:flex lg:flex-row"
  }, PriceRemoteForm_jsx("div", {
    className: classnames_default()({
      'flex lg:flex-2 -mx-px5': !priceRemoteContext.isCompact,
      hidden: priceRemoteContext.isCompact
    })
  }, PriceRemoteForm_jsx("div", {
    className: "flex-1 px-px5",
    "data-testid": "search-form-criteria-when"
  }, PriceRemoteForm_jsx(CriteriaWhen["a" /* CriteriaWhen */], {
    durationOptions: (availableDurations === null || availableDurations === void 0 ? void 0 : availableDurations.length) ? availableDurations : [],
    prices: prices,
    product: product,
    checkIfDepartureDateIsBookable: true
  })), PriceRemoteForm_jsx("div", {
    className: "flex-1 px-px5",
    "data-testid": "search-form-criteria-who"
  }, PriceRemoteForm_jsx(CriteriaWho["a" /* CriteriaWho */], {
    hasChildcareSwitch: false,
    isKidBirthdateRequired: true
  })), PriceRemoteForm_jsx("div", {
    className: "flex-1 px-px5",
    "data-testid": "search-form-criteria-transport"
  }, PriceRemoteForm_jsx(CriteriaTransport["a" /* CriteriaTransport */], {
    departureCitiesOptions: departureCities,
    initialTransport: initialTransport,
    reassurance: reassurance,
    transportIcon: transportIcon,
    withValidDepartureCity: true
  }))), PriceRemoteForm_jsx("div", {
    className: "max-w-full lg:rtl:ml-px10 mt-px10 lg:mt-0"
  }, PriceRemoteForm_jsx(PriceRemoteForm_SubmitButton, {
    label: isReadyForBookingEngine ? Object(src_i18n["h" /* t */])('common.continue') : Object(src_i18n["h" /* t */])('priceRemote.priceRemoteButton'),
    isStickyAndIsDesktop: isStickyAndIsDesktop
  }))));
};
// EXTERNAL MODULE: ./src/client/store/utils/createAction.js
var createAction = __webpack_require__("rJ95");

// EXTERNAL MODULE: ./src/client/store/priceTicket/priceTicket.helper.js
var priceTicket_helper = __webpack_require__("q/8t");

// EXTERNAL MODULE: ./src/client/store/priceTicket/constants.js
var priceTicket_constants = __webpack_require__("0OJc");

// CONCATENATED MODULE: ./src/client/store/priceTicket/priceTicket.actions.js



function priceTicketRequest(_ref) {
  var appContext = _ref.appContext,
      duration = _ref.duration,
      forceAdultPerTrip = _ref.forceAdultPerTrip,
      location = _ref.location,
      productId = _ref.productId,
      transport = _ref.transport,
      withDate = _ref.withDate;
  return Object(createAction["a" /* createOptimisticAction */])(priceTicket_constants["a" /* default */], {}, {
    optimist: true,
    promise: Object(priceTicket_helper["a" /* fetchPrice */])({
      appContext: appContext,
      duration: duration,
      forceAdultPerTrip: forceAdultPerTrip,
      location: location,
      productId: productId,
      transport: transport,
      withDate: withDate
    })
  });
}
// EXTERNAL MODULE: ./src/utils/date/dateUtils.js
var dateUtils = __webpack_require__("L73y");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.helper.js










function priceOfStay_helper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceOfStay_helper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceOfStay_helper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceOfStay_helper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}









var priceOfStay_helper_getChildrenBirthdates = function getChildrenBirthdates(_ref) {
  var _ref$kids = _ref.kids,
      kids = _ref$kids === void 0 ? [] : _ref$kids;
  return (// $FlowFixMe flow could not predict value after a filter and a map
    kids.filter(function (_ref2) {
      var birthdate = _ref2.birthdate;
      return !!birthdate;
    }).map(function (kid) {
      return Object(dateUtils["b" /* formatTimestampDate */])(kid.birthdate, date_apiDate["a" /* API_DATE_FORMAT */]);
    })
  );
};

var getNumberAttendees = function getNumberAttendees(_ref3) {
  var _ref3$adults = _ref3.adults,
      adults = _ref3$adults === void 0 ? [] : _ref3$adults,
      _ref3$kids = _ref3.kids,
      kids = _ref3$kids === void 0 ? [] : _ref3$kids;
  var kidsWithBirthdates = kids.filter(function (_ref4) {
    var birthdate = _ref4.birthdate;
    return !!birthdate;
  });
  return adults.length + kidsWithBirthdates.length;
};

var priceOfStay_helper_fetchPriceOfStay = function fetchPriceOfStay(appContext, searchCriteria) {
  var productId = searchCriteria.productId,
      departureDate = searchCriteria.departureDate,
      duration = searchCriteria.duration,
      departureCity = searchCriteria.departureCity,
      offerName = searchCriteria.offerName;
  var numberAttendees = getNumberAttendees(searchCriteria);

  var args = priceOfStay_helper_objectSpread(priceOfStay_helper_objectSpread(priceOfStay_helper_objectSpread(priceOfStay_helper_objectSpread({
    productId: productId,
    departureDate: Object(dateUtils["b" /* formatTimestampDate */])(departureDate, date_apiDate["a" /* API_DATE_FORMAT */]),
    duration: duration
  }, numberAttendees && {
    numberAttendees: numberAttendees
  }), numberAttendees && {
    childrenBirthdates: priceOfStay_helper_getChildrenBirthdates(searchCriteria)
  }), departureCity !== faceting_constants["h" /* DEFAULT_DEPARTURE_CITY_VALUE */] && {
    departureCity: departureCity
  }), offerName && {
    offerName: dist["url"].decodePath(offerName)
  });

  var argsString = Object(graphql["a" /* buildArgs */])(args);
  var query = "query {\n      priceOfStay(".concat(argsString, ") {\n        ... on ErrorsPriceOfStayType {\n          errors {\n            errorCode\n            errorDescription\n            errorValue\n          }\n        }\n        ... on PriceOfStayType {\n          accommodationId\n          accommodationLabel\n          bestPrice {\n            value\n            formattedValue\n          }\n          currency\n          gap\n          includesChildcare\n          includesTransportation\n          initialPrice {\n            value\n            formattedValue\n          }\n          resource\n          unit {\n            id\n            label\n          }\n          offerColor\n          productId\n          yieldPricingVariation\n        }\n      }\n    }");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["zd" /* STATE_PRODUCT_PRICE_OF_STAY */]
  });
};
// EXTERNAL MODULE: ./src/client/store/price-remote/constants.js
var price_remote_constants = __webpack_require__("GZgf");

// CONCATENATED MODULE: ./src/client/store/price-remote/price-of-stay/priceOfStay.actions.js



var priceOfStay_actions_getPriceOfStay = function getPriceOfStay(appContext, searchCriteria) {
  return Object(createAction["a" /* createOptimisticAction */])(price_remote_constants["b" /* PRICE_OF_STAY_REQUEST */], {}, {
    optimist: true,
    promise: priceOfStay_helper_fetchPriceOfStay(appContext, searchCriteria)
  });
};
var priceOfStay_actions_resetPriceOfStay = function resetPriceOfStay() {
  return Object(createAction["b" /* default */])(price_remote_constants["c" /* RESET_PRICE_OF_STAY */]);
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-of-stay/PriceOfStay.jsx










var PriceOfStay_jsx = react_default.a.createElement;

function PriceOfStay_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function PriceOfStay_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PriceOfStay_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PriceOfStay_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























var PriceOfStay_PriceOfStay = function PriceOfStay(_ref) {
  var departureCities = _ref.departureCities,
      initialTransport = _ref.initialTransport,
      productId = _ref.productId;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var pageContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]);

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      _useContext$ = _useContext[0],
      isDetailOpened = _useContext$.isDetailOpened,
      hasOpenedDetailsAtLeastOnce = _useContext$.hasOpenedDetailsAtLeastOnce,
      isJoyview = _useContext$.isJoyview,
      isCompact = _useContext$.isCompact,
      isOverrideSticky = _useContext$.isOverrideSticky,
      submitPriceRemoteForm = _useContext$.submitPriceRemoteForm,
      setPriceRemoteContext = _useContext[1];

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop,
      isAppMounted = _useResponsive.isAppMounted;

  var track = Object(useTracking["a" /* useTracking */])();
  var dispatch = Object(es["d" /* useDispatch */])();
  var adults = Object(es["e" /* useSelector */])(trip_information_storeHelper["a" /* getAdults */]);
  var blockInputDepartureDate = Object(es["e" /* useSelector */])(calendar_selector["b" /* getBlockInputDepartureDate */]);
  var departureCityFromStore = Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]);
  var departureDate = Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]);
  var duration = Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */]);
  var kids = Object(es["e" /* useSelector */])(trip_information_storeHelper["c" /* getKids */]);
  var basePrice = Object(es["e" /* useSelector */])(function (state) {
    return state.priceTicket.price;
  });

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    return {
      priceOfStay: priceOfStaySelector(state),
      priceOfStayError: state.priceRemote.priceOfStay.error
    };
  }),
      priceOfStay = _useSelector.priceOfStay,
      priceOfStayError = _useSelector.priceOfStayError;

  var priceOfStayIsLoading = Object(es["e" /* useSelector */])(priceOfStayIsLoadingSelector);
  var calendarIsLoading = Object(es["e" /* useSelector */])(calendar_selector["e" /* getCalendarLoading */]);
  var calendarDepartureCity = Object(es["e" /* useSelector */])(calendar_selector["d" /* getCalendarDepartureCity */]);
  var calendarProductId = Object(es["e" /* useSelector */])(calendar_selector["f" /* getCalendarProductId */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var offerName = location.queryParams.offer;
  var isDepartureCityAvailable = !departureCities || departureCities.some(function (_ref2) {
    var value = _ref2.value;
    return value === departureCityFromStore;
  });
  var departureCity = isDepartureCityAvailable ? departureCityFromStore : initialTransport || 'NO';
  var calendarIsReady = calendarDepartureCity === departureCity && calendarProductId === productId && !calendarIsLoading;
  var isLoading = !calendarIsReady || priceOfStayIsLoading || !isAppMounted;
  var hasValidCriteria = !blockInputDepartureDate && !!departureDate && !!duration;
  var withCustomCriteria = hasValidCriteria && calendarIsReady; // Fixme: refactor kids and adults reducers so that their state does not change unnecessarily

  var debouncedSearchCriteria = Object(useDebounce["a" /* useDebounce */])([departureCity, withCustomCriteria ? departureDate : null, duration, JSON.stringify(withCustomCriteria ? kids : null), JSON.stringify(withCustomCriteria ? adults : null), productId], 500);
  Object(react["useEffect"])(function () {
    dispatch(priceTicketRequest({
      appContext: appContext,
      location: location,
      productId: productId,
      transport: departureCity || 'NO',
      withDate: false
    }));
  }, [productId, departureCity]);
  Object(react["useEffect"])(function () {
    dispatch(priceOfStay_actions_resetPriceOfStay());
  }, [departureDate, departureCity]);
  Object(react["useEffect"])(function () {
    var searchCriteria = PriceOfStay_objectSpread(PriceOfStay_objectSpread(PriceOfStay_objectSpread({
      productId: productId,
      departureDate: withCustomCriteria ? departureDate : null,
      departureCity: departureCity,
      duration: duration
    }, kids && withCustomCriteria ? {
      kids: kids
    } : null), adults && withCustomCriteria ? {
      adults: adults
    } : null), {}, {
      offerName: offerName
    });

    if (withCustomCriteria && departureCity) {
      dispatch(priceOfStay_actions_getPriceOfStay(appContext, searchCriteria));
    }
  }, debouncedSearchCriteria);
  Object(react["useEffect"])(function () {
    if (priceOfStay) {
      track({
        actionGA: "realPriceDisplay_".concat(priceOfStay.resource),
        categoryGA: pageContext.pageType,
        labelGA: pageContext.pageMeta.resortId,
        resortAdult: adults.length,
        resortChildren: kids.length,
        resortCode: pageContext.pageMeta.resortId,
        resortDepartureCityCode: departureCity,
        resortDepartureDate: Object(dateUtils["b" /* formatTimestampDate */])(departureDate, 'YYYYMMDD'),
        resortNightNumber: duration,
        resortTotalParticipant: adults.length + kids.length,
        valueGA: priceOfStay.bestPrice.value
      });
    }
  }, [priceOfStay]);
  Object(react["useEffect"])(function () {
    if (priceOfStayError) {
      var errorDescription = priceOfStayError[0].errorDescription;
      track({
        event: 'eventGA',
        actionGA: "errorPriceRemote".concat(errorDescription ? "_".concat(errorDescription) : ''),
        categoryGA: pageContext.pageType,
        labelGA: pageContext.pageMeta.resortId,
        nonInteraction: '0'
      });
    }
  }, [priceOfStayError]);
  Object(react["useEffect"])(function () {
    if (priceOfStay && !isLoading) {
      setPriceRemoteContext(PriceOfStay_objectSpread({
        isTotalPrice: !!priceOfStay
      }, !hasOpenedDetailsAtLeastOnce && isDesktop ? {
        isDetailOpened: true,
        hasOpenedDetailsAtLeastOnce: true
      } : {
        isDetailOpened: isDetailOpened
      }));
    }
  }, [priceOfStay]);

  if (!isLoading && hasValidCriteria && priceOfStayError) {
    var btnCls = classnames_default()('reset-button text-success underline md:rtl:ml-px5 font-bold', {
      block: isCompact || isOverrideSticky
    });
    var errorValue = priceOfStayError[0].errorValue;
    var ctaLabelKey = ['priceRemote.notAvailableTransportation', 'priceRemote.errors.noTransport'].includes(errorValue) ? 'priceRemote.notAvailableCTATransportation' : 'priceRemote.notAvailableCTA';
    return PriceOfStay_jsx("div", {
      className: "flex flex-col lg:flex-row justify-center text-center items-center md:justify-end lg:mlx-px40"
    }, PriceOfStay_jsx("span", {
      className: "text-orange font-bold"
    }, Object(src_i18n["h" /* t */])(errorValue)), PriceOfStay_jsx("button", {
      className: btnCls,
      onClick: submitPriceRemoteForm,
      type: "button"
    }, Object(src_i18n["h" /* t */])(ctaLabelKey)));
  }

  return PriceOfStay_jsx("div", {
    className: "lg:flex"
  }, !isJoyview ? PriceOfStay_jsx("button", {
    onClick: function onClick() {
      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened,
        hasOpenedDetailsAtLeastOnce: true
      });
    },
    className: "hidden lg:flex lg:items-center reset-button"
  }, PriceOfStay_jsx(Icon["a" /* Icon */], {
    color: colors["a" /* COLORS */].BLUE,
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "1.5rem"
  }), PriceOfStay_jsx("div", {
    className: "font-brand text-blue text-md rtl:ml-px10"
  }, Object(src_i18n["h" /* t */])('common.allInclusive'))) : null, isLoading ? PriceOfStay_jsx("div", {
    className: "flex justify-center items-center md:justify-end lg:mx-px40"
  }, PriceOfStay_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })) : null, !isLoading && priceOfStay && hasValidCriteria && PriceOfStay_jsx(Price["a" /* Price */], {
    bestPrice: priceOfStay.bestPrice,
    className: "lg:mx-px40",
    color: isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE,
    currency: priceOfStay.currency,
    initialPrice: priceOfStay.initialPrice,
    onClick: function onClick() {
      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened,
        hasOpenedDetailsAtLeastOnce: true
      });
    },
    theme: "remote",
    unit: priceOfStay.unit.label,
    hasAsterisk: false
  }), !isLoading && !hasValidCriteria && basePrice && PriceOfStay_jsx("div", {
    className: "flex justify-center lg:mx-px40"
  }, basePrice.bestPrice && PriceOfStay_jsx("span", {
    className: "flex items-center font-sans font-bold text-sm text-blue px-px10"
  }, Object(src_i18n["h" /* t */])('price.format.from')), PriceOfStay_jsx(Price["a" /* Price */], {
    bestPrice: basePrice.bestPrice,
    currency: basePrice.currency,
    color: isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE,
    initialPrice: basePrice.initialPrice,
    onClick: function onClick() {
      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened,
        hasOpenedDetailsAtLeastOnce: true
      });
    },
    theme: "remote",
    unit: basePrice.unit
  })));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-banner/ProductBanner.jsx
var ProductBanner = __webpack_require__("SUcU");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-ticket/PriceRemoteTicket.jsx
var PriceRemoteTicket_jsx = react_default.a.createElement;




var PriceRemoteTicket_PriceRemoteTicket = function PriceRemoteTicket(_ref) {
  var className = _ref.className,
      departureCities = _ref.departureCities,
      initialTransport = _ref.initialTransport,
      product = _ref.product;
  return PriceRemoteTicket_jsx("div", {
    className: classnames_default()(className, 'flex flex-grow justify-between')
  }, PriceRemoteTicket_jsx(ProductBanner["a" /* ProductBanner */], {
    product: product
  }), PriceRemoteTicket_jsx("div", {
    className: "text-center w-full lg:w-auto lg:text-right lg:flex lg:flex-shrink-0 lg:items-center"
  }, PriceRemoteTicket_jsx(PriceOfStay_PriceOfStay, {
    departureCities: departureCities,
    initialTransport: initialTransport,
    productId: product.id
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-content/PriceRemoteContent.jsx


var PriceRemoteContent_jsx = react_default.a.createElement;






var PriceRemoteContent_PriceRemoteContent = function PriceRemoteContent(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      className = _ref.className,
      isSticky = _ref.isSticky,
      product = _ref.product,
      reassurance = _ref.reassurance,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      urgentisationRate = _ref.urgentisationRate;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      isCompact = _useContext[0].isCompact;

  var isCompactAndIsDesktop = isCompact && isDesktop;
  var isNotCompactAndIsDesktop = !isCompact && isDesktop;
  var isStickyAndIsMobile = isSticky && !isDesktop;
  var isStickyAndIsDesktop = isSticky && isDesktop;
  var isStickyAndIsNotCompact = isSticky && !isCompact;
  var isLongResortTitle = product.name && product.name.length > 45 && isDesktop;

  var departureCities = Object(toConsumableArray["a" /* default */])(bookingCriteria.departureCities || []);

  return PriceRemoteContent_jsx("div", {
    className: className,
    style: style
  }, PriceRemoteContent_jsx(PriceRemoteTicket_PriceRemoteTicket, {
    className: classnames_default()({
      'mb-px10': isStickyAndIsNotCompact || !isSticky,
      'mb-0': isStickyAndIsMobile,
      'w-full': isNotCompactAndIsDesktop || !isDesktop
    }),
    product: product,
    departureCities: departureCities,
    initialTransport: bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialTransport
  }), PriceRemoteContent_jsx(PriceRemoteForm_PriceRemoteForm, {
    className: classnames_default()({
      'fadeIn w-full': isNotCompactAndIsDesktop || !isDesktop,
      'flex items-center': isCompactAndIsDesktop,
      'm-auto': isLongResortTitle
    }),
    departureCities: departureCities,
    initialDuration: bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialDuration,
    initialTransport: bookingCriteria === null || bookingCriteria === void 0 ? void 0 : bookingCriteria.initialTransport,
    isJoyview: product.isJoyview,
    isStickyAndIsDesktop: isStickyAndIsDesktop,
    product: product,
    productId: product.id,
    reassurance: reassurance,
    transportIcon: product.transportType,
    urgentisationRate: urgentisationRate
  }));
};
// EXTERNAL MODULE: ./src/client/components/widgets/product-services/product-service/ProductService.jsx
var ProductService = __webpack_require__("9OZL");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-service-list/PriceRemoteServiceList.jsx

var PriceRemoteServiceList_jsx = react_default.a.createElement;



var PriceRemoteServiceList_PriceRemoteServiceList = function PriceRemoteServiceList(_ref) {
  var services = _ref.services,
      isDesktop = _ref.isDesktop;
  return PriceRemoteServiceList_jsx("div", {
    className: classnames_default()('text-base', {
      'w-1/2 px-px20': isDesktop,
      'w-full': !isDesktop
    })
  }, services.map(function (service) {
    return PriceRemoteServiceList_jsx(ProductService["a" /* ProductService */], {
      key: service.label,
      service: service
    });
  }), !isDesktop ? PriceRemoteServiceList_jsx("div", {
    style: {
      height: '40px'
    }
  }) : null);
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-details/PriceRemoteDetails.jsx



var PriceRemoteDetails_jsx = react_default.a.createElement;










var PriceRemoteDetails_PriceRemoteDetails = function PriceRemoteDetails(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      isLoading = _ref.isLoading,
      isSticky = _ref.isSticky,
      shouldDisplayAlternativePriceTitle = _ref.shouldDisplayAlternativePriceTitle;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      priceRemoteContext = _useContext[0],
      setPriceRemoteContext = _useContext[1];

  Object(react["useEffect"])(function () {
    if (allInclusiveServices && allInclusiveServices.length > 0 && isDesktop) {
      setPriceRemoteContext({
        isDetailOpened: true
      });
    }
  }, [allInclusiveServices.map(function (_ref2) {
    var label = _ref2.label;
    return label;
  }).join('|'), isSticky]);
  var trackingData = {
    event: 'eventGA',
    categoryGA: 'resort',
    actionGA: 'priceBar',
    labelGA: 'checkPrices',
    valueGA: '0',
    nonInteraction: '0'
  };
  var linkToCalendar = Object(src_i18n["h" /* t */])('priceRemote.linkToCalendar');
  var splitServices = allInclusiveServices && allInclusiveServices.length > 0 ? Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(allInclusiveServices), Object(lodash["ceil"])(allInclusiveServices.length / 2)) : [];
  return PriceRemoteDetails_jsx(react_collapse_lib["Collapse"], {
    className: "px-px20",
    isOpened: priceRemoteContext.isDetailOpened
  }, PriceRemoteDetails_jsx("div", {
    className: classnames_default()('absolute', {
      'rtl:right-0 mt-px5': isDesktop,
      'flex w-full mt-px40 justify-center': !isDesktop
    })
  }, !(priceRemoteContext.isDetailOpened || isSticky) && linkToCalendar && PriceRemoteDetails_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "bg-transparent text-center text-blue underline text-base font-bold",
    trackingData: trackingData,
    url: "#booking"
  }, linkToCalendar)), shouldDisplayAlternativePriceTitle && PriceRemoteDetails_jsx("div", {
    className: "text-base text-blue font-bold text-center pt-px10 pb-px5"
  }, Object(src_i18n["h" /* t */])('priceRemote.rateCounterProposalLabel')), priceRemoteContext.isTotalPrice && PriceRemoteDetails_jsx("div", {
    className: "text-base text-blue font-bold text-center pt-px10 pb-px5"
  }, Object(src_i18n["h" /* t */])('priceRemote.priceForAll')), PriceRemoteDetails_jsx("div", {
    className: classnames_default()('flex flex-wrap pb-px10 lg:pb-px20 transition-opacity', {
      'opacity-25': isLoading
    }),
    "data-testid": "price-remote-details-container"
  }, splitServices[0] ? PriceRemoteDetails_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: isDesktop,
    services: splitServices[0]
  }) : null, splitServices[1] ? PriceRemoteDetails_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: isDesktop,
    services: splitServices[1]
  }) : null));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-details-layer/PriceRemoteDetailsLayer.jsx
var PriceRemoteDetailsLayer_jsx = react_default.a.createElement;










var REMOTE_HEIGHT = '250px';
var PriceRemoteDetailsLayer_PriceRemoteDetailsLayer = function PriceRemoteDetailsLayer(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      closeLabel = _ref.closeLabel,
      isLoading = _ref.isLoading,
      onBack = _ref.onBack,
      nameRender = _ref.nameRender,
      children = _ref.children;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      isTotalPrice = _useContext[0].isTotalPrice,
      setPriceRemoteContext = _useContext[1];

  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      isInLayer: true
    });
    return function () {
      setPriceRemoteContext({
        isInLayer: false
      });
    };
  }, []);
  var layerHeaderTitle = Object(src_i18n["h" /* t */])('priceRemote.openAllInclusiveDetails');
  return PriceRemoteDetailsLayer_jsx(Layer["b" /* Layer */], {
    ariaLabel: layerHeaderTitle,
    ariaLabelledby: identifiers_constants["x" /* ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS */],
    buttonLeft: {
      label: Object(src_i18n["h" /* t */])('common.backNavigation'),
      iconName: icons["a" /* ICONS */].LEFT_ARROW,
      onClick: onBack
    },
    closeLabel: closeLabel,
    hasAnimateEnter: true,
    header: PriceRemoteDetailsLayer_jsx("span", {
      id: identifiers_constants["x" /* ID_LAYER_HEADER__SHOPPING__PRICE_REMOTE_DETAILS */],
      className: "w-full text-center block"
    }, layerHeaderTitle),
    onClose: onBack,
    portalName: nameRender || Portal_constants["c" /* BEFORE_APP */]
  }, PriceRemoteDetailsLayer_jsx("div", {
    className: classnames_default()('flex flex-col px-px20 items-center scroll-y transition-opacity', {
      'opacity-25': isLoading
    }),
    style: {
      height: "calc(100% - (".concat(REMOTE_HEIGHT, " - 60px))")
    },
    "data-testid": "price-remote-details-layer-container"
  }, isTotalPrice ? PriceRemoteDetailsLayer_jsx("div", {
    className: "text-base text-blue font-bold text-center pt-px20 pb-px5 lg:pt-px10"
  }, Object(src_i18n["h" /* t */])('priceRemote.priceForAll')) : null, allInclusiveServices && allInclusiveServices.length > 0 ? PriceRemoteDetailsLayer_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    services: allInclusiveServices,
    isDesktop: false
  }) : PriceRemoteDetailsLayer_jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })), children);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/strip-button/StripButton.jsx + 1 modules
var StripButton = __webpack_require__("ZpYc");

// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/price-remote-title-button/PriceRemoteTitleButton.jsx

var PriceRemoteTitleButton_jsx = react_default.a.createElement;








var PriceRemoteTitleButton_PriceRemoteTitleButton = function PriceRemoteTitleButton(_ref) {
  var handleClick = _ref.handleClick,
      isCollapsed = _ref.isCollapsed,
      isDesktop = _ref.isDesktop,
      _ref$isSticky = _ref.isSticky,
      isSticky = _ref$isSticky === void 0 ? false : _ref$isSticky;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      isJoyview = _useContext[0].isJoyview;

  var buttonLabel = isCollapsed ? Object(src_i18n["h" /* t */])('priceRemote.closeAllInclusiveDetails') : Object(src_i18n["h" /* t */])('priceRemote.openAllInclusiveDetails');
  var color = isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colors["a" /* COLORS */].BLUE;
  return isSticky && !isDesktop ? PriceRemoteTitleButton_jsx("button", {
    className: "bg-transparent text-center text-".concat(color, " underline text-base font-bold pt-px5 pb-px10"),
    onClick: handleClick,
    type: "button"
  }, buttonLabel, PriceRemoteTitleButton_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-blue rtl:ml-px10 transition-transform', Object(defineProperty["a" /* default */])({}, 'rotate-180', isCollapsed)),
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.625rem"
  })) : PriceRemoteTitleButton_jsx(StripButton["a" /* StripButton */], {
    className: "font-bold text-center text-".concat(color, " text-sm underline"),
    height: 30,
    onClick: handleClick,
    orientation: isSticky && isDesktop ? 'top' : 'bottom'
  }, PriceRemoteTitleButton_jsx("div", {
    className: "flex items-center text-base"
  }, buttonLabel, PriceRemoteTitleButton_jsx("div", {
    className: classnames_default()('rtl:ml-px10', Object(defineProperty["a" /* default */])({}, 'rotate-180', isSticky && isDesktop))
  }, PriceRemoteTitleButton_jsx(Icon["a" /* Icon */], {
    className: classnames_default()('text-blue transition-transform', Object(defineProperty["a" /* default */])({}, 'rotate-180', isCollapsed)),
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH_DOWN,
    width: "0.625rem"
  }))));
};
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.helper.js



var allInclusiveServices_helper_fetchAllInclusiveServices = function fetchAllInclusiveServices(appContext, criteria) {
  var allInclusiveServicesArgs = Object(graphql["a" /* buildArgs */])(criteria);
  var query = "query {\n      allInclusiveServices(".concat(allInclusiveServicesArgs, ") {\n        description\n        icon\n        label\n        type\n      }\n    }\n  ");
  return graphqlClient["a" /* default */].runQuery(query, appContext, {
    requestName: requestDictionary["wd" /* STATE_PRODUCT_ALL_INCLUSIVE_SERVICES */]
  });
};
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.actions.js



var allInclusiveServices_actions_getAllInclusiveServices = function getAllInclusiveServices(appContext, criteria) {
  return Object(createAction["a" /* createOptimisticAction */])(price_remote_constants["a" /* ALL_INCLUSIVE_SERVICES_REQUEST */], {}, {
    optimist: true,
    promise: allInclusiveServices_helper_fetchAllInclusiveServices(appContext, criteria)
  });
};
// CONCATENATED MODULE: ./src/client/store/price-remote/all-inclusive-services/allInclusiveServices.selector.js


var allInclusiveServicesSelector = Object(reselect_lib["createSelector"])(priceRemote_selector_priceRemoteSelector, function (_ref) {
  var data = _ref.allInclusiveServices.data;
  return data;
});
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/PriceRemote.jsx


var PriceRemote_jsx = react_default.a.createElement;




























var ALL_INCLUSIVE_SERVICES_TYPES = dist["constants"].ALL_INCLUSIVE_SERVICES_TYPES;
var PriceRemote_PriceRemote = function PriceRemote(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      isSticky = _ref.isSticky,
      product = _ref.product,
      reassurance = _ref.reassurance,
      urgentisationRate = _ref.urgentisationRate;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useContext = Object(react["useContext"])(PriceRemoteContext),
      isDetailOpened = _useContext[0].isDetailOpened,
      setPriceRemoteContext = _useContext[1];

  var _useContext2 = Object(react["useContext"])(CriteriaContext["a" /* CriteriaContext */]),
      criteriaContext = _useContext2[0],
      setCriteriaContext = _useContext2[1];

  var _useCriteriaDisplayCo = Object(CriteriaDisplayContext["c" /* useCriteriaDisplayContext */])(),
      _useCriteriaDisplayCo2 = Object(slicedToArray["a" /* default */])(_useCriteriaDisplayCo, 1),
      criteriaDisplayContext = _useCriteriaDisplayCo2[0];

  var dispatch = Object(es["d" /* useDispatch */])();
  var track = Object(useTracking["a" /* useTracking */])();
  var allInclusiveServices = Object(es["e" /* useSelector */])(allInclusiveServicesSelector);
  var allInclusiveServicesIsLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.priceRemote.allInclusiveServices.isLoading;
  });
  var adultsNumber = Object(es["e" /* useSelector */])(function (state) {
    return state.tripInformation.adults.length;
  });
  var shouldDisplayAlternativePriceTitle = Object(es["e" /* useSelector */])(shouldDisplayAlternativePriceTitleSelector);

  var _useSelector = Object(es["e" /* useSelector */])(function (state) {
    var _state$priceRemote$pr = state.priceRemote.priceOfStay,
        priceOfStayData = _state$priceRemote$pr.data,
        priceOfStayIsLoading = _state$priceRemote$pr.isLoading;
    return {
      priceOfStay: priceOfStayData || {},
      priceIsLoading: !priceOfStayData && Object(calendar_selector["e" /* getCalendarLoading */])(state) || priceOfStayData && priceOfStayIsLoading
    };
  }),
      priceOfStay = _useSelector.priceOfStay,
      priceIsLoading = _useSelector.priceIsLoading;

  var filteredAllInclusiveServices = criteriaContext ? allInclusiveServices.filter(function (_ref2) {
    var type = _ref2.type;

    switch (type) {
      case ALL_INCLUSIVE_SERVICES_TYPES.TRANSPORT:
        return criteriaContext.criteriaTransportIsSet;

      case ALL_INCLUSIVE_SERVICES_TYPES.CHILDCARE:
        return criteriaContext.criteriaWhoIsSet;

      default:
        return true;
    }
  }) : allInclusiveServices;
  var isStickyAndIsMobile = isSticky && !isDesktop;
  var isStickyAndIsDesktop = isSticky && isDesktop;
  var isJoyView = product.isJoyview;
  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      isJoyview: isJoyView
    });
    setCriteriaContext({
      isJoyview: isJoyView
    });
  }, [isJoyView]);
  Object(react["useEffect"])(function () {
    setPriceRemoteContext({
      isCompact: isSticky && !isDetailOpened
    });
  }, [isSticky, isDetailOpened]);
  Object(react["useEffect"])(function () {
    if (isSticky && isDesktop) {
      setPriceRemoteContext({
        isDetailOpened: !isSticky
      });
    }
  }, [isSticky]);
  Object(react["useEffect"])(function () {
    if (!adultsNumber) {
      dispatch(Object(adults_action["b" /* setAdultsNumber */])(adults_constants["a" /* DEFAULT_ADULTS_NB */]));
    }

    return function () {
      dispatch(priceOfStay_actions_resetPriceOfStay());
    };
  }, []);
  Object(react["useEffect"])(function () {
    var isOpen = criteriaDisplayContext.criteriaWhenIsOpen || criteriaDisplayContext.criteriaWhoIsOpen || criteriaDisplayContext.criteriaTransportIsOpen;
    setPriceRemoteContext({
      isOverrideSticky: !isOpen
    });

    if (isOpen) {
      Object(scrollToElement["a" /* scrollToElement */])('.PriceRemoteStickyWrapper-initialPosition');
    }
  }, [criteriaDisplayContext.criteriaWhenIsOpen, criteriaDisplayContext.criteriaWhoIsOpen, criteriaDisplayContext.criteriaTransportIsOpen]);
  Object(react["useEffect"])(function () {
    if (product.id && (priceOfStay.productId === product.id || !priceIsLoading && !priceOfStay.productId)) {
      dispatch(allInclusiveServices_actions_getAllInclusiveServices(appContext, {
        accommodationId: priceOfStay.accommodationId,
        accommodationLabel: priceOfStay.accommodationLabel,
        productId: product.id,
        includesTransportation: priceOfStay.includesTransportation,
        includesChildcare: priceOfStay.includesChildcare
      }));
    }
  }, [priceOfStay.accommodationId, priceOfStay.accommodationLabel, priceOfStay.includesTransportation, priceOfStay.includesChildcare, product.id, priceIsLoading]);
  var isLoading = priceIsLoading || allInclusiveServicesIsLoading;
  Object(react["useEffect"])(function () {
    var _priceOfStay$gap;

    if (shouldDisplayAlternativePriceTitle) {
      track({
        actionGA: 'remotePrice',
        labelGA: 'counterProposal_rate10'
      });
    }

    if (((_priceOfStay$gap = priceOfStay === null || priceOfStay === void 0 ? void 0 : priceOfStay.gap) !== null && _priceOfStay$gap !== void 0 ? _priceOfStay$gap : 0) >= proposals_constants["r" /* PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD */]) {
      track({
        actionGA: 'remotePrice',
        labelGA: 'counterProposal_rate30'
      });
    }
  }, [priceOfStay === null || priceOfStay === void 0 ? void 0 : priceOfStay.gap]);
  return PriceRemote_jsx(SiteContainer["a" /* SiteContainer */], {
    className: classnames_default()({
      'mb-px10': isStickyAndIsDesktop,
      'bg-white border-t-1 border-gray-light slideInBottom': isStickyAndIsMobile
    })
  }, PriceRemote_jsx("div", {
    className: classnames_default()('bg-white relative', {
      'border-1 rounded-small shadow-sm': !isStickyAndIsMobile
    })
  }, PriceRemote_jsx(react["Fragment"], null, PriceRemote_jsx(PriceRemoteContent_PriceRemoteContent, {
    bookingCriteria: bookingCriteria,
    className: classnames_default()('lg:flex flex-wrap p-px10', {
      flex: !isDesktop && !isDetailOpened,
      'lg:flex-no-wrap': isSticky && !isDetailOpened
    }),
    isSticky: isSticky,
    product: product,
    reassurance: reassurance,
    urgentisationRate: urgentisationRate
  }), isDesktop && isDetailOpened ? PriceRemote_jsx(PriceRemoteDetails_PriceRemoteDetails, {
    allInclusiveServices: filteredAllInclusiveServices,
    isSticky: isSticky,
    shouldDisplayAlternativePriceTitle: shouldDisplayAlternativePriceTitle,
    isLoading: isLoading
  }) : null, PriceRemote_jsx("div", {
    className: classnames_default()('flex items-center justify-center', {
      'absolute left-1/2 -translate-x-50': !isSticky || isSticky && isDesktop,
      'bottom-full': isSticky && isDesktop
    })
  }, PriceRemote_jsx(PriceRemoteTitleButton_PriceRemoteTitleButton, {
    isCollapsed: isDetailOpened,
    isDesktop: isDesktop,
    isJoyview: isJoyView,
    isSticky: isSticky,
    handleClick: function handleClick() {
      if (!isDetailOpened && !isSticky) {
        Object(scrollToElement["a" /* scrollToElement */])('.PriceRemoteStickyWrapper-initialPosition');
      }

      setPriceRemoteContext({
        isDetailOpened: !isDetailOpened,
        hasOpenedDetailsAtLeastOnce: true
      });
    }
  }))), !isDesktop && isDetailOpened ? PriceRemote_jsx(PriceRemoteDetailsLayer_PriceRemoteDetailsLayer, {
    allInclusiveServices: filteredAllInclusiveServices,
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    isLoading: isLoading,
    nameRender: Portal_constants["b" /* AFTER_APP */],
    onBack: function onBack() {
      return setPriceRemoteContext({
        isDetailOpened: false
      });
    }
  }, PriceRemote_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, PriceRemote_jsx(PriceRemoteContent_PriceRemoteContent, {
    bookingCriteria: bookingCriteria,
    className: "bg-white mt-auto p-px20 w-full",
    isSticky: isSticky,
    product: product,
    urgentisationRate: urgentisationRate
  }))) : null, PriceRemote_jsx("div", {
    className: "absolute lg:block flex justify-center mt-px40 lg:mt-px5 lg:rtl:right-0 w-full lg:w-auto"
  }, !(isDetailOpened || isSticky) && PriceRemote_jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "bg-transparent font-bold text-base text-blue text-center underline",
    trackingData: {
      actionGA: 'priceBar',
      categoryGA: 'resort',
      event: 'eventGA',
      labelGA: 'checkPrices',
      nonInteraction: '0',
      valueGA: '0'
    },
    url: "#booking"
  }, Object(src_i18n["h" /* t */])('priceRemote.linkToCalendar')))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-remote/PriceRemoteStickyWrapper.jsx

var PriceRemoteStickyWrapper_jsx = react_default.a.createElement;










var PriceRemoteStickyWrapper_PriceRemoteStickyWrapper = function PriceRemoteStickyWrapper(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      product = _ref.product,
      reassurance = _ref.reassurance,
      urgentisationRate = _ref.urgentisationRate;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var bottomBoundary = '.PriceTicket-sticky-beacon';

  var onStateChange = function onStateChange(status) {
    setIsSticky(status.status !== Sticky_default.a.STATUS_ORIGINAL);
  };

  var isPriceRemoteEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('priceRemote.enabled');

  if (!isPriceRemoteEnabled) {
    return null;
  }

  return PriceRemoteStickyWrapper_jsx(PriceRemoteContext_PriceRemoteContextProvider, null, PriceRemoteStickyWrapper_jsx(CriteriaContext["b" /* CriteriaContextProvider */], {
    value: {
      layerButtonLabel: Object(src_i18n["h" /* t */])('booking.editCriteria.validateCriteria'),
      trackingActionName: 'priceBar'
    }
  }, PriceRemoteStickyWrapper_jsx("div", {
    className: "".concat(PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME, " -mt-px10 pb-px10")
  }), PriceRemoteStickyWrapper_jsx(PriceRemoteContext.Consumer, null, function (_ref2) {
    var _ref3 = Object(slicedToArray["a" /* default */])(_ref2, 1),
        _ref3$ = _ref3[0],
        isOverrideSticky = _ref3$.isOverrideSticky,
        isDetailOpened = _ref3$.isDetailOpened;

    return PriceRemoteStickyWrapper_jsx(Sticky_default.a, {
      activeClass: "sticky-bottom",
      bottomBoundary: bottomBoundary,
      enabled: isOverrideSticky,
      innerZ: isOverrideSticky && !isDetailOpened ? 2 : 6,
      onStateChange: onStateChange,
      releasedClass: "sticky-bottom-released"
    }, PriceRemoteStickyWrapper_jsx(CriteriaDisplayContext["b" /* CriteriaDisplayProvider */], null, PriceRemoteStickyWrapper_jsx(PriceRemote_PriceRemote, {
      bookingCriteria: bookingCriteria,
      isSticky: isSticky,
      product: product,
      reassurance: reassurance,
      urgentisationRate: urgentisationRate
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-price-remote-line/ProductPriceRemoteLine.jsx
var ProductPriceRemoteLine_jsx = react_default.a.createElement;





var ProductPriceRemoteLine_ProductPriceRemoteLine = function ProductPriceRemoteLine(_ref) {
  var bookingCriteria = _ref.bookingCriteria,
      product = _ref.product,
      config = _ref.config;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  var isEnabled = Object(featureFlippingUtils["a" /* isFeatureFlipped */])(appContext)('priceRemote.enabled');

  if (!product || !bookingCriteria || !isEnabled) {
    return null;
  }

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var urgentisationRate = config.booking.priceCalendar.offers.urgentisation.rateToDisplay;
  var reassurance = config.faceting.transport.reassurance;
  return ProductPriceRemoteLine_jsx("div", {
    className: "Line Line-PriceRemote mb-px80 lg:mb-px40",
    "data-testid": "Line-ProductPriceRemote"
  }, ProductPriceRemoteLine_jsx(PriceRemoteStickyWrapper_PriceRemoteStickyWrapper, {
    bookingCriteria: bookingCriteria,
    key: product.id,
    product: product,
    reassurance: reassurance,
    urgentisationRate: urgentisationRate
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-remote/productPriceRemote.resolver.js
var productPriceRemote_resolver = __webpack_require__("+82i");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-remote/productPriceRemote.descriptor.js



var productPriceRemoteDescriptor = {
  name: constants["mb" /* RESORT_PRICE_REMOTE */],
  component: ProductPriceRemoteLine_ProductPriceRemoteLine,
  resolve: productPriceRemote_resolver["a" /* productPriceRemoteResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/productQuotationForm.constants.js
var QUOTATION_FORM_SECTION_ID = 'quotation-form-section';
var QUOTATION_FORM_ID = 'product-quotation-form';
var productQuotationForm_constants_MAX_FORM_ADULTS = 6;
var productQuotationForm_constants_MAX_FORM_KIDS = 6;
var MAX_FORM_TEENS = 6;
var productQuotationForm_constants_MIN_FORM_ADULTS = 1;
var productQuotationForm_constants_MIN_FORM_KIDS = 0;
var MIN_FORM_TEENS = 1;
var NO_VALUE = 'NO';
var RANGE_ESCAPADE = 'escapade';
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/priceTicket.mapper.js
















function priceTicket_mapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function priceTicket_mapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      priceTicket_mapper_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      priceTicket_mapper_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var priceTicket_mapper_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var priceTicket_mapper_getPriceTicketButton = function getPriceTicketButton(product) {
  var props = {
    children: Object(src_i18n["h" /* t */])('productPriceTicketLine.seeAllPrices'),
    colorBg: colors["a" /* COLORS */].BOOKING,
    colorBorder: colors["a" /* COLORS */].BOOKING,
    iconLeft: {
      name: icons["a" /* ICONS */].DATE
    },
    url: '#booking',
    trackingData: {
      actionGA: 'priceBar',
      labelGA: 'checkPrices'
    }
  };

  switch (product.type) {
    case priceTicket_mapper_PRODUCT_TYPES.TOUR:
      return priceTicket_mapper_objectSpread(priceTicket_mapper_objectSpread({}, props), {}, {
        iconLeft: null,
        children: Object(src_i18n["h" /* t */])('productPriceTicketLine.askForQuotation'),
        url: "#".concat(QUOTATION_FORM_SECTION_ID)
      });

    case priceTicket_mapper_PRODUCT_TYPES.CRUISE:
      return priceTicket_mapper_objectSpread(priceTicket_mapper_objectSpread({}, props), {}, {
        iconLeft: null,
        children: Object(src_i18n["h" /* t */])('productPriceTicketLine.book')
      });

    default:
      return props;
  }
};
var getPriceTicketSubtitle = function getPriceTicketSubtitle(product, cruise) {
  var _product$destination = product.destination,
      destination = _product$destination === void 0 ? {} : _product$destination,
      _product$type = product.type,
      type = _product$type === void 0 ? '' : _product$type;

  switch (type) {
    case priceTicket_mapper_PRODUCT_TYPES.CRUISE:
      return (cruise === null || cruise === void 0 ? void 0 : cruise.fromToDestination) || '';

    default:
      return destination.country || '';
  }
};
var priceTicket_mapper_getPriceTicketInfo = function getPriceTicketInfo(_ref) {
  var type = _ref.type;

  switch (type) {
    case priceTicket_mapper_PRODUCT_TYPES.TOUR:
      return {};

    case priceTicket_mapper_PRODUCT_TYPES.JOYVIEW:
      return {
        iconName: icons["a" /* ICONS */].ACCOMODATIONS,
        label: Object(src_i18n["h" /* t */])('resort.startingPrice.roomOnly')
      };

    default:
      return {
        iconName: icons["a" /* ICONS */].ALL_INCLUSIVE,
        label: Object(src_i18n["h" /* t */])('resort.startingPrice.allInclusive')
      };
  }
};

var getPriceTicketItem = function getPriceTicketItem(item) {
  return item.longDesc || item.shortDesc ? item : null;
};

var priceTicket_mapper_getPriceTicketItems = function getPriceTicketItems(_ref2) {
  var _price$termsAndCondit, _price$termsAndCondit2, _price$termsAndCondit3, _price$termsAndCondit4, _price$termsAndCondit5, _price$termsAndCondit6, _price$termsAndCondit7;

  var product = _ref2.product,
      price = _ref2.price,
      fromStore = _ref2.fromStore;
  var type = product.type;
  var duration = fromStore.duration || product.duration || '';
  /* departureDate */

  var departureDateValue = fromStore.departureDate ? moment_default()(fromStore.departureDate).format(date_apiDate["a" /* API_DATE_FORMAT */]) : ((_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.departureDate) || 0;
  var longDateFormat = Object(src_i18n["h" /* t */])('productPriceTicketLine.departureDateFormat');
  var shortDateFormat = Object(src_i18n["h" /* t */])('productPriceTicketLine.condensedDepartureDateFormat');
  var dValue = moment_default()(departureDateValue, 'YYYYMMDD');
  var departureDate = type !== priceTicket_mapper_PRODUCT_TYPES.TOUR ? getPriceTicketItem({
    iconName: icons["a" /* ICONS */].DATE,
    label: Object(src_i18n["h" /* t */])('productPriceTicketLine.departureDateLabel'),
    longDesc: "".concat(dValue.format(longDateFormat), " - ").concat(moment_default()(dValue).add(((_price$termsAndCondit2 = price.termsAndConditions) === null || _price$termsAndCondit2 === void 0 ? void 0 : _price$termsAndCondit2.duration) || 0, 'days').format(longDateFormat)),
    shortDesc: "".concat(dValue.format(shortDateFormat), " - ").concat(moment_default()(dValue).add(((_price$termsAndCondit3 = price.termsAndConditions) === null || _price$termsAndCondit3 === void 0 ? void 0 : _price$termsAndCondit3.duration) || 0, 'days').format(shortDateFormat)),
    subDesc: Object(src_i18n["h" /* t */])('booking.form.selectDuration', {
      duration: ((_price$termsAndCondit4 = price.termsAndConditions) === null || _price$termsAndCondit4 === void 0 ? void 0 : _price$termsAndCondit4.duration) || 0
    })
  }) : null;
  /* duration */

  var durationTour = type === priceTicket_mapper_PRODUCT_TYPES.TOUR ? getPriceTicketItem({
    iconName: icons["a" /* ICONS */].DURATION,
    longDesc: duration,
    shortDesc: duration
  }) : null;
  /* transport */

  var departureCityName = fromStore.departureCity || ((_price$termsAndCondit5 = price.termsAndConditions) === null || _price$termsAndCondit5 === void 0 ? void 0 : (_price$termsAndCondit6 = _price$termsAndCondit5.departureCity) === null || _price$termsAndCondit6 === void 0 ? void 0 : _price$termsAndCondit6.name);
  var transport = departureCityName && departureCityName !== 'NO' ? getPriceTicketItem({
    iconName: product.transportType || icons["a" /* ICONS */].TRANSPORT,
    label: Object(src_i18n["h" /* t */])('productPriceTicketLine.departureCityLabel'),
    longDesc: departureCityName
  }) : getPriceTicketItem({
    iconName: icons["a" /* ICONS */].NO_TRANSPORT,
    label: Object(src_i18n["h" /* t */])('productPriceTicketLine.departureCityLabel'),
    longDesc: Object(src_i18n["h" /* t */])('booking.form.withoutTransport')
  });
  /* accommodations */
  // const key =
  //   parseInt(fromStore.duration, 10) === 1
  //     ? 'faceting.when.durationSingular'
  //     : 'faceting.when.durationPlural';
  // const priceDurationFormatted = fromStore.duration
  //   ? messageFormat(t(key)).format({
  //       n: fromStore.duration,
  //     })
  //   : price.termsAndConditions?.durationFormatted;
  // const displayedDuration = type === PRODUCT_TYPES.CRUISE ? duration : priceDurationFormatted;
  // const accommodations =
  //   type !== PRODUCT_TYPES.TOUR
  //     ? getPriceTicketItem({
  //         iconName: ICONS.ACCOMODATIONS,
  //         label: displayedDuration,
  //         longDesc: price.termsAndConditions?.accommodationComfortLabel,
  //       })
  //     : null;

  /* persons */

  var numberOfAdults = fromStore.adultsNumber || Number((_price$termsAndCondit7 = price.termsAndConditions) === null || _price$termsAndCondit7 === void 0 ? void 0 : _price$termsAndCondit7.numberOfAdults) || 0;
  var personLabel = numberOfAdults > 1 ? Object(src_i18n["h" /* t */])('productPriceTicketLine.adults') : Object(src_i18n["h" /* t */])('productPriceTicketLine.adult');
  var persons = getPriceTicketItem({
    iconName: icons["a" /* ICONS */].USERS,
    label: numberOfAdults.toString(),
    longDesc: [numberOfAdults.toString(), personLabel].join(' ').trim(),
    shortDesc: numberOfAdults.toString()
  });
  return [departureDate, durationTour, persons, transport].filter(Boolean);
};
// EXTERNAL MODULE: ./src/client/components/frameworks/block-link/BlockLink.jsx
var BlockLink = __webpack_require__("Onl6");

// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket-large/PriceTicketLarge.jsx



var PriceTicketLarge_jsx = react_default.a.createElement;





















var PriceTicketLarge_ICONS_HEIGHT = 50;
var PriceTicketLarge_PriceTicketLarge = function PriceTicketLarge(_ref) {
  var _ref$allInclusiveServ = _ref.allInclusiveServices,
      allInclusiveServices = _ref$allInclusiveServ === void 0 ? [] : _ref$allInclusiveServ,
      button = _ref.button,
      badgeIcon = _ref.badgeIcon,
      className = _ref.className,
      _ref$hasCallCenter = _ref.hasCallCenter,
      hasCallCenter = _ref$hasCallCenter === void 0 ? false : _ref$hasCallCenter,
      _ref$hasECLogo = _ref.hasECLogo,
      hasECLogo = _ref$hasECLogo === void 0 ? false : _ref$hasECLogo,
      info = _ref.info,
      _ref$isLite = _ref.isLite,
      isLite = _ref$isLite === void 0 ? false : _ref$isLite,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isPriceFullWidth = _ref.isPriceFullWidth,
      isPriceFullWidth = _ref$isPriceFullWidth === void 0 ? false : _ref$isPriceFullWidth,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      price = _ref.price,
      subtitle = _ref.subtitle,
      title = _ref.title,
      travelAdvisorConfig = _ref.travelAdvisorConfig,
      _ref$fromPriceTicketC = _ref.fromPriceTicketCustom,
      fromPriceTicketCustom = _ref$fromPriceTicketC === void 0 ? false : _ref$fromPriceTicketC;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  Object(react["useEffect"])(function () {
    setIsDetailOpened(false);
  }, [isLite]);

  if (!title) {
    return null;
  }

  var hasDetail = !isLite && !hasCallCenter && (!Object(lodash["isEmpty"])(items) || !Object(lodash["isEmpty"])(info));
  var scroll = button && button.url && /^(#|\.)/.test(button.url) ? function () {
    return Object(scrollToElement["a" /* scrollToElement */])(button.url, 500);
  } : lodash["noop"];
  var splitServices = allInclusiveServices && allInclusiveServices.length > 0 ? Object(lodash["chunk"])(Object(toConsumableArray["a" /* default */])(allInclusiveServices), Object(lodash["ceil"])(allInclusiveServices.length / 2)) : [];
  return PriceTicketLarge_jsx("div", {
    className: classnames_default()(className, 'fadeInLong relative', {
      'mb-px10': isLite
    }),
    "data-testid": "PriceTicketLarge"
  }, PriceTicketLarge_jsx(SiteContainer["a" /* SiteContainer */], null, PriceTicketLarge_jsx("div", {
    className: classnames_default()('bg-white border-1 relative rounded-small shadow-sm', {
      'flex items-center justify-center opacity-75': isLoading
    }),
    style: {
      minHeight: MIN_HEIGHT
    }
  }, isLoading ? PriceTicketLarge_jsx(Spinner["a" /* Spinner */], {
    size: "small",
    color: colors["a" /* COLORS */].BLUE
  }) : PriceTicketLarge_jsx(react["Fragment"], null, PriceTicketLarge_jsx("div", {
    className: "flex items-center p-px10"
  }, PriceTicketLarge_jsx(Badge["a" /* Badge */], Object(esm_extends["a" /* default */])({}, badgeIcon, {
    className: "flex-shrink-0 rounded-tiny",
    size: PriceTicketLarge_ICONS_HEIGHT
  })), hasECLogo && (badgeIcon === null || badgeIcon === void 0 ? void 0 : badgeIcon.iconName) && PriceTicketLarge_jsx("span", {
    className: "font-brand mx-px5 text-base"
  }, "&"), hasECLogo && PriceTicketLarge_jsx(ECBadge["a" /* ECBadge */], {
    height: PriceTicketLarge_ICONS_HEIGHT,
    iconWidth: "80%"
  }), PriceTicketLarge_jsx("div", {
    className: "flex-auto mx-px10"
  }, PriceTicketLarge_jsx(Title["a" /* Title */], {
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 1,
    theme: "none"
  }, PriceTicketLarge_jsx("div", {
    className: "font-brand font-normal leading-tight text-xl",
    "data-testid": "priceTicket-title"
  }, title), PriceTicketLarge_jsx("div", {
    className: "font-sans font-bold leading-tight uppercase text-md",
    "data-testid": "priceTicket-subtitle"
  }, subtitle))), !Object(lodash["isEmpty"])(info) && PriceTicketLarge_jsx("div", {
    className: "flex items-center px-px10",
    "data-testid": "PriceTicketLarge-info"
  }, PriceTicketLarge_jsx(Icon["a" /* Icon */], {
    className: "-mt-px5",
    color: colors["a" /* COLORS */].BLUE,
    name: info.iconName,
    width: "1.2rem"
  }), PriceTicketLarge_jsx("span", {
    className: "font-brand mx-px10 text-blue text-md"
  }, info.label)), !hasCallCenter && !Object(lodash["isEmpty"])(price) && PriceTicketLarge_jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: classnames_default()('flex items-center px-px10', {
      'w-1/4': !isPriceFullWidth
    }),
    from: Object(src_i18n["h" /* t */])('price.format.from'),
    hasInitialPrice: false,
    instead: Object(src_i18n["h" /* t */])('price.format.instead'),
    theme: "remote"
  })), hasCallCenter && travelAdvisorConfig && PriceTicketLarge_jsx(BlockLink["a" /* BlockLink */], {
    className: classnames_default()('mx-px20 text-gray-darker', {
      'sr-only opacity-0 pointer-events-none': isLite
    }),
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: travelAdvisorConfig.text,
    url: travelAdvisorConfig.href
  }), (fromPriceTicketCustom || isLite || hasCallCenter) && PriceTicketLarge_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "rtl:ml-px20"
  }))), hasDetail && PriceTicketLarge_jsx("div", {
    className: "border-t-1 flex items-center justify-between p-px10"
  }, PriceTicketLarge_jsx("div", {
    className: "font-bold font-sans text-blue text-md w-1/4"
  }, Object(src_i18n["h" /* t */])('productPriceTicketLine.startingPriceCriteriaLabel', {}, '')), PriceTicketLarge_jsx("div", {
    className: "flex flex-1 items-stretch"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label,
        longDesc = _ref2.longDesc,
        subDesc = _ref2.subDesc;
    return PriceTicketLarge_jsx(DynamicLink["a" /* default */], {
      className: "flex flex-1 px-px10",
      "data-testid": "PriceTicketLarge-item",
      key: iconName,
      url: button === null || button === void 0 ? void 0 : button.url
    }, PriceTicketLarge_jsx(Icon["a" /* Icon */], {
      className: "flex-shrink-0",
      color: colors["a" /* COLORS */].BLUE,
      name: iconName,
      width: "1rem",
      title: label
    }), PriceTicketLarge_jsx("div", {
      className: "font-sans rtl:ml-px10 text-base text-gray-medium-dark"
    }, PriceTicketLarge_jsx("div", {
      className: "flex flex-col"
    }, PriceTicketLarge_jsx("div", null, longDesc), subDesc && PriceTicketLarge_jsx("div", {
      className: "font-bold"
    }, subDesc))));
  })), PriceTicketLarge_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "w-1/4",
    size: "large",
    onClick: scroll
  }))), !!(allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) && PriceTicketLarge_jsx(react["Fragment"], null, isDetailOpened && PriceTicketLarge_jsx(react_collapse_lib["Collapse"], {
    isOpened: isDetailOpened
  }, PriceTicketLarge_jsx("div", {
    className: "border-t-1 border-gray-light flex flex-wrap"
  }, splitServices[0] ? PriceTicketLarge_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: true,
    services: splitServices[0]
  }) : null, splitServices[1] ? PriceTicketLarge_jsx(PriceRemoteServiceList_PriceRemoteServiceList, {
    isDesktop: true,
    services: splitServices[1]
  }) : null)), PriceTicketLarge_jsx("div", {
    className: classnames_default()('absolute flex items-center justify-center left-1/2 -translate-x-50', {
      '-mt-px': !isLite,
      'bottom-full -mb-px': isLite
    })
  }, PriceTicketLarge_jsx(PriceRemoteTitleButton_PriceRemoteTitleButton, {
    handleClick: function handleClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    isCollapsed: isDetailOpened,
    isDesktop: true,
    isSticky: isLite
  })))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket-narrow/PriceTicketNarrow.jsx


var PriceTicketNarrow_jsx = react_default.a.createElement;


















var PriceTicketNarrow_PriceTicketNarrow = function PriceTicketNarrow(_ref) {
  var _ref$allInclusiveServ = _ref.allInclusiveServices,
      allInclusiveServices = _ref$allInclusiveServ === void 0 ? [] : _ref$allInclusiveServ,
      className = _ref.className,
      button = _ref.button,
      hasCallCenter = _ref.hasCallCenter,
      isLite = _ref.isLite,
      isLoading = _ref.isLoading,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      price = _ref.price,
      travelAdvisorConfig = _ref.travelAdvisorConfig;

  var _useState = Object(react["useState"])(false),
      isDetailOpened = _useState[0],
      setIsDetailOpened = _useState[1];

  var hasPrice = !hasCallCenter && !Object(lodash["isEmpty"])(price);
  var hasBlockLink = hasCallCenter && !isLite;
  var scroll = button && button.url && /^(#|\.)/.test(button.url) ? function () {
    return Object(scrollToElement["a" /* scrollToElement */])(button.url, 500);
  } : lodash["noop"];
  return PriceTicketNarrow_jsx("div", {
    className: classnames_default()(className, {
      'opacity-75': isLoading,
      fadeInLong: !isLite,
      slideInBottom: isLite
    }),
    "data-testid": "PriceTicketNarrow",
    style: {
      minHeight: MIN_HEIGHT
    }
  }, PriceTicketNarrow_jsx(SiteContainer["a" /* SiteContainer */], {
    isWide: isLite
  }, PriceTicketNarrow_jsx("div", {
    className: classnames_default()('bg-white border-t-1 flex flex-col items-center', {
      'border-1 rounded-small shadow-sm': !isLite
    })
  }, isLoading ? PriceTicketNarrow_jsx(Spinner["a" /* Spinner */], {
    className: "p-px10",
    size: "small",
    color: colors["a" /* COLORS */].BLUE
  }) : PriceTicketNarrow_jsx(react["Fragment"], null, hasBlockLink && travelAdvisorConfig && PriceTicketNarrow_jsx(BlockLink["a" /* BlockLink */], {
    className: "m-px10 text-gray-darker",
    icon: icons["a" /* ICONS */].PHONE_BUBBLE,
    texts: travelAdvisorConfig.text,
    url: travelAdvisorConfig.href
  }), hasPrice && PriceTicketNarrow_jsx(Price["a" /* Price */], Object(esm_extends["a" /* default */])({}, price, {
    className: "m-px10",
    from: Object(src_i18n["h" /* t */])('price.format.from'),
    hasInitialPrice: false,
    instead: Object(src_i18n["h" /* t */])('price.format.instead'),
    theme: "remote"
  })), PriceTicketNarrow_jsx("div", {
    className: classnames_default()('p-px10 w-full', {
      'border-t-1': !isLite
    })
  }, !isLite && !hasCallCenter && !!items.length && PriceTicketNarrow_jsx(react["Fragment"], null, PriceTicketNarrow_jsx("div", {
    className: "font-bold font-sans text-blue text-center text-sm"
  }, Object(src_i18n["h" /* t */])('productPriceTicketLine.startingPriceCriteriaLabel', {}, '')), PriceTicketNarrow_jsx("ul", {
    className: "reset-list flex items-center mb-px10 text-sm"
  }, items.map(function (_ref2) {
    var iconName = _ref2.iconName,
        shortDesc = _ref2.shortDesc,
        subDesc = _ref2.subDesc;
    return PriceTicketNarrow_jsx("li", {
      className: "flex-1",
      "data-testid": "PriceTicketNarrow-item",
      key: iconName
    }, PriceTicketNarrow_jsx(DynamicLink["a" /* default */], {
      className: "flex items-center justify-center text-gray-medium-dark",
      url: button === null || button === void 0 ? void 0 : button.url
    }, PriceTicketNarrow_jsx(Icon["a" /* Icon */], {
      className: "rtl:mr-px10",
      color: colors["a" /* COLORS */].BLUE,
      name: iconName,
      width: "1.25rem"
    }), PriceTicketNarrow_jsx("span", null, PriceTicketNarrow_jsx("span", null, shortDesc, ' ', subDesc && PriceTicketNarrow_jsx("div", {
      className: "font-bold"
    }, subDesc)))));
  }))), PriceTicketNarrow_jsx(Button["a" /* Button */], Object(esm_extends["a" /* default */])({}, button, {
    className: "w-full",
    size: "large",
    onClick: scroll
  }))), !!(allInclusiveServices === null || allInclusiveServices === void 0 ? void 0 : allInclusiveServices.length) && PriceTicketNarrow_jsx(react["Fragment"], null, isDetailOpened && PriceTicketNarrow_jsx(PriceRemoteDetailsLayer_PriceRemoteDetailsLayer, {
    allInclusiveServices: allInclusiveServices,
    closeLabel: Object(src_i18n["h" /* t */])('common.close'),
    isLoading: isLoading,
    nameRender: Portal_constants["b" /* AFTER_APP */],
    onBack: function onBack() {
      return setIsDetailOpened(false);
    }
  }), PriceTicketNarrow_jsx("div", {
    className: classnames_default()('absolute flex items-center justify-center left-1/2 -translate-x-50', {
      '-mt-px top-full': !isLite,
      'bottom-full -mb-px': isLite
    })
  }, PriceTicketNarrow_jsx(PriceRemoteTitleButton_PriceRemoteTitleButton, {
    handleClick: function handleClick() {
      return setIsDetailOpened(!isDetailOpened);
    },
    isCollapsed: isDetailOpened,
    isDesktop: true,
    isSticky: isLite
  })))))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/PriceTicketContentWrapper.jsx

var PriceTicketContentWrapper_jsx = react_default.a.createElement;












var PriceTicketContentWrapper_PriceTicketContentWrapper = function PriceTicketContentWrapper(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      history = _useRouter.history;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var onStateChange = function onStateChange(status) {
    setIsSticky(status.status !== Sticky_default.a.STATUS_ORIGINAL);
  };

  return PriceTicketContentWrapper_jsx(react["Fragment"], null, PriceTicketContentWrapper_jsx(SiteContainer["a" /* SiteContainer */], null, Object(sellerUtils["g" /* isSeller */])(appContext) && PriceTicketContentWrapper_jsx("button", {
    className: "flex items-center mb-px10 text-turquoise",
    "data-testid": "PriceTicketBackToSearch",
    onClick: history.back,
    type: "button"
  }, PriceTicketContentWrapper_jsx(Icon["a" /* Icon */], {
    className: "-scale-x-1 mr-px5",
    name: icons["a" /* ICONS */].BOLDER_ARROW_FORTH,
    width: "0.9rem"
  }), Object(src_i18n["h" /* t */])('common.comparator.backToSearch'))), PriceTicketContentWrapper_jsx(Sticky_default.a, {
    activeClass: "sticky-bottom",
    bottomBoundary: ".PriceTicket-sticky-beacon",
    innerZ: 6,
    onStateChange: onStateChange,
    releasedClass: "sticky-bottom-released"
  }, isDesktop ? PriceTicketContentWrapper_jsx(PriceTicketLarge_PriceTicketLarge, Object(esm_extends["a" /* default */])({}, props, {
    isLite: isSticky
  })) : PriceTicketContentWrapper_jsx(PriceTicketNarrow_PriceTicketNarrow, Object(esm_extends["a" /* default */])({}, props, {
    isLite: isSticky
  }))));
};
// CONCATENATED MODULE: ./src/client/components/widgets/price-ticket/PriceTicket.jsx



var PriceTicket_jsx = react_default.a.createElement;














var PriceTicket_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var MIN_HEIGHT = '4.25rem';
var PriceTicket_PriceTicket = function PriceTicket(_ref) {
  var _price$termsAndCondit3;

  var cruise = _ref.cruise,
      product = _ref.product,
      travelAdvisorConfig = _ref.travelAdvisorConfig;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var isLoading = Object(es["e" /* useSelector */])(function (state) {
    return state.priceTicket.isLoading;
  });
  var price = Object(es["e" /* useSelector */])(function (state) {
    return state.priceTicket.price;
  });
  var allInclusiveServices = Object(es["e" /* useSelector */])(allInclusiveServicesSelector);
  var dispatch = Object(es["d" /* useDispatch */])();
  Object(react["useEffect"])(function () {
    dispatch(priceTicketRequest({
      appContext: appContext,
      location: location,
      productId: product.id
    }));
  }, [product.id]);
  Object(react["useEffect"])(function () {
    var _price$termsAndCondit;

    if (product.id && product.id === (price === null || price === void 0 ? void 0 : (_price$termsAndCondit = price.termsAndConditions) === null || _price$termsAndCondit === void 0 ? void 0 : _price$termsAndCondit.productId)) {
      var _price$termsAndCondit2;

      dispatch(allInclusiveServices_actions_getAllInclusiveServices(appContext, {
        productId: product.id,
        accommodationId: price.termsAndConditions.accommodationId,
        includesTransportation: !!((_price$termsAndCondit2 = price.termsAndConditions.departureCity) === null || _price$termsAndCondit2 === void 0 ? void 0 : _price$termsAndCondit2.value)
      }));
    }
  }, [product.id === (price === null || price === void 0 ? void 0 : (_price$termsAndCondit3 = price.termsAndConditions) === null || _price$termsAndCondit3 === void 0 ? void 0 : _price$termsAndCondit3.productId)]);
  var fromStore = {
    adultsNumber: Object(es["e" /* useSelector */])(trip_information_storeHelper["b" /* getAdultsNumber */]),
    departureCity: Object(es["e" /* useSelector */])(tripCriteria_selector["a" /* getDepartureCity */]),
    departureDate: Object(es["e" /* useSelector */])(tripCriteria_selector["b" /* getDepartureDate */]),
    duration: Object(es["e" /* useSelector */])(tripCriteria_selector["c" /* getTripDuration */])
  };
  return PriceTicket_jsx(PriceTicketContentWrapper_PriceTicketContentWrapper, {
    allInclusiveServices: [PriceTicket_PRODUCT_TYPES.SUMMER_CAMP, PriceTicket_PRODUCT_TYPES.TOUR].includes(product.type) ? [] : allInclusiveServices,
    badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(product),
    button: priceTicket_mapper_getPriceTicketButton(product),
    hasCallCenter: !Object(price_util["d" /* hasAtLeastOnePrice */])(price),
    hasECLogo: product.isExplicitEC,
    info: priceTicket_mapper_getPriceTicketInfo(product),
    isLoading: isLoading,
    items: priceTicket_mapper_getPriceTicketItems({
      fromStore: fromStore,
      price: price,
      product: product
    }),
    price: price,
    subtitle: getPriceTicketSubtitle(product, cruise),
    title: product.name,
    travelAdvisorConfig: travelAdvisorConfig
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/product-price-ticket-line/ProductPriceTicketLine.jsx









var ProductPriceTicketLine_jsx = react_default.a.createElement;

function ProductPriceTicketLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductPriceTicketLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductPriceTicketLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductPriceTicketLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var ProductPriceTicketLine_DATE_FORMAT = 'D MMMM YYYY';
var ProductPriceTicketLine_ProductPriceTicketLine = function ProductPriceTicketLine(_ref) {
  var adult = _ref.adult,
      adults = _ref.adults,
      askForQuotation = _ref.askForQuotation,
      book = _ref.book,
      collapseLabels = _ref.collapseLabels,
      condensedDepartureDateFormat = _ref.condensedDepartureDateFormat,
      config = _ref.config,
      cruise = _ref.cruise,
      departureCityLabel = _ref.departureCityLabel,
      _ref$departureDateFor = _ref.departureDateFormat,
      departureDateFormat = _ref$departureDateFor === void 0 ? ProductPriceTicketLine_DATE_FORMAT : _ref$departureDateFor,
      departureDateLabel = _ref.departureDateLabel,
      durationPlaceholder = _ref.durationPlaceholder,
      fromToPlaceholder = _ref.fromToPlaceholder,
      product = _ref.product,
      seeAllPrices = _ref.seeAllPrices,
      startingPriceCriteriaLabel = _ref.startingPriceCriteriaLabel;

  if (!product) {
    return null;
  }

  var travelAdvisor = config.travelAdvisor,
      i18nConfig = Object(objectWithoutProperties["a" /* default */])(config, ["travelAdvisor"]);

  Object(src_i18n["a" /* addTranslationKeys */])(ProductPriceTicketLine_objectSpread(ProductPriceTicketLine_objectSpread({}, i18nConfig), {}, {
    productPriceTicketLine: {
      adult: adult,
      adults: adults,
      askForQuotation: askForQuotation,
      book: book,
      collapseLabels: collapseLabels,
      condensedDepartureDateFormat: condensedDepartureDateFormat,
      departureCityLabel: departureCityLabel,
      departureDateFormat: departureDateFormat,
      departureDateLabel: departureDateLabel,
      durationPlaceholder: durationPlaceholder,
      fromToPlaceholder: fromToPlaceholder,
      seeAllPrices: seeAllPrices,
      startingPriceCriteriaLabel: startingPriceCriteriaLabel
    }
  }));
  return ProductPriceTicketLine_jsx("div", {
    className: "Line Line-PriceTicket",
    "data-testid": "Line-ProductPriceTicket"
  }, ProductPriceTicketLine_jsx(PriceTicket_PriceTicket, {
    cruise: cruise,
    product: product,
    travelAdvisorConfig: travelAdvisor
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-ticket/productPriceTicket.resolver.js
var productPriceTicket_resolver = __webpack_require__("3FxL");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-ticket/productPriceTicket.descriptor.js



var productPriceTicketDescriptor = {
  name: constants["nb" /* RESORT_PRICE_TICKET */],
  component: ProductPriceTicketLine_ProductPriceTicketLine,
  resolve: productPriceTicket_resolver["a" /* productPriceTicketResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-price-ticket-custom/ProductPriceTicketCustom.jsx









var ProductPriceTicketCustom_jsx = react_default.a.createElement;

function ProductPriceTicketCustom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductPriceTicketCustom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductPriceTicketCustom_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductPriceTicketCustom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var ProductPriceTicketCustom_ProductPriceTicketCustom = function ProductPriceTicketCustom(_ref) {
  var getAQuoteCTA = _ref.getAQuoteCTA,
      getAQuoteURL = _ref.getAQuoteURL,
      resort = _ref.resort,
      config = _ref.config;

  var _useContext = Object(react["useContext"])(context_pageContext["a" /* ReactPageContext */]),
      pageType = _useContext.pageType;

  Object(src_i18n["a" /* addTranslationKeys */])(ProductPriceTicketCustom_objectSpread(ProductPriceTicketCustom_objectSpread({}, config), {}, {
    productPriceTicketMiceLine: {
      getAQuoteCTA: getAQuoteCTA,
      getAQuoteURL: getAQuoteURL
    }
  }));
  var priceTicketContentProps = {
    title: resort.name,
    subtitle: getPriceTicketSubtitle(resort),
    badgeIcon: Object(product_utils["d" /* getProductBadgeIcon */])(resort),
    button: {
      children: getAQuoteCTA,
      colorBg: colors["a" /* COLORS */].BOOKING,
      colorBorder: colors["a" /* COLORS */].BOOKING,
      url: getAQuoteURL,
      trackingData: {
        actionGA: 'priceBar',
        labelGA: 'getAQuote',
        categoryGA: pageType
      }
    },
    hasECLogo: resort.isExplicitEC,
    price: resort.mice,
    isPriceFullWidth: true,
    fromPriceTicketCustom: true
  };
  return ProductPriceTicketCustom_jsx("div", {
    className: "Line Line-PriceTicketCustom"
  }, ProductPriceTicketCustom_jsx(PriceTicketContentWrapper_PriceTicketContentWrapper, priceTicketContentProps));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-price-ticket-custom/productPriceTicketCustom.resolver.js
var productPriceTicketCustom_resolver = __webpack_require__("m4Zw");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-price-ticket-custom/productPriceTicketCustom.descriptor.js




var productPriceTicketCustomDescriptor = {
  name: constants["R" /* PRODUCT_PRICE_TICKET_CUSTOM */],
  component: ProductPriceTicketCustom_ProductPriceTicketCustom,
  resolve: productPriceTicketCustom_resolver["a" /* productPriceTicketCustomResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/tracking/utils.js
var utils = __webpack_require__("zwLB");

// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/productQuotationForm.utils.js















function productQuotationForm_utils_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productQuotationForm_utils_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productQuotationForm_utils_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productQuotationForm_utils_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}










var productQuotationForm_utils_getInitialFormValues = function getInitialFormValues(_ref) {
  var extensionOptions = _ref.extensionOptions,
      isEscapade = _ref.isEscapade,
      isSummerCamp = _ref.isSummerCamp;
  return productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread({
    adultsNumber: isSummerCamp ? MIN_FORM_TEENS.toString() : productQuotationForm_constants_MIN_FORM_ADULTS.toString(),
    comment: '',
    departureCity: '',
    departureDate: isEscapade ? {
      from: null,
      to: null
    } : ''
  }, extensionOptions.length > 0 ? {
    extension: ''
  } : null), isSummerCamp ? null : {
    kidsNumber: productQuotationForm_constants_MIN_FORM_KIDS.toString()
  }), {}, {
    optinEmail: false,
    traveler: {
      civility: '',
      email: '',
      firstName: '',
      lastName: '',
      phone: ''
    }
  });
}; // Set form schema

var productQuotationForm_utils_getFormSchema = function getFormSchema(t, _ref2) {
  var civilityOptions = _ref2.civilityOptions,
      departureCityOptions = _ref2.departureCityOptions,
      departureDateOptions = _ref2.departureDateOptions,
      extensionOptions = _ref2.extensionOptions,
      isEscapade = _ref2.isEscapade,
      isSummerCamp = _ref2.isSummerCamp;
  var fistNameSchema = lib["string"]().required(t('productQuotationForm.coordinates.firstName')).max(20, t('productQuotationForm.coordinates.firstName'));
  var lastNameSchema = lib["string"]().required(t('productQuotationForm.coordinates.lastName')).max(30, t('productQuotationForm.coordinates.lastName'));
  return lib["object"]().shape(productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread({
    adultsNumber: lib["string"]().required(),
    comment: lib["string"](),
    departureCity: lib["mixed"]().oneOf(departureCityOptions.map(function (c) {
      return c.value;
    })).required(),
    departureDate: isEscapade ? lib["object"]().shape({
      from: lib["date"](),
      to: lib["date"]().nullable()
    }).required() : lib["mixed"]().oneOf(departureDateOptions.map(function (d) {
      return d.value;
    })).required()
  }, extensionOptions.length > 0 ? {
    extension: lib["mixed"]().oneOf(extensionOptions.map(function (e) {
      return e.value;
    })).required()
  } : null), isSummerCamp ? null : {
    kidsNumber: lib["string"]().required()
  }), {}, {
    optinEmail: lib["boolean"](),
    traveler: lib["object"]().shape({
      civility: lib["mixed"]().oneOf(civilityOptions.map(function (c) {
        return c.value;
      })).required(),
      email: lib["string"]().email(t('productQuotationForm.coordinates.email')).required(t('productQuotationForm.coordinates.email')),
      firstName: fistNameSchema,
      lastName: lastNameSchema,
      phone: lib["string"]().required(t('productQuotationForm.coordinates.phoneNumber')).matches(/^(\+[1-9]|0)?\d{1,14}$/, {
        excludeEmptyString: true,
        message: t('productQuotationForm.coordinates.phoneNumber')
      })
    })
  }));
}; // Submit form

var productQuotationForm_utils_FORM_STATUS = {
  NEW: 'new',
  SUCCESS: 'success',
  ERROR: 'error'
};

var productQuotationForm_utils_getFormattedDepartureDate = function getFormattedDepartureDate(date) {
  return typeof date === 'string' ? date : Object(date_apiDate["j" /* momentToApiDate */])(moment_default()(date.from || Date.now()));
};

var productQuotationForm_utils_getProductQuotationFormMutation = function getProductQuotationFormMutation(values, product) {
  var adultsNumber = values.adultsNumber,
      _values$kidsNumber = values.kidsNumber,
      kidsNumber = _values$kidsNumber === void 0 ? 0 : _values$kidsNumber,
      comment = values.comment,
      departureCity = values.departureCity,
      departureDate = values.departureDate,
      _values$extension = values.extension,
      extension = _values$extension === void 0 ? '' : _values$extension,
      optinEmail = values.optinEmail,
      traveler = values.traveler;
  var productId = product.productId,
      productLabel = product.productLabel,
      productRangeLabel = product.productRangeLabel;
  var civility = traveler.civility,
      email = traveler.email,
      firstName = traveler.firstName,
      lastName = traveler.lastName,
      phone = traveler.phone;
  var formattedDepartureDate = productQuotationForm_utils_getFormattedDepartureDate(departureDate);
  return "mutation {\n    productRequest(\n      adultsCount: ".concat(parseInt(adultsNumber, 10), "\n      childrenCount: ").concat(parseInt(kidsNumber, 10), "\n      contact: {\n        civility: \"").concat(civility, "\"\n        firstName: \"").concat(firstName, "\"\n        lastName: \"").concat(lastName, "\"\n        email: \"").concat(email, "\"\n        mobile: \"").concat(phone, "\"\n      }\n      customerComment: ").concat(Object(graphql["e" /* graphqlifyString */])(comment), "\n      departureCity: \"").concat(departureCity || NO_VALUE, "\"\n      departureDate: \"").concat(formattedDepartureDate, "\"\n      extensionName: \"").concat(extension, "\"\n      productId: \"").concat(productId, "\"\n      productLabel: \"").concat(productLabel, "\"\n      productRangeLabel: \"").concat(productRangeLabel, "\"\n      optinEmail: ").concat(optinEmail.toString(), "\n    ) {\n      statusCode\n    }\n  }");
};
var getNewsletterSubscriptionMutation = function getNewsletterSubscriptionMutation(values, newsletterId) {
  var _values$traveler = values.traveler,
      civility = _values$traveler.civility,
      email = _values$traveler.email,
      firstName = _values$traveler.firstName,
      lastName = _values$traveler.lastName;
  return "mutation {\n    subscription (\n      civility: \"".concat(civility, "\"\n      email: \"").concat(email, "\"\n      firstName: \"").concat(firstName, "\"\n      isSubscription: true\n      lastName: \"").concat(lastName, "\"\n      newsletterSubscriptions : [\"").concat(newsletterId, "\"]\n      unicodeFirstName: \"").concat(firstName, "\"\n      unicodeLastName: \"").concat(lastName, "\"\n    ) {\n      id\n      neolaneId\n    }\n  }");
};
var productQuotationForm_utils_handleSubmit = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, params) {
    var actions, appContext, isSummerCamp, product, quotation, trackingData, productQuotationFormMutation, _yield$graphQLClient$, productRequest, pageType, adultsNumber, kidsNumber, hasNoTransport, formattedDepartureDate;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            actions = params.actions, appContext = params.appContext, isSummerCamp = params.isSummerCamp, product = params.product, quotation = params.quotation, trackingData = params.trackingData;
            actions.setSubmitting(true);
            productQuotationFormMutation = productQuotationForm_utils_getProductQuotationFormMutation(values, product);
            _context.prev = 3;
            _context.next = 6;
            return graphqlClient["a" /* default */].runNoCacheQuery(productQuotationFormMutation, appContext, {
              requestName: requestDictionary["Md" /* WIDGET_QUOTATION_FORM_SUBMIT */]
            });

          case 6:
            _yield$graphQLClient$ = _context.sent;
            productRequest = _yield$graphQLClient$.productRequest;

            if (productRequest.statusCode === 500) {
              actions.setStatus(productQuotationForm_utils_objectSpread({
                state: productQuotationForm_utils_FORM_STATUS.ERROR
              }, quotation.error));
            } else {
              if (isSummerCamp) {
                pageType = 'landing';
                tracking_api["b" /* setDataLayer */]({
                  actionGA: 'SummerCamp',
                  categoryGA: pageType,
                  labelGA: 'CTASendQuote',
                  siteSection: Object(utils["e" /* getSiteSection */])({
                    pageType: pageType
                  })
                }, appContext);
              }

              actions.setStatus(productQuotationForm_utils_objectSpread({
                state: productQuotationForm_utils_FORM_STATUS.SUCCESS
              }, quotation.success));
            }

            if (!isSummerCamp) {
              adultsNumber = parseInt(values.adultsNumber, 10);
              kidsNumber = parseInt(values.kidsNumber, 10);
              hasNoTransport = values.departureCity === '' || values.departureCity === 'NO';
              formattedDepartureDate = productQuotationForm_utils_getFormattedDepartureDate(values.departureDate);
              tracking_api["b" /* setDataLayer */](productQuotationForm_utils_objectSpread(productQuotationForm_utils_objectSpread({}, trackingData), {}, {
                resortAdult: adultsNumber,
                resortChildren: kidsNumber,
                resortDepartureCityCode: hasNoTransport ? 'without transport' : values.departureCity,
                resortDepartureDate: formattedDepartureDate,
                resortTotalParticipant: adultsNumber + kidsNumber,
                resortTransport: hasNoTransport ? 'without transport' : 'with transport'
              }), appContext);
            }

            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            actions.setStatus(productQuotationForm_utils_objectSpread({
              state: productQuotationForm_utils_FORM_STATUS.ERROR
            }, quotation.error));

          case 15:
            _context.prev = 15;
            actions.setSubmitting(false);
            return _context.finish(15);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 12, 15, 18]]);
  }));

  return function handleSubmit(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationForm.jsx




var ProductQuotationForm_jsx = react_default.a.createElement;















var FormFieldNote = function FormFieldNote(_ref) {
  var note = _ref.note;
  return ProductQuotationForm_jsx("span", {
    className: "mt-px5 text-sm text-gray-medium"
  }, note);
};

function ProductQuotationForm(_ref2) {
  var adultsOptions = _ref2.adultsOptions,
      ageIndicationAdults = _ref2.ageIndicationAdults,
      ageIndicationKids = _ref2.ageIndicationKids,
      availableDatesIndication = _ref2.availableDatesIndication,
      civilityOptions = _ref2.civilityOptions,
      dateFormat = _ref2.dateFormat,
      departureCityOptions = _ref2.departureCityOptions,
      departureDateOptions = _ref2.departureDateOptions,
      departureDateEnd = _ref2.departureDateEnd,
      departureDateStart = _ref2.departureDateStart,
      extensionOptions = _ref2.extensionOptions,
      footnotes = _ref2.footnotes,
      isEscapade = _ref2.isEscapade,
      isSummerCamp = _ref2.isSummerCamp,
      kidsOptions = _ref2.kidsOptions,
      newsletter = _ref2.newsletter,
      newsletterOptins = _ref2.newsletterOptins;

  var _useFormikContext = Object(formik_esm["e" /* useFormikContext */])(),
      isSubmitting = _useFormikContext.isSubmitting,
      isValid = _useFormikContext.isValid,
      status = _useFormikContext.status;

  var optinEmail = newsletterOptins.optinEmail,
      optinProfile = newsletterOptins.optinProfile;
  return ProductQuotationForm_jsx(formik_esm["c" /* Form */], {
    id: QUOTATION_FORM_ID,
    "data-testid": QUOTATION_FORM_ID
  }, ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    hLevel: 2,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.title')), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.criteria.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, isEscapade ? ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    dateFormat: dateFormat,
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.dateLabel'),
    maxDate: departureDateEnd,
    minDate: departureDateStart,
    name: "departureDate",
    placeholder: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.datePlaceholder'),
    type: "datepicker"
  }) : ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-date-field",
    hideErrorMessage: true,
    isDisabled: departureDateOptions.length === 0,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.dateLabel'),
    name: "departureDate",
    options: departureDateOptions,
    placeholder: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.datePlaceholder'),
    type: "select"
  }), departureDateOptions.length === 0 && ProductQuotationForm_jsx("span", {
    className: "flex items-center text-sm mt-px5 text-blue"
  }, ProductQuotationForm_jsx(Icon["a" /* Icon */], {
    className: "rtl:mr-px5",
    name: icons["a" /* ICONS */].WARNING,
    width: ".75rem"
  }), availableDatesIndication))), extensionOptions.length > 0 && ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "extension-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.extensionLabel'),
    name: "extension",
    options: extensionOptions,
    placeholder: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.extensionPlaceholder'),
    type: "select"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "departure-city-field",
    hideErrorMessage: true,
    isRequired: true,
    label: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.transportationLabel'),
    name: "departureCity",
    options: departureCityOptions,
    placeholder: Object(src_i18n["h" /* t */])('productQuotationForm.criteria.transportationPlaceholder'),
    type: "select"
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.pax.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("p", {
    className: "w-full mt-px10 mb-0 px-px10 text-base font-bold"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.pax.paxLabel'), '*'), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "adults-number-field",
    hideErrorMessage: true,
    name: "adultsNumber",
    options: adultsOptions,
    type: "select"
  }), ProductQuotationForm_jsx(FormFieldNote, {
    note: ageIndicationAdults
  })), !isSummerCamp && ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "kids-number-field",
    hideErrorMessage: true,
    name: "kidsNumber",
    options: kidsOptions,
    type: "select"
  }), ProductQuotationForm_jsx(FormFieldNote, {
    note: ageIndicationKids
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.title')), ProductQuotationForm_jsx("div", {
    className: "flex flex-wrap"
  }, ProductQuotationForm_jsx("p", {
    className: "w-full mt-px10 mb-0 px-px10 text-base font-bold"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.informationLabel')), ProductQuotationForm_jsx("div", {
    className: "w-full"
  }, ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-civility-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.civility",
    options: civilityOptions,
    placeholder: Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.civility'),
    type: "select"
  }))), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-firstName-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.firstName",
    placeholder: "".concat(Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.firstName'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-lastName-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.lastName",
    placeholder: "".concat(Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.lastName'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-email-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.email",
    placeholder: "".concat(Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.email'), " *"),
    type: "text"
  })), ProductQuotationForm_jsx("div", {
    className: "w-full md:w-1/2 p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "traveler-phone-field",
    hideErrorMessage: true,
    isRequired: true,
    name: "traveler.phone",
    placeholder: "".concat(Object(src_i18n["h" /* t */])('productQuotationForm.coordinates.phoneNumber'), " *"),
    type: "text"
  })), optinEmail && ProductQuotationForm_jsx("div", {
    className: "w-full p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    className: "mb-px10",
    dataTestId: "optin-email-field",
    label: newsletter.description || optinEmail.title,
    name: "optinEmail",
    optimized: true,
    type: "checkbox"
  }), optinEmail && optinEmail.description && ProductQuotationForm_jsx(Text["a" /* Text */], {
    className: "mt-px15",
    theme: "text-sans-2",
    text: optinEmail.description
  }), optinProfile && optinProfile.description && ProductQuotationForm_jsx(Text["a" /* Text */], {
    className: "mt-px15",
    theme: "text-sans-2",
    text: optinProfile.description
  }))), ProductQuotationForm_jsx(Title["a" /* Title */], {
    className: "mt-px30 mb-px5 px-px10",
    color: colors["a" /* COLORS */].BLUE,
    hLevel: 3,
    theme: "title-sans-4"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.specialRequest.title')), ProductQuotationForm_jsx("div", {
    className: "w-full p-px10"
  }, ProductQuotationForm_jsx(FormikInput["a" /* FormikInput */], {
    dataTestId: "comment-field",
    name: "comment",
    placeholder: Object(src_i18n["h" /* t */])('productQuotationForm.specialRequest.placeholder'),
    type: "textarea"
  })), ProductQuotationForm_jsx("div", {
    className: classnames_default()('mt-px30 px-px10', {
      'text-right': status.state === productQuotationForm_utils_FORM_STATUS.NEW,
      'flex justify-center': status.state !== productQuotationForm_utils_FORM_STATUS.NEW
    })
  }, status.state === productQuotationForm_utils_FORM_STATUS.NEW ? ProductQuotationForm_jsx(react["Fragment"], null, ProductQuotationForm_jsx(Button["a" /* Button */], {
    colorBg: colors["a" /* COLORS */].BLUE,
    colorBorder: colors["a" /* COLORS */].BLUE,
    dataTestId: "product-quotation-submit",
    isDisabled: !isValid,
    isLoading: isSubmitting,
    type: "submit"
  }, Object(src_i18n["h" /* t */])('productQuotationForm.quotation.buttonLabel')), footnotes.length > 0 && ProductQuotationForm_jsx("div", {
    className: "leading-normal py-px10 max-w-full text-base text-gray-darker"
  }, footnotes.map(function (note) {
    return ProductQuotationForm_jsx("p", {
      className: "my-0",
      key: note
    }, note);
  }))) : ProductQuotationForm_jsx(Confirmation["a" /* Confirmation */], Object(esm_extends["a" /* default */])({}, status, {
    status: status.state
  }))));
}
// CONCATENATED MODULE: ./src/client/components/widgets/product-quotation-form/ProductQuotationFormContainer.jsx



var ProductQuotationFormContainer_jsx = react_default.a.createElement;






function ProductQuotationFormContainer(_ref) {
  var adultsOptions = _ref.adultsOptions,
      ageIndicationAdults = _ref.ageIndicationAdults,
      ageIndicationKids = _ref.ageIndicationKids,
      availableDatesIndication = _ref.availableDatesIndication,
      civilityOptions = _ref.civilityOptions,
      dateFormat = _ref.dateFormat,
      departureCityOptions = _ref.departureCityOptions,
      departureDateOptions = _ref.departureDateOptions,
      departureDateEnd = _ref.departureDateEnd,
      departureDateStart = _ref.departureDateStart,
      extensionOptions = _ref.extensionOptions,
      footnotes = _ref.footnotes,
      isEscapade = _ref.isEscapade,
      isSummerCamp = _ref.isSummerCamp,
      kidsOptions = _ref.kidsOptions,
      newsletter = _ref.newsletter,
      newsletterOptins = _ref.newsletterOptins,
      product = _ref.product,
      quotation = _ref.quotation,
      trackingData = _ref.trackingData;
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);
  return ProductQuotationFormContainer_jsx(formik_esm["d" /* Formik */], {
    initialStatus: {
      state: productQuotationForm_utils_FORM_STATUS.NEW
    },
    initialValues: productQuotationForm_utils_getInitialFormValues({
      extensionOptions: extensionOptions,
      isSummerCamp: isSummerCamp,
      isEscapade: isEscapade
    }),
    validateOnMount: true,
    validationSchema: productQuotationForm_utils_getFormSchema(src_i18n["h" /* t */], {
      civilityOptions: civilityOptions,
      departureCityOptions: departureCityOptions,
      departureDateOptions: departureDateOptions,
      extensionOptions: extensionOptions,
      isEscapade: isEscapade,
      isSummerCamp: isSummerCamp,
      locale: appContext.locale
    }),
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(values, actions) {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return productQuotationForm_utils_handleSubmit(values, {
                  actions: actions,
                  appContext: appContext,
                  isSummerCamp: isSummerCamp,
                  newsletter: newsletter,
                  product: product,
                  quotation: quotation,
                  trackingData: trackingData
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, ProductQuotationFormContainer_jsx(ProductQuotationForm, {
    adultsOptions: adultsOptions,
    ageIndicationAdults: ageIndicationAdults,
    ageIndicationKids: ageIndicationKids,
    availableDatesIndication: availableDatesIndication,
    civilityOptions: civilityOptions,
    dateFormat: dateFormat,
    departureCityOptions: departureCityOptions,
    departureDateOptions: departureDateOptions,
    departureDateEnd: departureDateEnd,
    departureDateStart: departureDateStart,
    extensionOptions: extensionOptions,
    footnotes: footnotes,
    isEscapade: isEscapade,
    isSummerCamp: isSummerCamp,
    kidsOptions: kidsOptions,
    newsletter: newsletter,
    newsletterOptins: newsletterOptins
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/product-quotation-form-line/ProductQuotationFormLine.jsx




var ProductQuotationFormLine_jsx = react_default.a.createElement;










var ProductQuotationFormLine_PRODUCT_TYPES = dist["constants"].PRODUCT_TYPES;
var SUMMER_CAMP_AVAILABLE_DATES = [{
  value: '20220702'
}, {
  value: '20220709'
}, {
  value: '20220716'
}];
function ProductQuotationFormLine(props) {
  var _price$initialPrice, _price$initialPrice2;

  var bookingCriteria = props.bookingCriteria,
      civilities = props.civilities,
      coordinates = props.coordinates,
      criteria = props.criteria,
      legalInformations = props.legalInformations,
      newsletter = props.newsletter,
      pax = props.pax,
      price = props.price,
      product = props.product,
      quotation = props.quotation,
      specialRequest = props.specialRequest,
      stopover = props.stopover,
      title = props.title,
      tour = props.tour;
  Object(src_i18n["a" /* addTranslationKeys */])({
    productQuotationForm: {
      coordinates: coordinates,
      criteria: criteria,
      pax: pax,
      quotation: quotation,
      specialRequest: specialRequest,
      title: title
    }
  });
  var productType = product.type;
  var isEscapade = product.rangeId === RANGE_ESCAPADE;
  var isSummerCamp = productType === ProductQuotationFormLine_PRODUCT_TYPES.SUMMER_CAMP;
  var tourDuration = parseInt((stopover === null || stopover === void 0 ? void 0 : stopover.tour.duration) || '0', 10);
  var extensionName = (stopover === null || stopover === void 0 ? void 0 : stopover.extension.title) || '';
  var extensionOptions = []; // The API returns an empty string when no extension is available

  if (extensionName.length > 0) {
    extensionOptions.push({
      value: NO_VALUE,
      name: criteria.noExtension
    }, {
      value: extensionName,
      name: extensionName
    });
    tourDuration += parseInt((stopover === null || stopover === void 0 ? void 0 : stopover.extension.duration) || '0', 10);
  }

  var departureCityOptions = bookingCriteria.departureCities; // The API returns this array when no transport is available:
  // [{value : "NO", name : "No Transport"}]

  if (departureCityOptions.length === 1 && departureCityOptions[0].value === NO_VALUE && !isSummerCamp) {
    departureCityOptions = [];
  }

  var availableDatesIndication = pax.noMoreAvailableDates;
  var ageIndicationAdults = isSummerCamp ? pax.kidsAgeIndicationSummerCamp : pax.adultAgeIndication;
  var ageIndicationKids = isEscapade ? pax.kidsAgeIndicationEscapade : pax.kidsAgeIndicationTour;
  var departureDateStart = new Date(criteria.departureDateStart);
  var departureDateEnd = new Date(criteria.departureDateEnd);
  var adultsOptions = isSummerCamp ? getChildrenOptions(pax.teensChoices, MIN_FORM_TEENS, MAX_FORM_TEENS).map(function (_ref) {
    var label = _ref.label,
        value = _ref.value;
    return {
      name: label,
      value: value.toString()
    };
  }) : getAdultsOptions(pax.adultsChoices, productQuotationForm_constants_MIN_FORM_ADULTS, productQuotationForm_constants_MAX_FORM_ADULTS).map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      name: label,
      value: value.toString()
    };
  });
  var kidsOptions = getChildrenOptions(pax.kidsChoices, productQuotationForm_constants_MIN_FORM_KIDS, productQuotationForm_constants_MAX_FORM_KIDS).map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      name: label,
      value: value.toString()
    };
  });
  var newsletterOptins = PrebookingFormLine_utils_getNewsletterOptins(legalInformations.newsletterOptins || []);
  var trackingData = {
    actionGA: 'accommodation',
    categoryGA: 'bookingEngineEntry',
    labelGA: 'accommodation',
    basePriceAccommodation: (price === null || price === void 0 ? void 0 : (_price$initialPrice = price.initialPrice) === null || _price$initialPrice === void 0 ? void 0 : _price$initialPrice.value) || null,
    resortCode: product.productId,
    resortDefaultPrice: (price === null || price === void 0 ? void 0 : (_price$initialPrice2 = price.initialPrice) === null || _price$initialPrice2 === void 0 ? void 0 : _price$initialPrice2.value) || null,
    resortNightNumber: tourDuration,
    resortSeasonType: product.seasonName,
    resortUrlImage: product.image,
    siteSection: tracking_constants["a" /* BE */]
  };
  return ProductQuotationFormLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: QUOTATION_FORM_SECTION_ID,
    dataTestId: QUOTATION_FORM_SECTION_ID,
    className: "Line bg-white z-6"
  }, ProductQuotationFormLine_jsx("div", {
    className: "PriceTicket-sticky-beacon"
  }), ProductQuotationFormLine_jsx(ProductQuotationFormContainer, {
    adultsOptions: adultsOptions,
    ageIndicationAdults: ageIndicationAdults,
    ageIndicationKids: ageIndicationKids,
    availableDatesIndication: availableDatesIndication,
    civilityOptions: (civilities === null || civilities === void 0 ? void 0 : civilities.adult) || [],
    dateFormat: criteria.dateFormat,
    departureCityOptions: departureCityOptions,
    departureDateEnd: departureDateEnd,
    departureDateOptions: // TODO: this is done for ODR purpose to do remove this when
    // the summer camp date are set
    isSummerCamp ? SUMMER_CAMP_AVAILABLE_DATES.map(function (_ref4) {
      var value = _ref4.value;
      return {
        name: Object(date_apiDate["h" /* momentFromApiDate */])(value).format(criteria.dateFormat),
        value: value
      };
    }) : tour.availableDates.map(function (_ref5) {
      var name = _ref5.name,
          value = _ref5.value;
      return {
        name: name,
        value: value.toString()
      };
    }),
    departureDateStart: departureDateStart,
    extensionOptions: extensionOptions,
    footnotes: quotation.indication,
    isEscapade: isEscapade,
    isSummerCamp: isSummerCamp,
    kidsOptions: kidsOptions,
    newsletter: newsletter,
    newsletterOptins: newsletterOptins,
    product: product,
    quotation: {
      success: quotation.success,
      error: quotation.error
    },
    trackingData: trackingData
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-quotation-form/productQuotationForm.resolver.js
var productQuotationForm_resolver = __webpack_require__("aFmo");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-quotation-form/productQuotationForm.descriptor.js



var productQuotationFormDescriptor = {
  name: constants["Z" /* QUOTATION_FORM */],
  component: ProductQuotationFormLine,
  resolve: productQuotationForm_resolver["a" /* productQuotationFormResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-recommendations-line/ProductRecommendationsLine.jsx

var ProductRecommendationsLine_jsx = react_default.a.createElement;








var ProductRecommendationsLine_ProductRecommendationsLine = function ProductRecommendationsLine(props) {
  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  if (appContext.isSeller) {
    return null;
  }

  var _props$config = props.config,
      config = _props$config === void 0 ? {} : _props$config,
      recommendations = props.recommendations;
  var recommendedProducts = ((recommendations === null || recommendations === void 0 ? void 0 : recommendations.products) || []).map(function (product) {
    return Object(redux["d" /* compose */])(Product_mapper["c" /* getProductProps */], Product_mapper["e" /* setProductHref */])({
      config: config,
      product: product
    });
  });
  var seeMore = {
    color: colors["a" /* COLORS */].GRAY,
    label: config.resort.moreResultsLabels.buttonLabel,
    text: config.resort.moreResultsLabels.label
  };
  var title = config.common.recommendedResorts;
  return ProductRecommendationsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, ProductRecommendationsLine_jsx(ProductsGrid["a" /* ProductsGrid */], {
    hasSeeMore: true,
    isSynchronousGrid: true,
    lineName: constants["ob" /* RESORT_RECOMMENDATIONS */],
    products: recommendedProducts,
    seeMore: seeMore,
    title: title
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-recommendations/productRecommendations.resolver.js
var productRecommendations_resolver = __webpack_require__("/KRb");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-recommendations/productRecommendations.descriptor.js



var productRecommendationsDescriptor = {
  name: constants["ob" /* RESORT_RECOMMENDATIONS */],
  component: ProductRecommendationsLine_ProductRecommendationsLine,
  resolve: productRecommendations_resolver["a" /* productRecommendationsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-teaser/ProductTeaser.jsx

var ProductTeaser_jsx = react_default.a.createElement;





var ProductTeaser_ProductTeaser = function ProductTeaser(_ref) {
  var card = _ref.card,
      product = _ref.product;

  if (Object(lodash["isEmpty"])(card)) {
    return null;
  }

  return ProductTeaser_jsx("div", {
    className: "flex flex-wrap -mx-px10"
  }, ProductTeaser_jsx("div", {
    className: Object(lodash["isEmpty"])(product) ? 'px-px10 w-full' : 'px-px10 pb-px10 sm:pb-0 sm:mb-0 w-full sm:w-2/3 lg:3/4'
  }, ProductTeaser_jsx(Card["a" /* Card */], Object(esm_extends["a" /* default */])({
    layout: Card_constants["d" /* INLINE_1 */]
  }, card))), !Object(lodash["isEmpty"])(product) && ProductTeaser_jsx("div", {
    className: "px-px10 pt-px10 sm:pt-0 w-full sm:w-1/3 lg:1/4"
  }, ProductTeaser_jsx(Product["a" /* Product */], product)));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-related-products-line/ProductRelatedProductsLine.jsx


var ProductRelatedProductsLine_jsx = react_default.a.createElement;







var ProductRelatedProductsLine_ProductRelatedProductsLine = function ProductRelatedProductsLine(_ref) {
  var _product$relatedProdu;

  var config = _ref.config,
      product = _ref.product,
      title = _ref.title;

  if (!((_product$relatedProdu = product.relatedProducts) === null || _product$relatedProdu === void 0 ? void 0 : _product$relatedProdu.length)) {
    return null;
  }

  return ProductRelatedProductsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-RelatedProducts"
  }, ProductRelatedProductsLine_jsx(LineTitle["a" /* LineTitle */], null, title), product.relatedProducts.map(function (relatedProduct, index) {
    var card = {
      color: colors["a" /* COLORS */].BLUE,
      heading: {
        iconName: relatedProduct.resortId.toLowerCase(),
        title: relatedProduct.name
      },
      link: {
        url: relatedProduct.href
      },
      text: {
        text: relatedProduct.title
      }
    };
    return ProductRelatedProductsLine_jsx("article", {
      key: relatedProduct.id,
      className: "Line Line-ProductTeaser"
    }, ProductRelatedProductsLine_jsx(ProductTeaser_ProductTeaser, {
      card: card,
      index: index,
      lineName: constants["ab" /* RELATED_PRODUCTS */],
      product: Object(Product_mapper["c" /* getProductProps */])({
        config: config,
        product: relatedProduct
      })
    }));
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-related-products/productRelatedProducts.resolver.js
var productRelatedProducts_resolver = __webpack_require__("4HxW");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-related-products/productRelatedProducts.descriptor.js



var productRelatedProductsDescriptor = {
  name: constants["ab" /* RELATED_PRODUCTS */],
  component: ProductRelatedProductsLine_ProductRelatedProductsLine,
  resolve: productRelatedProducts_resolver["a" /* productRelatedProductsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-restaurants/productRestaurants.resolver.js
var productRestaurants_resolver = __webpack_require__("WUtx");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-restaurants/productRestaurants.descriptor.js











var productRestaurants_descriptor_jsx = react["createElement"];

function productRestaurants_descriptor_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function productRestaurants_descriptor_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      productRestaurants_descriptor_ownKeys(Object(source), true).forEach(function (key) {
        Object(defineProperty["a" /* default */])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      productRestaurants_descriptor_ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}








var productRestaurants_descriptor_ProductRestaurantsLine = function ProductRestaurantsLine(_ref) {
  var _ref$config = _ref.config,
      config = _ref$config === void 0 ? {} : _ref$config,
      _ref$restaurants = _ref.restaurants,
      introduction = _ref$restaurants.introduction,
      _ref$restaurants$rest = _ref$restaurants.restaurantsList,
      restaurantsList = _ref$restaurants$rest === void 0 ? [] : _ref$restaurants$rest,
      title = _ref.title;
  var intros = introduction ? [{
    description: introduction.description
  }] : [];
  var list = restaurantsList.map(function (restaurant) {
    var _restaurant$images = Object(slicedToArray["a" /* default */])(restaurant.images, 1),
        image = _restaurant$images[0];

    return productRestaurants_descriptor_objectSpread(productRestaurants_descriptor_objectSpread({}, restaurant), {}, {
      image: image
    });
  });
  return productRestaurants_descriptor_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, productRestaurants_descriptor_jsx(LineTitle["a" /* LineTitle */], null, title), productRestaurants_descriptor_jsx(ProductCatering_ProductCatering, {
    productCateringTitle: title,
    intros: intros,
    list: list,
    seeLessLabel: config.common.loadLess,
    seeMoreLabel: config.common.viewMore
  }));
};

var productRestaurantsDescriptor = {
  name: constants["pb" /* RESORT_RESTAURANTS */],
  component: productRestaurants_descriptor_ProductRestaurantsLine,
  resolve: productRestaurants_resolver["a" /* productRestaurantsResolver */].resolve
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-seo-title/productSEOTitle.resolver.js
var productSEOTitle_resolver = __webpack_require__("1I7E");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-seo-title/productSEOTitle.descriptor.js



var productSEOTitle_descriptor_jsx = react_default.a.createElement;




var productSEOTitleDescriptor = {
  name: constants["qb" /* RESORT_SEO */],
  // eslint-disable-next-line clubmed/no-fake-component
  component: function component(_ref) {
    var title = _ref.title,
        meta = _ref.meta,
        script = _ref.script;
    return productSEOTitle_descriptor_jsx(head_default.a, null, productSEOTitle_descriptor_jsx("title", {
      key: "title"
    }, title), meta.map(function (_ref2) {
      var content = _ref2.content,
          key = _ref2.key,
          name = _ref2.name,
          property = _ref2.property;
      return productSEOTitle_descriptor_jsx("meta", Object(esm_extends["a" /* default */])({
        key: key || name || property
      }, property ? {
        property: property
      } : {
        name: name
      }, {
        content: content
      }));
    }), script.map(function (_ref3) {
      var type = _ref3.type,
          innerHTML = _ref3.innerHTML;
      return productSEOTitle_descriptor_jsx("script", {
        key: "product-seo-title-ld-json",
        type: type // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: innerHTML
        }
      });
    }));
  },
  props: productSEOTitle_resolver["a" /* productSEOTitleResolver */].props,
  resolve: productSEOTitle_resolver["a" /* productSEOTitleResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-services/ProductServices.jsx

var ProductServices_jsx = react_default.a.createElement;





var ProductServices_ProductServices = function ProductServices(_ref) {
  var allInclusiveServices = _ref.allInclusiveServices,
      config = _ref.config;
  Object(src_i18n["a" /* addTranslationKeys */])(config);
  var style = '.ProductServices-serviceContainer:last-child .border-b-1 {border-width: 0;} @media (min-width: 64.01em) {.ProductServices-serviceContainer:nth-last-child(-n+2) .border-b-1 {border-width: 0}}';

  if (allInclusiveServices.length === 0) {
    return null;
  }

  return ProductServices_jsx("div", {
    className: "border-1 pt-px25 px-px20 lg:px-px40 rounded-tiny border-gray-medium"
  }, ProductServices_jsx("style", {
    dangerouslySetInnerHTML: {
      __html: style
    }
  }), ProductServices_jsx("div", {
    className: "text-blue font-brand flex justify-center items-center text-2xl"
  }, ProductServices_jsx(Icon["a" /* Icon */], {
    name: icons["a" /* ICONS */].ALL_INCLUSIVE,
    width: "calc(27rem / 16)"
  }), ProductServices_jsx("span", {
    className: "rtl:ml-px10 leading-one"
  }, Object(src_i18n["h" /* t */])('common.allInclusive'))), ProductServices_jsx("div", {
    className: "flex flex-wrap justify-between md:py-px10 ProductServices-list"
  }, allInclusiveServices.map(function (service, index) {
    return ProductServices_jsx("div", {
      className: "w-full lg:w-12/25 ProductServices-serviceContainer",
      key: service.label
    }, ProductServices_jsx(ProductService["a" /* ProductService */], {
      service: service,
      disableBorder: index === allInclusiveServices.length - 1
    }));
  })));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-services-line/ProductServicesLine.jsx

var ProductServicesLine_jsx = react_default.a.createElement;



function ProductServicesLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return ProductServicesLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line mb-px60 lg:mb-px40"
  }, ProductServicesLine_jsx(ProductServices_ProductServices, props));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-services/productServices.resolver.js
var productServices_resolver = __webpack_require__("/0L0");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-services/productServices.descriptor.js



var productServicesDescriptor = {
  name: constants["S" /* PRODUCT_SERVICES */],
  component: ProductServicesLine,
  resolve: productServices_resolver["a" /* productServicesResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-signatures/ProductSignatures.jsx
var ProductSignatures_jsx = react_default.a.createElement;



var ProductSignatures_ProductSignatures = function ProductSignatures(_ref) {
  var imageSrc = _ref.imageSrc,
      header = _ref.header,
      text = _ref.text,
      tail = _ref.tail;

  if (!text) {
    return null;
  }

  return ProductSignatures_jsx("article", {
    className: "relative inset-border-after",
    style: {
      padding: '7vw 30px'
    }
  }, ProductSignatures_jsx("div", {
    className: "bg-deepBlue rounded-tiny absolute inset-0"
  }, ProductSignatures_jsx("div", {
    className: "h-full relative opacity-50 overflow-y-hidden"
  }, ProductSignatures_jsx(Image["b" /* default */], {
    className: "absolute inset-center",
    imageUrl: imageSrc,
    ratioKey: ratios_utils["a" /* default */].L
  }))), ProductSignatures_jsx("div", {
    style: {
      minHeight: '120px'
    },
    className: "relative text-base font-brand flex flex-col items-center justify-between text-center text-white"
  }, ProductSignatures_jsx("div", null, header), ProductSignatures_jsx("div", {
    className: "text-2xl sm:text-7xl"
  }, text), ProductSignatures_jsx("div", {
    className: "font-sans"
  }, tail)));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-signatures-line/ProductSignaturesLine.jsx

var ProductSignaturesLine_jsx = react_default.a.createElement;



function ProductSignaturesLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  return ProductSignaturesLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, ProductSignaturesLine_jsx(ProductSignatures_ProductSignatures, props));
}
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-signatures/productSignatures.descriptor.jsx


var productSignaturesDescriptor = {
  name: constants["T" /* PRODUCT_SIGNATURES */],
  component: ProductSignaturesLine
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-space-introduction/ProductSpaceIntroduction.jsx

var ProductSpaceIntroduction_jsx = react_default.a.createElement;












var ProductSpaceIntroduction_ProductSpaceIntroduction = function ProductSpaceIntroduction(_ref) {
  var imageSrc = _ref.imageSrc,
      text = _ref.text,
      title = _ref.title,
      link = _ref.link;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  if (!title) {
    return null;
  }

  var logo = ProductSpaceIntroduction_jsx("div", {
    className: "md:text-initial"
  }, ProductSpaceIntroduction_jsx(Icon["a" /* Icon */], {
    isNotSquare: true,
    name: icons["a" /* ICONS */].CLUBMED_EXCLUSIVE,
    width: "calc(160rem / 16)"
  }));

  var content = ProductSpaceIntroduction_jsx(react["Fragment"], null, ProductSpaceIntroduction_jsx(Title["a" /* Title */], {
    className: "mb-px20",
    theme: "title-serif-2",
    color: colors["a" /* COLORS */].WHITE
  }, Object(string_util["d" /* truncate */])(title, 50)), ProductSpaceIntroduction_jsx(TextSeeMore["a" /* TextSeeMore */], {
    color: colors["a" /* COLORS */].WHITE,
    hasNoScrollOnCollapse: true,
    isCollapseEnabled: true,
    seeLessLabel: Object(src_i18n["h" /* t */])('common.loadLess'),
    seeMoreLabel: Object(src_i18n["h" /* t */])('common.viewMore'),
    seeMoreSize: 80,
    seeMoreTheme: "deepBlue",
    text: text,
    theme: "text-sans-3"
  }));

  var image = ProductSpaceIntroduction_jsx(Image["b" /* default */], {
    imageUrl: imageSrc,
    className: "rounded-tiny overflow-hidden inset-border-after--large",
    ratioKey: ratios_utils["a" /* default */].R_13_BY_12,
    ratioDisplay: 1 / 2
  });

  var spaceLink = link ? ProductSpaceIntroduction_jsx(DynamicLink["a" /* default */], {
    url: link.url,
    className: "block mt-px25 text-white underline"
  }, link.text) : null;
  return isTablet ? ProductSpaceIntroduction_jsx("article", {
    className: "font-serif",
    style: {
      margin: '100px 0 75px'
    }
  }, ProductSpaceIntroduction_jsx("div", {
    className: "flex bg-deepBlue rounded-tiny"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "w-1/2 p-px20 lg:p-px40 text-white"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "mb-px30 text-white text-center"
  }, logo), " ", content, " ", spaceLink), ProductSpaceIntroduction_jsx("div", {
    className: "h-full relative w-12/25 -my-px30 self-center"
  }, image))) : ProductSpaceIntroduction_jsx("article", {
    className: "font-serif"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "relative"
  }, image), ProductSpaceIntroduction_jsx("div", {
    className: "bg-deepBlue rounded-tiny px-px25 py-px40 text-center font-serif"
  }, ProductSpaceIntroduction_jsx("div", {
    className: "sm:inline-block mb-px30 text-white text-center"
  }, logo), content, spaceLink));
};
// CONCATENATED MODULE: ./src/client/components/lines/product-space-introduction-line/ProductSpaceIntroductionLine.jsx

var ProductSpaceIntroductionLine_jsx = react_default.a.createElement;




function ProductSpaceIntroductionLine(_ref) {
  var config = _ref.config,
      id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["config", "id"]);

  Object(src_i18n["a" /* addTranslationKeys */])(config);
  return ProductSpaceIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line",
    size: "medium"
  }, ProductSpaceIntroductionLine_jsx(ProductSpaceIntroduction_ProductSpaceIntroduction, props));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-space-introduction/productSpaceIntroduction.resolver.js
var productSpaceIntroduction_resolver = __webpack_require__("bLh8");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-space-introduction/productSpaceIntroduction.descriptor.js



var productSpaceIntroductionDescriptor = {
  name: constants["U" /* PRODUCT_SPACE_INTRODUCTION */],
  component: ProductSpaceIntroductionLine,
  resolver: productSpaceIntroduction_resolver["a" /* productSpaceIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/product-strengths/ProductStrengths.jsx




var ProductStrengths_jsx = react_default.a.createElement;








var ProductStrengths_ProductStrengths = function ProductStrengths(_ref) {
  var className = _ref.className,
      _ref$displayLoadMore = _ref.displayLoadMore,
      displayLoadMore = _ref$displayLoadMore === void 0 ? true : _ref$displayLoadMore,
      isExclusiveCollection = _ref.isExclusiveCollection,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      seeLessLabel = _ref.seeLessLabel,
      seeMoreLabel = _ref.seeMoreLabel;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var track = Object(useTracking["a" /* useTracking */])();

  if (!items.length) {
    return null;
  }

  var content = ProductStrengths_jsx("div", {
    className: classnames_default()(className, 'flex flex-wrap -mx-px10')
  }, items.map(function (_ref2, idx) {
    var _ref2$color = _ref2.color,
        color = _ref2$color === void 0 ? colors["a" /* COLORS */].BLUE : _ref2$color,
        iconName = _ref2.iconName,
        label = _ref2.label,
        trackingData = _ref2.trackingData,
        url = _ref2.url;
    var TagName = url ? DynamicLink["a" /* default */] : 'div';
    return ProductStrengths_jsx(react["Fragment"], {
      key: label
    }, !!idx && ProductStrengths_jsx("span", {
      className: "fadeInLong hidden sm:block font-serif mt-px10 opacity-50 text-gray-light text-7xl"
    }, "/"), ProductStrengths_jsx(TagName, Object(esm_extends["a" /* default */])({
      className: classnames_default()("w-1/2 sm:w-auto sm:flex-1 max-w-1/2 flex flex-col items-center p-px10 text-".concat(color, " text-sm sm:text-base text-center"), Object(defineProperty["a" /* default */])({}, "focus:text-".concat(color, "-active hover:text-").concat(color, "-active transition-color"), url)),
      onClick: trackingData ? function () {
        return track(trackingData);
      } : undefined
    }, url ? {
      url: url
    } : null), ProductStrengths_jsx(Icon["a" /* Icon */], {
      className: "mb-px10",
      name: iconName,
      width: "3.75rem"
    }), ProductStrengths_jsx("span", {
      className: classnames_default()('block w-full', {
        'font-serif': isExclusiveCollection
      })
    }, label)));
  }));

  return isTablet || !displayLoadMore ? content : ProductStrengths_jsx(SeeMore["a" /* SeeMore */], {
    classNameButton: "text-center",
    isCollapseEnabled: true,
    seeLessLabel: seeLessLabel,
    seeMoreLabel: seeMoreLabel,
    seeMoreSize: 150
  }, content);
};
// CONCATENATED MODULE: ./src/client/components/lines/product-strengths-line/ProductStrengthsLine.jsx









var ProductStrengthsLine_jsx = react_default.a.createElement;

function ProductStrengthsLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductStrengthsLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductStrengthsLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductStrengthsLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var ProductStrengthsLine_ProductStrengthsLine = function ProductStrengthsLine(_ref) {
  var displayLoadMore = _ref.displayLoadMore,
      id = _ref.id,
      items = _ref.items,
      isExclusiveCollection = _ref.isExclusiveCollection,
      resort = _ref.resort,
      title = _ref.title;

  if (Object(lodash["isEmpty"])(items) || !resort) {
    return null;
  }

  var isProductExclusiveCollection = resort.isExclusiveCollection,
      isJoyview = resort.isJoyview;
  var isEC = isProductExclusiveCollection || isExclusiveCollection;
  var colorBlue = isEC ? colors["a" /* COLORS */].DEEP_BLUE : colors["a" /* COLORS */].BLUE;
  var color = isJoyview ? colors["a" /* COLORS */].WATER_GREEN : colorBlue;
  var filledItems = items.map(function (item) {
    return ProductStrengthsLine_objectSpread(ProductStrengthsLine_objectSpread({}, item), {}, {
      color: color,
      trackingData: {
        actionGA: 'productStrenghtsBanner',
        labelGA: item.label
      }
    });
  });
  return ProductStrengthsLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductStrengthsLine_jsx(LineTitle["a" /* LineTitle */], {
    color: color,
    isExclusiveCollection: isEC
  }, title), ProductStrengthsLine_jsx(ProductStrengths_ProductStrengths, {
    displayLoadMore: displayLoadMore,
    isExclusiveCollection: isEC,
    items: filledItems
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-strengths/productStrengths.resolver.js
var productStrengths_resolver = __webpack_require__("jVcT");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-strengths/productStrengths.descriptor.js



var productStrengthsDescriptor = {
  name: constants["W" /* PRODUCT_STRENGTHS */],
  component: ProductStrengthsLine_ProductStrengthsLine,
  resolve: productStrengths_resolver["a" /* productStrengthsResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-summary-line/ProductSummaryLine.jsx

var ProductSummaryLine_jsx = react_default.a.createElement;




var ProductSummaryLine_ProductSummaryLine = function ProductSummaryLine(_ref) {
  var _product$resortId;

  var id = _ref.id,
      color = _ref.color,
      config = _ref.config,
      product = _ref.product;
  return ProductSummaryLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductSummaryLine_jsx(ProductTeaser_ProductTeaser, {
    card: {
      heading: {
        iconName: product === null || product === void 0 ? void 0 : (_product$resortId = product.resortId) === null || _product$resortId === void 0 ? void 0 : _product$resortId.toLowerCase(),
        title: product === null || product === void 0 ? void 0 : product.name
      },
      link: {
        url: product === null || product === void 0 ? void 0 : product.href
      },
      text: {
        text: product === null || product === void 0 ? void 0 : product.title
      },
      color: color
    },
    product: Object(Product_mapper["c" /* getProductProps */])({
      config: config,
      product: product
    })
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-summary/productSummary.resolver.js
var productSummary_resolver = __webpack_require__("kawP");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-summary/productSummary.descriptor.js



var productSummaryDescriptor = {
  name: constants["sb" /* RESORT_SUMMARY */],
  component: ProductSummaryLine_ProductSummaryLine,
  resolve: productSummary_resolver["a" /* productSummaryResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/frameworks/content-slideshow/ContentSlideShow.jsx
var ContentSlideShow_jsx = react_default.a.createElement;





function ContentSlideShow(props) {
  var children = props.children,
      className = props.className;
  if (!react["Children"].count(children)) return null;
  return ContentSlideShow_jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    items: children
  }, function (_ref) {
    var hasControls = _ref.hasControls,
        isNextControlDisabled = _ref.isNextControlDisabled,
        isPreviousControlDisabled = _ref.isPreviousControlDisabled,
        itemsNode = _ref.itemsNode,
        onNext = _ref.onNext,
        onPrevious = _ref.onPrevious;
    return ContentSlideShow_jsx("div", {
      className: classnames_default()(className, 'flex items-center justify-center')
    }, hasControls && ContentSlideShow_jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none rtl:mr-px15 shadow-sm', {
        invisible: isPreviousControlDisabled
      }),
      isDisabled: isPreviousControlDisabled,
      label: Object(src_i18n["h" /* t */])('common.previous'),
      onClick: onPrevious
    }), itemsNode, hasControls && ContentSlideShow_jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none rtl:ml-px15 shadow-sm', {
        invisible: isNextControlDisabled
      }),
      isDisabled: isNextControlDisabled,
      label: Object(src_i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180
    }));
  });
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-awards/TripAdvisorAwards.jsx

var TripAdvisorAwards_jsx = react_default.a.createElement;




function TripAdvisorAwards(props) {
  var _props$awards = props.awards,
      awards = _props$awards === void 0 ? [] : _props$awards,
      className = props.className;
  if (Object(lodash["isEmpty"])(awards)) return null;
  return TripAdvisorAwards_jsx("section", {
    className: className
  }, TripAdvisorAwards_jsx(ContentSlideShow, null, awards.map(function (_ref) {
    var altMsg = _ref.altMsg,
        imageUrl = _ref.imageUrl;
    return imageUrl ? TripAdvisorAwards_jsx("article", {
      className: "leading-none overflow-hidden px-px5 text-center",
      key: imageUrl
    }, TripAdvisorAwards_jsx(Image["b" /* default */], {
      altMsg: altMsg,
      className: "mx-auto",
      dontChangeAnything: true,
      imageUrl: imageUrl,
      style: {
        maxHeight: 'calc(140rem / 16)'
      }
    })) : null;
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-ratings/TripAdvisorRatings.jsx



var TripAdvisorRatings_jsx = react_default.a.createElement;



var TripAdvisorRatings_TripAdvisorRatings = function TripAdvisorRatings(_ref) {
  var className = _ref.className,
      counterLabel = _ref.counterLabel,
      counterUnit = _ref.counterUnit,
      counterValue = _ref.counterValue,
      _ref$image = _ref.image,
      image = _ref$image === void 0 ? {} : _ref$image,
      _ref$subratings = _ref.subratings,
      subratings = _ref$subratings === void 0 ? [] : _ref$subratings;

  if (Object(lodash["isEmpty"])(subratings)) {
    return null;
  }

  return TripAdvisorRatings_jsx("section", {
    className: className
  }, TripAdvisorRatings_jsx("div", {
    className: "flex items-center justify-center"
  }, !Object(lodash["isEmpty"])(image) ? TripAdvisorRatings_jsx(Image["b" /* default */], Object(esm_extends["a" /* default */])({
    className: "my-px5",
    dontChangeAnything: true
  }, image)) : null, TripAdvisorRatings_jsx("span", null, "\xA0"), TripAdvisorRatings_jsx("p", {
    className: "reset-paragraph text-base"
  }, counterLabel, TripAdvisorRatings_jsx("span", null, " "), TripAdvisorRatings_jsx("span", {
    style: {
      color: '#429E96'
    }
  }, [counterValue, counterUnit].join(' ')))), TripAdvisorRatings_jsx("ul", {
    style: {
      width: 'calc(290rem / 16)'
    },
    className: "reset-list mt-px30 mx-auto px-px5"
  }, subratings.map(function (_ref2) {
    var localizedName = _ref2.localizedName,
        ratingImageUrl = _ref2.ratingImageUrl,
        value = _ref2.value;
    if (Object(lodash["isEmpty"])(subratings[0])) return null;
    return TripAdvisorRatings_jsx("li", {
      key: localizedName,
      className: "mt-px5 mx-auto flex items-center justify-between w-full"
    }, TripAdvisorRatings_jsx("span", {
      className: "leading-one rtl:pr-px5"
    }, localizedName), TripAdvisorRatings_jsx("span", {
      className: "leading-none",
      style: {
        width: '5rem'
      }
    }, TripAdvisorRatings_jsx(Image["b" /* default */], {
      className: "w-full",
      altMsg: "".concat(value),
      dontChangeAnything: true,
      imageUrl: ratingImageUrl,
      dimensions: {
        w: 80,
        h: 17
      },
      style: {
        maxHeight: '1rem',
        width: '100%'
      }
    })));
  })));
};
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-reviews/TripAdvisorReviews.jsx

var TripAdvisorReviews_jsx = react_default.a.createElement;







function TripAdvisorReviews(props) {
  var className = props.className,
      _props$maxLengthOfRev = props.maxLengthOfReview,
      maxLengthOfReview = _props$maxLengthOfRev === void 0 ? 255 : _props$maxLengthOfRev,
      _props$reviews = props.reviews,
      reviews = _props$reviews === void 0 ? [] : _props$reviews;
  if (Object(lodash["isEmpty"])(reviews)) return null;
  return TripAdvisorReviews_jsx("section", {
    className: className
  }, TripAdvisorReviews_jsx(ContentSlideShow, null, reviews.map(function (_ref) {
    var datetime = _ref.datetime,
        rating = _ref.rating,
        ratingImageUrl = _ref.ratingImageUrl,
        _ref$authors = _ref.authors,
        authors = _ref$authors === void 0 ? [] : _ref$authors,
        date = _ref.date,
        text = _ref.text,
        title = _ref.title,
        url = _ref.url;
    if (Object(lodash["isEmpty"])(text)) return null;
    return TripAdvisorReviews_jsx(TrackClick["a" /* TrackClick */], {
      as: DynamicLink["a" /* default */],
      trackingData: {
        categoryGA: 'resort',
        actionGA: 'practicalInfos',
        labelGA: 'tripAdvisorReviews'
      },
      className: "block text-inherit",
      key: url,
      target: "_blank",
      url: url
    }, TripAdvisorReviews_jsx("blockquote", {
      cite: url,
      className: "m-0"
    }, title && TripAdvisorReviews_jsx("p", {
      className: "reset-paragraph font-bold mb-px10",
      title: title
    }, title), TripAdvisorReviews_jsx("div", {
      className: "flex items-center mb-px10"
    }, TripAdvisorReviews_jsx(Image["b" /* default */], {
      altMsg: "".concat(rating),
      dontChangeAnything: true,
      imageUrl: ratingImageUrl
    }), TripAdvisorReviews_jsx("time", {
      dateTime: datetime,
      className: "rtl:ml-px15 text-sm"
    }, date)), text && TripAdvisorReviews_jsx("p", {
      className: "reset-paragraph mb-px10 decorator-quote",
      title: text
    }, Object(string_util["d" /* truncate */])(text, maxLengthOfReview)), TripAdvisorReviews_jsx("small", {
      className: "block text-sm"
    }, TripAdvisorReviews_jsx("span", null, authors.map(function (author) {
      return TripAdvisorReviews_jsx("span", {
        key: author,
        "data-testid": "TripAdvisorReviewsAuthor"
      }, author, TripAdvisorReviews_jsx("br", null));
    })))));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-large/TripAdvisorLarge.jsx

var TripAdvisorLarge_jsx = react_default.a.createElement;






function TripAdvisorLarge(props) {
  var _props$awards = props.awards,
      awards = _props$awards === void 0 ? [] : _props$awards,
      className = props.className,
      _props$ratings = props.ratings,
      ratings = _props$ratings === void 0 ? {} : _props$ratings,
      reviews = props.reviews;
  if (Object(lodash["isEmpty"])(awards) && Object(lodash["isEmpty"])(ratings.subratings) && Object(lodash["isEmpty"])(reviews)) return null;
  var classes = 'flex items-center justify-center mx-px10 p-px15 w-1/3 rounded-tiny border-1 border-gray-light';
  return TripAdvisorLarge_jsx("section", {
    className: classnames_default()(className, 'flex justify-center -mx-px10 pb-px10')
  }, !Object(lodash["isEmpty"])(ratings.subratings) && TripAdvisorLarge_jsx("div", {
    className: classes,
    style: {
      width: '23.75rem'
    }
  }, TripAdvisorLarge_jsx(TripAdvisorRatings_TripAdvisorRatings, Object(esm_extends["a" /* default */])({
    className: "max-w-full w-full"
  }, ratings, {
    subratings: ratings.subratings
  }))), !Object(lodash["isEmpty"])(reviews) && TripAdvisorLarge_jsx("div", {
    className: classnames_default()(classes, 'flex-1')
  }, TripAdvisorLarge_jsx(TripAdvisorReviews, {
    className: "max-w-full w-full",
    maxLengthOfReview: 150 // $FlowFixMe
    ,
    reviews: reviews
  })), !Object(lodash["isEmpty"])(awards) && TripAdvisorLarge_jsx("div", {
    className: classes,
    style: {
      width: '17.5rem'
    }
  }, TripAdvisorLarge_jsx(TripAdvisorAwards, {
    className: "max-w-full w-full",
    awards: awards
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor-narrow/TripAdvisorNarrow.jsx


var TripAdvisorNarrow_jsx = react_default.a.createElement;






function TripAdvisorNarrow(props) {
  var _props$awards = props.awards,
      awards = _props$awards === void 0 ? [] : _props$awards,
      awardsLabel = props.awardsLabel,
      className = props.className,
      _props$ratings = props.ratings,
      ratings = _props$ratings === void 0 ? {} : _props$ratings,
      ratingsLabel = props.ratingsLabel,
      reviews = props.reviews,
      reviewsLabel = props.reviewsLabel;

  var _useState = Object(react["useState"])(0),
      position = _useState[0],
      setPosition = _useState[1];

  var hasAwards = !Object(lodash["isEmpty"])(awards);
  var hasRatings = !Object(lodash["isEmpty"])(ratings.subratings);
  var hasReviews = !Object(lodash["isEmpty"])(reviews);
  if (!hasAwards && !hasRatings && !hasReviews) return null;
  var items = [];
  var nav = [];

  if (hasReviews) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorReviews, {
      key: "reviews",
      className: "w-full" // $FlowFixMe
      ,
      reviews: reviews,
      maxLengthOfReview: 150
    }));
    nav.push(reviewsLabel);
  }

  if (hasRatings) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorRatings_TripAdvisorRatings, Object(esm_extends["a" /* default */])({}, ratings, {
      key: "ratings",
      className: "w-full",
      subratings: ratings.subratings
    })));
    nav.push(ratingsLabel);
  }

  if (hasAwards) {
    items.push(TripAdvisorNarrow_jsx(TripAdvisorAwards, {
      key: "awards",
      className: "w-full self-center",
      awards: awards
    }));
    nav.push(awardsLabel);
  }

  return TripAdvisorNarrow_jsx("section", {
    className: classnames_default()(className, 'mx-auto'),
    style: {
      maxWidth: '37.5rem'
    }
  }, TripAdvisorNarrow_jsx("div", {
    className: "border-1 border-gray-light rounded-tiny overflow-hidden"
  }, TripAdvisorNarrow_jsx("div", {
    className: "flex transition-transform",
    style: {
      transform: "translate(".concat(position * -100, "%, 0)")
    }
  }, items.map(function (item, idx) {
    return TripAdvisorNarrow_jsx("div", {
      key: idx,
      "aria-hidden": position !== idx,
      className: classnames_default()('max-w-full min-w-full overflow-hidden p-px10 flex', {
        invisible: position !== idx
      })
    }, item);
  }))), TripAdvisorNarrow_jsx("div", {
    className: "flex relative"
  }, TripAdvisorNarrow_jsx("div", {
    className: "absolute arrow-up arrow-white arrow-bg arrow-bg-blue border-t-1 border-blue",
    style: {
      width: "".concat(100 / nav.length, "%"),
      margin: "0 ".concat(100 / nav.length * position, "%"),
      transition: 'all .25s ease-in .2s'
    }
  }), nav.map(function (button, idx) {
    return TripAdvisorNarrow_jsx("button", {
      className: classnames_default()('reset-button flex-1 font-bold py-px20 text-base text-center', {
        'text-gray-medium': idx !== position
      }, {
        'text-turquoise': idx === position
      }),
      onClick: function onClick() {
        return setPosition(idx);
      },
      type: "button",
      key: button
    }, TripAdvisorNarrow_jsx("span", {
      className: classnames_default()('px-px10 block', {
        'rtl:border-l-1': idx > 0
      })
    }, button));
  })));
}
// CONCATENATED MODULE: ./src/client/components/widgets/tripadvisor/TripAdvisor.jsx
var TripAdvisor_jsx = react_default.a.createElement;




function TripAdvisor(props) {
  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  return isDesktop ? TripAdvisor_jsx(TripAdvisorLarge, props) : TripAdvisor_jsx(TripAdvisorNarrow, props);
}
// CONCATENATED MODULE: ./src/client/components/lines/product-tripadvisor-line/ProductTripAdvisorLine.jsx

var ProductTripAdvisorLine_jsx = react_default.a.createElement;







var ProductTripAdvisorLine_ProductTripAdvisorLine = function ProductTripAdvisorLine(props) {
  var tripadvisor = props.tripadvisor;

  var _useResponsive = Object(responsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  if (!tripadvisor || !tripadvisor.tripAdvisorUrl) {
    return null;
  }

  var awards = tripadvisor.awards.map(function (_ref) {
    var displayName = _ref.displayName,
        _ref$images = _ref.images,
        images = _ref$images === void 0 ? {} : _ref$images;
    return {
      altMsg: displayName,
      imageUrl: images.large
    };
  });
  var awardsLabel = props.awards;
  var ratings = {
    counterLabel: props.basedOn,
    counterUnit: props.reviews,
    counterValue: tripadvisor.numReviews,
    image: {
      altMsg: tripadvisor.rating,
      imageUrl: tripadvisor.ratingImageUrl
    },
    subratings: tripadvisor.subratings,
    title: props.ratingTitle
  };
  var ratingsLabel = props.ratings;
  var reviews = tripadvisor.reviews.map(function (review) {
    return {
      authors: review.reviewAuthor,
      date: review.reviewDate,
      datetime: review.publishedDate,
      rating: review.rating,
      ratingImageUrl: review.ratingImageUrl,
      text: review.text,
      title: review.title,
      url: review.url
    };
  });
  var reviewsLabel = props.reviews;
  var tripAdvisorUrl = tripadvisor.tripAdvisorUrl;
  var tripAdvisorLineTitle = props.tripAdvisorLineTitle,
      tripAdvisorViewMoreLabel = props.tripAdvisorViewMoreLabel;
  return ProductTripAdvisorLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: "tripadvisor"
  }, ProductTripAdvisorLine_jsx("div", {
    className: "relative"
  }, ProductTripAdvisorLine_jsx(LineTitle["a" /* LineTitle */], null, tripAdvisorLineTitle), isDesktop ? ProductTripAdvisorLine_jsx(TextLink["a" /* TextLink */], {
    className: "absolute rtl:right-0 top-0",
    color: colors["a" /* COLORS */].GRAY_DARKER,
    iconRightName: null,
    label: tripAdvisorViewMoreLabel,
    theme: "simple",
    url: tripAdvisorUrl,
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'practicalInfos',
      labelGA: 'tripAdvisorSeeMore'
    }
  }) : null), ProductTripAdvisorLine_jsx(TripAdvisor, {
    awards: awards,
    awardsLabel: awardsLabel,
    ratings: ratings,
    ratingsLabel: ratingsLabel,
    reviews: reviews,
    reviewsLabel: reviewsLabel
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-tripadvisor/productTripadvisor.resolver.js
var productTripadvisor_resolver = __webpack_require__("ODPy");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-tripadvisor/productTripadvisor.descriptor.js



var productTripadvisorDescriptor = {
  name: constants["ub" /* RESORT_TRIPADVISOR */],
  component: ProductTripAdvisorLine_ProductTripAdvisorLine,
  resolve: productTripadvisor_resolver["a" /* productTripadvisorResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/product-wellness-line/ProductWellnessLine.jsx









var ProductWellnessLine_jsx = react_default.a.createElement;

function ProductWellnessLine_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function ProductWellnessLine_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductWellnessLine_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductWellnessLine_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var ProductWellnessLine_ProductWellnessLine = function ProductWellnessLine(props) {
  var _props$config$common = props.config.common,
      loadLess = _props$config$common.loadLess,
      scrollBackward = _props$config$common.scrollBackward,
      scrollForward = _props$config$common.scrollForward,
      viewMore = _props$config$common.viewMore,
      id = props.id,
      _props$resort = props.resort,
      wellness = _props$resort.categories.wellness,
      _props$resort$wellnes = _props$resort.wellnessActivitiesIntroduction,
      wellnessActivitiesIntroduction = _props$resort$wellnes === void 0 ? {} : _props$resort$wellnes;

  var _useRouter = Object(useRouter["a" /* useRouter */])(),
      location = _useRouter.location;

  var appContext = Object(react["useContext"])(ReactAppContext["b" /* default */]);

  var fetchActivityServices = function fetchActivityServices(_ref) {
    var productId = _ref.productId,
        activityId = _ref.activityId;
    var query = Object(productFeatures_queries["e" /* productWellnessDetailQuery */])(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams
    });
    return graphqlClient["a" /* default */].runQuery(query, appContext, {
      requestName: requestDictionary["Kd" /* WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES */]
    }).then(function (data) {
      Object(src_i18n["a" /* addTranslationKeys */])(data.config);
      return {
        productActivities: ProductWellnessLine_objectSpread(ProductWellnessLine_objectSpread({}, data.productActivities), {}, {
          includedServices: data.includedServices,
          onDemandServices: data.onDemandServices
        })
      };
    });
  };

  var introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text: wellnessActivitiesIntroduction.description,
    title: wellnessActivitiesIntroduction.shortDescription
  };
  var productActivitiesCategories = wellness && wellness.filter(function (_ref2) {
    var _ref2$activities = _ref2.activities,
        activities = _ref2$activities === void 0 ? [] : _ref2$activities;
    return activities.length;
  });
  var productCategories = mapCategories({
    fetchActivityServices: fetchActivityServices,
    hasBanner: false,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].WELLNESS,
    productActivitiesCategories: productActivitiesCategories,
    productFeaturesLineData: props
  });
  return ProductWellnessLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, ProductWellnessLine_jsx(ProductFeatures_ProductFeatures, {
    categories: productCategories,
    introduction: introduction,
    labelGAPrefix: tracking_resort["a" /* TRACKING_PREFIX_MAPPING */].WELLNESS,
    queryLayer: "productWellnessLayer",
    renderDetail: function renderDetail(data) {
      return ProductWellnessLine_jsx(ProductFeatureDetail, data);
    },
    scrollBackwardLabel: scrollBackward,
    scrollForwardLabel: scrollForward
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/product-wellness/productWellness.resolver.js
var productWellness_resolver = __webpack_require__("i0/9");

// CONCATENATED MODULE: ./src/client/cms/toolkit/product-wellness/productWellness.descriptor.js



var productWellnessDescriptor = {
  name: constants["Y" /* PRODUCT_WELLNESS */],
  component: ProductWellnessLine_ProductWellnessLine,
  resolve: productWellness_resolver["a" /* productWellnessResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/widgets/tour-information/TourInformation.jsx

var TourInformation_jsx = react_default.a.createElement;



function TourInformation(_ref) {
  var infos = _ref.infos;
  return TourInformation_jsx("div", {
    className: "flex flex-wrap -m-px10"
  }, infos.map(function (_ref2) {
    var items = _ref2.items,
        text = _ref2.text,
        title = _ref2.title;
    return TourInformation_jsx("div", {
      className: "w-full sm:w-1/2 p-px10",
      key: title
    }, TourInformation_jsx(Title["a" /* Title */], {
      className: "mb-px10",
      theme: "title-sans-2"
    }, title), items && TourInformation_jsx("ul", {
      className: "reset-list leading-normal text-base text-gray-darker"
    }, items.map(function (item) {
      return TourInformation_jsx("li", {
        className: "list-disc py-px5",
        key: item
      }, item);
    })), text && TourInformation_jsx(Text["a" /* Text */], {
      text: text
    }));
  }));
}
// CONCATENATED MODULE: ./src/client/components/lines/tour-introduction-line/TourIntroductionLine.jsx
var TourIntroductionLine_jsx = react_default.a.createElement;



var TourIntroductionLine_TourIntroductionLine = function TourIntroductionLine(_ref) {
  var highlightTitle = _ref.highlightTitle,
      resort = _ref.resort,
      roadmapTitle = _ref.roadmapTitle;
  var details = resort.details,
      strengths = resort.strengths;
  var infos = [];

  if (details && details.length) {
    infos.push({
      title: roadmapTitle,
      items: details
    });
  }

  if (strengths && strengths.length) {
    infos.push({
      title: highlightTitle,
      items: strengths
    });
  }

  if (!infos.length) {
    return null;
  }

  return TourIntroductionLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, TourIntroductionLine_jsx(TourInformation, {
    infos: infos
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-introduction/tourIntroduction.resolver.js
var tourIntroduction_resolver = __webpack_require__("klIi");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-introduction/tourIntroduction.descriptor.js



var tourIntroductionDescriptor = {
  name: constants["Gb" /* TOUR_INTRODUCTION */],
  component: TourIntroductionLine_TourIntroductionLine,
  resolve: tourIntroduction_resolver["a" /* tourIntroductionResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/tour-practical-information-line/TourPracticalInformationLine.jsx
var TourPracticalInformationLine_jsx = react_default.a.createElement;



var TourPracticalInformationLine_TourPracticalInformationLine = function TourPracticalInformationLine(props) {
  var _props$resort$practic = props.resort.practicalInformation,
      includedInPackage = _props$resort$practic.includedInPackage,
      excludedInPackage = _props$resort$practic.excludedInPackage,
      healthFormalities = _props$resort$practic.healthFormalities,
      passportAndVisas = _props$resort$practic.passportAndVisas,
      immigrationFormalities = props.immigrationFormalities,
      healthFormalitiesTitle = props.healthFormalities,
      includedInTour = props.includedInTour,
      notIncludedInTour = props.notIncludedInTour;
  var infos = [];

  if (includedInPackage && includedInPackage.length) {
    infos.push({
      title: includedInTour,
      items: includedInPackage
    });
  }

  if (excludedInPackage && excludedInPackage.length) {
    infos.push({
      title: notIncludedInTour,
      items: excludedInPackage
    });
  }

  if (passportAndVisas) {
    infos.push({
      title: immigrationFormalities,
      text: passportAndVisas
    });
  }

  if (healthFormalities) {
    infos.push({
      title: healthFormalitiesTitle,
      text: healthFormalities
    });
  }

  if (!infos.length) {
    return null;
  }

  return TourPracticalInformationLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line"
  }, TourPracticalInformationLine_jsx(TourInformation, {
    infos: infos
  }));
};
// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-practical-information/tourPracticalInformation.resolver.js
var tourPracticalInformation_resolver = __webpack_require__("v7Z5");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-practical-information/tourPracticalInformation.descriptor.js



var tourPracticalInformationDescriptor = {
  name: constants["Hb" /* TOUR_PRACTICAL_INFORMATION */],
  component: TourPracticalInformationLine_TourPracticalInformationLine,
  resolve: tourPracticalInformation_resolver["a" /* tourPracticalInformationResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/components/lines/tour-program-line/TourProgramLine.jsx

var TourProgramLine_jsx = react_default.a.createElement;



function TourProgramLine(_ref) {
  var id = _ref.id,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["id"]);

  var _props$stopover = props.stopover,
      stopover = _props$stopover === void 0 ? {} : _props$stopover;
  var _stopover$tour = stopover.tour,
      tour = _stopover$tour === void 0 ? {} : _stopover$tour,
      _stopover$extension = stopover.extension,
      extension = _stopover$extension === void 0 ? {} : _stopover$extension;
  return TourProgramLine_jsx(SiteContainer["a" /* SiteContainer */], {
    id: id,
    className: "Line"
  }, TourProgramLine_jsx(ProductProgram, {
    isDetailed: props.isDetailed,
    extension: {
      title: extension.title,
      subtitle: extension.duration,
      stops: extension.stops
    },
    program: {
      title: tour.title,
      subtitle: tour.duration,
      stops: tour.stops
    }
  }));
}
// EXTERNAL MODULE: ./src/client/cms/toolkit/tour-program/tourProgram.resolver.js
var tourProgram_resolver = __webpack_require__("pUua");

// CONCATENATED MODULE: ./src/client/cms/toolkit/tour-program/tourProgram.descriptor.js



var tourProgramDescriptor = {
  name: constants["Ib" /* TOUR_PROGRAM */],
  component: TourProgramLine,
  resolve: tourProgram_resolver["a" /* tourProgramResolver */].resolve
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/descriptors.js



/* layout lines */

/* common lines */






































/* home lines : homepage recommended */



/* country lines : webedia countryId needed */





/* offer lines : offerId needed */




/* cruise lines : resortId/productId needed (only cruise ID) */


 // no ID needed but commonly on cruise page

/* product lines : resortId/productId needed */





























 // no ID but commonly on product page

 // no ID but commonly on product page

 // no ID but commonly on product page





/* tour lines : resortId/productId needed (only tour ID) */




var descriptors = [allInclusivePushDescriptor, brandPromiseDescriptor, checklistDescriptor, countryEventsDescriptor, countryInfosDescriptor, countryIntroductionDescriptor, countryPoiDescriptor, crisisAlertDescriptor, cruiseBookingDescriptor, cruiseProgramDescriptor, destinationsDescriptor, downloadLinksListDescriptor, editorialFoldingBlockDescriptor, eventAnimationDescriptor, eventFormDescriptor, buttonTicketDescriptor, highlightDescriptor, immersiveDescriptor, instagramDescriptor, lastSeenProductsDescriptor, mediaTextHorizontalDescriptor, mediaTextVerticalDescriptor, mediaThumbnailDescriptor, navigationTabDescriptor, navigationTabsDescriptor, offerDescriptionDescriptor, offerLegalInformationDescriptor, offerSEODescriptor, offersGridDescriptor, offersPushDescriptor, pageTrackingDescriptor, prebookingFormDescriptor, productAccessAndMapDescriptor, productAccommodationsDescriptor, productAccommodationsExclusiveCollectionDescriptor, productActivitiesDescriptor, productBarsDescriptor, productBookingBEDescriptor, productBreadcrumbDescriptor, productChildcaresDescriptor, productCommunityQuestionsDescriptor, productDestinationDescriptor, productExclusiveCollectionSpaceDescriptor, productFlashInfoDescriptor, productGoogleStreetViewDescriptor, productImageMapDescriptor, productImmersiveDescriptor, productInformationSummaryDescriptor, productInstagramDescriptor, productIntroductionDescriptor, productMeetingRoomInfoDescriptor, productMultimediaDescriptor, productMustTryExperiencesDescriptor, productPriceRemoteDescriptor, productPriceTicketDescriptor, productPriceTicketCustomDescriptor, productRecommendationsDescriptor, productRelatedProductsDescriptor, productRestaurantsDescriptor, productSEOTitleDescriptor, productServicesDescriptor, productsFiltersDescriptor, productsGridDescriptor, productQuotationFormDescriptor, productSignaturesDescriptor, productSpaceIntroductionDescriptor, productStrengthsDescriptor, productSummaryDescriptor, productTagsDescriptor, productTripadvisorDescriptor, productWellnessDescriptor, sectionDescriptor, sectionsDescriptor, smartFaqDescriptor, submissionStatusDescriptor, tabDescriptor, tabsDescriptor, teaserCardsDescriptor, testABDescriptor, textDescriptor, thematicDescriptor, titleAndTextDescriptor, tourIntroductionDescriptor, tourPracticalInformationDescriptor, tourProgramDescriptor, travelRestrictionsDescriptor, tripadvisorTestimonyDescriptor, videoDescriptor];
var descriptorsLibrary = descriptors.reduce(function (acc, descriptor) {
  if (acc[descriptor.name]) {
    throw new Error("A descriptor named ".concat(descriptor.name, " is already set."));
  }

  acc[descriptor.name] = descriptor;
  return acc;
}, {});
// EXTERNAL MODULE: ./src/client/context/ErrorBoundary.jsx
var ErrorBoundary = __webpack_require__("oG87");

// CONCATENATED MODULE: ./src/client/components/frameworks/line/Line.jsx




var Line_jsx = react_default.a.createElement;



function Line(_ref) {
  var id = _ref.id,
      component = _ref.component,
      name = _ref.name,
      _ref$pageLines = _ref.pageLines,
      pageLines = _ref$pageLines === void 0 ? [] : _ref$pageLines,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(objectWithoutProperties["a" /* default */])(_ref$props, ["lines"]);

  // A Line can have nested lines. The root Line, the one in `DynamicPage.jsx` doesn't match to a
  // component, the component is just used for the recursion
  var Component = // When coming from the standard lines process (formatLinesForLineComponent of DynamicPage)
  // there is not component wired to a line, we retrieve the corresponding component from its name
  // But some lines (editorialFoldingBlock for instance) directly render lines themselves, and
  // pass a component prop, which then takes priority
  component || descriptorsLibrary[name] && descriptorsLibrary[name].component || null;

  if (Component) {
    return Line_jsx(ErrorBoundary["a" /* ErrorBoundary */], {
      key: id
    }, Line_jsx(Component, Object(esm_extends["a" /* default */])({}, props, {
      lines: lines,
      pageLines: pageLines
    }), lines.map(Line)));
  }

  return lines.length > 0 ? Line_jsx(react["Fragment"], {
    key: id
  }, lines.map(function (linesProps) {
    return Line_jsx(Line, Object(esm_extends["a" /* default */])({}, linesProps, {
      key: linesProps.id,
      pageLines: pageLines
    }));
  })) : null;
}

/***/ }),

/***/ "ydRd":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("fhLv");
var isCallable = __webpack_require__("ANQd");
var classof = __webpack_require__("3LIW");
var getBuiltIn = __webpack_require__("x90g");
var inspectSource = __webpack_require__("/ExG");

var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = constructorRegExp.exec;
var INCORRECT_TO_STRING = !constructorRegExp.exec(function () { /* empty */ });

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(Object, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec.call(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "yfdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ ProductPriceModal_ProductPriceModal; });

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.utils.js

var ProductPriceModal_utils_getLabel = function getLabel(_ref) {
  var isJoyview = _ref.isJoyview,
      isTour = _ref.isTour;

  if (isTour) {
    return '';
  }

  return isJoyview ? Object(i18n["h" /* t */])('resort.startingPrice.roomOnly') : Object(i18n["h" /* t */])('resort.startingPrice.allInclusive');
};
// EXTERNAL MODULE: ./src/client/components/frameworks/pop-over/PopOver.jsx + 1 modules
var PopOver = __webpack_require__("Xzib");

// EXTERNAL MODULE: ./src/client/components/widgets/product-price-info/ProductPriceInfo.jsx
var ProductPriceInfo = __webpack_require__("ZS6v");

// CONCATENATED MODULE: ./src/client/components/widgets/product-price-modal/ProductPriceModal.jsx
var __jsx = react_default.a.createElement;




var ProductPriceModal_ProductPriceModal = function ProductPriceModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      city = _ref.city,
      endDate = _ref.endDate,
      _ref$hasTransport = _ref.hasTransport,
      hasTransport = _ref$hasTransport === void 0 ? false : _ref$hasTransport,
      _ref$isCruise = _ref.isCruise,
      isCruise = _ref$isCruise === void 0 ? false : _ref$isCruise,
      _ref$isJoyview = _ref.isJoyview,
      isJoyview = _ref$isJoyview === void 0 ? false : _ref$isJoyview,
      _ref$isTour = _ref.isTour,
      isTour = _ref$isTour === void 0 ? false : _ref$isTour,
      onClick = _ref.onClick,
      onClickButton = _ref.onClickButton,
      startDate = _ref.startDate,
      unit = _ref.unit;

  if (!react["Children"].count(children)) {
    return null;
  }

  return __jsx(PopOver["a" /* PopOver */], {
    ariaLabel: ProductPriceModal_utils_getLabel({
      isJoyview: isJoyview,
      isTour: isTour
    }),
    className: className,
    content: __jsx(ProductPriceInfo["a" /* ProductPriceInfo */], {
      city: city,
      endDate: endDate,
      hasTransport: hasTransport,
      isCruise: isCruise,
      isJoyview: isJoyview,
      isTour: isTour,
      onClick: onClickButton,
      startDate: startDate,
      unit: unit
    }),
    onClick: onClick,
    triggerOnHover: true
  }, children);
};

/***/ }),

/***/ "yhbn":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("gIGD");
var isConstructor = __webpack_require__("ydRd");
var isObject = __webpack_require__("1YFU");
var wellKnownSymbol = __webpack_require__("nJrx");

var SPECIES = wellKnownSymbol('species');

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "yjkv":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("S3pA"),
    baseUniq = __webpack_require__("s+R0");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),

/***/ "ysqo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("1t7P");

__webpack_require__("2G9S");

__webpack_require__("LW0h");

__webpack_require__("jwue");

__webpack_require__("vrRf");

__webpack_require__("lTEL");

__webpack_require__("z84I");

__webpack_require__("KOtZ");

__webpack_require__("wFPu");

__webpack_require__("M+/F");

__webpack_require__("5BYb");

__webpack_require__("daRM");

__webpack_require__("FtHn");

__webpack_require__("+KXO");

__webpack_require__("7x/C");

__webpack_require__("LqLs");

__webpack_require__("87if");

__webpack_require__("3voH");

__webpack_require__("ZUdG");

__webpack_require__("+oxZ");

__webpack_require__("kYxP");

var _defineProperty = __webpack_require__("O5Wi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.defaultHead = defaultHead;
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__("ERkP"));

var _sideEffect = _interopRequireDefault(__webpack_require__("J9Yr"));

var _ampContext = __webpack_require__("TZT2");

var _headManagerContext = __webpack_require__("op+c");

var _amp = __webpack_require__("dq4L");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react.default.createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react.default.createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react.default.Fragment) {
    return list.concat(_react.default.Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
returns a function for filtering head child elements
which shouldn't be duplicated, like <title/>
Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if (categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
*
* @param headElements List of multiple <Head> instances
*/


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react.default.Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if (false) { var newProps; }

    return /*#__PURE__*/_react.default.cloneElement(c, {
      key: key
    });
  });
}
/**
* This component injects elements to `<head>` of your page.
* To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
*/


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react.useContext)(_ampContext.AmpStateContext);
  var headManager = (0, _react.useContext)(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react.default.createElement(_sideEffect.default, {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp.isInAmpMode)(ampState)
  }, children);
} // TODO: Remove in the next major release


Head.rewind = function () {};

var _default = Head;
exports.default = _default;

/***/ }),

/***/ "yvHl":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("DZWw");
var isCallable = __webpack_require__("ANQd");
var toObject = __webpack_require__("A+R+");
var sharedKey = __webpack_require__("mmil");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("xVJP");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (has(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "z7Vv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "z8xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BOAT */
/* unused harmony export PLANE */
/* unused harmony export TRAIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSPORT_CLASS_TO_I18N; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SNCF_ID; });
/* unused harmony export getFindSectionTransportTypeFn */
/* unused harmony export getClassLabel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDiffAbsoluteDays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getWayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatConnectionLabel; });
/* unused harmony export getStep */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasOnlyPlanes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isTransportPlaneTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return tripsHaveSchedules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return transformMinutesInHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTransportIcon; });
/* unused harmony export hasCancellationPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCancellationPolicyDescription; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("DfhM");
/* harmony import */ var core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_every__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("hBpG");
/* harmony import */ var core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("5BYb");
/* harmony import */ var core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_some__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("Jhhs");
/* harmony import */ var core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_pad_start__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("SPKZ");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("kiXb");
/* harmony import */ var _utils_date_apiDate__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("ldK3");
/* harmony import */ var _utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("oL6k");

















var BOAT = 'BOAT';
var PLANE = 'PLANE';
var TRAIN = 'TRAIN';
var TRANSPORT_CLASS_TO_I18N = {
  '1CL': 'firstClassLabel',
  '2CL': 'secondClassLabel',
  BUS: 'businessClassLabel',
  DIV: 'economyClassLabel',
  DIB: 'emeraldClassLabel',
  'EC+': 'alizeeClassLabel',
  ECO: 'economyClassLabel',
  FIR: 'firstClassLabel',
  PRC: 'premiumClassLabel',
  PRE: 'premiumClassLabel'
};
var SNCF_ID = 'SNC';

function getDiffAbsoluteDays(fromDate, toDate) {
  var fromMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_15__[/* momentFromApiDate */ "h"])(fromDate);
  var toMoment = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_15__[/* momentFromApiDate */ "h"])(toDate);

  if (fromMoment.isValid() && toMoment.isValid()) {
    return toMoment.diff(fromMoment, 'days');
  }

  return null;
}

function formatTime(time, format) {
  var renderedTime = Object(_utils_date_apiDate__WEBPACK_IMPORTED_MODULE_15__[/* momentFromApiTime */ "i"])(time).format(format);
  return renderedTime !== 'Invalid date' ? renderedTime : null;
}

function getWayLabel(i18n, way) {
  var _i18n$common, _i18n$common$transpor, _i18n$common2, _i18n$common2$transpo;

  if (way === 'INBOUND') return i18n === null || i18n === void 0 ? void 0 : (_i18n$common = i18n.common) === null || _i18n$common === void 0 ? void 0 : (_i18n$common$transpor = _i18n$common.transport) === null || _i18n$common$transpor === void 0 ? void 0 : _i18n$common$transpor.inboundLabel;
  if (way === 'OUTBOUND') return i18n === null || i18n === void 0 ? void 0 : (_i18n$common2 = i18n.common) === null || _i18n$common2 === void 0 ? void 0 : (_i18n$common2$transpo = _i18n$common2.transport) === null || _i18n$common2$transpo === void 0 ? void 0 : _i18n$common2$transpo.outboundLabel;
  return null;
}

function formatConnectionLabel(label, duration) {
  var durationAsNumber = duration ? +duration : 0;
  var durationFormated = moment__WEBPACK_IMPORTED_MODULE_11___default.a.utc(moment__WEBPACK_IMPORTED_MODULE_11___default.a.duration(durationAsNumber, 'minutes').asMilliseconds());
  return Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["messageFormat"])('{label} {duration}').format({
    label: label,
    duration: "".concat(durationFormated.format('HH'), "h").concat(durationFormated.format('mm'))
  });
}

function getStep(i18n) {
  var _i18n$common3, _i18n$common3$transpo;

  var _ref = (i18n === null || i18n === void 0 ? void 0 : i18n.common) || {},
      timeFormat = _ref.timeFormat;

  var transportConnectionLabel = i18n === null || i18n === void 0 ? void 0 : (_i18n$common3 = i18n.common) === null || _i18n$common3 === void 0 ? void 0 : (_i18n$common3$transpo = _i18n$common3.transport) === null || _i18n$common3$transpo === void 0 ? void 0 : _i18n$common3$transpo.connection;
  return function (step) {
    var connectionDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'connectionDurationInMin');
    var stopOverDuration = Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'stopDurationInMin');
    var information = !Object(lodash__WEBPACK_IMPORTED_MODULE_10__["isEmpty"])(stopOverDuration) || !Object(lodash__WEBPACK_IMPORTED_MODULE_10__["isEmpty"])(connectionDuration) ? formatConnectionLabel(transportConnectionLabel, stopOverDuration || connectionDuration) : null;
    return {
      id: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'transport.reference'),
      type: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'transport.type'),
      information: information,
      operator: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'transport.companyOperator.label'),
      operatorId: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'transport.companyOperator.id'),
      operatorLogo: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'transport.companyOperator.logo'),
      start: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'departure.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'departure.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'departure.date')
      },
      end: {
        label: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'arrival.airportLabel'),
        time: formatTime(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'arrival.time'), timeFormat),
        date: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'arrival.date')
      },
      technicalStops: Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(step, 'technicalStops')
    };
  };
}

function hasOnlyBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.every(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasBoat(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(section, 'transport.type') === BOAT;
  });
}

function hasTrain(travelSections) {
  if (!travelSections || !travelSections.length) {
    return false;
  }

  return travelSections.some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(section, 'transport.type') === TRAIN;
  });
}

function hasOnlyPlanes(travelSections) {
  return !(hasTrain(travelSections) || hasBoat(travelSections));
}

function isTransportPlaneTicket(inboundFlight, outboundFlight) {
  return hasOnlyPlanes(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(inboundFlight, 'travelSections')) && hasOnlyPlanes(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(outboundFlight, 'travelSections'));
}

function getTransportIcon(inboundFlight, outboundFlight) {
  var isTrain = hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(inboundFlight, 'travelSections')) && hasTrain(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(outboundFlight, 'travelSections'));

  if (isTrain) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__[/* ICONS */ "a"].TRAIN;
  }

  var isBoat = hasOnlyBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(inboundFlight, 'travelSections')) && hasOnlyBoat(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(outboundFlight, 'travelSections'));

  if (isBoat) {
    return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__[/* ICONS */ "a"].BOAT;
  }

  return _utils_icon_icons__WEBPACK_IMPORTED_MODULE_13__[/* ICONS */ "a"].TRANSPORT;
}

function tripHasSchedules(travelSections) {
  return !Object(lodash__WEBPACK_IMPORTED_MODULE_10__["isEmpty"])(travelSections) ? (travelSections || []).some(function (section) {
    return Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(section, 'arrival.time') || Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(section, 'departure.time');
  }) : false;
}

function tripsHaveSchedules(inboundFlight, outboundFlight) {
  return tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(inboundFlight, 'travelSections')) || tripHasSchedules(Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(outboundFlight, 'travelSections'));
}

function transformMinutesInHours(minutes) {
  var numberMinutes = Number(minutes); // TODO cms translate h & m

  return Math.floor(numberMinutes / 60) + ' h ' + (numberMinutes % 60).toString().padStart(2, '0') + ' min';
}

function hasCancellationPolicy(transport) {
  var _transport$inbound, _transport$inbound2, _transport$outbound; // in case of AlternativeTransport


  if ((_transport$inbound = transport.inbound) === null || _transport$inbound === void 0 ? void 0 : _transport$inbound.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_16__[/* isCharterFlight */ "v"])(((_transport$inbound$jo = transport.inbound.journey) === null || _transport$inbound$jo === void 0 ? void 0 : _transport$inbound$jo.cancellationPolicyType) || '') || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.some(function (outbound) {
        var _outbound$journey;

        return (// $FlowFixMe at this point it's an AlternativeTransport object
          Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_16__[/* isCharterFlight */ "v"])(((_outbound$journey = outbound.journey) === null || _outbound$journey === void 0 ? void 0 : _outbound$journey.cancellationPolicyType) || '')
        );
      })
    );
  } // in case of Transport


  return (// $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_16__[/* isCharterFlight */ "v"])(((_transport$inbound2 = transport.inbound) === null || _transport$inbound2 === void 0 ? void 0 : _transport$inbound2.cancellationPolicyType) || '') || // $FlowFixMe at this point it's a Transport object
    Object(_utils_proposal_proposalUtils__WEBPACK_IMPORTED_MODULE_16__[/* isCharterFlight */ "v"])(((_transport$outbound = transport.outbound) === null || _transport$outbound === void 0 ? void 0 : _transport$outbound.cancellationPolicyType) || '')
  );
} // TODO: check business rule


var getCancellationPolicy = function getCancellationPolicy(transport) {
  var _transport$inbound3, _transport$inbound4, _transport$outbound2; // in case of AlternativeTransport


  if ((_transport$inbound3 = transport.inbound) === null || _transport$inbound3 === void 0 ? void 0 : _transport$inbound3.hasOwnProperty('transportInfo')) {
    var _transport$inbound$jo2;

    return (// $FlowFixMe at this point it's an AlternativeTransport object
      ((_transport$inbound$jo2 = transport.inbound.journey) === null || _transport$inbound$jo2 === void 0 ? void 0 : _transport$inbound$jo2.cancellationPolicyType) || // $FlowFixMe at this point it's an AlternativeTransport object
      transport.outboundList.find(function (outbound) {
        var _outbound$journey2;

        return !!((_outbound$journey2 = outbound.journey) === null || _outbound$journey2 === void 0 ? void 0 : _outbound$journey2.cancellationPolicyType);
      })
    );
  } // in case of Transport
  // $FlowFixMe at this point it's an Transport object


  return ((_transport$inbound4 = transport.inbound) === null || _transport$inbound4 === void 0 ? void 0 : _transport$inbound4.cancellationPolicyType) || ((_transport$outbound2 = transport.outbound) === null || _transport$outbound2 === void 0 ? void 0 : _transport$outbound2.cancellationPolicyType);
};

var getCancellationPolicyDescription = function getCancellationPolicyDescription(transport, i18n) {
  if (hasCancellationPolicy(transport)) {
    var _i18n$bookingProcess$;

    var cancellationPolicy = getCancellationPolicy(transport);
    return i18n === null || i18n === void 0 ? void 0 : (_i18n$bookingProcess$ = i18n.bookingProcess.find(function (legalInformation) {
      return legalInformation.id === cancellationPolicy;
    })) === null || _i18n$bookingProcess$ === void 0 ? void 0 : _i18n$bookingProcess$.description;
  }
};

var getFindSectionTransportTypeFn = function getFindSectionTransportTypeFn(transportType) {
  return function (_ref2) {
    var type = _ref2.transport.type;
    return type === transportType;
  };
};
var getClassLabel = function getClassLabel(_ref3) {
  var transportType = _ref3.transportType,
      travelSections = _ref3.travelSections,
      inboundCriteria = _ref3.inboundCriteria;
  var transportClass = (inboundCriteria === null || inboundCriteria === void 0 ? void 0 : inboundCriteria.flightClass) || Object(lodash__WEBPACK_IMPORTED_MODULE_10__["get"])(transportType ? travelSections.find(getFindSectionTransportTypeFn(transportType)) : travelSections[0], 'transport.class');

  if (!TRANSPORT_CLASS_TO_I18N[transportClass]) {
    return null;
  }

  return Object(_i18n__WEBPACK_IMPORTED_MODULE_14__[/* t */ "h"])("common.transport.transportClass.".concat(TRANSPORT_CLASS_TO_I18N[transportClass]));
};


/***/ }),

/***/ "z9Jh":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "zCbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACKING_PREFIX_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTrackingTransport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDepartureCityCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDepartureCityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSummer; });
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6U7i");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _client_tracking_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("829J");




var WITH_TRANSPORT = 'with Transport';
var WITHOUT_TRANSPORT = 'without Transport';
var NO_DEPARTURE_CITY = 'NO';
var TRACKING_PREFIX_MAPPING = {
  ACTIVITIES: 'activities',
  CHILDCARE: 'childcare',
  WELLNESS: 'wellness'
};
function getTrackingTransport(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_1__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? WITH_TRANSPORT : WITHOUT_TRANSPORT;
}
function getDepartureCityCode(departureCityCode) {
  return departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_1__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityCode : WITHOUT_TRANSPORT;
}
function getDepartureCityName(departureCityCode, departureCityName) {
  return departureCityName && departureCityCode && Object(lodash__WEBPACK_IMPORTED_MODULE_1__["toUpper"])(departureCityCode) !== NO_DEPARTURE_CITY ? departureCityName : '';
}
function isSummer(date) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_1__["inRange"])(Number(moment__WEBPACK_IMPORTED_MODULE_2___default()(date).format('MMDD')), _client_tracking_constants__WEBPACK_IMPORTED_MODULE_3__[/* SUMMER_DATE_START */ "x"], _client_tracking_constants__WEBPACK_IMPORTED_MODULE_3__[/* SUMMER_DATE_END */ "w"]);
}

/***/ }),

/***/ "zSnQ":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("LTtw");
var fails = __webpack_require__("fhLv");
var toIndexedObject = __webpack_require__("dNjr");
var nativeGetOwnPropertyDescriptor = __webpack_require__("5h8T").f;
var DESCRIPTORS = __webpack_require__("uGjT");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "zaNA":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "zcYo":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("nJrx");
var Iterators = __webpack_require__("oa0l");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "zr3P":
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__("kn3Q");

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ "zwLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPLECategoryGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPLEPaymentConfirmationSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSearchMappedTypeForLabelGA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSiteSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return noCase; });
/* unused harmony export pascalCase */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("nsO7");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("829J");












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}




var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["b2cPagesService"].PAGE_TYPES;
var formatPayload = function formatPayload(payload, options) {
  return Object.keys(payload).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])({}, key, Object(_clubmed_utils__WEBPACK_IMPORTED_MODULE_12__["messageFormat"])(payload[key]).format(options)));
  }, {});
};
function getPLECategoryGA(isUserQuickLogged) {
  return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_13__[/* PLE_QUICK */ "n"] : _constants__WEBPACK_IMPORTED_MODULE_13__[/* PLE */ "l"];
}
function getPLEPaymentConfirmationSiteSection(_ref) {
  var isOption = _ref.isOption,
      isUserQuickLogged = _ref.isUserQuickLogged;

  if (isOption) {
    return isUserQuickLogged ? _constants__WEBPACK_IMPORTED_MODULE_13__[/* PLE_QUICK_OPTION */ "o"] : _constants__WEBPACK_IMPORTED_MODULE_13__[/* PLE_OPTION */ "m"];
  } else {
    return getPLECategoryGA(isUserQuickLogged);
  }
}
function getSearchMappedTypeForLabelGA(type) {
  return _constants__WEBPACK_IMPORTED_MODULE_13__[/* SEARCH_LABEL_GA_MAP */ "r"][type || 'none'];
}
function getSiteSection(_ref2) {
  var _ref2$isOption = _ref2.isOption,
      isOption = _ref2$isOption === void 0 ? false : _ref2$isOption,
      _ref2$isUserQuickLogg = _ref2.isUserQuickLogged,
      isUserQuickLogged = _ref2$isUserQuickLogg === void 0 ? false : _ref2$isUserQuickLogg,
      pageType = _ref2.pageType;

  switch (pageType) {
    case PAGE_TYPES.DESTINATION_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.DESTINATION));

    case PAGE_TYPES.HOME_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.HOME));

    case PAGE_TYPES.LANDING_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.LANDING));

    case PAGE_TYPES.RESORT_MICE:
      return "M&E_".concat(pascalCase(PAGE_TYPES.RESORT));

    case PAGE_TYPES.PREBOOKING:
      var siteSection = pageType.split('-')[0];
      return "Shopping_".concat(pascalCase(siteSection));

    case _constants__WEBPACK_IMPORTED_MODULE_13__[/* STATIC_PAGE_TYPES */ "v"].BE:
      return _constants__WEBPACK_IMPORTED_MODULE_13__[/* BE */ "a"];

    case _constants__WEBPACK_IMPORTED_MODULE_13__[/* STATIC_PAGE_TYPES */ "v"].PLE:
      return getPLECategoryGA(isUserQuickLogged);

    case _constants__WEBPACK_IMPORTED_MODULE_13__[/* STATIC_PAGE_TYPES */ "v"].PLE_PAYMENT_CONFIRMATION:
      return getPLEPaymentConfirmationSiteSection({
        isOption: isOption,
        isUserQuickLogged: isUserQuickLogged
      });

    default:
      return "Shopping_".concat(pascalCase(pageType));
  }
}
function noCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_11__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_11__["startCase"], lodash__WEBPACK_IMPORTED_MODULE_11__["toLower"])(string);
}
function pascalCase(string) {
  return Object(lodash__WEBPACK_IMPORTED_MODULE_11__["flow"])(lodash__WEBPACK_IMPORTED_MODULE_11__["camelCase"], lodash__WEBPACK_IMPORTED_MODULE_11__["upperFirst"])(string);
}

/***/ })

},[["cbTx",1,2,5,6,0,4,3,7,8,9,10,11,12,13,14,15,16,17,18,19,21,20,22,23,24]]]);